(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire15c3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire15c3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eW0mB", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $75A1G = parcelRequire("75A1G");

var $vcsUi = parcelRequire("vcsUi");

var $267JK = parcelRequire("267JK");

var $hHCHw = parcelRequire("hHCHw");

var $8K3um = parcelRequire("8K3um");

var $lUQAX = parcelRequire("lUQAX");

var $b8P2u = parcelRequire("b8P2u");

var $7Rpvm = parcelRequire("7Rpvm");

var $gXINV = parcelRequire("gXINV");
var $adf6c3ad6d4b65f3$var$createElement = $8K3um.createElement;
var $adf6c3ad6d4b65f3$var$createFactory = $8K3um.createFactory;
var $adf6c3ad6d4b65f3$var$cloneElement = $8K3um.cloneElement;
var $adf6c3ad6d4b65f3$var$lowPriorityWarning, $adf6c3ad6d4b65f3$var$canDefineProperty, $adf6c3ad6d4b65f3$var$ReactElementValidator, $adf6c3ad6d4b65f3$var$didWarnPropTypesDeprecated;
var $adf6c3ad6d4b65f3$var$__spread = $75A1G;
var $adf6c3ad6d4b65f3$var$createMixin = function(mixin) {
    return mixin;
};
var $adf6c3ad6d4b65f3$var$warnedForSpread, $adf6c3ad6d4b65f3$var$warnedForCreateMixin;
var $adf6c3ad6d4b65f3$var$React = {
    // Modern
    Children: {
        map: $267JK.map,
        forEach: $267JK.forEach,
        count: $267JK.count,
        toArray: $267JK.toArray,
        only: $gXINV
    },
    Component: $vcsUi.Component,
    PureComponent: $vcsUi.PureComponent,
    createElement: $adf6c3ad6d4b65f3$var$createElement,
    cloneElement: $adf6c3ad6d4b65f3$var$cloneElement,
    isValidElement: $8K3um.isValidElement,
    // Classic
    PropTypes: $lUQAX,
    createClass: $7Rpvm,
    createFactory: $adf6c3ad6d4b65f3$var$createFactory,
    createMixin: $adf6c3ad6d4b65f3$var$createMixin,
    // This looks DOM specific but these are actually isomorphic helpers
    // since they are just generating DOM strings.
    DOM: $hHCHw,
    version: $b8P2u,
    // Deprecated hook for JSX spread, don't use this for anything.
    __spread: $adf6c3ad6d4b65f3$var$__spread
};
var $adf6c3ad6d4b65f3$var$warnedForCreateClass, $adf6c3ad6d4b65f3$var$warnedForFactories;
module.exports = $adf6c3ad6d4b65f3$var$React;

});
parcelRegister("75A1G", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5294f20d921f2fae$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5294f20d921f2fae$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5294f20d921f2fae$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5294f20d921f2fae$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5294f20d921f2fae$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5294f20d921f2fae$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5294f20d921f2fae$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5294f20d921f2fae$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5294f20d921f2fae$var$getOwnPropertySymbols) {
            symbols = $5294f20d921f2fae$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5294f20d921f2fae$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("vcsUi", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $023hx = parcelRequire("023hx");

var $75A1G = parcelRequire("75A1G");

var $3nXiu = parcelRequire("3nXiu");
parcelRequire("7MjiS");

var $X5IzL = parcelRequire("X5IzL");
parcelRequire("4Mb5c");
parcelRequire("2uPLX");
/**
 * Base class helpers for the updating state of a component.
 */ function $05dc90b3def5dd9c$var$ReactComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $X5IzL;
    // We initialize the default updater but the real one gets injected by the
    // renderer.
    this.updater = updater || $3nXiu;
}
$05dc90b3def5dd9c$var$ReactComponent.prototype.isReactComponent = {};
/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ $05dc90b3def5dd9c$var$ReactComponent.prototype.setState = function(partialState, callback) {
    !(typeof partialState === "object" || typeof partialState === "function" || partialState == null) && $023hx("85");
    this.updater.enqueueSetState(this, partialState);
    if (callback) this.updater.enqueueCallback(this, callback, "setState");
};
/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ $05dc90b3def5dd9c$var$ReactComponent.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this);
    if (callback) this.updater.enqueueCallback(this, callback, "forceUpdate");
};
var $05dc90b3def5dd9c$var$deprecatedAPIs, $05dc90b3def5dd9c$var$defineDeprecationWarning, $05dc90b3def5dd9c$var$fnName;
/**
 * Base class helpers for the updating state of a component.
 */ function $05dc90b3def5dd9c$var$ReactPureComponent(props, context, updater) {
    // Duplicated from ReactComponent.
    this.props = props;
    this.context = context;
    this.refs = $X5IzL;
    // We initialize the default updater but the real one gets injected by the
    // renderer.
    this.updater = updater || $3nXiu;
}
function $05dc90b3def5dd9c$var$ComponentDummy() {}
$05dc90b3def5dd9c$var$ComponentDummy.prototype = $05dc90b3def5dd9c$var$ReactComponent.prototype;
$05dc90b3def5dd9c$var$ReactPureComponent.prototype = new $05dc90b3def5dd9c$var$ComponentDummy();
$05dc90b3def5dd9c$var$ReactPureComponent.prototype.constructor = $05dc90b3def5dd9c$var$ReactPureComponent;
// Avoid an extra prototype jump for these methods.
$75A1G($05dc90b3def5dd9c$var$ReactPureComponent.prototype, $05dc90b3def5dd9c$var$ReactComponent.prototype);
$05dc90b3def5dd9c$var$ReactPureComponent.prototype.isPureReactComponent = true;
module.exports = {
    Component: $05dc90b3def5dd9c$var$ReactComponent,
    PureComponent: $05dc90b3def5dd9c$var$ReactPureComponent
};

});
parcelRegister("023hx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */ function $0062bbb6f93fdb76$var$reactProdInvariant(code) {
    var argCount = arguments.length - 1;
    var message = "Minified React error #" + code + "; visit " + "http://facebook.github.io/react/docs/error-decoder.html?invariant=" + code;
    for(var argIdx = 0; argIdx < argCount; argIdx++)message += "&args[]=" + encodeURIComponent(arguments[argIdx + 1]);
    message += " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    var error = new Error(message);
    error.name = "Invariant Violation";
    error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
    throw error;
}
module.exports = $0062bbb6f93fdb76$var$reactProdInvariant;

});

parcelRegister("3nXiu", function(module, exports) {
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
parcelRequire("fIzgz");
function $27718445dbe159c8$var$warnNoop(publicInstance, callerName) {
    var constructor;
}
/**
 * This is the abstract API for an update queue.
 */ var $27718445dbe159c8$var$ReactNoopUpdateQueue = {
    /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
        return false;
    },
    /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */ enqueueCallback: function(publicInstance, callback) {},
    /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */ enqueueForceUpdate: function(publicInstance) {
        $27718445dbe159c8$var$warnNoop(publicInstance, "forceUpdate");
    },
    /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState) {
        $27718445dbe159c8$var$warnNoop(publicInstance, "replaceState");
    },
    /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState) {
        $27718445dbe159c8$var$warnNoop(publicInstance, "setState");
    }
};
module.exports = $27718445dbe159c8$var$ReactNoopUpdateQueue;

});
parcelRegister("fIzgz", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $46CSh = parcelRequire("46CSh");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $b7165233e2fb209c$var$warning = $46CSh;
var $b7165233e2fb209c$var$printWarning;
module.exports = $b7165233e2fb209c$var$warning;

});
parcelRegister("46CSh", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $2fd5e09f25a880db$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $2fd5e09f25a880db$var$emptyFunction = function emptyFunction() {};
$2fd5e09f25a880db$var$emptyFunction.thatReturns = $2fd5e09f25a880db$var$makeEmptyFunction;
$2fd5e09f25a880db$var$emptyFunction.thatReturnsFalse = $2fd5e09f25a880db$var$makeEmptyFunction(false);
$2fd5e09f25a880db$var$emptyFunction.thatReturnsTrue = $2fd5e09f25a880db$var$makeEmptyFunction(true);
$2fd5e09f25a880db$var$emptyFunction.thatReturnsNull = $2fd5e09f25a880db$var$makeEmptyFunction(null);
$2fd5e09f25a880db$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$2fd5e09f25a880db$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $2fd5e09f25a880db$var$emptyFunction;

});



parcelRegister("7MjiS", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
var $5a9bfd589bc63eaf$var$canDefineProperty = false;
var $5a9bfd589bc63eaf$var$x;
module.exports = $5a9bfd589bc63eaf$var$canDefineProperty;

});

parcelRegister("X5IzL", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
var $0b19f2457bbaba9c$var$emptyObject = {};
module.exports = $0b19f2457bbaba9c$var$emptyObject;

});

parcelRegister("4Mb5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $37a43df17412f5fb$var$validateFormat = function validateFormat(format) {};
function $37a43df17412f5fb$var$invariant(condition, format, a, b, c, d, e, f) {
    $37a43df17412f5fb$var$validateFormat(format);
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}
module.exports = $37a43df17412f5fb$var$invariant;

});

parcelRegister("2uPLX", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $1d168b1446b47639$var$lowPriorityWarning = function() {};
var $1d168b1446b47639$var$printWarning;
module.exports = $1d168b1446b47639$var$lowPriorityWarning;

});


parcelRegister("267JK", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $aQkIS = parcelRequire("aQkIS");

var $8K3um = parcelRequire("8K3um");

var $46CSh = parcelRequire("46CSh");

var $gKDU4 = parcelRequire("gKDU4");
var $187224b18a537467$var$twoArgumentPooler = $aQkIS.twoArgumentPooler;
var $187224b18a537467$var$fourArgumentPooler = $aQkIS.fourArgumentPooler;
var $187224b18a537467$var$userProvidedKeyEscapeRegex = /\/+/g;
function $187224b18a537467$var$escapeUserProvidedKey(text) {
    return ("" + text).replace($187224b18a537467$var$userProvidedKeyEscapeRegex, "$&/");
}
/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */ function $187224b18a537467$var$ForEachBookKeeping(forEachFunction, forEachContext) {
    this.func = forEachFunction;
    this.context = forEachContext;
    this.count = 0;
}
$187224b18a537467$var$ForEachBookKeeping.prototype.destructor = function() {
    this.func = null;
    this.context = null;
    this.count = 0;
};
$aQkIS.addPoolingTo($187224b18a537467$var$ForEachBookKeeping, $187224b18a537467$var$twoArgumentPooler);
function $187224b18a537467$var$forEachSingleChild(bookKeeping, child, name) {
    var func = bookKeeping.func, context = bookKeeping.context;
    func.call(context, child, bookKeeping.count++);
}
/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function $187224b18a537467$var$forEachChildren(children, forEachFunc, forEachContext) {
    if (children == null) return children;
    var traverseContext = $187224b18a537467$var$ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
    $gKDU4(children, $187224b18a537467$var$forEachSingleChild, traverseContext);
    $187224b18a537467$var$ForEachBookKeeping.release(traverseContext);
}
/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */ function $187224b18a537467$var$MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
    this.result = mapResult;
    this.keyPrefix = keyPrefix;
    this.func = mapFunction;
    this.context = mapContext;
    this.count = 0;
}
$187224b18a537467$var$MapBookKeeping.prototype.destructor = function() {
    this.result = null;
    this.keyPrefix = null;
    this.func = null;
    this.context = null;
    this.count = 0;
};
$aQkIS.addPoolingTo($187224b18a537467$var$MapBookKeeping, $187224b18a537467$var$fourArgumentPooler);
function $187224b18a537467$var$mapSingleChildIntoContext(bookKeeping, child, childKey) {
    var result = bookKeeping.result, keyPrefix = bookKeeping.keyPrefix, func = bookKeeping.func, context = bookKeeping.context;
    var mappedChild = func.call(context, child, bookKeeping.count++);
    if (Array.isArray(mappedChild)) $187224b18a537467$var$mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, $46CSh.thatReturnsArgument);
    else if (mappedChild != null) {
        if ($8K3um.isValidElement(mappedChild)) mappedChild = $8K3um.cloneAndReplaceKey(mappedChild, // Keep both the (mapped) and old keys if they differ, just as
        // traverseAllChildren used to do for objects as children
        keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? $187224b18a537467$var$escapeUserProvidedKey(mappedChild.key) + "/" : "") + childKey);
        result.push(mappedChild);
    }
}
function $187224b18a537467$var$mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
    var escapedPrefix = "";
    if (prefix != null) escapedPrefix = $187224b18a537467$var$escapeUserProvidedKey(prefix) + "/";
    var traverseContext = $187224b18a537467$var$MapBookKeeping.getPooled(array, escapedPrefix, func, context);
    $gKDU4(children, $187224b18a537467$var$mapSingleChildIntoContext, traverseContext);
    $187224b18a537467$var$MapBookKeeping.release(traverseContext);
}
/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function $187224b18a537467$var$mapChildren(children, func, context) {
    if (children == null) return children;
    var result = [];
    $187224b18a537467$var$mapIntoWithKeyPrefixInternal(children, result, null, func, context);
    return result;
}
function $187224b18a537467$var$forEachSingleChildDummy(traverseContext, child, name) {
    return null;
}
/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function $187224b18a537467$var$countChildren(children, context) {
    return $gKDU4(children, $187224b18a537467$var$forEachSingleChildDummy, null);
}
/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */ function $187224b18a537467$var$toArray(children) {
    var result = [];
    $187224b18a537467$var$mapIntoWithKeyPrefixInternal(children, result, null, $46CSh.thatReturnsArgument);
    return result;
}
var $187224b18a537467$var$ReactChildren = {
    forEach: $187224b18a537467$var$forEachChildren,
    map: $187224b18a537467$var$mapChildren,
    mapIntoWithKeyPrefixInternal: $187224b18a537467$var$mapIntoWithKeyPrefixInternal,
    count: $187224b18a537467$var$countChildren,
    toArray: $187224b18a537467$var$toArray
};
module.exports = $187224b18a537467$var$ReactChildren;

});
parcelRegister("aQkIS", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";

var $023hx = parcelRequire("023hx");
parcelRequire("4Mb5c");
/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */ var $7e4ed5d741ae3887$var$oneArgumentPooler = function(copyFieldsFrom) {
    var Klass = this;
    if (Klass.instancePool.length) {
        var instance = Klass.instancePool.pop();
        Klass.call(instance, copyFieldsFrom);
        return instance;
    } else return new Klass(copyFieldsFrom);
};
var $7e4ed5d741ae3887$var$twoArgumentPooler = function(a1, a2) {
    var Klass = this;
    if (Klass.instancePool.length) {
        var instance = Klass.instancePool.pop();
        Klass.call(instance, a1, a2);
        return instance;
    } else return new Klass(a1, a2);
};
var $7e4ed5d741ae3887$var$threeArgumentPooler = function(a1, a2, a3) {
    var Klass = this;
    if (Klass.instancePool.length) {
        var instance = Klass.instancePool.pop();
        Klass.call(instance, a1, a2, a3);
        return instance;
    } else return new Klass(a1, a2, a3);
};
var $7e4ed5d741ae3887$var$fourArgumentPooler = function(a1, a2, a3, a4) {
    var Klass = this;
    if (Klass.instancePool.length) {
        var instance = Klass.instancePool.pop();
        Klass.call(instance, a1, a2, a3, a4);
        return instance;
    } else return new Klass(a1, a2, a3, a4);
};
var $7e4ed5d741ae3887$var$standardReleaser = function(instance) {
    var Klass = this;
    !(instance instanceof Klass) && $023hx("25");
    instance.destructor();
    if (Klass.instancePool.length < Klass.poolSize) Klass.instancePool.push(instance);
};
var $7e4ed5d741ae3887$var$DEFAULT_POOL_SIZE = 10;
var $7e4ed5d741ae3887$var$DEFAULT_POOLER = $7e4ed5d741ae3887$var$oneArgumentPooler;
/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */ var $7e4ed5d741ae3887$var$addPoolingTo = function(CopyConstructor, pooler) {
    // Casting as any so that flow ignores the actual implementation and trusts
    // it to match the type we declared
    var NewKlass = CopyConstructor;
    NewKlass.instancePool = [];
    NewKlass.getPooled = pooler || $7e4ed5d741ae3887$var$DEFAULT_POOLER;
    if (!NewKlass.poolSize) NewKlass.poolSize = $7e4ed5d741ae3887$var$DEFAULT_POOL_SIZE;
    NewKlass.release = $7e4ed5d741ae3887$var$standardReleaser;
    return NewKlass;
};
var $7e4ed5d741ae3887$var$PooledClass = {
    addPoolingTo: $7e4ed5d741ae3887$var$addPoolingTo,
    oneArgumentPooler: $7e4ed5d741ae3887$var$oneArgumentPooler,
    twoArgumentPooler: $7e4ed5d741ae3887$var$twoArgumentPooler,
    threeArgumentPooler: $7e4ed5d741ae3887$var$threeArgumentPooler,
    fourArgumentPooler: $7e4ed5d741ae3887$var$fourArgumentPooler
};
module.exports = $7e4ed5d741ae3887$var$PooledClass;

});

parcelRegister("8K3um", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $75A1G = parcelRequire("75A1G");

var $6qU6G = parcelRequire("6qU6G");
parcelRequire("fIzgz");
parcelRequire("7MjiS");
var $65d55363a43f74b0$var$hasOwnProperty = Object.prototype.hasOwnProperty;

var $f86BB = parcelRequire("f86BB");
var $65d55363a43f74b0$var$RESERVED_PROPS = {
    key: true,
    ref: true,
    __self: true,
    __source: true
};
var $65d55363a43f74b0$var$specialPropKeyWarningShown, $65d55363a43f74b0$var$specialPropRefWarningShown;
function $65d55363a43f74b0$var$hasValidRef(config) {
    var getter;
    return config.ref !== undefined;
}
function $65d55363a43f74b0$var$hasValidKey(config) {
    var getter;
    return config.key !== undefined;
}
function $65d55363a43f74b0$var$defineKeyPropWarningGetter(props, displayName) {
    var warnAboutAccessingKey = function() {
        if (!$65d55363a43f74b0$var$specialPropKeyWarningShown) $65d55363a43f74b0$var$specialPropKeyWarningShown = true;
    };
    warnAboutAccessingKey.isReactWarning = true;
    Object.defineProperty(props, "key", {
        get: warnAboutAccessingKey,
        configurable: true
    });
}
function $65d55363a43f74b0$var$defineRefPropWarningGetter(props, displayName) {
    var warnAboutAccessingRef = function() {
        if (!$65d55363a43f74b0$var$specialPropRefWarningShown) $65d55363a43f74b0$var$specialPropRefWarningShown = true;
    };
    warnAboutAccessingRef.isReactWarning = true;
    Object.defineProperty(props, "ref", {
        get: warnAboutAccessingRef,
        configurable: true
    });
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */ var $65d55363a43f74b0$var$ReactElement = function(type, key, ref, self, source, owner, props) {
    var element = {
        // This tag allow us to uniquely identify this as a React Element
        $$typeof: $f86BB,
        // Built-in properties that belong on the element
        type: type,
        key: key,
        ref: ref,
        props: props,
        // Record the component responsible for creating this element.
        _owner: owner
    };
    return element;
};
/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */ $65d55363a43f74b0$var$ReactElement.createElement = function(type, config, children) {
    var propName;
    // Reserved names are extracted
    var props = {};
    var key = null;
    var ref = null;
    var self = null;
    var source = null;
    if (config != null) {
        if ($65d55363a43f74b0$var$hasValidRef(config)) ref = config.ref;
        if ($65d55363a43f74b0$var$hasValidKey(config)) key = "" + config.key;
        self = config.__self === undefined ? null : config.__self;
        source = config.__source === undefined ? null : config.__source;
        // Remaining properties are added to a new props object
        for(propName in config)if ($65d55363a43f74b0$var$hasOwnProperty.call(config, propName) && !$65d55363a43f74b0$var$RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
    }
    // Children can be more than one argument, and those are transferred onto
    // the newly allocated props object.
    var childrenLength = arguments.length - 2;
    if (childrenLength === 1) props.children = children;
    else if (childrenLength > 1) {
        var childArray = Array(childrenLength);
        for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    // Resolve default props
    if (type && type.defaultProps) {
        var defaultProps = type.defaultProps;
        for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    }
    var displayName;
    return $65d55363a43f74b0$var$ReactElement(type, key, ref, self, source, $6qU6G.current, props);
};
/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */ $65d55363a43f74b0$var$ReactElement.createFactory = function(type) {
    var factory = $65d55363a43f74b0$var$ReactElement.createElement.bind(null, type);
    // Expose the type on the factory and the prototype so that it can be
    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
    // This should not be named `constructor` since this may not be the function
    // that created the element, and it may not even be a constructor.
    // Legacy hook TODO: Warn if this is accessed
    factory.type = type;
    return factory;
};
$65d55363a43f74b0$var$ReactElement.cloneAndReplaceKey = function(oldElement, newKey) {
    var newElement = $65d55363a43f74b0$var$ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
    return newElement;
};
/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */ $65d55363a43f74b0$var$ReactElement.cloneElement = function(element, config, children) {
    var propName;
    // Original props are copied
    var props = $75A1G({}, element.props);
    // Reserved names are extracted
    var key = element.key;
    var ref = element.ref;
    // Self is preserved since the owner is preserved.
    var self = element._self;
    // Source is preserved since cloneElement is unlikely to be targeted by a
    // transpiler, and the original source is probably a better indicator of the
    // true owner.
    var source = element._source;
    // Owner will be preserved, unless ref is overridden
    var owner = element._owner;
    if (config != null) {
        if ($65d55363a43f74b0$var$hasValidRef(config)) {
            // Silently steal the ref from the parent.
            ref = config.ref;
            owner = $6qU6G.current;
        }
        if ($65d55363a43f74b0$var$hasValidKey(config)) key = "" + config.key;
        // Remaining properties override existing props
        var defaultProps;
        if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
        for(propName in config)if ($65d55363a43f74b0$var$hasOwnProperty.call(config, propName) && !$65d55363a43f74b0$var$RESERVED_PROPS.hasOwnProperty(propName)) {
            if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
            props[propName] = defaultProps[propName];
            else props[propName] = config[propName];
        }
    }
    // Children can be more than one argument, and those are transferred onto
    // the newly allocated props object.
    var childrenLength = arguments.length - 2;
    if (childrenLength === 1) props.children = children;
    else if (childrenLength > 1) {
        var childArray = Array(childrenLength);
        for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $65d55363a43f74b0$var$ReactElement(element.type, key, ref, self, source, owner, props);
};
/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */ $65d55363a43f74b0$var$ReactElement.isValidElement = function(object) {
    return typeof object === "object" && object !== null && object.$$typeof === $f86BB;
};
module.exports = $65d55363a43f74b0$var$ReactElement;

});
parcelRegister("6qU6G", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var $4af0b16a1276667e$var$ReactCurrentOwner = {
    /**
   * @internal
   * @type {ReactComponent}
   */ current: null
};
module.exports = $4af0b16a1276667e$var$ReactCurrentOwner;

});

parcelRegister("f86BB", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var $b03cba157264ac9f$var$REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7;
module.exports = $b03cba157264ac9f$var$REACT_ELEMENT_TYPE;

});


parcelRegister("gKDU4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $023hx = parcelRequire("023hx");
parcelRequire("6qU6G");

var $f86BB = parcelRequire("f86BB");

var $1uvWn = parcelRequire("1uvWn");
parcelRequire("4Mb5c");

var $i1Y4m = parcelRequire("i1Y4m");
parcelRequire("fIzgz");
var $c31fe52dccda1182$var$SEPARATOR = ".";
var $c31fe52dccda1182$var$SUBSEPARATOR = ":";
/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */ /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var $c31fe52dccda1182$var$didWarnAboutMaps = false;
/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function $c31fe52dccda1182$var$getComponentKey(component, index) {
    // Do some typechecking here since we call this blindly. We want to ensure
    // that we don't block potential future ES APIs.
    if (component && typeof component === "object" && component.key != null) // Explicit key
    return $i1Y4m.escape(component.key);
    // Implicit key determined by the index in the set
    return index.toString(36);
}
/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */ function $c31fe52dccda1182$var$traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
    var type = typeof children;
    if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
    children = null;
    if (children === null || type === "string" || type === "number" || // The following is inlined from ReactElement. This means we can optimize
    // some checks. React Fiber also inlines this logic for similar purposes.
    type === "object" && children.$$typeof === $f86BB) {
        callback(traverseContext, children, // If it's the only child, treat the name as if it was wrapped in an array
        // so that it's consistent if the number of children grows.
        nameSoFar === "" ? $c31fe52dccda1182$var$SEPARATOR + $c31fe52dccda1182$var$getComponentKey(children, 0) : nameSoFar);
        return 1;
    }
    var child;
    var nextName;
    var subtreeCount = 0; // Count of children found in the current subtree.
    var nextNamePrefix = nameSoFar === "" ? $c31fe52dccda1182$var$SEPARATOR : nameSoFar + $c31fe52dccda1182$var$SUBSEPARATOR;
    if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
        child = children[i];
        nextName = nextNamePrefix + $c31fe52dccda1182$var$getComponentKey(child, i);
        subtreeCount += $c31fe52dccda1182$var$traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
    else {
        var iteratorFn = $1uvWn(children);
        if (iteratorFn) {
            var iterator = iteratorFn.call(children);
            var step;
            if (iteratorFn !== children.entries) {
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + $c31fe52dccda1182$var$getComponentKey(child, ii++);
                    subtreeCount += $c31fe52dccda1182$var$traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                }
            } else {
                var mapsAsChildrenAddendum, mapsAsChildrenOwnerName;
                // Iterator will provide entry [k,v] tuples rather than values.
                while(!(step = iterator.next()).done){
                    var entry = step.value;
                    if (entry) {
                        child = entry[1];
                        nextName = nextNamePrefix + $i1Y4m.escape(entry[0]) + $c31fe52dccda1182$var$SUBSEPARATOR + $c31fe52dccda1182$var$getComponentKey(child, 0);
                        subtreeCount += $c31fe52dccda1182$var$traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                    }
                }
            }
        } else if (type === "object") {
            var addendum = "";
            var name;
            var childrenString = String(children);
            $023hx("31", childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString, addendum);
        }
    }
    return subtreeCount;
}
/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */ function $c31fe52dccda1182$var$traverseAllChildren(children, callback, traverseContext) {
    if (children == null) return 0;
    return $c31fe52dccda1182$var$traverseAllChildrenImpl(children, "", callback, traverseContext);
}
module.exports = $c31fe52dccda1182$var$traverseAllChildren;

});
parcelRegister("1uvWn", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
/* global Symbol */ var $11615e7e47255424$var$ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
var $11615e7e47255424$var$FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */ function $11615e7e47255424$var$getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && ($11615e7e47255424$var$ITERATOR_SYMBOL && maybeIterable[$11615e7e47255424$var$ITERATOR_SYMBOL] || maybeIterable[$11615e7e47255424$var$FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === "function") return iteratorFn;
}
module.exports = $11615e7e47255424$var$getIteratorFn;

});

parcelRegister("i1Y4m", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function $d206ea7d3e553817$var$escape(key) {
    var escapeRegex = /[=:]/g;
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    var escapedString = ("" + key).replace(escapeRegex, function(match) {
        return escaperLookup[match];
    });
    return "$" + escapedString;
}
/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */ function $d206ea7d3e553817$var$unescape(key) {
    var unescapeRegex = /(=0|=2)/g;
    var unescaperLookup = {
        "=0": "=",
        "=2": ":"
    };
    var keySubstring = key[0] === "." && key[1] === "$" ? key.substring(2) : key.substring(1);
    return ("" + keySubstring).replace(unescapeRegex, function(match) {
        return unescaperLookup[match];
    });
}
var $d206ea7d3e553817$var$KeyEscapeUtils = {
    escape: $d206ea7d3e553817$var$escape,
    unescape: $d206ea7d3e553817$var$unescape
};
module.exports = $d206ea7d3e553817$var$KeyEscapeUtils;

});



parcelRegister("hHCHw", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $8K3um = parcelRequire("8K3um");
/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */ var $ce347906fd852f09$var$createDOMFactory = $8K3um.createFactory;
var $ce347906fd852f09$var$ReactElementValidator;
/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */ var $ce347906fd852f09$var$ReactDOMFactories = {
    a: $ce347906fd852f09$var$createDOMFactory("a"),
    abbr: $ce347906fd852f09$var$createDOMFactory("abbr"),
    address: $ce347906fd852f09$var$createDOMFactory("address"),
    area: $ce347906fd852f09$var$createDOMFactory("area"),
    article: $ce347906fd852f09$var$createDOMFactory("article"),
    aside: $ce347906fd852f09$var$createDOMFactory("aside"),
    audio: $ce347906fd852f09$var$createDOMFactory("audio"),
    b: $ce347906fd852f09$var$createDOMFactory("b"),
    base: $ce347906fd852f09$var$createDOMFactory("base"),
    bdi: $ce347906fd852f09$var$createDOMFactory("bdi"),
    bdo: $ce347906fd852f09$var$createDOMFactory("bdo"),
    big: $ce347906fd852f09$var$createDOMFactory("big"),
    blockquote: $ce347906fd852f09$var$createDOMFactory("blockquote"),
    body: $ce347906fd852f09$var$createDOMFactory("body"),
    br: $ce347906fd852f09$var$createDOMFactory("br"),
    button: $ce347906fd852f09$var$createDOMFactory("button"),
    canvas: $ce347906fd852f09$var$createDOMFactory("canvas"),
    caption: $ce347906fd852f09$var$createDOMFactory("caption"),
    cite: $ce347906fd852f09$var$createDOMFactory("cite"),
    code: $ce347906fd852f09$var$createDOMFactory("code"),
    col: $ce347906fd852f09$var$createDOMFactory("col"),
    colgroup: $ce347906fd852f09$var$createDOMFactory("colgroup"),
    data: $ce347906fd852f09$var$createDOMFactory("data"),
    datalist: $ce347906fd852f09$var$createDOMFactory("datalist"),
    dd: $ce347906fd852f09$var$createDOMFactory("dd"),
    del: $ce347906fd852f09$var$createDOMFactory("del"),
    details: $ce347906fd852f09$var$createDOMFactory("details"),
    dfn: $ce347906fd852f09$var$createDOMFactory("dfn"),
    dialog: $ce347906fd852f09$var$createDOMFactory("dialog"),
    div: $ce347906fd852f09$var$createDOMFactory("div"),
    dl: $ce347906fd852f09$var$createDOMFactory("dl"),
    dt: $ce347906fd852f09$var$createDOMFactory("dt"),
    em: $ce347906fd852f09$var$createDOMFactory("em"),
    embed: $ce347906fd852f09$var$createDOMFactory("embed"),
    fieldset: $ce347906fd852f09$var$createDOMFactory("fieldset"),
    figcaption: $ce347906fd852f09$var$createDOMFactory("figcaption"),
    figure: $ce347906fd852f09$var$createDOMFactory("figure"),
    footer: $ce347906fd852f09$var$createDOMFactory("footer"),
    form: $ce347906fd852f09$var$createDOMFactory("form"),
    h1: $ce347906fd852f09$var$createDOMFactory("h1"),
    h2: $ce347906fd852f09$var$createDOMFactory("h2"),
    h3: $ce347906fd852f09$var$createDOMFactory("h3"),
    h4: $ce347906fd852f09$var$createDOMFactory("h4"),
    h5: $ce347906fd852f09$var$createDOMFactory("h5"),
    h6: $ce347906fd852f09$var$createDOMFactory("h6"),
    head: $ce347906fd852f09$var$createDOMFactory("head"),
    header: $ce347906fd852f09$var$createDOMFactory("header"),
    hgroup: $ce347906fd852f09$var$createDOMFactory("hgroup"),
    hr: $ce347906fd852f09$var$createDOMFactory("hr"),
    html: $ce347906fd852f09$var$createDOMFactory("html"),
    i: $ce347906fd852f09$var$createDOMFactory("i"),
    iframe: $ce347906fd852f09$var$createDOMFactory("iframe"),
    img: $ce347906fd852f09$var$createDOMFactory("img"),
    input: $ce347906fd852f09$var$createDOMFactory("input"),
    ins: $ce347906fd852f09$var$createDOMFactory("ins"),
    kbd: $ce347906fd852f09$var$createDOMFactory("kbd"),
    keygen: $ce347906fd852f09$var$createDOMFactory("keygen"),
    label: $ce347906fd852f09$var$createDOMFactory("label"),
    legend: $ce347906fd852f09$var$createDOMFactory("legend"),
    li: $ce347906fd852f09$var$createDOMFactory("li"),
    link: $ce347906fd852f09$var$createDOMFactory("link"),
    main: $ce347906fd852f09$var$createDOMFactory("main"),
    map: $ce347906fd852f09$var$createDOMFactory("map"),
    mark: $ce347906fd852f09$var$createDOMFactory("mark"),
    menu: $ce347906fd852f09$var$createDOMFactory("menu"),
    menuitem: $ce347906fd852f09$var$createDOMFactory("menuitem"),
    meta: $ce347906fd852f09$var$createDOMFactory("meta"),
    meter: $ce347906fd852f09$var$createDOMFactory("meter"),
    nav: $ce347906fd852f09$var$createDOMFactory("nav"),
    noscript: $ce347906fd852f09$var$createDOMFactory("noscript"),
    object: $ce347906fd852f09$var$createDOMFactory("object"),
    ol: $ce347906fd852f09$var$createDOMFactory("ol"),
    optgroup: $ce347906fd852f09$var$createDOMFactory("optgroup"),
    option: $ce347906fd852f09$var$createDOMFactory("option"),
    output: $ce347906fd852f09$var$createDOMFactory("output"),
    p: $ce347906fd852f09$var$createDOMFactory("p"),
    param: $ce347906fd852f09$var$createDOMFactory("param"),
    picture: $ce347906fd852f09$var$createDOMFactory("picture"),
    pre: $ce347906fd852f09$var$createDOMFactory("pre"),
    progress: $ce347906fd852f09$var$createDOMFactory("progress"),
    q: $ce347906fd852f09$var$createDOMFactory("q"),
    rp: $ce347906fd852f09$var$createDOMFactory("rp"),
    rt: $ce347906fd852f09$var$createDOMFactory("rt"),
    ruby: $ce347906fd852f09$var$createDOMFactory("ruby"),
    s: $ce347906fd852f09$var$createDOMFactory("s"),
    samp: $ce347906fd852f09$var$createDOMFactory("samp"),
    script: $ce347906fd852f09$var$createDOMFactory("script"),
    section: $ce347906fd852f09$var$createDOMFactory("section"),
    select: $ce347906fd852f09$var$createDOMFactory("select"),
    small: $ce347906fd852f09$var$createDOMFactory("small"),
    source: $ce347906fd852f09$var$createDOMFactory("source"),
    span: $ce347906fd852f09$var$createDOMFactory("span"),
    strong: $ce347906fd852f09$var$createDOMFactory("strong"),
    style: $ce347906fd852f09$var$createDOMFactory("style"),
    sub: $ce347906fd852f09$var$createDOMFactory("sub"),
    summary: $ce347906fd852f09$var$createDOMFactory("summary"),
    sup: $ce347906fd852f09$var$createDOMFactory("sup"),
    table: $ce347906fd852f09$var$createDOMFactory("table"),
    tbody: $ce347906fd852f09$var$createDOMFactory("tbody"),
    td: $ce347906fd852f09$var$createDOMFactory("td"),
    textarea: $ce347906fd852f09$var$createDOMFactory("textarea"),
    tfoot: $ce347906fd852f09$var$createDOMFactory("tfoot"),
    th: $ce347906fd852f09$var$createDOMFactory("th"),
    thead: $ce347906fd852f09$var$createDOMFactory("thead"),
    time: $ce347906fd852f09$var$createDOMFactory("time"),
    title: $ce347906fd852f09$var$createDOMFactory("title"),
    tr: $ce347906fd852f09$var$createDOMFactory("tr"),
    track: $ce347906fd852f09$var$createDOMFactory("track"),
    u: $ce347906fd852f09$var$createDOMFactory("u"),
    ul: $ce347906fd852f09$var$createDOMFactory("ul"),
    "var": $ce347906fd852f09$var$createDOMFactory("var"),
    video: $ce347906fd852f09$var$createDOMFactory("video"),
    wbr: $ce347906fd852f09$var$createDOMFactory("wbr"),
    // SVG
    circle: $ce347906fd852f09$var$createDOMFactory("circle"),
    clipPath: $ce347906fd852f09$var$createDOMFactory("clipPath"),
    defs: $ce347906fd852f09$var$createDOMFactory("defs"),
    ellipse: $ce347906fd852f09$var$createDOMFactory("ellipse"),
    g: $ce347906fd852f09$var$createDOMFactory("g"),
    image: $ce347906fd852f09$var$createDOMFactory("image"),
    line: $ce347906fd852f09$var$createDOMFactory("line"),
    linearGradient: $ce347906fd852f09$var$createDOMFactory("linearGradient"),
    mask: $ce347906fd852f09$var$createDOMFactory("mask"),
    path: $ce347906fd852f09$var$createDOMFactory("path"),
    pattern: $ce347906fd852f09$var$createDOMFactory("pattern"),
    polygon: $ce347906fd852f09$var$createDOMFactory("polygon"),
    polyline: $ce347906fd852f09$var$createDOMFactory("polyline"),
    radialGradient: $ce347906fd852f09$var$createDOMFactory("radialGradient"),
    rect: $ce347906fd852f09$var$createDOMFactory("rect"),
    stop: $ce347906fd852f09$var$createDOMFactory("stop"),
    svg: $ce347906fd852f09$var$createDOMFactory("svg"),
    text: $ce347906fd852f09$var$createDOMFactory("text"),
    tspan: $ce347906fd852f09$var$createDOMFactory("tspan")
};
module.exports = $ce347906fd852f09$var$ReactDOMFactories;

});

parcelRegister("lUQAX", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $8K3um = parcelRequire("8K3um");
var $ff47a03e395e23e7$var$isValidElement = $8K3um.isValidElement;

var $iOcyt = parcelRequire("iOcyt");
module.exports = $iOcyt($ff47a03e395e23e7$var$isValidElement);

});
parcelRegister("iOcyt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $2tPV0 = parcelRequire("2tPV0");
module.exports = function(isValidElement) {
    // It is still allowed in 15.5.
    var throwOnDirectAccess = false;
    return $2tPV0(isValidElement, throwOnDirectAccess);
};

});
parcelRegister("2tPV0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $1TAMD = parcelRequire("1TAMD");

var $jjeoZ = parcelRequire("jjeoZ");

var $iz60K = parcelRequire("iz60K");

var $f36cf = parcelRequire("f36cf");

var $chsMq = parcelRequire("chsMq");
var $1ce69024f31ff498$var$printWarning = function() {};
function $1ce69024f31ff498$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache, manualPropTypeWarningCount;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $iz60K) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                } else var cacheKey;
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($1ce69024f31ff498$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", $iz60K);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$1TAMD.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) return $1ce69024f31ff498$var$emptyFunctionThatReturnsNull;
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === "symbol") return String(value);
                return value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
            for(var key in propValue)if ($f36cf(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, $iz60K);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) return $1ce69024f31ff498$var$emptyFunctionThatReturnsNull;
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== "function") {
                $1ce69024f31ff498$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                return $1ce69024f31ff498$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $iz60K);
                if (checkerResult == null) return null;
                if (checkerResult.data && $f36cf(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $iz60K);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $jjeoZ({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($f36cf(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $iz60K);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case "number":
            case "string":
            case "undefined":
                return true;
            case "boolean":
                return !propValue;
            case "object":
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === "symbol") return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue["@@toStringTag"] === "Symbol") return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return "array";
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
        if (isSymbol(propType, propValue)) return "symbol";
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
        var propType = getPropType(propValue);
        if (propType === "object") {
            if (propValue instanceof Date) return "date";
            else if (propValue instanceof RegExp) return "regexp";
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case "array":
            case "object":
                return "an " + type;
            case "boolean":
            case "date":
            case "regexp":
                return "a " + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $chsMq;
    ReactPropTypes.resetWarningCache = $chsMq.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("1TAMD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cdwfJ"));

});
parcelRegister("cdwfJ", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $8e4fb7a6186ef4a8$export$2b8d127b894957b9, (v) => $8e4fb7a6186ef4a8$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $8e4fb7a6186ef4a8$export$cea3a54a6425200c, (v) => $8e4fb7a6186ef4a8$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $8e4fb7a6186ef4a8$export$a7c73072b1a182ae, (v) => $8e4fb7a6186ef4a8$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8e4fb7a6186ef4a8$export$9f27bc3417b4524d, (v) => $8e4fb7a6186ef4a8$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8e4fb7a6186ef4a8$export$db77ccec0bb4ccac, (v) => $8e4fb7a6186ef4a8$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35, (v) => $8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8e4fb7a6186ef4a8$export$ffb0004e005737fa, (v) => $8e4fb7a6186ef4a8$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8e4fb7a6186ef4a8$export$b624eff549462981, (v) => $8e4fb7a6186ef4a8$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8e4fb7a6186ef4a8$export$7897aa7841a5380c, (v) => $8e4fb7a6186ef4a8$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8e4fb7a6186ef4a8$export$602eac185826482c, (v) => $8e4fb7a6186ef4a8$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8e4fb7a6186ef4a8$export$e2c29f18771995cb, (v) => $8e4fb7a6186ef4a8$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8e4fb7a6186ef4a8$export$5f8d39834fd61797, (v) => $8e4fb7a6186ef4a8$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8e4fb7a6186ef4a8$export$74bf444e3cd11ea5, (v) => $8e4fb7a6186ef4a8$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8e4fb7a6186ef4a8$export$92387174baf9b227, (v) => $8e4fb7a6186ef4a8$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8e4fb7a6186ef4a8$export$ec112efeb987d9c6, (v) => $8e4fb7a6186ef4a8$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8e4fb7a6186ef4a8$export$b706b080d889d2c9, (v) => $8e4fb7a6186ef4a8$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8e4fb7a6186ef4a8$export$5be5a87408f70ddc, (v) => $8e4fb7a6186ef4a8$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d, (v) => $8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8e4fb7a6186ef4a8$export$455c2e768291efa6, (v) => $8e4fb7a6186ef4a8$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8e4fb7a6186ef4a8$export$9522e17588c12572, (v) => $8e4fb7a6186ef4a8$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8e4fb7a6186ef4a8$export$2110ac352bb060b9, (v) => $8e4fb7a6186ef4a8$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8e4fb7a6186ef4a8$export$56885ab8b9c456ab, (v) => $8e4fb7a6186ef4a8$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8e4fb7a6186ef4a8$export$d927fcb6adf8f9de, (v) => $8e4fb7a6186ef4a8$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8e4fb7a6186ef4a8$export$b82d16f27459e05a, (v) => $8e4fb7a6186ef4a8$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8e4fb7a6186ef4a8$export$522c17b4f5e123e8, (v) => $8e4fb7a6186ef4a8$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6, (v) => $8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $8e4fb7a6186ef4a8$export$9b621391a187a31a, (v) => $8e4fb7a6186ef4a8$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8e4fb7a6186ef4a8$export$f5bbd400c2f4426f, (v) => $8e4fb7a6186ef4a8$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8e4fb7a6186ef4a8$export$2b8d127b894957b9;
var $8e4fb7a6186ef4a8$export$cea3a54a6425200c;
var $8e4fb7a6186ef4a8$export$a7c73072b1a182ae;
var $8e4fb7a6186ef4a8$export$9f27bc3417b4524d;
var $8e4fb7a6186ef4a8$export$db77ccec0bb4ccac;
var $8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35;
var $8e4fb7a6186ef4a8$export$ffb0004e005737fa;
var $8e4fb7a6186ef4a8$export$b624eff549462981;
var $8e4fb7a6186ef4a8$export$7897aa7841a5380c;
var $8e4fb7a6186ef4a8$export$602eac185826482c;
var $8e4fb7a6186ef4a8$export$e2c29f18771995cb;
var $8e4fb7a6186ef4a8$export$5f8d39834fd61797;
var $8e4fb7a6186ef4a8$export$74bf444e3cd11ea5;
var $8e4fb7a6186ef4a8$export$92387174baf9b227;
var $8e4fb7a6186ef4a8$export$ec112efeb987d9c6;
var $8e4fb7a6186ef4a8$export$b706b080d889d2c9;
var $8e4fb7a6186ef4a8$export$5be5a87408f70ddc;
var $8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d;
var $8e4fb7a6186ef4a8$export$455c2e768291efa6;
var $8e4fb7a6186ef4a8$export$9522e17588c12572;
var $8e4fb7a6186ef4a8$export$2110ac352bb060b9;
var $8e4fb7a6186ef4a8$export$56885ab8b9c456ab;
var $8e4fb7a6186ef4a8$export$d927fcb6adf8f9de;
var $8e4fb7a6186ef4a8$export$b82d16f27459e05a;
var $8e4fb7a6186ef4a8$export$522c17b4f5e123e8;
var $8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6;
var $8e4fb7a6186ef4a8$export$9b621391a187a31a;
var $8e4fb7a6186ef4a8$export$f5bbd400c2f4426f;
"use strict";
var $8e4fb7a6186ef4a8$var$b = "function" === typeof Symbol && Symbol.for, $8e4fb7a6186ef4a8$var$c = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.element") : 60103, $8e4fb7a6186ef4a8$var$d = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.portal") : 60106, $8e4fb7a6186ef4a8$var$e = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.fragment") : 60107, $8e4fb7a6186ef4a8$var$f = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.strict_mode") : 60108, $8e4fb7a6186ef4a8$var$g = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.profiler") : 60114, $8e4fb7a6186ef4a8$var$h = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.provider") : 60109, $8e4fb7a6186ef4a8$var$k = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.context") : 60110, $8e4fb7a6186ef4a8$var$l = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.async_mode") : 60111, $8e4fb7a6186ef4a8$var$m = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.concurrent_mode") : 60111, $8e4fb7a6186ef4a8$var$n = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.forward_ref") : 60112, $8e4fb7a6186ef4a8$var$p = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.suspense") : 60113, $8e4fb7a6186ef4a8$var$q = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.suspense_list") : 60120, $8e4fb7a6186ef4a8$var$r = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.memo") : 60115, $8e4fb7a6186ef4a8$var$t = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.lazy") : 60116, $8e4fb7a6186ef4a8$var$v = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.block") : 60121, $8e4fb7a6186ef4a8$var$w = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.fundamental") : 60117, $8e4fb7a6186ef4a8$var$x = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.responder") : 60118, $8e4fb7a6186ef4a8$var$y = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.scope") : 60119;
function $8e4fb7a6186ef4a8$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $8e4fb7a6186ef4a8$var$c:
                switch(a = a.type, a){
                    case $8e4fb7a6186ef4a8$var$l:
                    case $8e4fb7a6186ef4a8$var$m:
                    case $8e4fb7a6186ef4a8$var$e:
                    case $8e4fb7a6186ef4a8$var$g:
                    case $8e4fb7a6186ef4a8$var$f:
                    case $8e4fb7a6186ef4a8$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8e4fb7a6186ef4a8$var$k:
                            case $8e4fb7a6186ef4a8$var$n:
                            case $8e4fb7a6186ef4a8$var$t:
                            case $8e4fb7a6186ef4a8$var$r:
                            case $8e4fb7a6186ef4a8$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $8e4fb7a6186ef4a8$var$d:
                return u;
        }
    }
}
function $8e4fb7a6186ef4a8$var$A(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$m;
}
$8e4fb7a6186ef4a8$export$2b8d127b894957b9 = $8e4fb7a6186ef4a8$var$l;
$8e4fb7a6186ef4a8$export$cea3a54a6425200c = $8e4fb7a6186ef4a8$var$m;
$8e4fb7a6186ef4a8$export$a7c73072b1a182ae = $8e4fb7a6186ef4a8$var$k;
$8e4fb7a6186ef4a8$export$9f27bc3417b4524d = $8e4fb7a6186ef4a8$var$h;
$8e4fb7a6186ef4a8$export$db77ccec0bb4ccac = $8e4fb7a6186ef4a8$var$c;
$8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35 = $8e4fb7a6186ef4a8$var$n;
$8e4fb7a6186ef4a8$export$ffb0004e005737fa = $8e4fb7a6186ef4a8$var$e;
$8e4fb7a6186ef4a8$export$b624eff549462981 = $8e4fb7a6186ef4a8$var$t;
$8e4fb7a6186ef4a8$export$7897aa7841a5380c = $8e4fb7a6186ef4a8$var$r;
$8e4fb7a6186ef4a8$export$602eac185826482c = $8e4fb7a6186ef4a8$var$d;
$8e4fb7a6186ef4a8$export$e2c29f18771995cb = $8e4fb7a6186ef4a8$var$g;
$8e4fb7a6186ef4a8$export$5f8d39834fd61797 = $8e4fb7a6186ef4a8$var$f;
$8e4fb7a6186ef4a8$export$74bf444e3cd11ea5 = $8e4fb7a6186ef4a8$var$p;
$8e4fb7a6186ef4a8$export$92387174baf9b227 = function(a) {
    return $8e4fb7a6186ef4a8$var$A(a) || $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$l;
};
$8e4fb7a6186ef4a8$export$ec112efeb987d9c6 = $8e4fb7a6186ef4a8$var$A;
$8e4fb7a6186ef4a8$export$b706b080d889d2c9 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$k;
};
$8e4fb7a6186ef4a8$export$5be5a87408f70ddc = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$h;
};
$8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8e4fb7a6186ef4a8$var$c;
};
$8e4fb7a6186ef4a8$export$455c2e768291efa6 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$n;
};
$8e4fb7a6186ef4a8$export$9522e17588c12572 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$e;
};
$8e4fb7a6186ef4a8$export$2110ac352bb060b9 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$t;
};
$8e4fb7a6186ef4a8$export$56885ab8b9c456ab = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$r;
};
$8e4fb7a6186ef4a8$export$d927fcb6adf8f9de = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$d;
};
$8e4fb7a6186ef4a8$export$b82d16f27459e05a = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$g;
};
$8e4fb7a6186ef4a8$export$522c17b4f5e123e8 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$f;
};
$8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$p;
};
$8e4fb7a6186ef4a8$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8e4fb7a6186ef4a8$var$e || a === $8e4fb7a6186ef4a8$var$m || a === $8e4fb7a6186ef4a8$var$g || a === $8e4fb7a6186ef4a8$var$f || a === $8e4fb7a6186ef4a8$var$p || a === $8e4fb7a6186ef4a8$var$q || "object" === typeof a && null !== a && (a.$$typeof === $8e4fb7a6186ef4a8$var$t || a.$$typeof === $8e4fb7a6186ef4a8$var$r || a.$$typeof === $8e4fb7a6186ef4a8$var$h || a.$$typeof === $8e4fb7a6186ef4a8$var$k || a.$$typeof === $8e4fb7a6186ef4a8$var$n || a.$$typeof === $8e4fb7a6186ef4a8$var$w || a.$$typeof === $8e4fb7a6186ef4a8$var$x || a.$$typeof === $8e4fb7a6186ef4a8$var$y || a.$$typeof === $8e4fb7a6186ef4a8$var$v);
};
$8e4fb7a6186ef4a8$export$f5bbd400c2f4426f = $8e4fb7a6186ef4a8$var$z;

});


parcelRegister("jjeoZ", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $e0eaf69a4629e614$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $e0eaf69a4629e614$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $e0eaf69a4629e614$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $e0eaf69a4629e614$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $e0eaf69a4629e614$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $e0eaf69a4629e614$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $e0eaf69a4629e614$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($e0eaf69a4629e614$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($e0eaf69a4629e614$var$getOwnPropertySymbols) {
            symbols = $e0eaf69a4629e614$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($e0eaf69a4629e614$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("iz60K", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $d840288929500773$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $d840288929500773$var$ReactPropTypesSecret;

});

parcelRegister("f36cf", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("chsMq", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $8f0d65ac967e1443$var$printWarning = function() {};
var $8f0d65ac967e1443$var$ReactPropTypesSecret, $8f0d65ac967e1443$var$loggedTypeFailures, $8f0d65ac967e1443$var$has;
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $8f0d65ac967e1443$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    var typeSpecName, error, err, ex, stack;
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $8f0d65ac967e1443$var$checkPropTypes.resetWarningCache = function() {};
module.exports = $8f0d65ac967e1443$var$checkPropTypes;

});




parcelRegister("b8P2u", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
module.exports = "15.7.0";

});

parcelRegister("7Rpvm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $vcsUi = parcelRequire("vcsUi");
var $5b91445e87ed82c1$var$Component = $vcsUi.Component;

var $8K3um = parcelRequire("8K3um");
var $5b91445e87ed82c1$var$isValidElement = $8K3um.isValidElement;

var $3nXiu = parcelRequire("3nXiu");

var $jmPMv = parcelRequire("jmPMv");
module.exports = $jmPMv($5b91445e87ed82c1$var$Component, $5b91445e87ed82c1$var$isValidElement, $3nXiu);

});
parcelRegister("jmPMv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $j9Etv = parcelRequire("j9Etv");
// -- Inlined from fbjs --
var $e1983d13c4d2a7be$var$emptyObject = {};
var $e1983d13c4d2a7be$var$validateFormat = function validateFormat(format) {};
function $e1983d13c4d2a7be$var$_invariant(condition, format, a, b, c, d, e, f) {
    $e1983d13c4d2a7be$var$validateFormat(format);
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}
var $e1983d13c4d2a7be$var$warning = function() {};
var $e1983d13c4d2a7be$var$printWarning;
// /-- Inlined from fbjs --
var $e1983d13c4d2a7be$var$MIXINS_KEY = "mixins";
// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function $e1983d13c4d2a7be$var$identity(fn) {
    return fn;
}
var $e1983d13c4d2a7be$var$ReactPropTypeLocationNames;
$e1983d13c4d2a7be$var$ReactPropTypeLocationNames = {};
function $e1983d13c4d2a7be$var$factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
    /**
   * Policies that describe methods in `ReactClassInterface`.
   */ var injectedMixins = [];
    /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */ var ReactClassInterface = {
        /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */ mixins: "DEFINE_MANY",
        /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */ statics: "DEFINE_MANY",
        /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */ propTypes: "DEFINE_MANY",
        /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */ contextTypes: "DEFINE_MANY",
        /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */ childContextTypes: "DEFINE_MANY",
        // ==== Definition methods ====
        /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */ getDefaultProps: "DEFINE_MANY_MERGED",
        /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */ getInitialState: "DEFINE_MANY_MERGED",
        /**
     * @return {object}
     * @optional
     */ getChildContext: "DEFINE_MANY_MERGED",
        /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */ render: "DEFINE_ONCE",
        // ==== Delegate methods ====
        /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */ componentWillMount: "DEFINE_MANY",
        /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidMount: "DEFINE_MANY",
        /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */ componentWillReceiveProps: "DEFINE_MANY",
        /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */ shouldComponentUpdate: "DEFINE_ONCE",
        /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */ componentWillUpdate: "DEFINE_MANY",
        /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidUpdate: "DEFINE_MANY",
        /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */ componentWillUnmount: "DEFINE_MANY",
        /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */ UNSAFE_componentWillMount: "DEFINE_MANY",
        /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */ UNSAFE_componentWillReceiveProps: "DEFINE_MANY",
        /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */ UNSAFE_componentWillUpdate: "DEFINE_MANY",
        // ==== Advanced methods ====
        /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */ updateComponent: "OVERRIDE_BASE"
    };
    /**
   * Similar to ReactClassInterface but for static methods.
   */ var ReactClassStaticInterface = {
        /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */ getDerivedStateFromProps: "DEFINE_MANY_MERGED"
    };
    /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */ var RESERVED_SPEC_KEYS = {
        displayName: function(Constructor, displayName) {
            Constructor.displayName = displayName;
        },
        mixins: function(Constructor, mixins) {
            if (mixins) for(var i = 0; i < mixins.length; i++)mixSpecIntoComponent(Constructor, mixins[i]);
        },
        childContextTypes: function(Constructor, childContextTypes) {
            Constructor.childContextTypes = $j9Etv({}, Constructor.childContextTypes, childContextTypes);
        },
        contextTypes: function(Constructor, contextTypes) {
            Constructor.contextTypes = $j9Etv({}, Constructor.contextTypes, contextTypes);
        },
        /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */ getDefaultProps: function(Constructor, getDefaultProps) {
            if (Constructor.getDefaultProps) Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
            else Constructor.getDefaultProps = getDefaultProps;
        },
        propTypes: function(Constructor, propTypes) {
            Constructor.propTypes = $j9Etv({}, Constructor.propTypes, propTypes);
        },
        statics: function(Constructor, statics) {
            mixStaticSpecIntoComponent(Constructor, statics);
        },
        autobind: function() {}
    };
    function validateTypeDef(Constructor, typeDef, location) {
        for(var propName in typeDef)typeDef.hasOwnProperty(propName);
    }
    function validateMethodOverride(isAlreadyDefined, name) {
        var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
        // Disallow overriding of base class methods unless explicitly allowed.
        if (ReactClassMixin.hasOwnProperty(name)) $e1983d13c4d2a7be$var$_invariant(specPolicy === "OVERRIDE_BASE", "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.", name);
        // Disallow defining methods more than once unless explicitly allowed.
        if (isAlreadyDefined) $e1983d13c4d2a7be$var$_invariant(specPolicy === "DEFINE_MANY" || specPolicy === "DEFINE_MANY_MERGED", "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
    }
    /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */ function mixSpecIntoComponent(Constructor, spec) {
        if (!spec) {
            var typeofSpec, isMixinValid;
            return;
        }
        $e1983d13c4d2a7be$var$_invariant(typeof spec !== "function", "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object.");
        $e1983d13c4d2a7be$var$_invariant(!isValidElement(spec), "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");
        var proto = Constructor.prototype;
        var autoBindPairs = proto.__reactAutoBindPairs;
        // By handling mixins before any other properties, we ensure the same
        // chaining order is applied to methods with DEFINE_MANY policy, whether
        // mixins are listed before or after these methods in the spec.
        if (spec.hasOwnProperty($e1983d13c4d2a7be$var$MIXINS_KEY)) RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
        for(var name in spec){
            if (!spec.hasOwnProperty(name)) continue;
            if (name === $e1983d13c4d2a7be$var$MIXINS_KEY) continue;
            var property = spec[name];
            var isAlreadyDefined = proto.hasOwnProperty(name);
            validateMethodOverride(isAlreadyDefined, name);
            if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) RESERVED_SPEC_KEYS[name](Constructor, property);
            else {
                // Setup methods on prototype:
                // The following member methods should not be automatically bound:
                // 1. Expected ReactClass methods (in the "interface").
                // 2. Overridden methods (that were mixed in).
                var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
                var isFunction = typeof property === "function";
                var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
                if (shouldAutoBind) {
                    autoBindPairs.push(name, property);
                    proto[name] = property;
                } else if (isAlreadyDefined) {
                    var specPolicy = ReactClassInterface[name];
                    // These cases should already be caught by validateMethodOverride.
                    $e1983d13c4d2a7be$var$_invariant(isReactClassMethod && (specPolicy === "DEFINE_MANY_MERGED" || specPolicy === "DEFINE_MANY"), "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.", specPolicy, name);
                    // For methods which are defined more than once, call the existing
                    // methods before calling the new property, merging if appropriate.
                    if (specPolicy === "DEFINE_MANY_MERGED") proto[name] = createMergedResultFunction(proto[name], property);
                    else if (specPolicy === "DEFINE_MANY") proto[name] = createChainedFunction(proto[name], property);
                } else proto[name] = property;
            }
        }
    }
    function mixStaticSpecIntoComponent(Constructor, statics) {
        if (!statics) return;
        for(var name in statics){
            var property = statics[name];
            if (!statics.hasOwnProperty(name)) continue;
            var isReserved = name in RESERVED_SPEC_KEYS;
            $e1983d13c4d2a7be$var$_invariant(!isReserved, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name);
            var isAlreadyDefined = name in Constructor;
            if (isAlreadyDefined) {
                var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;
                $e1983d13c4d2a7be$var$_invariant(specPolicy === "DEFINE_MANY_MERGED", "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
                Constructor[name] = createMergedResultFunction(Constructor[name], property);
                return;
            }
            Constructor[name] = property;
        }
    }
    /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */ function mergeIntoWithNoDuplicateKeys(one, two) {
        $e1983d13c4d2a7be$var$_invariant(one && two && typeof one === "object" && typeof two === "object", "mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.");
        for(var key in two)if (two.hasOwnProperty(key)) {
            $e1983d13c4d2a7be$var$_invariant(one[key] === undefined, "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.", key);
            one[key] = two[key];
        }
        return one;
    }
    /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createMergedResultFunction(one, two) {
        return function mergedResult() {
            var a = one.apply(this, arguments);
            var b = two.apply(this, arguments);
            if (a == null) return b;
            else if (b == null) return a;
            var c = {};
            mergeIntoWithNoDuplicateKeys(c, a);
            mergeIntoWithNoDuplicateKeys(c, b);
            return c;
        };
    }
    /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createChainedFunction(one, two) {
        return function chainedFunction() {
            one.apply(this, arguments);
            two.apply(this, arguments);
        };
    }
    /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */ function bindAutoBindMethod(component, method) {
        var boundMethod = method.bind(component);
        var componentName, _bind;
        return boundMethod;
    }
    /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */ function bindAutoBindMethods(component) {
        var pairs = component.__reactAutoBindPairs;
        for(var i = 0; i < pairs.length; i += 2){
            var autoBindKey = pairs[i];
            var method = pairs[i + 1];
            component[autoBindKey] = bindAutoBindMethod(component, method);
        }
    }
    var IsMountedPreMixin = {
        componentDidMount: function() {
            this.__isMounted = true;
        }
    };
    var IsMountedPostMixin = {
        componentWillUnmount: function() {
            this.__isMounted = false;
        }
    };
    /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */ var ReactClassMixin = {
        /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */ replaceState: function(newState, callback) {
            this.updater.enqueueReplaceState(this, newState, callback);
        },
        /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */ isMounted: function() {
            return !!this.__isMounted;
        }
    };
    var ReactClassComponent = function() {};
    $j9Etv(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
    /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */ function createClass(spec) {
        // To keep our warnings more understandable, we'll use a little hack here to
        // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
        // unnecessarily identify a class without displayName as 'Constructor'.
        var Constructor = $e1983d13c4d2a7be$var$identity(function(props, context, updater) {
            // Wire up auto-binding
            if (this.__reactAutoBindPairs.length) bindAutoBindMethods(this);
            this.props = props;
            this.context = context;
            this.refs = $e1983d13c4d2a7be$var$emptyObject;
            this.updater = updater || ReactNoopUpdateQueue;
            this.state = null;
            // ReactClasses doesn't have constructors. Instead, they use the
            // getInitialState and componentWillMount methods for initialization.
            var initialState = this.getInitialState ? this.getInitialState() : null;
            $e1983d13c4d2a7be$var$_invariant(typeof initialState === "object" && !Array.isArray(initialState), "%s.getInitialState(): must return an object or null", Constructor.displayName || "ReactCompositeComponent");
            this.state = initialState;
        });
        Constructor.prototype = new ReactClassComponent();
        Constructor.prototype.constructor = Constructor;
        Constructor.prototype.__reactAutoBindPairs = [];
        injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
        mixSpecIntoComponent(Constructor, IsMountedPreMixin);
        mixSpecIntoComponent(Constructor, spec);
        mixSpecIntoComponent(Constructor, IsMountedPostMixin);
        // Initialize the defaultProps property after all mixins have been merged.
        if (Constructor.getDefaultProps) Constructor.defaultProps = Constructor.getDefaultProps();
        $e1983d13c4d2a7be$var$_invariant(Constructor.prototype.render, "createClass(...): Class specification must implement a `render` method.");
        // Reduce time spent doing lookups by setting these on the prototype.
        for(var methodName in ReactClassInterface)if (!Constructor.prototype[methodName]) Constructor.prototype[methodName] = null;
        return Constructor;
    }
    return createClass;
}
module.exports = $e1983d13c4d2a7be$var$factory;

});
parcelRegister("j9Etv", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $df1e41102d389115$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $df1e41102d389115$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $df1e41102d389115$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $df1e41102d389115$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $df1e41102d389115$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $df1e41102d389115$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $df1e41102d389115$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($df1e41102d389115$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($df1e41102d389115$var$getOwnPropertySymbols) {
            symbols = $df1e41102d389115$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($df1e41102d389115$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("gXINV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $023hx = parcelRequire("023hx");

var $8K3um = parcelRequire("8K3um");
parcelRequire("4Mb5c");
/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function $c594e9375ad42eb5$var$onlyChild(children) {
    !$8K3um.isValidElement(children) && $023hx("143");
    return children;
}
module.exports = $c594e9375ad42eb5$var$onlyChild;

});


parcelRegister("4SVKY", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/ "use strict";

var $5fGpM = parcelRequire("5fGpM");

var $dh0aB = parcelRequire("dh0aB");

var $50Cxn = parcelRequire("50Cxn");

var $5Kdrw = parcelRequire("5Kdrw");

var $gDXrr = parcelRequire("gDXrr");

var $4wTXj = parcelRequire("4wTXj");

var $acP88 = parcelRequire("acP88");

var $eRLS3 = parcelRequire("eRLS3");

var $9YRCL = parcelRequire("9YRCL");
parcelRequire("fIzgz");
$dh0aB.inject();
var $38e901d32e4f3bc7$var$ReactDOM = {
    findDOMNode: $acP88,
    render: $50Cxn.render,
    unmountComponentAtNode: $50Cxn.unmountComponentAtNode,
    version: $4wTXj,
    /* eslint-disable camelcase */ unstable_batchedUpdates: $gDXrr.batchedUpdates,
    unstable_renderSubtreeIntoContainer: $9YRCL
};
// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
        getClosestInstanceFromNode: $5fGpM.getClosestInstanceFromNode,
        getNodeFromInstance: function(inst) {
            // inst is an internal instance (but could be a composite)
            if (inst._renderedComponent) inst = $eRLS3(inst);
            if (inst) return $5fGpM.getNodeFromInstance(inst);
            else return null;
        }
    },
    Mount: $50Cxn,
    Reconciler: $5Kdrw
});
var $38e901d32e4f3bc7$var$ExecutionEnvironment, $38e901d32e4f3bc7$var$showFileUrlMessage, $38e901d32e4f3bc7$var$testFunc, $38e901d32e4f3bc7$var$ieCompatibilityMode, $38e901d32e4f3bc7$var$expectedFeatures, $38e901d32e4f3bc7$var$i;
var $38e901d32e4f3bc7$var$ReactInstrumentation, $38e901d32e4f3bc7$var$ReactDOMUnknownPropertyHook, $38e901d32e4f3bc7$var$ReactDOMNullInputValuePropHook, $38e901d32e4f3bc7$var$ReactDOMInvalidARIAHook;
module.exports = $38e901d32e4f3bc7$var$ReactDOM;

});
parcelRegister("5fGpM", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $Uj2z8 = parcelRequire("Uj2z8");

var $jCXRR = parcelRequire("jCXRR");
parcelRequire("4Mb5c");
var $3d2f4127de66570b$var$ATTR_NAME = $Uj2z8.ID_ATTRIBUTE_NAME;
var $3d2f4127de66570b$var$Flags = $jCXRR;
var $3d2f4127de66570b$var$internalInstanceKey = "__reactInternalInstance$" + Math.random().toString(36).slice(2);
/**
 * Check if a given node should be cached.
 */ function $3d2f4127de66570b$var$shouldPrecacheNode(node, nodeID) {
    return node.nodeType === 1 && node.getAttribute($3d2f4127de66570b$var$ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === " react-text: " + nodeID + " " || node.nodeType === 8 && node.nodeValue === " react-empty: " + nodeID + " ";
}
/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */ function $3d2f4127de66570b$var$getRenderedHostOrTextFromComponent(component) {
    var rendered;
    while(rendered = component._renderedComponent)component = rendered;
    return component;
}
/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */ function $3d2f4127de66570b$var$precacheNode(inst, node) {
    var hostInst = $3d2f4127de66570b$var$getRenderedHostOrTextFromComponent(inst);
    hostInst._hostNode = node;
    node[$3d2f4127de66570b$var$internalInstanceKey] = hostInst;
}
function $3d2f4127de66570b$var$uncacheNode(inst) {
    var node = inst._hostNode;
    if (node) {
        delete node[$3d2f4127de66570b$var$internalInstanceKey];
        inst._hostNode = null;
    }
}
/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */ function $3d2f4127de66570b$var$precacheChildNodes(inst, node) {
    if (inst._flags & $3d2f4127de66570b$var$Flags.hasCachedChildNodes) return;
    var children = inst._renderedChildren;
    var childNode = node.firstChild;
    outer: for(var name in children){
        if (!children.hasOwnProperty(name)) continue;
        var childInst = children[name];
        var childID = $3d2f4127de66570b$var$getRenderedHostOrTextFromComponent(childInst)._domID;
        if (childID === 0) continue;
        // We assume the child nodes are in the same order as the child instances.
        for(; childNode !== null; childNode = childNode.nextSibling)if ($3d2f4127de66570b$var$shouldPrecacheNode(childNode, childID)) {
            $3d2f4127de66570b$var$precacheNode(childInst, childNode);
            continue outer;
        }
        // We reached the end of the DOM children without finding an ID match.
        $jOpPq("32", childID);
    }
    inst._flags |= $3d2f4127de66570b$var$Flags.hasCachedChildNodes;
}
/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */ function $3d2f4127de66570b$var$getClosestInstanceFromNode(node) {
    if (node[$3d2f4127de66570b$var$internalInstanceKey]) return node[$3d2f4127de66570b$var$internalInstanceKey];
    // Walk up the tree until we find an ancestor whose instance we have cached.
    var parents = [];
    while(!node[$3d2f4127de66570b$var$internalInstanceKey]){
        parents.push(node);
        if (node.parentNode) node = node.parentNode;
        else // Top of the tree. This node must not be part of a React tree (or is
        // unmounted, potentially).
        return null;
    }
    var closest;
    var inst;
    for(; node && (inst = node[$3d2f4127de66570b$var$internalInstanceKey]); node = parents.pop()){
        closest = inst;
        if (parents.length) $3d2f4127de66570b$var$precacheChildNodes(inst, node);
    }
    return closest;
}
/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function $3d2f4127de66570b$var$getInstanceFromNode(node) {
    var inst = $3d2f4127de66570b$var$getClosestInstanceFromNode(node);
    if (inst != null && inst._hostNode === node) return inst;
    else return null;
}
/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function $3d2f4127de66570b$var$getNodeFromInstance(inst) {
    // Without this first invariant, passing a non-DOM-component triggers the next
    // invariant for a missing parent, which is super confusing.
    !(inst._hostNode !== undefined) && $jOpPq("33");
    if (inst._hostNode) return inst._hostNode;
    // Walk up the tree until we find an ancestor whose DOM node we have cached.
    var parents = [];
    while(!inst._hostNode){
        parents.push(inst);
        !inst._hostParent && $jOpPq("34");
        inst = inst._hostParent;
    }
    // Now parents contains each ancestor that does *not* have a cached native
    // node, and `inst` is the deepest ancestor that does.
    for(; parents.length; inst = parents.pop())$3d2f4127de66570b$var$precacheChildNodes(inst, inst._hostNode);
    return inst._hostNode;
}
var $3d2f4127de66570b$var$ReactDOMComponentTree = {
    getClosestInstanceFromNode: $3d2f4127de66570b$var$getClosestInstanceFromNode,
    getInstanceFromNode: $3d2f4127de66570b$var$getInstanceFromNode,
    getNodeFromInstance: $3d2f4127de66570b$var$getNodeFromInstance,
    precacheChildNodes: $3d2f4127de66570b$var$precacheChildNodes,
    precacheNode: $3d2f4127de66570b$var$precacheNode,
    uncacheNode: $3d2f4127de66570b$var$uncacheNode
};
module.exports = $3d2f4127de66570b$var$ReactDOMComponentTree;

});
parcelRegister("jOpPq", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */ function $e6c6b8d2fc2098ad$var$reactProdInvariant(code) {
    var argCount = arguments.length - 1;
    var message = "Minified React error #" + code + "; visit " + "http://facebook.github.io/react/docs/error-decoder.html?invariant=" + code;
    for(var argIdx = 0; argIdx < argCount; argIdx++)message += "&args[]=" + encodeURIComponent(arguments[argIdx + 1]);
    message += " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    var error = new Error(message);
    error.name = "Invariant Violation";
    error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
    throw error;
}
module.exports = $e6c6b8d2fc2098ad$var$reactProdInvariant;

});

parcelRegister("Uj2z8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
parcelRequire("4Mb5c");
function $0a940019d66c2dee$var$checkMask(value, bitmask) {
    return (value & bitmask) === bitmask;
}
var $0a940019d66c2dee$var$DOMPropertyInjection = {
    /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */ MUST_USE_PROPERTY: 0x1,
    HAS_BOOLEAN_VALUE: 0x4,
    HAS_NUMERIC_VALUE: 0x8,
    HAS_POSITIVE_NUMERIC_VALUE: 24,
    HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
    /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */ injectDOMPropertyConfig: function(domPropertyConfig) {
        var Injection = $0a940019d66c2dee$var$DOMPropertyInjection;
        var Properties = domPropertyConfig.Properties || {};
        var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
        var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
        var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
        var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
        if (domPropertyConfig.isCustomAttribute) $0a940019d66c2dee$var$DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
        for(var propName in Properties){
            !!$0a940019d66c2dee$var$DOMProperty.properties.hasOwnProperty(propName) && $jOpPq("48", propName);
            var lowerCased = propName.toLowerCase();
            var propConfig = Properties[propName];
            var propertyInfo = {
                attributeName: lowerCased,
                attributeNamespace: null,
                propertyName: propName,
                mutationMethod: null,
                mustUseProperty: $0a940019d66c2dee$var$checkMask(propConfig, Injection.MUST_USE_PROPERTY),
                hasBooleanValue: $0a940019d66c2dee$var$checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
                hasNumericValue: $0a940019d66c2dee$var$checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
                hasPositiveNumericValue: $0a940019d66c2dee$var$checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
                hasOverloadedBooleanValue: $0a940019d66c2dee$var$checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
            };
            !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) && $jOpPq("50", propName);
            if (DOMAttributeNames.hasOwnProperty(propName)) {
                var attributeName = DOMAttributeNames[propName];
                propertyInfo.attributeName = attributeName;
            }
            if (DOMAttributeNamespaces.hasOwnProperty(propName)) propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
            if (DOMPropertyNames.hasOwnProperty(propName)) propertyInfo.propertyName = DOMPropertyNames[propName];
            if (DOMMutationMethods.hasOwnProperty(propName)) propertyInfo.mutationMethod = DOMMutationMethods[propName];
            $0a940019d66c2dee$var$DOMProperty.properties[propName] = propertyInfo;
        }
    }
};
/* eslint-disable max-len */ var $0a940019d66c2dee$var$ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
/* eslint-enable max-len */ /**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */ var $0a940019d66c2dee$var$DOMProperty = {
    ID_ATTRIBUTE_NAME: "data-reactid",
    ROOT_ATTRIBUTE_NAME: "data-reactroot",
    ATTRIBUTE_NAME_START_CHAR: $0a940019d66c2dee$var$ATTRIBUTE_NAME_START_CHAR,
    ATTRIBUTE_NAME_CHAR: $0a940019d66c2dee$var$ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
    /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */ properties: {},
    /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */ getPossibleStandardName: null,
    /**
   * All of the isCustomAttribute() functions that have been injected.
   */ _isCustomAttributeFunctions: [],
    /**
   * Checks whether a property name is a custom attribute.
   * @method
   */ isCustomAttribute: function(attributeName) {
        for(var i = 0; i < $0a940019d66c2dee$var$DOMProperty._isCustomAttributeFunctions.length; i++){
            var isCustomAttributeFn = $0a940019d66c2dee$var$DOMProperty._isCustomAttributeFunctions[i];
            if (isCustomAttributeFn(attributeName)) return true;
        }
        return false;
    },
    injection: $0a940019d66c2dee$var$DOMPropertyInjection
};
module.exports = $0a940019d66c2dee$var$DOMProperty;

});

parcelRegister("jCXRR", function(module, exports) {
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
var $e4a0016488f24086$var$ReactDOMComponentFlags = {
    hasCachedChildNodes: 1
};
module.exports = $e4a0016488f24086$var$ReactDOMComponentFlags;

});


parcelRegister("dh0aB", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $3gNbt = parcelRequire("3gNbt");

var $lr3Sv = parcelRequire("lr3Sv");

var $haaI9 = parcelRequire("haaI9");

var $krY8l = parcelRequire("krY8l");

var $lAANg = parcelRequire("lAANg");

var $9jnfX = parcelRequire("9jnfX");

var $j1fD1 = parcelRequire("j1fD1");

var $aVA3J = parcelRequire("aVA3J");

var $5fGpM = parcelRequire("5fGpM");

var $8AymV = parcelRequire("8AymV");

var $fI5lm = parcelRequire("fI5lm");

var $BWPny = parcelRequire("BWPny");

var $g1KNQ = parcelRequire("g1KNQ");

var $hmJFq = parcelRequire("hmJFq");

var $jgTvI = parcelRequire("jgTvI");

var $BxkoC = parcelRequire("BxkoC");

var $chlm2 = parcelRequire("chlm2");

var $3b16B = parcelRequire("3b16B");

var $k1qrz = parcelRequire("k1qrz");
var $9a9cfea819683efe$var$alreadyInjected = false;
function $9a9cfea819683efe$var$inject() {
    if ($9a9cfea819683efe$var$alreadyInjected) // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
    $9a9cfea819683efe$var$alreadyInjected = true;
    $jgTvI.EventEmitter.injectReactEventListener($hmJFq);
    /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */ $jgTvI.EventPluginHub.injectEventPluginOrder($krY8l);
    $jgTvI.EventPluginUtils.injectComponentTree($5fGpM);
    $jgTvI.EventPluginUtils.injectTreeTraversal($fI5lm);
    /**
   * Some important event plugins included by default (without having to require
   * them).
   */ $jgTvI.EventPluginHub.injectEventPluginsByName({
        SimpleEventPlugin: $k1qrz,
        EnterLeaveEventPlugin: $lAANg,
        ChangeEventPlugin: $haaI9,
        SelectEventPlugin: $3b16B,
        BeforeInputEventPlugin: $lr3Sv
    });
    $jgTvI.HostComponent.injectGenericComponentClass($aVA3J);
    $jgTvI.HostComponent.injectTextComponentClass($BWPny);
    $jgTvI.DOMProperty.injectDOMPropertyConfig($3gNbt);
    $jgTvI.DOMProperty.injectDOMPropertyConfig($9jnfX);
    $jgTvI.DOMProperty.injectDOMPropertyConfig($chlm2);
    $jgTvI.EmptyComponent.injectEmptyComponentFactory(function(instantiate) {
        return new $8AymV(instantiate);
    });
    $jgTvI.Updates.injectReconcileTransaction($BxkoC);
    $jgTvI.Updates.injectBatchingStrategy($g1KNQ);
    $jgTvI.Component.injectEnvironment($j1fD1);
}
module.exports = {
    inject: $9a9cfea819683efe$var$inject
};

});
parcelRegister("3gNbt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
var $261904aac5012f2a$var$ARIADOMPropertyConfig = {
    Properties: {
        // Global States and Properties
        "aria-current": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        "aria-hidden": 0,
        "aria-invalid": 0,
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    },
    DOMAttributeNames: {},
    DOMPropertyNames: {}
};
module.exports = $261904aac5012f2a$var$ARIADOMPropertyConfig;

});

parcelRegister("lr3Sv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $1lzph = parcelRequire("1lzph");

var $kx286 = parcelRequire("kx286");

var $feACA = parcelRequire("feACA");

var $3HlIe = parcelRequire("3HlIe");

var $1nrfj = parcelRequire("1nrfj");
var $f9af20baddc8e6d5$var$END_KEYCODES = [
    9,
    13,
    27,
    32
]; // Tab, Return, Esc, Space
var $f9af20baddc8e6d5$var$START_KEYCODE = 229;
var $f9af20baddc8e6d5$var$canUseCompositionEvent = $kx286.canUseDOM && "CompositionEvent" in window;
var $f9af20baddc8e6d5$var$documentMode = null;
if ($kx286.canUseDOM && "documentMode" in document) $f9af20baddc8e6d5$var$documentMode = document.documentMode;
// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var $f9af20baddc8e6d5$var$canUseTextInputEvent = $kx286.canUseDOM && "TextEvent" in window && !$f9af20baddc8e6d5$var$documentMode && !$f9af20baddc8e6d5$var$isPresto();
// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var $f9af20baddc8e6d5$var$useFallbackCompositionData = $kx286.canUseDOM && (!$f9af20baddc8e6d5$var$canUseCompositionEvent || $f9af20baddc8e6d5$var$documentMode && $f9af20baddc8e6d5$var$documentMode > 8 && $f9af20baddc8e6d5$var$documentMode <= 11);
/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */ function $f9af20baddc8e6d5$var$isPresto() {
    var opera = window.opera;
    return typeof opera === "object" && typeof opera.version === "function" && parseInt(opera.version(), 10) <= 12;
}
var $f9af20baddc8e6d5$var$SPACEBAR_CODE = 32;
var $f9af20baddc8e6d5$var$SPACEBAR_CHAR = String.fromCharCode($f9af20baddc8e6d5$var$SPACEBAR_CODE);
// Events and their corresponding property names.
var $f9af20baddc8e6d5$var$eventTypes = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "topCompositionEnd",
            "topKeyPress",
            "topTextInput",
            "topPaste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: [
            "topBlur",
            "topCompositionEnd",
            "topKeyDown",
            "topKeyPress",
            "topKeyUp",
            "topMouseDown"
        ]
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: [
            "topBlur",
            "topCompositionStart",
            "topKeyDown",
            "topKeyPress",
            "topKeyUp",
            "topMouseDown"
        ]
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: [
            "topBlur",
            "topCompositionUpdate",
            "topKeyDown",
            "topKeyPress",
            "topKeyUp",
            "topMouseDown"
        ]
    }
};
// Track whether we've ever handled a keypress on the space key.
var $f9af20baddc8e6d5$var$hasSpaceKeypress = false;
/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function $f9af20baddc8e6d5$var$isKeypressCommand(nativeEvent) {
    return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
    !(nativeEvent.ctrlKey && nativeEvent.altKey);
}
/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */ function $f9af20baddc8e6d5$var$getCompositionEventType(topLevelType) {
    switch(topLevelType){
        case "topCompositionStart":
            return $f9af20baddc8e6d5$var$eventTypes.compositionStart;
        case "topCompositionEnd":
            return $f9af20baddc8e6d5$var$eventTypes.compositionEnd;
        case "topCompositionUpdate":
            return $f9af20baddc8e6d5$var$eventTypes.compositionUpdate;
    }
}
/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */ function $f9af20baddc8e6d5$var$isFallbackCompositionStart(topLevelType, nativeEvent) {
    return topLevelType === "topKeyDown" && nativeEvent.keyCode === $f9af20baddc8e6d5$var$START_KEYCODE;
}
/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */ function $f9af20baddc8e6d5$var$isFallbackCompositionEnd(topLevelType, nativeEvent) {
    switch(topLevelType){
        case "topKeyUp":
            // Command keys insert or clear IME input.
            return $f9af20baddc8e6d5$var$END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
        case "topKeyDown":
            // Expect IME keyCode on each keydown. If we get any other
            // code we must have exited earlier.
            return nativeEvent.keyCode !== $f9af20baddc8e6d5$var$START_KEYCODE;
        case "topKeyPress":
        case "topMouseDown":
        case "topBlur":
            // Events are not possible without cancelling IME.
            return true;
        default:
            return false;
    }
}
/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function $f9af20baddc8e6d5$var$getDataFromCustomEvent(nativeEvent) {
    var detail = nativeEvent.detail;
    if (typeof detail === "object" && "data" in detail) return detail.data;
    return null;
}
// Track the current IME composition fallback object, if any.
var $f9af20baddc8e6d5$var$currentComposition = null;
/**
 * @return {?object} A SyntheticCompositionEvent.
 */ function $f9af20baddc8e6d5$var$extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var eventType;
    var fallbackData;
    if ($f9af20baddc8e6d5$var$canUseCompositionEvent) eventType = $f9af20baddc8e6d5$var$getCompositionEventType(topLevelType);
    else if (!$f9af20baddc8e6d5$var$currentComposition) {
        if ($f9af20baddc8e6d5$var$isFallbackCompositionStart(topLevelType, nativeEvent)) eventType = $f9af20baddc8e6d5$var$eventTypes.compositionStart;
    } else if ($f9af20baddc8e6d5$var$isFallbackCompositionEnd(topLevelType, nativeEvent)) eventType = $f9af20baddc8e6d5$var$eventTypes.compositionEnd;
    if (!eventType) return null;
    if ($f9af20baddc8e6d5$var$useFallbackCompositionData) {
        // The current composition is stored statically and must not be
        // overwritten while composition continues.
        if (!$f9af20baddc8e6d5$var$currentComposition && eventType === $f9af20baddc8e6d5$var$eventTypes.compositionStart) $f9af20baddc8e6d5$var$currentComposition = $feACA.getPooled(nativeEventTarget);
        else if (eventType === $f9af20baddc8e6d5$var$eventTypes.compositionEnd) {
            if ($f9af20baddc8e6d5$var$currentComposition) fallbackData = $f9af20baddc8e6d5$var$currentComposition.getData();
        }
    }
    var event = $3HlIe.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
    if (fallbackData) // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
    else {
        var customData = $f9af20baddc8e6d5$var$getDataFromCustomEvent(nativeEvent);
        if (customData !== null) event.data = customData;
    }
    $1lzph.accumulateTwoPhaseDispatches(event);
    return event;
}
/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */ function $f9af20baddc8e6d5$var$getNativeBeforeInputChars(topLevelType, nativeEvent) {
    switch(topLevelType){
        case "topCompositionEnd":
            return $f9af20baddc8e6d5$var$getDataFromCustomEvent(nativeEvent);
        case "topKeyPress":
            /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
            if (which !== $f9af20baddc8e6d5$var$SPACEBAR_CODE) return null;
            $f9af20baddc8e6d5$var$hasSpaceKeypress = true;
            return $f9af20baddc8e6d5$var$SPACEBAR_CHAR;
        case "topTextInput":
            // Record the characters to be added to the DOM.
            var chars = nativeEvent.data;
            // If it's a spacebar character, assume that we have already handled
            // it at the keypress level and bail immediately. Android Chrome
            // doesn't give us keycodes, so we need to blacklist it.
            if (chars === $f9af20baddc8e6d5$var$SPACEBAR_CHAR && $f9af20baddc8e6d5$var$hasSpaceKeypress) return null;
            return chars;
        default:
            // For other native event types, do nothing.
            return null;
    }
}
/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */ function $f9af20baddc8e6d5$var$getFallbackBeforeInputChars(topLevelType, nativeEvent) {
    // If we are currently composing (IME) and using a fallback to do so,
    // try to extract the composed characters from the fallback object.
    // If composition event is available, we extract a string only at
    // compositionevent, otherwise extract it at fallback events.
    if ($f9af20baddc8e6d5$var$currentComposition) {
        if (topLevelType === "topCompositionEnd" || !$f9af20baddc8e6d5$var$canUseCompositionEvent && $f9af20baddc8e6d5$var$isFallbackCompositionEnd(topLevelType, nativeEvent)) {
            var chars = $f9af20baddc8e6d5$var$currentComposition.getData();
            $feACA.release($f9af20baddc8e6d5$var$currentComposition);
            $f9af20baddc8e6d5$var$currentComposition = null;
            return chars;
        }
        return null;
    }
    switch(topLevelType){
        case "topPaste":
            // If a paste event occurs after a keypress, throw out the input
            // chars. Paste events should not lead to BeforeInput events.
            return null;
        case "topKeyPress":
            /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (nativeEvent.which && !$f9af20baddc8e6d5$var$isKeypressCommand(nativeEvent)) return String.fromCharCode(nativeEvent.which);
            return null;
        case "topCompositionEnd":
            return $f9af20baddc8e6d5$var$useFallbackCompositionData ? null : nativeEvent.data;
        default:
            return null;
    }
}
/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function $f9af20baddc8e6d5$var$extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var chars;
    if ($f9af20baddc8e6d5$var$canUseTextInputEvent) chars = $f9af20baddc8e6d5$var$getNativeBeforeInputChars(topLevelType, nativeEvent);
    else chars = $f9af20baddc8e6d5$var$getFallbackBeforeInputChars(topLevelType, nativeEvent);
    // If no characters are being inserted, no BeforeInput event should
    // be fired.
    if (!chars) return null;
    var event = $1nrfj.getPooled($f9af20baddc8e6d5$var$eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
    event.data = chars;
    $1lzph.accumulateTwoPhaseDispatches(event);
    return event;
}
/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ var $f9af20baddc8e6d5$var$BeforeInputEventPlugin = {
    eventTypes: $f9af20baddc8e6d5$var$eventTypes,
    extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        return [
            $f9af20baddc8e6d5$var$extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget),
            $f9af20baddc8e6d5$var$extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)
        ];
    }
};
module.exports = $f9af20baddc8e6d5$var$BeforeInputEventPlugin;

});
parcelRegister("1lzph", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $53teI = parcelRequire("53teI");

var $9l8z5 = parcelRequire("9l8z5");

var $2Py3n = parcelRequire("2Py3n");

var $e6Ok2 = parcelRequire("e6Ok2");
parcelRequire("fIzgz");
var $0fb337a1e99d8d45$var$getListener = $53teI.getListener;
/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */ function $0fb337a1e99d8d45$var$listenerAtPhase(inst, event, propagationPhase) {
    var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
    return $0fb337a1e99d8d45$var$getListener(inst, registrationName);
}
/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */ function $0fb337a1e99d8d45$var$accumulateDirectionalDispatches(inst, phase, event) {
    var listener = $0fb337a1e99d8d45$var$listenerAtPhase(inst, event, phase);
    if (listener) {
        event._dispatchListeners = $2Py3n(event._dispatchListeners, listener);
        event._dispatchInstances = $2Py3n(event._dispatchInstances, inst);
    }
}
/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */ function $0fb337a1e99d8d45$var$accumulateTwoPhaseDispatchesSingle(event) {
    if (event && event.dispatchConfig.phasedRegistrationNames) $9l8z5.traverseTwoPhase(event._targetInst, $0fb337a1e99d8d45$var$accumulateDirectionalDispatches, event);
}
/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */ function $0fb337a1e99d8d45$var$accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
    if (event && event.dispatchConfig.phasedRegistrationNames) {
        var targetInst = event._targetInst;
        var parentInst = targetInst ? $9l8z5.getParentInstance(targetInst) : null;
        $9l8z5.traverseTwoPhase(parentInst, $0fb337a1e99d8d45$var$accumulateDirectionalDispatches, event);
    }
}
/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */ function $0fb337a1e99d8d45$var$accumulateDispatches(inst, ignoredDirection, event) {
    if (event && event.dispatchConfig.registrationName) {
        var registrationName = event.dispatchConfig.registrationName;
        var listener = $0fb337a1e99d8d45$var$getListener(inst, registrationName);
        if (listener) {
            event._dispatchListeners = $2Py3n(event._dispatchListeners, listener);
            event._dispatchInstances = $2Py3n(event._dispatchInstances, inst);
        }
    }
}
/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */ function $0fb337a1e99d8d45$var$accumulateDirectDispatchesSingle(event) {
    if (event && event.dispatchConfig.registrationName) $0fb337a1e99d8d45$var$accumulateDispatches(event._targetInst, null, event);
}
function $0fb337a1e99d8d45$var$accumulateTwoPhaseDispatches(events) {
    $e6Ok2(events, $0fb337a1e99d8d45$var$accumulateTwoPhaseDispatchesSingle);
}
function $0fb337a1e99d8d45$var$accumulateTwoPhaseDispatchesSkipTarget(events) {
    $e6Ok2(events, $0fb337a1e99d8d45$var$accumulateTwoPhaseDispatchesSingleSkipTarget);
}
function $0fb337a1e99d8d45$var$accumulateEnterLeaveDispatches(leave, enter, from, to) {
    $9l8z5.traverseEnterLeave(from, to, $0fb337a1e99d8d45$var$accumulateDispatches, leave, enter);
}
function $0fb337a1e99d8d45$var$accumulateDirectDispatches(events) {
    $e6Ok2(events, $0fb337a1e99d8d45$var$accumulateDirectDispatchesSingle);
}
/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */ var $0fb337a1e99d8d45$var$EventPropagators = {
    accumulateTwoPhaseDispatches: $0fb337a1e99d8d45$var$accumulateTwoPhaseDispatches,
    accumulateTwoPhaseDispatchesSkipTarget: $0fb337a1e99d8d45$var$accumulateTwoPhaseDispatchesSkipTarget,
    accumulateDirectDispatches: $0fb337a1e99d8d45$var$accumulateDirectDispatches,
    accumulateEnterLeaveDispatches: $0fb337a1e99d8d45$var$accumulateEnterLeaveDispatches
};
module.exports = $0fb337a1e99d8d45$var$EventPropagators;

});
parcelRegister("53teI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $6cytr = parcelRequire("6cytr");

var $9l8z5 = parcelRequire("9l8z5");

var $knj2S = parcelRequire("knj2S");

var $2Py3n = parcelRequire("2Py3n");

var $e6Ok2 = parcelRequire("e6Ok2");
parcelRequire("4Mb5c");
/**
 * Internal store for event listeners
 */ var $3ae3e94baf5c3075$var$listenerBank = {};
/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */ var $3ae3e94baf5c3075$var$eventQueue = null;
/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */ var $3ae3e94baf5c3075$var$executeDispatchesAndRelease = function(event, simulated) {
    if (event) {
        $9l8z5.executeDispatchesInOrder(event, simulated);
        if (!event.isPersistent()) event.constructor.release(event);
    }
};
var $3ae3e94baf5c3075$var$executeDispatchesAndReleaseSimulated = function(e) {
    return $3ae3e94baf5c3075$var$executeDispatchesAndRelease(e, true);
};
var $3ae3e94baf5c3075$var$executeDispatchesAndReleaseTopLevel = function(e) {
    return $3ae3e94baf5c3075$var$executeDispatchesAndRelease(e, false);
};
var $3ae3e94baf5c3075$var$getDictionaryKey = function(inst) {
    // Prevents V8 performance issue:
    // https://github.com/facebook/react/pull/7232
    return "." + inst._rootNodeID;
};
function $3ae3e94baf5c3075$var$isInteractive(tag) {
    return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
}
function $3ae3e94baf5c3075$var$shouldPreventMouseEvent(name, type, props) {
    switch(name){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
            return !!(props.disabled && $3ae3e94baf5c3075$var$isInteractive(type));
        default:
            return false;
    }
}
/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */ var $3ae3e94baf5c3075$var$EventPluginHub = {
    /**
   * Methods for injecting dependencies.
   */ injection: {
        /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */ injectEventPluginOrder: $6cytr.injectEventPluginOrder,
        /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */ injectEventPluginsByName: $6cytr.injectEventPluginsByName
    },
    /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */ putListener: function(inst, registrationName, listener) {
        !(typeof listener === "function") && $jOpPq("94", registrationName, typeof listener);
        var key = $3ae3e94baf5c3075$var$getDictionaryKey(inst);
        var bankForRegistrationName = $3ae3e94baf5c3075$var$listenerBank[registrationName] || ($3ae3e94baf5c3075$var$listenerBank[registrationName] = {});
        bankForRegistrationName[key] = listener;
        var PluginModule = $6cytr.registrationNameModules[registrationName];
        if (PluginModule && PluginModule.didPutListener) PluginModule.didPutListener(inst, registrationName, listener);
    },
    /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */ getListener: function(inst, registrationName) {
        // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
        // live here; needs to be moved to a better place soon
        var bankForRegistrationName = $3ae3e94baf5c3075$var$listenerBank[registrationName];
        if ($3ae3e94baf5c3075$var$shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) return null;
        var key = $3ae3e94baf5c3075$var$getDictionaryKey(inst);
        return bankForRegistrationName && bankForRegistrationName[key];
    },
    /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */ deleteListener: function(inst, registrationName) {
        var PluginModule = $6cytr.registrationNameModules[registrationName];
        if (PluginModule && PluginModule.willDeleteListener) PluginModule.willDeleteListener(inst, registrationName);
        var bankForRegistrationName = $3ae3e94baf5c3075$var$listenerBank[registrationName];
        // TODO: This should never be null -- when is it?
        if (bankForRegistrationName) {
            var key = $3ae3e94baf5c3075$var$getDictionaryKey(inst);
            delete bankForRegistrationName[key];
        }
    },
    /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */ deleteAllListeners: function(inst) {
        var key = $3ae3e94baf5c3075$var$getDictionaryKey(inst);
        for(var registrationName in $3ae3e94baf5c3075$var$listenerBank){
            if (!$3ae3e94baf5c3075$var$listenerBank.hasOwnProperty(registrationName)) continue;
            if (!$3ae3e94baf5c3075$var$listenerBank[registrationName][key]) continue;
            var PluginModule = $6cytr.registrationNameModules[registrationName];
            if (PluginModule && PluginModule.willDeleteListener) PluginModule.willDeleteListener(inst, registrationName);
            delete $3ae3e94baf5c3075$var$listenerBank[registrationName][key];
        }
    },
    /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */ extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        var events;
        var plugins = $6cytr.plugins;
        for(var i = 0; i < plugins.length; i++){
            // Not every plugin in the ordering may be loaded at runtime.
            var possiblePlugin = plugins[i];
            if (possiblePlugin) {
                var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
                if (extractedEvents) events = $2Py3n(events, extractedEvents);
            }
        }
        return events;
    },
    /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */ enqueueEvents: function(events) {
        if (events) $3ae3e94baf5c3075$var$eventQueue = $2Py3n($3ae3e94baf5c3075$var$eventQueue, events);
    },
    /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */ processEventQueue: function(simulated) {
        // Set `eventQueue` to null before processing it so that we can tell if more
        // events get enqueued while processing.
        var processingEventQueue = $3ae3e94baf5c3075$var$eventQueue;
        $3ae3e94baf5c3075$var$eventQueue = null;
        if (simulated) $e6Ok2(processingEventQueue, $3ae3e94baf5c3075$var$executeDispatchesAndReleaseSimulated);
        else $e6Ok2(processingEventQueue, $3ae3e94baf5c3075$var$executeDispatchesAndReleaseTopLevel);
        !!$3ae3e94baf5c3075$var$eventQueue && $jOpPq("95");
        // This would be a good time to rethrow if any of the event handlers threw.
        $knj2S.rethrowCaughtError();
    },
    /**
   * These are needed for tests only. Do not use!
   */ __purge: function() {
        $3ae3e94baf5c3075$var$listenerBank = {};
    },
    __getListenerBank: function() {
        return $3ae3e94baf5c3075$var$listenerBank;
    }
};
module.exports = $3ae3e94baf5c3075$var$EventPluginHub;

});
parcelRegister("6cytr", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
parcelRequire("4Mb5c");
/**
 * Injectable ordering of event plugins.
 */ var $483e9ad61c499428$var$eventPluginOrder = null;
/**
 * Injectable mapping from names to event plugin modules.
 */ var $483e9ad61c499428$var$namesToPlugins = {};
/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */ function $483e9ad61c499428$var$recomputePluginOrdering() {
    if (!$483e9ad61c499428$var$eventPluginOrder) // Wait until an `eventPluginOrder` is injected.
    return;
    for(var pluginName in $483e9ad61c499428$var$namesToPlugins){
        var pluginModule = $483e9ad61c499428$var$namesToPlugins[pluginName];
        var pluginIndex = $483e9ad61c499428$var$eventPluginOrder.indexOf(pluginName);
        !(pluginIndex > -1) && $jOpPq("96", pluginName);
        if ($483e9ad61c499428$var$EventPluginRegistry.plugins[pluginIndex]) continue;
        !pluginModule.extractEvents && $jOpPq("97", pluginName);
        $483e9ad61c499428$var$EventPluginRegistry.plugins[pluginIndex] = pluginModule;
        var publishedEvents = pluginModule.eventTypes;
        for(var eventName in publishedEvents)!$483e9ad61c499428$var$publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) && $jOpPq("98", eventName, pluginName);
    }
}
/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */ function $483e9ad61c499428$var$publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
    !!$483e9ad61c499428$var$EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) && $jOpPq("99", eventName);
    $483e9ad61c499428$var$EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
    var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
    if (phasedRegistrationNames) {
        for(var phaseName in phasedRegistrationNames)if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
            var phasedRegistrationName = phasedRegistrationNames[phaseName];
            $483e9ad61c499428$var$publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
        }
        return true;
    } else if (dispatchConfig.registrationName) {
        $483e9ad61c499428$var$publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
        return true;
    }
    return false;
}
/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */ function $483e9ad61c499428$var$publishRegistrationName(registrationName, pluginModule, eventName) {
    !!$483e9ad61c499428$var$EventPluginRegistry.registrationNameModules[registrationName] && $jOpPq("100", registrationName);
    $483e9ad61c499428$var$EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
    $483e9ad61c499428$var$EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
    var lowerCasedName;
}
/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */ var $483e9ad61c499428$var$EventPluginRegistry = {
    /**
   * Ordered list of injected plugins.
   */ plugins: [],
    /**
   * Mapping from event name to dispatch config
   */ eventNameDispatchConfigs: {},
    /**
   * Mapping from registration name to plugin module
   */ registrationNameModules: {},
    /**
   * Mapping from registration name to event name
   */ registrationNameDependencies: {},
    /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */ possibleRegistrationNames: null,
    // Trust the developer to only use possibleRegistrationNames in __DEV__
    /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */ injectEventPluginOrder: function(injectedEventPluginOrder) {
        !!$483e9ad61c499428$var$eventPluginOrder && $jOpPq("101");
        // Clone the ordering so it cannot be dynamically mutated.
        $483e9ad61c499428$var$eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
        $483e9ad61c499428$var$recomputePluginOrdering();
    },
    /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */ injectEventPluginsByName: function(injectedNamesToPlugins) {
        var isOrderingDirty = false;
        for(var pluginName in injectedNamesToPlugins){
            if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) continue;
            var pluginModule = injectedNamesToPlugins[pluginName];
            if (!$483e9ad61c499428$var$namesToPlugins.hasOwnProperty(pluginName) || $483e9ad61c499428$var$namesToPlugins[pluginName] !== pluginModule) {
                !!$483e9ad61c499428$var$namesToPlugins[pluginName] && $jOpPq("102", pluginName);
                $483e9ad61c499428$var$namesToPlugins[pluginName] = pluginModule;
                isOrderingDirty = true;
            }
        }
        if (isOrderingDirty) $483e9ad61c499428$var$recomputePluginOrdering();
    },
    /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */ getPluginModuleForEvent: function(event) {
        var dispatchConfig = event.dispatchConfig;
        if (dispatchConfig.registrationName) return $483e9ad61c499428$var$EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
        if (dispatchConfig.phasedRegistrationNames !== undefined) {
            // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
            // that it is not undefined.
            var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
            for(var phase in phasedRegistrationNames){
                if (!phasedRegistrationNames.hasOwnProperty(phase)) continue;
                var pluginModule = $483e9ad61c499428$var$EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
                if (pluginModule) return pluginModule;
            }
        }
        return null;
    },
    /**
   * Exposed for unit testing.
   * @private
   */ _resetEventPlugins: function() {
        $483e9ad61c499428$var$eventPluginOrder = null;
        for(var pluginName in $483e9ad61c499428$var$namesToPlugins)if ($483e9ad61c499428$var$namesToPlugins.hasOwnProperty(pluginName)) delete $483e9ad61c499428$var$namesToPlugins[pluginName];
        $483e9ad61c499428$var$EventPluginRegistry.plugins.length = 0;
        var eventNameDispatchConfigs = $483e9ad61c499428$var$EventPluginRegistry.eventNameDispatchConfigs;
        for(var eventName in eventNameDispatchConfigs)if (eventNameDispatchConfigs.hasOwnProperty(eventName)) delete eventNameDispatchConfigs[eventName];
        var registrationNameModules = $483e9ad61c499428$var$EventPluginRegistry.registrationNameModules;
        for(var registrationName in registrationNameModules)if (registrationNameModules.hasOwnProperty(registrationName)) delete registrationNameModules[registrationName];
        var possibleRegistrationNames, lowerCasedName;
    }
};
module.exports = $483e9ad61c499428$var$EventPluginRegistry;

});

parcelRegister("9l8z5", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $knj2S = parcelRequire("knj2S");
parcelRequire("4Mb5c");
parcelRequire("fIzgz");
/**
 * Injected dependencies:
 */ /**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */ var $6cccb80f3e47b61c$var$ComponentTree;
var $6cccb80f3e47b61c$var$TreeTraversal;
var $6cccb80f3e47b61c$var$injection = {
    injectComponentTree: function(Injected) {
        $6cccb80f3e47b61c$var$ComponentTree = Injected;
    },
    injectTreeTraversal: function(Injected) {
        $6cccb80f3e47b61c$var$TreeTraversal = Injected;
    }
};
function $6cccb80f3e47b61c$var$isEndish(topLevelType) {
    return topLevelType === "topMouseUp" || topLevelType === "topTouchEnd" || topLevelType === "topTouchCancel";
}
function $6cccb80f3e47b61c$var$isMoveish(topLevelType) {
    return topLevelType === "topMouseMove" || topLevelType === "topTouchMove";
}
function $6cccb80f3e47b61c$var$isStartish(topLevelType) {
    return topLevelType === "topMouseDown" || topLevelType === "topTouchStart";
}
var $6cccb80f3e47b61c$var$validateEventDispatches;
/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */ function $6cccb80f3e47b61c$var$executeDispatch(event, simulated, listener, inst) {
    var type = event.type || "unknown-event";
    event.currentTarget = $6cccb80f3e47b61c$var$EventPluginUtils.getNodeFromInstance(inst);
    if (simulated) $knj2S.invokeGuardedCallbackWithCatch(type, listener, event);
    else $knj2S.invokeGuardedCallback(type, listener, event);
    event.currentTarget = null;
}
/**
 * Standard/simple iteration through an event's collected dispatches.
 */ function $6cccb80f3e47b61c$var$executeDispatchesInOrder(event, simulated) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;
    if (Array.isArray(dispatchListeners)) for(var i = 0; i < dispatchListeners.length; i++){
        if (event.isPropagationStopped()) break;
        // Listeners and Instances are two parallel arrays that are always in sync.
        $6cccb80f3e47b61c$var$executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
    else if (dispatchListeners) $6cccb80f3e47b61c$var$executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
    event._dispatchListeners = null;
    event._dispatchInstances = null;
}
/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */ function $6cccb80f3e47b61c$var$executeDispatchesInOrderStopAtTrueImpl(event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;
    if (Array.isArray(dispatchListeners)) for(var i = 0; i < dispatchListeners.length; i++){
        if (event.isPropagationStopped()) break;
        // Listeners and Instances are two parallel arrays that are always in sync.
        if (dispatchListeners[i](event, dispatchInstances[i])) return dispatchInstances[i];
    }
    else if (dispatchListeners) {
        if (dispatchListeners(event, dispatchInstances)) return dispatchInstances;
    }
    return null;
}
/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */ function $6cccb80f3e47b61c$var$executeDispatchesInOrderStopAtTrue(event) {
    var ret = $6cccb80f3e47b61c$var$executeDispatchesInOrderStopAtTrueImpl(event);
    event._dispatchInstances = null;
    event._dispatchListeners = null;
    return ret;
}
/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */ function $6cccb80f3e47b61c$var$executeDirectDispatch(event) {
    var dispatchListener = event._dispatchListeners;
    var dispatchInstance = event._dispatchInstances;
    !!Array.isArray(dispatchListener) && $jOpPq("103");
    event.currentTarget = dispatchListener ? $6cccb80f3e47b61c$var$EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
    var res = dispatchListener ? dispatchListener(event) : null;
    event.currentTarget = null;
    event._dispatchListeners = null;
    event._dispatchInstances = null;
    return res;
}
/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */ function $6cccb80f3e47b61c$var$hasDispatches(event) {
    return !!event._dispatchListeners;
}
/**
 * General utilities that are useful in creating custom Event Plugins.
 */ var $6cccb80f3e47b61c$var$EventPluginUtils = {
    isEndish: $6cccb80f3e47b61c$var$isEndish,
    isMoveish: $6cccb80f3e47b61c$var$isMoveish,
    isStartish: $6cccb80f3e47b61c$var$isStartish,
    executeDirectDispatch: $6cccb80f3e47b61c$var$executeDirectDispatch,
    executeDispatchesInOrder: $6cccb80f3e47b61c$var$executeDispatchesInOrder,
    executeDispatchesInOrderStopAtTrue: $6cccb80f3e47b61c$var$executeDispatchesInOrderStopAtTrue,
    hasDispatches: $6cccb80f3e47b61c$var$hasDispatches,
    getInstanceFromNode: function(node) {
        return $6cccb80f3e47b61c$var$ComponentTree.getInstanceFromNode(node);
    },
    getNodeFromInstance: function(node) {
        return $6cccb80f3e47b61c$var$ComponentTree.getNodeFromInstance(node);
    },
    isAncestor: function(a, b) {
        return $6cccb80f3e47b61c$var$TreeTraversal.isAncestor(a, b);
    },
    getLowestCommonAncestor: function(a, b) {
        return $6cccb80f3e47b61c$var$TreeTraversal.getLowestCommonAncestor(a, b);
    },
    getParentInstance: function(inst) {
        return $6cccb80f3e47b61c$var$TreeTraversal.getParentInstance(inst);
    },
    traverseTwoPhase: function(target, fn, arg) {
        return $6cccb80f3e47b61c$var$TreeTraversal.traverseTwoPhase(target, fn, arg);
    },
    traverseEnterLeave: function(from, to, fn, argFrom, argTo) {
        return $6cccb80f3e47b61c$var$TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
    },
    injection: $6cccb80f3e47b61c$var$injection
};
module.exports = $6cccb80f3e47b61c$var$EventPluginUtils;

});
parcelRegister("knj2S", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
var $ed54ba9fe74b3eaf$var$caughtError = null;
/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */ function $ed54ba9fe74b3eaf$var$invokeGuardedCallback(name, func, a) {
    try {
        func(a);
    } catch (x) {
        if ($ed54ba9fe74b3eaf$var$caughtError === null) $ed54ba9fe74b3eaf$var$caughtError = x;
    }
}
var $ed54ba9fe74b3eaf$var$ReactErrorUtils = {
    invokeGuardedCallback: $ed54ba9fe74b3eaf$var$invokeGuardedCallback,
    /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */ invokeGuardedCallbackWithCatch: $ed54ba9fe74b3eaf$var$invokeGuardedCallback,
    /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */ rethrowCaughtError: function() {
        if ($ed54ba9fe74b3eaf$var$caughtError) {
            var error = $ed54ba9fe74b3eaf$var$caughtError;
            $ed54ba9fe74b3eaf$var$caughtError = null;
            throw error;
        }
    }
};
var $ed54ba9fe74b3eaf$var$fakeNode;
module.exports = $ed54ba9fe74b3eaf$var$ReactErrorUtils;

});


parcelRegister("2Py3n", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
parcelRequire("4Mb5c");
/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */ function $20fac28538a6b9ee$var$accumulateInto(current, next) {
    !(next != null) && $jOpPq("30");
    if (current == null) return next;
    // Both are not empty. Warning: Never call x.concat(y) when you are not
    // certain that x is an Array (x could be a string with concat method).
    if (Array.isArray(current)) {
        if (Array.isArray(next)) {
            current.push.apply(current, next);
            return current;
        }
        current.push(next);
        return current;
    }
    if (Array.isArray(next)) // A bit too dangerous to mutate `next`.
    return [
        current
    ].concat(next);
    return [
        current,
        next
    ];
}
module.exports = $20fac28538a6b9ee$var$accumulateInto;

});

parcelRegister("e6Ok2", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */ function $a458a9278d839b4e$var$forEachAccumulated(arr, cb, scope) {
    if (Array.isArray(arr)) arr.forEach(cb, scope);
    else if (arr) cb.call(scope, arr);
}
module.exports = $a458a9278d839b4e$var$forEachAccumulated;

});



parcelRegister("kx286", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
var $ef288aa564f32145$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */ var $ef288aa564f32145$var$ExecutionEnvironment = {
    canUseDOM: $ef288aa564f32145$var$canUseDOM,
    canUseWorkers: typeof Worker !== "undefined",
    canUseEventListeners: $ef288aa564f32145$var$canUseDOM && !!(window.addEventListener || window.attachEvent),
    canUseViewport: $ef288aa564f32145$var$canUseDOM && !!window.screen,
    isInWorker: !$ef288aa564f32145$var$canUseDOM // For now, this is true - might change in the future.
};
module.exports = $ef288aa564f32145$var$ExecutionEnvironment;

});

parcelRegister("feACA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $a6S4T = parcelRequire("a6S4T");

var $lM582 = parcelRequire("lM582");

var $eo8AR = parcelRequire("eo8AR");
/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */ function $b174920c6655886a$var$FallbackCompositionState(root) {
    this._root = root;
    this._startText = this.getText();
    this._fallbackText = null;
}
$a6S4T($b174920c6655886a$var$FallbackCompositionState.prototype, {
    destructor: function() {
        this._root = null;
        this._startText = null;
        this._fallbackText = null;
    },
    /**
   * Get current text of input.
   *
   * @return {string}
   */ getText: function() {
        if ("value" in this._root) return this._root.value;
        return this._root[$eo8AR()];
    },
    /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */ getData: function() {
        if (this._fallbackText) return this._fallbackText;
        var start;
        var startValue = this._startText;
        var startLength = startValue.length;
        var end;
        var endValue = this.getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        this._fallbackText = endValue.slice(start, sliceTail);
        return this._fallbackText;
    }
});
$lM582.addPoolingTo($b174920c6655886a$var$FallbackCompositionState);
module.exports = $b174920c6655886a$var$FallbackCompositionState;

});
parcelRegister("a6S4T", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $75c469a6fa2b9f7a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $75c469a6fa2b9f7a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $75c469a6fa2b9f7a$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $75c469a6fa2b9f7a$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $75c469a6fa2b9f7a$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $75c469a6fa2b9f7a$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $75c469a6fa2b9f7a$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($75c469a6fa2b9f7a$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($75c469a6fa2b9f7a$var$getOwnPropertySymbols) {
            symbols = $75c469a6fa2b9f7a$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($75c469a6fa2b9f7a$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("lM582", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
parcelRequire("4Mb5c");
/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */ var $fda20f18bcb1a805$var$oneArgumentPooler = function(copyFieldsFrom) {
    var Klass = this;
    if (Klass.instancePool.length) {
        var instance = Klass.instancePool.pop();
        Klass.call(instance, copyFieldsFrom);
        return instance;
    } else return new Klass(copyFieldsFrom);
};
var $fda20f18bcb1a805$var$twoArgumentPooler = function(a1, a2) {
    var Klass = this;
    if (Klass.instancePool.length) {
        var instance = Klass.instancePool.pop();
        Klass.call(instance, a1, a2);
        return instance;
    } else return new Klass(a1, a2);
};
var $fda20f18bcb1a805$var$threeArgumentPooler = function(a1, a2, a3) {
    var Klass = this;
    if (Klass.instancePool.length) {
        var instance = Klass.instancePool.pop();
        Klass.call(instance, a1, a2, a3);
        return instance;
    } else return new Klass(a1, a2, a3);
};
var $fda20f18bcb1a805$var$fourArgumentPooler = function(a1, a2, a3, a4) {
    var Klass = this;
    if (Klass.instancePool.length) {
        var instance = Klass.instancePool.pop();
        Klass.call(instance, a1, a2, a3, a4);
        return instance;
    } else return new Klass(a1, a2, a3, a4);
};
var $fda20f18bcb1a805$var$standardReleaser = function(instance) {
    var Klass = this;
    !(instance instanceof Klass) && $jOpPq("25");
    instance.destructor();
    if (Klass.instancePool.length < Klass.poolSize) Klass.instancePool.push(instance);
};
var $fda20f18bcb1a805$var$DEFAULT_POOL_SIZE = 10;
var $fda20f18bcb1a805$var$DEFAULT_POOLER = $fda20f18bcb1a805$var$oneArgumentPooler;
/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */ var $fda20f18bcb1a805$var$addPoolingTo = function(CopyConstructor, pooler) {
    // Casting as any so that flow ignores the actual implementation and trusts
    // it to match the type we declared
    var NewKlass = CopyConstructor;
    NewKlass.instancePool = [];
    NewKlass.getPooled = pooler || $fda20f18bcb1a805$var$DEFAULT_POOLER;
    if (!NewKlass.poolSize) NewKlass.poolSize = $fda20f18bcb1a805$var$DEFAULT_POOL_SIZE;
    NewKlass.release = $fda20f18bcb1a805$var$standardReleaser;
    return NewKlass;
};
var $fda20f18bcb1a805$var$PooledClass = {
    addPoolingTo: $fda20f18bcb1a805$var$addPoolingTo,
    oneArgumentPooler: $fda20f18bcb1a805$var$oneArgumentPooler,
    twoArgumentPooler: $fda20f18bcb1a805$var$twoArgumentPooler,
    threeArgumentPooler: $fda20f18bcb1a805$var$threeArgumentPooler,
    fourArgumentPooler: $fda20f18bcb1a805$var$fourArgumentPooler
};
module.exports = $fda20f18bcb1a805$var$PooledClass;

});

parcelRegister("eo8AR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $kx286 = parcelRequire("kx286");
var $a799f914d22e3fe6$var$contentKey = null;
/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */ function $a799f914d22e3fe6$var$getTextContentAccessor() {
    if (!$a799f914d22e3fe6$var$contentKey && $kx286.canUseDOM) // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    $a799f914d22e3fe6$var$contentKey = "textContent" in document.documentElement ? "textContent" : "innerText";
    return $a799f914d22e3fe6$var$contentKey;
}
module.exports = $a799f914d22e3fe6$var$getTextContentAccessor;

});


parcelRegister("3HlIe", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $6CUXY = parcelRequire("6CUXY");
/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var $2b163ae0acc0be54$var$CompositionEventInterface = {
    data: null
};
/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */ function $2b163ae0acc0be54$var$SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
    return $6CUXY.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}
$6CUXY.augmentClass($2b163ae0acc0be54$var$SyntheticCompositionEvent, $2b163ae0acc0be54$var$CompositionEventInterface);
module.exports = $2b163ae0acc0be54$var$SyntheticCompositionEvent;

});
parcelRegister("6CUXY", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $a6S4T = parcelRequire("a6S4T");

var $lM582 = parcelRequire("lM582");

var $46CSh = parcelRequire("46CSh");
parcelRequire("fIzgz");
var $4d327afdf30b4fe5$var$didWarnForAddedNewProperty = false;
var $4d327afdf30b4fe5$var$isProxySupported = typeof Proxy === "function";
var $4d327afdf30b4fe5$var$shouldBeReleasedProperties = [
    "dispatchConfig",
    "_targetInst",
    "nativeEvent",
    "isDefaultPrevented",
    "isPropagationStopped",
    "_dispatchListeners",
    "_dispatchInstances"
];
/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var $4d327afdf30b4fe5$var$EventInterface = {
    type: null,
    target: null,
    // currentTarget is set when dispatching; no use in copying it here
    currentTarget: $46CSh.thatReturnsNull,
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */ function $4d327afdf30b4fe5$var$SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
    this.dispatchConfig = dispatchConfig;
    this._targetInst = targetInst;
    this.nativeEvent = nativeEvent;
    var Interface = this.constructor.Interface;
    for(var propName in Interface){
        if (!Interface.hasOwnProperty(propName)) continue;
        var normalize = Interface[propName];
        if (normalize) this[propName] = normalize(nativeEvent);
        else if (propName === "target") this.target = nativeEventTarget;
        else this[propName] = nativeEvent[propName];
    }
    var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
    if (defaultPrevented) this.isDefaultPrevented = $46CSh.thatReturnsTrue;
    else this.isDefaultPrevented = $46CSh.thatReturnsFalse;
    this.isPropagationStopped = $46CSh.thatReturnsFalse;
    return this;
}
$a6S4T($4d327afdf30b4fe5$var$SyntheticEvent.prototype, {
    preventDefault: function() {
        this.defaultPrevented = true;
        var event = this.nativeEvent;
        if (!event) return;
        if (event.preventDefault) event.preventDefault();
        else if (typeof event.returnValue !== "unknown") event.returnValue = false;
        this.isDefaultPrevented = $46CSh.thatReturnsTrue;
    },
    stopPropagation: function() {
        var event = this.nativeEvent;
        if (!event) return;
        if (event.stopPropagation) event.stopPropagation();
        else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
        // IE. This event does not support bubbling or cancelling, and
        // any references to cancelBubble throw "Member not found".  A
        // typeof check of "unknown" circumvents this issue (and is also
        // IE specific).
        event.cancelBubble = true;
        this.isPropagationStopped = $46CSh.thatReturnsTrue;
    },
    /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */ persist: function() {
        this.isPersistent = $46CSh.thatReturnsTrue;
    },
    /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */ isPersistent: $46CSh.thatReturnsFalse,
    /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */ destructor: function() {
        var Interface = this.constructor.Interface;
        for(var propName in Interface)this[propName] = null;
        for(var i = 0; i < $4d327afdf30b4fe5$var$shouldBeReleasedProperties.length; i++)this[$4d327afdf30b4fe5$var$shouldBeReleasedProperties[i]] = null;
    }
});
$4d327afdf30b4fe5$var$SyntheticEvent.Interface = $4d327afdf30b4fe5$var$EventInterface;
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */ $4d327afdf30b4fe5$var$SyntheticEvent.augmentClass = function(Class, Interface) {
    var Super = this;
    var E = function() {};
    E.prototype = Super.prototype;
    var prototype = new E();
    $a6S4T(prototype, Class.prototype);
    Class.prototype = prototype;
    Class.prototype.constructor = Class;
    Class.Interface = $a6S4T({}, Super.Interface, Interface);
    Class.augmentClass = Super.augmentClass;
    $lM582.addPoolingTo(Class, $lM582.fourArgumentPooler);
};
$lM582.addPoolingTo($4d327afdf30b4fe5$var$SyntheticEvent, $lM582.fourArgumentPooler);
module.exports = $4d327afdf30b4fe5$var$SyntheticEvent;
/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */ function $4d327afdf30b4fe5$var$getPooledWarningPropertyDefinition(propName, getVal) {
    var isFunction = typeof getVal === "function";
    return {
        configurable: true,
        set: set,
        get: get
    };
    function set(val) {
        var action = isFunction ? "setting the method" : "setting the property";
        warn(action, "This is effectively a no-op");
        return val;
    }
    function get() {
        var action = isFunction ? "accessing the method" : "accessing the property";
        var result = isFunction ? "This is a no-op function" : "This is set to null";
        warn(action, result);
        return getVal;
    }
    function warn(action, result) {
        var warningCondition = false;
    }
}

});


parcelRegister("1nrfj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $6CUXY = parcelRequire("6CUXY");
/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ var $100d12ea2b10e52b$var$InputEventInterface = {
    data: null
};
/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */ function $100d12ea2b10e52b$var$SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
    return $6CUXY.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}
$6CUXY.augmentClass($100d12ea2b10e52b$var$SyntheticInputEvent, $100d12ea2b10e52b$var$InputEventInterface);
module.exports = $100d12ea2b10e52b$var$SyntheticInputEvent;

});


parcelRegister("haaI9", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $53teI = parcelRequire("53teI");

var $1lzph = parcelRequire("1lzph");

var $kx286 = parcelRequire("kx286");

var $5fGpM = parcelRequire("5fGpM");

var $gDXrr = parcelRequire("gDXrr");

var $6CUXY = parcelRequire("6CUXY");

var $clPIH = parcelRequire("clPIH");

var $aNWE1 = parcelRequire("aNWE1");

var $7yqoI = parcelRequire("7yqoI");

var $2qW9o = parcelRequire("2qW9o");
var $c7ebadda9eb0e180$var$eventTypes = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: [
            "topBlur",
            "topChange",
            "topClick",
            "topFocus",
            "topInput",
            "topKeyDown",
            "topKeyUp",
            "topSelectionChange"
        ]
    }
};
function $c7ebadda9eb0e180$var$createAndAccumulateChangeEvent(inst, nativeEvent, target) {
    var event = $6CUXY.getPooled($c7ebadda9eb0e180$var$eventTypes.change, inst, nativeEvent, target);
    event.type = "change";
    $1lzph.accumulateTwoPhaseDispatches(event);
    return event;
}
/**
 * For IE shims
 */ var $c7ebadda9eb0e180$var$activeElement = null;
var $c7ebadda9eb0e180$var$activeElementInst = null;
/**
 * SECTION: handle `change` event
 */ function $c7ebadda9eb0e180$var$shouldUseChangeEvent(elem) {
    var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName === "select" || nodeName === "input" && elem.type === "file";
}
var $c7ebadda9eb0e180$var$doesChangeEventBubble = false;
if ($kx286.canUseDOM) // See `handleChange` comment below
$c7ebadda9eb0e180$var$doesChangeEventBubble = $7yqoI("change") && (!document.documentMode || document.documentMode > 8);
function $c7ebadda9eb0e180$var$manualDispatchChangeEvent(nativeEvent) {
    var event = $c7ebadda9eb0e180$var$createAndAccumulateChangeEvent($c7ebadda9eb0e180$var$activeElementInst, nativeEvent, $aNWE1(nativeEvent));
    // If change and propertychange bubbled, we'd just bind to it like all the
    // other events and have it go through ReactBrowserEventEmitter. Since it
    // doesn't, we manually listen for the events and so we have to enqueue and
    // process the abstract event manually.
    //
    // Batching is necessary here in order to ensure that all event handlers run
    // before the next rerender (including event handlers attached to ancestor
    // elements instead of directly on the input). Without this, controlled
    // components don't work properly in conjunction with event bubbling because
    // the component is rerendered and the value reverted before all the event
    // handlers can run. See https://github.com/facebook/react/issues/708.
    $gDXrr.batchedUpdates($c7ebadda9eb0e180$var$runEventInBatch, event);
}
function $c7ebadda9eb0e180$var$runEventInBatch(event) {
    $53teI.enqueueEvents(event);
    $53teI.processEventQueue(false);
}
function $c7ebadda9eb0e180$var$startWatchingForChangeEventIE8(target, targetInst) {
    $c7ebadda9eb0e180$var$activeElement = target;
    $c7ebadda9eb0e180$var$activeElementInst = targetInst;
    $c7ebadda9eb0e180$var$activeElement.attachEvent("onchange", $c7ebadda9eb0e180$var$manualDispatchChangeEvent);
}
function $c7ebadda9eb0e180$var$stopWatchingForChangeEventIE8() {
    if (!$c7ebadda9eb0e180$var$activeElement) return;
    $c7ebadda9eb0e180$var$activeElement.detachEvent("onchange", $c7ebadda9eb0e180$var$manualDispatchChangeEvent);
    $c7ebadda9eb0e180$var$activeElement = null;
    $c7ebadda9eb0e180$var$activeElementInst = null;
}
function $c7ebadda9eb0e180$var$getInstIfValueChanged(targetInst, nativeEvent) {
    var updated = $clPIH.updateValueIfChanged(targetInst);
    var simulated = nativeEvent.simulated === true && $c7ebadda9eb0e180$var$ChangeEventPlugin._allowSimulatedPassThrough;
    if (updated || simulated) return targetInst;
}
function $c7ebadda9eb0e180$var$getTargetInstForChangeEvent(topLevelType, targetInst) {
    if (topLevelType === "topChange") return targetInst;
}
function $c7ebadda9eb0e180$var$handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
    if (topLevelType === "topFocus") {
        // stopWatching() should be a noop here but we call it just in case we
        // missed a blur event somehow.
        $c7ebadda9eb0e180$var$stopWatchingForChangeEventIE8();
        $c7ebadda9eb0e180$var$startWatchingForChangeEventIE8(target, targetInst);
    } else if (topLevelType === "topBlur") $c7ebadda9eb0e180$var$stopWatchingForChangeEventIE8();
}
/**
 * SECTION: handle `input` event
 */ var $c7ebadda9eb0e180$var$isInputEventSupported = false;
if ($kx286.canUseDOM) // IE9 claims to support the input event but fails to trigger it when
// deleting text, so we ignore its input events.
$c7ebadda9eb0e180$var$isInputEventSupported = $7yqoI("input") && (!document.documentMode || document.documentMode > 9);
/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function $c7ebadda9eb0e180$var$startWatchingForValueChange(target, targetInst) {
    $c7ebadda9eb0e180$var$activeElement = target;
    $c7ebadda9eb0e180$var$activeElementInst = targetInst;
    $c7ebadda9eb0e180$var$activeElement.attachEvent("onpropertychange", $c7ebadda9eb0e180$var$handlePropertyChange);
}
/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function $c7ebadda9eb0e180$var$stopWatchingForValueChange() {
    if (!$c7ebadda9eb0e180$var$activeElement) return;
    $c7ebadda9eb0e180$var$activeElement.detachEvent("onpropertychange", $c7ebadda9eb0e180$var$handlePropertyChange);
    $c7ebadda9eb0e180$var$activeElement = null;
    $c7ebadda9eb0e180$var$activeElementInst = null;
}
/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function $c7ebadda9eb0e180$var$handlePropertyChange(nativeEvent) {
    if (nativeEvent.propertyName !== "value") return;
    if ($c7ebadda9eb0e180$var$getInstIfValueChanged($c7ebadda9eb0e180$var$activeElementInst, nativeEvent)) $c7ebadda9eb0e180$var$manualDispatchChangeEvent(nativeEvent);
}
function $c7ebadda9eb0e180$var$handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
    if (topLevelType === "topFocus") {
        // In IE8, we can capture almost all .value changes by adding a
        // propertychange handler and looking for events with propertyName
        // equal to 'value'
        // In IE9, propertychange fires for most input events but is buggy and
        // doesn't fire when text is deleted, but conveniently, selectionchange
        // appears to fire in all of the remaining cases so we catch those and
        // forward the event if the value has changed
        // In either case, we don't want to call the event handler if the value
        // is changed from JS so we redefine a setter for `.value` that updates
        // our activeElementValue variable, allowing us to ignore those changes
        //
        // stopWatching() should be a noop here but we call it just in case we
        // missed a blur event somehow.
        $c7ebadda9eb0e180$var$stopWatchingForValueChange();
        $c7ebadda9eb0e180$var$startWatchingForValueChange(target, targetInst);
    } else if (topLevelType === "topBlur") $c7ebadda9eb0e180$var$stopWatchingForValueChange();
}
// For IE8 and IE9.
function $c7ebadda9eb0e180$var$getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
    if (topLevelType === "topSelectionChange" || topLevelType === "topKeyUp" || topLevelType === "topKeyDown") // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return $c7ebadda9eb0e180$var$getInstIfValueChanged($c7ebadda9eb0e180$var$activeElementInst, nativeEvent);
}
/**
 * SECTION: handle `click` event
 */ function $c7ebadda9eb0e180$var$shouldUseClickEvent(elem) {
    // Use the `click` event to detect changes to checkbox and radio inputs.
    // This approach works across all browsers, whereas `change` does not fire
    // until `blur` in IE8.
    var nodeName = elem.nodeName;
    return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
}
function $c7ebadda9eb0e180$var$getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
    if (topLevelType === "topClick") return $c7ebadda9eb0e180$var$getInstIfValueChanged(targetInst, nativeEvent);
}
function $c7ebadda9eb0e180$var$getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
    if (topLevelType === "topInput" || topLevelType === "topChange") return $c7ebadda9eb0e180$var$getInstIfValueChanged(targetInst, nativeEvent);
}
function $c7ebadda9eb0e180$var$handleControlledInputBlur(inst, node) {
    // TODO: In IE, inst is occasionally null. Why?
    if (inst == null) return;
    // Fiber and ReactDOM keep wrapper state in separate places
    var state = inst._wrapperState || node._wrapperState;
    if (!state || !state.controlled || node.type !== "number") return;
    // If controlled, assign the value attribute to the current value on blur
    var value = "" + node.value;
    if (node.getAttribute("value") !== value) node.setAttribute("value", value);
}
/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ var $c7ebadda9eb0e180$var$ChangeEventPlugin = {
    eventTypes: $c7ebadda9eb0e180$var$eventTypes,
    _allowSimulatedPassThrough: true,
    _isInputEventSupported: $c7ebadda9eb0e180$var$isInputEventSupported,
    extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        var targetNode = targetInst ? $5fGpM.getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if ($c7ebadda9eb0e180$var$shouldUseChangeEvent(targetNode)) {
            if ($c7ebadda9eb0e180$var$doesChangeEventBubble) getTargetInstFunc = $c7ebadda9eb0e180$var$getTargetInstForChangeEvent;
            else handleEventFunc = $c7ebadda9eb0e180$var$handleEventsForChangeEventIE8;
        } else if ($2qW9o(targetNode)) {
            if ($c7ebadda9eb0e180$var$isInputEventSupported) getTargetInstFunc = $c7ebadda9eb0e180$var$getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = $c7ebadda9eb0e180$var$getTargetInstForInputEventPolyfill;
                handleEventFunc = $c7ebadda9eb0e180$var$handleEventsForInputEventPolyfill;
            }
        } else if ($c7ebadda9eb0e180$var$shouldUseClickEvent(targetNode)) getTargetInstFunc = $c7ebadda9eb0e180$var$getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
            if (inst) {
                var event = $c7ebadda9eb0e180$var$createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
                return event;
            }
        }
        if (handleEventFunc) handleEventFunc(topLevelType, targetNode, targetInst);
        // When blurring, set the value attribute for number inputs
        if (topLevelType === "topBlur") $c7ebadda9eb0e180$var$handleControlledInputBlur(targetInst, targetNode);
    }
};
module.exports = $c7ebadda9eb0e180$var$ChangeEventPlugin;

});
parcelRegister("gDXrr", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $a6S4T = parcelRequire("a6S4T");

var $7QUwY = parcelRequire("7QUwY");

var $lM582 = parcelRequire("lM582");

var $isyRe = parcelRequire("isyRe");

var $5Kdrw = parcelRequire("5Kdrw");

var $2PXJf = parcelRequire("2PXJf");

var $4Mb5c = parcelRequire("4Mb5c");
var $c1de65bf8dc4426c$var$dirtyComponents = [];
var $c1de65bf8dc4426c$var$updateBatchNumber = 0;
var $c1de65bf8dc4426c$var$asapCallbackQueue = $7QUwY.getPooled();
var $c1de65bf8dc4426c$var$asapEnqueued = false;
var $c1de65bf8dc4426c$var$batchingStrategy = null;
function $c1de65bf8dc4426c$var$ensureInjected() {
    !($c1de65bf8dc4426c$var$ReactUpdates.ReactReconcileTransaction && $c1de65bf8dc4426c$var$batchingStrategy) && $jOpPq("123");
}
var $c1de65bf8dc4426c$var$NESTED_UPDATES = {
    initialize: function() {
        this.dirtyComponentsLength = $c1de65bf8dc4426c$var$dirtyComponents.length;
    },
    close: function() {
        if (this.dirtyComponentsLength !== $c1de65bf8dc4426c$var$dirtyComponents.length) {
            // Additional updates were enqueued by componentDidUpdate handlers or
            // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
            // these new updates so that if A's componentDidUpdate calls setState on
            // B, B will update before the callback A's updater provided when calling
            // setState.
            $c1de65bf8dc4426c$var$dirtyComponents.splice(0, this.dirtyComponentsLength);
            $c1de65bf8dc4426c$var$flushBatchedUpdates();
        } else $c1de65bf8dc4426c$var$dirtyComponents.length = 0;
    }
};
var $c1de65bf8dc4426c$var$UPDATE_QUEUEING = {
    initialize: function() {
        this.callbackQueue.reset();
    },
    close: function() {
        this.callbackQueue.notifyAll();
    }
};
var $c1de65bf8dc4426c$var$TRANSACTION_WRAPPERS = [
    $c1de65bf8dc4426c$var$NESTED_UPDATES,
    $c1de65bf8dc4426c$var$UPDATE_QUEUEING
];
function $c1de65bf8dc4426c$var$ReactUpdatesFlushTransaction() {
    this.reinitializeTransaction();
    this.dirtyComponentsLength = null;
    this.callbackQueue = $7QUwY.getPooled();
    this.reconcileTransaction = $c1de65bf8dc4426c$var$ReactUpdates.ReactReconcileTransaction.getPooled(/* useCreateElement */ true);
}
$a6S4T($c1de65bf8dc4426c$var$ReactUpdatesFlushTransaction.prototype, $2PXJf, {
    getTransactionWrappers: function() {
        return $c1de65bf8dc4426c$var$TRANSACTION_WRAPPERS;
    },
    destructor: function() {
        this.dirtyComponentsLength = null;
        $7QUwY.release(this.callbackQueue);
        this.callbackQueue = null;
        $c1de65bf8dc4426c$var$ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
        this.reconcileTransaction = null;
    },
    perform: function(method, scope, a) {
        // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
        // with this transaction's wrappers around it.
        return $2PXJf.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
    }
});
$lM582.addPoolingTo($c1de65bf8dc4426c$var$ReactUpdatesFlushTransaction);
function $c1de65bf8dc4426c$var$batchedUpdates(callback, a, b, c, d, e) {
    $c1de65bf8dc4426c$var$ensureInjected();
    return $c1de65bf8dc4426c$var$batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}
/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */ function $c1de65bf8dc4426c$var$mountOrderComparator(c1, c2) {
    return c1._mountOrder - c2._mountOrder;
}
function $c1de65bf8dc4426c$var$runBatchedUpdates(transaction) {
    var len = transaction.dirtyComponentsLength;
    !(len === $c1de65bf8dc4426c$var$dirtyComponents.length) && $jOpPq("124", len, $c1de65bf8dc4426c$var$dirtyComponents.length);
    // Since reconciling a component higher in the owner hierarchy usually (not
    // always -- see shouldComponentUpdate()) will reconcile children, reconcile
    // them before their children by sorting the array.
    $c1de65bf8dc4426c$var$dirtyComponents.sort($c1de65bf8dc4426c$var$mountOrderComparator);
    // Any updates enqueued while reconciling must be performed after this entire
    // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
    // C, B could update twice in a single batch if C's render enqueues an update
    // to B (since B would have already updated, we should skip it, and the only
    // way we can know to do so is by checking the batch counter).
    $c1de65bf8dc4426c$var$updateBatchNumber++;
    for(var i = 0; i < len; i++){
        // If a component is unmounted before pending changes apply, it will still
        // be here, but we assume that it has cleared its _pendingCallbacks and
        // that performUpdateIfNecessary is a noop.
        var component = $c1de65bf8dc4426c$var$dirtyComponents[i];
        // If performUpdateIfNecessary happens to enqueue any new updates, we
        // shouldn't execute the callbacks until the next render happens, so
        // stash the callbacks first
        var callbacks = component._pendingCallbacks;
        component._pendingCallbacks = null;
        var markerName;
        if ($isyRe.logTopLevelRenders) {
            var namedComponent = component;
            // Duck type TopLevelWrapper. This is probably always true.
            if (component._currentElement.type.isReactTopLevelWrapper) namedComponent = component._renderedComponent;
            markerName = "React update: " + namedComponent.getName();
            console.time(markerName);
        }
        $5Kdrw.performUpdateIfNecessary(component, transaction.reconcileTransaction, $c1de65bf8dc4426c$var$updateBatchNumber);
        if (markerName) console.timeEnd(markerName);
        if (callbacks) for(var j = 0; j < callbacks.length; j++)transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
    }
}
var $c1de65bf8dc4426c$var$flushBatchedUpdates = function() {
    // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
    // array and perform any updates enqueued by mount-ready handlers (i.e.,
    // componentDidUpdate) but we need to check here too in order to catch
    // updates enqueued by setState callbacks and asap calls.
    while($c1de65bf8dc4426c$var$dirtyComponents.length || $c1de65bf8dc4426c$var$asapEnqueued){
        if ($c1de65bf8dc4426c$var$dirtyComponents.length) {
            var transaction = $c1de65bf8dc4426c$var$ReactUpdatesFlushTransaction.getPooled();
            transaction.perform($c1de65bf8dc4426c$var$runBatchedUpdates, null, transaction);
            $c1de65bf8dc4426c$var$ReactUpdatesFlushTransaction.release(transaction);
        }
        if ($c1de65bf8dc4426c$var$asapEnqueued) {
            $c1de65bf8dc4426c$var$asapEnqueued = false;
            var queue = $c1de65bf8dc4426c$var$asapCallbackQueue;
            $c1de65bf8dc4426c$var$asapCallbackQueue = $7QUwY.getPooled();
            queue.notifyAll();
            $7QUwY.release(queue);
        }
    }
};
/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */ function $c1de65bf8dc4426c$var$enqueueUpdate(component) {
    $c1de65bf8dc4426c$var$ensureInjected();
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (This is called by each top-level update
    // function, like setState, forceUpdate, etc.; creation and
    // destruction of top-level components is guarded in ReactMount.)
    if (!$c1de65bf8dc4426c$var$batchingStrategy.isBatchingUpdates) {
        $c1de65bf8dc4426c$var$batchingStrategy.batchedUpdates($c1de65bf8dc4426c$var$enqueueUpdate, component);
        return;
    }
    $c1de65bf8dc4426c$var$dirtyComponents.push(component);
    if (component._updateBatchNumber == null) component._updateBatchNumber = $c1de65bf8dc4426c$var$updateBatchNumber + 1;
}
/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */ function $c1de65bf8dc4426c$var$asap(callback, context) {
    $4Mb5c($c1de65bf8dc4426c$var$batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context whereupdates are not being batched.");
    $c1de65bf8dc4426c$var$asapCallbackQueue.enqueue(callback, context);
    $c1de65bf8dc4426c$var$asapEnqueued = true;
}
var $c1de65bf8dc4426c$var$ReactUpdatesInjection = {
    injectReconcileTransaction: function(ReconcileTransaction) {
        !ReconcileTransaction && $jOpPq("126");
        $c1de65bf8dc4426c$var$ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
    },
    injectBatchingStrategy: function(_batchingStrategy) {
        !_batchingStrategy && $jOpPq("127");
        !(typeof _batchingStrategy.batchedUpdates === "function") && $jOpPq("128");
        !(typeof _batchingStrategy.isBatchingUpdates === "boolean") && $jOpPq("129");
        $c1de65bf8dc4426c$var$batchingStrategy = _batchingStrategy;
    }
};
var $c1de65bf8dc4426c$var$ReactUpdates = {
    /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */ ReactReconcileTransaction: null,
    batchedUpdates: $c1de65bf8dc4426c$var$batchedUpdates,
    enqueueUpdate: $c1de65bf8dc4426c$var$enqueueUpdate,
    flushBatchedUpdates: $c1de65bf8dc4426c$var$flushBatchedUpdates,
    injection: $c1de65bf8dc4426c$var$ReactUpdatesInjection,
    asap: $c1de65bf8dc4426c$var$asap
};
module.exports = $c1de65bf8dc4426c$var$ReactUpdates;

});
parcelRegister("7QUwY", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
function $5b793d93a580c684$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $lM582 = parcelRequire("lM582");
parcelRequire("4Mb5c");
/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */ var $5b793d93a580c684$var$CallbackQueue = function() {
    function CallbackQueue(arg) {
        $5b793d93a580c684$var$_classCallCheck(this, CallbackQueue);
        this._callbacks = null;
        this._contexts = null;
        this._arg = arg;
    }
    /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */ CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
        this._callbacks = this._callbacks || [];
        this._callbacks.push(callback);
        this._contexts = this._contexts || [];
        this._contexts.push(context);
    };
    /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */ CallbackQueue.prototype.notifyAll = function notifyAll() {
        var callbacks = this._callbacks;
        var contexts = this._contexts;
        var arg = this._arg;
        if (callbacks && contexts) {
            !(callbacks.length === contexts.length) && $jOpPq("24");
            this._callbacks = null;
            this._contexts = null;
            for(var i = 0; i < callbacks.length; i++)callbacks[i].call(contexts[i], arg);
            callbacks.length = 0;
            contexts.length = 0;
        }
    };
    CallbackQueue.prototype.checkpoint = function checkpoint() {
        return this._callbacks ? this._callbacks.length : 0;
    };
    CallbackQueue.prototype.rollback = function rollback(len) {
        if (this._callbacks && this._contexts) {
            this._callbacks.length = len;
            this._contexts.length = len;
        }
    };
    /**
   * Resets the internal queue.
   *
   * @internal
   */ CallbackQueue.prototype.reset = function reset() {
        this._callbacks = null;
        this._contexts = null;
    };
    /**
   * `PooledClass` looks for this.
   */ CallbackQueue.prototype.destructor = function destructor() {
        this.reset();
    };
    return CallbackQueue;
}();
module.exports = $lM582.addPoolingTo($5b793d93a580c684$var$CallbackQueue);

});

parcelRegister("isyRe", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
var $d705e17dd2ec5faa$var$ReactFeatureFlags = {
    // When true, call console.time() before and .timeEnd() after each top-level
    // render (both initial renders and updates). Useful when looking at prod-mode
    // timeline profiles in Chrome, for example.
    logTopLevelRenders: false
};
module.exports = $d705e17dd2ec5faa$var$ReactFeatureFlags;

});

parcelRegister("5Kdrw", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $bwcIj = parcelRequire("bwcIj");
parcelRequire("d1IRY");
parcelRequire("fIzgz");
/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */ function $42ebad1c50ee9d28$var$attachRefs() {
    $bwcIj.attachRefs(this, this._currentElement);
}
var $42ebad1c50ee9d28$var$ReactReconciler = {
    /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */ mountComponent: function(internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) {
        var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
        if (internalInstance._currentElement && internalInstance._currentElement.ref != null) transaction.getReactMountReady().enqueue($42ebad1c50ee9d28$var$attachRefs, internalInstance);
        return markup;
    },
    /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */ getHostNode: function(internalInstance) {
        return internalInstance.getHostNode();
    },
    /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */ unmountComponent: function(internalInstance, safely) {
        $bwcIj.detachRefs(internalInstance, internalInstance._currentElement);
        internalInstance.unmountComponent(safely);
    },
    /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */ receiveComponent: function(internalInstance, nextElement, transaction, context) {
        var prevElement = internalInstance._currentElement;
        if (nextElement === prevElement && context === internalInstance._context) // Since elements are immutable after the owner is rendered,
        // we can do a cheap identity compare here to determine if this is a
        // superfluous reconcile. It's possible for state to be mutable but such
        // change should trigger an update of the owner which would recreate
        // the element. We explicitly check for the existence of an owner since
        // it's possible for an element created outside a composite to be
        // deeply mutated and reused.
        // TODO: Bailing out early is just a perf optimization right?
        // TODO: Removing the return statement should affect correctness?
        return;
        var refsChanged = $bwcIj.shouldUpdateRefs(prevElement, nextElement);
        if (refsChanged) $bwcIj.detachRefs(internalInstance, prevElement);
        internalInstance.receiveComponent(nextElement, transaction, context);
        if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) transaction.getReactMountReady().enqueue($42ebad1c50ee9d28$var$attachRefs, internalInstance);
    },
    /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */ performUpdateIfNecessary: function(internalInstance, transaction, updateBatchNumber) {
        if (internalInstance._updateBatchNumber !== updateBatchNumber) return;
        internalInstance.performUpdateIfNecessary(transaction);
    }
};
module.exports = $42ebad1c50ee9d28$var$ReactReconciler;

});
parcelRegister("bwcIj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";

var $fNjKe = parcelRequire("fNjKe");
var $862c8b89b22ec5f7$var$ReactRef = {};
function $862c8b89b22ec5f7$var$attachRef(ref, component, owner) {
    if (typeof ref === "function") ref(component.getPublicInstance());
    else // Legacy ref
    $fNjKe.addComponentAsRefTo(component, ref, owner);
}
function $862c8b89b22ec5f7$var$detachRef(ref, component, owner) {
    if (typeof ref === "function") ref(null);
    else // Legacy ref
    $fNjKe.removeComponentAsRefFrom(component, ref, owner);
}
$862c8b89b22ec5f7$var$ReactRef.attachRefs = function(instance, element) {
    if (element === null || typeof element !== "object") return;
    var ref = element.ref;
    if (ref != null) $862c8b89b22ec5f7$var$attachRef(ref, instance, element._owner);
};
$862c8b89b22ec5f7$var$ReactRef.shouldUpdateRefs = function(prevElement, nextElement) {
    // If either the owner or a `ref` has changed, make sure the newest owner
    // has stored a reference to `this`, and the previous owner (if different)
    // has forgotten the reference to `this`. We use the element instead
    // of the public this.props because the post processing cannot determine
    // a ref. The ref conceptually lives on the element.
    // TODO: Should this even be possible? The owner cannot change because
    // it's forbidden by shouldUpdateReactComponent. The ref can change
    // if you swap the keys of but not the refs. Reconsider where this check
    // is made. It probably belongs where the key checking and
    // instantiateReactComponent is done.
    var prevRef = null;
    var prevOwner = null;
    if (prevElement !== null && typeof prevElement === "object") {
        prevRef = prevElement.ref;
        prevOwner = prevElement._owner;
    }
    var nextRef = null;
    var nextOwner = null;
    if (nextElement !== null && typeof nextElement === "object") {
        nextRef = nextElement.ref;
        nextOwner = nextElement._owner;
    }
    return prevRef !== nextRef || // If owner changes but we have an unchanged function ref, don't update refs
    typeof nextRef === "string" && nextOwner !== prevOwner;
};
$862c8b89b22ec5f7$var$ReactRef.detachRefs = function(instance, element) {
    if (element === null || typeof element !== "object") return;
    var ref = element.ref;
    if (ref != null) $862c8b89b22ec5f7$var$detachRef(ref, instance, element._owner);
};
module.exports = $862c8b89b22ec5f7$var$ReactRef;

});
parcelRegister("fNjKe", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
parcelRequire("4Mb5c");
/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */ function $b7fabf8479089370$var$isValidOwner(object) {
    return !!(object && typeof object.attachRef === "function" && typeof object.detachRef === "function");
}
/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */ var $b7fabf8479089370$var$ReactOwner = {
    /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */ addComponentAsRefTo: function(component, ref, owner) {
        !$b7fabf8479089370$var$isValidOwner(owner) && $jOpPq("119");
        owner.attachRef(ref, component);
    },
    /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */ removeComponentAsRefFrom: function(component, ref, owner) {
        !$b7fabf8479089370$var$isValidOwner(owner) && $jOpPq("120");
        var ownerPublicInstance = owner.getPublicInstance();
        // Check that `component`'s owner is still alive and that `component` is still the current ref
        // because we do not want to detach the ref if another component stole it.
        if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) owner.detachRef(ref);
    }
};
module.exports = $b7fabf8479089370$var$ReactOwner;

});


parcelRegister("d1IRY", function(module, exports) {
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
// Trust the developer to only use ReactInstrumentation with a __DEV__ check
var $97be2c845780e2b0$var$debugTool = null;
var $97be2c845780e2b0$var$ReactDebugTool;
module.exports = {
    debugTool: $97be2c845780e2b0$var$debugTool
};

});


parcelRegister("2PXJf", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
parcelRequire("4Mb5c");
var $210ead178316676c$var$OBSERVED_ERROR = {};
/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */ var $210ead178316676c$var$TransactionImpl = {
    /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */ reinitializeTransaction: function() {
        this.transactionWrappers = this.getTransactionWrappers();
        if (this.wrapperInitData) this.wrapperInitData.length = 0;
        else this.wrapperInitData = [];
        this._isInTransaction = false;
    },
    _isInTransaction: false,
    /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */ getTransactionWrappers: null,
    isInTransaction: function() {
        return !!this._isInTransaction;
    },
    /* eslint-disable space-before-function-paren */ /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */ perform: function(method, scope, a, b, c, d, e, f) {
        /* eslint-enable space-before-function-paren */ !!this.isInTransaction() && $jOpPq("27");
        var errorThrown;
        var ret;
        try {
            this._isInTransaction = true;
            // Catching errors makes debugging more difficult, so we start with
            // errorThrown set to true before setting it to false after calling
            // close -- if it's still set to true in the finally block, it means
            // one of these calls threw.
            errorThrown = true;
            this.initializeAll(0);
            ret = method.call(scope, a, b, c, d, e, f);
            errorThrown = false;
        } finally{
            try {
                if (errorThrown) // If `method` throws, prefer to show that stack trace over any thrown
                // by invoking `closeAll`.
                try {
                    this.closeAll(0);
                } catch (err) {}
                else // Since `method` didn't throw, we don't want to silence the exception
                // here.
                this.closeAll(0);
            } finally{
                this._isInTransaction = false;
            }
        }
        return ret;
    },
    initializeAll: function(startIndex) {
        var transactionWrappers = this.transactionWrappers;
        for(var i = startIndex; i < transactionWrappers.length; i++){
            var wrapper = transactionWrappers[i];
            try {
                // Catching errors makes debugging more difficult, so we start with the
                // OBSERVED_ERROR state before overwriting it with the real return value
                // of initialize -- if it's still set to OBSERVED_ERROR in the finally
                // block, it means wrapper.initialize threw.
                this.wrapperInitData[i] = $210ead178316676c$var$OBSERVED_ERROR;
                this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
            } finally{
                if (this.wrapperInitData[i] === $210ead178316676c$var$OBSERVED_ERROR) // The initializer for wrapper i threw an error; initialize the
                // remaining wrappers but silence any exceptions from them to ensure
                // that the first error is the one to bubble up.
                try {
                    this.initializeAll(i + 1);
                } catch (err) {}
            }
        }
    },
    /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */ closeAll: function(startIndex) {
        !this.isInTransaction() && $jOpPq("28");
        var transactionWrappers = this.transactionWrappers;
        for(var i = startIndex; i < transactionWrappers.length; i++){
            var wrapper = transactionWrappers[i];
            var initData = this.wrapperInitData[i];
            var errorThrown;
            try {
                // Catching errors makes debugging more difficult, so we start with
                // errorThrown set to true before setting it to false after calling
                // close -- if it's still set to true in the finally block, it means
                // wrapper.close threw.
                errorThrown = true;
                if (initData !== $210ead178316676c$var$OBSERVED_ERROR && wrapper.close) wrapper.close.call(this, initData);
                errorThrown = false;
            } finally{
                if (errorThrown) // The closer for wrapper i threw an error; close the remaining
                // wrappers but silence any exceptions from them to ensure that the
                // first error is the one to bubble up.
                try {
                    this.closeAll(i + 1);
                } catch (e) {}
            }
        }
        this.wrapperInitData.length = 0;
    }
};
module.exports = $210ead178316676c$var$TransactionImpl;

});


parcelRegister("clPIH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $5fGpM = parcelRequire("5fGpM");
function $8fdf90ba4cb50aee$var$isCheckable(elem) {
    var type = elem.type;
    var nodeName = elem.nodeName;
    return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
}
function $8fdf90ba4cb50aee$var$getTracker(inst) {
    return inst._wrapperState.valueTracker;
}
function $8fdf90ba4cb50aee$var$attachTracker(inst, tracker) {
    inst._wrapperState.valueTracker = tracker;
}
function $8fdf90ba4cb50aee$var$detachTracker(inst) {
    inst._wrapperState.valueTracker = null;
}
function $8fdf90ba4cb50aee$var$getValueFromNode(node) {
    var value;
    if (node) value = $8fdf90ba4cb50aee$var$isCheckable(node) ? "" + node.checked : node.value;
    return value;
}
var $8fdf90ba4cb50aee$var$inputValueTracking = {
    // exposed for testing
    _getTrackerFromNode: function(node) {
        return $8fdf90ba4cb50aee$var$getTracker($5fGpM.getInstanceFromNode(node));
    },
    track: function(inst) {
        if ($8fdf90ba4cb50aee$var$getTracker(inst)) return;
        var node = $5fGpM.getNodeFromInstance(inst);
        var valueField = $8fdf90ba4cb50aee$var$isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        var currentValue = "" + node[valueField];
        // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable,
            configurable: true,
            get: function() {
                return descriptor.get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                descriptor.set.call(this, value);
            }
        });
        $8fdf90ba4cb50aee$var$attachTracker(inst, {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                $8fdf90ba4cb50aee$var$detachTracker(inst);
                delete node[valueField];
            }
        });
    },
    updateValueIfChanged: function(inst) {
        if (!inst) return false;
        var tracker = $8fdf90ba4cb50aee$var$getTracker(inst);
        if (!tracker) {
            $8fdf90ba4cb50aee$var$inputValueTracking.track(inst);
            return true;
        }
        var lastValue = tracker.getValue();
        var nextValue = $8fdf90ba4cb50aee$var$getValueFromNode($5fGpM.getNodeFromInstance(inst));
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    },
    stopTracking: function(inst) {
        var tracker = $8fdf90ba4cb50aee$var$getTracker(inst);
        if (tracker) tracker.stopTracking();
    }
};
module.exports = $8fdf90ba4cb50aee$var$inputValueTracking;

});

parcelRegister("aNWE1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function $7ddbf8956ff0a9c9$var$getEventTarget(nativeEvent) {
    var target = nativeEvent.target || nativeEvent.srcElement || window;
    // Normalize SVG <use> element events #4963
    if (target.correspondingUseElement) target = target.correspondingUseElement;
    // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
    // @see http://www.quirksmode.org/js/events_properties.html
    return target.nodeType === 3 ? target.parentNode : target;
}
module.exports = $7ddbf8956ff0a9c9$var$getEventTarget;

});

parcelRegister("7yqoI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $kx286 = parcelRequire("kx286");
var $58002f6280b5b59d$var$useHasFeature;
if ($kx286.canUseDOM) $58002f6280b5b59d$var$useHasFeature = document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
// @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
document.implementation.hasFeature("", "") !== true;
/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function $58002f6280b5b59d$var$isEventSupported(eventNameSuffix, capture) {
    if (!$kx286.canUseDOM || capture && !("addEventListener" in document)) return false;
    var eventName = "on" + eventNameSuffix;
    var isSupported = eventName in document;
    if (!isSupported) {
        var element = document.createElement("div");
        element.setAttribute(eventName, "return;");
        isSupported = typeof element[eventName] === "function";
    }
    if (!isSupported && $58002f6280b5b59d$var$useHasFeature && eventNameSuffix === "wheel") // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature("Events.wheel", "3.0");
    return isSupported;
}
module.exports = $58002f6280b5b59d$var$isEventSupported;

});

parcelRegister("2qW9o", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var $1c5b1df9af378370$var$supportedInputTypes = {
    color: true,
    date: true,
    datetime: true,
    "datetime-local": true,
    email: true,
    month: true,
    number: true,
    password: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true
};
function $1c5b1df9af378370$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    if (nodeName === "input") return !!$1c5b1df9af378370$var$supportedInputTypes[elem.type];
    if (nodeName === "textarea") return true;
    return false;
}
module.exports = $1c5b1df9af378370$var$isTextInputElement;

});


parcelRegister("krY8l", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */ var $ee34f987ef411f88$var$DefaultEventPluginOrder = [
    "ResponderEventPlugin",
    "SimpleEventPlugin",
    "TapEventPlugin",
    "EnterLeaveEventPlugin",
    "ChangeEventPlugin",
    "SelectEventPlugin",
    "BeforeInputEventPlugin"
];
module.exports = $ee34f987ef411f88$var$DefaultEventPluginOrder;

});

parcelRegister("lAANg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $1lzph = parcelRequire("1lzph");

var $5fGpM = parcelRequire("5fGpM");

var $fCyn6 = parcelRequire("fCyn6");
var $fb7980309bca4323$var$eventTypes = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "topMouseOut",
            "topMouseOver"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "topMouseOut",
            "topMouseOver"
        ]
    }
};
var $fb7980309bca4323$var$EnterLeaveEventPlugin = {
    eventTypes: $fb7980309bca4323$var$eventTypes,
    /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */ extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        if (topLevelType === "topMouseOver" && (nativeEvent.relatedTarget || nativeEvent.fromElement)) return null;
        if (topLevelType !== "topMouseOut" && topLevelType !== "topMouseOver") // Must not be a mouse in or mouse out - ignoring.
        return null;
        var win;
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (topLevelType === "topMouseOut") {
            from = targetInst;
            var related = nativeEvent.relatedTarget || nativeEvent.toElement;
            to = related ? $5fGpM.getClosestInstanceFromNode(related) : null;
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return null;
        var fromNode = from == null ? win : $5fGpM.getNodeFromInstance(from);
        var toNode = to == null ? win : $5fGpM.getNodeFromInstance(to);
        var leave = $fCyn6.getPooled($fb7980309bca4323$var$eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
        leave.type = "mouseleave";
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = $fCyn6.getPooled($fb7980309bca4323$var$eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
        enter.type = "mouseenter";
        enter.target = toNode;
        enter.relatedTarget = fromNode;
        $1lzph.accumulateEnterLeaveDispatches(leave, enter, from, to);
        return [
            leave,
            enter
        ];
    }
};
module.exports = $fb7980309bca4323$var$EnterLeaveEventPlugin;

});
parcelRegister("fCyn6", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $fPGeq = parcelRequire("fPGeq");

var $cPu0Q = parcelRequire("cPu0Q");

var $a01SI = parcelRequire("a01SI");
/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var $b5f5112022cc614d$var$MouseEventInterface = {
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: $a01SI,
    button: function(event) {
        // Webkit, Firefox, IE9+
        // which:  1 2 3
        // button: 0 1 2 (standard)
        var button = event.button;
        if ("which" in event) return button;
        // IE<9
        // which:  undefined
        // button: 0 0 0
        // button: 1 4 2 (onmouseup)
        return button === 2 ? 2 : button === 4 ? 1 : 0;
    },
    buttons: null,
    relatedTarget: function(event) {
        return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
    },
    // "Proprietary" Interface.
    pageX: function(event) {
        return "pageX" in event ? event.pageX : event.clientX + $cPu0Q.currentScrollLeft;
    },
    pageY: function(event) {
        return "pageY" in event ? event.pageY : event.clientY + $cPu0Q.currentScrollTop;
    }
};
/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */ function $b5f5112022cc614d$var$SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
    return $fPGeq.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}
$fPGeq.augmentClass($b5f5112022cc614d$var$SyntheticMouseEvent, $b5f5112022cc614d$var$MouseEventInterface);
module.exports = $b5f5112022cc614d$var$SyntheticMouseEvent;

});
parcelRegister("fPGeq", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $6CUXY = parcelRequire("6CUXY");

var $aNWE1 = parcelRequire("aNWE1");
/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var $b86c60c5c967fdff$var$UIEventInterface = {
    view: function(event) {
        if (event.view) return event.view;
        var target = $aNWE1(event);
        if (target.window === target) // target is a window object
        return target;
        var doc = target.ownerDocument;
        // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
        if (doc) return doc.defaultView || doc.parentWindow;
        else return window;
    },
    detail: function(event) {
        return event.detail || 0;
    }
};
/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */ function $b86c60c5c967fdff$var$SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
    return $6CUXY.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}
$6CUXY.augmentClass($b86c60c5c967fdff$var$SyntheticUIEvent, $b86c60c5c967fdff$var$UIEventInterface);
module.exports = $b86c60c5c967fdff$var$SyntheticUIEvent;

});

parcelRegister("cPu0Q", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
var $9571875b23d6f702$var$ViewportMetrics = {
    currentScrollLeft: 0,
    currentScrollTop: 0,
    refreshScrollValues: function(scrollPosition) {
        $9571875b23d6f702$var$ViewportMetrics.currentScrollLeft = scrollPosition.x;
        $9571875b23d6f702$var$ViewportMetrics.currentScrollTop = scrollPosition.y;
    }
};
module.exports = $9571875b23d6f702$var$ViewportMetrics;

});

parcelRegister("a01SI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var $747b5d1b67616f7f$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function $747b5d1b67616f7f$var$modifierStateGetter(keyArg) {
    var syntheticEvent = this;
    var nativeEvent = syntheticEvent.nativeEvent;
    if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
    var keyProp = $747b5d1b67616f7f$var$modifierKeyToProp[keyArg];
    return keyProp ? !!nativeEvent[keyProp] : false;
}
function $747b5d1b67616f7f$var$getEventModifierState(nativeEvent) {
    return $747b5d1b67616f7f$var$modifierStateGetter;
}
module.exports = $747b5d1b67616f7f$var$getEventModifierState;

});



parcelRegister("9jnfX", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $Uj2z8 = parcelRequire("Uj2z8");
var $6c77eda156a01a95$var$MUST_USE_PROPERTY = $Uj2z8.injection.MUST_USE_PROPERTY;
var $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE = $Uj2z8.injection.HAS_BOOLEAN_VALUE;
var $6c77eda156a01a95$var$HAS_NUMERIC_VALUE = $Uj2z8.injection.HAS_NUMERIC_VALUE;
var $6c77eda156a01a95$var$HAS_POSITIVE_NUMERIC_VALUE = $Uj2z8.injection.HAS_POSITIVE_NUMERIC_VALUE;
var $6c77eda156a01a95$var$HAS_OVERLOADED_BOOLEAN_VALUE = $Uj2z8.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
var $6c77eda156a01a95$var$HTMLDOMPropertyConfig = {
    isCustomAttribute: RegExp.prototype.test.bind(new RegExp("^(data|aria)-[" + $Uj2z8.ATTRIBUTE_NAME_CHAR + "]*$")),
    Properties: {
        /**
     * Standard Properties
     */ accept: 0,
        acceptCharset: 0,
        accessKey: 0,
        action: 0,
        allowFullScreen: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        allowTransparency: 0,
        alt: 0,
        // specifies target context for links with `preload` type
        as: 0,
        async: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        autoComplete: 0,
        // autoFocus is polyfilled/normalized by AutoFocusUtils
        // autoFocus: HAS_BOOLEAN_VALUE,
        autoPlay: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        capture: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        cellPadding: 0,
        cellSpacing: 0,
        charSet: 0,
        challenge: 0,
        checked: $6c77eda156a01a95$var$MUST_USE_PROPERTY | $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        cite: 0,
        classID: 0,
        className: 0,
        cols: $6c77eda156a01a95$var$HAS_POSITIVE_NUMERIC_VALUE,
        colSpan: 0,
        content: 0,
        contentEditable: 0,
        contextMenu: 0,
        controls: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        controlsList: 0,
        coords: 0,
        crossOrigin: 0,
        data: 0,
        dateTime: 0,
        "default": $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        defer: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        dir: 0,
        disabled: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        download: $6c77eda156a01a95$var$HAS_OVERLOADED_BOOLEAN_VALUE,
        draggable: 0,
        encType: 0,
        form: 0,
        formAction: 0,
        formEncType: 0,
        formMethod: 0,
        formNoValidate: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        formTarget: 0,
        frameBorder: 0,
        headers: 0,
        height: 0,
        hidden: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        high: 0,
        href: 0,
        hrefLang: 0,
        htmlFor: 0,
        httpEquiv: 0,
        icon: 0,
        id: 0,
        inputMode: 0,
        integrity: 0,
        is: 0,
        keyParams: 0,
        keyType: 0,
        kind: 0,
        label: 0,
        lang: 0,
        list: 0,
        loop: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        low: 0,
        manifest: 0,
        marginHeight: 0,
        marginWidth: 0,
        max: 0,
        maxLength: 0,
        media: 0,
        mediaGroup: 0,
        method: 0,
        min: 0,
        minLength: 0,
        // Caution; `option.selected` is not updated if `select.multiple` is
        // disabled with `removeAttribute`.
        multiple: $6c77eda156a01a95$var$MUST_USE_PROPERTY | $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        muted: $6c77eda156a01a95$var$MUST_USE_PROPERTY | $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        name: 0,
        nonce: 0,
        noValidate: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        open: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        optimum: 0,
        pattern: 0,
        placeholder: 0,
        playsInline: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        poster: 0,
        preload: 0,
        profile: 0,
        radioGroup: 0,
        readOnly: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        referrerPolicy: 0,
        rel: 0,
        required: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        reversed: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        role: 0,
        rows: $6c77eda156a01a95$var$HAS_POSITIVE_NUMERIC_VALUE,
        rowSpan: $6c77eda156a01a95$var$HAS_NUMERIC_VALUE,
        sandbox: 0,
        scope: 0,
        scoped: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        scrolling: 0,
        seamless: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        selected: $6c77eda156a01a95$var$MUST_USE_PROPERTY | $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        shape: 0,
        size: $6c77eda156a01a95$var$HAS_POSITIVE_NUMERIC_VALUE,
        sizes: 0,
        span: $6c77eda156a01a95$var$HAS_POSITIVE_NUMERIC_VALUE,
        spellCheck: 0,
        src: 0,
        srcDoc: 0,
        srcLang: 0,
        srcSet: 0,
        start: $6c77eda156a01a95$var$HAS_NUMERIC_VALUE,
        step: 0,
        style: 0,
        summary: 0,
        tabIndex: 0,
        target: 0,
        title: 0,
        // Setting .type throws on non-<input> tags
        type: 0,
        useMap: 0,
        value: 0,
        width: 0,
        wmode: 0,
        wrap: 0,
        /**
     * RDFa Properties
     */ about: 0,
        datatype: 0,
        inlist: 0,
        prefix: 0,
        // property is also supported for OpenGraph in meta tags.
        property: 0,
        resource: 0,
        "typeof": 0,
        vocab: 0,
        /**
     * Non-standard Properties
     */ // autoCapitalize and autoCorrect are supported in Mobile Safari for
        // keyboard hints.
        autoCapitalize: 0,
        autoCorrect: 0,
        // autoSave allows WebKit/Blink to persist values of input fields on page reloads
        autoSave: 0,
        // color is for Safari mask-icon link
        color: 0,
        // itemProp, itemScope, itemType are for
        // Microdata support. See http://schema.org/docs/gs.html
        itemProp: 0,
        itemScope: $6c77eda156a01a95$var$HAS_BOOLEAN_VALUE,
        itemType: 0,
        // itemID and itemRef are for Microdata support as well but
        // only specified in the WHATWG spec document. See
        // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
        itemID: 0,
        itemRef: 0,
        // results show looking glass icon and recent searches on input
        // search fields in WebKit/Blink
        results: 0,
        // IE-only attribute that specifies security restrictions on an iframe
        // as an alternative to the sandbox attribute on IE<10
        security: 0,
        // IE-only attribute that controls focus behavior
        unselectable: 0
    },
    DOMAttributeNames: {
        acceptCharset: "accept-charset",
        className: "class",
        htmlFor: "for",
        httpEquiv: "http-equiv"
    },
    DOMPropertyNames: {},
    DOMMutationMethods: {
        value: function(node, value) {
            if (value == null) return node.removeAttribute("value");
            // Number inputs get special treatment due to some edge cases in
            // Chrome. Let everything else assign the value attribute as normal.
            // https://github.com/facebook/react/issues/7253#issuecomment-236074326
            if (node.type !== "number" || node.hasAttribute("value") === false) node.setAttribute("value", "" + value);
            else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) // Don't assign an attribute if validation reports bad
            // input. Chrome will clear the value. Additionally, don't
            // operate on inputs that have focus, otherwise Chrome might
            // strip off trailing decimal places and cause the user's
            // cursor position to jump to the beginning of the input.
            //
            // In ReactDOMInput, we have an onBlur event that will trigger
            // this function again when focus is lost.
            node.setAttribute("value", "" + value);
        }
    }
};
module.exports = $6c77eda156a01a95$var$HTMLDOMPropertyConfig;

});

parcelRegister("j1fD1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $2BUuH = parcelRequire("2BUuH");

var $hIl0J = parcelRequire("hIl0J");
/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */ var $dd8a3bc50eb3a7ee$var$ReactComponentBrowserEnvironment = {
    processChildrenUpdates: $hIl0J.dangerouslyProcessChildrenUpdates,
    replaceNodeWithMarkup: $2BUuH.dangerouslyReplaceNodeWithMarkup
};
module.exports = $dd8a3bc50eb3a7ee$var$ReactComponentBrowserEnvironment;

});
parcelRegister("2BUuH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $QV5G5 = parcelRequire("QV5G5");

var $feTE0 = parcelRequire("feTE0");
parcelRequire("5fGpM");
parcelRequire("d1IRY");

var $b1yf2 = parcelRequire("b1yf2");

var $1dgCK = parcelRequire("1dgCK");

var $9RhMG = parcelRequire("9RhMG");
function $1e6adc02e4a72bf4$var$getNodeAfter(parentNode, node) {
    // Special case for text components, which return [open, close] comments
    // from getHostNode.
    if (Array.isArray(node)) node = node[1];
    return node ? node.nextSibling : parentNode.firstChild;
}
/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */ var $1e6adc02e4a72bf4$var$insertChildAt = $b1yf2(function(parentNode, childNode, referenceNode) {
    // We rely exclusively on `insertBefore(node, null)` instead of also using
    // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
    // we are careful to use `null`.)
    parentNode.insertBefore(childNode, referenceNode);
});
function $1e6adc02e4a72bf4$var$insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
    $QV5G5.insertTreeBefore(parentNode, childTree, referenceNode);
}
function $1e6adc02e4a72bf4$var$moveChild(parentNode, childNode, referenceNode) {
    if (Array.isArray(childNode)) $1e6adc02e4a72bf4$var$moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
    else $1e6adc02e4a72bf4$var$insertChildAt(parentNode, childNode, referenceNode);
}
function $1e6adc02e4a72bf4$var$removeChild(parentNode, childNode) {
    if (Array.isArray(childNode)) {
        var closingComment = childNode[1];
        childNode = childNode[0];
        $1e6adc02e4a72bf4$var$removeDelimitedText(parentNode, childNode, closingComment);
        parentNode.removeChild(closingComment);
    }
    parentNode.removeChild(childNode);
}
function $1e6adc02e4a72bf4$var$moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
    var node = openingComment;
    while(true){
        var nextNode = node.nextSibling;
        $1e6adc02e4a72bf4$var$insertChildAt(parentNode, node, referenceNode);
        if (node === closingComment) break;
        node = nextNode;
    }
}
function $1e6adc02e4a72bf4$var$removeDelimitedText(parentNode, startNode, closingComment) {
    while(true){
        var node = startNode.nextSibling;
        if (node === closingComment) break;
        else parentNode.removeChild(node);
    }
}
function $1e6adc02e4a72bf4$var$replaceDelimitedText(openingComment, closingComment, stringText) {
    var parentNode = openingComment.parentNode;
    var nodeAfterComment = openingComment.nextSibling;
    if (nodeAfterComment === closingComment) // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    {
        if (stringText) $1e6adc02e4a72bf4$var$insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    } else if (stringText) {
        // Set the text content of the first node after the opening comment, and
        // remove all following nodes up until the closing comment.
        $9RhMG(nodeAfterComment, stringText);
        $1e6adc02e4a72bf4$var$removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else $1e6adc02e4a72bf4$var$removeDelimitedText(parentNode, openingComment, closingComment);
}
var $1e6adc02e4a72bf4$var$dangerouslyReplaceNodeWithMarkup = $feTE0.dangerouslyReplaceNodeWithMarkup;
/**
 * Operations for updating with DOM children.
 */ var $1e6adc02e4a72bf4$var$DOMChildrenOperations = {
    dangerouslyReplaceNodeWithMarkup: $1e6adc02e4a72bf4$var$dangerouslyReplaceNodeWithMarkup,
    replaceDelimitedText: $1e6adc02e4a72bf4$var$replaceDelimitedText,
    /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */ processUpdates: function(parentNode, updates) {
        var parentNodeDebugID;
        for(var k = 0; k < updates.length; k++){
            var update = updates[k];
            switch(update.type){
                case "INSERT_MARKUP":
                    $1e6adc02e4a72bf4$var$insertLazyTreeChildAt(parentNode, update.content, $1e6adc02e4a72bf4$var$getNodeAfter(parentNode, update.afterNode));
                    break;
                case "MOVE_EXISTING":
                    $1e6adc02e4a72bf4$var$moveChild(parentNode, update.fromNode, $1e6adc02e4a72bf4$var$getNodeAfter(parentNode, update.afterNode));
                    break;
                case "SET_MARKUP":
                    $1dgCK(parentNode, update.content);
                    break;
                case "TEXT_CONTENT":
                    $9RhMG(parentNode, update.content);
                    break;
                case "REMOVE_NODE":
                    $1e6adc02e4a72bf4$var$removeChild(parentNode, update.fromNode);
                    break;
            }
        }
    }
};
module.exports = $1e6adc02e4a72bf4$var$DOMChildrenOperations;

});
parcelRegister("QV5G5", function(module, exports) {
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $e4vh0 = parcelRequire("e4vh0");

var $1dgCK = parcelRequire("1dgCK");

var $b1yf2 = parcelRequire("b1yf2");

var $9RhMG = parcelRequire("9RhMG");
var $09f124717a1bebe4$var$ELEMENT_NODE_TYPE = 1;
var $09f124717a1bebe4$var$DOCUMENT_FRAGMENT_NODE_TYPE = 11;
/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */ var $09f124717a1bebe4$var$enableLazy = typeof document !== "undefined" && typeof document.documentMode === "number" || typeof navigator !== "undefined" && typeof navigator.userAgent === "string" && /\bEdge\/\d/.test(navigator.userAgent);
function $09f124717a1bebe4$var$insertTreeChildren(tree) {
    if (!$09f124717a1bebe4$var$enableLazy) return;
    var node = tree.node;
    var children = tree.children;
    if (children.length) for(var i = 0; i < children.length; i++)$09f124717a1bebe4$var$insertTreeBefore(node, children[i], null);
    else if (tree.html != null) $1dgCK(node, tree.html);
    else if (tree.text != null) $9RhMG(node, tree.text);
}
var $09f124717a1bebe4$var$insertTreeBefore = $b1yf2(function(parentNode, tree, referenceNode) {
    // DocumentFragments aren't actually part of the DOM after insertion so
    // appending children won't update the DOM. We need to ensure the fragment
    // is properly populated first, breaking out of our lazy approach for just
    // this level. Also, some <object> plugins (like Flash Player) will read
    // <param> nodes immediately upon insertion into the DOM, so <object>
    // must also be populated prior to insertion into the DOM.
    if (tree.node.nodeType === $09f124717a1bebe4$var$DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === $09f124717a1bebe4$var$ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === "object" && (tree.node.namespaceURI == null || tree.node.namespaceURI === $e4vh0.html)) {
        $09f124717a1bebe4$var$insertTreeChildren(tree);
        parentNode.insertBefore(tree.node, referenceNode);
    } else {
        parentNode.insertBefore(tree.node, referenceNode);
        $09f124717a1bebe4$var$insertTreeChildren(tree);
    }
});
function $09f124717a1bebe4$var$replaceChildWithTree(oldNode, newTree) {
    oldNode.parentNode.replaceChild(newTree.node, oldNode);
    $09f124717a1bebe4$var$insertTreeChildren(newTree);
}
function $09f124717a1bebe4$var$queueChild(parentTree, childTree) {
    if ($09f124717a1bebe4$var$enableLazy) parentTree.children.push(childTree);
    else parentTree.node.appendChild(childTree.node);
}
function $09f124717a1bebe4$var$queueHTML(tree, html) {
    if ($09f124717a1bebe4$var$enableLazy) tree.html = html;
    else $1dgCK(tree.node, html);
}
function $09f124717a1bebe4$var$queueText(tree, text) {
    if ($09f124717a1bebe4$var$enableLazy) tree.text = text;
    else $9RhMG(tree.node, text);
}
function $09f124717a1bebe4$var$toString() {
    return this.node.nodeName;
}
function $09f124717a1bebe4$var$DOMLazyTree(node) {
    return {
        node: node,
        children: [],
        html: null,
        text: null,
        toString: $09f124717a1bebe4$var$toString
    };
}
$09f124717a1bebe4$var$DOMLazyTree.insertTreeBefore = $09f124717a1bebe4$var$insertTreeBefore;
$09f124717a1bebe4$var$DOMLazyTree.replaceChildWithTree = $09f124717a1bebe4$var$replaceChildWithTree;
$09f124717a1bebe4$var$DOMLazyTree.queueChild = $09f124717a1bebe4$var$queueChild;
$09f124717a1bebe4$var$DOMLazyTree.queueHTML = $09f124717a1bebe4$var$queueHTML;
$09f124717a1bebe4$var$DOMLazyTree.queueText = $09f124717a1bebe4$var$queueText;
module.exports = $09f124717a1bebe4$var$DOMLazyTree;

});
parcelRegister("e4vh0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
var $a3e9b29ebd109ded$var$DOMNamespaces = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
module.exports = $a3e9b29ebd109ded$var$DOMNamespaces;

});

parcelRegister("1dgCK", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $kx286 = parcelRequire("kx286");

var $e4vh0 = parcelRequire("e4vh0");
var $0e23e68a2333d74b$var$WHITESPACE_TEST = /^[ \r\n\t\f]/;
var $0e23e68a2333d74b$var$NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var $b1yf2 = parcelRequire("b1yf2");
// SVG temp container for IE lacking innerHTML
var $0e23e68a2333d74b$var$reusableSVGContainer;
/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var $0e23e68a2333d74b$var$setInnerHTML = $b1yf2(function(node, html) {
    // IE does not have innerHTML for SVG nodes, so instead we inject the
    // new markup in a temp node and then move the child nodes across into
    // the target node
    if (node.namespaceURI === $e4vh0.svg && !("innerHTML" in node)) {
        $0e23e68a2333d74b$var$reusableSVGContainer = $0e23e68a2333d74b$var$reusableSVGContainer || document.createElement("div");
        $0e23e68a2333d74b$var$reusableSVGContainer.innerHTML = "<svg>" + html + "</svg>";
        var svgNode = $0e23e68a2333d74b$var$reusableSVGContainer.firstChild;
        while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
    } else node.innerHTML = html;
});
if ($kx286.canUseDOM) {
    // IE8: When updating a just created node with innerHTML only leading
    // whitespace is removed. When updating an existing node with innerHTML
    // whitespace in root TextNodes is also collapsed.
    // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
    // Feature detection; only IE8 is known to behave improperly like this.
    var $0e23e68a2333d74b$var$testElement = document.createElement("div");
    $0e23e68a2333d74b$var$testElement.innerHTML = " ";
    if ($0e23e68a2333d74b$var$testElement.innerHTML === "") $0e23e68a2333d74b$var$setInnerHTML = function(node, html) {
        // Magic theory: IE8 supposedly differentiates between added and updated
        // nodes when processing innerHTML, innerHTML on updated nodes suffers
        // from worse whitespace behavior. Re-adding a node like this triggers
        // the initial and more favorable whitespace behavior.
        // TODO: What to do on a detached node?
        if (node.parentNode) node.parentNode.replaceChild(node, node);
        // We also implement a workaround for non-visible tags disappearing into
        // thin air on IE8, this only happens if there is no visible text
        // in-front of the non-visible tags. Piggyback on the whitespace fix
        // and simply check if any non-visible tags appear in the source.
        if ($0e23e68a2333d74b$var$WHITESPACE_TEST.test(html) || html[0] === "<" && $0e23e68a2333d74b$var$NONVISIBLE_TEST.test(html)) {
            // Recover leading whitespace by temporarily prepending any character.
            // \uFEFF has the potential advantage of being zero-width/invisible.
            // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
            // in hopes that this is preserved even if "\uFEFF" is transformed to
            // the actual Unicode character (by Babel, for example).
            // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
            node.innerHTML = String.fromCharCode(0xfeff) + html;
            // deleteData leaves an empty `TextNode` which offsets the index of all
            // children. Definitely want to avoid this.
            var textNode = node.firstChild;
            if (textNode.data.length === 1) node.removeChild(textNode);
            else textNode.deleteData(0, 1);
        } else node.innerHTML = html;
    };
    $0e23e68a2333d74b$var$testElement = null;
}
module.exports = $0e23e68a2333d74b$var$setInnerHTML;

});
parcelRegister("b1yf2", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /* globals MSApp */ "use strict";
/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var $806a596240ee413e$var$createMicrosoftUnsafeLocalFunction = function(func) {
    if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
        MSApp.execUnsafeLocalFunction(function() {
            return func(arg0, arg1, arg2, arg3);
        });
    };
    else return func;
};
module.exports = $806a596240ee413e$var$createMicrosoftUnsafeLocalFunction;

});


parcelRegister("9RhMG", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $kx286 = parcelRequire("kx286");

var $8i9tX = parcelRequire("8i9tX");

var $1dgCK = parcelRequire("1dgCK");
/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var $72d6dbdb47d4038f$var$setTextContent = function(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
};
if ($kx286.canUseDOM) {
    if (!("textContent" in document.documentElement)) $72d6dbdb47d4038f$var$setTextContent = function(node, text) {
        if (node.nodeType === 3) {
            node.nodeValue = text;
            return;
        }
        $1dgCK(node, $8i9tX(text));
    };
}
module.exports = $72d6dbdb47d4038f$var$setTextContent;

});
parcelRegister("8i9tX", function(module, exports) {
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */ "use strict";
// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */ var $60975c229faa1393$var$matchHtmlRegExp = /["'&<>]/;
/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */ function $60975c229faa1393$var$escapeHtml(string) {
    var str = "" + string;
    var match = $60975c229faa1393$var$matchHtmlRegExp.exec(str);
    if (!match) return str;
    var escape;
    var html = "";
    var index = 0;
    var lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                // "
                escape = "&quot;";
                break;
            case 38:
                // &
                escape = "&amp;";
                break;
            case 39:
                // '
                escape = "&#x27;"; // modified from escape-html; used to be '&#39'
                break;
            case 60:
                // <
                escape = "&lt;";
                break;
            case 62:
                // >
                escape = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.substring(lastIndex, index);
        lastIndex = index + 1;
        html += escape;
    }
    return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html
/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */ function $60975c229faa1393$var$escapeTextContentForBrowser(text) {
    if (typeof text === "boolean" || typeof text === "number") // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return "" + text;
    return $60975c229faa1393$var$escapeHtml(text);
}
module.exports = $60975c229faa1393$var$escapeTextContentForBrowser;

});



parcelRegister("feTE0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $QV5G5 = parcelRequire("QV5G5");

var $kx286 = parcelRequire("kx286");

var $37Gic = parcelRequire("37Gic");

var $46CSh = parcelRequire("46CSh");
parcelRequire("4Mb5c");
var $b1835396582eb8c6$var$Danger = {
    /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */ dangerouslyReplaceNodeWithMarkup: function(oldChild, markup) {
        !$kx286.canUseDOM && $jOpPq("56");
        !markup && $jOpPq("57");
        !(oldChild.nodeName !== "HTML") && $jOpPq("58");
        if (typeof markup === "string") {
            var newChild = $37Gic(markup, $46CSh)[0];
            oldChild.parentNode.replaceChild(newChild, oldChild);
        } else $QV5G5.replaceChildWithTree(oldChild, markup);
    }
};
module.exports = $b1835396582eb8c6$var$Danger;

});
parcelRegister("37Gic", function(module, exports) {
"use strict";

var $kx286 = parcelRequire("kx286");

var $3AZSv = parcelRequire("3AZSv");

var $kT7Ku = parcelRequire("kT7Ku");

var $4Mb5c = parcelRequire("4Mb5c");
/**
 * Dummy container used to render all markup.
 */ var $2462d4f2b80c93cf$var$dummyNode = $kx286.canUseDOM ? document.createElement("div") : null;
/**
 * Pattern used by `getNodeName`.
 */ var $2462d4f2b80c93cf$var$nodeNamePattern = /^\s*<(\w+)/;
/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */ function $2462d4f2b80c93cf$var$getNodeName(markup) {
    var nodeNameMatch = markup.match($2462d4f2b80c93cf$var$nodeNamePattern);
    return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}
/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */ function $2462d4f2b80c93cf$var$createNodesFromMarkup(markup, handleScript) {
    var node = $2462d4f2b80c93cf$var$dummyNode;
    !!!$2462d4f2b80c93cf$var$dummyNode && $4Mb5c(false);
    var nodeName = $2462d4f2b80c93cf$var$getNodeName(markup);
    var wrap = nodeName && $kT7Ku(nodeName);
    if (wrap) {
        node.innerHTML = wrap[1] + markup + wrap[2];
        var wrapDepth = wrap[0];
        while(wrapDepth--)node = node.lastChild;
    } else node.innerHTML = markup;
    var scripts = node.getElementsByTagName("script");
    if (scripts.length) {
        !handleScript && $4Mb5c(false);
        $3AZSv(scripts).forEach(handleScript);
    }
    var nodes = Array.from(node.childNodes);
    while(node.lastChild)node.removeChild(node.lastChild);
    return nodes;
}
module.exports = $2462d4f2b80c93cf$var$createNodesFromMarkup;

});
parcelRegister("3AZSv", function(module, exports) {
"use strict";

var $4Mb5c = parcelRequire("4Mb5c");
/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */ function $29e4bb941c92fc20$var$toArray(obj) {
    var length = obj.length;
    // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
    // in old versions of Safari).
    !(!Array.isArray(obj) && (typeof obj === "object" || typeof obj === "function")) && $4Mb5c(false);
    !(typeof length === "number") && $4Mb5c(false);
    !(length === 0 || length - 1 in obj) && $4Mb5c(false);
    !(typeof obj.callee !== "function") && $4Mb5c(false);
    // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
    // without method will throw during the slice call and skip straight to the
    // fallback.
    if (obj.hasOwnProperty) try {
        return Array.prototype.slice.call(obj);
    } catch (e) {
    // IE < 9 does not support Array#slice on collections objects
    }
    // Fall back to copying key by key. This assumes all keys have a value,
    // so will not preserve sparsely populated inputs.
    var ret = Array(length);
    for(var ii = 0; ii < length; ii++)ret[ii] = obj[ii];
    return ret;
}
/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */ function $29e4bb941c92fc20$var$hasArrayNature(obj) {
    return(// not null/false
    !!obj && // arrays are objects, NodeLists are functions in Safari
    (typeof obj == "object" || typeof obj == "function") && // quacks like an array
    "length" in obj && // not window
    !("setInterval" in obj) && // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != "number" && // a real array
    (Array.isArray(obj) || // arguments
    "callee" in obj || // HTMLCollection/NodeList
    "item" in obj));
}
/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */ function $29e4bb941c92fc20$var$createArrayFromMixed(obj) {
    if (!$29e4bb941c92fc20$var$hasArrayNature(obj)) return [
        obj
    ];
    else if (Array.isArray(obj)) return obj.slice();
    else return $29e4bb941c92fc20$var$toArray(obj);
}
module.exports = $29e4bb941c92fc20$var$createArrayFromMixed;

});

parcelRegister("kT7Ku", function(module, exports) {
"use strict";

var $kx286 = parcelRequire("kx286");

var $4Mb5c = parcelRequire("4Mb5c");
/**
 * Dummy container used to detect which wraps are necessary.
 */ var $f34ef4775020e0b9$var$dummyNode = $kx286.canUseDOM ? document.createElement("div") : null;
/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */ var $f34ef4775020e0b9$var$shouldWrap = {};
var $f34ef4775020e0b9$var$selectWrap = [
    1,
    '<select multiple="true">',
    "</select>"
];
var $f34ef4775020e0b9$var$tableWrap = [
    1,
    "<table>",
    "</table>"
];
var $f34ef4775020e0b9$var$trWrap = [
    3,
    "<table><tbody><tr>",
    "</tr></tbody></table>"
];
var $f34ef4775020e0b9$var$svgWrap = [
    1,
    '<svg xmlns="http://www.w3.org/2000/svg">',
    "</svg>"
];
var $f34ef4775020e0b9$var$markupWrap = {
    "*": [
        1,
        "?<div>",
        "</div>"
    ],
    "area": [
        1,
        "<map>",
        "</map>"
    ],
    "col": [
        2,
        "<table><tbody></tbody><colgroup>",
        "</colgroup></table>"
    ],
    "legend": [
        1,
        "<fieldset>",
        "</fieldset>"
    ],
    "param": [
        1,
        "<object>",
        "</object>"
    ],
    "tr": [
        2,
        "<table><tbody>",
        "</tbody></table>"
    ],
    "optgroup": $f34ef4775020e0b9$var$selectWrap,
    "option": $f34ef4775020e0b9$var$selectWrap,
    "caption": $f34ef4775020e0b9$var$tableWrap,
    "colgroup": $f34ef4775020e0b9$var$tableWrap,
    "tbody": $f34ef4775020e0b9$var$tableWrap,
    "tfoot": $f34ef4775020e0b9$var$tableWrap,
    "thead": $f34ef4775020e0b9$var$tableWrap,
    "td": $f34ef4775020e0b9$var$trWrap,
    "th": $f34ef4775020e0b9$var$trWrap
};
// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var $f34ef4775020e0b9$var$svgElements = [
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "text",
    "tspan"
];
$f34ef4775020e0b9$var$svgElements.forEach(function(nodeName) {
    $f34ef4775020e0b9$var$markupWrap[nodeName] = $f34ef4775020e0b9$var$svgWrap;
    $f34ef4775020e0b9$var$shouldWrap[nodeName] = true;
});
/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */ function $f34ef4775020e0b9$var$getMarkupWrap(nodeName) {
    !!!$f34ef4775020e0b9$var$dummyNode && $4Mb5c(false);
    if (!$f34ef4775020e0b9$var$markupWrap.hasOwnProperty(nodeName)) nodeName = "*";
    if (!$f34ef4775020e0b9$var$shouldWrap.hasOwnProperty(nodeName)) {
        if (nodeName === "*") $f34ef4775020e0b9$var$dummyNode.innerHTML = "<link />";
        else $f34ef4775020e0b9$var$dummyNode.innerHTML = "<" + nodeName + "></" + nodeName + ">";
        $f34ef4775020e0b9$var$shouldWrap[nodeName] = !$f34ef4775020e0b9$var$dummyNode.firstChild;
    }
    return $f34ef4775020e0b9$var$shouldWrap[nodeName] ? $f34ef4775020e0b9$var$markupWrap[nodeName] : null;
}
module.exports = $f34ef4775020e0b9$var$getMarkupWrap;

});




parcelRegister("hIl0J", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $2BUuH = parcelRequire("2BUuH");

var $5fGpM = parcelRequire("5fGpM");
/**
 * Operations used to process updates to DOM nodes.
 */ var $ce56d80495bfb21b$var$ReactDOMIDOperations = {
    /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */ dangerouslyProcessChildrenUpdates: function(parentInst, updates) {
        var node = $5fGpM.getNodeFromInstance(parentInst);
        $2BUuH.processUpdates(node, updates);
    }
};
module.exports = $ce56d80495bfb21b$var$ReactDOMIDOperations;

});


parcelRegister("aVA3J", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /* global hasOwnProperty:true */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $a6S4T = parcelRequire("a6S4T");

var $di7md = parcelRequire("di7md");

var $4AxOp = parcelRequire("4AxOp");

var $QV5G5 = parcelRequire("QV5G5");

var $e4vh0 = parcelRequire("e4vh0");

var $Uj2z8 = parcelRequire("Uj2z8");

var $jQzHJ = parcelRequire("jQzHJ");

var $53teI = parcelRequire("53teI");

var $6cytr = parcelRequire("6cytr");

var $jugFn = parcelRequire("jugFn");

var $jCXRR = parcelRequire("jCXRR");

var $5fGpM = parcelRequire("5fGpM");

var $6WA5t = parcelRequire("6WA5t");

var $cQDh1 = parcelRequire("cQDh1");

var $k7YMG = parcelRequire("k7YMG");

var $2EDkc = parcelRequire("2EDkc");
parcelRequire("d1IRY");

var $jkvXw = parcelRequire("jkvXw");

var $17lgn = parcelRequire("17lgn");

var $46CSh = parcelRequire("46CSh");

var $8i9tX = parcelRequire("8i9tX");
parcelRequire("4Mb5c");
parcelRequire("7yqoI");

var $el2AU = parcelRequire("el2AU");

var $clPIH = parcelRequire("clPIH");
parcelRequire("dBldY");
parcelRequire("fIzgz");
var $7f4b32d672c5c832$var$Flags = $jCXRR;
var $7f4b32d672c5c832$var$deleteListener = $53teI.deleteListener;
var $7f4b32d672c5c832$var$getNode = $5fGpM.getNodeFromInstance;
var $7f4b32d672c5c832$var$listenTo = $jugFn.listenTo;
var $7f4b32d672c5c832$var$registrationNameModules = $6cytr.registrationNameModules;
// For quickly matching children type, to test if can be treated as content.
var $7f4b32d672c5c832$var$CONTENT_TYPES = {
    string: true,
    number: true
};
var $7f4b32d672c5c832$var$STYLE = "style";
var $7f4b32d672c5c832$var$HTML = "__html";
var $7f4b32d672c5c832$var$RESERVED_PROPS = {
    children: null,
    dangerouslySetInnerHTML: null,
    suppressContentEditableWarning: null
};
// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var $7f4b32d672c5c832$var$DOC_FRAGMENT_TYPE = 11;
function $7f4b32d672c5c832$var$getDeclarationErrorAddendum(internalInstance) {
    if (internalInstance) {
        var owner = internalInstance._currentElement._owner || null;
        if (owner) {
            var name = owner.getName();
            if (name) return " This DOM node was rendered by `" + name + "`.";
        }
    }
    return "";
}
function $7f4b32d672c5c832$var$friendlyStringify(obj) {
    if (typeof obj === "object") {
        if (Array.isArray(obj)) return "[" + obj.map($7f4b32d672c5c832$var$friendlyStringify).join(", ") + "]";
        else {
            var pairs = [];
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
                pairs.push(keyEscaped + ": " + $7f4b32d672c5c832$var$friendlyStringify(obj[key]));
            }
            return "{" + pairs.join(", ") + "}";
        }
    } else if (typeof obj === "string") return JSON.stringify(obj);
    else if (typeof obj === "function") return "[function object]";
    // Differs from JSON.stringify in that undefined because undefined and that
    // inf and nan don't become null
    return String(obj);
}
var $7f4b32d672c5c832$var$styleMutationWarning = {};
function $7f4b32d672c5c832$var$checkAndWarnForMutatedStyle(style1, style2, component) {
    if (style1 == null || style2 == null) return;
    if ($el2AU(style1, style2)) return;
    var componentName = component._tag;
    var owner = component._currentElement._owner;
    var ownerName;
    if (owner) ownerName = owner.getName();
    var hash = ownerName + "|" + componentName;
    if ($7f4b32d672c5c832$var$styleMutationWarning.hasOwnProperty(hash)) return;
    $7f4b32d672c5c832$var$styleMutationWarning[hash] = true;
}
/**
 * @param {object} component
 * @param {?object} props
 */ function $7f4b32d672c5c832$var$assertValidProps(component, props) {
    if (!props) return;
    // Note the use of `==` which checks for null or undefined.
    if ($7f4b32d672c5c832$var$voidElementTags[component._tag]) !(props.children == null && props.dangerouslySetInnerHTML == null) && $jOpPq("137", component._tag, component._currentElement._owner ? " Check the render method of " + component._currentElement._owner.getName() + "." : "");
    if (props.dangerouslySetInnerHTML != null) {
        !(props.children == null) && $jOpPq("60");
        !(typeof props.dangerouslySetInnerHTML === "object" && $7f4b32d672c5c832$var$HTML in props.dangerouslySetInnerHTML) && $jOpPq("61");
    }
    !(props.style == null || typeof props.style === "object") && $jOpPq("62", $7f4b32d672c5c832$var$getDeclarationErrorAddendum(component));
}
function $7f4b32d672c5c832$var$enqueuePutListener(inst, registrationName, listener, transaction) {
    if (transaction instanceof $17lgn) return;
    var containerInfo = inst._hostContainerInfo;
    var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === $7f4b32d672c5c832$var$DOC_FRAGMENT_TYPE;
    var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
    $7f4b32d672c5c832$var$listenTo(registrationName, doc);
    transaction.getReactMountReady().enqueue($7f4b32d672c5c832$var$putListener, {
        inst: inst,
        registrationName: registrationName,
        listener: listener
    });
}
function $7f4b32d672c5c832$var$putListener() {
    var listenerToPut = this;
    $53teI.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}
function $7f4b32d672c5c832$var$inputPostMount() {
    var inst = this;
    $6WA5t.postMountWrapper(inst);
}
function $7f4b32d672c5c832$var$textareaPostMount() {
    var inst = this;
    $2EDkc.postMountWrapper(inst);
}
function $7f4b32d672c5c832$var$optionPostMount() {
    var inst = this;
    $cQDh1.postMountWrapper(inst);
}
var $7f4b32d672c5c832$var$setAndValidateContentChildDev = $46CSh;
// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var $7f4b32d672c5c832$var$mediaEvents = {
    topAbort: "abort",
    topCanPlay: "canplay",
    topCanPlayThrough: "canplaythrough",
    topDurationChange: "durationchange",
    topEmptied: "emptied",
    topEncrypted: "encrypted",
    topEnded: "ended",
    topError: "error",
    topLoadedData: "loadeddata",
    topLoadedMetadata: "loadedmetadata",
    topLoadStart: "loadstart",
    topPause: "pause",
    topPlay: "play",
    topPlaying: "playing",
    topProgress: "progress",
    topRateChange: "ratechange",
    topSeeked: "seeked",
    topSeeking: "seeking",
    topStalled: "stalled",
    topSuspend: "suspend",
    topTimeUpdate: "timeupdate",
    topVolumeChange: "volumechange",
    topWaiting: "waiting"
};
function $7f4b32d672c5c832$var$trackInputValue() {
    $clPIH.track(this);
}
function $7f4b32d672c5c832$var$trapBubbledEventsLocal() {
    var inst = this;
    // If a component renders to null or if another component fatals and causes
    // the state of the tree to be corrupted, `node` here can be null.
    !inst._rootNodeID && $jOpPq("63");
    var node = $7f4b32d672c5c832$var$getNode(inst);
    !node && $jOpPq("64");
    switch(inst._tag){
        case "iframe":
        case "object":
            inst._wrapperState.listeners = [
                $jugFn.trapBubbledEvent("topLoad", "load", node)
            ];
            break;
        case "video":
        case "audio":
            inst._wrapperState.listeners = [];
            // Create listener for each media event
            for(var event in $7f4b32d672c5c832$var$mediaEvents)if ($7f4b32d672c5c832$var$mediaEvents.hasOwnProperty(event)) inst._wrapperState.listeners.push($jugFn.trapBubbledEvent(event, $7f4b32d672c5c832$var$mediaEvents[event], node));
            break;
        case "source":
            inst._wrapperState.listeners = [
                $jugFn.trapBubbledEvent("topError", "error", node)
            ];
            break;
        case "img":
            inst._wrapperState.listeners = [
                $jugFn.trapBubbledEvent("topError", "error", node),
                $jugFn.trapBubbledEvent("topLoad", "load", node)
            ];
            break;
        case "form":
            inst._wrapperState.listeners = [
                $jugFn.trapBubbledEvent("topReset", "reset", node),
                $jugFn.trapBubbledEvent("topSubmit", "submit", node)
            ];
            break;
        case "input":
        case "select":
        case "textarea":
            inst._wrapperState.listeners = [
                $jugFn.trapBubbledEvent("topInvalid", "invalid", node)
            ];
            break;
    }
}
function $7f4b32d672c5c832$var$postUpdateSelectWrapper() {
    $k7YMG.postUpdateWrapper(this);
}
// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.
var $7f4b32d672c5c832$var$omittedCloseTags = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true
};
var $7f4b32d672c5c832$var$newlineEatingTags = {
    listing: true,
    pre: true,
    textarea: true
};
// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.
var $7f4b32d672c5c832$var$voidElementTags = $a6S4T({
    menuitem: true
}, $7f4b32d672c5c832$var$omittedCloseTags);
// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name
var $7f4b32d672c5c832$var$VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var $7f4b32d672c5c832$var$validatedTagCache = {};
var $7f4b32d672c5c832$var$hasOwnProperty = {}.hasOwnProperty;
function $7f4b32d672c5c832$var$validateDangerousTag(tag) {
    if (!$7f4b32d672c5c832$var$hasOwnProperty.call($7f4b32d672c5c832$var$validatedTagCache, tag)) {
        !$7f4b32d672c5c832$var$VALID_TAG_REGEX.test(tag) && $jOpPq("65", tag);
        $7f4b32d672c5c832$var$validatedTagCache[tag] = true;
    }
}
function $7f4b32d672c5c832$var$isCustomComponent(tagName, props) {
    return tagName.indexOf("-") >= 0 || props.is != null;
}
var $7f4b32d672c5c832$var$globalIdCounter = 1;
/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */ function $7f4b32d672c5c832$var$ReactDOMComponent(element) {
    var tag = element.type;
    $7f4b32d672c5c832$var$validateDangerousTag(tag);
    this._currentElement = element;
    this._tag = tag.toLowerCase();
    this._namespaceURI = null;
    this._renderedChildren = null;
    this._previousStyle = null;
    this._previousStyleCopy = null;
    this._hostNode = null;
    this._hostParent = null;
    this._rootNodeID = 0;
    this._domID = 0;
    this._hostContainerInfo = null;
    this._wrapperState = null;
    this._topLevelWrapper = null;
    this._flags = 0;
}
$7f4b32d672c5c832$var$ReactDOMComponent.displayName = "ReactDOMComponent";
$7f4b32d672c5c832$var$ReactDOMComponent.Mixin = {
    /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */ mountComponent: function(transaction, hostParent, hostContainerInfo, context) {
        this._rootNodeID = $7f4b32d672c5c832$var$globalIdCounter++;
        this._domID = hostContainerInfo._idCounter++;
        this._hostParent = hostParent;
        this._hostContainerInfo = hostContainerInfo;
        var props = this._currentElement.props;
        switch(this._tag){
            case "audio":
            case "form":
            case "iframe":
            case "img":
            case "link":
            case "object":
            case "source":
            case "video":
                this._wrapperState = {
                    listeners: null
                };
                transaction.getReactMountReady().enqueue($7f4b32d672c5c832$var$trapBubbledEventsLocal, this);
                break;
            case "input":
                $6WA5t.mountWrapper(this, props, hostParent);
                props = $6WA5t.getHostProps(this, props);
                transaction.getReactMountReady().enqueue($7f4b32d672c5c832$var$trackInputValue, this);
                transaction.getReactMountReady().enqueue($7f4b32d672c5c832$var$trapBubbledEventsLocal, this);
                break;
            case "option":
                $cQDh1.mountWrapper(this, props, hostParent);
                props = $cQDh1.getHostProps(this, props);
                break;
            case "select":
                $k7YMG.mountWrapper(this, props, hostParent);
                props = $k7YMG.getHostProps(this, props);
                transaction.getReactMountReady().enqueue($7f4b32d672c5c832$var$trapBubbledEventsLocal, this);
                break;
            case "textarea":
                $2EDkc.mountWrapper(this, props, hostParent);
                props = $2EDkc.getHostProps(this, props);
                transaction.getReactMountReady().enqueue($7f4b32d672c5c832$var$trackInputValue, this);
                transaction.getReactMountReady().enqueue($7f4b32d672c5c832$var$trapBubbledEventsLocal, this);
                break;
        }
        $7f4b32d672c5c832$var$assertValidProps(this, props);
        // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var namespaceURI;
        var parentTag;
        if (hostParent != null) {
            namespaceURI = hostParent._namespaceURI;
            parentTag = hostParent._tag;
        } else if (hostContainerInfo._tag) {
            namespaceURI = hostContainerInfo._namespaceURI;
            parentTag = hostContainerInfo._tag;
        }
        if (namespaceURI == null || namespaceURI === $e4vh0.svg && parentTag === "foreignobject") namespaceURI = $e4vh0.html;
        if (namespaceURI === $e4vh0.html) {
            if (this._tag === "svg") namespaceURI = $e4vh0.svg;
            else if (this._tag === "math") namespaceURI = $e4vh0.mathml;
        }
        this._namespaceURI = namespaceURI;
        var parentInfo;
        var mountImage;
        if (transaction.useCreateElement) {
            var ownerDocument = hostContainerInfo._ownerDocument;
            var el;
            if (namespaceURI === $e4vh0.html) {
                if (this._tag === "script") {
                    // Create the script via .innerHTML so its "parser-inserted" flag is
                    // set to true and it does not execute
                    var div = ownerDocument.createElement("div");
                    var type = this._currentElement.type;
                    div.innerHTML = "<" + type + "></" + type + ">";
                    el = div.removeChild(div.firstChild);
                } else if (props.is) el = ownerDocument.createElement(this._currentElement.type, props.is);
                else // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                el = ownerDocument.createElement(this._currentElement.type);
            } else el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
            $5fGpM.precacheNode(this, el);
            this._flags |= $7f4b32d672c5c832$var$Flags.hasCachedChildNodes;
            if (!this._hostParent) $jQzHJ.setAttributeForRoot(el);
            this._updateDOMProperties(null, props, transaction);
            var lazyTree = $QV5G5(el);
            this._createInitialChildren(transaction, props, context, lazyTree);
            mountImage = lazyTree;
        } else {
            var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
            var tagContent = this._createContentMarkup(transaction, props, context);
            if (!tagContent && $7f4b32d672c5c832$var$omittedCloseTags[this._tag]) mountImage = tagOpen + "/>";
            else mountImage = tagOpen + ">" + tagContent + "</" + this._currentElement.type + ">";
        }
        switch(this._tag){
            case "input":
                transaction.getReactMountReady().enqueue($7f4b32d672c5c832$var$inputPostMount, this);
                if (props.autoFocus) transaction.getReactMountReady().enqueue($di7md.focusDOMComponent, this);
                break;
            case "textarea":
                transaction.getReactMountReady().enqueue($7f4b32d672c5c832$var$textareaPostMount, this);
                if (props.autoFocus) transaction.getReactMountReady().enqueue($di7md.focusDOMComponent, this);
                break;
            case "select":
                if (props.autoFocus) transaction.getReactMountReady().enqueue($di7md.focusDOMComponent, this);
                break;
            case "button":
                if (props.autoFocus) transaction.getReactMountReady().enqueue($di7md.focusDOMComponent, this);
                break;
            case "option":
                transaction.getReactMountReady().enqueue($7f4b32d672c5c832$var$optionPostMount, this);
                break;
        }
        return mountImage;
    },
    /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */ _createOpenTagMarkupAndPutListeners: function(transaction, props) {
        var ret = "<" + this._currentElement.type;
        for(var propKey in props){
            if (!props.hasOwnProperty(propKey)) continue;
            var propValue = props[propKey];
            if (propValue == null) continue;
            if ($7f4b32d672c5c832$var$registrationNameModules.hasOwnProperty(propKey)) {
                if (propValue) $7f4b32d672c5c832$var$enqueuePutListener(this, propKey, propValue, transaction);
            } else {
                if (propKey === $7f4b32d672c5c832$var$STYLE) {
                    if (propValue) propValue = this._previousStyleCopy = $a6S4T({}, props.style);
                    propValue = $4AxOp.createMarkupForStyles(propValue, this);
                }
                var markup = null;
                if (this._tag != null && $7f4b32d672c5c832$var$isCustomComponent(this._tag, props)) {
                    if (!$7f4b32d672c5c832$var$RESERVED_PROPS.hasOwnProperty(propKey)) markup = $jQzHJ.createMarkupForCustomAttribute(propKey, propValue);
                } else markup = $jQzHJ.createMarkupForProperty(propKey, propValue);
                if (markup) ret += " " + markup;
            }
        }
        // For static pages, no need to put React ID and checksum. Saves lots of
        // bytes.
        if (transaction.renderToStaticMarkup) return ret;
        if (!this._hostParent) ret += " " + $jQzHJ.createMarkupForRoot();
        ret += " " + $jQzHJ.createMarkupForID(this._domID);
        return ret;
    },
    /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */ _createContentMarkup: function(transaction, props, context) {
        var ret = "";
        // Intentional use of != to avoid catching zero/false.
        var innerHTML = props.dangerouslySetInnerHTML;
        if (innerHTML != null) {
            if (innerHTML.__html != null) ret = innerHTML.__html;
        } else {
            var contentToUse = $7f4b32d672c5c832$var$CONTENT_TYPES[typeof props.children] ? props.children : null;
            var childrenToUse = contentToUse != null ? null : props.children;
            if (contentToUse != null) // TODO: Validate that text is allowed as a child of this node
            ret = $8i9tX(contentToUse);
            else if (childrenToUse != null) {
                var mountImages = this.mountChildren(childrenToUse, transaction, context);
                ret = mountImages.join("");
            }
        }
        if ($7f4b32d672c5c832$var$newlineEatingTags[this._tag] && ret.charAt(0) === "\n") // text/html ignores the first character in these tags if it's a newline
        // Prefer to break application/xml over text/html (for now) by adding
        // a newline specifically to get eaten by the parser. (Alternately for
        // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
        // \r is normalized out by HTMLTextAreaElement#value.)
        // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
        // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
        // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
        // See: Parsing of "textarea" "listing" and "pre" elements
        //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
        return "\n" + ret;
        else return ret;
    },
    _createInitialChildren: function(transaction, props, context, lazyTree) {
        // Intentional use of != to avoid catching zero/false.
        var innerHTML = props.dangerouslySetInnerHTML;
        if (innerHTML != null) {
            if (innerHTML.__html != null) $QV5G5.queueHTML(lazyTree, innerHTML.__html);
        } else {
            var contentToUse = $7f4b32d672c5c832$var$CONTENT_TYPES[typeof props.children] ? props.children : null;
            var childrenToUse = contentToUse != null ? null : props.children;
            // TODO: Validate that text is allowed as a child of this node
            if (contentToUse != null) // Avoid setting textContent when the text is empty. In IE11 setting
            // textContent on a text area will cause the placeholder to not
            // show within the textarea until it has been focused and blurred again.
            // https://github.com/facebook/react/issues/6731#issuecomment-254874553
            {
                if (contentToUse !== "") $QV5G5.queueText(lazyTree, contentToUse);
            } else if (childrenToUse != null) {
                var mountImages = this.mountChildren(childrenToUse, transaction, context);
                for(var i = 0; i < mountImages.length; i++)$QV5G5.queueChild(lazyTree, mountImages[i]);
            }
        }
    },
    /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */ receiveComponent: function(nextElement, transaction, context) {
        var prevElement = this._currentElement;
        this._currentElement = nextElement;
        this.updateComponent(transaction, prevElement, nextElement, context);
    },
    /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */ updateComponent: function(transaction, prevElement, nextElement, context) {
        var lastProps = prevElement.props;
        var nextProps = this._currentElement.props;
        switch(this._tag){
            case "input":
                lastProps = $6WA5t.getHostProps(this, lastProps);
                nextProps = $6WA5t.getHostProps(this, nextProps);
                break;
            case "option":
                lastProps = $cQDh1.getHostProps(this, lastProps);
                nextProps = $cQDh1.getHostProps(this, nextProps);
                break;
            case "select":
                lastProps = $k7YMG.getHostProps(this, lastProps);
                nextProps = $k7YMG.getHostProps(this, nextProps);
                break;
            case "textarea":
                lastProps = $2EDkc.getHostProps(this, lastProps);
                nextProps = $2EDkc.getHostProps(this, nextProps);
                break;
        }
        $7f4b32d672c5c832$var$assertValidProps(this, nextProps);
        this._updateDOMProperties(lastProps, nextProps, transaction);
        this._updateDOMChildren(lastProps, nextProps, transaction, context);
        switch(this._tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                $6WA5t.updateWrapper(this);
                // We also check that we haven't missed a value update, such as a
                // Radio group shifting the checked value to another named radio input.
                $clPIH.updateValueIfChanged(this);
                break;
            case "textarea":
                $2EDkc.updateWrapper(this);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                transaction.getReactMountReady().enqueue($7f4b32d672c5c832$var$postUpdateSelectWrapper, this);
                break;
        }
    },
    /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */ _updateDOMProperties: function(lastProps, nextProps, transaction) {
        var propKey;
        var styleName;
        var styleUpdates;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === $7f4b32d672c5c832$var$STYLE) {
                var lastStyle = this._previousStyleCopy;
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    styleUpdates = styleUpdates || {};
                    styleUpdates[styleName] = "";
                }
                this._previousStyleCopy = null;
            } else if ($7f4b32d672c5c832$var$registrationNameModules.hasOwnProperty(propKey)) {
                if (lastProps[propKey]) // Only call deleteListener if there was a listener previously or
                // else willDeleteListener gets called when there wasn't actually a
                // listener (e.g., onClick={null})
                $7f4b32d672c5c832$var$deleteListener(this, propKey);
            } else if ($7f4b32d672c5c832$var$isCustomComponent(this._tag, lastProps)) {
                if (!$7f4b32d672c5c832$var$RESERVED_PROPS.hasOwnProperty(propKey)) $jQzHJ.deleteValueForAttribute($7f4b32d672c5c832$var$getNode(this), propKey);
            } else if ($Uj2z8.properties[propKey] || $Uj2z8.isCustomAttribute(propKey)) $jQzHJ.deleteValueForProperty($7f4b32d672c5c832$var$getNode(this), propKey);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = propKey === $7f4b32d672c5c832$var$STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === $7f4b32d672c5c832$var$STYLE) {
                if (nextProp) nextProp = this._previousStyleCopy = $a6S4T({}, nextProp);
                else this._previousStyleCopy = null;
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        styleUpdates = styleUpdates || {};
                        styleUpdates[styleName] = "";
                    }
                    // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        styleUpdates = styleUpdates || {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else // Relies on `updateStylesByID` not mutating `styleUpdates`.
                styleUpdates = nextProp;
            } else if ($7f4b32d672c5c832$var$registrationNameModules.hasOwnProperty(propKey)) {
                if (nextProp) $7f4b32d672c5c832$var$enqueuePutListener(this, propKey, nextProp, transaction);
                else if (lastProp) $7f4b32d672c5c832$var$deleteListener(this, propKey);
            } else if ($7f4b32d672c5c832$var$isCustomComponent(this._tag, nextProps)) {
                if (!$7f4b32d672c5c832$var$RESERVED_PROPS.hasOwnProperty(propKey)) $jQzHJ.setValueForAttribute($7f4b32d672c5c832$var$getNode(this), propKey, nextProp);
            } else if ($Uj2z8.properties[propKey] || $Uj2z8.isCustomAttribute(propKey)) {
                var node = $7f4b32d672c5c832$var$getNode(this);
                // If we're updating to null or undefined, we should remove the property
                // from the DOM node instead of inadvertently setting to a string. This
                // brings us in line with the same behavior we have on initial render.
                if (nextProp != null) $jQzHJ.setValueForProperty(node, propKey, nextProp);
                else $jQzHJ.deleteValueForProperty(node, propKey);
            }
        }
        if (styleUpdates) $4AxOp.setValueForStyles($7f4b32d672c5c832$var$getNode(this), styleUpdates, this);
    },
    /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */ _updateDOMChildren: function(lastProps, nextProps, transaction, context) {
        var lastContent = $7f4b32d672c5c832$var$CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
        var nextContent = $7f4b32d672c5c832$var$CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
        var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
        var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
        // Note the use of `!=` which checks for null or undefined.
        var lastChildren = lastContent != null ? null : lastProps.children;
        var nextChildren = nextContent != null ? null : nextProps.children;
        // If we're switching from children to content/html or vice versa, remove
        // the old content
        var lastHasContentOrHtml = lastContent != null || lastHtml != null;
        var nextHasContentOrHtml = nextContent != null || nextHtml != null;
        if (lastChildren != null && nextChildren == null) this.updateChildren(null, transaction, context);
        else if (lastHasContentOrHtml && !nextHasContentOrHtml) this.updateTextContent("");
        if (nextContent != null) {
            if (lastContent !== nextContent) this.updateTextContent("" + nextContent);
        } else if (nextHtml != null) {
            if (lastHtml !== nextHtml) this.updateMarkup("" + nextHtml);
        } else if (nextChildren != null) this.updateChildren(nextChildren, transaction, context);
    },
    getHostNode: function() {
        return $7f4b32d672c5c832$var$getNode(this);
    },
    /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */ unmountComponent: function(safely) {
        switch(this._tag){
            case "audio":
            case "form":
            case "iframe":
            case "img":
            case "link":
            case "object":
            case "source":
            case "video":
                var listeners = this._wrapperState.listeners;
                if (listeners) for(var i = 0; i < listeners.length; i++)listeners[i].remove();
                break;
            case "input":
            case "textarea":
                $clPIH.stopTracking(this);
                break;
            case "html":
            case "head":
            case "body":
                /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */ $jOpPq("66", this._tag);
                break;
        }
        this.unmountChildren(safely);
        $5fGpM.uncacheNode(this);
        $53teI.deleteAllListeners(this);
        this._rootNodeID = 0;
        this._domID = 0;
        this._wrapperState = null;
    },
    getPublicInstance: function() {
        return $7f4b32d672c5c832$var$getNode(this);
    }
};
$a6S4T($7f4b32d672c5c832$var$ReactDOMComponent.prototype, $7f4b32d672c5c832$var$ReactDOMComponent.Mixin, $jkvXw.Mixin);
module.exports = $7f4b32d672c5c832$var$ReactDOMComponent;

});
parcelRegister("di7md", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $5fGpM = parcelRequire("5fGpM");

var $i660C = parcelRequire("i660C");
var $9ad2a9d5f5adfcd5$var$AutoFocusUtils = {
    focusDOMComponent: function() {
        $i660C($5fGpM.getNodeFromInstance(this));
    }
};
module.exports = $9ad2a9d5f5adfcd5$var$AutoFocusUtils;

});
parcelRegister("i660C", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
/**
 * @param {DOMElement} node input/textarea to focus
 */ function $d2cd72c75cbbd6a3$var$focusNode(node) {
    // IE8 can throw "Can't move focus to the control because it is invisible,
    // not enabled, or of a type that does not accept the focus." for all kinds of
    // reasons that are too expensive and fragile to test.
    try {
        node.focus();
    } catch (e) {}
}
module.exports = $d2cd72c75cbbd6a3$var$focusNode;

});


parcelRegister("4AxOp", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $bf8Yh = parcelRequire("bf8Yh");

var $kx286 = parcelRequire("kx286");
parcelRequire("d1IRY");
parcelRequire("actZ6");

var $dClcE = parcelRequire("dClcE");

var $bIbM4 = parcelRequire("bIbM4");

var $fq20v = parcelRequire("fq20v");
parcelRequire("fIzgz");
var $3574c0960c4dcde4$var$processStyleName = $fq20v(function(styleName) {
    return $bIbM4(styleName);
});
var $3574c0960c4dcde4$var$hasShorthandPropertyBug = false;
var $3574c0960c4dcde4$var$styleFloatAccessor = "cssFloat";
if ($kx286.canUseDOM) {
    var $3574c0960c4dcde4$var$tempStyle = document.createElement("div").style;
    try {
        // IE8 throws "Invalid argument." if resetting shorthand style properties.
        $3574c0960c4dcde4$var$tempStyle.font = "";
    } catch (e) {
        $3574c0960c4dcde4$var$hasShorthandPropertyBug = true;
    }
    // IE8 only supports accessing cssFloat (standard) as styleFloat
    if (document.documentElement.style.cssFloat === undefined) $3574c0960c4dcde4$var$styleFloatAccessor = "styleFloat";
}
var $3574c0960c4dcde4$var$badVendoredStyleNamePattern, $3574c0960c4dcde4$var$badStyleValueWithSemicolonPattern, $3574c0960c4dcde4$var$warnedStyleNames, $3574c0960c4dcde4$var$warnedStyleValues, $3574c0960c4dcde4$var$warnedForNaNValue, $3574c0960c4dcde4$var$warnHyphenatedStyleName, $3574c0960c4dcde4$var$warnBadVendoredStyleName, $3574c0960c4dcde4$var$warnStyleValueWithSemicolon, $3574c0960c4dcde4$var$warnStyleValueIsNaN, $3574c0960c4dcde4$var$checkRenderMessage, $3574c0960c4dcde4$var$warnValidStyle;
/**
 * Operations for dealing with CSS properties.
 */ var $3574c0960c4dcde4$var$CSSPropertyOperations = {
    /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */ createMarkupForStyles: function(styles, component) {
        var serialized = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                serialized += $3574c0960c4dcde4$var$processStyleName(styleName) + ":";
                serialized += $dClcE(styleName, styleValue, component, isCustomProperty) + ";";
            }
        }
        return serialized || null;
    },
    /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */ setValueForStyles: function(node, styles, component) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            var styleValue = $dClcE(styleName, styles[styleName], component, isCustomProperty);
            if (styleName === "float" || styleName === "cssFloat") styleName = $3574c0960c4dcde4$var$styleFloatAccessor;
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else if (styleValue) style[styleName] = styleValue;
            else {
                var expansion = $3574c0960c4dcde4$var$hasShorthandPropertyBug && $bf8Yh.shorthandPropertyExpansions[styleName];
                if (expansion) // Shorthand property that IE8 won't like unsetting, so unset each
                // component to placate it
                for(var individualStyleName in expansion)style[individualStyleName] = "";
                else style[styleName] = "";
            }
        }
    }
};
module.exports = $3574c0960c4dcde4$var$CSSPropertyOperations;

});
parcelRegister("bf8Yh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
/**
 * CSS properties which accept numbers but are not in units of "px".
 */ var $82f80deb5cb37808$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function $82f80deb5cb37808$var$prefixKey(prefix, key) {
    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var $82f80deb5cb37808$var$prefixes = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys($82f80deb5cb37808$var$isUnitlessNumber).forEach(function(prop) {
    $82f80deb5cb37808$var$prefixes.forEach(function(prefix) {
        $82f80deb5cb37808$var$isUnitlessNumber[$82f80deb5cb37808$var$prefixKey(prefix, prop)] = $82f80deb5cb37808$var$isUnitlessNumber[prop];
    });
});
/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */ var $82f80deb5cb37808$var$shorthandPropertyExpansions = {
    background: {
        backgroundAttachment: true,
        backgroundColor: true,
        backgroundImage: true,
        backgroundPositionX: true,
        backgroundPositionY: true,
        backgroundRepeat: true
    },
    backgroundPosition: {
        backgroundPositionX: true,
        backgroundPositionY: true
    },
    border: {
        borderWidth: true,
        borderStyle: true,
        borderColor: true
    },
    borderBottom: {
        borderBottomWidth: true,
        borderBottomStyle: true,
        borderBottomColor: true
    },
    borderLeft: {
        borderLeftWidth: true,
        borderLeftStyle: true,
        borderLeftColor: true
    },
    borderRight: {
        borderRightWidth: true,
        borderRightStyle: true,
        borderRightColor: true
    },
    borderTop: {
        borderTopWidth: true,
        borderTopStyle: true,
        borderTopColor: true
    },
    font: {
        fontStyle: true,
        fontVariant: true,
        fontWeight: true,
        fontSize: true,
        lineHeight: true,
        fontFamily: true
    },
    outline: {
        outlineWidth: true,
        outlineStyle: true,
        outlineColor: true
    }
};
var $82f80deb5cb37808$var$CSSProperty = {
    isUnitlessNumber: $82f80deb5cb37808$var$isUnitlessNumber,
    shorthandPropertyExpansions: $82f80deb5cb37808$var$shorthandPropertyExpansions
};
module.exports = $82f80deb5cb37808$var$CSSProperty;

});

parcelRegister("actZ6", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ "use strict";

var $3TPjV = parcelRequire("3TPjV");
var $76d248aed81aee82$var$msPattern = /^-ms-/;
/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */ function $76d248aed81aee82$var$camelizeStyleName(string) {
    return $3TPjV(string.replace($76d248aed81aee82$var$msPattern, "ms-"));
}
module.exports = $76d248aed81aee82$var$camelizeStyleName;

});
parcelRegister("3TPjV", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ var $2d6e514d2e9cd65b$var$_hyphenPattern = /-(.)/g;
/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */ function $2d6e514d2e9cd65b$var$camelize(string) {
    return string.replace($2d6e514d2e9cd65b$var$_hyphenPattern, function(_, character) {
        return character.toUpperCase();
    });
}
module.exports = $2d6e514d2e9cd65b$var$camelize;

});


parcelRegister("dClcE", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $bf8Yh = parcelRequire("bf8Yh");
parcelRequire("fIzgz");
var $9e9f4572bc94fcb9$var$isUnitlessNumber = $bf8Yh.isUnitlessNumber;
var $9e9f4572bc94fcb9$var$styleWarnings = {};
/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */ function $9e9f4572bc94fcb9$var$dangerousStyleValue(name, value, component, isCustomProperty) {
    // Note that we've removed escapeTextForBrowser() calls here since the
    // whole string will be escaped when the attribute is injected into
    // the markup. If you provide unsafe user data here they can inject
    // arbitrary CSS which may be problematic (I couldn't repro this):
    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
    // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
    // This is not an XSS hole but instead a potential CSS injection issue
    // which has lead to a greater discussion about how we're going to
    // trust URLs moving forward. See #2115901
    var isEmpty = value == null || typeof value === "boolean" || value === "";
    if (isEmpty) return "";
    var isNonNumeric = isNaN(value);
    if (isCustomProperty || isNonNumeric || value === 0 || $9e9f4572bc94fcb9$var$isUnitlessNumber.hasOwnProperty(name) && $9e9f4572bc94fcb9$var$isUnitlessNumber[name]) return "" + value; // cast to string
    if (typeof value === "string") {
        var owner, ownerName, warned, warnings;
        value = value.trim();
    }
    return value + "px";
}
module.exports = $9e9f4572bc94fcb9$var$dangerousStyleValue;

});

parcelRegister("bIbM4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ "use strict";

var $4OTlY = parcelRequire("4OTlY");
var $886cefecb2dd7140$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $886cefecb2dd7140$var$hyphenateStyleName(string) {
    return $4OTlY(string).replace($886cefecb2dd7140$var$msPattern, "-ms-");
}
module.exports = $886cefecb2dd7140$var$hyphenateStyleName;

});
parcelRegister("4OTlY", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ var $3826c4f3cfef155c$var$_uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */ function $3826c4f3cfef155c$var$hyphenate(string) {
    return string.replace($3826c4f3cfef155c$var$_uppercasePattern, "-$1").toLowerCase();
}
module.exports = $3826c4f3cfef155c$var$hyphenate;

});


parcelRegister("fq20v", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */ "use strict";
/**
 * Memoizes the return value of a function that accepts one string argument.
 */ function $b39ad749f16c3770$var$memoizeStringOnly(callback) {
    var cache = {};
    return function(string) {
        if (!cache.hasOwnProperty(string)) cache[string] = callback.call(this, string);
        return cache[string];
    };
}
module.exports = $b39ad749f16c3770$var$memoizeStringOnly;

});


parcelRegister("jQzHJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $Uj2z8 = parcelRequire("Uj2z8");
parcelRequire("5fGpM");
parcelRequire("d1IRY");

var $73r0l = parcelRequire("73r0l");
parcelRequire("fIzgz");
var $e72e91c798f3d44f$var$VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + $Uj2z8.ATTRIBUTE_NAME_START_CHAR + "][" + $Uj2z8.ATTRIBUTE_NAME_CHAR + "]*$");
var $e72e91c798f3d44f$var$illegalAttributeNameCache = {};
var $e72e91c798f3d44f$var$validatedAttributeNameCache = {};
function $e72e91c798f3d44f$var$isAttributeNameSafe(attributeName) {
    if ($e72e91c798f3d44f$var$validatedAttributeNameCache.hasOwnProperty(attributeName)) return true;
    if ($e72e91c798f3d44f$var$illegalAttributeNameCache.hasOwnProperty(attributeName)) return false;
    if ($e72e91c798f3d44f$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
        $e72e91c798f3d44f$var$validatedAttributeNameCache[attributeName] = true;
        return true;
    }
    $e72e91c798f3d44f$var$illegalAttributeNameCache[attributeName] = true;
    return false;
}
function $e72e91c798f3d44f$var$shouldIgnoreValue(propertyInfo, value) {
    return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}
/**
 * Operations for dealing with DOM properties.
 */ var $e72e91c798f3d44f$var$DOMPropertyOperations = {
    /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */ createMarkupForID: function(id) {
        return $Uj2z8.ID_ATTRIBUTE_NAME + "=" + $73r0l(id);
    },
    setAttributeForID: function(node, id) {
        node.setAttribute($Uj2z8.ID_ATTRIBUTE_NAME, id);
    },
    createMarkupForRoot: function() {
        return $Uj2z8.ROOT_ATTRIBUTE_NAME + '=""';
    },
    setAttributeForRoot: function(node) {
        node.setAttribute($Uj2z8.ROOT_ATTRIBUTE_NAME, "");
    },
    /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */ createMarkupForProperty: function(name, value) {
        var propertyInfo = $Uj2z8.properties.hasOwnProperty(name) ? $Uj2z8.properties[name] : null;
        if (propertyInfo) {
            if ($e72e91c798f3d44f$var$shouldIgnoreValue(propertyInfo, value)) return "";
            var attributeName = propertyInfo.attributeName;
            if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) return attributeName + '=""';
            return attributeName + "=" + $73r0l(value);
        } else if ($Uj2z8.isCustomAttribute(name)) {
            if (value == null) return "";
            return name + "=" + $73r0l(value);
        }
        return null;
    },
    /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */ createMarkupForCustomAttribute: function(name, value) {
        if (!$e72e91c798f3d44f$var$isAttributeNameSafe(name) || value == null) return "";
        return name + "=" + $73r0l(value);
    },
    /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */ setValueForProperty: function(node, name, value) {
        var propertyInfo = $Uj2z8.properties.hasOwnProperty(name) ? $Uj2z8.properties[name] : null;
        if (propertyInfo) {
            var mutationMethod = propertyInfo.mutationMethod;
            if (mutationMethod) mutationMethod(node, value);
            else if ($e72e91c798f3d44f$var$shouldIgnoreValue(propertyInfo, value)) {
                this.deleteValueForProperty(node, name);
                return;
            } else if (propertyInfo.mustUseProperty) // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyInfo.propertyName] = value;
            else {
                var attributeName = propertyInfo.attributeName;
                var namespace = propertyInfo.attributeNamespace;
                // `setAttribute` with objects becomes only `[object]` in IE8/9,
                // ('' + value) makes it output the correct toString()-value.
                if (namespace) node.setAttributeNS(namespace, attributeName, "" + value);
                else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) node.setAttribute(attributeName, "");
                else node.setAttribute(attributeName, "" + value);
            }
        } else if ($Uj2z8.isCustomAttribute(name)) {
            $e72e91c798f3d44f$var$DOMPropertyOperations.setValueForAttribute(node, name, value);
            return;
        }
        var payload;
    },
    setValueForAttribute: function(node, name, value) {
        if (!$e72e91c798f3d44f$var$isAttributeNameSafe(name)) return;
        if (value == null) node.removeAttribute(name);
        else node.setAttribute(name, "" + value);
        var payload;
    },
    /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */ deleteValueForAttribute: function(node, name) {
        node.removeAttribute(name);
    },
    /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */ deleteValueForProperty: function(node, name) {
        var propertyInfo = $Uj2z8.properties.hasOwnProperty(name) ? $Uj2z8.properties[name] : null;
        if (propertyInfo) {
            var mutationMethod = propertyInfo.mutationMethod;
            if (mutationMethod) mutationMethod(node, undefined);
            else if (propertyInfo.mustUseProperty) {
                var propName = propertyInfo.propertyName;
                if (propertyInfo.hasBooleanValue) node[propName] = false;
                else node[propName] = "";
            } else node.removeAttribute(propertyInfo.attributeName);
        } else if ($Uj2z8.isCustomAttribute(name)) node.removeAttribute(name);
    }
};
module.exports = $e72e91c798f3d44f$var$DOMPropertyOperations;

});
parcelRegister("73r0l", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $8i9tX = parcelRequire("8i9tX");
/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */ function $522dc2bce4b9c3bc$var$quoteAttributeValueForBrowser(value) {
    return '"' + $8i9tX(value) + '"';
}
module.exports = $522dc2bce4b9c3bc$var$quoteAttributeValueForBrowser;

});


parcelRegister("jugFn", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $a6S4T = parcelRequire("a6S4T");

var $6cytr = parcelRequire("6cytr");

var $iRAHA = parcelRequire("iRAHA");

var $cPu0Q = parcelRequire("cPu0Q");

var $crOej = parcelRequire("crOej");

var $7yqoI = parcelRequire("7yqoI");
/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */ var $e2fdbf3f92af2b07$var$hasEventPageXY;
var $e2fdbf3f92af2b07$var$alreadyListeningTo = {};
var $e2fdbf3f92af2b07$var$isMonitoringScrollValue = false;
var $e2fdbf3f92af2b07$var$reactTopListenersCounter = 0;
// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var $e2fdbf3f92af2b07$var$topEventMapping = {
    topAbort: "abort",
    topAnimationEnd: $crOej("animationend") || "animationend",
    topAnimationIteration: $crOej("animationiteration") || "animationiteration",
    topAnimationStart: $crOej("animationstart") || "animationstart",
    topBlur: "blur",
    topCanPlay: "canplay",
    topCanPlayThrough: "canplaythrough",
    topChange: "change",
    topClick: "click",
    topCompositionEnd: "compositionend",
    topCompositionStart: "compositionstart",
    topCompositionUpdate: "compositionupdate",
    topContextMenu: "contextmenu",
    topCopy: "copy",
    topCut: "cut",
    topDoubleClick: "dblclick",
    topDrag: "drag",
    topDragEnd: "dragend",
    topDragEnter: "dragenter",
    topDragExit: "dragexit",
    topDragLeave: "dragleave",
    topDragOver: "dragover",
    topDragStart: "dragstart",
    topDrop: "drop",
    topDurationChange: "durationchange",
    topEmptied: "emptied",
    topEncrypted: "encrypted",
    topEnded: "ended",
    topError: "error",
    topFocus: "focus",
    topInput: "input",
    topKeyDown: "keydown",
    topKeyPress: "keypress",
    topKeyUp: "keyup",
    topLoadedData: "loadeddata",
    topLoadedMetadata: "loadedmetadata",
    topLoadStart: "loadstart",
    topMouseDown: "mousedown",
    topMouseMove: "mousemove",
    topMouseOut: "mouseout",
    topMouseOver: "mouseover",
    topMouseUp: "mouseup",
    topPaste: "paste",
    topPause: "pause",
    topPlay: "play",
    topPlaying: "playing",
    topProgress: "progress",
    topRateChange: "ratechange",
    topScroll: "scroll",
    topSeeked: "seeked",
    topSeeking: "seeking",
    topSelectionChange: "selectionchange",
    topStalled: "stalled",
    topSuspend: "suspend",
    topTextInput: "textInput",
    topTimeUpdate: "timeupdate",
    topTouchCancel: "touchcancel",
    topTouchEnd: "touchend",
    topTouchMove: "touchmove",
    topTouchStart: "touchstart",
    topTransitionEnd: $crOej("transitionend") || "transitionend",
    topVolumeChange: "volumechange",
    topWaiting: "waiting",
    topWheel: "wheel"
};
/**
 * To ensure no conflicts with other potential React instances on the page
 */ var $e2fdbf3f92af2b07$var$topListenersIDKey = "_reactListenersID" + String(Math.random()).slice(2);
function $e2fdbf3f92af2b07$var$getListeningForDocument(mountAt) {
    // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
    // directly.
    if (!Object.prototype.hasOwnProperty.call(mountAt, $e2fdbf3f92af2b07$var$topListenersIDKey)) {
        mountAt[$e2fdbf3f92af2b07$var$topListenersIDKey] = $e2fdbf3f92af2b07$var$reactTopListenersCounter++;
        $e2fdbf3f92af2b07$var$alreadyListeningTo[mountAt[$e2fdbf3f92af2b07$var$topListenersIDKey]] = {};
    }
    return $e2fdbf3f92af2b07$var$alreadyListeningTo[mountAt[$e2fdbf3f92af2b07$var$topListenersIDKey]];
}
/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */ var $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter = $a6S4T({}, $iRAHA, {
    /**
   * Injectable event backend
   */ ReactEventListener: null,
    injection: {
        /**
     * @param {object} ReactEventListener
     */ injectReactEventListener: function(ReactEventListener) {
            ReactEventListener.setHandleTopLevel($e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.handleTopLevel);
            $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
        }
    },
    /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */ setEnabled: function(enabled) {
        if ($e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener) $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    },
    /**
   * @return {boolean} True if callbacks are enabled.
   */ isEnabled: function() {
        return !!($e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener && $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.isEnabled());
    },
    /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */ listenTo: function(registrationName, contentDocumentHandle) {
        var mountAt = contentDocumentHandle;
        var isListening = $e2fdbf3f92af2b07$var$getListeningForDocument(mountAt);
        var dependencies = $6cytr.registrationNameDependencies[registrationName];
        for(var i = 0; i < dependencies.length; i++){
            var dependency = dependencies[i];
            if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
                if (dependency === "topWheel") {
                    if ($7yqoI("wheel")) $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent("topWheel", "wheel", mountAt);
                    else if ($7yqoI("mousewheel")) $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent("topWheel", "mousewheel", mountAt);
                    else // Firefox needs to capture a different mouse scroll event.
                    // @see http://www.quirksmode.org/dom/events/tests/scroll.html
                    $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent("topWheel", "DOMMouseScroll", mountAt);
                } else if (dependency === "topScroll") {
                    if ($7yqoI("scroll", true)) $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent("topScroll", "scroll", mountAt);
                    else $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent("topScroll", "scroll", $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
                } else if (dependency === "topFocus" || dependency === "topBlur") {
                    if ($7yqoI("focus", true)) {
                        $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent("topFocus", "focus", mountAt);
                        $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent("topBlur", "blur", mountAt);
                    } else if ($7yqoI("focusin")) {
                        // IE has `focusin` and `focusout` events which bubble.
                        // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
                        $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent("topFocus", "focusin", mountAt);
                        $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent("topBlur", "focusout", mountAt);
                    }
                    // to make sure blur and focus event listeners are only attached once
                    isListening.topBlur = true;
                    isListening.topFocus = true;
                } else if ($e2fdbf3f92af2b07$var$topEventMapping.hasOwnProperty(dependency)) $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, $e2fdbf3f92af2b07$var$topEventMapping[dependency], mountAt);
                isListening[dependency] = true;
            }
        }
    },
    trapBubbledEvent: function(topLevelType, handlerBaseName, handle) {
        return $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
    },
    trapCapturedEvent: function(topLevelType, handlerBaseName, handle) {
        return $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
    },
    /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */ supportsEventPageXY: function() {
        if (!document.createEvent) return false;
        var ev = document.createEvent("MouseEvent");
        return ev != null && "pageX" in ev;
    },
    /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */ ensureScrollValueMonitoring: function() {
        if ($e2fdbf3f92af2b07$var$hasEventPageXY === undefined) $e2fdbf3f92af2b07$var$hasEventPageXY = $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.supportsEventPageXY();
        if (!$e2fdbf3f92af2b07$var$hasEventPageXY && !$e2fdbf3f92af2b07$var$isMonitoringScrollValue) {
            var refresh = $cPu0Q.refreshScrollValues;
            $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
            $e2fdbf3f92af2b07$var$isMonitoringScrollValue = true;
        }
    }
});
module.exports = $e2fdbf3f92af2b07$var$ReactBrowserEventEmitter;

});
parcelRegister("iRAHA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $53teI = parcelRequire("53teI");
function $dbb9a57bb5c61dbb$var$runEventQueueInBatch(events) {
    $53teI.enqueueEvents(events);
    $53teI.processEventQueue(false);
}
var $dbb9a57bb5c61dbb$var$ReactEventEmitterMixin = {
    /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */ handleTopLevel: function(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        var events = $53teI.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        $dbb9a57bb5c61dbb$var$runEventQueueInBatch(events);
    }
};
module.exports = $dbb9a57bb5c61dbb$var$ReactEventEmitterMixin;

});

parcelRegister("crOej", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $kx286 = parcelRequire("kx286");
/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function $90fef8439c7b8a37$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    prefixes["ms" + styleProp] = "MS" + eventName;
    prefixes["O" + styleProp] = "o" + eventName.toLowerCase();
    return prefixes;
}
/**
 * A list of event names to a configurable list of vendor prefixes.
 */ var $90fef8439c7b8a37$var$vendorPrefixes = {
    animationend: $90fef8439c7b8a37$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $90fef8439c7b8a37$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $90fef8439c7b8a37$var$makePrefixMap("Animation", "AnimationStart"),
    transitionend: $90fef8439c7b8a37$var$makePrefixMap("Transition", "TransitionEnd")
};
/**
 * Event names that have already been detected and prefixed (if applicable).
 */ var $90fef8439c7b8a37$var$prefixedEventNames = {};
/**
 * Element to check for prefixes on.
 */ var $90fef8439c7b8a37$var$style = {};
/**
 * Bootstrap if a DOM exists.
 */ if ($kx286.canUseDOM) {
    $90fef8439c7b8a37$var$style = document.createElement("div").style;
    // On some platforms, in particular some releases of Android 4.x,
    // the un-prefixed "animation" and "transition" properties are defined on the
    // style object but the events that fire will still be prefixed, so we need
    // to check if the un-prefixed events are usable, and if not remove them from the map.
    if (!("AnimationEvent" in window)) {
        delete $90fef8439c7b8a37$var$vendorPrefixes.animationend.animation;
        delete $90fef8439c7b8a37$var$vendorPrefixes.animationiteration.animation;
        delete $90fef8439c7b8a37$var$vendorPrefixes.animationstart.animation;
    }
    // Same as above
    if (!("TransitionEvent" in window)) delete $90fef8439c7b8a37$var$vendorPrefixes.transitionend.transition;
}
/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function $90fef8439c7b8a37$var$getVendorPrefixedEventName(eventName) {
    if ($90fef8439c7b8a37$var$prefixedEventNames[eventName]) return $90fef8439c7b8a37$var$prefixedEventNames[eventName];
    else if (!$90fef8439c7b8a37$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $90fef8439c7b8a37$var$vendorPrefixes[eventName];
    for(var styleProp in prefixMap){
        if (prefixMap.hasOwnProperty(styleProp) && styleProp in $90fef8439c7b8a37$var$style) return $90fef8439c7b8a37$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    }
    return "";
}
module.exports = $90fef8439c7b8a37$var$getVendorPrefixedEventName;

});


parcelRegister("6WA5t", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $a6S4T = parcelRequire("a6S4T");

var $jQzHJ = parcelRequire("jQzHJ");

var $32YhR = parcelRequire("32YhR");

var $5fGpM = parcelRequire("5fGpM");

var $gDXrr = parcelRequire("gDXrr");
parcelRequire("4Mb5c");
parcelRequire("fIzgz");
var $50e4270afd3eb5e5$var$didWarnValueLink = false;
var $50e4270afd3eb5e5$var$didWarnCheckedLink = false;
var $50e4270afd3eb5e5$var$didWarnValueDefaultValue = false;
var $50e4270afd3eb5e5$var$didWarnCheckedDefaultChecked = false;
var $50e4270afd3eb5e5$var$didWarnControlledToUncontrolled = false;
var $50e4270afd3eb5e5$var$didWarnUncontrolledToControlled = false;
function $50e4270afd3eb5e5$var$forceUpdateIfMounted() {
    if (this._rootNodeID) // DOM component is still mounted; update
    $50e4270afd3eb5e5$var$ReactDOMInput.updateWrapper(this);
}
function $50e4270afd3eb5e5$var$isControlled(props) {
    var usesChecked = props.type === "checkbox" || props.type === "radio";
    return usesChecked ? props.checked != null : props.value != null;
}
/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ var $50e4270afd3eb5e5$var$ReactDOMInput = {
    getHostProps: function(inst, props) {
        var value = $32YhR.getValue(props);
        var checked = $32YhR.getChecked(props);
        var hostProps = $a6S4T({
            // Make sure we set .type before any other properties (setting .value
            // before .type means .value is lost in IE11 and below)
            type: undefined,
            // Make sure we set .step before .value (setting .value before .step
            // means .value is rounded on mount, based upon step precision)
            step: undefined,
            // Make sure we set .min & .max before .value (to ensure proper order
            // in corner cases such as min or max deriving from value, e.g. Issue #7170)
            min: undefined,
            max: undefined
        }, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: value != null ? value : inst._wrapperState.initialValue,
            checked: checked != null ? checked : inst._wrapperState.initialChecked,
            onChange: inst._wrapperState.onChange
        });
        return hostProps;
    },
    mountWrapper: function(inst, props) {
        var owner;
        var defaultValue = props.defaultValue;
        inst._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: props.value != null ? props.value : defaultValue,
            listeners: null,
            onChange: $50e4270afd3eb5e5$var$_handleChange.bind(inst),
            controlled: $50e4270afd3eb5e5$var$isControlled(props)
        };
    },
    updateWrapper: function(inst) {
        var props = inst._currentElement.props;
        var controlled, owner;
        // TODO: Shouldn't this be getChecked(props)?
        var checked = props.checked;
        if (checked != null) $jQzHJ.setValueForProperty($5fGpM.getNodeFromInstance(inst), "checked", checked || false);
        var node = $5fGpM.getNodeFromInstance(inst);
        var value = $32YhR.getValue(props);
        if (value != null) {
            if (value === 0 && node.value === "") node.value = "0";
            else if (props.type === "number") {
                // Simulate `input.valueAsNumber`. IE9 does not support it
                var valueAsNumber = parseFloat(node.value, 10) || 0;
                if (// eslint-disable-next-line
                value != valueAsNumber || // eslint-disable-next-line
                value == valueAsNumber && node.value != value) // Cast `value` to a string to ensure the value is set correctly. While
                // browsers typically do this as necessary, jsdom doesn't.
                node.value = "" + value;
            } else if (node.value !== "" + value) // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            node.value = "" + value;
        } else {
            if (props.value == null && props.defaultValue != null) // In Chrome, assigning defaultValue to certain input types triggers input validation.
            // For number inputs, the display value loses trailing decimal points. For email inputs,
            // Chrome raises "The specified value <x> is not a valid email address".
            //
            // Here we check to see if the defaultValue has actually changed, avoiding these problems
            // when the user is inputting text
            //
            // https://github.com/facebook/react/issues/7253
            {
                if (node.defaultValue !== "" + props.defaultValue) node.defaultValue = "" + props.defaultValue;
            }
            if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
        }
    },
    postMountWrapper: function(inst) {
        var props = inst._currentElement.props;
        // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var node = $5fGpM.getNodeFromInstance(inst);
        // Detach value from defaultValue. We won't do anything if we're working on
        // submit or reset inputs as those values & defaultValues are linked. They
        // are not resetable nodes so this operation doesn't matter and actually
        // removes browser-default values (eg "Submit Query") when no value is
        // provided.
        switch(props.type){
            case "submit":
            case "reset":
                break;
            case "color":
            case "date":
            case "datetime":
            case "datetime-local":
            case "month":
            case "time":
            case "week":
                // This fixes the no-show issue on iOS Safari and Android Chrome:
                // https://github.com/facebook/react/issues/7233
                node.value = "";
                node.value = node.defaultValue;
                break;
            default:
                node.value = node.value;
                break;
        }
        // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !node.defaultChecked;
        if (name !== "") node.name = name;
    }
};
function $50e4270afd3eb5e5$var$_handleChange(event) {
    var props = this._currentElement.props;
    var returnValue = $32YhR.executeOnChange(props, event);
    // Here we use asap to wait until all updates have propagated, which
    // is important when using controlled components within layers:
    // https://github.com/facebook/react/issues/1698
    $gDXrr.asap($50e4270afd3eb5e5$var$forceUpdateIfMounted, this);
    var name = props.name;
    if (props.type === "radio" && name != null) {
        var rootNode = $5fGpM.getNodeFromInstance(this);
        var queryRoot = rootNode;
        while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
        // If `rootNode.form` was non-null, then we could try `form.elements`,
        // but that sometimes behaves strangely in IE8. We could also try using
        // `form.getElementsByName`, but that will only return direct children
        // and won't include inputs that use the HTML5 `form=` attribute. Since
        // the input might not even be in a form, let's just use the global
        // `querySelectorAll` to ensure we don't miss anything.
        var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
        for(var i = 0; i < group.length; i++){
            var otherNode = group[i];
            if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
            // This will throw if radio buttons rendered by different copies of React
            // and the same name are rendered into the same form (same as #1939).
            // That's probably okay; we don't support it just as we don't support
            // mixing React radio buttons with non-React ones.
            var otherInstance = $5fGpM.getInstanceFromNode(otherNode);
            !otherInstance && $jOpPq("90");
            // If this is a controlled radio button group, forcing the input that
            // was previously checked to update will cause it to be come re-checked
            // as appropriate.
            $gDXrr.asap($50e4270afd3eb5e5$var$forceUpdateIfMounted, otherInstance);
        }
    }
    return returnValue;
}
module.exports = $50e4270afd3eb5e5$var$ReactDOMInput;

});
parcelRegister("32YhR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $44sfv = parcelRequire("44sfv");

var $iOcyt = parcelRequire("iOcyt");

var $eW0mB = parcelRequire("eW0mB");
var $238052bea6e2b62c$var$PropTypes = $iOcyt($eW0mB.isValidElement);
parcelRequire("4Mb5c");
parcelRequire("fIzgz");
var $238052bea6e2b62c$var$hasReadOnlyValue = {
    button: true,
    checkbox: true,
    image: true,
    hidden: true,
    radio: true,
    reset: true,
    submit: true
};
function $238052bea6e2b62c$var$_assertSingleLink(inputProps) {
    !(inputProps.checkedLink == null || inputProps.valueLink == null) && $jOpPq("87");
}
function $238052bea6e2b62c$var$_assertValueLink(inputProps) {
    $238052bea6e2b62c$var$_assertSingleLink(inputProps);
    !(inputProps.value == null && inputProps.onChange == null) && $jOpPq("88");
}
function $238052bea6e2b62c$var$_assertCheckedLink(inputProps) {
    $238052bea6e2b62c$var$_assertSingleLink(inputProps);
    !(inputProps.checked == null && inputProps.onChange == null) && $jOpPq("89");
}
var $238052bea6e2b62c$var$propTypes = {
    value: function(props, propName, componentName) {
        if (!props[propName] || $238052bea6e2b62c$var$hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) return null;
        return new Error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
    },
    checked: function(props, propName, componentName) {
        if (!props[propName] || props.onChange || props.readOnly || props.disabled) return null;
        return new Error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    },
    onChange: $238052bea6e2b62c$var$PropTypes.func
};
var $238052bea6e2b62c$var$loggedTypeFailures = {};
function $238052bea6e2b62c$var$getDeclarationErrorAddendum(owner) {
    if (owner) {
        var name = owner.getName();
        if (name) return " Check the render method of `" + name + "`.";
    }
    return "";
}
/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */ var $238052bea6e2b62c$var$LinkedValueUtils = {
    checkPropTypes: function(tagName, props, owner) {
        for(var propName in $238052bea6e2b62c$var$propTypes){
            if ($238052bea6e2b62c$var$propTypes.hasOwnProperty(propName)) var error = $238052bea6e2b62c$var$propTypes[propName](props, propName, tagName, "prop", null, $44sfv);
            if (error instanceof Error && !(error.message in $238052bea6e2b62c$var$loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                $238052bea6e2b62c$var$loggedTypeFailures[error.message] = true;
                var addendum = $238052bea6e2b62c$var$getDeclarationErrorAddendum(owner);
            }
        }
    },
    /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */ getValue: function(inputProps) {
        if (inputProps.valueLink) {
            $238052bea6e2b62c$var$_assertValueLink(inputProps);
            return inputProps.valueLink.value;
        }
        return inputProps.value;
    },
    /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */ getChecked: function(inputProps) {
        if (inputProps.checkedLink) {
            $238052bea6e2b62c$var$_assertCheckedLink(inputProps);
            return inputProps.checkedLink.value;
        }
        return inputProps.checked;
    },
    /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */ executeOnChange: function(inputProps, event) {
        if (inputProps.valueLink) {
            $238052bea6e2b62c$var$_assertValueLink(inputProps);
            return inputProps.valueLink.requestChange(event.target.value);
        } else if (inputProps.checkedLink) {
            $238052bea6e2b62c$var$_assertCheckedLink(inputProps);
            return inputProps.checkedLink.requestChange(event.target.checked);
        } else if (inputProps.onChange) return inputProps.onChange.call(undefined, event);
    }
};
module.exports = $238052bea6e2b62c$var$LinkedValueUtils;

});
parcelRegister("44sfv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
var $2f6d72d941228a3f$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $2f6d72d941228a3f$var$ReactPropTypesSecret;

});



parcelRegister("cQDh1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $a6S4T = parcelRequire("a6S4T");

var $eW0mB = parcelRequire("eW0mB");

var $5fGpM = parcelRequire("5fGpM");

var $k7YMG = parcelRequire("k7YMG");
parcelRequire("fIzgz");
var $95a8ce437d8ec456$var$didWarnInvalidOptionChildren = false;
function $95a8ce437d8ec456$var$flattenChildren(children) {
    var content = "";
    // Flatten children and warn if they aren't strings or numbers;
    // invalid types are ignored.
    $eW0mB.Children.forEach(children, function(child) {
        if (child == null) return;
        if (typeof child === "string" || typeof child === "number") content += child;
        else if (!$95a8ce437d8ec456$var$didWarnInvalidOptionChildren) $95a8ce437d8ec456$var$didWarnInvalidOptionChildren = true;
    });
    return content;
}
/**
 * Implements an <option> host component that warns when `selected` is set.
 */ var $95a8ce437d8ec456$var$ReactDOMOption = {
    mountWrapper: function(inst, props, hostParent) {
        // Look up whether this option is 'selected'
        var selectValue = null;
        if (hostParent != null) {
            var selectParent = hostParent;
            if (selectParent._tag === "optgroup") selectParent = selectParent._hostParent;
            if (selectParent != null && selectParent._tag === "select") selectValue = $k7YMG.getSelectValueContext(selectParent);
        }
        // If the value is null (e.g., no specified value or after initial mount)
        // or missing (e.g., for <datalist>), we don't change props.selected
        var selected = null;
        if (selectValue != null) {
            var value;
            if (props.value != null) value = props.value + "";
            else value = $95a8ce437d8ec456$var$flattenChildren(props.children);
            selected = false;
            if (Array.isArray(selectValue)) {
                // multiple
                for(var i = 0; i < selectValue.length; i++)if ("" + selectValue[i] === value) {
                    selected = true;
                    break;
                }
            } else selected = "" + selectValue === value;
        }
        inst._wrapperState = {
            selected: selected
        };
    },
    postMountWrapper: function(inst) {
        // value="" should make a value attribute (#6219)
        var props = inst._currentElement.props;
        if (props.value != null) {
            var node = $5fGpM.getNodeFromInstance(inst);
            node.setAttribute("value", props.value);
        }
    },
    getHostProps: function(inst, props) {
        var hostProps = $a6S4T({
            selected: undefined,
            children: undefined
        }, props);
        // Read state only from initial mount because <select> updates value
        // manually; we need the initial state only for server rendering
        if (inst._wrapperState.selected != null) hostProps.selected = inst._wrapperState.selected;
        var content = $95a8ce437d8ec456$var$flattenChildren(props.children);
        if (content) hostProps.children = content;
        return hostProps;
    }
};
module.exports = $95a8ce437d8ec456$var$ReactDOMOption;

});
parcelRegister("k7YMG", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $a6S4T = parcelRequire("a6S4T");

var $32YhR = parcelRequire("32YhR");

var $5fGpM = parcelRequire("5fGpM");

var $gDXrr = parcelRequire("gDXrr");
parcelRequire("fIzgz");
var $ea739c95c592f1f9$var$didWarnValueLink = false;
var $ea739c95c592f1f9$var$didWarnValueDefaultValue = false;
function $ea739c95c592f1f9$var$updateOptionsIfPendingUpdateAndMounted() {
    if (this._rootNodeID && this._wrapperState.pendingUpdate) {
        this._wrapperState.pendingUpdate = false;
        var props = this._currentElement.props;
        var value = $32YhR.getValue(props);
        if (value != null) $ea739c95c592f1f9$var$updateOptions(this, Boolean(props.multiple), value);
    }
}
function $ea739c95c592f1f9$var$getDeclarationErrorAddendum(owner) {
    if (owner) {
        var name = owner.getName();
        if (name) return " Check the render method of `" + name + "`.";
    }
    return "";
}
var $ea739c95c592f1f9$var$valuePropNames = [
    "value",
    "defaultValue"
];
/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */ function $ea739c95c592f1f9$var$checkSelectPropTypes(inst, props) {
    var owner = inst._currentElement._owner;
    $32YhR.checkPropTypes("select", props, owner);
    if (props.valueLink !== undefined && !$ea739c95c592f1f9$var$didWarnValueLink) $ea739c95c592f1f9$var$didWarnValueLink = true;
    for(var i = 0; i < $ea739c95c592f1f9$var$valuePropNames.length; i++){
        var propName = $ea739c95c592f1f9$var$valuePropNames[i];
        if (props[propName] == null) continue;
        var isArray = Array.isArray(props[propName]);
        if (props.multiple && !isArray) ;
        else !props.multiple && isArray;
    }
}
/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */ function $ea739c95c592f1f9$var$updateOptions(inst, multiple, propValue) {
    var selectedValue, i;
    var options = $5fGpM.getNodeFromInstance(inst).options;
    if (multiple) {
        selectedValue = {};
        for(i = 0; i < propValue.length; i++)selectedValue["" + propValue[i]] = true;
        for(i = 0; i < options.length; i++){
            var selected = selectedValue.hasOwnProperty(options[i].value);
            if (options[i].selected !== selected) options[i].selected = selected;
        }
    } else {
        // Do not set `select.value` as exact behavior isn't consistent across all
        // browsers for all cases.
        selectedValue = "" + propValue;
        for(i = 0; i < options.length; i++)if (options[i].value === selectedValue) {
            options[i].selected = true;
            return;
        }
        if (options.length) options[0].selected = true;
    }
}
/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ var $ea739c95c592f1f9$var$ReactDOMSelect = {
    getHostProps: function(inst, props) {
        return $a6S4T({}, props, {
            onChange: inst._wrapperState.onChange,
            value: undefined
        });
    },
    mountWrapper: function(inst, props) {
        var value = $32YhR.getValue(props);
        inst._wrapperState = {
            pendingUpdate: false,
            initialValue: value != null ? value : props.defaultValue,
            listeners: null,
            onChange: $ea739c95c592f1f9$var$_handleChange.bind(inst),
            wasMultiple: Boolean(props.multiple)
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !$ea739c95c592f1f9$var$didWarnValueDefaultValue) $ea739c95c592f1f9$var$didWarnValueDefaultValue = true;
    },
    getSelectValueContext: function(inst) {
        // ReactDOMOption looks at this initial value so the initial generated
        // markup has correct `selected` attributes
        return inst._wrapperState.initialValue;
    },
    postUpdateWrapper: function(inst) {
        var props = inst._currentElement.props;
        // After the initial mount, we control selected-ness manually so don't pass
        // this value down
        inst._wrapperState.initialValue = undefined;
        var wasMultiple = inst._wrapperState.wasMultiple;
        inst._wrapperState.wasMultiple = Boolean(props.multiple);
        var value = $32YhR.getValue(props);
        if (value != null) {
            inst._wrapperState.pendingUpdate = false;
            $ea739c95c592f1f9$var$updateOptions(inst, Boolean(props.multiple), value);
        } else if (wasMultiple !== Boolean(props.multiple)) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) $ea739c95c592f1f9$var$updateOptions(inst, Boolean(props.multiple), props.defaultValue);
            else // Revert the select back to its default unselected state.
            $ea739c95c592f1f9$var$updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : "");
        }
    }
};
function $ea739c95c592f1f9$var$_handleChange(event) {
    var props = this._currentElement.props;
    var returnValue = $32YhR.executeOnChange(props, event);
    if (this._rootNodeID) this._wrapperState.pendingUpdate = true;
    $gDXrr.asap($ea739c95c592f1f9$var$updateOptionsIfPendingUpdateAndMounted, this);
    return returnValue;
}
module.exports = $ea739c95c592f1f9$var$ReactDOMSelect;

});


parcelRegister("2EDkc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $a6S4T = parcelRequire("a6S4T");

var $32YhR = parcelRequire("32YhR");

var $5fGpM = parcelRequire("5fGpM");

var $gDXrr = parcelRequire("gDXrr");
parcelRequire("4Mb5c");
parcelRequire("fIzgz");
var $1eedd2446bf8ad59$var$didWarnValueLink = false;
var $1eedd2446bf8ad59$var$didWarnValDefaultVal = false;
function $1eedd2446bf8ad59$var$forceUpdateIfMounted() {
    if (this._rootNodeID) // DOM component is still mounted; update
    $1eedd2446bf8ad59$var$ReactDOMTextarea.updateWrapper(this);
}
/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ var $1eedd2446bf8ad59$var$ReactDOMTextarea = {
    getHostProps: function(inst, props) {
        !(props.dangerouslySetInnerHTML == null) && $jOpPq("91");
        // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
        // The value can be a boolean or object so that's why it's forced to be a string.
        var hostProps = $a6S4T({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: "" + inst._wrapperState.initialValue,
            onChange: inst._wrapperState.onChange
        });
        return hostProps;
    },
    mountWrapper: function(inst, props) {
        var value = $32YhR.getValue(props);
        var initialValue = value;
        // Only bother fetching default value if we're going to use it
        if (value == null) {
            var defaultValue = props.defaultValue;
            // TODO (yungsters): Remove support for children content in <textarea>.
            var children = props.children;
            if (children != null) {
                !(defaultValue == null) && $jOpPq("92");
                if (Array.isArray(children)) {
                    !(children.length <= 1) && $jOpPq("93");
                    children = children[0];
                }
                defaultValue = "" + children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        inst._wrapperState = {
            initialValue: "" + initialValue,
            listeners: null,
            onChange: $1eedd2446bf8ad59$var$_handleChange.bind(inst)
        };
    },
    updateWrapper: function(inst) {
        var props = inst._currentElement.props;
        var node = $5fGpM.getNodeFromInstance(inst);
        var value = $32YhR.getValue(props);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = "" + value;
            // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null) node.defaultValue = newValue;
        }
        if (props.defaultValue != null) node.defaultValue = props.defaultValue;
    },
    postMountWrapper: function(inst) {
        // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var node = $5fGpM.getNodeFromInstance(inst);
        var textContent = node.textContent;
        // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === inst._wrapperState.initialValue) node.value = textContent;
    }
};
function $1eedd2446bf8ad59$var$_handleChange(event) {
    var props = this._currentElement.props;
    var returnValue = $32YhR.executeOnChange(props, event);
    $gDXrr.asap($1eedd2446bf8ad59$var$forceUpdateIfMounted, this);
    return returnValue;
}
module.exports = $1eedd2446bf8ad59$var$ReactDOMTextarea;

});

parcelRegister("jkvXw", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $cpJSD = parcelRequire("cpJSD");
parcelRequire("adVZ1");
parcelRequire("d1IRY");
parcelRequire("6qU6G");

var $5Kdrw = parcelRequire("5Kdrw");

var $kZ9Tt = parcelRequire("kZ9Tt");

var $46CSh = parcelRequire("46CSh");

var $hXtoY = parcelRequire("hXtoY");
parcelRequire("4Mb5c");
/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */ function $e128acf76b2514b0$var$makeInsertMarkup(markup, afterNode, toIndex) {
    // NOTE: Null values reduce hidden classes.
    return {
        type: "INSERT_MARKUP",
        content: markup,
        fromIndex: null,
        fromNode: null,
        toIndex: toIndex,
        afterNode: afterNode
    };
}
/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */ function $e128acf76b2514b0$var$makeMove(child, afterNode, toIndex) {
    // NOTE: Null values reduce hidden classes.
    return {
        type: "MOVE_EXISTING",
        content: null,
        fromIndex: child._mountIndex,
        fromNode: $5Kdrw.getHostNode(child),
        toIndex: toIndex,
        afterNode: afterNode
    };
}
/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */ function $e128acf76b2514b0$var$makeRemove(child, node) {
    // NOTE: Null values reduce hidden classes.
    return {
        type: "REMOVE_NODE",
        content: null,
        fromIndex: child._mountIndex,
        fromNode: node,
        toIndex: null,
        afterNode: null
    };
}
/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */ function $e128acf76b2514b0$var$makeSetMarkup(markup) {
    // NOTE: Null values reduce hidden classes.
    return {
        type: "SET_MARKUP",
        content: markup,
        fromIndex: null,
        fromNode: null,
        toIndex: null,
        afterNode: null
    };
}
/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */ function $e128acf76b2514b0$var$makeTextContent(textContent) {
    // NOTE: Null values reduce hidden classes.
    return {
        type: "TEXT_CONTENT",
        content: textContent,
        fromIndex: null,
        fromNode: null,
        toIndex: null,
        afterNode: null
    };
}
/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */ function $e128acf76b2514b0$var$enqueue(queue, update) {
    if (update) {
        queue = queue || [];
        queue.push(update);
    }
    return queue;
}
/**
 * Processes any enqueued updates.
 *
 * @private
 */ function $e128acf76b2514b0$var$processQueue(inst, updateQueue) {
    $cpJSD.processChildrenUpdates(inst, updateQueue);
}
var $e128acf76b2514b0$var$setChildrenForInstrumentation = $46CSh;
var $e128acf76b2514b0$var$getDebugID;
/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */ var $e128acf76b2514b0$var$ReactMultiChild = {
    /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */ Mixin: {
        _reconcilerInstantiateChildren: function(nestedChildren, transaction, context) {
            var selfDebugID;
            return $kZ9Tt.instantiateChildren(nestedChildren, transaction, context);
        },
        _reconcilerUpdateChildren: function(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
            var nextChildren;
            var selfDebugID = 0;
            nextChildren = $hXtoY(nextNestedChildrenElements, selfDebugID);
            $kZ9Tt.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
            return nextChildren;
        },
        /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */ mountChildren: function(nestedChildren, transaction, context) {
            var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
            this._renderedChildren = children;
            var mountImages = [];
            var index = 0;
            for(var name in children)if (children.hasOwnProperty(name)) {
                var child = children[name];
                var selfDebugID = 0;
                var mountImage = $5Kdrw.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
                child._mountIndex = index++;
                mountImages.push(mountImage);
            }
            return mountImages;
        },
        /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */ updateTextContent: function(nextContent) {
            var prevChildren = this._renderedChildren;
            // Remove any rendered children.
            $kZ9Tt.unmountChildren(prevChildren, false);
            for(var name in prevChildren)if (prevChildren.hasOwnProperty(name)) $jOpPq("118");
            // Set new text content.
            var updates = [
                $e128acf76b2514b0$var$makeTextContent(nextContent)
            ];
            $e128acf76b2514b0$var$processQueue(this, updates);
        },
        /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */ updateMarkup: function(nextMarkup) {
            var prevChildren = this._renderedChildren;
            // Remove any rendered children.
            $kZ9Tt.unmountChildren(prevChildren, false);
            for(var name in prevChildren)if (prevChildren.hasOwnProperty(name)) $jOpPq("118");
            var updates = [
                $e128acf76b2514b0$var$makeSetMarkup(nextMarkup)
            ];
            $e128acf76b2514b0$var$processQueue(this, updates);
        },
        /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */ updateChildren: function(nextNestedChildrenElements, transaction, context) {
            // Hook used by React ART
            this._updateChildren(nextNestedChildrenElements, transaction, context);
        },
        /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */ _updateChildren: function(nextNestedChildrenElements, transaction, context) {
            var prevChildren = this._renderedChildren;
            var removedNodes = {};
            var mountImages = [];
            var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
            if (!nextChildren && !prevChildren) return;
            var updates = null;
            var name;
            // `nextIndex` will increment for each child in `nextChildren`, but
            // `lastIndex` will be the last index visited in `prevChildren`.
            var nextIndex = 0;
            var lastIndex = 0;
            // `nextMountIndex` will increment for each newly mounted child.
            var nextMountIndex = 0;
            var lastPlacedNode = null;
            for(name in nextChildren){
                if (!nextChildren.hasOwnProperty(name)) continue;
                var prevChild = prevChildren && prevChildren[name];
                var nextChild = nextChildren[name];
                if (prevChild === nextChild) {
                    updates = $e128acf76b2514b0$var$enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
                    lastIndex = Math.max(prevChild._mountIndex, lastIndex);
                    prevChild._mountIndex = nextIndex;
                } else {
                    if (prevChild) // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
                    lastIndex = Math.max(prevChild._mountIndex, lastIndex);
                    // The child must be instantiated before it's mounted.
                    updates = $e128acf76b2514b0$var$enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
                    nextMountIndex++;
                }
                nextIndex++;
                lastPlacedNode = $5Kdrw.getHostNode(nextChild);
            }
            // Remove children that are no longer present.
            for(name in removedNodes)if (removedNodes.hasOwnProperty(name)) updates = $e128acf76b2514b0$var$enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
            if (updates) $e128acf76b2514b0$var$processQueue(this, updates);
            this._renderedChildren = nextChildren;
        },
        /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */ unmountChildren: function(safely) {
            var renderedChildren = this._renderedChildren;
            $kZ9Tt.unmountChildren(renderedChildren, safely);
            this._renderedChildren = null;
        },
        /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */ moveChild: function(child, afterNode, toIndex, lastIndex) {
            // If the index of `child` is less than `lastIndex`, then it needs to
            // be moved. Otherwise, we do not need to move it because a child will be
            // inserted or moved before `child`.
            if (child._mountIndex < lastIndex) return $e128acf76b2514b0$var$makeMove(child, afterNode, toIndex);
        },
        /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */ createChild: function(child, afterNode, mountImage) {
            return $e128acf76b2514b0$var$makeInsertMarkup(mountImage, afterNode, child._mountIndex);
        },
        /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */ removeChild: function(child, node) {
            return $e128acf76b2514b0$var$makeRemove(child, node);
        },
        /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */ _mountChildAtIndex: function(child, mountImage, afterNode, index, transaction, context) {
            child._mountIndex = index;
            return this.createChild(child, afterNode, mountImage);
        },
        /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */ _unmountChild: function(child, node) {
            var update = this.removeChild(child, node);
            child._mountIndex = null;
            return update;
        }
    }
};
module.exports = $e128acf76b2514b0$var$ReactMultiChild;

});
parcelRegister("cpJSD", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
parcelRequire("4Mb5c");
var $909b68b506b4e05f$var$injected = false;
var $909b68b506b4e05f$var$ReactComponentEnvironment = {
    /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */ replaceNodeWithMarkup: null,
    /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */ processChildrenUpdates: null,
    injection: {
        injectEnvironment: function(environment) {
            !!$909b68b506b4e05f$var$injected && $jOpPq("104");
            $909b68b506b4e05f$var$ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
            $909b68b506b4e05f$var$ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
            $909b68b506b4e05f$var$injected = true;
        }
    }
};
module.exports = $909b68b506b4e05f$var$ReactComponentEnvironment;

});

parcelRegister("adVZ1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */ // TODO: Replace this with ES6: var ReactInstanceMap = new Map();
var $7718188fbcc068e2$var$ReactInstanceMap = {
    /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */ remove: function(key) {
        key._reactInternalInstance = undefined;
    },
    get: function(key) {
        return key._reactInternalInstance;
    },
    has: function(key) {
        return key._reactInternalInstance !== undefined;
    },
    set: function(key, value) {
        key._reactInternalInstance = value;
    }
};
module.exports = $7718188fbcc068e2$var$ReactInstanceMap;

});

parcelRegister("kZ9Tt", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $ibaza = parcelRequire("ibaza");
"use strict";

var $5Kdrw = parcelRequire("5Kdrw");

var $14nb3 = parcelRequire("14nb3");
parcelRequire("ezVAX");

var $14WBm = parcelRequire("14WBm");

var $ht2M0 = parcelRequire("ht2M0");
parcelRequire("fIzgz");
var $f4712ddc4a8617c9$var$ReactComponentTreeHook;
typeof $ibaza !== "undefined" && $ibaza.env;
function $f4712ddc4a8617c9$var$instantiateChild(childInstances, child, name, selfDebugID) {
    // We found a component instance.
    var keyUnique = childInstances[name] === undefined;
    if (child != null && keyUnique) childInstances[name] = $14nb3(child, true);
}
/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */ var $f4712ddc4a8617c9$var$ReactChildReconciler = {
    /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */ instantiateChildren: function(nestedChildNodes, transaction, context, selfDebugID) {
        if (nestedChildNodes == null) return null;
        var childInstances = {};
        $ht2M0(nestedChildNodes, $f4712ddc4a8617c9$var$instantiateChild, childInstances);
        return childInstances;
    },
    /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */ updateChildren: function(prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) {
        // We currently don't have a way to track moves here but if we use iterators
        // instead of for..in we can zip the iterators and check if an item has
        // moved.
        // TODO: If nothing has changed, return the prevChildren object so that we
        // can quickly bailout if nothing has changed.
        if (!nextChildren && !prevChildren) return;
        var name;
        var prevChild;
        for(name in nextChildren){
            if (!nextChildren.hasOwnProperty(name)) continue;
            prevChild = prevChildren && prevChildren[name];
            var prevElement = prevChild && prevChild._currentElement;
            var nextElement = nextChildren[name];
            if (prevChild != null && $14WBm(prevElement, nextElement)) {
                $5Kdrw.receiveComponent(prevChild, nextElement, transaction, context);
                nextChildren[name] = prevChild;
            } else {
                if (prevChild) {
                    removedNodes[name] = $5Kdrw.getHostNode(prevChild);
                    $5Kdrw.unmountComponent(prevChild, false);
                }
                // The child must be instantiated before it's mounted.
                var nextChildInstance = $14nb3(nextElement, true);
                nextChildren[name] = nextChildInstance;
                // Creating mount image now ensures refs are resolved in right order
                // (see https://github.com/facebook/react/pull/7101 for explanation).
                var nextChildMountImage = $5Kdrw.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
                mountImages.push(nextChildMountImage);
            }
        }
        // Unmount children that are no longer present.
        for(name in prevChildren)if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
            prevChild = prevChildren[name];
            removedNodes[name] = $5Kdrw.getHostNode(prevChild);
            $5Kdrw.unmountComponent(prevChild, false);
        }
    },
    /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */ unmountChildren: function(renderedChildren, safely) {
        for(var name in renderedChildren)if (renderedChildren.hasOwnProperty(name)) {
            var renderedChild = renderedChildren[name];
            $5Kdrw.unmountComponent(renderedChild, safely);
        }
    }
};
module.exports = $f4712ddc4a8617c9$var$ReactChildReconciler;

});
parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = "browser";
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ""; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d3c1734dacb01657$var$process.cwd = function() {
    return "/";
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});

parcelRegister("14nb3", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $a6S4T = parcelRequire("a6S4T");

var $6WibP = parcelRequire("6WibP");

var $h6tCq = parcelRequire("h6tCq");

var $8JqAb = parcelRequire("8JqAb");
parcelRequire("5m4zE");
parcelRequire("4Mb5c");
parcelRequire("fIzgz");
// To avoid a cyclic dependency, we create the final class in this module
var $0c7824af37904d03$var$ReactCompositeComponentWrapper = function(element) {
    this.construct(element);
};
function $0c7824af37904d03$var$getDeclarationErrorAddendum(owner) {
    if (owner) {
        var name = owner.getName();
        if (name) return " Check the render method of `" + name + "`.";
    }
    return "";
}
/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */ function $0c7824af37904d03$var$isInternalComponentType(type) {
    return typeof type === "function" && typeof type.prototype !== "undefined" && typeof type.prototype.mountComponent === "function" && typeof type.prototype.receiveComponent === "function";
}
/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */ function $0c7824af37904d03$var$instantiateReactComponent(node, shouldHaveDebugID) {
    var instance;
    if (node === null || node === false) instance = $h6tCq.create($0c7824af37904d03$var$instantiateReactComponent);
    else if (typeof node === "object") {
        var element = node;
        var type = element.type;
        if (typeof type !== "function" && typeof type !== "string") {
            var info = "";
            info += $0c7824af37904d03$var$getDeclarationErrorAddendum(element._owner);
            $jOpPq("130", type == null ? type : typeof type, info);
        }
        // Special case string values
        if (typeof element.type === "string") instance = $8JqAb.createInternalComponent(element);
        else if ($0c7824af37904d03$var$isInternalComponentType(element.type)) {
            // This is temporarily available for custom components that are not string
            // representations. I.e. ART. Once those are updated to use the string
            // representation, we can drop this code path.
            instance = new element.type(element);
            // We renamed this. Allow the old name for compat. :(
            if (!instance.getHostNode) instance.getHostNode = instance.getNativeNode;
        } else instance = new $0c7824af37904d03$var$ReactCompositeComponentWrapper(element);
    } else if (typeof node === "string" || typeof node === "number") instance = $8JqAb.createInstanceForText(node);
    else $jOpPq("131", typeof node);
    // These two fields are used by the DOM and ART diffing algorithms
    // respectively. Instead of using expandos on components, we should be
    // storing the state needed by the diffing algorithms elsewhere.
    instance._mountIndex = 0;
    instance._mountImage = null;
    return instance;
}
$a6S4T($0c7824af37904d03$var$ReactCompositeComponentWrapper.prototype, $6WibP, {
    _instantiateReactComponent: $0c7824af37904d03$var$instantiateReactComponent
});
module.exports = $0c7824af37904d03$var$instantiateReactComponent;

});
parcelRegister("6WibP", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $a6S4T = parcelRequire("a6S4T");

var $eW0mB = parcelRequire("eW0mB");

var $cpJSD = parcelRequire("cpJSD");

var $6qU6G = parcelRequire("6qU6G");

var $knj2S = parcelRequire("knj2S");

var $adVZ1 = parcelRequire("adVZ1");

var $d1IRY = parcelRequire("d1IRY");

var $ugkUw = parcelRequire("ugkUw");

var $5Kdrw = parcelRequire("5Kdrw");
var $50d644fd46e0b08c$var$checkReactTypeSpec;

var $X5IzL = parcelRequire("X5IzL");
parcelRequire("4Mb5c");

var $el2AU = parcelRequire("el2AU");

var $14WBm = parcelRequire("14WBm");
parcelRequire("fIzgz");
var $50d644fd46e0b08c$var$CompositeTypes = {
    ImpureClass: 0,
    PureClass: 1,
    StatelessFunctional: 2
};
function $50d644fd46e0b08c$var$StatelessComponent(Component) {}
$50d644fd46e0b08c$var$StatelessComponent.prototype.render = function() {
    var Component = $adVZ1.get(this)._currentElement.type;
    var element = Component(this.props, this.context, this.updater);
    $50d644fd46e0b08c$var$warnIfInvalidElement(Component, element);
    return element;
};
function $50d644fd46e0b08c$var$warnIfInvalidElement(Component, element) {}
function $50d644fd46e0b08c$var$shouldConstruct(Component) {
    return !!(Component.prototype && Component.prototype.isReactComponent);
}
function $50d644fd46e0b08c$var$isPureComponent(Component) {
    return !!(Component.prototype && Component.prototype.isPureReactComponent);
}
// Separated into a function to contain deoptimizations caused by try/finally.
function $50d644fd46e0b08c$var$measureLifeCyclePerf(fn, debugID, timerType) {
    if (debugID === 0) // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
    $d1IRY.debugTool.onBeginLifeCycleTimer(debugID, timerType);
    try {
        return fn();
    } finally{
        $d1IRY.debugTool.onEndLifeCycleTimer(debugID, timerType);
    }
}
/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */ /**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */ var $50d644fd46e0b08c$var$nextMountID = 1;
/**
 * @lends {ReactCompositeComponent.prototype}
 */ var $50d644fd46e0b08c$var$ReactCompositeComponent = {
    /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */ construct: function(element) {
        this._currentElement = element;
        this._rootNodeID = 0;
        this._compositeType = null;
        this._instance = null;
        this._hostParent = null;
        this._hostContainerInfo = null;
        // See ReactUpdateQueue
        this._updateBatchNumber = null;
        this._pendingElement = null;
        this._pendingStateQueue = null;
        this._pendingReplaceState = false;
        this._pendingForceUpdate = false;
        this._renderedNodeType = null;
        this._renderedComponent = null;
        this._context = null;
        this._mountOrder = 0;
        this._topLevelWrapper = null;
        // See ReactUpdates and ReactUpdateQueue.
        this._pendingCallbacks = null;
        // ComponentWillUnmount shall only be called once
        this._calledComponentWillUnmount = false;
    },
    /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */ mountComponent: function(transaction, hostParent, hostContainerInfo, context) {
        var _this = this;
        this._context = context;
        this._mountOrder = $50d644fd46e0b08c$var$nextMountID++;
        this._hostParent = hostParent;
        this._hostContainerInfo = hostContainerInfo;
        var publicProps = this._currentElement.props;
        var publicContext = this._processContext(context);
        var Component = this._currentElement.type;
        var updateQueue = transaction.getUpdateQueue();
        // Initialize the public class
        var doConstruct = $50d644fd46e0b08c$var$shouldConstruct(Component);
        var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
        var renderedElement;
        // Support functional components
        if (!doConstruct && (inst == null || inst.render == null)) {
            renderedElement = inst;
            $50d644fd46e0b08c$var$warnIfInvalidElement(Component, renderedElement);
            !(inst === null || inst === false || $eW0mB.isValidElement(inst)) && $jOpPq("105", Component.displayName || Component.name || "Component");
            inst = new $50d644fd46e0b08c$var$StatelessComponent(Component);
            this._compositeType = $50d644fd46e0b08c$var$CompositeTypes.StatelessFunctional;
        } else if ($50d644fd46e0b08c$var$isPureComponent(Component)) this._compositeType = $50d644fd46e0b08c$var$CompositeTypes.PureClass;
        else this._compositeType = $50d644fd46e0b08c$var$CompositeTypes.ImpureClass;
        var propsMutated, componentName;
        // These should be set up in the constructor, but as a convenience for
        // simpler class abstractions, we set them up after the fact.
        inst.props = publicProps;
        inst.context = publicContext;
        inst.refs = $X5IzL;
        inst.updater = updateQueue;
        this._instance = inst;
        // Store a reference from the instance back to the internal representation
        $adVZ1.set(inst, this);
        var initialState = inst.state;
        if (initialState === undefined) inst.state = initialState = null;
        !(typeof initialState === "object" && !Array.isArray(initialState)) && $jOpPq("106", this.getName() || "ReactCompositeComponent");
        this._pendingStateQueue = null;
        this._pendingReplaceState = false;
        this._pendingForceUpdate = false;
        var markup;
        if (inst.unstable_handleError) markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
        else markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
        if (inst.componentDidMount) transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
        return markup;
    },
    _constructComponent: function(doConstruct, publicProps, publicContext, updateQueue) {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    },
    _constructComponentWithoutOwner: function(doConstruct, publicProps, publicContext, updateQueue) {
        var Component = this._currentElement.type;
        if (doConstruct) return new Component(publicProps, publicContext, updateQueue);
        return Component(publicProps, publicContext, updateQueue);
    },
    performInitialMountWithErrorHandling: function(renderedElement, hostParent, hostContainerInfo, transaction, context) {
        var markup;
        var checkpoint = transaction.checkpoint();
        try {
            markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
        } catch (e) {
            // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
            transaction.rollback(checkpoint);
            this._instance.unstable_handleError(e);
            if (this._pendingStateQueue) this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
            checkpoint = transaction.checkpoint();
            this._renderedComponent.unmountComponent(true);
            transaction.rollback(checkpoint);
            // Try again - we've informed the component about the error, so they can render an error message this time.
            // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
            markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
        }
        return markup;
    },
    performInitialMount: function(renderedElement, hostParent, hostContainerInfo, transaction, context) {
        var inst = this._instance;
        var debugID = 0;
        if (inst.componentWillMount) {
            inst.componentWillMount();
            // When mounting, calls to `setState` by `componentWillMount` will set
            // `this._pendingStateQueue` without triggering a re-render.
            if (this._pendingStateQueue) inst.state = this._processPendingState(inst.props, inst.context);
        }
        // If not a stateless component, we now render
        if (renderedElement === undefined) renderedElement = this._renderValidatedComponent();
        var nodeType = $ugkUw.getType(renderedElement);
        this._renderedNodeType = nodeType;
        var child = this._instantiateReactComponent(renderedElement, nodeType !== $ugkUw.EMPTY /* shouldHaveDebugID */ );
        this._renderedComponent = child;
        var markup = $5Kdrw.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
        var childDebugIDs;
        return markup;
    },
    getHostNode: function() {
        return $5Kdrw.getHostNode(this._renderedComponent);
    },
    /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */ unmountComponent: function(safely) {
        if (!this._renderedComponent) return;
        var inst = this._instance;
        if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
            inst._calledComponentWillUnmount = true;
            if (safely) {
                var name = this.getName() + ".componentWillUnmount()";
                $knj2S.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
            } else inst.componentWillUnmount();
        }
        if (this._renderedComponent) {
            $5Kdrw.unmountComponent(this._renderedComponent, safely);
            this._renderedNodeType = null;
            this._renderedComponent = null;
            this._instance = null;
        }
        // Reset pending fields
        // Even if this component is scheduled for another update in ReactUpdates,
        // it would still be ignored because these fields are reset.
        this._pendingStateQueue = null;
        this._pendingReplaceState = false;
        this._pendingForceUpdate = false;
        this._pendingCallbacks = null;
        this._pendingElement = null;
        // These fields do not really need to be reset since this object is no
        // longer accessible.
        this._context = null;
        this._rootNodeID = 0;
        this._topLevelWrapper = null;
        // Delete the reference from the instance to this internal representation
        // which allow the internals to be properly cleaned up even if the user
        // leaks a reference to the public instance.
        $adVZ1.remove(inst);
    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
    },
    /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */ _maskContext: function(context) {
        var Component = this._currentElement.type;
        var contextTypes = Component.contextTypes;
        if (!contextTypes) return $X5IzL;
        var maskedContext = {};
        for(var contextName in contextTypes)maskedContext[contextName] = context[contextName];
        return maskedContext;
    },
    /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */ _processContext: function(context) {
        var maskedContext = this._maskContext(context);
        var Component;
        return maskedContext;
    },
    /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */ _processChildContext: function(currentContext) {
        var Component = this._currentElement.type;
        var inst = this._instance;
        var childContext;
        if (inst.getChildContext) childContext = inst.getChildContext();
        if (childContext) {
            !(typeof Component.childContextTypes === "object") && $jOpPq("107", this.getName() || "ReactCompositeComponent");
            for(var name in childContext)!(name in Component.childContextTypes) && $jOpPq("108", this.getName() || "ReactCompositeComponent", name);
            return $a6S4T({}, currentContext, childContext);
        }
        return currentContext;
    },
    /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */ _checkContextTypes: function(typeSpecs, values, location) {},
    receiveComponent: function(nextElement, transaction, nextContext) {
        var prevElement = this._currentElement;
        var prevContext = this._context;
        this._pendingElement = null;
        this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
    },
    /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */ performUpdateIfNecessary: function(transaction) {
        if (this._pendingElement != null) $5Kdrw.receiveComponent(this, this._pendingElement, transaction, this._context);
        else if (this._pendingStateQueue !== null || this._pendingForceUpdate) this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
        else this._updateBatchNumber = null;
    },
    /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */ updateComponent: function(transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
        var inst = this._instance;
        !(inst != null) && $jOpPq("136", this.getName() || "ReactCompositeComponent");
        var willReceive = false;
        var nextContext;
        // Determine if the context has changed or not
        if (this._context === nextUnmaskedContext) nextContext = inst.context;
        else {
            nextContext = this._processContext(nextUnmaskedContext);
            willReceive = true;
        }
        var prevProps = prevParentElement.props;
        var nextProps = nextParentElement.props;
        // Not a simple state update but a props update
        if (prevParentElement !== nextParentElement) willReceive = true;
        // An update here will schedule an update but immediately set
        // _pendingStateQueue which will ensure that any state updates gets
        // immediately reconciled instead of waiting for the next batch.
        if (willReceive && inst.componentWillReceiveProps) inst.componentWillReceiveProps(nextProps, nextContext);
        var nextState = this._processPendingState(nextProps, nextContext);
        var shouldUpdate = true;
        if (!this._pendingForceUpdate) {
            if (inst.shouldComponentUpdate) shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
            else if (this._compositeType === $50d644fd46e0b08c$var$CompositeTypes.PureClass) shouldUpdate = !$el2AU(prevProps, nextProps) || !$el2AU(inst.state, nextState);
        }
        this._updateBatchNumber = null;
        if (shouldUpdate) {
            this._pendingForceUpdate = false;
            // Will set `this.props`, `this.state` and `this.context`.
            this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
        } else {
            // If it's determined that a component should not update, we still want
            // to set props and state but we shortcut the rest of the update.
            this._currentElement = nextParentElement;
            this._context = nextUnmaskedContext;
            inst.props = nextProps;
            inst.state = nextState;
            inst.context = nextContext;
        }
    },
    _processPendingState: function(props, context) {
        var inst = this._instance;
        var queue = this._pendingStateQueue;
        var replace = this._pendingReplaceState;
        this._pendingReplaceState = false;
        this._pendingStateQueue = null;
        if (!queue) return inst.state;
        if (replace && queue.length === 1) return queue[0];
        var nextState = $a6S4T({}, replace ? queue[0] : inst.state);
        for(var i = replace ? 1 : 0; i < queue.length; i++){
            var partial = queue[i];
            $a6S4T(nextState, typeof partial === "function" ? partial.call(inst, nextState, props, context) : partial);
        }
        return nextState;
    },
    /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */ _performComponentUpdate: function(nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
        var _this2 = this;
        var inst = this._instance;
        var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
        var prevProps;
        var prevState;
        var prevContext;
        if (hasComponentDidUpdate) {
            prevProps = inst.props;
            prevState = inst.state;
            prevContext = inst.context;
        }
        if (inst.componentWillUpdate) inst.componentWillUpdate(nextProps, nextState, nextContext);
        this._currentElement = nextElement;
        this._context = unmaskedContext;
        inst.props = nextProps;
        inst.state = nextState;
        inst.context = nextContext;
        this._updateRenderedComponent(transaction, unmaskedContext);
        if (hasComponentDidUpdate) transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
    },
    /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */ _updateRenderedComponent: function(transaction, context) {
        var prevComponentInstance = this._renderedComponent;
        var prevRenderedElement = prevComponentInstance._currentElement;
        var nextRenderedElement = this._renderValidatedComponent();
        var debugID = 0;
        if ($14WBm(prevRenderedElement, nextRenderedElement)) $5Kdrw.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
        else {
            var oldHostNode = $5Kdrw.getHostNode(prevComponentInstance);
            $5Kdrw.unmountComponent(prevComponentInstance, false);
            var nodeType = $ugkUw.getType(nextRenderedElement);
            this._renderedNodeType = nodeType;
            var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== $ugkUw.EMPTY /* shouldHaveDebugID */ );
            this._renderedComponent = child;
            var nextMarkup = $5Kdrw.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
            var childDebugIDs;
            this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
        }
    },
    /**
   * Overridden in shallow rendering.
   *
   * @protected
   */ _replaceNodeWithMarkup: function(oldHostNode, nextMarkup, prevInstance) {
        $cpJSD.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
    },
    /**
   * @protected
   */ _renderValidatedComponentWithoutOwnerOrContext: function() {
        var inst = this._instance;
        var renderedElement;
        renderedElement = inst.render();
        return renderedElement;
    },
    /**
   * @private
   */ _renderValidatedComponent: function() {
        var renderedElement;
        if (this._compositeType !== $50d644fd46e0b08c$var$CompositeTypes.StatelessFunctional) {
            $6qU6G.current = this;
            try {
                renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
            } finally{
                $6qU6G.current = null;
            }
        } else renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
        !// TODO: An `isValidNode` function would probably be more appropriate
        (renderedElement === null || renderedElement === false || $eW0mB.isValidElement(renderedElement)) && $jOpPq("109", this.getName() || "ReactCompositeComponent");
        return renderedElement;
    },
    /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */ attachRef: function(ref, component) {
        var inst = this.getPublicInstance();
        !(inst != null) && $jOpPq("110");
        var publicComponentInstance = component.getPublicInstance();
        var componentName;
        var refs = inst.refs === $X5IzL ? inst.refs = {} : inst.refs;
        refs[ref] = publicComponentInstance;
    },
    /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */ detachRef: function(ref) {
        var refs = this.getPublicInstance().refs;
        delete refs[ref];
    },
    /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */ getName: function() {
        var type = this._currentElement.type;
        var constructor = this._instance && this._instance.constructor;
        return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
    },
    /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */ getPublicInstance: function() {
        var inst = this._instance;
        if (this._compositeType === $50d644fd46e0b08c$var$CompositeTypes.StatelessFunctional) return null;
        return inst;
    },
    // Stub
    _instantiateReactComponent: null
};
module.exports = $50d644fd46e0b08c$var$ReactCompositeComponent;

});
parcelRegister("ugkUw", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $eW0mB = parcelRequire("eW0mB");
parcelRequire("4Mb5c");
var $05af797fe7c4e0c1$var$ReactNodeTypes = {
    HOST: 0,
    COMPOSITE: 1,
    EMPTY: 2,
    getType: function(node) {
        if (node === null || node === false) return $05af797fe7c4e0c1$var$ReactNodeTypes.EMPTY;
        else if ($eW0mB.isValidElement(node)) {
            if (typeof node.type === "function") return $05af797fe7c4e0c1$var$ReactNodeTypes.COMPOSITE;
            else return $05af797fe7c4e0c1$var$ReactNodeTypes.HOST;
        }
        $jOpPq("26", node);
    }
};
module.exports = $05af797fe7c4e0c1$var$ReactNodeTypes;

});

parcelRegister("el2AU", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */ /*eslint-disable no-self-compare */ "use strict";
var $a7050a096b4fdc01$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $a7050a096b4fdc01$var$is(x, y) {
    // SameValue algorithm
    if (x === y) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else // Step 6.a: NaN == NaN
    return x !== x && y !== y;
}
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function $a7050a096b4fdc01$var$shallowEqual(objA, objB) {
    if ($a7050a096b4fdc01$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(var i = 0; i < keysA.length; i++){
        if (!$a7050a096b4fdc01$var$hasOwnProperty.call(objB, keysA[i]) || !$a7050a096b4fdc01$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
module.exports = $a7050a096b4fdc01$var$shallowEqual;

});

parcelRegister("14WBm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */ function $0c939f3f0444ab1a$var$shouldUpdateReactComponent(prevElement, nextElement) {
    var prevEmpty = prevElement === null || prevElement === false;
    var nextEmpty = nextElement === null || nextElement === false;
    if (prevEmpty || nextEmpty) return prevEmpty === nextEmpty;
    var prevType = typeof prevElement;
    var nextType = typeof nextElement;
    if (prevType === "string" || prevType === "number") return nextType === "string" || nextType === "number";
    else return nextType === "object" && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
}
module.exports = $0c939f3f0444ab1a$var$shouldUpdateReactComponent;

});


parcelRegister("h6tCq", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
var $c739f8e16348eb98$var$emptyComponentFactory;
var $c739f8e16348eb98$var$ReactEmptyComponentInjection = {
    injectEmptyComponentFactory: function(factory) {
        $c739f8e16348eb98$var$emptyComponentFactory = factory;
    }
};
var $c739f8e16348eb98$var$ReactEmptyComponent = {
    create: function(instantiate) {
        return $c739f8e16348eb98$var$emptyComponentFactory(instantiate);
    }
};
$c739f8e16348eb98$var$ReactEmptyComponent.injection = $c739f8e16348eb98$var$ReactEmptyComponentInjection;
module.exports = $c739f8e16348eb98$var$ReactEmptyComponent;

});

parcelRegister("8JqAb", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
parcelRequire("4Mb5c");
var $65b72570053b78ca$var$genericComponentClass = null;
var $65b72570053b78ca$var$textComponentClass = null;
var $65b72570053b78ca$var$ReactHostComponentInjection = {
    // This accepts a class that receives the tag string. This is a catch all
    // that can render any kind of tag.
    injectGenericComponentClass: function(componentClass) {
        $65b72570053b78ca$var$genericComponentClass = componentClass;
    },
    // This accepts a text component class that takes the text string to be
    // rendered as props.
    injectTextComponentClass: function(componentClass) {
        $65b72570053b78ca$var$textComponentClass = componentClass;
    }
};
/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */ function $65b72570053b78ca$var$createInternalComponent(element) {
    !$65b72570053b78ca$var$genericComponentClass && $jOpPq("111", element.type);
    return new $65b72570053b78ca$var$genericComponentClass(element);
}
/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */ function $65b72570053b78ca$var$createInstanceForText(text) {
    return new $65b72570053b78ca$var$textComponentClass(text);
}
/**
 * @param {ReactComponent} component
 * @return {boolean}
 */ function $65b72570053b78ca$var$isTextComponent(component) {
    return component instanceof $65b72570053b78ca$var$textComponentClass;
}
var $65b72570053b78ca$var$ReactHostComponent = {
    createInternalComponent: $65b72570053b78ca$var$createInternalComponent,
    createInstanceForText: $65b72570053b78ca$var$createInstanceForText,
    isTextComponent: $65b72570053b78ca$var$isTextComponent,
    injection: $65b72570053b78ca$var$ReactHostComponentInjection
};
module.exports = $65b72570053b78ca$var$ReactHostComponent;

});

parcelRegister("5m4zE", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
var $3e628e242cdb3dc4$var$nextDebugID = 1;
function $3e628e242cdb3dc4$var$getNextDebugID() {
    return $3e628e242cdb3dc4$var$nextDebugID++;
}
module.exports = $3e628e242cdb3dc4$var$getNextDebugID;

});


parcelRegister("ezVAX", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function $a9d102bcf080a037$var$escape(key) {
    var escapeRegex = /[=:]/g;
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    var escapedString = ("" + key).replace(escapeRegex, function(match) {
        return escaperLookup[match];
    });
    return "$" + escapedString;
}
/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */ function $a9d102bcf080a037$var$unescape(key) {
    var unescapeRegex = /(=0|=2)/g;
    var unescaperLookup = {
        "=0": "=",
        "=2": ":"
    };
    var keySubstring = key[0] === "." && key[1] === "$" ? key.substring(2) : key.substring(1);
    return ("" + keySubstring).replace(unescapeRegex, function(match) {
        return unescaperLookup[match];
    });
}
var $a9d102bcf080a037$var$KeyEscapeUtils = {
    escape: $a9d102bcf080a037$var$escape,
    unescape: $a9d102bcf080a037$var$unescape
};
module.exports = $a9d102bcf080a037$var$KeyEscapeUtils;

});

parcelRegister("ht2M0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
parcelRequire("6qU6G");

var $7Nyey = parcelRequire("7Nyey");

var $62Rwj = parcelRequire("62Rwj");
parcelRequire("4Mb5c");

var $ezVAX = parcelRequire("ezVAX");
parcelRequire("fIzgz");
var $cb774bcbd891256c$var$SEPARATOR = ".";
var $cb774bcbd891256c$var$SUBSEPARATOR = ":";
/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */ /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var $cb774bcbd891256c$var$didWarnAboutMaps = false;
/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function $cb774bcbd891256c$var$getComponentKey(component, index) {
    // Do some typechecking here since we call this blindly. We want to ensure
    // that we don't block potential future ES APIs.
    if (component && typeof component === "object" && component.key != null) // Explicit key
    return $ezVAX.escape(component.key);
    // Implicit key determined by the index in the set
    return index.toString(36);
}
/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */ function $cb774bcbd891256c$var$traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
    var type = typeof children;
    if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
    children = null;
    if (children === null || type === "string" || type === "number" || // The following is inlined from ReactElement. This means we can optimize
    // some checks. React Fiber also inlines this logic for similar purposes.
    type === "object" && children.$$typeof === $7Nyey) {
        callback(traverseContext, children, // If it's the only child, treat the name as if it was wrapped in an array
        // so that it's consistent if the number of children grows.
        nameSoFar === "" ? $cb774bcbd891256c$var$SEPARATOR + $cb774bcbd891256c$var$getComponentKey(children, 0) : nameSoFar);
        return 1;
    }
    var child;
    var nextName;
    var subtreeCount = 0; // Count of children found in the current subtree.
    var nextNamePrefix = nameSoFar === "" ? $cb774bcbd891256c$var$SEPARATOR : nameSoFar + $cb774bcbd891256c$var$SUBSEPARATOR;
    if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
        child = children[i];
        nextName = nextNamePrefix + $cb774bcbd891256c$var$getComponentKey(child, i);
        subtreeCount += $cb774bcbd891256c$var$traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
    else {
        var iteratorFn = $62Rwj(children);
        if (iteratorFn) {
            var iterator = iteratorFn.call(children);
            var step;
            if (iteratorFn !== children.entries) {
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + $cb774bcbd891256c$var$getComponentKey(child, ii++);
                    subtreeCount += $cb774bcbd891256c$var$traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                }
            } else {
                var mapsAsChildrenAddendum, mapsAsChildrenOwnerName;
                // Iterator will provide entry [k,v] tuples rather than values.
                while(!(step = iterator.next()).done){
                    var entry = step.value;
                    if (entry) {
                        child = entry[1];
                        nextName = nextNamePrefix + $ezVAX.escape(entry[0]) + $cb774bcbd891256c$var$SUBSEPARATOR + $cb774bcbd891256c$var$getComponentKey(child, 0);
                        subtreeCount += $cb774bcbd891256c$var$traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                    }
                }
            }
        } else if (type === "object") {
            var addendum = "";
            var name;
            var childrenString = String(children);
            $jOpPq("31", childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString, addendum);
        }
    }
    return subtreeCount;
}
/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */ function $cb774bcbd891256c$var$traverseAllChildren(children, callback, traverseContext) {
    if (children == null) return 0;
    return $cb774bcbd891256c$var$traverseAllChildrenImpl(children, "", callback, traverseContext);
}
module.exports = $cb774bcbd891256c$var$traverseAllChildren;

});
parcelRegister("7Nyey", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var $5ad7aa24037af381$var$REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7;
module.exports = $5ad7aa24037af381$var$REACT_ELEMENT_TYPE;

});

parcelRegister("62Rwj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
/* global Symbol */ var $466c71f7b0866f42$var$ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
var $466c71f7b0866f42$var$FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */ function $466c71f7b0866f42$var$getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && ($466c71f7b0866f42$var$ITERATOR_SYMBOL && maybeIterable[$466c71f7b0866f42$var$ITERATOR_SYMBOL] || maybeIterable[$466c71f7b0866f42$var$FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === "function") return iteratorFn;
}
module.exports = $466c71f7b0866f42$var$getIteratorFn;

});



parcelRegister("hXtoY", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ 
var $ibaza = parcelRequire("ibaza");
"use strict";
parcelRequire("ezVAX");

var $ht2M0 = parcelRequire("ht2M0");
parcelRequire("fIzgz");
var $d12ec0f6681f665f$var$ReactComponentTreeHook;
typeof $ibaza !== "undefined" && $ibaza.env;
/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */ function $d12ec0f6681f665f$var$flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
    // We found a component instance.
    if (traverseContext && typeof traverseContext === "object") {
        var result = traverseContext;
        var keyUnique = result[name] === undefined;
        if (keyUnique && child != null) result[name] = child;
    }
}
/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */ function $d12ec0f6681f665f$var$flattenChildren(children, selfDebugID) {
    if (children == null) return children;
    var result = {};
    $ht2M0(children, $d12ec0f6681f665f$var$flattenSingleChildIntoContext, result);
    return result;
}
module.exports = $d12ec0f6681f665f$var$flattenChildren;

});


parcelRegister("17lgn", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $a6S4T = parcelRequire("a6S4T");

var $lM582 = parcelRequire("lM582");

var $2PXJf = parcelRequire("2PXJf");
parcelRequire("d1IRY");

var $lq119 = parcelRequire("lq119");
/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */ var $0d06f05411b826a9$var$TRANSACTION_WRAPPERS = [];
var $0d06f05411b826a9$var$noopCallbackQueue = {
    enqueue: function() {}
};
/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */ function $0d06f05411b826a9$var$ReactServerRenderingTransaction(renderToStaticMarkup) {
    this.reinitializeTransaction();
    this.renderToStaticMarkup = renderToStaticMarkup;
    this.useCreateElement = false;
    this.updateQueue = new $lq119(this);
}
var $0d06f05411b826a9$var$Mixin = {
    /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */ getTransactionWrappers: function() {
        return $0d06f05411b826a9$var$TRANSACTION_WRAPPERS;
    },
    /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */ getReactMountReady: function() {
        return $0d06f05411b826a9$var$noopCallbackQueue;
    },
    /**
   * @return {object} The queue to collect React async events.
   */ getUpdateQueue: function() {
        return this.updateQueue;
    },
    /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */ destructor: function() {},
    checkpoint: function() {},
    rollback: function() {}
};
$a6S4T($0d06f05411b826a9$var$ReactServerRenderingTransaction.prototype, $2PXJf, $0d06f05411b826a9$var$Mixin);
$lM582.addPoolingTo($0d06f05411b826a9$var$ReactServerRenderingTransaction);
module.exports = $0d06f05411b826a9$var$ReactServerRenderingTransaction;

});
parcelRegister("lq119", function(module, exports) {
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
function $f97cd0bf6593d336$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $8GGGt = parcelRequire("8GGGt");
parcelRequire("fIzgz");
function $f97cd0bf6593d336$var$warnNoop(publicInstance, callerName) {
    var constructor;
}
/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */ var $f97cd0bf6593d336$var$ReactServerUpdateQueue = function() {
    function ReactServerUpdateQueue(transaction) {
        $f97cd0bf6593d336$var$_classCallCheck(this, ReactServerUpdateQueue);
        this.transaction = transaction;
    }
    /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
        return false;
    };
    /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */ ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
        if (this.transaction.isInTransaction()) $8GGGt.enqueueCallback(publicInstance, callback, callerName);
    };
    /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */ ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
        if (this.transaction.isInTransaction()) $8GGGt.enqueueForceUpdate(publicInstance);
        else $f97cd0bf6593d336$var$warnNoop(publicInstance, "forceUpdate");
    };
    /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */ ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
        if (this.transaction.isInTransaction()) $8GGGt.enqueueReplaceState(publicInstance, completeState);
        else $f97cd0bf6593d336$var$warnNoop(publicInstance, "replaceState");
    };
    /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */ ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
        if (this.transaction.isInTransaction()) $8GGGt.enqueueSetState(publicInstance, partialState);
        else $f97cd0bf6593d336$var$warnNoop(publicInstance, "setState");
    };
    return ReactServerUpdateQueue;
}();
module.exports = $f97cd0bf6593d336$var$ReactServerUpdateQueue;

});
parcelRegister("8GGGt", function(module, exports) {
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
parcelRequire("6qU6G");

var $adVZ1 = parcelRequire("adVZ1");
parcelRequire("d1IRY");

var $gDXrr = parcelRequire("gDXrr");
parcelRequire("4Mb5c");
parcelRequire("fIzgz");
function $65335b24201e1dda$var$enqueueUpdate(internalInstance) {
    $gDXrr.enqueueUpdate(internalInstance);
}
function $65335b24201e1dda$var$formatUnexpectedArgument(arg) {
    var type = typeof arg;
    if (type !== "object") return type;
    var displayName = arg.constructor && arg.constructor.name || type;
    var keys = Object.keys(arg);
    if (keys.length > 0 && keys.length < 20) return displayName + " (keys: " + keys.join(", ") + ")";
    return displayName;
}
function $65335b24201e1dda$var$getInternalInstanceReadyForUpdate(publicInstance, callerName) {
    var internalInstance = $adVZ1.get(publicInstance);
    if (!internalInstance) {
        var ctor;
        return null;
    }
    return internalInstance;
}
/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */ var $65335b24201e1dda$var$ReactUpdateQueue = {
    /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
        var owner;
        var internalInstance = $adVZ1.get(publicInstance);
        if (internalInstance) // During componentWillMount and render this will still be null but after
        // that will always render to something. At least for now. So we can use
        // this hack.
        return !!internalInstance._renderedComponent;
        else return false;
    },
    /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */ enqueueCallback: function(publicInstance, callback, callerName) {
        $65335b24201e1dda$var$ReactUpdateQueue.validateCallback(callback, callerName);
        var internalInstance = $65335b24201e1dda$var$getInternalInstanceReadyForUpdate(publicInstance);
        // Previously we would throw an error if we didn't have an internal
        // instance. Since we want to make it a no-op instead, we mirror the same
        // behavior we have in other enqueue* methods.
        // We also need to ignore callbacks in componentWillMount. See
        // enqueueUpdates.
        if (!internalInstance) return null;
        if (internalInstance._pendingCallbacks) internalInstance._pendingCallbacks.push(callback);
        else internalInstance._pendingCallbacks = [
            callback
        ];
        // TODO: The callback here is ignored when setState is called from
        // componentWillMount. Either fix it or disallow doing so completely in
        // favor of getInitialState. Alternatively, we can disallow
        // componentWillMount during server-side rendering.
        $65335b24201e1dda$var$enqueueUpdate(internalInstance);
    },
    enqueueCallbackInternal: function(internalInstance, callback) {
        if (internalInstance._pendingCallbacks) internalInstance._pendingCallbacks.push(callback);
        else internalInstance._pendingCallbacks = [
            callback
        ];
        $65335b24201e1dda$var$enqueueUpdate(internalInstance);
    },
    /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */ enqueueForceUpdate: function(publicInstance) {
        var internalInstance = $65335b24201e1dda$var$getInternalInstanceReadyForUpdate(publicInstance, "forceUpdate");
        if (!internalInstance) return;
        internalInstance._pendingForceUpdate = true;
        $65335b24201e1dda$var$enqueueUpdate(internalInstance);
    },
    /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback) {
        var internalInstance = $65335b24201e1dda$var$getInternalInstanceReadyForUpdate(publicInstance, "replaceState");
        if (!internalInstance) return;
        internalInstance._pendingStateQueue = [
            completeState
        ];
        internalInstance._pendingReplaceState = true;
        // Future-proof 15.5
        if (callback !== undefined && callback !== null) {
            $65335b24201e1dda$var$ReactUpdateQueue.validateCallback(callback, "replaceState");
            if (internalInstance._pendingCallbacks) internalInstance._pendingCallbacks.push(callback);
            else internalInstance._pendingCallbacks = [
                callback
            ];
        }
        $65335b24201e1dda$var$enqueueUpdate(internalInstance);
    },
    /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState) {
        var internalInstance = $65335b24201e1dda$var$getInternalInstanceReadyForUpdate(publicInstance, "setState");
        if (!internalInstance) return;
        var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
        queue.push(partialState);
        $65335b24201e1dda$var$enqueueUpdate(internalInstance);
    },
    enqueueElementInternal: function(internalInstance, nextElement, nextContext) {
        internalInstance._pendingElement = nextElement;
        // TODO: introduce _pendingContext instead of setting it directly.
        internalInstance._context = nextContext;
        $65335b24201e1dda$var$enqueueUpdate(internalInstance);
    },
    validateCallback: function(callback, callerName) {
        !(!callback || typeof callback === "function") && $jOpPq("122", callerName, $65335b24201e1dda$var$formatUnexpectedArgument(callback));
    }
};
module.exports = $65335b24201e1dda$var$ReactUpdateQueue;

});



parcelRegister("dBldY", function(module, exports) {
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
parcelRequire("a6S4T");

var $46CSh = parcelRequire("46CSh");
parcelRequire("fIzgz");
var $9e6f31c9f8f0a457$var$validateDOMNesting = $46CSh;
var $9e6f31c9f8f0a457$var$specialTags, $9e6f31c9f8f0a457$var$inScopeTags, $9e6f31c9f8f0a457$var$buttonScopeTags, $9e6f31c9f8f0a457$var$impliedEndTags, $9e6f31c9f8f0a457$var$emptyAncestorInfo, $9e6f31c9f8f0a457$var$updatedAncestorInfo, $9e6f31c9f8f0a457$var$isTagValidWithParent, $9e6f31c9f8f0a457$var$findInvalidAncestorForTag, $9e6f31c9f8f0a457$var$findOwnerStack, $9e6f31c9f8f0a457$var$didWarn;
module.exports = $9e6f31c9f8f0a457$var$validateDOMNesting;

});


parcelRegister("8AymV", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $a6S4T = parcelRequire("a6S4T");

var $QV5G5 = parcelRequire("QV5G5");

var $5fGpM = parcelRequire("5fGpM");
var $640c587483059e50$var$ReactDOMEmptyComponent = function(instantiate) {
    // ReactCompositeComponent uses this:
    this._currentElement = null;
    // ReactDOMComponentTree uses these:
    this._hostNode = null;
    this._hostParent = null;
    this._hostContainerInfo = null;
    this._domID = 0;
};
$a6S4T($640c587483059e50$var$ReactDOMEmptyComponent.prototype, {
    mountComponent: function(transaction, hostParent, hostContainerInfo, context) {
        var domID = hostContainerInfo._idCounter++;
        this._domID = domID;
        this._hostParent = hostParent;
        this._hostContainerInfo = hostContainerInfo;
        var nodeValue = " react-empty: " + this._domID + " ";
        if (transaction.useCreateElement) {
            var ownerDocument = hostContainerInfo._ownerDocument;
            var node = ownerDocument.createComment(nodeValue);
            $5fGpM.precacheNode(this, node);
            return $QV5G5(node);
        } else {
            if (transaction.renderToStaticMarkup) // Normally we'd insert a comment node, but since this is a situation
            // where React won't take over (static pages), we can simply return
            // nothing.
            return "";
            return "<!--" + nodeValue + "-->";
        }
    },
    receiveComponent: function() {},
    getHostNode: function() {
        return $5fGpM.getNodeFromInstance(this);
    },
    unmountComponent: function() {
        $5fGpM.uncacheNode(this);
    }
});
module.exports = $640c587483059e50$var$ReactDOMEmptyComponent;

});

parcelRegister("fI5lm", function(module, exports) {
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
parcelRequire("4Mb5c");
/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function $b6ff1c35642f5a44$var$getLowestCommonAncestor(instA, instB) {
    !("_hostNode" in instA) && $jOpPq("33");
    !("_hostNode" in instB) && $jOpPq("33");
    var depthA = 0;
    for(var tempA = instA; tempA; tempA = tempA._hostParent)depthA++;
    var depthB = 0;
    for(var tempB = instB; tempB; tempB = tempB._hostParent)depthB++;
    // If A is deeper, crawl up.
    while(depthA - depthB > 0){
        instA = instA._hostParent;
        depthA--;
    }
    // If B is deeper, crawl up.
    while(depthB - depthA > 0){
        instB = instB._hostParent;
        depthB--;
    }
    // Walk in lockstep until we find a match.
    var depth = depthA;
    while(depth--){
        if (instA === instB) return instA;
        instA = instA._hostParent;
        instB = instB._hostParent;
    }
    return null;
}
/**
 * Return if A is an ancestor of B.
 */ function $b6ff1c35642f5a44$var$isAncestor(instA, instB) {
    !("_hostNode" in instA) && $jOpPq("35");
    !("_hostNode" in instB) && $jOpPq("35");
    while(instB){
        if (instB === instA) return true;
        instB = instB._hostParent;
    }
    return false;
}
/**
 * Return the parent instance of the passed-in instance.
 */ function $b6ff1c35642f5a44$var$getParentInstance(inst) {
    !("_hostNode" in inst) && $jOpPq("36");
    return inst._hostParent;
}
/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */ function $b6ff1c35642f5a44$var$traverseTwoPhase(inst, fn, arg) {
    var path = [];
    while(inst){
        path.push(inst);
        inst = inst._hostParent;
    }
    var i;
    for(i = path.length; i-- > 0;)fn(path[i], "captured", arg);
    for(i = 0; i < path.length; i++)fn(path[i], "bubbled", arg);
}
/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */ function $b6ff1c35642f5a44$var$traverseEnterLeave(from, to, fn, argFrom, argTo) {
    var common = from && to ? $b6ff1c35642f5a44$var$getLowestCommonAncestor(from, to) : null;
    var pathFrom = [];
    while(from && from !== common){
        pathFrom.push(from);
        from = from._hostParent;
    }
    var pathTo = [];
    while(to && to !== common){
        pathTo.push(to);
        to = to._hostParent;
    }
    var i;
    for(i = 0; i < pathFrom.length; i++)fn(pathFrom[i], "bubbled", argFrom);
    for(i = pathTo.length; i-- > 0;)fn(pathTo[i], "captured", argTo);
}
module.exports = {
    isAncestor: $b6ff1c35642f5a44$var$isAncestor,
    getLowestCommonAncestor: $b6ff1c35642f5a44$var$getLowestCommonAncestor,
    getParentInstance: $b6ff1c35642f5a44$var$getParentInstance,
    traverseTwoPhase: $b6ff1c35642f5a44$var$traverseTwoPhase,
    traverseEnterLeave: $b6ff1c35642f5a44$var$traverseEnterLeave
};

});

parcelRegister("BWPny", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $a6S4T = parcelRequire("a6S4T");

var $2BUuH = parcelRequire("2BUuH");

var $QV5G5 = parcelRequire("QV5G5");

var $5fGpM = parcelRequire("5fGpM");

var $8i9tX = parcelRequire("8i9tX");
parcelRequire("4Mb5c");
parcelRequire("dBldY");
/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */ var $072116c54b341142$var$ReactDOMTextComponent = function(text) {
    // TODO: This is really a ReactText (ReactNode), not a ReactElement
    this._currentElement = text;
    this._stringText = "" + text;
    // ReactDOMComponentTree uses these:
    this._hostNode = null;
    this._hostParent = null;
    // Properties
    this._domID = 0;
    this._mountIndex = 0;
    this._closingComment = null;
    this._commentNodes = null;
};
$a6S4T($072116c54b341142$var$ReactDOMTextComponent.prototype, {
    /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */ mountComponent: function(transaction, hostParent, hostContainerInfo, context) {
        var parentInfo;
        var domID = hostContainerInfo._idCounter++;
        var openingValue = " react-text: " + domID + " ";
        var closingValue = " /react-text ";
        this._domID = domID;
        this._hostParent = hostParent;
        if (transaction.useCreateElement) {
            var ownerDocument = hostContainerInfo._ownerDocument;
            var openingComment = ownerDocument.createComment(openingValue);
            var closingComment = ownerDocument.createComment(closingValue);
            var lazyTree = $QV5G5(ownerDocument.createDocumentFragment());
            $QV5G5.queueChild(lazyTree, $QV5G5(openingComment));
            if (this._stringText) $QV5G5.queueChild(lazyTree, $QV5G5(ownerDocument.createTextNode(this._stringText)));
            $QV5G5.queueChild(lazyTree, $QV5G5(closingComment));
            $5fGpM.precacheNode(this, openingComment);
            this._closingComment = closingComment;
            return lazyTree;
        } else {
            var escapedText = $8i9tX(this._stringText);
            if (transaction.renderToStaticMarkup) // Normally we'd wrap this between comment nodes for the reasons stated
            // above, but since this is a situation where React won't take over
            // (static pages), we can simply return the text as it is.
            return escapedText;
            return "<!--" + openingValue + "-->" + escapedText + "<!--" + closingValue + "-->";
        }
    },
    /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */ receiveComponent: function(nextText, transaction) {
        if (nextText !== this._currentElement) {
            this._currentElement = nextText;
            var nextStringText = "" + nextText;
            if (nextStringText !== this._stringText) {
                // TODO: Save this as pending props and use performUpdateIfNecessary
                // and/or updateComponent to do the actual update for consistency with
                // other component types?
                this._stringText = nextStringText;
                var commentNodes = this.getHostNode();
                $2BUuH.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
            }
        }
    },
    getHostNode: function() {
        var hostNode = this._commentNodes;
        if (hostNode) return hostNode;
        if (!this._closingComment) {
            var openingComment = $5fGpM.getNodeFromInstance(this);
            var node = openingComment.nextSibling;
            while(true){
                !(node != null) && $jOpPq("67", this._domID);
                if (node.nodeType === 8 && node.nodeValue === " /react-text ") {
                    this._closingComment = node;
                    break;
                }
                node = node.nextSibling;
            }
        }
        hostNode = [
            this._hostNode,
            this._closingComment
        ];
        this._commentNodes = hostNode;
        return hostNode;
    },
    unmountComponent: function() {
        this._closingComment = null;
        this._commentNodes = null;
        $5fGpM.uncacheNode(this);
    }
});
module.exports = $072116c54b341142$var$ReactDOMTextComponent;

});

parcelRegister("g1KNQ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $a6S4T = parcelRequire("a6S4T");

var $gDXrr = parcelRequire("gDXrr");

var $2PXJf = parcelRequire("2PXJf");

var $46CSh = parcelRequire("46CSh");
var $bab10b711c12b0dd$var$RESET_BATCHED_UPDATES = {
    initialize: $46CSh,
    close: function() {
        $bab10b711c12b0dd$var$ReactDefaultBatchingStrategy.isBatchingUpdates = false;
    }
};
var $bab10b711c12b0dd$var$FLUSH_BATCHED_UPDATES = {
    initialize: $46CSh,
    close: $gDXrr.flushBatchedUpdates.bind($gDXrr)
};
var $bab10b711c12b0dd$var$TRANSACTION_WRAPPERS = [
    $bab10b711c12b0dd$var$FLUSH_BATCHED_UPDATES,
    $bab10b711c12b0dd$var$RESET_BATCHED_UPDATES
];
function $bab10b711c12b0dd$var$ReactDefaultBatchingStrategyTransaction() {
    this.reinitializeTransaction();
}
$a6S4T($bab10b711c12b0dd$var$ReactDefaultBatchingStrategyTransaction.prototype, $2PXJf, {
    getTransactionWrappers: function() {
        return $bab10b711c12b0dd$var$TRANSACTION_WRAPPERS;
    }
});
var $bab10b711c12b0dd$var$transaction = new $bab10b711c12b0dd$var$ReactDefaultBatchingStrategyTransaction();
var $bab10b711c12b0dd$var$ReactDefaultBatchingStrategy = {
    isBatchingUpdates: false,
    /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */ batchedUpdates: function(callback, a, b, c, d, e) {
        var alreadyBatchingUpdates = $bab10b711c12b0dd$var$ReactDefaultBatchingStrategy.isBatchingUpdates;
        $bab10b711c12b0dd$var$ReactDefaultBatchingStrategy.isBatchingUpdates = true;
        // The code is written this way to avoid extra allocations
        if (alreadyBatchingUpdates) return callback(a, b, c, d, e);
        else return $bab10b711c12b0dd$var$transaction.perform(callback, null, a, b, c, d, e);
    }
};
module.exports = $bab10b711c12b0dd$var$ReactDefaultBatchingStrategy;

});

parcelRegister("hmJFq", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $a6S4T = parcelRequire("a6S4T");

var $knJhf = parcelRequire("knJhf");

var $kx286 = parcelRequire("kx286");

var $lM582 = parcelRequire("lM582");

var $5fGpM = parcelRequire("5fGpM");

var $gDXrr = parcelRequire("gDXrr");

var $aNWE1 = parcelRequire("aNWE1");

var $7xzs2 = parcelRequire("7xzs2");
/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */ function $ca47ea46ba1d04b2$var$findParent(inst) {
    // TODO: It may be a good idea to cache this to prevent unnecessary DOM
    // traversal, but caching is difficult to do correctly without using a
    // mutation observer to listen for all DOM changes.
    while(inst._hostParent)inst = inst._hostParent;
    var rootNode = $5fGpM.getNodeFromInstance(inst);
    var container = rootNode.parentNode;
    return $5fGpM.getClosestInstanceFromNode(container);
}
// Used to store ancestor hierarchy in top level callback
function $ca47ea46ba1d04b2$var$TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
    this.topLevelType = topLevelType;
    this.nativeEvent = nativeEvent;
    this.ancestors = [];
}
$a6S4T($ca47ea46ba1d04b2$var$TopLevelCallbackBookKeeping.prototype, {
    destructor: function() {
        this.topLevelType = null;
        this.nativeEvent = null;
        this.ancestors.length = 0;
    }
});
$lM582.addPoolingTo($ca47ea46ba1d04b2$var$TopLevelCallbackBookKeeping, $lM582.twoArgumentPooler);
function $ca47ea46ba1d04b2$var$handleTopLevelImpl(bookKeeping) {
    var nativeEventTarget = $aNWE1(bookKeeping.nativeEvent);
    var targetInst = $5fGpM.getClosestInstanceFromNode(nativeEventTarget);
    // Loop through the hierarchy, in case there's any nested components.
    // It's important that we build the array of ancestors before calling any
    // event handlers, because event handlers can modify the DOM, leading to
    // inconsistencies with ReactMount's node cache. See #1105.
    var ancestor = targetInst;
    do {
        bookKeeping.ancestors.push(ancestor);
        ancestor = ancestor && $ca47ea46ba1d04b2$var$findParent(ancestor);
    }while (ancestor);
    for(var i = 0; i < bookKeeping.ancestors.length; i++){
        targetInst = bookKeeping.ancestors[i];
        $ca47ea46ba1d04b2$var$ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, $aNWE1(bookKeeping.nativeEvent));
    }
}
function $ca47ea46ba1d04b2$var$scrollValueMonitor(cb) {
    var scrollPosition = $7xzs2(window);
    cb(scrollPosition);
}
var $ca47ea46ba1d04b2$var$ReactEventListener = {
    _enabled: true,
    _handleTopLevel: null,
    WINDOW_HANDLE: $kx286.canUseDOM ? window : null,
    setHandleTopLevel: function(handleTopLevel) {
        $ca47ea46ba1d04b2$var$ReactEventListener._handleTopLevel = handleTopLevel;
    },
    setEnabled: function(enabled) {
        $ca47ea46ba1d04b2$var$ReactEventListener._enabled = !!enabled;
    },
    isEnabled: function() {
        return $ca47ea46ba1d04b2$var$ReactEventListener._enabled;
    },
    /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */ trapBubbledEvent: function(topLevelType, handlerBaseName, element) {
        if (!element) return null;
        return $knJhf.listen(element, handlerBaseName, $ca47ea46ba1d04b2$var$ReactEventListener.dispatchEvent.bind(null, topLevelType));
    },
    /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */ trapCapturedEvent: function(topLevelType, handlerBaseName, element) {
        if (!element) return null;
        return $knJhf.capture(element, handlerBaseName, $ca47ea46ba1d04b2$var$ReactEventListener.dispatchEvent.bind(null, topLevelType));
    },
    monitorScrollValue: function(refresh) {
        var callback = $ca47ea46ba1d04b2$var$scrollValueMonitor.bind(null, refresh);
        $knJhf.listen(window, "scroll", callback);
    },
    dispatchEvent: function(topLevelType, nativeEvent) {
        if (!$ca47ea46ba1d04b2$var$ReactEventListener._enabled) return;
        var bookKeeping = $ca47ea46ba1d04b2$var$TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
        try {
            // Event queue being processed in the same cycle allows
            // `preventDefault`.
            $gDXrr.batchedUpdates($ca47ea46ba1d04b2$var$handleTopLevelImpl, bookKeeping);
        } finally{
            $ca47ea46ba1d04b2$var$TopLevelCallbackBookKeeping.release(bookKeeping);
        }
    }
};
module.exports = $ca47ea46ba1d04b2$var$ReactEventListener;

});
parcelRegister("knJhf", function(module, exports) {
"use strict";

var $46CSh = parcelRequire("46CSh");
/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */ var $ed6913bde6dee2d6$var$EventListener = {
    /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */ listen: function listen(target, eventType, callback) {
        if (target.addEventListener) {
            target.addEventListener(eventType, callback, false);
            return {
                remove: function remove() {
                    target.removeEventListener(eventType, callback, false);
                }
            };
        } else if (target.attachEvent) {
            target.attachEvent("on" + eventType, callback);
            return {
                remove: function remove() {
                    target.detachEvent("on" + eventType, callback);
                }
            };
        }
    },
    /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */ capture: function capture(target, eventType, callback) {
        if (target.addEventListener) {
            target.addEventListener(eventType, callback, true);
            return {
                remove: function remove() {
                    target.removeEventListener(eventType, callback, true);
                }
            };
        } else return {
            remove: $46CSh
        };
    },
    registerDefault: function registerDefault() {}
};
module.exports = $ed6913bde6dee2d6$var$EventListener;

});

parcelRegister("7xzs2", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ "use strict";
/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */ function $57d71d52efb4ecf2$var$getUnboundedScrollPosition(scrollable) {
    if (scrollable.Window && scrollable instanceof scrollable.Window) return {
        x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
        y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
    return {
        x: scrollable.scrollLeft,
        y: scrollable.scrollTop
    };
}
module.exports = $57d71d52efb4ecf2$var$getUnboundedScrollPosition;

});


parcelRegister("jgTvI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $Uj2z8 = parcelRequire("Uj2z8");

var $53teI = parcelRequire("53teI");

var $9l8z5 = parcelRequire("9l8z5");

var $cpJSD = parcelRequire("cpJSD");

var $h6tCq = parcelRequire("h6tCq");

var $jugFn = parcelRequire("jugFn");

var $8JqAb = parcelRequire("8JqAb");

var $gDXrr = parcelRequire("gDXrr");
var $e07a9230004d6f7d$var$ReactInjection = {
    Component: $cpJSD.injection,
    DOMProperty: $Uj2z8.injection,
    EmptyComponent: $h6tCq.injection,
    EventPluginHub: $53teI.injection,
    EventPluginUtils: $9l8z5.injection,
    EventEmitter: $jugFn.injection,
    HostComponent: $8JqAb.injection,
    Updates: $gDXrr.injection
};
module.exports = $e07a9230004d6f7d$var$ReactInjection;

});

parcelRegister("BxkoC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $a6S4T = parcelRequire("a6S4T");

var $7QUwY = parcelRequire("7QUwY");

var $lM582 = parcelRequire("lM582");

var $jugFn = parcelRequire("jugFn");

var $hGZCz = parcelRequire("hGZCz");
parcelRequire("d1IRY");

var $2PXJf = parcelRequire("2PXJf");

var $8GGGt = parcelRequire("8GGGt");
/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */ var $070d4f0e82f3c782$var$SELECTION_RESTORATION = {
    /**
   * @return {Selection} Selection information.
   */ initialize: $hGZCz.getSelectionInformation,
    /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */ close: $hGZCz.restoreSelection
};
/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */ var $070d4f0e82f3c782$var$EVENT_SUPPRESSION = {
    /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */ initialize: function() {
        var currentlyEnabled = $jugFn.isEnabled();
        $jugFn.setEnabled(false);
        return currentlyEnabled;
    },
    /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */ close: function(previouslyEnabled) {
        $jugFn.setEnabled(previouslyEnabled);
    }
};
/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */ var $070d4f0e82f3c782$var$ON_DOM_READY_QUEUEING = {
    /**
   * Initializes the internal `onDOMReady` queue.
   */ initialize: function() {
        this.reactMountReady.reset();
    },
    /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */ close: function() {
        this.reactMountReady.notifyAll();
    }
};
/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */ var $070d4f0e82f3c782$var$TRANSACTION_WRAPPERS = [
    $070d4f0e82f3c782$var$SELECTION_RESTORATION,
    $070d4f0e82f3c782$var$EVENT_SUPPRESSION,
    $070d4f0e82f3c782$var$ON_DOM_READY_QUEUEING
];
/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */ function $070d4f0e82f3c782$var$ReactReconcileTransaction(useCreateElement) {
    this.reinitializeTransaction();
    // Only server-side rendering really needs this option (see
    // `ReactServerRendering`), but server-side uses
    // `ReactServerRenderingTransaction` instead. This option is here so that it's
    // accessible and defaults to false when `ReactDOMComponent` and
    // `ReactDOMTextComponent` checks it in `mountComponent`.`
    this.renderToStaticMarkup = false;
    this.reactMountReady = $7QUwY.getPooled(null);
    this.useCreateElement = useCreateElement;
}
var $070d4f0e82f3c782$var$Mixin = {
    /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */ getTransactionWrappers: function() {
        return $070d4f0e82f3c782$var$TRANSACTION_WRAPPERS;
    },
    /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */ getReactMountReady: function() {
        return this.reactMountReady;
    },
    /**
   * @return {object} The queue to collect React async events.
   */ getUpdateQueue: function() {
        return $8GGGt;
    },
    /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */ checkpoint: function() {
        // reactMountReady is the our only stateful wrapper
        return this.reactMountReady.checkpoint();
    },
    rollback: function(checkpoint) {
        this.reactMountReady.rollback(checkpoint);
    },
    /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */ destructor: function() {
        $7QUwY.release(this.reactMountReady);
        this.reactMountReady = null;
    }
};
$a6S4T($070d4f0e82f3c782$var$ReactReconcileTransaction.prototype, $2PXJf, $070d4f0e82f3c782$var$Mixin);
$lM582.addPoolingTo($070d4f0e82f3c782$var$ReactReconcileTransaction);
module.exports = $070d4f0e82f3c782$var$ReactReconcileTransaction;

});
parcelRegister("hGZCz", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $iDMfl = parcelRequire("iDMfl");

var $fYWy4 = parcelRequire("fYWy4");

var $i660C = parcelRequire("i660C");

var $7mp7N = parcelRequire("7mp7N");
function $ce162899c656d2f9$var$isInDocument(node) {
    return $fYWy4(document.documentElement, node);
}
/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ var $ce162899c656d2f9$var$ReactInputSelection = {
    hasSelectionCapabilities: function(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && elem.type === "text" || nodeName === "textarea" || elem.contentEditable === "true");
    },
    getSelectionInformation: function() {
        var focusedElem = $7mp7N();
        return {
            focusedElem: focusedElem,
            selectionRange: $ce162899c656d2f9$var$ReactInputSelection.hasSelectionCapabilities(focusedElem) ? $ce162899c656d2f9$var$ReactInputSelection.getSelection(focusedElem) : null
        };
    },
    /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */ restoreSelection: function(priorSelectionInformation) {
        var curFocusedElem = $7mp7N();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && $ce162899c656d2f9$var$isInDocument(priorFocusedElem)) {
            if ($ce162899c656d2f9$var$ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) $ce162899c656d2f9$var$ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
            $i660C(priorFocusedElem);
        }
    },
    /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */ getSelection: function(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === "input") {
            // IE8 input.
            var range = document.selection.createRange();
            // There can only be one selection per document in IE, so it must
            // be in our element.
            if (range.parentElement() === input) selection = {
                start: -range.moveStart("character", -input.value.length),
                end: -range.moveEnd("character", -input.value.length)
            };
        } else // Content editable or old IE textarea.
        selection = $iDMfl.getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    },
    /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */ setSelection: function(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === "input") {
            var range = input.createTextRange();
            range.collapse(true);
            range.moveStart("character", start);
            range.moveEnd("character", end - start);
            range.select();
        } else $iDMfl.setOffsets(input, offsets);
    }
};
module.exports = $ce162899c656d2f9$var$ReactInputSelection;

});
parcelRegister("iDMfl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $kx286 = parcelRequire("kx286");

var $6KUuK = parcelRequire("6KUuK");

var $eo8AR = parcelRequire("eo8AR");
/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */ function $d9214b48ce6e9e5c$var$isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
    return anchorNode === focusNode && anchorOffset === focusOffset;
}
/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */ function $d9214b48ce6e9e5c$var$getIEOffsets(node) {
    var selection = document.selection;
    var selectedRange = selection.createRange();
    var selectedLength = selectedRange.text.length;
    // Duplicate selection so we can move range without breaking user selection.
    var fromStart = selectedRange.duplicate();
    fromStart.moveToElementText(node);
    fromStart.setEndPoint("EndToStart", selectedRange);
    var startOffset = fromStart.text.length;
    var endOffset = startOffset + selectedLength;
    return {
        start: startOffset,
        end: endOffset
    };
}
/**
 * @param {DOMElement} node
 * @return {?object}
 */ function $d9214b48ce6e9e5c$var$getModernOffsets(node) {
    var selection = window.getSelection && window.getSelection();
    if (!selection || selection.rangeCount === 0) return null;
    var anchorNode = selection.anchorNode;
    var anchorOffset = selection.anchorOffset;
    var focusNode = selection.focusNode;
    var focusOffset = selection.focusOffset;
    var currentRange = selection.getRangeAt(0);
    // In Firefox, range.startContainer and range.endContainer can be "anonymous
    // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
    // divs do not seem to expose properties, triggering a "Permission denied
    // error" if any of its properties are accessed. The only seemingly possible
    // way to avoid erroring is to access a property that typically works for
    // non-anonymous divs and catch any error that may otherwise arise. See
    // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
    try {
        /* eslint-disable no-unused-expressions */ currentRange.startContainer.nodeType;
        currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */ } catch (e) {
        return null;
    }
    // If the node and offset values are the same, the selection is collapsed.
    // `Selection.isCollapsed` is available natively, but IE sometimes gets
    // this value wrong.
    var isSelectionCollapsed = $d9214b48ce6e9e5c$var$isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
    var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
    var tempRange = currentRange.cloneRange();
    tempRange.selectNodeContents(node);
    tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
    var isTempRangeCollapsed = $d9214b48ce6e9e5c$var$isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
    var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
    var end = start + rangeLength;
    // Detect whether the selection is backward.
    var detectionRange = document.createRange();
    detectionRange.setStart(anchorNode, anchorOffset);
    detectionRange.setEnd(focusNode, focusOffset);
    var isBackward = detectionRange.collapsed;
    return {
        start: isBackward ? end : start,
        end: isBackward ? start : end
    };
}
/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function $d9214b48ce6e9e5c$var$setIEOffsets(node, offsets) {
    var range = document.selection.createRange().duplicate();
    var start, end;
    if (offsets.end === undefined) {
        start = offsets.start;
        end = start;
    } else if (offsets.start > offsets.end) {
        start = offsets.end;
        end = offsets.start;
    } else {
        start = offsets.start;
        end = offsets.end;
    }
    range.moveToElementText(node);
    range.moveStart("character", start);
    range.setEndPoint("EndToStart", range);
    range.moveEnd("character", end - start);
    range.select();
}
/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function $d9214b48ce6e9e5c$var$setModernOffsets(node, offsets) {
    if (!window.getSelection) return;
    var selection = window.getSelection();
    var length = node[$eo8AR()].length;
    var start = Math.min(offsets.start, length);
    var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
    // IE 11 uses modern selection, but doesn't support the extend method.
    // Flip backward selections, so we can set with a single range.
    if (!selection.extend && start > end) {
        var temp = end;
        end = start;
        start = temp;
    }
    var startMarker = $6KUuK(node, start);
    var endMarker = $6KUuK(node, end);
    if (startMarker && endMarker) {
        var range = document.createRange();
        range.setStart(startMarker.node, startMarker.offset);
        selection.removeAllRanges();
        if (start > end) {
            selection.addRange(range);
            selection.extend(endMarker.node, endMarker.offset);
        } else {
            range.setEnd(endMarker.node, endMarker.offset);
            selection.addRange(range);
        }
    }
}
var $d9214b48ce6e9e5c$var$useIEOffsets = $kx286.canUseDOM && "selection" in document && !("getSelection" in window);
var $d9214b48ce6e9e5c$var$ReactDOMSelection = {
    /**
   * @param {DOMElement} node
   */ getOffsets: $d9214b48ce6e9e5c$var$useIEOffsets ? $d9214b48ce6e9e5c$var$getIEOffsets : $d9214b48ce6e9e5c$var$getModernOffsets,
    /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */ setOffsets: $d9214b48ce6e9e5c$var$useIEOffsets ? $d9214b48ce6e9e5c$var$setIEOffsets : $d9214b48ce6e9e5c$var$setModernOffsets
};
module.exports = $d9214b48ce6e9e5c$var$ReactDOMSelection;

});
parcelRegister("6KUuK", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function $4eb2dca7e595c3a3$var$getLeafNode(node) {
    while(node && node.firstChild)node = node.firstChild;
    return node;
}
/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function $4eb2dca7e595c3a3$var$getSiblingNode(node) {
    while(node){
        if (node.nextSibling) return node.nextSibling;
        node = node.parentNode;
    }
}
/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function $4eb2dca7e595c3a3$var$getNodeForCharacterOffset(root, offset) {
    var node = $4eb2dca7e595c3a3$var$getLeafNode(root);
    var nodeStart = 0;
    var nodeEnd = 0;
    while(node){
        if (node.nodeType === 3) {
            nodeEnd = nodeStart + node.textContent.length;
            if (nodeStart <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - nodeStart
            };
            nodeStart = nodeEnd;
        }
        node = $4eb2dca7e595c3a3$var$getLeafNode($4eb2dca7e595c3a3$var$getSiblingNode(node));
    }
}
module.exports = $4eb2dca7e595c3a3$var$getNodeForCharacterOffset;

});


parcelRegister("fYWy4", function(module, exports) {
"use strict";

var $b65i4 = parcelRequire("b65i4");
/*eslint-disable no-bitwise */ /**
 * Checks if a given DOM node contains or is another DOM node.
 */ function $ba29e01b6c1f8b10$var$containsNode(outerNode, innerNode) {
    if (!outerNode || !innerNode) return false;
    else if (outerNode === innerNode) return true;
    else if ($b65i4(outerNode)) return false;
    else if ($b65i4(innerNode)) return $ba29e01b6c1f8b10$var$containsNode(outerNode, innerNode.parentNode);
    else if ("contains" in outerNode) return outerNode.contains(innerNode);
    else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
    else return false;
}
module.exports = $ba29e01b6c1f8b10$var$containsNode;

});
parcelRegister("b65i4", function(module, exports) {
"use strict";

var $aKm84 = parcelRequire("aKm84");
/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */ function $81445bd89c4256a0$var$isTextNode(object) {
    return $aKm84(object) && object.nodeType == 3;
}
module.exports = $81445bd89c4256a0$var$isTextNode;

});
parcelRegister("aKm84", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ /**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */ function $7d2f5da98cd0e8b1$var$isNode(object) {
    var doc = object ? object.ownerDocument || object : document;
    var defaultView = doc.defaultView || window;
    return !!(object && (typeof defaultView.Node === "function" ? object instanceof defaultView.Node : typeof object === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string"));
}
module.exports = $7d2f5da98cd0e8b1$var$isNode;

});



parcelRegister("7mp7N", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ /* eslint-disable fb-www/typeof-undefined */ /**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */ function $55be13b52248235b$var$getActiveElement(doc) /*?DOMElement*/ {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
module.exports = $55be13b52248235b$var$getActiveElement;

});



parcelRegister("chlm2", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
var $8f07a31d06e858ec$var$NS = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var $8f07a31d06e858ec$var$ATTRS = {
    accentHeight: "accent-height",
    accumulate: 0,
    additive: 0,
    alignmentBaseline: "alignment-baseline",
    allowReorder: "allowReorder",
    alphabetic: 0,
    amplitude: 0,
    arabicForm: "arabic-form",
    ascent: 0,
    attributeName: "attributeName",
    attributeType: "attributeType",
    autoReverse: "autoReverse",
    azimuth: 0,
    baseFrequency: "baseFrequency",
    baseProfile: "baseProfile",
    baselineShift: "baseline-shift",
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: "calcMode",
    capHeight: "cap-height",
    clip: 0,
    clipPath: "clip-path",
    clipRule: "clip-rule",
    clipPathUnits: "clipPathUnits",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    contentScriptType: "contentScriptType",
    contentStyleType: "contentStyleType",
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: "diffuseConstant",
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: "dominant-baseline",
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: "edgeMode",
    elevation: 0,
    enableBackground: "enable-background",
    end: 0,
    exponent: 0,
    externalResourcesRequired: "externalResourcesRequired",
    fill: 0,
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    filter: 0,
    filterRes: "filterRes",
    filterUnits: "filterUnits",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    focusable: 0,
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    glyphRef: "glyphRef",
    gradientTransform: "gradientTransform",
    gradientUnits: "gradientUnits",
    hanging: 0,
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    ideographic: 0,
    imageRendering: "image-rendering",
    "in": 0,
    in2: 0,
    intercept: 0,
    k: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    kernelMatrix: "kernelMatrix",
    kernelUnitLength: "kernelUnitLength",
    kerning: 0,
    keyPoints: "keyPoints",
    keySplines: "keySplines",
    keyTimes: "keyTimes",
    lengthAdjust: "lengthAdjust",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    limitingConeAngle: "limitingConeAngle",
    local: 0,
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    markerHeight: "markerHeight",
    markerUnits: "markerUnits",
    markerWidth: "markerWidth",
    mask: 0,
    maskContentUnits: "maskContentUnits",
    maskUnits: "maskUnits",
    mathematical: 0,
    mode: 0,
    numOctaves: "numOctaves",
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pathLength: "pathLength",
    patternContentUnits: "patternContentUnits",
    patternTransform: "patternTransform",
    patternUnits: "patternUnits",
    pointerEvents: "pointer-events",
    points: 0,
    pointsAtX: "pointsAtX",
    pointsAtY: "pointsAtY",
    pointsAtZ: "pointsAtZ",
    preserveAlpha: "preserveAlpha",
    preserveAspectRatio: "preserveAspectRatio",
    primitiveUnits: "primitiveUnits",
    r: 0,
    radius: 0,
    refX: "refX",
    refY: "refY",
    renderingIntent: "rendering-intent",
    repeatCount: "repeatCount",
    repeatDur: "repeatDur",
    requiredExtensions: "requiredExtensions",
    requiredFeatures: "requiredFeatures",
    restart: 0,
    result: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    seed: 0,
    shapeRendering: "shape-rendering",
    slope: 0,
    spacing: 0,
    specularConstant: "specularConstant",
    specularExponent: "specularExponent",
    speed: 0,
    spreadMethod: "spreadMethod",
    startOffset: "startOffset",
    stdDeviation: "stdDeviation",
    stemh: 0,
    stemv: 0,
    stitchTiles: "stitchTiles",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    string: 0,
    stroke: 0,
    strokeDasharray: "stroke-dasharray",
    strokeDashoffset: "stroke-dashoffset",
    strokeLinecap: "stroke-linecap",
    strokeLinejoin: "stroke-linejoin",
    strokeMiterlimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    surfaceScale: "surfaceScale",
    systemLanguage: "systemLanguage",
    tableValues: "tableValues",
    targetX: "targetX",
    targetY: "targetY",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    textLength: "textLength",
    to: 0,
    transform: 0,
    u1: 0,
    u2: 0,
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicode: 0,
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    values: 0,
    vectorEffect: "vector-effect",
    version: 0,
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    viewBox: "viewBox",
    viewTarget: "viewTarget",
    visibility: 0,
    widths: 0,
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    x: 0,
    xHeight: "x-height",
    x1: 0,
    x2: 0,
    xChannelSelector: "xChannelSelector",
    xlinkActuate: "xlink:actuate",
    xlinkArcrole: "xlink:arcrole",
    xlinkHref: "xlink:href",
    xlinkRole: "xlink:role",
    xlinkShow: "xlink:show",
    xlinkTitle: "xlink:title",
    xlinkType: "xlink:type",
    xmlBase: "xml:base",
    xmlns: 0,
    xmlnsXlink: "xmlns:xlink",
    xmlLang: "xml:lang",
    xmlSpace: "xml:space",
    y: 0,
    y1: 0,
    y2: 0,
    yChannelSelector: "yChannelSelector",
    z: 0,
    zoomAndPan: "zoomAndPan"
};
var $8f07a31d06e858ec$var$SVGDOMPropertyConfig = {
    Properties: {},
    DOMAttributeNamespaces: {
        xlinkActuate: $8f07a31d06e858ec$var$NS.xlink,
        xlinkArcrole: $8f07a31d06e858ec$var$NS.xlink,
        xlinkHref: $8f07a31d06e858ec$var$NS.xlink,
        xlinkRole: $8f07a31d06e858ec$var$NS.xlink,
        xlinkShow: $8f07a31d06e858ec$var$NS.xlink,
        xlinkTitle: $8f07a31d06e858ec$var$NS.xlink,
        xlinkType: $8f07a31d06e858ec$var$NS.xlink,
        xmlBase: $8f07a31d06e858ec$var$NS.xml,
        xmlLang: $8f07a31d06e858ec$var$NS.xml,
        xmlSpace: $8f07a31d06e858ec$var$NS.xml
    },
    DOMAttributeNames: {}
};
Object.keys($8f07a31d06e858ec$var$ATTRS).forEach(function(key) {
    $8f07a31d06e858ec$var$SVGDOMPropertyConfig.Properties[key] = 0;
    if ($8f07a31d06e858ec$var$ATTRS[key]) $8f07a31d06e858ec$var$SVGDOMPropertyConfig.DOMAttributeNames[key] = $8f07a31d06e858ec$var$ATTRS[key];
});
module.exports = $8f07a31d06e858ec$var$SVGDOMPropertyConfig;

});

parcelRegister("3b16B", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $1lzph = parcelRequire("1lzph");

var $kx286 = parcelRequire("kx286");

var $5fGpM = parcelRequire("5fGpM");

var $hGZCz = parcelRequire("hGZCz");

var $6CUXY = parcelRequire("6CUXY");

var $7mp7N = parcelRequire("7mp7N");

var $2qW9o = parcelRequire("2qW9o");

var $el2AU = parcelRequire("el2AU");
var $250341b236109624$var$skipSelectionChangeEvent = $kx286.canUseDOM && "documentMode" in document && document.documentMode <= 11;
var $250341b236109624$var$eventTypes = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: [
            "topBlur",
            "topContextMenu",
            "topFocus",
            "topKeyDown",
            "topKeyUp",
            "topMouseDown",
            "topMouseUp",
            "topSelectionChange"
        ]
    }
};
var $250341b236109624$var$activeElement = null;
var $250341b236109624$var$activeElementInst = null;
var $250341b236109624$var$lastSelection = null;
var $250341b236109624$var$mouseDown = false;
// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var $250341b236109624$var$hasListener = false;
/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */ function $250341b236109624$var$getSelection(node) {
    if ("selectionStart" in node && $hGZCz.hasSelectionCapabilities(node)) return {
        start: node.selectionStart,
        end: node.selectionEnd
    };
    else if (window.getSelection) {
        var selection = window.getSelection();
        return {
            anchorNode: selection.anchorNode,
            anchorOffset: selection.anchorOffset,
            focusNode: selection.focusNode,
            focusOffset: selection.focusOffset
        };
    } else if (document.selection) {
        var range = document.selection.createRange();
        return {
            parentElement: range.parentElement(),
            text: range.text,
            top: range.boundingTop,
            left: range.boundingLeft
        };
    }
}
/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */ function $250341b236109624$var$constructSelectEvent(nativeEvent, nativeEventTarget) {
    // Ensure we have the right element, and that the user is not dragging a
    // selection (this matches native `select` event behavior). In HTML5, select
    // fires only on input and textarea thus if there's no focused element we
    // won't dispatch.
    if ($250341b236109624$var$mouseDown || $250341b236109624$var$activeElement == null || $250341b236109624$var$activeElement !== $7mp7N()) return null;
    // Only fire when selection has actually changed.
    var currentSelection = $250341b236109624$var$getSelection($250341b236109624$var$activeElement);
    if (!$250341b236109624$var$lastSelection || !$el2AU($250341b236109624$var$lastSelection, currentSelection)) {
        $250341b236109624$var$lastSelection = currentSelection;
        var syntheticEvent = $6CUXY.getPooled($250341b236109624$var$eventTypes.select, $250341b236109624$var$activeElementInst, nativeEvent, nativeEventTarget);
        syntheticEvent.type = "select";
        syntheticEvent.target = $250341b236109624$var$activeElement;
        $1lzph.accumulateTwoPhaseDispatches(syntheticEvent);
        return syntheticEvent;
    }
    return null;
}
/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ var $250341b236109624$var$SelectEventPlugin = {
    eventTypes: $250341b236109624$var$eventTypes,
    extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        if (!$250341b236109624$var$hasListener) return null;
        var targetNode = targetInst ? $5fGpM.getNodeFromInstance(targetInst) : window;
        switch(topLevelType){
            // Track the input node that has focus.
            case "topFocus":
                if ($2qW9o(targetNode) || targetNode.contentEditable === "true") {
                    $250341b236109624$var$activeElement = targetNode;
                    $250341b236109624$var$activeElementInst = targetInst;
                    $250341b236109624$var$lastSelection = null;
                }
                break;
            case "topBlur":
                $250341b236109624$var$activeElement = null;
                $250341b236109624$var$activeElementInst = null;
                $250341b236109624$var$lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "topMouseDown":
                $250341b236109624$var$mouseDown = true;
                break;
            case "topContextMenu":
            case "topMouseUp":
                $250341b236109624$var$mouseDown = false;
                return $250341b236109624$var$constructSelectEvent(nativeEvent, nativeEventTarget);
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "topSelectionChange":
                if ($250341b236109624$var$skipSelectionChangeEvent) break;
            // falls through
            case "topKeyDown":
            case "topKeyUp":
                return $250341b236109624$var$constructSelectEvent(nativeEvent, nativeEventTarget);
        }
        return null;
    },
    didPutListener: function(inst, registrationName, listener) {
        if (registrationName === "onSelect") $250341b236109624$var$hasListener = true;
    }
};
module.exports = $250341b236109624$var$SelectEventPlugin;

});

parcelRegister("k1qrz", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $knJhf = parcelRequire("knJhf");

var $1lzph = parcelRequire("1lzph");

var $5fGpM = parcelRequire("5fGpM");

var $2Lt6k = parcelRequire("2Lt6k");

var $1AIBf = parcelRequire("1AIBf");

var $6CUXY = parcelRequire("6CUXY");

var $k4v8o = parcelRequire("k4v8o");

var $d5bY2 = parcelRequire("d5bY2");

var $fCyn6 = parcelRequire("fCyn6");

var $jBMXm = parcelRequire("jBMXm");

var $lAhGr = parcelRequire("lAhGr");

var $1e8rX = parcelRequire("1e8rX");

var $fPGeq = parcelRequire("fPGeq");

var $abfIC = parcelRequire("abfIC");

var $46CSh = parcelRequire("46CSh");

var $60GHK = parcelRequire("60GHK");
parcelRequire("4Mb5c");
/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */ var $e93869d5514984ec$var$eventTypes = {};
var $e93869d5514984ec$var$topLevelEventsToDispatchConfig = {};
[
    "abort",
    "animationEnd",
    "animationIteration",
    "animationStart",
    "blur",
    "canPlay",
    "canPlayThrough",
    "click",
    "contextMenu",
    "copy",
    "cut",
    "doubleClick",
    "drag",
    "dragEnd",
    "dragEnter",
    "dragExit",
    "dragLeave",
    "dragOver",
    "dragStart",
    "drop",
    "durationChange",
    "emptied",
    "encrypted",
    "ended",
    "error",
    "focus",
    "input",
    "invalid",
    "keyDown",
    "keyPress",
    "keyUp",
    "load",
    "loadedData",
    "loadedMetadata",
    "loadStart",
    "mouseDown",
    "mouseMove",
    "mouseOut",
    "mouseOver",
    "mouseUp",
    "paste",
    "pause",
    "play",
    "playing",
    "progress",
    "rateChange",
    "reset",
    "scroll",
    "seeked",
    "seeking",
    "stalled",
    "submit",
    "suspend",
    "timeUpdate",
    "touchCancel",
    "touchEnd",
    "touchMove",
    "touchStart",
    "transitionEnd",
    "volumeChange",
    "waiting",
    "wheel"
].forEach(function(event) {
    var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
    var onEvent = "on" + capitalizedEvent;
    var topEvent = "top" + capitalizedEvent;
    var type = {
        phasedRegistrationNames: {
            bubbled: onEvent,
            captured: onEvent + "Capture"
        },
        dependencies: [
            topEvent
        ]
    };
    $e93869d5514984ec$var$eventTypes[event] = type;
    $e93869d5514984ec$var$topLevelEventsToDispatchConfig[topEvent] = type;
});
var $e93869d5514984ec$var$onClickListeners = {};
function $e93869d5514984ec$var$getDictionaryKey(inst) {
    // Prevents V8 performance issue:
    // https://github.com/facebook/react/pull/7232
    return "." + inst._rootNodeID;
}
function $e93869d5514984ec$var$isInteractive(tag) {
    return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
}
var $e93869d5514984ec$var$SimpleEventPlugin = {
    eventTypes: $e93869d5514984ec$var$eventTypes,
    extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        var dispatchConfig = $e93869d5514984ec$var$topLevelEventsToDispatchConfig[topLevelType];
        if (!dispatchConfig) return null;
        var EventConstructor;
        switch(topLevelType){
            case "topAbort":
            case "topCanPlay":
            case "topCanPlayThrough":
            case "topDurationChange":
            case "topEmptied":
            case "topEncrypted":
            case "topEnded":
            case "topError":
            case "topInput":
            case "topInvalid":
            case "topLoad":
            case "topLoadedData":
            case "topLoadedMetadata":
            case "topLoadStart":
            case "topPause":
            case "topPlay":
            case "topPlaying":
            case "topProgress":
            case "topRateChange":
            case "topReset":
            case "topSeeked":
            case "topSeeking":
            case "topStalled":
            case "topSubmit":
            case "topSuspend":
            case "topTimeUpdate":
            case "topVolumeChange":
            case "topWaiting":
                // HTML Events
                // @see http://www.w3.org/TR/html5/index.html#events-0
                EventConstructor = $6CUXY;
                break;
            case "topKeyPress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if ($60GHK(nativeEvent) === 0) return null;
            /* falls through */ case "topKeyDown":
            case "topKeyUp":
                EventConstructor = $d5bY2;
                break;
            case "topBlur":
            case "topFocus":
                EventConstructor = $k4v8o;
                break;
            case "topClick":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return null;
            /* falls through */ case "topDoubleClick":
            case "topMouseDown":
            case "topMouseMove":
            case "topMouseUp":
            // TODO: Disabled elements should not respond to mouse events
            /* falls through */ case "topMouseOut":
            case "topMouseOver":
            case "topContextMenu":
                EventConstructor = $fCyn6;
                break;
            case "topDrag":
            case "topDragEnd":
            case "topDragEnter":
            case "topDragExit":
            case "topDragLeave":
            case "topDragOver":
            case "topDragStart":
            case "topDrop":
                EventConstructor = $jBMXm;
                break;
            case "topTouchCancel":
            case "topTouchEnd":
            case "topTouchMove":
            case "topTouchStart":
                EventConstructor = $lAhGr;
                break;
            case "topAnimationEnd":
            case "topAnimationIteration":
            case "topAnimationStart":
                EventConstructor = $2Lt6k;
                break;
            case "topTransitionEnd":
                EventConstructor = $1e8rX;
                break;
            case "topScroll":
                EventConstructor = $fPGeq;
                break;
            case "topWheel":
                EventConstructor = $abfIC;
                break;
            case "topCopy":
            case "topCut":
            case "topPaste":
                EventConstructor = $1AIBf;
                break;
        }
        !EventConstructor && $jOpPq("86", topLevelType);
        var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
        $1lzph.accumulateTwoPhaseDispatches(event);
        return event;
    },
    didPutListener: function(inst, registrationName, listener) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        if (registrationName === "onClick" && !$e93869d5514984ec$var$isInteractive(inst._tag)) {
            var key = $e93869d5514984ec$var$getDictionaryKey(inst);
            var node = $5fGpM.getNodeFromInstance(inst);
            if (!$e93869d5514984ec$var$onClickListeners[key]) $e93869d5514984ec$var$onClickListeners[key] = $knJhf.listen(node, "click", $46CSh);
        }
    },
    willDeleteListener: function(inst, registrationName) {
        if (registrationName === "onClick" && !$e93869d5514984ec$var$isInteractive(inst._tag)) {
            var key = $e93869d5514984ec$var$getDictionaryKey(inst);
            $e93869d5514984ec$var$onClickListeners[key].remove();
            delete $e93869d5514984ec$var$onClickListeners[key];
        }
    }
};
module.exports = $e93869d5514984ec$var$SimpleEventPlugin;

});
parcelRegister("2Lt6k", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $6CUXY = parcelRequire("6CUXY");
/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var $20368b72c845aeb1$var$AnimationEventInterface = {
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
};
/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */ function $20368b72c845aeb1$var$SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
    return $6CUXY.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}
$6CUXY.augmentClass($20368b72c845aeb1$var$SyntheticAnimationEvent, $20368b72c845aeb1$var$AnimationEventInterface);
module.exports = $20368b72c845aeb1$var$SyntheticAnimationEvent;

});

parcelRegister("1AIBf", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $6CUXY = parcelRequire("6CUXY");
/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var $128bbfd36ed2810b$var$ClipboardEventInterface = {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
};
/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */ function $128bbfd36ed2810b$var$SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
    return $6CUXY.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}
$6CUXY.augmentClass($128bbfd36ed2810b$var$SyntheticClipboardEvent, $128bbfd36ed2810b$var$ClipboardEventInterface);
module.exports = $128bbfd36ed2810b$var$SyntheticClipboardEvent;

});

parcelRegister("k4v8o", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $fPGeq = parcelRequire("fPGeq");
/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var $e9cc54fdb8d1fc25$var$FocusEventInterface = {
    relatedTarget: null
};
/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */ function $e9cc54fdb8d1fc25$var$SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
    return $fPGeq.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}
$fPGeq.augmentClass($e9cc54fdb8d1fc25$var$SyntheticFocusEvent, $e9cc54fdb8d1fc25$var$FocusEventInterface);
module.exports = $e9cc54fdb8d1fc25$var$SyntheticFocusEvent;

});

parcelRegister("d5bY2", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $fPGeq = parcelRequire("fPGeq");

var $60GHK = parcelRequire("60GHK");

var $2Wh8Y = parcelRequire("2Wh8Y");

var $a01SI = parcelRequire("a01SI");
/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var $9865066f1bfab5fa$var$KeyboardEventInterface = {
    key: $2Wh8Y,
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: $a01SI,
    // Legacy Interface
    charCode: function(event) {
        // `charCode` is the result of a KeyPress event and represents the value of
        // the actual printable character.
        // KeyPress is deprecated, but its replacement is not yet final and not
        // implemented in any major browser. Only KeyPress has charCode.
        if (event.type === "keypress") return $60GHK(event);
        return 0;
    },
    keyCode: function(event) {
        // `keyCode` is the result of a KeyDown/Up event and represents the value of
        // physical keyboard key.
        // The actual meaning of the value depends on the users' keyboard layout
        // which cannot be detected. Assuming that it is a US keyboard layout
        // provides a surprisingly accurate mapping for US and European users.
        // Due to this, it is left to the user to implement at this time.
        if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
        return 0;
    },
    which: function(event) {
        // `which` is an alias for either `keyCode` or `charCode` depending on the
        // type of the event.
        if (event.type === "keypress") return $60GHK(event);
        if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
        return 0;
    }
};
/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */ function $9865066f1bfab5fa$var$SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
    return $fPGeq.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}
$fPGeq.augmentClass($9865066f1bfab5fa$var$SyntheticKeyboardEvent, $9865066f1bfab5fa$var$KeyboardEventInterface);
module.exports = $9865066f1bfab5fa$var$SyntheticKeyboardEvent;

});
parcelRegister("60GHK", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function $4603de6e3072d26d$var$getEventCharCode(nativeEvent) {
    var charCode;
    var keyCode = nativeEvent.keyCode;
    if ("charCode" in nativeEvent) {
        charCode = nativeEvent.charCode;
        // FF does not set `charCode` for the Enter-key, check against `keyCode`.
        if (charCode === 0 && keyCode === 13) charCode = 13;
    } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
    // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
    // Must not discard the (non-)printable Enter-key.
    if (charCode >= 32 || charCode === 13) return charCode;
    return 0;
}
module.exports = $4603de6e3072d26d$var$getEventCharCode;

});

parcelRegister("2Wh8Y", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $60GHK = parcelRequire("60GHK");
/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var $223e4beed3a4fe90$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
};
/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var $223e4beed3a4fe90$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
};
/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function $223e4beed3a4fe90$var$getEventKey(nativeEvent) {
    if (nativeEvent.key) {
        // Normalize inconsistent values reported by browsers due to
        // implementations of a working draft specification.
        // FireFox implements `key` but returns `MozPrintableKey` for all
        // printable characters (normalized to `Unidentified`), ignore it.
        var key = $223e4beed3a4fe90$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
        if (key !== "Unidentified") return key;
    }
    // Browser does not implement `key`, polyfill as much of it as we can.
    if (nativeEvent.type === "keypress") {
        var charCode = $60GHK(nativeEvent);
        // The enter-key is technically both printable and non-printable and can
        // thus be captured by `keypress`, no other non-printable key should.
        return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
    }
    if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return $223e4beed3a4fe90$var$translateToKey[nativeEvent.keyCode] || "Unidentified";
    return "";
}
module.exports = $223e4beed3a4fe90$var$getEventKey;

});


parcelRegister("jBMXm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $fCyn6 = parcelRequire("fCyn6");
/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var $e46772bb6752f98f$var$DragEventInterface = {
    dataTransfer: null
};
/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */ function $e46772bb6752f98f$var$SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
    return $fCyn6.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}
$fCyn6.augmentClass($e46772bb6752f98f$var$SyntheticDragEvent, $e46772bb6752f98f$var$DragEventInterface);
module.exports = $e46772bb6752f98f$var$SyntheticDragEvent;

});

parcelRegister("lAhGr", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $fPGeq = parcelRequire("fPGeq");

var $a01SI = parcelRequire("a01SI");
/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var $fb6aad546070d8fc$var$TouchEventInterface = {
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: $a01SI
};
/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */ function $fb6aad546070d8fc$var$SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
    return $fPGeq.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}
$fPGeq.augmentClass($fb6aad546070d8fc$var$SyntheticTouchEvent, $fb6aad546070d8fc$var$TouchEventInterface);
module.exports = $fb6aad546070d8fc$var$SyntheticTouchEvent;

});

parcelRegister("1e8rX", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $6CUXY = parcelRequire("6CUXY");
/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var $0e4da73d09834f9b$var$TransitionEventInterface = {
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
};
/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */ function $0e4da73d09834f9b$var$SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
    return $6CUXY.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}
$6CUXY.augmentClass($0e4da73d09834f9b$var$SyntheticTransitionEvent, $0e4da73d09834f9b$var$TransitionEventInterface);
module.exports = $0e4da73d09834f9b$var$SyntheticTransitionEvent;

});

parcelRegister("abfIC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $fCyn6 = parcelRequire("fCyn6");
/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var $76971fd8cc05c9ab$var$WheelEventInterface = {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: null,
    // Browsers without "deltaMode" is reporting in raw wheel delta where one
    // notch on the scroll is always +/- 120, roughly equivalent to pixels.
    // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
    // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
    deltaMode: null
};
/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */ function $76971fd8cc05c9ab$var$SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
    return $fCyn6.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}
$fCyn6.augmentClass($76971fd8cc05c9ab$var$SyntheticWheelEvent, $76971fd8cc05c9ab$var$WheelEventInterface);
module.exports = $76971fd8cc05c9ab$var$SyntheticWheelEvent;

});



parcelRegister("50Cxn", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");

var $QV5G5 = parcelRequire("QV5G5");

var $Uj2z8 = parcelRequire("Uj2z8");

var $eW0mB = parcelRequire("eW0mB");

var $jugFn = parcelRequire("jugFn");
parcelRequire("6qU6G");

var $5fGpM = parcelRequire("5fGpM");

var $iHWQ0 = parcelRequire("iHWQ0");

var $325v6 = parcelRequire("325v6");

var $isyRe = parcelRequire("isyRe");

var $adVZ1 = parcelRequire("adVZ1");
parcelRequire("d1IRY");

var $5KA59 = parcelRequire("5KA59");

var $5Kdrw = parcelRequire("5Kdrw");

var $8GGGt = parcelRequire("8GGGt");

var $gDXrr = parcelRequire("gDXrr");

var $X5IzL = parcelRequire("X5IzL");

var $14nb3 = parcelRequire("14nb3");
parcelRequire("4Mb5c");

var $1dgCK = parcelRequire("1dgCK");

var $14WBm = parcelRequire("14WBm");
parcelRequire("fIzgz");
var $3a5ad88b6558b913$var$ATTR_NAME = $Uj2z8.ID_ATTRIBUTE_NAME;
var $3a5ad88b6558b913$var$ROOT_ATTR_NAME = $Uj2z8.ROOT_ATTRIBUTE_NAME;
var $3a5ad88b6558b913$var$ELEMENT_NODE_TYPE = 1;
var $3a5ad88b6558b913$var$DOC_NODE_TYPE = 9;
var $3a5ad88b6558b913$var$DOCUMENT_FRAGMENT_NODE_TYPE = 11;
var $3a5ad88b6558b913$var$instancesByReactRootID = {};
/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */ function $3a5ad88b6558b913$var$firstDifferenceIndex(string1, string2) {
    var minLen = Math.min(string1.length, string2.length);
    for(var i = 0; i < minLen; i++){
        if (string1.charAt(i) !== string2.charAt(i)) return i;
    }
    return string1.length === string2.length ? -1 : minLen;
}
/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */ function $3a5ad88b6558b913$var$getReactRootElementInContainer(container) {
    if (!container) return null;
    if (container.nodeType === $3a5ad88b6558b913$var$DOC_NODE_TYPE) return container.documentElement;
    else return container.firstChild;
}
function $3a5ad88b6558b913$var$internalGetID(node) {
    // If node is something like a window, document, or text node, none of
    // which support attributes or a .getAttribute method, gracefully return
    // the empty string, as if the attribute were missing.
    return node.getAttribute && node.getAttribute($3a5ad88b6558b913$var$ATTR_NAME) || "";
}
/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */ function $3a5ad88b6558b913$var$mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
    var markerName;
    if ($isyRe.logTopLevelRenders) {
        var wrappedElement = wrapperInstance._currentElement.props.child;
        var type = wrappedElement.type;
        markerName = "React mount: " + (typeof type === "string" ? type : type.displayName || type.name);
        console.time(markerName);
    }
    var markup = $5Kdrw.mountComponent(wrapperInstance, transaction, null, $iHWQ0(wrapperInstance, container), context, 0 /* parentDebugID */ );
    if (markerName) console.timeEnd(markerName);
    wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
    $3a5ad88b6558b913$var$ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}
/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */ function $3a5ad88b6558b913$var$batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
    var transaction = $gDXrr.ReactReconcileTransaction.getPooled(/* useCreateElement */ !shouldReuseMarkup && $325v6.useCreateElement);
    transaction.perform($3a5ad88b6558b913$var$mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
    $gDXrr.ReactReconcileTransaction.release(transaction);
}
/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */ function $3a5ad88b6558b913$var$unmountComponentFromNode(instance, container, safely) {
    $5Kdrw.unmountComponent(instance, safely);
    if (container.nodeType === $3a5ad88b6558b913$var$DOC_NODE_TYPE) container = container.documentElement;
    // http://jsperf.com/emptying-a-node
    while(container.lastChild)container.removeChild(container.lastChild);
}
/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */ function $3a5ad88b6558b913$var$hasNonRootReactChild(container) {
    var rootEl = $3a5ad88b6558b913$var$getReactRootElementInContainer(container);
    if (rootEl) {
        var inst = $5fGpM.getInstanceFromNode(rootEl);
        return !!(inst && inst._hostParent);
    }
}
/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */ function $3a5ad88b6558b913$var$nodeIsRenderedByOtherInstance(container) {
    var rootEl = $3a5ad88b6558b913$var$getReactRootElementInContainer(container);
    return !!(rootEl && $3a5ad88b6558b913$var$isReactNode(rootEl) && !$5fGpM.getInstanceFromNode(rootEl));
}
/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */ function $3a5ad88b6558b913$var$isValidContainer(node) {
    return !!(node && (node.nodeType === $3a5ad88b6558b913$var$ELEMENT_NODE_TYPE || node.nodeType === $3a5ad88b6558b913$var$DOC_NODE_TYPE || node.nodeType === $3a5ad88b6558b913$var$DOCUMENT_FRAGMENT_NODE_TYPE));
}
/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */ function $3a5ad88b6558b913$var$isReactNode(node) {
    return $3a5ad88b6558b913$var$isValidContainer(node) && (node.hasAttribute($3a5ad88b6558b913$var$ROOT_ATTR_NAME) || node.hasAttribute($3a5ad88b6558b913$var$ATTR_NAME));
}
function $3a5ad88b6558b913$var$getHostRootInstanceInContainer(container) {
    var rootEl = $3a5ad88b6558b913$var$getReactRootElementInContainer(container);
    var prevHostInstance = rootEl && $5fGpM.getInstanceFromNode(rootEl);
    return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}
function $3a5ad88b6558b913$var$getTopLevelWrapperInContainer(container) {
    var root = $3a5ad88b6558b913$var$getHostRootInstanceInContainer(container);
    return root ? root._hostContainerInfo._topLevelWrapper : null;
}
/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */ var $3a5ad88b6558b913$var$topLevelRootCounter = 1;
var $3a5ad88b6558b913$var$TopLevelWrapper = function() {
    this.rootID = $3a5ad88b6558b913$var$topLevelRootCounter++;
};
$3a5ad88b6558b913$var$TopLevelWrapper.prototype.isReactComponent = {};
$3a5ad88b6558b913$var$TopLevelWrapper.prototype.render = function() {
    return this.props.child;
};
$3a5ad88b6558b913$var$TopLevelWrapper.isReactTopLevelWrapper = true;
/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */ var $3a5ad88b6558b913$var$ReactMount = {
    TopLevelWrapper: $3a5ad88b6558b913$var$TopLevelWrapper,
    /**
   * Used by devtools. The keys are not important.
   */ _instancesByReactRootID: $3a5ad88b6558b913$var$instancesByReactRootID,
    /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */ scrollMonitor: function(container, renderCallback) {
        renderCallback();
    },
    /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */ _updateRootComponent: function(prevComponent, nextElement, nextContext, container, callback) {
        $3a5ad88b6558b913$var$ReactMount.scrollMonitor(container, function() {
            $8GGGt.enqueueElementInternal(prevComponent, nextElement, nextContext);
            if (callback) $8GGGt.enqueueCallbackInternal(prevComponent, callback);
        });
        return prevComponent;
    },
    /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */ _renderNewRootComponent: function(nextElement, container, shouldReuseMarkup, context) {
        !$3a5ad88b6558b913$var$isValidContainer(container) && $jOpPq("37");
        $jugFn.ensureScrollValueMonitoring();
        var componentInstance = $14nb3(nextElement, false);
        // The initial render is synchronous but any updates that happen during
        // rendering, in componentWillMount or componentDidMount, will be batched
        // according to the current batching strategy.
        $gDXrr.batchedUpdates($3a5ad88b6558b913$var$batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
        var wrapperID = componentInstance._instance.rootID;
        $3a5ad88b6558b913$var$instancesByReactRootID[wrapperID] = componentInstance;
        return componentInstance;
    },
    /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */ renderSubtreeIntoContainer: function(parentComponent, nextElement, container, callback) {
        !(parentComponent != null && $adVZ1.has(parentComponent)) && $jOpPq("38");
        return $3a5ad88b6558b913$var$ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
    },
    _renderSubtreeIntoContainer: function(parentComponent, nextElement, container, callback) {
        $8GGGt.validateCallback(callback, "ReactDOM.render");
        !$eW0mB.isValidElement(nextElement) && $jOpPq("39", typeof nextElement === "string" ? " Instead of passing a string like 'div', pass React.createElement('div') or <div />." : typeof nextElement === "function" ? " Instead of passing a class like Foo, pass React.createElement(Foo) or <Foo />." : nextElement != null && nextElement.props !== undefined ? " This may be caused by unintentionally loading two independent copies of React." : "");
        var nextWrappedElement = $eW0mB.createElement($3a5ad88b6558b913$var$TopLevelWrapper, {
            child: nextElement
        });
        var nextContext;
        if (parentComponent) {
            var parentInst = $adVZ1.get(parentComponent);
            nextContext = parentInst._processChildContext(parentInst._context);
        } else nextContext = $X5IzL;
        var prevComponent = $3a5ad88b6558b913$var$getTopLevelWrapperInContainer(container);
        if (prevComponent) {
            var prevWrappedElement = prevComponent._currentElement;
            var prevElement = prevWrappedElement.props.child;
            if ($14WBm(prevElement, nextElement)) {
                var publicInst = prevComponent._renderedComponent.getPublicInstance();
                var updatedCallback = callback && function() {
                    callback.call(publicInst);
                };
                $3a5ad88b6558b913$var$ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
                return publicInst;
            } else $3a5ad88b6558b913$var$ReactMount.unmountComponentAtNode(container);
        }
        var reactRootElement = $3a5ad88b6558b913$var$getReactRootElementInContainer(container);
        var containerHasReactMarkup = reactRootElement && !!$3a5ad88b6558b913$var$internalGetID(reactRootElement);
        var containerHasNonRootReactChild = $3a5ad88b6558b913$var$hasNonRootReactChild(container);
        var rootElementSibling;
        var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
        var component = $3a5ad88b6558b913$var$ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
        if (callback) callback.call(component);
        return component;
    },
    /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */ render: function(nextElement, container, callback) {
        return $3a5ad88b6558b913$var$ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
    },
    /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */ unmountComponentAtNode: function(container) {
        !$3a5ad88b6558b913$var$isValidContainer(container) && $jOpPq("40");
        var prevComponent = $3a5ad88b6558b913$var$getTopLevelWrapperInContainer(container);
        if (!prevComponent) {
            // Check if the node being unmounted was rendered by React, but isn't a
            // root node.
            var containerHasNonRootReactChild = $3a5ad88b6558b913$var$hasNonRootReactChild(container);
            // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute($3a5ad88b6558b913$var$ROOT_ATTR_NAME);
            return false;
        }
        delete $3a5ad88b6558b913$var$instancesByReactRootID[prevComponent._instance.rootID];
        $gDXrr.batchedUpdates($3a5ad88b6558b913$var$unmountComponentFromNode, prevComponent, container, false);
        return true;
    },
    _mountImageIntoNode: function(markup, container, instance, shouldReuseMarkup, transaction) {
        !$3a5ad88b6558b913$var$isValidContainer(container) && $jOpPq("41");
        if (shouldReuseMarkup) {
            var rootElement = $3a5ad88b6558b913$var$getReactRootElementInContainer(container);
            if ($5KA59.canReuseMarkup(markup, rootElement)) {
                $5fGpM.precacheNode(instance, rootElement);
                return;
            } else {
                var checksum = rootElement.getAttribute($5KA59.CHECKSUM_ATTR_NAME);
                rootElement.removeAttribute($5KA59.CHECKSUM_ATTR_NAME);
                var rootMarkup = rootElement.outerHTML;
                rootElement.setAttribute($5KA59.CHECKSUM_ATTR_NAME, checksum);
                var normalizedMarkup = markup;
                var normalizer;
                var diffIndex = $3a5ad88b6558b913$var$firstDifferenceIndex(normalizedMarkup, rootMarkup);
                var difference = " (client) " + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + "\n (server) " + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
                !(container.nodeType !== $3a5ad88b6558b913$var$DOC_NODE_TYPE) && $jOpPq("42", difference);
            }
        }
        !(container.nodeType !== $3a5ad88b6558b913$var$DOC_NODE_TYPE) && $jOpPq("43");
        if (transaction.useCreateElement) {
            while(container.lastChild)container.removeChild(container.lastChild);
            $QV5G5.insertTreeBefore(container, markup, null);
        } else {
            $1dgCK(container, markup);
            $5fGpM.precacheNode(instance, container.firstChild);
        }
        var hostNode;
    }
};
module.exports = $3a5ad88b6558b913$var$ReactMount;

});
parcelRegister("iHWQ0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
parcelRequire("dBldY");
var $d9e9e21b8a1d98a8$var$DOC_NODE_TYPE = 9;
function $d9e9e21b8a1d98a8$var$ReactDOMContainerInfo(topLevelWrapper, node) {
    var info = {
        _topLevelWrapper: topLevelWrapper,
        _idCounter: 1,
        _ownerDocument: node ? node.nodeType === $d9e9e21b8a1d98a8$var$DOC_NODE_TYPE ? node : node.ownerDocument : null,
        _node: node,
        _tag: node ? node.nodeName.toLowerCase() : null,
        _namespaceURI: node ? node.namespaceURI : null
    };
    return info;
}
module.exports = $d9e9e21b8a1d98a8$var$ReactDOMContainerInfo;

});

parcelRegister("325v6", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
var $2355d355d93f898e$var$ReactDOMFeatureFlags = {
    useCreateElement: true,
    useFiber: false
};
module.exports = $2355d355d93f898e$var$ReactDOMFeatureFlags;

});

parcelRegister("5KA59", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $eakJE = parcelRequire("eakJE");
var $42fd3cc175c7348c$var$TAG_END = /\/?>/;
var $42fd3cc175c7348c$var$COMMENT_START = /^<\!\-\-/;
var $42fd3cc175c7348c$var$ReactMarkupChecksum = {
    CHECKSUM_ATTR_NAME: "data-react-checksum",
    /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */ addChecksumToMarkup: function(markup) {
        var checksum = $eakJE(markup);
        // Add checksum (handle both parent tags, comments and self-closing tags)
        if ($42fd3cc175c7348c$var$COMMENT_START.test(markup)) return markup;
        else return markup.replace($42fd3cc175c7348c$var$TAG_END, " " + $42fd3cc175c7348c$var$ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    },
    /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */ canReuseMarkup: function(markup, element) {
        var existingChecksum = element.getAttribute($42fd3cc175c7348c$var$ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
        var markupChecksum = $eakJE(markup);
        return markupChecksum === existingChecksum;
    }
};
module.exports = $42fd3cc175c7348c$var$ReactMarkupChecksum;

});
parcelRegister("eakJE", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ "use strict";
var $a502157433495385$var$MOD = 65521;
// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function $a502157433495385$var$adler32(data) {
    var a = 1;
    var b = 0;
    var i = 0;
    var l = data.length;
    var m = l & -4;
    while(i < m){
        var n = Math.min(i + 4096, m);
        for(; i < n; i += 4)b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
        a %= $a502157433495385$var$MOD;
        b %= $a502157433495385$var$MOD;
    }
    for(; i < l; i++)b += a += data.charCodeAt(i);
    a %= $a502157433495385$var$MOD;
    b %= $a502157433495385$var$MOD;
    return a | b << 16;
}
module.exports = $a502157433495385$var$adler32;

});



parcelRegister("4wTXj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
module.exports = "15.6.2";

});

parcelRegister("acP88", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $jOpPq = parcelRequire("jOpPq");
parcelRequire("6qU6G");

var $5fGpM = parcelRequire("5fGpM");

var $adVZ1 = parcelRequire("adVZ1");

var $eRLS3 = parcelRequire("eRLS3");
parcelRequire("4Mb5c");
parcelRequire("fIzgz");
/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */ function $76e2afbf5ac36b23$var$findDOMNode(componentOrElement) {
    var owner;
    if (componentOrElement == null) return null;
    if (componentOrElement.nodeType === 1) return componentOrElement;
    var inst = $adVZ1.get(componentOrElement);
    if (inst) {
        inst = $eRLS3(inst);
        return inst ? $5fGpM.getNodeFromInstance(inst) : null;
    }
    if (typeof componentOrElement.render === "function") $jOpPq("44");
    else $jOpPq("45", Object.keys(componentOrElement));
}
module.exports = $76e2afbf5ac36b23$var$findDOMNode;

});
parcelRegister("eRLS3", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $ugkUw = parcelRequire("ugkUw");
function $ad2b260df46eb509$var$getHostComponentFromComposite(inst) {
    var type;
    while((type = inst._renderedNodeType) === $ugkUw.COMPOSITE)inst = inst._renderedComponent;
    if (type === $ugkUw.HOST) return inst._renderedComponent;
    else if (type === $ugkUw.EMPTY) return null;
}
module.exports = $ad2b260df46eb509$var$getHostComponentFromComposite;

});


parcelRegister("9YRCL", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $50Cxn = parcelRequire("50Cxn");
module.exports = $50Cxn.renderSubtreeIntoContainer;

});


parcelRegister("6DzO8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $iz60K = parcelRequire("iz60K");
function $4d52293a79bcab4c$var$emptyFunction() {}
function $4d52293a79bcab4c$var$emptyFunctionWithReset() {}
$4d52293a79bcab4c$var$emptyFunctionWithReset.resetWarningCache = $4d52293a79bcab4c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iz60K) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4d52293a79bcab4c$var$emptyFunctionWithReset,
        resetWarningCache: $4d52293a79bcab4c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});

parcelRegister("5pegU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3efa5b9e7c4f9356$export$2e2bcd8739ae039);
/* global window */ 
var $9zJPz = parcelRequire("9zJPz");
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = (0, $9zJPz.default)(root);
var $3efa5b9e7c4f9356$export$2e2bcd8739ae039 = result;

});
parcelRegister("9zJPz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8aeef5d23ad0c5$export$2e2bcd8739ae039);
function $6f8aeef5d23ad0c5$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol("observable");
            Symbol.observable = result;
        }
    } else result = "@@observable";
    return result;
}

});


parcelRegister("afi2q", function(module, exports) {

$parcel$export(module.exports, "Children", () => $77594c13806fd230$export$dca3b0875bd9a954, (v) => $77594c13806fd230$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $77594c13806fd230$export$16fa2f45be04daa8, (v) => $77594c13806fd230$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $77594c13806fd230$export$ffb0004e005737fa, (v) => $77594c13806fd230$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $77594c13806fd230$export$e2c29f18771995cb, (v) => $77594c13806fd230$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $77594c13806fd230$export$221d75b3f55bb0bd, (v) => $77594c13806fd230$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $77594c13806fd230$export$5f8d39834fd61797, (v) => $77594c13806fd230$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $77594c13806fd230$export$74bf444e3cd11ea5, (v) => $77594c13806fd230$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $77594c13806fd230$export$ae55be85d98224ed, (v) => $77594c13806fd230$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $77594c13806fd230$export$e530037191fcd5d7, (v) => $77594c13806fd230$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $77594c13806fd230$export$fd42f52fd3ae1109, (v) => $77594c13806fd230$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $77594c13806fd230$export$c8a8987d4410bf2d, (v) => $77594c13806fd230$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $77594c13806fd230$export$d38cd72104c1f0e9, (v) => $77594c13806fd230$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $77594c13806fd230$export$7d1e3a5e95ceca43, (v) => $77594c13806fd230$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $77594c13806fd230$export$257a8862b851cb5b, (v) => $77594c13806fd230$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $77594c13806fd230$export$a8257692ac88316c, (v) => $77594c13806fd230$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $77594c13806fd230$export$488013bae63b21da, (v) => $77594c13806fd230$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $77594c13806fd230$export$7c73462e0d25e514, (v) => $77594c13806fd230$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $77594c13806fd230$export$35808ee640e87ca7, (v) => $77594c13806fd230$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $77594c13806fd230$export$fae74005e78b1a27, (v) => $77594c13806fd230$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $77594c13806fd230$export$dc8fbce3eb94dc1e, (v) => $77594c13806fd230$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $77594c13806fd230$export$6d9c69b0de29b591, (v) => $77594c13806fd230$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $77594c13806fd230$export$d5a552a76deda3c2, (v) => $77594c13806fd230$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $77594c13806fd230$export$e5c5a5f917a5871c, (v) => $77594c13806fd230$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $77594c13806fd230$export$1538c33de8887b59, (v) => $77594c13806fd230$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $77594c13806fd230$export$13e3392192263954, (v) => $77594c13806fd230$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $77594c13806fd230$export$b8f5890fc79d6aca, (v) => $77594c13806fd230$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $77594c13806fd230$export$60241385465d0a34, (v) => $77594c13806fd230$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $77594c13806fd230$export$83d89fbfd8236492, (v) => $77594c13806fd230$export$83d89fbfd8236492 = v);
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $77594c13806fd230$export$dca3b0875bd9a954;
var $77594c13806fd230$export$16fa2f45be04daa8;
var $77594c13806fd230$export$ffb0004e005737fa;
var $77594c13806fd230$export$e2c29f18771995cb;
var $77594c13806fd230$export$221d75b3f55bb0bd;
var $77594c13806fd230$export$5f8d39834fd61797;
var $77594c13806fd230$export$74bf444e3cd11ea5;
var $77594c13806fd230$export$ae55be85d98224ed;
var $77594c13806fd230$export$e530037191fcd5d7;
var $77594c13806fd230$export$fd42f52fd3ae1109;
var $77594c13806fd230$export$c8a8987d4410bf2d;
var $77594c13806fd230$export$d38cd72104c1f0e9;
var $77594c13806fd230$export$7d1e3a5e95ceca43;
var $77594c13806fd230$export$257a8862b851cb5b;
var $77594c13806fd230$export$a8257692ac88316c;
var $77594c13806fd230$export$488013bae63b21da;
var $77594c13806fd230$export$7c73462e0d25e514;
var $77594c13806fd230$export$35808ee640e87ca7;
var $77594c13806fd230$export$fae74005e78b1a27;
var $77594c13806fd230$export$dc8fbce3eb94dc1e;
var $77594c13806fd230$export$6d9c69b0de29b591;
var $77594c13806fd230$export$d5a552a76deda3c2;
var $77594c13806fd230$export$e5c5a5f917a5871c;
var $77594c13806fd230$export$1538c33de8887b59;
var $77594c13806fd230$export$13e3392192263954;
var $77594c13806fd230$export$b8f5890fc79d6aca;
var $77594c13806fd230$export$60241385465d0a34;
var $77594c13806fd230$export$83d89fbfd8236492;
"use strict";

var $5ezDB = parcelRequire("5ezDB");
var $77594c13806fd230$var$n = "function" === typeof Symbol && Symbol.for, $77594c13806fd230$var$p = $77594c13806fd230$var$n ? Symbol.for("react.element") : 60103, $77594c13806fd230$var$q = $77594c13806fd230$var$n ? Symbol.for("react.portal") : 60106, $77594c13806fd230$var$r = $77594c13806fd230$var$n ? Symbol.for("react.fragment") : 60107, $77594c13806fd230$var$t = $77594c13806fd230$var$n ? Symbol.for("react.strict_mode") : 60108, $77594c13806fd230$var$u = $77594c13806fd230$var$n ? Symbol.for("react.profiler") : 60114, $77594c13806fd230$var$v = $77594c13806fd230$var$n ? Symbol.for("react.provider") : 60109, $77594c13806fd230$var$w = $77594c13806fd230$var$n ? Symbol.for("react.context") : 60110, $77594c13806fd230$var$x = $77594c13806fd230$var$n ? Symbol.for("react.forward_ref") : 60112, $77594c13806fd230$var$y = $77594c13806fd230$var$n ? Symbol.for("react.suspense") : 60113, $77594c13806fd230$var$z = $77594c13806fd230$var$n ? Symbol.for("react.memo") : 60115, $77594c13806fd230$var$A = $77594c13806fd230$var$n ? Symbol.for("react.lazy") : 60116, $77594c13806fd230$var$B = "function" === typeof Symbol && Symbol.iterator;
function $77594c13806fd230$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $77594c13806fd230$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $77594c13806fd230$var$E = {};
function $77594c13806fd230$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $77594c13806fd230$var$E;
    this.updater = c || $77594c13806fd230$var$D;
}
$77594c13806fd230$var$F.prototype.isReactComponent = {};
$77594c13806fd230$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($77594c13806fd230$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$77594c13806fd230$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $77594c13806fd230$var$G() {}
$77594c13806fd230$var$G.prototype = $77594c13806fd230$var$F.prototype;
function $77594c13806fd230$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $77594c13806fd230$var$E;
    this.updater = c || $77594c13806fd230$var$D;
}
var $77594c13806fd230$var$I = $77594c13806fd230$var$H.prototype = new $77594c13806fd230$var$G;
$77594c13806fd230$var$I.constructor = $77594c13806fd230$var$H;
$5ezDB($77594c13806fd230$var$I, $77594c13806fd230$var$F.prototype);
$77594c13806fd230$var$I.isPureReactComponent = !0;
var $77594c13806fd230$var$J = {
    current: null
}, $77594c13806fd230$var$K = Object.prototype.hasOwnProperty, $77594c13806fd230$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $77594c13806fd230$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$77594c13806fd230$var$K.call(b, e) && !$77594c13806fd230$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $77594c13806fd230$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $77594c13806fd230$var$J.current
    };
}
function $77594c13806fd230$var$N(a, b) {
    return {
        $$typeof: $77594c13806fd230$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $77594c13806fd230$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $77594c13806fd230$var$p;
}
function $77594c13806fd230$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $77594c13806fd230$var$P = /\/+/g, $77594c13806fd230$var$Q = [];
function $77594c13806fd230$var$R(a, b, c, e) {
    if ($77594c13806fd230$var$Q.length) {
        var d = $77594c13806fd230$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $77594c13806fd230$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $77594c13806fd230$var$Q.length && $77594c13806fd230$var$Q.push(a);
}
function $77594c13806fd230$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $77594c13806fd230$var$p:
                case $77594c13806fd230$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $77594c13806fd230$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $77594c13806fd230$var$U(d, k);
        g += $77594c13806fd230$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $77594c13806fd230$var$B && a[$77594c13806fd230$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $77594c13806fd230$var$U(d, k++), g += $77594c13806fd230$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($77594c13806fd230$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $77594c13806fd230$var$V(a, b, c) {
    return null == a ? 0 : $77594c13806fd230$var$T(a, "", b, c);
}
function $77594c13806fd230$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $77594c13806fd230$var$escape(a.key) : b.toString(36);
}
function $77594c13806fd230$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $77594c13806fd230$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $77594c13806fd230$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($77594c13806fd230$var$O(a) && (a = $77594c13806fd230$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($77594c13806fd230$var$P, "$&/") + "/") + c)), e.push(a));
}
function $77594c13806fd230$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($77594c13806fd230$var$P, "$&/") + "/");
    b = $77594c13806fd230$var$R(b, g, e, d);
    $77594c13806fd230$var$V(a, $77594c13806fd230$var$aa, b);
    $77594c13806fd230$var$S(b);
}
var $77594c13806fd230$var$Y = {
    current: null
};
function $77594c13806fd230$var$Z() {
    var a = $77594c13806fd230$var$Y.current;
    if (null === a) throw Error($77594c13806fd230$var$C(321));
    return a;
}
var $77594c13806fd230$var$ba = {
    ReactCurrentDispatcher: $77594c13806fd230$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $77594c13806fd230$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $5ezDB
};
$77594c13806fd230$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $77594c13806fd230$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $77594c13806fd230$var$R(null, null, b, c);
        $77594c13806fd230$var$V(a, $77594c13806fd230$var$W, b);
        $77594c13806fd230$var$S(b);
    },
    count: function(a) {
        return $77594c13806fd230$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $77594c13806fd230$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$77594c13806fd230$var$O(a)) throw Error($77594c13806fd230$var$C(143));
        return a;
    }
};
$77594c13806fd230$export$16fa2f45be04daa8 = $77594c13806fd230$var$F;
$77594c13806fd230$export$ffb0004e005737fa = $77594c13806fd230$var$r;
$77594c13806fd230$export$e2c29f18771995cb = $77594c13806fd230$var$u;
$77594c13806fd230$export$221d75b3f55bb0bd = $77594c13806fd230$var$H;
$77594c13806fd230$export$5f8d39834fd61797 = $77594c13806fd230$var$t;
$77594c13806fd230$export$74bf444e3cd11ea5 = $77594c13806fd230$var$y;
$77594c13806fd230$export$ae55be85d98224ed = $77594c13806fd230$var$ba;
$77594c13806fd230$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($77594c13806fd230$var$C(267, a));
    var e = $5ezDB({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $77594c13806fd230$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$77594c13806fd230$var$K.call(b, h) && !$77594c13806fd230$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $77594c13806fd230$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$77594c13806fd230$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $77594c13806fd230$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $77594c13806fd230$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$77594c13806fd230$export$c8a8987d4410bf2d = $77594c13806fd230$var$M;
$77594c13806fd230$export$d38cd72104c1f0e9 = function(a) {
    var b = $77594c13806fd230$var$M.bind(null, a);
    b.type = a;
    return b;
};
$77594c13806fd230$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$77594c13806fd230$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $77594c13806fd230$var$x,
        render: a
    };
};
$77594c13806fd230$export$a8257692ac88316c = $77594c13806fd230$var$O;
$77594c13806fd230$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $77594c13806fd230$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$77594c13806fd230$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $77594c13806fd230$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$77594c13806fd230$export$35808ee640e87ca7 = function(a, b) {
    return $77594c13806fd230$var$Z().useCallback(a, b);
};
$77594c13806fd230$export$fae74005e78b1a27 = function(a, b) {
    return $77594c13806fd230$var$Z().useContext(a, b);
};
$77594c13806fd230$export$dc8fbce3eb94dc1e = function() {};
$77594c13806fd230$export$6d9c69b0de29b591 = function(a, b) {
    return $77594c13806fd230$var$Z().useEffect(a, b);
};
$77594c13806fd230$export$d5a552a76deda3c2 = function(a, b, c) {
    return $77594c13806fd230$var$Z().useImperativeHandle(a, b, c);
};
$77594c13806fd230$export$e5c5a5f917a5871c = function(a, b) {
    return $77594c13806fd230$var$Z().useLayoutEffect(a, b);
};
$77594c13806fd230$export$1538c33de8887b59 = function(a, b) {
    return $77594c13806fd230$var$Z().useMemo(a, b);
};
$77594c13806fd230$export$13e3392192263954 = function(a, b, c) {
    return $77594c13806fd230$var$Z().useReducer(a, b, c);
};
$77594c13806fd230$export$b8f5890fc79d6aca = function(a) {
    return $77594c13806fd230$var$Z().useRef(a);
};
$77594c13806fd230$export$60241385465d0a34 = function(a) {
    return $77594c13806fd230$var$Z().useState(a);
};
$77594c13806fd230$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("5ezDB", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $3cf9e778af79b2a6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3cf9e778af79b2a6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3cf9e778af79b2a6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $3cf9e778af79b2a6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $3cf9e778af79b2a6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $3cf9e778af79b2a6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $3cf9e778af79b2a6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($3cf9e778af79b2a6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($3cf9e778af79b2a6$var$getOwnPropertySymbols) {
            symbols = $3cf9e778af79b2a6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($3cf9e778af79b2a6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


/**
 * Created by gavorhes on 6/1/2016.
 */ var $9ecd55d78a78afa4$exports = {};
"use strict";
Object.defineProperty($9ecd55d78a78afa4$exports, "__esModule", {
    value: true
});
var $dc57b31f1b066f38$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $dc57b31f1b066f38$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $dc57b31f1b066f38$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $dc57b31f1b066f38$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


window["$"] = window["jQuery"] = $dc57b31f1b066f38$exports;
/*! jQuery UI - v1.11.1 - 2014-08-13
* http://jqueryui.com
* Includes: core.js, widget.js, mouse.js, position.js, accordion.js, autocomplete.js, button.js, datepicker.js, dialog.js, draggable.js, droppable.js, effect.js, effect-blind.js, effect-bounce.js, effect-clip.js, effect-drop.js, effect-explode.js, effect-fade.js, effect-fold.js, effect-highlight.js, effect-puff.js, effect-pulsate.js, effect-scale.js, effect-shake.js, effect-size.js, effect-slide.js, effect-transfer.js, menu.js, progressbar.js, resizable.js, selectable.js, selectmenu.js, slider.js, sortable.js, spinner.js, tabs.js, tooltip.js
* Copyright 2014 jQuery Foundation and other contributors; Licensed MIT */ (function(factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    /*!
 * jQuery UI Core 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ // $.ui might exist from components with no dependencies, e.g., $.ui.position
    $.ui = $.ui || {};
    $.extend($.ui, {
        version: "1.11.1",
        keyCode: {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38
        }
    });
    // plugins
    $.fn.extend({
        scrollParent: function(includeHidden) {
            var position = this.css("position"), excludeStaticParent = position === "absolute", overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/, scrollParent = this.parents().filter(function() {
                var parent = $(this);
                if (excludeStaticParent && parent.css("position") === "static") return false;
                return overflowRegex.test(parent.css("overflow") + parent.css("overflow-y") + parent.css("overflow-x"));
            }).eq(0);
            return position === "fixed" || !scrollParent.length ? $(this[0].ownerDocument || document) : scrollParent;
        },
        uniqueId: function() {
            var uuid = 0;
            return function() {
                return this.each(function() {
                    if (!this.id) this.id = "ui-id-" + ++uuid;
                });
            };
        }(),
        removeUniqueId: function() {
            return this.each(function() {
                if (/^ui-id-\d+$/.test(this.id)) $(this).removeAttr("id");
            });
        }
    });
    // selectors
    function focusable(element, isTabIndexNotNaN) {
        var map, mapName, img, nodeName = element.nodeName.toLowerCase();
        if ("area" === nodeName) {
            map = element.parentNode;
            mapName = map.name;
            if (!element.href || !mapName || map.nodeName.toLowerCase() !== "map") return false;
            img = $("img[usemap='#" + mapName + "']")[0];
            return !!img && visible(img);
        }
        return (/input|select|textarea|button|object/.test(nodeName) ? !element.disabled : "a" === nodeName ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) && // the element and all of its ancestors must be visible
        visible(element);
    }
    function visible(element) {
        return $.expr.filters.visible(element) && !$(element).parents().addBack().filter(function() {
            return $.css(this, "visibility") === "hidden";
        }).length;
    }
    $.extend($.expr[":"], {
        data: $.expr.createPseudo ? $.expr.createPseudo(function(dataName) {
            return function(elem) {
                return !!$.data(elem, dataName);
            };
        }) : // support: jQuery <1.8
        function(elem, i, match) {
            return !!$.data(elem, match[3]);
        },
        focusable: function(element) {
            return focusable(element, !isNaN($.attr(element, "tabindex")));
        },
        tabbable: function(element) {
            var tabIndex = $.attr(element, "tabindex"), isTabIndexNaN = isNaN(tabIndex);
            return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
        }
    });
    // support: jQuery <1.8
    if (!$("<a>").outerWidth(1).jquery) $.each([
        "Width",
        "Height"
    ], function(i, name) {
        var side = name === "Width" ? [
            "Left",
            "Right"
        ] : [
            "Top",
            "Bottom"
        ], type = name.toLowerCase(), orig = {
            innerWidth: $.fn.innerWidth,
            innerHeight: $.fn.innerHeight,
            outerWidth: $.fn.outerWidth,
            outerHeight: $.fn.outerHeight
        };
        function reduce(elem, size, border, margin) {
            $.each(side, function() {
                size -= parseFloat($.css(elem, "padding" + this)) || 0;
                if (border) size -= parseFloat($.css(elem, "border" + this + "Width")) || 0;
                if (margin) size -= parseFloat($.css(elem, "margin" + this)) || 0;
            });
            return size;
        }
        $.fn["inner" + name] = function(size) {
            if (size === undefined) return orig["inner" + name].call(this);
            return this.each(function() {
                $(this).css(type, reduce(this, size) + "px");
            });
        };
        $.fn["outer" + name] = function(size, margin) {
            if (typeof size !== "number") return orig["outer" + name].call(this, size);
            return this.each(function() {
                $(this).css(type, reduce(this, size, true, margin) + "px");
            });
        };
    });
    // support: jQuery <1.8
    if (!$.fn.addBack) $.fn.addBack = function(selector) {
        return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
    };
    // support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
    if ($("<a>").data("a-b", "a").removeData("a-b").data("a-b")) $.fn.removeData = function(removeData) {
        return function(key) {
            if (arguments.length) return removeData.call(this, $.camelCase(key));
            else return removeData.call(this);
        };
    }($.fn.removeData);
    // deprecated
    $.ui.ie = !!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());
    $.fn.extend({
        focus: function(orig) {
            return function(delay, fn) {
                return typeof delay === "number" ? this.each(function() {
                    var elem = this;
                    setTimeout(function() {
                        $(elem).focus();
                        if (fn) fn.call(elem);
                    }, delay);
                }) : orig.apply(this, arguments);
            };
        }($.fn.focus),
        disableSelection: function() {
            var eventType = "onselectstart" in document.createElement("div") ? "selectstart" : "mousedown";
            return function() {
                return this.bind(eventType + ".ui-disableSelection", function(event) {
                    event.preventDefault();
                });
            };
        }(),
        enableSelection: function() {
            return this.unbind(".ui-disableSelection");
        },
        zIndex: function(zIndex) {
            if (zIndex !== undefined) return this.css("zIndex", zIndex);
            if (this.length) {
                var elem = $(this[0]), position, value;
                while(elem.length && elem[0] !== document){
                    // Ignore z-index if position is set to a value where z-index is ignored by the browser
                    // This makes behavior of this function consistent across browsers
                    // WebKit always returns auto if the element is positioned
                    position = elem.css("position");
                    if (position === "absolute" || position === "relative" || position === "fixed") {
                        // IE returns 0 when zIndex is not specified
                        // other browsers return a string
                        // we ignore the case of nested elements with an explicit value of 0
                        // <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
                        value = parseInt(elem.css("zIndex"), 10);
                        if (!isNaN(value) && value !== 0) return value;
                    }
                    elem = elem.parent();
                }
            }
            return 0;
        }
    });
    // $.ui.plugin is deprecated. Use $.widget() extensions instead.
    $.ui.plugin = {
        add: function(module, option, set) {
            var i, proto = $.ui[module].prototype;
            for(i in set){
                proto.plugins[i] = proto.plugins[i] || [];
                proto.plugins[i].push([
                    option,
                    set[i]
                ]);
            }
        },
        call: function(instance, name, args, allowDisconnected) {
            var i, set = instance.plugins[name];
            if (!set) return;
            if (!allowDisconnected && (!instance.element[0].parentNode || instance.element[0].parentNode.nodeType === 11)) return;
            for(i = 0; i < set.length; i++)if (instance.options[set[i][0]]) set[i][1].apply(instance.element, args);
        }
    };
    /*!
 * jQuery UI Widget 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/jQuery.widget/
 */ var widget_uuid = 0, widget_slice = Array.prototype.slice;
    $.cleanData = function(orig) {
        return function(elems) {
            var events, elem, i;
            for(i = 0; (elem = elems[i]) != null; i++)try {
                // Only trigger remove when necessary to save time
                events = $._data(elem, "events");
                if (events && events.remove) $(elem).triggerHandler("remove");
            // http://bugs.jquery.com/ticket/8235
            } catch (e) {}
            orig(elems);
        };
    }($.cleanData);
    $.widget = function(name, base, prototype) {
        var fullName, existingConstructor, constructor, basePrototype, // proxiedPrototype allows the provided prototype to remain unmodified
        // so that it can be used as a mixin for multiple widgets (#8876)
        proxiedPrototype = {}, namespace = name.split(".")[0];
        name = name.split(".")[1];
        fullName = namespace + "-" + name;
        if (!prototype) {
            prototype = base;
            base = $.Widget;
        }
        // create selector for plugin
        $.expr[":"][fullName.toLowerCase()] = function(elem) {
            return !!$.data(elem, fullName);
        };
        $[namespace] = $[namespace] || {};
        existingConstructor = $[namespace][name];
        constructor = $[namespace][name] = function(options, element) {
            // allow instantiation without "new" keyword
            if (!this._createWidget) return new constructor(options, element);
            // allow instantiation without initializing for simple inheritance
            // must use "new" keyword (the code above always passes args)
            if (arguments.length) this._createWidget(options, element);
        };
        // extend with the existing constructor to carry over any static properties
        $.extend(constructor, existingConstructor, {
            version: prototype.version,
            // copy the object used to create the prototype in case we need to
            // redefine the widget later
            _proto: $.extend({}, prototype),
            // track widgets that inherit from this widget in case this widget is
            // redefined after a widget inherits from it
            _childConstructors: []
        });
        basePrototype = new base();
        // we need to make the options hash a property directly on the new instance
        // otherwise we'll modify the options hash on the prototype that we're
        // inheriting from
        basePrototype.options = $.widget.extend({}, basePrototype.options);
        $.each(prototype, function(prop, value) {
            if (!$.isFunction(value)) {
                proxiedPrototype[prop] = value;
                return;
            }
            proxiedPrototype[prop] = function() {
                var _super = function() {
                    return base.prototype[prop].apply(this, arguments);
                }, _superApply = function(args) {
                    return base.prototype[prop].apply(this, args);
                };
                return function() {
                    var __super = this._super, __superApply = this._superApply, returnValue;
                    this._super = _super;
                    this._superApply = _superApply;
                    returnValue = value.apply(this, arguments);
                    this._super = __super;
                    this._superApply = __superApply;
                    return returnValue;
                };
            }();
        });
        constructor.prototype = $.widget.extend(basePrototype, {
            // TODO: remove support for widgetEventPrefix
            // always use the name + a colon as the prefix, e.g., draggable:start
            // don't prefix for widgets that aren't DOM-based
            widgetEventPrefix: existingConstructor ? basePrototype.widgetEventPrefix || name : name
        }, proxiedPrototype, {
            constructor: constructor,
            namespace: namespace,
            widgetName: name,
            widgetFullName: fullName
        });
        // If this widget is being redefined then we need to find all widgets that
        // are inheriting from it and redefine all of them so that they inherit from
        // the new version of this widget. We're essentially trying to replace one
        // level in the prototype chain.
        if (existingConstructor) {
            $.each(existingConstructor._childConstructors, function(i, child) {
                var childPrototype = child.prototype;
                // redefine the child widget using the same prototype that was
                // originally used, but inherit from the new version of the base
                $.widget(childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto);
            });
            // remove the list of existing child constructors from the old constructor
            // so the old child constructors can be garbage collected
            delete existingConstructor._childConstructors;
        } else base._childConstructors.push(constructor);
        $.widget.bridge(name, constructor);
        return constructor;
    };
    $.widget.extend = function(target) {
        var input = widget_slice.call(arguments, 1), inputIndex = 0, inputLength = input.length, key, value;
        for(; inputIndex < inputLength; inputIndex++)for(key in input[inputIndex]){
            value = input[inputIndex][key];
            if (input[inputIndex].hasOwnProperty(key) && value !== undefined) {
                // Clone objects
                if ($.isPlainObject(value)) target[key] = $.isPlainObject(target[key]) ? $.widget.extend({}, target[key], value) : // Don't extend strings, arrays, etc. with objects
                $.widget.extend({}, value);
                else target[key] = value;
            }
        }
        return target;
    };
    $.widget.bridge = function(name, object) {
        var fullName = object.prototype.widgetFullName || name;
        $.fn[name] = function(options) {
            var isMethodCall = typeof options === "string", args = widget_slice.call(arguments, 1), returnValue = this;
            // allow multiple hashes to be passed on init
            options = !isMethodCall && args.length ? $.widget.extend.apply(null, [
                options
            ].concat(args)) : options;
            if (isMethodCall) this.each(function() {
                var methodValue, instance = $.data(this, fullName);
                if (options === "instance") {
                    returnValue = instance;
                    return false;
                }
                if (!instance) return $.error("cannot call methods on " + name + " prior to initialization; " + "attempted to call method '" + options + "'");
                if (!$.isFunction(instance[options]) || options.charAt(0) === "_") return $.error("no such method '" + options + "' for " + name + " widget instance");
                methodValue = instance[options].apply(instance, args);
                if (methodValue !== instance && methodValue !== undefined) {
                    returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
                    return false;
                }
            });
            else this.each(function() {
                var instance = $.data(this, fullName);
                if (instance) {
                    instance.option(options || {});
                    if (instance._init) instance._init();
                } else $.data(this, fullName, new object(options, this));
            });
            return returnValue;
        };
    };
    $.Widget = function() {};
    $.Widget._childConstructors = [];
    $.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: {
            disabled: false,
            // callbacks
            create: null
        },
        _createWidget: function(options, element) {
            element = $(element || this.defaultElement || this)[0];
            this.element = $(element);
            this.uuid = widget_uuid++;
            this.eventNamespace = "." + this.widgetName + this.uuid;
            this.options = $.widget.extend({}, this.options, this._getCreateOptions(), options);
            this.bindings = $();
            this.hoverable = $();
            this.focusable = $();
            if (element !== this) {
                $.data(element, this.widgetFullName, this);
                this._on(true, this.element, {
                    remove: function(event) {
                        if (event.target === element) this.destroy();
                    }
                });
                this.document = $(element.style ? // element within the document
                element.ownerDocument : // element is window or document
                element.document || element);
                this.window = $(this.document[0].defaultView || this.document[0].parentWindow);
            }
            this._create();
            this._trigger("create", null, this._getCreateEventData());
            this._init();
        },
        _getCreateOptions: $.noop,
        _getCreateEventData: $.noop,
        _create: $.noop,
        _init: $.noop,
        destroy: function() {
            this._destroy();
            // we can probably remove the unbind calls in 2.0
            // all event bindings should go through this._on()
            this.element.unbind(this.eventNamespace).removeData(this.widgetFullName)// support: jquery <1.6.3
            // http://bugs.jquery.com/ticket/9413
            .removeData($.camelCase(this.widgetFullName));
            this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName + "-disabled " + "ui-state-disabled");
            // clean up events and states
            this.bindings.unbind(this.eventNamespace);
            this.hoverable.removeClass("ui-state-hover");
            this.focusable.removeClass("ui-state-focus");
        },
        _destroy: $.noop,
        widget: function() {
            return this.element;
        },
        option: function(key, value) {
            var options = key, parts, curOption, i;
            if (arguments.length === 0) // don't return a reference to the internal hash
            return $.widget.extend({}, this.options);
            if (typeof key === "string") {
                // handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
                options = {};
                parts = key.split(".");
                key = parts.shift();
                if (parts.length) {
                    curOption = options[key] = $.widget.extend({}, this.options[key]);
                    for(i = 0; i < parts.length - 1; i++){
                        curOption[parts[i]] = curOption[parts[i]] || {};
                        curOption = curOption[parts[i]];
                    }
                    key = parts.pop();
                    if (arguments.length === 1) return curOption[key] === undefined ? null : curOption[key];
                    curOption[key] = value;
                } else {
                    if (arguments.length === 1) return this.options[key] === undefined ? null : this.options[key];
                    options[key] = value;
                }
            }
            this._setOptions(options);
            return this;
        },
        _setOptions: function(options) {
            var key;
            for(key in options)this._setOption(key, options[key]);
            return this;
        },
        _setOption: function(key, value) {
            this.options[key] = value;
            if (key === "disabled") {
                this.widget().toggleClass(this.widgetFullName + "-disabled", !!value);
                // If the widget is becoming disabled, then nothing is interactive
                if (value) {
                    this.hoverable.removeClass("ui-state-hover");
                    this.focusable.removeClass("ui-state-focus");
                }
            }
            return this;
        },
        enable: function() {
            return this._setOptions({
                disabled: false
            });
        },
        disable: function() {
            return this._setOptions({
                disabled: true
            });
        },
        _on: function(suppressDisabledCheck, element, handlers) {
            var delegateElement, instance = this;
            // no suppressDisabledCheck flag, shuffle arguments
            if (typeof suppressDisabledCheck !== "boolean") {
                handlers = element;
                element = suppressDisabledCheck;
                suppressDisabledCheck = false;
            }
            // no element argument, shuffle and use this.element
            if (!handlers) {
                handlers = element;
                element = this.element;
                delegateElement = this.widget();
            } else {
                element = delegateElement = $(element);
                this.bindings = this.bindings.add(element);
            }
            $.each(handlers, function(event, handler) {
                function handlerProxy() {
                    // allow widgets to customize the disabled handling
                    // - disabled as an array instead of boolean
                    // - disabled class as method for disabling individual parts
                    if (!suppressDisabledCheck && (instance.options.disabled === true || $(this).hasClass("ui-state-disabled"))) return;
                    return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
                }
                // copy the guid so direct unbinding works
                if (typeof handler !== "string") handlerProxy.guid = handler.guid = handler.guid || handlerProxy.guid || $.guid++;
                var match = event.match(/^([\w:-]*)\s*(.*)$/), eventName = match[1] + instance.eventNamespace, selector = match[2];
                if (selector) delegateElement.delegate(selector, eventName, handlerProxy);
                else element.bind(eventName, handlerProxy);
            });
        },
        _off: function(element, eventName) {
            eventName = (eventName || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace;
            element.unbind(eventName).undelegate(eventName);
        },
        _delay: function(handler, delay) {
            function handlerProxy() {
                return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
            }
            var instance = this;
            return setTimeout(handlerProxy, delay || 0);
        },
        _hoverable: function(element) {
            this.hoverable = this.hoverable.add(element);
            this._on(element, {
                mouseenter: function(event) {
                    $(event.currentTarget).addClass("ui-state-hover");
                },
                mouseleave: function(event) {
                    $(event.currentTarget).removeClass("ui-state-hover");
                }
            });
        },
        _focusable: function(element) {
            this.focusable = this.focusable.add(element);
            this._on(element, {
                focusin: function(event) {
                    $(event.currentTarget).addClass("ui-state-focus");
                },
                focusout: function(event) {
                    $(event.currentTarget).removeClass("ui-state-focus");
                }
            });
        },
        _trigger: function(type, event, data) {
            var prop, orig, callback = this.options[type];
            data = data || {};
            event = $.Event(event);
            event.type = (type === this.widgetEventPrefix ? type : this.widgetEventPrefix + type).toLowerCase();
            // the original event may come from any element
            // so we need to reset the target on the new event
            event.target = this.element[0];
            // copy original event properties over to the new event
            orig = event.originalEvent;
            if (orig) {
                for(prop in orig)if (!(prop in event)) event[prop] = orig[prop];
            }
            this.element.trigger(event, data);
            return !($.isFunction(callback) && callback.apply(this.element[0], [
                event
            ].concat(data)) === false || event.isDefaultPrevented());
        }
    };
    $.each({
        show: "fadeIn",
        hide: "fadeOut"
    }, function(method, defaultEffect) {
        $.Widget.prototype["_" + method] = function(element, options, callback) {
            if (typeof options === "string") options = {
                effect: options
            };
            var hasOptions, effectName = !options ? method : options === true || typeof options === "number" ? defaultEffect : options.effect || defaultEffect;
            options = options || {};
            if (typeof options === "number") options = {
                duration: options
            };
            hasOptions = !$.isEmptyObject(options);
            options.complete = callback;
            if (options.delay) element.delay(options.delay);
            if (hasOptions && $.effects && $.effects.effect[effectName]) element[method](options);
            else if (effectName !== method && element[effectName]) element[effectName](options.duration, options.easing, callback);
            else element.queue(function(next) {
                $(this)[method]();
                if (callback) callback.call(element[0]);
                next();
            });
        };
    });
    var widget = $.widget;
    /*!
 * jQuery UI Mouse 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/mouse/
 */ var mouseHandled = false;
    $(document).mouseup(function() {
        mouseHandled = false;
    });
    var mouse = $.widget("ui.mouse", {
        version: "1.11.1",
        options: {
            cancel: "input,textarea,button,select,option",
            distance: 1,
            delay: 0
        },
        _mouseInit: function() {
            var that = this;
            this.element.bind("mousedown." + this.widgetName, function(event) {
                return that._mouseDown(event);
            }).bind("click." + this.widgetName, function(event) {
                if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
                    $.removeData(event.target, that.widgetName + ".preventClickEvent");
                    event.stopImmediatePropagation();
                    return false;
                }
            });
            this.started = false;
        },
        // TODO: make sure destroying one instance of mouse doesn't mess with
        // other instances of mouse
        _mouseDestroy: function() {
            this.element.unbind("." + this.widgetName);
            if (this._mouseMoveDelegate) this.document.unbind("mousemove." + this.widgetName, this._mouseMoveDelegate).unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
        },
        _mouseDown: function(event) {
            // don't let more than one widget handle mouseStart
            if (mouseHandled) return;
            // we may have missed mouseup (out of window)
            this._mouseStarted && this._mouseUp(event);
            this._mouseDownEvent = event;
            var that = this, btnIsLeft = event.which === 1, // event.target.nodeName works around a bug in IE 8 with
            // disabled inputs (#7620)
            elIsCancel = typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false;
            if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) return true;
            this.mouseDelayMet = !this.options.delay;
            if (!this.mouseDelayMet) this._mouseDelayTimer = setTimeout(function() {
                that.mouseDelayMet = true;
            }, this.options.delay);
            if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
                this._mouseStarted = this._mouseStart(event) !== false;
                if (!this._mouseStarted) {
                    event.preventDefault();
                    return true;
                }
            }
            // Click event may never have fired (Gecko & Opera)
            if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) $.removeData(event.target, this.widgetName + ".preventClickEvent");
            // these delegates are required to keep context
            this._mouseMoveDelegate = function(event) {
                return that._mouseMove(event);
            };
            this._mouseUpDelegate = function(event) {
                return that._mouseUp(event);
            };
            this.document.bind("mousemove." + this.widgetName, this._mouseMoveDelegate).bind("mouseup." + this.widgetName, this._mouseUpDelegate);
            event.preventDefault();
            mouseHandled = true;
            return true;
        },
        _mouseMove: function(event) {
            // IE mouseup check - mouseup happened when mouse was out of window
            if ($.ui.ie && (!document.documentMode || document.documentMode < 9) && !event.button) return this._mouseUp(event);
            else if (!event.which) return this._mouseUp(event);
            if (this._mouseStarted) {
                this._mouseDrag(event);
                return event.preventDefault();
            }
            if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
                this._mouseStarted = this._mouseStart(this._mouseDownEvent, event) !== false;
                this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event);
            }
            return !this._mouseStarted;
        },
        _mouseUp: function(event) {
            this.document.unbind("mousemove." + this.widgetName, this._mouseMoveDelegate).unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
            if (this._mouseStarted) {
                this._mouseStarted = false;
                if (event.target === this._mouseDownEvent.target) $.data(event.target, this.widgetName + ".preventClickEvent", true);
                this._mouseStop(event);
            }
            mouseHandled = false;
            return false;
        },
        _mouseDistanceMet: function(event) {
            return Math.max(Math.abs(this._mouseDownEvent.pageX - event.pageX), Math.abs(this._mouseDownEvent.pageY - event.pageY)) >= this.options.distance;
        },
        _mouseDelayMet: function() {
            return this.mouseDelayMet;
        },
        // These are placeholder methods, to be overriden by extending plugin
        _mouseStart: function() {},
        _mouseDrag: function() {},
        _mouseStop: function() {},
        _mouseCapture: function() {
            return true;
        }
    });
    /*!
 * jQuery UI Position 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */ (function() {
        $.ui = $.ui || {};
        var cachedScrollbarWidth, supportsOffsetFractions, max = Math.max, abs = Math.abs, round = Math.round, rhorizontal = /left|center|right/, rvertical = /top|center|bottom/, roffset = /[\+\-]\d+(\.[\d]+)?%?/, rposition = /^\w+/, rpercent = /%$/, _position = $.fn.position;
        function getOffsets(offsets, width, height) {
            return [
                parseFloat(offsets[0]) * (rpercent.test(offsets[0]) ? width / 100 : 1),
                parseFloat(offsets[1]) * (rpercent.test(offsets[1]) ? height / 100 : 1)
            ];
        }
        function parseCss(element, property) {
            return parseInt($.css(element, property), 10) || 0;
        }
        function getDimensions(elem) {
            var raw = elem[0];
            if (raw.nodeType === 9) return {
                width: elem.width(),
                height: elem.height(),
                offset: {
                    top: 0,
                    left: 0
                }
            };
            if ($.isWindow(raw)) return {
                width: elem.width(),
                height: elem.height(),
                offset: {
                    top: elem.scrollTop(),
                    left: elem.scrollLeft()
                }
            };
            if (raw.preventDefault) return {
                width: 0,
                height: 0,
                offset: {
                    top: raw.pageY,
                    left: raw.pageX
                }
            };
            return {
                width: elem.outerWidth(),
                height: elem.outerHeight(),
                offset: elem.offset()
            };
        }
        $.position = {
            scrollbarWidth: function() {
                if (cachedScrollbarWidth !== undefined) return cachedScrollbarWidth;
                var w1, w2, div = $("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"), innerDiv = div.children()[0];
                $("body").append(div);
                w1 = innerDiv.offsetWidth;
                div.css("overflow", "scroll");
                w2 = innerDiv.offsetWidth;
                if (w1 === w2) w2 = div[0].clientWidth;
                div.remove();
                return cachedScrollbarWidth = w1 - w2;
            },
            getScrollInfo: function(within) {
                var overflowX = within.isWindow || within.isDocument ? "" : within.element.css("overflow-x"), overflowY = within.isWindow || within.isDocument ? "" : within.element.css("overflow-y"), hasOverflowX = overflowX === "scroll" || overflowX === "auto" && within.width < within.element[0].scrollWidth, hasOverflowY = overflowY === "scroll" || overflowY === "auto" && within.height < within.element[0].scrollHeight;
                return {
                    width: hasOverflowY ? $.position.scrollbarWidth() : 0,
                    height: hasOverflowX ? $.position.scrollbarWidth() : 0
                };
            },
            getWithinInfo: function(element) {
                var withinElement = $(element || window), isWindow = $.isWindow(withinElement[0]), isDocument = !!withinElement[0] && withinElement[0].nodeType === 9;
                return {
                    element: withinElement,
                    isWindow: isWindow,
                    isDocument: isDocument,
                    offset: withinElement.offset() || {
                        left: 0,
                        top: 0
                    },
                    scrollLeft: withinElement.scrollLeft(),
                    scrollTop: withinElement.scrollTop(),
                    // support: jQuery 1.6.x
                    // jQuery 1.6 doesn't support .outerWidth/Height() on documents or windows
                    width: isWindow || isDocument ? withinElement.width() : withinElement.outerWidth(),
                    height: isWindow || isDocument ? withinElement.height() : withinElement.outerHeight()
                };
            }
        };
        $.fn.position = function(options) {
            if (!options || !options.of) return _position.apply(this, arguments);
            // make a copy, we don't want to modify arguments
            options = $.extend({}, options);
            var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions, target = $(options.of), within = $.position.getWithinInfo(options.within), scrollInfo = $.position.getScrollInfo(within), collision = (options.collision || "flip").split(" "), offsets = {};
            dimensions = getDimensions(target);
            if (target[0].preventDefault) // force left top to allow flipping
            options.at = "left top";
            targetWidth = dimensions.width;
            targetHeight = dimensions.height;
            targetOffset = dimensions.offset;
            // clone to reuse original targetOffset later
            basePosition = $.extend({}, targetOffset);
            // force my and at to have valid horizontal and vertical positions
            // if a value is missing or invalid, it will be converted to center
            $.each([
                "my",
                "at"
            ], function() {
                var pos = (options[this] || "").split(" "), horizontalOffset, verticalOffset;
                if (pos.length === 1) pos = rhorizontal.test(pos[0]) ? pos.concat([
                    "center"
                ]) : rvertical.test(pos[0]) ? [
                    "center"
                ].concat(pos) : [
                    "center",
                    "center"
                ];
                pos[0] = rhorizontal.test(pos[0]) ? pos[0] : "center";
                pos[1] = rvertical.test(pos[1]) ? pos[1] : "center";
                // calculate offsets
                horizontalOffset = roffset.exec(pos[0]);
                verticalOffset = roffset.exec(pos[1]);
                offsets[this] = [
                    horizontalOffset ? horizontalOffset[0] : 0,
                    verticalOffset ? verticalOffset[0] : 0
                ];
                // reduce to just the positions without the offsets
                options[this] = [
                    rposition.exec(pos[0])[0],
                    rposition.exec(pos[1])[0]
                ];
            });
            // normalize collision option
            if (collision.length === 1) collision[1] = collision[0];
            if (options.at[0] === "right") basePosition.left += targetWidth;
            else if (options.at[0] === "center") basePosition.left += targetWidth / 2;
            if (options.at[1] === "bottom") basePosition.top += targetHeight;
            else if (options.at[1] === "center") basePosition.top += targetHeight / 2;
            atOffset = getOffsets(offsets.at, targetWidth, targetHeight);
            basePosition.left += atOffset[0];
            basePosition.top += atOffset[1];
            return this.each(function() {
                var collisionPosition, using, elem = $(this), elemWidth = elem.outerWidth(), elemHeight = elem.outerHeight(), marginLeft = parseCss(this, "marginLeft"), marginTop = parseCss(this, "marginTop"), collisionWidth = elemWidth + marginLeft + parseCss(this, "marginRight") + scrollInfo.width, collisionHeight = elemHeight + marginTop + parseCss(this, "marginBottom") + scrollInfo.height, position = $.extend({}, basePosition), myOffset = getOffsets(offsets.my, elem.outerWidth(), elem.outerHeight());
                if (options.my[0] === "right") position.left -= elemWidth;
                else if (options.my[0] === "center") position.left -= elemWidth / 2;
                if (options.my[1] === "bottom") position.top -= elemHeight;
                else if (options.my[1] === "center") position.top -= elemHeight / 2;
                position.left += myOffset[0];
                position.top += myOffset[1];
                // if the browser doesn't support fractions, then round for consistent results
                if (!supportsOffsetFractions) {
                    position.left = round(position.left);
                    position.top = round(position.top);
                }
                collisionPosition = {
                    marginLeft: marginLeft,
                    marginTop: marginTop
                };
                $.each([
                    "left",
                    "top"
                ], function(i, dir) {
                    if ($.ui.position[collision[i]]) $.ui.position[collision[i]][dir](position, {
                        targetWidth: targetWidth,
                        targetHeight: targetHeight,
                        elemWidth: elemWidth,
                        elemHeight: elemHeight,
                        collisionPosition: collisionPosition,
                        collisionWidth: collisionWidth,
                        collisionHeight: collisionHeight,
                        offset: [
                            atOffset[0] + myOffset[0],
                            atOffset[1] + myOffset[1]
                        ],
                        my: options.my,
                        at: options.at,
                        within: within,
                        elem: elem
                    });
                });
                if (options.using) // adds feedback as second argument to using callback, if present
                using = function(props) {
                    var left = targetOffset.left - position.left, right = left + targetWidth - elemWidth, top = targetOffset.top - position.top, bottom = top + targetHeight - elemHeight, feedback = {
                        target: {
                            element: target,
                            left: targetOffset.left,
                            top: targetOffset.top,
                            width: targetWidth,
                            height: targetHeight
                        },
                        element: {
                            element: elem,
                            left: position.left,
                            top: position.top,
                            width: elemWidth,
                            height: elemHeight
                        },
                        horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
                        vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
                    };
                    if (targetWidth < elemWidth && abs(left + right) < targetWidth) feedback.horizontal = "center";
                    if (targetHeight < elemHeight && abs(top + bottom) < targetHeight) feedback.vertical = "middle";
                    if (max(abs(left), abs(right)) > max(abs(top), abs(bottom))) feedback.important = "horizontal";
                    else feedback.important = "vertical";
                    options.using.call(this, props, feedback);
                };
                elem.offset($.extend(position, {
                    using: using
                }));
            });
        };
        $.ui.position = {
            fit: {
                left: function(position, data) {
                    var within = data.within, withinOffset = within.isWindow ? within.scrollLeft : within.offset.left, outerWidth = within.width, collisionPosLeft = position.left - data.collisionPosition.marginLeft, overLeft = withinOffset - collisionPosLeft, overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset, newOverRight;
                    // element is wider than within
                    if (data.collisionWidth > outerWidth) {
                        // element is initially over the left side of within
                        if (overLeft > 0 && overRight <= 0) {
                            newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
                            position.left += overLeft - newOverRight;
                        // element is initially over right side of within
                        } else if (overRight > 0 && overLeft <= 0) position.left = withinOffset;
                        else if (overLeft > overRight) position.left = withinOffset + outerWidth - data.collisionWidth;
                        else position.left = withinOffset;
                    // too far left -> align with left edge
                    } else if (overLeft > 0) position.left += overLeft;
                    else if (overRight > 0) position.left -= overRight;
                    else position.left = max(position.left - collisionPosLeft, position.left);
                },
                top: function(position, data) {
                    var within = data.within, withinOffset = within.isWindow ? within.scrollTop : within.offset.top, outerHeight = data.within.height, collisionPosTop = position.top - data.collisionPosition.marginTop, overTop = withinOffset - collisionPosTop, overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset, newOverBottom;
                    // element is taller than within
                    if (data.collisionHeight > outerHeight) {
                        // element is initially over the top of within
                        if (overTop > 0 && overBottom <= 0) {
                            newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
                            position.top += overTop - newOverBottom;
                        // element is initially over bottom of within
                        } else if (overBottom > 0 && overTop <= 0) position.top = withinOffset;
                        else if (overTop > overBottom) position.top = withinOffset + outerHeight - data.collisionHeight;
                        else position.top = withinOffset;
                    // too far up -> align with top
                    } else if (overTop > 0) position.top += overTop;
                    else if (overBottom > 0) position.top -= overBottom;
                    else position.top = max(position.top - collisionPosTop, position.top);
                }
            },
            flip: {
                left: function(position, data) {
                    var within = data.within, withinOffset = within.offset.left + within.scrollLeft, outerWidth = within.width, offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left, collisionPosLeft = position.left - data.collisionPosition.marginLeft, overLeft = collisionPosLeft - offsetLeft, overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft, myOffset = data.my[0] === "left" ? -data.elemWidth : data.my[0] === "right" ? data.elemWidth : 0, atOffset = data.at[0] === "left" ? data.targetWidth : data.at[0] === "right" ? -data.targetWidth : 0, offset = -2 * data.offset[0], newOverRight, newOverLeft;
                    if (overLeft < 0) {
                        newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
                        if (newOverRight < 0 || newOverRight < abs(overLeft)) position.left += myOffset + atOffset + offset;
                    } else if (overRight > 0) {
                        newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
                        if (newOverLeft > 0 || abs(newOverLeft) < overRight) position.left += myOffset + atOffset + offset;
                    }
                },
                top: function(position, data) {
                    var within = data.within, withinOffset = within.offset.top + within.scrollTop, outerHeight = within.height, offsetTop = within.isWindow ? within.scrollTop : within.offset.top, collisionPosTop = position.top - data.collisionPosition.marginTop, overTop = collisionPosTop - offsetTop, overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop, top = data.my[1] === "top", myOffset = top ? -data.elemHeight : data.my[1] === "bottom" ? data.elemHeight : 0, atOffset = data.at[1] === "top" ? data.targetHeight : data.at[1] === "bottom" ? -data.targetHeight : 0, offset = -2 * data.offset[1], newOverTop, newOverBottom;
                    if (overTop < 0) {
                        newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
                        if (position.top + myOffset + atOffset + offset > overTop && (newOverBottom < 0 || newOverBottom < abs(overTop))) position.top += myOffset + atOffset + offset;
                    } else if (overBottom > 0) {
                        newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
                        if (position.top + myOffset + atOffset + offset > overBottom && (newOverTop > 0 || abs(newOverTop) < overBottom)) position.top += myOffset + atOffset + offset;
                    }
                }
            },
            flipfit: {
                left: function() {
                    $.ui.position.flip.left.apply(this, arguments);
                    $.ui.position.fit.left.apply(this, arguments);
                },
                top: function() {
                    $.ui.position.flip.top.apply(this, arguments);
                    $.ui.position.fit.top.apply(this, arguments);
                }
            }
        };
        // fraction support test
        (function() {
            var testElement, testElementParent, testElementStyle, offsetLeft, i, body = document.getElementsByTagName("body")[0], div = document.createElement("div");
            //Create a "fake body" for testing based on method used in jQuery.support
            testElement = document.createElement(body ? "div" : "body");
            testElementStyle = {
                visibility: "hidden",
                width: 0,
                height: 0,
                border: 0,
                margin: 0,
                background: "none"
            };
            if (body) $.extend(testElementStyle, {
                position: "absolute",
                left: "-1000px",
                top: "-1000px"
            });
            for(i in testElementStyle)testElement.style[i] = testElementStyle[i];
            testElement.appendChild(div);
            testElementParent = body || document.documentElement;
            testElementParent.insertBefore(testElement, testElementParent.firstChild);
            div.style.cssText = "position: absolute; left: 10.7432222px;";
            offsetLeft = $(div).offset().left;
            supportsOffsetFractions = offsetLeft > 10 && offsetLeft < 11;
            testElement.innerHTML = "";
            testElementParent.removeChild(testElement);
        })();
    })();
    var position = $.ui.position;
    /*!
 * jQuery UI Accordion 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/accordion/
 */ var accordion = $.widget("ui.accordion", {
        version: "1.11.1",
        options: {
            active: 0,
            animate: {},
            collapsible: false,
            event: "click",
            header: "> li > :first-child,> :not(li):even",
            heightStyle: "auto",
            icons: {
                activeHeader: "ui-icon-triangle-1-s",
                header: "ui-icon-triangle-1-e"
            },
            // callbacks
            activate: null,
            beforeActivate: null
        },
        hideProps: {
            borderTopWidth: "hide",
            borderBottomWidth: "hide",
            paddingTop: "hide",
            paddingBottom: "hide",
            height: "hide"
        },
        showProps: {
            borderTopWidth: "show",
            borderBottomWidth: "show",
            paddingTop: "show",
            paddingBottom: "show",
            height: "show"
        },
        _create: function() {
            var options = this.options;
            this.prevShow = this.prevHide = $();
            this.element.addClass("ui-accordion ui-widget ui-helper-reset")// ARIA
            .attr("role", "tablist");
            // don't allow collapsible: false and active: false / null
            if (!options.collapsible && (options.active === false || options.active == null)) options.active = 0;
            this._processPanels();
            // handle negative values
            if (options.active < 0) options.active += this.headers.length;
            this._refresh();
        },
        _getCreateEventData: function() {
            return {
                header: this.active,
                panel: !this.active.length ? $() : this.active.next()
            };
        },
        _createIcons: function() {
            var icons = this.options.icons;
            if (icons) {
                $("<span>").addClass("ui-accordion-header-icon ui-icon " + icons.header).prependTo(this.headers);
                this.active.children(".ui-accordion-header-icon").removeClass(icons.header).addClass(icons.activeHeader);
                this.headers.addClass("ui-accordion-icons");
            }
        },
        _destroyIcons: function() {
            this.headers.removeClass("ui-accordion-icons").children(".ui-accordion-header-icon").remove();
        },
        _destroy: function() {
            var contents;
            // clean up main element
            this.element.removeClass("ui-accordion ui-widget ui-helper-reset").removeAttr("role");
            // clean up headers
            this.headers.removeClass("ui-accordion-header ui-accordion-header-active ui-state-default ui-corner-all ui-state-active ui-state-disabled ui-corner-top").removeAttr("role").removeAttr("aria-expanded").removeAttr("aria-selected").removeAttr("aria-controls").removeAttr("tabIndex").removeUniqueId();
            this._destroyIcons();
            // clean up content panels
            contents = this.headers.next().removeClass("ui-helper-reset ui-widget-content ui-corner-bottom ui-accordion-content ui-accordion-content-active ui-state-disabled").css("display", "").removeAttr("role").removeAttr("aria-hidden").removeAttr("aria-labelledby").removeUniqueId();
            if (this.options.heightStyle !== "content") contents.css("height", "");
        },
        _setOption: function(key, value) {
            if (key === "active") {
                // _activate() will handle invalid values and update this.options
                this._activate(value);
                return;
            }
            if (key === "event") {
                if (this.options.event) this._off(this.headers, this.options.event);
                this._setupEvents(value);
            }
            this._super(key, value);
            // setting collapsible: false while collapsed; open first panel
            if (key === "collapsible" && !value && this.options.active === false) this._activate(0);
            if (key === "icons") {
                this._destroyIcons();
                if (value) this._createIcons();
            }
            // #5332 - opacity doesn't cascade to positioned elements in IE
            // so we need to add the disabled class to the headers and panels
            if (key === "disabled") {
                this.element.toggleClass("ui-state-disabled", !!value).attr("aria-disabled", value);
                this.headers.add(this.headers.next()).toggleClass("ui-state-disabled", !!value);
            }
        },
        _keydown: function(event) {
            if (event.altKey || event.ctrlKey) return;
            var keyCode = $.ui.keyCode, length = this.headers.length, currentIndex = this.headers.index(event.target), toFocus = false;
            switch(event.keyCode){
                case keyCode.RIGHT:
                case keyCode.DOWN:
                    toFocus = this.headers[(currentIndex + 1) % length];
                    break;
                case keyCode.LEFT:
                case keyCode.UP:
                    toFocus = this.headers[(currentIndex - 1 + length) % length];
                    break;
                case keyCode.SPACE:
                case keyCode.ENTER:
                    this._eventHandler(event);
                    break;
                case keyCode.HOME:
                    toFocus = this.headers[0];
                    break;
                case keyCode.END:
                    toFocus = this.headers[length - 1];
                    break;
            }
            if (toFocus) {
                $(event.target).attr("tabIndex", -1);
                $(toFocus).attr("tabIndex", 0);
                toFocus.focus();
                event.preventDefault();
            }
        },
        _panelKeyDown: function(event) {
            if (event.keyCode === $.ui.keyCode.UP && event.ctrlKey) $(event.currentTarget).prev().focus();
        },
        refresh: function() {
            var options = this.options;
            this._processPanels();
            // was collapsed or no panel
            if (options.active === false && options.collapsible === true || !this.headers.length) {
                options.active = false;
                this.active = $();
            // active false only when collapsible is true
            } else if (options.active === false) this._activate(0);
            else if (this.active.length && !$.contains(this.element[0], this.active[0])) {
                // all remaining panel are disabled
                if (this.headers.length === this.headers.find(".ui-state-disabled").length) {
                    options.active = false;
                    this.active = $();
                // activate previous panel
                } else this._activate(Math.max(0, options.active - 1));
            } else // make sure active index is correct
            options.active = this.headers.index(this.active);
            this._destroyIcons();
            this._refresh();
        },
        _processPanels: function() {
            this.headers = this.element.find(this.options.header).addClass("ui-accordion-header ui-state-default ui-corner-all");
            this.headers.next().addClass("ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom").filter(":not(.ui-accordion-content-active)").hide();
        },
        _refresh: function() {
            var maxHeight, options = this.options, heightStyle = options.heightStyle, parent = this.element.parent();
            this.active = this._findActive(options.active).addClass("ui-accordion-header-active ui-state-active ui-corner-top").removeClass("ui-corner-all");
            this.active.next().addClass("ui-accordion-content-active").show();
            this.headers.attr("role", "tab").each(function() {
                var header = $(this), headerId = header.uniqueId().attr("id"), panel = header.next(), panelId = panel.uniqueId().attr("id");
                header.attr("aria-controls", panelId);
                panel.attr("aria-labelledby", headerId);
            }).next().attr("role", "tabpanel");
            this.headers.not(this.active).attr({
                "aria-selected": "false",
                "aria-expanded": "false",
                tabIndex: -1
            }).next().attr({
                "aria-hidden": "true"
            }).hide();
            // make sure at least one header is in the tab order
            if (!this.active.length) this.headers.eq(0).attr("tabIndex", 0);
            else this.active.attr({
                "aria-selected": "true",
                "aria-expanded": "true",
                tabIndex: 0
            }).next().attr({
                "aria-hidden": "false"
            });
            this._createIcons();
            this._setupEvents(options.event);
            if (heightStyle === "fill") {
                maxHeight = parent.height();
                this.element.siblings(":visible").each(function() {
                    var elem = $(this), position = elem.css("position");
                    if (position === "absolute" || position === "fixed") return;
                    maxHeight -= elem.outerHeight(true);
                });
                this.headers.each(function() {
                    maxHeight -= $(this).outerHeight(true);
                });
                this.headers.next().each(function() {
                    $(this).height(Math.max(0, maxHeight - $(this).innerHeight() + $(this).height()));
                }).css("overflow", "auto");
            } else if (heightStyle === "auto") {
                maxHeight = 0;
                this.headers.next().each(function() {
                    maxHeight = Math.max(maxHeight, $(this).css("height", "").height());
                }).height(maxHeight);
            }
        },
        _activate: function(index) {
            var active = this._findActive(index)[0];
            // trying to activate the already active panel
            if (active === this.active[0]) return;
            // trying to collapse, simulate a click on the currently active header
            active = active || this.active[0];
            this._eventHandler({
                target: active,
                currentTarget: active,
                preventDefault: $.noop
            });
        },
        _findActive: function(selector) {
            return typeof selector === "number" ? this.headers.eq(selector) : $();
        },
        _setupEvents: function(event) {
            var events = {
                keydown: "_keydown"
            };
            if (event) $.each(event.split(" "), function(index, eventName) {
                events[eventName] = "_eventHandler";
            });
            this._off(this.headers.add(this.headers.next()));
            this._on(this.headers, events);
            this._on(this.headers.next(), {
                keydown: "_panelKeyDown"
            });
            this._hoverable(this.headers);
            this._focusable(this.headers);
        },
        _eventHandler: function(event) {
            var options = this.options, active = this.active, clicked = $(event.currentTarget), clickedIsActive = clicked[0] === active[0], collapsing = clickedIsActive && options.collapsible, toShow = collapsing ? $() : clicked.next(), toHide = active.next(), eventData = {
                oldHeader: active,
                oldPanel: toHide,
                newHeader: collapsing ? $() : clicked,
                newPanel: toShow
            };
            event.preventDefault();
            if (// click on active header, but not collapsible
            clickedIsActive && !options.collapsible || // allow canceling activation
            this._trigger("beforeActivate", event, eventData) === false) return;
            options.active = collapsing ? false : this.headers.index(clicked);
            // when the call to ._toggle() comes after the class changes
            // it causes a very odd bug in IE 8 (see #6720)
            this.active = clickedIsActive ? $() : clicked;
            this._toggle(eventData);
            // switch classes
            // corner classes on the previously active header stay after the animation
            active.removeClass("ui-accordion-header-active ui-state-active");
            if (options.icons) active.children(".ui-accordion-header-icon").removeClass(options.icons.activeHeader).addClass(options.icons.header);
            if (!clickedIsActive) {
                clicked.removeClass("ui-corner-all").addClass("ui-accordion-header-active ui-state-active ui-corner-top");
                if (options.icons) clicked.children(".ui-accordion-header-icon").removeClass(options.icons.header).addClass(options.icons.activeHeader);
                clicked.next().addClass("ui-accordion-content-active");
            }
        },
        _toggle: function(data) {
            var toShow = data.newPanel, toHide = this.prevShow.length ? this.prevShow : data.oldPanel;
            // handle activating a panel during the animation for another activation
            this.prevShow.add(this.prevHide).stop(true, true);
            this.prevShow = toShow;
            this.prevHide = toHide;
            if (this.options.animate) this._animate(toShow, toHide, data);
            else {
                toHide.hide();
                toShow.show();
                this._toggleComplete(data);
            }
            toHide.attr({
                "aria-hidden": "true"
            });
            toHide.prev().attr("aria-selected", "false");
            // if we're switching panels, remove the old header from the tab order
            // if we're opening from collapsed state, remove the previous header from the tab order
            // if we're collapsing, then keep the collapsing header in the tab order
            if (toShow.length && toHide.length) toHide.prev().attr({
                "tabIndex": -1,
                "aria-expanded": "false"
            });
            else if (toShow.length) this.headers.filter(function() {
                return $(this).attr("tabIndex") === 0;
            }).attr("tabIndex", -1);
            toShow.attr("aria-hidden", "false").prev().attr({
                "aria-selected": "true",
                tabIndex: 0,
                "aria-expanded": "true"
            });
        },
        _animate: function(toShow, toHide, data) {
            var total, easing, duration, that = this, adjust = 0, down = toShow.length && (!toHide.length || toShow.index() < toHide.index()), animate = this.options.animate || {}, options = down && animate.down || animate, complete = function() {
                that._toggleComplete(data);
            };
            if (typeof options === "number") duration = options;
            if (typeof options === "string") easing = options;
            // fall back from options to animation in case of partial down settings
            easing = easing || options.easing || animate.easing;
            duration = duration || options.duration || animate.duration;
            if (!toHide.length) return toShow.animate(this.showProps, duration, easing, complete);
            if (!toShow.length) return toHide.animate(this.hideProps, duration, easing, complete);
            total = toShow.show().outerHeight();
            toHide.animate(this.hideProps, {
                duration: duration,
                easing: easing,
                step: function(now, fx) {
                    fx.now = Math.round(now);
                }
            });
            toShow.hide().animate(this.showProps, {
                duration: duration,
                easing: easing,
                complete: complete,
                step: function(now, fx) {
                    fx.now = Math.round(now);
                    if (fx.prop !== "height") adjust += fx.now;
                    else if (that.options.heightStyle !== "content") {
                        fx.now = Math.round(total - toHide.outerHeight() - adjust);
                        adjust = 0;
                    }
                }
            });
        },
        _toggleComplete: function(data) {
            var toHide = data.oldPanel;
            toHide.removeClass("ui-accordion-content-active").prev().removeClass("ui-corner-top").addClass("ui-corner-all");
            // Work around for rendering bug in IE (#5421)
            if (toHide.length) toHide.parent()[0].className = toHide.parent()[0].className;
            this._trigger("activate", null, data);
        }
    });
    /*!
 * jQuery UI Menu 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/menu/
 */ var menu = $.widget("ui.menu", {
        version: "1.11.1",
        defaultElement: "<ul>",
        delay: 300,
        options: {
            icons: {
                submenu: "ui-icon-carat-1-e"
            },
            items: "> *",
            menus: "ul",
            position: {
                my: "left-1 top",
                at: "right top"
            },
            role: "menu",
            // callbacks
            blur: null,
            focus: null,
            select: null
        },
        _create: function() {
            this.activeMenu = this.element;
            // Flag used to prevent firing of the click handler
            // as the event bubbles up through nested menus
            this.mouseHandled = false;
            this.element.uniqueId().addClass("ui-menu ui-widget ui-widget-content").toggleClass("ui-menu-icons", !!this.element.find(".ui-icon").length).attr({
                role: this.options.role,
                tabIndex: 0
            });
            if (this.options.disabled) this.element.addClass("ui-state-disabled").attr("aria-disabled", "true");
            this._on({
                // Prevent focus from sticking to links inside menu after clicking
                // them (focus should always stay on UL during navigation).
                "mousedown .ui-menu-item": function(event) {
                    event.preventDefault();
                },
                "click .ui-menu-item": function(event) {
                    var target = $(event.target);
                    if (!this.mouseHandled && target.not(".ui-state-disabled").length) {
                        this.select(event);
                        // Only set the mouseHandled flag if the event will bubble, see #9469.
                        if (!event.isPropagationStopped()) this.mouseHandled = true;
                        // Open submenu on click
                        if (target.has(".ui-menu").length) this.expand(event);
                        else if (!this.element.is(":focus") && $(this.document[0].activeElement).closest(".ui-menu").length) {
                            // Redirect focus to the menu
                            this.element.trigger("focus", [
                                true
                            ]);
                            // If the active item is on the top level, let it stay active.
                            // Otherwise, blur the active item since it is no longer visible.
                            if (this.active && this.active.parents(".ui-menu").length === 1) clearTimeout(this.timer);
                        }
                    }
                },
                "mouseenter .ui-menu-item": function(event) {
                    var target = $(event.currentTarget);
                    // Remove ui-state-active class from siblings of the newly focused menu item
                    // to avoid a jump caused by adjacent elements both having a class with a border
                    target.siblings(".ui-state-active").removeClass("ui-state-active");
                    this.focus(event, target);
                },
                mouseleave: "collapseAll",
                "mouseleave .ui-menu": "collapseAll",
                focus: function(event, keepActiveItem) {
                    // If there's already an active item, keep it active
                    // If not, activate the first item
                    var item = this.active || this.element.find(this.options.items).eq(0);
                    if (!keepActiveItem) this.focus(event, item);
                },
                blur: function(event) {
                    this._delay(function() {
                        if (!$.contains(this.element[0], this.document[0].activeElement)) this.collapseAll(event);
                    });
                },
                keydown: "_keydown"
            });
            this.refresh();
            // Clicks outside of a menu collapse any open menus
            this._on(this.document, {
                click: function(event) {
                    if (this._closeOnDocumentClick(event)) this.collapseAll(event);
                    // Reset the mouseHandled flag
                    this.mouseHandled = false;
                }
            });
        },
        _destroy: function() {
            // Destroy (sub)menus
            this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeClass("ui-menu ui-widget ui-widget-content ui-menu-icons ui-front").removeAttr("role").removeAttr("tabIndex").removeAttr("aria-labelledby").removeAttr("aria-expanded").removeAttr("aria-hidden").removeAttr("aria-disabled").removeUniqueId().show();
            // Destroy menu items
            this.element.find(".ui-menu-item").removeClass("ui-menu-item").removeAttr("role").removeAttr("aria-disabled").removeUniqueId().removeClass("ui-state-hover").removeAttr("tabIndex").removeAttr("role").removeAttr("aria-haspopup").children().each(function() {
                var elem = $(this);
                if (elem.data("ui-menu-submenu-carat")) elem.remove();
            });
            // Destroy menu dividers
            this.element.find(".ui-menu-divider").removeClass("ui-menu-divider ui-widget-content");
        },
        _keydown: function(event) {
            var match, prev, character, skip, regex, preventDefault = true;
            function escape(value) {
                return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
            }
            switch(event.keyCode){
                case $.ui.keyCode.PAGE_UP:
                    this.previousPage(event);
                    break;
                case $.ui.keyCode.PAGE_DOWN:
                    this.nextPage(event);
                    break;
                case $.ui.keyCode.HOME:
                    this._move("first", "first", event);
                    break;
                case $.ui.keyCode.END:
                    this._move("last", "last", event);
                    break;
                case $.ui.keyCode.UP:
                    this.previous(event);
                    break;
                case $.ui.keyCode.DOWN:
                    this.next(event);
                    break;
                case $.ui.keyCode.LEFT:
                    this.collapse(event);
                    break;
                case $.ui.keyCode.RIGHT:
                    if (this.active && !this.active.is(".ui-state-disabled")) this.expand(event);
                    break;
                case $.ui.keyCode.ENTER:
                case $.ui.keyCode.SPACE:
                    this._activate(event);
                    break;
                case $.ui.keyCode.ESCAPE:
                    this.collapse(event);
                    break;
                default:
                    preventDefault = false;
                    prev = this.previousFilter || "";
                    character = String.fromCharCode(event.keyCode);
                    skip = false;
                    clearTimeout(this.filterTimer);
                    if (character === prev) skip = true;
                    else character = prev + character;
                    regex = new RegExp("^" + escape(character), "i");
                    match = this.activeMenu.find(this.options.items).filter(function() {
                        return regex.test($(this).text());
                    });
                    match = skip && match.index(this.active.next()) !== -1 ? this.active.nextAll(".ui-menu-item") : match;
                    // If no matches on the current filter, reset to the last character pressed
                    // to move down the menu to the first item that starts with that character
                    if (!match.length) {
                        character = String.fromCharCode(event.keyCode);
                        regex = new RegExp("^" + escape(character), "i");
                        match = this.activeMenu.find(this.options.items).filter(function() {
                            return regex.test($(this).text());
                        });
                    }
                    if (match.length) {
                        this.focus(event, match);
                        if (match.length > 1) {
                            this.previousFilter = character;
                            this.filterTimer = this._delay(function() {
                                delete this.previousFilter;
                            }, 1000);
                        } else delete this.previousFilter;
                    } else delete this.previousFilter;
            }
            if (preventDefault) event.preventDefault();
        },
        _activate: function(event) {
            if (!this.active.is(".ui-state-disabled")) {
                if (this.active.is("[aria-haspopup='true']")) this.expand(event);
                else this.select(event);
            }
        },
        refresh: function() {
            var menus, items, that = this, icon = this.options.icons.submenu, submenus = this.element.find(this.options.menus);
            this.element.toggleClass("ui-menu-icons", !!this.element.find(".ui-icon").length);
            // Initialize nested menus
            submenus.filter(":not(.ui-menu)").addClass("ui-menu ui-widget ui-widget-content ui-front").hide().attr({
                role: this.options.role,
                "aria-hidden": "true",
                "aria-expanded": "false"
            }).each(function() {
                var menu = $(this), item = menu.parent(), submenuCarat = $("<span>").addClass("ui-menu-icon ui-icon " + icon).data("ui-menu-submenu-carat", true);
                item.attr("aria-haspopup", "true").prepend(submenuCarat);
                menu.attr("aria-labelledby", item.attr("id"));
            });
            menus = submenus.add(this.element);
            items = menus.find(this.options.items);
            // Initialize menu-items containing spaces and/or dashes only as dividers
            items.not(".ui-menu-item").each(function() {
                var item = $(this);
                if (that._isDivider(item)) item.addClass("ui-widget-content ui-menu-divider");
            });
            // Don't refresh list items that are already adapted
            items.not(".ui-menu-item, .ui-menu-divider").addClass("ui-menu-item").uniqueId().attr({
                tabIndex: -1,
                role: this._itemRole()
            });
            // Add aria-disabled attribute to any disabled menu item
            items.filter(".ui-state-disabled").attr("aria-disabled", "true");
            // If the active item has been removed, blur the menu
            if (this.active && !$.contains(this.element[0], this.active[0])) this.blur();
        },
        _itemRole: function() {
            return ({
                menu: "menuitem",
                listbox: "option"
            })[this.options.role];
        },
        _setOption: function(key, value) {
            if (key === "icons") this.element.find(".ui-menu-icon").removeClass(this.options.icons.submenu).addClass(value.submenu);
            if (key === "disabled") this.element.toggleClass("ui-state-disabled", !!value).attr("aria-disabled", value);
            this._super(key, value);
        },
        focus: function(event, item) {
            var nested, focused;
            this.blur(event, event && event.type === "focus");
            this._scrollIntoView(item);
            this.active = item.first();
            focused = this.active.addClass("ui-state-focus").removeClass("ui-state-active");
            // Only update aria-activedescendant if there's a role
            // otherwise we assume focus is managed elsewhere
            if (this.options.role) this.element.attr("aria-activedescendant", focused.attr("id"));
            // Highlight active parent menu item, if any
            this.active.parent().closest(".ui-menu-item").addClass("ui-state-active");
            if (event && event.type === "keydown") this._close();
            else this.timer = this._delay(function() {
                this._close();
            }, this.delay);
            nested = item.children(".ui-menu");
            if (nested.length && event && /^mouse/.test(event.type)) this._startOpening(nested);
            this.activeMenu = item.parent();
            this._trigger("focus", event, {
                item: item
            });
        },
        _scrollIntoView: function(item) {
            var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
            if (this._hasScroll()) {
                borderTop = parseFloat($.css(this.activeMenu[0], "borderTopWidth")) || 0;
                paddingTop = parseFloat($.css(this.activeMenu[0], "paddingTop")) || 0;
                offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
                scroll = this.activeMenu.scrollTop();
                elementHeight = this.activeMenu.height();
                itemHeight = item.outerHeight();
                if (offset < 0) this.activeMenu.scrollTop(scroll + offset);
                else if (offset + itemHeight > elementHeight) this.activeMenu.scrollTop(scroll + offset - elementHeight + itemHeight);
            }
        },
        blur: function(event, fromFocus) {
            if (!fromFocus) clearTimeout(this.timer);
            if (!this.active) return;
            this.active.removeClass("ui-state-focus");
            this.active = null;
            this._trigger("blur", event, {
                item: this.active
            });
        },
        _startOpening: function(submenu) {
            clearTimeout(this.timer);
            // Don't open if already open fixes a Firefox bug that caused a .5 pixel
            // shift in the submenu position when mousing over the carat icon
            if (submenu.attr("aria-hidden") !== "true") return;
            this.timer = this._delay(function() {
                this._close();
                this._open(submenu);
            }, this.delay);
        },
        _open: function(submenu) {
            var position = $.extend({
                of: this.active
            }, this.options.position);
            clearTimeout(this.timer);
            this.element.find(".ui-menu").not(submenu.parents(".ui-menu")).hide().attr("aria-hidden", "true");
            submenu.show().removeAttr("aria-hidden").attr("aria-expanded", "true").position(position);
        },
        collapseAll: function(event, all) {
            clearTimeout(this.timer);
            this.timer = this._delay(function() {
                // If we were passed an event, look for the submenu that contains the event
                var currentMenu = all ? this.element : $(event && event.target).closest(this.element.find(".ui-menu"));
                // If we found no valid submenu ancestor, use the main menu to close all sub menus anyway
                if (!currentMenu.length) currentMenu = this.element;
                this._close(currentMenu);
                this.blur(event);
                this.activeMenu = currentMenu;
            }, this.delay);
        },
        // With no arguments, closes the currently active menu - if nothing is active
        // it closes all menus.  If passed an argument, it will search for menus BELOW
        _close: function(startMenu) {
            if (!startMenu) startMenu = this.active ? this.active.parent() : this.element;
            startMenu.find(".ui-menu").hide().attr("aria-hidden", "true").attr("aria-expanded", "false").end().find(".ui-state-active").not(".ui-state-focus").removeClass("ui-state-active");
        },
        _closeOnDocumentClick: function(event) {
            return !$(event.target).closest(".ui-menu").length;
        },
        _isDivider: function(item) {
            // Match hyphen, em dash, en dash
            return !/[^\-\u2014\u2013\s]/.test(item.text());
        },
        collapse: function(event) {
            var newItem = this.active && this.active.parent().closest(".ui-menu-item", this.element);
            if (newItem && newItem.length) {
                this._close();
                this.focus(event, newItem);
            }
        },
        expand: function(event) {
            var newItem = this.active && this.active.children(".ui-menu ").find(this.options.items).first();
            if (newItem && newItem.length) {
                this._open(newItem.parent());
                // Delay so Firefox will not hide activedescendant change in expanding submenu from AT
                this._delay(function() {
                    this.focus(event, newItem);
                });
            }
        },
        next: function(event) {
            this._move("next", "first", event);
        },
        previous: function(event) {
            this._move("prev", "last", event);
        },
        isFirstItem: function() {
            return this.active && !this.active.prevAll(".ui-menu-item").length;
        },
        isLastItem: function() {
            return this.active && !this.active.nextAll(".ui-menu-item").length;
        },
        _move: function(direction, filter, event) {
            var next;
            if (this.active) {
                if (direction === "first" || direction === "last") next = this.active[direction === "first" ? "prevAll" : "nextAll"](".ui-menu-item").eq(-1);
                else next = this.active[direction + "All"](".ui-menu-item").eq(0);
            }
            if (!next || !next.length || !this.active) next = this.activeMenu.find(this.options.items)[filter]();
            this.focus(event, next);
        },
        nextPage: function(event) {
            var item, base, height;
            if (!this.active) {
                this.next(event);
                return;
            }
            if (this.isLastItem()) return;
            if (this._hasScroll()) {
                base = this.active.offset().top;
                height = this.element.height();
                this.active.nextAll(".ui-menu-item").each(function() {
                    item = $(this);
                    return item.offset().top - base - height < 0;
                });
                this.focus(event, item);
            } else this.focus(event, this.activeMenu.find(this.options.items)[!this.active ? "first" : "last"]());
        },
        previousPage: function(event) {
            var item, base, height;
            if (!this.active) {
                this.next(event);
                return;
            }
            if (this.isFirstItem()) return;
            if (this._hasScroll()) {
                base = this.active.offset().top;
                height = this.element.height();
                this.active.prevAll(".ui-menu-item").each(function() {
                    item = $(this);
                    return item.offset().top - base + height > 0;
                });
                this.focus(event, item);
            } else this.focus(event, this.activeMenu.find(this.options.items).first());
        },
        _hasScroll: function() {
            return this.element.outerHeight() < this.element.prop("scrollHeight");
        },
        select: function(event) {
            // TODO: It should never be possible to not have an active item at this
            // point, but the tests don't trigger mouseenter before click.
            this.active = this.active || $(event.target).closest(".ui-menu-item");
            var ui = {
                item: this.active
            };
            if (!this.active.has(".ui-menu").length) this.collapseAll(event, true);
            this._trigger("select", event, ui);
        }
    });
    /*!
 * jQuery UI Autocomplete 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/autocomplete/
 */ $.widget("ui.autocomplete", {
        version: "1.11.1",
        defaultElement: "<input>",
        options: {
            appendTo: null,
            autoFocus: false,
            delay: 300,
            minLength: 1,
            position: {
                my: "left top",
                at: "left bottom",
                collision: "none"
            },
            source: null,
            // callbacks
            change: null,
            close: null,
            focus: null,
            open: null,
            response: null,
            search: null,
            select: null
        },
        requestIndex: 0,
        pending: 0,
        _create: function() {
            // Some browsers only repeat keydown events, not keypress events,
            // so we use the suppressKeyPress flag to determine if we've already
            // handled the keydown event. #7269
            // Unfortunately the code for & in keypress is the same as the up arrow,
            // so we use the suppressKeyPressRepeat flag to avoid handling keypress
            // events when we know the keydown event was used to modify the
            // search term. #7799
            var suppressKeyPress, suppressKeyPressRepeat, suppressInput, nodeName = this.element[0].nodeName.toLowerCase(), isTextarea = nodeName === "textarea", isInput = nodeName === "input";
            this.isMultiLine = // Textareas are always multi-line
            isTextarea ? true : // Inputs are always single-line, even if inside a contentEditable element
            // IE also treats inputs as contentEditable
            isInput ? false : // All other element types are determined by whether or not they're contentEditable
            this.element.prop("isContentEditable");
            this.valueMethod = this.element[isTextarea || isInput ? "val" : "text"];
            this.isNewMenu = true;
            this.element.addClass("ui-autocomplete-input").attr("autocomplete", "off");
            this._on(this.element, {
                keydown: function(event) {
                    if (this.element.prop("readOnly")) {
                        suppressKeyPress = true;
                        suppressInput = true;
                        suppressKeyPressRepeat = true;
                        return;
                    }
                    suppressKeyPress = false;
                    suppressInput = false;
                    suppressKeyPressRepeat = false;
                    var keyCode = $.ui.keyCode;
                    switch(event.keyCode){
                        case keyCode.PAGE_UP:
                            suppressKeyPress = true;
                            this._move("previousPage", event);
                            break;
                        case keyCode.PAGE_DOWN:
                            suppressKeyPress = true;
                            this._move("nextPage", event);
                            break;
                        case keyCode.UP:
                            suppressKeyPress = true;
                            this._keyEvent("previous", event);
                            break;
                        case keyCode.DOWN:
                            suppressKeyPress = true;
                            this._keyEvent("next", event);
                            break;
                        case keyCode.ENTER:
                            // when menu is open and has focus
                            if (this.menu.active) {
                                // #6055 - Opera still allows the keypress to occur
                                // which causes forms to submit
                                suppressKeyPress = true;
                                event.preventDefault();
                                this.menu.select(event);
                            }
                            break;
                        case keyCode.TAB:
                            if (this.menu.active) this.menu.select(event);
                            break;
                        case keyCode.ESCAPE:
                            if (this.menu.element.is(":visible")) {
                                if (!this.isMultiLine) this._value(this.term);
                                this.close(event);
                                // Different browsers have different default behavior for escape
                                // Single press can mean undo or clear
                                // Double press in IE means clear the whole form
                                event.preventDefault();
                            }
                            break;
                        default:
                            suppressKeyPressRepeat = true;
                            // search timeout should be triggered before the input value is changed
                            this._searchTimeout(event);
                            break;
                    }
                },
                keypress: function(event) {
                    if (suppressKeyPress) {
                        suppressKeyPress = false;
                        if (!this.isMultiLine || this.menu.element.is(":visible")) event.preventDefault();
                        return;
                    }
                    if (suppressKeyPressRepeat) return;
                    // replicate some key handlers to allow them to repeat in Firefox and Opera
                    var keyCode = $.ui.keyCode;
                    switch(event.keyCode){
                        case keyCode.PAGE_UP:
                            this._move("previousPage", event);
                            break;
                        case keyCode.PAGE_DOWN:
                            this._move("nextPage", event);
                            break;
                        case keyCode.UP:
                            this._keyEvent("previous", event);
                            break;
                        case keyCode.DOWN:
                            this._keyEvent("next", event);
                            break;
                    }
                },
                input: function(event) {
                    if (suppressInput) {
                        suppressInput = false;
                        event.preventDefault();
                        return;
                    }
                    this._searchTimeout(event);
                },
                focus: function() {
                    this.selectedItem = null;
                    this.previous = this._value();
                },
                blur: function(event) {
                    if (this.cancelBlur) {
                        delete this.cancelBlur;
                        return;
                    }
                    clearTimeout(this.searching);
                    this.close(event);
                    this._change(event);
                }
            });
            this._initSource();
            this.menu = $("<ul>").addClass("ui-autocomplete ui-front").appendTo(this._appendTo()).menu({
                // disable ARIA support, the live region takes care of that
                role: null
            }).hide().menu("instance");
            this._on(this.menu.element, {
                mousedown: function(event) {
                    // prevent moving focus out of the text field
                    event.preventDefault();
                    // IE doesn't prevent moving focus even with event.preventDefault()
                    // so we set a flag to know when we should ignore the blur event
                    this.cancelBlur = true;
                    this._delay(function() {
                        delete this.cancelBlur;
                    });
                    // clicking on the scrollbar causes focus to shift to the body
                    // but we can't detect a mouseup or a click immediately afterward
                    // so we have to track the next mousedown and close the menu if
                    // the user clicks somewhere outside of the autocomplete
                    var menuElement = this.menu.element[0];
                    if (!$(event.target).closest(".ui-menu-item").length) this._delay(function() {
                        var that = this;
                        this.document.one("mousedown", function(event) {
                            if (event.target !== that.element[0] && event.target !== menuElement && !$.contains(menuElement, event.target)) that.close();
                        });
                    });
                },
                menufocus: function(event, ui) {
                    var label, item;
                    // support: Firefox
                    // Prevent accidental activation of menu items in Firefox (#7024 #9118)
                    if (this.isNewMenu) {
                        this.isNewMenu = false;
                        if (event.originalEvent && /^mouse/.test(event.originalEvent.type)) {
                            this.menu.blur();
                            this.document.one("mousemove", function() {
                                $(event.target).trigger(event.originalEvent);
                            });
                            return;
                        }
                    }
                    item = ui.item.data("ui-autocomplete-item");
                    if (false !== this._trigger("focus", event, {
                        item: item
                    })) // use value to match what will end up in the input, if it was a key event
                    {
                        if (event.originalEvent && /^key/.test(event.originalEvent.type)) this._value(item.value);
                    }
                    // Announce the value in the liveRegion
                    label = ui.item.attr("aria-label") || item.value;
                    if (label && $.trim(label).length) {
                        this.liveRegion.children().hide();
                        $("<div>").text(label).appendTo(this.liveRegion);
                    }
                },
                menuselect: function(event, ui) {
                    var item = ui.item.data("ui-autocomplete-item"), previous = this.previous;
                    // only trigger when focus was lost (click on menu)
                    if (this.element[0] !== this.document[0].activeElement) {
                        this.element.focus();
                        this.previous = previous;
                        // #6109 - IE triggers two focus events and the second
                        // is asynchronous, so we need to reset the previous
                        // term synchronously and asynchronously :-(
                        this._delay(function() {
                            this.previous = previous;
                            this.selectedItem = item;
                        });
                    }
                    if (false !== this._trigger("select", event, {
                        item: item
                    })) this._value(item.value);
                    // reset the term after the select event
                    // this allows custom select handling to work properly
                    this.term = this._value();
                    this.close(event);
                    this.selectedItem = item;
                }
            });
            this.liveRegion = $("<span>", {
                role: "status",
                "aria-live": "assertive",
                "aria-relevant": "additions"
            }).addClass("ui-helper-hidden-accessible").appendTo(this.document[0].body);
            // turning off autocomplete prevents the browser from remembering the
            // value when navigating through history, so we re-enable autocomplete
            // if the page is unloaded before the widget is destroyed. #7790
            this._on(this.window, {
                beforeunload: function() {
                    this.element.removeAttr("autocomplete");
                }
            });
        },
        _destroy: function() {
            clearTimeout(this.searching);
            this.element.removeClass("ui-autocomplete-input").removeAttr("autocomplete");
            this.menu.element.remove();
            this.liveRegion.remove();
        },
        _setOption: function(key, value) {
            this._super(key, value);
            if (key === "source") this._initSource();
            if (key === "appendTo") this.menu.element.appendTo(this._appendTo());
            if (key === "disabled" && value && this.xhr) this.xhr.abort();
        },
        _appendTo: function() {
            var element = this.options.appendTo;
            if (element) element = element.jquery || element.nodeType ? $(element) : this.document.find(element).eq(0);
            if (!element || !element[0]) element = this.element.closest(".ui-front");
            if (!element.length) element = this.document[0].body;
            return element;
        },
        _initSource: function() {
            var array, url, that = this;
            if ($.isArray(this.options.source)) {
                array = this.options.source;
                this.source = function(request, response) {
                    response($.ui.autocomplete.filter(array, request.term));
                };
            } else if (typeof this.options.source === "string") {
                url = this.options.source;
                this.source = function(request, response) {
                    if (that.xhr) that.xhr.abort();
                    that.xhr = $.ajax({
                        url: url,
                        data: request,
                        dataType: "json",
                        success: function(data) {
                            response(data);
                        },
                        error: function() {
                            response([]);
                        }
                    });
                };
            } else this.source = this.options.source;
        },
        _searchTimeout: function(event) {
            clearTimeout(this.searching);
            this.searching = this._delay(function() {
                // Search if the value has changed, or if the user retypes the same value (see #7434)
                var equalValues = this.term === this._value(), menuVisible = this.menu.element.is(":visible"), modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
                if (!equalValues || equalValues && !menuVisible && !modifierKey) {
                    this.selectedItem = null;
                    this.search(null, event);
                }
            }, this.options.delay);
        },
        search: function(value, event) {
            value = value != null ? value : this._value();
            // always save the actual value, not the one passed as an argument
            this.term = this._value();
            if (value.length < this.options.minLength) return this.close(event);
            if (this._trigger("search", event) === false) return;
            return this._search(value);
        },
        _search: function(value) {
            this.pending++;
            this.element.addClass("ui-autocomplete-loading");
            this.cancelSearch = false;
            this.source({
                term: value
            }, this._response());
        },
        _response: function() {
            var index = ++this.requestIndex;
            return $.proxy(function(content) {
                if (index === this.requestIndex) this.__response(content);
                this.pending--;
                if (!this.pending) this.element.removeClass("ui-autocomplete-loading");
            }, this);
        },
        __response: function(content) {
            if (content) content = this._normalize(content);
            this._trigger("response", null, {
                content: content
            });
            if (!this.options.disabled && content && content.length && !this.cancelSearch) {
                this._suggest(content);
                this._trigger("open");
            } else // use ._close() instead of .close() so we don't cancel future searches
            this._close();
        },
        close: function(event) {
            this.cancelSearch = true;
            this._close(event);
        },
        _close: function(event) {
            if (this.menu.element.is(":visible")) {
                this.menu.element.hide();
                this.menu.blur();
                this.isNewMenu = true;
                this._trigger("close", event);
            }
        },
        _change: function(event) {
            if (this.previous !== this._value()) this._trigger("change", event, {
                item: this.selectedItem
            });
        },
        _normalize: function(items) {
            // assume all items have the right format when the first item is complete
            if (items.length && items[0].label && items[0].value) return items;
            return $.map(items, function(item) {
                if (typeof item === "string") return {
                    label: item,
                    value: item
                };
                return $.extend({}, item, {
                    label: item.label || item.value,
                    value: item.value || item.label
                });
            });
        },
        _suggest: function(items) {
            var ul = this.menu.element.empty();
            this._renderMenu(ul, items);
            this.isNewMenu = true;
            this.menu.refresh();
            // size and position menu
            ul.show();
            this._resizeMenu();
            ul.position($.extend({
                of: this.element
            }, this.options.position));
            if (this.options.autoFocus) this.menu.next();
        },
        _resizeMenu: function() {
            var ul = this.menu.element;
            ul.outerWidth(Math.max(// Firefox wraps long text (possibly a rounding bug)
            // so we add 1px to avoid the wrapping (#7513)
            ul.width("").outerWidth() + 1, this.element.outerWidth()));
        },
        _renderMenu: function(ul, items) {
            var that = this;
            $.each(items, function(index, item) {
                that._renderItemData(ul, item);
            });
        },
        _renderItemData: function(ul, item) {
            return this._renderItem(ul, item).data("ui-autocomplete-item", item);
        },
        _renderItem: function(ul, item) {
            return $("<li>").text(item.label).appendTo(ul);
        },
        _move: function(direction, event) {
            if (!this.menu.element.is(":visible")) {
                this.search(null, event);
                return;
            }
            if (this.menu.isFirstItem() && /^previous/.test(direction) || this.menu.isLastItem() && /^next/.test(direction)) {
                if (!this.isMultiLine) this._value(this.term);
                this.menu.blur();
                return;
            }
            this.menu[direction](event);
        },
        widget: function() {
            return this.menu.element;
        },
        _value: function() {
            return this.valueMethod.apply(this.element, arguments);
        },
        _keyEvent: function(keyEvent, event) {
            if (!this.isMultiLine || this.menu.element.is(":visible")) {
                this._move(keyEvent, event);
                // prevents moving cursor to beginning/end of the text field in some browsers
                event.preventDefault();
            }
        }
    });
    $.extend($.ui.autocomplete, {
        escapeRegex: function(value) {
            return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
        },
        filter: function(array, term) {
            var matcher = new RegExp($.ui.autocomplete.escapeRegex(term), "i");
            return $.grep(array, function(value) {
                return matcher.test(value.label || value.value || value);
            });
        }
    });
    // live region extension, adding a `messages` option
    // NOTE: This is an experimental API. We are still investigating
    // a full solution for string manipulation and internationalization.
    $.widget("ui.autocomplete", $.ui.autocomplete, {
        options: {
            messages: {
                noResults: "No search results.",
                results: function(amount) {
                    return amount + (amount > 1 ? " results are" : " result is") + " available, use up and down arrow keys to navigate.";
                }
            }
        },
        __response: function(content) {
            var message;
            this._superApply(arguments);
            if (this.options.disabled || this.cancelSearch) return;
            if (content && content.length) message = this.options.messages.results(content.length);
            else message = this.options.messages.noResults;
            this.liveRegion.children().hide();
            $("<div>").text(message).appendTo(this.liveRegion);
        }
    });
    var autocomplete = $.ui.autocomplete;
    /*!
 * jQuery UI Button 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/button/
 */ var lastActive, baseClasses = "ui-button ui-widget ui-state-default ui-corner-all", typeClasses = "ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only", formResetHandler = function() {
        var form = $(this);
        setTimeout(function() {
            form.find(":ui-button").button("refresh");
        }, 1);
    }, radioGroup = function(radio) {
        var name = radio.name, form = radio.form, radios = $([]);
        if (name) {
            name = name.replace(/'/g, "\\'");
            if (form) radios = $(form).find("[name='" + name + "'][type=radio]");
            else radios = $("[name='" + name + "'][type=radio]", radio.ownerDocument).filter(function() {
                return !this.form;
            });
        }
        return radios;
    };
    $.widget("ui.button", {
        version: "1.11.1",
        defaultElement: "<button>",
        options: {
            disabled: null,
            text: true,
            label: null,
            icons: {
                primary: null,
                secondary: null
            }
        },
        _create: function() {
            this.element.closest("form").unbind("reset" + this.eventNamespace).bind("reset" + this.eventNamespace, formResetHandler);
            if (typeof this.options.disabled !== "boolean") this.options.disabled = !!this.element.prop("disabled");
            else this.element.prop("disabled", this.options.disabled);
            this._determineButtonType();
            this.hasTitle = !!this.buttonElement.attr("title");
            var that = this, options = this.options, toggleButton = this.type === "checkbox" || this.type === "radio", activeClass = !toggleButton ? "ui-state-active" : "";
            if (options.label === null) options.label = this.type === "input" ? this.buttonElement.val() : this.buttonElement.html();
            this._hoverable(this.buttonElement);
            this.buttonElement.addClass(baseClasses).attr("role", "button").bind("mouseenter" + this.eventNamespace, function() {
                if (options.disabled) return;
                if (this === lastActive) $(this).addClass("ui-state-active");
            }).bind("mouseleave" + this.eventNamespace, function() {
                if (options.disabled) return;
                $(this).removeClass(activeClass);
            }).bind("click" + this.eventNamespace, function(event) {
                if (options.disabled) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
            });
            // Can't use _focusable() because the element that receives focus
            // and the element that gets the ui-state-focus class are different
            this._on({
                focus: function() {
                    this.buttonElement.addClass("ui-state-focus");
                },
                blur: function() {
                    this.buttonElement.removeClass("ui-state-focus");
                }
            });
            if (toggleButton) this.element.bind("change" + this.eventNamespace, function() {
                that.refresh();
            });
            if (this.type === "checkbox") this.buttonElement.bind("click" + this.eventNamespace, function() {
                if (options.disabled) return false;
            });
            else if (this.type === "radio") this.buttonElement.bind("click" + this.eventNamespace, function() {
                if (options.disabled) return false;
                $(this).addClass("ui-state-active");
                that.buttonElement.attr("aria-pressed", "true");
                var radio = that.element[0];
                radioGroup(radio).not(radio).map(function() {
                    return $(this).button("widget")[0];
                }).removeClass("ui-state-active").attr("aria-pressed", "false");
            });
            else {
                this.buttonElement.bind("mousedown" + this.eventNamespace, function() {
                    if (options.disabled) return false;
                    $(this).addClass("ui-state-active");
                    lastActive = this;
                    that.document.one("mouseup", function() {
                        lastActive = null;
                    });
                }).bind("mouseup" + this.eventNamespace, function() {
                    if (options.disabled) return false;
                    $(this).removeClass("ui-state-active");
                }).bind("keydown" + this.eventNamespace, function(event) {
                    if (options.disabled) return false;
                    if (event.keyCode === $.ui.keyCode.SPACE || event.keyCode === $.ui.keyCode.ENTER) $(this).addClass("ui-state-active");
                })// see #8559, we bind to blur here in case the button element loses
                // focus between keydown and keyup, it would be left in an "active" state
                .bind("keyup" + this.eventNamespace + " blur" + this.eventNamespace, function() {
                    $(this).removeClass("ui-state-active");
                });
                if (this.buttonElement.is("a")) this.buttonElement.keyup(function(event) {
                    if (event.keyCode === $.ui.keyCode.SPACE) // TODO pass through original event correctly (just as 2nd argument doesn't work)
                    $(this).click();
                });
            }
            this._setOption("disabled", options.disabled);
            this._resetButton();
        },
        _determineButtonType: function() {
            var ancestor, labelSelector, checked;
            if (this.element.is("[type=checkbox]")) this.type = "checkbox";
            else if (this.element.is("[type=radio]")) this.type = "radio";
            else if (this.element.is("input")) this.type = "input";
            else this.type = "button";
            if (this.type === "checkbox" || this.type === "radio") {
                // we don't search against the document in case the element
                // is disconnected from the DOM
                ancestor = this.element.parents().last();
                labelSelector = "label[for='" + this.element.attr("id") + "']";
                this.buttonElement = ancestor.find(labelSelector);
                if (!this.buttonElement.length) {
                    ancestor = ancestor.length ? ancestor.siblings() : this.element.siblings();
                    this.buttonElement = ancestor.filter(labelSelector);
                    if (!this.buttonElement.length) this.buttonElement = ancestor.find(labelSelector);
                }
                this.element.addClass("ui-helper-hidden-accessible");
                checked = this.element.is(":checked");
                if (checked) this.buttonElement.addClass("ui-state-active");
                this.buttonElement.prop("aria-pressed", checked);
            } else this.buttonElement = this.element;
        },
        widget: function() {
            return this.buttonElement;
        },
        _destroy: function() {
            this.element.removeClass("ui-helper-hidden-accessible");
            this.buttonElement.removeClass(baseClasses + " ui-state-active " + typeClasses).removeAttr("role").removeAttr("aria-pressed").html(this.buttonElement.find(".ui-button-text").html());
            if (!this.hasTitle) this.buttonElement.removeAttr("title");
        },
        _setOption: function(key, value) {
            this._super(key, value);
            if (key === "disabled") {
                this.widget().toggleClass("ui-state-disabled", !!value);
                this.element.prop("disabled", !!value);
                if (value) {
                    if (this.type === "checkbox" || this.type === "radio") this.buttonElement.removeClass("ui-state-focus");
                    else this.buttonElement.removeClass("ui-state-focus ui-state-active");
                }
                return;
            }
            this._resetButton();
        },
        refresh: function() {
            //See #8237 & #8828
            var isDisabled = this.element.is("input, button") ? this.element.is(":disabled") : this.element.hasClass("ui-button-disabled");
            if (isDisabled !== this.options.disabled) this._setOption("disabled", isDisabled);
            if (this.type === "radio") radioGroup(this.element[0]).each(function() {
                if ($(this).is(":checked")) $(this).button("widget").addClass("ui-state-active").attr("aria-pressed", "true");
                else $(this).button("widget").removeClass("ui-state-active").attr("aria-pressed", "false");
            });
            else if (this.type === "checkbox") {
                if (this.element.is(":checked")) this.buttonElement.addClass("ui-state-active").attr("aria-pressed", "true");
                else this.buttonElement.removeClass("ui-state-active").attr("aria-pressed", "false");
            }
        },
        _resetButton: function() {
            if (this.type === "input") {
                if (this.options.label) this.element.val(this.options.label);
                return;
            }
            var buttonElement = this.buttonElement.removeClass(typeClasses), buttonText = $("<span></span>", this.document[0]).addClass("ui-button-text").html(this.options.label).appendTo(buttonElement.empty()).text(), icons = this.options.icons, multipleIcons = icons.primary && icons.secondary, buttonClasses = [];
            if (icons.primary || icons.secondary) {
                if (this.options.text) buttonClasses.push("ui-button-text-icon" + (multipleIcons ? "s" : icons.primary ? "-primary" : "-secondary"));
                if (icons.primary) buttonElement.prepend("<span class='ui-button-icon-primary ui-icon " + icons.primary + "'></span>");
                if (icons.secondary) buttonElement.append("<span class='ui-button-icon-secondary ui-icon " + icons.secondary + "'></span>");
                if (!this.options.text) {
                    buttonClasses.push(multipleIcons ? "ui-button-icons-only" : "ui-button-icon-only");
                    if (!this.hasTitle) buttonElement.attr("title", $.trim(buttonText));
                }
            } else buttonClasses.push("ui-button-text-only");
            buttonElement.addClass(buttonClasses.join(" "));
        }
    });
    $.widget("ui.buttonset", {
        version: "1.11.1",
        options: {
            items: "button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"
        },
        _create: function() {
            this.element.addClass("ui-buttonset");
        },
        _init: function() {
            this.refresh();
        },
        _setOption: function(key, value) {
            if (key === "disabled") this.buttons.button("option", key, value);
            this._super(key, value);
        },
        refresh: function() {
            var rtl = this.element.css("direction") === "rtl", allButtons = this.element.find(this.options.items), existingButtons = allButtons.filter(":ui-button");
            // Initialize new buttons
            allButtons.not(":ui-button").button();
            // Refresh existing buttons
            existingButtons.button("refresh");
            this.buttons = allButtons.map(function() {
                return $(this).button("widget")[0];
            }).removeClass("ui-corner-all ui-corner-left ui-corner-right").filter(":first").addClass(rtl ? "ui-corner-right" : "ui-corner-left").end().filter(":last").addClass(rtl ? "ui-corner-left" : "ui-corner-right").end().end();
        },
        _destroy: function() {
            this.element.removeClass("ui-buttonset");
            this.buttons.map(function() {
                return $(this).button("widget")[0];
            }).removeClass("ui-corner-left ui-corner-right").end().button("destroy");
        }
    });
    var button = $.ui.button;
    /*!
 * jQuery UI Datepicker 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/datepicker/
 */ $.extend($.ui, {
        datepicker: {
            version: "1.11.1"
        }
    });
    var datepicker_instActive;
    function datepicker_getZindex(elem) {
        var position, value;
        while(elem.length && elem[0] !== document){
            // Ignore z-index if position is set to a value where z-index is ignored by the browser
            // This makes behavior of this function consistent across browsers
            // WebKit always returns auto if the element is positioned
            position = elem.css("position");
            if (position === "absolute" || position === "relative" || position === "fixed") {
                // IE returns 0 when zIndex is not specified
                // other browsers return a string
                // we ignore the case of nested elements with an explicit value of 0
                // <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
                value = parseInt(elem.css("zIndex"), 10);
                if (!isNaN(value) && value !== 0) return value;
            }
            elem = elem.parent();
        }
        return 0;
    }
    /* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */ function Datepicker() {
        this._curInst = null; // The current instance in use
        this._keyEvent = false; // If the last event was a key event
        this._disabledInputs = []; // List of date picker inputs that have been disabled
        this._datepickerShowing = false; // True if the popup picker is showing , false if not
        this._inDialog = false; // True if showing within a "dialog", false if not
        this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
        this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
        this._appendClass = "ui-datepicker-append"; // The name of the append marker class
        this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
        this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
        this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
        this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
        this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
        this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
        this.regional = []; // Available regional settings, indexed by language code
        this.regional[""] = {
            closeText: "Done",
            prevText: "Prev",
            nextText: "Next",
            currentText: "Today",
            monthNames: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            monthNamesShort: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            dayNames: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            dayNamesShort: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            dayNamesMin: [
                "Su",
                "Mo",
                "Tu",
                "We",
                "Th",
                "Fr",
                "Sa"
            ],
            weekHeader: "Wk",
            dateFormat: "mm/dd/yy",
            firstDay: 0,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: "" // Additional text to append to the year in the month headers
        };
        this._defaults = {
            showOn: "focus",
            // "button" for trigger button, or "both" for either
            showAnim: "fadeIn",
            showOptions: {},
            defaultDate: null,
            // +/-number for offset from today, null for today
            appendText: "",
            buttonText: "...",
            buttonImage: "",
            buttonImageOnly: false,
            hideIfNoPrevNext: false,
            // if not applicable, false to just disable them
            navigationAsDateFormat: false,
            gotoCurrent: false,
            changeMonth: false,
            changeYear: false,
            yearRange: "c-10:c+10",
            // either relative to today's year (-nn:+nn), relative to currently displayed year
            // (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
            showOtherMonths: false,
            selectOtherMonths: false,
            showWeek: false,
            calculateWeek: this.iso8601Week,
            // takes a Date and returns the number of the week for it
            shortYearCutoff: "+10",
            // > this are in the previous century,
            // string value starting with "+" for current year + value
            minDate: null,
            maxDate: null,
            duration: "fast",
            beforeShowDay: null,
            // [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
            // [2] = cell title (optional), e.g. $.datepicker.noWeekends
            beforeShow: null,
            // returns a set of custom settings for the date picker
            onSelect: null,
            onChangeMonthYear: null,
            onClose: null,
            numberOfMonths: 1,
            showCurrentAtPos: 0,
            stepMonths: 1,
            stepBigMonths: 12,
            altField: "",
            altFormat: "",
            constrainInput: true,
            showButtonPanel: false,
            autoSize: false,
            disabled: false // The initial disabled state
        };
        $.extend(this._defaults, this.regional[""]);
        this.regional.en = $.extend(true, {}, this.regional[""]);
        this.regional["en-US"] = $.extend(true, {}, this.regional.en);
        this.dpDiv = datepicker_bindHover($("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));
    }
    $.extend(Datepicker.prototype, {
        /* Class name added to elements to indicate already configured with a date picker. */ markerClassName: "hasDatepicker",
        //Keep track of the maximum number of rows displayed (see #7043)
        maxRows: 4,
        // TODO rename to "widget" when switching to widget factory
        _widgetDatepicker: function() {
            return this.dpDiv;
        },
        /* Override the default settings for all instances of the date picker.
	 * @param  settings  object - the new settings to use as defaults (anonymous object)
	 * @return the manager object
	 */ setDefaults: function(settings) {
            datepicker_extendRemove(this._defaults, settings || {});
            return this;
        },
        /* Attach the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
	 */ _attachDatepicker: function(target, settings) {
            var nodeName, inline, inst;
            nodeName = target.nodeName.toLowerCase();
            inline = nodeName === "div" || nodeName === "span";
            if (!target.id) {
                this.uuid += 1;
                target.id = "dp" + this.uuid;
            }
            inst = this._newInst($(target), inline);
            inst.settings = $.extend({}, settings || {});
            if (nodeName === "input") this._connectDatepicker(target, inst);
            else if (inline) this._inlineDatepicker(target, inst);
        },
        /* Create a new instance object. */ _newInst: function(target, inline) {
            var id = target[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1"); // escape jQuery meta chars
            return {
                id: id,
                input: target,
                selectedDay: 0,
                selectedMonth: 0,
                selectedYear: 0,
                drawMonth: 0,
                drawYear: 0,
                inline: inline,
                dpDiv: !inline ? this.dpDiv : datepicker_bindHover($("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))
            };
        },
        /* Attach the date picker to an input field. */ _connectDatepicker: function(target, inst) {
            var input = $(target);
            inst.append = $([]);
            inst.trigger = $([]);
            if (input.hasClass(this.markerClassName)) return;
            this._attachments(input, inst);
            input.addClass(this.markerClassName).keydown(this._doKeyDown).keypress(this._doKeyPress).keyup(this._doKeyUp);
            this._autoSize(inst);
            $.data(target, "datepicker", inst);
            //If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
            if (inst.settings.disabled) this._disableDatepicker(target);
        },
        /* Make attachments based on settings. */ _attachments: function(input, inst) {
            var showOn, buttonText, buttonImage, appendText = this._get(inst, "appendText"), isRTL = this._get(inst, "isRTL");
            if (inst.append) inst.append.remove();
            if (appendText) {
                inst.append = $("<span class='" + this._appendClass + "'>" + appendText + "</span>");
                input[isRTL ? "before" : "after"](inst.append);
            }
            input.unbind("focus", this._showDatepicker);
            if (inst.trigger) inst.trigger.remove();
            showOn = this._get(inst, "showOn");
            if (showOn === "focus" || showOn === "both") input.focus(this._showDatepicker);
            if (showOn === "button" || showOn === "both") {
                buttonText = this._get(inst, "buttonText");
                buttonImage = this._get(inst, "buttonImage");
                inst.trigger = $(this._get(inst, "buttonImageOnly") ? $("<img/>").addClass(this._triggerClass).attr({
                    src: buttonImage,
                    alt: buttonText,
                    title: buttonText
                }) : $("<button type='button'></button>").addClass(this._triggerClass).html(!buttonImage ? buttonText : $("<img/>").attr({
                    src: buttonImage,
                    alt: buttonText,
                    title: buttonText
                })));
                input[isRTL ? "before" : "after"](inst.trigger);
                inst.trigger.click(function() {
                    if ($.datepicker._datepickerShowing && $.datepicker._lastInput === input[0]) $.datepicker._hideDatepicker();
                    else if ($.datepicker._datepickerShowing && $.datepicker._lastInput !== input[0]) {
                        $.datepicker._hideDatepicker();
                        $.datepicker._showDatepicker(input[0]);
                    } else $.datepicker._showDatepicker(input[0]);
                    return false;
                });
            }
        },
        /* Apply the maximum length for the date format. */ _autoSize: function(inst) {
            if (this._get(inst, "autoSize") && !inst.inline) {
                var findMax, max, maxI, i, date = new Date(2009, 11, 20), dateFormat = this._get(inst, "dateFormat");
                if (dateFormat.match(/[DM]/)) {
                    findMax = function(names) {
                        max = 0;
                        maxI = 0;
                        for(i = 0; i < names.length; i++)if (names[i].length > max) {
                            max = names[i].length;
                            maxI = i;
                        }
                        return maxI;
                    };
                    date.setMonth(findMax(this._get(inst, dateFormat.match(/MM/) ? "monthNames" : "monthNamesShort")));
                    date.setDate(findMax(this._get(inst, dateFormat.match(/DD/) ? "dayNames" : "dayNamesShort")) + 20 - date.getDay());
                }
                inst.input.attr("size", this._formatDate(inst, date).length);
            }
        },
        /* Attach an inline date picker to a div. */ _inlineDatepicker: function(target, inst) {
            var divSpan = $(target);
            if (divSpan.hasClass(this.markerClassName)) return;
            divSpan.addClass(this.markerClassName).append(inst.dpDiv);
            $.data(target, "datepicker", inst);
            this._setDate(inst, this._getDefaultDate(inst), true);
            this._updateDatepicker(inst);
            this._updateAlternate(inst);
            //If disabled option is true, disable the datepicker before showing it (see ticket #5665)
            if (inst.settings.disabled) this._disableDatepicker(target);
            // Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
            // http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
            inst.dpDiv.css("display", "block");
        },
        /* Pop-up the date picker in a "dialog" box.
	 * @param  input element - ignored
	 * @param  date	string or Date - the initial date to display
	 * @param  onSelect  function - the function to call when a date is selected
	 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	 * @param  pos int[2] - coordinates for the dialog's position within the screen or
	 *					event - with x/y coordinates or
	 *					leave empty for default (screen centre)
	 * @return the manager object
	 */ _dialogDatepicker: function(input, date, onSelect, settings, pos) {
            var id, browserWidth, browserHeight, scrollX, scrollY, inst = this._dialogInst; // internal instance
            if (!inst) {
                this.uuid += 1;
                id = "dp" + this.uuid;
                this._dialogInput = $("<input type='text' id='" + id + "' style='position: absolute; top: -100px; width: 0px;'/>");
                this._dialogInput.keydown(this._doKeyDown);
                $("body").append(this._dialogInput);
                inst = this._dialogInst = this._newInst(this._dialogInput, false);
                inst.settings = {};
                $.data(this._dialogInput[0], "datepicker", inst);
            }
            datepicker_extendRemove(inst.settings, settings || {});
            date = date && date.constructor === Date ? this._formatDate(inst, date) : date;
            this._dialogInput.val(date);
            this._pos = pos ? pos.length ? pos : [
                pos.pageX,
                pos.pageY
            ] : null;
            if (!this._pos) {
                browserWidth = document.documentElement.clientWidth;
                browserHeight = document.documentElement.clientHeight;
                scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
                scrollY = document.documentElement.scrollTop || document.body.scrollTop;
                this._pos = [
                    browserWidth / 2 - 100 + scrollX,
                    browserHeight / 2 - 150 + scrollY
                ];
            }
            // move input on screen for focus, but hidden behind dialog
            this._dialogInput.css("left", this._pos[0] + 20 + "px").css("top", this._pos[1] + "px");
            inst.settings.onSelect = onSelect;
            this._inDialog = true;
            this.dpDiv.addClass(this._dialogClass);
            this._showDatepicker(this._dialogInput[0]);
            if ($.blockUI) $.blockUI(this.dpDiv);
            $.data(this._dialogInput[0], "datepicker", inst);
            return this;
        },
        /* Detach a datepicker from its control.
	 * @param  target	element - the target input field or division or span
	 */ _destroyDatepicker: function(target) {
            var nodeName, $target = $(target), inst = $.data(target, "datepicker");
            if (!$target.hasClass(this.markerClassName)) return;
            nodeName = target.nodeName.toLowerCase();
            $.removeData(target, "datepicker");
            if (nodeName === "input") {
                inst.append.remove();
                inst.trigger.remove();
                $target.removeClass(this.markerClassName).unbind("focus", this._showDatepicker).unbind("keydown", this._doKeyDown).unbind("keypress", this._doKeyPress).unbind("keyup", this._doKeyUp);
            } else if (nodeName === "div" || nodeName === "span") $target.removeClass(this.markerClassName).empty();
        },
        /* Enable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */ _enableDatepicker: function(target) {
            var nodeName, inline, $target = $(target), inst = $.data(target, "datepicker");
            if (!$target.hasClass(this.markerClassName)) return;
            nodeName = target.nodeName.toLowerCase();
            if (nodeName === "input") {
                target.disabled = false;
                inst.trigger.filter("button").each(function() {
                    this.disabled = false;
                }).end().filter("img").css({
                    opacity: "1.0",
                    cursor: ""
                });
            } else if (nodeName === "div" || nodeName === "span") {
                inline = $target.children("." + this._inlineClass);
                inline.children().removeClass("ui-state-disabled");
                inline.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", false);
            }
            this._disabledInputs = $.map(this._disabledInputs, function(value) {
                return value === target ? null : value;
            }); // delete entry
        },
        /* Disable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */ _disableDatepicker: function(target) {
            var nodeName, inline, $target = $(target), inst = $.data(target, "datepicker");
            if (!$target.hasClass(this.markerClassName)) return;
            nodeName = target.nodeName.toLowerCase();
            if (nodeName === "input") {
                target.disabled = true;
                inst.trigger.filter("button").each(function() {
                    this.disabled = true;
                }).end().filter("img").css({
                    opacity: "0.5",
                    cursor: "default"
                });
            } else if (nodeName === "div" || nodeName === "span") {
                inline = $target.children("." + this._inlineClass);
                inline.children().addClass("ui-state-disabled");
                inline.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", true);
            }
            this._disabledInputs = $.map(this._disabledInputs, function(value) {
                return value === target ? null : value;
            }); // delete entry
            this._disabledInputs[this._disabledInputs.length] = target;
        },
        /* Is the first field in a jQuery collection disabled as a datepicker?
	 * @param  target	element - the target input field or division or span
	 * @return boolean - true if disabled, false if enabled
	 */ _isDisabledDatepicker: function(target) {
            if (!target) return false;
            for(var i = 0; i < this._disabledInputs.length; i++){
                if (this._disabledInputs[i] === target) return true;
            }
            return false;
        },
        /* Retrieve the instance data for the target control.
	 * @param  target  element - the target input field or division or span
	 * @return  object - the associated instance data
	 * @throws  error if a jQuery problem getting data
	 */ _getInst: function(target) {
            try {
                return $.data(target, "datepicker");
            } catch (err) {
                throw "Missing instance data for this datepicker";
            }
        },
        /* Update or retrieve the settings for a date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 * @param  name	object - the new settings to update or
	 *				string - the name of the setting to change or retrieve,
	 *				when retrieving also "all" for all instance settings or
	 *				"defaults" for all global defaults
	 * @param  value   any - the new value for the setting
	 *				(omit if above is an object or to retrieve a value)
	 */ _optionDatepicker: function(target, name, value) {
            var settings, date, minDate, maxDate, inst = this._getInst(target);
            if (arguments.length === 2 && typeof name === "string") return name === "defaults" ? $.extend({}, $.datepicker._defaults) : inst ? name === "all" ? $.extend({}, inst.settings) : this._get(inst, name) : null;
            settings = name || {};
            if (typeof name === "string") {
                settings = {};
                settings[name] = value;
            }
            if (inst) {
                if (this._curInst === inst) this._hideDatepicker();
                date = this._getDateDatepicker(target, true);
                minDate = this._getMinMaxDate(inst, "min");
                maxDate = this._getMinMaxDate(inst, "max");
                datepicker_extendRemove(inst.settings, settings);
                // reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
                if (minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined) inst.settings.minDate = this._formatDate(inst, minDate);
                if (maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined) inst.settings.maxDate = this._formatDate(inst, maxDate);
                if ("disabled" in settings) {
                    if (settings.disabled) this._disableDatepicker(target);
                    else this._enableDatepicker(target);
                }
                this._attachments($(target), inst);
                this._autoSize(inst);
                this._setDate(inst, date);
                this._updateAlternate(inst);
                this._updateDatepicker(inst);
            }
        },
        // change method deprecated
        _changeDatepicker: function(target, name, value) {
            this._optionDatepicker(target, name, value);
        },
        /* Redraw the date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 */ _refreshDatepicker: function(target) {
            var inst = this._getInst(target);
            if (inst) this._updateDatepicker(inst);
        },
        /* Set the dates for a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  date	Date - the new date
	 */ _setDateDatepicker: function(target, date) {
            var inst = this._getInst(target);
            if (inst) {
                this._setDate(inst, date);
                this._updateDatepicker(inst);
                this._updateAlternate(inst);
            }
        },
        /* Get the date(s) for the first entry in a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  noDefault boolean - true if no default date is to be used
	 * @return Date - the current date
	 */ _getDateDatepicker: function(target, noDefault) {
            var inst = this._getInst(target);
            if (inst && !inst.inline) this._setDateFromField(inst, noDefault);
            return inst ? this._getDate(inst) : null;
        },
        /* Handle keystrokes. */ _doKeyDown: function(event) {
            var onSelect, dateStr, sel, inst = $.datepicker._getInst(event.target), handled = true, isRTL = inst.dpDiv.is(".ui-datepicker-rtl");
            inst._keyEvent = true;
            if ($.datepicker._datepickerShowing) switch(event.keyCode){
                case 9:
                    $.datepicker._hideDatepicker();
                    handled = false;
                    break; // hide on tab out
                case 13:
                    sel = $("td." + $.datepicker._dayOverClass + ":not(." + $.datepicker._currentClass + ")", inst.dpDiv);
                    if (sel[0]) $.datepicker._selectDay(event.target, inst.selectedMonth, inst.selectedYear, sel[0]);
                    onSelect = $.datepicker._get(inst, "onSelect");
                    if (onSelect) {
                        dateStr = $.datepicker._formatDate(inst);
                        // trigger custom callback
                        onSelect.apply(inst.input ? inst.input[0] : null, [
                            dateStr,
                            inst
                        ]);
                    } else $.datepicker._hideDatepicker();
                    return false; // don't submit the form
                case 27:
                    $.datepicker._hideDatepicker();
                    break; // hide on escape
                case 33:
                    $.datepicker._adjustDate(event.target, event.ctrlKey ? -$.datepicker._get(inst, "stepBigMonths") : -$.datepicker._get(inst, "stepMonths"), "M");
                    break; // previous month/year on page up/+ ctrl
                case 34:
                    $.datepicker._adjustDate(event.target, event.ctrlKey ? +$.datepicker._get(inst, "stepBigMonths") : +$.datepicker._get(inst, "stepMonths"), "M");
                    break; // next month/year on page down/+ ctrl
                case 35:
                    if (event.ctrlKey || event.metaKey) $.datepicker._clearDate(event.target);
                    handled = event.ctrlKey || event.metaKey;
                    break; // clear on ctrl or command +end
                case 36:
                    if (event.ctrlKey || event.metaKey) $.datepicker._gotoToday(event.target);
                    handled = event.ctrlKey || event.metaKey;
                    break; // current on ctrl or command +home
                case 37:
                    if (event.ctrlKey || event.metaKey) $.datepicker._adjustDate(event.target, isRTL ? 1 : -1, "D");
                    handled = event.ctrlKey || event.metaKey;
                    // -1 day on ctrl or command +left
                    if (event.originalEvent.altKey) $.datepicker._adjustDate(event.target, event.ctrlKey ? -$.datepicker._get(inst, "stepBigMonths") : -$.datepicker._get(inst, "stepMonths"), "M");
                    break;
                case 38:
                    if (event.ctrlKey || event.metaKey) $.datepicker._adjustDate(event.target, -7, "D");
                    handled = event.ctrlKey || event.metaKey;
                    break; // -1 week on ctrl or command +up
                case 39:
                    if (event.ctrlKey || event.metaKey) $.datepicker._adjustDate(event.target, isRTL ? -1 : 1, "D");
                    handled = event.ctrlKey || event.metaKey;
                    // +1 day on ctrl or command +right
                    if (event.originalEvent.altKey) $.datepicker._adjustDate(event.target, event.ctrlKey ? +$.datepicker._get(inst, "stepBigMonths") : +$.datepicker._get(inst, "stepMonths"), "M");
                    break;
                case 40:
                    if (event.ctrlKey || event.metaKey) $.datepicker._adjustDate(event.target, 7, "D");
                    handled = event.ctrlKey || event.metaKey;
                    break; // +1 week on ctrl or command +down
                default:
                    handled = false;
            }
            else if (event.keyCode === 36 && event.ctrlKey) $.datepicker._showDatepicker(this);
            else handled = false;
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
            }
        },
        /* Filter entered characters - based on date format. */ _doKeyPress: function(event) {
            var chars, chr, inst = $.datepicker._getInst(event.target);
            if ($.datepicker._get(inst, "constrainInput")) {
                chars = $.datepicker._possibleChars($.datepicker._get(inst, "dateFormat"));
                chr = String.fromCharCode(event.charCode == null ? event.keyCode : event.charCode);
                return event.ctrlKey || event.metaKey || chr < " " || !chars || chars.indexOf(chr) > -1;
            }
        },
        /* Synchronise manual entry and field/alternate field. */ _doKeyUp: function(event) {
            var date, inst = $.datepicker._getInst(event.target);
            if (inst.input.val() !== inst.lastVal) try {
                date = $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"), inst.input ? inst.input.val() : null, $.datepicker._getFormatConfig(inst));
                if (date) {
                    $.datepicker._setDateFromField(inst);
                    $.datepicker._updateAlternate(inst);
                    $.datepicker._updateDatepicker(inst);
                }
            } catch (err) {}
            return true;
        },
        /* Pop-up the date picker for a given input field.
	 * If false returned from beforeShow event handler do not show.
	 * @param  input  element - the input field attached to the date picker or
	 *					event - if triggered by focus
	 */ _showDatepicker: function(input) {
            input = input.target || input;
            if (input.nodeName.toLowerCase() !== "input") input = $("input", input.parentNode)[0];
            if ($.datepicker._isDisabledDatepicker(input) || $.datepicker._lastInput === input) return;
            var inst, beforeShow, beforeShowSettings, isFixed, offset, showAnim, duration;
            inst = $.datepicker._getInst(input);
            if ($.datepicker._curInst && $.datepicker._curInst !== inst) {
                $.datepicker._curInst.dpDiv.stop(true, true);
                if (inst && $.datepicker._datepickerShowing) $.datepicker._hideDatepicker($.datepicker._curInst.input[0]);
            }
            beforeShow = $.datepicker._get(inst, "beforeShow");
            beforeShowSettings = beforeShow ? beforeShow.apply(input, [
                input,
                inst
            ]) : {};
            if (beforeShowSettings === false) return;
            datepicker_extendRemove(inst.settings, beforeShowSettings);
            inst.lastVal = null;
            $.datepicker._lastInput = input;
            $.datepicker._setDateFromField(inst);
            if ($.datepicker._inDialog) input.value = "";
            if (!$.datepicker._pos) {
                $.datepicker._pos = $.datepicker._findPos(input);
                $.datepicker._pos[1] += input.offsetHeight; // add the height
            }
            isFixed = false;
            $(input).parents().each(function() {
                isFixed |= $(this).css("position") === "fixed";
                return !isFixed;
            });
            offset = {
                left: $.datepicker._pos[0],
                top: $.datepicker._pos[1]
            };
            $.datepicker._pos = null;
            //to avoid flashes on Firefox
            inst.dpDiv.empty();
            // determine sizing offscreen
            inst.dpDiv.css({
                position: "absolute",
                display: "block",
                top: "-1000px"
            });
            $.datepicker._updateDatepicker(inst);
            // fix width for dynamic number of date pickers
            // and adjust position before showing
            offset = $.datepicker._checkOffset(inst, offset, isFixed);
            inst.dpDiv.css({
                position: $.datepicker._inDialog && $.blockUI ? "static" : isFixed ? "fixed" : "absolute",
                display: "none",
                left: offset.left + "px",
                top: offset.top + "px"
            });
            if (!inst.inline) {
                showAnim = $.datepicker._get(inst, "showAnim");
                duration = $.datepicker._get(inst, "duration");
                inst.dpDiv.css("z-index", datepicker_getZindex($(input)) + 1);
                $.datepicker._datepickerShowing = true;
                if ($.effects && $.effects.effect[showAnim]) inst.dpDiv.show(showAnim, $.datepicker._get(inst, "showOptions"), duration);
                else inst.dpDiv[showAnim || "show"](showAnim ? duration : null);
                if ($.datepicker._shouldFocusInput(inst)) inst.input.focus();
                $.datepicker._curInst = inst;
            }
        },
        /* Generate the date picker content. */ _updateDatepicker: function(inst) {
            this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
            datepicker_instActive = inst; // for delegate hover events
            inst.dpDiv.empty().append(this._generateHTML(inst));
            this._attachHandlers(inst);
            var origyearshtml, numMonths = this._getNumberOfMonths(inst), cols = numMonths[1], width = 17, activeCell = inst.dpDiv.find("." + this._dayOverClass + " a");
            if (activeCell.length > 0) datepicker_handleMouseover.apply(activeCell.get(0));
            inst.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width("");
            if (cols > 1) inst.dpDiv.addClass("ui-datepicker-multi-" + cols).css("width", width * cols + "em");
            inst.dpDiv[(numMonths[0] !== 1 || numMonths[1] !== 1 ? "add" : "remove") + "Class"]("ui-datepicker-multi");
            inst.dpDiv[(this._get(inst, "isRTL") ? "add" : "remove") + "Class"]("ui-datepicker-rtl");
            if (inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput(inst)) inst.input.focus();
            // deffered render of the years select (to avoid flashes on Firefox)
            if (inst.yearshtml) {
                origyearshtml = inst.yearshtml;
                setTimeout(function() {
                    //assure that inst.yearshtml didn't change.
                    if (origyearshtml === inst.yearshtml && inst.yearshtml) inst.dpDiv.find("select.ui-datepicker-year:first").replaceWith(inst.yearshtml);
                    origyearshtml = inst.yearshtml = null;
                }, 0);
            }
        },
        // #6694 - don't focus the input if it's already focused
        // this breaks the change event in IE
        // Support: IE and jQuery <1.9
        _shouldFocusInput: function(inst) {
            return inst.input && inst.input.is(":visible") && !inst.input.is(":disabled") && !inst.input.is(":focus");
        },
        /* Check positioning to remain on screen. */ _checkOffset: function(inst, offset, isFixed) {
            var dpWidth = inst.dpDiv.outerWidth(), dpHeight = inst.dpDiv.outerHeight(), inputWidth = inst.input ? inst.input.outerWidth() : 0, inputHeight = inst.input ? inst.input.outerHeight() : 0, viewWidth = document.documentElement.clientWidth + (isFixed ? 0 : $(document).scrollLeft()), viewHeight = document.documentElement.clientHeight + (isFixed ? 0 : $(document).scrollTop());
            offset.left -= this._get(inst, "isRTL") ? dpWidth - inputWidth : 0;
            offset.left -= isFixed && offset.left === inst.input.offset().left ? $(document).scrollLeft() : 0;
            offset.top -= isFixed && offset.top === inst.input.offset().top + inputHeight ? $(document).scrollTop() : 0;
            // now check if datepicker is showing outside window viewport - move to a better place if so.
            offset.left -= Math.min(offset.left, offset.left + dpWidth > viewWidth && viewWidth > dpWidth ? Math.abs(offset.left + dpWidth - viewWidth) : 0);
            offset.top -= Math.min(offset.top, offset.top + dpHeight > viewHeight && viewHeight > dpHeight ? Math.abs(dpHeight + inputHeight) : 0);
            return offset;
        },
        /* Find an object's position on the screen. */ _findPos: function(obj) {
            var position, inst = this._getInst(obj), isRTL = this._get(inst, "isRTL");
            while(obj && (obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden(obj)))obj = obj[isRTL ? "previousSibling" : "nextSibling"];
            position = $(obj).offset();
            return [
                position.left,
                position.top
            ];
        },
        /* Hide the date picker from view.
	 * @param  input  element - the input field attached to the date picker
	 */ _hideDatepicker: function(input) {
            var showAnim, duration, postProcess, onClose, inst = this._curInst;
            if (!inst || input && inst !== $.data(input, "datepicker")) return;
            if (this._datepickerShowing) {
                showAnim = this._get(inst, "showAnim");
                duration = this._get(inst, "duration");
                postProcess = function() {
                    $.datepicker._tidyDialog(inst);
                };
                // DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
                if ($.effects && ($.effects.effect[showAnim] || $.effects[showAnim])) inst.dpDiv.hide(showAnim, $.datepicker._get(inst, "showOptions"), duration, postProcess);
                else inst.dpDiv[showAnim === "slideDown" ? "slideUp" : showAnim === "fadeIn" ? "fadeOut" : "hide"](showAnim ? duration : null, postProcess);
                if (!showAnim) postProcess();
                this._datepickerShowing = false;
                onClose = this._get(inst, "onClose");
                if (onClose) onClose.apply(inst.input ? inst.input[0] : null, [
                    inst.input ? inst.input.val() : "",
                    inst
                ]);
                this._lastInput = null;
                if (this._inDialog) {
                    this._dialogInput.css({
                        position: "absolute",
                        left: "0",
                        top: "-100px"
                    });
                    if ($.blockUI) {
                        $.unblockUI();
                        $("body").append(this.dpDiv);
                    }
                }
                this._inDialog = false;
            }
        },
        /* Tidy up after a dialog display. */ _tidyDialog: function(inst) {
            inst.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar");
        },
        /* Close date picker if clicked elsewhere. */ _checkExternalClick: function(event) {
            if (!$.datepicker._curInst) return;
            var $target = $(event.target), inst = $.datepicker._getInst($target[0]);
            if ($target[0].id !== $.datepicker._mainDivId && $target.parents("#" + $.datepicker._mainDivId).length === 0 && !$target.hasClass($.datepicker.markerClassName) && !$target.closest("." + $.datepicker._triggerClass).length && $.datepicker._datepickerShowing && !($.datepicker._inDialog && $.blockUI) || $target.hasClass($.datepicker.markerClassName) && $.datepicker._curInst !== inst) $.datepicker._hideDatepicker();
        },
        /* Adjust one of the date sub-fields. */ _adjustDate: function(id, offset, period) {
            var target = $(id), inst = this._getInst(target[0]);
            if (this._isDisabledDatepicker(target[0])) return;
            this._adjustInstDate(inst, offset + (period === "M" ? this._get(inst, "showCurrentAtPos") : 0), period);
            this._updateDatepicker(inst);
        },
        /* Action for current link. */ _gotoToday: function(id) {
            var date, target = $(id), inst = this._getInst(target[0]);
            if (this._get(inst, "gotoCurrent") && inst.currentDay) {
                inst.selectedDay = inst.currentDay;
                inst.drawMonth = inst.selectedMonth = inst.currentMonth;
                inst.drawYear = inst.selectedYear = inst.currentYear;
            } else {
                date = new Date();
                inst.selectedDay = date.getDate();
                inst.drawMonth = inst.selectedMonth = date.getMonth();
                inst.drawYear = inst.selectedYear = date.getFullYear();
            }
            this._notifyChange(inst);
            this._adjustDate(target);
        },
        /* Action for selecting a new month/year. */ _selectMonthYear: function(id, select, period) {
            var target = $(id), inst = this._getInst(target[0]);
            inst["selected" + (period === "M" ? "Month" : "Year")] = inst["draw" + (period === "M" ? "Month" : "Year")] = parseInt(select.options[select.selectedIndex].value, 10);
            this._notifyChange(inst);
            this._adjustDate(target);
        },
        /* Action for selecting a day. */ _selectDay: function(id, month, year, td) {
            var inst, target = $(id);
            if ($(td).hasClass(this._unselectableClass) || this._isDisabledDatepicker(target[0])) return;
            inst = this._getInst(target[0]);
            inst.selectedDay = inst.currentDay = $("a", td).html();
            inst.selectedMonth = inst.currentMonth = month;
            inst.selectedYear = inst.currentYear = year;
            this._selectDate(id, this._formatDate(inst, inst.currentDay, inst.currentMonth, inst.currentYear));
        },
        /* Erase the input field and hide the date picker. */ _clearDate: function(id) {
            var target = $(id);
            this._selectDate(target, "");
        },
        /* Update the input field with the selected date. */ _selectDate: function(id, dateStr) {
            var onSelect, target = $(id), inst = this._getInst(target[0]);
            dateStr = dateStr != null ? dateStr : this._formatDate(inst);
            if (inst.input) inst.input.val(dateStr);
            this._updateAlternate(inst);
            onSelect = this._get(inst, "onSelect");
            if (onSelect) onSelect.apply(inst.input ? inst.input[0] : null, [
                dateStr,
                inst
            ]); // trigger custom callback
            else if (inst.input) inst.input.trigger("change"); // fire the change event
            if (inst.inline) this._updateDatepicker(inst);
            else {
                this._hideDatepicker();
                this._lastInput = inst.input[0];
                if (typeof inst.input[0] !== "object") inst.input.focus(); // restore focus
                this._lastInput = null;
            }
        },
        /* Update any alternate field to synchronise with the main field. */ _updateAlternate: function(inst) {
            var altFormat, date, dateStr, altField = this._get(inst, "altField");
            if (altField) {
                altFormat = this._get(inst, "altFormat") || this._get(inst, "dateFormat");
                date = this._getDate(inst);
                dateStr = this.formatDate(altFormat, date, this._getFormatConfig(inst));
                $(altField).each(function() {
                    $(this).val(dateStr);
                });
            }
        },
        /* Set as beforeShowDay function to prevent selection of weekends.
	 * @param  date  Date - the date to customise
	 * @return [boolean, string] - is this date selectable?, what is its CSS class?
	 */ noWeekends: function(date) {
            var day = date.getDay();
            return [
                day > 0 && day < 6,
                ""
            ];
        },
        /* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	 * @param  date  Date - the date to get the week for
	 * @return  number - the number of the week within the year that contains this date
	 */ iso8601Week: function(date) {
            var time, checkDate = new Date(date.getTime());
            // Find Thursday of this week starting on Monday
            checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
            time = checkDate.getTime();
            checkDate.setMonth(0); // Compare with Jan 1
            checkDate.setDate(1);
            return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
        },
        /* Parse a string value into a date object.
	 * See formatDate below for the possible formats.
	 *
	 * @param  format string - the expected format of the date
	 * @param  value string - the date in the above format
	 * @param  settings Object - attributes include:
	 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  Date - the extracted date value or null if value is blank
	 */ parseDate: function(format, value, settings) {
            if (format == null || value == null) throw "Invalid arguments";
            value = typeof value === "object" ? value.toString() : value + "";
            if (value === "") return null;
            var iFormat, dim, extra, iValue = 0, shortYearCutoffTemp = (settings ? settings.shortYearCutoff : null) || this._defaults.shortYearCutoff, shortYearCutoff = typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp : new Date().getFullYear() % 100 + parseInt(shortYearCutoffTemp, 10), dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort, dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames, monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort, monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames, year = -1, month = -1, day = -1, doy = -1, literal = false, date, // Check whether a format character is doubled
            lookAhead = function(match) {
                var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
                if (matches) iFormat++;
                return matches;
            }, // Extract a number from the string value
            getNumber = function(match) {
                var isDoubled = lookAhead(match), size = match === "@" ? 14 : match === "!" ? 20 : match === "y" && isDoubled ? 4 : match === "o" ? 3 : 2, minSize = match === "y" ? size : 1, digits = new RegExp("^\\d{" + minSize + "," + size + "}"), num = value.substring(iValue).match(digits);
                if (!num) throw "Missing number at position " + iValue;
                iValue += num[0].length;
                return parseInt(num[0], 10);
            }, // Extract a name from the string value and convert to an index
            getName = function(match, shortNames, longNames) {
                var index = -1, names = $.map(lookAhead(match) ? longNames : shortNames, function(v, k) {
                    return [
                        [
                            k,
                            v
                        ]
                    ];
                }).sort(function(a, b) {
                    return -(a[1].length - b[1].length);
                });
                $.each(names, function(i, pair) {
                    var name = pair[1];
                    if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
                        index = pair[0];
                        iValue += name.length;
                        return false;
                    }
                });
                if (index !== -1) return index + 1;
                else throw "Unknown name at position " + iValue;
            }, // Confirm that a literal character matches the string value
            checkLiteral = function() {
                if (value.charAt(iValue) !== format.charAt(iFormat)) throw "Unexpected literal at position " + iValue;
                iValue++;
            };
            for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
                if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
                else checkLiteral();
            } else switch(format.charAt(iFormat)){
                case "d":
                    day = getNumber("d");
                    break;
                case "D":
                    getName("D", dayNamesShort, dayNames);
                    break;
                case "o":
                    doy = getNumber("o");
                    break;
                case "m":
                    month = getNumber("m");
                    break;
                case "M":
                    month = getName("M", monthNamesShort, monthNames);
                    break;
                case "y":
                    year = getNumber("y");
                    break;
                case "@":
                    date = new Date(getNumber("@"));
                    year = date.getFullYear();
                    month = date.getMonth() + 1;
                    day = date.getDate();
                    break;
                case "!":
                    date = new Date((getNumber("!") - this._ticksTo1970) / 10000);
                    year = date.getFullYear();
                    month = date.getMonth() + 1;
                    day = date.getDate();
                    break;
                case "'":
                    if (lookAhead("'")) checkLiteral();
                    else literal = true;
                    break;
                default:
                    checkLiteral();
            }
            if (iValue < value.length) {
                extra = value.substr(iValue);
                if (!/^\s+/.test(extra)) throw "Extra/unparsed characters found in date: " + extra;
            }
            if (year === -1) year = new Date().getFullYear();
            else if (year < 100) year += new Date().getFullYear() - new Date().getFullYear() % 100 + (year <= shortYearCutoff ? 0 : -100);
            if (doy > -1) {
                month = 1;
                day = doy;
                do {
                    dim = this._getDaysInMonth(year, month - 1);
                    if (day <= dim) break;
                    month++;
                    day -= dim;
                }while (true);
            }
            date = this._daylightSavingAdjust(new Date(year, month - 1, day));
            if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) throw "Invalid date"; // E.g. 31/02/00
            return date;
        },
        /* Standard date formats. */ ATOM: "yy-mm-dd",
        COOKIE: "D, dd M yy",
        ISO_8601: "yy-mm-dd",
        RFC_822: "D, d M y",
        RFC_850: "DD, dd-M-y",
        RFC_1036: "D, d M y",
        RFC_1123: "D, d M yy",
        RFC_2822: "D, d M yy",
        RSS: "D, d M y",
        TICKS: "!",
        TIMESTAMP: "@",
        W3C: "yy-mm-dd",
        _ticksTo1970: (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)) * 864000000000,
        /* Format a date object into a string value.
	 * The format can be combinations of the following:
	 * d  - day of month (no leading zero)
	 * dd - day of month (two digit)
	 * o  - day of year (no leading zeros)
	 * oo - day of year (three digit)
	 * D  - day name short
	 * DD - day name long
	 * m  - month of year (no leading zero)
	 * mm - month of year (two digit)
	 * M  - month name short
	 * MM - month name long
	 * y  - year (two digit)
	 * yy - year (four digit)
	 * @ - Unix timestamp (ms since 01/01/1970)
	 * ! - Windows ticks (100ns since 01/01/0001)
	 * "..." - literal text
	 * '' - single quote
	 *
	 * @param  format string - the desired format of the date
	 * @param  date Date - the date value to format
	 * @param  settings Object - attributes include:
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  string - the date in the above format
	 */ formatDate: function(format, date, settings) {
            if (!date) return "";
            var iFormat, dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort, dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames, monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort, monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames, // Check whether a format character is doubled
            lookAhead = function(match) {
                var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
                if (matches) iFormat++;
                return matches;
            }, // Format a number, with leading zero if necessary
            formatNumber = function(match, value, len) {
                var num = "" + value;
                if (lookAhead(match)) while(num.length < len)num = "0" + num;
                return num;
            }, // Format a name, short or long as requested
            formatName = function(match, value, shortNames, longNames) {
                return lookAhead(match) ? longNames[value] : shortNames[value];
            }, output = "", literal = false;
            if (date) {
                for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
                    if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
                    else output += format.charAt(iFormat);
                } else switch(format.charAt(iFormat)){
                    case "d":
                        output += formatNumber("d", date.getDate(), 2);
                        break;
                    case "D":
                        output += formatName("D", date.getDay(), dayNamesShort, dayNames);
                        break;
                    case "o":
                        output += formatNumber("o", Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
                        break;
                    case "m":
                        output += formatNumber("m", date.getMonth() + 1, 2);
                        break;
                    case "M":
                        output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
                        break;
                    case "y":
                        output += lookAhead("y") ? date.getFullYear() : (date.getYear() % 100 < 10 ? "0" : "") + date.getYear() % 100;
                        break;
                    case "@":
                        output += date.getTime();
                        break;
                    case "!":
                        output += date.getTime() * 10000 + this._ticksTo1970;
                        break;
                    case "'":
                        if (lookAhead("'")) output += "'";
                        else literal = true;
                        break;
                    default:
                        output += format.charAt(iFormat);
                }
            }
            return output;
        },
        /* Extract all possible characters from the date format. */ _possibleChars: function(format) {
            var iFormat, chars = "", literal = false, // Check whether a format character is doubled
            lookAhead = function(match) {
                var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
                if (matches) iFormat++;
                return matches;
            };
            for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
                if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
                else chars += format.charAt(iFormat);
            } else switch(format.charAt(iFormat)){
                case "d":
                case "m":
                case "y":
                case "@":
                    chars += "0123456789";
                    break;
                case "D":
                case "M":
                    return null; // Accept anything
                case "'":
                    if (lookAhead("'")) chars += "'";
                    else literal = true;
                    break;
                default:
                    chars += format.charAt(iFormat);
            }
            return chars;
        },
        /* Get a setting value, defaulting if necessary. */ _get: function(inst, name) {
            return inst.settings[name] !== undefined ? inst.settings[name] : this._defaults[name];
        },
        /* Parse existing date and initialise date picker. */ _setDateFromField: function(inst, noDefault) {
            if (inst.input.val() === inst.lastVal) return;
            var dateFormat = this._get(inst, "dateFormat"), dates = inst.lastVal = inst.input ? inst.input.val() : null, defaultDate = this._getDefaultDate(inst), date = defaultDate, settings = this._getFormatConfig(inst);
            try {
                date = this.parseDate(dateFormat, dates, settings) || defaultDate;
            } catch (event) {
                dates = noDefault ? "" : dates;
            }
            inst.selectedDay = date.getDate();
            inst.drawMonth = inst.selectedMonth = date.getMonth();
            inst.drawYear = inst.selectedYear = date.getFullYear();
            inst.currentDay = dates ? date.getDate() : 0;
            inst.currentMonth = dates ? date.getMonth() : 0;
            inst.currentYear = dates ? date.getFullYear() : 0;
            this._adjustInstDate(inst);
        },
        /* Retrieve the default date shown on opening. */ _getDefaultDate: function(inst) {
            return this._restrictMinMax(inst, this._determineDate(inst, this._get(inst, "defaultDate"), new Date()));
        },
        /* A date may be specified as an exact value or a relative one. */ _determineDate: function(inst, date, defaultDate) {
            var offsetNumeric = function(offset) {
                var date = new Date();
                date.setDate(date.getDate() + offset);
                return date;
            }, offsetString = function(offset) {
                try {
                    return $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"), offset, $.datepicker._getFormatConfig(inst));
                } catch (e) {
                // Ignore
                }
                var date = (offset.toLowerCase().match(/^c/) ? $.datepicker._getDate(inst) : null) || new Date(), year = date.getFullYear(), month = date.getMonth(), day = date.getDate(), pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g, matches = pattern.exec(offset);
                while(matches){
                    switch(matches[2] || "d"){
                        case "d":
                        case "D":
                            day += parseInt(matches[1], 10);
                            break;
                        case "w":
                        case "W":
                            day += parseInt(matches[1], 10) * 7;
                            break;
                        case "m":
                        case "M":
                            month += parseInt(matches[1], 10);
                            day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
                            break;
                        case "y":
                        case "Y":
                            year += parseInt(matches[1], 10);
                            day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
                            break;
                    }
                    matches = pattern.exec(offset);
                }
                return new Date(year, month, day);
            }, newDate = date == null || date === "" ? defaultDate : typeof date === "string" ? offsetString(date) : typeof date === "number" ? isNaN(date) ? defaultDate : offsetNumeric(date) : new Date(date.getTime());
            newDate = newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate;
            if (newDate) {
                newDate.setHours(0);
                newDate.setMinutes(0);
                newDate.setSeconds(0);
                newDate.setMilliseconds(0);
            }
            return this._daylightSavingAdjust(newDate);
        },
        /* Handle switch to/from daylight saving.
	 * Hours may be non-zero on daylight saving cut-over:
	 * > 12 when midnight changeover, but then cannot generate
	 * midnight datetime, so jump to 1AM, otherwise reset.
	 * @param  date  (Date) the date to check
	 * @return  (Date) the corrected date
	 */ _daylightSavingAdjust: function(date) {
            if (!date) return null;
            date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
            return date;
        },
        /* Set the date(s) directly. */ _setDate: function(inst, date, noChange) {
            var clear = !date, origMonth = inst.selectedMonth, origYear = inst.selectedYear, newDate = this._restrictMinMax(inst, this._determineDate(inst, date, new Date()));
            inst.selectedDay = inst.currentDay = newDate.getDate();
            inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
            inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
            if ((origMonth !== inst.selectedMonth || origYear !== inst.selectedYear) && !noChange) this._notifyChange(inst);
            this._adjustInstDate(inst);
            if (inst.input) inst.input.val(clear ? "" : this._formatDate(inst));
        },
        /* Retrieve the date(s) directly. */ _getDate: function(inst) {
            var startDate = !inst.currentYear || inst.input && inst.input.val() === "" ? null : this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay));
            return startDate;
        },
        /* Attach the onxxx handlers.  These are declared statically so
	 * they work with static code transformers like Caja.
	 */ _attachHandlers: function(inst) {
            var stepMonths = this._get(inst, "stepMonths"), id = "#" + inst.id.replace(/\\\\/g, "\\");
            inst.dpDiv.find("[data-handler]").map(function() {
                var handler = {
                    prev: function() {
                        $.datepicker._adjustDate(id, -stepMonths, "M");
                    },
                    next: function() {
                        $.datepicker._adjustDate(id, +stepMonths, "M");
                    },
                    hide: function() {
                        $.datepicker._hideDatepicker();
                    },
                    today: function() {
                        $.datepicker._gotoToday(id);
                    },
                    selectDay: function() {
                        $.datepicker._selectDay(id, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this);
                        return false;
                    },
                    selectMonth: function() {
                        $.datepicker._selectMonthYear(id, this, "M");
                        return false;
                    },
                    selectYear: function() {
                        $.datepicker._selectMonthYear(id, this, "Y");
                        return false;
                    }
                };
                $(this).bind(this.getAttribute("data-event"), handler[this.getAttribute("data-handler")]);
            });
        },
        /* Generate the HTML for the current state of the date picker. */ _generateHTML: function(inst) {
            var maxDraw, prevText, prev, nextText, next, currentText, gotoDate, controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin, monthNames, monthNamesShort, beforeShowDay, showOtherMonths, selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate, cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows, printDate, dRow, tbody, daySettings, otherMonth, unselectable, tempDate = new Date(), today = this._daylightSavingAdjust(new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate())), isRTL = this._get(inst, "isRTL"), showButtonPanel = this._get(inst, "showButtonPanel"), hideIfNoPrevNext = this._get(inst, "hideIfNoPrevNext"), navigationAsDateFormat = this._get(inst, "navigationAsDateFormat"), numMonths = this._getNumberOfMonths(inst), showCurrentAtPos = this._get(inst, "showCurrentAtPos"), stepMonths = this._get(inst, "stepMonths"), isMultiMonth = numMonths[0] !== 1 || numMonths[1] !== 1, currentDate = this._daylightSavingAdjust(!inst.currentDay ? new Date(9999, 9, 9) : new Date(inst.currentYear, inst.currentMonth, inst.currentDay)), minDate = this._getMinMaxDate(inst, "min"), maxDate = this._getMinMaxDate(inst, "max"), drawMonth = inst.drawMonth - showCurrentAtPos, drawYear = inst.drawYear;
            if (drawMonth < 0) {
                drawMonth += 12;
                drawYear--;
            }
            if (maxDate) {
                maxDraw = this._daylightSavingAdjust(new Date(maxDate.getFullYear(), maxDate.getMonth() - numMonths[0] * numMonths[1] + 1, maxDate.getDate()));
                maxDraw = minDate && maxDraw < minDate ? minDate : maxDraw;
                while(this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1)) > maxDraw){
                    drawMonth--;
                    if (drawMonth < 0) {
                        drawMonth = 11;
                        drawYear--;
                    }
                }
            }
            inst.drawMonth = drawMonth;
            inst.drawYear = drawYear;
            prevText = this._get(inst, "prevText");
            prevText = !navigationAsDateFormat ? prevText : this.formatDate(prevText, this._daylightSavingAdjust(new Date(drawYear, drawMonth - stepMonths, 1)), this._getFormatConfig(inst));
            prev = this._canAdjustMonth(inst, -1, drawYear, drawMonth) ? "<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + (isRTL ? "e" : "w") + "'>" + prevText + "</span></a>" : hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + (isRTL ? "e" : "w") + "'>" + prevText + "</span></a>";
            nextText = this._get(inst, "nextText");
            nextText = !navigationAsDateFormat ? nextText : this.formatDate(nextText, this._daylightSavingAdjust(new Date(drawYear, drawMonth + stepMonths, 1)), this._getFormatConfig(inst));
            next = this._canAdjustMonth(inst, 1, drawYear, drawMonth) ? "<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + (isRTL ? "w" : "e") + "'>" + nextText + "</span></a>" : hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + (isRTL ? "w" : "e") + "'>" + nextText + "</span></a>";
            currentText = this._get(inst, "currentText");
            gotoDate = this._get(inst, "gotoCurrent") && inst.currentDay ? currentDate : today;
            currentText = !navigationAsDateFormat ? currentText : this.formatDate(currentText, gotoDate, this._getFormatConfig(inst));
            controls = !inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" + this._get(inst, "closeText") + "</button>" : "";
            buttonPanel = showButtonPanel ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (isRTL ? controls : "") + (this._isInRange(inst, gotoDate) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>" + currentText + "</button>" : "") + (isRTL ? "" : controls) + "</div>" : "";
            firstDay = parseInt(this._get(inst, "firstDay"), 10);
            firstDay = isNaN(firstDay) ? 0 : firstDay;
            showWeek = this._get(inst, "showWeek");
            dayNames = this._get(inst, "dayNames");
            dayNamesMin = this._get(inst, "dayNamesMin");
            monthNames = this._get(inst, "monthNames");
            monthNamesShort = this._get(inst, "monthNamesShort");
            beforeShowDay = this._get(inst, "beforeShowDay");
            showOtherMonths = this._get(inst, "showOtherMonths");
            selectOtherMonths = this._get(inst, "selectOtherMonths");
            defaultDate = this._getDefaultDate(inst);
            html = "";
            dow;
            for(row = 0; row < numMonths[0]; row++){
                group = "";
                this.maxRows = 4;
                for(col = 0; col < numMonths[1]; col++){
                    selectedDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, inst.selectedDay));
                    cornerClass = " ui-corner-all";
                    calender = "";
                    if (isMultiMonth) {
                        calender += "<div class='ui-datepicker-group";
                        if (numMonths[1] > 1) switch(col){
                            case 0:
                                calender += " ui-datepicker-group-first";
                                cornerClass = " ui-corner-" + (isRTL ? "right" : "left");
                                break;
                            case numMonths[1] - 1:
                                calender += " ui-datepicker-group-last";
                                cornerClass = " ui-corner-" + (isRTL ? "left" : "right");
                                break;
                            default:
                                calender += " ui-datepicker-group-middle";
                                cornerClass = "";
                                break;
                        }
                        calender += "'>";
                    }
                    calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" + (/all|left/.test(cornerClass) && row === 0 ? isRTL ? next : prev : "") + (/all|right/.test(cornerClass) && row === 0 ? isRTL ? prev : next : "") + this._generateMonthYearHeader(inst, drawMonth, drawYear, minDate, maxDate, row > 0 || col > 0, monthNames, monthNamesShort) + // draw month headers
                    "</div><table class='ui-datepicker-calendar'><thead>" + "<tr>";
                    thead = showWeek ? "<th class='ui-datepicker-week-col'>" + this._get(inst, "weekHeader") + "</th>" : "";
                    for(dow = 0; dow < 7; dow++){
                        day = (dow + firstDay) % 7;
                        thead += "<th scope='col'" + ((dow + firstDay + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" + "<span title='" + dayNames[day] + "'>" + dayNamesMin[day] + "</span></th>";
                    }
                    calender += thead + "</tr></thead><tbody>";
                    daysInMonth = this._getDaysInMonth(drawYear, drawMonth);
                    if (drawYear === inst.selectedYear && drawMonth === inst.selectedMonth) inst.selectedDay = Math.min(inst.selectedDay, daysInMonth);
                    leadDays = (this._getFirstDayOfMonth(drawYear, drawMonth) - firstDay + 7) % 7;
                    curRows = Math.ceil((leadDays + daysInMonth) / 7); // calculate the number of rows to generate
                    numRows = isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows; //If multiple months, use the higher number of rows (see #7043)
                    this.maxRows = numRows;
                    printDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1 - leadDays));
                    for(dRow = 0; dRow < numRows; dRow++){
                        calender += "<tr>";
                        tbody = !showWeek ? "" : "<td class='ui-datepicker-week-col'>" + this._get(inst, "calculateWeek")(printDate) + "</td>";
                        for(dow = 0; dow < 7; dow++){
                            daySettings = beforeShowDay ? beforeShowDay.apply(inst.input ? inst.input[0] : null, [
                                printDate
                            ]) : [
                                true,
                                ""
                            ];
                            otherMonth = printDate.getMonth() !== drawMonth;
                            unselectable = otherMonth && !selectOtherMonths || !daySettings[0] || minDate && printDate < minDate || maxDate && printDate > maxDate;
                            tbody += "<td class='" + ((dow + firstDay + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + // highlight weekends
                            (otherMonth ? " ui-datepicker-other-month" : "") + // highlight days from other months
                            (printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent || // user pressed key
                            defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime() ? // or defaultDate is current printedDate and defaultDate is selectedDate
                            " " + this._dayOverClass : "") + // highlight selected day
                            (unselectable ? " " + this._unselectableClass + " ui-state-disabled" : "") + // highlight unselectable days
                            (otherMonth && !showOtherMonths ? "" : " " + daySettings[1] + // highlight custom dates
                            (printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "") + // highlight selected day
                            (printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "")) + "'" + // highlight today (if different)
                            ((!otherMonth || showOtherMonths) && daySettings[2] ? " title='" + daySettings[2].replace(/'/g, "&#39;") + "'" : "") + // cell title
                            (unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'") + ">" + // actions
                            (otherMonth && !showOtherMonths ? "&#xa0;" : unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" + (printDate.getTime() === today.getTime() ? " ui-state-highlight" : "") + (printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "") + // highlight selected day
                            (otherMonth ? " ui-priority-secondary" : "") + // distinguish dates from other months
                            "' href='#'>" + printDate.getDate() + "</a>") + "</td>"; // display selectable date
                            printDate.setDate(printDate.getDate() + 1);
                            printDate = this._daylightSavingAdjust(printDate);
                        }
                        calender += tbody + "</tr>";
                    }
                    drawMonth++;
                    if (drawMonth > 11) {
                        drawMonth = 0;
                        drawYear++;
                    }
                    calender += "</tbody></table>" + (isMultiMonth ? "</div>" + (numMonths[0] > 0 && col === numMonths[1] - 1 ? "<div class='ui-datepicker-row-break'></div>" : "") : "");
                    group += calender;
                }
                html += group;
            }
            html += buttonPanel;
            inst._keyEvent = false;
            return html;
        },
        /* Generate the month and year header. */ _generateMonthYearHeader: function(inst, drawMonth, drawYear, minDate, maxDate, secondary, monthNames, monthNamesShort) {
            var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear, changeMonth = this._get(inst, "changeMonth"), changeYear = this._get(inst, "changeYear"), showMonthAfterYear = this._get(inst, "showMonthAfterYear"), html = "<div class='ui-datepicker-title'>", monthHtml = "";
            // month selection
            if (secondary || !changeMonth) monthHtml += "<span class='ui-datepicker-month'>" + monthNames[drawMonth] + "</span>";
            else {
                inMinYear = minDate && minDate.getFullYear() === drawYear;
                inMaxYear = maxDate && maxDate.getFullYear() === drawYear;
                monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
                for(month = 0; month < 12; month++)if ((!inMinYear || month >= minDate.getMonth()) && (!inMaxYear || month <= maxDate.getMonth())) monthHtml += "<option value='" + month + "'" + (month === drawMonth ? " selected='selected'" : "") + ">" + monthNamesShort[month] + "</option>";
                monthHtml += "</select>";
            }
            if (!showMonthAfterYear) html += monthHtml + (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "");
            // year selection
            if (!inst.yearshtml) {
                inst.yearshtml = "";
                if (secondary || !changeYear) html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
                else {
                    // determine range of years to display
                    years = this._get(inst, "yearRange").split(":");
                    thisYear = new Date().getFullYear();
                    determineYear = function(value) {
                        var year = value.match(/c[+\-].*/) ? drawYear + parseInt(value.substring(1), 10) : value.match(/[+\-].*/) ? thisYear + parseInt(value, 10) : parseInt(value, 10);
                        return isNaN(year) ? thisYear : year;
                    };
                    year = determineYear(years[0]);
                    endYear = Math.max(year, determineYear(years[1] || ""));
                    year = minDate ? Math.max(year, minDate.getFullYear()) : year;
                    endYear = maxDate ? Math.min(endYear, maxDate.getFullYear()) : endYear;
                    inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
                    for(; year <= endYear; year++)inst.yearshtml += "<option value='" + year + "'" + (year === drawYear ? " selected='selected'" : "") + ">" + year + "</option>";
                    inst.yearshtml += "</select>";
                    html += inst.yearshtml;
                    inst.yearshtml = null;
                }
            }
            html += this._get(inst, "yearSuffix");
            if (showMonthAfterYear) html += (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "") + monthHtml;
            html += "</div>"; // Close datepicker_header
            return html;
        },
        /* Adjust one of the date sub-fields. */ _adjustInstDate: function(inst, offset, period) {
            var year = inst.drawYear + (period === "Y" ? offset : 0), month = inst.drawMonth + (period === "M" ? offset : 0), day = Math.min(inst.selectedDay, this._getDaysInMonth(year, month)) + (period === "D" ? offset : 0), date = this._restrictMinMax(inst, this._daylightSavingAdjust(new Date(year, month, day)));
            inst.selectedDay = date.getDate();
            inst.drawMonth = inst.selectedMonth = date.getMonth();
            inst.drawYear = inst.selectedYear = date.getFullYear();
            if (period === "M" || period === "Y") this._notifyChange(inst);
        },
        /* Ensure a date is within any min/max bounds. */ _restrictMinMax: function(inst, date) {
            var minDate = this._getMinMaxDate(inst, "min"), maxDate = this._getMinMaxDate(inst, "max"), newDate = minDate && date < minDate ? minDate : date;
            return maxDate && newDate > maxDate ? maxDate : newDate;
        },
        /* Notify change of month/year. */ _notifyChange: function(inst) {
            var onChange = this._get(inst, "onChangeMonthYear");
            if (onChange) onChange.apply(inst.input ? inst.input[0] : null, [
                inst.selectedYear,
                inst.selectedMonth + 1,
                inst
            ]);
        },
        /* Determine the number of months to show. */ _getNumberOfMonths: function(inst) {
            var numMonths = this._get(inst, "numberOfMonths");
            return numMonths == null ? [
                1,
                1
            ] : typeof numMonths === "number" ? [
                1,
                numMonths
            ] : numMonths;
        },
        /* Determine the current maximum date - ensure no time components are set. */ _getMinMaxDate: function(inst, minMax) {
            return this._determineDate(inst, this._get(inst, minMax + "Date"), null);
        },
        /* Find the number of days in a given month. */ _getDaysInMonth: function(year, month) {
            return 32 - this._daylightSavingAdjust(new Date(year, month, 32)).getDate();
        },
        /* Find the day of the week of the first of a month. */ _getFirstDayOfMonth: function(year, month) {
            return new Date(year, month, 1).getDay();
        },
        /* Determines if we should allow a "next/prev" month display change. */ _canAdjustMonth: function(inst, offset, curYear, curMonth) {
            var numMonths = this._getNumberOfMonths(inst), date = this._daylightSavingAdjust(new Date(curYear, curMonth + (offset < 0 ? offset : numMonths[0] * numMonths[1]), 1));
            if (offset < 0) date.setDate(this._getDaysInMonth(date.getFullYear(), date.getMonth()));
            return this._isInRange(inst, date);
        },
        /* Is the given date in the accepted range? */ _isInRange: function(inst, date) {
            var yearSplit, currentYear, minDate = this._getMinMaxDate(inst, "min"), maxDate = this._getMinMaxDate(inst, "max"), minYear = null, maxYear = null, years = this._get(inst, "yearRange");
            if (years) {
                yearSplit = years.split(":");
                currentYear = new Date().getFullYear();
                minYear = parseInt(yearSplit[0], 10);
                maxYear = parseInt(yearSplit[1], 10);
                if (yearSplit[0].match(/[+\-].*/)) minYear += currentYear;
                if (yearSplit[1].match(/[+\-].*/)) maxYear += currentYear;
            }
            return (!minDate || date.getTime() >= minDate.getTime()) && (!maxDate || date.getTime() <= maxDate.getTime()) && (!minYear || date.getFullYear() >= minYear) && (!maxYear || date.getFullYear() <= maxYear);
        },
        /* Provide the configuration settings for formatting/parsing. */ _getFormatConfig: function(inst) {
            var shortYearCutoff = this._get(inst, "shortYearCutoff");
            shortYearCutoff = typeof shortYearCutoff !== "string" ? shortYearCutoff : new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10);
            return {
                shortYearCutoff: shortYearCutoff,
                dayNamesShort: this._get(inst, "dayNamesShort"),
                dayNames: this._get(inst, "dayNames"),
                monthNamesShort: this._get(inst, "monthNamesShort"),
                monthNames: this._get(inst, "monthNames")
            };
        },
        /* Format the given date for display. */ _formatDate: function(inst, day, month, year) {
            if (!day) {
                inst.currentDay = inst.selectedDay;
                inst.currentMonth = inst.selectedMonth;
                inst.currentYear = inst.selectedYear;
            }
            var date = day ? typeof day === "object" ? day : this._daylightSavingAdjust(new Date(year, month, day)) : this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay));
            return this.formatDate(this._get(inst, "dateFormat"), date, this._getFormatConfig(inst));
        }
    });
    /*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */ function datepicker_bindHover(dpDiv) {
        var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
        return dpDiv.delegate(selector, "mouseout", function() {
            $(this).removeClass("ui-state-hover");
            if (this.className.indexOf("ui-datepicker-prev") !== -1) $(this).removeClass("ui-datepicker-prev-hover");
            if (this.className.indexOf("ui-datepicker-next") !== -1) $(this).removeClass("ui-datepicker-next-hover");
        }).delegate(selector, "mouseover", datepicker_handleMouseover);
    }
    function datepicker_handleMouseover() {
        if (!$.datepicker._isDisabledDatepicker(datepicker_instActive.inline ? datepicker_instActive.dpDiv.parent()[0] : datepicker_instActive.input[0])) {
            $(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover");
            $(this).addClass("ui-state-hover");
            if (this.className.indexOf("ui-datepicker-prev") !== -1) $(this).addClass("ui-datepicker-prev-hover");
            if (this.className.indexOf("ui-datepicker-next") !== -1) $(this).addClass("ui-datepicker-next-hover");
        }
    }
    /* jQuery extend now ignores nulls! */ function datepicker_extendRemove(target, props) {
        $.extend(target, props);
        for(var name in props)if (props[name] == null) target[name] = props[name];
        return target;
    }
    /* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
					Object - settings for attaching new datepicker functionality
   @return  jQuery object */ $.fn.datepicker = function(options) {
        /* Verify an empty collection wasn't passed - Fixes #6976 */ if (!this.length) return this;
        /* Initialise the date picker. */ if (!$.datepicker.initialized) {
            $(document).mousedown($.datepicker._checkExternalClick);
            $.datepicker.initialized = true;
        }
        /* Append datepicker main container to body if not exist. */ if ($("#" + $.datepicker._mainDivId).length === 0) $("body").append($.datepicker.dpDiv);
        var otherArgs = Array.prototype.slice.call(arguments, 1);
        if (typeof options === "string" && (options === "isDisabled" || options === "getDate" || options === "widget")) return $.datepicker["_" + options + "Datepicker"].apply($.datepicker, [
            this[0]
        ].concat(otherArgs));
        if (options === "option" && arguments.length === 2 && typeof arguments[1] === "string") return $.datepicker["_" + options + "Datepicker"].apply($.datepicker, [
            this[0]
        ].concat(otherArgs));
        return this.each(function() {
            typeof options === "string" ? $.datepicker["_" + options + "Datepicker"].apply($.datepicker, [
                this
            ].concat(otherArgs)) : $.datepicker._attachDatepicker(this, options);
        });
    };
    $.datepicker = new Datepicker(); // singleton instance
    $.datepicker.initialized = false;
    $.datepicker.uuid = new Date().getTime();
    $.datepicker.version = "1.11.1";
    var datepicker = $.datepicker;
    /*!
 * jQuery UI Draggable 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/draggable/
 */ $.widget("ui.draggable", $.ui.mouse, {
        version: "1.11.1",
        widgetEventPrefix: "drag",
        options: {
            addClasses: true,
            appendTo: "parent",
            axis: false,
            connectToSortable: false,
            containment: false,
            cursor: "auto",
            cursorAt: false,
            grid: false,
            handle: false,
            helper: "original",
            iframeFix: false,
            opacity: false,
            refreshPositions: false,
            revert: false,
            revertDuration: 500,
            scope: "default",
            scroll: true,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            snap: false,
            snapMode: "both",
            snapTolerance: 20,
            stack: false,
            zIndex: false,
            // callbacks
            drag: null,
            start: null,
            stop: null
        },
        _create: function() {
            if (this.options.helper === "original" && !/^(?:r|a|f)/.test(this.element.css("position"))) this.element[0].style.position = "relative";
            if (this.options.addClasses) this.element.addClass("ui-draggable");
            if (this.options.disabled) this.element.addClass("ui-draggable-disabled");
            this._setHandleClassName();
            this._mouseInit();
        },
        _setOption: function(key, value) {
            this._super(key, value);
            if (key === "handle") {
                this._removeHandleClassName();
                this._setHandleClassName();
            }
        },
        _destroy: function() {
            if ((this.helper || this.element).is(".ui-draggable-dragging")) {
                this.destroyOnClear = true;
                return;
            }
            this.element.removeClass("ui-draggable ui-draggable-dragging ui-draggable-disabled");
            this._removeHandleClassName();
            this._mouseDestroy();
        },
        _mouseCapture: function(event) {
            var document1 = this.document[0], o = this.options;
            // support: IE9
            // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
            try {
                // Support: IE9+
                // If the <body> is blurred, IE will switch windows, see #9520
                if (document1.activeElement && document1.activeElement.nodeName.toLowerCase() !== "body") // Blur any element that currently has focus, see #4261
                $(document1.activeElement).blur();
            } catch (error) {}
            // among others, prevent a drag on a resizable-handle
            if (this.helper || o.disabled || $(event.target).closest(".ui-resizable-handle").length > 0) return false;
            //Quit if we're not on a valid handle
            this.handle = this._getHandle(event);
            if (!this.handle) return false;
            $(o.iframeFix === true ? "iframe" : o.iframeFix).each(function() {
                $("<div class='ui-draggable-iframeFix' style='background: #fff;'></div>").css({
                    width: this.offsetWidth + "px",
                    height: this.offsetHeight + "px",
                    position: "absolute",
                    opacity: "0.001",
                    zIndex: 1000
                }).css($(this).offset()).appendTo("body");
            });
            return true;
        },
        _mouseStart: function(event) {
            var o = this.options;
            //Create and append the visible helper
            this.helper = this._createHelper(event);
            this.helper.addClass("ui-draggable-dragging");
            //Cache the helper size
            this._cacheHelperProportions();
            //If ddmanager is used for droppables, set the global draggable
            if ($.ui.ddmanager) $.ui.ddmanager.current = this;
            /*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */ //Cache the margins of the original element
            this._cacheMargins();
            //Store the helper's css position
            this.cssPosition = this.helper.css("position");
            this.scrollParent = this.helper.scrollParent(true);
            this.offsetParent = this.helper.offsetParent();
            this.offsetParentCssPosition = this.offsetParent.css("position");
            //The element's absolute position on the page minus margins
            this.offset = this.positionAbs = this.element.offset();
            this.offset = {
                top: this.offset.top - this.margins.top,
                left: this.offset.left - this.margins.left
            };
            //Reset scroll cache
            this.offset.scroll = false;
            $.extend(this.offset, {
                click: {
                    left: event.pageX - this.offset.left,
                    top: event.pageY - this.offset.top
                },
                parent: this._getParentOffset(),
                relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
            });
            //Generate the original position
            this.originalPosition = this.position = this._generatePosition(event, false);
            this.originalPageX = event.pageX;
            this.originalPageY = event.pageY;
            //Adjust the mouse offset relative to the helper if "cursorAt" is supplied
            o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt);
            //Set a containment if given in the options
            this._setContainment();
            //Trigger event + callbacks
            if (this._trigger("start", event) === false) {
                this._clear();
                return false;
            }
            //Recache the helper size
            this._cacheHelperProportions();
            //Prepare the droppable offsets
            if ($.ui.ddmanager && !o.dropBehaviour) $.ui.ddmanager.prepareOffsets(this, event);
            this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position
            //If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
            if ($.ui.ddmanager) $.ui.ddmanager.dragStart(this, event);
            return true;
        },
        _mouseDrag: function(event, noPropagation) {
            // reset any necessary cached properties (see #5009)
            if (this.offsetParentCssPosition === "fixed") this.offset.parent = this._getParentOffset();
            //Compute the helpers position
            this.position = this._generatePosition(event, true);
            this.positionAbs = this._convertPositionTo("absolute");
            //Call plugins and callbacks and use the resulting position if something is returned
            if (!noPropagation) {
                var ui = this._uiHash();
                if (this._trigger("drag", event, ui) === false) {
                    this._mouseUp({});
                    return false;
                }
                this.position = ui.position;
            }
            this.helper[0].style.left = this.position.left + "px";
            this.helper[0].style.top = this.position.top + "px";
            if ($.ui.ddmanager) $.ui.ddmanager.drag(this, event);
            return false;
        },
        _mouseStop: function(event) {
            //If we are using droppables, inform the manager about the drop
            var that = this, dropped = false;
            if ($.ui.ddmanager && !this.options.dropBehaviour) dropped = $.ui.ddmanager.drop(this, event);
            //if a drop comes from outside (a sortable)
            if (this.dropped) {
                dropped = this.dropped;
                this.dropped = false;
            }
            if (this.options.revert === "invalid" && !dropped || this.options.revert === "valid" && dropped || this.options.revert === true || $.isFunction(this.options.revert) && this.options.revert.call(this.element, dropped)) $(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function() {
                if (that._trigger("stop", event) !== false) that._clear();
            });
            else if (this._trigger("stop", event) !== false) this._clear();
            return false;
        },
        _mouseUp: function(event) {
            //Remove frame helpers
            $("div.ui-draggable-iframeFix").each(function() {
                this.parentNode.removeChild(this);
            });
            //If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
            if ($.ui.ddmanager) $.ui.ddmanager.dragStop(this, event);
            // The interaction is over; whether or not the click resulted in a drag, focus the element
            this.element.focus();
            return $.ui.mouse.prototype._mouseUp.call(this, event);
        },
        cancel: function() {
            if (this.helper.is(".ui-draggable-dragging")) this._mouseUp({});
            else this._clear();
            return this;
        },
        _getHandle: function(event) {
            return this.options.handle ? !!$(event.target).closest(this.element.find(this.options.handle)).length : true;
        },
        _setHandleClassName: function() {
            this.handleElement = this.options.handle ? this.element.find(this.options.handle) : this.element;
            this.handleElement.addClass("ui-draggable-handle");
        },
        _removeHandleClassName: function() {
            this.handleElement.removeClass("ui-draggable-handle");
        },
        _createHelper: function(event) {
            var o = this.options, helper = $.isFunction(o.helper) ? $(o.helper.apply(this.element[0], [
                event
            ])) : o.helper === "clone" ? this.element.clone().removeAttr("id") : this.element;
            if (!helper.parents("body").length) helper.appendTo(o.appendTo === "parent" ? this.element[0].parentNode : o.appendTo);
            if (helper[0] !== this.element[0] && !/(fixed|absolute)/.test(helper.css("position"))) helper.css("position", "absolute");
            return helper;
        },
        _adjustOffsetFromHelper: function(obj) {
            if (typeof obj === "string") obj = obj.split(" ");
            if ($.isArray(obj)) obj = {
                left: +obj[0],
                top: +obj[1] || 0
            };
            if ("left" in obj) this.offset.click.left = obj.left + this.margins.left;
            if ("right" in obj) this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
            if ("top" in obj) this.offset.click.top = obj.top + this.margins.top;
            if ("bottom" in obj) this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
        },
        _isRootNode: function(element) {
            return /(html|body)/i.test(element.tagName) || element === this.document[0];
        },
        _getParentOffset: function() {
            //Get the offsetParent and cache its position
            var po = this.offsetParent.offset(), document1 = this.document[0];
            // This is a special case where we need to modify a offset calculated on start, since the following happened:
            // 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
            // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
            //    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
            if (this.cssPosition === "absolute" && this.scrollParent[0] !== document1 && $.contains(this.scrollParent[0], this.offsetParent[0])) {
                po.left += this.scrollParent.scrollLeft();
                po.top += this.scrollParent.scrollTop();
            }
            if (this._isRootNode(this.offsetParent[0])) po = {
                top: 0,
                left: 0
            };
            return {
                top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
                left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
            };
        },
        _getRelativeOffset: function() {
            if (this.cssPosition !== "relative") return {
                top: 0,
                left: 0
            };
            var p = this.element.position(), scrollIsRootNode = this._isRootNode(this.scrollParent[0]);
            return {
                top: p.top - (parseInt(this.helper.css("top"), 10) || 0) + (!scrollIsRootNode ? this.scrollParent.scrollTop() : 0),
                left: p.left - (parseInt(this.helper.css("left"), 10) || 0) + (!scrollIsRootNode ? this.scrollParent.scrollLeft() : 0)
            };
        },
        _cacheMargins: function() {
            this.margins = {
                left: parseInt(this.element.css("marginLeft"), 10) || 0,
                top: parseInt(this.element.css("marginTop"), 10) || 0,
                right: parseInt(this.element.css("marginRight"), 10) || 0,
                bottom: parseInt(this.element.css("marginBottom"), 10) || 0
            };
        },
        _cacheHelperProportions: function() {
            this.helperProportions = {
                width: this.helper.outerWidth(),
                height: this.helper.outerHeight()
            };
        },
        _setContainment: function() {
            var over, c, ce, o = this.options, document1 = this.document[0];
            this.relativeContainer = null;
            if (!o.containment) {
                this.containment = null;
                return;
            }
            if (o.containment === "window") {
                this.containment = [
                    $(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
                    $(window).scrollTop() - this.offset.relative.top - this.offset.parent.top,
                    $(window).scrollLeft() + $(window).width() - this.helperProportions.width - this.margins.left,
                    $(window).scrollTop() + ($(window).height() || document1.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
                ];
                return;
            }
            if (o.containment === "document") {
                this.containment = [
                    0,
                    0,
                    $(document1).width() - this.helperProportions.width - this.margins.left,
                    ($(document1).height() || document1.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
                ];
                return;
            }
            if (o.containment.constructor === Array) {
                this.containment = o.containment;
                return;
            }
            if (o.containment === "parent") o.containment = this.helper[0].parentNode;
            c = $(o.containment);
            ce = c[0];
            if (!ce) return;
            over = c.css("overflow") !== "hidden";
            this.containment = [
                (parseInt(c.css("borderLeftWidth"), 10) || 0) + (parseInt(c.css("paddingLeft"), 10) || 0),
                (parseInt(c.css("borderTopWidth"), 10) || 0) + (parseInt(c.css("paddingTop"), 10) || 0),
                (over ? Math.max(ce.scrollWidth, ce.offsetWidth) : ce.offsetWidth) - (parseInt(c.css("borderRightWidth"), 10) || 0) - (parseInt(c.css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left - this.margins.right,
                (over ? Math.max(ce.scrollHeight, ce.offsetHeight) : ce.offsetHeight) - (parseInt(c.css("borderBottomWidth"), 10) || 0) - (parseInt(c.css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top - this.margins.bottom
            ];
            this.relativeContainer = c;
        },
        _convertPositionTo: function(d, pos) {
            if (!pos) pos = this.position;
            var mod = d === "absolute" ? 1 : -1, scrollIsRootNode = this._isRootNode(this.scrollParent[0]);
            return {
                top: pos.top + // The absolute mouse position
                this.offset.relative.top * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.parent.top * mod - // The offsetParent's offset without borders (offset + border)
                (this.cssPosition === "fixed" ? -this.offset.scroll.top : scrollIsRootNode ? 0 : this.offset.scroll.top) * mod,
                left: pos.left + // The absolute mouse position
                this.offset.relative.left * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.parent.left * mod - // The offsetParent's offset without borders (offset + border)
                (this.cssPosition === "fixed" ? -this.offset.scroll.left : scrollIsRootNode ? 0 : this.offset.scroll.left) * mod
            };
        },
        _generatePosition: function(event, constrainPosition) {
            var containment, co, top, left, o = this.options, scrollIsRootNode = this._isRootNode(this.scrollParent[0]), pageX = event.pageX, pageY = event.pageY;
            // Cache the scroll
            if (!scrollIsRootNode || !this.offset.scroll) this.offset.scroll = {
                top: this.scrollParent.scrollTop(),
                left: this.scrollParent.scrollLeft()
            };
            /*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */ // If we are not dragging yet, we won't check for options
            if (constrainPosition) {
                if (this.containment) {
                    if (this.relativeContainer) {
                        co = this.relativeContainer.offset();
                        containment = [
                            this.containment[0] + co.left,
                            this.containment[1] + co.top,
                            this.containment[2] + co.left,
                            this.containment[3] + co.top
                        ];
                    } else containment = this.containment;
                    if (event.pageX - this.offset.click.left < containment[0]) pageX = containment[0] + this.offset.click.left;
                    if (event.pageY - this.offset.click.top < containment[1]) pageY = containment[1] + this.offset.click.top;
                    if (event.pageX - this.offset.click.left > containment[2]) pageX = containment[2] + this.offset.click.left;
                    if (event.pageY - this.offset.click.top > containment[3]) pageY = containment[3] + this.offset.click.top;
                }
                if (o.grid) {
                    //Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
                    top = o.grid[1] ? this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY;
                    pageY = containment ? top - this.offset.click.top >= containment[1] || top - this.offset.click.top > containment[3] ? top : top - this.offset.click.top >= containment[1] ? top - o.grid[1] : top + o.grid[1] : top;
                    left = o.grid[0] ? this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX;
                    pageX = containment ? left - this.offset.click.left >= containment[0] || left - this.offset.click.left > containment[2] ? left : left - this.offset.click.left >= containment[0] ? left - o.grid[0] : left + o.grid[0] : left;
                }
                if (o.axis === "y") pageX = this.originalPageX;
                if (o.axis === "x") pageY = this.originalPageY;
            }
            return {
                top: pageY - // The absolute mouse position
                this.offset.click.top - // Click offset (relative to the element)
                this.offset.relative.top - // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.parent.top + // The offsetParent's offset without borders (offset + border)
                (this.cssPosition === "fixed" ? -this.offset.scroll.top : scrollIsRootNode ? 0 : this.offset.scroll.top),
                left: pageX - // The absolute mouse position
                this.offset.click.left - // Click offset (relative to the element)
                this.offset.relative.left - // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.parent.left + // The offsetParent's offset without borders (offset + border)
                (this.cssPosition === "fixed" ? -this.offset.scroll.left : scrollIsRootNode ? 0 : this.offset.scroll.left)
            };
        },
        _clear: function() {
            this.helper.removeClass("ui-draggable-dragging");
            if (this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) this.helper.remove();
            this.helper = null;
            this.cancelHelperRemoval = false;
            if (this.destroyOnClear) this.destroy();
        },
        // From now on bulk stuff - mainly helpers
        _trigger: function(type, event, ui) {
            ui = ui || this._uiHash();
            $.ui.plugin.call(this, type, [
                event,
                ui,
                this
            ], true);
            //The absolute position has to be recalculated after plugins
            if (type === "drag") this.positionAbs = this._convertPositionTo("absolute");
            return $.Widget.prototype._trigger.call(this, type, event, ui);
        },
        plugins: {},
        _uiHash: function() {
            return {
                helper: this.helper,
                position: this.position,
                originalPosition: this.originalPosition,
                offset: this.positionAbs
            };
        }
    });
    $.ui.plugin.add("draggable", "connectToSortable", {
        start: function(event, ui, inst) {
            var o = inst.options, uiSortable = $.extend({}, ui, {
                item: inst.element
            });
            inst.sortables = [];
            $(o.connectToSortable).each(function() {
                var sortable = $(this).sortable("instance");
                if (sortable && !sortable.options.disabled) {
                    inst.sortables.push({
                        instance: sortable,
                        shouldRevert: sortable.options.revert
                    });
                    sortable.refreshPositions(); // Call the sortable's refreshPositions at drag start to refresh the containerCache since the sortable container cache is used in drag and needs to be up to date (this will ensure it's initialised as well as being kept in step with any changes that might have happened on the page).
                    sortable._trigger("activate", event, uiSortable);
                }
            });
        },
        stop: function(event, ui, inst) {
            //If we are still over the sortable, we fake the stop event of the sortable, but also remove helper
            var uiSortable = $.extend({}, ui, {
                item: inst.element
            });
            $.each(inst.sortables, function() {
                if (this.instance.isOver) {
                    this.instance.isOver = 0;
                    inst.cancelHelperRemoval = true; //Don't remove the helper in the draggable instance
                    this.instance.cancelHelperRemoval = false; //Remove it in the sortable instance (so sortable plugins like revert still work)
                    //The sortable revert is supported, and we have to set a temporary dropped variable on the draggable to support revert: "valid/invalid"
                    if (this.shouldRevert) this.instance.options.revert = this.shouldRevert;
                    //Trigger the stop of the sortable
                    this.instance._mouseStop(event);
                    this.instance.options.helper = this.instance.options._helper;
                    //If the helper has been the original item, restore properties in the sortable
                    if (inst.options.helper === "original") this.instance.currentItem.css({
                        top: "auto",
                        left: "auto"
                    });
                } else {
                    this.instance.cancelHelperRemoval = false; //Remove the helper in the sortable instance
                    this.instance._trigger("deactivate", event, uiSortable);
                }
            });
        },
        drag: function(event, ui, inst) {
            var that = this;
            $.each(inst.sortables, function() {
                var innermostIntersecting = false, thisSortable = this;
                //Copy over some variables to allow calling the sortable's native _intersectsWith
                this.instance.positionAbs = inst.positionAbs;
                this.instance.helperProportions = inst.helperProportions;
                this.instance.offset.click = inst.offset.click;
                if (this.instance._intersectsWith(this.instance.containerCache)) {
                    innermostIntersecting = true;
                    $.each(inst.sortables, function() {
                        this.instance.positionAbs = inst.positionAbs;
                        this.instance.helperProportions = inst.helperProportions;
                        this.instance.offset.click = inst.offset.click;
                        if (this !== thisSortable && this.instance._intersectsWith(this.instance.containerCache) && $.contains(thisSortable.instance.element[0], this.instance.element[0])) innermostIntersecting = false;
                        return innermostIntersecting;
                    });
                }
                if (innermostIntersecting) {
                    //If it intersects, we use a little isOver variable and set it once, so our move-in stuff gets fired only once
                    if (!this.instance.isOver) {
                        this.instance.isOver = 1;
                        //Now we fake the start of dragging for the sortable instance,
                        //by cloning the list group item, appending it to the sortable and using it as inst.currentItem
                        //We can then fire the start event of the sortable with our passed browser event, and our own helper (so it doesn't create a new one)
                        this.instance.currentItem = $(that).clone().removeAttr("id").appendTo(this.instance.element).data("ui-sortable-item", true);
                        this.instance.options._helper = this.instance.options.helper; //Store helper option to later restore it
                        this.instance.options.helper = function() {
                            return ui.helper[0];
                        };
                        event.target = this.instance.currentItem[0];
                        this.instance._mouseCapture(event, true);
                        this.instance._mouseStart(event, true, true);
                        //Because the browser event is way off the new appended portlet, we modify a couple of variables to reflect the changes
                        this.instance.offset.click.top = inst.offset.click.top;
                        this.instance.offset.click.left = inst.offset.click.left;
                        this.instance.offset.parent.left -= inst.offset.parent.left - this.instance.offset.parent.left;
                        this.instance.offset.parent.top -= inst.offset.parent.top - this.instance.offset.parent.top;
                        inst._trigger("toSortable", event);
                        inst.dropped = this.instance.element; //draggable revert needs that
                        //hack so receive/update callbacks work (mostly)
                        inst.currentItem = inst.element;
                        this.instance.fromOutside = inst;
                    }
                    //Provided we did all the previous steps, we can fire the drag event of the sortable on every draggable drag, when it intersects with the sortable
                    if (this.instance.currentItem) this.instance._mouseDrag(event);
                } else //If it doesn't intersect with the sortable, and it intersected before,
                //we fake the drag stop of the sortable, but make sure it doesn't remove the helper by using cancelHelperRemoval
                if (this.instance.isOver) {
                    this.instance.isOver = 0;
                    this.instance.cancelHelperRemoval = true;
                    //Prevent reverting on this forced stop
                    this.instance.options.revert = false;
                    // The out event needs to be triggered independently
                    this.instance._trigger("out", event, this.instance._uiHash(this.instance));
                    this.instance._mouseStop(event, true);
                    this.instance.options.helper = this.instance.options._helper;
                    //Now we remove our currentItem, the list group clone again, and the placeholder, and animate the helper back to it's original size
                    this.instance.currentItem.remove();
                    if (this.instance.placeholder) this.instance.placeholder.remove();
                    inst._trigger("fromSortable", event);
                    inst.dropped = false; //draggable revert needs that
                }
            });
        }
    });
    $.ui.plugin.add("draggable", "cursor", {
        start: function(event, ui, instance) {
            var t = $("body"), o = instance.options;
            if (t.css("cursor")) o._cursor = t.css("cursor");
            t.css("cursor", o.cursor);
        },
        stop: function(event, ui, instance) {
            var o = instance.options;
            if (o._cursor) $("body").css("cursor", o._cursor);
        }
    });
    $.ui.plugin.add("draggable", "opacity", {
        start: function(event, ui, instance) {
            var t = $(ui.helper), o = instance.options;
            if (t.css("opacity")) o._opacity = t.css("opacity");
            t.css("opacity", o.opacity);
        },
        stop: function(event, ui, instance) {
            var o = instance.options;
            if (o._opacity) $(ui.helper).css("opacity", o._opacity);
        }
    });
    $.ui.plugin.add("draggable", "scroll", {
        start: function(event, ui, i) {
            if (!i.scrollParentNotHidden) i.scrollParentNotHidden = i.helper.scrollParent(false);
            if (i.scrollParentNotHidden[0] !== i.document[0] && i.scrollParentNotHidden[0].tagName !== "HTML") i.overflowOffset = i.scrollParentNotHidden.offset();
        },
        drag: function(event, ui, i) {
            var o = i.options, scrolled = false, scrollParent = i.scrollParentNotHidden[0], document1 = i.document[0];
            if (scrollParent !== document1 && scrollParent.tagName !== "HTML") {
                if (!o.axis || o.axis !== "x") {
                    if (i.overflowOffset.top + scrollParent.offsetHeight - event.pageY < o.scrollSensitivity) scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
                    else if (event.pageY - i.overflowOffset.top < o.scrollSensitivity) scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
                }
                if (!o.axis || o.axis !== "y") {
                    if (i.overflowOffset.left + scrollParent.offsetWidth - event.pageX < o.scrollSensitivity) scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
                    else if (event.pageX - i.overflowOffset.left < o.scrollSensitivity) scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
                }
            } else {
                if (!o.axis || o.axis !== "x") {
                    if (event.pageY - $(document1).scrollTop() < o.scrollSensitivity) scrolled = $(document1).scrollTop($(document1).scrollTop() - o.scrollSpeed);
                    else if ($(window).height() - (event.pageY - $(document1).scrollTop()) < o.scrollSensitivity) scrolled = $(document1).scrollTop($(document1).scrollTop() + o.scrollSpeed);
                }
                if (!o.axis || o.axis !== "y") {
                    if (event.pageX - $(document1).scrollLeft() < o.scrollSensitivity) scrolled = $(document1).scrollLeft($(document1).scrollLeft() - o.scrollSpeed);
                    else if ($(window).width() - (event.pageX - $(document1).scrollLeft()) < o.scrollSensitivity) scrolled = $(document1).scrollLeft($(document1).scrollLeft() + o.scrollSpeed);
                }
            }
            if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) $.ui.ddmanager.prepareOffsets(i, event);
        }
    });
    $.ui.plugin.add("draggable", "snap", {
        start: function(event, ui, i) {
            var o = i.options;
            i.snapElements = [];
            $(o.snap.constructor !== String ? o.snap.items || ":data(ui-draggable)" : o.snap).each(function() {
                var $t = $(this), $o = $t.offset();
                if (this !== i.element[0]) i.snapElements.push({
                    item: this,
                    width: $t.outerWidth(),
                    height: $t.outerHeight(),
                    top: $o.top,
                    left: $o.left
                });
            });
        },
        drag: function(event, ui, inst) {
            var ts, bs, ls, rs, l, r, t, b, i, first, o = inst.options, d = o.snapTolerance, x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width, y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;
            for(i = inst.snapElements.length - 1; i >= 0; i--){
                l = inst.snapElements[i].left;
                r = l + inst.snapElements[i].width;
                t = inst.snapElements[i].top;
                b = t + inst.snapElements[i].height;
                if (x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d || !$.contains(inst.snapElements[i].item.ownerDocument, inst.snapElements[i].item)) {
                    if (inst.snapElements[i].snapping) inst.options.snap.release && inst.options.snap.release.call(inst.element, event, $.extend(inst._uiHash(), {
                        snapItem: inst.snapElements[i].item
                    }));
                    inst.snapElements[i].snapping = false;
                    continue;
                }
                if (o.snapMode !== "inner") {
                    ts = Math.abs(t - y2) <= d;
                    bs = Math.abs(b - y1) <= d;
                    ls = Math.abs(l - x2) <= d;
                    rs = Math.abs(r - x1) <= d;
                    if (ts) ui.position.top = inst._convertPositionTo("relative", {
                        top: t - inst.helperProportions.height,
                        left: 0
                    }).top - inst.margins.top;
                    if (bs) ui.position.top = inst._convertPositionTo("relative", {
                        top: b,
                        left: 0
                    }).top - inst.margins.top;
                    if (ls) ui.position.left = inst._convertPositionTo("relative", {
                        top: 0,
                        left: l - inst.helperProportions.width
                    }).left - inst.margins.left;
                    if (rs) ui.position.left = inst._convertPositionTo("relative", {
                        top: 0,
                        left: r
                    }).left - inst.margins.left;
                }
                first = ts || bs || ls || rs;
                if (o.snapMode !== "outer") {
                    ts = Math.abs(t - y1) <= d;
                    bs = Math.abs(b - y2) <= d;
                    ls = Math.abs(l - x1) <= d;
                    rs = Math.abs(r - x2) <= d;
                    if (ts) ui.position.top = inst._convertPositionTo("relative", {
                        top: t,
                        left: 0
                    }).top - inst.margins.top;
                    if (bs) ui.position.top = inst._convertPositionTo("relative", {
                        top: b - inst.helperProportions.height,
                        left: 0
                    }).top - inst.margins.top;
                    if (ls) ui.position.left = inst._convertPositionTo("relative", {
                        top: 0,
                        left: l
                    }).left - inst.margins.left;
                    if (rs) ui.position.left = inst._convertPositionTo("relative", {
                        top: 0,
                        left: r - inst.helperProportions.width
                    }).left - inst.margins.left;
                }
                if (!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) inst.options.snap.snap && inst.options.snap.snap.call(inst.element, event, $.extend(inst._uiHash(), {
                    snapItem: inst.snapElements[i].item
                }));
                inst.snapElements[i].snapping = ts || bs || ls || rs || first;
            }
        }
    });
    $.ui.plugin.add("draggable", "stack", {
        start: function(event, ui, instance) {
            var min, o = instance.options, group = $.makeArray($(o.stack)).sort(function(a, b) {
                return (parseInt($(a).css("zIndex"), 10) || 0) - (parseInt($(b).css("zIndex"), 10) || 0);
            });
            if (!group.length) return;
            min = parseInt($(group[0]).css("zIndex"), 10) || 0;
            $(group).each(function(i) {
                $(this).css("zIndex", min + i);
            });
            this.css("zIndex", min + group.length);
        }
    });
    $.ui.plugin.add("draggable", "zIndex", {
        start: function(event, ui, instance) {
            var t = $(ui.helper), o = instance.options;
            if (t.css("zIndex")) o._zIndex = t.css("zIndex");
            t.css("zIndex", o.zIndex);
        },
        stop: function(event, ui, instance) {
            var o = instance.options;
            if (o._zIndex) $(ui.helper).css("zIndex", o._zIndex);
        }
    });
    var draggable = $.ui.draggable;
    /*!
 * jQuery UI Resizable 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/resizable/
 */ $.widget("ui.resizable", $.ui.mouse, {
        version: "1.11.1",
        widgetEventPrefix: "resize",
        options: {
            alsoResize: false,
            animate: false,
            animateDuration: "slow",
            animateEasing: "swing",
            aspectRatio: false,
            autoHide: false,
            containment: false,
            ghost: false,
            grid: false,
            handles: "e,s,se",
            helper: false,
            maxHeight: null,
            maxWidth: null,
            minHeight: 10,
            minWidth: 10,
            // See #7960
            zIndex: 90,
            // callbacks
            resize: null,
            start: null,
            stop: null
        },
        _num: function(value) {
            return parseInt(value, 10) || 0;
        },
        _isNumber: function(value) {
            return !isNaN(parseInt(value, 10));
        },
        _hasScroll: function(el, a) {
            if ($(el).css("overflow") === "hidden") return false;
            var scroll = a && a === "left" ? "scrollLeft" : "scrollTop", has = false;
            if (el[scroll] > 0) return true;
            // TODO: determine which cases actually cause this to happen
            // if the element doesn't have the scroll set, see if it's possible to
            // set the scroll
            el[scroll] = 1;
            has = el[scroll] > 0;
            el[scroll] = 0;
            return has;
        },
        _create: function() {
            var n, i, handle, axis, hname, that = this, o = this.options;
            this.element.addClass("ui-resizable");
            $.extend(this, {
                _aspectRatio: !!o.aspectRatio,
                aspectRatio: o.aspectRatio,
                originalElement: this.element,
                _proportionallyResizeElements: [],
                _helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
            });
            // Wrap the element if it cannot hold child nodes
            if (this.element[0].nodeName.match(/canvas|textarea|input|select|button|img/i)) {
                this.element.wrap($("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({
                    position: this.element.css("position"),
                    width: this.element.outerWidth(),
                    height: this.element.outerHeight(),
                    top: this.element.css("top"),
                    left: this.element.css("left")
                }));
                this.element = this.element.parent().data("ui-resizable", this.element.resizable("instance"));
                this.elementIsWrapper = true;
                this.element.css({
                    marginLeft: this.originalElement.css("marginLeft"),
                    marginTop: this.originalElement.css("marginTop"),
                    marginRight: this.originalElement.css("marginRight"),
                    marginBottom: this.originalElement.css("marginBottom")
                });
                this.originalElement.css({
                    marginLeft: 0,
                    marginTop: 0,
                    marginRight: 0,
                    marginBottom: 0
                });
                // support: Safari
                // Prevent Safari textarea resize
                this.originalResizeStyle = this.originalElement.css("resize");
                this.originalElement.css("resize", "none");
                this._proportionallyResizeElements.push(this.originalElement.css({
                    position: "static",
                    zoom: 1,
                    display: "block"
                }));
                // support: IE9
                // avoid IE jump (hard set the margin)
                this.originalElement.css({
                    margin: this.originalElement.css("margin")
                });
                this._proportionallyResize();
            }
            this.handles = o.handles || (!$(".ui-resizable-handle", this.element).length ? "e,s,se" : {
                n: ".ui-resizable-n",
                e: ".ui-resizable-e",
                s: ".ui-resizable-s",
                w: ".ui-resizable-w",
                se: ".ui-resizable-se",
                sw: ".ui-resizable-sw",
                ne: ".ui-resizable-ne",
                nw: ".ui-resizable-nw"
            });
            if (this.handles.constructor === String) {
                if (this.handles === "all") this.handles = "n,e,s,w,se,sw,ne,nw";
                n = this.handles.split(",");
                this.handles = {};
                for(i = 0; i < n.length; i++){
                    handle = $.trim(n[i]);
                    hname = "ui-resizable-" + handle;
                    axis = $("<div class='ui-resizable-handle " + hname + "'></div>");
                    axis.css({
                        zIndex: o.zIndex
                    });
                    // TODO : What's going on here?
                    if ("se" === handle) axis.addClass("ui-icon ui-icon-gripsmall-diagonal-se");
                    this.handles[handle] = ".ui-resizable-" + handle;
                    this.element.append(axis);
                }
            }
            this._renderAxis = function(target) {
                var i, axis, padPos, padWrapper;
                target = target || this.element;
                for(i in this.handles){
                    if (this.handles[i].constructor === String) this.handles[i] = this.element.children(this.handles[i]).first().show();
                    if (this.elementIsWrapper && this.originalElement[0].nodeName.match(/textarea|input|select|button/i)) {
                        axis = $(this.handles[i], this.element);
                        padWrapper = /sw|ne|nw|se|n|s/.test(i) ? axis.outerHeight() : axis.outerWidth();
                        padPos = [
                            "padding",
                            /ne|nw|n/.test(i) ? "Top" : /se|sw|s/.test(i) ? "Bottom" : /^e$/.test(i) ? "Right" : "Left"
                        ].join("");
                        target.css(padPos, padWrapper);
                        this._proportionallyResize();
                    }
                    // TODO: What's that good for? There's not anything to be executed left
                    if (!$(this.handles[i]).length) continue;
                }
            };
            // TODO: make renderAxis a prototype function
            this._renderAxis(this.element);
            this._handles = $(".ui-resizable-handle", this.element).disableSelection();
            this._handles.mouseover(function() {
                if (!that.resizing) {
                    if (this.className) axis = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i);
                    that.axis = axis && axis[1] ? axis[1] : "se";
                }
            });
            if (o.autoHide) {
                this._handles.hide();
                $(this.element).addClass("ui-resizable-autohide").mouseenter(function() {
                    if (o.disabled) return;
                    $(this).removeClass("ui-resizable-autohide");
                    that._handles.show();
                }).mouseleave(function() {
                    if (o.disabled) return;
                    if (!that.resizing) {
                        $(this).addClass("ui-resizable-autohide");
                        that._handles.hide();
                    }
                });
            }
            this._mouseInit();
        },
        _destroy: function() {
            this._mouseDestroy();
            var wrapper, _destroy = function(exp) {
                $(exp).removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing").removeData("resizable").removeData("ui-resizable").unbind(".resizable").find(".ui-resizable-handle").remove();
            };
            // TODO: Unwrap at same DOM position
            if (this.elementIsWrapper) {
                _destroy(this.element);
                wrapper = this.element;
                this.originalElement.css({
                    position: wrapper.css("position"),
                    width: wrapper.outerWidth(),
                    height: wrapper.outerHeight(),
                    top: wrapper.css("top"),
                    left: wrapper.css("left")
                }).insertAfter(wrapper);
                wrapper.remove();
            }
            this.originalElement.css("resize", this.originalResizeStyle);
            _destroy(this.originalElement);
            return this;
        },
        _mouseCapture: function(event) {
            var i, handle, capture = false;
            for(i in this.handles){
                handle = $(this.handles[i])[0];
                if (handle === event.target || $.contains(handle, event.target)) capture = true;
            }
            return !this.options.disabled && capture;
        },
        _mouseStart: function(event) {
            var curleft, curtop, cursor, o = this.options, el = this.element;
            this.resizing = true;
            this._renderProxy();
            curleft = this._num(this.helper.css("left"));
            curtop = this._num(this.helper.css("top"));
            if (o.containment) {
                curleft += $(o.containment).scrollLeft() || 0;
                curtop += $(o.containment).scrollTop() || 0;
            }
            this.offset = this.helper.offset();
            this.position = {
                left: curleft,
                top: curtop
            };
            this.size = this._helper ? {
                width: this.helper.width(),
                height: this.helper.height()
            } : {
                width: el.width(),
                height: el.height()
            };
            this.originalSize = this._helper ? {
                width: el.outerWidth(),
                height: el.outerHeight()
            } : {
                width: el.width(),
                height: el.height()
            };
            this.sizeDiff = {
                width: el.outerWidth() - el.width(),
                height: el.outerHeight() - el.height()
            };
            this.originalPosition = {
                left: curleft,
                top: curtop
            };
            this.originalMousePosition = {
                left: event.pageX,
                top: event.pageY
            };
            this.aspectRatio = typeof o.aspectRatio === "number" ? o.aspectRatio : this.originalSize.width / this.originalSize.height || 1;
            cursor = $(".ui-resizable-" + this.axis).css("cursor");
            $("body").css("cursor", cursor === "auto" ? this.axis + "-resize" : cursor);
            el.addClass("ui-resizable-resizing");
            this._propagate("start", event);
            return true;
        },
        _mouseDrag: function(event) {
            var data, props, smp = this.originalMousePosition, a = this.axis, dx = event.pageX - smp.left || 0, dy = event.pageY - smp.top || 0, trigger = this._change[a];
            this._updatePrevProperties();
            if (!trigger) return false;
            data = trigger.apply(this, [
                event,
                dx,
                dy
            ]);
            this._updateVirtualBoundaries(event.shiftKey);
            if (this._aspectRatio || event.shiftKey) data = this._updateRatio(data, event);
            data = this._respectSize(data, event);
            this._updateCache(data);
            this._propagate("resize", event);
            props = this._applyChanges();
            if (!this._helper && this._proportionallyResizeElements.length) this._proportionallyResize();
            if (!$.isEmptyObject(props)) {
                this._updatePrevProperties();
                this._trigger("resize", event, this.ui());
                this._applyChanges();
            }
            return false;
        },
        _mouseStop: function(event) {
            this.resizing = false;
            var pr, ista, soffseth, soffsetw, s, left, top, o = this.options, that = this;
            if (this._helper) {
                pr = this._proportionallyResizeElements;
                ista = pr.length && /textarea/i.test(pr[0].nodeName);
                soffseth = ista && this._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height;
                soffsetw = ista ? 0 : that.sizeDiff.width;
                s = {
                    width: that.helper.width() - soffsetw,
                    height: that.helper.height() - soffseth
                };
                left = parseInt(that.element.css("left"), 10) + (that.position.left - that.originalPosition.left) || null;
                top = parseInt(that.element.css("top"), 10) + (that.position.top - that.originalPosition.top) || null;
                if (!o.animate) this.element.css($.extend(s, {
                    top: top,
                    left: left
                }));
                that.helper.height(that.size.height);
                that.helper.width(that.size.width);
                if (this._helper && !o.animate) this._proportionallyResize();
            }
            $("body").css("cursor", "auto");
            this.element.removeClass("ui-resizable-resizing");
            this._propagate("stop", event);
            if (this._helper) this.helper.remove();
            return false;
        },
        _updatePrevProperties: function() {
            this.prevPosition = {
                top: this.position.top,
                left: this.position.left
            };
            this.prevSize = {
                width: this.size.width,
                height: this.size.height
            };
        },
        _applyChanges: function() {
            var props = {};
            if (this.position.top !== this.prevPosition.top) props.top = this.position.top + "px";
            if (this.position.left !== this.prevPosition.left) props.left = this.position.left + "px";
            if (this.size.width !== this.prevSize.width) props.width = this.size.width + "px";
            if (this.size.height !== this.prevSize.height) props.height = this.size.height + "px";
            this.helper.css(props);
            return props;
        },
        _updateVirtualBoundaries: function(forceAspectRatio) {
            var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b, o = this.options;
            b = {
                minWidth: this._isNumber(o.minWidth) ? o.minWidth : 0,
                maxWidth: this._isNumber(o.maxWidth) ? o.maxWidth : Infinity,
                minHeight: this._isNumber(o.minHeight) ? o.minHeight : 0,
                maxHeight: this._isNumber(o.maxHeight) ? o.maxHeight : Infinity
            };
            if (this._aspectRatio || forceAspectRatio) {
                pMinWidth = b.minHeight * this.aspectRatio;
                pMinHeight = b.minWidth / this.aspectRatio;
                pMaxWidth = b.maxHeight * this.aspectRatio;
                pMaxHeight = b.maxWidth / this.aspectRatio;
                if (pMinWidth > b.minWidth) b.minWidth = pMinWidth;
                if (pMinHeight > b.minHeight) b.minHeight = pMinHeight;
                if (pMaxWidth < b.maxWidth) b.maxWidth = pMaxWidth;
                if (pMaxHeight < b.maxHeight) b.maxHeight = pMaxHeight;
            }
            this._vBoundaries = b;
        },
        _updateCache: function(data) {
            this.offset = this.helper.offset();
            if (this._isNumber(data.left)) this.position.left = data.left;
            if (this._isNumber(data.top)) this.position.top = data.top;
            if (this._isNumber(data.height)) this.size.height = data.height;
            if (this._isNumber(data.width)) this.size.width = data.width;
        },
        _updateRatio: function(data) {
            var cpos = this.position, csize = this.size, a = this.axis;
            if (this._isNumber(data.height)) data.width = data.height * this.aspectRatio;
            else if (this._isNumber(data.width)) data.height = data.width / this.aspectRatio;
            if (a === "sw") {
                data.left = cpos.left + (csize.width - data.width);
                data.top = null;
            }
            if (a === "nw") {
                data.top = cpos.top + (csize.height - data.height);
                data.left = cpos.left + (csize.width - data.width);
            }
            return data;
        },
        _respectSize: function(data) {
            var o = this._vBoundaries, a = this.axis, ismaxw = this._isNumber(data.width) && o.maxWidth && o.maxWidth < data.width, ismaxh = this._isNumber(data.height) && o.maxHeight && o.maxHeight < data.height, isminw = this._isNumber(data.width) && o.minWidth && o.minWidth > data.width, isminh = this._isNumber(data.height) && o.minHeight && o.minHeight > data.height, dw = this.originalPosition.left + this.originalSize.width, dh = this.position.top + this.size.height, cw = /sw|nw|w/.test(a), ch = /nw|ne|n/.test(a);
            if (isminw) data.width = o.minWidth;
            if (isminh) data.height = o.minHeight;
            if (ismaxw) data.width = o.maxWidth;
            if (ismaxh) data.height = o.maxHeight;
            if (isminw && cw) data.left = dw - o.minWidth;
            if (ismaxw && cw) data.left = dw - o.maxWidth;
            if (isminh && ch) data.top = dh - o.minHeight;
            if (ismaxh && ch) data.top = dh - o.maxHeight;
            // Fixing jump error on top/left - bug #2330
            if (!data.width && !data.height && !data.left && data.top) data.top = null;
            else if (!data.width && !data.height && !data.top && data.left) data.left = null;
            return data;
        },
        _getPaddingPlusBorderDimensions: function(element) {
            var i = 0, widths = [], borders = [
                element.css("borderTopWidth"),
                element.css("borderRightWidth"),
                element.css("borderBottomWidth"),
                element.css("borderLeftWidth")
            ], paddings = [
                element.css("paddingTop"),
                element.css("paddingRight"),
                element.css("paddingBottom"),
                element.css("paddingLeft")
            ];
            for(; i < 4; i++){
                widths[i] = parseInt(borders[i], 10) || 0;
                widths[i] += parseInt(paddings[i], 10) || 0;
            }
            return {
                height: widths[0] + widths[2],
                width: widths[1] + widths[3]
            };
        },
        _proportionallyResize: function() {
            if (!this._proportionallyResizeElements.length) return;
            var prel, i = 0, element = this.helper || this.element;
            for(; i < this._proportionallyResizeElements.length; i++){
                prel = this._proportionallyResizeElements[i];
                // TODO: Seems like a bug to cache this.outerDimensions
                // considering that we are in a loop.
                if (!this.outerDimensions) this.outerDimensions = this._getPaddingPlusBorderDimensions(prel);
                prel.css({
                    height: element.height() - this.outerDimensions.height || 0,
                    width: element.width() - this.outerDimensions.width || 0
                });
            }
        },
        _renderProxy: function() {
            var el = this.element, o = this.options;
            this.elementOffset = el.offset();
            if (this._helper) {
                this.helper = this.helper || $("<div style='overflow:hidden;'></div>");
                this.helper.addClass(this._helper).css({
                    width: this.element.outerWidth() - 1,
                    height: this.element.outerHeight() - 1,
                    position: "absolute",
                    left: this.elementOffset.left + "px",
                    top: this.elementOffset.top + "px",
                    zIndex: ++o.zIndex //TODO: Don't modify option
                });
                this.helper.appendTo("body").disableSelection();
            } else this.helper = this.element;
        },
        _change: {
            e: function(event, dx) {
                return {
                    width: this.originalSize.width + dx
                };
            },
            w: function(event, dx) {
                var cs = this.originalSize, sp = this.originalPosition;
                return {
                    left: sp.left + dx,
                    width: cs.width - dx
                };
            },
            n: function(event, dx, dy) {
                var cs = this.originalSize, sp = this.originalPosition;
                return {
                    top: sp.top + dy,
                    height: cs.height - dy
                };
            },
            s: function(event, dx, dy) {
                return {
                    height: this.originalSize.height + dy
                };
            },
            se: function(event, dx, dy) {
                return $.extend(this._change.s.apply(this, arguments), this._change.e.apply(this, [
                    event,
                    dx,
                    dy
                ]));
            },
            sw: function(event, dx, dy) {
                return $.extend(this._change.s.apply(this, arguments), this._change.w.apply(this, [
                    event,
                    dx,
                    dy
                ]));
            },
            ne: function(event, dx, dy) {
                return $.extend(this._change.n.apply(this, arguments), this._change.e.apply(this, [
                    event,
                    dx,
                    dy
                ]));
            },
            nw: function(event, dx, dy) {
                return $.extend(this._change.n.apply(this, arguments), this._change.w.apply(this, [
                    event,
                    dx,
                    dy
                ]));
            }
        },
        _propagate: function(n, event) {
            $.ui.plugin.call(this, n, [
                event,
                this.ui()
            ]);
            n !== "resize" && this._trigger(n, event, this.ui());
        },
        plugins: {},
        ui: function() {
            return {
                originalElement: this.originalElement,
                element: this.element,
                helper: this.helper,
                position: this.position,
                size: this.size,
                originalSize: this.originalSize,
                originalPosition: this.originalPosition
            };
        }
    });
    /*
 * Resizable Extensions
 */ $.ui.plugin.add("resizable", "animate", {
        stop: function(event) {
            var that = $(this).resizable("instance"), o = that.options, pr = that._proportionallyResizeElements, ista = pr.length && /textarea/i.test(pr[0].nodeName), soffseth = ista && that._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height, soffsetw = ista ? 0 : that.sizeDiff.width, style = {
                width: that.size.width - soffsetw,
                height: that.size.height - soffseth
            }, left = parseInt(that.element.css("left"), 10) + (that.position.left - that.originalPosition.left) || null, top = parseInt(that.element.css("top"), 10) + (that.position.top - that.originalPosition.top) || null;
            that.element.animate($.extend(style, top && left ? {
                top: top,
                left: left
            } : {}), {
                duration: o.animateDuration,
                easing: o.animateEasing,
                step: function() {
                    var data = {
                        width: parseInt(that.element.css("width"), 10),
                        height: parseInt(that.element.css("height"), 10),
                        top: parseInt(that.element.css("top"), 10),
                        left: parseInt(that.element.css("left"), 10)
                    };
                    if (pr && pr.length) $(pr[0]).css({
                        width: data.width,
                        height: data.height
                    });
                    // propagating resize, and updating values for each animation step
                    that._updateCache(data);
                    that._propagate("resize", event);
                }
            });
        }
    });
    $.ui.plugin.add("resizable", "containment", {
        start: function() {
            var element, p, co, ch, cw, width, height, that = $(this).resizable("instance"), o = that.options, el = that.element, oc = o.containment, ce = oc instanceof $ ? oc.get(0) : /parent/.test(oc) ? el.parent().get(0) : oc;
            if (!ce) return;
            that.containerElement = $(ce);
            if (/document/.test(oc) || oc === document) {
                that.containerOffset = {
                    left: 0,
                    top: 0
                };
                that.containerPosition = {
                    left: 0,
                    top: 0
                };
                that.parentData = {
                    element: $(document),
                    left: 0,
                    top: 0,
                    width: $(document).width(),
                    height: $(document).height() || document.body.parentNode.scrollHeight
                };
            } else {
                element = $(ce);
                p = [];
                $([
                    "Top",
                    "Right",
                    "Left",
                    "Bottom"
                ]).each(function(i, name) {
                    p[i] = that._num(element.css("padding" + name));
                });
                that.containerOffset = element.offset();
                that.containerPosition = element.position();
                that.containerSize = {
                    height: element.innerHeight() - p[3],
                    width: element.innerWidth() - p[1]
                };
                co = that.containerOffset;
                ch = that.containerSize.height;
                cw = that.containerSize.width;
                width = that._hasScroll(ce, "left") ? ce.scrollWidth : cw;
                height = that._hasScroll(ce) ? ce.scrollHeight : ch;
                that.parentData = {
                    element: ce,
                    left: co.left,
                    top: co.top,
                    width: width,
                    height: height
                };
            }
        },
        resize: function(event) {
            var woset, hoset, isParent, isOffsetRelative, that = $(this).resizable("instance"), o = that.options, co = that.containerOffset, cp = that.position, pRatio = that._aspectRatio || event.shiftKey, cop = {
                top: 0,
                left: 0
            }, ce = that.containerElement, continueResize = true;
            if (ce[0] !== document && /static/.test(ce.css("position"))) cop = co;
            if (cp.left < (that._helper ? co.left : 0)) {
                that.size.width = that.size.width + (that._helper ? that.position.left - co.left : that.position.left - cop.left);
                if (pRatio) {
                    that.size.height = that.size.width / that.aspectRatio;
                    continueResize = false;
                }
                that.position.left = o.helper ? co.left : 0;
            }
            if (cp.top < (that._helper ? co.top : 0)) {
                that.size.height = that.size.height + (that._helper ? that.position.top - co.top : that.position.top);
                if (pRatio) {
                    that.size.width = that.size.height * that.aspectRatio;
                    continueResize = false;
                }
                that.position.top = that._helper ? co.top : 0;
            }
            isParent = that.containerElement.get(0) === that.element.parent().get(0);
            isOffsetRelative = /relative|absolute/.test(that.containerElement.css("position"));
            if (isParent && isOffsetRelative) {
                that.offset.left = that.parentData.left + that.position.left;
                that.offset.top = that.parentData.top + that.position.top;
            } else {
                that.offset.left = that.element.offset().left;
                that.offset.top = that.element.offset().top;
            }
            woset = Math.abs(that.sizeDiff.width + (that._helper ? that.offset.left - cop.left : that.offset.left - co.left));
            hoset = Math.abs(that.sizeDiff.height + (that._helper ? that.offset.top - cop.top : that.offset.top - co.top));
            if (woset + that.size.width >= that.parentData.width) {
                that.size.width = that.parentData.width - woset;
                if (pRatio) {
                    that.size.height = that.size.width / that.aspectRatio;
                    continueResize = false;
                }
            }
            if (hoset + that.size.height >= that.parentData.height) {
                that.size.height = that.parentData.height - hoset;
                if (pRatio) {
                    that.size.width = that.size.height * that.aspectRatio;
                    continueResize = false;
                }
            }
            if (!continueResize) {
                that.position.left = that.prevPosition.left;
                that.position.top = that.prevPosition.top;
                that.size.width = that.prevSize.width;
                that.size.height = that.prevSize.height;
            }
        },
        stop: function() {
            var that = $(this).resizable("instance"), o = that.options, co = that.containerOffset, cop = that.containerPosition, ce = that.containerElement, helper = $(that.helper), ho = helper.offset(), w = helper.outerWidth() - that.sizeDiff.width, h = helper.outerHeight() - that.sizeDiff.height;
            if (that._helper && !o.animate && /relative/.test(ce.css("position"))) $(this).css({
                left: ho.left - cop.left - co.left,
                width: w,
                height: h
            });
            if (that._helper && !o.animate && /static/.test(ce.css("position"))) $(this).css({
                left: ho.left - cop.left - co.left,
                width: w,
                height: h
            });
        }
    });
    $.ui.plugin.add("resizable", "alsoResize", {
        start: function() {
            var that = $(this).resizable("instance"), o = that.options, _store = function(exp) {
                $(exp).each(function() {
                    var el = $(this);
                    el.data("ui-resizable-alsoresize", {
                        width: parseInt(el.width(), 10),
                        height: parseInt(el.height(), 10),
                        left: parseInt(el.css("left"), 10),
                        top: parseInt(el.css("top"), 10)
                    });
                });
            };
            if (typeof o.alsoResize === "object" && !o.alsoResize.parentNode) {
                if (o.alsoResize.length) {
                    o.alsoResize = o.alsoResize[0];
                    _store(o.alsoResize);
                } else $.each(o.alsoResize, function(exp) {
                    _store(exp);
                });
            } else _store(o.alsoResize);
        },
        resize: function(event, ui) {
            var that = $(this).resizable("instance"), o = that.options, os = that.originalSize, op = that.originalPosition, delta = {
                height: that.size.height - os.height || 0,
                width: that.size.width - os.width || 0,
                top: that.position.top - op.top || 0,
                left: that.position.left - op.left || 0
            }, _alsoResize = function(exp, c) {
                $(exp).each(function() {
                    var el = $(this), start = $(this).data("ui-resizable-alsoresize"), style = {}, css = c && c.length ? c : el.parents(ui.originalElement[0]).length ? [
                        "width",
                        "height"
                    ] : [
                        "width",
                        "height",
                        "top",
                        "left"
                    ];
                    $.each(css, function(i, prop) {
                        var sum = (start[prop] || 0) + (delta[prop] || 0);
                        if (sum && sum >= 0) style[prop] = sum || null;
                    });
                    el.css(style);
                });
            };
            if (typeof o.alsoResize === "object" && !o.alsoResize.nodeType) $.each(o.alsoResize, function(exp, c) {
                _alsoResize(exp, c);
            });
            else _alsoResize(o.alsoResize);
        },
        stop: function() {
            $(this).removeData("resizable-alsoresize");
        }
    });
    $.ui.plugin.add("resizable", "ghost", {
        start: function() {
            var that = $(this).resizable("instance"), o = that.options, cs = that.size;
            that.ghost = that.originalElement.clone();
            that.ghost.css({
                opacity: 0.25,
                display: "block",
                position: "relative",
                height: cs.height,
                width: cs.width,
                margin: 0,
                left: 0,
                top: 0
            }).addClass("ui-resizable-ghost").addClass(typeof o.ghost === "string" ? o.ghost : "");
            that.ghost.appendTo(that.helper);
        },
        resize: function() {
            var that = $(this).resizable("instance");
            if (that.ghost) that.ghost.css({
                position: "relative",
                height: that.size.height,
                width: that.size.width
            });
        },
        stop: function() {
            var that = $(this).resizable("instance");
            if (that.ghost && that.helper) that.helper.get(0).removeChild(that.ghost.get(0));
        }
    });
    $.ui.plugin.add("resizable", "grid", {
        resize: function() {
            var outerDimensions, that = $(this).resizable("instance"), o = that.options, cs = that.size, os = that.originalSize, op = that.originalPosition, a = that.axis, grid = typeof o.grid === "number" ? [
                o.grid,
                o.grid
            ] : o.grid, gridX = grid[0] || 1, gridY = grid[1] || 1, ox = Math.round((cs.width - os.width) / gridX) * gridX, oy = Math.round((cs.height - os.height) / gridY) * gridY, newWidth = os.width + ox, newHeight = os.height + oy, isMaxWidth = o.maxWidth && o.maxWidth < newWidth, isMaxHeight = o.maxHeight && o.maxHeight < newHeight, isMinWidth = o.minWidth && o.minWidth > newWidth, isMinHeight = o.minHeight && o.minHeight > newHeight;
            o.grid = grid;
            if (isMinWidth) newWidth += gridX;
            if (isMinHeight) newHeight += gridY;
            if (isMaxWidth) newWidth -= gridX;
            if (isMaxHeight) newHeight -= gridY;
            if (/^(se|s|e)$/.test(a)) {
                that.size.width = newWidth;
                that.size.height = newHeight;
            } else if (/^(ne)$/.test(a)) {
                that.size.width = newWidth;
                that.size.height = newHeight;
                that.position.top = op.top - oy;
            } else if (/^(sw)$/.test(a)) {
                that.size.width = newWidth;
                that.size.height = newHeight;
                that.position.left = op.left - ox;
            } else {
                if (newHeight - gridY <= 0 || newWidth - gridX <= 0) outerDimensions = that._getPaddingPlusBorderDimensions(this);
                if (newHeight - gridY > 0) {
                    that.size.height = newHeight;
                    that.position.top = op.top - oy;
                } else {
                    newHeight = gridY - outerDimensions.height;
                    that.size.height = newHeight;
                    that.position.top = op.top + os.height - newHeight;
                }
                if (newWidth - gridX > 0) {
                    that.size.width = newWidth;
                    that.position.left = op.left - ox;
                } else {
                    newWidth = gridY - outerDimensions.height;
                    that.size.width = newWidth;
                    that.position.left = op.left + os.width - newWidth;
                }
            }
        }
    });
    var resizable = $.ui.resizable;
    /*!
 * jQuery UI Dialog 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/dialog/
 */ var dialog = $.widget("ui.dialog", {
        version: "1.11.1",
        options: {
            appendTo: "body",
            autoOpen: true,
            buttons: [],
            closeOnEscape: true,
            closeText: "Close",
            dialogClass: "",
            draggable: true,
            hide: null,
            height: "auto",
            maxHeight: null,
            maxWidth: null,
            minHeight: 150,
            minWidth: 150,
            modal: false,
            position: {
                my: "center",
                at: "center",
                of: window,
                collision: "fit",
                // Ensure the titlebar is always visible
                using: function(pos) {
                    var topOffset = $(this).css(pos).offset().top;
                    if (topOffset < 0) $(this).css("top", pos.top - topOffset);
                }
            },
            resizable: true,
            show: null,
            title: null,
            width: 300,
            // callbacks
            beforeClose: null,
            close: null,
            drag: null,
            dragStart: null,
            dragStop: null,
            focus: null,
            open: null,
            resize: null,
            resizeStart: null,
            resizeStop: null
        },
        sizeRelatedOptions: {
            buttons: true,
            height: true,
            maxHeight: true,
            maxWidth: true,
            minHeight: true,
            minWidth: true,
            width: true
        },
        resizableRelatedOptions: {
            maxHeight: true,
            maxWidth: true,
            minHeight: true,
            minWidth: true
        },
        _create: function() {
            this.originalCss = {
                display: this.element[0].style.display,
                width: this.element[0].style.width,
                minHeight: this.element[0].style.minHeight,
                maxHeight: this.element[0].style.maxHeight,
                height: this.element[0].style.height
            };
            this.originalPosition = {
                parent: this.element.parent(),
                index: this.element.parent().children().index(this.element)
            };
            this.originalTitle = this.element.attr("title");
            this.options.title = this.options.title || this.originalTitle;
            this._createWrapper();
            this.element.show().removeAttr("title").addClass("ui-dialog-content ui-widget-content").appendTo(this.uiDialog);
            this._createTitlebar();
            this._createButtonPane();
            if (this.options.draggable && $.fn.draggable) this._makeDraggable();
            if (this.options.resizable && $.fn.resizable) this._makeResizable();
            this._isOpen = false;
            this._trackFocus();
        },
        _init: function() {
            if (this.options.autoOpen) this.open();
        },
        _appendTo: function() {
            var element = this.options.appendTo;
            if (element && (element.jquery || element.nodeType)) return $(element);
            return this.document.find(element || "body").eq(0);
        },
        _destroy: function() {
            var next, originalPosition = this.originalPosition;
            this._destroyOverlay();
            this.element.removeUniqueId().removeClass("ui-dialog-content ui-widget-content").css(this.originalCss)// Without detaching first, the following becomes really slow
            .detach();
            this.uiDialog.stop(true, true).remove();
            if (this.originalTitle) this.element.attr("title", this.originalTitle);
            next = originalPosition.parent.children().eq(originalPosition.index);
            // Don't try to place the dialog next to itself (#8613)
            if (next.length && next[0] !== this.element[0]) next.before(this.element);
            else originalPosition.parent.append(this.element);
        },
        widget: function() {
            return this.uiDialog;
        },
        disable: $.noop,
        enable: $.noop,
        close: function(event) {
            var activeElement, that = this;
            if (!this._isOpen || this._trigger("beforeClose", event) === false) return;
            this._isOpen = false;
            this._focusedElement = null;
            this._destroyOverlay();
            this._untrackInstance();
            if (!this.opener.filter(":focusable").focus().length) // support: IE9
            // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
            try {
                activeElement = this.document[0].activeElement;
                // Support: IE9, IE10
                // If the <body> is blurred, IE will switch windows, see #4520
                if (activeElement && activeElement.nodeName.toLowerCase() !== "body") // Hiding a focused element doesn't trigger blur in WebKit
                // so in case we have nothing to focus on, explicitly blur the active element
                // https://bugs.webkit.org/show_bug.cgi?id=47182
                $(activeElement).blur();
            } catch (error) {}
            this._hide(this.uiDialog, this.options.hide, function() {
                that._trigger("close", event);
            });
        },
        isOpen: function() {
            return this._isOpen;
        },
        moveToTop: function() {
            this._moveToTop();
        },
        _moveToTop: function(event, silent) {
            var moved = false, zIndicies = this.uiDialog.siblings(".ui-front:visible").map(function() {
                return +$(this).css("z-index");
            }).get(), zIndexMax = Math.max.apply(null, zIndicies);
            if (zIndexMax >= +this.uiDialog.css("z-index")) {
                this.uiDialog.css("z-index", zIndexMax + 1);
                moved = true;
            }
            if (moved && !silent) this._trigger("focus", event);
            return moved;
        },
        open: function() {
            var that = this;
            if (this._isOpen) {
                if (this._moveToTop()) this._focusTabbable();
                return;
            }
            this._isOpen = true;
            this.opener = $(this.document[0].activeElement);
            this._size();
            this._position();
            this._createOverlay();
            this._moveToTop(null, true);
            // Ensure the overlay is moved to the top with the dialog, but only when
            // opening. The overlay shouldn't move after the dialog is open so that
            // modeless dialogs opened after the modal dialog stack properly.
            if (this.overlay) this.overlay.css("z-index", this.uiDialog.css("z-index") - 1);
            this._show(this.uiDialog, this.options.show, function() {
                that._focusTabbable();
                that._trigger("focus");
            });
            // Track the dialog immediately upon openening in case a focus event
            // somehow occurs outside of the dialog before an element inside the
            // dialog is focused (#10152)
            this._makeFocusTarget();
            this._trigger("open");
        },
        _focusTabbable: function() {
            // Set focus to the first match:
            // 1. An element that was focused previously
            // 2. First element inside the dialog matching [autofocus]
            // 3. Tabbable element inside the content element
            // 4. Tabbable element inside the buttonpane
            // 5. The close button
            // 6. The dialog itself
            var hasFocus = this._focusedElement;
            if (!hasFocus) hasFocus = this.element.find("[autofocus]");
            if (!hasFocus.length) hasFocus = this.element.find(":tabbable");
            if (!hasFocus.length) hasFocus = this.uiDialogButtonPane.find(":tabbable");
            if (!hasFocus.length) hasFocus = this.uiDialogTitlebarClose.filter(":tabbable");
            if (!hasFocus.length) hasFocus = this.uiDialog;
            hasFocus.eq(0).focus();
        },
        _keepFocus: function(event) {
            function checkFocus() {
                var activeElement = this.document[0].activeElement, isActive = this.uiDialog[0] === activeElement || $.contains(this.uiDialog[0], activeElement);
                if (!isActive) this._focusTabbable();
            }
            event.preventDefault();
            checkFocus.call(this);
            // support: IE
            // IE <= 8 doesn't prevent moving focus even with event.preventDefault()
            // so we check again later
            this._delay(checkFocus);
        },
        _createWrapper: function() {
            this.uiDialog = $("<div>").addClass("ui-dialog ui-widget ui-widget-content ui-corner-all ui-front " + this.options.dialogClass).hide().attr({
                // Setting tabIndex makes the div focusable
                tabIndex: -1,
                role: "dialog"
            }).appendTo(this._appendTo());
            this._on(this.uiDialog, {
                keydown: function(event) {
                    if (this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode && event.keyCode === $.ui.keyCode.ESCAPE) {
                        event.preventDefault();
                        this.close(event);
                        return;
                    }
                    // prevent tabbing out of dialogs
                    if (event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented()) return;
                    var tabbables = this.uiDialog.find(":tabbable"), first = tabbables.filter(":first"), last = tabbables.filter(":last");
                    if ((event.target === last[0] || event.target === this.uiDialog[0]) && !event.shiftKey) {
                        this._delay(function() {
                            first.focus();
                        });
                        event.preventDefault();
                    } else if ((event.target === first[0] || event.target === this.uiDialog[0]) && event.shiftKey) {
                        this._delay(function() {
                            last.focus();
                        });
                        event.preventDefault();
                    }
                },
                mousedown: function(event) {
                    if (this._moveToTop(event)) this._focusTabbable();
                }
            });
            // We assume that any existing aria-describedby attribute means
            // that the dialog content is marked up properly
            // otherwise we brute force the content as the description
            if (!this.element.find("[aria-describedby]").length) this.uiDialog.attr({
                "aria-describedby": this.element.uniqueId().attr("id")
            });
        },
        _createTitlebar: function() {
            var uiDialogTitle;
            this.uiDialogTitlebar = $("<div>").addClass("ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix").prependTo(this.uiDialog);
            this._on(this.uiDialogTitlebar, {
                mousedown: function(event) {
                    // Don't prevent click on close button (#8838)
                    // Focusing a dialog that is partially scrolled out of view
                    // causes the browser to scroll it into view, preventing the click event
                    if (!$(event.target).closest(".ui-dialog-titlebar-close")) // Dialog isn't getting focus when dragging (#8063)
                    this.uiDialog.focus();
                }
            });
            // support: IE
            // Use type="button" to prevent enter keypresses in textboxes from closing the
            // dialog in IE (#9312)
            this.uiDialogTitlebarClose = $("<button type='button'></button>").button({
                label: this.options.closeText,
                icons: {
                    primary: "ui-icon-closethick"
                },
                text: false
            }).addClass("ui-dialog-titlebar-close").appendTo(this.uiDialogTitlebar);
            this._on(this.uiDialogTitlebarClose, {
                click: function(event) {
                    event.preventDefault();
                    this.close(event);
                }
            });
            uiDialogTitle = $("<span>").uniqueId().addClass("ui-dialog-title").prependTo(this.uiDialogTitlebar);
            this._title(uiDialogTitle);
            this.uiDialog.attr({
                "aria-labelledby": uiDialogTitle.attr("id")
            });
        },
        _title: function(title) {
            if (!this.options.title) title.html("&#160;");
            title.text(this.options.title);
        },
        _createButtonPane: function() {
            this.uiDialogButtonPane = $("<div>").addClass("ui-dialog-buttonpane ui-widget-content ui-helper-clearfix");
            this.uiButtonSet = $("<div>").addClass("ui-dialog-buttonset").appendTo(this.uiDialogButtonPane);
            this._createButtons();
        },
        _createButtons: function() {
            var that = this, buttons = this.options.buttons;
            // if we already have a button pane, remove it
            this.uiDialogButtonPane.remove();
            this.uiButtonSet.empty();
            if ($.isEmptyObject(buttons) || $.isArray(buttons) && !buttons.length) {
                this.uiDialog.removeClass("ui-dialog-buttons");
                return;
            }
            $.each(buttons, function(name, props) {
                var click, buttonOptions;
                props = $.isFunction(props) ? {
                    click: props,
                    text: name
                } : props;
                // Default to a non-submitting button
                props = $.extend({
                    type: "button"
                }, props);
                // Change the context for the click callback to be the main element
                click = props.click;
                props.click = function() {
                    click.apply(that.element[0], arguments);
                };
                buttonOptions = {
                    icons: props.icons,
                    text: props.showText
                };
                delete props.icons;
                delete props.showText;
                $("<button></button>", props).button(buttonOptions).appendTo(that.uiButtonSet);
            });
            this.uiDialog.addClass("ui-dialog-buttons");
            this.uiDialogButtonPane.appendTo(this.uiDialog);
        },
        _makeDraggable: function() {
            var that = this, options = this.options;
            function filteredUi(ui) {
                return {
                    position: ui.position,
                    offset: ui.offset
                };
            }
            this.uiDialog.draggable({
                cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
                handle: ".ui-dialog-titlebar",
                containment: "document",
                start: function(event, ui) {
                    $(this).addClass("ui-dialog-dragging");
                    that._blockFrames();
                    that._trigger("dragStart", event, filteredUi(ui));
                },
                drag: function(event, ui) {
                    that._trigger("drag", event, filteredUi(ui));
                },
                stop: function(event, ui) {
                    var left = ui.offset.left - that.document.scrollLeft(), top = ui.offset.top - that.document.scrollTop();
                    options.position = {
                        my: "left top",
                        at: "left" + (left >= 0 ? "+" : "") + left + " " + "top" + (top >= 0 ? "+" : "") + top,
                        of: that.window
                    };
                    $(this).removeClass("ui-dialog-dragging");
                    that._unblockFrames();
                    that._trigger("dragStop", event, filteredUi(ui));
                }
            });
        },
        _makeResizable: function() {
            var that = this, options = this.options, handles = options.resizable, // .ui-resizable has position: relative defined in the stylesheet
            // but dialogs have to use absolute or fixed positioning
            position = this.uiDialog.css("position"), resizeHandles = typeof handles === "string" ? handles : "n,e,s,w,se,sw,ne,nw";
            function filteredUi(ui) {
                return {
                    originalPosition: ui.originalPosition,
                    originalSize: ui.originalSize,
                    position: ui.position,
                    size: ui.size
                };
            }
            this.uiDialog.resizable({
                cancel: ".ui-dialog-content",
                containment: "document",
                alsoResize: this.element,
                maxWidth: options.maxWidth,
                maxHeight: options.maxHeight,
                minWidth: options.minWidth,
                minHeight: this._minHeight(),
                handles: resizeHandles,
                start: function(event, ui) {
                    $(this).addClass("ui-dialog-resizing");
                    that._blockFrames();
                    that._trigger("resizeStart", event, filteredUi(ui));
                },
                resize: function(event, ui) {
                    that._trigger("resize", event, filteredUi(ui));
                },
                stop: function(event, ui) {
                    var offset = that.uiDialog.offset(), left = offset.left - that.document.scrollLeft(), top = offset.top - that.document.scrollTop();
                    options.height = that.uiDialog.height();
                    options.width = that.uiDialog.width();
                    options.position = {
                        my: "left top",
                        at: "left" + (left >= 0 ? "+" : "") + left + " " + "top" + (top >= 0 ? "+" : "") + top,
                        of: that.window
                    };
                    $(this).removeClass("ui-dialog-resizing");
                    that._unblockFrames();
                    that._trigger("resizeStop", event, filteredUi(ui));
                }
            }).css("position", position);
        },
        _trackFocus: function() {
            this._on(this.widget(), {
                focusin: function(event) {
                    this._makeFocusTarget();
                    this._focusedElement = $(event.target);
                }
            });
        },
        _makeFocusTarget: function() {
            this._untrackInstance();
            this._trackingInstances().unshift(this);
        },
        _untrackInstance: function() {
            var instances = this._trackingInstances(), exists = $.inArray(this, instances);
            if (exists !== -1) instances.splice(exists, 1);
        },
        _trackingInstances: function() {
            var instances = this.document.data("ui-dialog-instances");
            if (!instances) {
                instances = [];
                this.document.data("ui-dialog-instances", instances);
            }
            return instances;
        },
        _minHeight: function() {
            var options = this.options;
            return options.height === "auto" ? options.minHeight : Math.min(options.minHeight, options.height);
        },
        _position: function() {
            // Need to show the dialog to get the actual offset in the position plugin
            var isVisible = this.uiDialog.is(":visible");
            if (!isVisible) this.uiDialog.show();
            this.uiDialog.position(this.options.position);
            if (!isVisible) this.uiDialog.hide();
        },
        _setOptions: function(options) {
            var that = this, resize = false, resizableOptions = {};
            $.each(options, function(key, value) {
                that._setOption(key, value);
                if (key in that.sizeRelatedOptions) resize = true;
                if (key in that.resizableRelatedOptions) resizableOptions[key] = value;
            });
            if (resize) {
                this._size();
                this._position();
            }
            if (this.uiDialog.is(":data(ui-resizable)")) this.uiDialog.resizable("option", resizableOptions);
        },
        _setOption: function(key, value) {
            var isDraggable, isResizable, uiDialog = this.uiDialog;
            if (key === "dialogClass") uiDialog.removeClass(this.options.dialogClass).addClass(value);
            if (key === "disabled") return;
            this._super(key, value);
            if (key === "appendTo") this.uiDialog.appendTo(this._appendTo());
            if (key === "buttons") this._createButtons();
            if (key === "closeText") this.uiDialogTitlebarClose.button({
                // Ensure that we always pass a string
                label: "" + value
            });
            if (key === "draggable") {
                isDraggable = uiDialog.is(":data(ui-draggable)");
                if (isDraggable && !value) uiDialog.draggable("destroy");
                if (!isDraggable && value) this._makeDraggable();
            }
            if (key === "position") this._position();
            if (key === "resizable") {
                // currently resizable, becoming non-resizable
                isResizable = uiDialog.is(":data(ui-resizable)");
                if (isResizable && !value) uiDialog.resizable("destroy");
                // currently resizable, changing handles
                if (isResizable && typeof value === "string") uiDialog.resizable("option", "handles", value);
                // currently non-resizable, becoming resizable
                if (!isResizable && value !== false) this._makeResizable();
            }
            if (key === "title") this._title(this.uiDialogTitlebar.find(".ui-dialog-title"));
        },
        _size: function() {
            // If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
            // divs will both have width and height set, so we need to reset them
            var nonContentHeight, minContentHeight, maxContentHeight, options = this.options;
            // Reset content sizing
            this.element.show().css({
                width: "auto",
                minHeight: 0,
                maxHeight: "none",
                height: 0
            });
            if (options.minWidth > options.width) options.width = options.minWidth;
            // reset wrapper sizing
            // determine the height of all the non-content elements
            nonContentHeight = this.uiDialog.css({
                height: "auto",
                width: options.width
            }).outerHeight();
            minContentHeight = Math.max(0, options.minHeight - nonContentHeight);
            maxContentHeight = typeof options.maxHeight === "number" ? Math.max(0, options.maxHeight - nonContentHeight) : "none";
            if (options.height === "auto") this.element.css({
                minHeight: minContentHeight,
                maxHeight: maxContentHeight,
                height: "auto"
            });
            else this.element.height(Math.max(0, options.height - nonContentHeight));
            if (this.uiDialog.is(":data(ui-resizable)")) this.uiDialog.resizable("option", "minHeight", this._minHeight());
        },
        _blockFrames: function() {
            this.iframeBlocks = this.document.find("iframe").map(function() {
                var iframe = $(this);
                return $("<div>").css({
                    position: "absolute",
                    width: iframe.outerWidth(),
                    height: iframe.outerHeight()
                }).appendTo(iframe.parent()).offset(iframe.offset())[0];
            });
        },
        _unblockFrames: function() {
            if (this.iframeBlocks) {
                this.iframeBlocks.remove();
                delete this.iframeBlocks;
            }
        },
        _allowInteraction: function(event) {
            if ($(event.target).closest(".ui-dialog").length) return true;
            // TODO: Remove hack when datepicker implements
            // the .ui-front logic (#8989)
            return !!$(event.target).closest(".ui-datepicker").length;
        },
        _createOverlay: function() {
            if (!this.options.modal) return;
            // We use a delay in case the overlay is created from an
            // event that we're going to be cancelling (#2804)
            var isOpening = true;
            this._delay(function() {
                isOpening = false;
            });
            if (!this.document.data("ui-dialog-overlays")) // Prevent use of anchors and inputs
            // Using _on() for an event handler shared across many instances is
            // safe because the dialogs stack and must be closed in reverse order
            this._on(this.document, {
                focusin: function(event) {
                    if (isOpening) return;
                    if (!this._allowInteraction(event)) {
                        event.preventDefault();
                        this._trackingInstances()[0]._focusTabbable();
                    }
                }
            });
            this.overlay = $("<div>").addClass("ui-widget-overlay ui-front").appendTo(this._appendTo());
            this._on(this.overlay, {
                mousedown: "_keepFocus"
            });
            this.document.data("ui-dialog-overlays", (this.document.data("ui-dialog-overlays") || 0) + 1);
        },
        _destroyOverlay: function() {
            if (!this.options.modal) return;
            if (this.overlay) {
                var overlays = this.document.data("ui-dialog-overlays") - 1;
                if (!overlays) this.document.unbind("focusin").removeData("ui-dialog-overlays");
                else this.document.data("ui-dialog-overlays", overlays);
                this.overlay.remove();
                this.overlay = null;
            }
        }
    });
    /*!
 * jQuery UI Droppable 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/droppable/
 */ $.widget("ui.droppable", {
        version: "1.11.1",
        widgetEventPrefix: "drop",
        options: {
            accept: "*",
            activeClass: false,
            addClasses: true,
            greedy: false,
            hoverClass: false,
            scope: "default",
            tolerance: "intersect",
            // callbacks
            activate: null,
            deactivate: null,
            drop: null,
            out: null,
            over: null
        },
        _create: function() {
            var proportions, o = this.options, accept = o.accept;
            this.isover = false;
            this.isout = true;
            this.accept = $.isFunction(accept) ? accept : function(d) {
                return d.is(accept);
            };
            this.proportions = function() {
                if (arguments.length) // Store the droppable's proportions
                proportions = arguments[0];
                else // Retrieve or derive the droppable's proportions
                return proportions ? proportions : proportions = {
                    width: this.element[0].offsetWidth,
                    height: this.element[0].offsetHeight
                };
            };
            this._addToManager(o.scope);
            o.addClasses && this.element.addClass("ui-droppable");
        },
        _addToManager: function(scope) {
            // Add the reference and positions to the manager
            $.ui.ddmanager.droppables[scope] = $.ui.ddmanager.droppables[scope] || [];
            $.ui.ddmanager.droppables[scope].push(this);
        },
        _splice: function(drop) {
            var i = 0;
            for(; i < drop.length; i++)if (drop[i] === this) drop.splice(i, 1);
        },
        _destroy: function() {
            var drop = $.ui.ddmanager.droppables[this.options.scope];
            this._splice(drop);
            this.element.removeClass("ui-droppable ui-droppable-disabled");
        },
        _setOption: function(key, value) {
            if (key === "accept") this.accept = $.isFunction(value) ? value : function(d) {
                return d.is(value);
            };
            else if (key === "scope") {
                var drop = $.ui.ddmanager.droppables[this.options.scope];
                this._splice(drop);
                this._addToManager(value);
            }
            this._super(key, value);
        },
        _activate: function(event) {
            var draggable = $.ui.ddmanager.current;
            if (this.options.activeClass) this.element.addClass(this.options.activeClass);
            if (draggable) this._trigger("activate", event, this.ui(draggable));
        },
        _deactivate: function(event) {
            var draggable = $.ui.ddmanager.current;
            if (this.options.activeClass) this.element.removeClass(this.options.activeClass);
            if (draggable) this._trigger("deactivate", event, this.ui(draggable));
        },
        _over: function(event) {
            var draggable = $.ui.ddmanager.current;
            // Bail if draggable and droppable are same element
            if (!draggable || (draggable.currentItem || draggable.element)[0] === this.element[0]) return;
            if (this.accept.call(this.element[0], draggable.currentItem || draggable.element)) {
                if (this.options.hoverClass) this.element.addClass(this.options.hoverClass);
                this._trigger("over", event, this.ui(draggable));
            }
        },
        _out: function(event) {
            var draggable = $.ui.ddmanager.current;
            // Bail if draggable and droppable are same element
            if (!draggable || (draggable.currentItem || draggable.element)[0] === this.element[0]) return;
            if (this.accept.call(this.element[0], draggable.currentItem || draggable.element)) {
                if (this.options.hoverClass) this.element.removeClass(this.options.hoverClass);
                this._trigger("out", event, this.ui(draggable));
            }
        },
        _drop: function(event, custom) {
            var draggable = custom || $.ui.ddmanager.current, childrenIntersection = false;
            // Bail if draggable and droppable are same element
            if (!draggable || (draggable.currentItem || draggable.element)[0] === this.element[0]) return false;
            this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function() {
                var inst = $(this).droppable("instance");
                if (inst.options.greedy && !inst.options.disabled && inst.options.scope === draggable.options.scope && inst.accept.call(inst.element[0], draggable.currentItem || draggable.element) && $.ui.intersect(draggable, $.extend(inst, {
                    offset: inst.element.offset()
                }), inst.options.tolerance, event)) {
                    childrenIntersection = true;
                    return false;
                }
            });
            if (childrenIntersection) return false;
            if (this.accept.call(this.element[0], draggable.currentItem || draggable.element)) {
                if (this.options.activeClass) this.element.removeClass(this.options.activeClass);
                if (this.options.hoverClass) this.element.removeClass(this.options.hoverClass);
                this._trigger("drop", event, this.ui(draggable));
                return this.element;
            }
            return false;
        },
        ui: function(c) {
            return {
                draggable: c.currentItem || c.element,
                helper: c.helper,
                position: c.position,
                offset: c.positionAbs
            };
        }
    });
    $.ui.intersect = function() {
        function isOverAxis(x, reference, size) {
            return x >= reference && x < reference + size;
        }
        return function(draggable, droppable, toleranceMode, event) {
            if (!droppable.offset) return false;
            var x1 = (draggable.positionAbs || draggable.position.absolute).left, y1 = (draggable.positionAbs || draggable.position.absolute).top, x2 = x1 + draggable.helperProportions.width, y2 = y1 + draggable.helperProportions.height, l = droppable.offset.left, t = droppable.offset.top, r = l + droppable.proportions().width, b = t + droppable.proportions().height;
            switch(toleranceMode){
                case "fit":
                    return l <= x1 && x2 <= r && t <= y1 && y2 <= b;
                case "intersect":
                    return l < x1 + draggable.helperProportions.width / 2 && // Right Half
                    x2 - draggable.helperProportions.width / 2 < r && // Left Half
                    t < y1 + draggable.helperProportions.height / 2 && // Bottom Half
                    y2 - draggable.helperProportions.height / 2 < b; // Top Half
                case "pointer":
                    return isOverAxis(event.pageY, t, droppable.proportions().height) && isOverAxis(event.pageX, l, droppable.proportions().width);
                case "touch":
                    return (y1 >= t && y1 <= b || // Top edge touching
                    y2 >= t && y2 <= b || // Bottom edge touching
                    y1 < t && y2 > b // Surrounded vertically
                    ) && (x1 >= l && x1 <= r || // Left edge touching
                    x2 >= l && x2 <= r || // Right edge touching
                    x1 < l && x2 > r // Surrounded horizontally
                    );
                default:
                    return false;
            }
        };
    }();
    /*
	This manager tracks offsets of draggables and droppables
*/ $.ui.ddmanager = {
        current: null,
        droppables: {
            "default": []
        },
        prepareOffsets: function(t, event) {
            var i, j, m = $.ui.ddmanager.droppables[t.options.scope] || [], type = event ? event.type : null, list = (t.currentItem || t.element).find(":data(ui-droppable)").addBack();
            droppablesLoop: for(i = 0; i < m.length; i++){
                // No disabled and non-accepted
                if (m[i].options.disabled || t && !m[i].accept.call(m[i].element[0], t.currentItem || t.element)) continue;
                // Filter out elements in the current dragged item
                for(j = 0; j < list.length; j++)if (list[j] === m[i].element[0]) {
                    m[i].proportions().height = 0;
                    continue droppablesLoop;
                }
                m[i].visible = m[i].element.css("display") !== "none";
                if (!m[i].visible) continue;
                // Activate the droppable if used directly from draggables
                if (type === "mousedown") m[i]._activate.call(m[i], event);
                m[i].offset = m[i].element.offset();
                m[i].proportions({
                    width: m[i].element[0].offsetWidth,
                    height: m[i].element[0].offsetHeight
                });
            }
        },
        drop: function(draggable, event) {
            var dropped = false;
            // Create a copy of the droppables in case the list changes during the drop (#9116)
            $.each(($.ui.ddmanager.droppables[draggable.options.scope] || []).slice(), function() {
                if (!this.options) return;
                if (!this.options.disabled && this.visible && $.ui.intersect(draggable, this, this.options.tolerance, event)) dropped = this._drop.call(this, event) || dropped;
                if (!this.options.disabled && this.visible && this.accept.call(this.element[0], draggable.currentItem || draggable.element)) {
                    this.isout = true;
                    this.isover = false;
                    this._deactivate.call(this, event);
                }
            });
            return dropped;
        },
        dragStart: function(draggable, event) {
            // Listen for scrolling so that if the dragging causes scrolling the position of the droppables can be recalculated (see #5003)
            draggable.element.parentsUntil("body").bind("scroll.droppable", function() {
                if (!draggable.options.refreshPositions) $.ui.ddmanager.prepareOffsets(draggable, event);
            });
        },
        drag: function(draggable, event) {
            // If you have a highly dynamic page, you might try this option. It renders positions every time you move the mouse.
            if (draggable.options.refreshPositions) $.ui.ddmanager.prepareOffsets(draggable, event);
            // Run through all droppables and check their positions based on specific tolerance options
            $.each($.ui.ddmanager.droppables[draggable.options.scope] || [], function() {
                if (this.options.disabled || this.greedyChild || !this.visible) return;
                var parentInstance, scope, parent, intersects = $.ui.intersect(draggable, this, this.options.tolerance, event), c = !intersects && this.isover ? "isout" : intersects && !this.isover ? "isover" : null;
                if (!c) return;
                if (this.options.greedy) {
                    // find droppable parents with same scope
                    scope = this.options.scope;
                    parent = this.element.parents(":data(ui-droppable)").filter(function() {
                        return $(this).droppable("instance").options.scope === scope;
                    });
                    if (parent.length) {
                        parentInstance = $(parent[0]).droppable("instance");
                        parentInstance.greedyChild = c === "isover";
                    }
                }
                // we just moved into a greedy child
                if (parentInstance && c === "isover") {
                    parentInstance.isover = false;
                    parentInstance.isout = true;
                    parentInstance._out.call(parentInstance, event);
                }
                this[c] = true;
                this[c === "isout" ? "isover" : "isout"] = false;
                this[c === "isover" ? "_over" : "_out"].call(this, event);
                // we just moved out of a greedy child
                if (parentInstance && c === "isout") {
                    parentInstance.isout = false;
                    parentInstance.isover = true;
                    parentInstance._over.call(parentInstance, event);
                }
            });
        },
        dragStop: function(draggable, event) {
            draggable.element.parentsUntil("body").unbind("scroll.droppable");
            // Call prepareOffsets one final time since IE does not fire return scroll events when overflow was caused by drag (see #5003)
            if (!draggable.options.refreshPositions) $.ui.ddmanager.prepareOffsets(draggable, event);
        }
    };
    var droppable = $.ui.droppable;
    /*!
 * jQuery UI Effects 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/effects-core/
 */ var dataSpace = "ui-effects-", // Create a local jQuery because jQuery Color relies on it and the
    // global may not exist with AMD and a custom build (#10199)
    jQuery1 = $;
    $.effects = {
        effect: {}
    };
    /*!
 * jQuery Color Animations v2.1.2
 * https://github.com/jquery/jquery-color
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * Date: Wed Jan 16 08:47:09 2013 -0600
 */ (function(jQuery1, undefined1) {
        var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor", // plusequals test for += 100 -= 100
        rplusequals = /^([\-+])=\s*(\d+\.?\d*)/, // a set of RE's that can match strings and generate color tuples.
        stringParsers = [
            {
                re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
                parse: function(execResult) {
                    return [
                        execResult[1],
                        execResult[2],
                        execResult[3],
                        execResult[4]
                    ];
                }
            },
            {
                re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
                parse: function(execResult) {
                    return [
                        execResult[1] * 2.55,
                        execResult[2] * 2.55,
                        execResult[3] * 2.55,
                        execResult[4]
                    ];
                }
            },
            {
                // this regex ignores A-F because it's compared against an already lowercased string
                re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
                parse: function(execResult) {
                    return [
                        parseInt(execResult[1], 16),
                        parseInt(execResult[2], 16),
                        parseInt(execResult[3], 16)
                    ];
                }
            },
            {
                // this regex ignores A-F because it's compared against an already lowercased string
                re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
                parse: function(execResult) {
                    return [
                        parseInt(execResult[1] + execResult[1], 16),
                        parseInt(execResult[2] + execResult[2], 16),
                        parseInt(execResult[3] + execResult[3], 16)
                    ];
                }
            },
            {
                re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
                space: "hsla",
                parse: function(execResult) {
                    return [
                        execResult[1],
                        execResult[2] / 100,
                        execResult[3] / 100,
                        execResult[4]
                    ];
                }
            }
        ], // jQuery.Color( )
        color = jQuery1.Color = function(color, green, blue, alpha) {
            return new jQuery1.Color.fn.parse(color, green, blue, alpha);
        }, spaces = {
            rgba: {
                props: {
                    red: {
                        idx: 0,
                        type: "byte"
                    },
                    green: {
                        idx: 1,
                        type: "byte"
                    },
                    blue: {
                        idx: 2,
                        type: "byte"
                    }
                }
            },
            hsla: {
                props: {
                    hue: {
                        idx: 0,
                        type: "degrees"
                    },
                    saturation: {
                        idx: 1,
                        type: "percent"
                    },
                    lightness: {
                        idx: 2,
                        type: "percent"
                    }
                }
            }
        }, propTypes = {
            "byte": {
                floor: true,
                max: 255
            },
            "percent": {
                max: 1
            },
            "degrees": {
                mod: 360,
                floor: true
            }
        }, support = color.support = {}, // element for support tests
        supportElem = jQuery1("<p>")[0], // colors = jQuery.Color.names
        colors, // local aliases of functions called often
        each = jQuery1.each;
        // determine rgba support immediately
        supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
        support.rgba = supportElem.style.backgroundColor.indexOf("rgba") > -1;
        // define cache name and alpha properties
        // for rgba and hsla spaces
        each(spaces, function(spaceName, space) {
            space.cache = "_" + spaceName;
            space.props.alpha = {
                idx: 3,
                type: "percent",
                def: 1
            };
        });
        function clamp(value, prop, allowEmpty) {
            var type = propTypes[prop.type] || {};
            if (value == null) return allowEmpty || !prop.def ? null : prop.def;
            // ~~ is an short way of doing floor for positive numbers
            value = type.floor ? ~~value : parseFloat(value);
            // IE will pass in empty strings as value for alpha,
            // which will hit this case
            if (isNaN(value)) return prop.def;
            if (type.mod) // we add mod before modding to make sure that negatives values
            // get converted properly: -10 -> 350
            return (value + type.mod) % type.mod;
            // for now all property types without mod have min and max
            return 0 > value ? 0 : type.max < value ? type.max : value;
        }
        function stringParse(string) {
            var inst = color(), rgba = inst._rgba = [];
            string = string.toLowerCase();
            each(stringParsers, function(i, parser) {
                var parsed, match = parser.re.exec(string), values = match && parser.parse(match), spaceName = parser.space || "rgba";
                if (values) {
                    parsed = inst[spaceName](values);
                    // if this was an rgba parse the assignment might happen twice
                    // oh well....
                    inst[spaces[spaceName].cache] = parsed[spaces[spaceName].cache];
                    rgba = inst._rgba = parsed._rgba;
                    // exit each( stringParsers ) here because we matched
                    return false;
                }
            });
            // Found a stringParser that handled it
            if (rgba.length) {
                // if this came from a parsed string, force "transparent" when alpha is 0
                // chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
                if (rgba.join() === "0,0,0,0") jQuery1.extend(rgba, colors.transparent);
                return inst;
            }
            // named colors
            return colors[string];
        }
        color.fn = jQuery1.extend(color.prototype, {
            parse: function(red, green, blue, alpha) {
                if (red === undefined1) {
                    this._rgba = [
                        null,
                        null,
                        null,
                        null
                    ];
                    return this;
                }
                if (red.jquery || red.nodeType) {
                    red = jQuery1(red).css(green);
                    green = undefined1;
                }
                var inst = this, type = jQuery1.type(red), rgba = this._rgba = [];
                // more than 1 argument specified - assume ( red, green, blue, alpha )
                if (green !== undefined1) {
                    red = [
                        red,
                        green,
                        blue,
                        alpha
                    ];
                    type = "array";
                }
                if (type === "string") return this.parse(stringParse(red) || colors._default);
                if (type === "array") {
                    each(spaces.rgba.props, function(key, prop) {
                        rgba[prop.idx] = clamp(red[prop.idx], prop);
                    });
                    return this;
                }
                if (type === "object") {
                    if (red instanceof color) each(spaces, function(spaceName, space) {
                        if (red[space.cache]) inst[space.cache] = red[space.cache].slice();
                    });
                    else each(spaces, function(spaceName, space) {
                        var cache = space.cache;
                        each(space.props, function(key, prop) {
                            // if the cache doesn't exist, and we know how to convert
                            if (!inst[cache] && space.to) {
                                // if the value was null, we don't need to copy it
                                // if the key was alpha, we don't need to copy it either
                                if (key === "alpha" || red[key] == null) return;
                                inst[cache] = space.to(inst._rgba);
                            }
                            // this is the only case where we allow nulls for ALL properties.
                            // call clamp with alwaysAllowEmpty
                            inst[cache][prop.idx] = clamp(red[key], prop, true);
                        });
                        // everything defined but alpha?
                        if (inst[cache] && jQuery1.inArray(null, inst[cache].slice(0, 3)) < 0) {
                            // use the default of 1
                            inst[cache][3] = 1;
                            if (space.from) inst._rgba = space.from(inst[cache]);
                        }
                    });
                    return this;
                }
            },
            is: function(compare) {
                var is = color(compare), same = true, inst = this;
                each(spaces, function(_, space) {
                    var localCache, isCache = is[space.cache];
                    if (isCache) {
                        localCache = inst[space.cache] || space.to && space.to(inst._rgba) || [];
                        each(space.props, function(_, prop) {
                            if (isCache[prop.idx] != null) {
                                same = isCache[prop.idx] === localCache[prop.idx];
                                return same;
                            }
                        });
                    }
                    return same;
                });
                return same;
            },
            _space: function() {
                var used = [], inst = this;
                each(spaces, function(spaceName, space) {
                    if (inst[space.cache]) used.push(spaceName);
                });
                return used.pop();
            },
            transition: function(other, distance) {
                var end = color(other), spaceName = end._space(), space = spaces[spaceName], startColor = this.alpha() === 0 ? color("transparent") : this, start = startColor[space.cache] || space.to(startColor._rgba), result = start.slice();
                end = end[space.cache];
                each(space.props, function(key, prop) {
                    var index = prop.idx, startValue = start[index], endValue = end[index], type = propTypes[prop.type] || {};
                    // if null, don't override start value
                    if (endValue === null) return;
                    // if null - use end
                    if (startValue === null) result[index] = endValue;
                    else {
                        if (type.mod) {
                            if (endValue - startValue > type.mod / 2) startValue += type.mod;
                            else if (startValue - endValue > type.mod / 2) startValue -= type.mod;
                        }
                        result[index] = clamp((endValue - startValue) * distance + startValue, prop);
                    }
                });
                return this[spaceName](result);
            },
            blend: function(opaque) {
                // if we are already opaque - return ourself
                if (this._rgba[3] === 1) return this;
                var rgb = this._rgba.slice(), a = rgb.pop(), blend = color(opaque)._rgba;
                return color(jQuery1.map(rgb, function(v, i) {
                    return (1 - a) * blend[i] + a * v;
                }));
            },
            toRgbaString: function() {
                var prefix = "rgba(", rgba = jQuery1.map(this._rgba, function(v, i) {
                    return v == null ? i > 2 ? 1 : 0 : v;
                });
                if (rgba[3] === 1) {
                    rgba.pop();
                    prefix = "rgb(";
                }
                return prefix + rgba.join() + ")";
            },
            toHslaString: function() {
                var prefix = "hsla(", hsla = jQuery1.map(this.hsla(), function(v, i) {
                    if (v == null) v = i > 2 ? 1 : 0;
                    // catch 1 and 2
                    if (i && i < 3) v = Math.round(v * 100) + "%";
                    return v;
                });
                if (hsla[3] === 1) {
                    hsla.pop();
                    prefix = "hsl(";
                }
                return prefix + hsla.join() + ")";
            },
            toHexString: function(includeAlpha) {
                var rgba = this._rgba.slice(), alpha = rgba.pop();
                if (includeAlpha) rgba.push(~~(alpha * 255));
                return "#" + jQuery1.map(rgba, function(v) {
                    // default to 0 when nulls exist
                    v = (v || 0).toString(16);
                    return v.length === 1 ? "0" + v : v;
                }).join("");
            },
            toString: function() {
                return this._rgba[3] === 0 ? "transparent" : this.toRgbaString();
            }
        });
        color.fn.parse.prototype = color.fn;
        // hsla conversions adapted from:
        // https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021
        function hue2rgb(p, q, h) {
            h = (h + 1) % 1;
            if (h * 6 < 1) return p + (q - p) * h * 6;
            if (h * 2 < 1) return q;
            if (h * 3 < 2) return p + (q - p) * (2 / 3 - h) * 6;
            return p;
        }
        spaces.hsla.to = function(rgba) {
            if (rgba[0] == null || rgba[1] == null || rgba[2] == null) return [
                null,
                null,
                null,
                rgba[3]
            ];
            var r = rgba[0] / 255, g = rgba[1] / 255, b = rgba[2] / 255, a = rgba[3], max = Math.max(r, g, b), min = Math.min(r, g, b), diff = max - min, add = max + min, l = add * 0.5, h, s;
            if (min === max) h = 0;
            else if (r === max) h = 60 * (g - b) / diff + 360;
            else if (g === max) h = 60 * (b - r) / diff + 120;
            else h = 60 * (r - g) / diff + 240;
            // chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
            // otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
            if (diff === 0) s = 0;
            else if (l <= 0.5) s = diff / add;
            else s = diff / (2 - add);
            return [
                Math.round(h) % 360,
                s,
                l,
                a == null ? 1 : a
            ];
        };
        spaces.hsla.from = function(hsla) {
            if (hsla[0] == null || hsla[1] == null || hsla[2] == null) return [
                null,
                null,
                null,
                hsla[3]
            ];
            var h = hsla[0] / 360, s = hsla[1], l = hsla[2], a = hsla[3], q = l <= 0.5 ? l * (1 + s) : l + s - l * s, p = 2 * l - q;
            return [
                Math.round(hue2rgb(p, q, h + 1 / 3) * 255),
                Math.round(hue2rgb(p, q, h) * 255),
                Math.round(hue2rgb(p, q, h - 1 / 3) * 255),
                a
            ];
        };
        each(spaces, function(spaceName, space) {
            var props = space.props, cache = space.cache, to = space.to, from = space.from;
            // makes rgba() and hsla()
            color.fn[spaceName] = function(value) {
                // generate a cache for this space if it doesn't exist
                if (to && !this[cache]) this[cache] = to(this._rgba);
                if (value === undefined1) return this[cache].slice();
                var ret, type = jQuery1.type(value), arr = type === "array" || type === "object" ? value : arguments, local = this[cache].slice();
                each(props, function(key, prop) {
                    var val = arr[type === "object" ? key : prop.idx];
                    if (val == null) val = local[prop.idx];
                    local[prop.idx] = clamp(val, prop);
                });
                if (from) {
                    ret = color(from(local));
                    ret[cache] = local;
                    return ret;
                } else return color(local);
            };
            // makes red() green() blue() alpha() hue() saturation() lightness()
            each(props, function(key, prop) {
                // alpha is included in more than one space
                if (color.fn[key]) return;
                color.fn[key] = function(value) {
                    var vtype = jQuery1.type(value), fn = key === "alpha" ? this._hsla ? "hsla" : "rgba" : spaceName, local = this[fn](), cur = local[prop.idx], match;
                    if (vtype === "undefined") return cur;
                    if (vtype === "function") {
                        value = value.call(this, cur);
                        vtype = jQuery1.type(value);
                    }
                    if (value == null && prop.empty) return this;
                    if (vtype === "string") {
                        match = rplusequals.exec(value);
                        if (match) value = cur + parseFloat(match[2]) * (match[1] === "+" ? 1 : -1);
                    }
                    local[prop.idx] = value;
                    return this[fn](local);
                };
            });
        });
        // add cssHook and .fx.step function for each named hook.
        // accept a space separated string of properties
        color.hook = function(hook) {
            var hooks = hook.split(" ");
            each(hooks, function(i, hook) {
                jQuery1.cssHooks[hook] = {
                    set: function(elem, value) {
                        var parsed, curElem, backgroundColor = "";
                        if (value !== "transparent" && (jQuery1.type(value) !== "string" || (parsed = stringParse(value)))) {
                            value = color(parsed || value);
                            if (!support.rgba && value._rgba[3] !== 1) {
                                curElem = hook === "backgroundColor" ? elem.parentNode : elem;
                                while((backgroundColor === "" || backgroundColor === "transparent") && curElem && curElem.style)try {
                                    backgroundColor = jQuery1.css(curElem, "backgroundColor");
                                    curElem = curElem.parentNode;
                                } catch (e) {}
                                value = value.blend(backgroundColor && backgroundColor !== "transparent" ? backgroundColor : "_default");
                            }
                            value = value.toRgbaString();
                        }
                        try {
                            elem.style[hook] = value;
                        } catch (e) {
                        // wrapped to prevent IE from throwing errors on "invalid" values like 'auto' or 'inherit'
                        }
                    }
                };
                jQuery1.fx.step[hook] = function(fx) {
                    if (!fx.colorInit) {
                        fx.start = color(fx.elem, hook);
                        fx.end = color(fx.end);
                        fx.colorInit = true;
                    }
                    jQuery1.cssHooks[hook].set(fx.elem, fx.start.transition(fx.end, fx.pos));
                };
            });
        };
        color.hook(stepHooks);
        jQuery1.cssHooks.borderColor = {
            expand: function(value) {
                var expanded = {};
                each([
                    "Top",
                    "Right",
                    "Bottom",
                    "Left"
                ], function(i, part) {
                    expanded["border" + part + "Color"] = value;
                });
                return expanded;
            }
        };
        // Basic color names only.
        // Usage of any of the other color names requires adding yourself or including
        // jquery.color.svg-names.js.
        colors = jQuery1.Color.names = {
            // 4.1. Basic color keywords
            aqua: "#00ffff",
            black: "#000000",
            blue: "#0000ff",
            fuchsia: "#ff00ff",
            gray: "#808080",
            green: "#008000",
            lime: "#00ff00",
            maroon: "#800000",
            navy: "#000080",
            olive: "#808000",
            purple: "#800080",
            red: "#ff0000",
            silver: "#c0c0c0",
            teal: "#008080",
            white: "#ffffff",
            yellow: "#ffff00",
            // 4.2.3. "transparent" color keyword
            transparent: [
                null,
                null,
                null,
                0
            ],
            _default: "#ffffff"
        };
    })(jQuery1);
    /******************************************************************************/ /****************************** CLASS ANIMATIONS ******************************/ /******************************************************************************/ (function() {
        var classAnimationActions = [
            "add",
            "remove",
            "toggle"
        ], shorthandStyles = {
            border: 1,
            borderBottom: 1,
            borderColor: 1,
            borderLeft: 1,
            borderRight: 1,
            borderTop: 1,
            borderWidth: 1,
            margin: 1,
            padding: 1
        };
        $.each([
            "borderLeftStyle",
            "borderRightStyle",
            "borderBottomStyle",
            "borderTopStyle"
        ], function(_, prop) {
            $.fx.step[prop] = function(fx) {
                if (fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr) {
                    jQuery1.style(fx.elem, prop, fx.end);
                    fx.setAttr = true;
                }
            };
        });
        function getElementStyles(elem) {
            var key, len, style = elem.ownerDocument.defaultView ? elem.ownerDocument.defaultView.getComputedStyle(elem, null) : elem.currentStyle, styles = {};
            if (style && style.length && style[0] && style[style[0]]) {
                len = style.length;
                while(len--){
                    key = style[len];
                    if (typeof style[key] === "string") styles[$.camelCase(key)] = style[key];
                }
            // support: Opera, IE <9
            } else {
                for(key in style)if (typeof style[key] === "string") styles[key] = style[key];
            }
            return styles;
        }
        function styleDifference(oldStyle, newStyle) {
            var diff = {}, name, value;
            for(name in newStyle){
                value = newStyle[name];
                if (oldStyle[name] !== value) {
                    if (!shorthandStyles[name]) {
                        if ($.fx.step[name] || !isNaN(parseFloat(value))) diff[name] = value;
                    }
                }
            }
            return diff;
        }
        // support: jQuery <1.8
        if (!$.fn.addBack) $.fn.addBack = function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        };
        $.effects.animateClass = function(value, duration, easing, callback) {
            var o = $.speed(duration, easing, callback);
            return this.queue(function() {
                var animated = $(this), baseClass = animated.attr("class") || "", applyClassChange, allAnimations = o.children ? animated.find("*").addBack() : animated;
                // map the animated objects to store the original styles.
                allAnimations = allAnimations.map(function() {
                    var el = $(this);
                    return {
                        el: el,
                        start: getElementStyles(this)
                    };
                });
                // apply class change
                applyClassChange = function() {
                    $.each(classAnimationActions, function(i, action) {
                        if (value[action]) animated[action + "Class"](value[action]);
                    });
                };
                applyClassChange();
                // map all animated objects again - calculate new styles and diff
                allAnimations = allAnimations.map(function() {
                    this.end = getElementStyles(this.el[0]);
                    this.diff = styleDifference(this.start, this.end);
                    return this;
                });
                // apply original class
                animated.attr("class", baseClass);
                // map all animated objects again - this time collecting a promise
                allAnimations = allAnimations.map(function() {
                    var styleInfo = this, dfd = $.Deferred(), opts = $.extend({}, o, {
                        queue: false,
                        complete: function() {
                            dfd.resolve(styleInfo);
                        }
                    });
                    this.el.animate(this.diff, opts);
                    return dfd.promise();
                });
                // once all animations have completed:
                $.when.apply($, allAnimations.get()).done(function() {
                    // set the final class
                    applyClassChange();
                    // for each animated element,
                    // clear all css properties that were animated
                    $.each(arguments, function() {
                        var el = this.el;
                        $.each(this.diff, function(key) {
                            el.css(key, "");
                        });
                    });
                    // this is guarnteed to be there if you use jQuery.speed()
                    // it also handles dequeuing the next anim...
                    o.complete.call(animated[0]);
                });
            });
        };
        $.fn.extend({
            addClass: function(orig) {
                return function(classNames, speed, easing, callback) {
                    return speed ? $.effects.animateClass.call(this, {
                        add: classNames
                    }, speed, easing, callback) : orig.apply(this, arguments);
                };
            }($.fn.addClass),
            removeClass: function(orig) {
                return function(classNames, speed, easing, callback) {
                    return arguments.length > 1 ? $.effects.animateClass.call(this, {
                        remove: classNames
                    }, speed, easing, callback) : orig.apply(this, arguments);
                };
            }($.fn.removeClass),
            toggleClass: function(orig) {
                return function(classNames, force, speed, easing, callback) {
                    if (typeof force === "boolean" || force === undefined) {
                        if (!speed) // without speed parameter
                        return orig.apply(this, arguments);
                        else return $.effects.animateClass.call(this, force ? {
                            add: classNames
                        } : {
                            remove: classNames
                        }, speed, easing, callback);
                    } else // without force parameter
                    return $.effects.animateClass.call(this, {
                        toggle: classNames
                    }, force, speed, easing);
                };
            }($.fn.toggleClass),
            switchClass: function(remove, add, speed, easing, callback) {
                return $.effects.animateClass.call(this, {
                    add: add,
                    remove: remove
                }, speed, easing, callback);
            }
        });
    })();
    /******************************************************************************/ /*********************************** EFFECTS **********************************/ /******************************************************************************/ (function() {
        $.extend($.effects, {
            version: "1.11.1",
            // Saves a set of properties in a data storage
            save: function(element, set) {
                for(var i = 0; i < set.length; i++)if (set[i] !== null) element.data(dataSpace + set[i], element[0].style[set[i]]);
            },
            // Restores a set of previously saved properties from a data storage
            restore: function(element, set) {
                var val, i;
                for(i = 0; i < set.length; i++)if (set[i] !== null) {
                    val = element.data(dataSpace + set[i]);
                    // support: jQuery 1.6.2
                    // http://bugs.jquery.com/ticket/9917
                    // jQuery 1.6.2 incorrectly returns undefined for any falsy value.
                    // We can't differentiate between "" and 0 here, so we just assume
                    // empty string since it's likely to be a more common value...
                    if (val === undefined) val = "";
                    element.css(set[i], val);
                }
            },
            setMode: function(el, mode) {
                if (mode === "toggle") mode = el.is(":hidden") ? "show" : "hide";
                return mode;
            },
            // Translates a [top,left] array into a baseline value
            // this should be a little more flexible in the future to handle a string & hash
            getBaseline: function(origin, original) {
                var y, x;
                switch(origin[0]){
                    case "top":
                        y = 0;
                        break;
                    case "middle":
                        y = 0.5;
                        break;
                    case "bottom":
                        y = 1;
                        break;
                    default:
                        y = origin[0] / original.height;
                }
                switch(origin[1]){
                    case "left":
                        x = 0;
                        break;
                    case "center":
                        x = 0.5;
                        break;
                    case "right":
                        x = 1;
                        break;
                    default:
                        x = origin[1] / original.width;
                }
                return {
                    x: x,
                    y: y
                };
            },
            // Wraps the element around a wrapper that copies position properties
            createWrapper: function(element) {
                // if the element is already wrapped, return it
                if (element.parent().is(".ui-effects-wrapper")) return element.parent();
                // wrap the element
                var props = {
                    width: element.outerWidth(true),
                    height: element.outerHeight(true),
                    "float": element.css("float")
                }, wrapper = $("<div></div>").addClass("ui-effects-wrapper").css({
                    fontSize: "100%",
                    background: "transparent",
                    border: "none",
                    margin: 0,
                    padding: 0
                }), // Store the size in case width/height are defined in % - Fixes #5245
                size = {
                    width: element.width(),
                    height: element.height()
                }, active = document.activeElement;
                // support: Firefox
                // Firefox incorrectly exposes anonymous content
                // https://bugzilla.mozilla.org/show_bug.cgi?id=561664
                try {
                    active.id;
                } catch (e) {
                    active = document.body;
                }
                element.wrap(wrapper);
                // Fixes #7595 - Elements lose focus when wrapped.
                if (element[0] === active || $.contains(element[0], active)) $(active).focus();
                wrapper = element.parent(); //Hotfix for jQuery 1.4 since some change in wrap() seems to actually lose the reference to the wrapped element
                // transfer positioning properties to the wrapper
                if (element.css("position") === "static") {
                    wrapper.css({
                        position: "relative"
                    });
                    element.css({
                        position: "relative"
                    });
                } else {
                    $.extend(props, {
                        position: element.css("position"),
                        zIndex: element.css("z-index")
                    });
                    $.each([
                        "top",
                        "left",
                        "bottom",
                        "right"
                    ], function(i, pos) {
                        props[pos] = element.css(pos);
                        if (isNaN(parseInt(props[pos], 10))) props[pos] = "auto";
                    });
                    element.css({
                        position: "relative",
                        top: 0,
                        left: 0,
                        right: "auto",
                        bottom: "auto"
                    });
                }
                element.css(size);
                return wrapper.css(props).show();
            },
            removeWrapper: function(element) {
                var active = document.activeElement;
                if (element.parent().is(".ui-effects-wrapper")) {
                    element.parent().replaceWith(element);
                    // Fixes #7595 - Elements lose focus when wrapped.
                    if (element[0] === active || $.contains(element[0], active)) $(active).focus();
                }
                return element;
            },
            setTransition: function(element, list, factor, value) {
                value = value || {};
                $.each(list, function(i, x) {
                    var unit = element.cssUnit(x);
                    if (unit[0] > 0) value[x] = unit[0] * factor + unit[1];
                });
                return value;
            }
        });
        // return an effect options object for the given parameters:
        function _normalizeArguments(effect, options, speed, callback) {
            // allow passing all options as the first parameter
            if ($.isPlainObject(effect)) {
                options = effect;
                effect = effect.effect;
            }
            // convert to an object
            effect = {
                effect: effect
            };
            // catch (effect, null, ...)
            if (options == null) options = {};
            // catch (effect, callback)
            if ($.isFunction(options)) {
                callback = options;
                speed = null;
                options = {};
            }
            // catch (effect, speed, ?)
            if (typeof options === "number" || $.fx.speeds[options]) {
                callback = speed;
                speed = options;
                options = {};
            }
            // catch (effect, options, callback)
            if ($.isFunction(speed)) {
                callback = speed;
                speed = null;
            }
            // add options to effect
            if (options) $.extend(effect, options);
            speed = speed || options.duration;
            effect.duration = $.fx.off ? 0 : typeof speed === "number" ? speed : speed in $.fx.speeds ? $.fx.speeds[speed] : $.fx.speeds._default;
            effect.complete = callback || options.complete;
            return effect;
        }
        function standardAnimationOption(option) {
            // Valid standard speeds (nothing, number, named speed)
            if (!option || typeof option === "number" || $.fx.speeds[option]) return true;
            // Invalid strings - treat as "normal" speed
            if (typeof option === "string" && !$.effects.effect[option]) return true;
            // Complete callback
            if ($.isFunction(option)) return true;
            // Options hash (but not naming an effect)
            if (typeof option === "object" && !option.effect) return true;
            // Didn't match any standard API
            return false;
        }
        $.fn.extend({
            effect: function() {
                var args = _normalizeArguments.apply(this, arguments), mode = args.mode, queue = args.queue, effectMethod = $.effects.effect[args.effect];
                if ($.fx.off || !effectMethod) {
                    // delegate to the original method (e.g., .show()) if possible
                    if (mode) return this[mode](args.duration, args.complete);
                    else return this.each(function() {
                        if (args.complete) args.complete.call(this);
                    });
                }
                function run(next) {
                    var elem = $(this), complete = args.complete, mode = args.mode;
                    function done() {
                        if ($.isFunction(complete)) complete.call(elem[0]);
                        if ($.isFunction(next)) next();
                    }
                    // If the element already has the correct final state, delegate to
                    // the core methods so the internal tracking of "olddisplay" works.
                    if (elem.is(":hidden") ? mode === "hide" : mode === "show") {
                        elem[mode]();
                        done();
                    } else effectMethod.call(elem[0], args, done);
                }
                return queue === false ? this.each(run) : this.queue(queue || "fx", run);
            },
            show: function(orig) {
                return function(option) {
                    if (standardAnimationOption(option)) return orig.apply(this, arguments);
                    else {
                        var args = _normalizeArguments.apply(this, arguments);
                        args.mode = "show";
                        return this.effect.call(this, args);
                    }
                };
            }($.fn.show),
            hide: function(orig) {
                return function(option) {
                    if (standardAnimationOption(option)) return orig.apply(this, arguments);
                    else {
                        var args = _normalizeArguments.apply(this, arguments);
                        args.mode = "hide";
                        return this.effect.call(this, args);
                    }
                };
            }($.fn.hide),
            toggle: function(orig) {
                return function(option) {
                    if (standardAnimationOption(option) || typeof option === "boolean") return orig.apply(this, arguments);
                    else {
                        var args = _normalizeArguments.apply(this, arguments);
                        args.mode = "toggle";
                        return this.effect.call(this, args);
                    }
                };
            }($.fn.toggle),
            // helper functions
            cssUnit: function(key) {
                var style = this.css(key), val = [];
                $.each([
                    "em",
                    "px",
                    "%",
                    "pt"
                ], function(i, unit) {
                    if (style.indexOf(unit) > 0) val = [
                        parseFloat(style),
                        unit
                    ];
                });
                return val;
            }
        });
    })();
    /******************************************************************************/ /*********************************** EASING ***********************************/ /******************************************************************************/ (function() {
        // based on easing equations from Robert Penner (http://www.robertpenner.com/easing)
        var baseEasings = {};
        $.each([
            "Quad",
            "Cubic",
            "Quart",
            "Quint",
            "Expo"
        ], function(i, name) {
            baseEasings[name] = function(p) {
                return Math.pow(p, i + 2);
            };
        });
        $.extend(baseEasings, {
            Sine: function(p) {
                return 1 - Math.cos(p * Math.PI / 2);
            },
            Circ: function(p) {
                return 1 - Math.sqrt(1 - p * p);
            },
            Elastic: function(p) {
                return p === 0 || p === 1 ? p : -Math.pow(2, 8 * (p - 1)) * Math.sin(((p - 1) * 80 - 7.5) * Math.PI / 15);
            },
            Back: function(p) {
                return p * p * (3 * p - 2);
            },
            Bounce: function(p) {
                var pow2, bounce = 4;
                while(p < ((pow2 = Math.pow(2, --bounce)) - 1) / 11);
                return 1 / Math.pow(4, 3 - bounce) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - p, 2);
            }
        });
        $.each(baseEasings, function(name, easeIn) {
            $.easing["easeIn" + name] = easeIn;
            $.easing["easeOut" + name] = function(p) {
                return 1 - easeIn(1 - p);
            };
            $.easing["easeInOut" + name] = function(p) {
                return p < 0.5 ? easeIn(p * 2) / 2 : 1 - easeIn(p * -2 + 2) / 2;
            };
        });
    })();
    var effect = $.effects;
    /*!
 * jQuery UI Effects Blind 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/blind-effect/
 */ var effectBlind = $.effects.effect.blind = function(o, done) {
        // Create element
        var el = $(this), rvertical = /up|down|vertical/, rpositivemotion = /up|left|vertical|horizontal/, props = [
            "position",
            "top",
            "bottom",
            "left",
            "right",
            "height",
            "width"
        ], mode = $.effects.setMode(el, o.mode || "hide"), direction = o.direction || "up", vertical = rvertical.test(direction), ref = vertical ? "height" : "width", ref2 = vertical ? "top" : "left", motion = rpositivemotion.test(direction), animation = {}, show = mode === "show", wrapper, distance, margin;
        // if already wrapped, the wrapper's properties are my property. #6245
        if (el.parent().is(".ui-effects-wrapper")) $.effects.save(el.parent(), props);
        else $.effects.save(el, props);
        el.show();
        wrapper = $.effects.createWrapper(el).css({
            overflow: "hidden"
        });
        distance = wrapper[ref]();
        margin = parseFloat(wrapper.css(ref2)) || 0;
        animation[ref] = show ? distance : 0;
        if (!motion) {
            el.css(vertical ? "bottom" : "right", 0).css(vertical ? "top" : "left", "auto").css({
                position: "absolute"
            });
            animation[ref2] = show ? margin : distance + margin;
        }
        // start at 0 if we are showing
        if (show) {
            wrapper.css(ref, 0);
            if (!motion) wrapper.css(ref2, margin + distance);
        }
        // Animate
        wrapper.animate(animation, {
            duration: o.duration,
            easing: o.easing,
            queue: false,
            complete: function() {
                if (mode === "hide") el.hide();
                $.effects.restore(el, props);
                $.effects.removeWrapper(el);
                done();
            }
        });
    };
    /*!
 * jQuery UI Effects Bounce 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/bounce-effect/
 */ var effectBounce = $.effects.effect.bounce = function(o, done) {
        var el = $(this), props = [
            "position",
            "top",
            "bottom",
            "left",
            "right",
            "height",
            "width"
        ], // defaults:
        mode = $.effects.setMode(el, o.mode || "effect"), hide = mode === "hide", show = mode === "show", direction = o.direction || "up", distance = o.distance, times = o.times || 5, // number of internal animations
        anims = times * 2 + (show || hide ? 1 : 0), speed = o.duration / anims, easing = o.easing, // utility:
        ref = direction === "up" || direction === "down" ? "top" : "left", motion = direction === "up" || direction === "left", i, upAnim, downAnim, // we will need to re-assemble the queue to stack our animations in place
        queue = el.queue(), queuelen = queue.length;
        // Avoid touching opacity to prevent clearType and PNG issues in IE
        if (show || hide) props.push("opacity");
        $.effects.save(el, props);
        el.show();
        $.effects.createWrapper(el); // Create Wrapper
        // default distance for the BIGGEST bounce is the outer Distance / 3
        if (!distance) distance = el[ref === "top" ? "outerHeight" : "outerWidth"]() / 3;
        if (show) {
            downAnim = {
                opacity: 1
            };
            downAnim[ref] = 0;
            // if we are showing, force opacity 0 and set the initial position
            // then do the "first" animation
            el.css("opacity", 0).css(ref, motion ? -distance * 2 : distance * 2).animate(downAnim, speed, easing);
        }
        // start at the smallest distance if we are hiding
        if (hide) distance = distance / Math.pow(2, times - 1);
        downAnim = {};
        downAnim[ref] = 0;
        // Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
        for(i = 0; i < times; i++){
            upAnim = {};
            upAnim[ref] = (motion ? "-=" : "+=") + distance;
            el.animate(upAnim, speed, easing).animate(downAnim, speed, easing);
            distance = hide ? distance * 2 : distance / 2;
        }
        // Last Bounce when Hiding
        if (hide) {
            upAnim = {
                opacity: 0
            };
            upAnim[ref] = (motion ? "-=" : "+=") + distance;
            el.animate(upAnim, speed, easing);
        }
        el.queue(function() {
            if (hide) el.hide();
            $.effects.restore(el, props);
            $.effects.removeWrapper(el);
            done();
        });
        // inject all the animations we just queued to be first in line (after "inprogress")
        if (queuelen > 1) queue.splice.apply(queue, [
            1,
            0
        ].concat(queue.splice(queuelen, anims + 1)));
        el.dequeue();
    };
    /*!
 * jQuery UI Effects Clip 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/clip-effect/
 */ var effectClip = $.effects.effect.clip = function(o, done) {
        // Create element
        var el = $(this), props = [
            "position",
            "top",
            "bottom",
            "left",
            "right",
            "height",
            "width"
        ], mode = $.effects.setMode(el, o.mode || "hide"), show = mode === "show", direction = o.direction || "vertical", vert = direction === "vertical", size = vert ? "height" : "width", position = vert ? "top" : "left", animation = {}, wrapper, animate, distance;
        // Save & Show
        $.effects.save(el, props);
        el.show();
        // Create Wrapper
        wrapper = $.effects.createWrapper(el).css({
            overflow: "hidden"
        });
        animate = el[0].tagName === "IMG" ? wrapper : el;
        distance = animate[size]();
        // Shift
        if (show) {
            animate.css(size, 0);
            animate.css(position, distance / 2);
        }
        // Create Animation Object:
        animation[size] = show ? distance : 0;
        animation[position] = show ? 0 : distance / 2;
        // Animate
        animate.animate(animation, {
            queue: false,
            duration: o.duration,
            easing: o.easing,
            complete: function() {
                if (!show) el.hide();
                $.effects.restore(el, props);
                $.effects.removeWrapper(el);
                done();
            }
        });
    };
    /*!
 * jQuery UI Effects Drop 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/drop-effect/
 */ var effectDrop = $.effects.effect.drop = function(o, done) {
        var el = $(this), props = [
            "position",
            "top",
            "bottom",
            "left",
            "right",
            "opacity",
            "height",
            "width"
        ], mode = $.effects.setMode(el, o.mode || "hide"), show = mode === "show", direction = o.direction || "left", ref = direction === "up" || direction === "down" ? "top" : "left", motion = direction === "up" || direction === "left" ? "pos" : "neg", animation = {
            opacity: show ? 1 : 0
        }, distance;
        // Adjust
        $.effects.save(el, props);
        el.show();
        $.effects.createWrapper(el);
        distance = o.distance || el[ref === "top" ? "outerHeight" : "outerWidth"](true) / 2;
        if (show) el.css("opacity", 0).css(ref, motion === "pos" ? -distance : distance);
        // Animation
        animation[ref] = (show ? motion === "pos" ? "+=" : "-=" : motion === "pos" ? "-=" : "+=") + distance;
        // Animate
        el.animate(animation, {
            queue: false,
            duration: o.duration,
            easing: o.easing,
            complete: function() {
                if (mode === "hide") el.hide();
                $.effects.restore(el, props);
                $.effects.removeWrapper(el);
                done();
            }
        });
    };
    /*!
 * jQuery UI Effects Explode 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/explode-effect/
 */ var effectExplode = $.effects.effect.explode = function(o, done) {
        var rows = o.pieces ? Math.round(Math.sqrt(o.pieces)) : 3, cells = rows, el = $(this), mode = $.effects.setMode(el, o.mode || "hide"), show = mode === "show", // show and then visibility:hidden the element before calculating offset
        offset = el.show().css("visibility", "hidden").offset(), // width and height of a piece
        width = Math.ceil(el.outerWidth() / cells), height = Math.ceil(el.outerHeight() / rows), pieces = [], // loop
        i, j, left, top, mx, my;
        // children animate complete:
        function childComplete() {
            pieces.push(this);
            if (pieces.length === rows * cells) animComplete();
        }
        // clone the element for each row and cell.
        for(i = 0; i < rows; i++){
            top = offset.top + i * height;
            my = i - (rows - 1) / 2;
            for(j = 0; j < cells; j++){
                left = offset.left + j * width;
                mx = j - (cells - 1) / 2;
                // Create a clone of the now hidden main element that will be absolute positioned
                // within a wrapper div off the -left and -top equal to size of our pieces
                el.clone().appendTo("body").wrap("<div></div>").css({
                    position: "absolute",
                    visibility: "visible",
                    left: -j * width,
                    top: -i * height
                })// select the wrapper - make it overflow: hidden and absolute positioned based on
                // where the original was located +left and +top equal to the size of pieces
                .parent().addClass("ui-effects-explode").css({
                    position: "absolute",
                    overflow: "hidden",
                    width: width,
                    height: height,
                    left: left + (show ? mx * width : 0),
                    top: top + (show ? my * height : 0),
                    opacity: show ? 0 : 1
                }).animate({
                    left: left + (show ? 0 : mx * width),
                    top: top + (show ? 0 : my * height),
                    opacity: show ? 1 : 0
                }, o.duration || 500, o.easing, childComplete);
            }
        }
        function animComplete() {
            el.css({
                visibility: "visible"
            });
            $(pieces).remove();
            if (!show) el.hide();
            done();
        }
    };
    /*!
 * jQuery UI Effects Fade 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/fade-effect/
 */ var effectFade = $.effects.effect.fade = function(o, done) {
        var el = $(this), mode = $.effects.setMode(el, o.mode || "toggle");
        el.animate({
            opacity: mode
        }, {
            queue: false,
            duration: o.duration,
            easing: o.easing,
            complete: done
        });
    };
    /*!
 * jQuery UI Effects Fold 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/fold-effect/
 */ var effectFold = $.effects.effect.fold = function(o, done) {
        // Create element
        var el = $(this), props = [
            "position",
            "top",
            "bottom",
            "left",
            "right",
            "height",
            "width"
        ], mode = $.effects.setMode(el, o.mode || "hide"), show = mode === "show", hide = mode === "hide", size = o.size || 15, percent = /([0-9]+)%/.exec(size), horizFirst = !!o.horizFirst, widthFirst = show !== horizFirst, ref = widthFirst ? [
            "width",
            "height"
        ] : [
            "height",
            "width"
        ], duration = o.duration / 2, wrapper, distance, animation1 = {}, animation2 = {};
        $.effects.save(el, props);
        el.show();
        // Create Wrapper
        wrapper = $.effects.createWrapper(el).css({
            overflow: "hidden"
        });
        distance = widthFirst ? [
            wrapper.width(),
            wrapper.height()
        ] : [
            wrapper.height(),
            wrapper.width()
        ];
        if (percent) size = parseInt(percent[1], 10) / 100 * distance[hide ? 0 : 1];
        if (show) wrapper.css(horizFirst ? {
            height: 0,
            width: size
        } : {
            height: size,
            width: 0
        });
        // Animation
        animation1[ref[0]] = show ? distance[0] : size;
        animation2[ref[1]] = show ? distance[1] : 0;
        // Animate
        wrapper.animate(animation1, duration, o.easing).animate(animation2, duration, o.easing, function() {
            if (hide) el.hide();
            $.effects.restore(el, props);
            $.effects.removeWrapper(el);
            done();
        });
    };
    /*!
 * jQuery UI Effects Highlight 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/highlight-effect/
 */ var effectHighlight = $.effects.effect.highlight = function(o, done) {
        var elem = $(this), props = [
            "backgroundImage",
            "backgroundColor",
            "opacity"
        ], mode = $.effects.setMode(elem, o.mode || "show"), animation = {
            backgroundColor: elem.css("backgroundColor")
        };
        if (mode === "hide") animation.opacity = 0;
        $.effects.save(elem, props);
        elem.show().css({
            backgroundImage: "none",
            backgroundColor: o.color || "#ffff99"
        }).animate(animation, {
            queue: false,
            duration: o.duration,
            easing: o.easing,
            complete: function() {
                if (mode === "hide") elem.hide();
                $.effects.restore(elem, props);
                done();
            }
        });
    };
    /*!
 * jQuery UI Effects Size 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/size-effect/
 */ var effectSize = $.effects.effect.size = function(o, done) {
        // Create element
        var original, baseline, factor, el = $(this), props0 = [
            "position",
            "top",
            "bottom",
            "left",
            "right",
            "width",
            "height",
            "overflow",
            "opacity"
        ], // Always restore
        props1 = [
            "position",
            "top",
            "bottom",
            "left",
            "right",
            "overflow",
            "opacity"
        ], // Copy for children
        props2 = [
            "width",
            "height",
            "overflow"
        ], cProps = [
            "fontSize"
        ], vProps = [
            "borderTopWidth",
            "borderBottomWidth",
            "paddingTop",
            "paddingBottom"
        ], hProps = [
            "borderLeftWidth",
            "borderRightWidth",
            "paddingLeft",
            "paddingRight"
        ], // Set options
        mode = $.effects.setMode(el, o.mode || "effect"), restore = o.restore || mode !== "effect", scale = o.scale || "both", origin = o.origin || [
            "middle",
            "center"
        ], position = el.css("position"), props = restore ? props0 : props1, zero = {
            height: 0,
            width: 0,
            outerHeight: 0,
            outerWidth: 0
        };
        if (mode === "show") el.show();
        original = {
            height: el.height(),
            width: el.width(),
            outerHeight: el.outerHeight(),
            outerWidth: el.outerWidth()
        };
        if (o.mode === "toggle" && mode === "show") {
            el.from = o.to || zero;
            el.to = o.from || original;
        } else {
            el.from = o.from || (mode === "show" ? zero : original);
            el.to = o.to || (mode === "hide" ? zero : original);
        }
        // Set scaling factor
        factor = {
            from: {
                y: el.from.height / original.height,
                x: el.from.width / original.width
            },
            to: {
                y: el.to.height / original.height,
                x: el.to.width / original.width
            }
        };
        // Scale the css box
        if (scale === "box" || scale === "both") {
            // Vertical props scaling
            if (factor.from.y !== factor.to.y) {
                props = props.concat(vProps);
                el.from = $.effects.setTransition(el, vProps, factor.from.y, el.from);
                el.to = $.effects.setTransition(el, vProps, factor.to.y, el.to);
            }
            // Horizontal props scaling
            if (factor.from.x !== factor.to.x) {
                props = props.concat(hProps);
                el.from = $.effects.setTransition(el, hProps, factor.from.x, el.from);
                el.to = $.effects.setTransition(el, hProps, factor.to.x, el.to);
            }
        }
        // Scale the content
        if (scale === "content" || scale === "both") // Vertical props scaling
        {
            if (factor.from.y !== factor.to.y) {
                props = props.concat(cProps).concat(props2);
                el.from = $.effects.setTransition(el, cProps, factor.from.y, el.from);
                el.to = $.effects.setTransition(el, cProps, factor.to.y, el.to);
            }
        }
        $.effects.save(el, props);
        el.show();
        $.effects.createWrapper(el);
        el.css("overflow", "hidden").css(el.from);
        // Adjust
        if (origin) {
            baseline = $.effects.getBaseline(origin, original);
            el.from.top = (original.outerHeight - el.outerHeight()) * baseline.y;
            el.from.left = (original.outerWidth - el.outerWidth()) * baseline.x;
            el.to.top = (original.outerHeight - el.to.outerHeight) * baseline.y;
            el.to.left = (original.outerWidth - el.to.outerWidth) * baseline.x;
        }
        el.css(el.from); // set top & left
        // Animate
        if (scale === "content" || scale === "both") {
            // Add margins/font-size
            vProps = vProps.concat([
                "marginTop",
                "marginBottom"
            ]).concat(cProps);
            hProps = hProps.concat([
                "marginLeft",
                "marginRight"
            ]);
            props2 = props0.concat(vProps).concat(hProps);
            el.find("*[width]").each(function() {
                var child = $(this), c_original = {
                    height: child.height(),
                    width: child.width(),
                    outerHeight: child.outerHeight(),
                    outerWidth: child.outerWidth()
                };
                if (restore) $.effects.save(child, props2);
                child.from = {
                    height: c_original.height * factor.from.y,
                    width: c_original.width * factor.from.x,
                    outerHeight: c_original.outerHeight * factor.from.y,
                    outerWidth: c_original.outerWidth * factor.from.x
                };
                child.to = {
                    height: c_original.height * factor.to.y,
                    width: c_original.width * factor.to.x,
                    outerHeight: c_original.height * factor.to.y,
                    outerWidth: c_original.width * factor.to.x
                };
                // Vertical props scaling
                if (factor.from.y !== factor.to.y) {
                    child.from = $.effects.setTransition(child, vProps, factor.from.y, child.from);
                    child.to = $.effects.setTransition(child, vProps, factor.to.y, child.to);
                }
                // Horizontal props scaling
                if (factor.from.x !== factor.to.x) {
                    child.from = $.effects.setTransition(child, hProps, factor.from.x, child.from);
                    child.to = $.effects.setTransition(child, hProps, factor.to.x, child.to);
                }
                // Animate children
                child.css(child.from);
                child.animate(child.to, o.duration, o.easing, function() {
                    // Restore children
                    if (restore) $.effects.restore(child, props2);
                });
            });
        }
        // Animate
        el.animate(el.to, {
            queue: false,
            duration: o.duration,
            easing: o.easing,
            complete: function() {
                if (el.to.opacity === 0) el.css("opacity", el.from.opacity);
                if (mode === "hide") el.hide();
                $.effects.restore(el, props);
                if (!restore) {
                    // we need to calculate our new positioning based on the scaling
                    if (position === "static") el.css({
                        position: "relative",
                        top: el.to.top,
                        left: el.to.left
                    });
                    else $.each([
                        "top",
                        "left"
                    ], function(idx, pos) {
                        el.css(pos, function(_, str) {
                            var val = parseInt(str, 10), toRef = idx ? el.to.left : el.to.top;
                            // if original was "auto", recalculate the new value from wrapper
                            if (str === "auto") return toRef + "px";
                            return val + toRef + "px";
                        });
                    });
                }
                $.effects.removeWrapper(el);
                done();
            }
        });
    };
    /*!
 * jQuery UI Effects Scale 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/scale-effect/
 */ var effectScale = $.effects.effect.scale = function(o, done) {
        // Create element
        var el = $(this), options = $.extend(true, {}, o), mode = $.effects.setMode(el, o.mode || "effect"), percent = parseInt(o.percent, 10) || (parseInt(o.percent, 10) === 0 ? 0 : mode === "hide" ? 0 : 100), direction = o.direction || "both", origin = o.origin, original = {
            height: el.height(),
            width: el.width(),
            outerHeight: el.outerHeight(),
            outerWidth: el.outerWidth()
        }, factor = {
            y: direction !== "horizontal" ? percent / 100 : 1,
            x: direction !== "vertical" ? percent / 100 : 1
        };
        // We are going to pass this effect to the size effect:
        options.effect = "size";
        options.queue = false;
        options.complete = done;
        // Set default origin and restore for show/hide
        if (mode !== "effect") {
            options.origin = origin || [
                "middle",
                "center"
            ];
            options.restore = true;
        }
        options.from = o.from || (mode === "show" ? {
            height: 0,
            width: 0,
            outerHeight: 0,
            outerWidth: 0
        } : original);
        options.to = {
            height: original.height * factor.y,
            width: original.width * factor.x,
            outerHeight: original.outerHeight * factor.y,
            outerWidth: original.outerWidth * factor.x
        };
        // Fade option to support puff
        if (options.fade) {
            if (mode === "show") {
                options.from.opacity = 0;
                options.to.opacity = 1;
            }
            if (mode === "hide") {
                options.from.opacity = 1;
                options.to.opacity = 0;
            }
        }
        // Animate
        el.effect(options);
    };
    /*!
 * jQuery UI Effects Puff 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/puff-effect/
 */ var effectPuff = $.effects.effect.puff = function(o, done) {
        var elem = $(this), mode = $.effects.setMode(elem, o.mode || "hide"), hide = mode === "hide", percent = parseInt(o.percent, 10) || 150, factor = percent / 100, original = {
            height: elem.height(),
            width: elem.width(),
            outerHeight: elem.outerHeight(),
            outerWidth: elem.outerWidth()
        };
        $.extend(o, {
            effect: "scale",
            queue: false,
            fade: true,
            mode: mode,
            complete: done,
            percent: hide ? percent : 100,
            from: hide ? original : {
                height: original.height * factor,
                width: original.width * factor,
                outerHeight: original.outerHeight * factor,
                outerWidth: original.outerWidth * factor
            }
        });
        elem.effect(o);
    };
    /*!
 * jQuery UI Effects Pulsate 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/pulsate-effect/
 */ var effectPulsate = $.effects.effect.pulsate = function(o, done) {
        var elem = $(this), mode = $.effects.setMode(elem, o.mode || "show"), show = mode === "show", hide = mode === "hide", showhide = show || mode === "hide", // showing or hiding leaves of the "last" animation
        anims = (o.times || 5) * 2 + (showhide ? 1 : 0), duration = o.duration / anims, animateTo = 0, queue = elem.queue(), queuelen = queue.length, i;
        if (show || !elem.is(":visible")) {
            elem.css("opacity", 0).show();
            animateTo = 1;
        }
        // anims - 1 opacity "toggles"
        for(i = 1; i < anims; i++){
            elem.animate({
                opacity: animateTo
            }, duration, o.easing);
            animateTo = 1 - animateTo;
        }
        elem.animate({
            opacity: animateTo
        }, duration, o.easing);
        elem.queue(function() {
            if (hide) elem.hide();
            done();
        });
        // We just queued up "anims" animations, we need to put them next in the queue
        if (queuelen > 1) queue.splice.apply(queue, [
            1,
            0
        ].concat(queue.splice(queuelen, anims + 1)));
        elem.dequeue();
    };
    /*!
 * jQuery UI Effects Shake 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/shake-effect/
 */ var effectShake = $.effects.effect.shake = function(o, done) {
        var el = $(this), props = [
            "position",
            "top",
            "bottom",
            "left",
            "right",
            "height",
            "width"
        ], mode = $.effects.setMode(el, o.mode || "effect"), direction = o.direction || "left", distance = o.distance || 20, times = o.times || 3, anims = times * 2 + 1, speed = Math.round(o.duration / anims), ref = direction === "up" || direction === "down" ? "top" : "left", positiveMotion = direction === "up" || direction === "left", animation = {}, animation1 = {}, animation2 = {}, i, // we will need to re-assemble the queue to stack our animations in place
        queue = el.queue(), queuelen = queue.length;
        $.effects.save(el, props);
        el.show();
        $.effects.createWrapper(el);
        // Animation
        animation[ref] = (positiveMotion ? "-=" : "+=") + distance;
        animation1[ref] = (positiveMotion ? "+=" : "-=") + distance * 2;
        animation2[ref] = (positiveMotion ? "-=" : "+=") + distance * 2;
        // Animate
        el.animate(animation, speed, o.easing);
        // Shakes
        for(i = 1; i < times; i++)el.animate(animation1, speed, o.easing).animate(animation2, speed, o.easing);
        el.animate(animation1, speed, o.easing).animate(animation, speed / 2, o.easing).queue(function() {
            if (mode === "hide") el.hide();
            $.effects.restore(el, props);
            $.effects.removeWrapper(el);
            done();
        });
        // inject all the animations we just queued to be first in line (after "inprogress")
        if (queuelen > 1) queue.splice.apply(queue, [
            1,
            0
        ].concat(queue.splice(queuelen, anims + 1)));
        el.dequeue();
    };
    /*!
 * jQuery UI Effects Slide 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/slide-effect/
 */ var effectSlide = $.effects.effect.slide = function(o, done) {
        // Create element
        var el = $(this), props = [
            "position",
            "top",
            "bottom",
            "left",
            "right",
            "width",
            "height"
        ], mode = $.effects.setMode(el, o.mode || "show"), show = mode === "show", direction = o.direction || "left", ref = direction === "up" || direction === "down" ? "top" : "left", positiveMotion = direction === "up" || direction === "left", distance, animation = {};
        // Adjust
        $.effects.save(el, props);
        el.show();
        distance = o.distance || el[ref === "top" ? "outerHeight" : "outerWidth"](true);
        $.effects.createWrapper(el).css({
            overflow: "hidden"
        });
        if (show) el.css(ref, positiveMotion ? isNaN(distance) ? "-" + distance : -distance : distance);
        // Animation
        animation[ref] = (show ? positiveMotion ? "+=" : "-=" : positiveMotion ? "-=" : "+=") + distance;
        // Animate
        el.animate(animation, {
            queue: false,
            duration: o.duration,
            easing: o.easing,
            complete: function() {
                if (mode === "hide") el.hide();
                $.effects.restore(el, props);
                $.effects.removeWrapper(el);
                done();
            }
        });
    };
    /*!
 * jQuery UI Effects Transfer 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/transfer-effect/
 */ var effectTransfer = $.effects.effect.transfer = function(o, done) {
        var elem = $(this), target = $(o.to), targetFixed = target.css("position") === "fixed", body = $("body"), fixTop = targetFixed ? body.scrollTop() : 0, fixLeft = targetFixed ? body.scrollLeft() : 0, endPosition = target.offset(), animation = {
            top: endPosition.top - fixTop,
            left: endPosition.left - fixLeft,
            height: target.innerHeight(),
            width: target.innerWidth()
        }, startPosition = elem.offset(), transfer = $("<div class='ui-effects-transfer'></div>").appendTo(document.body).addClass(o.className).css({
            top: startPosition.top - fixTop,
            left: startPosition.left - fixLeft,
            height: elem.innerHeight(),
            width: elem.innerWidth(),
            position: targetFixed ? "fixed" : "absolute"
        }).animate(animation, o.duration, o.easing, function() {
            transfer.remove();
            done();
        });
    };
    /*!
 * jQuery UI Progressbar 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/progressbar/
 */ var progressbar = $.widget("ui.progressbar", {
        version: "1.11.1",
        options: {
            max: 100,
            value: 0,
            change: null,
            complete: null
        },
        min: 0,
        _create: function() {
            // Constrain initial value
            this.oldValue = this.options.value = this._constrainedValue();
            this.element.addClass("ui-progressbar ui-widget ui-widget-content ui-corner-all").attr({
                // Only set static values, aria-valuenow and aria-valuemax are
                // set inside _refreshValue()
                role: "progressbar",
                "aria-valuemin": this.min
            });
            this.valueDiv = $("<div class='ui-progressbar-value ui-widget-header ui-corner-left'></div>").appendTo(this.element);
            this._refreshValue();
        },
        _destroy: function() {
            this.element.removeClass("ui-progressbar ui-widget ui-widget-content ui-corner-all").removeAttr("role").removeAttr("aria-valuemin").removeAttr("aria-valuemax").removeAttr("aria-valuenow");
            this.valueDiv.remove();
        },
        value: function(newValue) {
            if (newValue === undefined) return this.options.value;
            this.options.value = this._constrainedValue(newValue);
            this._refreshValue();
        },
        _constrainedValue: function(newValue) {
            if (newValue === undefined) newValue = this.options.value;
            this.indeterminate = newValue === false;
            // sanitize value
            if (typeof newValue !== "number") newValue = 0;
            return this.indeterminate ? false : Math.min(this.options.max, Math.max(this.min, newValue));
        },
        _setOptions: function(options) {
            // Ensure "value" option is set after other values (like max)
            var value = options.value;
            delete options.value;
            this._super(options);
            this.options.value = this._constrainedValue(value);
            this._refreshValue();
        },
        _setOption: function(key, value) {
            if (key === "max") // Don't allow a max less than min
            value = Math.max(this.min, value);
            if (key === "disabled") this.element.toggleClass("ui-state-disabled", !!value).attr("aria-disabled", value);
            this._super(key, value);
        },
        _percentage: function() {
            return this.indeterminate ? 100 : 100 * (this.options.value - this.min) / (this.options.max - this.min);
        },
        _refreshValue: function() {
            var value = this.options.value, percentage = this._percentage();
            this.valueDiv.toggle(this.indeterminate || value > this.min).toggleClass("ui-corner-right", value === this.options.max).width(percentage.toFixed(0) + "%");
            this.element.toggleClass("ui-progressbar-indeterminate", this.indeterminate);
            if (this.indeterminate) {
                this.element.removeAttr("aria-valuenow");
                if (!this.overlayDiv) this.overlayDiv = $("<div class='ui-progressbar-overlay'></div>").appendTo(this.valueDiv);
            } else {
                this.element.attr({
                    "aria-valuemax": this.options.max,
                    "aria-valuenow": value
                });
                if (this.overlayDiv) {
                    this.overlayDiv.remove();
                    this.overlayDiv = null;
                }
            }
            if (this.oldValue !== value) {
                this.oldValue = value;
                this._trigger("change");
            }
            if (value === this.options.max) this._trigger("complete");
        }
    });
    /*!
 * jQuery UI Selectable 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/selectable/
 */ var selectable = $.widget("ui.selectable", $.ui.mouse, {
        version: "1.11.1",
        options: {
            appendTo: "body",
            autoRefresh: true,
            distance: 0,
            filter: "*",
            tolerance: "touch",
            // callbacks
            selected: null,
            selecting: null,
            start: null,
            stop: null,
            unselected: null,
            unselecting: null
        },
        _create: function() {
            var selectees, that = this;
            this.element.addClass("ui-selectable");
            this.dragged = false;
            // cache selectee children based on filter
            this.refresh = function() {
                selectees = $(that.options.filter, that.element[0]);
                selectees.addClass("ui-selectee");
                selectees.each(function() {
                    var $this = $(this), pos = $this.offset();
                    $.data(this, "selectable-item", {
                        element: this,
                        $element: $this,
                        left: pos.left,
                        top: pos.top,
                        right: pos.left + $this.outerWidth(),
                        bottom: pos.top + $this.outerHeight(),
                        startselected: false,
                        selected: $this.hasClass("ui-selected"),
                        selecting: $this.hasClass("ui-selecting"),
                        unselecting: $this.hasClass("ui-unselecting")
                    });
                });
            };
            this.refresh();
            this.selectees = selectees.addClass("ui-selectee");
            this._mouseInit();
            this.helper = $("<div class='ui-selectable-helper'></div>");
        },
        _destroy: function() {
            this.selectees.removeClass("ui-selectee").removeData("selectable-item");
            this.element.removeClass("ui-selectable ui-selectable-disabled");
            this._mouseDestroy();
        },
        _mouseStart: function(event) {
            var that = this, options = this.options;
            this.opos = [
                event.pageX,
                event.pageY
            ];
            if (this.options.disabled) return;
            this.selectees = $(options.filter, this.element[0]);
            this._trigger("start", event);
            $(options.appendTo).append(this.helper);
            // position helper (lasso)
            this.helper.css({
                "left": event.pageX,
                "top": event.pageY,
                "width": 0,
                "height": 0
            });
            if (options.autoRefresh) this.refresh();
            this.selectees.filter(".ui-selected").each(function() {
                var selectee = $.data(this, "selectable-item");
                selectee.startselected = true;
                if (!event.metaKey && !event.ctrlKey) {
                    selectee.$element.removeClass("ui-selected");
                    selectee.selected = false;
                    selectee.$element.addClass("ui-unselecting");
                    selectee.unselecting = true;
                    // selectable UNSELECTING callback
                    that._trigger("unselecting", event, {
                        unselecting: selectee.element
                    });
                }
            });
            $(event.target).parents().addBack().each(function() {
                var doSelect, selectee = $.data(this, "selectable-item");
                if (selectee) {
                    doSelect = !event.metaKey && !event.ctrlKey || !selectee.$element.hasClass("ui-selected");
                    selectee.$element.removeClass(doSelect ? "ui-unselecting" : "ui-selected").addClass(doSelect ? "ui-selecting" : "ui-unselecting");
                    selectee.unselecting = !doSelect;
                    selectee.selecting = doSelect;
                    selectee.selected = doSelect;
                    // selectable (UN)SELECTING callback
                    if (doSelect) that._trigger("selecting", event, {
                        selecting: selectee.element
                    });
                    else that._trigger("unselecting", event, {
                        unselecting: selectee.element
                    });
                    return false;
                }
            });
        },
        _mouseDrag: function(event) {
            this.dragged = true;
            if (this.options.disabled) return;
            var tmp, that = this, options = this.options, x1 = this.opos[0], y1 = this.opos[1], x2 = event.pageX, y2 = event.pageY;
            if (x1 > x2) {
                tmp = x2;
                x2 = x1;
                x1 = tmp;
            }
            if (y1 > y2) {
                tmp = y2;
                y2 = y1;
                y1 = tmp;
            }
            this.helper.css({
                left: x1,
                top: y1,
                width: x2 - x1,
                height: y2 - y1
            });
            this.selectees.each(function() {
                var selectee = $.data(this, "selectable-item"), hit = false;
                //prevent helper from being selected if appendTo: selectable
                if (!selectee || selectee.element === that.element[0]) return;
                if (options.tolerance === "touch") hit = !(selectee.left > x2 || selectee.right < x1 || selectee.top > y2 || selectee.bottom < y1);
                else if (options.tolerance === "fit") hit = selectee.left > x1 && selectee.right < x2 && selectee.top > y1 && selectee.bottom < y2;
                if (hit) {
                    // SELECT
                    if (selectee.selected) {
                        selectee.$element.removeClass("ui-selected");
                        selectee.selected = false;
                    }
                    if (selectee.unselecting) {
                        selectee.$element.removeClass("ui-unselecting");
                        selectee.unselecting = false;
                    }
                    if (!selectee.selecting) {
                        selectee.$element.addClass("ui-selecting");
                        selectee.selecting = true;
                        // selectable SELECTING callback
                        that._trigger("selecting", event, {
                            selecting: selectee.element
                        });
                    }
                } else {
                    // UNSELECT
                    if (selectee.selecting) {
                        if ((event.metaKey || event.ctrlKey) && selectee.startselected) {
                            selectee.$element.removeClass("ui-selecting");
                            selectee.selecting = false;
                            selectee.$element.addClass("ui-selected");
                            selectee.selected = true;
                        } else {
                            selectee.$element.removeClass("ui-selecting");
                            selectee.selecting = false;
                            if (selectee.startselected) {
                                selectee.$element.addClass("ui-unselecting");
                                selectee.unselecting = true;
                            }
                            // selectable UNSELECTING callback
                            that._trigger("unselecting", event, {
                                unselecting: selectee.element
                            });
                        }
                    }
                    if (selectee.selected) {
                        if (!event.metaKey && !event.ctrlKey && !selectee.startselected) {
                            selectee.$element.removeClass("ui-selected");
                            selectee.selected = false;
                            selectee.$element.addClass("ui-unselecting");
                            selectee.unselecting = true;
                            // selectable UNSELECTING callback
                            that._trigger("unselecting", event, {
                                unselecting: selectee.element
                            });
                        }
                    }
                }
            });
            return false;
        },
        _mouseStop: function(event) {
            var that = this;
            this.dragged = false;
            $(".ui-unselecting", this.element[0]).each(function() {
                var selectee = $.data(this, "selectable-item");
                selectee.$element.removeClass("ui-unselecting");
                selectee.unselecting = false;
                selectee.startselected = false;
                that._trigger("unselected", event, {
                    unselected: selectee.element
                });
            });
            $(".ui-selecting", this.element[0]).each(function() {
                var selectee = $.data(this, "selectable-item");
                selectee.$element.removeClass("ui-selecting").addClass("ui-selected");
                selectee.selecting = false;
                selectee.selected = true;
                selectee.startselected = true;
                that._trigger("selected", event, {
                    selected: selectee.element
                });
            });
            this._trigger("stop", event);
            this.helper.remove();
            return false;
        }
    });
    /*!
 * jQuery UI Selectmenu 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/selectmenu
 */ var selectmenu = $.widget("ui.selectmenu", {
        version: "1.11.1",
        defaultElement: "<select>",
        options: {
            appendTo: null,
            disabled: null,
            icons: {
                button: "ui-icon-triangle-1-s"
            },
            position: {
                my: "left top",
                at: "left bottom",
                collision: "none"
            },
            width: null,
            // callbacks
            change: null,
            close: null,
            focus: null,
            open: null,
            select: null
        },
        _create: function() {
            var selectmenuId = this.element.uniqueId().attr("id");
            this.ids = {
                element: selectmenuId,
                button: selectmenuId + "-button",
                menu: selectmenuId + "-menu"
            };
            this._drawButton();
            this._drawMenu();
            if (this.options.disabled) this.disable();
        },
        _drawButton: function() {
            var that = this, tabindex = this.element.attr("tabindex");
            // Associate existing label with the new button
            this.label = $("label[for='" + this.ids.element + "']").attr("for", this.ids.button);
            this._on(this.label, {
                click: function(event) {
                    this.button.focus();
                    event.preventDefault();
                }
            });
            // Hide original select element
            this.element.hide();
            // Create button
            this.button = $("<span>", {
                "class": "ui-selectmenu-button ui-widget ui-state-default ui-corner-all",
                tabindex: tabindex || this.options.disabled ? -1 : 0,
                id: this.ids.button,
                role: "combobox",
                "aria-expanded": "false",
                "aria-autocomplete": "list",
                "aria-owns": this.ids.menu,
                "aria-haspopup": "true"
            }).insertAfter(this.element);
            $("<span>", {
                "class": "ui-icon " + this.options.icons.button
            }).prependTo(this.button);
            this.buttonText = $("<span>", {
                "class": "ui-selectmenu-text"
            }).appendTo(this.button);
            this._setText(this.buttonText, this.element.find("option:selected").text());
            this._resizeButton();
            this._on(this.button, this._buttonEvents);
            this.button.one("focusin", function() {
                // Delay rendering the menu items until the button receives focus.
                // The menu may have already been rendered via a programmatic open.
                if (!that.menuItems) that._refreshMenu();
            });
            this._hoverable(this.button);
            this._focusable(this.button);
        },
        _drawMenu: function() {
            var that = this;
            // Create menu
            this.menu = $("<ul>", {
                "aria-hidden": "true",
                "aria-labelledby": this.ids.button,
                id: this.ids.menu
            });
            // Wrap menu
            this.menuWrap = $("<div>", {
                "class": "ui-selectmenu-menu ui-front"
            }).append(this.menu).appendTo(this._appendTo());
            // Initialize menu widget
            this.menuInstance = this.menu.menu({
                role: "listbox",
                select: function(event, ui) {
                    event.preventDefault();
                    that._select(ui.item.data("ui-selectmenu-item"), event);
                },
                focus: function(event, ui) {
                    var item = ui.item.data("ui-selectmenu-item");
                    // Prevent inital focus from firing and check if its a newly focused item
                    if (that.focusIndex != null && item.index !== that.focusIndex) {
                        that._trigger("focus", event, {
                            item: item
                        });
                        if (!that.isOpen) that._select(item, event);
                    }
                    that.focusIndex = item.index;
                    that.button.attr("aria-activedescendant", that.menuItems.eq(item.index).attr("id"));
                }
            }).menu("instance");
            // Adjust menu styles to dropdown
            this.menu.addClass("ui-corner-bottom").removeClass("ui-corner-all");
            // Don't close the menu on mouseleave
            this.menuInstance._off(this.menu, "mouseleave");
            // Cancel the menu's collapseAll on document click
            this.menuInstance._closeOnDocumentClick = function() {
                return false;
            };
            // Selects often contain empty items, but never contain dividers
            this.menuInstance._isDivider = function() {
                return false;
            };
        },
        refresh: function() {
            this._refreshMenu();
            this._setText(this.buttonText, this._getSelectedItem().text());
            if (!this.options.width) this._resizeButton();
        },
        _refreshMenu: function() {
            this.menu.empty();
            var item, options = this.element.find("option");
            if (!options.length) return;
            this._parseOptions(options);
            this._renderMenu(this.menu, this.items);
            this.menuInstance.refresh();
            this.menuItems = this.menu.find("li").not(".ui-selectmenu-optgroup");
            item = this._getSelectedItem();
            // Update the menu to have the correct item focused
            this.menuInstance.focus(null, item);
            this._setAria(item.data("ui-selectmenu-item"));
            // Set disabled state
            this._setOption("disabled", this.element.prop("disabled"));
        },
        open: function(event) {
            if (this.options.disabled) return;
            // If this is the first time the menu is being opened, render the items
            if (!this.menuItems) this._refreshMenu();
            else {
                // Menu clears focus on close, reset focus to selected item
                this.menu.find(".ui-state-focus").removeClass("ui-state-focus");
                this.menuInstance.focus(null, this._getSelectedItem());
            }
            this.isOpen = true;
            this._toggleAttr();
            this._resizeMenu();
            this._position();
            this._on(this.document, this._documentClick);
            this._trigger("open", event);
        },
        _position: function() {
            this.menuWrap.position($.extend({
                of: this.button
            }, this.options.position));
        },
        close: function(event) {
            if (!this.isOpen) return;
            this.isOpen = false;
            this._toggleAttr();
            this._off(this.document);
            this._trigger("close", event);
        },
        widget: function() {
            return this.button;
        },
        menuWidget: function() {
            return this.menu;
        },
        _renderMenu: function(ul, items) {
            var that = this, currentOptgroup = "";
            $.each(items, function(index, item) {
                if (item.optgroup !== currentOptgroup) {
                    $("<li>", {
                        "class": "ui-selectmenu-optgroup ui-menu-divider" + (item.element.parent("optgroup").prop("disabled") ? " ui-state-disabled" : ""),
                        text: item.optgroup
                    }).appendTo(ul);
                    currentOptgroup = item.optgroup;
                }
                that._renderItemData(ul, item);
            });
        },
        _renderItemData: function(ul, item) {
            return this._renderItem(ul, item).data("ui-selectmenu-item", item);
        },
        _renderItem: function(ul, item) {
            var li = $("<li>");
            if (item.disabled) li.addClass("ui-state-disabled");
            this._setText(li, item.label);
            return li.appendTo(ul);
        },
        _setText: function(element, value) {
            if (value) element.text(value);
            else element.html("&#160;");
        },
        _move: function(direction, event) {
            var item, next, filter = ".ui-menu-item";
            if (this.isOpen) item = this.menuItems.eq(this.focusIndex);
            else {
                item = this.menuItems.eq(this.element[0].selectedIndex);
                filter += ":not(.ui-state-disabled)";
            }
            if (direction === "first" || direction === "last") next = item[direction === "first" ? "prevAll" : "nextAll"](filter).eq(-1);
            else next = item[direction + "All"](filter).eq(0);
            if (next.length) this.menuInstance.focus(event, next);
        },
        _getSelectedItem: function() {
            return this.menuItems.eq(this.element[0].selectedIndex);
        },
        _toggle: function(event) {
            this[this.isOpen ? "close" : "open"](event);
        },
        _documentClick: {
            mousedown: function(event) {
                if (!this.isOpen) return;
                if (!$(event.target).closest(".ui-selectmenu-menu, #" + this.ids.button).length) this.close(event);
            }
        },
        _buttonEvents: {
            // Prevent text selection from being reset when interacting with the selectmenu (#10144)
            mousedown: function(event) {
                event.preventDefault();
            },
            click: "_toggle",
            keydown: function(event) {
                var preventDefault = true;
                switch(event.keyCode){
                    case $.ui.keyCode.TAB:
                    case $.ui.keyCode.ESCAPE:
                        this.close(event);
                        preventDefault = false;
                        break;
                    case $.ui.keyCode.ENTER:
                        if (this.isOpen) this._selectFocusedItem(event);
                        break;
                    case $.ui.keyCode.UP:
                        if (event.altKey) this._toggle(event);
                        else this._move("prev", event);
                        break;
                    case $.ui.keyCode.DOWN:
                        if (event.altKey) this._toggle(event);
                        else this._move("next", event);
                        break;
                    case $.ui.keyCode.SPACE:
                        if (this.isOpen) this._selectFocusedItem(event);
                        else this._toggle(event);
                        break;
                    case $.ui.keyCode.LEFT:
                        this._move("prev", event);
                        break;
                    case $.ui.keyCode.RIGHT:
                        this._move("next", event);
                        break;
                    case $.ui.keyCode.HOME:
                    case $.ui.keyCode.PAGE_UP:
                        this._move("first", event);
                        break;
                    case $.ui.keyCode.END:
                    case $.ui.keyCode.PAGE_DOWN:
                        this._move("last", event);
                        break;
                    default:
                        this.menu.trigger(event);
                        preventDefault = false;
                }
                if (preventDefault) event.preventDefault();
            }
        },
        _selectFocusedItem: function(event) {
            var item = this.menuItems.eq(this.focusIndex);
            if (!item.hasClass("ui-state-disabled")) this._select(item.data("ui-selectmenu-item"), event);
        },
        _select: function(item, event) {
            var oldIndex = this.element[0].selectedIndex;
            // Change native select element
            this.element[0].selectedIndex = item.index;
            this._setText(this.buttonText, item.label);
            this._setAria(item);
            this._trigger("select", event, {
                item: item
            });
            if (item.index !== oldIndex) this._trigger("change", event, {
                item: item
            });
            this.close(event);
        },
        _setAria: function(item) {
            var id = this.menuItems.eq(item.index).attr("id");
            this.button.attr({
                "aria-labelledby": id,
                "aria-activedescendant": id
            });
            this.menu.attr("aria-activedescendant", id);
        },
        _setOption: function(key, value) {
            if (key === "icons") this.button.find("span.ui-icon").removeClass(this.options.icons.button).addClass(value.button);
            this._super(key, value);
            if (key === "appendTo") this.menuWrap.appendTo(this._appendTo());
            if (key === "disabled") {
                this.menuInstance.option("disabled", value);
                this.button.toggleClass("ui-state-disabled", value).attr("aria-disabled", value);
                this.element.prop("disabled", value);
                if (value) {
                    this.button.attr("tabindex", -1);
                    this.close();
                } else this.button.attr("tabindex", 0);
            }
            if (key === "width") this._resizeButton();
        },
        _appendTo: function() {
            var element = this.options.appendTo;
            if (element) element = element.jquery || element.nodeType ? $(element) : this.document.find(element).eq(0);
            if (!element || !element[0]) element = this.element.closest(".ui-front");
            if (!element.length) element = this.document[0].body;
            return element;
        },
        _toggleAttr: function() {
            this.button.toggleClass("ui-corner-top", this.isOpen).toggleClass("ui-corner-all", !this.isOpen).attr("aria-expanded", this.isOpen);
            this.menuWrap.toggleClass("ui-selectmenu-open", this.isOpen);
            this.menu.attr("aria-hidden", !this.isOpen);
        },
        _resizeButton: function() {
            var width = this.options.width;
            if (!width) {
                width = this.element.show().outerWidth();
                this.element.hide();
            }
            this.button.outerWidth(width);
        },
        _resizeMenu: function() {
            this.menu.outerWidth(Math.max(this.button.outerWidth(), // support: IE10
            // IE10 wraps long text (possibly a rounding bug)
            // so we add 1px to avoid the wrapping
            this.menu.width("").outerWidth() + 1));
        },
        _getCreateOptions: function() {
            return {
                disabled: this.element.prop("disabled")
            };
        },
        _parseOptions: function(options) {
            var data = [];
            options.each(function(index, item) {
                var option = $(item), optgroup = option.parent("optgroup");
                data.push({
                    element: option,
                    index: index,
                    value: option.attr("value"),
                    label: option.text(),
                    optgroup: optgroup.attr("label") || "",
                    disabled: optgroup.prop("disabled") || option.prop("disabled")
                });
            });
            this.items = data;
        },
        _destroy: function() {
            this.menuWrap.remove();
            this.button.remove();
            this.element.show();
            this.element.removeUniqueId();
            this.label.attr("for", this.ids.element);
        }
    });
    /*!
 * jQuery UI Slider 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/slider/
 */ var slider = $.widget("ui.slider", $.ui.mouse, {
        version: "1.11.1",
        widgetEventPrefix: "slide",
        options: {
            animate: false,
            distance: 0,
            max: 100,
            min: 0,
            orientation: "horizontal",
            range: false,
            step: 1,
            value: 0,
            values: null,
            // callbacks
            change: null,
            slide: null,
            start: null,
            stop: null
        },
        // number of pages in a slider
        // (how many times can you page up/down to go through the whole range)
        numPages: 5,
        _create: function() {
            this._keySliding = false;
            this._mouseSliding = false;
            this._animateOff = true;
            this._handleIndex = null;
            this._detectOrientation();
            this._mouseInit();
            this.element.addClass("ui-slider ui-slider-" + this.orientation + " ui-widget" + " ui-widget-content" + " ui-corner-all");
            this._refresh();
            this._setOption("disabled", this.options.disabled);
            this._animateOff = false;
        },
        _refresh: function() {
            this._createRange();
            this._createHandles();
            this._setupEvents();
            this._refreshValue();
        },
        _createHandles: function() {
            var i, handleCount, options = this.options, existingHandles = this.element.find(".ui-slider-handle").addClass("ui-state-default ui-corner-all"), handle = "<span class='ui-slider-handle ui-state-default ui-corner-all' tabindex='0'></span>", handles = [];
            handleCount = options.values && options.values.length || 1;
            if (existingHandles.length > handleCount) {
                existingHandles.slice(handleCount).remove();
                existingHandles = existingHandles.slice(0, handleCount);
            }
            for(i = existingHandles.length; i < handleCount; i++)handles.push(handle);
            this.handles = existingHandles.add($(handles.join("")).appendTo(this.element));
            this.handle = this.handles.eq(0);
            this.handles.each(function(i) {
                $(this).data("ui-slider-handle-index", i);
            });
        },
        _createRange: function() {
            var options = this.options, classes = "";
            if (options.range) {
                if (options.range === true) {
                    if (!options.values) options.values = [
                        this._valueMin(),
                        this._valueMin()
                    ];
                    else if (options.values.length && options.values.length !== 2) options.values = [
                        options.values[0],
                        options.values[0]
                    ];
                    else if ($.isArray(options.values)) options.values = options.values.slice(0);
                }
                if (!this.range || !this.range.length) {
                    this.range = $("<div></div>").appendTo(this.element);
                    classes = "ui-slider-range ui-widget-header ui-corner-all";
                } else this.range.removeClass("ui-slider-range-min ui-slider-range-max")// Handle range switching from true to min/max
                .css({
                    "left": "",
                    "bottom": ""
                });
                this.range.addClass(classes + (options.range === "min" || options.range === "max" ? " ui-slider-range-" + options.range : ""));
            } else {
                if (this.range) this.range.remove();
                this.range = null;
            }
        },
        _setupEvents: function() {
            this._off(this.handles);
            this._on(this.handles, this._handleEvents);
            this._hoverable(this.handles);
            this._focusable(this.handles);
        },
        _destroy: function() {
            this.handles.remove();
            if (this.range) this.range.remove();
            this.element.removeClass("ui-slider ui-slider-horizontal ui-slider-vertical ui-widget ui-widget-content ui-corner-all");
            this._mouseDestroy();
        },
        _mouseCapture: function(event) {
            var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle, that = this, o = this.options;
            if (o.disabled) return false;
            this.elementSize = {
                width: this.element.outerWidth(),
                height: this.element.outerHeight()
            };
            this.elementOffset = this.element.offset();
            position = {
                x: event.pageX,
                y: event.pageY
            };
            normValue = this._normValueFromMouse(position);
            distance = this._valueMax() - this._valueMin() + 1;
            this.handles.each(function(i) {
                var thisDistance = Math.abs(normValue - that.values(i));
                if (distance > thisDistance || distance === thisDistance && (i === that._lastChangedValue || that.values(i) === o.min)) {
                    distance = thisDistance;
                    closestHandle = $(this);
                    index = i;
                }
            });
            allowed = this._start(event, index);
            if (allowed === false) return false;
            this._mouseSliding = true;
            this._handleIndex = index;
            closestHandle.addClass("ui-state-active").focus();
            offset = closestHandle.offset();
            mouseOverHandle = !$(event.target).parents().addBack().is(".ui-slider-handle");
            this._clickOffset = mouseOverHandle ? {
                left: 0,
                top: 0
            } : {
                left: event.pageX - offset.left - closestHandle.width() / 2,
                top: event.pageY - offset.top - closestHandle.height() / 2 - (parseInt(closestHandle.css("borderTopWidth"), 10) || 0) - (parseInt(closestHandle.css("borderBottomWidth"), 10) || 0) + (parseInt(closestHandle.css("marginTop"), 10) || 0)
            };
            if (!this.handles.hasClass("ui-state-hover")) this._slide(event, index, normValue);
            this._animateOff = true;
            return true;
        },
        _mouseStart: function() {
            return true;
        },
        _mouseDrag: function(event) {
            var position = {
                x: event.pageX,
                y: event.pageY
            }, normValue = this._normValueFromMouse(position);
            this._slide(event, this._handleIndex, normValue);
            return false;
        },
        _mouseStop: function(event) {
            this.handles.removeClass("ui-state-active");
            this._mouseSliding = false;
            this._stop(event, this._handleIndex);
            this._change(event, this._handleIndex);
            this._handleIndex = null;
            this._clickOffset = null;
            this._animateOff = false;
            return false;
        },
        _detectOrientation: function() {
            this.orientation = this.options.orientation === "vertical" ? "vertical" : "horizontal";
        },
        _normValueFromMouse: function(position) {
            var pixelTotal, pixelMouse, percentMouse, valueTotal, valueMouse;
            if (this.orientation === "horizontal") {
                pixelTotal = this.elementSize.width;
                pixelMouse = position.x - this.elementOffset.left - (this._clickOffset ? this._clickOffset.left : 0);
            } else {
                pixelTotal = this.elementSize.height;
                pixelMouse = position.y - this.elementOffset.top - (this._clickOffset ? this._clickOffset.top : 0);
            }
            percentMouse = pixelMouse / pixelTotal;
            if (percentMouse > 1) percentMouse = 1;
            if (percentMouse < 0) percentMouse = 0;
            if (this.orientation === "vertical") percentMouse = 1 - percentMouse;
            valueTotal = this._valueMax() - this._valueMin();
            valueMouse = this._valueMin() + percentMouse * valueTotal;
            return this._trimAlignValue(valueMouse);
        },
        _start: function(event, index) {
            var uiHash = {
                handle: this.handles[index],
                value: this.value()
            };
            if (this.options.values && this.options.values.length) {
                uiHash.value = this.values(index);
                uiHash.values = this.values();
            }
            return this._trigger("start", event, uiHash);
        },
        _slide: function(event, index, newVal) {
            var otherVal, newValues, allowed;
            if (this.options.values && this.options.values.length) {
                otherVal = this.values(index ? 0 : 1);
                if (this.options.values.length === 2 && this.options.range === true && (index === 0 && newVal > otherVal || index === 1 && newVal < otherVal)) newVal = otherVal;
                if (newVal !== this.values(index)) {
                    newValues = this.values();
                    newValues[index] = newVal;
                    // A slide can be canceled by returning false from the slide callback
                    allowed = this._trigger("slide", event, {
                        handle: this.handles[index],
                        value: newVal,
                        values: newValues
                    });
                    otherVal = this.values(index ? 0 : 1);
                    if (allowed !== false) this.values(index, newVal);
                }
            } else if (newVal !== this.value()) {
                // A slide can be canceled by returning false from the slide callback
                allowed = this._trigger("slide", event, {
                    handle: this.handles[index],
                    value: newVal
                });
                if (allowed !== false) this.value(newVal);
            }
        },
        _stop: function(event, index) {
            var uiHash = {
                handle: this.handles[index],
                value: this.value()
            };
            if (this.options.values && this.options.values.length) {
                uiHash.value = this.values(index);
                uiHash.values = this.values();
            }
            this._trigger("stop", event, uiHash);
        },
        _change: function(event, index) {
            if (!this._keySliding && !this._mouseSliding) {
                var uiHash = {
                    handle: this.handles[index],
                    value: this.value()
                };
                if (this.options.values && this.options.values.length) {
                    uiHash.value = this.values(index);
                    uiHash.values = this.values();
                }
                //store the last changed value index for reference when handles overlap
                this._lastChangedValue = index;
                this._trigger("change", event, uiHash);
            }
        },
        value: function(newValue) {
            if (arguments.length) {
                this.options.value = this._trimAlignValue(newValue);
                this._refreshValue();
                this._change(null, 0);
                return;
            }
            return this._value();
        },
        values: function(index, newValue) {
            var vals, newValues, i;
            if (arguments.length > 1) {
                this.options.values[index] = this._trimAlignValue(newValue);
                this._refreshValue();
                this._change(null, index);
                return;
            }
            if (arguments.length) {
                if ($.isArray(arguments[0])) {
                    vals = this.options.values;
                    newValues = arguments[0];
                    for(i = 0; i < vals.length; i += 1){
                        vals[i] = this._trimAlignValue(newValues[i]);
                        this._change(null, i);
                    }
                    this._refreshValue();
                } else {
                    if (this.options.values && this.options.values.length) return this._values(index);
                    else return this.value();
                }
            } else return this._values();
        },
        _setOption: function(key, value) {
            var i, valsLength = 0;
            if (key === "range" && this.options.range === true) {
                if (value === "min") {
                    this.options.value = this._values(0);
                    this.options.values = null;
                } else if (value === "max") {
                    this.options.value = this._values(this.options.values.length - 1);
                    this.options.values = null;
                }
            }
            if ($.isArray(this.options.values)) valsLength = this.options.values.length;
            if (key === "disabled") this.element.toggleClass("ui-state-disabled", !!value);
            this._super(key, value);
            switch(key){
                case "orientation":
                    this._detectOrientation();
                    this.element.removeClass("ui-slider-horizontal ui-slider-vertical").addClass("ui-slider-" + this.orientation);
                    this._refreshValue();
                    // Reset positioning from previous orientation
                    this.handles.css(value === "horizontal" ? "bottom" : "left", "");
                    break;
                case "value":
                    this._animateOff = true;
                    this._refreshValue();
                    this._change(null, 0);
                    this._animateOff = false;
                    break;
                case "values":
                    this._animateOff = true;
                    this._refreshValue();
                    for(i = 0; i < valsLength; i += 1)this._change(null, i);
                    this._animateOff = false;
                    break;
                case "min":
                case "max":
                    this._animateOff = true;
                    this._refreshValue();
                    this._animateOff = false;
                    break;
                case "range":
                    this._animateOff = true;
                    this._refresh();
                    this._animateOff = false;
                    break;
            }
        },
        //internal value getter
        // _value() returns value trimmed by min and max, aligned by step
        _value: function() {
            var val = this.options.value;
            val = this._trimAlignValue(val);
            return val;
        },
        //internal values getter
        // _values() returns array of values trimmed by min and max, aligned by step
        // _values( index ) returns single value trimmed by min and max, aligned by step
        _values: function(index) {
            var val, vals, i;
            if (arguments.length) {
                val = this.options.values[index];
                val = this._trimAlignValue(val);
                return val;
            } else if (this.options.values && this.options.values.length) {
                // .slice() creates a copy of the array
                // this copy gets trimmed by min and max and then returned
                vals = this.options.values.slice();
                for(i = 0; i < vals.length; i += 1)vals[i] = this._trimAlignValue(vals[i]);
                return vals;
            } else return [];
        },
        // returns the step-aligned value that val is closest to, between (inclusive) min and max
        _trimAlignValue: function(val) {
            if (val <= this._valueMin()) return this._valueMin();
            if (val >= this._valueMax()) return this._valueMax();
            var step = this.options.step > 0 ? this.options.step : 1, valModStep = (val - this._valueMin()) % step, alignValue = val - valModStep;
            if (Math.abs(valModStep) * 2 >= step) alignValue += valModStep > 0 ? step : -step;
            // Since JavaScript has problems with large floats, round
            // the final value to 5 digits after the decimal point (see #4124)
            return parseFloat(alignValue.toFixed(5));
        },
        _valueMin: function() {
            return this.options.min;
        },
        _valueMax: function() {
            return this.options.max;
        },
        _refreshValue: function() {
            var lastValPercent, valPercent, value, valueMin, valueMax, oRange = this.options.range, o = this.options, that = this, animate = !this._animateOff ? o.animate : false, _set = {};
            if (this.options.values && this.options.values.length) this.handles.each(function(i) {
                valPercent = (that.values(i) - that._valueMin()) / (that._valueMax() - that._valueMin()) * 100;
                _set[that.orientation === "horizontal" ? "left" : "bottom"] = valPercent + "%";
                $(this).stop(1, 1)[animate ? "animate" : "css"](_set, o.animate);
                if (that.options.range === true) {
                    if (that.orientation === "horizontal") {
                        if (i === 0) that.range.stop(1, 1)[animate ? "animate" : "css"]({
                            left: valPercent + "%"
                        }, o.animate);
                        if (i === 1) that.range[animate ? "animate" : "css"]({
                            width: valPercent - lastValPercent + "%"
                        }, {
                            queue: false,
                            duration: o.animate
                        });
                    } else {
                        if (i === 0) that.range.stop(1, 1)[animate ? "animate" : "css"]({
                            bottom: valPercent + "%"
                        }, o.animate);
                        if (i === 1) that.range[animate ? "animate" : "css"]({
                            height: valPercent - lastValPercent + "%"
                        }, {
                            queue: false,
                            duration: o.animate
                        });
                    }
                }
                lastValPercent = valPercent;
            });
            else {
                value = this.value();
                valueMin = this._valueMin();
                valueMax = this._valueMax();
                valPercent = valueMax !== valueMin ? (value - valueMin) / (valueMax - valueMin) * 100 : 0;
                _set[this.orientation === "horizontal" ? "left" : "bottom"] = valPercent + "%";
                this.handle.stop(1, 1)[animate ? "animate" : "css"](_set, o.animate);
                if (oRange === "min" && this.orientation === "horizontal") this.range.stop(1, 1)[animate ? "animate" : "css"]({
                    width: valPercent + "%"
                }, o.animate);
                if (oRange === "max" && this.orientation === "horizontal") this.range[animate ? "animate" : "css"]({
                    width: 100 - valPercent + "%"
                }, {
                    queue: false,
                    duration: o.animate
                });
                if (oRange === "min" && this.orientation === "vertical") this.range.stop(1, 1)[animate ? "animate" : "css"]({
                    height: valPercent + "%"
                }, o.animate);
                if (oRange === "max" && this.orientation === "vertical") this.range[animate ? "animate" : "css"]({
                    height: 100 - valPercent + "%"
                }, {
                    queue: false,
                    duration: o.animate
                });
            }
        },
        _handleEvents: {
            keydown: function(event) {
                var allowed, curVal, newVal, step, index = $(event.target).data("ui-slider-handle-index");
                switch(event.keyCode){
                    case $.ui.keyCode.HOME:
                    case $.ui.keyCode.END:
                    case $.ui.keyCode.PAGE_UP:
                    case $.ui.keyCode.PAGE_DOWN:
                    case $.ui.keyCode.UP:
                    case $.ui.keyCode.RIGHT:
                    case $.ui.keyCode.DOWN:
                    case $.ui.keyCode.LEFT:
                        event.preventDefault();
                        if (!this._keySliding) {
                            this._keySliding = true;
                            $(event.target).addClass("ui-state-active");
                            allowed = this._start(event, index);
                            if (allowed === false) return;
                        }
                        break;
                }
                step = this.options.step;
                if (this.options.values && this.options.values.length) curVal = newVal = this.values(index);
                else curVal = newVal = this.value();
                switch(event.keyCode){
                    case $.ui.keyCode.HOME:
                        newVal = this._valueMin();
                        break;
                    case $.ui.keyCode.END:
                        newVal = this._valueMax();
                        break;
                    case $.ui.keyCode.PAGE_UP:
                        newVal = this._trimAlignValue(curVal + (this._valueMax() - this._valueMin()) / this.numPages);
                        break;
                    case $.ui.keyCode.PAGE_DOWN:
                        newVal = this._trimAlignValue(curVal - (this._valueMax() - this._valueMin()) / this.numPages);
                        break;
                    case $.ui.keyCode.UP:
                    case $.ui.keyCode.RIGHT:
                        if (curVal === this._valueMax()) return;
                        newVal = this._trimAlignValue(curVal + step);
                        break;
                    case $.ui.keyCode.DOWN:
                    case $.ui.keyCode.LEFT:
                        if (curVal === this._valueMin()) return;
                        newVal = this._trimAlignValue(curVal - step);
                        break;
                }
                this._slide(event, index, newVal);
            },
            keyup: function(event) {
                var index = $(event.target).data("ui-slider-handle-index");
                if (this._keySliding) {
                    this._keySliding = false;
                    this._stop(event, index);
                    this._change(event, index);
                    $(event.target).removeClass("ui-state-active");
                }
            }
        }
    });
    /*!
 * jQuery UI Sortable 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/sortable/
 */ var sortable = $.widget("ui.sortable", $.ui.mouse, {
        version: "1.11.1",
        widgetEventPrefix: "sort",
        ready: false,
        options: {
            appendTo: "parent",
            axis: false,
            connectWith: false,
            containment: false,
            cursor: "auto",
            cursorAt: false,
            dropOnEmpty: true,
            forcePlaceholderSize: false,
            forceHelperSize: false,
            grid: false,
            handle: false,
            helper: "original",
            items: "> *",
            opacity: false,
            placeholder: false,
            revert: false,
            scroll: true,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            scope: "default",
            tolerance: "intersect",
            zIndex: 1000,
            // callbacks
            activate: null,
            beforeStop: null,
            change: null,
            deactivate: null,
            out: null,
            over: null,
            receive: null,
            remove: null,
            sort: null,
            start: null,
            stop: null,
            update: null
        },
        _isOverAxis: function(x, reference, size) {
            return x >= reference && x < reference + size;
        },
        _isFloating: function(item) {
            return /left|right/.test(item.css("float")) || /inline|table-cell/.test(item.css("display"));
        },
        _create: function() {
            var o = this.options;
            this.containerCache = {};
            this.element.addClass("ui-sortable");
            //Get the items
            this.refresh();
            //Let's determine if the items are being displayed horizontally
            this.floating = this.items.length ? o.axis === "x" || this._isFloating(this.items[0].item) : false;
            //Let's determine the parent's offset
            this.offset = this.element.offset();
            //Initialize mouse events for interaction
            this._mouseInit();
            this._setHandleClassName();
            //We're ready to go
            this.ready = true;
        },
        _setOption: function(key, value) {
            this._super(key, value);
            if (key === "handle") this._setHandleClassName();
        },
        _setHandleClassName: function() {
            this.element.find(".ui-sortable-handle").removeClass("ui-sortable-handle");
            $.each(this.items, function() {
                (this.instance.options.handle ? this.item.find(this.instance.options.handle) : this.item).addClass("ui-sortable-handle");
            });
        },
        _destroy: function() {
            this.element.removeClass("ui-sortable ui-sortable-disabled").find(".ui-sortable-handle").removeClass("ui-sortable-handle");
            this._mouseDestroy();
            for(var i = this.items.length - 1; i >= 0; i--)this.items[i].item.removeData(this.widgetName + "-item");
            return this;
        },
        _mouseCapture: function(event, overrideHandle) {
            var currentItem = null, validHandle = false, that = this;
            if (this.reverting) return false;
            if (this.options.disabled || this.options.type === "static") return false;
            //We have to refresh the items data once first
            this._refreshItems(event);
            //Find out if the clicked node (or one of its parents) is a actual item in this.items
            $(event.target).parents().each(function() {
                if ($.data(this, that.widgetName + "-item") === that) {
                    currentItem = $(this);
                    return false;
                }
            });
            if ($.data(event.target, that.widgetName + "-item") === that) currentItem = $(event.target);
            if (!currentItem) return false;
            if (this.options.handle && !overrideHandle) {
                $(this.options.handle, currentItem).find("*").addBack().each(function() {
                    if (this === event.target) validHandle = true;
                });
                if (!validHandle) return false;
            }
            this.currentItem = currentItem;
            this._removeCurrentsFromItems();
            return true;
        },
        _mouseStart: function(event, overrideHandle, noActivation) {
            var i, body, o = this.options;
            this.currentContainer = this;
            //We only need to call refreshPositions, because the refreshItems call has been moved to mouseCapture
            this.refreshPositions();
            //Create and append the visible helper
            this.helper = this._createHelper(event);
            //Cache the helper size
            this._cacheHelperProportions();
            /*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */ //Cache the margins of the original element
            this._cacheMargins();
            //Get the next scrolling parent
            this.scrollParent = this.helper.scrollParent();
            //The element's absolute position on the page minus margins
            this.offset = this.currentItem.offset();
            this.offset = {
                top: this.offset.top - this.margins.top,
                left: this.offset.left - this.margins.left
            };
            $.extend(this.offset, {
                click: {
                    left: event.pageX - this.offset.left,
                    top: event.pageY - this.offset.top
                },
                parent: this._getParentOffset(),
                relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
            });
            // Only after we got the offset, we can change the helper's position to absolute
            // TODO: Still need to figure out a way to make relative sorting possible
            this.helper.css("position", "absolute");
            this.cssPosition = this.helper.css("position");
            //Generate the original position
            this.originalPosition = this._generatePosition(event);
            this.originalPageX = event.pageX;
            this.originalPageY = event.pageY;
            //Adjust the mouse offset relative to the helper if "cursorAt" is supplied
            o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt);
            //Cache the former DOM position
            this.domPosition = {
                prev: this.currentItem.prev()[0],
                parent: this.currentItem.parent()[0]
            };
            //If the helper is not the original, hide the original so it's not playing any role during the drag, won't cause anything bad this way
            if (this.helper[0] !== this.currentItem[0]) this.currentItem.hide();
            //Create the placeholder
            this._createPlaceholder();
            //Set a containment if given in the options
            if (o.containment) this._setContainment();
            if (o.cursor && o.cursor !== "auto") {
                body = this.document.find("body");
                // support: IE
                this.storedCursor = body.css("cursor");
                body.css("cursor", o.cursor);
                this.storedStylesheet = $("<style>*{ cursor: " + o.cursor + " !important; }</style>").appendTo(body);
            }
            if (o.opacity) {
                if (this.helper.css("opacity")) this._storedOpacity = this.helper.css("opacity");
                this.helper.css("opacity", o.opacity);
            }
            if (o.zIndex) {
                if (this.helper.css("zIndex")) this._storedZIndex = this.helper.css("zIndex");
                this.helper.css("zIndex", o.zIndex);
            }
            //Prepare scrolling
            if (this.scrollParent[0] !== document && this.scrollParent[0].tagName !== "HTML") this.overflowOffset = this.scrollParent.offset();
            //Call callbacks
            this._trigger("start", event, this._uiHash());
            //Recache the helper size
            if (!this._preserveHelperProportions) this._cacheHelperProportions();
            //Post "activate" events to possible containers
            if (!noActivation) for(i = this.containers.length - 1; i >= 0; i--)this.containers[i]._trigger("activate", event, this._uiHash(this));
            //Prepare possible droppables
            if ($.ui.ddmanager) $.ui.ddmanager.current = this;
            if ($.ui.ddmanager && !o.dropBehaviour) $.ui.ddmanager.prepareOffsets(this, event);
            this.dragging = true;
            this.helper.addClass("ui-sortable-helper");
            this._mouseDrag(event); //Execute the drag once - this causes the helper not to be visible before getting its correct position
            return true;
        },
        _mouseDrag: function(event) {
            var i, item, itemElement, intersection, o = this.options, scrolled = false;
            //Compute the helpers position
            this.position = this._generatePosition(event);
            this.positionAbs = this._convertPositionTo("absolute");
            if (!this.lastPositionAbs) this.lastPositionAbs = this.positionAbs;
            //Do scrolling
            if (this.options.scroll) {
                if (this.scrollParent[0] !== document && this.scrollParent[0].tagName !== "HTML") {
                    if (this.overflowOffset.top + this.scrollParent[0].offsetHeight - event.pageY < o.scrollSensitivity) this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop + o.scrollSpeed;
                    else if (event.pageY - this.overflowOffset.top < o.scrollSensitivity) this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop - o.scrollSpeed;
                    if (this.overflowOffset.left + this.scrollParent[0].offsetWidth - event.pageX < o.scrollSensitivity) this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft + o.scrollSpeed;
                    else if (event.pageX - this.overflowOffset.left < o.scrollSensitivity) this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft - o.scrollSpeed;
                } else {
                    if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
                    else if ($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
                    if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
                    else if ($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
                }
                if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) $.ui.ddmanager.prepareOffsets(this, event);
            }
            //Regenerate the absolute position used for position checks
            this.positionAbs = this._convertPositionTo("absolute");
            //Set the helper position
            if (!this.options.axis || this.options.axis !== "y") this.helper[0].style.left = this.position.left + "px";
            if (!this.options.axis || this.options.axis !== "x") this.helper[0].style.top = this.position.top + "px";
            //Rearrange
            for(i = this.items.length - 1; i >= 0; i--){
                //Cache variables and intersection, continue if no intersection
                item = this.items[i];
                itemElement = item.item[0];
                intersection = this._intersectsWithPointer(item);
                if (!intersection) continue;
                // Only put the placeholder inside the current Container, skip all
                // items from other containers. This works because when moving
                // an item from one container to another the
                // currentContainer is switched before the placeholder is moved.
                //
                // Without this, moving items in "sub-sortables" can cause
                // the placeholder to jitter between the outer and inner container.
                if (item.instance !== this.currentContainer) continue;
                // cannot intersect with itself
                // no useless actions that have been done before
                // no action if the item moved is the parent of the item checked
                if (itemElement !== this.currentItem[0] && this.placeholder[intersection === 1 ? "next" : "prev"]()[0] !== itemElement && !$.contains(this.placeholder[0], itemElement) && (this.options.type === "semi-dynamic" ? !$.contains(this.element[0], itemElement) : true)) {
                    this.direction = intersection === 1 ? "down" : "up";
                    if (this.options.tolerance === "pointer" || this._intersectsWithSides(item)) this._rearrange(event, item);
                    else break;
                    this._trigger("change", event, this._uiHash());
                    break;
                }
            }
            //Post events to containers
            this._contactContainers(event);
            //Interconnect with droppables
            if ($.ui.ddmanager) $.ui.ddmanager.drag(this, event);
            //Call callbacks
            this._trigger("sort", event, this._uiHash());
            this.lastPositionAbs = this.positionAbs;
            return false;
        },
        _mouseStop: function(event, noPropagation) {
            if (!event) return;
            //If we are using droppables, inform the manager about the drop
            if ($.ui.ddmanager && !this.options.dropBehaviour) $.ui.ddmanager.drop(this, event);
            if (this.options.revert) {
                var that = this, cur = this.placeholder.offset(), axis = this.options.axis, animation = {};
                if (!axis || axis === "x") animation.left = cur.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === document.body ? 0 : this.offsetParent[0].scrollLeft);
                if (!axis || axis === "y") animation.top = cur.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === document.body ? 0 : this.offsetParent[0].scrollTop);
                this.reverting = true;
                $(this.helper).animate(animation, parseInt(this.options.revert, 10) || 500, function() {
                    that._clear(event);
                });
            } else this._clear(event, noPropagation);
            return false;
        },
        cancel: function() {
            if (this.dragging) {
                this._mouseUp({
                    target: null
                });
                if (this.options.helper === "original") this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
                else this.currentItem.show();
                //Post deactivating events to containers
                for(var i = this.containers.length - 1; i >= 0; i--){
                    this.containers[i]._trigger("deactivate", null, this._uiHash(this));
                    if (this.containers[i].containerCache.over) {
                        this.containers[i]._trigger("out", null, this._uiHash(this));
                        this.containers[i].containerCache.over = 0;
                    }
                }
            }
            if (this.placeholder) {
                //$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
                if (this.placeholder[0].parentNode) this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
                if (this.options.helper !== "original" && this.helper && this.helper[0].parentNode) this.helper.remove();
                $.extend(this, {
                    helper: null,
                    dragging: false,
                    reverting: false,
                    _noFinalSort: null
                });
                if (this.domPosition.prev) $(this.domPosition.prev).after(this.currentItem);
                else $(this.domPosition.parent).prepend(this.currentItem);
            }
            return this;
        },
        serialize: function(o) {
            var items = this._getItemsAsjQuery(o && o.connected), str = [];
            o = o || {};
            $(items).each(function() {
                var res = ($(o.item || this).attr(o.attribute || "id") || "").match(o.expression || /(.+)[\-=_](.+)/);
                if (res) str.push((o.key || res[1] + "[]") + "=" + (o.key && o.expression ? res[1] : res[2]));
            });
            if (!str.length && o.key) str.push(o.key + "=");
            return str.join("&");
        },
        toArray: function(o) {
            var items = this._getItemsAsjQuery(o && o.connected), ret = [];
            o = o || {};
            items.each(function() {
                ret.push($(o.item || this).attr(o.attribute || "id") || "");
            });
            return ret;
        },
        /* Be careful with the following core functions */ _intersectsWith: function(item) {
            var x1 = this.positionAbs.left, x2 = x1 + this.helperProportions.width, y1 = this.positionAbs.top, y2 = y1 + this.helperProportions.height, l = item.left, r = l + item.width, t = item.top, b = t + item.height, dyClick = this.offset.click.top, dxClick = this.offset.click.left, isOverElementHeight = this.options.axis === "x" || y1 + dyClick > t && y1 + dyClick < b, isOverElementWidth = this.options.axis === "y" || x1 + dxClick > l && x1 + dxClick < r, isOverElement = isOverElementHeight && isOverElementWidth;
            if (this.options.tolerance === "pointer" || this.options.forcePointerForContainers || this.options.tolerance !== "pointer" && this.helperProportions[this.floating ? "width" : "height"] > item[this.floating ? "width" : "height"]) return isOverElement;
            else return l < x1 + this.helperProportions.width / 2 && // Right Half
            x2 - this.helperProportions.width / 2 < r && // Left Half
            t < y1 + this.helperProportions.height / 2 && // Bottom Half
            y2 - this.helperProportions.height / 2 < b; // Top Half
        },
        _intersectsWithPointer: function(item) {
            var isOverElementHeight = this.options.axis === "x" || this._isOverAxis(this.positionAbs.top + this.offset.click.top, item.top, item.height), isOverElementWidth = this.options.axis === "y" || this._isOverAxis(this.positionAbs.left + this.offset.click.left, item.left, item.width), isOverElement = isOverElementHeight && isOverElementWidth, verticalDirection = this._getDragVerticalDirection(), horizontalDirection = this._getDragHorizontalDirection();
            if (!isOverElement) return false;
            return this.floating ? horizontalDirection && horizontalDirection === "right" || verticalDirection === "down" ? 2 : 1 : verticalDirection && (verticalDirection === "down" ? 2 : 1);
        },
        _intersectsWithSides: function(item) {
            var isOverBottomHalf = this._isOverAxis(this.positionAbs.top + this.offset.click.top, item.top + item.height / 2, item.height), isOverRightHalf = this._isOverAxis(this.positionAbs.left + this.offset.click.left, item.left + item.width / 2, item.width), verticalDirection = this._getDragVerticalDirection(), horizontalDirection = this._getDragHorizontalDirection();
            if (this.floating && horizontalDirection) return horizontalDirection === "right" && isOverRightHalf || horizontalDirection === "left" && !isOverRightHalf;
            else return verticalDirection && (verticalDirection === "down" && isOverBottomHalf || verticalDirection === "up" && !isOverBottomHalf);
        },
        _getDragVerticalDirection: function() {
            var delta = this.positionAbs.top - this.lastPositionAbs.top;
            return delta !== 0 && (delta > 0 ? "down" : "up");
        },
        _getDragHorizontalDirection: function() {
            var delta = this.positionAbs.left - this.lastPositionAbs.left;
            return delta !== 0 && (delta > 0 ? "right" : "left");
        },
        refresh: function(event) {
            this._refreshItems(event);
            this._setHandleClassName();
            this.refreshPositions();
            return this;
        },
        _connectWith: function() {
            var options = this.options;
            return options.connectWith.constructor === String ? [
                options.connectWith
            ] : options.connectWith;
        },
        _getItemsAsjQuery: function(connected) {
            var i, j, cur, inst, items = [], queries = [], connectWith = this._connectWith();
            if (connectWith && connected) for(i = connectWith.length - 1; i >= 0; i--){
                cur = $(connectWith[i]);
                for(j = cur.length - 1; j >= 0; j--){
                    inst = $.data(cur[j], this.widgetFullName);
                    if (inst && inst !== this && !inst.options.disabled) queries.push([
                        $.isFunction(inst.options.items) ? inst.options.items.call(inst.element) : $(inst.options.items, inst.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),
                        inst
                    ]);
                }
            }
            queries.push([
                $.isFunction(this.options.items) ? this.options.items.call(this.element, null, {
                    options: this.options,
                    item: this.currentItem
                }) : $(this.options.items, this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),
                this
            ]);
            function addItems() {
                items.push(this);
            }
            for(i = queries.length - 1; i >= 0; i--)queries[i][0].each(addItems);
            return $(items);
        },
        _removeCurrentsFromItems: function() {
            var list = this.currentItem.find(":data(" + this.widgetName + "-item)");
            this.items = $.grep(this.items, function(item) {
                for(var j = 0; j < list.length; j++){
                    if (list[j] === item.item[0]) return false;
                }
                return true;
            });
        },
        _refreshItems: function(event) {
            this.items = [];
            this.containers = [
                this
            ];
            var i, j, cur, inst, targetData, _queries, item, queriesLength, items = this.items, queries = [
                [
                    $.isFunction(this.options.items) ? this.options.items.call(this.element[0], event, {
                        item: this.currentItem
                    }) : $(this.options.items, this.element),
                    this
                ]
            ], connectWith = this._connectWith();
            if (connectWith && this.ready) for(i = connectWith.length - 1; i >= 0; i--){
                cur = $(connectWith[i]);
                for(j = cur.length - 1; j >= 0; j--){
                    inst = $.data(cur[j], this.widgetFullName);
                    if (inst && inst !== this && !inst.options.disabled) {
                        queries.push([
                            $.isFunction(inst.options.items) ? inst.options.items.call(inst.element[0], event, {
                                item: this.currentItem
                            }) : $(inst.options.items, inst.element),
                            inst
                        ]);
                        this.containers.push(inst);
                    }
                }
            }
            for(i = queries.length - 1; i >= 0; i--){
                targetData = queries[i][1];
                _queries = queries[i][0];
                for(j = 0, queriesLength = _queries.length; j < queriesLength; j++){
                    item = $(_queries[j]);
                    item.data(this.widgetName + "-item", targetData); // Data for target checking (mouse manager)
                    items.push({
                        item: item,
                        instance: targetData,
                        width: 0,
                        height: 0,
                        left: 0,
                        top: 0
                    });
                }
            }
        },
        refreshPositions: function(fast) {
            //This has to be redone because due to the item being moved out/into the offsetParent, the offsetParent's position will change
            if (this.offsetParent && this.helper) this.offset.parent = this._getParentOffset();
            var i, item, t, p;
            for(i = this.items.length - 1; i >= 0; i--){
                item = this.items[i];
                //We ignore calculating positions of all connected containers when we're not over them
                if (item.instance !== this.currentContainer && this.currentContainer && item.item[0] !== this.currentItem[0]) continue;
                t = this.options.toleranceElement ? $(this.options.toleranceElement, item.item) : item.item;
                if (!fast) {
                    item.width = t.outerWidth();
                    item.height = t.outerHeight();
                }
                p = t.offset();
                item.left = p.left;
                item.top = p.top;
            }
            if (this.options.custom && this.options.custom.refreshContainers) this.options.custom.refreshContainers.call(this);
            else for(i = this.containers.length - 1; i >= 0; i--){
                p = this.containers[i].element.offset();
                this.containers[i].containerCache.left = p.left;
                this.containers[i].containerCache.top = p.top;
                this.containers[i].containerCache.width = this.containers[i].element.outerWidth();
                this.containers[i].containerCache.height = this.containers[i].element.outerHeight();
            }
            return this;
        },
        _createPlaceholder: function(that) {
            that = that || this;
            var className, o = that.options;
            if (!o.placeholder || o.placeholder.constructor === String) {
                className = o.placeholder;
                o.placeholder = {
                    element: function() {
                        var nodeName = that.currentItem[0].nodeName.toLowerCase(), element = $("<" + nodeName + ">", that.document[0]).addClass(className || that.currentItem[0].className + " ui-sortable-placeholder").removeClass("ui-sortable-helper");
                        if (nodeName === "tr") that.currentItem.children().each(function() {
                            $("<td>&#160;</td>", that.document[0]).attr("colspan", $(this).attr("colspan") || 1).appendTo(element);
                        });
                        else if (nodeName === "img") element.attr("src", that.currentItem.attr("src"));
                        if (!className) element.css("visibility", "hidden");
                        return element;
                    },
                    update: function(container, p) {
                        // 1. If a className is set as 'placeholder option, we don't force sizes - the class is responsible for that
                        // 2. The option 'forcePlaceholderSize can be enabled to force it even if a class name is specified
                        if (className && !o.forcePlaceholderSize) return;
                        //If the element doesn't have a actual height by itself (without styles coming from a stylesheet), it receives the inline height from the dragged item
                        if (!p.height()) p.height(that.currentItem.innerHeight() - parseInt(that.currentItem.css("paddingTop") || 0, 10) - parseInt(that.currentItem.css("paddingBottom") || 0, 10));
                        if (!p.width()) p.width(that.currentItem.innerWidth() - parseInt(that.currentItem.css("paddingLeft") || 0, 10) - parseInt(that.currentItem.css("paddingRight") || 0, 10));
                    }
                };
            }
            //Create the placeholder
            that.placeholder = $(o.placeholder.element.call(that.element, that.currentItem));
            //Append it after the actual current item
            that.currentItem.after(that.placeholder);
            //Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
            o.placeholder.update(that, that.placeholder);
        },
        _contactContainers: function(event) {
            var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom, floating, axis, innermostContainer = null, innermostIndex = null;
            // get innermost container that intersects with item
            for(i = this.containers.length - 1; i >= 0; i--){
                // never consider a container that's located within the item itself
                if ($.contains(this.currentItem[0], this.containers[i].element[0])) continue;
                if (this._intersectsWith(this.containers[i].containerCache)) {
                    // if we've already found a container and it's more "inner" than this, then continue
                    if (innermostContainer && $.contains(this.containers[i].element[0], innermostContainer.element[0])) continue;
                    innermostContainer = this.containers[i];
                    innermostIndex = i;
                } else // container doesn't intersect. trigger "out" event if necessary
                if (this.containers[i].containerCache.over) {
                    this.containers[i]._trigger("out", event, this._uiHash(this));
                    this.containers[i].containerCache.over = 0;
                }
            }
            // if no intersecting containers found, return
            if (!innermostContainer) return;
            // move the item into the container if it's not there already
            if (this.containers.length === 1) {
                if (!this.containers[innermostIndex].containerCache.over) {
                    this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
                    this.containers[innermostIndex].containerCache.over = 1;
                }
            } else {
                //When entering a new container, we will find the item with the least distance and append our item near it
                dist = 10000;
                itemWithLeastDistance = null;
                floating = innermostContainer.floating || this._isFloating(this.currentItem);
                posProperty = floating ? "left" : "top";
                sizeProperty = floating ? "width" : "height";
                axis = floating ? "clientX" : "clientY";
                for(j = this.items.length - 1; j >= 0; j--){
                    if (!$.contains(this.containers[innermostIndex].element[0], this.items[j].item[0])) continue;
                    if (this.items[j].item[0] === this.currentItem[0]) continue;
                    cur = this.items[j].item.offset()[posProperty];
                    nearBottom = false;
                    if (event[axis] - cur > this.items[j][sizeProperty] / 2) nearBottom = true;
                    if (Math.abs(event[axis] - cur) < dist) {
                        dist = Math.abs(event[axis] - cur);
                        itemWithLeastDistance = this.items[j];
                        this.direction = nearBottom ? "up" : "down";
                    }
                }
                //Check if dropOnEmpty is enabled
                if (!itemWithLeastDistance && !this.options.dropOnEmpty) return;
                if (this.currentContainer === this.containers[innermostIndex]) return;
                itemWithLeastDistance ? this._rearrange(event, itemWithLeastDistance, null, true) : this._rearrange(event, null, this.containers[innermostIndex].element, true);
                this._trigger("change", event, this._uiHash());
                this.containers[innermostIndex]._trigger("change", event, this._uiHash(this));
                this.currentContainer = this.containers[innermostIndex];
                //Update the placeholder
                this.options.placeholder.update(this.currentContainer, this.placeholder);
                this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
                this.containers[innermostIndex].containerCache.over = 1;
            }
        },
        _createHelper: function(event) {
            var o = this.options, helper = $.isFunction(o.helper) ? $(o.helper.apply(this.element[0], [
                event,
                this.currentItem
            ])) : o.helper === "clone" ? this.currentItem.clone() : this.currentItem;
            //Add the helper to the DOM if that didn't happen already
            if (!helper.parents("body").length) $(o.appendTo !== "parent" ? o.appendTo : this.currentItem[0].parentNode)[0].appendChild(helper[0]);
            if (helper[0] === this.currentItem[0]) this._storedCSS = {
                width: this.currentItem[0].style.width,
                height: this.currentItem[0].style.height,
                position: this.currentItem.css("position"),
                top: this.currentItem.css("top"),
                left: this.currentItem.css("left")
            };
            if (!helper[0].style.width || o.forceHelperSize) helper.width(this.currentItem.width());
            if (!helper[0].style.height || o.forceHelperSize) helper.height(this.currentItem.height());
            return helper;
        },
        _adjustOffsetFromHelper: function(obj) {
            if (typeof obj === "string") obj = obj.split(" ");
            if ($.isArray(obj)) obj = {
                left: +obj[0],
                top: +obj[1] || 0
            };
            if ("left" in obj) this.offset.click.left = obj.left + this.margins.left;
            if ("right" in obj) this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
            if ("top" in obj) this.offset.click.top = obj.top + this.margins.top;
            if ("bottom" in obj) this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
        },
        _getParentOffset: function() {
            //Get the offsetParent and cache its position
            this.offsetParent = this.helper.offsetParent();
            var po = this.offsetParent.offset();
            // This is a special case where we need to modify a offset calculated on start, since the following happened:
            // 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
            // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
            //    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
            if (this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
                po.left += this.scrollParent.scrollLeft();
                po.top += this.scrollParent.scrollTop();
            }
            // This needs to be actually done for all browsers, since pageX/pageY includes this information
            // with an ugly IE fix
            if (this.offsetParent[0] === document.body || this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() === "html" && $.ui.ie) po = {
                top: 0,
                left: 0
            };
            return {
                top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
                left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
            };
        },
        _getRelativeOffset: function() {
            if (this.cssPosition === "relative") {
                var p = this.currentItem.position();
                return {
                    top: p.top - (parseInt(this.helper.css("top"), 10) || 0) + this.scrollParent.scrollTop(),
                    left: p.left - (parseInt(this.helper.css("left"), 10) || 0) + this.scrollParent.scrollLeft()
                };
            } else return {
                top: 0,
                left: 0
            };
        },
        _cacheMargins: function() {
            this.margins = {
                left: parseInt(this.currentItem.css("marginLeft"), 10) || 0,
                top: parseInt(this.currentItem.css("marginTop"), 10) || 0
            };
        },
        _cacheHelperProportions: function() {
            this.helperProportions = {
                width: this.helper.outerWidth(),
                height: this.helper.outerHeight()
            };
        },
        _setContainment: function() {
            var ce, co, over, o = this.options;
            if (o.containment === "parent") o.containment = this.helper[0].parentNode;
            if (o.containment === "document" || o.containment === "window") this.containment = [
                0 - this.offset.relative.left - this.offset.parent.left,
                0 - this.offset.relative.top - this.offset.parent.top,
                $(o.containment === "document" ? document : window).width() - this.helperProportions.width - this.margins.left,
                ($(o.containment === "document" ? document : window).height() || document.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
            ];
            if (!/^(document|window|parent)$/.test(o.containment)) {
                ce = $(o.containment)[0];
                co = $(o.containment).offset();
                over = $(ce).css("overflow") !== "hidden";
                this.containment = [
                    co.left + (parseInt($(ce).css("borderLeftWidth"), 10) || 0) + (parseInt($(ce).css("paddingLeft"), 10) || 0) - this.margins.left,
                    co.top + (parseInt($(ce).css("borderTopWidth"), 10) || 0) + (parseInt($(ce).css("paddingTop"), 10) || 0) - this.margins.top,
                    co.left + (over ? Math.max(ce.scrollWidth, ce.offsetWidth) : ce.offsetWidth) - (parseInt($(ce).css("borderLeftWidth"), 10) || 0) - (parseInt($(ce).css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left,
                    co.top + (over ? Math.max(ce.scrollHeight, ce.offsetHeight) : ce.offsetHeight) - (parseInt($(ce).css("borderTopWidth"), 10) || 0) - (parseInt($(ce).css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top
                ];
            }
        },
        _convertPositionTo: function(d, pos) {
            if (!pos) pos = this.position;
            var mod = d === "absolute" ? 1 : -1, scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = /(html|body)/i.test(scroll[0].tagName);
            return {
                top: pos.top + // The absolute mouse position
                this.offset.relative.top * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.parent.top * mod - // The offsetParent's offset without borders (offset + border)
                (this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : scrollIsRootNode ? 0 : scroll.scrollTop()) * mod,
                left: pos.left + // The absolute mouse position
                this.offset.relative.left * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.parent.left * mod - // The offsetParent's offset without borders (offset + border)
                (this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft()) * mod
            };
        },
        _generatePosition: function(event) {
            var top, left, o = this.options, pageX = event.pageX, pageY = event.pageY, scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = /(html|body)/i.test(scroll[0].tagName);
            // This is another very weird special case that only happens for relative elements:
            // 1. If the css position is relative
            // 2. and the scroll parent is the document or similar to the offset parent
            // we have to refresh the relative offset during the scroll so there are no jumps
            if (this.cssPosition === "relative" && !(this.scrollParent[0] !== document && this.scrollParent[0] !== this.offsetParent[0])) this.offset.relative = this._getRelativeOffset();
            /*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */ if (this.originalPosition) {
                if (this.containment) {
                    if (event.pageX - this.offset.click.left < this.containment[0]) pageX = this.containment[0] + this.offset.click.left;
                    if (event.pageY - this.offset.click.top < this.containment[1]) pageY = this.containment[1] + this.offset.click.top;
                    if (event.pageX - this.offset.click.left > this.containment[2]) pageX = this.containment[2] + this.offset.click.left;
                    if (event.pageY - this.offset.click.top > this.containment[3]) pageY = this.containment[3] + this.offset.click.top;
                }
                if (o.grid) {
                    top = this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1];
                    pageY = this.containment ? top - this.offset.click.top >= this.containment[1] && top - this.offset.click.top <= this.containment[3] ? top : top - this.offset.click.top >= this.containment[1] ? top - o.grid[1] : top + o.grid[1] : top;
                    left = this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0];
                    pageX = this.containment ? left - this.offset.click.left >= this.containment[0] && left - this.offset.click.left <= this.containment[2] ? left : left - this.offset.click.left >= this.containment[0] ? left - o.grid[0] : left + o.grid[0] : left;
                }
            }
            return {
                top: pageY - // The absolute mouse position
                this.offset.click.top - // Click offset (relative to the element)
                this.offset.relative.top - // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.parent.top + (this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : scrollIsRootNode ? 0 : scroll.scrollTop()),
                left: pageX - // The absolute mouse position
                this.offset.click.left - // Click offset (relative to the element)
                this.offset.relative.left - // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.parent.left + (this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft())
            };
        },
        _rearrange: function(event, i, a, hardRefresh) {
            a ? a[0].appendChild(this.placeholder[0]) : i.item[0].parentNode.insertBefore(this.placeholder[0], this.direction === "down" ? i.item[0] : i.item[0].nextSibling);
            //Various things done here to improve the performance:
            // 1. we create a setTimeout, that calls refreshPositions
            // 2. on the instance, we have a counter variable, that get's higher after every append
            // 3. on the local scope, we copy the counter variable, and check in the timeout, if it's still the same
            // 4. this lets only the last addition to the timeout stack through
            this.counter = this.counter ? ++this.counter : 1;
            var counter = this.counter;
            this._delay(function() {
                if (counter === this.counter) this.refreshPositions(!hardRefresh); //Precompute after each DOM insertion, NOT on mousemove
            });
        },
        _clear: function(event, noPropagation) {
            this.reverting = false;
            // We delay all events that have to be triggered to after the point where the placeholder has been removed and
            // everything else normalized again
            var i, delayedTriggers = [];
            // We first have to update the dom position of the actual currentItem
            // Note: don't do it if the current item is already removed (by a user), or it gets reappended (see #4088)
            if (!this._noFinalSort && this.currentItem.parent().length) this.placeholder.before(this.currentItem);
            this._noFinalSort = null;
            if (this.helper[0] === this.currentItem[0]) {
                for(i in this._storedCSS)if (this._storedCSS[i] === "auto" || this._storedCSS[i] === "static") this._storedCSS[i] = "";
                this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
            } else this.currentItem.show();
            if (this.fromOutside && !noPropagation) delayedTriggers.push(function(event) {
                this._trigger("receive", event, this._uiHash(this.fromOutside));
            });
            if ((this.fromOutside || this.domPosition.prev !== this.currentItem.prev().not(".ui-sortable-helper")[0] || this.domPosition.parent !== this.currentItem.parent()[0]) && !noPropagation) delayedTriggers.push(function(event) {
                this._trigger("update", event, this._uiHash());
            }); //Trigger update callback if the DOM position has changed
            // Check if the items Container has Changed and trigger appropriate
            // events.
            if (this !== this.currentContainer) {
                if (!noPropagation) {
                    delayedTriggers.push(function(event) {
                        this._trigger("remove", event, this._uiHash());
                    });
                    delayedTriggers.push((function(c) {
                        return function(event) {
                            c._trigger("receive", event, this._uiHash(this));
                        };
                    }).call(this, this.currentContainer));
                    delayedTriggers.push((function(c) {
                        return function(event) {
                            c._trigger("update", event, this._uiHash(this));
                        };
                    }).call(this, this.currentContainer));
                }
            }
            //Post events to containers
            function delayEvent(type, instance, container) {
                return function(event) {
                    container._trigger(type, event, instance._uiHash(instance));
                };
            }
            for(i = this.containers.length - 1; i >= 0; i--){
                if (!noPropagation) delayedTriggers.push(delayEvent("deactivate", this, this.containers[i]));
                if (this.containers[i].containerCache.over) {
                    delayedTriggers.push(delayEvent("out", this, this.containers[i]));
                    this.containers[i].containerCache.over = 0;
                }
            }
            //Do what was originally in plugins
            if (this.storedCursor) {
                this.document.find("body").css("cursor", this.storedCursor);
                this.storedStylesheet.remove();
            }
            if (this._storedOpacity) this.helper.css("opacity", this._storedOpacity);
            if (this._storedZIndex) this.helper.css("zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex);
            this.dragging = false;
            if (this.cancelHelperRemoval) {
                if (!noPropagation) {
                    this._trigger("beforeStop", event, this._uiHash());
                    for(i = 0; i < delayedTriggers.length; i++)delayedTriggers[i].call(this, event);
                     //Trigger all delayed events
                    this._trigger("stop", event, this._uiHash());
                }
                this.fromOutside = false;
                return false;
            }
            if (!noPropagation) this._trigger("beforeStop", event, this._uiHash());
            //$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
            this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
            if (this.helper[0] !== this.currentItem[0]) this.helper.remove();
            this.helper = null;
            if (!noPropagation) {
                for(i = 0; i < delayedTriggers.length; i++)delayedTriggers[i].call(this, event);
                 //Trigger all delayed events
                this._trigger("stop", event, this._uiHash());
            }
            this.fromOutside = false;
            return true;
        },
        _trigger: function() {
            if ($.Widget.prototype._trigger.apply(this, arguments) === false) this.cancel();
        },
        _uiHash: function(_inst) {
            var inst = _inst || this;
            return {
                helper: inst.helper,
                placeholder: inst.placeholder || $([]),
                position: inst.position,
                originalPosition: inst.originalPosition,
                offset: inst.positionAbs,
                item: inst.currentItem,
                sender: _inst ? _inst.element : null
            };
        }
    });
    /*!
 * jQuery UI Spinner 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/spinner/
 */ function spinner_modifier(fn) {
        return function() {
            var previous = this.element.val();
            fn.apply(this, arguments);
            this._refresh();
            if (previous !== this.element.val()) this._trigger("change");
        };
    }
    var spinner = $.widget("ui.spinner", {
        version: "1.11.1",
        defaultElement: "<input>",
        widgetEventPrefix: "spin",
        options: {
            culture: null,
            icons: {
                down: "ui-icon-triangle-1-s",
                up: "ui-icon-triangle-1-n"
            },
            incremental: true,
            max: null,
            min: null,
            numberFormat: null,
            page: 10,
            step: 1,
            change: null,
            spin: null,
            start: null,
            stop: null
        },
        _create: function() {
            // handle string values that need to be parsed
            this._setOption("max", this.options.max);
            this._setOption("min", this.options.min);
            this._setOption("step", this.options.step);
            // Only format if there is a value, prevents the field from being marked
            // as invalid in Firefox, see #9573.
            if (this.value() !== "") // Format the value, but don't constrain.
            this._value(this.element.val(), true);
            this._draw();
            this._on(this._events);
            this._refresh();
            // turning off autocomplete prevents the browser from remembering the
            // value when navigating through history, so we re-enable autocomplete
            // if the page is unloaded before the widget is destroyed. #7790
            this._on(this.window, {
                beforeunload: function() {
                    this.element.removeAttr("autocomplete");
                }
            });
        },
        _getCreateOptions: function() {
            var options = {}, element = this.element;
            $.each([
                "min",
                "max",
                "step"
            ], function(i, option) {
                var value = element.attr(option);
                if (value !== undefined && value.length) options[option] = value;
            });
            return options;
        },
        _events: {
            keydown: function(event) {
                if (this._start(event) && this._keydown(event)) event.preventDefault();
            },
            keyup: "_stop",
            focus: function() {
                this.previous = this.element.val();
            },
            blur: function(event) {
                if (this.cancelBlur) {
                    delete this.cancelBlur;
                    return;
                }
                this._stop();
                this._refresh();
                if (this.previous !== this.element.val()) this._trigger("change", event);
            },
            mousewheel: function(event, delta) {
                if (!delta) return;
                if (!this.spinning && !this._start(event)) return false;
                this._spin((delta > 0 ? 1 : -1) * this.options.step, event);
                clearTimeout(this.mousewheelTimer);
                this.mousewheelTimer = this._delay(function() {
                    if (this.spinning) this._stop(event);
                }, 100);
                event.preventDefault();
            },
            "mousedown .ui-spinner-button": function(event) {
                var previous;
                // We never want the buttons to have focus; whenever the user is
                // interacting with the spinner, the focus should be on the input.
                // If the input is focused then this.previous is properly set from
                // when the input first received focus. If the input is not focused
                // then we need to set this.previous based on the value before spinning.
                previous = this.element[0] === this.document[0].activeElement ? this.previous : this.element.val();
                function checkFocus() {
                    var isActive = this.element[0] === this.document[0].activeElement;
                    if (!isActive) {
                        this.element.focus();
                        this.previous = previous;
                        // support: IE
                        // IE sets focus asynchronously, so we need to check if focus
                        // moved off of the input because the user clicked on the button.
                        this._delay(function() {
                            this.previous = previous;
                        });
                    }
                }
                // ensure focus is on (or stays on) the text field
                event.preventDefault();
                checkFocus.call(this);
                // support: IE
                // IE doesn't prevent moving focus even with event.preventDefault()
                // so we set a flag to know when we should ignore the blur event
                // and check (again) if focus moved off of the input.
                this.cancelBlur = true;
                this._delay(function() {
                    delete this.cancelBlur;
                    checkFocus.call(this);
                });
                if (this._start(event) === false) return;
                this._repeat(null, $(event.currentTarget).hasClass("ui-spinner-up") ? 1 : -1, event);
            },
            "mouseup .ui-spinner-button": "_stop",
            "mouseenter .ui-spinner-button": function(event) {
                // button will add ui-state-active if mouse was down while mouseleave and kept down
                if (!$(event.currentTarget).hasClass("ui-state-active")) return;
                if (this._start(event) === false) return false;
                this._repeat(null, $(event.currentTarget).hasClass("ui-spinner-up") ? 1 : -1, event);
            },
            // TODO: do we really want to consider this a stop?
            // shouldn't we just stop the repeater and wait until mouseup before
            // we trigger the stop event?
            "mouseleave .ui-spinner-button": "_stop"
        },
        _draw: function() {
            var uiSpinner = this.uiSpinner = this.element.addClass("ui-spinner-input").attr("autocomplete", "off").wrap(this._uiSpinnerHtml()).parent()// add buttons
            .append(this._buttonHtml());
            this.element.attr("role", "spinbutton");
            // button bindings
            this.buttons = uiSpinner.find(".ui-spinner-button").attr("tabIndex", -1).button().removeClass("ui-corner-all");
            // IE 6 doesn't understand height: 50% for the buttons
            // unless the wrapper has an explicit height
            if (this.buttons.height() > Math.ceil(uiSpinner.height() * 0.5) && uiSpinner.height() > 0) uiSpinner.height(uiSpinner.height());
            // disable spinner if element was already disabled
            if (this.options.disabled) this.disable();
        },
        _keydown: function(event) {
            var options = this.options, keyCode = $.ui.keyCode;
            switch(event.keyCode){
                case keyCode.UP:
                    this._repeat(null, 1, event);
                    return true;
                case keyCode.DOWN:
                    this._repeat(null, -1, event);
                    return true;
                case keyCode.PAGE_UP:
                    this._repeat(null, options.page, event);
                    return true;
                case keyCode.PAGE_DOWN:
                    this._repeat(null, -options.page, event);
                    return true;
            }
            return false;
        },
        _uiSpinnerHtml: function() {
            return "<span class='ui-spinner ui-widget ui-widget-content ui-corner-all'></span>";
        },
        _buttonHtml: function() {
            return "<a class='ui-spinner-button ui-spinner-up ui-corner-tr'><span class='ui-icon " + this.options.icons.up + "'>&#9650;</span>" + "</a>" + "<a class='ui-spinner-button ui-spinner-down ui-corner-br'>" + "<span class='ui-icon " + this.options.icons.down + "'>&#9660;</span>" + "</a>";
        },
        _start: function(event) {
            if (!this.spinning && this._trigger("start", event) === false) return false;
            if (!this.counter) this.counter = 1;
            this.spinning = true;
            return true;
        },
        _repeat: function(i, steps, event) {
            i = i || 500;
            clearTimeout(this.timer);
            this.timer = this._delay(function() {
                this._repeat(40, steps, event);
            }, i);
            this._spin(steps * this.options.step, event);
        },
        _spin: function(step, event) {
            var value = this.value() || 0;
            if (!this.counter) this.counter = 1;
            value = this._adjustValue(value + step * this._increment(this.counter));
            if (!this.spinning || this._trigger("spin", event, {
                value: value
            }) !== false) {
                this._value(value);
                this.counter++;
            }
        },
        _increment: function(i) {
            var incremental = this.options.incremental;
            if (incremental) return $.isFunction(incremental) ? incremental(i) : Math.floor(i * i * i / 50000 - i * i / 500 + 17 * i / 200 + 1);
            return 1;
        },
        _precision: function() {
            var precision = this._precisionOf(this.options.step);
            if (this.options.min !== null) precision = Math.max(precision, this._precisionOf(this.options.min));
            return precision;
        },
        _precisionOf: function(num) {
            var str = num.toString(), decimal = str.indexOf(".");
            return decimal === -1 ? 0 : str.length - decimal - 1;
        },
        _adjustValue: function(value) {
            var base, aboveMin, options = this.options;
            // make sure we're at a valid step
            // - find out where we are relative to the base (min or 0)
            base = options.min !== null ? options.min : 0;
            aboveMin = value - base;
            // - round to the nearest step
            aboveMin = Math.round(aboveMin / options.step) * options.step;
            // - rounding is based on 0, so adjust back to our base
            value = base + aboveMin;
            // fix precision from bad JS floating point math
            value = parseFloat(value.toFixed(this._precision()));
            // clamp the value
            if (options.max !== null && value > options.max) return options.max;
            if (options.min !== null && value < options.min) return options.min;
            return value;
        },
        _stop: function(event) {
            if (!this.spinning) return;
            clearTimeout(this.timer);
            clearTimeout(this.mousewheelTimer);
            this.counter = 0;
            this.spinning = false;
            this._trigger("stop", event);
        },
        _setOption: function(key, value) {
            if (key === "culture" || key === "numberFormat") {
                var prevValue = this._parse(this.element.val());
                this.options[key] = value;
                this.element.val(this._format(prevValue));
                return;
            }
            if (key === "max" || key === "min" || key === "step") {
                if (typeof value === "string") value = this._parse(value);
            }
            if (key === "icons") {
                this.buttons.first().find(".ui-icon").removeClass(this.options.icons.up).addClass(value.up);
                this.buttons.last().find(".ui-icon").removeClass(this.options.icons.down).addClass(value.down);
            }
            this._super(key, value);
            if (key === "disabled") {
                this.widget().toggleClass("ui-state-disabled", !!value);
                this.element.prop("disabled", !!value);
                this.buttons.button(value ? "disable" : "enable");
            }
        },
        _setOptions: spinner_modifier(function(options) {
            this._super(options);
        }),
        _parse: function(val) {
            if (typeof val === "string" && val !== "") val = window.Globalize && this.options.numberFormat ? Globalize.parseFloat(val, 10, this.options.culture) : +val;
            return val === "" || isNaN(val) ? null : val;
        },
        _format: function(value) {
            if (value === "") return "";
            return window.Globalize && this.options.numberFormat ? Globalize.format(value, this.options.numberFormat, this.options.culture) : value;
        },
        _refresh: function() {
            this.element.attr({
                "aria-valuemin": this.options.min,
                "aria-valuemax": this.options.max,
                // TODO: what should we do with values that can't be parsed?
                "aria-valuenow": this._parse(this.element.val())
            });
        },
        isValid: function() {
            var value = this.value();
            // null is invalid
            if (value === null) return false;
            // if value gets adjusted, it's invalid
            return value === this._adjustValue(value);
        },
        // update the value without triggering change
        _value: function(value, allowAny) {
            var parsed;
            if (value !== "") {
                parsed = this._parse(value);
                if (parsed !== null) {
                    if (!allowAny) parsed = this._adjustValue(parsed);
                    value = this._format(parsed);
                }
            }
            this.element.val(value);
            this._refresh();
        },
        _destroy: function() {
            this.element.removeClass("ui-spinner-input").prop("disabled", false).removeAttr("autocomplete").removeAttr("role").removeAttr("aria-valuemin").removeAttr("aria-valuemax").removeAttr("aria-valuenow");
            this.uiSpinner.replaceWith(this.element);
        },
        stepUp: spinner_modifier(function(steps) {
            this._stepUp(steps);
        }),
        _stepUp: function(steps) {
            if (this._start()) {
                this._spin((steps || 1) * this.options.step);
                this._stop();
            }
        },
        stepDown: spinner_modifier(function(steps) {
            this._stepDown(steps);
        }),
        _stepDown: function(steps) {
            if (this._start()) {
                this._spin((steps || 1) * -this.options.step);
                this._stop();
            }
        },
        pageUp: spinner_modifier(function(pages) {
            this._stepUp((pages || 1) * this.options.page);
        }),
        pageDown: spinner_modifier(function(pages) {
            this._stepDown((pages || 1) * this.options.page);
        }),
        value: function(newVal) {
            if (!arguments.length) return this._parse(this.element.val());
            spinner_modifier(this._value).call(this, newVal);
        },
        widget: function() {
            return this.uiSpinner;
        }
    });
    /*!
 * jQuery UI Tabs 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/tabs/
 */ var tabs = $.widget("ui.tabs", {
        version: "1.11.1",
        delay: 300,
        options: {
            active: null,
            collapsible: false,
            event: "click",
            heightStyle: "content",
            hide: null,
            show: null,
            // callbacks
            activate: null,
            beforeActivate: null,
            beforeLoad: null,
            load: null
        },
        _isLocal: function() {
            var rhash = /#.*$/;
            return function(anchor) {
                var anchorUrl, locationUrl;
                // support: IE7
                // IE7 doesn't normalize the href property when set via script (#9317)
                anchor = anchor.cloneNode(false);
                anchorUrl = anchor.href.replace(rhash, "");
                locationUrl = location.href.replace(rhash, "");
                // decoding may throw an error if the URL isn't UTF-8 (#9518)
                try {
                    anchorUrl = decodeURIComponent(anchorUrl);
                } catch (error) {}
                try {
                    locationUrl = decodeURIComponent(locationUrl);
                } catch (error) {}
                return anchor.hash.length > 1 && anchorUrl === locationUrl;
            };
        }(),
        _create: function() {
            var that = this, options = this.options;
            this.running = false;
            this.element.addClass("ui-tabs ui-widget ui-widget-content ui-corner-all").toggleClass("ui-tabs-collapsible", options.collapsible);
            this._processTabs();
            options.active = this._initialActive();
            // Take disabling tabs via class attribute from HTML
            // into account and update option properly.
            if ($.isArray(options.disabled)) options.disabled = $.unique(options.disabled.concat($.map(this.tabs.filter(".ui-state-disabled"), function(li) {
                return that.tabs.index(li);
            }))).sort();
            // check for length avoids error when initializing empty list
            if (this.options.active !== false && this.anchors.length) this.active = this._findActive(options.active);
            else this.active = $();
            this._refresh();
            if (this.active.length) this.load(options.active);
        },
        _initialActive: function() {
            var active = this.options.active, collapsible = this.options.collapsible, locationHash = location.hash.substring(1);
            if (active === null) {
                // check the fragment identifier in the URL
                if (locationHash) this.tabs.each(function(i, tab) {
                    if ($(tab).attr("aria-controls") === locationHash) {
                        active = i;
                        return false;
                    }
                });
                // check for a tab marked active via a class
                if (active === null) active = this.tabs.index(this.tabs.filter(".ui-tabs-active"));
                // no active tab, set to false
                if (active === null || active === -1) active = this.tabs.length ? 0 : false;
            }
            // handle numbers: negative, out of range
            if (active !== false) {
                active = this.tabs.index(this.tabs.eq(active));
                if (active === -1) active = collapsible ? false : 0;
            }
            // don't allow collapsible: false and active: false
            if (!collapsible && active === false && this.anchors.length) active = 0;
            return active;
        },
        _getCreateEventData: function() {
            return {
                tab: this.active,
                panel: !this.active.length ? $() : this._getPanelForTab(this.active)
            };
        },
        _tabKeydown: function(event) {
            var focusedTab = $(this.document[0].activeElement).closest("li"), selectedIndex = this.tabs.index(focusedTab), goingForward = true;
            if (this._handlePageNav(event)) return;
            switch(event.keyCode){
                case $.ui.keyCode.RIGHT:
                case $.ui.keyCode.DOWN:
                    selectedIndex++;
                    break;
                case $.ui.keyCode.UP:
                case $.ui.keyCode.LEFT:
                    goingForward = false;
                    selectedIndex--;
                    break;
                case $.ui.keyCode.END:
                    selectedIndex = this.anchors.length - 1;
                    break;
                case $.ui.keyCode.HOME:
                    selectedIndex = 0;
                    break;
                case $.ui.keyCode.SPACE:
                    // Activate only, no collapsing
                    event.preventDefault();
                    clearTimeout(this.activating);
                    this._activate(selectedIndex);
                    return;
                case $.ui.keyCode.ENTER:
                    // Toggle (cancel delayed activation, allow collapsing)
                    event.preventDefault();
                    clearTimeout(this.activating);
                    // Determine if we should collapse or activate
                    this._activate(selectedIndex === this.options.active ? false : selectedIndex);
                    return;
                default:
                    return;
            }
            // Focus the appropriate tab, based on which key was pressed
            event.preventDefault();
            clearTimeout(this.activating);
            selectedIndex = this._focusNextTab(selectedIndex, goingForward);
            // Navigating with control key will prevent automatic activation
            if (!event.ctrlKey) {
                // Update aria-selected immediately so that AT think the tab is already selected.
                // Otherwise AT may confuse the user by stating that they need to activate the tab,
                // but the tab will already be activated by the time the announcement finishes.
                focusedTab.attr("aria-selected", "false");
                this.tabs.eq(selectedIndex).attr("aria-selected", "true");
                this.activating = this._delay(function() {
                    this.option("active", selectedIndex);
                }, this.delay);
            }
        },
        _panelKeydown: function(event) {
            if (this._handlePageNav(event)) return;
            // Ctrl+up moves focus to the current tab
            if (event.ctrlKey && event.keyCode === $.ui.keyCode.UP) {
                event.preventDefault();
                this.active.focus();
            }
        },
        // Alt+page up/down moves focus to the previous/next tab (and activates)
        _handlePageNav: function(event) {
            if (event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP) {
                this._activate(this._focusNextTab(this.options.active - 1, false));
                return true;
            }
            if (event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN) {
                this._activate(this._focusNextTab(this.options.active + 1, true));
                return true;
            }
        },
        _findNextTab: function(index, goingForward) {
            var lastTabIndex = this.tabs.length - 1;
            function constrain() {
                if (index > lastTabIndex) index = 0;
                if (index < 0) index = lastTabIndex;
                return index;
            }
            while($.inArray(constrain(), this.options.disabled) !== -1)index = goingForward ? index + 1 : index - 1;
            return index;
        },
        _focusNextTab: function(index, goingForward) {
            index = this._findNextTab(index, goingForward);
            this.tabs.eq(index).focus();
            return index;
        },
        _setOption: function(key, value) {
            if (key === "active") {
                // _activate() will handle invalid values and update this.options
                this._activate(value);
                return;
            }
            if (key === "disabled") {
                // don't use the widget factory's disabled handling
                this._setupDisabled(value);
                return;
            }
            this._super(key, value);
            if (key === "collapsible") {
                this.element.toggleClass("ui-tabs-collapsible", value);
                // Setting collapsible: false while collapsed; open first panel
                if (!value && this.options.active === false) this._activate(0);
            }
            if (key === "event") this._setupEvents(value);
            if (key === "heightStyle") this._setupHeightStyle(value);
        },
        _sanitizeSelector: function(hash) {
            return hash ? hash.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&") : "";
        },
        refresh: function() {
            var options = this.options, lis = this.tablist.children(":has(a[href])");
            // get disabled tabs from class attribute from HTML
            // this will get converted to a boolean if needed in _refresh()
            options.disabled = $.map(lis.filter(".ui-state-disabled"), function(tab) {
                return lis.index(tab);
            });
            this._processTabs();
            // was collapsed or no tabs
            if (options.active === false || !this.anchors.length) {
                options.active = false;
                this.active = $();
            // was active, but active tab is gone
            } else if (this.active.length && !$.contains(this.tablist[0], this.active[0])) {
                // all remaining tabs are disabled
                if (this.tabs.length === options.disabled.length) {
                    options.active = false;
                    this.active = $();
                // activate previous tab
                } else this._activate(this._findNextTab(Math.max(0, options.active - 1), false));
            } else // make sure active index is correct
            options.active = this.tabs.index(this.active);
            this._refresh();
        },
        _refresh: function() {
            this._setupDisabled(this.options.disabled);
            this._setupEvents(this.options.event);
            this._setupHeightStyle(this.options.heightStyle);
            this.tabs.not(this.active).attr({
                "aria-selected": "false",
                "aria-expanded": "false",
                tabIndex: -1
            });
            this.panels.not(this._getPanelForTab(this.active)).hide().attr({
                "aria-hidden": "true"
            });
            // Make sure one tab is in the tab order
            if (!this.active.length) this.tabs.eq(0).attr("tabIndex", 0);
            else {
                this.active.addClass("ui-tabs-active ui-state-active").attr({
                    "aria-selected": "true",
                    "aria-expanded": "true",
                    tabIndex: 0
                });
                this._getPanelForTab(this.active).show().attr({
                    "aria-hidden": "false"
                });
            }
        },
        _processTabs: function() {
            var that = this;
            this.tablist = this._getList().addClass("ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all").attr("role", "tablist")// Prevent users from focusing disabled tabs via click
            .delegate("> li", "mousedown" + this.eventNamespace, function(event) {
                if ($(this).is(".ui-state-disabled")) event.preventDefault();
            })// support: IE <9
            // Preventing the default action in mousedown doesn't prevent IE
            // from focusing the element, so if the anchor gets focused, blur.
            // We don't have to worry about focusing the previously focused
            // element since clicking on a non-focusable element should focus
            // the body anyway.
            .delegate(".ui-tabs-anchor", "focus" + this.eventNamespace, function() {
                if ($(this).closest("li").is(".ui-state-disabled")) this.blur();
            });
            this.tabs = this.tablist.find("> li:has(a[href])").addClass("ui-state-default ui-corner-top").attr({
                role: "tab",
                tabIndex: -1
            });
            this.anchors = this.tabs.map(function() {
                return $("a", this)[0];
            }).addClass("ui-tabs-anchor").attr({
                role: "presentation",
                tabIndex: -1
            });
            this.panels = $();
            this.anchors.each(function(i, anchor) {
                var selector, panel, panelId, anchorId = $(anchor).uniqueId().attr("id"), tab = $(anchor).closest("li"), originalAriaControls = tab.attr("aria-controls");
                // inline tab
                if (that._isLocal(anchor)) {
                    selector = anchor.hash;
                    panelId = selector.substring(1);
                    panel = that.element.find(that._sanitizeSelector(selector));
                // remote tab
                } else {
                    // If the tab doesn't already have aria-controls,
                    // generate an id by using a throw-away element
                    panelId = tab.attr("aria-controls") || $({}).uniqueId()[0].id;
                    selector = "#" + panelId;
                    panel = that.element.find(selector);
                    if (!panel.length) {
                        panel = that._createPanel(panelId);
                        panel.insertAfter(that.panels[i - 1] || that.tablist);
                    }
                    panel.attr("aria-live", "polite");
                }
                if (panel.length) that.panels = that.panels.add(panel);
                if (originalAriaControls) tab.data("ui-tabs-aria-controls", originalAriaControls);
                tab.attr({
                    "aria-controls": panelId,
                    "aria-labelledby": anchorId
                });
                panel.attr("aria-labelledby", anchorId);
            });
            this.panels.addClass("ui-tabs-panel ui-widget-content ui-corner-bottom").attr("role", "tabpanel");
        },
        // allow overriding how to find the list for rare usage scenarios (#7715)
        _getList: function() {
            return this.tablist || this.element.find("ol,ul").eq(0);
        },
        _createPanel: function(id) {
            return $("<div>").attr("id", id).addClass("ui-tabs-panel ui-widget-content ui-corner-bottom").data("ui-tabs-destroy", true);
        },
        _setupDisabled: function(disabled) {
            if ($.isArray(disabled)) {
                if (!disabled.length) disabled = false;
                else if (disabled.length === this.anchors.length) disabled = true;
            }
            // disable tabs
            for(var i = 0, li; li = this.tabs[i]; i++)if (disabled === true || $.inArray(i, disabled) !== -1) $(li).addClass("ui-state-disabled").attr("aria-disabled", "true");
            else $(li).removeClass("ui-state-disabled").removeAttr("aria-disabled");
            this.options.disabled = disabled;
        },
        _setupEvents: function(event) {
            var events = {};
            if (event) $.each(event.split(" "), function(index, eventName) {
                events[eventName] = "_eventHandler";
            });
            this._off(this.anchors.add(this.tabs).add(this.panels));
            // Always prevent the default action, even when disabled
            this._on(true, this.anchors, {
                click: function(event) {
                    event.preventDefault();
                }
            });
            this._on(this.anchors, events);
            this._on(this.tabs, {
                keydown: "_tabKeydown"
            });
            this._on(this.panels, {
                keydown: "_panelKeydown"
            });
            this._focusable(this.tabs);
            this._hoverable(this.tabs);
        },
        _setupHeightStyle: function(heightStyle) {
            var maxHeight, parent = this.element.parent();
            if (heightStyle === "fill") {
                maxHeight = parent.height();
                maxHeight -= this.element.outerHeight() - this.element.height();
                this.element.siblings(":visible").each(function() {
                    var elem = $(this), position = elem.css("position");
                    if (position === "absolute" || position === "fixed") return;
                    maxHeight -= elem.outerHeight(true);
                });
                this.element.children().not(this.panels).each(function() {
                    maxHeight -= $(this).outerHeight(true);
                });
                this.panels.each(function() {
                    $(this).height(Math.max(0, maxHeight - $(this).innerHeight() + $(this).height()));
                }).css("overflow", "auto");
            } else if (heightStyle === "auto") {
                maxHeight = 0;
                this.panels.each(function() {
                    maxHeight = Math.max(maxHeight, $(this).height("").height());
                }).height(maxHeight);
            }
        },
        _eventHandler: function(event) {
            var options = this.options, active = this.active, anchor = $(event.currentTarget), tab = anchor.closest("li"), clickedIsActive = tab[0] === active[0], collapsing = clickedIsActive && options.collapsible, toShow = collapsing ? $() : this._getPanelForTab(tab), toHide = !active.length ? $() : this._getPanelForTab(active), eventData = {
                oldTab: active,
                oldPanel: toHide,
                newTab: collapsing ? $() : tab,
                newPanel: toShow
            };
            event.preventDefault();
            if (tab.hasClass("ui-state-disabled") || // tab is already loading
            tab.hasClass("ui-tabs-loading") || // can't switch durning an animation
            this.running || // click on active header, but not collapsible
            clickedIsActive && !options.collapsible || // allow canceling activation
            this._trigger("beforeActivate", event, eventData) === false) return;
            options.active = collapsing ? false : this.tabs.index(tab);
            this.active = clickedIsActive ? $() : tab;
            if (this.xhr) this.xhr.abort();
            if (!toHide.length && !toShow.length) $.error("jQuery UI Tabs: Mismatching fragment identifier.");
            if (toShow.length) this.load(this.tabs.index(tab), event);
            this._toggle(event, eventData);
        },
        // handles show/hide for selecting tabs
        _toggle: function(event, eventData) {
            var that = this, toShow = eventData.newPanel, toHide = eventData.oldPanel;
            this.running = true;
            function complete() {
                that.running = false;
                that._trigger("activate", event, eventData);
            }
            function show() {
                eventData.newTab.closest("li").addClass("ui-tabs-active ui-state-active");
                if (toShow.length && that.options.show) that._show(toShow, that.options.show, complete);
                else {
                    toShow.show();
                    complete();
                }
            }
            // start out by hiding, then showing, then completing
            if (toHide.length && this.options.hide) this._hide(toHide, this.options.hide, function() {
                eventData.oldTab.closest("li").removeClass("ui-tabs-active ui-state-active");
                show();
            });
            else {
                eventData.oldTab.closest("li").removeClass("ui-tabs-active ui-state-active");
                toHide.hide();
                show();
            }
            toHide.attr("aria-hidden", "true");
            eventData.oldTab.attr({
                "aria-selected": "false",
                "aria-expanded": "false"
            });
            // If we're switching tabs, remove the old tab from the tab order.
            // If we're opening from collapsed state, remove the previous tab from the tab order.
            // If we're collapsing, then keep the collapsing tab in the tab order.
            if (toShow.length && toHide.length) eventData.oldTab.attr("tabIndex", -1);
            else if (toShow.length) this.tabs.filter(function() {
                return $(this).attr("tabIndex") === 0;
            }).attr("tabIndex", -1);
            toShow.attr("aria-hidden", "false");
            eventData.newTab.attr({
                "aria-selected": "true",
                "aria-expanded": "true",
                tabIndex: 0
            });
        },
        _activate: function(index) {
            var anchor, active = this._findActive(index);
            // trying to activate the already active panel
            if (active[0] === this.active[0]) return;
            // trying to collapse, simulate a click on the current active header
            if (!active.length) active = this.active;
            anchor = active.find(".ui-tabs-anchor")[0];
            this._eventHandler({
                target: anchor,
                currentTarget: anchor,
                preventDefault: $.noop
            });
        },
        _findActive: function(index) {
            return index === false ? $() : this.tabs.eq(index);
        },
        _getIndex: function(index) {
            // meta-function to give users option to provide a href string instead of a numerical index.
            if (typeof index === "string") index = this.anchors.index(this.anchors.filter("[href$='" + index + "']"));
            return index;
        },
        _destroy: function() {
            if (this.xhr) this.xhr.abort();
            this.element.removeClass("ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible");
            this.tablist.removeClass("ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all").removeAttr("role");
            this.anchors.removeClass("ui-tabs-anchor").removeAttr("role").removeAttr("tabIndex").removeUniqueId();
            this.tablist.unbind(this.eventNamespace);
            this.tabs.add(this.panels).each(function() {
                if ($.data(this, "ui-tabs-destroy")) $(this).remove();
                else $(this).removeClass("ui-state-default ui-state-active ui-state-disabled ui-corner-top ui-corner-bottom ui-widget-content ui-tabs-active ui-tabs-panel").removeAttr("tabIndex").removeAttr("aria-live").removeAttr("aria-busy").removeAttr("aria-selected").removeAttr("aria-labelledby").removeAttr("aria-hidden").removeAttr("aria-expanded").removeAttr("role");
            });
            this.tabs.each(function() {
                var li = $(this), prev = li.data("ui-tabs-aria-controls");
                if (prev) li.attr("aria-controls", prev).removeData("ui-tabs-aria-controls");
                else li.removeAttr("aria-controls");
            });
            this.panels.show();
            if (this.options.heightStyle !== "content") this.panels.css("height", "");
        },
        enable: function(index) {
            var disabled = this.options.disabled;
            if (disabled === false) return;
            if (index === undefined) disabled = false;
            else {
                index = this._getIndex(index);
                if ($.isArray(disabled)) disabled = $.map(disabled, function(num) {
                    return num !== index ? num : null;
                });
                else disabled = $.map(this.tabs, function(li, num) {
                    return num !== index ? num : null;
                });
            }
            this._setupDisabled(disabled);
        },
        disable: function(index) {
            var disabled = this.options.disabled;
            if (disabled === true) return;
            if (index === undefined) disabled = true;
            else {
                index = this._getIndex(index);
                if ($.inArray(index, disabled) !== -1) return;
                if ($.isArray(disabled)) disabled = $.merge([
                    index
                ], disabled).sort();
                else disabled = [
                    index
                ];
            }
            this._setupDisabled(disabled);
        },
        load: function(index, event) {
            index = this._getIndex(index);
            var that = this, tab = this.tabs.eq(index), anchor = tab.find(".ui-tabs-anchor"), panel = this._getPanelForTab(tab), eventData = {
                tab: tab,
                panel: panel
            };
            // not remote
            if (this._isLocal(anchor[0])) return;
            this.xhr = $.ajax(this._ajaxSettings(anchor, event, eventData));
            // support: jQuery <1.8
            // jQuery <1.8 returns false if the request is canceled in beforeSend,
            // but as of 1.8, $.ajax() always returns a jqXHR object.
            if (this.xhr && this.xhr.statusText !== "canceled") {
                tab.addClass("ui-tabs-loading");
                panel.attr("aria-busy", "true");
                this.xhr.success(function(response) {
                    // support: jQuery <1.8
                    // http://bugs.jquery.com/ticket/11778
                    setTimeout(function() {
                        panel.html(response);
                        that._trigger("load", event, eventData);
                    }, 1);
                }).complete(function(jqXHR, status) {
                    // support: jQuery <1.8
                    // http://bugs.jquery.com/ticket/11778
                    setTimeout(function() {
                        if (status === "abort") that.panels.stop(false, true);
                        tab.removeClass("ui-tabs-loading");
                        panel.removeAttr("aria-busy");
                        if (jqXHR === that.xhr) delete that.xhr;
                    }, 1);
                });
            }
        },
        _ajaxSettings: function(anchor, event, eventData) {
            var that = this;
            return {
                url: anchor.attr("href"),
                beforeSend: function(jqXHR, settings) {
                    return that._trigger("beforeLoad", event, $.extend({
                        jqXHR: jqXHR,
                        ajaxSettings: settings
                    }, eventData));
                }
            };
        },
        _getPanelForTab: function(tab) {
            var id = $(tab).attr("aria-controls");
            return this.element.find(this._sanitizeSelector("#" + id));
        }
    });
    /*!
 * jQuery UI Tooltip 1.11.1
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/tooltip/
 */ var tooltip = $.widget("ui.tooltip", {
        version: "1.11.1",
        options: {
            content: function() {
                // support: IE<9, Opera in jQuery <1.7
                // .text() can't accept undefined, so coerce to a string
                var title = $(this).attr("title") || "";
                // Escape title, since we're going from an attribute to raw HTML
                return $("<a>").text(title).html();
            },
            hide: true,
            // Disabled elements have inconsistent behavior across browsers (#8661)
            items: "[title]:not([disabled])",
            position: {
                my: "left top+15",
                at: "left bottom",
                collision: "flipfit flip"
            },
            show: true,
            tooltipClass: null,
            track: false,
            // callbacks
            close: null,
            open: null
        },
        _addDescribedBy: function(elem, id) {
            var describedby = (elem.attr("aria-describedby") || "").split(/\s+/);
            describedby.push(id);
            elem.data("ui-tooltip-id", id).attr("aria-describedby", $.trim(describedby.join(" ")));
        },
        _removeDescribedBy: function(elem) {
            var id = elem.data("ui-tooltip-id"), describedby = (elem.attr("aria-describedby") || "").split(/\s+/), index = $.inArray(id, describedby);
            if (index !== -1) describedby.splice(index, 1);
            elem.removeData("ui-tooltip-id");
            describedby = $.trim(describedby.join(" "));
            if (describedby) elem.attr("aria-describedby", describedby);
            else elem.removeAttr("aria-describedby");
        },
        _create: function() {
            this._on({
                mouseover: "open",
                focusin: "open"
            });
            // IDs of generated tooltips, needed for destroy
            this.tooltips = {};
            // IDs of parent tooltips where we removed the title attribute
            this.parents = {};
            if (this.options.disabled) this._disable();
            // Append the aria-live region so tooltips announce correctly
            this.liveRegion = $("<div>").attr({
                role: "log",
                "aria-live": "assertive",
                "aria-relevant": "additions"
            }).addClass("ui-helper-hidden-accessible").appendTo(this.document[0].body);
        },
        _setOption: function(key, value) {
            var that = this;
            if (key === "disabled") {
                this[value ? "_disable" : "_enable"]();
                this.options[key] = value;
                // disable element style changes
                return;
            }
            this._super(key, value);
            if (key === "content") $.each(this.tooltips, function(id, element) {
                that._updateContent(element);
            });
        },
        _disable: function() {
            var that = this;
            // close open tooltips
            $.each(this.tooltips, function(id, element) {
                var event = $.Event("blur");
                event.target = event.currentTarget = element[0];
                that.close(event, true);
            });
            // remove title attributes to prevent native tooltips
            this.element.find(this.options.items).addBack().each(function() {
                var element = $(this);
                if (element.is("[title]")) element.data("ui-tooltip-title", element.attr("title")).removeAttr("title");
            });
        },
        _enable: function() {
            // restore title attributes
            this.element.find(this.options.items).addBack().each(function() {
                var element = $(this);
                if (element.data("ui-tooltip-title")) element.attr("title", element.data("ui-tooltip-title"));
            });
        },
        open: function(event) {
            var that = this, target = $(event ? event.target : this.element)// we need closest here due to mouseover bubbling,
            // but always pointing at the same event target
            .closest(this.options.items);
            // No element to show a tooltip for or the tooltip is already open
            if (!target.length || target.data("ui-tooltip-id")) return;
            if (target.attr("title")) target.data("ui-tooltip-title", target.attr("title"));
            target.data("ui-tooltip-open", true);
            // kill parent tooltips, custom or native, for hover
            if (event && event.type === "mouseover") target.parents().each(function() {
                var parent = $(this), blurEvent;
                if (parent.data("ui-tooltip-open")) {
                    blurEvent = $.Event("blur");
                    blurEvent.target = blurEvent.currentTarget = this;
                    that.close(blurEvent, true);
                }
                if (parent.attr("title")) {
                    parent.uniqueId();
                    that.parents[this.id] = {
                        element: this,
                        title: parent.attr("title")
                    };
                    parent.attr("title", "");
                }
            });
            this._updateContent(target, event);
        },
        _updateContent: function(target, event) {
            var content, contentOption = this.options.content, that = this, eventType = event ? event.type : null;
            if (typeof contentOption === "string") return this._open(event, target, contentOption);
            content = contentOption.call(target[0], function(response) {
                // ignore async response if tooltip was closed already
                if (!target.data("ui-tooltip-open")) return;
                // IE may instantly serve a cached response for ajax requests
                // delay this call to _open so the other call to _open runs first
                that._delay(function() {
                    // jQuery creates a special event for focusin when it doesn't
                    // exist natively. To improve performance, the native event
                    // object is reused and the type is changed. Therefore, we can't
                    // rely on the type being correct after the event finished
                    // bubbling, so we set it back to the previous value. (#8740)
                    if (event) event.type = eventType;
                    this._open(event, target, response);
                });
            });
            if (content) this._open(event, target, content);
        },
        _open: function(event, target, content) {
            var tooltip, events, delayedShow, a11yContent, positionOption = $.extend({}, this.options.position);
            if (!content) return;
            // Content can be updated multiple times. If the tooltip already
            // exists, then just update the content and bail.
            tooltip = this._find(target);
            if (tooltip.length) {
                tooltip.find(".ui-tooltip-content").html(content);
                return;
            }
            // if we have a title, clear it to prevent the native tooltip
            // we have to check first to avoid defining a title if none exists
            // (we don't want to cause an element to start matching [title])
            //
            // We use removeAttr only for key events, to allow IE to export the correct
            // accessible attributes. For mouse events, set to empty string to avoid
            // native tooltip showing up (happens only when removing inside mouseover).
            if (target.is("[title]")) {
                if (event && event.type === "mouseover") target.attr("title", "");
                else target.removeAttr("title");
            }
            tooltip = this._tooltip(target);
            this._addDescribedBy(target, tooltip.attr("id"));
            tooltip.find(".ui-tooltip-content").html(content);
            // Support: Voiceover on OS X, JAWS on IE <= 9
            // JAWS announces deletions even when aria-relevant="additions"
            // Voiceover will sometimes re-read the entire log region's contents from the beginning
            this.liveRegion.children().hide();
            if (content.clone) {
                a11yContent = content.clone();
                a11yContent.removeAttr("id").find("[id]").removeAttr("id");
            } else a11yContent = content;
            $("<div>").html(a11yContent).appendTo(this.liveRegion);
            function position(event) {
                positionOption.of = event;
                if (tooltip.is(":hidden")) return;
                tooltip.position(positionOption);
            }
            if (this.options.track && event && /^mouse/.test(event.type)) {
                this._on(this.document, {
                    mousemove: position
                });
                // trigger once to override element-relative positioning
                position(event);
            } else tooltip.position($.extend({
                of: target
            }, this.options.position));
            this.hiding = false;
            this.closing = false;
            tooltip.hide();
            this._show(tooltip, this.options.show);
            // Handle tracking tooltips that are shown with a delay (#8644). As soon
            // as the tooltip is visible, position the tooltip using the most recent
            // event.
            if (this.options.show && this.options.show.delay) delayedShow = this.delayedShow = setInterval(function() {
                if (tooltip.is(":visible")) {
                    position(positionOption.of);
                    clearInterval(delayedShow);
                }
            }, $.fx.interval);
            this._trigger("open", event, {
                tooltip: tooltip
            });
            events = {
                keyup: function(event) {
                    if (event.keyCode === $.ui.keyCode.ESCAPE) {
                        var fakeEvent = $.Event(event);
                        fakeEvent.currentTarget = target[0];
                        this.close(fakeEvent, true);
                    }
                }
            };
            // Only bind remove handler for delegated targets. Non-delegated
            // tooltips will handle this in destroy.
            if (target[0] !== this.element[0]) events.remove = function() {
                this._removeTooltip(tooltip);
            };
            if (!event || event.type === "mouseover") events.mouseleave = "close";
            if (!event || event.type === "focusin") events.focusout = "close";
            this._on(true, target, events);
        },
        close: function(event) {
            var that = this, target = $(event ? event.currentTarget : this.element), tooltip = this._find(target);
            // disabling closes the tooltip, so we need to track when we're closing
            // to avoid an infinite loop in case the tooltip becomes disabled on close
            if (this.closing) return;
            // Clear the interval for delayed tracking tooltips
            clearInterval(this.delayedShow);
            // only set title if we had one before (see comment in _open())
            // If the title attribute has changed since open(), don't restore
            if (target.data("ui-tooltip-title") && !target.attr("title")) target.attr("title", target.data("ui-tooltip-title"));
            this._removeDescribedBy(target);
            this.hiding = true;
            tooltip.stop(true);
            this._hide(tooltip, this.options.hide, function() {
                that._removeTooltip($(this));
                this.hiding = false;
                this.closing = false;
            });
            target.removeData("ui-tooltip-open");
            this._off(target, "mouseleave focusout keyup");
            // Remove 'remove' binding only on delegated targets
            if (target[0] !== this.element[0]) this._off(target, "remove");
            this._off(this.document, "mousemove");
            if (event && event.type === "mouseleave") $.each(this.parents, function(id, parent) {
                $(parent.element).attr("title", parent.title);
                delete that.parents[id];
            });
            this.closing = true;
            this._trigger("close", event, {
                tooltip: tooltip
            });
            if (!this.hiding) this.closing = false;
        },
        _tooltip: function(element) {
            var tooltip = $("<div>").attr("role", "tooltip").addClass("ui-tooltip ui-widget ui-corner-all ui-widget-content " + (this.options.tooltipClass || "")), id = tooltip.uniqueId().attr("id");
            $("<div>").addClass("ui-tooltip-content").appendTo(tooltip);
            tooltip.appendTo(this.document[0].body);
            this.tooltips[id] = element;
            return tooltip;
        },
        _find: function(target) {
            var id = target.data("ui-tooltip-id");
            return id ? $("#" + id) : $();
        },
        _removeTooltip: function(tooltip) {
            tooltip.remove();
            delete this.tooltips[tooltip.attr("id")];
        },
        _destroy: function() {
            var that = this;
            // close open tooltips
            $.each(this.tooltips, function(id, element) {
                // Delegate to close method to handle common cleanup
                var event = $.Event("blur");
                event.target = event.currentTarget = element[0];
                that.close(event, true);
                // Remove immediately; destroying an open tooltip doesn't use the
                // hide animation
                $("#" + id).remove();
                // Restore the title
                if (element.data("ui-tooltip-title")) {
                    // If the title attribute has changed since open(), don't restore
                    if (!element.attr("title")) element.attr("title", element.data("ui-tooltip-title"));
                    element.removeData("ui-tooltip-title");
                }
            });
            this.liveRegion.remove();
        }
    });
});




var $b95b5545766c3f4f$exports = {};
"use strict";
/**
 * Created by gavorhes on 12/15/2015.
 */ Object.defineProperty($b95b5545766c3f4f$exports, "__esModule", {
    value: true
});
$b95b5545766c3f4f$exports.quickMap = void 0;
var $cc12fb92b6cb9cf8$exports = {};
"use strict";
/**
 * Created by gavorhes on 12/15/2015.
 */ Object.defineProperty($cc12fb92b6cb9cf8$exports, "__esModule", {
    value: true
});
$cc12fb92b6cb9cf8$exports.quickMapBase = void 0;
var $c45303ef5b6fbfc7$exports = {};
"use strict";
/**
 * Created by gavorhes on 12/10/2015.
 */ Object.defineProperty($c45303ef5b6fbfc7$exports, "__esModule", {
    value: true
});
/**
 * create a namespace on the gv object
 * @param {string} namespace to create
 * @returns {object} object representing the namespace
 */ function $c45303ef5b6fbfc7$var$provide(namespace) {
    "use strict";
    if (typeof window.gv == "undefined") window.gv = {};
    var parts = namespace.split(".");
    var nameSpace = window.gv;
    for(var i = 0; i < parts.length; i++){
        var newObject = nameSpace[parts[i]];
        if (typeof newObject == "undefined") nameSpace[parts[i]] = {};
        nameSpace = nameSpace[parts[i]];
    }
    return nameSpace;
}
$c45303ef5b6fbfc7$var$provide("util");
window.gv.util.provide = $c45303ef5b6fbfc7$var$provide;
$c45303ef5b6fbfc7$exports.default = $c45303ef5b6fbfc7$var$provide;


/**
 * @module ol/Map
 */ /**
 * @module ol/PluggableMap
 */ /**
 * @module ol/util
 */ /**
 * @return {?} Any return.
 */ function $34772e91e89a736f$export$817eb92a8194bab0() {
    return /** @type {?} */ function() {
        throw new Error("Unimplemented abstract method.");
    }();
}
function $34772e91e89a736f$export$69f1b2dcda23c5f8(childCtor, parentCtor) {
    childCtor.prototype = Object.create(parentCtor.prototype);
    childCtor.prototype.constructor = childCtor;
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ var $34772e91e89a736f$var$uidCounter_ = 0;
function $34772e91e89a736f$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$34772e91e89a736f$var$uidCounter_));
}
var $34772e91e89a736f$export$a4ad2735b021c132 = "5.3.3";


/**
 * @module ol/Collection
 */ /**
 * @module ol/AssertionError
 */ 
/**
 * Error object thrown when an assertion failed. This is an ECMA-262 Error,
 * extended with a `code` property.
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error.
 */ var $4096c163f6eb88c6$var$AssertionError = /*@__PURE__*/ function(Error1) {
    function AssertionError(code) {
        var path = (0, $34772e91e89a736f$export$a4ad2735b021c132) === "latest" ? (0, $34772e91e89a736f$export$a4ad2735b021c132) : "v" + (0, $34772e91e89a736f$export$a4ad2735b021c132).split("-")[0];
        var message = "Assertion failed. See https://openlayers.org/en/" + path + "/doc/errors/#" + code + " for details.";
        Error1.call(this, message);
        /**
     * Error code. The meaning of the code can be found on
     * https://openlayers.org/en/latest/doc/errors/ (replace `latest` with
     * the version found in the OpenLayers script's header comment if a version
     * other than the latest is used).
     * @type {number}
     * @api
     */ this.code = code;
        /**
     * @type {string}
     */ this.name = "AssertionError";
        // Re-assign message, see https://github.com/Rich-Harris/buble/issues/40
        this.message = message;
    }
    if (Error1) AssertionError.__proto__ = Error1;
    AssertionError.prototype = Object.create(Error1 && Error1.prototype);
    AssertionError.prototype.constructor = AssertionError;
    return AssertionError;
}(Error);
var $4096c163f6eb88c6$export$2e2bcd8739ae039 = $4096c163f6eb88c6$var$AssertionError;


/**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $da68a68ae95b5159$export$2e2bcd8739ae039 = {
    /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */ ADD: "add",
    /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */ REMOVE: "remove"
};


/**
 * @module ol/Object
 */ 
/**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $19100aa5be43a728$export$2e2bcd8739ae039 = {
    /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */ PROPERTYCHANGE: "propertychange"
};


/**
 * @module ol/Observable
 */ /**
 * @module ol/events
 */ /**
 * @module ol/obj
 */ /**
 * Polyfill for Object.assign().  Assigns enumerable and own properties from
 * one or more source objects to a target object.
 * See https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign.
 *
 * @param {!Object} target The target object.
 * @param {...Object} var_sources The source object(s).
 * @return {!Object} The modified target object.
 */ var $8c1e0b75b65663dc$export$e6e34fd1f2686227 = typeof Object.assign === "function" ? Object.assign : function(target, var_sources) {
    var arguments$1 = arguments;
    if (target === undefined || target === null) throw new TypeError("Cannot convert undefined or null to object");
    var output = Object(target);
    for(var i = 1, ii = arguments.length; i < ii; ++i){
        var source = arguments$1[i];
        if (source !== undefined && source !== null) {
            for(var key in source)if (source.hasOwnProperty(key)) output[key] = source[key];
        }
    }
    return output;
};
function $8c1e0b75b65663dc$export$42ffd38884aecdac(object) {
    for(var property in object)delete object[property];
}
function $8c1e0b75b65663dc$export$a5c4301012ad6f07(object) {
    var values = [];
    for(var property in object)values.push(object[property]);
    return values;
}
function $8c1e0b75b65663dc$export$dd1bc94b04021eeb(object) {
    var property;
    for(property in object)return false;
    return !property;
}


function $37a5c0af9052e360$export$e5764c46705b10ce(listenerObj) {
    var boundListener = function(evt) {
        var listener = listenerObj.listener;
        var bindTo = listenerObj.bindTo || listenerObj.target;
        if (listenerObj.callOnce) $37a5c0af9052e360$export$b0a21c8b3c1c921(listenerObj);
        return listener.call(bindTo, evt);
    };
    listenerObj.boundListener = boundListener;
    return boundListener;
}
function $37a5c0af9052e360$export$dcafe004bcd20156(listeners, listener, opt_this, opt_setDeleteIndex) {
    var listenerObj;
    for(var i = 0, ii = listeners.length; i < ii; ++i){
        listenerObj = listeners[i];
        if (listenerObj.listener === listener && listenerObj.bindTo === opt_this) {
            if (opt_setDeleteIndex) listenerObj.deleteIndex = i;
            return listenerObj;
        }
    }
    return undefined;
}
function $37a5c0af9052e360$export$e4834a4a0b883c5b(target, type) {
    var listenerMap = $37a5c0af9052e360$var$getListenerMap(target);
    return listenerMap ? listenerMap[type] : undefined;
}
/**
 * Get the lookup of listeners.
 * @param {Object} target Target.
 * @param {boolean=} opt_create If a map should be created if it doesn't exist.
 * @return {!Object<string, Array<EventsKey>>} Map of
 *     listeners by event type.
 */ function $37a5c0af9052e360$var$getListenerMap(target, opt_create) {
    var listenerMap = target.ol_lm;
    if (!listenerMap && opt_create) listenerMap = target.ol_lm = {};
    return listenerMap;
}
/**
 * Remove the listener map from a target.
 * @param {Object} target Target.
 */ function $37a5c0af9052e360$var$removeListenerMap(target) {
    delete target.ol_lm;
}
/**
 * Clean up all listener objects of the given type.  All properties on the
 * listener objects will be removed, and if no listeners remain in the listener
 * map, it will be removed from the target.
 * @param {import("./events/Target.js").EventTargetLike} target Target.
 * @param {string} type Type.
 */ function $37a5c0af9052e360$var$removeListeners(target, type) {
    var listeners = $37a5c0af9052e360$export$e4834a4a0b883c5b(target, type);
    if (listeners) {
        for(var i = 0, ii = listeners.length; i < ii; ++i){
            /** @type {import("./events/Target.js").default} */ target.removeEventListener(type, listeners[i].boundListener);
            (0, $8c1e0b75b65663dc$export$42ffd38884aecdac)(listeners[i]);
        }
        listeners.length = 0;
        var listenerMap = $37a5c0af9052e360$var$getListenerMap(target);
        if (listenerMap) {
            delete listenerMap[type];
            if (Object.keys(listenerMap).length === 0) $37a5c0af9052e360$var$removeListenerMap(target);
        }
    }
}
function $37a5c0af9052e360$export$63174c828edd6ff8(target, type, listener, opt_this, opt_once) {
    var listenerMap = $37a5c0af9052e360$var$getListenerMap(target, true);
    var listeners = listenerMap[type];
    if (!listeners) listeners = listenerMap[type] = [];
    var listenerObj = $37a5c0af9052e360$export$dcafe004bcd20156(listeners, listener, opt_this, false);
    if (listenerObj) {
        if (!opt_once) // Turn one-off listener into a permanent one.
        listenerObj.callOnce = false;
    } else {
        listenerObj = /** @type {EventsKey} */ {
            bindTo: opt_this,
            callOnce: !!opt_once,
            listener: listener,
            target: target,
            type: type
        };
        /** @type {import("./events/Target.js").default} */ target.addEventListener(type, $37a5c0af9052e360$export$e5764c46705b10ce(listenerObj));
        listeners.push(listenerObj);
    }
    return listenerObj;
}
function $37a5c0af9052e360$export$8d2a95bc11b44725(target, type, listener, opt_this) {
    return $37a5c0af9052e360$export$63174c828edd6ff8(target, type, listener, opt_this, true);
}
function $37a5c0af9052e360$export$35276765542cd163(target, type, listener, opt_this) {
    var listeners = $37a5c0af9052e360$export$e4834a4a0b883c5b(target, type);
    if (listeners) {
        var listenerObj = $37a5c0af9052e360$export$dcafe004bcd20156(listeners, listener, opt_this, true);
        if (listenerObj) $37a5c0af9052e360$export$b0a21c8b3c1c921(listenerObj);
    }
}
function $37a5c0af9052e360$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        /** @type {import("./events/Target.js").default} */ key.target.removeEventListener(key.type, key.boundListener);
        var listeners = $37a5c0af9052e360$export$e4834a4a0b883c5b(key.target, key.type);
        if (listeners) {
            var i = "deleteIndex" in key ? key.deleteIndex : listeners.indexOf(key);
            if (i !== -1) listeners.splice(i, 1);
            if (listeners.length === 0) $37a5c0af9052e360$var$removeListeners(key.target, key.type);
        }
        (0, $8c1e0b75b65663dc$export$42ffd38884aecdac)(key);
    }
}
function $37a5c0af9052e360$export$8ce8a452ff642aaf(target) {
    var listenerMap = $37a5c0af9052e360$var$getListenerMap(target);
    if (listenerMap) for(var type in listenerMap)$37a5c0af9052e360$var$removeListeners(target, type);
}


/**
 * @module ol/events/Target
 */ /**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ var $17f88068b11f58ac$var$Disposable = function Disposable() {
    /**
   * The object has already been disposed.
   * @type {boolean}
   * @private
   */ this.disposed_ = false;
};
/**
 * Clean up.
 */ $17f88068b11f58ac$var$Disposable.prototype.dispose = function dispose() {
    if (!this.disposed_) {
        this.disposed_ = true;
        this.disposeInternal();
    }
};
/**
 * Extension point for disposable objects.
 * @protected
 */ $17f88068b11f58ac$var$Disposable.prototype.disposeInternal = function disposeInternal() {};
var $17f88068b11f58ac$export$2e2bcd8739ae039 = $17f88068b11f58ac$var$Disposable;



/**
 * @module ol/functions
 */ /**
 * Always returns true.
 * @returns {boolean} true.
 */ function $de1052d9f293b73a$export$22e23a2304399231() {
    return true;
}
function $de1052d9f293b73a$export$8f11cee4bdc7e668() {
    return false;
}
function $de1052d9f293b73a$export$1cd1943b3a73bbe8() {}


/**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ var $0327f54963b35733$var$Event = function Event(type) {
    /**
   * @type {boolean}
   */ this.propagationStopped;
    /**
   * The event type.
   * @type {string}
   * @api
   */ this.type = type;
    /**
   * The event target.
   * @type {Object}
   * @api
   */ this.target = null;
};
/**
 * Stop event propagation.
 * @api
 */ $0327f54963b35733$var$Event.prototype.preventDefault = function preventDefault() {
    this.propagationStopped = true;
};
/**
 * Stop event propagation.
 * @api
 */ $0327f54963b35733$var$Event.prototype.stopPropagation = function stopPropagation() {
    this.propagationStopped = true;
};
function $0327f54963b35733$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $0327f54963b35733$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $0327f54963b35733$export$2e2bcd8739ae039 = $0327f54963b35733$var$Event;


/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ var $dd029d816e3b4259$var$Target = /*@__PURE__*/ function(Disposable) {
    function Target() {
        Disposable.call(this);
        /**
     * @private
     * @type {!Object<string, number>}
     */ this.pendingRemovals_ = {};
        /**
     * @private
     * @type {!Object<string, number>}
     */ this.dispatching_ = {};
        /**
     * @private
     * @type {!Object<string, Array<import("../events.js").ListenerFunction>>}
     */ this.listeners_ = {};
    }
    if (Disposable) Target.__proto__ = Disposable;
    Target.prototype = Object.create(Disposable && Disposable.prototype);
    Target.prototype.constructor = Target;
    /**
   * @param {string} type Type.
   * @param {import("../events.js").ListenerFunction} listener Listener.
   */ Target.prototype.addEventListener = function addEventListener(type, listener) {
        var listeners = this.listeners_[type];
        if (!listeners) listeners = this.listeners_[type] = [];
        if (listeners.indexOf(listener) === -1) listeners.push(listener);
    };
    /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {{type: string,
   *     target: (EventTargetLike|undefined),
   *     propagationStopped: (boolean|undefined)}|
   *     import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */ Target.prototype.dispatchEvent = function dispatchEvent(event) {
        var evt = typeof event === "string" ? new (0, $0327f54963b35733$export$2e2bcd8739ae039)(event) : event;
        var type = evt.type;
        evt.target = this;
        var listeners = this.listeners_[type];
        var propagate;
        if (listeners) {
            if (!(type in this.dispatching_)) {
                this.dispatching_[type] = 0;
                this.pendingRemovals_[type] = 0;
            }
            ++this.dispatching_[type];
            for(var i = 0, ii = listeners.length; i < ii; ++i)if (listeners[i].call(this, evt) === false || evt.propagationStopped) {
                propagate = false;
                break;
            }
            --this.dispatching_[type];
            if (this.dispatching_[type] === 0) {
                var pendingRemovals = this.pendingRemovals_[type];
                delete this.pendingRemovals_[type];
                while(pendingRemovals--)this.removeEventListener(type, (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8));
                delete this.dispatching_[type];
            }
            return propagate;
        }
    };
    /**
   * @inheritDoc
   */ Target.prototype.disposeInternal = function disposeInternal() {
        (0, $37a5c0af9052e360$export$8ce8a452ff642aaf)(this);
    };
    /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").ListenerFunction>} Listeners.
   */ Target.prototype.getListeners = function getListeners(type) {
        return this.listeners_[type];
    };
    /**
   * @param {string=} opt_type Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */ Target.prototype.hasListener = function hasListener(opt_type) {
        return opt_type ? opt_type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    };
    /**
   * @param {string} type Type.
   * @param {import("../events.js").ListenerFunction} listener Listener.
   */ Target.prototype.removeEventListener = function removeEventListener(type, listener) {
        var listeners = this.listeners_[type];
        if (listeners) {
            var index = listeners.indexOf(listener);
            if (type in this.pendingRemovals_) {
                // make listener a no-op, and remove later in #dispatchEvent()
                listeners[index] = (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8);
                ++this.pendingRemovals_[type];
            } else {
                listeners.splice(index, 1);
                if (listeners.length === 0) delete this.listeners_[type];
            }
        }
    };
    return Target;
}((0, $17f88068b11f58ac$export$2e2bcd8739ae039));
var $dd029d816e3b4259$export$2e2bcd8739ae039 = $dd029d816e3b4259$var$Target;


/**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $6a4d89c0e1a6605f$export$2e2bcd8739ae039 = {
    /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~Event#change
   * @api
   */ CHANGE: "change",
    CLEAR: "clear",
    CONTEXTMENU: "contextmenu",
    CLICK: "click",
    DBLCLICK: "dblclick",
    DRAGENTER: "dragenter",
    DRAGOVER: "dragover",
    DROP: "drop",
    ERROR: "error",
    KEYDOWN: "keydown",
    KEYPRESS: "keypress",
    LOAD: "load",
    MOUSEDOWN: "mousedown",
    MOUSEMOVE: "mousemove",
    MOUSEOUT: "mouseout",
    MOUSEUP: "mouseup",
    MOUSEWHEEL: "mousewheel",
    MSPOINTERDOWN: "MSPointerDown",
    RESIZE: "resize",
    TOUCHSTART: "touchstart",
    TOUCHMOVE: "touchmove",
    TOUCHEND: "touchend",
    WHEEL: "wheel"
};


/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").Event
 * @api
 */ var $5cf0b3202980c59c$var$Observable = /*@__PURE__*/ function(EventTarget) {
    function Observable() {
        EventTarget.call(this);
        /**
     * @private
     * @type {number}
     */ this.revision_ = 0;
    }
    if (EventTarget) Observable.__proto__ = EventTarget;
    Observable.prototype = Object.create(EventTarget && EventTarget.prototype);
    Observable.prototype.constructor = Observable;
    /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */ Observable.prototype.changed = function changed() {
        ++this.revision_;
        this.dispatchEvent((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE);
    };
    /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */ Observable.prototype.getRevision = function getRevision() {
        return this.revision_;
    };
    /**
   * Listen for a certain type of event.
   * @param {string|Array<string>} type The event type or array of event types.
   * @param {function(?): ?} listener The listener function.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
   *     called with an array of event types as the first argument, the return
   *     will be an array of keys.
   * @api
   */ Observable.prototype.on = function on(type, listener) {
        if (Array.isArray(type)) {
            var len = type.length;
            var keys = new Array(len);
            for(var i = 0; i < len; ++i)keys[i] = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, type[i], listener);
            return keys;
        } else return (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, /** @type {string} */ type, listener);
    };
    /**
   * Listen once for a certain type of event.
   * @param {string|Array<string>} type The event type or array of event types.
   * @param {function(?): ?} listener The listener function.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
   *     called with an array of event types as the first argument, the return
   *     will be an array of keys.
   * @api
   */ Observable.prototype.once = function once(type, listener) {
        if (Array.isArray(type)) {
            var len = type.length;
            var keys = new Array(len);
            for(var i = 0; i < len; ++i)keys[i] = (0, $37a5c0af9052e360$export$8d2a95bc11b44725)(this, type[i], listener);
            return keys;
        } else return (0, $37a5c0af9052e360$export$8d2a95bc11b44725)(this, /** @type {string} */ type, listener);
    };
    /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type The event type or array of event types.
   * @param {function(?): ?} listener The listener function.
   * @api
   */ Observable.prototype.un = function un(type, listener) {
        if (Array.isArray(type)) {
            for(var i = 0, ii = type.length; i < ii; ++i)(0, $37a5c0af9052e360$export$35276765542cd163)(this, type[i], listener);
            return;
        } else (0, $37a5c0af9052e360$export$35276765542cd163)(this, /** @type {string} */ type, listener);
    };
    return Observable;
}((0, $dd029d816e3b4259$export$2e2bcd8739ae039));
function $5cf0b3202980c59c$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(var i = 0, ii = key.length; i < ii; ++i)(0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(key[i]);
    else (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(/** @type {import("./events.js").EventsKey} */ key);
}
var $5cf0b3202980c59c$export$2e2bcd8739ae039 = $5cf0b3202980c59c$var$Observable;




var $d575b598d09f57d3$export$cf395d7c4a2d5a17 = /*@__PURE__*/ function(Event) {
    function ObjectEvent(type, key, oldValue) {
        Event.call(this, type);
        /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */ this.key = key;
        /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */ this.oldValue = oldValue;
    }
    if (Event) ObjectEvent.__proto__ = Event;
    ObjectEvent.prototype = Object.create(Event && Event.prototype);
    ObjectEvent.prototype.constructor = ObjectEvent;
    return ObjectEvent;
}((0, $0327f54963b35733$export$2e2bcd8739ae039));
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @api
 */ var $d575b598d09f57d3$var$BaseObject = /*@__PURE__*/ function(Observable) {
    function BaseObject(opt_values) {
        Observable.call(this);
        // Call {@link module:ol/util~getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $34772e91e89a736f$export$5e82334337e0f204)(this);
        /**
     * @private
     * @type {!Object<string, *>}
     */ this.values_ = {};
        if (opt_values !== undefined) this.setProperties(opt_values);
    }
    if (Observable) BaseObject.__proto__ = Observable;
    BaseObject.prototype = Object.create(Observable && Observable.prototype);
    BaseObject.prototype.constructor = BaseObject;
    /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */ BaseObject.prototype.get = function get(key) {
        var value;
        if (this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    };
    /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */ BaseObject.prototype.getKeys = function getKeys() {
        return Object.keys(this.values_);
    };
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>} Object.
   * @api
   */ BaseObject.prototype.getProperties = function getProperties() {
        return (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({}, this.values_);
    };
    /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */ BaseObject.prototype.notify = function notify(key, oldValue) {
        var eventType;
        eventType = $d575b598d09f57d3$export$1ae67e5877b1d378(key);
        this.dispatchEvent(new $d575b598d09f57d3$export$cf395d7c4a2d5a17(eventType, key, oldValue));
        eventType = (0, $19100aa5be43a728$export$2e2bcd8739ae039).PROPERTYCHANGE;
        this.dispatchEvent(new $d575b598d09f57d3$export$cf395d7c4a2d5a17(eventType, key, oldValue));
    };
    /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean=} opt_silent Update without triggering an event.
   * @api
   */ BaseObject.prototype.set = function set(key, value, opt_silent) {
        if (opt_silent) this.values_[key] = value;
        else {
            var oldValue = this.values_[key];
            this.values_[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    };
    /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Object<string, *>} values Values.
   * @param {boolean=} opt_silent Update without triggering an event.
   * @api
   */ BaseObject.prototype.setProperties = function setProperties(values, opt_silent) {
        for(var key in values)this.set(key, values[key], opt_silent);
    };
    /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean=} opt_silent Unset without triggering an event.
   * @api
   */ BaseObject.prototype.unset = function unset(key, opt_silent) {
        if (key in this.values_) {
            var oldValue = this.values_[key];
            delete this.values_[key];
            if (!opt_silent) this.notify(key, oldValue);
        }
    };
    return BaseObject;
}((0, $5cf0b3202980c59c$export$2e2bcd8739ae039));
/**
 * @type {Object<string, string>}
 */ var $d575b598d09f57d3$var$changeEventTypeCache = {};
function $d575b598d09f57d3$export$1ae67e5877b1d378(key) {
    return $d575b598d09f57d3$var$changeEventTypeCache.hasOwnProperty(key) ? $d575b598d09f57d3$var$changeEventTypeCache[key] : $d575b598d09f57d3$var$changeEventTypeCache[key] = "change:" + key;
}
var $d575b598d09f57d3$export$2e2bcd8739ae039 = $d575b598d09f57d3$var$BaseObject;



/**
 * @enum {string}
 * @private
 */ var $7be3d63260860659$var$Property = {
    LENGTH: "length"
};
var $7be3d63260860659$export$a87ae6eb2761ec6d = /*@__PURE__*/ function(Event) {
    function CollectionEvent(type, opt_element) {
        Event.call(this, type);
        /**
     * The element that is added to or removed from the collection.
     * @type {*}
     * @api
     */ this.element = opt_element;
    }
    if (Event) CollectionEvent.__proto__ = Event;
    CollectionEvent.prototype = Object.create(Event && Event.prototype);
    CollectionEvent.prototype.constructor = CollectionEvent;
    return CollectionEvent;
}((0, $0327f54963b35733$export$2e2bcd8739ae039));
/**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ var $7be3d63260860659$var$Collection = /*@__PURE__*/ function(BaseObject) {
    function Collection(opt_array, opt_options) {
        BaseObject.call(this);
        var options = opt_options || {};
        /**
     * @private
     * @type {boolean}
     */ this.unique_ = !!options.unique;
        /**
     * @private
     * @type {!Array<T>}
     */ this.array_ = opt_array ? opt_array : [];
        if (this.unique_) for(var i = 0, ii = this.array_.length; i < ii; ++i)this.assertUnique_(this.array_[i], i);
        this.updateLength_();
    }
    if (BaseObject) Collection.__proto__ = BaseObject;
    Collection.prototype = Object.create(BaseObject && BaseObject.prototype);
    Collection.prototype.constructor = Collection;
    /**
   * Remove all elements from the collection.
   * @api
   */ Collection.prototype.clear = function clear() {
        while(this.getLength() > 0)this.pop();
    };
    /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */ Collection.prototype.extend = function extend(arr) {
        for(var i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    };
    /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */ Collection.prototype.forEach = function forEach(f) {
        var array = this.array_;
        for(var i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    };
    /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */ Collection.prototype.getArray = function getArray() {
        return this.array_;
    };
    /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */ Collection.prototype.item = function item(index) {
        return this.array_[index];
    };
    /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */ Collection.prototype.getLength = function getLength() {
        return this.get($7be3d63260860659$var$Property.LENGTH);
    };
    /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ Collection.prototype.insertAt = function insertAt(index, elem) {
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new $7be3d63260860659$export$a87ae6eb2761ec6d((0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, elem));
    };
    /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */ Collection.prototype.pop = function pop() {
        return this.removeAt(this.getLength() - 1);
    };
    /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */ Collection.prototype.push = function push(elem) {
        if (this.unique_) this.assertUnique_(elem);
        var n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    };
    /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */ Collection.prototype.remove = function remove(elem) {
        var arr = this.array_;
        for(var i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    };
    /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */ Collection.prototype.removeAt = function removeAt(index) {
        var prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(new $7be3d63260860659$export$a87ae6eb2761ec6d((0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, prev));
        return prev;
    };
    /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ Collection.prototype.setAt = function setAt(index, elem) {
        var n = this.getLength();
        if (index < n) {
            if (this.unique_) this.assertUnique_(elem, index);
            var prev = this.array_[index];
            this.array_[index] = elem;
            this.dispatchEvent(new $7be3d63260860659$export$a87ae6eb2761ec6d((0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, prev));
            this.dispatchEvent(new $7be3d63260860659$export$a87ae6eb2761ec6d((0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, elem));
        } else {
            for(var j = n; j < index; ++j)this.insertAt(j, undefined);
            this.insertAt(index, elem);
        }
    };
    /**
   * @private
   */ Collection.prototype.updateLength_ = function updateLength_() {
        this.set($7be3d63260860659$var$Property.LENGTH, this.array_.length);
    };
    /**
   * @private
   * @param {T} elem Element.
   * @param {number=} opt_except Optional index to ignore.
   */ Collection.prototype.assertUnique_ = function assertUnique_(elem, opt_except) {
        for(var i = 0, ii = this.array_.length; i < ii; ++i){
            if (this.array_[i] === elem && i !== opt_except) throw new (0, $4096c163f6eb88c6$export$2e2bcd8739ae039)(58);
        }
    };
    return Collection;
}((0, $d575b598d09f57d3$export$2e2bcd8739ae039));
var $7be3d63260860659$export$2e2bcd8739ae039 = $7be3d63260860659$var$Collection;



/**
 * @module ol/MapBrowserEvent
 */ /**
 * @module ol/MapEvent
 */ 
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/PluggableMap~PluggableMap} for which events trigger a map event.
 */ var $7513f8b91fec7508$var$MapEvent = /*@__PURE__*/ function(Event) {
    function MapEvent(type, map, opt_frameState) {
        Event.call(this, type);
        /**
     * The map where the event occurred.
     * @type {import("./PluggableMap.js").default}
     * @api
     */ this.map = map;
        /**
     * The frame state at the time of the event.
     * @type {?import("./PluggableMap.js").FrameState}
     * @api
     */ this.frameState = opt_frameState !== undefined ? opt_frameState : null;
    }
    if (Event) MapEvent.__proto__ = Event;
    MapEvent.prototype = Object.create(Event && Event.prototype);
    MapEvent.prototype.constructor = MapEvent;
    return MapEvent;
}((0, $0327f54963b35733$export$2e2bcd8739ae039));
var $7513f8b91fec7508$export$2e2bcd8739ae039 = $7513f8b91fec7508$var$MapEvent;


/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/PluggableMap~PluggableMap} for which events trigger a map browser event.
 */ var $f924e5a83a2737ce$var$MapBrowserEvent = /*@__PURE__*/ function(MapEvent) {
    function MapBrowserEvent(type, map, browserEvent, opt_dragging, opt_frameState) {
        MapEvent.call(this, type, map, opt_frameState);
        /**
     * The original browser event.
     * @const
     * @type {Event}
     * @api
     */ this.originalEvent = browserEvent;
        /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {import("./pixel.js").Pixel}
     * @api
     */ this.pixel = map.getEventPixel(browserEvent);
        /**
     * The coordinate in view projection corresponding to the original browser event.
     * @type {import("./coordinate.js").Coordinate}
     * @api
     */ this.coordinate = map.getCoordinateFromPixel(this.pixel);
        /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */ this.dragging = opt_dragging !== undefined ? opt_dragging : false;
    }
    if (MapEvent) MapBrowserEvent.__proto__ = MapEvent;
    MapBrowserEvent.prototype = Object.create(MapEvent && MapEvent.prototype);
    MapBrowserEvent.prototype.constructor = MapBrowserEvent;
    /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @override
   * @api
   */ MapBrowserEvent.prototype.preventDefault = function preventDefault() {
        MapEvent.prototype.preventDefault.call(this);
        this.originalEvent.preventDefault();
    };
    /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @override
   * @api
   */ MapBrowserEvent.prototype.stopPropagation = function stopPropagation() {
        MapEvent.prototype.stopPropagation.call(this);
        this.originalEvent.stopPropagation();
    };
    return MapBrowserEvent;
}((0, $7513f8b91fec7508$export$2e2bcd8739ae039));
var $f924e5a83a2737ce$export$2e2bcd8739ae039 = $f924e5a83a2737ce$var$MapBrowserEvent;


/**
 * @module ol/MapBrowserEventHandler
 */ /**
 * @module ol/has
 */ 
var $89969764a1196844$var$ua = typeof navigator !== "undefined" ? navigator.userAgent.toLowerCase() : "";
var $89969764a1196844$export$8442bdfd18b7b8a6 = $89969764a1196844$var$ua.indexOf("firefox") !== -1;
var $89969764a1196844$export$3227bfbdaa9275de = $89969764a1196844$var$ua.indexOf("safari") !== -1 && $89969764a1196844$var$ua.indexOf("chrom") == -1;
var $89969764a1196844$export$39dfd62a25e0fe93 = $89969764a1196844$var$ua.indexOf("webkit") !== -1 && $89969764a1196844$var$ua.indexOf("edge") == -1;
var $89969764a1196844$export$76c0a3b101d93136 = $89969764a1196844$var$ua.indexOf("macintosh") !== -1;
var $89969764a1196844$export$6b83a0446fc26f94 = window.devicePixelRatio || 1;
var $89969764a1196844$export$c986c2374f97af1a = function() {
    var has = false;
    try {
        has = !!document.createElement("canvas").getContext("2d").setLineDash;
    } catch (e) {
    // pass
    }
    return has;
}();
var $89969764a1196844$export$dbec86a293ec3f70 = "geolocation" in navigator;
var $89969764a1196844$export$d46bd3ead7cc759b = "ontouchstart" in window;
var $89969764a1196844$export$dccde0e92ea6945d = "PointerEvent" in window;
var $89969764a1196844$export$6e620742ec21ecc4 = !!navigator.msPointerEnabled;


/**
 * @module ol/MapBrowserEventType
 */ 
var /**
 * Constants for event names.
 * @enum {string}
 */ $4d29e2d9bc8184b4$export$2e2bcd8739ae039 = {
    /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */ SINGLECLICK: "singleclick",
    /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */ CLICK: (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLICK,
    /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */ DBLCLICK: (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).DBLCLICK,
    /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */ POINTERDRAG: "pointerdrag",
    /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */ POINTERMOVE: "pointermove",
    POINTERDOWN: "pointerdown",
    POINTERUP: "pointerup",
    POINTEROVER: "pointerover",
    POINTEROUT: "pointerout",
    POINTERENTER: "pointerenter",
    POINTERLEAVE: "pointerleave",
    POINTERCANCEL: "pointercancel"
};


/**
 * @module ol/MapBrowserPointerEvent
 */ 
var $f38b81bf0090e6d7$var$MapBrowserPointerEvent = /*@__PURE__*/ function(MapBrowserEvent) {
    function MapBrowserPointerEvent(type, map, pointerEvent, opt_dragging, opt_frameState) {
        MapBrowserEvent.call(this, type, map, pointerEvent.originalEvent, opt_dragging, opt_frameState);
        /**
     * @const
     * @type {import("./pointer/PointerEvent.js").default}
     */ this.pointerEvent = pointerEvent;
    }
    if (MapBrowserEvent) MapBrowserPointerEvent.__proto__ = MapBrowserEvent;
    MapBrowserPointerEvent.prototype = Object.create(MapBrowserEvent && MapBrowserEvent.prototype);
    MapBrowserPointerEvent.prototype.constructor = MapBrowserPointerEvent;
    return MapBrowserPointerEvent;
}((0, $f924e5a83a2737ce$export$2e2bcd8739ae039));
var $f38b81bf0090e6d7$export$2e2bcd8739ae039 = $f38b81bf0090e6d7$var$MapBrowserPointerEvent;




/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $8b8450889b821db1$export$2e2bcd8739ae039 = {
    POINTERMOVE: "pointermove",
    POINTERDOWN: "pointerdown",
    POINTERUP: "pointerup",
    POINTEROVER: "pointerover",
    POINTEROUT: "pointerout",
    POINTERENTER: "pointerenter",
    POINTERLEAVE: "pointerleave",
    POINTERCANCEL: "pointercancel"
};


/**
 * @module ol/pointer/PointerEventHandler
 */ // Based on https://github.com/Polymer/PointerEvents
// Copyright (c) 2013 The Polymer Authors. All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
// * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
// * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
// * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.




/**
 * @module ol/pointer/MouseSource
 */ // Based on https://github.com/Polymer/PointerEvents
// Copyright (c) 2013 The Polymer Authors. All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
// * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
// * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
// * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
/**
 * @module ol/pointer/EventSource
 */ var $3bcb787536cf3f65$var$EventSource = function EventSource(dispatcher, mapping) {
    /**
   * @type {import("./PointerEventHandler.js").default}
   */ this.dispatcher = dispatcher;
    /**
   * @private
   * @const
   * @type {!Object<string, function(Event)>}
   */ this.mapping_ = mapping;
};
/**
 * List of events supported by this source.
 * @return {Array<string>} Event names
 */ $3bcb787536cf3f65$var$EventSource.prototype.getEvents = function getEvents() {
    return Object.keys(this.mapping_);
};
/**
 * Returns the handler that should handle a given event type.
 * @param {string} eventType The event type.
 * @return {function(Event)} Handler
 */ $3bcb787536cf3f65$var$EventSource.prototype.getHandlerForEvent = function getHandlerForEvent(eventType) {
    return this.mapping_[eventType];
};
var $3bcb787536cf3f65$export$2e2bcd8739ae039 = $3bcb787536cf3f65$var$EventSource;


var $b35fa32ce9b38cf6$export$cbf1ee0ba0a79a8a = 1;
var $b35fa32ce9b38cf6$export$bfaa7c08c18ee972 = "mouse";
/**
 * Radius around touchend that swallows mouse events.
 *
 * @type {number}
 */ var $b35fa32ce9b38cf6$var$DEDUP_DIST = 25;
/**
 * Handler for `mousedown`.
 *
 * @this {MouseSource}
 * @param {MouseEvent} inEvent The in event.
 */ function $b35fa32ce9b38cf6$var$mousedown(inEvent) {
    if (!this.isEventSimulatedFromTouch_(inEvent)) {
        // TODO(dfreedman) workaround for some elements not sending mouseup
        // http://crbug/149091
        if ($b35fa32ce9b38cf6$export$cbf1ee0ba0a79a8a.toString() in this.pointerMap) this.cancel(inEvent);
        var e = $b35fa32ce9b38cf6$export$2d67fb380bd11267(inEvent, this.dispatcher);
        this.pointerMap[$b35fa32ce9b38cf6$export$cbf1ee0ba0a79a8a.toString()] = inEvent;
        this.dispatcher.down(e, inEvent);
    }
}
/**
 * Handler for `mousemove`.
 *
 * @this {MouseSource}
 * @param {MouseEvent} inEvent The in event.
 */ function $b35fa32ce9b38cf6$var$mousemove(inEvent) {
    if (!this.isEventSimulatedFromTouch_(inEvent)) {
        var e = $b35fa32ce9b38cf6$export$2d67fb380bd11267(inEvent, this.dispatcher);
        this.dispatcher.move(e, inEvent);
    }
}
/**
 * Handler for `mouseup`.
 *
 * @this {MouseSource}
 * @param {MouseEvent} inEvent The in event.
 */ function $b35fa32ce9b38cf6$var$mouseup(inEvent) {
    if (!this.isEventSimulatedFromTouch_(inEvent)) {
        var p = this.pointerMap[$b35fa32ce9b38cf6$export$cbf1ee0ba0a79a8a.toString()];
        if (p && p.button === inEvent.button) {
            var e = $b35fa32ce9b38cf6$export$2d67fb380bd11267(inEvent, this.dispatcher);
            this.dispatcher.up(e, inEvent);
            this.cleanupMouse();
        }
    }
}
/**
 * Handler for `mouseover`.
 *
 * @this {MouseSource}
 * @param {MouseEvent} inEvent The in event.
 */ function $b35fa32ce9b38cf6$var$mouseover(inEvent) {
    if (!this.isEventSimulatedFromTouch_(inEvent)) {
        var e = $b35fa32ce9b38cf6$export$2d67fb380bd11267(inEvent, this.dispatcher);
        this.dispatcher.enterOver(e, inEvent);
    }
}
/**
 * Handler for `mouseout`.
 *
 * @this {MouseSource}
 * @param {MouseEvent} inEvent The in event.
 */ function $b35fa32ce9b38cf6$var$mouseout(inEvent) {
    if (!this.isEventSimulatedFromTouch_(inEvent)) {
        var e = $b35fa32ce9b38cf6$export$2d67fb380bd11267(inEvent, this.dispatcher);
        this.dispatcher.leaveOut(e, inEvent);
    }
}
var $b35fa32ce9b38cf6$var$MouseSource = /*@__PURE__*/ function(EventSource) {
    function MouseSource(dispatcher) {
        var mapping = {
            "mousedown": $b35fa32ce9b38cf6$var$mousedown,
            "mousemove": $b35fa32ce9b38cf6$var$mousemove,
            "mouseup": $b35fa32ce9b38cf6$var$mouseup,
            "mouseover": $b35fa32ce9b38cf6$var$mouseover,
            "mouseout": $b35fa32ce9b38cf6$var$mouseout
        };
        EventSource.call(this, dispatcher, mapping);
        /**
     * @const
     * @type {!Object<string, Event|Object>}
     */ this.pointerMap = dispatcher.pointerMap;
        /**
     * @const
     * @type {Array<import("../pixel.js").Pixel>}
     */ this.lastTouches = [];
    }
    if (EventSource) MouseSource.__proto__ = EventSource;
    MouseSource.prototype = Object.create(EventSource && EventSource.prototype);
    MouseSource.prototype.constructor = MouseSource;
    /**
   * Detect if a mouse event was simulated from a touch by
   * checking if previously there was a touch event at the
   * same position.
   *
   * FIXME - Known problem with the native Android browser on
   * Samsung GT-I9100 (Android 4.1.2):
   * In case the page is scrolled, this function does not work
   * correctly when a canvas is used (WebGL or canvas renderer).
   * Mouse listeners on canvas elements (for this browser), create
   * two mouse events: One 'good' and one 'bad' one (on other browsers or
   * when a div is used, there is only one event). For the 'bad' one,
   * clientX/clientY and also pageX/pageY are wrong when the page
   * is scrolled. Because of that, this function can not detect if
   * the events were simulated from a touch event. As result, a
   * pointer event at a wrong position is dispatched, which confuses
   * the map interactions.
   * It is unclear, how one can get the correct position for the event
   * or detect that the positions are invalid.
   *
   * @private
   * @param {MouseEvent} inEvent The in event.
   * @return {boolean} True, if the event was generated by a touch.
   */ MouseSource.prototype.isEventSimulatedFromTouch_ = function isEventSimulatedFromTouch_(inEvent) {
        var lts = this.lastTouches;
        var x = inEvent.clientX;
        var y = inEvent.clientY;
        for(var i = 0, l = lts.length, t = void 0; i < l && (t = lts[i]); i++){
            // simulated mouse events will be swallowed near a primary touchend
            var dx = Math.abs(x - t[0]);
            var dy = Math.abs(y - t[1]);
            if (dx <= $b35fa32ce9b38cf6$var$DEDUP_DIST && dy <= $b35fa32ce9b38cf6$var$DEDUP_DIST) return true;
        }
        return false;
    };
    /**
   * Dispatches a `pointercancel` event.
   *
   * @param {Event} inEvent The in event.
   */ MouseSource.prototype.cancel = function cancel(inEvent) {
        var e = $b35fa32ce9b38cf6$export$2d67fb380bd11267(inEvent, this.dispatcher);
        this.dispatcher.cancel(e, inEvent);
        this.cleanupMouse();
    };
    /**
   * Remove the mouse from the list of active pointers.
   */ MouseSource.prototype.cleanupMouse = function cleanupMouse() {
        delete this.pointerMap[$b35fa32ce9b38cf6$export$cbf1ee0ba0a79a8a.toString()];
    };
    return MouseSource;
}((0, $3bcb787536cf3f65$export$2e2bcd8739ae039));
function $b35fa32ce9b38cf6$export$2d67fb380bd11267(inEvent, dispatcher) {
    var e = dispatcher.cloneEvent(inEvent, inEvent);
    // forward mouse preventDefault
    var pd = e.preventDefault;
    e.preventDefault = function() {
        inEvent.preventDefault();
        pd();
    };
    e.pointerId = $b35fa32ce9b38cf6$export$cbf1ee0ba0a79a8a;
    e.isPrimary = true;
    e.pointerType = $b35fa32ce9b38cf6$export$bfaa7c08c18ee972;
    return e;
}
var $b35fa32ce9b38cf6$export$2e2bcd8739ae039 = $b35fa32ce9b38cf6$var$MouseSource;


/**
 * @module ol/pointer/MsSource
 */ // Based on https://github.com/Polymer/PointerEvents
// Copyright (c) 2013 The Polymer Authors. All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
// * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
// * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
// * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

/**
 * @const
 * @type {Array<string>}
 */ var $9c5c40c4cc248a75$var$POINTER_TYPES = [
    "",
    "unavailable",
    "touch",
    "pen",
    "mouse"
];
/**
 * Handler for `msPointerDown`.
 *
 * @this {MsSource}
 * @param {MSPointerEvent} inEvent The in event.
 */ function $9c5c40c4cc248a75$var$msPointerDown(inEvent) {
    this.pointerMap[inEvent.pointerId.toString()] = inEvent;
    var e = this.prepareEvent_(inEvent);
    this.dispatcher.down(e, inEvent);
}
/**
 * Handler for `msPointerMove`.
 *
 * @this {MsSource}
 * @param {MSPointerEvent} inEvent The in event.
 */ function $9c5c40c4cc248a75$var$msPointerMove(inEvent) {
    var e = this.prepareEvent_(inEvent);
    this.dispatcher.move(e, inEvent);
}
/**
 * Handler for `msPointerUp`.
 *
 * @this {MsSource}
 * @param {MSPointerEvent} inEvent The in event.
 */ function $9c5c40c4cc248a75$var$msPointerUp(inEvent) {
    var e = this.prepareEvent_(inEvent);
    this.dispatcher.up(e, inEvent);
    this.cleanup(inEvent.pointerId);
}
/**
 * Handler for `msPointerOut`.
 *
 * @this {MsSource}
 * @param {MSPointerEvent} inEvent The in event.
 */ function $9c5c40c4cc248a75$var$msPointerOut(inEvent) {
    var e = this.prepareEvent_(inEvent);
    this.dispatcher.leaveOut(e, inEvent);
}
/**
 * Handler for `msPointerOver`.
 *
 * @this {MsSource}
 * @param {MSPointerEvent} inEvent The in event.
 */ function $9c5c40c4cc248a75$var$msPointerOver(inEvent) {
    var e = this.prepareEvent_(inEvent);
    this.dispatcher.enterOver(e, inEvent);
}
/**
 * Handler for `msPointerCancel`.
 *
 * @this {MsSource}
 * @param {MSPointerEvent} inEvent The in event.
 */ function $9c5c40c4cc248a75$var$msPointerCancel(inEvent) {
    var e = this.prepareEvent_(inEvent);
    this.dispatcher.cancel(e, inEvent);
    this.cleanup(inEvent.pointerId);
}
/**
 * Handler for `msLostPointerCapture`.
 *
 * @this {MsSource}
 * @param {MSPointerEvent} inEvent The in event.
 */ function $9c5c40c4cc248a75$var$msLostPointerCapture(inEvent) {
    var e = this.dispatcher.makeEvent("lostpointercapture", inEvent, inEvent);
    this.dispatcher.dispatchEvent(e);
}
/**
 * Handler for `msGotPointerCapture`.
 *
 * @this {MsSource}
 * @param {MSPointerEvent} inEvent The in event.
 */ function $9c5c40c4cc248a75$var$msGotPointerCapture(inEvent) {
    var e = this.dispatcher.makeEvent("gotpointercapture", inEvent, inEvent);
    this.dispatcher.dispatchEvent(e);
}
var $9c5c40c4cc248a75$var$MsSource = /*@__PURE__*/ function(EventSource) {
    function MsSource(dispatcher) {
        var mapping = {
            "MSPointerDown": $9c5c40c4cc248a75$var$msPointerDown,
            "MSPointerMove": $9c5c40c4cc248a75$var$msPointerMove,
            "MSPointerUp": $9c5c40c4cc248a75$var$msPointerUp,
            "MSPointerOut": $9c5c40c4cc248a75$var$msPointerOut,
            "MSPointerOver": $9c5c40c4cc248a75$var$msPointerOver,
            "MSPointerCancel": $9c5c40c4cc248a75$var$msPointerCancel,
            "MSGotPointerCapture": $9c5c40c4cc248a75$var$msGotPointerCapture,
            "MSLostPointerCapture": $9c5c40c4cc248a75$var$msLostPointerCapture
        };
        EventSource.call(this, dispatcher, mapping);
        /**
     * @const
     * @type {!Object<string, MSPointerEvent|Object>}
     */ this.pointerMap = dispatcher.pointerMap;
    }
    if (EventSource) MsSource.__proto__ = EventSource;
    MsSource.prototype = Object.create(EventSource && EventSource.prototype);
    MsSource.prototype.constructor = MsSource;
    /**
   * Creates a copy of the original event that will be used
   * for the fake pointer event.
   *
   * @private
   * @param {MSPointerEvent} inEvent The in event.
   * @return {Object} The copied event.
   */ MsSource.prototype.prepareEvent_ = function prepareEvent_(inEvent) {
        /** @type {MSPointerEvent|Object} */ var e = inEvent;
        if (typeof inEvent.pointerType === "number") {
            e = this.dispatcher.cloneEvent(inEvent, inEvent);
            e.pointerType = $9c5c40c4cc248a75$var$POINTER_TYPES[inEvent.pointerType];
        }
        return e;
    };
    /**
   * Remove this pointer from the list of active pointers.
   * @param {number} pointerId Pointer identifier.
   */ MsSource.prototype.cleanup = function cleanup(pointerId) {
        delete this.pointerMap[pointerId.toString()];
    };
    return MsSource;
}((0, $3bcb787536cf3f65$export$2e2bcd8739ae039));
var $9c5c40c4cc248a75$export$2e2bcd8739ae039 = $9c5c40c4cc248a75$var$MsSource;


/**
 * @module ol/pointer/NativeSource
 */ // Based on https://github.com/Polymer/PointerEvents
// Copyright (c) 2013 The Polymer Authors. All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
// * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
// * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
// * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

/**
 * Handler for `pointerdown`.
 *
 * @this {NativeSource}
 * @param {Event} inEvent The in event.
 */ function $1f76eae2a2dfc831$var$pointerDown(inEvent) {
    this.dispatcher.fireNativeEvent(inEvent);
}
/**
 * Handler for `pointermove`.
 *
 * @this {NativeSource}
 * @param {Event} inEvent The in event.
 */ function $1f76eae2a2dfc831$var$pointerMove(inEvent) {
    this.dispatcher.fireNativeEvent(inEvent);
}
/**
 * Handler for `pointerup`.
 *
 * @this {NativeSource}
 * @param {Event} inEvent The in event.
 */ function $1f76eae2a2dfc831$var$pointerUp(inEvent) {
    this.dispatcher.fireNativeEvent(inEvent);
}
/**
 * Handler for `pointerout`.
 *
 * @this {NativeSource}
 * @param {Event} inEvent The in event.
 */ function $1f76eae2a2dfc831$var$pointerOut(inEvent) {
    this.dispatcher.fireNativeEvent(inEvent);
}
/**
 * Handler for `pointerover`.
 *
 * @this {NativeSource}
 * @param {Event} inEvent The in event.
 */ function $1f76eae2a2dfc831$var$pointerOver(inEvent) {
    this.dispatcher.fireNativeEvent(inEvent);
}
/**
 * Handler for `pointercancel`.
 *
 * @this {NativeSource}
 * @param {Event} inEvent The in event.
 */ function $1f76eae2a2dfc831$var$pointerCancel(inEvent) {
    this.dispatcher.fireNativeEvent(inEvent);
}
/**
 * Handler for `lostpointercapture`.
 *
 * @this {NativeSource}
 * @param {Event} inEvent The in event.
 */ function $1f76eae2a2dfc831$var$lostPointerCapture(inEvent) {
    this.dispatcher.fireNativeEvent(inEvent);
}
/**
 * Handler for `gotpointercapture`.
 *
 * @this {NativeSource}
 * @param {Event} inEvent The in event.
 */ function $1f76eae2a2dfc831$var$gotPointerCapture(inEvent) {
    this.dispatcher.fireNativeEvent(inEvent);
}
var $1f76eae2a2dfc831$var$NativeSource = /*@__PURE__*/ function(EventSource) {
    function NativeSource(dispatcher) {
        var mapping = {
            "pointerdown": $1f76eae2a2dfc831$var$pointerDown,
            "pointermove": $1f76eae2a2dfc831$var$pointerMove,
            "pointerup": $1f76eae2a2dfc831$var$pointerUp,
            "pointerout": $1f76eae2a2dfc831$var$pointerOut,
            "pointerover": $1f76eae2a2dfc831$var$pointerOver,
            "pointercancel": $1f76eae2a2dfc831$var$pointerCancel,
            "gotpointercapture": $1f76eae2a2dfc831$var$gotPointerCapture,
            "lostpointercapture": $1f76eae2a2dfc831$var$lostPointerCapture
        };
        EventSource.call(this, dispatcher, mapping);
    }
    if (EventSource) NativeSource.__proto__ = EventSource;
    NativeSource.prototype = Object.create(EventSource && EventSource.prototype);
    NativeSource.prototype.constructor = NativeSource;
    return NativeSource;
}((0, $3bcb787536cf3f65$export$2e2bcd8739ae039));
var $1f76eae2a2dfc831$export$2e2bcd8739ae039 = $1f76eae2a2dfc831$var$NativeSource;


/**
 * @module ol/pointer/PointerEvent
 */ // Based on https://github.com/Polymer/PointerEvents
// Copyright (c) 2013 The Polymer Authors. All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
// * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
// * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
// * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

/**
 * Is the `buttons` property supported?
 * @type {boolean}
 */ var $a9997e849e93576d$var$HAS_BUTTONS = false;
var $a9997e849e93576d$var$PointerEvent = /*@__PURE__*/ function(_Event) {
    function PointerEvent(type, originalEvent, opt_eventDict) {
        _Event.call(this, type);
        /**
     * @const
     * @type {Event}
     */ this.originalEvent = originalEvent;
        var eventDict = opt_eventDict ? opt_eventDict : {};
        /**
     * @type {number}
     */ this.buttons = $a9997e849e93576d$var$getButtons(eventDict);
        /**
     * @type {number}
     */ this.pressure = $a9997e849e93576d$var$getPressure(eventDict, this.buttons);
        // MouseEvent related properties
        /**
     * @type {boolean}
     */ this.bubbles = "bubbles" in eventDict ? eventDict["bubbles"] : false;
        /**
     * @type {boolean}
     */ this.cancelable = "cancelable" in eventDict ? eventDict["cancelable"] : false;
        /**
     * @type {Object}
     */ this.view = "view" in eventDict ? eventDict["view"] : null;
        /**
     * @type {number}
     */ this.detail = "detail" in eventDict ? eventDict["detail"] : null;
        /**
     * @type {number}
     */ this.screenX = "screenX" in eventDict ? eventDict["screenX"] : 0;
        /**
     * @type {number}
     */ this.screenY = "screenY" in eventDict ? eventDict["screenY"] : 0;
        /**
     * @type {number}
     */ this.clientX = "clientX" in eventDict ? eventDict["clientX"] : 0;
        /**
     * @type {number}
     */ this.clientY = "clientY" in eventDict ? eventDict["clientY"] : 0;
        /**
     * @type {boolean}
     */ this.ctrlKey = "ctrlKey" in eventDict ? eventDict["ctrlKey"] : false;
        /**
     * @type {boolean}
     */ this.altKey = "altKey" in eventDict ? eventDict["altKey"] : false;
        /**
     * @type {boolean}
     */ this.shiftKey = "shiftKey" in eventDict ? eventDict["shiftKey"] : false;
        /**
     * @type {boolean}
     */ this.metaKey = "metaKey" in eventDict ? eventDict["metaKey"] : false;
        /**
     * @type {number}
     */ this.button = "button" in eventDict ? eventDict["button"] : 0;
        /**
     * @type {Node}
     */ this.relatedTarget = "relatedTarget" in eventDict ? eventDict["relatedTarget"] : null;
        // PointerEvent related properties
        /**
     * @const
     * @type {number}
     */ this.pointerId = "pointerId" in eventDict ? eventDict["pointerId"] : 0;
        /**
     * @type {number}
     */ this.width = "width" in eventDict ? eventDict["width"] : 0;
        /**
     * @type {number}
     */ this.height = "height" in eventDict ? eventDict["height"] : 0;
        /**
     * @type {number}
     */ this.tiltX = "tiltX" in eventDict ? eventDict["tiltX"] : 0;
        /**
     * @type {number}
     */ this.tiltY = "tiltY" in eventDict ? eventDict["tiltY"] : 0;
        /**
     * @type {string}
     */ this.pointerType = "pointerType" in eventDict ? eventDict["pointerType"] : "";
        /**
     * @type {number}
     */ this.hwTimestamp = "hwTimestamp" in eventDict ? eventDict["hwTimestamp"] : 0;
        /**
     * @type {boolean}
     */ this.isPrimary = "isPrimary" in eventDict ? eventDict["isPrimary"] : false;
        // keep the semantics of preventDefault
        if (originalEvent.preventDefault) this.preventDefault = function() {
            originalEvent.preventDefault();
        };
    }
    if (_Event) PointerEvent.__proto__ = _Event;
    PointerEvent.prototype = Object.create(_Event && _Event.prototype);
    PointerEvent.prototype.constructor = PointerEvent;
    return PointerEvent;
}((0, $0327f54963b35733$export$2e2bcd8739ae039));
/**
 * @param {Object<string, ?>} eventDict The event dictionary.
 * @return {number} Button indicator.
 */ function $a9997e849e93576d$var$getButtons(eventDict) {
    // According to the w3c spec,
    // http://www.w3.org/TR/DOM-Level-3-Events/#events-MouseEvent-button
    // MouseEvent.button == 0 can mean either no mouse button depressed, or the
    // left mouse button depressed.
    //
    // As of now, the only way to distinguish between the two states of
    // MouseEvent.button is by using the deprecated MouseEvent.which property, as
    // this maps mouse buttons to positive integers > 0, and uses 0 to mean that
    // no mouse button is held.
    //
    // MouseEvent.which is derived from MouseEvent.button at MouseEvent creation,
    // but initMouseEvent does not expose an argument with which to set
    // MouseEvent.which. Calling initMouseEvent with a buttonArg of 0 will set
    // MouseEvent.button == 0 and MouseEvent.which == 1, breaking the expectations
    // of app developers.
    //
    // The only way to propagate the correct state of MouseEvent.which and
    // MouseEvent.button to a new MouseEvent.button == 0 and MouseEvent.which == 0
    // is to call initMouseEvent with a buttonArg value of -1.
    //
    // This is fixed with DOM Level 4's use of buttons
    var buttons;
    if (eventDict.buttons || $a9997e849e93576d$var$HAS_BUTTONS) buttons = eventDict.buttons;
    else switch(eventDict.which){
        case 1:
            buttons = 1;
            break;
        case 2:
            buttons = 4;
            break;
        case 3:
            buttons = 2;
            break;
        default:
            buttons = 0;
    }
    return buttons;
}
/**
 * @param {Object<string, ?>} eventDict The event dictionary.
 * @param {number} buttons Button indicator.
 * @return {number} The pressure.
 */ function $a9997e849e93576d$var$getPressure(eventDict, buttons) {
    // Spec requires that pointers without pressure specified use 0.5 for down
    // state and 0 for up state.
    var pressure = 0;
    if (eventDict.pressure) pressure = eventDict.pressure;
    else pressure = buttons ? 0.5 : 0;
    return pressure;
}
/**
 * Checks if the `buttons` property is supported.
 */ (function() {
    try {
        var ev = new MouseEvent("click", {
            buttons: 1
        });
        $a9997e849e93576d$var$HAS_BUTTONS = ev.buttons === 1;
    } catch (e) {
    // pass
    }
})();
var $a9997e849e93576d$export$2e2bcd8739ae039 = $a9997e849e93576d$var$PointerEvent;


/**
 * @module ol/pointer/TouchSource
 */ // Based on https://github.com/Polymer/PointerEvents
// Copyright (c) 2013 The Polymer Authors. All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
// * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
// * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
// * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
/**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function=} opt_comparator Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $830d23b8323fc080$export$2e0ae67339d5f1ac(haystack, needle, opt_comparator) {
    var mid, cmp;
    var comparator = opt_comparator || $830d23b8323fc080$export$4e734a3b32fb971b;
    var low = 0;
    var high = haystack.length;
    var found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) low = mid + 1;
        else {
            high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $830d23b8323fc080$export$4e734a3b32fb971b(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $830d23b8323fc080$export$ee2e0f811dca1807(arr, obj) {
    return arr.indexOf(obj) >= 0;
}
function $830d23b8323fc080$export$8a3786cc03fdb777(arr, target, direction) {
    var n = arr.length;
    if (arr[0] <= target) return 0;
    else if (target <= arr[n - 1]) return n - 1;
    else {
        var i;
        if (direction > 0) for(i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        else if (direction < 0) for(i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        else for(i = 1; i < n; ++i){
            if (arr[i] == target) return i;
            else if (arr[i] < target) {
                if (arr[i - 1] - target < target - arr[i]) return i - 1;
                else return i;
            }
        }
        return n - 1;
    }
}
function $830d23b8323fc080$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        var tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $830d23b8323fc080$export$8b58be045bf06082(arr, data) {
    var extension = Array.isArray(data) ? data : [
        data
    ];
    var length = extension.length;
    for(var i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $830d23b8323fc080$export$cd7f480d6b8286c3(arr, obj) {
    var i = arr.indexOf(obj);
    var found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $830d23b8323fc080$export$71aa6c912b956294(arr, func) {
    var length = arr.length >>> 0;
    var value;
    for(var i = 0; i < length; i++){
        value = arr[i];
        if (func(value, i, arr)) return value;
    }
    return null;
}
function $830d23b8323fc080$export$e9bab7fafb253603(arr1, arr2) {
    var len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(var i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $830d23b8323fc080$export$c7d3d1f96a700512(arr, compareFnc) {
    var length = arr.length;
    var tmp = Array(arr.length);
    var i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $830d23b8323fc080$export$de3a4d4a0d731119(arr, func) {
    var index;
    var found = !arr.every(function(el, idx) {
        index = idx;
        return !func(el, idx, arr);
    });
    return found ? index : -1;
}
function $830d23b8323fc080$export$efa610630f9e181(arr, opt_func, opt_strict) {
    var compare = opt_func || $830d23b8323fc080$export$4e734a3b32fb971b;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        var res = compare(arr[index - 1], currentVal);
        return !(res > 0 || opt_strict && res === 0);
    });
}




/**
 * @type {number}
 */ var $ce4c1ef6aae5abc1$var$CLICK_COUNT_TIMEOUT = 200;
/**
 * @type {string}
 */ var $ce4c1ef6aae5abc1$var$POINTER_TYPE = "touch";
/**
 * Handler for `touchstart`, triggers `pointerover`,
 * `pointerenter` and `pointerdown` events.
 *
 * @this {TouchSource}
 * @param {TouchEvent} inEvent The in event.
 */ function $ce4c1ef6aae5abc1$var$touchstart(inEvent) {
    this.vacuumTouches_(inEvent);
    this.setPrimaryTouch_(inEvent.changedTouches[0]);
    this.dedupSynthMouse_(inEvent);
    this.clickCount_++;
    this.processTouches_(inEvent, this.overDown_);
}
/**
 * Handler for `touchmove`.
 *
 * @this {TouchSource}
 * @param {TouchEvent} inEvent The in event.
 */ function $ce4c1ef6aae5abc1$var$touchmove(inEvent) {
    this.processTouches_(inEvent, this.moveOverOut_);
}
/**
 * Handler for `touchend`, triggers `pointerup`,
 * `pointerout` and `pointerleave` events.
 *
 * @this {TouchSource}
 * @param {TouchEvent} inEvent The event.
 */ function $ce4c1ef6aae5abc1$var$touchend(inEvent) {
    this.dedupSynthMouse_(inEvent);
    this.processTouches_(inEvent, this.upOut_);
}
/**
 * Handler for `touchcancel`, triggers `pointercancel`,
 * `pointerout` and `pointerleave` events.
 *
 * @this {TouchSource}
 * @param {TouchEvent} inEvent The in event.
 */ function $ce4c1ef6aae5abc1$var$touchcancel(inEvent) {
    this.processTouches_(inEvent, this.cancelOut_);
}
var $ce4c1ef6aae5abc1$var$TouchSource = /*@__PURE__*/ function(EventSource) {
    function TouchSource(dispatcher, mouseSource) {
        var mapping = {
            "touchstart": $ce4c1ef6aae5abc1$var$touchstart,
            "touchmove": $ce4c1ef6aae5abc1$var$touchmove,
            "touchend": $ce4c1ef6aae5abc1$var$touchend,
            "touchcancel": $ce4c1ef6aae5abc1$var$touchcancel
        };
        EventSource.call(this, dispatcher, mapping);
        /**
     * @const
     * @type {!Object<string, Event|Object>}
     */ this.pointerMap = dispatcher.pointerMap;
        /**
     * @const
     * @type {import("./MouseSource.js").default}
     */ this.mouseSource = mouseSource;
        /**
     * @private
     * @type {number|undefined}
     */ this.firstTouchId_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.clickCount_ = 0;
        /**
     * @private
     * @type {?}
     */ this.resetId_;
        /**
     * Mouse event timeout: This should be long enough to
     * ignore compat mouse events made by touch.
     * @private
     * @type {number}
     */ this.dedupTimeout_ = 2500;
    }
    if (EventSource) TouchSource.__proto__ = EventSource;
    TouchSource.prototype = Object.create(EventSource && EventSource.prototype);
    TouchSource.prototype.constructor = TouchSource;
    /**
   * @private
   * @param {Touch} inTouch The in touch.
   * @return {boolean} True, if this is the primary touch.
   */ TouchSource.prototype.isPrimaryTouch_ = function isPrimaryTouch_(inTouch) {
        return this.firstTouchId_ === inTouch.identifier;
    };
    /**
   * Set primary touch if there are no pointers, or the only pointer is the mouse.
   * @param {Touch} inTouch The in touch.
   * @private
   */ TouchSource.prototype.setPrimaryTouch_ = function setPrimaryTouch_(inTouch) {
        var count = Object.keys(this.pointerMap).length;
        if (count === 0 || count === 1 && (0, $b35fa32ce9b38cf6$export$cbf1ee0ba0a79a8a).toString() in this.pointerMap) {
            this.firstTouchId_ = inTouch.identifier;
            this.cancelResetClickCount_();
        }
    };
    /**
   * @private
   * @param {PointerEvent} inPointer The in pointer object.
   */ TouchSource.prototype.removePrimaryPointer_ = function removePrimaryPointer_(inPointer) {
        if (inPointer.isPrimary) {
            this.firstTouchId_ = undefined;
            this.resetClickCount_();
        }
    };
    /**
   * @private
   */ TouchSource.prototype.resetClickCount_ = function resetClickCount_() {
        this.resetId_ = setTimeout(this.resetClickCountHandler_.bind(this), $ce4c1ef6aae5abc1$var$CLICK_COUNT_TIMEOUT);
    };
    /**
   * @private
   */ TouchSource.prototype.resetClickCountHandler_ = function resetClickCountHandler_() {
        this.clickCount_ = 0;
        this.resetId_ = undefined;
    };
    /**
   * @private
   */ TouchSource.prototype.cancelResetClickCount_ = function cancelResetClickCount_() {
        if (this.resetId_ !== undefined) clearTimeout(this.resetId_);
    };
    /**
   * @private
   * @param {TouchEvent} browserEvent Browser event
   * @param {Touch} inTouch Touch event
   * @return {PointerEvent} A pointer object.
   */ TouchSource.prototype.touchToPointer_ = function touchToPointer_(browserEvent, inTouch) {
        var e = this.dispatcher.cloneEvent(browserEvent, inTouch);
        // Spec specifies that pointerId 1 is reserved for Mouse.
        // Touch identifiers can start at 0.
        // Add 2 to the touch identifier for compatibility.
        e.pointerId = inTouch.identifier + 2;
        // TODO: check if this is necessary?
        //e.target = findTarget(e);
        e.bubbles = true;
        e.cancelable = true;
        e.detail = this.clickCount_;
        e.button = 0;
        e.buttons = 1;
        e.width = inTouch.radiusX || 0;
        e.height = inTouch.radiusY || 0;
        e.pressure = inTouch.force || 0.5;
        e.isPrimary = this.isPrimaryTouch_(inTouch);
        e.pointerType = $ce4c1ef6aae5abc1$var$POINTER_TYPE;
        // make sure that the properties that are different for
        // each `Touch` object are not copied from the BrowserEvent object
        e.clientX = inTouch.clientX;
        e.clientY = inTouch.clientY;
        e.screenX = inTouch.screenX;
        e.screenY = inTouch.screenY;
        return e;
    };
    /**
   * @private
   * @param {TouchEvent} inEvent Touch event
   * @param {function(TouchEvent, PointerEvent)} inFunction In function.
   */ TouchSource.prototype.processTouches_ = function processTouches_(inEvent, inFunction) {
        var touches = Array.prototype.slice.call(inEvent.changedTouches);
        var count = touches.length;
        function preventDefault() {
            inEvent.preventDefault();
        }
        for(var i = 0; i < count; ++i){
            var pointer = this.touchToPointer_(inEvent, touches[i]);
            // forward touch preventDefaults
            pointer.preventDefault = preventDefault;
            inFunction.call(this, inEvent, pointer);
        }
    };
    /**
   * @private
   * @param {TouchList} touchList The touch list.
   * @param {number} searchId Search identifier.
   * @return {boolean} True, if the `Touch` with the given id is in the list.
   */ TouchSource.prototype.findTouch_ = function findTouch_(touchList, searchId) {
        var l = touchList.length;
        for(var i = 0; i < l; i++){
            var touch = touchList[i];
            if (touch.identifier === searchId) return true;
        }
        return false;
    };
    /**
   * In some instances, a touchstart can happen without a touchend. This
   * leaves the pointermap in a broken state.
   * Therefore, on every touchstart, we remove the touches that did not fire a
   * touchend event.
   * To keep state globally consistent, we fire a pointercancel for
   * this "abandoned" touch
   *
   * @private
   * @param {TouchEvent} inEvent The in event.
   */ TouchSource.prototype.vacuumTouches_ = function vacuumTouches_(inEvent) {
        var touchList = inEvent.touches;
        // pointerMap.getCount() should be < touchList.length here,
        // as the touchstart has not been processed yet.
        var keys = Object.keys(this.pointerMap);
        var count = keys.length;
        if (count >= touchList.length) {
            var d = [];
            for(var i = 0; i < count; ++i){
                var key = Number(keys[i]);
                var value = this.pointerMap[key];
                // Never remove pointerId == 1, which is mouse.
                // Touch identifiers are 2 smaller than their pointerId, which is the
                // index in pointermap.
                if (key != (0, $b35fa32ce9b38cf6$export$cbf1ee0ba0a79a8a) && !this.findTouch_(touchList, key - 2)) d.push(value.out);
            }
            for(var i$1 = 0; i$1 < d.length; ++i$1)this.cancelOut_(inEvent, d[i$1]);
        }
    };
    /**
   * @private
   * @param {TouchEvent} browserEvent The event.
   * @param {PointerEvent} inPointer The in pointer object.
   */ TouchSource.prototype.overDown_ = function overDown_(browserEvent, inPointer) {
        this.pointerMap[inPointer.pointerId] = {
            target: inPointer.target,
            out: inPointer,
            outTarget: inPointer.target
        };
        this.dispatcher.over(inPointer, browserEvent);
        this.dispatcher.enter(inPointer, browserEvent);
        this.dispatcher.down(inPointer, browserEvent);
    };
    /**
   * @private
   * @param {TouchEvent} browserEvent The event.
   * @param {PointerEvent} inPointer The in pointer.
   */ TouchSource.prototype.moveOverOut_ = function moveOverOut_(browserEvent, inPointer) {
        var event = inPointer;
        var pointer = this.pointerMap[event.pointerId];
        // a finger drifted off the screen, ignore it
        if (!pointer) return;
        var outEvent = pointer.out;
        var outTarget = pointer.outTarget;
        this.dispatcher.move(event, browserEvent);
        if (outEvent && outTarget !== event.target) {
            outEvent.relatedTarget = event.target;
            /** @type {Object} */ event.relatedTarget = outTarget;
            // recover from retargeting by shadow
            outEvent.target = outTarget;
            if (event.target) {
                this.dispatcher.leaveOut(outEvent, browserEvent);
                this.dispatcher.enterOver(event, browserEvent);
            } else {
                // clean up case when finger leaves the screen
                /** @type {Object} */ event.target = outTarget;
                /** @type {Object} */ event.relatedTarget = null;
                this.cancelOut_(browserEvent, event);
            }
        }
        pointer.out = event;
        pointer.outTarget = event.target;
    };
    /**
   * @private
   * @param {TouchEvent} browserEvent An event.
   * @param {PointerEvent} inPointer The inPointer object.
   */ TouchSource.prototype.upOut_ = function upOut_(browserEvent, inPointer) {
        this.dispatcher.up(inPointer, browserEvent);
        this.dispatcher.out(inPointer, browserEvent);
        this.dispatcher.leave(inPointer, browserEvent);
        this.cleanUpPointer_(inPointer);
    };
    /**
   * @private
   * @param {TouchEvent} browserEvent The event.
   * @param {PointerEvent} inPointer The in pointer.
   */ TouchSource.prototype.cancelOut_ = function cancelOut_(browserEvent, inPointer) {
        this.dispatcher.cancel(inPointer, browserEvent);
        this.dispatcher.out(inPointer, browserEvent);
        this.dispatcher.leave(inPointer, browserEvent);
        this.cleanUpPointer_(inPointer);
    };
    /**
   * @private
   * @param {PointerEvent} inPointer The inPointer object.
   */ TouchSource.prototype.cleanUpPointer_ = function cleanUpPointer_(inPointer) {
        delete this.pointerMap[inPointer.pointerId];
        this.removePrimaryPointer_(inPointer);
    };
    /**
   * Prevent synth mouse events from creating pointer events.
   *
   * @private
   * @param {TouchEvent} inEvent The in event.
   */ TouchSource.prototype.dedupSynthMouse_ = function dedupSynthMouse_(inEvent) {
        var lts = this.mouseSource.lastTouches;
        var t = inEvent.changedTouches[0];
        // only the primary finger will synth mouse events
        if (this.isPrimaryTouch_(t)) {
            // remember x/y of last touch
            var lt = [
                t.clientX,
                t.clientY
            ];
            lts.push(lt);
            setTimeout(function() {
                // remove touch after timeout
                (0, $830d23b8323fc080$export$cd7f480d6b8286c3)(lts, lt);
            }, this.dedupTimeout_);
        }
    };
    return TouchSource;
}((0, $3bcb787536cf3f65$export$2e2bcd8739ae039));
var $ce4c1ef6aae5abc1$export$2e2bcd8739ae039 = $ce4c1ef6aae5abc1$var$TouchSource;


/**
 * Properties to copy when cloning an event, with default values.
 * @type {Array<Array>}
 */ var $92983fea1f45798c$var$CLONE_PROPS = [
    // MouseEvent
    [
        "bubbles",
        false
    ],
    [
        "cancelable",
        false
    ],
    [
        "view",
        null
    ],
    [
        "detail",
        null
    ],
    [
        "screenX",
        0
    ],
    [
        "screenY",
        0
    ],
    [
        "clientX",
        0
    ],
    [
        "clientY",
        0
    ],
    [
        "ctrlKey",
        false
    ],
    [
        "altKey",
        false
    ],
    [
        "shiftKey",
        false
    ],
    [
        "metaKey",
        false
    ],
    [
        "button",
        0
    ],
    [
        "relatedTarget",
        null
    ],
    // DOM Level 3
    [
        "buttons",
        0
    ],
    // PointerEvent
    [
        "pointerId",
        0
    ],
    [
        "width",
        0
    ],
    [
        "height",
        0
    ],
    [
        "pressure",
        0
    ],
    [
        "tiltX",
        0
    ],
    [
        "tiltY",
        0
    ],
    [
        "pointerType",
        ""
    ],
    [
        "hwTimestamp",
        0
    ],
    [
        "isPrimary",
        false
    ],
    // event instance
    [
        "type",
        ""
    ],
    [
        "target",
        null
    ],
    [
        "currentTarget",
        null
    ],
    [
        "which",
        0
    ]
];
var $92983fea1f45798c$var$PointerEventHandler = /*@__PURE__*/ function(EventTarget) {
    function PointerEventHandler(element) {
        EventTarget.call(this);
        /**
     * @const
     * @private
     * @type {Element|HTMLDocument}
     */ this.element_ = element;
        /**
     * @const
     * @type {!Object<string, Event|Object>}
     */ this.pointerMap = {};
        /**
     * @type {Object<string, function(Event)>}
     * @private
     */ this.eventMap_ = {};
        /**
     * @type {Array<import("./EventSource.js").default>}
     * @private
     */ this.eventSourceList_ = [];
        this.registerSources();
    }
    if (EventTarget) PointerEventHandler.__proto__ = EventTarget;
    PointerEventHandler.prototype = Object.create(EventTarget && EventTarget.prototype);
    PointerEventHandler.prototype.constructor = PointerEventHandler;
    /**
   * Set up the event sources (mouse, touch and native pointers)
   * that generate pointer events.
   */ PointerEventHandler.prototype.registerSources = function registerSources() {
        if (0, $89969764a1196844$export$dccde0e92ea6945d) this.registerSource("native", new (0, $1f76eae2a2dfc831$export$2e2bcd8739ae039)(this));
        else if (0, $89969764a1196844$export$6e620742ec21ecc4) this.registerSource("ms", new (0, $9c5c40c4cc248a75$export$2e2bcd8739ae039)(this));
        else {
            var mouseSource = new (0, $b35fa32ce9b38cf6$export$2e2bcd8739ae039)(this);
            this.registerSource("mouse", mouseSource);
            if (0, $89969764a1196844$export$d46bd3ead7cc759b) this.registerSource("touch", new (0, $ce4c1ef6aae5abc1$export$2e2bcd8739ae039)(this, mouseSource));
        }
        // register events on the viewport element
        this.register_();
    };
    /**
   * Add a new event source that will generate pointer events.
   *
   * @param {string} name A name for the event source
   * @param {import("./EventSource.js").default} source The source event.
   */ PointerEventHandler.prototype.registerSource = function registerSource(name, source) {
        var s = source;
        var newEvents = s.getEvents();
        if (newEvents) {
            newEvents.forEach((function(e) {
                var handler = s.getHandlerForEvent(e);
                if (handler) this.eventMap_[e] = handler.bind(s);
            }).bind(this));
            this.eventSourceList_.push(s);
        }
    };
    /**
   * Set up the events for all registered event sources.
   * @private
   */ PointerEventHandler.prototype.register_ = function register_() {
        var l = this.eventSourceList_.length;
        for(var i = 0; i < l; i++){
            var eventSource = this.eventSourceList_[i];
            this.addEvents_(eventSource.getEvents());
        }
    };
    /**
   * Remove all registered events.
   * @private
   */ PointerEventHandler.prototype.unregister_ = function unregister_() {
        var l = this.eventSourceList_.length;
        for(var i = 0; i < l; i++){
            var eventSource = this.eventSourceList_[i];
            this.removeEvents_(eventSource.getEvents());
        }
    };
    /**
   * Calls the right handler for a new event.
   * @private
   * @param {Event} inEvent Browser event.
   */ PointerEventHandler.prototype.eventHandler_ = function eventHandler_(inEvent) {
        var type = inEvent.type;
        var handler = this.eventMap_[type];
        if (handler) handler(inEvent);
    };
    /**
   * Setup listeners for the given events.
   * @private
   * @param {Array<string>} events List of events.
   */ PointerEventHandler.prototype.addEvents_ = function addEvents_(events) {
        events.forEach((function(eventName) {
            (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.element_, eventName, this.eventHandler_, this);
        }).bind(this));
    };
    /**
   * Unregister listeners for the given events.
   * @private
   * @param {Array<string>} events List of events.
   */ PointerEventHandler.prototype.removeEvents_ = function removeEvents_(events) {
        events.forEach((function(e) {
            (0, $37a5c0af9052e360$export$35276765542cd163)(this.element_, e, this.eventHandler_, this);
        }).bind(this));
    };
    /**
   * Returns a snapshot of inEvent, with writable properties.
   *
   * @param {Event} event Browser event.
   * @param {Event|Touch} inEvent An event that contains
   *    properties to copy.
   * @return {Object} An object containing shallow copies of
   *    `inEvent`'s properties.
   */ PointerEventHandler.prototype.cloneEvent = function cloneEvent(event, inEvent) {
        var eventCopy = {};
        for(var i = 0, ii = $92983fea1f45798c$var$CLONE_PROPS.length; i < ii; i++){
            var p = $92983fea1f45798c$var$CLONE_PROPS[i][0];
            eventCopy[p] = event[p] || inEvent[p] || $92983fea1f45798c$var$CLONE_PROPS[i][1];
        }
        return eventCopy;
    };
    // EVENTS
    /**
   * Triggers a 'pointerdown' event.
   * @param {Object} data Pointer event data.
   * @param {Event} event The event.
   */ PointerEventHandler.prototype.down = function down(data, event) {
        this.fireEvent((0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTERDOWN, data, event);
    };
    /**
   * Triggers a 'pointermove' event.
   * @param {Object} data Pointer event data.
   * @param {Event} event The event.
   */ PointerEventHandler.prototype.move = function move(data, event) {
        this.fireEvent((0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTERMOVE, data, event);
    };
    /**
   * Triggers a 'pointerup' event.
   * @param {Object} data Pointer event data.
   * @param {Event} event The event.
   */ PointerEventHandler.prototype.up = function up(data, event) {
        this.fireEvent((0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTERUP, data, event);
    };
    /**
   * Triggers a 'pointerenter' event.
   * @param {Object} data Pointer event data.
   * @param {Event} event The event.
   */ PointerEventHandler.prototype.enter = function enter(data, event) {
        data.bubbles = false;
        this.fireEvent((0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTERENTER, data, event);
    };
    /**
   * Triggers a 'pointerleave' event.
   * @param {Object} data Pointer event data.
   * @param {Event} event The event.
   */ PointerEventHandler.prototype.leave = function leave(data, event) {
        data.bubbles = false;
        this.fireEvent((0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTERLEAVE, data, event);
    };
    /**
   * Triggers a 'pointerover' event.
   * @param {Object} data Pointer event data.
   * @param {Event} event The event.
   */ PointerEventHandler.prototype.over = function over(data, event) {
        data.bubbles = true;
        this.fireEvent((0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTEROVER, data, event);
    };
    /**
   * Triggers a 'pointerout' event.
   * @param {Object} data Pointer event data.
   * @param {Event} event The event.
   */ PointerEventHandler.prototype.out = function out(data, event) {
        data.bubbles = true;
        this.fireEvent((0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTEROUT, data, event);
    };
    /**
   * Triggers a 'pointercancel' event.
   * @param {Object} data Pointer event data.
   * @param {Event} event The event.
   */ PointerEventHandler.prototype.cancel = function cancel(data, event) {
        this.fireEvent((0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTERCANCEL, data, event);
    };
    /**
   * Triggers a combination of 'pointerout' and 'pointerleave' events.
   * @param {Object} data Pointer event data.
   * @param {Event} event The event.
   */ PointerEventHandler.prototype.leaveOut = function leaveOut(data, event) {
        this.out(data, event);
        if (!this.contains_(data.target, data.relatedTarget)) this.leave(data, event);
    };
    /**
   * Triggers a combination of 'pointerover' and 'pointerevents' events.
   * @param {Object} data Pointer event data.
   * @param {Event} event The event.
   */ PointerEventHandler.prototype.enterOver = function enterOver(data, event) {
        this.over(data, event);
        if (!this.contains_(data.target, data.relatedTarget)) this.enter(data, event);
    };
    /**
   * @private
   * @param {Element} container The container element.
   * @param {Element} contained The contained element.
   * @return {boolean} Returns true if the container element
   *   contains the other element.
   */ PointerEventHandler.prototype.contains_ = function contains_(container, contained) {
        if (!container || !contained) return false;
        return container.contains(contained);
    };
    // EVENT CREATION AND TRACKING
    /**
   * Creates a new Event of type `inType`, based on the information in
   * `data`.
   *
   * @param {string} inType A string representing the type of event to create.
   * @param {Object} data Pointer event data.
   * @param {Event} event The event.
   * @return {PointerEvent} A PointerEvent of type `inType`.
   */ PointerEventHandler.prototype.makeEvent = function makeEvent(inType, data, event) {
        return new (0, $a9997e849e93576d$export$2e2bcd8739ae039)(inType, event, data);
    };
    /**
   * Make and dispatch an event in one call.
   * @param {string} inType A string representing the type of event.
   * @param {Object} data Pointer event data.
   * @param {Event} event The event.
   */ PointerEventHandler.prototype.fireEvent = function fireEvent(inType, data, event) {
        var e = this.makeEvent(inType, data, event);
        this.dispatchEvent(e);
    };
    /**
   * Creates a pointer event from a native pointer event
   * and dispatches this event.
   * @param {Event} event A platform event with a target.
   */ PointerEventHandler.prototype.fireNativeEvent = function fireNativeEvent(event) {
        var e = this.makeEvent(event.type, event, event);
        this.dispatchEvent(e);
    };
    /**
   * Wrap a native mouse event into a pointer event.
   * This proxy method is required for the legacy IE support.
   * @param {string} eventType The pointer event type.
   * @param {Event} event The event.
   * @return {PointerEvent} The wrapped event.
   */ PointerEventHandler.prototype.wrapMouseEvent = function wrapMouseEvent(eventType, event) {
        var pointerEvent = this.makeEvent(eventType, (0, $b35fa32ce9b38cf6$export$2d67fb380bd11267)(event, this), event);
        return pointerEvent;
    };
    /**
   * @inheritDoc
   */ PointerEventHandler.prototype.disposeInternal = function disposeInternal() {
        this.unregister_();
        EventTarget.prototype.disposeInternal.call(this);
    };
    return PointerEventHandler;
}((0, $dd029d816e3b4259$export$2e2bcd8739ae039));
var $92983fea1f45798c$export$2e2bcd8739ae039 = $92983fea1f45798c$var$PointerEventHandler;


var $ad641aa29114f9e4$var$MapBrowserEventHandler = /*@__PURE__*/ function(EventTarget) {
    function MapBrowserEventHandler(map, moveTolerance) {
        EventTarget.call(this);
        /**
     * This is the element that we will listen to the real events on.
     * @type {import("./PluggableMap.js").default}
     * @private
     */ this.map_ = map;
        /**
     * @type {any}
     * @private
     */ this.clickTimeoutId_;
        /**
     * @type {boolean}
     * @private
     */ this.dragging_ = false;
        /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */ this.dragListenerKeys_ = [];
        /**
     * @type {number}
     * @private
     */ this.moveTolerance_ = moveTolerance ? moveTolerance * (0, $89969764a1196844$export$6b83a0446fc26f94) : (0, $89969764a1196844$export$6b83a0446fc26f94);
        /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {import("./pointer/PointerEvent.js").default}
     * @private
     */ this.down_ = null;
        var element = this.map_.getViewport();
        /**
     * @type {number}
     * @private
     */ this.activePointers_ = 0;
        /**
     * @type {!Object<number, boolean>}
     * @private
     */ this.trackedTouches_ = {};
        /**
     * Event handler which generates pointer events for
     * the viewport element.
     *
     * @type {PointerEventHandler}
     * @private
     */ this.pointerEventHandler_ = new (0, $92983fea1f45798c$export$2e2bcd8739ae039)(element);
        /**
     * Event handler which generates pointer events for
     * the document (used when dragging).
     *
     * @type {PointerEventHandler}
     * @private
     */ this.documentPointerEventHandler_ = null;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.pointerdownListenerKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.pointerEventHandler_, (0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTERDOWN, this.handlePointerDown_, this);
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.relayedListenerKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.pointerEventHandler_, (0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTERMOVE, this.relayEvent_, this);
    }
    if (EventTarget) MapBrowserEventHandler.__proto__ = EventTarget;
    MapBrowserEventHandler.prototype = Object.create(EventTarget && EventTarget.prototype);
    MapBrowserEventHandler.prototype.constructor = MapBrowserEventHandler;
    /**
   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
   * event.
   * @private
   */ MapBrowserEventHandler.prototype.emulateClick_ = function emulateClick_(pointerEvent) {
        var newEvent = new (0, $f38b81bf0090e6d7$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, $f38b81bf0090e6d7$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout((function() {
            this.clickTimeoutId_ = undefined;
            var newEvent = new (0, $f38b81bf0090e6d7$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }).bind(this), 250);
    };
    /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
   * event.
   * @private
   */ MapBrowserEventHandler.prototype.updateActivePointers_ = function updateActivePointers_(pointerEvent) {
        var event = pointerEvent;
        if (event.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERUP || event.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERCANCEL) delete this.trackedTouches_[event.pointerId];
        else if (event.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDOWN) this.trackedTouches_[event.pointerId] = true;
        this.activePointers_ = Object.keys(this.trackedTouches_).length;
    };
    /**
   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
   * event.
   * @private
   */ MapBrowserEventHandler.prototype.handlePointerUp_ = function handlePointerUp_(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        var newEvent = new (0, $f38b81bf0090e6d7$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERUP, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.stopPropagation() or event.preventDefault().
        if (!newEvent.propagationStopped && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_ === 0) {
            this.dragListenerKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
            this.documentPointerEventHandler_.dispose();
            this.documentPointerEventHandler_ = null;
        }
    };
    /**
   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */ MapBrowserEventHandler.prototype.isMouseActionButton_ = function isMouseActionButton_(pointerEvent) {
        return pointerEvent.button === 0;
    };
    /**
   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
   * event.
   * @private
   */ MapBrowserEventHandler.prototype.handlePointerDown_ = function handlePointerDown_(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        var newEvent = new (0, $f38b81bf0090e6d7$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDOWN, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        this.down_ = pointerEvent;
        if (this.dragListenerKeys_.length === 0) {
            /* Set up a pointer event handler on the `document`,
       * which is required when the pointer is moved outside
       * the viewport when dragging.
       */ this.documentPointerEventHandler_ = new (0, $92983fea1f45798c$export$2e2bcd8739ae039)(document);
            this.dragListenerKeys_.push((0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.documentPointerEventHandler_, (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERMOVE, this.handlePointerMove_, this), (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.documentPointerEventHandler_, (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */ (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.pointerEventHandler_, (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERCANCEL, this.handlePointerUp_, this));
        }
    };
    /**
   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
   * event.
   * @private
   */ MapBrowserEventHandler.prototype.handlePointerMove_ = function handlePointerMove_(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.dragging_ = true;
            var newEvent = new (0, $f38b81bf0090e6d7$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDRAG, this.map_, pointerEvent, this.dragging_);
            this.dispatchEvent(newEvent);
        }
        // Some native android browser triggers mousemove events during small period
        // of time. See: https://code.google.com/p/android/issues/detail?id=5491 or
        // https://code.google.com/p/android/issues/detail?id=19827
        // ex: Galaxy Tab P3110 + Android 4.1.1
        pointerEvent.preventDefault();
    };
    /**
   * Wrap and relay a pointer event.  Note that this requires that the type
   * string for the MapBrowserPointerEvent matches the PointerEvent type.
   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
   * event.
   * @private
   */ MapBrowserEventHandler.prototype.relayEvent_ = function relayEvent_(pointerEvent) {
        var dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, $f38b81bf0090e6d7$export$2e2bcd8739ae039)(pointerEvent.type, this.map_, pointerEvent, dragging));
    };
    /**
   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */ MapBrowserEventHandler.prototype.isMoving_ = function isMoving_(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    };
    /**
   * @inheritDoc
   */ MapBrowserEventHandler.prototype.disposeInternal = function disposeInternal() {
        if (this.relayedListenerKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        if (this.pointerdownListenerKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        this.dragListenerKeys_.length = 0;
        if (this.documentPointerEventHandler_) {
            this.documentPointerEventHandler_.dispose();
            this.documentPointerEventHandler_ = null;
        }
        if (this.pointerEventHandler_) {
            this.pointerEventHandler_.dispose();
            this.pointerEventHandler_ = null;
        }
        EventTarget.prototype.disposeInternal.call(this);
    };
    return MapBrowserEventHandler;
}((0, $dd029d816e3b4259$export$2e2bcd8739ae039));
var $ad641aa29114f9e4$export$2e2bcd8739ae039 = $ad641aa29114f9e4$var$MapBrowserEventHandler;




/**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $392290a16437301e$export$2e2bcd8739ae039 = {
    /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */ POSTRENDER: "postrender",
    /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */ MOVESTART: "movestart",
    /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */ MOVEEND: "moveend"
};


/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $25ec5d593032f523$export$2e2bcd8739ae039 = {
    LAYERGROUP: "layergroup",
    SIZE: "size",
    TARGET: "target",
    VIEW: "view"
};


/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $847c6e8c21904781$export$2e2bcd8739ae039 = {
    /**
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */ POSTCOMPOSE: "postcompose",
    /**
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */ PRECOMPOSE: "precompose",
    /**
   * @event module:ol/render/Event~RenderEvent#render
   * @api
   */ RENDER: "render",
    /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */ RENDERCOMPLETE: "rendercomplete"
};




/**
 * @module ol/TileQueue
 */ /**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $2cb810f54791c0da$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
   * Indicates that tile loading failed
   * @type {number}
   */ ERROR: 3,
    EMPTY: 4,
    ABORT: 5
};




/**
 * @module ol/structs/PriorityQueue
 */ /**
 * @module ol/asserts
 */ 
function $b6052fc13e9a3991$export$a7a9523472993e97(assertion, errorCode) {
    if (!assertion) throw new (0, $4096c163f6eb88c6$export$2e2bcd8739ae039)(errorCode);
}



var $10b2c64d0f765608$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See http://closure-library.googlecode.com/svn/docs/closure_goog_structs_heap.js.source.html
 * and http://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ var $10b2c64d0f765608$var$PriorityQueue = function PriorityQueue(priorityFunction, keyFunction) {
    /**
   * @type {function(T): number}
   * @private
   */ this.priorityFunction_ = priorityFunction;
    /**
   * @type {function(T): string}
   * @private
   */ this.keyFunction_ = keyFunction;
    /**
   * @type {Array<T>}
   * @private
   */ this.elements_ = [];
    /**
   * @type {Array<number>}
   * @private
   */ this.priorities_ = [];
    /**
   * @type {!Object<string, boolean>}
   * @private
   */ this.queuedElements_ = {};
};
/**
 * FIXME empty description for jsdoc
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.clear = function clear$1() {
    this.elements_.length = 0;
    this.priorities_.length = 0;
    (0, $8c1e0b75b65663dc$export$42ffd38884aecdac)(this.queuedElements_);
};
/**
 * Remove and return the highest-priority element. O(log N).
 * @return {T} Element.
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.dequeue = function dequeue() {
    var elements = this.elements_;
    var priorities = this.priorities_;
    var element = elements[0];
    if (elements.length == 1) {
        elements.length = 0;
        priorities.length = 0;
    } else {
        elements[0] = elements.pop();
        priorities[0] = priorities.pop();
        this.siftUp_(0);
    }
    var elementKey = this.keyFunction_(element);
    delete this.queuedElements_[elementKey];
    return element;
};
/**
 * Enqueue an element. O(log N).
 * @param {T} element Element.
 * @return {boolean} The element was added to the queue.
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.enqueue = function enqueue(element) {
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!(this.keyFunction_(element) in this.queuedElements_), 31); // Tried to enqueue an `element` that was already added to the queue
    var priority = this.priorityFunction_(element);
    if (priority != $10b2c64d0f765608$export$b4af72c40fd57063) {
        this.elements_.push(element);
        this.priorities_.push(priority);
        this.queuedElements_[this.keyFunction_(element)] = true;
        this.siftDown_(0, this.elements_.length - 1);
        return true;
    }
    return false;
};
/**
 * @return {number} Count.
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.getCount = function getCount() {
    return this.elements_.length;
};
/**
 * Gets the index of the left child of the node at the given index.
 * @param {number} index The index of the node to get the left child for.
 * @return {number} The index of the left child.
 * @private
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.getLeftChildIndex_ = function getLeftChildIndex_(index) {
    return index * 2 + 1;
};
/**
 * Gets the index of the right child of the node at the given index.
 * @param {number} index The index of the node to get the right child for.
 * @return {number} The index of the right child.
 * @private
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.getRightChildIndex_ = function getRightChildIndex_(index) {
    return index * 2 + 2;
};
/**
 * Gets the index of the parent of the node at the given index.
 * @param {number} index The index of the node to get the parent for.
 * @return {number} The index of the parent.
 * @private
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.getParentIndex_ = function getParentIndex_(index) {
    return index - 1 >> 1;
};
/**
 * Make this a heap. O(N).
 * @private
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.heapify_ = function heapify_() {
    var i;
    for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
};
/**
 * @return {boolean} Is empty.
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.isEmpty = function isEmpty() {
    return this.elements_.length === 0;
};
/**
 * @param {string} key Key.
 * @return {boolean} Is key queued.
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.isKeyQueued = function isKeyQueued(key) {
    return key in this.queuedElements_;
};
/**
 * @param {T} element Element.
 * @return {boolean} Is queued.
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.isQueued = function isQueued(element) {
    return this.isKeyQueued(this.keyFunction_(element));
};
/**
 * @param {number} index The index of the node to move down.
 * @private
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.siftUp_ = function siftUp_(index) {
    var elements = this.elements_;
    var priorities = this.priorities_;
    var count = elements.length;
    var element = elements[index];
    var priority = priorities[index];
    var startIndex = index;
    while(index < count >> 1){
        var lIndex = this.getLeftChildIndex_(index);
        var rIndex = this.getRightChildIndex_(index);
        var smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
        elements[index] = elements[smallerChildIndex];
        priorities[index] = priorities[smallerChildIndex];
        index = smallerChildIndex;
    }
    elements[index] = element;
    priorities[index] = priority;
    this.siftDown_(startIndex, index);
};
/**
 * @param {number} startIndex The index of the root.
 * @param {number} index The index of the node to move up.
 * @private
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.siftDown_ = function siftDown_(startIndex, index) {
    var elements = this.elements_;
    var priorities = this.priorities_;
    var element = elements[index];
    var priority = priorities[index];
    while(index > startIndex){
        var parentIndex = this.getParentIndex_(index);
        if (priorities[parentIndex] > priority) {
            elements[index] = elements[parentIndex];
            priorities[index] = priorities[parentIndex];
            index = parentIndex;
        } else break;
    }
    elements[index] = element;
    priorities[index] = priority;
};
/**
 * FIXME empty description for jsdoc
 */ $10b2c64d0f765608$var$PriorityQueue.prototype.reprioritize = function reprioritize() {
    var priorityFunction = this.priorityFunction_;
    var elements = this.elements_;
    var priorities = this.priorities_;
    var index = 0;
    var n = elements.length;
    var element, i, priority;
    for(i = 0; i < n; ++i){
        element = elements[i];
        priority = priorityFunction(element);
        if (priority == $10b2c64d0f765608$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
        else {
            priorities[index] = priority;
            elements[index++] = element;
        }
    }
    elements.length = index;
    priorities.length = index;
    this.heapify_();
};
var $10b2c64d0f765608$export$2e2bcd8739ae039 = $10b2c64d0f765608$var$PriorityQueue;


/**
 * @typedef {function(import("./Tile.js").default, string, import("./coordinate.js").Coordinate, number): number} PriorityFunction
 */ var $05ff08069bfd30f8$var$TileQueue = /*@__PURE__*/ function(PriorityQueue) {
    function TileQueue(tilePriorityFunction, tileChangeCallback) {
        PriorityQueue.call(/**
       * @param {Array} element Element.
       * @return {number} Priority.
       */ this, function(element) {
            return tilePriorityFunction.apply(null, element);
        }, /**
       * @param {Array} element Element.
       * @return {string} Key.
       */ function(element) {
            return /** @type {import("./Tile.js").default} */ element[0].getKey();
        });
        /**
     * @private
     * @type {function(): ?}
     */ this.tileChangeCallback_ = tileChangeCallback;
        /**
     * @private
     * @type {number}
     */ this.tilesLoading_ = 0;
        /**
     * @private
     * @type {!Object<string,boolean>}
     */ this.tilesLoadingKeys_ = {};
    }
    if (PriorityQueue) TileQueue.__proto__ = PriorityQueue;
    TileQueue.prototype = Object.create(PriorityQueue && PriorityQueue.prototype);
    TileQueue.prototype.constructor = TileQueue;
    /**
   * @inheritDoc
   */ TileQueue.prototype.enqueue = function enqueue(element) {
        var added = PriorityQueue.prototype.enqueue.call(this, element);
        if (added) {
            var tile = element[0];
            (0, $37a5c0af9052e360$export$63174c828edd6ff8)(tile, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleTileChange, this);
        }
        return added;
    };
    /**
   * @return {number} Number of tiles loading.
   */ TileQueue.prototype.getTilesLoading = function getTilesLoading() {
        return this.tilesLoading_;
    };
    /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */ TileQueue.prototype.handleTileChange = function handleTileChange(event) {
        var tile = /** @type {import("./Tile.js").default} */ event.target;
        var state = tile.getState();
        if (state === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED || state === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR || state === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY || state === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ABORT) {
            (0, $37a5c0af9052e360$export$35276765542cd163)(tile, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleTileChange, this);
            var tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    };
    /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */ TileQueue.prototype.loadMoreTiles = function loadMoreTiles(maxTotalLoading, maxNewLoads) {
        var newLoads = 0;
        var abortedTiles = false;
        var state, tile, tileKey;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            tile = /** @type {import("./Tile.js").default} */ this.dequeue()[0];
            tileKey = tile.getKey();
            state = tile.getState();
            if (state === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ABORT) abortedTiles = true;
            else if (state === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
        if (newLoads === 0 && abortedTiles) // Do not stop the render loop when all wanted tiles were aborted due to
        // a small, saturated tile cache.
        this.tileChangeCallback_();
    };
    return TileQueue;
}((0, $10b2c64d0f765608$export$2e2bcd8739ae039));
var $05ff08069bfd30f8$export$2e2bcd8739ae039 = $05ff08069bfd30f8$var$TileQueue;


/**
 * @module ol/View
 */ /**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ var $9a8010a8337e7cef$export$e98a216cdcc847dc = 42;
var $9a8010a8337e7cef$export$6b8cb5cd370bd90c = 256;




/**
 * @module ol/centerconstraint
 */ /**
 * @module ol/math
 */ 
function $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
var $d4e56cfc37d8b1f9$export$2e2fd1ad24e4d350 = function() {
    // Wrapped in a iife, to save the overhead of checking for the native
    // implementation on every invocation.
    var cosh;
    if ("cosh" in Math) // The environment supports the native Math.cosh function, use it…
    cosh = Math.cosh;
    else // … else, use the reference implementation of MDN:
    cosh = function(x) {
        var y = /** @type {Math} */ Math.exp(x);
        return (y + 1 / y) / 2;
    };
    return cosh;
}();
function $d4e56cfc37d8b1f9$export$7e3142e021fa7d62(x) {
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)(0 < x, 29); // `x` must be greater than `0`
    return Math.pow(2, Math.ceil(Math.log(x) / Math.LN2));
}
function $d4e56cfc37d8b1f9$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $d4e56cfc37d8b1f9$export$8240f01c446270e6(mat) {
    var n = mat.length;
    for(var i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        var maxRow = i;
        var maxEl = Math.abs(mat[i][i]);
        for(var r = i + 1; r < n; r++){
            var absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        var tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(var j = i + 1; j < n; j++){
            var coef = -mat[j][i] / mat[i][i];
            for(var k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    var x = new Array(n);
    for(var l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(var m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $d4e56cfc37d8b1f9$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $d4e56cfc37d8b1f9$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $d4e56cfc37d8b1f9$export$ba467bec01d66def(a, b) {
    var r = a % b;
    return r * b < 0 ? r + b : r;
}
function $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}


function $6a005ced57043b5f$export$c2f0af2c946f6897(extent) {
    return(/**
     * @param {import("./coordinate.js").Coordinate=} center Center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center) {
        if (center) return [
            (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(center[0], extent[0], extent[2]),
            (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(center[1], extent[1], extent[3])
        ];
        else return undefined;
    });
}
function $6a005ced57043b5f$export$f883a24d5edde77c(center) {
    return center;
}



/**
 * @module ol/resolutionconstraint
 */ 

function $fc7552e588d344e0$export$d65a517690fc4385(resolutions) {
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} delta Delta.
     * @param {number} direction Direction.
     * @return {number|undefined} Resolution.
     */ function(resolution, delta, direction) {
        if (resolution !== undefined) {
            var z = (0, $830d23b8323fc080$export$8a3786cc03fdb777)(resolutions, resolution, direction);
            z = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(z + delta, 0, resolutions.length - 1);
            var index = Math.floor(z);
            if (z != index && index < resolutions.length - 1) {
                var power = resolutions[index] / resolutions[index + 1];
                return resolutions[index] / Math.pow(power, z - index);
            } else return resolutions[index];
        } else return undefined;
    });
}
function $fc7552e588d344e0$export$22ac0f6b219de91a(power, maxResolution, opt_maxLevel) {
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} delta Delta.
     * @param {number} direction Direction.
     * @return {number|undefined} Resolution.
     */ function(resolution, delta, direction) {
        if (resolution !== undefined) {
            var offset = -direction / 2 + 0.5;
            var oldLevel = Math.floor(Math.log(maxResolution / resolution) / Math.log(power) + offset);
            var newLevel = Math.max(oldLevel + delta, 0);
            if (opt_maxLevel !== undefined) newLevel = Math.min(newLevel, opt_maxLevel);
            return maxResolution / Math.pow(power, newLevel);
        } else return undefined;
    });
}


/**
 * @module ol/rotationconstraint
 */ 
function $ea3e0fdf428207b8$export$e20fbacbb41798b(rotation, delta) {
    if (rotation !== undefined) return 0;
    else return undefined;
}
function $ea3e0fdf428207b8$export$f883a24d5edde77c(rotation, delta) {
    if (rotation !== undefined) return rotation + delta;
    else return undefined;
}
function $ea3e0fdf428207b8$export$9ba78806de831083(n) {
    var theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {number} delta Delta.
     * @return {number|undefined} Rotation.
     */ function(rotation, delta) {
        if (rotation !== undefined) {
            rotation = Math.floor((rotation + delta) / theta + 0.5) * theta;
            return rotation;
        } else return undefined;
    });
}
function $ea3e0fdf428207b8$export$17a6e6f3448b17e8(opt_tolerance) {
    var tolerance = opt_tolerance || (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(5);
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {number} delta Delta.
     * @return {number|undefined} Rotation.
     */ function(rotation, delta) {
        if (rotation !== undefined) {
            if (Math.abs(rotation + delta) <= tolerance) return 0;
            else return rotation + delta;
        } else return undefined;
    });
}


/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $1c808e01929bd7f1$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};


/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $5f86c3d53c01e8fe$export$2e2bcd8739ae039 = {
    CENTER: "center",
    RESOLUTION: "resolution",
    ROTATION: "rotation"
};




/**
 * @module ol/coordinate
 */ 
/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number=} opt_precision Precision of the output string (i.e. number of decimal places)
 * @returns {string} Formatted string
 */ function $812f370f71eebcf4$export$24be126cb0a7bbeb(number, width, opt_precision) {
    var numberString = opt_precision !== undefined ? number.toFixed(opt_precision) : "" + number;
    var decimal = numberString.indexOf(".");
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join("0") + numberString;
}
function $812f370f71eebcf4$export$66e1c0999abad646(v1, v2) {
    var s1 = ("" + v1).split(".");
    var s2 = ("" + v2).split(".");
    for(var i = 0; i < Math.max(s1.length, s2.length); i++){
        var n1 = parseInt(s1[i] || "0", 10);
        var n2 = parseInt(s2[i] || "0", 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}


function $8b28786758450fff$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += delta[0];
    coordinate[1] += delta[1];
    return coordinate;
}
function $8b28786758450fff$export$cbe80a3fcd2b99b7(coordinate, circle) {
    var r = circle.getRadius();
    var center = circle.getCenter();
    var x0 = center[0];
    var y0 = center[1];
    var x1 = coordinate[0];
    var y1 = coordinate[1];
    var dx = x1 - x0;
    var dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    var d = Math.sqrt(dx * dx + dy * dy);
    var x = x0 + r * dx / d;
    var y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $8b28786758450fff$export$18cdd31d17f97131(coordinate, segment) {
    var x0 = coordinate[0];
    var y0 = coordinate[1];
    var start = segment[0];
    var end = segment[1];
    var x1 = start[0];
    var y1 = start[1];
    var x2 = end[0];
    var y2 = end[1];
    var dx = x2 - x1;
    var dy = y2 - y1;
    var along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    var x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $8b28786758450fff$export$35ad6765fe262b6(opt_fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $8b28786758450fff$export$9ff8f16060979e0a(coordinate, opt_fractionDigits);
    });
}
function $8b28786758450fff$export$6eb0ac5f024d8590(hemispheres, degrees, opt_fractionDigits) {
    var normalizedDegrees = (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(degrees + 180, 360) - 180;
    var x = Math.abs(3600 * normalizedDegrees);
    var dflPrecision = opt_fractionDigits || 0;
    var precision = Math.pow(10, dflPrecision);
    var deg = Math.floor(x / 3600);
    var min = Math.floor((x - deg * 3600) / 60);
    var sec = x - deg * 3600 - min * 60;
    sec = Math.ceil(sec * precision) / precision;
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    return deg + "\xb0 " + (0, $812f370f71eebcf4$export$24be126cb0a7bbeb)(min, 2) + "\u2032 " + (0, $812f370f71eebcf4$export$24be126cb0a7bbeb)(sec, 2, dflPrecision) + "\u2033" + (normalizedDegrees == 0 ? "" : " " + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0));
}
function $8b28786758450fff$export$d9468344d3651243(coordinate, template, opt_fractionDigits) {
    if (coordinate) return template.replace("{x}", coordinate[0].toFixed(opt_fractionDigits)).replace("{y}", coordinate[1].toFixed(opt_fractionDigits));
    else return "";
}
function $8b28786758450fff$export$e9bab7fafb253603(coordinate1, coordinate2) {
    var equals = true;
    for(var i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $8b28786758450fff$export$bb628a54ab399bc9(coordinate, angle) {
    var cosAngle = Math.cos(angle);
    var sinAngle = Math.sin(angle);
    var x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    var y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $8b28786758450fff$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $8b28786758450fff$export$88e6ebb4fe54f538(coord1, coord2) {
    var dx = coord1[0] - coord2[0];
    var dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $8b28786758450fff$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($8b28786758450fff$export$88e6ebb4fe54f538(coord1, coord2));
}
function $8b28786758450fff$export$6985570514055196(coordinate, segment) {
    return $8b28786758450fff$export$88e6ebb4fe54f538(coordinate, $8b28786758450fff$export$18cdd31d17f97131(coordinate, segment));
}
function $8b28786758450fff$export$c883fd238161f841(coordinate, opt_fractionDigits) {
    if (coordinate) return $8b28786758450fff$export$6eb0ac5f024d8590("NS", coordinate[1], opt_fractionDigits) + " " + $8b28786758450fff$export$6eb0ac5f024d8590("EW", coordinate[0], opt_fractionDigits);
    else return "";
}
function $8b28786758450fff$export$9ff8f16060979e0a(coordinate, opt_fractionDigits) {
    return $8b28786758450fff$export$d9468344d3651243(coordinate, "{x}, {y}", opt_fractionDigits);
}


/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $0164a93fcf6e65ad$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $0164a93fcf6e65ad$export$57636bb43b1ccbb0(t) {
    return 1 - $0164a93fcf6e65ad$export$929e5a82286172a6(1 - t);
}
function $0164a93fcf6e65ad$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $0164a93fcf6e65ad$export$45db2fc2f15997e7(t) {
    return t;
}
function $0164a93fcf6e65ad$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $0164a93fcf6e65ad$export$9b47139b511b56e4(2 * t);
    else return 1 - $0164a93fcf6e65ad$export$9b47139b511b56e4(2 * (t - 0.5));
}


/**
 * @module ol/extent
 */ 
/**
 * @module ol/extent/Corner
 */ /**
 * Extent corner.
 * @enum {string}
 */ var $f386e227189cd37a$export$2e2bcd8739ae039 = {
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right"
};


/**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $68b6ebc493ff6e57$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};


function $7e819822b33b3d32$export$8aceca7c77505534(coordinates) {
    var extent = $7e819822b33b3d32$export$fe201bb3bbe031e9();
    for(var i = 0, ii = coordinates.length; i < ii; ++i)$7e819822b33b3d32$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent=} opt_extent Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $7e819822b33b3d32$var$_boundingExtentXYs(xs, ys, opt_extent) {
    var minX = Math.min.apply(null, xs);
    var minY = Math.min.apply(null, ys);
    var maxX = Math.max.apply(null, xs);
    var maxY = Math.max.apply(null, ys);
    return $7e819822b33b3d32$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, opt_extent);
}
function $7e819822b33b3d32$export$ab1029bcae9ddb4a(extent, value, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = extent[0] - value;
        opt_extent[1] = extent[1] - value;
        opt_extent[2] = extent[2] + value;
        opt_extent[3] = extent[3] + value;
        return opt_extent;
    } else return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $7e819822b33b3d32$export$9cd59f9826255e47(extent, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = extent[0];
        opt_extent[1] = extent[1];
        opt_extent[2] = extent[2];
        opt_extent[3] = extent[3];
        return opt_extent;
    } else return extent.slice();
}
function $7e819822b33b3d32$export$cbe64c389534206f(extent, x, y) {
    var dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $7e819822b33b3d32$export$ac68c24d37ca240f(extent, coordinate) {
    return $7e819822b33b3d32$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $7e819822b33b3d32$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $7e819822b33b3d32$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $7e819822b33b3d32$export$f97905ead28c61a8(extent, coordinate) {
    var minX = extent[0];
    var minY = extent[1];
    var maxX = extent[2];
    var maxY = extent[3];
    var x = coordinate[0];
    var y = coordinate[1];
    var relationship = (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).LEFT;
    else if (x > maxX) relationship = relationship | (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).RIGHT;
    if (y < minY) relationship = relationship | (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).BELOW;
    else if (y > maxY) relationship = relationship | (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).ABOVE;
    if (relationship === (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).UNKNOWN) relationship = (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).INTERSECTING;
    return relationship;
}
function $7e819822b33b3d32$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $7e819822b33b3d32$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = minX;
        opt_extent[1] = minY;
        opt_extent[2] = maxX;
        opt_extent[3] = maxY;
        return opt_extent;
    } else return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $7e819822b33b3d32$export$3e2152b047719fa1(opt_extent) {
    return $7e819822b33b3d32$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, opt_extent);
}
function $7e819822b33b3d32$export$4838bf78d04a9440(coordinate, opt_extent) {
    var x = coordinate[0];
    var y = coordinate[1];
    return $7e819822b33b3d32$export$958e3e1a02eac4b6(x, y, x, y, opt_extent);
}
function $7e819822b33b3d32$export$29e3ad4dbd0cb863(coordinates, opt_extent) {
    var extent = $7e819822b33b3d32$export$3e2152b047719fa1(opt_extent);
    return $7e819822b33b3d32$export$795cd48be4d5f252(extent, coordinates);
}
function $7e819822b33b3d32$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, opt_extent) {
    var extent = $7e819822b33b3d32$export$3e2152b047719fa1(opt_extent);
    return $7e819822b33b3d32$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $7e819822b33b3d32$export$73b4897e93bc5c83(rings, opt_extent) {
    var extent = $7e819822b33b3d32$export$3e2152b047719fa1(opt_extent);
    return $7e819822b33b3d32$export$9b319549574402d7(extent, rings);
}
function $7e819822b33b3d32$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $7e819822b33b3d32$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $7e819822b33b3d32$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $7e819822b33b3d32$export$795cd48be4d5f252(extent, coordinates) {
    for(var i = 0, ii = coordinates.length; i < ii; ++i)$7e819822b33b3d32$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $7e819822b33b3d32$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$7e819822b33b3d32$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $7e819822b33b3d32$export$9b319549574402d7(extent, rings) {
    for(var i = 0, ii = rings.length; i < ii; ++i)$7e819822b33b3d32$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $7e819822b33b3d32$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $7e819822b33b3d32$export$f9ed8a3d123a08e2(extent, callback, opt_this) {
    var val;
    val = callback.call(opt_this, $7e819822b33b3d32$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback.call(opt_this, $7e819822b33b3d32$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback.call(opt_this, $7e819822b33b3d32$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback.call(opt_this, $7e819822b33b3d32$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $7e819822b33b3d32$export$520c40045967cb15(extent) {
    var area = 0;
    if (!$7e819822b33b3d32$export$dd1bc94b04021eeb(extent)) area = $7e819822b33b3d32$export$3c49c185de0c2bfc(extent) * $7e819822b33b3d32$export$c08559766941f856(extent);
    return area;
}
function $7e819822b33b3d32$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $7e819822b33b3d32$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $7e819822b33b3d32$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $7e819822b33b3d32$export$a1cfd206661d0801(extent, corner) {
    var coordinate;
    if (corner === (0, $f386e227189cd37a$export$2e2bcd8739ae039).BOTTOM_LEFT) coordinate = $7e819822b33b3d32$export$8d09f5e2e1bf560d(extent);
    else if (corner === (0, $f386e227189cd37a$export$2e2bcd8739ae039).BOTTOM_RIGHT) coordinate = $7e819822b33b3d32$export$e77c1cf70445e168(extent);
    else if (corner === (0, $f386e227189cd37a$export$2e2bcd8739ae039).TOP_LEFT) coordinate = $7e819822b33b3d32$export$cb1538b07e6964ff(extent);
    else if (corner === (0, $f386e227189cd37a$export$2e2bcd8739ae039).TOP_RIGHT) coordinate = $7e819822b33b3d32$export$b84fa077c8b05295(extent);
    else (0, $b6052fc13e9a3991$export$a7a9523472993e97)(false, 13); // Invalid corner
    return coordinate;
}
function $7e819822b33b3d32$export$7d6fa884b32a3751(extent1, extent2) {
    var minX = Math.min(extent1[0], extent2[0]);
    var minY = Math.min(extent1[1], extent2[1]);
    var maxX = Math.max(extent1[2], extent2[2]);
    var maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $7e819822b33b3d32$export$13ba650faf8308(center, resolution, rotation, size, opt_extent) {
    var dx = resolution * size[0] / 2;
    var dy = resolution * size[1] / 2;
    var cosRotation = Math.cos(rotation);
    var sinRotation = Math.sin(rotation);
    var xCos = dx * cosRotation;
    var xSin = dx * sinRotation;
    var yCos = dy * cosRotation;
    var ySin = dy * sinRotation;
    var x = center[0];
    var y = center[1];
    var x0 = x - xCos + ySin;
    var x1 = x - xCos - ySin;
    var x2 = x + xCos - ySin;
    var x3 = x + xCos + ySin;
    var y0 = y - xSin - yCos;
    var y1 = y - xSin + yCos;
    var y2 = y + xSin + yCos;
    var y3 = y + xSin - yCos;
    return $7e819822b33b3d32$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), opt_extent);
}
function $7e819822b33b3d32$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $7e819822b33b3d32$export$f3fe0e9a60cde324(extent1, extent2) {
    var intersection = $7e819822b33b3d32$export$72209efa88586d42(extent1, extent2);
    return $7e819822b33b3d32$export$520c40045967cb15(intersection);
}
function $7e819822b33b3d32$export$72209efa88586d42(extent1, extent2, opt_extent) {
    var intersection = opt_extent ? opt_extent : $7e819822b33b3d32$export$fe201bb3bbe031e9();
    if ($7e819822b33b3d32$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $7e819822b33b3d32$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $7e819822b33b3d32$export$1bc603050bd777b1(extent) {
    return $7e819822b33b3d32$export$3c49c185de0c2bfc(extent) + $7e819822b33b3d32$export$c08559766941f856(extent);
}
function $7e819822b33b3d32$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $7e819822b33b3d32$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $7e819822b33b3d32$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $7e819822b33b3d32$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $7e819822b33b3d32$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $7e819822b33b3d32$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $7e819822b33b3d32$export$6a4fe494c558c238(extent, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = extent[0];
        opt_extent[1] = extent[1];
        opt_extent[2] = extent[2];
        opt_extent[3] = extent[3];
        return opt_extent;
    } else return extent;
}
function $7e819822b33b3d32$export$80cbab86674143b6(extent, value) {
    var deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    var deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $7e819822b33b3d32$export$a6a5a7a461419425(extent, start, end) {
    var intersects = false;
    var startRel = $7e819822b33b3d32$export$f97905ead28c61a8(extent, start);
    var endRel = $7e819822b33b3d32$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).INTERSECTING || endRel === (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).INTERSECTING) intersects = true;
    else {
        var minX = extent[0];
        var minY = extent[1];
        var maxX = extent[2];
        var maxY = extent[3];
        var startX = start[0];
        var startY = start[1];
        var endX = end[0];
        var endY = end[1];
        var slope = (endY - startY) / (endX - startX);
        var x, y;
        if (!!(endRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).ABOVE) && !(startRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).RIGHT) && !(startRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).BELOW) && !(startRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).LEFT) && !(startRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $7e819822b33b3d32$export$9f9dcb98c894b623(extent, transformFn, opt_extent) {
    var coordinates = [
        extent[0],
        extent[1],
        extent[0],
        extent[3],
        extent[2],
        extent[1],
        extent[2],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    var xs = [
        coordinates[0],
        coordinates[2],
        coordinates[4],
        coordinates[6]
    ];
    var ys = [
        coordinates[1],
        coordinates[3],
        coordinates[5],
        coordinates[7]
    ];
    return $7e819822b33b3d32$var$_boundingExtentXYs(xs, ys, opt_extent);
}


/**
 * @module ol/geom/GeometryType
 */ /**
 * The geometry type. One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, `'Circle'`.
 * @enum {string}
 */ var $8826602b1d512d67$export$2e2bcd8739ae039 = {
    POINT: "Point",
    LINE_STRING: "LineString",
    LINEAR_RING: "LinearRing",
    POLYGON: "Polygon",
    MULTI_POINT: "MultiPoint",
    MULTI_LINE_STRING: "MultiLineString",
    MULTI_POLYGON: "MultiPolygon",
    GEOMETRY_COLLECTION: "GeometryCollection",
    CIRCLE: "Circle"
};


/**
 * @module ol/geom/Polygon
 */ 

/**
 * @module ol/geom/GeometryLayout
 */ /**
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available. Supported values are `'XY'`,
 * `'XYZ'`, `'XYM'`, `'XYZM'`.
 * @enum {string}
 */ var $292479d5529f3ff8$export$2e2bcd8739ae039 = {
    XY: "XY",
    XYZ: "XYZ",
    XYM: "XYM",
    XYZM: "XYZM"
};



/**
 * @module ol/geom/LinearRing
 */ 


/**
 * @module ol/geom/SimpleGeometry
 */ 

/**
 * @module ol/geom/Geometry
 */ 


/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>=} opt_dest Destination.
 * @return {Array<number>} Transformed coordinates.
 */ function $24a54079104c80a7$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        var x = flatCoordinates[j];
        var y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
    }
    if (opt_dest && dest.length != i) dest.length = i;
    return dest;
}
function $24a54079104c80a7$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var anchorX = anchor[0];
    var anchorY = anchor[1];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        var deltaX = flatCoordinates[j] - anchorX;
        var deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(var k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (opt_dest && dest.length != i) dest.length = i;
    return dest;
}
function $24a54079104c80a7$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var anchorX = anchor[0];
    var anchorY = anchor[1];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        var deltaX = flatCoordinates[j] - anchorX;
        var deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(var k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (opt_dest && dest.length != i) dest.length = i;
    return dest;
}
function $24a54079104c80a7$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(var k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (opt_dest && dest.length != i) dest.length = i;
    return dest;
}


/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * * a list of {@link module:ol/proj/Projection}
 * objects, one for each projection supported by the application
 * * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://epsg.io/, and are a JS function, so can be loaded in a script
 * tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj~addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection} object for the new projection and add it with
 * {@link module:ol/proj~addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj~addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection} with
 * {@link module:ol/proj~addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ /**
 * @license
 * Latitude/longitude spherical geodesy formulae taken from
 * http://www.movable-type.co.uk/scripts/latlong.html
 * Licensed under CC-BY-3.0.
 */ /**
 * @module ol/sphere
 */ 

var $0e7893c26680b018$export$63f2df7bd7371262 = 6371008.8;
function $0e7893c26680b018$export$79376507b09a66f(c1, c2, opt_radius) {
    var radius = opt_radius || $0e7893c26680b018$export$63f2df7bd7371262;
    var lat1 = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(c1[1]);
    var lat2 = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(c2[1]);
    var deltaLatBy2 = (lat2 - lat1) / 2;
    var deltaLonBy2 = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(c2[0] - c1[0]) / 2;
    var a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $0e7893c26680b018$var$getLengthInternal(coordinates, radius) {
    var length = 0;
    for(var i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $0e7893c26680b018$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $0e7893c26680b018$export$f0d11c074a923179(geometry, opt_options) {
    var options = opt_options || {};
    var radius = options.radius || $0e7893c26680b018$export$63f2df7bd7371262;
    var projection = options.projection || "EPSG:3857";
    var type = geometry.getType();
    if (type !== (0, $8826602b1d512d67$export$2e2bcd8739ae039).GEOMETRY_COLLECTION) geometry = geometry.clone().transform(projection, "EPSG:4326");
    var length = 0;
    var coordinates, coords, i, ii, j, jj;
    switch(type){
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).POINT:
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POINT:
            break;
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING:
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).LINEAR_RING:
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $0e7893c26680b018$var$getLengthInternal(coordinates, radius);
            break;
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_LINE_STRING:
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON:
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $0e7893c26680b018$var$getLengthInternal(coordinates[i], radius);
            break;
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POLYGON:
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $0e7893c26680b018$var$getLengthInternal(coords[j], radius);
            }
            break;
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).GEOMETRY_COLLECTION:
            var geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
            for(i = 0, ii = geometries.length; i < ii; ++i)length += $0e7893c26680b018$export$f0d11c074a923179(geometries[i], opt_options);
            break;
        default:
            throw new Error("Unsupported geometry type: " + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs-new.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $0e7893c26680b018$var$getAreaInternal(coordinates, radius) {
    var area = 0;
    var len = coordinates.length;
    var x1 = coordinates[len - 1][0];
    var y1 = coordinates[len - 1][1];
    for(var i = 0; i < len; i++){
        var x2 = coordinates[i][0];
        var y2 = coordinates[i][1];
        area += (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(x2 - x1) * (2 + Math.sin((0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(y1)) + Math.sin((0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $0e7893c26680b018$export$520c40045967cb15(geometry, opt_options) {
    var options = opt_options || {};
    var radius = options.radius || $0e7893c26680b018$export$63f2df7bd7371262;
    var projection = options.projection || "EPSG:3857";
    var type = geometry.getType();
    if (type !== (0, $8826602b1d512d67$export$2e2bcd8739ae039).GEOMETRY_COLLECTION) geometry = geometry.clone().transform(projection, "EPSG:4326");
    var area = 0;
    var coordinates, coords, i, ii, j, jj;
    switch(type){
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).POINT:
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POINT:
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING:
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_LINE_STRING:
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).LINEAR_RING:
            break;
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON:
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($0e7893c26680b018$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($0e7893c26680b018$var$getAreaInternal(coordinates[i], radius));
            break;
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POLYGON:
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($0e7893c26680b018$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($0e7893c26680b018$var$getAreaInternal(coords[j], radius));
            }
            break;
        case (0, $8826602b1d512d67$export$2e2bcd8739ae039).GEOMETRY_COLLECTION:
            var geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
            for(i = 0, ii = geometries.length; i < ii; ++i)area += $0e7893c26680b018$export$520c40045967cb15(geometries[i], opt_options);
            break;
        default:
            throw new Error("Unsupported geometry type: " + type);
    }
    return area;
}
function $0e7893c26680b018$export$cc800923e997bb8(c1, distance, bearing, opt_radius) {
    var radius = opt_radius || $0e7893c26680b018$export$63f2df7bd7371262;
    var lat1 = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(c1[1]);
    var lon1 = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(c1[0]);
    var dByR = distance / radius;
    var lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    var lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $d4e56cfc37d8b1f9$export$56cb859c01fa134d)(lon),
        (0, $d4e56cfc37d8b1f9$export$56cb859c01fa134d)(lat)
    ];
}




/**
 * @module ol/proj/epsg3857
 */ 
/**
 * @module ol/proj/Projection
 */ /**
 * @module ol/proj/Units
 */ /**
 * Projection units: `'degrees'`, `'ft'`, `'m'`, `'pixels'`, `'tile-pixels'` or
 * `'us-ft'`.
 * @enum {string}
 */ var $fb72d58bc9104528$var$Units = {
    DEGREES: "degrees",
    FEET: "ft",
    METERS: "m",
    PIXELS: "pixels",
    TILE_PIXELS: "tile-pixels",
    USFEET: "us-ft"
};
var $fb72d58bc9104528$export$1482081eec883108 = {};
// use the radius of the Normal sphere
$fb72d58bc9104528$export$1482081eec883108[$fb72d58bc9104528$var$Units.DEGREES] = 2 * Math.PI * 6370997 / 360;
$fb72d58bc9104528$export$1482081eec883108[$fb72d58bc9104528$var$Units.FEET] = 0.3048;
$fb72d58bc9104528$export$1482081eec883108[$fb72d58bc9104528$var$Units.METERS] = 1;
$fb72d58bc9104528$export$1482081eec883108[$fb72d58bc9104528$var$Units.USFEET] = 1200 / 3937;
var $fb72d58bc9104528$export$2e2bcd8739ae039 = $fb72d58bc9104528$var$Units;


/**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").default|string} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link module:ol/proj/Units~METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {function(number, import("../coordinate.js").Coordinate):number} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `{number}` view resolution and an `{import("../coordinate.js").Coordinate}` as arguments, and returns
 * the `{number}` resolution at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj#getPointResolution} function will be used.
 */ /**
 * @classdesc
 * Projection definition class. One of these is created for each projection
 * supported in the application and stored in the {@link module:ol/proj} namespace.
 * You can use these in applications, but this is not required, as API params
 * and options use {@link module:ol/proj~ProjectionLike} which means the simple string
 * code will suffice.
 *
 * You can use {@link module:ol/proj~get} to retrieve the object for a particular
 * projection.
 *
 * The library includes definitions for `EPSG:4326` and `EPSG:3857`, together
 * with the following aliases:
 * * `EPSG:4326`: CRS:84, urn:ogc:def:crs:EPSG:6.6:4326,
 *     urn:ogc:def:crs:OGC:1.3:CRS84, urn:ogc:def:crs:OGC:2:84,
 *     http://www.opengis.net/gml/srs/epsg.xml#4326,
 *     urn:x-ogc:def:crs:EPSG:4326
 * * `EPSG:3857`: EPSG:102100, EPSG:102113, EPSG:900913,
 *     urn:ogc:def:crs:EPSG:6.18:3:3857,
 *     http://www.opengis.net/gml/srs/epsg.xml#3857
 *
 * If you use [proj4js](https://github.com/proj4js/proj4js), aliases can
 * be added using `proj4.defs()`. After all required projection definitions are
 * added, call the {@link module:ol/proj/proj4~register} function.
 *
 * @api
 */ var $8fe6435c5dc78f3e$var$Projection = function Projection(options) {
    /**
   * @private
   * @type {string}
   */ this.code_ = options.code;
    /**
   * Units of projected coordinates. When set to `TILE_PIXELS`, a
   * `this.extent_` and `this.worldExtent_` must be configured properly for each
   * tile.
   * @private
   * @type {import("./Units.js").default}
   */ this.units_ = /** @type {import("./Units.js").default} */ options.units;
    /**
   * Validity extent of the projection in projected coordinates. For projections
   * with `TILE_PIXELS` units, this is the extent of the tile in
   * tile pixel space.
   * @private
   * @type {import("../extent.js").Extent}
   */ this.extent_ = options.extent !== undefined ? options.extent : null;
    /**
   * Extent of the world in EPSG:4326. For projections with
   * `TILE_PIXELS` units, this is the extent of the tile in
   * projected coordinate space.
   * @private
   * @type {import("../extent.js").Extent}
   */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
    /**
   * @private
   * @type {string}
   */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : "enu";
    /**
   * @private
   * @type {boolean}
   */ this.global_ = options.global !== undefined ? options.global : false;
    /**
   * @private
   * @type {boolean}
   */ this.canWrapX_ = !!(this.global_ && this.extent_);
    /**
   * @private
   * @type {function(number, import("../coordinate.js").Coordinate):number|undefined}
   */ this.getPointResolutionFunc_ = options.getPointResolution;
    /**
   * @private
   * @type {import("../tilegrid/TileGrid.js").default}
   */ this.defaultTileGrid_ = null;
    /**
   * @private
   * @type {number|undefined}
   */ this.metersPerUnit_ = options.metersPerUnit;
};
/**
 * @return {boolean} The projection is suitable for wrapping the x-axis
 */ $8fe6435c5dc78f3e$var$Projection.prototype.canWrapX = function canWrapX() {
    return this.canWrapX_;
};
/**
 * Get the code for this projection, e.g. 'EPSG:4326'.
 * @return {string} Code.
 * @api
 */ $8fe6435c5dc78f3e$var$Projection.prototype.getCode = function getCode() {
    return this.code_;
};
/**
 * Get the validity extent for this projection.
 * @return {import("../extent.js").Extent} Extent.
 * @api
 */ $8fe6435c5dc78f3e$var$Projection.prototype.getExtent = function getExtent() {
    return this.extent_;
};
/**
 * Get the units of this projection.
 * @return {import("./Units.js").default} Units.
 * @api
 */ $8fe6435c5dc78f3e$var$Projection.prototype.getUnits = function getUnits() {
    return this.units_;
};
/**
 * Get the amount of meters per unit of this projection.If the projection is
 * not configured with `metersPerUnit` or a units identifier, the return is
 * `undefined`.
 * @return {number|undefined} Meters.
 * @api
 */ $8fe6435c5dc78f3e$var$Projection.prototype.getMetersPerUnit = function getMetersPerUnit() {
    return this.metersPerUnit_ || (0, $fb72d58bc9104528$export$1482081eec883108)[this.units_];
};
/**
 * Get the world extent for this projection.
 * @return {import("../extent.js").Extent} Extent.
 * @api
 */ $8fe6435c5dc78f3e$var$Projection.prototype.getWorldExtent = function getWorldExtent() {
    return this.worldExtent_;
};
/**
 * Get the axis orientation of this projection.
 * Example values are:
 * enu - the default easting, northing, elevation.
 * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
 *   or south orientated transverse mercator.
 * wnu - westing, northing, up - some planetary coordinate systems have
 *   "west positive" coordinate systems
 * @return {string} Axis orientation.
 * @api
 */ $8fe6435c5dc78f3e$var$Projection.prototype.getAxisOrientation = function getAxisOrientation() {
    return this.axisOrientation_;
};
/**
 * Is this projection a global projection which spans the whole world?
 * @return {boolean} Whether the projection is global.
 * @api
 */ $8fe6435c5dc78f3e$var$Projection.prototype.isGlobal = function isGlobal() {
    return this.global_;
};
/**
 * Set if the projection is a global projection which spans the whole world
 * @param {boolean} global Whether the projection is global.
 * @api
 */ $8fe6435c5dc78f3e$var$Projection.prototype.setGlobal = function setGlobal(global) {
    this.global_ = global;
    this.canWrapX_ = !!(global && this.extent_);
};
/**
 * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
 */ $8fe6435c5dc78f3e$var$Projection.prototype.getDefaultTileGrid = function getDefaultTileGrid() {
    return this.defaultTileGrid_;
};
/**
 * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
 */ $8fe6435c5dc78f3e$var$Projection.prototype.setDefaultTileGrid = function setDefaultTileGrid(tileGrid) {
    this.defaultTileGrid_ = tileGrid;
};
/**
 * Set the validity extent for this projection.
 * @param {import("../extent.js").Extent} extent Extent.
 * @api
 */ $8fe6435c5dc78f3e$var$Projection.prototype.setExtent = function setExtent(extent) {
    this.extent_ = extent;
    this.canWrapX_ = !!(this.global_ && extent);
};
/**
 * Set the world extent for this projection.
 * @param {import("../extent.js").Extent} worldExtent World extent
 *   [minlon, minlat, maxlon, maxlat].
 * @api
 */ $8fe6435c5dc78f3e$var$Projection.prototype.setWorldExtent = function setWorldExtent(worldExtent) {
    this.worldExtent_ = worldExtent;
};
/**
 * Set the getPointResolution function (see {@link module:ol/proj~getPointResolution}
 * for this projection.
 * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
 * @api
 */ $8fe6435c5dc78f3e$var$Projection.prototype.setGetPointResolution = function setGetPointResolution(func) {
    this.getPointResolutionFunc_ = func;
};
/**
 * Get the custom point resolution function for this projection (if set).
 * @return {function(number, import("../coordinate.js").Coordinate):number|undefined} The custom point
 * resolution function (if set).
 */ $8fe6435c5dc78f3e$var$Projection.prototype.getPointResolutionFunc = function getPointResolutionFunc() {
    return this.getPointResolutionFunc_;
};
var $8fe6435c5dc78f3e$export$2e2bcd8739ae039 = $8fe6435c5dc78f3e$var$Projection;



var $830637c92019e485$export$2d2c9be8b5b863f = 6378137;
var $830637c92019e485$export$f3928063e5e96d35 = Math.PI * $830637c92019e485$export$2d2c9be8b5b863f;
var $830637c92019e485$export$21e6da8a7375dfe8 = [
    -$830637c92019e485$export$f3928063e5e96d35,
    -$830637c92019e485$export$f3928063e5e96d35,
    $830637c92019e485$export$f3928063e5e96d35,
    $830637c92019e485$export$f3928063e5e96d35
];
var $830637c92019e485$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ var $830637c92019e485$var$EPSG3857Projection = /*@__PURE__*/ function(Projection) {
    function EPSG3857Projection(code) {
        Projection.call(this, {
            code: code,
            units: (0, $fb72d58bc9104528$export$2e2bcd8739ae039).METERS,
            extent: $830637c92019e485$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $830637c92019e485$export$ae9d6ed80df710e5,
            getPointResolution: function(resolution, point) {
                return resolution / (0, $d4e56cfc37d8b1f9$export$2e2fd1ad24e4d350)(point[1] / $830637c92019e485$export$2d2c9be8b5b863f);
            }
        });
    }
    if (Projection) EPSG3857Projection.__proto__ = Projection;
    EPSG3857Projection.prototype = Object.create(Projection && Projection.prototype);
    EPSG3857Projection.prototype.constructor = EPSG3857Projection;
    return EPSG3857Projection;
}((0, $8fe6435c5dc78f3e$export$2e2bcd8739ae039));
var $830637c92019e485$export$b508d7ad9a891c1b = [
    new $830637c92019e485$var$EPSG3857Projection("EPSG:3857"),
    new $830637c92019e485$var$EPSG3857Projection("EPSG:102100"),
    new $830637c92019e485$var$EPSG3857Projection("EPSG:102113"),
    new $830637c92019e485$var$EPSG3857Projection("EPSG:900913"),
    new $830637c92019e485$var$EPSG3857Projection("urn:ogc:def:crs:EPSG:6.18:3:3857"),
    new $830637c92019e485$var$EPSG3857Projection("urn:ogc:def:crs:EPSG::3857"),
    new $830637c92019e485$var$EPSG3857Projection("http://www.opengis.net/gml/srs/epsg.xml#3857")
];
function $830637c92019e485$export$1ff8bb36c0983070(input, opt_output, opt_dimension) {
    var length = input.length;
    var dimension = opt_dimension > 1 ? opt_dimension : 2;
    var output = opt_output;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    var halfSize = $830637c92019e485$export$f3928063e5e96d35;
    for(var i = 0; i < length; i += dimension){
        output[i] = halfSize * input[i] / 180;
        var y = $830637c92019e485$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (input[i + 1] + 90) / 360));
        if (y > halfSize) y = halfSize;
        else if (y < -halfSize) y = -halfSize;
        output[i + 1] = y;
    }
    return output;
}
function $830637c92019e485$export$8c71322ec28ed6b4(input, opt_output, opt_dimension) {
    var length = input.length;
    var dimension = opt_dimension > 1 ? opt_dimension : 2;
    var output = opt_output;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(var i = 0; i < length; i += dimension){
        output[i] = 180 * input[i] / $830637c92019e485$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $830637c92019e485$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}


/**
 * @module ol/proj/epsg4326
 */ 

var $4cc5940fd2dc7816$export$2d2c9be8b5b863f = 6378137;
var $4cc5940fd2dc7816$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
var $4cc5940fd2dc7816$export$1482081eec883108 = Math.PI * $4cc5940fd2dc7816$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ var $4cc5940fd2dc7816$var$EPSG4326Projection = /*@__PURE__*/ function(Projection) {
    function EPSG4326Projection(code, opt_axisOrientation) {
        Projection.call(this, {
            code: code,
            units: (0, $fb72d58bc9104528$export$2e2bcd8739ae039).DEGREES,
            extent: $4cc5940fd2dc7816$export$21e6da8a7375dfe8,
            axisOrientation: opt_axisOrientation,
            global: true,
            metersPerUnit: $4cc5940fd2dc7816$export$1482081eec883108,
            worldExtent: $4cc5940fd2dc7816$export$21e6da8a7375dfe8
        });
    }
    if (Projection) EPSG4326Projection.__proto__ = Projection;
    EPSG4326Projection.prototype = Object.create(Projection && Projection.prototype);
    EPSG4326Projection.prototype.constructor = EPSG4326Projection;
    return EPSG4326Projection;
}((0, $8fe6435c5dc78f3e$export$2e2bcd8739ae039));
var $4cc5940fd2dc7816$export$b508d7ad9a891c1b = [
    new $4cc5940fd2dc7816$var$EPSG4326Projection("CRS:84"),
    new $4cc5940fd2dc7816$var$EPSG4326Projection("EPSG:4326", "neu"),
    new $4cc5940fd2dc7816$var$EPSG4326Projection("urn:ogc:def:crs:EPSG::4326", "neu"),
    new $4cc5940fd2dc7816$var$EPSG4326Projection("urn:ogc:def:crs:EPSG:6.6:4326", "neu"),
    new $4cc5940fd2dc7816$var$EPSG4326Projection("urn:ogc:def:crs:OGC:1.3:CRS84"),
    new $4cc5940fd2dc7816$var$EPSG4326Projection("urn:ogc:def:crs:OGC:2:84"),
    new $4cc5940fd2dc7816$var$EPSG4326Projection("http://www.opengis.net/gml/srs/epsg.xml#4326", "neu"),
    new $4cc5940fd2dc7816$var$EPSG4326Projection("urn:x-ogc:def:crs:EPSG:4326", "neu")
];




/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ var $1c99841673e46c67$var$cache = {};
function $1c99841673e46c67$export$42ffd38884aecdac() {
    $1c99841673e46c67$var$cache = {};
}
function $1c99841673e46c67$export$3988ae62b71be9a3(code) {
    return $1c99841673e46c67$var$cache[code] || null;
}
function $1c99841673e46c67$export$e16d8520af44a096(code, projection) {
    $1c99841673e46c67$var$cache[code] = projection;
}


/**
 * @module ol/proj/transforms
 */ 
/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ var $5311269cd01b387a$var$transforms = {};
function $5311269cd01b387a$export$42ffd38884aecdac() {
    $5311269cd01b387a$var$transforms = {};
}
function $5311269cd01b387a$export$e16d8520af44a096(source, destination, transformFn) {
    var sourceCode = source.getCode();
    var destinationCode = destination.getCode();
    if (!(sourceCode in $5311269cd01b387a$var$transforms)) $5311269cd01b387a$var$transforms[sourceCode] = {};
    $5311269cd01b387a$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $5311269cd01b387a$export$cd7f480d6b8286c3(source, destination) {
    var sourceCode = source.getCode();
    var destinationCode = destination.getCode();
    var transform = $5311269cd01b387a$var$transforms[sourceCode][destinationCode];
    delete $5311269cd01b387a$var$transforms[sourceCode][destinationCode];
    if ((0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)($5311269cd01b387a$var$transforms[sourceCode])) delete $5311269cd01b387a$var$transforms[sourceCode];
    return transform;
}
function $5311269cd01b387a$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    var transform;
    if (sourceCode in $5311269cd01b387a$var$transforms && destinationCode in $5311269cd01b387a$var$transforms[sourceCode]) transform = $5311269cd01b387a$var$transforms[sourceCode][destinationCode];
    return transform;
}


function $92f1443438429e81$export$dd516654c5f598fb(input, opt_output, opt_dimension) {
    var output;
    if (opt_output !== undefined) {
        for(var i = 0, ii = input.length; i < ii; ++i)opt_output[i] = input[i];
        output = opt_output;
    } else output = input.slice();
    return output;
}
function $92f1443438429e81$export$83e8ab53904f8022(input, opt_output, opt_dimension) {
    if (opt_output !== undefined && input !== opt_output) {
        for(var i = 0, ii = input.length; i < ii; ++i)opt_output[i] = input[i];
        input = opt_output;
    }
    return input;
}
function $92f1443438429e81$export$59ae956cd3e343f7(projection) {
    $1c99841673e46c67$export$e16d8520af44a096(projection.getCode(), projection);
    (0, $5311269cd01b387a$export$e16d8520af44a096)(projection, projection, $92f1443438429e81$export$dd516654c5f598fb);
}
function $92f1443438429e81$export$638ad73f7aafb913(projections) {
    projections.forEach($92f1443438429e81$export$59ae956cd3e343f7);
}
function $92f1443438429e81$export$3988ae62b71be9a3(projectionLike) {
    return typeof projectionLike === "string" ? $1c99841673e46c67$export$3988ae62b71be9a3(/** @type {string} */ projectionLike) : /** @type {Projection} */ projectionLike || null;
}
function $92f1443438429e81$export$2d8f7b4eec383d44(projection, resolution, point, opt_units) {
    projection = $92f1443438429e81$export$3988ae62b71be9a3(projection);
    var pointResolution;
    var getter = projection.getPointResolutionFunc();
    if (getter) pointResolution = getter(resolution, point);
    else {
        var units = projection.getUnits();
        if (units == (0, $fb72d58bc9104528$export$2e2bcd8739ae039).DEGREES && !opt_units || opt_units == (0, $fb72d58bc9104528$export$2e2bcd8739ae039).DEGREES) pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            var toEPSG4326 = $92f1443438429e81$export$e3c4995a701c26a3(projection, $92f1443438429e81$export$3988ae62b71be9a3("EPSG:4326"));
            var vertices = [
                point[0] - resolution / 2,
                point[1],
                point[0] + resolution / 2,
                point[1],
                point[0],
                point[1] - resolution / 2,
                point[0],
                point[1] + resolution / 2
            ];
            vertices = toEPSG4326(vertices, vertices, 2);
            var width = (0, $0e7893c26680b018$export$79376507b09a66f)(vertices.slice(0, 2), vertices.slice(2, 4));
            var height = (0, $0e7893c26680b018$export$79376507b09a66f)(vertices.slice(4, 6), vertices.slice(6, 8));
            pointResolution = (width + height) / 2;
            var metersPerUnit = opt_units ? (0, $fb72d58bc9104528$export$1482081eec883108)[opt_units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function $92f1443438429e81$export$eeb8392580a05a37(projections) {
    $92f1443438429e81$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $5311269cd01b387a$export$e16d8520af44a096)(source, destination, $92f1443438429e81$export$dd516654c5f598fb);
        });
    });
}
function $92f1443438429e81$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $5311269cd01b387a$export$e16d8520af44a096)(projection1, projection2, forwardTransform);
            (0, $5311269cd01b387a$export$e16d8520af44a096)(projection2, projection1, inverseTransform);
        });
    });
}
function $92f1443438429e81$export$4860237d10380594() {
    $1c99841673e46c67$export$42ffd38884aecdac();
    (0, $5311269cd01b387a$export$42ffd38884aecdac)();
}
function $92f1443438429e81$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $92f1443438429e81$export$3988ae62b71be9a3(defaultCode);
    else if (typeof projection === "string") return $92f1443438429e81$export$3988ae62b71be9a3(projection);
    else return /** @type {Projection} */ projection;
}
function $92f1443438429e81$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>=} opt_output Output.
     * @param {number=} opt_dimension Dimension.
     * @return {Array<number>} Output.
     */ function(input, opt_output, opt_dimension) {
        var length = input.length;
        var dimension = opt_dimension !== undefined ? opt_dimension : 2;
        var output = opt_output !== undefined ? opt_output : new Array(length);
        for(var i = 0; i < length; i += dimension){
            var point = coordTransform([
                input[i],
                input[i + 1]
            ]);
            output[i] = point[0];
            output[i + 1] = point[1];
            for(var j = dimension - 1; j >= 2; --j)output[i + j] = input[i + j];
        }
        return output;
    });
}
function $92f1443438429e81$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    var sourceProj = $92f1443438429e81$export$3988ae62b71be9a3(source);
    var destProj = $92f1443438429e81$export$3988ae62b71be9a3(destination);
    (0, $5311269cd01b387a$export$e16d8520af44a096)(sourceProj, destProj, $92f1443438429e81$export$6b4aafd331159e0d(forward));
    (0, $5311269cd01b387a$export$e16d8520af44a096)(destProj, sourceProj, $92f1443438429e81$export$6b4aafd331159e0d(inverse));
}
function $92f1443438429e81$export$b15d9668511529b9(coordinate, opt_projection) {
    return $92f1443438429e81$export$51186ad6e864892a(coordinate, "EPSG:4326", opt_projection !== undefined ? opt_projection : "EPSG:3857");
}
function $92f1443438429e81$export$3fb495868742d370(coordinate, opt_projection) {
    var lonLat = $92f1443438429e81$export$51186ad6e864892a(coordinate, opt_projection !== undefined ? opt_projection : "EPSG:3857", "EPSG:4326");
    var lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(lon + 180, 360) - 180;
    return lonLat;
}
function $92f1443438429e81$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    var equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    else {
        var transformFunc = $92f1443438429e81$export$e3c4995a701c26a3(projection1, projection2);
        return transformFunc === $92f1443438429e81$export$dd516654c5f598fb && equalUnits;
    }
}
function $92f1443438429e81$export$e3c4995a701c26a3(sourceProjection, destinationProjection) {
    var sourceCode = sourceProjection.getCode();
    var destinationCode = destinationProjection.getCode();
    var transformFunc = (0, $5311269cd01b387a$export$3988ae62b71be9a3)(sourceCode, destinationCode);
    if (!transformFunc) transformFunc = $92f1443438429e81$export$83e8ab53904f8022;
    return transformFunc;
}
function $92f1443438429e81$export$fce0c6cfca85ed96(source, destination) {
    var sourceProjection = $92f1443438429e81$export$3988ae62b71be9a3(source);
    var destinationProjection = $92f1443438429e81$export$3988ae62b71be9a3(destination);
    return $92f1443438429e81$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $92f1443438429e81$export$51186ad6e864892a(coordinate, source, destination) {
    var transformFunc = $92f1443438429e81$export$fce0c6cfca85ed96(source, destination);
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $92f1443438429e81$export$751c68e0e0efff79(extent, source, destination) {
    var transformFunc = $92f1443438429e81$export$fce0c6cfca85ed96(source, destination);
    return (0, $7e819822b33b3d32$export$9f9dcb98c894b623)(extent, transformFunc);
}
function $92f1443438429e81$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    var transformFunc = $92f1443438429e81$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
function $92f1443438429e81$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $92f1443438429e81$export$eeb8392580a05a37((0, $830637c92019e485$export$b508d7ad9a891c1b));
    $92f1443438429e81$export$eeb8392580a05a37((0, $4cc5940fd2dc7816$export$b508d7ad9a891c1b));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $92f1443438429e81$export$4856f21c2f184f24((0, $4cc5940fd2dc7816$export$b508d7ad9a891c1b), (0, $830637c92019e485$export$b508d7ad9a891c1b), (0, $830637c92019e485$export$1ff8bb36c0983070), (0, $830637c92019e485$export$8c71322ec28ed6b4));
}
$92f1443438429e81$export$86eed449eb2dcac4();



/**
 * @module ol/transform
 */ 
/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ var $2567d97ab31c5663$var$tmp_ = new Array(6);
function $2567d97ab31c5663$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $2567d97ab31c5663$export$aad8462122ac592b(transform) {
    return $2567d97ab31c5663$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $2567d97ab31c5663$export$2060d2db72cce88f(transform1, transform2) {
    var a1 = transform1[0];
    var b1 = transform1[1];
    var c1 = transform1[2];
    var d1 = transform1[3];
    var e1 = transform1[4];
    var f1 = transform1[5];
    var a2 = transform2[0];
    var b2 = transform2[1];
    var c2 = transform2[2];
    var d2 = transform2[3];
    var e2 = transform2[4];
    var f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $2567d97ab31c5663$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $2567d97ab31c5663$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $2567d97ab31c5663$export$5635d7ef4b8fee1c(transform, coordinate) {
    var x = coordinate[0];
    var y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $2567d97ab31c5663$export$bb628a54ab399bc9(transform, angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    return $2567d97ab31c5663$export$2060d2db72cce88f(transform, $2567d97ab31c5663$export$adaa4cf7ef1b65be($2567d97ab31c5663$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $2567d97ab31c5663$export$dcdf75081b88279d(transform, x, y) {
    return $2567d97ab31c5663$export$2060d2db72cce88f(transform, $2567d97ab31c5663$export$adaa4cf7ef1b65be($2567d97ab31c5663$var$tmp_, x, 0, 0, y, 0, 0));
}
function $2567d97ab31c5663$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $2567d97ab31c5663$export$2060d2db72cce88f(transform, $2567d97ab31c5663$export$adaa4cf7ef1b65be($2567d97ab31c5663$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $2567d97ab31c5663$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    var sin = Math.sin(angle);
    var cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $2567d97ab31c5663$export$6897c284b6f9f4dc(transform) {
    var det = $2567d97ab31c5663$export$a04698f914c55ed9(transform);
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)(det !== 0, 32); // Transformation matrix cannot be inverted
    var a = transform[0];
    var b = transform[1];
    var c = transform[2];
    var d = transform[3];
    var e = transform[4];
    var f = transform[5];
    transform[0] = d / det;
    transform[1] = -b / det;
    transform[2] = -c / det;
    transform[3] = a / det;
    transform[4] = (c * f - d * e) / det;
    transform[5] = -(a * f - b * e) / det;
    return transform;
}
function $2567d97ab31c5663$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}


/**
 * @type {import("../transform.js").Transform}
 */ var $e9ce7123fdd10994$var$tmpTransform = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ var $e9ce7123fdd10994$var$Geometry = /*@__PURE__*/ function(BaseObject) {
    function Geometry() {
        BaseObject.call(this);
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.extentRevision_ = -1;
        /**
     * @protected
     * @type {Object<string, Geometry>}
     */ this.simplifiedGeometryCache = {};
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryRevision = 0;
    }
    if (BaseObject) Geometry.__proto__ = BaseObject;
    Geometry.prototype = Object.create(BaseObject && BaseObject.prototype);
    Geometry.prototype.constructor = Geometry;
    /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */ Geometry.prototype.clone = function clone() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ Geometry.prototype.closestPointXY = function closestPointXY(x, y, closestPoint, minSquaredDistance) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ Geometry.prototype.containsXY = function containsXY(x, y) {
        return false;
    };
    /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate=} opt_closestPoint Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */ Geometry.prototype.getClosestPoint = function getClosestPoint(point, opt_closestPoint) {
        var closestPoint = opt_closestPoint ? opt_closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    };
    /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */ Geometry.prototype.intersectsCoordinate = function intersectsCoordinate(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    };
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ Geometry.prototype.computeExtent = function computeExtent(extent) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent=} opt_extent Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */ Geometry.prototype.getExtent = function getExtent(opt_extent) {
        if (this.extentRevision_ != this.getRevision()) {
            this.extent_ = this.computeExtent(this.extent_);
            this.extentRevision_ = this.getRevision();
        }
        return (0, $7e819822b33b3d32$export$6a4fe494c558c238)(this.extent_, opt_extent);
    };
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ Geometry.prototype.rotate = function rotate(angle, anchor) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number=} opt_sy The scaling factor in the y-direction (defaults to
   *     sx).
   * @param {import("../coordinate.js").Coordinate=} opt_anchor The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ Geometry.prototype.scale = function scale(sx, opt_sy, opt_anchor) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the the {@link
   * https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
   * Douglas Peucker} algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */ Geometry.prototype.simplify = function simplify(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    };
    /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */ Geometry.prototype.getSimplifiedGeometry = function getSimplifiedGeometry(squaredTolerance) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Get the type of this geometry.
   * @abstract
   * @return {import("./GeometryType.js").default} Geometry type.
   */ Geometry.prototype.getType = function getType() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Apply a transform function to each coordinate of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform.
   */ Geometry.prototype.applyTransform = function applyTransform(transformFn) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */ Geometry.prototype.intersectsExtent = function intersectsExtent(extent) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ Geometry.prototype.translate = function translate(deltaX, deltaY) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {Geometry} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */ Geometry.prototype.transform = function transform(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ var sourceProj = (0, $92f1443438429e81$export$3988ae62b71be9a3)(source);
        var transformFn = sourceProj.getUnits() == (0, $fb72d58bc9104528$export$2e2bcd8739ae039).TILE_PIXELS ? function(inCoordinates, outCoordinates, stride) {
            var pixelExtent = sourceProj.getExtent();
            var projectedExtent = sourceProj.getWorldExtent();
            var scale = (0, $7e819822b33b3d32$export$c08559766941f856)(projectedExtent) / (0, $7e819822b33b3d32$export$c08559766941f856)(pixelExtent);
            (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)($e9ce7123fdd10994$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $24a54079104c80a7$export$b92b2dedcfff79de)(inCoordinates, 0, inCoordinates.length, stride, $e9ce7123fdd10994$var$tmpTransform, outCoordinates);
            return (0, $92f1443438429e81$export$fce0c6cfca85ed96)(sourceProj, destination)(inCoordinates, outCoordinates, stride);
        } : (0, $92f1443438429e81$export$fce0c6cfca85ed96)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    };
    return Geometry;
}((0, $d575b598d09f57d3$export$2e2bcd8739ae039));
var $e9ce7123fdd10994$export$2e2bcd8739ae039 = $e9ce7123fdd10994$var$Geometry;





/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ var $ce25558341ea2841$var$SimpleGeometry = /*@__PURE__*/ function(Geometry) {
    function SimpleGeometry() {
        Geometry.call(this);
        /**
     * @protected
     * @type {GeometryLayout}
     */ this.layout = (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY;
        /**
     * @protected
     * @type {number}
     */ this.stride = 2;
        /**
     * @protected
     * @type {Array<number>}
     */ this.flatCoordinates = null;
    }
    if (Geometry) SimpleGeometry.__proto__ = Geometry;
    SimpleGeometry.prototype = Object.create(Geometry && Geometry.prototype);
    SimpleGeometry.prototype.constructor = SimpleGeometry;
    /**
   * @inheritDoc
   */ SimpleGeometry.prototype.computeExtent = function computeExtent(extent) {
        return (0, $7e819822b33b3d32$export$be0ab0bf96ca59ca)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    };
    /**
   * @abstract
   * @return {Array} Coordinates.
   */ SimpleGeometry.prototype.getCoordinates = function getCoordinates() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */ SimpleGeometry.prototype.getFirstCoordinate = function getFirstCoordinate() {
        return this.flatCoordinates.slice(0, this.stride);
    };
    /**
   * @return {Array<number>} Flat coordinates.
   */ SimpleGeometry.prototype.getFlatCoordinates = function getFlatCoordinates() {
        return this.flatCoordinates;
    };
    /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */ SimpleGeometry.prototype.getLastCoordinate = function getLastCoordinate() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    };
    /**
   * Return the {@link module:ol/geom/GeometryLayout layout} of the geometry.
   * @return {GeometryLayout} Layout.
   * @api
   */ SimpleGeometry.prototype.getLayout = function getLayout() {
        return this.layout;
    };
    /**
   * @inheritDoc
   */ SimpleGeometry.prototype.getSimplifiedGeometry = function getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision != this.getRevision()) {
            (0, $8c1e0b75b65663dc$export$42ffd38884aecdac)(this.simplifiedGeometryCache);
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        var key = squaredTolerance.toString();
        if (this.simplifiedGeometryCache.hasOwnProperty(key)) return this.simplifiedGeometryCache[key];
        else {
            var simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
            var simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
            if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) {
                this.simplifiedGeometryCache[key] = simplifiedGeometry;
                return simplifiedGeometry;
            } else {
                // Simplification did not actually remove any coordinates.  We now know
                // that any calls to getSimplifiedGeometry with a squaredTolerance less
                // than or equal to the current squaredTolerance will also not have any
                // effect.  This allows us to short circuit simplification (saving CPU
                // cycles) and prevents the cache of simplified geometries from filling
                // up with useless identical copies of this geometry (saving memory).
                this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
                return this;
            }
        }
    };
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */ SimpleGeometry.prototype.getSimplifiedGeometryInternal = function getSimplifiedGeometryInternal(squaredTolerance) {
        return this;
    };
    /**
   * @return {number} Stride.
   */ SimpleGeometry.prototype.getStride = function getStride() {
        return this.stride;
    };
    /**
   * @param {GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */ SimpleGeometry.prototype.setFlatCoordinates = function setFlatCoordinates(layout, flatCoordinates) {
        this.stride = $ce25558341ea2841$export$6af0c1b4a8549a43(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    };
    /**
   * @abstract
   * @param {!Array} coordinates Coordinates.
   * @param {GeometryLayout=} opt_layout Layout.
   */ SimpleGeometry.prototype.setCoordinates = function setCoordinates(coordinates, opt_layout) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * @param {GeometryLayout|undefined} layout Layout.
   * @param {Array} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */ SimpleGeometry.prototype.setLayout = function setLayout(layout, coordinates, nesting) {
        /** @type {number} */ var stride;
        if (layout) stride = $ce25558341ea2841$export$6af0c1b4a8549a43(layout);
        else {
            for(var i = 0; i < nesting; ++i)if (coordinates.length === 0) {
                this.layout = (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY;
                this.stride = 2;
                return;
            } else coordinates = /** @type {Array} */ coordinates[0];
            stride = coordinates.length;
            layout = $ce25558341ea2841$var$getLayoutForStride(stride);
        }
        this.layout = layout;
        this.stride = stride;
    };
    /**
   * @inheritDoc
   * @api
   */ SimpleGeometry.prototype.applyTransform = function applyTransform(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.stride);
            this.changed();
        }
    };
    /**
   * @inheritDoc
   * @api
   */ SimpleGeometry.prototype.rotate = function rotate$1(angle, anchor) {
        var flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            var stride = this.getStride();
            (0, $24a54079104c80a7$export$bb628a54ab399bc9)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    };
    /**
   * @inheritDoc
   * @api
   */ SimpleGeometry.prototype.scale = function scale$1(sx, opt_sy, opt_anchor) {
        var sy = opt_sy;
        if (sy === undefined) sy = sx;
        var anchor = opt_anchor;
        if (!anchor) anchor = (0, $7e819822b33b3d32$export$c91255cadecfe081)(this.getExtent());
        var flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            var stride = this.getStride();
            (0, $24a54079104c80a7$export$dcdf75081b88279d)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    };
    /**
   * @inheritDoc
   * @api
   */ SimpleGeometry.prototype.translate = function translate$1(deltaX, deltaY) {
        var flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            var stride = this.getStride();
            (0, $24a54079104c80a7$export$d73ee8ef04f5226a)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    };
    return SimpleGeometry;
}((0, $e9ce7123fdd10994$export$2e2bcd8739ae039));
/**
 * @param {number} stride Stride.
 * @return {GeometryLayout} layout Layout.
 */ function $ce25558341ea2841$var$getLayoutForStride(stride) {
    var layout;
    if (stride == 2) layout = (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY;
    else if (stride == 3) layout = (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZ;
    else if (stride == 4) layout = (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZM;
    return /** @type {GeometryLayout} */ layout;
}
function $ce25558341ea2841$export$6af0c1b4a8549a43(layout) {
    var stride;
    if (layout == (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY) stride = 2;
    else if (layout == (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZ || layout == (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYM) stride = 3;
    else if (layout == (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZM) stride = 4;
    return /** @type {number} */ stride;
}
function $ce25558341ea2841$export$a3767472617c7861(simpleGeometry, transform, opt_dest) {
    var flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    else {
        var stride = simpleGeometry.getStride();
        return (0, $24a54079104c80a7$export$b92b2dedcfff79de)(flatCoordinates, 0, flatCoordinates.length, stride, transform, opt_dest);
    }
}
var $ce25558341ea2841$export$2e2bcd8739ae039 = $ce25558341ea2841$var$SimpleGeometry;


/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $b024f94ecb74bc8b$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    var twiceArea = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        twiceArea += y1 * x2 - x1 * y2;
        x1 = x2;
        y1 = y2;
    }
    return twiceArea / 2;
}
function $b024f94ecb74bc8b$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    var area = 0;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        area += $b024f94ecb74bc8b$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $b024f94ecb74bc8b$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    var area = 0;
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        area += $b024f94ecb74bc8b$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}


/**
 * @module ol/geom/flat/closest
 */ 
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $bf52e23c2de7bae9$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    var x1 = flatCoordinates[offset1];
    var y1 = flatCoordinates[offset1 + 1];
    var dx = flatCoordinates[offset2] - x1;
    var dy = flatCoordinates[offset2 + 1] - y1;
    var offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(var i = 0; i < stride; ++i)closestPoint[i] = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(var i$1 = 0; i$1 < stride; ++i$1)closestPoint[i$1] = flatCoordinates[offset + i$1];
    closestPoint.length = stride;
}
function $bf52e23c2de7bae9$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        var squaredDelta = (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $bf52e23c2de7bae9$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        max = $bf52e23c2de7bae9$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $bf52e23c2de7bae9$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        max = $bf52e23c2de7bae9$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $bf52e23c2de7bae9$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, opt_tmpPoint) {
    if (offset == end) return minSquaredDistance;
    var i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        } else return minSquaredDistance;
    }
    var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [
        NaN,
        NaN
    ];
    var index = offset + stride;
    while(index < end){
        $bf52e23c2de7bae9$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $bf52e23c2de7bae9$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $bf52e23c2de7bae9$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, opt_tmpPoint) {
    var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [
        NaN,
        NaN
    ];
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        minSquaredDistance = $bf52e23c2de7bae9$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $bf52e23c2de7bae9$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, opt_tmpPoint) {
    var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [
        NaN,
        NaN
    ];
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        minSquaredDistance = $bf52e23c2de7bae9$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}


/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $4ae92c9bec373de6$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(var i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $4ae92c9bec373de6$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(var i = 0, ii = coordinates.length; i < ii; ++i){
        var coordinate = coordinates[i];
        for(var j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $4ae92c9bec373de6$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, opt_ends) {
    var ends = opt_ends ? opt_ends : [];
    var i = 0;
    for(var j = 0, jj = coordinatess.length; j < jj; ++j){
        var end = $4ae92c9bec373de6$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $4ae92c9bec373de6$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, opt_endss) {
    var endss = opt_endss ? opt_endss : [];
    var i = 0;
    for(var j = 0, jj = coordinatesss.length; j < jj; ++j){
        var ends = $4ae92c9bec373de6$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}


/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>=} opt_coordinates Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $76a969a6125a5a4a$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, opt_coordinates) {
    var coordinates = opt_coordinates !== undefined ? opt_coordinates : [];
    var i = 0;
    for(var j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $76a969a6125a5a4a$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, opt_coordinatess) {
    var coordinatess = opt_coordinatess !== undefined ? opt_coordinatess : [];
    var i = 0;
    for(var j = 0, jj = ends.length; j < jj; ++j){
        var end = ends[j];
        coordinatess[i++] = $76a969a6125a5a4a$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $76a969a6125a5a4a$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, opt_coordinatesss) {
    var coordinatesss = opt_coordinatesss !== undefined ? opt_coordinatesss : [];
    var i = 0;
    for(var j = 0, jj = endss.length; j < jj; ++j){
        var ends = endss[j];
        coordinatesss[i++] = $76a969a6125a5a4a$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}


/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

function $ab8844daaf207c08$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, opt_simplifiedFlatCoordinates) {
    var simplifiedFlatCoordinates = opt_simplifiedFlatCoordinates !== undefined ? opt_simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $ab8844daaf207c08$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $ab8844daaf207c08$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $ab8844daaf207c08$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    var n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ var markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ var stack = [
        offset,
        end - stride
    ];
    var index = 0;
    while(stack.length > 0){
        var last = stack.pop();
        var first = stack.pop();
        var maxSquaredDistance = 0;
        var x1 = flatCoordinates[first];
        var y1 = flatCoordinates[first + 1];
        var x2 = flatCoordinates[last];
        var y2 = flatCoordinates[last + 1];
        for(var i = first + stride; i < last; i += stride){
            var x = flatCoordinates[i];
            var y = flatCoordinates[i + 1];
            var squaredDistance = (0, $d4e56cfc37d8b1f9$export$251bb0a9cef172e6)(x, y, x1, y1, x2, y2);
            if (squaredDistance > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(var i$1 = 0; i$1 < n; ++i$1)if (markers[i$1]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i$1 * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i$1 * stride + 1];
    }
    return simplifiedOffset;
}
function $ab8844daaf207c08$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        simplifiedOffset = $ab8844daaf207c08$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $ab8844daaf207c08$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        var simplifiedEnds = [];
        simplifiedOffset = $ab8844daaf207c08$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $ab8844daaf207c08$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    var x2 = x1;
    var y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $ab8844daaf207c08$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $ab8844daaf207c08$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    var x1 = $ab8844daaf207c08$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    var y1 = $ab8844daaf207c08$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    var x2, y2;
    do {
        x2 = $ab8844daaf207c08$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $ab8844daaf207c08$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        var x3 = $ab8844daaf207c08$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        var y3 = $ab8844daaf207c08$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        var dx1 = x2 - x1;
        var dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        var dx2 = x3 - x1;
        var dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $ab8844daaf207c08$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        simplifiedOffset = $ab8844daaf207c08$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $ab8844daaf207c08$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        var simplifiedEnds = [];
        simplifiedOffset = $ab8844daaf207c08$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}


/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ var $d4b07f96c637c824$var$LinearRing = /*@__PURE__*/ function(SimpleGeometry) {
    function LinearRing(coordinates, opt_layout) {
        SimpleGeometry.call(this);
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (opt_layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, opt_layout);
    }
    if (SimpleGeometry) LinearRing.__proto__ = SimpleGeometry;
    LinearRing.prototype = Object.create(SimpleGeometry && SimpleGeometry.prototype);
    LinearRing.prototype.constructor = LinearRing;
    /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @override
   * @api
   */ LinearRing.prototype.clone = function clone() {
        return new LinearRing(this.flatCoordinates.slice(), this.layout);
    };
    /**
   * @inheritDoc
   */ LinearRing.prototype.closestPointXY = function closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf52e23c2de7bae9$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf52e23c2de7bae9$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    };
    /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ LinearRing.prototype.getArea = function getArea() {
        return (0, $b024f94ecb74bc8b$export$3c5e1905f889266e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @override
   * @api
   */ LinearRing.prototype.getCoordinates = function getCoordinates() {
        return (0, $76a969a6125a5a4a$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
   * @inheritDoc
   */ LinearRing.prototype.getSimplifiedGeometryInternal = function getSimplifiedGeometryInternal(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new LinearRing(simplifiedFlatCoordinates, (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY);
    };
    /**
   * @inheritDoc
   * @api
   */ LinearRing.prototype.getType = function getType() {
        return (0, $8826602b1d512d67$export$2e2bcd8739ae039).LINEAR_RING;
    };
    /**
   * @inheritDoc
   */ LinearRing.prototype.intersectsExtent = function intersectsExtent(extent) {
        return false;
    };
    /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {GeometryLayout=} opt_layout Layout.
   * @override
   * @api
   */ LinearRing.prototype.setCoordinates = function setCoordinates(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $4ae92c9bec373de6$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return LinearRing;
}((0, $ce25558341ea2841$export$2e2bcd8739ae039));
var $d4b07f96c637c824$export$2e2bcd8739ae039 = $d4b07f96c637c824$var$LinearRing;


/**
 * @module ol/geom/Point
 */ 




/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ var $f7e297e9f8b90024$var$Point = /*@__PURE__*/ function(SimpleGeometry) {
    function Point(coordinates, opt_layout) {
        SimpleGeometry.call(this);
        this.setCoordinates(coordinates, opt_layout);
    }
    if (SimpleGeometry) Point.__proto__ = SimpleGeometry;
    Point.prototype = Object.create(SimpleGeometry && SimpleGeometry.prototype);
    Point.prototype.constructor = Point;
    /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @override
   * @api
   */ Point.prototype.clone = function clone() {
        var point = new Point(this.flatCoordinates.slice(), this.layout);
        return point;
    };
    /**
   * @inheritDoc
   */ Point.prototype.closestPointXY = function closestPointXY(x, y, closestPoint, minSquaredDistance) {
        var flatCoordinates = this.flatCoordinates;
        var squaredDistance = (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            var stride = this.stride;
            for(var i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        } else return minSquaredDistance;
    };
    /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @override
   * @api
   */ Point.prototype.getCoordinates = function getCoordinates() {
        return !this.flatCoordinates ? [] : this.flatCoordinates.slice();
    };
    /**
   * @inheritDoc
   */ Point.prototype.computeExtent = function computeExtent(extent) {
        return (0, $7e819822b33b3d32$export$4838bf78d04a9440)(this.flatCoordinates, extent);
    };
    /**
   * @inheritDoc
   * @api
   */ Point.prototype.getType = function getType() {
        return (0, $8826602b1d512d67$export$2e2bcd8739ae039).POINT;
    };
    /**
   * @inheritDoc
   * @api
   */ Point.prototype.intersectsExtent = function intersectsExtent(extent) {
        return (0, $7e819822b33b3d32$export$805bdfd6d6690e97)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    };
    /**
   * @inheritDoc
   * @api
   */ Point.prototype.setCoordinates = function setCoordinates(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $4ae92c9bec373de6$export$60815ead40ec79ab)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return Point;
}((0, $ce25558341ea2841$export$2e2bcd8739ae039));
var $f7e297e9f8b90024$export$2e2bcd8739ae039 = $f7e297e9f8b90024$var$Point;






/**
 * @module ol/geom/flat/contains
 */ 
function $a614d7cd6ef0f487$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    var outside = (0, $7e819822b33b3d32$export$f9ed8a3d123a08e2)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$a614d7cd6ef0f487$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $a614d7cd6ef0f487$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // http://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    var wn = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $a614d7cd6ef0f487$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$a614d7cd6ef0f487$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(var i = 1, ii = ends.length; i < ii; ++i){
        if ($a614d7cd6ef0f487$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $a614d7cd6ef0f487$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        if ($a614d7cd6ef0f487$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}




/**
 * @module ol/geom/flat/interiorpoint
 */ 

function $197384c2130f50ad$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, opt_dest) {
    var i, ii, x, x1, x2, y1, y2;
    var y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ var intersections = [];
    // Calculate intersections with the horizontal line
    for(var r = 0, rr = ends.length; r < rr; ++r){
        var end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    var pointX = NaN;
    var maxSegmentLength = -Infinity;
    intersections.sort((0, $830d23b8323fc080$export$4e734a3b32fb971b));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        var segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $a614d7cd6ef0f487$export$ae868c0f6acc3355)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (opt_dest) {
        opt_dest.push(pointX, y, maxSegmentLength);
        return opt_dest;
    } else return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $197384c2130f50ad$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    var interiorPoints = [];
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        interiorPoints = $197384c2130f50ad$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}


/**
 * @module ol/geom/flat/intersectsextent
 */ 

/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(this: S, import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @param {S=} opt_this The object to be used as the value of 'this'
 *     within callback.
 * @return {T|boolean} Value.
 * @template T,S
 */ function $d3093947f1b30e1e$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback, opt_this) {
    var point1 = [
        flatCoordinates[offset],
        flatCoordinates[offset + 1]
    ];
    var point2 = [];
    var ret;
    for(; offset + stride < end; offset += stride){
        point2[0] = flatCoordinates[offset + stride];
        point2[1] = flatCoordinates[offset + stride + 1];
        ret = callback.call(opt_this, point1, point2);
        if (ret) return ret;
        point1[0] = point2[0];
        point1[1] = point2[1];
    }
    return false;
}


function $96949d2e503054c4$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent) {
    var coordinatesExtent = (0, $7e819822b33b3d32$export$30570204156ffd18)((0, $7e819822b33b3d32$export$fe201bb3bbe031e9)(), flatCoordinates, offset, end, stride);
    if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(extent, coordinatesExtent)) return false;
    if ((0, $7e819822b33b3d32$export$be866b1e0809b17e)(extent, coordinatesExtent)) return true;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2]) return true;
    if (coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $d3093947f1b30e1e$export$4b80e395e36b5a56)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $7e819822b33b3d32$export$a6a5a7a461419425)(extent, point1, point2);
    });
}
function $96949d2e503054c4$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        if ($96949d2e503054c4$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $96949d2e503054c4$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($96949d2e503054c4$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $a614d7cd6ef0f487$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $a614d7cd6ef0f487$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $a614d7cd6ef0f487$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $a614d7cd6ef0f487$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $96949d2e503054c4$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$96949d2e503054c4$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(var i = 1, ii = ends.length; i < ii; ++i)if ((0, $a614d7cd6ef0f487$export$cedabedc7ac0e138)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$96949d2e503054c4$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $96949d2e503054c4$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        if ($96949d2e503054c4$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


/**
 * @module ol/geom/flat/orient
 */ /**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $3f20011cf27b19b1$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(var i = 0; i < stride; ++i){
            var tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}


function $c8291834a008fd82$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // http://tinyurl.com/clockwise-method
    // https://github.com/OSGeo/gdal/blob/trunk/gdal/ogr/ogrlinearring.cpp
    var edge = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge > 0;
}
function $c8291834a008fd82$export$56d165a4e6daf1c9(flatCoordinates, offset, ends, stride, opt_right) {
    var right = opt_right !== undefined ? opt_right : false;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        var isClockwise = $c8291834a008fd82$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $c8291834a008fd82$export$f27cd06e85f4ba28(flatCoordinates, offset, endss, stride, opt_right) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        if (!$c8291834a008fd82$export$56d165a4e6daf1c9(flatCoordinates, offset, endss[i], stride, opt_right)) return false;
    }
    return true;
}
function $c8291834a008fd82$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, opt_right) {
    var right = opt_right !== undefined ? opt_right : false;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        var isClockwise = $c8291834a008fd82$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        var reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $3f20011cf27b19b1$export$741858880c96b18c)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $c8291834a008fd82$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, opt_right) {
    for(var i = 0, ii = endss.length; i < ii; ++i)offset = $c8291834a008fd82$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, opt_right);
    return offset;
}




/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ var $46a66e0f2fc72479$var$Polygon = /*@__PURE__*/ function(SimpleGeometry) {
    function Polygon(coordinates, opt_layout, opt_ends) {
        SimpleGeometry.call(this);
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointRevision_ = -1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.flatInteriorPoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>}
     */ this.orientedFlatCoordinates_ = null;
        if (opt_layout !== undefined && opt_ends) {
            this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = opt_ends;
        } else this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, opt_layout);
    }
    if (SimpleGeometry) Polygon.__proto__ = SimpleGeometry;
    Polygon.prototype = Object.create(SimpleGeometry && SimpleGeometry.prototype);
    Polygon.prototype.constructor = Polygon;
    /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */ Polygon.prototype.appendLinearRing = function appendLinearRing(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, $830d23b8323fc080$export$8b58be045bf06082)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    };
    /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @override
   * @api
   */ Polygon.prototype.clone = function clone() {
        return new Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
    };
    /**
   * @inheritDoc
   */ Polygon.prototype.closestPointXY = function closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf52e23c2de7bae9$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf52e23c2de7bae9$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    };
    /**
   * @inheritDoc
   */ Polygon.prototype.containsXY = function containsXY(x, y) {
        return (0, $a614d7cd6ef0f487$export$ae868c0f6acc3355)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    };
    /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ Polygon.prototype.getArea = function getArea() {
        return (0, $b024f94ecb74bc8b$export$7a8ee541dfdf2ed5)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    };
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean=} opt_right Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @override
   * @api
   */ Polygon.prototype.getCoordinates = function getCoordinates(opt_right) {
        var flatCoordinates;
        if (opt_right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $c8291834a008fd82$export$b71b604ddfc778c7)(flatCoordinates, 0, this.ends_, this.stride, opt_right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $76a969a6125a5a4a$export$cbb9596fc0f40db2)(flatCoordinates, 0, this.ends_, this.stride);
    };
    /**
   * @return {Array<number>} Ends.
   */ Polygon.prototype.getEnds = function getEnds() {
        return this.ends_;
    };
    /**
   * @return {Array<number>} Interior point.
   */ Polygon.prototype.getFlatInteriorPoint = function getFlatInteriorPoint() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            var flatCenter = (0, $7e819822b33b3d32$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoint_ = (0, $197384c2130f50ad$export$50e3b25928a5e892)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return this.flatInteriorPoint_;
    };
    /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */ Polygon.prototype.getInteriorPoint = function getInteriorPoint() {
        return new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)(this.getFlatInteriorPoint(), (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYM);
    };
    /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */ Polygon.prototype.getLinearRingCount = function getLinearRingCount() {
        return this.ends_.length;
    };
    /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing} Linear ring.
   * @api
   */ Polygon.prototype.getLinearRing = function getLinearRing(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $d4b07f96c637c824$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    };
    /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */ Polygon.prototype.getLinearRings = function getLinearRings() {
        var layout = this.layout;
        var flatCoordinates = this.flatCoordinates;
        var ends = this.ends_;
        var linearRings = [];
        var offset = 0;
        for(var i = 0, ii = ends.length; i < ii; ++i){
            var end = ends[i];
            var linearRing = new (0, $d4b07f96c637c824$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    };
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ Polygon.prototype.getOrientedFlatCoordinates = function getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            var flatCoordinates = this.flatCoordinates;
            if ((0, $c8291834a008fd82$export$56d165a4e6daf1c9)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $c8291834a008fd82$export$b71b604ddfc778c7)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return this.orientedFlatCoordinates_;
    };
    /**
   * @inheritDoc
   */ Polygon.prototype.getSimplifiedGeometryInternal = function getSimplifiedGeometryInternal(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        var simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$60a9904b67f8d51b)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new Polygon(simplifiedFlatCoordinates, (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY, simplifiedEnds);
    };
    /**
   * @inheritDoc
   * @api
   */ Polygon.prototype.getType = function getType() {
        return (0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON;
    };
    /**
   * @inheritDoc
   * @api
   */ Polygon.prototype.intersectsExtent = function intersectsExtent(extent) {
        return (0, $96949d2e503054c4$export$76dcd8f8f83b6ddb)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    };
    /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {GeometryLayout=} opt_layout Layout.
   * @override
   * @api
   */ Polygon.prototype.setCoordinates = function setCoordinates(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        var ends = (0, $4ae92c9bec373de6$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    };
    return Polygon;
}((0, $ce25558341ea2841$export$2e2bcd8739ae039));
var $46a66e0f2fc72479$export$2e2bcd8739ae039 = $46a66e0f2fc72479$var$Polygon;
function $46a66e0f2fc72479$export$f99d756c6d81ae3f(center, radius, opt_n, opt_sphereRadius) {
    var n = opt_n ? opt_n : 32;
    /** @type {Array<number>} */ var flatCoordinates = [];
    for(var i = 0; i < n; ++i)(0, $830d23b8323fc080$export$8b58be045bf06082)(flatCoordinates, (0, $0e7893c26680b018$export$cc800923e997bb8)(center, radius, 2 * Math.PI * i / n, opt_sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $46a66e0f2fc72479$var$Polygon(flatCoordinates, (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY, [
        flatCoordinates.length
    ]);
}
function $46a66e0f2fc72479$export$c16b671815801c75(extent) {
    var minX = extent[0];
    var minY = extent[1];
    var maxX = extent[2];
    var maxY = extent[3];
    var flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $46a66e0f2fc72479$var$Polygon(flatCoordinates, (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY, [
        flatCoordinates.length
    ]);
}
function $46a66e0f2fc72479$export$2451009d645fb8c2(circle, opt_sides, opt_angle) {
    var sides = opt_sides ? opt_sides : 32;
    var stride = circle.getStride();
    var layout = circle.getLayout();
    var center = circle.getCenter();
    var arrayLength = stride * (sides + 1);
    var flatCoordinates = new Array(arrayLength);
    for(var i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(var j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    var ends = [
        flatCoordinates.length
    ];
    var polygon = new $46a66e0f2fc72479$var$Polygon(flatCoordinates, layout, ends);
    $46a66e0f2fc72479$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), opt_angle);
    return polygon;
}
function $46a66e0f2fc72479$export$87d6a1539a56e47f(polygon, center, radius, opt_angle) {
    var flatCoordinates = polygon.getFlatCoordinates();
    var stride = polygon.getStride();
    var sides = flatCoordinates.length / stride - 1;
    var startAngle = opt_angle ? opt_angle : 0;
    for(var i = 0; i <= sides; ++i){
        var offset = i * stride;
        var angle = startAngle + (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}






/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter]
 * @property {import("./coordinate.js").Coordinate} [targetCenter]
 * @property {number} [sourceResolution]
 * @property {number} [targetResolution]
 * @property {number} [sourceRotation]
 * @property {number} [targetRotation]
 * @property {import("./coordinate.js").Coordinate} [anchor]
 * @property {number} start
 * @property {number} duration
 * @property {boolean} complete
 * @property {function(number):number} easing
 * @property {function(boolean)} callback
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center
 * @property {import("./resolutionconstraint.js").Type} resolution
 * @property {import("./rotationconstraint.js").Type} rotation
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to fit
 * the extent into. Default is the current size of the first map in the DOM that
 * uses this view, or `[100, 100]` if no such map is found.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [constrainResolution=true] Constrain the resolution.
 * @property {boolean} [nearest=false] If `constrainResolution` is `true`, get
 * the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing~inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean)} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. The coordinate system for the center is specified with the
 * `projection` option. Layer sources will not be fetched if this is not set,
 * but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * center, in other words, center cannot be set outside this extent.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions to determine the
 * resolution constraint. If set the `maxResolution`, `minResolution`,
 * `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view. The initial
 * resolution is determined using the {@link #constrainResolution} method.
 * @property {number} [zoomFactor=2] The zoom factor used to determine the
 * resolution constraint.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remained fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing~inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center
 * @property {import("./proj/Projection.js").default} projection
 * @property {number} resolution
 * @property {number} rotation
 * @property {number} zoom
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ var $3192ea72f934a3fd$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * ### The view states
 *
 * An View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * An View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Spherical Mercator (EPSG:3857).
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view. Any value can be passed to the setters. And the value
 * that is passed to a setter will effectively be the value set in the view,
 * and returned by the corresponding getter.
 *
 * But a View object also has a *resolution constraint*, a
 * *rotation constraint* and a *center constraint*.
 *
 * As said above, no constraints are applied when the setters are used to set
 * new states for the view. Applying constraints is done explicitly through
 * the use of the `constrain*` functions (`constrainResolution` and
 * `constrainRotation` and `constrainCenter`).
 *
 * The main users of the constraints are the interactions and the
 * controls. For example, double-clicking on the map changes the view to
 * the "next" resolution. And releasing the fingers after pinch-zooming
 * snaps to the closest resolution (with an animation).
 *
 * The *resolution constraint* snaps to specific resolutions. It is
 * determined by the following options: `resolutions`, `maxResolution`,
 * `maxZoom`, and `zoomFactor`. If `resolutions` is set, the other three
 * options are ignored. See documentation for each option for more
 * information.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default the rotation value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the center is not constrained at all.
 *
  * @api
 */ var $3192ea72f934a3fd$var$View = /*@__PURE__*/ function(BaseObject) {
    function View(opt_options) {
        BaseObject.call(this);
        var options = (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({}, opt_options);
        /**
     * @private
     * @type {Array<number>}
     */ this.hints_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {Array<Array<Animation>>}
     */ this.animations_ = [];
        /**
     * @private
     * @type {number|undefined}
     */ this.updateAnimationKey_;
        this.updateAnimations_ = this.updateAnimations_.bind(this);
        /**
     * @private
     * @const
     * @type {import("./proj/Projection.js").default}
     */ this.projection_ = (0, $92f1443438429e81$export$549167224996a0fb)(options.projection, "EPSG:3857");
        this.applyOptions_(options);
    }
    if (BaseObject) View.__proto__ = BaseObject;
    View.prototype = Object.create(BaseObject && BaseObject.prototype);
    View.prototype.constructor = View;
    /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */ View.prototype.applyOptions_ = function applyOptions_(options) {
        /**
     * @type {Object<string, *>}
     */ var properties = {};
        properties[(0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).CENTER] = options.center !== undefined ? options.center : null;
        var resolutionConstraintInfo = $3192ea72f934a3fd$export$c68d65f9148da196(options);
        /**
     * @private
     * @type {number}
     */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
     * @private
     * @type {number}
     */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
     * @private
     * @type {number}
     */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
     * @private
     * @type {Array<number>|undefined}
     */ this.resolutions_ = options.resolutions;
        /**
     * @private
     * @type {number}
     */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        var centerConstraint = $3192ea72f934a3fd$export$964345001ee9ac52(options);
        var resolutionConstraint = resolutionConstraintInfo.constraint;
        var rotationConstraint = $3192ea72f934a3fd$export$4eeaa08dd550e3c0(options);
        /**
     * @private
     * @type {Constraints}
     */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        if (options.resolution !== undefined) properties[(0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).RESOLUTION] = options.resolution;
        else if (options.zoom !== undefined) {
            properties[(0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).RESOLUTION] = this.constrainResolution(this.maxResolution_, options.zoom - this.minZoom_);
            if (this.resolutions_) properties[(0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).RESOLUTION] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(Number(this.getResolution() || properties[(0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).RESOLUTION]), this.minResolution_, this.maxResolution_);
        }
        properties[(0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).ROTATION] = options.rotation !== undefined ? options.rotation : 0;
        this.setProperties(properties);
        /**
     * @private
     * @type {ViewOptions}
     */ this.options_ = options;
    };
    /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */ View.prototype.getUpdatedOptions_ = function getUpdatedOptions_(newOptions) {
        var options = (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({}, this.options_);
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenter();
        // preserve rotation
        options.rotation = this.getRotation();
        return (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({}, options, newOptions);
    };
    /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean))} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */ View.prototype.animate = function animate(var_args) {
        var arguments$1 = arguments;
        var animationCount = arguments.length;
        var callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === "function") {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        if (!this.isDef()) {
            // if view properties are not yet set, shortcut to the final state
            var state = arguments[animationCount - 1];
            if (state.center) this.setCenter(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
            if (callback) $3192ea72f934a3fd$var$animationCallback(callback, true);
            return;
        }
        var start = Date.now();
        var center = this.getCenter().slice();
        var resolution = this.getResolution();
        var rotation = this.getRotation();
        var series = [];
        for(var i = 0; i < animationCount; ++i){
            var options = /** @type {AnimationOptions} */ arguments$1[i];
            var animation = /** @type {Animation} */ {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, $0164a93fcf6e65ad$export$9b47139b511b56e4)
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center;
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.constrainResolution(this.maxResolution_, options.zoom - this.minZoom_, 0);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                var delta = (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            animation.callback = callback;
            // check if animation is a no-op
            if ($3192ea72f934a3fd$export$ee75376562060184(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING, 1);
        this.updateAnimations_();
    };
    /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */ View.prototype.getAnimating = function getAnimating() {
        return this.hints_[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING] > 0;
    };
    /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */ View.prototype.getInteracting = function getInteracting() {
        return this.hints_[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING] > 0;
    };
    /**
   * Cancel any ongoing animations.
   * @api
   */ View.prototype.cancelAnimations = function cancelAnimations() {
        this.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING, -this.hints_[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING]);
        for(var i = 0, ii = this.animations_.length; i < ii; ++i){
            var series = this.animations_[i];
            if (series[0].callback) $3192ea72f934a3fd$var$animationCallback(series[0].callback, false);
        }
        this.animations_.length = 0;
    };
    /**
   * Update all animations.
   */ View.prototype.updateAnimations_ = function updateAnimations_() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        var now = Date.now();
        var more = false;
        for(var i = this.animations_.length - 1; i >= 0; --i){
            var series = this.animations_[i];
            var seriesComplete = true;
            for(var j = 0, jj = series.length; j < jj; ++j){
                var animation = series[j];
                if (animation.complete) continue;
                var elapsed = now - animation.start;
                var fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                var progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    var x0 = animation.sourceCenter[0];
                    var y0 = animation.sourceCenter[1];
                    var x1 = animation.targetCenter[0];
                    var y1 = animation.targetCenter[1];
                    var x = x0 + progress * (x1 - x0);
                    var y = y0 + progress * (y1 - y0);
                    this.set((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).CENTER, [
                        x,
                        y
                    ]);
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    var resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) this.set((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).CENTER, this.calculateCenterZoom(resolution, animation.anchor));
                    this.set((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).RESOLUTION, resolution);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    var rotation = progress === 1 ? (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) this.set((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).CENTER, this.calculateCenterRotate(rotation, animation.anchor));
                    this.set((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).ROTATION, rotation);
                }
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING, -1);
                var callback = series[0].callback;
                if (callback) $3192ea72f934a3fd$var$animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_);
    };
    /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */ View.prototype.calculateCenterRotate = function calculateCenterRotate(rotation, anchor) {
        var center;
        var currentCenter = this.getCenter();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, $8b28786758450fff$export$bb628a54ab399bc9)(center, rotation - this.getRotation());
            (0, $8b28786758450fff$export$e16d8520af44a096)(center, anchor);
        }
        return center;
    };
    /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */ View.prototype.calculateCenterZoom = function calculateCenterZoom(resolution, anchor) {
        var center;
        var currentCenter = this.getCenter();
        var currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            var x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            var y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    };
    /**
   * @private
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */ View.prototype.getSizeFromViewport_ = function getSizeFromViewport_() {
        var size = [
            100,
            100
        ];
        var selector = '.ol-viewport[data-view="' + (0, $34772e91e89a736f$export$5e82334337e0f204)(this) + '"]';
        var element = document.querySelector(selector);
        if (element) {
            var metrics = getComputedStyle(element);
            size[0] = parseInt(metrics.width, 10);
            size[1] = parseInt(metrics.height, 10);
        }
        return size;
    };
    /**
   * Get the constrained center of this view.
   * @param {import("./coordinate.js").Coordinate|undefined} center Center.
   * @return {import("./coordinate.js").Coordinate|undefined} Constrained center.
   * @api
   */ View.prototype.constrainCenter = function constrainCenter(center) {
        return this.constraints_.center(center);
    };
    /**
   * Get the constrained resolution of this view.
   * @param {number|undefined} resolution Resolution.
   * @param {number=} opt_delta Delta. Default is `0`.
   * @param {number=} opt_direction Direction. Default is `0`.
   * @return {number|undefined} Constrained resolution.
   * @api
   */ View.prototype.constrainResolution = function constrainResolution(resolution, opt_delta, opt_direction) {
        var delta = opt_delta || 0;
        var direction = opt_direction || 0;
        return this.constraints_.resolution(resolution, delta, direction);
    };
    /**
   * Get the constrained rotation of this view.
   * @param {number|undefined} rotation Rotation.
   * @param {number=} opt_delta Delta. Default is `0`.
   * @return {number|undefined} Constrained rotation.
   * @api
   */ View.prototype.constrainRotation = function constrainRotation(rotation, opt_delta) {
        var delta = opt_delta || 0;
        return this.constraints_.rotation(rotation, delta);
    };
    /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */ View.prototype.getCenter = function getCenter() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).CENTER);
    };
    /**
   * @return {Constraints} Constraints.
   */ View.prototype.getConstraints = function getConstraints() {
        return this.constraints_;
    };
    /**
   * @param {Array<number>=} opt_hints Destination array.
   * @return {Array<number>} Hint.
   */ View.prototype.getHints = function getHints(opt_hints) {
        if (opt_hints !== undefined) {
            opt_hints[0] = this.hints_[0];
            opt_hints[1] = this.hints_[1];
            return opt_hints;
        } else return this.hints_.slice();
    };
    /**
   * Calculate the extent for the current view state and the passed size.
   * The size is the pixel dimensions of the box into which the calculated extent
   * should fit. In most cases you want to get the extent of the entire map,
   * that is `map.getSize()`.
   * @param {import("./size.js").Size=} opt_size Box pixel size. If not provided, the size of the
   * first map that uses this view will be used.
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */ View.prototype.calculateExtent = function calculateExtent(opt_size) {
        var size = opt_size || this.getSizeFromViewport_();
        var center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenter();
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(center, 1); // The view center is not defined
        var resolution = /** @type {!number} */ this.getResolution();
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(resolution !== undefined, 2); // The view resolution is not defined
        var rotation = /** @type {!number} */ this.getRotation();
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(rotation !== undefined, 3); // The view rotation is not defined
        return (0, $7e819822b33b3d32$export$13ba650faf8308)(center, resolution, rotation, size);
    };
    /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */ View.prototype.getMaxResolution = function getMaxResolution() {
        return this.maxResolution_;
    };
    /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */ View.prototype.getMinResolution = function getMinResolution() {
        return this.minResolution_;
    };
    /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */ View.prototype.getMaxZoom = function getMaxZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    };
    /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */ View.prototype.setMaxZoom = function setMaxZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    };
    /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */ View.prototype.getMinZoom = function getMinZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    };
    /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */ View.prototype.setMinZoom = function setMinZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    };
    /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */ View.prototype.getProjection = function getProjection() {
        return this.projection_;
    };
    /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */ View.prototype.getResolution = function getResolution() {
        return /** @type {number|undefined} */ this.get((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).RESOLUTION);
    };
    /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */ View.prototype.getResolutions = function getResolutions() {
        return this.resolutions_;
    };
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size=} opt_size Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */ View.prototype.getResolutionForExtent = function getResolutionForExtent(extent, opt_size) {
        var size = opt_size || this.getSizeFromViewport_();
        var xResolution = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(extent) / size[0];
        var yResolution = (0, $7e819822b33b3d32$export$c08559766941f856)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    };
    /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number=} opt_power Power.
   * @return {function(number): number} Resolution for value function.
   */ View.prototype.getResolutionForValueFunction = function getResolutionForValueFunction(opt_power) {
        var power = opt_power || 2;
        var maxResolution = this.maxResolution_;
        var minResolution = this.minResolution_;
        var max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
       * @param {number} value Value.
       * @return {number} Resolution.
       */ function(value) {
            var resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    };
    /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */ View.prototype.getRotation = function getRotation() {
        return /** @type {number} */ this.get((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).ROTATION);
    };
    /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number=} opt_power Power.
   * @return {function(number): number} Value for resolution function.
   */ View.prototype.getValueForResolutionFunction = function getValueForResolutionFunction(opt_power) {
        var power = opt_power || 2;
        var maxResolution = this.maxResolution_;
        var minResolution = this.minResolution_;
        var max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */ function(resolution) {
            var value = Math.log(maxResolution / resolution) / Math.log(power) / max;
            return value;
        });
    };
    /**
   * @param {number} pixelRatio Pixel ratio for center rounding.
   * @return {State} View state.
   */ View.prototype.getState = function getState(pixelRatio) {
        var center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenter();
        var projection = this.getProjection();
        var resolution = /** @type {number} */ this.getResolution();
        var pixelResolution = resolution / pixelRatio;
        var rotation = this.getRotation();
        return /** @type {State} */ {
            center: [
                Math.round(center[0] / pixelResolution) * pixelResolution,
                Math.round(center[1] / pixelResolution) * pixelResolution
            ],
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            rotation: rotation,
            zoom: this.getZoom()
        };
    };
    /**
   * Get the current zoom level.  If you configured your view with a resolutions
   * array (this is rare), this method may return non-integer zoom levels (so
   * the zoom level is not safe to use as an index into a resolutions array).
   * @return {number|undefined} Zoom.
   * @api
   */ View.prototype.getZoom = function getZoom() {
        var zoom;
        var resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    };
    /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */ View.prototype.getZoomForResolution = function getZoomForResolution(resolution) {
        var offset = this.minZoom_ || 0;
        var max, zoomFactor;
        if (this.resolutions_) {
            var nearest = (0, $830d23b8323fc080$export$8a3786cc03fdb777)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    };
    /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */ View.prototype.getResolutionForZoom = function getResolutionForZoom(zoom) {
        return /** @type {number} */ this.constrainResolution(this.maxResolution_, zoom - this.minZoom_, 0);
    };
    /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions=} opt_options Options.
   * @api
   */ View.prototype.fit = function fit(geometryOrExtent, opt_options) {
        var options = opt_options || {};
        var size = options.size;
        if (!size) size = this.getSizeFromViewport_();
        /** @type {import("./geom/SimpleGeometry.js").default} */ var geometry;
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === "function", 24); // Invalid extent or geometry provided as `geometry`
        if (Array.isArray(geometryOrExtent)) {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!(0, $7e819822b33b3d32$export$dd1bc94b04021eeb)(geometryOrExtent), 25); // Cannot fit empty extent provided as `geometry`
            geometry = (0, $46a66e0f2fc72479$export$c16b671815801c75)(geometryOrExtent);
        } else if (geometryOrExtent.getType() === (0, $8826602b1d512d67$export$2e2bcd8739ae039).CIRCLE) {
            geometryOrExtent = geometryOrExtent.getExtent();
            geometry = (0, $46a66e0f2fc72479$export$c16b671815801c75)(geometryOrExtent);
            geometry.rotate(this.getRotation(), (0, $7e819822b33b3d32$export$c91255cadecfe081)(geometryOrExtent));
        } else geometry = geometryOrExtent;
        var padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        var constrainResolution = options.constrainResolution !== undefined ? options.constrainResolution : true;
        var nearest = options.nearest !== undefined ? options.nearest : false;
        var minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.constrainResolution(this.maxResolution_, options.maxZoom - this.minZoom_, 0);
        else minResolution = 0;
        var coords = geometry.getFlatCoordinates();
        // calculate rotated extent
        var rotation = this.getRotation();
        var cosAngle = Math.cos(-rotation);
        var sinAngle = Math.sin(-rotation);
        var minRotX = Infinity;
        var minRotY = Infinity;
        var maxRotX = -Infinity;
        var maxRotY = -Infinity;
        var stride = geometry.getStride();
        for(var i = 0, ii = coords.length; i < ii; i += stride){
            var rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            var rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        // calculate resolution
        var resolution = this.getResolutionForExtent([
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ], [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        if (constrainResolution) {
            var constrainedResolution = this.constrainResolution(resolution, 0, 0);
            if (!nearest && constrainedResolution < resolution) constrainedResolution = this.constrainResolution(constrainedResolution, -1, 0);
            resolution = constrainedResolution;
        }
        // calculate center
        sinAngle = -sinAngle; // go back to original rotation
        var centerRotX = (minRotX + maxRotX) / 2;
        var centerRotY = (minRotY + maxRotY) / 2;
        centerRotX += (padding[1] - padding[3]) / 2 * resolution;
        centerRotY += (padding[0] - padding[2]) / 2 * resolution;
        var centerX = centerRotX * cosAngle - centerRotY * sinAngle;
        var centerY = centerRotY * cosAngle + centerRotX * sinAngle;
        var center = [
            centerX,
            centerY
        ];
        var callback = options.callback ? options.callback : (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8);
        if (options.duration !== undefined) this.animate({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.setResolution(resolution);
            this.setCenter(center);
            $3192ea72f934a3fd$var$animationCallback(callback, true);
        }
    };
    /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */ View.prototype.centerOn = function centerOn(coordinate, size, position) {
        // calculate rotated position
        var rotation = this.getRotation();
        var cosAngle = Math.cos(-rotation);
        var sinAngle = Math.sin(-rotation);
        var rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
        var rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
        var resolution = this.getResolution();
        rotX += (size[0] / 2 - position[0]) * resolution;
        rotY += (position[1] - size[1] / 2) * resolution;
        // go back to original angle
        sinAngle = -sinAngle; // go back to original rotation
        var centerX = rotX * cosAngle - rotY * sinAngle;
        var centerY = rotY * cosAngle + rotX * sinAngle;
        this.setCenter([
            centerX,
            centerY
        ]);
    };
    /**
   * @return {boolean} Is defined.
   */ View.prototype.isDef = function isDef() {
        return !!this.getCenter() && this.getResolution() !== undefined;
    };
    /**
   * Rotate the view around a given coordinate.
   * @param {number} rotation New rotation value for the view.
   * @param {import("./coordinate.js").Coordinate=} opt_anchor The rotation center.
   * @api
   */ View.prototype.rotate = function rotate(rotation, opt_anchor) {
        if (opt_anchor !== undefined) {
            var center = this.calculateCenterRotate(rotation, opt_anchor);
            this.setCenter(center);
        }
        this.setRotation(rotation);
    };
    /**
   * Set the center of the current view.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */ View.prototype.setCenter = function setCenter(center) {
        this.set((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).CENTER, center);
        if (this.getAnimating()) this.cancelAnimations();
    };
    /**
   * @param {ViewHint} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */ View.prototype.setHint = function setHint(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    };
    /**
   * Set the resolution for this view.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */ View.prototype.setResolution = function setResolution(resolution) {
        this.set((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).RESOLUTION, resolution);
        if (this.getAnimating()) this.cancelAnimations();
    };
    /**
   * Set the rotation for this view.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */ View.prototype.setRotation = function setRotation(rotation) {
        this.set((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).ROTATION, rotation);
        if (this.getAnimating()) this.cancelAnimations();
    };
    /**
   * Zoom to a specific zoom level.
   * @param {number} zoom Zoom level.
   * @api
   */ View.prototype.setZoom = function setZoom(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    };
    return View;
}((0, $d575b598d09f57d3$export$2e2bcd8739ae039));
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $3192ea72f934a3fd$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $3192ea72f934a3fd$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) return (0, $6a005ced57043b5f$export$c2f0af2c946f6897)(options.extent);
    else return 0, $6a005ced57043b5f$export$f883a24d5edde77c;
}
function $3192ea72f934a3fd$export$c68d65f9148da196(options) {
    var resolutionConstraint;
    var maxResolution;
    var minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    var defaultMaxZoom = 28;
    var defaultZoomFactor = 2;
    var minZoom = options.minZoom !== undefined ? options.minZoom : $3192ea72f934a3fd$var$DEFAULT_MIN_ZOOM;
    var maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    var zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    if (options.resolutions !== undefined) {
        var resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        resolutionConstraint = (0, $fc7552e588d344e0$export$d65a517690fc4385)(resolutions);
    } else {
        // calculate the default min and max resolution
        var projection = (0, $92f1443438429e81$export$549167224996a0fb)(options.projection, "EPSG:3857");
        var extent = projection.getExtent();
        var size = !extent ? // use an extent that can fit the whole world if need be
        360 * (0, $fb72d58bc9104528$export$1482081eec883108)[(0, $fb72d58bc9104528$export$2e2bcd8739ae039).DEGREES] / projection.getMetersPerUnit() : Math.max((0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(extent), (0, $7e819822b33b3d32$export$c08559766941f856)(extent));
        var defaultMaxResolution = size / (0, $9a8010a8337e7cef$export$6b8cb5cd370bd90c) / Math.pow(defaultZoomFactor, $3192ea72f934a3fd$var$DEFAULT_MIN_ZOOM);
        var defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $3192ea72f934a3fd$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        resolutionConstraint = (0, $fc7552e588d344e0$export$22ac0f6b219de91a)(zoomFactor, maxResolution, maxZoom - minZoom);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $3192ea72f934a3fd$export$4eeaa08dd550e3c0(options) {
    var enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        var constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $ea3e0fdf428207b8$export$17a6e6f3448b17e8)();
        else if (constrainRotation === false) return 0, $ea3e0fdf428207b8$export$f883a24d5edde77c;
        else if (typeof constrainRotation === "number") return (0, $ea3e0fdf428207b8$export$9ba78806de831083)(constrainRotation);
        else return 0, $ea3e0fdf428207b8$export$f883a24d5edde77c;
    } else return 0, $ea3e0fdf428207b8$export$e20fbacbb41798b;
}
function $3192ea72f934a3fd$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $8b28786758450fff$export$e9bab7fafb253603)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
var $3192ea72f934a3fd$export$2e2bcd8739ae039 = $3192ea72f934a3fd$var$View;




/**
 * @module ol/dom
 */ /**
 * Create an html canvas element and returns its 2d context.
 * @param {number=} opt_width Canvas width.
 * @param {number=} opt_height Canvas height.
 * @return {CanvasRenderingContext2D} The context.
 */ function $755a3001f896bcf1$export$9e05d10eae75c464(opt_width, opt_height) {
    var canvas = /** @type {HTMLCanvasElement} */ document.createElement("canvas");
    if (opt_width) canvas.width = opt_width;
    if (opt_height) canvas.height = opt_height;
    return /** @type {CanvasRenderingContext2D} */ canvas.getContext("2d");
}
function $755a3001f896bcf1$export$e823f88e4111159a(element) {
    var width = element.offsetWidth;
    var style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $755a3001f896bcf1$export$fc5b8aac72846d1e(element) {
    var height = element.offsetHeight;
    var style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $755a3001f896bcf1$export$5542201de9311ab2(newNode, oldNode) {
    var parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $755a3001f896bcf1$export$1d0aa160432dfea5(node) {
    return node && node.parentNode ? node.parentNode.removeChild(node) : null;
}
function $755a3001f896bcf1$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.removeChild(node.lastChild);
}








/**
 * @module ol/layer/Group
 */ 








/**
 * @module ol/layer/Base
 */ 

/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $6cc5709edf8fe4ca$export$2e2bcd8739ae039 = {
    OPACITY: "opacity",
    VISIBLE: "visible",
    EXTENT: "extent",
    Z_INDEX: "zIndex",
    MAX_RESOLUTION: "maxResolution",
    MIN_RESOLUTION: "minResolution",
    SOURCE: "source"
};




/**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 */ var $462b2201ee49de24$var$BaseLayer = /*@__PURE__*/ function(BaseObject) {
    function BaseLayer(options) {
        BaseObject.call(this);
        /**
     * @type {Object<string, *>}
     */ var properties = (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({}, options);
        properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).Z_INDEX] = options.zIndex;
        properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        this.setProperties(properties);
        /**
     * @type {import("./Layer.js").State}
     * @private
     */ this.state_ = null;
        /**
     * The layer type.
     * @type {import("../LayerType.js").default}
     * @protected;
     */ this.type;
    }
    if (BaseObject) BaseLayer.__proto__ = BaseObject;
    BaseLayer.prototype = Object.create(BaseObject && BaseObject.prototype);
    BaseLayer.prototype.constructor = BaseLayer;
    /**
   * Get the layer type (used when creating a layer renderer).
   * @return {import("../LayerType.js").default} The layer type.
   */ BaseLayer.prototype.getType = function getType() {
        return this.type;
    };
    /**
   * @return {import("./Layer.js").State} Layer state.
   */ BaseLayer.prototype.getLayerState = function getLayerState() {
        /** @type {import("./Layer.js").State} */ var state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: true
        };
        state.opacity = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(this.getOpacity(), 0, 1);
        state.sourceState = this.getSourceState();
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = this.getZIndex() || 0;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        this.state_ = state;
        return state;
    };
    /**
   * @abstract
   * @param {Array<import("./Layer.js").default>=} opt_array Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ BaseLayer.prototype.getLayersArray = function getLayersArray(opt_array) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * @abstract
   * @param {Array<import("./Layer.js").State>=} opt_states Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ BaseLayer.prototype.getLayerStatesArray = function getLayerStatesArray(opt_states) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */ BaseLayer.prototype.getExtent = function getExtent() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).EXTENT);
    };
    /**
   * Return the maximum resolution of the layer.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */ BaseLayer.prototype.getMaxResolution = function getMaxResolution() {
        return /** @type {number} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MAX_RESOLUTION);
    };
    /**
   * Return the minimum resolution of the layer.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */ BaseLayer.prototype.getMinResolution = function getMinResolution() {
        return /** @type {number} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MIN_RESOLUTION);
    };
    /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */ BaseLayer.prototype.getOpacity = function getOpacity() {
        return /** @type {number} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).OPACITY);
    };
    /**
   * @abstract
   * @return {import("../source/State.js").default} Source state.
   */ BaseLayer.prototype.getSourceState = function getSourceState() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Return the visibility of the layer (`true` or `false`).
   * @return {boolean} The visibility of the layer.
   * @observable
   * @api
   */ BaseLayer.prototype.getVisible = function getVisible() {
        return /** @type {boolean} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).VISIBLE);
    };
    /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. The default Z-index is 0.
   * @return {number} The Z-index of the layer.
   * @observable
   * @api
   */ BaseLayer.prototype.getZIndex = function getZIndex() {
        return /** @type {number} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).Z_INDEX);
    };
    /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */ BaseLayer.prototype.setExtent = function setExtent(extent) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).EXTENT, extent);
    };
    /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */ BaseLayer.prototype.setMaxResolution = function setMaxResolution(maxResolution) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MAX_RESOLUTION, maxResolution);
    };
    /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */ BaseLayer.prototype.setMinResolution = function setMinResolution(minResolution) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MIN_RESOLUTION, minResolution);
    };
    /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */ BaseLayer.prototype.setOpacity = function setOpacity(opacity) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).OPACITY, opacity);
    };
    /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */ BaseLayer.prototype.setVisible = function setVisible(visible) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).VISIBLE, visible);
    };
    /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */ BaseLayer.prototype.setZIndex = function setZIndex(zindex) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).Z_INDEX, zindex);
    };
    return BaseLayer;
}((0, $d575b598d09f57d3$export$2e2bcd8739ae039));
var $462b2201ee49de24$export$2e2bcd8739ae039 = $462b2201ee49de24$var$BaseLayer;



/**
 * @module ol/source/State
 */ /**
 * @enum {string}
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ var $7c2f117cb5c1ce12$export$2e2bcd8739ae039 = {
    UNDEFINED: "undefined",
    LOADING: "loading",
    READY: "ready",
    ERROR: "error"
};


/**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|import("../Collection.js").default<import("./Base.js").default>} [layers] Child layers.
 */ /**
 * @enum {string}
 * @private
 */ var $96e8168163e6fc58$var$Property = {
    LAYERS: "layers"
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @api
 */ var $96e8168163e6fc58$var$LayerGroup = /*@__PURE__*/ function(BaseLayer) {
    function LayerGroup(opt_options) {
        var options = opt_options || {};
        var baseOptions = /** @type {Options} */ (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({}, options);
        delete baseOptions.layers;
        var layers = options.layers;
        BaseLayer.call(this, baseOptions);
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.layersListenerKeys_ = [];
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.listenerKeys_ = {};
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)($96e8168163e6fc58$var$Property.LAYERS), this.handleLayersChanged_, this);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $7be3d63260860659$export$2e2bcd8739ae039)(layers.slice(), {
                unique: true
            });
            else (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof /** @type {?} */ layers.getArray === "function", 43); // Expected `layers` to be an array or a `Collection`
        } else layers = new (0, $7be3d63260860659$export$2e2bcd8739ae039)(undefined, {
            unique: true
        });
        this.setLayers(layers);
    }
    if (BaseLayer) LayerGroup.__proto__ = BaseLayer;
    LayerGroup.prototype = Object.create(BaseLayer && BaseLayer.prototype);
    LayerGroup.prototype.constructor = LayerGroup;
    /**
   * @private
   */ LayerGroup.prototype.handleLayerChange_ = function handleLayerChange_() {
        this.changed();
    };
    /**
   * @private
   */ LayerGroup.prototype.handleLayersChanged_ = function handleLayersChanged_() {
        this.layersListenerKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        this.layersListenerKeys_.length = 0;
        var layers = this.getLayers();
        this.layersListenerKeys_.push((0, $37a5c0af9052e360$export$63174c828edd6ff8)(layers, (0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, this.handleLayersAdd_, this), (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layers, (0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, this.handleLayersRemove_, this));
        for(var id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        (0, $8c1e0b75b65663dc$export$42ffd38884aecdac)(this.listenerKeys_);
        var layersArray = layers.getArray();
        for(var i = 0, ii = layersArray.length; i < ii; i++){
            var layer = layersArray[i];
            this.listenerKeys_[(0, $34772e91e89a736f$export$5e82334337e0f204)(layer)] = [
                (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layer, (0, $19100aa5be43a728$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleLayerChange_, this),
                (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layer, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleLayerChange_, this)
            ];
        }
        this.changed();
    };
    /**
   * @param {import("../Collection.js").CollectionEvent} collectionEvent CollectionEvent.
   * @private
   */ LayerGroup.prototype.handleLayersAdd_ = function handleLayersAdd_(collectionEvent) {
        var layer = /** @type {import("./Base.js").default} */ collectionEvent.element;
        this.listenerKeys_[(0, $34772e91e89a736f$export$5e82334337e0f204)(layer)] = [
            (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layer, (0, $19100aa5be43a728$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layer, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleLayerChange_, this)
        ];
        this.changed();
    };
    /**
   * @param {import("../Collection.js").CollectionEvent} collectionEvent CollectionEvent.
   * @private
   */ LayerGroup.prototype.handleLayersRemove_ = function handleLayersRemove_(collectionEvent) {
        var layer = /** @type {import("./Base.js").default} */ collectionEvent.element;
        var key = (0, $34772e91e89a736f$export$5e82334337e0f204)(layer);
        this.listenerKeys_[key].forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        delete this.listenerKeys_[key];
        this.changed();
    };
    /**
   * Returns the {@link module:ol/Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!import("../Collection.js").default<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base layers} that are part of this group.
   * @observable
   * @api
   */ LayerGroup.prototype.getLayers = function getLayers() {
        return /** @type {!import("../Collection.js").default<import("./Base.js").default>} */ this.get($96e8168163e6fc58$var$Property.LAYERS);
    };
    /**
   * Set the {@link module:ol/Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!import("../Collection.js").default<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base layers} that are part of this group.
   * @observable
   * @api
   */ LayerGroup.prototype.setLayers = function setLayers(layers) {
        this.set($96e8168163e6fc58$var$Property.LAYERS, layers);
    };
    /**
   * @inheritDoc
   */ LayerGroup.prototype.getLayersArray = function getLayersArray(opt_array) {
        var array = opt_array !== undefined ? opt_array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    };
    /**
   * @inheritDoc
   */ LayerGroup.prototype.getLayerStatesArray = function getLayerStatesArray(opt_states) {
        var states = opt_states !== undefined ? opt_states : [];
        var pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        var ownLayerState = this.getLayerState();
        for(var i = pos, ii = states.length; i < ii; i++){
            var layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, $7e819822b33b3d32$export$72209efa88586d42)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
        }
        return states;
    };
    /**
   * @inheritDoc
   */ LayerGroup.prototype.getSourceState = function getSourceState() {
        return (0, $7c2f117cb5c1ce12$export$2e2bcd8739ae039).READY;
    };
    return LayerGroup;
}((0, $462b2201ee49de24$export$2e2bcd8739ae039));
var $96e8168163e6fc58$export$2e2bcd8739ae039 = $96e8168163e6fc58$var$LayerGroup;


/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size=} opt_size Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $f65ee5b9d8e75975$export$ab1029bcae9ddb4a(size, num, opt_size) {
    if (opt_size === undefined) opt_size = [
        0,
        0
    ];
    opt_size[0] = size[0] + 2 * num;
    opt_size[1] = size[1] + 2 * num;
    return opt_size;
}
function $f65ee5b9d8e75975$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $f65ee5b9d8e75975$export$dcdf75081b88279d(size, ratio, opt_size) {
    if (opt_size === undefined) opt_size = [
        0,
        0
    ];
    opt_size[0] = size[0] * ratio + 0.5 | 0;
    opt_size[1] = size[1] * ratio + 0.5 | 0;
    return opt_size;
}
function $f65ee5b9d8e75975$export$a71a825ff42fb8e1(size, opt_size) {
    if (Array.isArray(size)) return size;
    else {
        if (opt_size === undefined) opt_size = [
            size,
            size
        ];
        else opt_size[0] = opt_size[1] = /** @type {number} */ size;
        return opt_size;
    }
}




/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate
 * @property {import("./transform.js").Transform} coordinateToPixelTransform
 * @property {null|import("./extent.js").Extent} extent
 * @property {import("./coordinate.js").Coordinate} focus
 * @property {number} index
 * @property {Object<string, import("./layer/Layer.js").State>} layerStates
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform
 * @property {Array<PostRenderFunction>} postRenderFunctions
 * @property {import("./size.js").Size} size
 * @property {!Object<string, boolean>} skippedFeatureUids
 * @property {TileQueue} tileQueue
 * @property {Object<string, Object<string, import("./TileRange.js").default>>} usedTiles
 * @property {Array<number>} viewHints
 * @property {!Object<string, Object<string, boolean>>} wantedTiles
 */ /**
 * @typedef {function(PluggableMap, ?FrameState): boolean} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default): boolean} layerFilter Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in pixels. Pixels
 * inside the radius around the given position will be checked for features. This only
 * works for the canvas renderer and not for WebGL.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls]
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions]
 * @property {HTMLElement|Document} keyboardEventTarget
 * @property {Collection<import("./Overlay.js").default>} overlays
 * @property {Object<string, *>} values
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control~defaults} is used.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction~defaults} is used.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {boolean} [loadTilesWhileAnimating=false] When set to `true`, tiles
 * will be loaded during animations. This may improve the user experience, but
 * can also make animations stutter on devices with slow memory.
 * @property {boolean} [loadTilesWhileInteracting=false] When set to `true`,
 * tiles will be loaded while interacting with the map. This may improve the
 * user experience, but can also make map panning and zooming choppy on devices
 * with slow memory.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered.
 * @property {View} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires module:ol/render/Event~RenderEvent#postcompose
 * @fires module:ol/render/Event~RenderEvent#precompose
 * @fires module:ol/render/Event~RenderEvent#rendercomplete
 * @api
 */ var $2f0f58592e3964f7$var$PluggableMap = /*@__PURE__*/ function(BaseObject) {
    function PluggableMap(options) {
        BaseObject.call(this);
        var optionsInternal = $2f0f58592e3964f7$var$createOptionsInternal(options);
        /**
     * @type {number}
     * @private
     */ this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
     * @type {boolean}
     * @private
     */ this.loadTilesWhileAnimating_ = options.loadTilesWhileAnimating !== undefined ? options.loadTilesWhileAnimating : false;
        /**
     * @type {boolean}
     * @private
     */ this.loadTilesWhileInteracting_ = options.loadTilesWhileInteracting !== undefined ? options.loadTilesWhileInteracting : false;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $89969764a1196844$export$6b83a0446fc26f94);
        /**
     * @private
     * @type {number|undefined}
     */ this.animationDelayKey_;
        /**
     * @private
     */ this.animationDelay_ = (function() {
            this.animationDelayKey_ = undefined;
            this.renderFrame_.call(this, Date.now());
        }).bind(this);
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.coordinateToPixelTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.pixelToCoordinateTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {number}
     */ this.frameIndex_ = 0;
        /**
     * @private
     * @type {?FrameState}
     */ this.frameState_ = null;
        /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */ this.previousExtent_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewPropertyListenerKey_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewChangeListenerKey_ = null;
        /**
     * @private
     * @type {Array<import("./events.js").EventsKey>}
     */ this.layerGroupPropertyListenerKeys_ = null;
        /**
     * @private
     * @type {!HTMLElement}
     */ this.viewport_ = document.createElement("div");
        this.viewport_.className = "ol-viewport" + ((0, $89969764a1196844$export$d46bd3ead7cc759b) ? " ol-touch" : "");
        this.viewport_.style.position = "relative";
        this.viewport_.style.overflow = "hidden";
        this.viewport_.style.width = "100%";
        this.viewport_.style.height = "100%";
        // prevent page zoom on IE >= 10 browsers
        this.viewport_.style.msTouchAction = "none";
        this.viewport_.style.touchAction = "none";
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainer_ = document.createElement("div");
        this.overlayContainer_.className = "ol-overlaycontainer";
        this.viewport_.appendChild(this.overlayContainer_);
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainerStopEvent_ = document.createElement("div");
        this.overlayContainerStopEvent_.className = "ol-overlaycontainer-stopevent";
        var overlayEvents = [
            (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLICK,
            (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).DBLCLICK,
            (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).MOUSEDOWN,
            (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).TOUCHSTART,
            (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).MSPOINTERDOWN,
            (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDOWN,
            (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).MOUSEWHEEL,
            (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).WHEEL
        ];
        for(var i = 0, ii = overlayEvents.length; i < ii; ++i)(0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.overlayContainerStopEvent_, overlayEvents[i], (0, $0327f54963b35733$export$51134cce184326b9));
        this.viewport_.appendChild(this.overlayContainerStopEvent_);
        /**
     * @private
     * @type {MapBrowserEventHandler}
     */ this.mapBrowserEventHandler_ = new (0, $ad641aa29114f9e4$export$2e2bcd8739ae039)(this, options.moveTolerance);
        for(var key in 0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039)(0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.mapBrowserEventHandler_, (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039)[key], this.handleMapBrowserEvent, this);
        /**
     * @private
     * @type {HTMLElement|Document}
     */ this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
     * @private
     * @type {Array<import("./events.js").EventsKey>}
     */ this.keyHandlerKeys_ = null;
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.viewport_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CONTEXTMENU, this.handleBrowserEvent, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.viewport_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).WHEEL, this.handleBrowserEvent, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.viewport_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).MOUSEWHEEL, this.handleBrowserEvent, this);
        /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */ this.controls = optionsInternal.controls || new (0, $7be3d63260860659$export$2e2bcd8739ae039)();
        /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */ this.interactions = optionsInternal.interactions || new (0, $7be3d63260860659$export$2e2bcd8739ae039)();
        /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */ this.overlays_ = optionsInternal.overlays;
        /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */ this.overlayIdIndex_ = {};
        /**
     * @type {import("./renderer/Map.js").default}
     * @private
     */ this.renderer_ = this.createRenderer();
        /**
     * @type {function(Event)|undefined}
     * @private
     */ this.handleResize_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate}
     */ this.focus_ = null;
        /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */ this.postRenderFunctions_ = [];
        /**
     * @private
     * @type {TileQueue}
     */ this.tileQueue_ = new (0, $05ff08069bfd30f8$export$2e2bcd8739ae039)(this.getTilePriority.bind(this), this.handleTileChange_.bind(this));
        /**
     * Uids of features to skip at rendering time.
     * @type {Object<string, boolean>}
     * @private
     */ this.skippedFeatureUids_ = {};
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)((0, $25ec5d593032f523$export$2e2bcd8739ae039).LAYERGROUP), this.handleLayerGroupChanged_, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)((0, $25ec5d593032f523$export$2e2bcd8739ae039).VIEW), this.handleViewChanged_, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)((0, $25ec5d593032f523$export$2e2bcd8739ae039).SIZE), this.handleSizeChanged_, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)((0, $25ec5d593032f523$export$2e2bcd8739ae039).TARGET), this.handleTargetChanged_, this);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        this.setProperties(optionsInternal.values);
        this.controls.forEach(/**
       * @param {import("./control/Control.js").default} control Control.
       * @this {PluggableMap}
       */ (function(control) {
            control.setMap(this);
        }).bind(this));
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.controls, (0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
       */ function(event) {
            event.element.setMap(this);
        }, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.controls, (0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
       */ function(event) {
            event.element.setMap(null);
        }, this);
        this.interactions.forEach(/**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       * @this {PluggableMap}
       */ (function(interaction) {
            interaction.setMap(this);
        }).bind(this));
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.interactions, (0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
       */ function(event) {
            event.element.setMap(this);
        }, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.interactions, (0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
       */ function(event) {
            event.element.setMap(null);
        }, this);
        this.overlays_.forEach(this.addOverlayInternal_.bind(this));
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.overlays_, (0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
       */ function(event) {
            this.addOverlayInternal_(/** @type {import("./Overlay.js").default} */ event.element);
        }, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.overlays_, (0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
       */ function(event) {
            var overlay = /** @type {import("./Overlay.js").default} */ event.element;
            var id = overlay.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        }, this);
    }
    if (BaseObject) PluggableMap.__proto__ = BaseObject;
    PluggableMap.prototype = Object.create(BaseObject && BaseObject.prototype);
    PluggableMap.prototype.constructor = PluggableMap;
    /**
   * @abstract
   * @return {import("./renderer/Map.js").default} The map renderer
   */ PluggableMap.prototype.createRenderer = function createRenderer() {
        throw new Error("Use a map type that has a createRenderer method");
    };
    /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */ PluggableMap.prototype.addControl = function addControl(control) {
        this.getControls().push(control);
    };
    /**
   * Add the given interaction to the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */ PluggableMap.prototype.addInteraction = function addInteraction(interaction) {
        this.getInteractions().push(interaction);
    };
    /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */ PluggableMap.prototype.addLayer = function addLayer(layer) {
        var layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    };
    /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */ PluggableMap.prototype.addOverlay = function addOverlay(overlay) {
        this.getOverlays().push(overlay);
    };
    /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */ PluggableMap.prototype.addOverlayInternal_ = function addOverlayInternal_(overlay) {
        var id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    };
    /**
   *
   * @inheritDoc
   */ PluggableMap.prototype.disposeInternal = function disposeInternal() {
        this.mapBrowserEventHandler_.dispose();
        (0, $37a5c0af9052e360$export$35276765542cd163)(this.viewport_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CONTEXTMENU, this.handleBrowserEvent, this);
        (0, $37a5c0af9052e360$export$35276765542cd163)(this.viewport_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).WHEEL, this.handleBrowserEvent, this);
        (0, $37a5c0af9052e360$export$35276765542cd163)(this.viewport_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).MOUSEWHEEL, this.handleBrowserEvent, this);
        if (this.handleResize_ !== undefined) {
            removeEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).RESIZE, this.handleResize_, false);
            this.handleResize_ = undefined;
        }
        if (this.animationDelayKey_) {
            cancelAnimationFrame(this.animationDelayKey_);
            this.animationDelayKey_ = undefined;
        }
        this.setTarget(null);
        BaseObject.prototype.disposeInternal.call(this);
    };
    /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `opt_options`.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(this: S, import("./Feature.js").FeatureLike,
   *     import("./layer/Layer.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature feature} or
   *     {@link module:ol/render/Feature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions=} opt_options Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template S,T
   * @api
   */ PluggableMap.prototype.forEachFeatureAtPixel = function forEachFeatureAtPixel(pixel, callback, opt_options) {
        if (!this.frameState_) return;
        var coordinate = this.getCoordinateFromPixel(pixel);
        opt_options = opt_options !== undefined ? opt_options : /** @type {AtPixelOptions} */ {};
        var hitTolerance = opt_options.hitTolerance !== undefined ? opt_options.hitTolerance * this.frameState_.pixelRatio : 0;
        var layerFilter = opt_options.layerFilter !== undefined ? opt_options.layerFilter : (0, $de1052d9f293b73a$export$22e23a2304399231);
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, callback, null, layerFilter, null);
    };
    /**
   * Get all features that intersect a pixel on the viewport.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions=} opt_options Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * `null` if none were found.
   * @api
   */ PluggableMap.prototype.getFeaturesAtPixel = function getFeaturesAtPixel(pixel, opt_options) {
        var features = null;
        this.forEachFeatureAtPixel(pixel, function(feature) {
            if (!features) features = [];
            features.push(feature);
        }, opt_options);
        return features;
    };
    /**
   * Detect layers that have a color value at a pixel on the viewport, and
   * execute a callback with each matching layer. Layers included in the
   * detection can be configured through `opt_layerFilter`.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(this: S, import("./layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback
   *     Layer callback. This callback will receive two arguments: first is the
   *     {@link module:ol/layer/Layer layer}, second argument is an array representing
   *     [R, G, B, A] pixel values (0 - 255) and will be `null` for layer types
   *     that do not currently support this argument. To stop detection, callback
   *     functions can return a truthy value.
   * @param {AtPixelOptions=} opt_options Configuration options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template S,T
   * @api
   */ PluggableMap.prototype.forEachLayerAtPixel = function forEachLayerAtPixel(pixel, callback, opt_options) {
        if (!this.frameState_) return;
        var options = opt_options || /** @type {AtPixelOptions} */ {};
        var hitTolerance = options.hitTolerance !== undefined ? opt_options.hitTolerance * this.frameState_.pixelRatio : 0;
        var layerFilter = options.layerFilter || (0, $de1052d9f293b73a$export$22e23a2304399231);
        return this.renderer_.forEachLayerAtPixel(pixel, this.frameState_, hitTolerance, callback, null, layerFilter, null);
    };
    /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through `opt_layerFilter`.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions=} opt_options Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @template U
   * @api
   */ PluggableMap.prototype.hasFeatureAtPixel = function hasFeatureAtPixel(pixel, opt_options) {
        if (!this.frameState_) return false;
        var coordinate = this.getCoordinateFromPixel(pixel);
        opt_options = opt_options !== undefined ? opt_options : /** @type {AtPixelOptions} */ {};
        var layerFilter = opt_options.layerFilter !== undefined ? opt_options.layerFilter : (0, $de1052d9f293b73a$export$22e23a2304399231);
        var hitTolerance = opt_options.hitTolerance !== undefined ? opt_options.hitTolerance * this.frameState_.pixelRatio : 0;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, layerFilter, null);
    };
    /**
   * Returns the coordinate in view projection for a browser event.
   * @param {Event} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */ PluggableMap.prototype.getEventCoordinate = function getEventCoordinate(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    };
    /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {Event|TouchEvent} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */ PluggableMap.prototype.getEventPixel = function getEventPixel(event) {
        var viewportPosition = this.viewport_.getBoundingClientRect();
        var eventPosition = "changedTouches" in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            eventPosition.clientX - viewportPosition.left,
            eventPosition.clientY - viewportPosition.top
        ];
    };
    /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */ PluggableMap.prototype.getTarget = function getTarget() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, $25ec5d593032f523$export$2e2bcd8739ae039).TARGET);
    };
    /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */ PluggableMap.prototype.getTargetElement = function getTargetElement() {
        var target = this.getTarget();
        if (target !== undefined) return typeof target === "string" ? document.getElementById(target) : target;
        else return null;
    };
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */ PluggableMap.prototype.getCoordinateFromPixel = function getCoordinateFromPixel(pixel) {
        var frameState = this.frameState_;
        if (!frameState) return null;
        else return (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
    };
    /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */ PluggableMap.prototype.getControls = function getControls() {
        return this.controls;
    };
    /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */ PluggableMap.prototype.getOverlays = function getOverlays() {
        return this.overlays_;
    };
    /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default} Overlay.
   * @api
   */ PluggableMap.prototype.getOverlayById = function getOverlayById(id) {
        var overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    };
    /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */ PluggableMap.prototype.getInteractions = function getInteractions() {
        return this.interactions;
    };
    /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */ PluggableMap.prototype.getLayerGroup = function getLayerGroup() {
        return /** @type {LayerGroup} */ this.get((0, $25ec5d593032f523$export$2e2bcd8739ae039).LAYERGROUP);
    };
    /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */ PluggableMap.prototype.getLayers = function getLayers() {
        var layers = this.getLayerGroup().getLayers();
        return layers;
    };
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */ PluggableMap.prototype.getPixelFromCoordinate = function getPixelFromCoordinate(coordinate) {
        var frameState = this.frameState_;
        if (!frameState) return null;
        else return (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    };
    /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default} Renderer
   */ PluggableMap.prototype.getRenderer = function getRenderer() {
        return this.renderer_;
    };
    /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ PluggableMap.prototype.getSize = function getSize() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, $25ec5d593032f523$export$2e2bcd8739ae039).SIZE);
    };
    /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */ PluggableMap.prototype.getView = function getView() {
        return /** @type {View} */ this.get((0, $25ec5d593032f523$export$2e2bcd8739ae039).VIEW);
    };
    /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */ PluggableMap.prototype.getViewport = function getViewport() {
        return this.viewport_;
    };
    /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */ PluggableMap.prototype.getOverlayContainer = function getOverlayContainer() {
        return this.overlayContainer_;
    };
    /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */ PluggableMap.prototype.getOverlayContainerStopEvent = function getOverlayContainerStopEvent() {
        return this.overlayContainerStopEvent_;
    };
    /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */ PluggableMap.prototype.getTilePriority = function getTilePriority(tile, tileSourceKey, tileCenter, tileResolution) {
        // Filter out tiles at higher zoom levels than the current zoom level, or that
        // are outside the visible extent.
        var frameState = this.frameState_;
        if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $10b2c64d0f765608$export$b4af72c40fd57063;
        if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $10b2c64d0f765608$export$b4af72c40fd57063;
        // Prioritize the highest zoom level tiles closest to the focus.
        // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
        // Within a zoom level, tiles are prioritized by the distance in pixels
        // between the center of the tile and the focus.  The factor of 65536 means
        // that the prioritization should behave as desired for tiles up to
        // 65536 * Math.log(2) = 45426 pixels from the focus.
        var deltaX = tileCenter[0] - frameState.focus[0];
        var deltaY = tileCenter[1] - frameState.focus[1];
        return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
    };
    /**
   * @param {Event} browserEvent Browser event.
   * @param {string=} opt_type Type.
   */ PluggableMap.prototype.handleBrowserEvent = function handleBrowserEvent(browserEvent, opt_type) {
        var type = opt_type || browserEvent.type;
        var mapBrowserEvent = new (0, $f924e5a83a2737ce$export$2e2bcd8739ae039)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    };
    /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */ PluggableMap.prototype.handleMapBrowserEvent = function handleMapBrowserEvent(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        this.focus_ = mapBrowserEvent.coordinate;
        mapBrowserEvent.frameState = this.frameState_;
        var interactionsArray = this.getInteractions().getArray();
        if (this.dispatchEvent(mapBrowserEvent) !== false) for(var i = interactionsArray.length - 1; i >= 0; i--){
            var interaction = interactionsArray[i];
            if (!interaction.getActive()) continue;
            var cont = interaction.handleEvent(mapBrowserEvent);
            if (!cont) break;
        }
    };
    /**
   * @protected
   */ PluggableMap.prototype.handlePostRender = function handlePostRender() {
        var frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        var tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            var maxTotalLoading = this.maxTilesLoading_;
            var maxNewLoads = maxTotalLoading;
            if (frameState) {
                var hints = frameState.viewHints;
                if (hints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING]) {
                    maxTotalLoading = this.loadTilesWhileAnimating_ ? 8 : 0;
                    maxNewLoads = 2;
                }
                if (hints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING]) {
                    maxTotalLoading = this.loadTilesWhileInteracting_ ? 8 : 0;
                    maxNewLoads = 2;
                }
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                tileQueue.reprioritize(); // FIXME only call if view has changed
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.hasListener((0, $847c6e8c21904781$export$2e2bcd8739ae039).RENDERCOMPLETE) && !frameState.animate && !this.tileQueue_.getTilesLoading() && !$2f0f58592e3964f7$var$getLoading(this.getLayers().getArray())) this.renderer_.dispatchRenderEvent((0, $847c6e8c21904781$export$2e2bcd8739ae039).RENDERCOMPLETE, frameState);
        var postRenderFunctions = this.postRenderFunctions_;
        for(var i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    };
    /**
   * @private
   */ PluggableMap.prototype.handleSizeChanged_ = function handleSizeChanged_() {
        this.render();
    };
    /**
   * @private
   */ PluggableMap.prototype.handleTargetChanged_ = function handleTargetChanged_() {
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        var targetElement;
        if (this.getTarget()) targetElement = this.getTargetElement();
        if (this.keyHandlerKeys_) {
            for(var i = 0, ii = this.keyHandlerKeys_.length; i < ii; ++i)(0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.keyHandlerKeys_[i]);
            this.keyHandlerKeys_ = null;
        }
        if (!targetElement) {
            this.renderer_.removeLayerRenderers();
            (0, $755a3001f896bcf1$export$1d0aa160432dfea5)(this.viewport_);
            if (this.handleResize_ !== undefined) {
                removeEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).RESIZE, this.handleResize_, false);
                this.handleResize_ = undefined;
            }
        } else {
            targetElement.appendChild(this.viewport_);
            var keyboardEventTarget = !this.keyboardEventTarget_ ? targetElement : this.keyboardEventTarget_;
            this.keyHandlerKeys_ = [
                (0, $37a5c0af9052e360$export$63174c828edd6ff8)(keyboardEventTarget, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).KEYDOWN, this.handleBrowserEvent, this),
                (0, $37a5c0af9052e360$export$63174c828edd6ff8)(keyboardEventTarget, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).KEYPRESS, this.handleBrowserEvent, this)
            ];
            if (!this.handleResize_) {
                this.handleResize_ = this.updateSize.bind(this);
                window.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).RESIZE, this.handleResize_, false);
            }
        }
        this.updateSize();
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    };
    /**
   * @private
   */ PluggableMap.prototype.handleTileChange_ = function handleTileChange_() {
        this.render();
    };
    /**
   * @private
   */ PluggableMap.prototype.handleViewPropertyChanged_ = function handleViewPropertyChanged_() {
        this.render();
    };
    /**
   * @private
   */ PluggableMap.prototype.handleViewChanged_ = function handleViewChanged_() {
        if (this.viewPropertyListenerKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        var view = this.getView();
        if (view) {
            this.viewport_.setAttribute("data-view", (0, $34772e91e89a736f$export$5e82334337e0f204)(view));
            this.viewPropertyListenerKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(view, (0, $19100aa5be43a728$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(view, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleViewPropertyChanged_, this);
        }
        this.render();
    };
    /**
   * @private
   */ PluggableMap.prototype.handleLayerGroupChanged_ = function handleLayerGroupChanged_() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        var layerGroup = this.getLayerGroup();
        if (layerGroup) this.layerGroupPropertyListenerKeys_ = [
            (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layerGroup, (0, $19100aa5be43a728$export$2e2bcd8739ae039).PROPERTYCHANGE, this.render, this),
            (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layerGroup, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.render, this)
        ];
        this.render();
    };
    /**
   * @return {boolean} Is rendered.
   */ PluggableMap.prototype.isRendered = function isRendered() {
        return !!this.frameState_;
    };
    /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */ PluggableMap.prototype.renderSync = function renderSync() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    };
    /**
   * Request a map rendering (at the next animation frame).
   * @api
   */ PluggableMap.prototype.render = function render() {
        if (this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    };
    /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */ PluggableMap.prototype.removeControl = function removeControl(control) {
        return this.getControls().remove(control);
    };
    /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */ PluggableMap.prototype.removeInteraction = function removeInteraction(interaction) {
        return this.getInteractions().remove(interaction);
    };
    /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */ PluggableMap.prototype.removeLayer = function removeLayer(layer) {
        var layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    };
    /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */ PluggableMap.prototype.removeOverlay = function removeOverlay(overlay) {
        return this.getOverlays().remove(overlay);
    };
    /**
   * @param {number} time Time.
   * @private
   */ PluggableMap.prototype.renderFrame_ = function renderFrame_(time) {
        var viewState;
        var size = this.getSize();
        var view = this.getView();
        var extent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
        var previousFrameState = this.frameState_;
        /** @type {?FrameState} */ var frameState = null;
        if (size !== undefined && (0, $f65ee5b9d8e75975$export$622c471beb1693c7)(size) && view && view.isDef()) {
            var viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            var layerStatesArray = this.getLayerGroup().getLayerStatesArray();
            var layerStates = {};
            for(var i = 0, ii = layerStatesArray.length; i < ii; ++i)layerStates[(0, $34772e91e89a736f$export$5e82334337e0f204)(layerStatesArray[i].layer)] = layerStatesArray[i];
            viewState = view.getState(this.pixelRatio_);
            frameState = /** @type {FrameState} */ {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                extent: extent,
                focus: this.focus_ ? this.focus_ : viewState.center,
                index: this.frameIndex_++,
                layerStates: layerStates,
                layerStatesArray: layerStatesArray,
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                skippedFeatureUids: this.skippedFeatureUids_,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {}
            };
        }
        if (frameState) frameState.extent = (0, $7e819822b33b3d32$export$13ba650faf8308)(viewState.center, viewState.resolution, viewState.rotation, frameState.size, extent);
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                var moveStart = !this.previousExtent_ || !(0, $7e819822b33b3d32$export$dd1bc94b04021eeb)(this.previousExtent_) && !(0, $7e819822b33b3d32$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, $7513f8b91fec7508$export$2e2bcd8739ae039)((0, $392290a16437301e$export$2e2bcd8739ae039).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, $7e819822b33b3d32$export$3e2152b047719fa1)(this.previousExtent_);
                }
            }
            var idle = this.previousExtent_ && !frameState.viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING] && !frameState.viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING] && !(0, $7e819822b33b3d32$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, $7513f8b91fec7508$export$2e2bcd8739ae039)((0, $392290a16437301e$export$2e2bcd8739ae039).MOVEEND, this, frameState));
                (0, $7e819822b33b3d32$export$9cd59f9826255e47)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, $7513f8b91fec7508$export$2e2bcd8739ae039)((0, $392290a16437301e$export$2e2bcd8739ae039).POSTRENDER, this, frameState));
        setTimeout(this.handlePostRender.bind(this), 0);
    };
    /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */ PluggableMap.prototype.setLayerGroup = function setLayerGroup(layerGroup) {
        this.set((0, $25ec5d593032f523$export$2e2bcd8739ae039).LAYERGROUP, layerGroup);
    };
    /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ PluggableMap.prototype.setSize = function setSize(size) {
        this.set((0, $25ec5d593032f523$export$2e2bcd8739ae039).SIZE, size);
    };
    /**
   * Set the target element to render this map into.
   * @param {HTMLElement|string|undefined} target The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */ PluggableMap.prototype.setTarget = function setTarget(target) {
        this.set((0, $25ec5d593032f523$export$2e2bcd8739ae039).TARGET, target);
    };
    /**
   * Set the view for this map.
   * @param {View} view The view that controls this map.
   * @observable
   * @api
   */ PluggableMap.prototype.setView = function setView(view) {
        this.set((0, $25ec5d593032f523$export$2e2bcd8739ae039).VIEW, view);
    };
    /**
   * @param {import("./Feature.js").default} feature Feature.
   */ PluggableMap.prototype.skipFeature = function skipFeature(feature) {
        this.skippedFeatureUids_[(0, $34772e91e89a736f$export$5e82334337e0f204)(feature)] = true;
        this.render();
    };
    /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */ PluggableMap.prototype.updateSize = function updateSize() {
        var targetElement = this.getTargetElement();
        if (!targetElement) this.setSize(undefined);
        else {
            var computedStyle = getComputedStyle(targetElement);
            this.setSize([
                targetElement.offsetWidth - parseFloat(computedStyle["borderLeftWidth"]) - parseFloat(computedStyle["paddingLeft"]) - parseFloat(computedStyle["paddingRight"]) - parseFloat(computedStyle["borderRightWidth"]),
                targetElement.offsetHeight - parseFloat(computedStyle["borderTopWidth"]) - parseFloat(computedStyle["paddingTop"]) - parseFloat(computedStyle["paddingBottom"]) - parseFloat(computedStyle["borderBottomWidth"])
            ]);
        }
    };
    /**
   * @param {import("./Feature.js").default} feature Feature.
   */ PluggableMap.prototype.unskipFeature = function unskipFeature(feature) {
        delete this.skippedFeatureUids_[(0, $34772e91e89a736f$export$5e82334337e0f204)(feature)];
        this.render();
    };
    return PluggableMap;
}((0, $d575b598d09f57d3$export$2e2bcd8739ae039));
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $2f0f58592e3964f7$var$createOptionsInternal(options) {
    /**
   * @type {HTMLElement|Document}
   */ var keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === "string" ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
   * @type {Object<string, *>}
   */ var values = {};
    var layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === "function" ? /** @type {LayerGroup} */ options.layers : new (0, $96e8168163e6fc58$export$2e2bcd8739ae039)({
        layers: /** @type {Collection} */ options.layers
    });
    values[(0, $25ec5d593032f523$export$2e2bcd8739ae039).LAYERGROUP] = layerGroup;
    values[(0, $25ec5d593032f523$export$2e2bcd8739ae039).TARGET] = options.target;
    values[(0, $25ec5d593032f523$export$2e2bcd8739ae039).VIEW] = options.view !== undefined ? options.view : new (0, $3192ea72f934a3fd$export$2e2bcd8739ae039)();
    var controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $7be3d63260860659$export$2e2bcd8739ae039)(options.controls.slice());
        else {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof /** @type {?} */ options.controls.getArray === "function", 47); // Expected `controls` to be an array or an `import("./Collection.js").Collection`
            controls = /** @type {Collection} */ options.controls;
        }
    }
    var interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $7be3d63260860659$export$2e2bcd8739ae039)(options.interactions.slice());
        else {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof /** @type {?} */ options.interactions.getArray === "function", 48); // Expected `interactions` to be an array or an `import("./Collection.js").Collection`
            interactions = /** @type {Collection} */ options.interactions;
        }
    }
    var overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $7be3d63260860659$export$2e2bcd8739ae039)(options.overlays.slice());
        else {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof /** @type {?} */ options.overlays.getArray === "function", 49); // Expected `overlays` to be an array or an `import("./Collection.js").Collection`
            overlays = options.overlays;
        }
    } else overlays = new (0, $7be3d63260860659$export$2e2bcd8739ae039)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $2f0f58592e3964f7$export$2e2bcd8739ae039 = $2f0f58592e3964f7$var$PluggableMap;
/**
 * @param  {Array<import("./layer/Base.js").default>} layers Layers.
 * @return {boolean} Layers have sources that are still loading.
 */ function $2f0f58592e3964f7$var$getLoading(layers) {
    for(var i = 0, ii = layers.length; i < ii; ++i){
        var layer = layers[i];
        if (typeof /** @type {?} */ layer.getLayers === "function") return $2f0f58592e3964f7$var$getLoading(/** @type {LayerGroup} */ layer.getLayers().getArray());
        else {
            var source = /** @type {import("./layer/Layer.js").default} */ layer.getSource();
            if (source && source.loading) return true;
        }
    }
    return false;
}


/**
 * @module ol/control/util
 */ 
/**
 * @module ol/control/Attribution
 */ 
/**
 * @module ol/control/Control
 */ 




/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default)} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * var myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ var $ef003b45d4724b43$var$Control = /*@__PURE__*/ function(BaseObject) {
    function Control(options) {
        BaseObject.call(this);
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = options.element ? options.element : null;
        /**
     * @private
     * @type {HTMLElement}
     */ this.target_ = null;
        /**
     * @private
     * @type {import("../PluggableMap.js").default}
     */ this.map_ = null;
        /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */ this.listenerKeys = [];
        /**
     * @type {function(import("../MapEvent.js").default)}
     */ this.render = options.render ? options.render : (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8);
        if (options.target) this.setTarget(options.target);
    }
    if (BaseObject) Control.__proto__ = BaseObject;
    Control.prototype = Object.create(BaseObject && BaseObject.prototype);
    Control.prototype.constructor = Control;
    /**
   * @inheritDoc
   */ Control.prototype.disposeInternal = function disposeInternal() {
        (0, $755a3001f896bcf1$export$1d0aa160432dfea5)(this.element);
        BaseObject.prototype.disposeInternal.call(this);
    };
    /**
   * Get the map associated with this control.
   * @return {import("../PluggableMap.js").default} Map.
   * @api
   */ Control.prototype.getMap = function getMap() {
        return this.map_;
    };
    /**
   * Remove the control from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default} map Map.
   * @api
   */ Control.prototype.setMap = function setMap(map) {
        if (this.map_) (0, $755a3001f896bcf1$export$1d0aa160432dfea5)(this.element);
        for(var i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (this.map_) {
            var target = this.target_ ? this.target_ : map.getOverlayContainerStopEvent();
            target.appendChild(this.element);
            if (this.render !== (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8)) this.listenerKeys.push((0, $37a5c0af9052e360$export$63174c828edd6ff8)(map, (0, $392290a16437301e$export$2e2bcd8739ae039).POSTRENDER, this.render, this));
            map.render();
        }
    };
    /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */ Control.prototype.setTarget = function setTarget(target) {
        this.target_ = typeof target === "string" ? document.getElementById(target) : target;
    };
    return Control;
}((0, $d575b598d09f57d3$export$2e2bcd8739ae039));
var $ef003b45d4724b43$export$2e2bcd8739ae039 = $ef003b45d4724b43$var$Control;


/**
 * @module ol/css
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ var $bbcb4c1977b6e9f0$export$981241db82723ce2 = "ol-hidden";
var $bbcb4c1977b6e9f0$export$99b49471b0394319 = "ol-selectable";
var $bbcb4c1977b6e9f0$export$1afde3d6e16a7b29 = "ol-unselectable";
var $bbcb4c1977b6e9f0$export$68eede0dd8c6c1da = "ol-unsupported";
var $bbcb4c1977b6e9f0$export$4d4f8be70b656192 = "ol-control";
var $bbcb4c1977b6e9f0$export$e16017ac68d14492 = "ol-collapsed";
var $bbcb4c1977b6e9f0$export$93b0d97b0a4b6bf5 = function() {
    var style;
    var cache = {};
    return function(font) {
        if (!style) style = document.createElement("div").style;
        if (!(font in cache)) {
            style.font = font;
            var family = style.fontFamily;
            style.font = "";
            if (!family) return null;
            cache[font] = family.split(/,\s?/);
        }
        return cache[font];
    };
}();





/**
 * @module ol/layer/Layer
 */ 








/**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {import("../source/Source.js").default} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../PluggableMap.js").default} [map] Map.
 */ /**
 * @typedef {Object} State
 * @property {import("./Base.js").default} layer
 * @property {number} opacity
 * @property {SourceState} sourceState
 * @property {boolean} visible
 * @property {boolean} managed
 * @property {import("../extent.js").Extent} [extent]
 * @property {number} zIndex
 * @property {number} maxResolution
 * @property {number} minResolution
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with {@link module:ol/Map#addLayer}. Components
 * like {@link module:ol/interaction/Select~Select} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * {@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 *
 * @fires import("../render/Event.js").RenderEvent
 */ var $575253350abb8238$var$Layer = /*@__PURE__*/ function(BaseLayer) {
    function Layer(options) {
        var baseOptions = (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({}, options);
        delete baseOptions.source;
        BaseLayer.call(this, baseOptions);
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapPrecomposeKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapRenderKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceChangeKey_ = null;
        if (options.map) this.setMap(options.map);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).SOURCE), this.handleSourcePropertyChange_, this);
        var source = options.source ? options.source : null;
        this.setSource(source);
    }
    if (BaseLayer) Layer.__proto__ = BaseLayer;
    Layer.prototype = Object.create(BaseLayer && BaseLayer.prototype);
    Layer.prototype.constructor = Layer;
    /**
   * @inheritDoc
   */ Layer.prototype.getLayersArray = function getLayersArray(opt_array) {
        var array = opt_array ? opt_array : [];
        array.push(this);
        return array;
    };
    /**
   * @inheritDoc
   */ Layer.prototype.getLayerStatesArray = function getLayerStatesArray(opt_states) {
        var states = opt_states ? opt_states : [];
        states.push(this.getLayerState());
        return states;
    };
    /**
   * Get the layer source.
   * @return {import("../source/Source.js").default} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */ Layer.prototype.getSource = function getSource() {
        var source = this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).SOURCE);
        return /** @type {import("../source/Source.js").default} */ source || null;
    };
    /**
    * @inheritDoc
    */ Layer.prototype.getSourceState = function getSourceState() {
        var source = this.getSource();
        return !source ? (0, $7c2f117cb5c1ce12$export$2e2bcd8739ae039).UNDEFINED : source.getState();
    };
    /**
   * @private
   */ Layer.prototype.handleSourceChange_ = function handleSourceChange_() {
        this.changed();
    };
    /**
   * @private
   */ Layer.prototype.handleSourcePropertyChange_ = function handleSourcePropertyChange_() {
        if (this.sourceChangeKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        var source = this.getSource();
        if (source) this.sourceChangeKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(source, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleSourceChange_, this);
        this.changed();
    };
    /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection, and the callback in
   * {@link module:ol/Map#forEachLayerAtPixel} will receive `null` as layer. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map#addLayer} instead.
   * @param {import("../PluggableMap.js").default} map Map.
   * @api
   */ Layer.prototype.setMap = function setMap(map) {
        if (this.mapPrecomposeKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(map, (0, $847c6e8c21904781$export$2e2bcd8739ae039).PRECOMPOSE, function(evt) {
                var renderEvent = /** @type {import("../render/Event.js").default} */ evt;
                var layerState = this.getLayerState();
                layerState.managed = false;
                if (this.getZIndex() === undefined) layerState.zIndex = Infinity;
                renderEvent.frameState.layerStatesArray.push(layerState);
                renderEvent.frameState.layerStates[(0, $34772e91e89a736f$export$5e82334337e0f204)(this)] = layerState;
            }, this);
            this.mapRenderKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, map.render, map);
            this.changed();
        }
    };
    /**
   * Set the layer source.
   * @param {import("../source/Source.js").default} source The layer source.
   * @observable
   * @api
   */ Layer.prototype.setSource = function setSource(source) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).SOURCE, source);
    };
    return Layer;
}((0, $462b2201ee49de24$export$2e2bcd8739ae039));
function $575253350abb8238$export$791774a6af20d8cc(layerState, resolution) {
    return layerState.visible && resolution >= layerState.minResolution && resolution < layerState.maxResolution;
}
var $575253350abb8238$export$2e2bcd8739ae039 = $575253350abb8238$var$Layer;


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [collapseLabel='»'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {function(import("../MapEvent.js").default)} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ var $b571c0ea2d2b497f$var$Attribution = /*@__PURE__*/ function(Control) {
    function Attribution(opt_options) {
        var options = opt_options ? opt_options : {};
        Control.call(this, {
            element: document.createElement("div"),
            render: options.render || $b571c0ea2d2b497f$export$b3890eb0ae9dca99,
            target: options.target
        });
        /**
     * @private
     * @type {HTMLElement}
     */ this.ulElement_ = document.createElement("ul");
        /**
     * @private
     * @type {boolean}
     */ this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
     * @private
     * @type {boolean}
     */ this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!this.collapsible_) this.collapsed_ = false;
        var className = options.className !== undefined ? options.className : "ol-attribution";
        var tipLabel = options.tipLabel !== undefined ? options.tipLabel : "Attributions";
        var collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : "\xbb";
        if (typeof collapseLabel === "string") {
            /**
       * @private
       * @type {HTMLElement}
       */ this.collapseLabel_ = document.createElement("span");
            this.collapseLabel_.textContent = collapseLabel;
        } else this.collapseLabel_ = collapseLabel;
        var label = options.label !== undefined ? options.label : "i";
        if (typeof label === "string") {
            /**
       * @private
       * @type {HTMLElement}
       */ this.label_ = document.createElement("span");
            this.label_.textContent = label;
        } else this.label_ = label;
        var activeLabel = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
        var button = document.createElement("button");
        button.setAttribute("type", "button");
        button.title = tipLabel;
        button.appendChild(activeLabel);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(button, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLICK, this.handleClick_, this);
        var cssClasses = className + " " + (0, $bbcb4c1977b6e9f0$export$1afde3d6e16a7b29) + " " + (0, $bbcb4c1977b6e9f0$export$4d4f8be70b656192) + (this.collapsed_ && this.collapsible_ ? " " + (0, $bbcb4c1977b6e9f0$export$e16017ac68d14492) : "") + (this.collapsible_ ? "" : " ol-uncollapsible");
        var element = this.element;
        element.className = cssClasses;
        element.appendChild(this.ulElement_);
        element.appendChild(button);
        /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */ this.renderedAttributions_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    if (Control) Attribution.__proto__ = Control;
    Attribution.prototype = Object.create(Control && Control.prototype);
    Attribution.prototype.constructor = Attribution;
    /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */ Attribution.prototype.collectSourceAttributions_ = function collectSourceAttributions_(frameState) {
        /**
     * Used to determine if an attribution already exists.
     * @type {!Object<string, boolean>}
     */ var lookup = {};
        /**
     * A list of visible attributions.
     * @type {Array<string>}
     */ var visibleAttributions = [];
        var layerStatesArray = frameState.layerStatesArray;
        var resolution = frameState.viewState.resolution;
        for(var i = 0, ii = layerStatesArray.length; i < ii; ++i){
            var layerState = layerStatesArray[i];
            if (!(0, $575253350abb8238$export$791774a6af20d8cc)(layerState, resolution)) continue;
            var source = /** @type {import("../layer/Layer.js").default} */ layerState.layer.getSource();
            if (!source) continue;
            var attributionGetter = source.getAttributions();
            if (!attributionGetter) continue;
            var attributions = attributionGetter(frameState);
            if (!attributions) continue;
            if (!this.overrideCollapsible_ && source.getAttributionsCollapsible() === false) this.setCollapsible(false);
            if (Array.isArray(attributions)) {
                for(var j = 0, jj = attributions.length; j < jj; ++j)if (!(attributions[j] in lookup)) {
                    visibleAttributions.push(attributions[j]);
                    lookup[attributions[j]] = true;
                }
            } else if (!(attributions in lookup)) {
                visibleAttributions.push(attributions);
                lookup[attributions] = true;
            }
        }
        return visibleAttributions;
    };
    /**
   * @private
   * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
   */ Attribution.prototype.updateElement_ = function updateElement_(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = "none";
                this.renderedVisible_ = false;
            }
            return;
        }
        var attributions = this.collectSourceAttributions_(frameState);
        var visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? "" : "none";
            this.renderedVisible_ = visible;
        }
        if ((0, $830d23b8323fc080$export$e9bab7fafb253603)(attributions, this.renderedAttributions_)) return;
        (0, $755a3001f896bcf1$export$1e1c9bf5a4ffe0d1)(this.ulElement_);
        // append the attributions
        for(var i = 0, ii = attributions.length; i < ii; ++i){
            var element = document.createElement("li");
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    };
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ Attribution.prototype.handleClick_ = function handleClick_(event) {
        event.preventDefault();
        this.handleToggle_();
    };
    /**
   * @private
   */ Attribution.prototype.handleToggle_ = function handleToggle_() {
        this.element.classList.toggle((0, $bbcb4c1977b6e9f0$export$e16017ac68d14492));
        if (this.collapsed_) (0, $755a3001f896bcf1$export$5542201de9311ab2)(this.collapseLabel_, this.label_);
        else (0, $755a3001f896bcf1$export$5542201de9311ab2)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
    };
    /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ Attribution.prototype.getCollapsible = function getCollapsible() {
        return this.collapsible_;
    };
    /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ Attribution.prototype.setCollapsible = function setCollapsible(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle("ol-uncollapsible");
        if (!collapsible && this.collapsed_) this.handleToggle_();
    };
    /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ Attribution.prototype.setCollapsed = function setCollapsed(collapsed) {
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    };
    /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */ Attribution.prototype.getCollapsed = function getCollapsed() {
        return this.collapsed_;
    };
    return Attribution;
}((0, $ef003b45d4724b43$export$2e2bcd8739ae039));
function $b571c0ea2d2b497f$export$b3890eb0ae9dca99(mapEvent) {
    this.updateElement_(mapEvent.frameState);
}
var $b571c0ea2d2b497f$export$2e2bcd8739ae039 = $b571c0ea2d2b497f$var$Attribution;


/**
 * @module ol/control/Rotate
 */ 




/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default)} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function()} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ var $2fed84634fb1aa03$var$Rotate = /*@__PURE__*/ function(Control) {
    function Rotate(opt_options) {
        var options = opt_options ? opt_options : {};
        Control.call(this, {
            element: document.createElement("div"),
            render: options.render || $2fed84634fb1aa03$export$b3890eb0ae9dca99,
            target: options.target
        });
        var className = options.className !== undefined ? options.className : "ol-rotate";
        var label = options.label !== undefined ? options.label : "\u21E7";
        /**
     * @type {HTMLElement}
     * @private
     */ this.label_ = null;
        if (typeof label === "string") {
            this.label_ = document.createElement("span");
            this.label_.className = "ol-compass";
            this.label_.textContent = label;
        } else {
            this.label_ = label;
            this.label_.classList.add("ol-compass");
        }
        var tipLabel = options.tipLabel ? options.tipLabel : "Reset rotation";
        var button = document.createElement("button");
        button.className = className + "-reset";
        button.setAttribute("type", "button");
        button.title = tipLabel;
        button.appendChild(this.label_);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(button, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLICK, this.handleClick_, this);
        var cssClasses = className + " " + (0, $bbcb4c1977b6e9f0$export$1afde3d6e16a7b29) + " " + (0, $bbcb4c1977b6e9f0$export$4d4f8be70b656192);
        var element = this.element;
        element.className = cssClasses;
        element.appendChild(button);
        this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @type {boolean}
     * @private
     */ this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        if (this.autoHide_) this.element.classList.add((0, $bbcb4c1977b6e9f0$export$981241db82723ce2));
    }
    if (Control) Rotate.__proto__ = Control;
    Rotate.prototype = Object.create(Control && Control.prototype);
    Rotate.prototype.constructor = Rotate;
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ Rotate.prototype.handleClick_ = function handleClick_(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    };
    /**
   * @private
   */ Rotate.prototype.resetNorth_ = function resetNorth_() {
        var map = this.getMap();
        var view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        if (view.getRotation() !== undefined) {
            if (this.duration_ > 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0)
            });
            else view.setRotation(0);
        }
    };
    return Rotate;
}((0, $ef003b45d4724b43$export$2e2bcd8739ae039));
function $2fed84634fb1aa03$export$b3890eb0ae9dca99(mapEvent) {
    var frameState = mapEvent.frameState;
    if (!frameState) return;
    var rotation = frameState.viewState.rotation;
    if (rotation != this.rotation_) {
        var transform = "rotate(" + rotation + "rad)";
        if (this.autoHide_) {
            var contains = this.element.classList.contains((0, $bbcb4c1977b6e9f0$export$981241db82723ce2));
            if (!contains && rotation === 0) this.element.classList.add((0, $bbcb4c1977b6e9f0$export$981241db82723ce2));
            else if (contains && rotation !== 0) this.element.classList.remove((0, $bbcb4c1977b6e9f0$export$981241db82723ce2));
        }
        this.label_.style.msTransform = transform;
        this.label_.style.webkitTransform = transform;
        this.label_.style.transform = transform;
    }
    this.rotation_ = rotation;
}
var $2fed84634fb1aa03$export$2e2bcd8739ae039 = $2fed84634fb1aa03$var$Rotate;


/**
 * @module ol/control/Zoom
 */ 




/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='-'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ var $176f524e524aadb7$var$Zoom = /*@__PURE__*/ function(Control) {
    function Zoom(opt_options) {
        var options = opt_options ? opt_options : {};
        Control.call(this, {
            element: document.createElement("div"),
            target: options.target
        });
        var className = options.className !== undefined ? options.className : "ol-zoom";
        var delta = options.delta !== undefined ? options.delta : 1;
        var zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : "+";
        var zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : "\u2212";
        var zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : "Zoom in";
        var zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : "Zoom out";
        var inElement = document.createElement("button");
        inElement.className = className + "-in";
        inElement.setAttribute("type", "button");
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === "string" ? document.createTextNode(zoomInLabel) : zoomInLabel);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(inElement, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, delta));
        var outElement = document.createElement("button");
        outElement.className = className + "-out";
        outElement.setAttribute("type", "button");
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === "string" ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(outElement, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, -delta));
        var cssClasses = className + " " + (0, $bbcb4c1977b6e9f0$export$1afde3d6e16a7b29) + " " + (0, $bbcb4c1977b6e9f0$export$4d4f8be70b656192);
        var element = this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    if (Control) Zoom.__proto__ = Control;
    Zoom.prototype = Object.create(Control && Control.prototype);
    Zoom.prototype.constructor = Zoom;
    /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */ Zoom.prototype.handleClick_ = function handleClick_(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    };
    /**
   * @param {number} delta Zoom delta.
   * @private
   */ Zoom.prototype.zoomByDelta_ = function zoomByDelta_(delta) {
        var map = this.getMap();
        var view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        var currentResolution = view.getResolution();
        if (currentResolution) {
            var newResolution = view.constrainResolution(currentResolution, delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    resolution: newResolution,
                    duration: this.duration_,
                    easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0)
                });
            } else view.setResolution(newResolution);
        }
    };
    return Zoom;
}((0, $ef003b45d4724b43$export$2e2bcd8739ae039));
var $176f524e524aadb7$export$2e2bcd8739ae039 = $176f524e524aadb7$var$Zoom;


function $1c5b03a65fa2f53c$export$ebe90cb607ad99e(opt_options) {
    var options = opt_options ? opt_options : {};
    var controls = new (0, $7be3d63260860659$export$2e2bcd8739ae039)();
    var zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $176f524e524aadb7$export$2e2bcd8739ae039)(options.zoomOptions));
    var rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $2fed84634fb1aa03$export$2e2bcd8739ae039)(options.rotateOptions));
    var attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $b571c0ea2d2b497f$export$2e2bcd8739ae039)(options.attributionOptions));
    return controls;
}


/**
 * @module ol/interaction
 */ 
/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ var $477a0a09e8e7589b$var$Kinetic = function Kinetic(decay, minVelocity, delay) {
    /**
   * @private
   * @type {number}
   */ this.decay_ = decay;
    /**
   * @private
   * @type {number}
   */ this.minVelocity_ = minVelocity;
    /**
   * @private
   * @type {number}
   */ this.delay_ = delay;
    /**
   * @private
   * @type {Array<number>}
   */ this.points_ = [];
    /**
   * @private
   * @type {number}
   */ this.angle_ = 0;
    /**
   * @private
   * @type {number}
   */ this.initialVelocity_ = 0;
};
/**
 * FIXME empty description for jsdoc
 */ $477a0a09e8e7589b$var$Kinetic.prototype.begin = function begin() {
    this.points_.length = 0;
    this.angle_ = 0;
    this.initialVelocity_ = 0;
};
/**
 * @param {number} x X.
 * @param {number} y Y.
 */ $477a0a09e8e7589b$var$Kinetic.prototype.update = function update(x, y) {
    this.points_.push(x, y, Date.now());
};
/**
 * @return {boolean} Whether we should do kinetic animation.
 */ $477a0a09e8e7589b$var$Kinetic.prototype.end = function end() {
    if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
    // in the array)
    return false;
    var delay = Date.now() - this.delay_;
    var lastIndex = this.points_.length - 3;
    if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
    // panning before releasing the map
    return false;
    // get the first point which still falls into the delay time
    var firstIndex = lastIndex - 3;
    while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
    var duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
    // we don't want a duration of 0 (divide by zero)
    // we also make sure the user panned for a duration of at least one frame
    // (1/60s) to compute sane displacement values
    if (duration < 1000 / 60) return false;
    var dx = this.points_[lastIndex] - this.points_[firstIndex];
    var dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
    this.angle_ = Math.atan2(dy, dx);
    this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
    return this.initialVelocity_ > this.minVelocity_;
};
/**
 * @return {number} Total distance travelled (pixels).
 */ $477a0a09e8e7589b$var$Kinetic.prototype.getDistance = function getDistance() {
    return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
};
/**
 * @return {number} Angle of the kinetic panning animation (radians).
 */ $477a0a09e8e7589b$var$Kinetic.prototype.getAngle = function getAngle() {
    return this.angle_;
};
var $477a0a09e8e7589b$export$2e2bcd8739ae039 = $477a0a09e8e7589b$var$Kinetic;


/**
 * @module ol/interaction/DoubleClickZoom
 */ 
/**
 * @module ol/interaction/Interaction
 */ 

/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $066074cf84cc0514$export$2e2bcd8739ae039 = {
    ACTIVE: "active"
};



/**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} handleEvent
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return).
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ var $36e1c4dbb62d535d$var$Interaction = /*@__PURE__*/ function(BaseObject) {
    function Interaction(options) {
        BaseObject.call(this);
        if (options.handleEvent) this.handleEvent = options.handleEvent;
        /**
     * @private
     * @type {import("../PluggableMap.js").default}
     */ this.map_ = null;
        this.setActive(true);
    }
    if (BaseObject) Interaction.__proto__ = BaseObject;
    Interaction.prototype = Object.create(BaseObject && BaseObject.prototype);
    Interaction.prototype.constructor = Interaction;
    /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */ Interaction.prototype.getActive = function getActive() {
        return /** @type {boolean} */ this.get((0, $066074cf84cc0514$export$2e2bcd8739ae039).ACTIVE);
    };
    /**
   * Get the map associated with this interaction.
   * @return {import("../PluggableMap.js").default} Map.
   * @api
   */ Interaction.prototype.getMap = function getMap() {
        return this.map_;
    };
    /**
   * Handles the {@link module:ol/MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ Interaction.prototype.handleEvent = function handleEvent(mapBrowserEvent) {
        return true;
    };
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ Interaction.prototype.setActive = function setActive(active) {
        this.set((0, $066074cf84cc0514$export$2e2bcd8739ae039).ACTIVE, active);
    };
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default} map Map.
   */ Interaction.prototype.setMap = function setMap(map) {
        this.map_ = map;
    };
    return Interaction;
}((0, $d575b598d09f57d3$export$2e2bcd8739ae039));
function $36e1c4dbb62d535d$export$4c486572e961a974(view, delta, opt_duration) {
    var currentCenter = view.getCenter();
    if (currentCenter) {
        var center = view.constrainCenter([
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ]);
        if (opt_duration) view.animate({
            duration: opt_duration,
            easing: (0, $0164a93fcf6e65ad$export$45db2fc2f15997e7),
            center: center
        });
        else view.setCenter(center);
    }
}
function $36e1c4dbb62d535d$export$bb628a54ab399bc9(view, rotation, opt_anchor, opt_duration) {
    rotation = view.constrainRotation(rotation, 0);
    $36e1c4dbb62d535d$export$c734e19e4e5b6a43(view, rotation, opt_anchor, opt_duration);
}
function $36e1c4dbb62d535d$export$c734e19e4e5b6a43(view, rotation, opt_anchor, opt_duration) {
    if (rotation !== undefined) {
        var currentRotation = view.getRotation();
        var currentCenter = view.getCenter();
        if (currentRotation !== undefined && currentCenter && opt_duration > 0) view.animate({
            rotation: rotation,
            anchor: opt_anchor,
            duration: opt_duration,
            easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0)
        });
        else view.rotate(rotation, opt_anchor);
    }
}
function $36e1c4dbb62d535d$export$e83f174dbf56adcc(view, resolution, opt_anchor, opt_duration, opt_direction) {
    resolution = view.constrainResolution(resolution, 0, opt_direction);
    $36e1c4dbb62d535d$export$f5e0922d80e7a081(view, resolution, opt_anchor, opt_duration);
}
function $36e1c4dbb62d535d$export$ace321ff2a8016ef(view, delta, opt_anchor, opt_duration) {
    var currentResolution = view.getResolution();
    var resolution = view.constrainResolution(currentResolution, delta, 0);
    if (resolution !== undefined) {
        var resolutions = view.getResolutions();
        resolution = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(resolution, view.getMinResolution() || resolutions[resolutions.length - 1], view.getMaxResolution() || resolutions[0]);
    }
    // If we have a constraint on center, we need to change the anchor so that the
    // new center is within the extent. We first calculate the new center, apply
    // the constraint to it, and then calculate back the anchor
    if (opt_anchor && resolution !== undefined && resolution !== currentResolution) {
        var currentCenter = view.getCenter();
        var center = view.calculateCenterZoom(resolution, opt_anchor);
        center = view.constrainCenter(center);
        opt_anchor = [
            (resolution * currentCenter[0] - currentResolution * center[0]) / (resolution - currentResolution),
            (resolution * currentCenter[1] - currentResolution * center[1]) / (resolution - currentResolution)
        ];
    }
    $36e1c4dbb62d535d$export$f5e0922d80e7a081(view, resolution, opt_anchor, opt_duration);
}
function $36e1c4dbb62d535d$export$f5e0922d80e7a081(view, resolution, opt_anchor, opt_duration) {
    if (resolution) {
        var currentResolution = view.getResolution();
        var currentCenter = view.getCenter();
        if (currentResolution !== undefined && currentCenter && resolution !== currentResolution && opt_duration) view.animate({
            resolution: resolution,
            anchor: opt_anchor,
            duration: opt_duration,
            easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0)
        });
        else {
            if (opt_anchor) {
                var center = view.calculateCenterZoom(resolution, opt_anchor);
                view.setCenter(center);
            }
            view.setResolution(resolution);
        }
    }
}
var $36e1c4dbb62d535d$export$2e2bcd8739ae039 = $36e1c4dbb62d535d$var$Interaction;


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ var $6922361fb812290c$var$DoubleClickZoom = /*@__PURE__*/ function(Interaction) {
    function DoubleClickZoom(opt_options) {
        Interaction.call(this, {
            handleEvent: $6922361fb812290c$var$handleEvent
        });
        var options = opt_options ? opt_options : {};
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    if (Interaction) DoubleClickZoom.__proto__ = Interaction;
    DoubleClickZoom.prototype = Object.create(Interaction && Interaction.prototype);
    DoubleClickZoom.prototype.constructor = DoubleClickZoom;
    return DoubleClickZoom;
}((0, $36e1c4dbb62d535d$export$2e2bcd8739ae039));
/**
 * Handles the {@link module:ol/MapBrowserEvent map browser event} (if it was a
 * doubleclick) and eventually zooms the map.
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} `false` to stop event propagation.
 * @this {DoubleClickZoom}
 */ function $6922361fb812290c$var$handleEvent(mapBrowserEvent) {
    var stopEvent = false;
    if (mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).DBLCLICK) {
        var browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
        var map = mapBrowserEvent.map;
        var anchor = mapBrowserEvent.coordinate;
        var delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
        var view = map.getView();
        (0, $36e1c4dbb62d535d$export$ace321ff2a8016ef)(view, delta, anchor, this.duration_);
        mapBrowserEvent.preventDefault();
        stopEvent = true;
    }
    return !stopEvent;
}
var $6922361fb812290c$export$2e2bcd8739ae039 = $6922361fb812290c$var$DoubleClickZoom;


/**
 * @module ol/interaction/DragPan
 */ 


/**
 * @module ol/events/condition
 */ 



var $2083adc1400fd9db$export$573409992e89967e = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
var $2083adc1400fd9db$export$4e5f01653f9f1f82 = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
var $2083adc1400fd9db$export$d7ddd398f22d79ef = function(event) {
    return event.target.getTargetElement() === document.activeElement;
};
var $2083adc1400fd9db$export$ba9e5d519bc326ca = (0, $de1052d9f293b73a$export$22e23a2304399231);
var $2083adc1400fd9db$export$64ef1bee2b9504c1 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).CLICK;
};
var $2083adc1400fd9db$export$1238ad6b5e7fff70 = function(mapBrowserEvent) {
    var originalEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.button == 0 && !((0, $89969764a1196844$export$39dfd62a25e0fe93) && (0, $89969764a1196844$export$76c0a3b101d93136) && originalEvent.ctrlKey);
};
var $2083adc1400fd9db$export$b3e22bcfd64c1022 = (0, $de1052d9f293b73a$export$8f11cee4bdc7e668);
var $2083adc1400fd9db$export$71eac0963f2c2f01 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == "pointermove";
};
var $2083adc1400fd9db$export$194df8bad091b401 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).SINGLECLICK;
};
var $2083adc1400fd9db$export$c59d944dd10b3dc7 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).DBLCLICK;
};
var $2083adc1400fd9db$export$fdc892d0d8fe3bfb = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
var $2083adc1400fd9db$export$f3100d8d6292d638 = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $89969764a1196844$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
var $2083adc1400fd9db$export$5d31fe68a477cfbb = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
var $2083adc1400fd9db$export$e5570ca80cd8fd54 = function(mapBrowserEvent) {
    var target = mapBrowserEvent.originalEvent.target;
    var tagName = /** @type {Element} */ target.tagName;
    return tagName !== "INPUT" && tagName !== "SELECT" && tagName !== "TEXTAREA";
};
var $2083adc1400fd9db$export$abb7acbfa76bf3c4 = function(mapBrowserEvent) {
    var pointerEvent = /** @type {import("../MapBrowserPointerEvent").default} */ mapBrowserEvent.pointerEvent;
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)(pointerEvent !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    // see http://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvent.pointerType == "mouse";
};
var $2083adc1400fd9db$export$189f0d593022b199 = function(mapBrowserEvent) {
    var pointerEvent = /** @type {import("../MapBrowserPointerEvent").default} */ mapBrowserEvent.pointerEvent;
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)(pointerEvent !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    return pointerEvent.isPrimary && pointerEvent.button === 0;
};



/**
 * @module ol/interaction/Pointer
 */ 


/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserPointerEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserPointerEvent.js").default)} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserPointerEvent.js").default)} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events,
 * also during a drag sequence (so during a drag sequence both the
 * `handleDragEvent` function and this function are called).
 * @property {function(import("../MapBrowserPointerEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ var $f4f64f356a570c0e$var$PointerInteraction = /*@__PURE__*/ function(Interaction) {
    function PointerInteraction(opt_options) {
        var options = opt_options ? opt_options : {};
        Interaction.call(/** @type {import("./Interaction.js").InteractionOptions} */ this, options);
        if (options.handleDownEvent) this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) this.stopDown = options.stopDown;
        /**
     * @type {boolean}
     * @protected
     */ this.handlingDownUpSequence = false;
        /**
     * @type {!Object<string, import("../pointer/PointerEvent.js").default>}
     * @private
     */ this.trackedPointers_ = {};
        /**
     * @type {Array<import("../pointer/PointerEvent.js").default>}
     * @protected
     */ this.targetPointers = [];
    }
    if (Interaction) PointerInteraction.__proto__ = Interaction;
    PointerInteraction.prototype = Object.create(Interaction && Interaction.prototype);
    PointerInteraction.prototype.constructor = PointerInteraction;
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserPointerEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ PointerInteraction.prototype.handleDownEvent = function handleDownEvent(mapBrowserEvent) {
        return false;
    };
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserPointerEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ PointerInteraction.prototype.handleDragEvent = function handleDragEvent(mapBrowserEvent) {};
    /**
   * Handles the {@link module:ol/MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @override
   * @api
   */ PointerInteraction.prototype.handleEvent = function handleEvent(mapBrowserEvent) {
        if (!/** @type {import("../MapBrowserPointerEvent.js").default} */ mapBrowserEvent.pointerEvent) return true;
        var stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDRAG) this.handleDragEvent(mapBrowserEvent);
            else if (mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERUP) {
                var handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDOWN) {
                var handled = this.handleDownEvent(mapBrowserEvent);
                if (handled) mapBrowserEvent.preventDefault();
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    };
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserPointerEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ PointerInteraction.prototype.handleMoveEvent = function handleMoveEvent(mapBrowserEvent) {};
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserPointerEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ PointerInteraction.prototype.handleUpEvent = function handleUpEvent(mapBrowserEvent) {
        return false;
    };
    /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */ PointerInteraction.prototype.stopDown = function stopDown(handled) {
        return handled;
    };
    /**
   * @param {import("../MapBrowserPointerEvent.js").default} mapBrowserEvent Event.
   * @private
   */ PointerInteraction.prototype.updateTrackedPointers_ = function updateTrackedPointers_(mapBrowserEvent) {
        if ($f4f64f356a570c0e$var$isPointerDraggingEvent(mapBrowserEvent)) {
            var event = mapBrowserEvent.pointerEvent;
            var id = event.pointerId.toString();
            if (mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERUP) delete this.trackedPointers_[id];
            else if (mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDOWN) this.trackedPointers_[id] = event;
            else if (id in this.trackedPointers_) // update only when there was a pointerdown event for this pointer
            this.trackedPointers_[id] = event;
            this.targetPointers = (0, $8c1e0b75b65663dc$export$a5c4301012ad6f07)(this.trackedPointers_);
        }
    };
    return PointerInteraction;
}((0, $36e1c4dbb62d535d$export$2e2bcd8739ae039));
function $f4f64f356a570c0e$export$e2a20c553f6c85ce(pointerEvents) {
    var length = pointerEvents.length;
    var clientX = 0;
    var clientY = 0;
    for(var i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return [
        clientX / length,
        clientY / length
    ];
}
/**
 * @param {import("../MapBrowserPointerEvent.js").default} mapBrowserEvent Event.
 * @return {boolean} Whether the event is a pointerdown, pointerdrag
 *     or pointerup event.
 */ function $f4f64f356a570c0e$var$isPointerDraggingEvent(mapBrowserEvent) {
    var type = mapBrowserEvent.type;
    return type === (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDOWN || type === (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDRAG || type === (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERUP;
}
var $f4f64f356a570c0e$export$2e2bcd8739ae039 = $f4f64f356a570c0e$var$PointerInteraction;


/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition~noModifierKeys}.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ var $6baed6e1188f6d5d$var$DragPan = /*@__PURE__*/ function(PointerInteraction) {
    function DragPan(opt_options) {
        PointerInteraction.call(this, {
            stopDown: (0, $de1052d9f293b73a$export$8f11cee4bdc7e668)
        });
        var options = opt_options ? opt_options : {};
        /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */ this.kinetic_ = options.kinetic;
        /**
     * @type {import("../pixel.js").Pixel}
     */ this.lastCentroid = null;
        /**
     * @type {number}
     */ this.lastPointersCount_;
        /**
     * @type {boolean}
     */ this.panning_ = false;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $2083adc1400fd9db$export$fdc892d0d8fe3bfb);
        /**
     * @private
     * @type {boolean}
     */ this.noKinetic_ = false;
    }
    if (PointerInteraction) DragPan.__proto__ = PointerInteraction;
    DragPan.prototype = Object.create(PointerInteraction && PointerInteraction.prototype);
    DragPan.prototype.constructor = DragPan;
    /**
   * @inheritDoc
   */ DragPan.prototype.handleDragEvent = function handleDragEvent(mapBrowserEvent) {
        if (!this.panning_) {
            this.panning_ = true;
            this.getMap().getView().setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING, 1);
        }
        var targetPointers = this.targetPointers;
        var centroid = (0, $f4f64f356a570c0e$export$e2a20c553f6c85ce)(targetPointers);
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                var deltaX = this.lastCentroid[0] - centroid[0];
                var deltaY = centroid[1] - this.lastCentroid[1];
                var map = mapBrowserEvent.map;
                var view = map.getView();
                var center = [
                    deltaX,
                    deltaY
                ];
                (0, $8b28786758450fff$export$dcdf75081b88279d)(center, view.getResolution());
                (0, $8b28786758450fff$export$bb628a54ab399bc9)(center, view.getRotation());
                (0, $8b28786758450fff$export$e16d8520af44a096)(center, view.getCenter());
                center = view.constrainCenter(center);
                view.setCenter(center);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
    };
    /**
   * @inheritDoc
   */ DragPan.prototype.handleUpEvent = function handleUpEvent(mapBrowserEvent) {
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                var distance = this.kinetic_.getDistance();
                var angle = this.kinetic_.getAngle();
                var center = /** @type {!import("../coordinate.js").Coordinate} */ view.getCenter();
                var centerpx = map.getPixelFromCoordinate(center);
                var dest = map.getCoordinateFromPixel([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animate({
                    center: view.constrainCenter(dest),
                    duration: 500,
                    easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING, -1);
            }
            return false;
        } else {
            if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
            // after one finger up, tiny drag, second finger up
            this.kinetic_.begin();
            this.lastCentroid = null;
            return true;
        }
    };
    /**
   * @inheritDoc
   */ DragPan.prototype.handleDownEvent = function handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.setCenter(mapBrowserEvent.frameState.viewState.center);
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        } else return false;
    };
    return DragPan;
}((0, $f4f64f356a570c0e$export$2e2bcd8739ae039));
var $6baed6e1188f6d5d$export$2e2bcd8739ae039 = $6baed6e1188f6d5d$var$DragPan;


/**
 * @module ol/interaction/DragRotate
 */ 





/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition~altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ var $e973edd1a46ee1a2$var$DragRotate = /*@__PURE__*/ function(PointerInteraction) {
    function DragRotate(opt_options) {
        var options = opt_options ? opt_options : {};
        PointerInteraction.call(this, {
            stopDown: (0, $de1052d9f293b73a$export$8f11cee4bdc7e668)
        });
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $2083adc1400fd9db$export$4e5f01653f9f1f82);
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    if (PointerInteraction) DragRotate.__proto__ = PointerInteraction;
    DragRotate.prototype = Object.create(PointerInteraction && PointerInteraction.prototype);
    DragRotate.prototype.constructor = DragRotate;
    /**
   * @inheritDoc
   */ DragRotate.prototype.handleDragEvent = function handleDragEvent(mapBrowserEvent) {
        if (!(0, $2083adc1400fd9db$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (view.getConstraints().rotation === (0, $ea3e0fdf428207b8$export$e20fbacbb41798b)) return;
        var size = map.getSize();
        var offset = mapBrowserEvent.pixel;
        var theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            var delta = theta - this.lastAngle_;
            var rotation = view.getRotation();
            (0, $36e1c4dbb62d535d$export$c734e19e4e5b6a43)(view, rotation - delta);
        }
        this.lastAngle_ = theta;
    };
    /**
   * @inheritDoc
   */ DragRotate.prototype.handleUpEvent = function handleUpEvent(mapBrowserEvent) {
        if (!(0, $2083adc1400fd9db$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        view.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING, -1);
        var rotation = view.getRotation();
        (0, $36e1c4dbb62d535d$export$bb628a54ab399bc9)(view, rotation, undefined, this.duration_);
        return false;
    };
    /**
   * @inheritDoc
   */ DragRotate.prototype.handleDownEvent = function handleDownEvent(mapBrowserEvent) {
        if (!(0, $2083adc1400fd9db$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
        if ((0, $2083adc1400fd9db$export$1238ad6b5e7fff70)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            var map = mapBrowserEvent.map;
            map.getView().setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING, 1);
            this.lastAngle_ = undefined;
            return true;
        } else return false;
    };
    return DragRotate;
}((0, $f4f64f356a570c0e$export$2e2bcd8739ae039));
var $e973edd1a46ee1a2$export$2e2bcd8739ae039 = $e973edd1a46ee1a2$var$DragRotate;


/**
 * @module ol/interaction/DragZoom
 */ 


/**
 * @module ol/interaction/DragBox
 */ // FIXME draw drag box




/**
 * @module ol/render/Box
 */ 

var $1af1c079fa1cf31c$var$RenderBox = /*@__PURE__*/ function(Disposable) {
    function RenderBox(className) {
        Disposable.call(this);
        /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */ this.geometry_ = null;
        /**
     * @type {HTMLDivElement}
     * @private
     */ this.element_ = /** @type {HTMLDivElement} */ document.createElement("div");
        this.element_.style.position = "absolute";
        this.element_.className = "ol-box " + className;
        /**
     * @private
     * @type {import("../PluggableMap.js").default}
     */ this.map_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.endPixel_ = null;
    }
    if (Disposable) RenderBox.__proto__ = Disposable;
    RenderBox.prototype = Object.create(Disposable && Disposable.prototype);
    RenderBox.prototype.constructor = RenderBox;
    /**
   * @inheritDoc
   */ RenderBox.prototype.disposeInternal = function disposeInternal() {
        this.setMap(null);
    };
    /**
   * @private
   */ RenderBox.prototype.render_ = function render_() {
        var startPixel = this.startPixel_;
        var endPixel = this.endPixel_;
        var px = "px";
        var style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    };
    /**
   * @param {import("../PluggableMap.js").default} map Map.
   */ RenderBox.prototype.setMap = function setMap(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            var style = this.element_.style;
            style.left = style.top = style.width = style.height = "inherit";
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    };
    /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */ RenderBox.prototype.setPixels = function setPixels(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    };
    /**
   * Creates or updates the cached geometry.
   */ RenderBox.prototype.createOrUpdateGeometry = function createOrUpdateGeometry() {
        var startPixel = this.startPixel_;
        var endPixel = this.endPixel_;
        var pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        var coordinates = pixels.map(this.map_.getCoordinateFromPixel, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, $46a66e0f2fc72479$export$2e2bcd8739ae039)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    };
    /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */ RenderBox.prototype.getGeometry = function getGeometry() {
        return this.geometry_;
    };
    return RenderBox;
}((0, $17f88068b11f58ac$export$2e2bcd8739ae039));
var $1af1c079fa1cf31c$export$2e2bcd8739ae039 = $1af1c079fa1cf31c$var$RenderBox;


/**
 * A function that takes a {@link module:ol/MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~always}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default)} onBoxEnd Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ var $3abf4a6a6173e05c$var$DragBoxEventType = {
    /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */ BOXSTART: "boxstart",
    /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */ BOXDRAG: "boxdrag",
    /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */ BOXEND: "boxend"
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/DragBox~DragBox} instances are instances of
 * this type.
 */ var $3abf4a6a6173e05c$var$DragBoxEvent = /*@__PURE__*/ function(Event) {
    function DragBoxEvent(type, coordinate, mapBrowserEvent) {
        Event.call(this, type);
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
    if (Event) DragBoxEvent.__proto__ = Event;
    DragBoxEvent.prototype = Object.create(Event && Event.prototype);
    DragBoxEvent.prototype.constructor = DragBoxEvent;
    return DragBoxEvent;
}((0, $0327f54963b35733$export$2e2bcd8739ae039));
/**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom}).
 *
 * This interaction is only supported for mouse devices.
 *
 * @fires DragBoxEvent
 * @api
 */ var $3abf4a6a6173e05c$var$DragBox = /*@__PURE__*/ function(PointerInteraction) {
    function DragBox(opt_options) {
        PointerInteraction.call(this);
        var options = opt_options ? opt_options : {};
        /**
    * @type {import("../render/Box.js").default}
    * @private
    */ this.box_ = new (0, $1af1c079fa1cf31c$export$2e2bcd8739ae039)(options.className || "ol-dragbox");
        /**
    * @type {number}
    * @private
    */ this.minArea_ = options.minArea !== undefined ? options.minArea : 64;
        /**
     * Function to execute just before `onboxend` is fired
     * @type {function(this:DragBox, import("../MapBrowserEvent.js").default)}
     * @private
     */ this.onBoxEnd_ = options.onBoxEnd ? options.onBoxEnd : (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8);
        /**
    * @type {import("../pixel.js").Pixel}
    * @private
    */ this.startPixel_ = null;
        /**
    * @private
    * @type {import("../events/condition.js").Condition}
    */ this.condition_ = options.condition ? options.condition : (0, $2083adc1400fd9db$export$ba9e5d519bc326ca);
        /**
    * @private
    * @type {EndCondition}
    */ this.boxEndCondition_ = options.boxEndCondition ? options.boxEndCondition : this.defaultBoxEndCondition;
    }
    if (PointerInteraction) DragBox.__proto__ = PointerInteraction;
    DragBox.prototype = Object.create(PointerInteraction && PointerInteraction.prototype);
    DragBox.prototype.constructor = DragBox;
    /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */ DragBox.prototype.defaultBoxEndCondition = function defaultBoxEndCondition(mapBrowserEvent, startPixel, endPixel) {
        var width = endPixel[0] - startPixel[0];
        var height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    };
    /**
  * Returns geometry of last drawn box.
  * @return {import("../geom/Polygon.js").default} Geometry.
  * @api
  */ DragBox.prototype.getGeometry = function getGeometry() {
        return this.box_.getGeometry();
    };
    /**
   * @inheritDoc
   */ DragBox.prototype.handleDragEvent = function handleDragEvent(mapBrowserEvent) {
        if (!(0, $2083adc1400fd9db$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new $3abf4a6a6173e05c$var$DragBoxEvent($3abf4a6a6173e05c$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    };
    /**
   * @inheritDoc
   */ DragBox.prototype.handleUpEvent = function handleUpEvent(mapBrowserEvent) {
        if (!(0, $2083adc1400fd9db$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
        this.box_.setMap(null);
        if (this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel)) {
            this.onBoxEnd_(mapBrowserEvent);
            this.dispatchEvent(new $3abf4a6a6173e05c$var$DragBoxEvent($3abf4a6a6173e05c$var$DragBoxEventType.BOXEND, mapBrowserEvent.coordinate, mapBrowserEvent));
        }
        return false;
    };
    /**
   * @inheritDoc
   */ DragBox.prototype.handleDownEvent = function handleDownEvent(mapBrowserEvent) {
        if (!(0, $2083adc1400fd9db$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
        if ((0, $2083adc1400fd9db$export$1238ad6b5e7fff70)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new $3abf4a6a6173e05c$var$DragBoxEvent($3abf4a6a6173e05c$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        } else return false;
    };
    return DragBox;
}((0, $f4f64f356a570c0e$export$2e2bcd8739ae039));
var $3abf4a6a6173e05c$export$2e2bcd8739ae039 = $3abf4a6a6173e05c$var$DragBox;


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition~shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ var $c2873d0d637ab598$var$DragZoom = /*@__PURE__*/ function(DragBox) {
    function DragZoom(opt_options) {
        var options = opt_options ? opt_options : {};
        var condition = options.condition ? options.condition : (0, $2083adc1400fd9db$export$5d31fe68a477cfbb);
        DragBox.call(this, {
            condition: condition,
            className: options.className || "ol-dragzoom",
            onBoxEnd: $c2873d0d637ab598$var$onBoxEnd
        });
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
     * @private
     * @type {boolean}
     */ this.out_ = options.out !== undefined ? options.out : false;
    }
    if (DragBox) DragZoom.__proto__ = DragBox;
    DragZoom.prototype = Object.create(DragBox && DragBox.prototype);
    DragZoom.prototype.constructor = DragZoom;
    return DragZoom;
}((0, $3abf4a6a6173e05c$export$2e2bcd8739ae039));
/**
 * @this {DragZoom}
 */ function $c2873d0d637ab598$var$onBoxEnd() {
    var map = this.getMap();
    var view = /** @type {!import("../View.js").default} */ map.getView();
    var size = /** @type {!import("../size.js").Size} */ map.getSize();
    var extent = this.getGeometry().getExtent();
    if (this.out_) {
        var mapExtent = view.calculateExtent(size);
        var boxPixelExtent = (0, $7e819822b33b3d32$export$29e3ad4dbd0cb863)([
            map.getPixelFromCoordinate((0, $7e819822b33b3d32$export$8d09f5e2e1bf560d)(extent)),
            map.getPixelFromCoordinate((0, $7e819822b33b3d32$export$b84fa077c8b05295)(extent))
        ]);
        var factor = view.getResolutionForExtent(boxPixelExtent, size);
        (0, $7e819822b33b3d32$export$80cbab86674143b6)(mapExtent, 1 / factor);
        extent = mapExtent;
    }
    var resolution = view.constrainResolution(view.getResolutionForExtent(extent, size));
    var center = (0, $7e819822b33b3d32$export$c91255cadecfe081)(extent);
    center = view.constrainCenter(center);
    view.animate({
        resolution: resolution,
        center: center,
        duration: this.duration_,
        easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0)
    });
}
var $c2873d0d637ab598$export$2e2bcd8739ae039 = $c2873d0d637ab598$var$DragZoom;


/**
 * @module ol/interaction/KeyboardPan
 */ 

/**
 * @module ol/events/KeyCode
 */ /**
 * @enum {number}
 * @const
 */ var $acbe80278ef7c532$export$2e2bcd8739ae039 = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
};




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition~noModifierKeys} and
 * {@link module:ol/events/condition~targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ var $49f656d79a965468$var$KeyboardPan = /*@__PURE__*/ function(Interaction) {
    function KeyboardPan(opt_options) {
        Interaction.call(this, {
            handleEvent: $49f656d79a965468$var$handleEvent
        });
        var options = opt_options || {};
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $2083adc1400fd9db$export$fdc892d0d8fe3bfb)(mapBrowserEvent) && (0, $2083adc1400fd9db$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition !== undefined ? options.condition : this.defaultCondition_;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
     * @private
     * @type {number}
     */ this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
    }
    if (Interaction) KeyboardPan.__proto__ = Interaction;
    KeyboardPan.prototype = Object.create(Interaction && Interaction.prototype);
    KeyboardPan.prototype.constructor = KeyboardPan;
    return KeyboardPan;
}((0, $36e1c4dbb62d535d$export$2e2bcd8739ae039));
/**
 * Handles the {@link module:ol/MapBrowserEvent map browser event} if it was a
 * `KeyEvent`, and decides the direction to pan to (if an arrow key was
 * pressed).
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} `false` to stop event propagation.
 * @this {KeyboardPan}
 */ function $49f656d79a965468$var$handleEvent(mapBrowserEvent) {
    var stopEvent = false;
    if (mapBrowserEvent.type == (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).KEYDOWN) {
        var keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
        var keyCode = keyEvent.keyCode;
        if (this.condition_(mapBrowserEvent) && (keyCode == (0, $acbe80278ef7c532$export$2e2bcd8739ae039).DOWN || keyCode == (0, $acbe80278ef7c532$export$2e2bcd8739ae039).LEFT || keyCode == (0, $acbe80278ef7c532$export$2e2bcd8739ae039).RIGHT || keyCode == (0, $acbe80278ef7c532$export$2e2bcd8739ae039).UP)) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            var mapUnitsDelta = view.getResolution() * this.pixelDelta_;
            var deltaX = 0, deltaY = 0;
            if (keyCode == (0, $acbe80278ef7c532$export$2e2bcd8739ae039).DOWN) deltaY = -mapUnitsDelta;
            else if (keyCode == (0, $acbe80278ef7c532$export$2e2bcd8739ae039).LEFT) deltaX = -mapUnitsDelta;
            else if (keyCode == (0, $acbe80278ef7c532$export$2e2bcd8739ae039).RIGHT) deltaX = mapUnitsDelta;
            else deltaY = mapUnitsDelta;
            var delta = [
                deltaX,
                deltaY
            ];
            (0, $8b28786758450fff$export$bb628a54ab399bc9)(delta, view.getRotation());
            (0, $36e1c4dbb62d535d$export$4c486572e961a974)(view, delta, this.duration_);
            mapBrowserEvent.preventDefault();
            stopEvent = true;
        }
    }
    return !stopEvent;
}
var $49f656d79a965468$export$2e2bcd8739ae039 = $49f656d79a965468$var$KeyboardPan;


/**
 * @module ol/interaction/KeyboardZoom
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition~targetNotEditable}.
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ var $ee0a6f663ca23f5a$var$KeyboardZoom = /*@__PURE__*/ function(Interaction) {
    function KeyboardZoom(opt_options) {
        Interaction.call(this, {
            handleEvent: $ee0a6f663ca23f5a$var$handleEvent
        });
        var options = opt_options ? opt_options : {};
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $2083adc1400fd9db$export$e5570ca80cd8fd54);
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
    }
    if (Interaction) KeyboardZoom.__proto__ = Interaction;
    KeyboardZoom.prototype = Object.create(Interaction && Interaction.prototype);
    KeyboardZoom.prototype.constructor = KeyboardZoom;
    return KeyboardZoom;
}((0, $36e1c4dbb62d535d$export$2e2bcd8739ae039));
/**
 * Handles the {@link module:ol/MapBrowserEvent map browser event} if it was a
 * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
 * key pressed was '+' or '-').
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} `false` to stop event propagation.
 * @this {KeyboardZoom}
 */ function $ee0a6f663ca23f5a$var$handleEvent(mapBrowserEvent) {
    var stopEvent = false;
    if (mapBrowserEvent.type == (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).KEYDOWN || mapBrowserEvent.type == (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).KEYPRESS) {
        var keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
        var charCode = keyEvent.charCode;
        if (this.condition_(mapBrowserEvent) && (charCode == "+".charCodeAt(0) || charCode == "-".charCodeAt(0))) {
            var map = mapBrowserEvent.map;
            var delta = charCode == "+".charCodeAt(0) ? this.delta_ : -this.delta_;
            var view = map.getView();
            (0, $36e1c4dbb62d535d$export$ace321ff2a8016ef)(view, delta, undefined, this.duration_);
            mapBrowserEvent.preventDefault();
            stopEvent = true;
        }
    }
    return !stopEvent;
}
var $ee0a6f663ca23f5a$export$2e2bcd8739ae039 = $ee0a6f663ca23f5a$var$KeyboardZoom;


/**
 * @module ol/interaction/MouseWheelZoom
 */ 






/**
 * Maximum mouse wheel delta.
 * @type {number}
 */ var $d63f90228254196b$var$MAX_DELTA = 1;
var $d63f90228254196b$export$9484bbecc3c49a2e = {
    TRACKPAD: "trackpad",
    WHEEL: "wheel"
};
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition~always}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [constrainResolution=false] When using a trackpad or
 * magic mouse, zoom to the closest integer zoom level after the scroll gesture
 * ends.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ var $d63f90228254196b$var$MouseWheelZoom = /*@__PURE__*/ function(Interaction) {
    function MouseWheelZoom(opt_options) {
        var options = opt_options ? opt_options : {};
        Interaction.call(/** @type {import("./Interaction.js").InteractionOptions} */ this, options);
        /**
     * @private
     * @type {number}
     */ this.delta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @private
     * @type {number}
     */ this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
     * @private
     * @type {boolean}
     */ this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
     * @private
     * @type {boolean}
     */ this.constrainResolution_ = options.constrainResolution || false;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $2083adc1400fd9db$export$ba9e5d519bc326ca);
        /**
     * @private
     * @type {?import("../coordinate.js").Coordinate}
     */ this.lastAnchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.startTime_ = undefined;
        /**
     * @private
     * @type {?}
     */ this.timeoutId_;
        /**
     * @private
     * @type {Mode|undefined}
     */ this.mode_ = undefined;
        /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @type {number}
     */ this.trackpadEventGap_ = 400;
        /**
     * @type {?}
     */ this.trackpadTimeoutId_;
        /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */ this.trackpadDeltaPerZoom_ = 300;
        /**
     * The zoom factor by which scroll zooming is allowed to exceed the limits.
     * @private
     * @type {number}
     */ this.trackpadZoomBuffer_ = 1.5;
    }
    if (Interaction) MouseWheelZoom.__proto__ = Interaction;
    MouseWheelZoom.prototype = Object.create(Interaction && Interaction.prototype);
    MouseWheelZoom.prototype.constructor = MouseWheelZoom;
    /**
   * @private
   */ MouseWheelZoom.prototype.decrementInteractingHint_ = function decrementInteractingHint_() {
        this.trackpadTimeoutId_ = undefined;
        var view = this.getMap().getView();
        view.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING, -1);
    };
    /**
   * Handles the {@link module:ol/MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @override
   */ MouseWheelZoom.prototype.handleEvent = function handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        var type = mapBrowserEvent.type;
        if (type !== (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).WHEEL && type !== (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).MOUSEWHEEL) return true;
        mapBrowserEvent.preventDefault();
        var map = mapBrowserEvent.map;
        var wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.coordinate;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        var delta;
        if (mapBrowserEvent.type == (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).WHEEL) {
            delta = wheelEvent.deltaY;
            if ((0, $89969764a1196844$export$8442bdfd18b7b8a6) && wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) delta /= (0, $89969764a1196844$export$6b83a0446fc26f94);
            if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) delta *= 40;
        } else if (mapBrowserEvent.type == (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).MOUSEWHEEL) {
            delta = -wheelEvent.wheelDeltaY;
            if (0, $89969764a1196844$export$3227bfbdaa9275de) delta /= 3;
        }
        if (delta === 0) return false;
        var now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? $d63f90228254196b$export$9484bbecc3c49a2e.TRACKPAD : $d63f90228254196b$export$9484bbecc3c49a2e.WHEEL;
        if (this.mode_ === $d63f90228254196b$export$9484bbecc3c49a2e.TRACKPAD) {
            var view = map.getView();
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else view.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING, 1);
            this.trackpadTimeoutId_ = setTimeout(this.decrementInteractingHint_.bind(this), this.trackpadEventGap_);
            var resolution = view.getResolution() * Math.pow(2, delta / this.trackpadDeltaPerZoom_);
            var minResolution = view.getMinResolution();
            var maxResolution = view.getMaxResolution();
            var rebound = 0;
            if (resolution < minResolution) {
                resolution = Math.max(resolution, minResolution / this.trackpadZoomBuffer_);
                rebound = 1;
            } else if (resolution > maxResolution) {
                resolution = Math.min(resolution, maxResolution * this.trackpadZoomBuffer_);
                rebound = -1;
            }
            if (this.lastAnchor_) {
                var center = view.calculateCenterZoom(resolution, this.lastAnchor_);
                view.setCenter(view.constrainCenter(center));
            }
            view.setResolution(resolution);
            if (rebound === 0 && this.constrainResolution_) view.animate({
                resolution: view.constrainResolution(resolution, delta > 0 ? -1 : 1),
                easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0),
                anchor: this.lastAnchor_,
                duration: this.duration_
            });
            if (rebound > 0) view.animate({
                resolution: minResolution,
                easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0),
                anchor: this.lastAnchor_,
                duration: 500
            });
            else if (rebound < 0) view.animate({
                resolution: maxResolution,
                easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0),
                anchor: this.lastAnchor_,
                duration: 500
            });
            this.startTime_ = now;
            return false;
        }
        this.delta_ += delta;
        var timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    };
    /**
   * @private
   * @param {import("../PluggableMap.js").default} map Map.
   */ MouseWheelZoom.prototype.handleWheelZoom_ = function handleWheelZoom_(map) {
        var view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        var maxDelta = $d63f90228254196b$var$MAX_DELTA;
        var delta = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(this.delta_, -maxDelta, maxDelta);
        (0, $36e1c4dbb62d535d$export$ace321ff2a8016ef)(view, -delta, this.lastAnchor_, this.duration_);
        this.mode_ = undefined;
        this.delta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    };
    /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */ MouseWheelZoom.prototype.setMouseAnchor = function setMouseAnchor(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    };
    return MouseWheelZoom;
}((0, $36e1c4dbb62d535d$export$2e2bcd8739ae039));
var $d63f90228254196b$export$2e2bcd8739ae039 = $d63f90228254196b$var$MouseWheelZoom;


/**
 * @module ol/interaction/PinchRotate
 */ 




/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ var $8fea13ae61596510$var$PinchRotate = /*@__PURE__*/ function(PointerInteraction) {
    function PinchRotate(opt_options) {
        var options = opt_options ? opt_options : {};
        var pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $de1052d9f293b73a$export$8f11cee4bdc7e668);
        PointerInteraction.call(this, pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {boolean}
     */ this.rotating_ = false;
        /**
     * @private
     * @type {number}
     */ this.rotationDelta_ = 0.0;
        /**
     * @private
     * @type {number}
     */ this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    if (PointerInteraction) PinchRotate.__proto__ = PointerInteraction;
    PinchRotate.prototype = Object.create(PointerInteraction && PointerInteraction.prototype);
    PinchRotate.prototype.constructor = PinchRotate;
    /**
   * @inheritDoc
   */ PinchRotate.prototype.handleDragEvent = function handleDragEvent(mapBrowserEvent) {
        var rotationDelta = 0.0;
        var touch0 = this.targetPointers[0];
        var touch1 = this.targetPointers[1];
        // angle between touches
        var angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            var delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (view.getConstraints().rotation === (0, $ea3e0fdf428207b8$export$e20fbacbb41798b)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        var viewportPosition = map.getViewport().getBoundingClientRect();
        var centroid = (0, $f4f64f356a570c0e$export$e2a20c553f6c85ce)(this.targetPointers);
        centroid[0] -= viewportPosition.left;
        centroid[1] -= viewportPosition.top;
        this.anchor_ = map.getCoordinateFromPixel(centroid);
        // rotate
        if (this.rotating_) {
            var rotation = view.getRotation();
            map.render();
            (0, $36e1c4dbb62d535d$export$c734e19e4e5b6a43)(view, rotation + rotationDelta, this.anchor_);
        }
    };
    /**
   * @inheritDoc
   */ PinchRotate.prototype.handleUpEvent = function handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            view.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING, -1);
            if (this.rotating_) {
                var rotation = view.getRotation();
                (0, $36e1c4dbb62d535d$export$bb628a54ab399bc9)(view, rotation, this.anchor_, this.duration_);
            }
            return false;
        } else return true;
    };
    /**
   * @inheritDoc
   */ PinchRotate.prototype.handleDownEvent = function handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            var map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING, 1);
            return true;
        } else return false;
    };
    return PinchRotate;
}((0, $f4f64f356a570c0e$export$2e2bcd8739ae039));
var $8fea13ae61596510$export$2e2bcd8739ae039 = $8fea13ae61596510$var$PinchRotate;


/**
 * @module ol/interaction/PinchZoom
 */ 



/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 * @property {boolean} [constrainResolution=false] Zoom to the closest integer
 * zoom level after the pinch gesture ends.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ var $2b37714dcc016e14$var$PinchZoom = /*@__PURE__*/ function(PointerInteraction) {
    function PinchZoom(opt_options) {
        var options = opt_options ? opt_options : {};
        var pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $de1052d9f293b73a$export$8f11cee4bdc7e668);
        PointerInteraction.call(this, pointerOptions);
        /**
     * @private
     * @type {boolean}
     */ this.constrainResolution_ = options.constrainResolution || false;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastDistance_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.lastScaleDelta_ = 1;
    }
    if (PointerInteraction) PinchZoom.__proto__ = PointerInteraction;
    PinchZoom.prototype = Object.create(PointerInteraction && PointerInteraction.prototype);
    PinchZoom.prototype.constructor = PinchZoom;
    /**
   * @inheritDoc
   */ PinchZoom.prototype.handleDragEvent = function handleDragEvent(mapBrowserEvent) {
        var scaleDelta = 1.0;
        var touch0 = this.targetPointers[0];
        var touch1 = this.targetPointers[1];
        var dx = touch0.clientX - touch1.clientX;
        var dy = touch0.clientY - touch1.clientY;
        // distance between touches
        var distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        var resolution = view.getResolution();
        var maxResolution = view.getMaxResolution();
        var minResolution = view.getMinResolution();
        var newResolution = resolution * scaleDelta;
        if (newResolution > maxResolution) {
            scaleDelta = maxResolution / resolution;
            newResolution = maxResolution;
        } else if (newResolution < minResolution) {
            scaleDelta = minResolution / resolution;
            newResolution = minResolution;
        }
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        var viewportPosition = map.getViewport().getBoundingClientRect();
        var centroid = (0, $f4f64f356a570c0e$export$e2a20c553f6c85ce)(this.targetPointers);
        centroid[0] -= viewportPosition.left;
        centroid[1] -= viewportPosition.top;
        this.anchor_ = map.getCoordinateFromPixel(centroid);
        // scale, bypass the resolution constraint
        map.render();
        (0, $36e1c4dbb62d535d$export$f5e0922d80e7a081)(view, newResolution, this.anchor_);
    };
    /**
   * @inheritDoc
   */ PinchZoom.prototype.handleUpEvent = function handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            view.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING, -1);
            var resolution = view.getResolution();
            if (this.constrainResolution_ || resolution < view.getMinResolution() || resolution > view.getMaxResolution()) {
                // Zoom to final resolution, with an animation, and provide a
                // direction not to zoom out/in if user was pinching in/out.
                // Direction is > 0 if pinching out, and < 0 if pinching in.
                var direction = this.lastScaleDelta_ - 1;
                (0, $36e1c4dbb62d535d$export$e83f174dbf56adcc)(view, resolution, this.anchor_, this.duration_, direction);
            }
            return false;
        } else return true;
    };
    /**
   * @inheritDoc
   */ PinchZoom.prototype.handleDownEvent = function handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            var map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING, 1);
            return true;
        } else return false;
    };
    return PinchZoom;
}((0, $f4f64f356a570c0e$export$2e2bcd8739ae039));
var $2b37714dcc016e14$export$2e2bcd8739ae039 = $2b37714dcc016e14$var$PinchZoom;














function $e30eb1cf0f64773b$export$ebe90cb607ad99e(opt_options) {
    var options = opt_options ? opt_options : {};
    var interactions = new (0, $7be3d63260860659$export$2e2bcd8739ae039)();
    var kinetic = new (0, $477a0a09e8e7589b$export$2e2bcd8739ae039)(-0.005, 0.05, 100);
    var altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $e973edd1a46ee1a2$export$2e2bcd8739ae039)());
    var doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $6922361fb812290c$export$2e2bcd8739ae039)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    var dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $6baed6e1188f6d5d$export$2e2bcd8739ae039)({
        condition: options.onFocusOnly ? (0, $2083adc1400fd9db$export$d7ddd398f22d79ef) : undefined,
        kinetic: kinetic
    }));
    var pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $8fea13ae61596510$export$2e2bcd8739ae039)());
    var pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $2b37714dcc016e14$export$2e2bcd8739ae039)({
        constrainResolution: options.constrainResolution,
        duration: options.zoomDuration
    }));
    var keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $49f656d79a965468$export$2e2bcd8739ae039)());
        interactions.push(new (0, $ee0a6f663ca23f5a$export$2e2bcd8739ae039)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    var mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $d63f90228254196b$export$2e2bcd8739ae039)({
        condition: options.onFocusOnly ? (0, $2083adc1400fd9db$export$d7ddd398f22d79ef) : undefined,
        constrainResolution: options.constrainResolution,
        duration: options.zoomDuration
    }));
    var shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $c2873d0d637ab598$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    return interactions;
}



/**
 * @module ol/renderer/canvas/ImageLayer
 */ /**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ var $7b3aa4a24649670e$export$3ecb4bcfa5aae855 = 0.5;
var $7b3aa4a24649670e$export$584433cc24140052 = true;


/**
 * @module ol/ImageCanvas
 */ /**
 * @module ol/ImageBase
 */ 


/**
 * @abstract
 */ var $5b82361d328c6dd8$var$ImageBase = /*@__PURE__*/ function(EventTarget) {
    function ImageBase(extent, resolution, pixelRatio, state) {
        EventTarget.call(this);
        /**
     * @protected
     * @type {import("./extent.js").Extent}
     */ this.extent = extent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @protected
     * @type {number|undefined}
     */ this.resolution = resolution;
        /**
     * @protected
     * @type {import("./ImageState.js").default}
     */ this.state = state;
    }
    if (EventTarget) ImageBase.__proto__ = EventTarget;
    ImageBase.prototype = Object.create(EventTarget && EventTarget.prototype);
    ImageBase.prototype.constructor = ImageBase;
    /**
   * @protected
   */ ImageBase.prototype.changed = function changed() {
        this.dispatchEvent((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE);
    };
    /**
   * @return {import("./extent.js").Extent} Extent.
   */ ImageBase.prototype.getExtent = function getExtent() {
        return this.extent;
    };
    /**
   * @abstract
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   */ ImageBase.prototype.getImage = function getImage() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * @return {number} PixelRatio.
   */ ImageBase.prototype.getPixelRatio = function getPixelRatio() {
        return this.pixelRatio_;
    };
    /**
   * @return {number} Resolution.
   */ ImageBase.prototype.getResolution = function getResolution() {
        return /** @type {number} */ this.resolution;
    };
    /**
   * @return {import("./ImageState.js").default} State.
   */ ImageBase.prototype.getState = function getState() {
        return this.state;
    };
    /**
   * Load not yet loaded URI.
   * @abstract
   */ ImageBase.prototype.load = function load() {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    return ImageBase;
}((0, $dd029d816e3b4259$export$2e2bcd8739ae039));
var $5b82361d328c6dd8$export$2e2bcd8739ae039 = $5b82361d328c6dd8$var$ImageBase;


/**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $23fb176c76153f22$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3
};


/**
 * A function that is called to trigger asynchronous canvas drawing.  It is
 * called with a "done" callback that should be called when drawing is done.
 * If any error occurs during drawing, the "done" callback should be called with
 * that error.
 *
 * @typedef {function(function(Error=))} Loader
 */ var $4b5760d150634964$var$ImageCanvas = /*@__PURE__*/ function(ImageBase) {
    function ImageCanvas(extent, resolution, pixelRatio, canvas, opt_loader) {
        var state = opt_loader !== undefined ? (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE : (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED;
        ImageBase.call(this, extent, resolution, pixelRatio, state);
        /**
     * Optional canvas loader function.
     * @type {?Loader}
     * @private
     */ this.loader_ = opt_loader !== undefined ? opt_loader : null;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = canvas;
        /**
     * @private
     * @type {Error}
     */ this.error_ = null;
    }
    if (ImageBase) ImageCanvas.__proto__ = ImageBase;
    ImageCanvas.prototype = Object.create(ImageBase && ImageBase.prototype);
    ImageCanvas.prototype.constructor = ImageCanvas;
    /**
   * Get any error associated with asynchronous rendering.
   * @return {Error} Any error that occurred during rendering.
   */ ImageCanvas.prototype.getError = function getError() {
        return this.error_;
    };
    /**
   * Handle async drawing complete.
   * @param {Error=} err Any error during drawing.
   * @private
   */ ImageCanvas.prototype.handleLoad_ = function handleLoad_(err) {
        if (err) {
            this.error_ = err;
            this.state = (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR;
        } else this.state = (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED;
        this.changed();
    };
    /**
   * @inheritDoc
   */ ImageCanvas.prototype.load = function load() {
        if (this.state == (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.loader_(this.handleLoad_.bind(this));
        }
    };
    /**
   * @return {HTMLCanvasElement} Canvas element.
   */ ImageCanvas.prototype.getImage = function getImage() {
        return this.canvas_;
    };
    return ImageCanvas;
}((0, $5b82361d328c6dd8$export$2e2bcd8739ae039));
var $4b5760d150634964$export$2e2bcd8739ae039 = $4b5760d150634964$var$ImageCanvas;


/**
 * @module ol/LayerType
 */ /**
 * A layer type used when creating layer renderers.
 * @enum {string}
 */ var $e2d469ffcbcaca70$export$2e2bcd8739ae039 = {
    IMAGE: "IMAGE",
    TILE: "TILE",
    VECTOR_TILE: "VECTOR_TILE",
    VECTOR: "VECTOR"
};





/**
 * @module ol/layer/VectorRenderType
 */ /**
 * @enum {string}
 * Render mode for vector layers:
 *  * `'image'`: Vector layers are rendered as images. Great performance, but
 *    point symbols and texts are always rotated with the view and pixels are
 *    scaled during zoom animations.
 *  * `'vector'`: Vector layers are rendered as vectors. Most accurate rendering
 *    even during animations, but slower performance.
 * @api
 */ var $f47fc48773998764$export$2e2bcd8739ae039 = {
    IMAGE: "image",
    VECTOR: "vector"
};



/**
 * @module ol/renderer/canvas/Map
 */ 




/**
 * @module ol/render/Event
 */ 
var $802ec85cbdf20290$var$RenderEvent = /*@__PURE__*/ function(Event) {
    function RenderEvent(type, opt_vectorContext, opt_frameState, opt_context, opt_glContext) {
        Event.call(this, type);
        /**
     * For canvas, this is an instance of {@link module:ol/render/canvas/Immediate}.
     * @type {import("./VectorContext.js").default|undefined}
     * @api
     */ this.vectorContext = opt_vectorContext;
        /**
     * An object representing the current render frame state.
     * @type {import("../PluggableMap.js").FrameState|undefined}
     * @api
     */ this.frameState = opt_frameState;
        /**
     * Canvas context. Only available when a Canvas renderer is used, null
     * otherwise.
     * @type {CanvasRenderingContext2D|null|undefined}
     * @api
     */ this.context = opt_context;
        /**
     * WebGL context. Only available when a WebGL renderer is used, null
     * otherwise.
     * @type {import("../webgl/Context.js").default|null|undefined}
     * @api
     */ this.glContext = opt_glContext;
    }
    if (Event) RenderEvent.__proto__ = Event;
    RenderEvent.prototype = Object.create(Event && Event.prototype);
    RenderEvent.prototype.constructor = RenderEvent;
    return RenderEvent;
}((0, $0327f54963b35733$export$2e2bcd8739ae039));
var $802ec85cbdf20290$export$2e2bcd8739ae039 = $802ec85cbdf20290$var$RenderEvent;



/**
 * @module ol/render/canvas
 */ 


/**
 * @module ol/structs/LRUCache
 */ 


/**
 * @typedef {Object} Entry
 * @property {string} key_
 * @property {Object} newer
 * @property {Object} older
 * @property {*} value_
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").Event
 * @template T
 */ var $24eec3dde9adb61e$var$LRUCache = /*@__PURE__*/ function(EventTarget) {
    function LRUCache(opt_highWaterMark) {
        EventTarget.call(this);
        /**
     * @type {number}
     */ this.highWaterMark = opt_highWaterMark !== undefined ? opt_highWaterMark : 2048;
        /**
     * @private
     * @type {number}
     */ this.count_ = 0;
        /**
     * @private
     * @type {!Object<string, Entry>}
     */ this.entries_ = {};
        /**
     * @private
     * @type {?Entry}
     */ this.oldest_ = null;
        /**
     * @private
     * @type {?Entry}
     */ this.newest_ = null;
    }
    if (EventTarget) LRUCache.__proto__ = EventTarget;
    LRUCache.prototype = Object.create(EventTarget && EventTarget.prototype);
    LRUCache.prototype.constructor = LRUCache;
    /**
   * @return {boolean} Can expire cache.
   */ LRUCache.prototype.canExpireCache = function canExpireCache() {
        return this.getCount() > this.highWaterMark;
    };
    /**
   * FIXME empty description for jsdoc
   */ LRUCache.prototype.clear = function clear() {
        this.count_ = 0;
        this.entries_ = {};
        this.oldest_ = null;
        this.newest_ = null;
        this.dispatchEvent((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLEAR);
    };
    /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */ LRUCache.prototype.containsKey = function containsKey(key) {
        return this.entries_.hasOwnProperty(key);
    };
    /**
   * @param {function(this: S, T, string, LRUCache): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   * @param {S=} opt_this The object to use as `this` in `f`.
   * @template S
   */ LRUCache.prototype.forEach = function forEach(f, opt_this) {
        var entry = this.oldest_;
        while(entry){
            f.call(opt_this, entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    };
    /**
   * @param {string} key Key.
   * @return {T} Value.
   */ LRUCache.prototype.get = function get(key) {
        var entry = this.entries_[key];
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(entry !== undefined, 15); // Tried to get a value for a key that does not exist in the cache
        if (entry === this.newest_) return entry.value_;
        else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    };
    /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */ LRUCache.prototype.remove = function remove(key) {
        var entry = this.entries_[key];
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(entry !== undefined, 15); // Tried to get a value for a key that does not exist in the cache
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    };
    /**
   * @return {number} Count.
   */ LRUCache.prototype.getCount = function getCount() {
        return this.count_;
    };
    /**
   * @return {Array<string>} Keys.
   */ LRUCache.prototype.getKeys = function getKeys() {
        var keys = new Array(this.count_);
        var i = 0;
        var entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    };
    /**
   * @return {Array<T>} Values.
   */ LRUCache.prototype.getValues = function getValues() {
        var values = new Array(this.count_);
        var i = 0;
        var entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    };
    /**
   * @return {T} Last value.
   */ LRUCache.prototype.peekLast = function peekLast() {
        return this.oldest_.value_;
    };
    /**
   * @return {string} Last key.
   */ LRUCache.prototype.peekLastKey = function peekLastKey() {
        return this.oldest_.key_;
    };
    /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */ LRUCache.prototype.peekFirstKey = function peekFirstKey() {
        return this.newest_.key_;
    };
    /**
   * @return {T} value Value.
   */ LRUCache.prototype.pop = function pop() {
        var entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    };
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ LRUCache.prototype.replace = function replace(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    };
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ LRUCache.prototype.set = function set(key, value) {
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!(key in this.entries_), 16); // Tried to set a value for a key that is used already
        var entry = /** @type {Entry} */ {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    };
    /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */ LRUCache.prototype.setSize = function setSize(size) {
        this.highWaterMark = size;
    };
    /**
   * Prune the cache.
   */ LRUCache.prototype.prune = function prune() {
        while(this.canExpireCache())this.pop();
    };
    return LRUCache;
}((0, $dd029d816e3b4259$export$2e2bcd8739ae039));
var $24eec3dde9adb61e$export$2e2bcd8739ae039 = $24eec3dde9adb61e$var$LRUCache;



var $c8f894129d9fa0b9$export$3847dfea4f8d4dfa = "10px sans-serif";
var $c8f894129d9fa0b9$export$c495d52ee3fd74b2 = [
    0,
    0,
    0,
    1
];
var $c8f894129d9fa0b9$export$17bd0c38d6ae694e = "round";
var $c8f894129d9fa0b9$export$e21b4112fdc612fc = [];
var $c8f894129d9fa0b9$export$e06efc2409049f76 = 0;
var $c8f894129d9fa0b9$export$365eb9648cf19bd0 = "round";
var $c8f894129d9fa0b9$export$80c1c01844597b7b = 10;
var $c8f894129d9fa0b9$export$1eb2eaecacf2031e = [
    0,
    0,
    0,
    1
];
var $c8f894129d9fa0b9$export$94d53b95641b5766 = "center";
var $c8f894129d9fa0b9$export$cf2279a1bff62eb = "middle";
var $c8f894129d9fa0b9$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
var $c8f894129d9fa0b9$export$79661f132c62010e = 1;
var $c8f894129d9fa0b9$export$18212182f4e22723 = new (0, $24eec3dde9adb61e$export$2e2bcd8739ae039)();
var $c8f894129d9fa0b9$export$1d36981fcadac93b = {};
/**
 * @type {CanvasRenderingContext2D}
 */ var $c8f894129d9fa0b9$var$measureContext = null;
var $c8f894129d9fa0b9$export$7fdcec604f0b1fa7 = {};
var $c8f894129d9fa0b9$export$ea12437b7b2e443e = function() {
    var retries = 60;
    var checked = $c8f894129d9fa0b9$export$1d36981fcadac93b;
    var size = "32px ";
    var referenceFonts = [
        "monospace",
        "serif"
    ];
    var len = referenceFonts.length;
    var text = "wmytzilWMYTZIL@#/&?$%10\uF013";
    var interval, referenceWidth;
    function isAvailable(font) {
        var context = $c8f894129d9fa0b9$var$getMeasureContext();
        // Check weight ranges according to
        // https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight#Fallback_weights
        for(var weight = 100; weight <= 700; weight += 300){
            var fontWeight = weight + " ";
            var available = true;
            for(var i = 0; i < len; ++i){
                var referenceFont = referenceFonts[i];
                context.font = fontWeight + size + referenceFont;
                referenceWidth = context.measureText(text).width;
                if (font != referenceFont) {
                    context.font = fontWeight + size + font + "," + referenceFont;
                    var width = context.measureText(text).width;
                    // If width and referenceWidth are the same, then the fallback was used
                    // instead of the font we wanted, so the font is not available.
                    available = available && width != referenceWidth;
                }
            }
            if (available) // Consider font available when it is available in one weight range.
            //FIXME With this we miss rare corner cases, so we should consider
            //FIXME checking availability for each requested weight range.
            return true;
        }
        return false;
    }
    function check() {
        var done = true;
        for(var font in checked)if (checked[font] < retries) {
            if (isAvailable(font)) {
                checked[font] = retries;
                (0, $8c1e0b75b65663dc$export$42ffd38884aecdac)($c8f894129d9fa0b9$export$7fdcec604f0b1fa7);
                // Make sure that loaded fonts are picked up by Safari
                $c8f894129d9fa0b9$var$measureContext = null;
                $c8f894129d9fa0b9$export$18212182f4e22723.clear();
            } else {
                ++checked[font];
                done = false;
            }
        }
        if (done) {
            clearInterval(interval);
            interval = undefined;
        }
    }
    return function(fontSpec) {
        var fontFamilies = (0, $bbcb4c1977b6e9f0$export$93b0d97b0a4b6bf5)(fontSpec);
        if (!fontFamilies) return;
        for(var i = 0, ii = fontFamilies.length; i < ii; ++i){
            var fontFamily = fontFamilies[i];
            if (!(fontFamily in checked)) {
                checked[fontFamily] = retries;
                if (!isAvailable(fontFamily)) {
                    checked[fontFamily] = 0;
                    if (interval === undefined) interval = setInterval(check, 32);
                }
            }
        }
    };
}();
/**
 * @return {CanvasRenderingContext2D} Measure context.
 */ function $c8f894129d9fa0b9$var$getMeasureContext() {
    if (!$c8f894129d9fa0b9$var$measureContext) $c8f894129d9fa0b9$var$measureContext = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(1, 1);
    return $c8f894129d9fa0b9$var$measureContext;
}
var $c8f894129d9fa0b9$export$4feaf6852ff92513 = function() {
    var span;
    var heights = $c8f894129d9fa0b9$export$7fdcec604f0b1fa7;
    return function(font) {
        var height = heights[font];
        if (height == undefined) {
            if (!span) {
                span = document.createElement("span");
                span.textContent = "M";
                span.style.margin = span.style.padding = "0 !important";
                span.style.position = "absolute !important";
                span.style.left = "-99999px !important";
            }
            span.style.font = font;
            document.body.appendChild(span);
            height = heights[font] = span.offsetHeight;
            document.body.removeChild(span);
        }
        return height;
    };
}();
function $c8f894129d9fa0b9$export$4ea92329b673abd1(font, text) {
    var measureContext = $c8f894129d9fa0b9$var$getMeasureContext();
    if (font != measureContext.font) measureContext.font = font;
    return measureContext.measureText(text).width;
}
function $c8f894129d9fa0b9$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
var $c8f894129d9fa0b9$export$d601bed2da9f1374 = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
function $c8f894129d9fa0b9$export$21a059be5bfd5fb(context, transform, opacity, image, originX, originY, w, h, x, y, scale) {
    var alpha;
    if (opacity != 1) {
        alpha = context.globalAlpha;
        context.globalAlpha = alpha * opacity;
    }
    if (transform) context.setTransform.apply(context, transform);
    context.drawImage(image, originX, originY, w, h, x, y, w * scale, h * scale);
    if (alpha) context.globalAlpha = alpha;
    if (transform) context.setTransform.apply(context, $c8f894129d9fa0b9$export$d601bed2da9f1374);
}


/**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?

/**
 * @module ol/colorlike
 */ /**
 * @module ol/color
 */ 

/**
 * A color represented as a short array [red, green, blue, alpha].
 * red, green, and blue should be integers in the range 0..255 inclusive.
 * alpha should be a float in the range 0..1 inclusive. If no alpha value is
 * given then `1` will be used.
 * @typedef {Array<number>} Color
 * @api
 */ /**
 * This RegExp matches # followed by 3, 4, 6, or 8 hex digits.
 * @const
 * @type {RegExp}
 * @private
 */ var $2c17bfc916c8f689$var$HEX_COLOR_RE_ = /^#([a-f0-9]{3}|[a-f0-9]{4}(?:[a-f0-9]{2}){0,2})$/i;
/**
 * Regular expression for matching potential named color style strings.
 * @const
 * @type {RegExp}
 * @private
 */ var $2c17bfc916c8f689$var$NAMED_COLOR_RE_ = /^([a-z]*)$/i;
function $2c17bfc916c8f689$export$590567be997858b6(color) {
    if (typeof color === "string") return color;
    else return $2c17bfc916c8f689$export$f84e8e69fd4488a5(color);
}
/**
 * Return named color as an rgba string.
 * @param {string} color Named color.
 * @return {string} Rgb string.
 */ function $2c17bfc916c8f689$var$fromNamed(color) {
    var el = document.createElement("div");
    el.style.color = color;
    if (el.style.color !== "") {
        document.body.appendChild(el);
        var rgb = getComputedStyle(el).color;
        document.body.removeChild(el);
        return rgb;
    } else return "";
}
var $2c17bfc916c8f689$export$3004f64547af360e = function() {
    // We maintain a small cache of parsed strings.  To provide cheap LRU-like
    // semantics, whenever the cache grows too large we simply delete an
    // arbitrary 25% of the entries.
    /**
     * @const
     * @type {number}
     */ var MAX_CACHE_SIZE = 1024;
    /**
     * @type {Object<string, Color>}
     */ var cache = {};
    /**
     * @type {number}
     */ var cacheSize = 0;
    return(/**
       * @param {string} s String.
       * @return {Color} Color.
       */ function(s) {
        var color;
        if (cache.hasOwnProperty(s)) color = cache[s];
        else {
            if (cacheSize >= MAX_CACHE_SIZE) {
                var i = 0;
                for(var key in cache)if ((i++ & 3) === 0) {
                    delete cache[key];
                    --cacheSize;
                }
            }
            color = $2c17bfc916c8f689$var$fromStringInternal_(s);
            cache[s] = color;
            ++cacheSize;
        }
        return color;
    });
}();
function $2c17bfc916c8f689$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    else return $2c17bfc916c8f689$export$3004f64547af360e(color);
}
/**
 * @param {string} s String.
 * @private
 * @return {Color} Color.
 */ function $2c17bfc916c8f689$var$fromStringInternal_(s) {
    var r, g, b, a, color;
    if ($2c17bfc916c8f689$var$NAMED_COLOR_RE_.exec(s)) s = $2c17bfc916c8f689$var$fromNamed(s);
    if ($2c17bfc916c8f689$var$HEX_COLOR_RE_.exec(s)) {
        var n = s.length - 1; // number of hex digits
        var d; // number of digits per channel
        if (n <= 4) d = 1;
        else d = 2;
        var hasAlpha = n === 4 || n === 8;
        r = parseInt(s.substr(1 + 0 * d, d), 16);
        g = parseInt(s.substr(1 + 1 * d, d), 16);
        b = parseInt(s.substr(1 + 2 * d, d), 16);
        if (hasAlpha) a = parseInt(s.substr(1 + 3 * d, d), 16);
        else a = 255;
        if (d == 1) {
            r = (r << 4) + r;
            g = (g << 4) + g;
            b = (b << 4) + b;
            if (hasAlpha) a = (a << 4) + a;
        }
        color = [
            r,
            g,
            b,
            a / 255
        ];
    } else if (s.indexOf("rgba(") == 0) {
        color = s.slice(5, -1).split(",").map(Number);
        $2c17bfc916c8f689$export$a3295358bff77e(color);
    } else if (s.indexOf("rgb(") == 0) {
        color = s.slice(4, -1).split(",").map(Number);
        color.push(1);
        $2c17bfc916c8f689$export$a3295358bff77e(color);
    } else (0, $b6052fc13e9a3991$export$a7a9523472993e97)(false, 14); // Invalid color
    return color;
}
function $2c17bfc916c8f689$export$a3295358bff77e(color) {
    color[0] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(color[0] + 0.5 | 0, 0, 255);
    color[1] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(color[1] + 0.5 | 0, 0, 255);
    color[2] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(color[2] + 0.5 | 0, 0, 255);
    color[3] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(color[3], 0, 1);
    return color;
}
function $2c17bfc916c8f689$export$f84e8e69fd4488a5(color) {
    var r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    var g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    var b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    var a = color[3] === undefined ? 1 : color[3];
    return "rgba(" + r + "," + g + "," + b + "," + a + ")";
}


function $51e4a33855e1d867$export$dc5b1400ac3a10a8(color) {
    if (Array.isArray(color)) return (0, $2c17bfc916c8f689$export$f84e8e69fd4488a5)(color);
    else return color;
}







/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ var $37298fa487b80ee5$var$VectorContext = function VectorContext() {};
$37298fa487b80ee5$var$VectorContext.prototype.drawCustom = function drawCustom(geometry, feature, renderer) {};
/**
 * Render a geometry.
 *
 * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
 */ $37298fa487b80ee5$var$VectorContext.prototype.drawGeometry = function drawGeometry(geometry) {};
/**
 * Set the rendering style.
 *
 * @param {import("../style/Style.js").default} style The rendering style.
 */ $37298fa487b80ee5$var$VectorContext.prototype.setStyle = function setStyle(style) {};
/**
 * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
 * @param {import("../Feature.js").default} feature Feature.
 */ $37298fa487b80ee5$var$VectorContext.prototype.drawCircle = function drawCircle(circleGeometry, feature) {};
/**
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 */ $37298fa487b80ee5$var$VectorContext.prototype.drawFeature = function drawFeature(feature, style) {};
/**
 * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
 * @param {import("../Feature.js").default} feature Feature.
 */ $37298fa487b80ee5$var$VectorContext.prototype.drawGeometryCollection = function drawGeometryCollection(geometryCollectionGeometry, feature) {};
/**
 * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
 */ $37298fa487b80ee5$var$VectorContext.prototype.drawLineString = function drawLineString(lineStringGeometry, feature) {};
/**
 * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
 */ $37298fa487b80ee5$var$VectorContext.prototype.drawMultiLineString = function drawMultiLineString(multiLineStringGeometry, feature) {};
/**
 * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
 */ $37298fa487b80ee5$var$VectorContext.prototype.drawMultiPoint = function drawMultiPoint(multiPointGeometry, feature) {};
/**
 * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
 */ $37298fa487b80ee5$var$VectorContext.prototype.drawMultiPolygon = function drawMultiPolygon(multiPolygonGeometry, feature) {};
/**
 * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
 */ $37298fa487b80ee5$var$VectorContext.prototype.drawPoint = function drawPoint(pointGeometry, feature) {};
/**
 * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
 */ $37298fa487b80ee5$var$VectorContext.prototype.drawPolygon = function drawPolygon(polygonGeometry, feature) {};
/**
 * @param {import("../geom/Geometry.js").default|import("./Feature.js").default} geometry Geometry.
 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
 */ $37298fa487b80ee5$var$VectorContext.prototype.drawText = function drawText(geometry, feature) {};
/**
 * @param {import("../style/Fill.js").default} fillStyle Fill style.
 * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
 */ $37298fa487b80ee5$var$VectorContext.prototype.setFillStrokeStyle = function setFillStrokeStyle(fillStyle, strokeStyle) {};
/**
 * @param {import("../style/Image.js").default} imageStyle Image style.
 * @param {import("./canvas.js").DeclutterGroup=} opt_declutterGroup Declutter.
 */ $37298fa487b80ee5$var$VectorContext.prototype.setImageStyle = function setImageStyle(imageStyle, opt_declutterGroup) {};
/**
 * @param {import("../style/Text.js").default} textStyle Text style.
 * @param {import("./canvas.js").DeclutterGroup=} opt_declutterGroup Declutter.
 */ $37298fa487b80ee5$var$VectorContext.prototype.setTextStyle = function setTextStyle(textStyle, opt_declutterGroup) {};
var $37298fa487b80ee5$export$2e2bcd8739ae039 = $37298fa487b80ee5$var$VectorContext;




/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ var $38d7ec0eb2f8558c$var$CanvasImmediateRenderer = /*@__PURE__*/ function(VectorContext) {
    function CanvasImmediateRenderer(context, pixelRatio, extent, transform, viewRotation) {
        VectorContext.call(this);
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.context_ = context;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.extent_ = extent;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = transform;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = viewRotation;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.contextFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.contextStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.contextTextState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.fillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.strokeState_ = null;
        /**
     * @private
     * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
     */ this.image_ = null;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorY_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageHeight_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOpacity_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.imageRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.imageRotation_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageScale_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageWidth_ = 0;
        /**
     * @private
     * @type {string}
     */ this.text_ = "";
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.textRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textScale_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.textState_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = [];
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpLocalTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
    }
    if (VectorContext) CanvasImmediateRenderer.__proto__ = VectorContext;
    CanvasImmediateRenderer.prototype = Object.create(VectorContext && VectorContext.prototype);
    CanvasImmediateRenderer.prototype.constructor = CanvasImmediateRenderer;
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ CanvasImmediateRenderer.prototype.drawImages_ = function drawImages_(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        var pixelCoordinates = (0, $24a54079104c80a7$export$b92b2dedcfff79de)(flatCoordinates, offset, end, 2, this.transform_, this.pixelCoordinates_);
        var context = this.context_;
        var localTransform = this.tmpLocalTransform_;
        var alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        var rotation = this.imageRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(var i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            var x = pixelCoordinates[i] - this.imageAnchorX_;
            var y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_ != 1) {
                var centerX = x + this.imageAnchorX_;
                var centerY = y + this.imageAnchorY_;
                (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(localTransform, centerX, centerY, this.imageScale_, this.imageScale_, rotation, -centerX, -centerY);
                context.setTransform.apply(context, localTransform);
            }
            context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (rotation !== 0 || this.imageScale_ != 1) context.setTransform(1, 0, 0, 1, 0, 0);
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    };
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ CanvasImmediateRenderer.prototype.drawText_ = function drawText_(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === "") return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        var pixelCoordinates = (0, $24a54079104c80a7$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        var context = this.context_;
        var rotation = this.textRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            var x = pixelCoordinates[offset] + this.textOffsetX_;
            var y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_ != 1) {
                var localTransform = (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.tmpLocalTransform_, x, y, this.textScale_, this.textScale_, rotation, -x, -y);
                context.setTransform.apply(context, localTransform);
            }
            if (this.textStrokeState_) context.strokeText(this.text_, x, y);
            if (this.textFillState_) context.fillText(this.text_, x, y);
        }
        if (rotation !== 0 || this.textScale_ != 1) context.setTransform(1, 0, 0, 1, 0, 0);
    };
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @private
   * @return {number} end End.
   */ CanvasImmediateRenderer.prototype.moveToLineTo_ = function moveToLineTo_(flatCoordinates, offset, end, stride, close) {
        var context = this.context_;
        var pixelCoordinates = (0, $24a54079104c80a7$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        var length = pixelCoordinates.length;
        if (close) length -= 2;
        for(var i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    };
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ CanvasImmediateRenderer.prototype.drawRings_ = function drawRings_(flatCoordinates, offset, ends, stride) {
        for(var i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
        return offset;
    };
    /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @override
   * @api
   */ CanvasImmediateRenderer.prototype.drawCircle = function drawCircle(geometry) {
        if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            var pixelCoordinates = (0, $ce25558341ea2841$export$a3767472617c7861)(geometry, this.transform_, this.pixelCoordinates_);
            var dx = pixelCoordinates[2] - pixelCoordinates[0];
            var dy = pixelCoordinates[3] - pixelCoordinates[1];
            var radius = Math.sqrt(dx * dx + dy * dy);
            var context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== "") this.drawText_(geometry.getCenter(), 0, 2, 2);
    };
    /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @override
   * @api
   */ CanvasImmediateRenderer.prototype.setStyle = function setStyle(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    };
    /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate#setStyle} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @override
   * @api
   */ CanvasImmediateRenderer.prototype.drawGeometry = function drawGeometry(geometry) {
        var type = geometry.getType();
        switch(type){
            case (0, $8826602b1d512d67$export$2e2bcd8739ae039).POINT:
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case (0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING:
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case (0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON:
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POINT:
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_LINE_STRING:
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POLYGON:
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case (0, $8826602b1d512d67$export$2e2bcd8739ae039).GEOMETRY_COLLECTION:
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case (0, $8826602b1d512d67$export$2e2bcd8739ae039).CIRCLE:
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    };
    /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @override
   * @api
   */ CanvasImmediateRenderer.prototype.drawFeature = function drawFeature(feature, style) {
        var geometry = style.getGeometryFunction()(feature);
        if (!geometry || !(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    };
    /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   * @override
   */ CanvasImmediateRenderer.prototype.drawGeometryCollection = function drawGeometryCollection(geometry) {
        var geometries = geometry.getGeometriesArray();
        for(var i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    };
    /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   * @override
   */ CanvasImmediateRenderer.prototype.drawPoint = function drawPoint(geometry) {
        var flatCoordinates = geometry.getFlatCoordinates();
        var stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== "") this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    };
    /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   * @override
   */ CanvasImmediateRenderer.prototype.drawMultiPoint = function drawMultiPoint(geometry) {
        var flatCoordinates = geometry.getFlatCoordinates();
        var stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== "") this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    };
    /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   * @override
   */ CanvasImmediateRenderer.prototype.drawLineString = function drawLineString(geometry) {
        if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            var flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false);
            context.stroke();
        }
        if (this.text_ !== "") {
            var flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    };
    /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   * @override
   */ CanvasImmediateRenderer.prototype.drawMultiLineString = function drawMultiLineString(geometry) {
        var geometryExtent = geometry.getExtent();
        if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            var flatCoordinates = geometry.getFlatCoordinates();
            var offset = 0;
            var ends = /** @type {Array<number>} */ geometry.getEnds();
            var stride = geometry.getStride();
            context.beginPath();
            for(var i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
            context.stroke();
        }
        if (this.text_ !== "") {
            var flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    };
    /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   * @override
   */ CanvasImmediateRenderer.prototype.drawPolygon = function drawPolygon(geometry) {
        if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride());
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== "") {
            var flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    };
    /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   * @override
   */ CanvasImmediateRenderer.prototype.drawMultiPolygon = function drawMultiPolygon(geometry) {
        if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            var flatCoordinates = geometry.getOrientedFlatCoordinates();
            var offset = 0;
            var endss = geometry.getEndss();
            var stride = geometry.getStride();
            context.beginPath();
            for(var i = 0, ii = endss.length; i < ii; ++i){
                var ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== "") {
            var flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    };
    /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */ CanvasImmediateRenderer.prototype.setContextFillState_ = function setContextFillState_(fillState) {
        var context = this.context_;
        var contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) contextFillState.fillStyle = context.fillStyle = fillState.fillStyle;
    };
    /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */ CanvasImmediateRenderer.prototype.setContextStrokeState_ = function setContextStrokeState_(strokeState) {
        var context = this.context_;
        var contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = /** @type {CanvasLineCap} */ strokeState.lineCap;
            if (0, $89969764a1196844$export$c986c2374f97af1a) {
                context.setLineDash(strokeState.lineDash);
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            context.lineJoin = /** @type {CanvasLineJoin} */ strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) contextStrokeState.lineCap = context.lineCap = /** @type {CanvasLineCap} */ strokeState.lineCap;
            if (0, $89969764a1196844$export$c986c2374f97af1a) {
                if (!(0, $830d23b8323fc080$export$e9bab7fafb253603)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
                if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) contextStrokeState.lineDashOffset = context.lineDashOffset = strokeState.lineDashOffset;
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) contextStrokeState.lineJoin = context.lineJoin = /** @type {CanvasLineJoin} */ strokeState.lineJoin;
            if (contextStrokeState.lineWidth != strokeState.lineWidth) contextStrokeState.lineWidth = context.lineWidth = strokeState.lineWidth;
            if (contextStrokeState.miterLimit != strokeState.miterLimit) contextStrokeState.miterLimit = context.miterLimit = strokeState.miterLimit;
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) contextStrokeState.strokeStyle = context.strokeStyle = strokeState.strokeStyle;
        }
    };
    /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */ CanvasImmediateRenderer.prototype.setContextTextState_ = function setContextTextState_(textState) {
        var context = this.context_;
        var contextTextState = this.contextTextState_;
        var textAlign = textState.textAlign ? textState.textAlign : (0, $c8f894129d9fa0b9$export$94d53b95641b5766);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = /** @type {CanvasTextAlign} */ textAlign;
            context.textBaseline = /** @type {CanvasTextBaseline} */ textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) contextTextState.font = context.font = textState.font;
            if (contextTextState.textAlign != textAlign) contextTextState.textAlign = context.textAlign = /** @type {CanvasTextAlign} */ textAlign;
            if (contextTextState.textBaseline != textState.textBaseline) contextTextState.textBaseline = context.textBaseline = /** @type {CanvasTextBaseline} */ textState.textBaseline;
        }
    };
    /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ CanvasImmediateRenderer.prototype.setFillStrokeStyle = function setFillStrokeStyle(fillStyle, strokeStyle) {
        if (!fillStyle) this.fillState_ = null;
        else {
            var fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            var strokeStyleColor = strokeStyle.getColor();
            var strokeStyleLineCap = strokeStyle.getLineCap();
            var strokeStyleLineDash = strokeStyle.getLineDash();
            var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            var strokeStyleLineJoin = strokeStyle.getLineJoin();
            var strokeStyleWidth = strokeStyle.getWidth();
            var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $c8f894129d9fa0b9$export$17bd0c38d6ae694e),
                lineDash: strokeStyleLineDash ? strokeStyleLineDash : (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc),
                lineDashOffset: strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $c8f894129d9fa0b9$export$e06efc2409049f76),
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $c8f894129d9fa0b9$export$365eb9648cf19bd0),
                lineWidth: this.pixelRatio_ * (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $c8f894129d9fa0b9$export$79661f132c62010e)),
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $c8f894129d9fa0b9$export$80c1c01844597b7b),
                strokeStyle: (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $c8f894129d9fa0b9$export$1eb2eaecacf2031e))
            };
        }
    };
    /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @override
   */ CanvasImmediateRenderer.prototype.setImageStyle = function setImageStyle(imageStyle) {
        if (!imageStyle) this.image_ = null;
        else {
            var imageAnchor = imageStyle.getAnchor();
            // FIXME pixel ratio
            var imageImage = imageStyle.getImage(1);
            var imageOrigin = imageStyle.getOrigin();
            var imageSize = imageStyle.getSize();
            this.imageAnchorX_ = imageAnchor[0];
            this.imageAnchorY_ = imageAnchor[1];
            this.imageHeight_ = imageSize[1];
            this.image_ = imageImage;
            this.imageOpacity_ = imageStyle.getOpacity();
            this.imageOriginX_ = imageOrigin[0];
            this.imageOriginY_ = imageOrigin[1];
            this.imageRotateWithView_ = imageStyle.getRotateWithView();
            this.imageRotation_ = imageStyle.getRotation();
            this.imageScale_ = imageStyle.getScale() * this.pixelRatio_;
            this.imageWidth_ = imageSize[0];
        }
    };
    /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @override
   */ CanvasImmediateRenderer.prototype.setTextStyle = function setTextStyle(textStyle) {
        if (!textStyle) this.text_ = "";
        else {
            var textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                var textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(textFillStyleColor ? textFillStyleColor : (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2))
                };
            }
            var textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                var textStrokeStyleColor = textStrokeStyle.getColor();
                var textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                var textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                var textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                var textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                var textStrokeStyleWidth = textStrokeStyle.getWidth();
                var textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $c8f894129d9fa0b9$export$17bd0c38d6ae694e),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $c8f894129d9fa0b9$export$e06efc2409049f76),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $c8f894129d9fa0b9$export$365eb9648cf19bd0),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $c8f894129d9fa0b9$export$79661f132c62010e),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $c8f894129d9fa0b9$export$80c1c01844597b7b),
                    strokeStyle: (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(textStrokeStyleColor ? textStrokeStyleColor : (0, $c8f894129d9fa0b9$export$1eb2eaecacf2031e))
                };
            }
            var textFont = textStyle.getFont();
            var textOffsetX = textStyle.getOffsetX();
            var textOffsetY = textStyle.getOffsetY();
            var textRotateWithView = textStyle.getRotateWithView();
            var textRotation = textStyle.getRotation();
            var textScale = textStyle.getScale();
            var textText = textStyle.getText();
            var textTextAlign = textStyle.getTextAlign();
            var textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, $c8f894129d9fa0b9$export$3847dfea4f8d4dfa),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, $c8f894129d9fa0b9$export$94d53b95641b5766),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $c8f894129d9fa0b9$export$cf2279a1bff62eb)
            };
            this.text_ = textText !== undefined ? textText : "";
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = this.pixelRatio_ * (textScale !== undefined ? textScale : 1);
        }
    };
    return CanvasImmediateRenderer;
}((0, $37298fa487b80ee5$export$2e2bcd8739ae039));
var $38d7ec0eb2f8558c$export$2e2bcd8739ae039 = $38d7ec0eb2f8558c$var$CanvasImmediateRenderer;


/**
 * @module ol/renderer/Map
 */ 






/**
 * @module ol/style/IconImageCache
 */ 
/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache~shared}.
 */ var $20f070df2eea68ee$var$IconImageCache = function IconImageCache() {
    /**
  * @type {!Object<string, import("./IconImage.js").default>}
  * @private
  */ this.cache_ = {};
    /**
  * @type {number}
  * @private
  */ this.cacheSize_ = 0;
    /**
  * @type {number}
  * @private
  */ this.maxCacheSize_ = 32;
};
/**
* FIXME empty description for jsdoc
*/ $20f070df2eea68ee$var$IconImageCache.prototype.clear = function clear() {
    this.cache_ = {};
    this.cacheSize_ = 0;
};
/**
* FIXME empty description for jsdoc
*/ $20f070df2eea68ee$var$IconImageCache.prototype.expire = function expire() {
    if (this.cacheSize_ > this.maxCacheSize_) {
        var i = 0;
        for(var key in this.cache_){
            var iconImage = this.cache_[key];
            if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                delete this.cache_[key];
                --this.cacheSize_;
            }
        }
    }
};
/**
* @param {string} src Src.
* @param {?string} crossOrigin Cross origin.
* @param {import("../color.js").Color} color Color.
* @return {import("./IconImage.js").default} Icon image.
*/ $20f070df2eea68ee$var$IconImageCache.prototype.get = function get(src, crossOrigin, color) {
    var key = $20f070df2eea68ee$var$getKey(src, crossOrigin, color);
    return key in this.cache_ ? this.cache_[key] : null;
};
/**
* @param {string} src Src.
* @param {?string} crossOrigin Cross origin.
* @param {import("../color.js").Color} color Color.
* @param {import("./IconImage.js").default} iconImage Icon image.
*/ $20f070df2eea68ee$var$IconImageCache.prototype.set = function set(src, crossOrigin, color, iconImage) {
    var key = $20f070df2eea68ee$var$getKey(src, crossOrigin, color);
    this.cache_[key] = iconImage;
    ++this.cacheSize_;
};
/**
* Set the cache size of the icon cache. Default is `32`. Change this value when
* your map uses more than 32 different icon images and you are not caching icon
* styles on the application level.
* @param {number} maxCacheSize Cache max size.
* @api
*/ $20f070df2eea68ee$var$IconImageCache.prototype.setSize = function setSize(maxCacheSize) {
    this.maxCacheSize_ = maxCacheSize;
    this.expire();
};
/**
 * @param {string} src Src.
 * @param {?string} crossOrigin Cross origin.
 * @param {import("../color.js").Color} color Color.
 * @return {string} Cache key.
 */ function $20f070df2eea68ee$var$getKey(src, crossOrigin, color) {
    var colorString = color ? (0, $2c17bfc916c8f689$export$590567be997858b6)(color) : "null";
    return crossOrigin + ":" + src + ":" + colorString;
}
var $20f070df2eea68ee$export$2e2bcd8739ae039 = $20f070df2eea68ee$var$IconImageCache;
var $20f070df2eea68ee$export$747ccdf771a87ab8 = new $20f070df2eea68ee$var$IconImageCache();



/**
 * @abstract
 */ var $74336bc6031ad34b$var$MapRenderer = /*@__PURE__*/ function(Disposable) {
    function MapRenderer(map) {
        Disposable.call(this);
        /**
     * @private
     * @type {import("../PluggableMap.js").default}
     */ this.map_ = map;
        /**
     * @private
     * @type {!Object<string, import("./Layer.js").default>}
     */ this.layerRenderers_ = {};
        /**
     * @private
     * @type {Object<string, import("../events.js").EventsKey>}
     */ this.layerRendererListeners_ = {};
        /**
     * @private
     * @type {Array<typeof import("./Layer.js").default>}
     */ this.layerRendererConstructors_ = [];
    }
    if (Disposable) MapRenderer.__proto__ = Disposable;
    MapRenderer.prototype = Object.create(Disposable && Disposable.prototype);
    MapRenderer.prototype.constructor = MapRenderer;
    /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   */ MapRenderer.prototype.dispatchRenderEvent = function dispatchRenderEvent(type, frameState) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Register layer renderer constructors.
   * @param {Array<typeof import("./Layer.js").default>} constructors Layer renderers.
   */ MapRenderer.prototype.registerLayerRenderers = function registerLayerRenderers(constructors) {
        this.layerRendererConstructors_.push.apply(this.layerRendererConstructors_, constructors);
    };
    /**
   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
   * @protected
   */ MapRenderer.prototype.calculateMatrices2D = function calculateMatrices2D(frameState) {
        var viewState = frameState.viewState;
        var coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        var pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, $2567d97ab31c5663$export$6897c284b6f9f4dc)((0, $2567d97ab31c5663$export$42b4187a82d80ed0)(pixelToCoordinateTransform, coordinateToPixelTransform));
    };
    /**
   * Removes all layer renderers.
   */ MapRenderer.prototype.removeLayerRenderers = function removeLayerRenderers() {
        for(var key in this.layerRenderers_)this.removeLayerRendererByKey_(key).dispose();
    };
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(this: S, import("../Feature.js").FeatureLike,
   *     import("../layer/Layer.js").default): T} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ MapRenderer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, thisArg, layerFilter, thisArg2) {
        var result;
        var viewState = frameState.viewState;
        var viewResolution = viewState.resolution;
        /**
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @return {?} Callback result.
     */ function forEachFeatureAtCoordinate(feature, layer) {
            var managed = frameState.layerStates[(0, $34772e91e89a736f$export$5e82334337e0f204)(layer)].managed;
            if (!((0, $34772e91e89a736f$export$5e82334337e0f204)(feature) in frameState.skippedFeatureUids && !managed)) return callback.call(thisArg, feature, managed ? layer : null);
        }
        var projection = viewState.projection;
        var translatedCoordinate = coordinate;
        if (projection.canWrapX()) {
            var projectionExtent = projection.getExtent();
            var worldWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(projectionExtent);
            var x = coordinate[0];
            if (x < projectionExtent[0] || x > projectionExtent[2]) {
                var worldsAway = Math.ceil((projectionExtent[0] - x) / worldWidth);
                translatedCoordinate = [
                    x + worldWidth * worldsAway,
                    coordinate[1]
                ];
            }
        }
        var layerStates = frameState.layerStatesArray;
        var numLayers = layerStates.length;
        var i;
        for(i = numLayers - 1; i >= 0; --i){
            var layerState = layerStates[i];
            var layer = layerState.layer;
            if ((0, $575253350abb8238$export$791774a6af20d8cc)(layerState, viewResolution) && layerFilter.call(thisArg2, layer)) {
                var layerRenderer = this.getLayerRenderer(layer);
                var source = /** @type {import("../layer/Layer.js").default} */ layer.getSource();
                if (source) result = layerRenderer.forEachFeatureAtCoordinate(source.getWrapX() ? translatedCoordinate : coordinate, frameState, hitTolerance, forEachFeatureAtCoordinate);
                if (result) return result;
            }
        }
        return undefined;
    };
    /**
   * @abstract
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(this: S, import("../layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback Layer
   *     callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ MapRenderer.prototype.forEachLayerAtPixel = function forEachLayerAtPixel(pixel, frameState, hitTolerance, callback, thisArg, layerFilter, thisArg2) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */ MapRenderer.prototype.hasFeatureAtCoordinate = function hasFeatureAtCoordinate(coordinate, frameState, hitTolerance, layerFilter, thisArg) {
        var hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, (0, $de1052d9f293b73a$export$22e23a2304399231), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    };
    /**
   * @param {import("../layer/Base.js").default} layer Layer.
   * @protected
   * @return {import("./Layer.js").default} Layer renderer.
   */ MapRenderer.prototype.getLayerRenderer = function getLayerRenderer(layer) {
        var layerKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(layer);
        if (layerKey in this.layerRenderers_) return this.layerRenderers_[layerKey];
        else {
            var renderer;
            for(var i = 0, ii = this.layerRendererConstructors_.length; i < ii; ++i){
                var candidate = this.layerRendererConstructors_[i];
                if (candidate["handles"](layer)) {
                    renderer = candidate["create"](this, layer);
                    break;
                }
            }
            if (renderer) {
                this.layerRenderers_[layerKey] = renderer;
                this.layerRendererListeners_[layerKey] = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(renderer, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleLayerRendererChange_, this);
            } else throw new Error("Unable to create renderer for layer: " + layer.getType());
            return renderer;
        }
    };
    /**
   * @param {string} layerKey Layer key.
   * @protected
   * @return {import("./Layer.js").default} Layer renderer.
   */ MapRenderer.prototype.getLayerRendererByKey = function getLayerRendererByKey(layerKey) {
        return this.layerRenderers_[layerKey];
    };
    /**
   * @protected
   * @return {Object<string, import("./Layer.js").default>} Layer renderers.
   */ MapRenderer.prototype.getLayerRenderers = function getLayerRenderers() {
        return this.layerRenderers_;
    };
    /**
   * @return {import("../PluggableMap.js").default} Map.
   */ MapRenderer.prototype.getMap = function getMap() {
        return this.map_;
    };
    /**
   * Handle changes in a layer renderer.
   * @private
   */ MapRenderer.prototype.handleLayerRendererChange_ = function handleLayerRendererChange_() {
        this.map_.render();
    };
    /**
   * @param {string} layerKey Layer key.
   * @return {import("./Layer.js").default} Layer renderer.
   * @private
   */ MapRenderer.prototype.removeLayerRendererByKey_ = function removeLayerRendererByKey_(layerKey) {
        var layerRenderer = this.layerRenderers_[layerKey];
        delete this.layerRenderers_[layerKey];
        (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.layerRendererListeners_[layerKey]);
        delete this.layerRendererListeners_[layerKey];
        return layerRenderer;
    };
    /**
   * @param {import("../PluggableMap.js").default} map Map.
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   * @private
   */ MapRenderer.prototype.removeUnusedLayerRenderers_ = function removeUnusedLayerRenderers_(map, frameState) {
        for(var layerKey in this.layerRenderers_)if (!frameState || !(layerKey in frameState.layerStates)) this.removeLayerRendererByKey_(layerKey).dispose();
    };
    /**
   * Render.
   * @abstract
   * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
   */ MapRenderer.prototype.renderFrame = function renderFrame(frameState) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   * @protected
   */ MapRenderer.prototype.scheduleExpireIconCache = function scheduleExpireIconCache(frameState) {
        frameState.postRenderFunctions.push(/** @type {import("../PluggableMap.js").PostRenderFunction} */ $74336bc6031ad34b$var$expireIconCache);
    };
    /**
   * @param {!import("../PluggableMap.js").FrameState} frameState Frame state.
   * @protected
   */ MapRenderer.prototype.scheduleRemoveUnusedLayerRenderers = function scheduleRemoveUnusedLayerRenderers(frameState) {
        for(var layerKey in this.layerRenderers_)if (!(layerKey in frameState.layerStates)) {
            frameState.postRenderFunctions.push(/** @type {import("../PluggableMap.js").PostRenderFunction} */ this.removeUnusedLayerRenderers_.bind(this));
            return;
        }
    };
    return MapRenderer;
}((0, $17f88068b11f58ac$export$2e2bcd8739ae039));
/**
 * @param {import("../PluggableMap.js").default} map Map.
 * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
 */ function $74336bc6031ad34b$var$expireIconCache(map, frameState) {
    (0, $20f070df2eea68ee$export$747ccdf771a87ab8).expire();
}
function $74336bc6031ad34b$export$d8520e872d284878(state1, state2) {
    return state1.zIndex - state2.zIndex;
}
var $74336bc6031ad34b$export$2e2bcd8739ae039 = $74336bc6031ad34b$var$MapRenderer;



var $38a2f3b2ed67e329$export$3372ee2fc5fdeb09 = [];
/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ var $38a2f3b2ed67e329$var$CanvasMapRenderer = /*@__PURE__*/ function(MapRenderer) {
    function CanvasMapRenderer(map) {
        MapRenderer.call(this, map);
        var container = map.getViewport();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.context_ = (0, $755a3001f896bcf1$export$9e05d10eae75c464)();
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = this.context_.canvas;
        this.canvas_.style.width = "100%";
        this.canvas_.style.height = "100%";
        this.canvas_.style.display = "block";
        this.canvas_.className = (0, $bbcb4c1977b6e9f0$export$1afde3d6e16a7b29);
        container.insertBefore(this.canvas_, container.childNodes[0] || null);
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
    }
    if (MapRenderer) CanvasMapRenderer.__proto__ = MapRenderer;
    CanvasMapRenderer.prototype = Object.create(MapRenderer && MapRenderer.prototype);
    CanvasMapRenderer.prototype.constructor = CanvasMapRenderer;
    /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   */ CanvasMapRenderer.prototype.dispatchRenderEvent = function dispatchRenderEvent(type, frameState) {
        var map = this.getMap();
        var context = this.context_;
        if (map.hasListener(type)) {
            var extent = frameState.extent;
            var pixelRatio = frameState.pixelRatio;
            var viewState = frameState.viewState;
            var rotation = viewState.rotation;
            var transform = this.getTransform(frameState);
            var vectorContext = new (0, $38d7ec0eb2f8558c$export$2e2bcd8739ae039)(context, pixelRatio, extent, transform, rotation);
            var composeEvent = new (0, $802ec85cbdf20290$export$2e2bcd8739ae039)(type, vectorContext, frameState, context, null);
            map.dispatchEvent(composeEvent);
        }
    };
    /**
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ CanvasMapRenderer.prototype.getTransform = function getTransform(frameState) {
        var viewState = frameState.viewState;
        var dx1 = this.canvas_.width / 2;
        var dy1 = this.canvas_.height / 2;
        var sx = frameState.pixelRatio / viewState.resolution;
        var sy = -sx;
        var angle = -viewState.rotation;
        var dx2 = -viewState.center[0];
        var dy2 = -viewState.center[1];
        return (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.transform_, dx1, dy1, sx, sy, angle, dx2, dy2);
    };
    /**
   * @inheritDoc
   */ CanvasMapRenderer.prototype.renderFrame = function renderFrame(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.canvas_.style.display = "none";
                this.renderedVisible_ = false;
            }
            return;
        }
        var context = this.context_;
        var pixelRatio = frameState.pixelRatio;
        var width = Math.round(frameState.size[0] * pixelRatio);
        var height = Math.round(frameState.size[1] * pixelRatio);
        if (this.canvas_.width != width || this.canvas_.height != height) {
            this.canvas_.width = width;
            this.canvas_.height = height;
        } else context.clearRect(0, 0, width, height);
        var rotation = frameState.viewState.rotation;
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, $847c6e8c21904781$export$2e2bcd8739ae039).PRECOMPOSE, frameState);
        var layerStatesArray = frameState.layerStatesArray;
        (0, $830d23b8323fc080$export$c7d3d1f96a700512)(layerStatesArray, (0, $74336bc6031ad34b$export$d8520e872d284878));
        if (rotation) {
            context.save();
            (0, $c8f894129d9fa0b9$export$8ac4d72be78047e6)(context, rotation, width / 2, height / 2);
        }
        var viewResolution = frameState.viewState.resolution;
        var i, ii;
        for(i = 0, ii = layerStatesArray.length; i < ii; ++i){
            var layerState = layerStatesArray[i];
            var layer = layerState.layer;
            var layerRenderer = /** @type {import("./Layer.js").default} */ this.getLayerRenderer(layer);
            if (!(0, $575253350abb8238$export$791774a6af20d8cc)(layerState, viewResolution) || layerState.sourceState != (0, $7c2f117cb5c1ce12$export$2e2bcd8739ae039).READY) continue;
            if (layerRenderer.prepareFrame(frameState, layerState)) layerRenderer.composeFrame(frameState, layerState, context);
        }
        if (rotation) context.restore();
        this.dispatchRenderEvent((0, $847c6e8c21904781$export$2e2bcd8739ae039).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.canvas_.style.display = "";
            this.renderedVisible_ = true;
        }
        this.scheduleRemoveUnusedLayerRenderers(frameState);
        this.scheduleExpireIconCache(frameState);
    };
    /**
   * @inheritDoc
   */ CanvasMapRenderer.prototype.forEachLayerAtPixel = function forEachLayerAtPixel(pixel, frameState, hitTolerance, callback, thisArg, layerFilter, thisArg2) {
        var result;
        var viewState = frameState.viewState;
        var viewResolution = viewState.resolution;
        var layerStates = frameState.layerStatesArray;
        var numLayers = layerStates.length;
        var coordinate = (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        var i;
        for(i = numLayers - 1; i >= 0; --i){
            var layerState = layerStates[i];
            var layer = layerState.layer;
            if ((0, $575253350abb8238$export$791774a6af20d8cc)(layerState, viewResolution) && layerFilter.call(thisArg2, layer)) {
                var layerRenderer = /** @type {import("./Layer.js").default} */ this.getLayerRenderer(layer);
                result = layerRenderer.forEachLayerAtCoordinate(coordinate, frameState, hitTolerance, callback, thisArg);
                if (result) return result;
            }
        }
        return undefined;
    };
    /**
   * @inheritDoc
   */ CanvasMapRenderer.prototype.registerLayerRenderers = function registerLayerRenderers(constructors) {
        MapRenderer.prototype.registerLayerRenderers.call(this, constructors);
        for(var i = 0, ii = constructors.length; i < ii; ++i){
            var ctor = constructors[i];
            if (!(0, $830d23b8323fc080$export$ee2e0f811dca1807)($38a2f3b2ed67e329$export$3372ee2fc5fdeb09, ctor)) $38a2f3b2ed67e329$export$3372ee2fc5fdeb09.push(ctor);
        }
    };
    return CanvasMapRenderer;
}((0, $74336bc6031ad34b$export$2e2bcd8739ae039));
var $38a2f3b2ed67e329$export$2e2bcd8739ae039 = $38a2f3b2ed67e329$var$CanvasMapRenderer;


/**
 * @module ol/renderer/canvas/IntermediateCanvas
 */ 



/**
 * @module ol/renderer/canvas/Layer
 */ 






/**
 * @module ol/renderer/Layer
 */ 






var $2151efd61380bcce$var$LayerRenderer = /*@__PURE__*/ function(Observable) {
    function LayerRenderer(layer) {
        Observable.call(this);
        /**
     * @private
     * @type {import("../layer/Layer.js").default}
     */ this.layer_ = layer;
    }
    if (Observable) LayerRenderer.__proto__ = Observable;
    LayerRenderer.prototype = Object.create(Observable && Observable.prototype);
    LayerRenderer.prototype.constructor = LayerRenderer;
    /**
   * Create a function that adds loaded tiles to the tile lookup.
   * @param {import("../source/Tile.js").default} source Tile source.
   * @param {import("../proj/Projection.js").default} projection Projection of the tiles.
   * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @return {function(number, import("../TileRange.js").default):boolean} A function that can be
   *     called with a zoom level and a tile range to add loaded tiles to the lookup.
   * @protected
   */ LayerRenderer.prototype.createLoadedTileFinder = function createLoadedTileFinder(source, projection, tiles) {
        return(/**
       * @param {number} zoom Zoom level.
       * @param {import("../TileRange.js").default} tileRange Tile range.
       * @return {boolean} The tile range is fully loaded.
       */ function(zoom, tileRange) {
            /**
         * @param {import("../Tile.js").default} tile Tile.
         */ function callback(tile) {
                if (!tiles[zoom]) tiles[zoom] = {};
                tiles[zoom][tile.tileCoord.toString()] = tile;
            }
            return source.forEachLoadedTile(projection, zoom, tileRange, callback);
        });
    };
    /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default): T} callback Feature callback.
   * @return {T|void} Callback result.
   * @template T
   */ LayerRenderer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback) {};
    /**
   * @return {import("../layer/Layer.js").default} Layer.
   */ LayerRenderer.prototype.getLayer = function getLayer() {
        return this.layer_;
    };
    /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */ LayerRenderer.prototype.handleImageChange_ = function handleImageChange_(event) {
        var image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED) this.renderIfReadyAndVisible();
    };
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   * @return {boolean} Is there a feature at the given coordinate?
   */ LayerRenderer.prototype.hasFeatureAtCoordinate = function hasFeatureAtCoordinate(coordinate, frameState) {
        return false;
    };
    /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../ImageBase.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */ LayerRenderer.prototype.loadImage = function loadImage(image) {
        var imageState = image.getState();
        if (imageState != (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED && imageState != (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR) (0, $37a5c0af9052e360$export$63174c828edd6ff8)(image, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleImageChange_, this);
        if (imageState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED;
    };
    /**
   * @protected
   */ LayerRenderer.prototype.renderIfReadyAndVisible = function renderIfReadyAndVisible() {
        var layer = this.getLayer();
        if (layer.getVisible() && layer.getSourceState() == (0, $7c2f117cb5c1ce12$export$2e2bcd8739ae039).READY) this.changed();
    };
    /**
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("../source/Tile.js").default} tileSource Tile source.
   * @protected
   */ LayerRenderer.prototype.scheduleExpireCache = function scheduleExpireCache(frameState, tileSource) {
        if (tileSource.canExpireCache()) {
            /**
       * @param {import("../source/Tile.js").default} tileSource Tile source.
       * @param {import("../PluggableMap.js").default} map Map.
       * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
       */ var postRenderFunction = (function(tileSource, map, frameState) {
                var tileSourceKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(tileSource);
                if (tileSourceKey in frameState.usedTiles) tileSource.expireCache(frameState.viewState.projection, frameState.usedTiles[tileSourceKey]);
            }).bind(null, tileSource);
            frameState.postRenderFunctions.push(/** @type {import("../PluggableMap.js").PostRenderFunction} */ postRenderFunction);
        }
    };
    /**
   * @param {!Object<string, !Object<string, import("../TileRange.js").default>>} usedTiles Used tiles.
   * @param {import("../source/Tile.js").default} tileSource Tile source.
   * @param {number} z Z.
   * @param {import("../TileRange.js").default} tileRange Tile range.
   * @protected
   */ LayerRenderer.prototype.updateUsedTiles = function updateUsedTiles(usedTiles, tileSource, z, tileRange) {
        // FIXME should we use tilesToDrawByZ instead?
        var tileSourceKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(tileSource);
        var zKey = z.toString();
        if (tileSourceKey in usedTiles) {
            if (zKey in usedTiles[tileSourceKey]) usedTiles[tileSourceKey][zKey].extend(tileRange);
            else usedTiles[tileSourceKey][zKey] = tileRange;
        } else {
            usedTiles[tileSourceKey] = {};
            usedTiles[tileSourceKey][zKey] = tileRange;
        }
    };
    /**
   * Manage tile pyramid.
   * This function performs a number of functions related to the tiles at the
   * current zoom and lower zoom levels:
   * - registers idle tiles in frameState.wantedTiles so that they are not
   *   discarded by the tile queue
   * - enqueues missing tiles
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("../source/Tile.js").default} tileSource Tile source.
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid Tile grid.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} currentZ Current Z.
   * @param {number} preload Load low resolution tiles up to 'preload' levels.
   * @param {function(this: T, import("../Tile.js").default)=} opt_tileCallback Tile callback.
   * @param {T=} opt_this Object to use as `this` in `opt_tileCallback`.
   * @protected
   * @template T
   */ LayerRenderer.prototype.manageTilePyramid = function manageTilePyramid(frameState, tileSource, tileGrid, pixelRatio, projection, extent, currentZ, preload, opt_tileCallback, opt_this) {
        var tileSourceKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        var wantedTiles = frameState.wantedTiles[tileSourceKey];
        var tileQueue = frameState.tileQueue;
        var minZoom = tileGrid.getMinZoom();
        var tile, tileRange, tileResolution, x, y, z;
        for(z = minZoom; z <= currentZ; ++z){
            tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, tileRange);
            tileResolution = tileGrid.getResolution(z);
            for(x = tileRange.minX; x <= tileRange.maxX; ++x){
                for(y = tileRange.minY; y <= tileRange.maxY; ++y)if (currentZ - z <= preload) {
                    tile = tileSource.getTile(z, x, y, pixelRatio, projection);
                    if (tile.getState() == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE) {
                        wantedTiles[tile.getKey()] = true;
                        if (!tileQueue.isKeyQueued(tile.getKey())) tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tile.tileCoord),
                            tileResolution
                        ]);
                    }
                    if (opt_tileCallback !== undefined) opt_tileCallback.call(opt_this, tile);
                } else tileSource.useTile(z, x, y, projection);
            }
        }
    };
    return LayerRenderer;
}((0, $5cf0b3202980c59c$export$2e2bcd8739ae039));
var $2151efd61380bcce$export$2e2bcd8739ae039 = $2151efd61380bcce$var$LayerRenderer;



/**
 * @abstract
 */ var $22aba15f167ce2ee$var$CanvasLayerRenderer = /*@__PURE__*/ function(LayerRenderer) {
    function CanvasLayerRenderer(layer) {
        LayerRenderer.call(this, layer);
        /**
     * @protected
     * @type {number}
     */ this.renderedResolution;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
    }
    if (LayerRenderer) CanvasLayerRenderer.__proto__ = LayerRenderer;
    CanvasLayerRenderer.prototype = Object.create(LayerRenderer && LayerRenderer.prototype);
    CanvasLayerRenderer.prototype.constructor = CanvasLayerRenderer;
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */ CanvasLayerRenderer.prototype.clip = function clip(context, frameState, extent) {
        var pixelRatio = frameState.pixelRatio;
        var width = frameState.size[0] * pixelRatio;
        var height = frameState.size[1] * pixelRatio;
        var rotation = frameState.viewState.rotation;
        var topLeft = (0, $7e819822b33b3d32$export$cb1538b07e6964ff)(extent);
        var topRight = (0, $7e819822b33b3d32$export$b84fa077c8b05295)(extent);
        var bottomRight = (0, $7e819822b33b3d32$export$e77c1cf70445e168)(extent);
        var bottomLeft = (0, $7e819822b33b3d32$export$8d09f5e2e1bf560d)(extent);
        (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topLeft);
        (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topRight);
        (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomLeft);
        context.save();
        (0, $c8f894129d9fa0b9$export$8ac4d72be78047e6)(context, -rotation, width / 2, height / 2);
        context.beginPath();
        context.moveTo(topLeft[0] * pixelRatio, topLeft[1] * pixelRatio);
        context.lineTo(topRight[0] * pixelRatio, topRight[1] * pixelRatio);
        context.lineTo(bottomRight[0] * pixelRatio, bottomRight[1] * pixelRatio);
        context.lineTo(bottomLeft[0] * pixelRatio, bottomLeft[1] * pixelRatio);
        context.clip();
        (0, $c8f894129d9fa0b9$export$8ac4d72be78047e6)(context, rotation, width / 2, height / 2);
    };
    /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("../../transform.js").Transform=} opt_transform Transform.
   * @private
   */ CanvasLayerRenderer.prototype.dispatchComposeEvent_ = function dispatchComposeEvent_(type, context, frameState, opt_transform) {
        var layer = this.getLayer();
        if (layer.hasListener(type)) {
            var width = frameState.size[0] * frameState.pixelRatio;
            var height = frameState.size[1] * frameState.pixelRatio;
            var rotation = frameState.viewState.rotation;
            (0, $c8f894129d9fa0b9$export$8ac4d72be78047e6)(context, -rotation, width / 2, height / 2);
            var transform = opt_transform !== undefined ? opt_transform : this.getTransform(frameState, 0);
            var render = new (0, $38d7ec0eb2f8558c$export$2e2bcd8739ae039)(context, frameState.pixelRatio, frameState.extent, transform, frameState.viewState.rotation);
            var composeEvent = new (0, $802ec85cbdf20290$export$2e2bcd8739ae039)(type, render, frameState, context, null);
            layer.dispatchEvent(composeEvent);
            (0, $c8f894129d9fa0b9$export$8ac4d72be78047e6)(context, rotation, width / 2, height / 2);
        }
    };
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../PluggableMap.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(this: S, import("../../layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback Layer
   *     callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ CanvasLayerRenderer.prototype.forEachLayerAtCoordinate = function forEachLayerAtCoordinate(coordinate, frameState, hitTolerance, callback, thisArg) {
        var hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, (0, $de1052d9f293b73a$export$22e23a2304399231));
        if (hasFeature) return callback.call(thisArg, this.getLayer(), null);
        else return undefined;
    };
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("../../layer/Layer.js").State} layerState Layer state.
   * @param {import("../../transform.js").Transform=} opt_transform Transform.
   * @protected
   */ CanvasLayerRenderer.prototype.postCompose = function postCompose(context, frameState, layerState, opt_transform) {
        this.dispatchComposeEvent_((0, $847c6e8c21904781$export$2e2bcd8739ae039).POSTCOMPOSE, context, frameState, opt_transform);
    };
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("../../transform.js").Transform=} opt_transform Transform.
   * @protected
   */ CanvasLayerRenderer.prototype.preCompose = function preCompose(context, frameState, opt_transform) {
        this.dispatchComposeEvent_((0, $847c6e8c21904781$export$2e2bcd8739ae039).PRECOMPOSE, context, frameState, opt_transform);
    };
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("../../transform.js").Transform=} opt_transform Transform.
   * @protected
   */ CanvasLayerRenderer.prototype.dispatchRenderEvent = function dispatchRenderEvent(context, frameState, opt_transform) {
        this.dispatchComposeEvent_((0, $847c6e8c21904781$export$2e2bcd8739ae039).RENDER, context, frameState, opt_transform);
    };
    /**
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ CanvasLayerRenderer.prototype.getTransform = function getTransform(frameState, offsetX) {
        var viewState = frameState.viewState;
        var pixelRatio = frameState.pixelRatio;
        var dx1 = pixelRatio * frameState.size[0] / 2;
        var dy1 = pixelRatio * frameState.size[1] / 2;
        var sx = pixelRatio / viewState.resolution;
        var sy = -sx;
        var angle = -viewState.rotation;
        var dx2 = -viewState.center[0] + offsetX;
        var dy2 = -viewState.center[1];
        return (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.transform_, dx1, dy1, sx, sy, angle, dx2, dy2);
    };
    /**
   * @abstract
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("../../layer/Layer.js").State} layerState Layer state.
   * @param {CanvasRenderingContext2D} context Context.
   */ CanvasLayerRenderer.prototype.composeFrame = function composeFrame(frameState, layerState, context) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * @abstract
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("../../layer/Layer.js").State} layerState Layer state.
   * @return {boolean} whether composeFrame should be called.
   */ CanvasLayerRenderer.prototype.prepareFrame = function prepareFrame(frameState, layerState) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    return CanvasLayerRenderer;
}((0, $2151efd61380bcce$export$2e2bcd8739ae039));
var $22aba15f167ce2ee$export$2e2bcd8739ae039 = $22aba15f167ce2ee$var$CanvasLayerRenderer;



/**
 * @abstract
 */ var $43ce8a2ddc22b6cb$var$IntermediateCanvasRenderer = /*@__PURE__*/ function(CanvasLayerRenderer) {
    function IntermediateCanvasRenderer(layer) {
        CanvasLayerRenderer.call(this, layer);
        /**
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.coordinateToCanvasPixelTransform = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.hitCanvasContext_ = null;
    }
    if (CanvasLayerRenderer) IntermediateCanvasRenderer.__proto__ = CanvasLayerRenderer;
    IntermediateCanvasRenderer.prototype = Object.create(CanvasLayerRenderer && CanvasLayerRenderer.prototype);
    IntermediateCanvasRenderer.prototype.constructor = IntermediateCanvasRenderer;
    /**
   * @inheritDoc
   */ IntermediateCanvasRenderer.prototype.composeFrame = function composeFrame(frameState, layerState, context) {
        this.preCompose(context, frameState);
        var image = this.getImage();
        if (image) {
            // clipped rendering if layer extent is set
            var extent = layerState.extent;
            var clipped = extent !== undefined && !(0, $7e819822b33b3d32$export$be866b1e0809b17e)(extent, frameState.extent) && (0, $7e819822b33b3d32$export$7b0a31e10bbff018)(extent, frameState.extent);
            if (clipped) this.clip(context, frameState, /** @type {import("../../extent.js").Extent} */ extent);
            var imageTransform = this.getImageTransform();
            // for performance reasons, context.save / context.restore is not used
            // to save and restore the transformation matrix and the opacity.
            // see http://jsperf.com/context-save-restore-versus-variable
            var alpha = context.globalAlpha;
            context.globalAlpha = layerState.opacity;
            // for performance reasons, context.setTransform is only used
            // when the view is rotated. see http://jsperf.com/canvas-transform
            var dx = imageTransform[4];
            var dy = imageTransform[5];
            var dw = image.width * imageTransform[0];
            var dh = image.height * imageTransform[3];
            if (dw >= 0.5 && dh >= 0.5) context.drawImage(image, 0, 0, +image.width, +image.height, Math.round(dx), Math.round(dy), Math.round(dw), Math.round(dh));
            context.globalAlpha = alpha;
            if (clipped) context.restore();
        }
        this.postCompose(context, frameState, layerState);
    };
    /**
   * @abstract
   * @return {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} Canvas.
   */ IntermediateCanvasRenderer.prototype.getImage = function getImage() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * @abstract
   * @return {!import("../../transform.js").Transform} Image transform.
   */ IntermediateCanvasRenderer.prototype.getImageTransform = function getImageTransform() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * @inheritDoc
   */ IntermediateCanvasRenderer.prototype.forEachLayerAtCoordinate = function forEachLayerAtCoordinate(coordinate, frameState, hitTolerance, callback, thisArg) {
        if (!this.getImage()) return undefined;
        var pixel = (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(this.coordinateToCanvasPixelTransform, coordinate.slice());
        (0, $8b28786758450fff$export$dcdf75081b88279d)(pixel, frameState.viewState.resolution / this.renderedResolution);
        if (!this.hitCanvasContext_) this.hitCanvasContext_ = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(1, 1);
        this.hitCanvasContext_.clearRect(0, 0, 1, 1);
        this.hitCanvasContext_.drawImage(this.getImage(), pixel[0], pixel[1], 1, 1, 0, 0, 1, 1);
        var imageData = this.hitCanvasContext_.getImageData(0, 0, 1, 1).data;
        if (imageData[3] > 0) return callback.call(thisArg, this.getLayer(), imageData);
        else return undefined;
    };
    return IntermediateCanvasRenderer;
}((0, $22aba15f167ce2ee$export$2e2bcd8739ae039));
var $43ce8a2ddc22b6cb$export$2e2bcd8739ae039 = $43ce8a2ddc22b6cb$var$IntermediateCanvasRenderer;



/**
 * @classdesc
 * Canvas renderer for image layers.
 * @api
 */ var $2a67941380f9882b$var$CanvasImageLayerRenderer = /*@__PURE__*/ function(IntermediateCanvasRenderer) {
    function CanvasImageLayerRenderer(imageLayer) {
        IntermediateCanvasRenderer.call(this, imageLayer);
        /**
     * @private
     * @type {?import("../../ImageBase.js").default}
     */ this.image_ = null;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.imageTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * @type {!Array<string>}
     */ this.skippedFeatures_ = [];
        /**
     * @private
     * @type {import("./VectorLayer.js").default}
     */ this.vectorRenderer_ = null;
        if (imageLayer.getType() === (0, $e2d469ffcbcaca70$export$2e2bcd8739ae039).VECTOR) for(var i = 0, ii = (0, $38a2f3b2ed67e329$export$3372ee2fc5fdeb09).length; i < ii; ++i){
            var ctor = (0, $38a2f3b2ed67e329$export$3372ee2fc5fdeb09)[i];
            if (ctor !== CanvasImageLayerRenderer && ctor["handles"](imageLayer)) {
                this.vectorRenderer_ = /** @type {import("./VectorLayer.js").default} */ new ctor(imageLayer);
                break;
            }
        }
    }
    if (IntermediateCanvasRenderer) CanvasImageLayerRenderer.__proto__ = IntermediateCanvasRenderer;
    CanvasImageLayerRenderer.prototype = Object.create(IntermediateCanvasRenderer && IntermediateCanvasRenderer.prototype);
    CanvasImageLayerRenderer.prototype.constructor = CanvasImageLayerRenderer;
    /**
   * @inheritDoc
   */ CanvasImageLayerRenderer.prototype.disposeInternal = function disposeInternal() {
        if (this.vectorRenderer_) this.vectorRenderer_.dispose();
        IntermediateCanvasRenderer.prototype.disposeInternal.call(this);
    };
    /**
   * @inheritDoc
   */ CanvasImageLayerRenderer.prototype.getImage = function getImage() {
        return !this.image_ ? null : this.image_.getImage();
    };
    /**
   * @inheritDoc
   */ CanvasImageLayerRenderer.prototype.getImageTransform = function getImageTransform() {
        return this.imageTransform_;
    };
    /**
   * @inheritDoc
   */ CanvasImageLayerRenderer.prototype.prepareFrame = function prepareFrame(frameState, layerState) {
        var pixelRatio = frameState.pixelRatio;
        var size = frameState.size;
        var viewState = frameState.viewState;
        var viewCenter = viewState.center;
        var viewResolution = viewState.resolution;
        var image;
        var imageLayer = /** @type {import("../../layer/Image.js").default} */ this.getLayer();
        var imageSource = /** @type {import("../../source/Image.js").default} */ imageLayer.getSource();
        var hints = frameState.viewHints;
        var vectorRenderer = this.vectorRenderer_;
        var renderedExtent = frameState.extent;
        if (!vectorRenderer && layerState.extent !== undefined) renderedExtent = (0, $7e819822b33b3d32$export$72209efa88586d42)(renderedExtent, layerState.extent);
        if (!hints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING] && !hints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING] && !(0, $7e819822b33b3d32$export$dd1bc94b04021eeb)(renderedExtent)) {
            var projection = viewState.projection;
            if (!(0, $7b3aa4a24649670e$export$584433cc24140052)) {
                var sourceProjection = imageSource.getProjection();
                if (sourceProjection) projection = sourceProjection;
            }
            var skippedFeatures = this.skippedFeatures_;
            if (vectorRenderer) {
                var context = vectorRenderer.context;
                var imageFrameState = /** @type {import("../../PluggableMap.js").FrameState} */ (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({}, frameState, {
                    size: [
                        (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(renderedExtent) / viewResolution,
                        (0, $7e819822b33b3d32$export$c08559766941f856)(renderedExtent) / viewResolution
                    ],
                    viewState: /** @type {import("../../View.js").State} */ (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({}, frameState.viewState, {
                        rotation: 0
                    })
                });
                var newSkippedFeatures = Object.keys(imageFrameState.skippedFeatureUids).sort();
                image = new (0, $4b5760d150634964$export$2e2bcd8739ae039)(renderedExtent, viewResolution, pixelRatio, context.canvas, function(callback) {
                    if (vectorRenderer.prepareFrame(imageFrameState, layerState) && (vectorRenderer.replayGroupChanged || !(0, $830d23b8323fc080$export$e9bab7fafb253603)(skippedFeatures, newSkippedFeatures))) {
                        context.canvas.width = imageFrameState.size[0] * pixelRatio;
                        context.canvas.height = imageFrameState.size[1] * pixelRatio;
                        vectorRenderer.compose(context, imageFrameState, layerState);
                        skippedFeatures = newSkippedFeatures;
                        callback();
                    }
                });
            } else image = imageSource.getImage(renderedExtent, viewResolution, pixelRatio, projection);
            if (image && this.loadImage(image)) {
                this.image_ = image;
                this.skippedFeatures_ = skippedFeatures;
            }
        }
        if (this.image_) {
            image = this.image_;
            var imageExtent = image.getExtent();
            var imageResolution = image.getResolution();
            var imagePixelRatio = image.getPixelRatio();
            var scale = pixelRatio * imageResolution / (viewResolution * imagePixelRatio);
            var transform = (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.imageTransform_, pixelRatio * size[0] / 2, pixelRatio * size[1] / 2, scale, scale, 0, imagePixelRatio * (imageExtent[0] - viewCenter[0]) / imageResolution, imagePixelRatio * (viewCenter[1] - imageExtent[3]) / imageResolution);
            (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.coordinateToCanvasPixelTransform, pixelRatio * size[0] / 2 - transform[4], pixelRatio * size[1] / 2 - transform[5], pixelRatio / viewResolution, -pixelRatio / viewResolution, 0, -viewCenter[0], -viewCenter[1]);
            this.renderedResolution = imageResolution * pixelRatio / imagePixelRatio;
        }
        return !!this.image_;
    };
    /**
   * @inheritDoc
   */ CanvasImageLayerRenderer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback) {
        if (this.vectorRenderer_) return this.vectorRenderer_.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback);
        else return IntermediateCanvasRenderer.prototype.forEachFeatureAtCoordinate.call(this, coordinate, frameState, hitTolerance, callback);
    };
    return CanvasImageLayerRenderer;
}((0, $43ce8a2ddc22b6cb$export$2e2bcd8739ae039));
/**
 * Determine if this renderer handles the provided layer.
 * @param {import("../../layer/Layer.js").default} layer The candidate layer.
 * @return {boolean} The renderer can render the layer.
 */ $2a67941380f9882b$var$CanvasImageLayerRenderer["handles"] = function(layer) {
    return layer.getType() === (0, $e2d469ffcbcaca70$export$2e2bcd8739ae039).IMAGE || layer.getType() === (0, $e2d469ffcbcaca70$export$2e2bcd8739ae039).VECTOR && /** @type {import("../../layer/Vector.js").default} */ layer.getRenderMode() === (0, $f47fc48773998764$export$2e2bcd8739ae039).IMAGE;
};
/**
 * Create a layer renderer.
 * @param {import("../Map.js").default} mapRenderer The map renderer.
 * @param {import("../../layer/Layer.js").default} layer The layer to be rendererd.
 * @return {CanvasImageLayerRenderer} The layer renderer.
 */ $2a67941380f9882b$var$CanvasImageLayerRenderer["create"] = function(mapRenderer, layer) {
    return new $2a67941380f9882b$var$CanvasImageLayerRenderer(/** @type {import("../../layer/Image.js").default} */ layer);
};
var $2a67941380f9882b$export$2e2bcd8739ae039 = $2a67941380f9882b$var$CanvasImageLayerRenderer;



/**
 * @module ol/renderer/canvas/TileLayer
 */ 

/**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ var $014fe51f68272f2c$var$TileRange = function TileRange(minX, maxX, minY, maxY) {
    /**
   * @type {number}
   */ this.minX = minX;
    /**
   * @type {number}
   */ this.maxX = maxX;
    /**
   * @type {number}
   */ this.minY = minY;
    /**
   * @type {number}
   */ this.maxY = maxY;
};
/**
 * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @return {boolean} Contains tile coordinate.
 */ $014fe51f68272f2c$var$TileRange.prototype.contains = function contains(tileCoord) {
    return this.containsXY(tileCoord[1], tileCoord[2]);
};
/**
 * @param {TileRange} tileRange Tile range.
 * @return {boolean} Contains.
 */ $014fe51f68272f2c$var$TileRange.prototype.containsTileRange = function containsTileRange(tileRange) {
    return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
};
/**
 * @param {number} x Tile coordinate x.
 * @param {number} y Tile coordinate y.
 * @return {boolean} Contains coordinate.
 */ $014fe51f68272f2c$var$TileRange.prototype.containsXY = function containsXY(x, y) {
    return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
};
/**
 * @param {TileRange} tileRange Tile range.
 * @return {boolean} Equals.
 */ $014fe51f68272f2c$var$TileRange.prototype.equals = function equals(tileRange) {
    return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
};
/**
 * @param {TileRange} tileRange Tile range.
 */ $014fe51f68272f2c$var$TileRange.prototype.extend = function extend(tileRange) {
    if (tileRange.minX < this.minX) this.minX = tileRange.minX;
    if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
    if (tileRange.minY < this.minY) this.minY = tileRange.minY;
    if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
};
/**
 * @return {number} Height.
 */ $014fe51f68272f2c$var$TileRange.prototype.getHeight = function getHeight() {
    return this.maxY - this.minY + 1;
};
/**
 * @return {import("./size.js").Size} Size.
 */ $014fe51f68272f2c$var$TileRange.prototype.getSize = function getSize() {
    return [
        this.getWidth(),
        this.getHeight()
    ];
};
/**
 * @return {number} Width.
 */ $014fe51f68272f2c$var$TileRange.prototype.getWidth = function getWidth() {
    return this.maxX - this.minX + 1;
};
/**
 * @param {TileRange} tileRange Tile range.
 * @return {boolean} Intersects.
 */ $014fe51f68272f2c$var$TileRange.prototype.intersects = function intersects(tileRange) {
    return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
};
function $014fe51f68272f2c$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    } else return new $014fe51f68272f2c$var$TileRange(minX, maxX, minY, maxY);
}
var $014fe51f68272f2c$export$2e2bcd8739ae039 = $014fe51f68272f2c$var$TileRange;








/**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 */ var $317841df0443139a$var$CanvasTileLayerRenderer = /*@__PURE__*/ function(IntermediateCanvasRenderer) {
    function CanvasTileLayerRenderer(tileLayer, opt_noContext) {
        IntermediateCanvasRenderer.call(this, tileLayer);
        /**
     * @protected
     * @type {CanvasRenderingContext2D}
     */ this.context = opt_noContext ? null : (0, $755a3001f896bcf1$export$9e05d10eae75c464)();
        /**
     * @private
     * @type {number}
     */ this.oversampling_;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.renderedExtent_ = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedRevision;
        /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */ this.renderedTiles = [];
        /**
     * @private
     * @type {boolean}
     */ this.newTiles_ = false;
        /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */ this.tmpExtent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../TileRange.js").default}
     */ this.tmpTileRange_ = new (0, $014fe51f68272f2c$export$2e2bcd8739ae039)(0, 0, 0, 0);
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.imageTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * @protected
     * @type {number}
     */ this.zDirection = 0;
    }
    if (IntermediateCanvasRenderer) CanvasTileLayerRenderer.__proto__ = IntermediateCanvasRenderer;
    CanvasTileLayerRenderer.prototype = Object.create(IntermediateCanvasRenderer && IntermediateCanvasRenderer.prototype);
    CanvasTileLayerRenderer.prototype.constructor = CanvasTileLayerRenderer;
    /**
   * @private
   * @param {import("../../Tile.js").default} tile Tile.
   * @return {boolean} Tile is drawable.
   */ CanvasTileLayerRenderer.prototype.isDrawableTile_ = function isDrawableTile_(tile) {
        var tileLayer = /** @type {import("../../layer/Tile.js").default} */ this.getLayer();
        var tileState = tile.getState();
        var useInterimTilesOnError = tileLayer.getUseInterimTilesOnError();
        return tileState == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED || tileState == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY || tileState == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR && !useInterimTilesOnError;
    };
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../proj/Projection.js").default} projection Projection.
   * @return {!import("../../Tile.js").default} Tile.
   */ CanvasTileLayerRenderer.prototype.getTile = function getTile(z, x, y, pixelRatio, projection) {
        var tileLayer = /** @type {import("../../layer/Tile.js").default} */ this.getLayer();
        var tileSource = /** @type {import("../../source/Tile.js").default} */ tileLayer.getSource();
        var tile = tileSource.getTile(z, x, y, pixelRatio, projection);
        if (tile.getState() == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR) {
            if (!tileLayer.getUseInterimTilesOnError()) // When useInterimTilesOnError is false, we consider the error tile as loaded.
            tile.setState((0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED);
            else if (tileLayer.getPreload() > 0) // Preloaded tiles for lower resolutions might have finished loading.
            this.newTiles_ = true;
        }
        if (!this.isDrawableTile_(tile)) tile = tile.getInterimTile();
        return tile;
    };
    /**
   * @inheritDoc
   */ CanvasTileLayerRenderer.prototype.prepareFrame = function prepareFrame(frameState, layerState) {
        var pixelRatio = frameState.pixelRatio;
        var size = frameState.size;
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        var viewResolution = viewState.resolution;
        var viewCenter = viewState.center;
        var tileLayer = /** @type {import("../../layer/Tile.js").default} */ this.getLayer();
        var tileSource = /** @type {import("../../source/Tile.js").default} */ tileLayer.getSource();
        var sourceRevision = tileSource.getRevision();
        var tileGrid = tileSource.getTileGridForProjection(projection);
        var z = tileGrid.getZForResolution(viewResolution, this.zDirection);
        var tileResolution = tileGrid.getResolution(z);
        var oversampling = Math.round(viewResolution / tileResolution) || 1;
        var extent = frameState.extent;
        if (layerState.extent !== undefined) extent = (0, $7e819822b33b3d32$export$72209efa88586d42)(extent, layerState.extent);
        if ((0, $7e819822b33b3d32$export$dd1bc94b04021eeb)(extent)) // Return false to prevent the rendering of the layer.
        return false;
        var tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
        var imageExtent = tileGrid.getTileRangeExtent(z, tileRange);
        var tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        /**
     * @type {Object<number, Object<string, import("../../Tile.js").default>>}
     */ var tilesToDrawByZ = {};
        tilesToDrawByZ[z] = {};
        var findLoadedTiles = this.createLoadedTileFinder(tileSource, projection, tilesToDrawByZ);
        var hints = frameState.viewHints;
        var animatingOrInteracting = hints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING] || hints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING];
        var tmpExtent = this.tmpExtent;
        var tmpTileRange = this.tmpTileRange_;
        this.newTiles_ = false;
        var tile, x, y;
        for(x = tileRange.minX; x <= tileRange.maxX; ++x)for(y = tileRange.minY; y <= tileRange.maxY; ++y){
            if (Date.now() - frameState.time > 16 && animatingOrInteracting) continue;
            tile = this.getTile(z, x, y, pixelRatio, projection);
            if (this.isDrawableTile_(tile)) {
                var uid = (0, $34772e91e89a736f$export$5e82334337e0f204)(this);
                if (tile.getState() == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) {
                    tilesToDrawByZ[z][tile.tileCoord.toString()] = tile;
                    var inTransition = tile.inTransition(uid);
                    if (!this.newTiles_ && (inTransition || this.renderedTiles.indexOf(tile) === -1)) this.newTiles_ = true;
                }
                if (tile.getAlpha(uid, frameState.time) === 1) continue;
            }
            var childTileRange = tileGrid.getTileCoordChildTileRange(tile.tileCoord, tmpTileRange, tmpExtent);
            var covered = false;
            if (childTileRange) covered = findLoadedTiles(z + 1, childTileRange);
            if (!covered) tileGrid.forEachTileCoordParentTileRange(tile.tileCoord, findLoadedTiles, null, tmpTileRange, tmpExtent);
        }
        var renderedResolution = tileResolution * pixelRatio / tilePixelRatio * oversampling;
        if (!(this.renderedResolution && Date.now() - frameState.time > 16 && animatingOrInteracting) && (this.newTiles_ || !(this.renderedExtent_ && (0, $7e819822b33b3d32$export$be866b1e0809b17e)(this.renderedExtent_, extent)) || this.renderedRevision != sourceRevision || oversampling != this.oversampling_ || !animatingOrInteracting && renderedResolution != this.renderedResolution)) {
            var context = this.context;
            if (context) {
                var tilePixelSize = tileSource.getTilePixelSize(z, pixelRatio, projection);
                var width = Math.round(tileRange.getWidth() * tilePixelSize[0] / oversampling);
                var height = Math.round(tileRange.getHeight() * tilePixelSize[1] / oversampling);
                var canvas = context.canvas;
                if (canvas.width != width || canvas.height != height) {
                    this.oversampling_ = oversampling;
                    canvas.width = width;
                    canvas.height = height;
                } else {
                    if (this.renderedExtent_ && !(0, $7e819822b33b3d32$export$e9bab7fafb253603)(imageExtent, this.renderedExtent_) || this.renderedRevision != sourceRevision) context.clearRect(0, 0, width, height);
                    oversampling = this.oversampling_;
                }
            }
            this.renderedTiles.length = 0;
            /** @type {Array<number>} */ var zs = Object.keys(tilesToDrawByZ).map(Number);
            zs.sort(function(a, b) {
                if (a === z) return 1;
                else if (b === z) return -1;
                else return a > b ? 1 : a < b ? -1 : 0;
            });
            var currentResolution, currentScale, currentTilePixelSize, currentZ, i, ii;
            var tileExtent, tileGutter, tilesToDraw, w, h;
            for(i = 0, ii = zs.length; i < ii; ++i){
                currentZ = zs[i];
                currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
                currentResolution = tileGrid.getResolution(currentZ);
                currentScale = currentResolution / tileResolution;
                tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
                tilesToDraw = tilesToDrawByZ[currentZ];
                for(var tileCoordKey in tilesToDraw){
                    tile = tilesToDraw[tileCoordKey];
                    tileExtent = tileGrid.getTileCoordExtent(tile.getTileCoord(), tmpExtent);
                    x = (tileExtent[0] - imageExtent[0]) / tileResolution * tilePixelRatio / oversampling;
                    y = (imageExtent[3] - tileExtent[3]) / tileResolution * tilePixelRatio / oversampling;
                    w = currentTilePixelSize[0] * currentScale / oversampling;
                    h = currentTilePixelSize[1] * currentScale / oversampling;
                    this.drawTileImage(tile, frameState, layerState, x, y, w, h, tileGutter, z === currentZ);
                    this.renderedTiles.push(tile);
                }
            }
            this.renderedRevision = sourceRevision;
            this.renderedResolution = tileResolution * pixelRatio / tilePixelRatio * oversampling;
            this.renderedExtent_ = imageExtent;
        }
        var scale = this.renderedResolution / viewResolution;
        var transform = (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.imageTransform_, pixelRatio * size[0] / 2, pixelRatio * size[1] / 2, scale, scale, 0, (this.renderedExtent_[0] - viewCenter[0]) / this.renderedResolution * pixelRatio, (viewCenter[1] - this.renderedExtent_[3]) / this.renderedResolution * pixelRatio);
        (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.coordinateToCanvasPixelTransform, pixelRatio * size[0] / 2 - transform[4], pixelRatio * size[1] / 2 - transform[5], pixelRatio / viewResolution, -pixelRatio / viewResolution, 0, -viewCenter[0], -viewCenter[1]);
        this.updateUsedTiles(frameState.usedTiles, tileSource, z, tileRange);
        this.manageTilePyramid(frameState, tileSource, tileGrid, pixelRatio, projection, extent, z, tileLayer.getPreload());
        this.scheduleExpireCache(frameState, tileSource);
        return this.renderedTiles.length > 0;
    };
    /**
   * @param {import("../../Tile.js").default} tile Tile.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("../../layer/Layer.js").State} layerState Layer state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   */ CanvasTileLayerRenderer.prototype.drawTileImage = function drawTileImage(tile, frameState, layerState, x, y, w, h, gutter, transition) {
        var image = this.getTileImage(tile);
        if (!image) return;
        var uid = (0, $34772e91e89a736f$export$5e82334337e0f204)(this);
        var alpha = transition ? tile.getAlpha(uid, frameState.time) : 1;
        var tileLayer = /** @type {import("../../layer/Tile.js").default} */ this.getLayer();
        var tileSource = /** @type {import("../../source/Tile.js").default} */ tileLayer.getSource();
        if (alpha === 1 && !tileSource.getOpaque(frameState.viewState.projection)) this.context.clearRect(x, y, w, h);
        var alphaChanged = alpha !== this.context.globalAlpha;
        if (alphaChanged) {
            this.context.save();
            this.context.globalAlpha = alpha;
        }
        this.context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) this.context.restore();
        if (alpha !== 1) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    };
    /**
   * @inheritDoc
   */ CanvasTileLayerRenderer.prototype.getImage = function getImage() {
        var context = this.context;
        return context ? context.canvas : null;
    };
    /**
   * @inheritDoc
   */ CanvasTileLayerRenderer.prototype.getImageTransform = function getImageTransform() {
        return this.imageTransform_;
    };
    /**
   * Get the image from a tile.
   * @param {import("../../Tile.js").default} tile Tile.
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */ CanvasTileLayerRenderer.prototype.getTileImage = function getTileImage(tile) {
        return /** @type {import("../../ImageTile.js").default} */ tile.getImage();
    };
    return CanvasTileLayerRenderer;
}((0, $43ce8a2ddc22b6cb$export$2e2bcd8739ae039));
/**
 * Determine if this renderer handles the provided layer.
 * @param {import("../../layer/Layer.js").default} layer The candidate layer.
 * @return {boolean} The renderer can render the layer.
 */ $317841df0443139a$var$CanvasTileLayerRenderer["handles"] = function(layer) {
    return layer.getType() === (0, $e2d469ffcbcaca70$export$2e2bcd8739ae039).TILE;
};
/**
 * Create a layer renderer.
 * @param {import("../Map.js").default} mapRenderer The map renderer.
 * @param {import("../../layer/Layer.js").default} layer The layer to be rendererd.
 * @return {CanvasTileLayerRenderer} The layer renderer.
 */ $317841df0443139a$var$CanvasTileLayerRenderer["create"] = function(mapRenderer, layer) {
    return new $317841df0443139a$var$CanvasTileLayerRenderer(/** @type {import("../../layer/Tile.js").default} */ layer);
};
/**
 * @function
 * @return {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default}
 */ $317841df0443139a$var$CanvasTileLayerRenderer.prototype.getLayer;
var $317841df0443139a$export$2e2bcd8739ae039 = $317841df0443139a$var$CanvasTileLayerRenderer;


/**
 * @module ol/renderer/canvas/VectorLayer
 */ 





var $2714652880d6ac2a$exports = {};
"use strict";
$2714652880d6ac2a$exports = $2714652880d6ac2a$var$rbush;
$2714652880d6ac2a$exports.default = $2714652880d6ac2a$var$rbush;
var $0317e0baaccf2538$exports = {};
(function(global, factory) {
    $0317e0baaccf2538$exports = factory();
})($0317e0baaccf2538$exports, function() {
    "use strict";
    function quickselect(arr, k, left, right, compare) {
        quickselectStep(arr, k, left || 0, right || arr.length - 1, compare || defaultCompare);
    }
    function quickselectStep(arr, k, left, right, compare) {
        while(right > left){
            if (right - left > 600) {
                var n = right - left + 1;
                var m = k - left + 1;
                var z = Math.log(n);
                var s = 0.5 * Math.exp(2 * z / 3);
                var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
                var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
                var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
                quickselectStep(arr, k, newLeft, newRight, compare);
            }
            var t = arr[k];
            var i = left;
            var j = right;
            swap(arr, left, k);
            if (compare(arr[right], t) > 0) swap(arr, left, right);
            while(i < j){
                swap(arr, i, j);
                i++;
                j--;
                while(compare(arr[i], t) < 0)i++;
                while(compare(arr[j], t) > 0)j--;
            }
            if (compare(arr[left], t) === 0) swap(arr, left, j);
            else {
                j++;
                swap(arr, j, right);
            }
            if (j <= k) left = j + 1;
            if (k <= j) right = j - 1;
        }
    }
    function swap(arr, i, j) {
        var tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
    }
    function defaultCompare(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }
    return quickselect;
});


function $2714652880d6ac2a$var$rbush(maxEntries, format) {
    if (!(this instanceof $2714652880d6ac2a$var$rbush)) return new $2714652880d6ac2a$var$rbush(maxEntries, format);
    // max entries in a node is 9 by default; min node fill is 40% for best performance
    this._maxEntries = Math.max(4, maxEntries || 9);
    this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));
    if (format) this._initFormat(format);
    this.clear();
}
$2714652880d6ac2a$var$rbush.prototype = {
    all: function() {
        return this._all(this.data, []);
    },
    search: function(bbox) {
        var node = this.data, result = [], toBBox = this.toBBox;
        if (!$2714652880d6ac2a$var$intersects(bbox, node)) return result;
        var nodesToSearch = [], i, len, child, childBBox;
        while(node){
            for(i = 0, len = node.children.length; i < len; i++){
                child = node.children[i];
                childBBox = node.leaf ? toBBox(child) : child;
                if ($2714652880d6ac2a$var$intersects(bbox, childBBox)) {
                    if (node.leaf) result.push(child);
                    else if ($2714652880d6ac2a$var$contains(bbox, childBBox)) this._all(child, result);
                    else nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }
        return result;
    },
    collides: function(bbox) {
        var node = this.data, toBBox = this.toBBox;
        if (!$2714652880d6ac2a$var$intersects(bbox, node)) return false;
        var nodesToSearch = [], i, len, child, childBBox;
        while(node){
            for(i = 0, len = node.children.length; i < len; i++){
                child = node.children[i];
                childBBox = node.leaf ? toBBox(child) : child;
                if ($2714652880d6ac2a$var$intersects(bbox, childBBox)) {
                    if (node.leaf || $2714652880d6ac2a$var$contains(bbox, childBBox)) return true;
                    nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }
        return false;
    },
    load: function(data) {
        if (!(data && data.length)) return this;
        if (data.length < this._minEntries) {
            for(var i = 0, len = data.length; i < len; i++)this.insert(data[i]);
            return this;
        }
        // recursively build the tree with the given data from scratch using OMT algorithm
        var node = this._build(data.slice(), 0, data.length - 1, 0);
        if (!this.data.children.length) // save as is if tree is empty
        this.data = node;
        else if (this.data.height === node.height) // split root if trees have the same height
        this._splitRoot(this.data, node);
        else {
            if (this.data.height < node.height) {
                // swap trees if inserted one is bigger
                var tmpNode = this.data;
                this.data = node;
                node = tmpNode;
            }
            // insert the small tree into the large tree at appropriate level
            this._insert(node, this.data.height - node.height - 1, true);
        }
        return this;
    },
    insert: function(item) {
        if (item) this._insert(item, this.data.height - 1);
        return this;
    },
    clear: function() {
        this.data = $2714652880d6ac2a$var$createNode([]);
        return this;
    },
    remove: function(item, equalsFn) {
        if (!item) return this;
        var node = this.data, bbox = this.toBBox(item), path = [], indexes = [], i, parent, index, goingUp;
        // depth-first iterative tree traversal
        while(node || path.length){
            if (!node) {
                node = path.pop();
                parent = path[path.length - 1];
                i = indexes.pop();
                goingUp = true;
            }
            if (node.leaf) {
                index = $2714652880d6ac2a$var$findItem(item, node.children, equalsFn);
                if (index !== -1) {
                    // item found, remove the item and condense tree upwards
                    node.children.splice(index, 1);
                    path.push(node);
                    this._condense(path);
                    return this;
                }
            }
            if (!goingUp && !node.leaf && $2714652880d6ac2a$var$contains(node, bbox)) {
                path.push(node);
                indexes.push(i);
                i = 0;
                parent = node;
                node = node.children[0];
            } else if (parent) {
                i++;
                node = parent.children[i];
                goingUp = false;
            } else node = null; // nothing found
        }
        return this;
    },
    toBBox: function(item) {
        return item;
    },
    compareMinX: $2714652880d6ac2a$var$compareNodeMinX,
    compareMinY: $2714652880d6ac2a$var$compareNodeMinY,
    toJSON: function() {
        return this.data;
    },
    fromJSON: function(data) {
        this.data = data;
        return this;
    },
    _all: function(node, result) {
        var nodesToSearch = [];
        while(node){
            if (node.leaf) result.push.apply(result, node.children);
            else nodesToSearch.push.apply(nodesToSearch, node.children);
            node = nodesToSearch.pop();
        }
        return result;
    },
    _build: function(items, left, right, height) {
        var N = right - left + 1, M = this._maxEntries, node;
        if (N <= M) {
            // reached leaf level; return leaf
            node = $2714652880d6ac2a$var$createNode(items.slice(left, right + 1));
            $2714652880d6ac2a$var$calcBBox(node, this.toBBox);
            return node;
        }
        if (!height) {
            // target height of the bulk-loaded tree
            height = Math.ceil(Math.log(N) / Math.log(M));
            // target number of root entries to maximize storage utilization
            M = Math.ceil(N / Math.pow(M, height - 1));
        }
        node = $2714652880d6ac2a$var$createNode([]);
        node.leaf = false;
        node.height = height;
        // split the items into M mostly square tiles
        var N2 = Math.ceil(N / M), N1 = N2 * Math.ceil(Math.sqrt(M)), i, j, right2, right3;
        $2714652880d6ac2a$var$multiSelect(items, left, right, N1, this.compareMinX);
        for(i = left; i <= right; i += N1){
            right2 = Math.min(i + N1 - 1, right);
            $2714652880d6ac2a$var$multiSelect(items, i, right2, N2, this.compareMinY);
            for(j = i; j <= right2; j += N2){
                right3 = Math.min(j + N2 - 1, right2);
                // pack each entry recursively
                node.children.push(this._build(items, j, right3, height - 1));
            }
        }
        $2714652880d6ac2a$var$calcBBox(node, this.toBBox);
        return node;
    },
    _chooseSubtree: function(bbox, node, level, path) {
        var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;
        while(true){
            path.push(node);
            if (node.leaf || path.length - 1 === level) break;
            minArea = minEnlargement = Infinity;
            for(i = 0, len = node.children.length; i < len; i++){
                child = node.children[i];
                area = $2714652880d6ac2a$var$bboxArea(child);
                enlargement = $2714652880d6ac2a$var$enlargedArea(bbox, child) - area;
                // choose entry with the least area enlargement
                if (enlargement < minEnlargement) {
                    minEnlargement = enlargement;
                    minArea = area < minArea ? area : minArea;
                    targetNode = child;
                } else if (enlargement === minEnlargement) // otherwise choose one with the smallest area
                {
                    if (area < minArea) {
                        minArea = area;
                        targetNode = child;
                    }
                }
            }
            node = targetNode || node.children[0];
        }
        return node;
    },
    _insert: function(item, level, isNode) {
        var toBBox = this.toBBox, bbox = isNode ? item : toBBox(item), insertPath = [];
        // find the best node for accommodating the item, saving all nodes along the path too
        var node = this._chooseSubtree(bbox, this.data, level, insertPath);
        // put the item into the node
        node.children.push(item);
        $2714652880d6ac2a$var$extend(node, bbox);
        // split on node overflow; propagate upwards if necessary
        while(level >= 0){
            if (insertPath[level].children.length > this._maxEntries) {
                this._split(insertPath, level);
                level--;
            } else break;
        }
        // adjust bboxes along the insertion path
        this._adjustParentBBoxes(bbox, insertPath, level);
    },
    // split overflowed node into two
    _split: function(insertPath, level) {
        var node = insertPath[level], M = node.children.length, m = this._minEntries;
        this._chooseSplitAxis(node, m, M);
        var splitIndex = this._chooseSplitIndex(node, m, M);
        var newNode = $2714652880d6ac2a$var$createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
        newNode.height = node.height;
        newNode.leaf = node.leaf;
        $2714652880d6ac2a$var$calcBBox(node, this.toBBox);
        $2714652880d6ac2a$var$calcBBox(newNode, this.toBBox);
        if (level) insertPath[level - 1].children.push(newNode);
        else this._splitRoot(node, newNode);
    },
    _splitRoot: function(node, newNode) {
        // split root node
        this.data = $2714652880d6ac2a$var$createNode([
            node,
            newNode
        ]);
        this.data.height = node.height + 1;
        this.data.leaf = false;
        $2714652880d6ac2a$var$calcBBox(this.data, this.toBBox);
    },
    _chooseSplitIndex: function(node, m, M) {
        var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;
        minOverlap = minArea = Infinity;
        for(i = m; i <= M - m; i++){
            bbox1 = $2714652880d6ac2a$var$distBBox(node, 0, i, this.toBBox);
            bbox2 = $2714652880d6ac2a$var$distBBox(node, i, M, this.toBBox);
            overlap = $2714652880d6ac2a$var$intersectionArea(bbox1, bbox2);
            area = $2714652880d6ac2a$var$bboxArea(bbox1) + $2714652880d6ac2a$var$bboxArea(bbox2);
            // choose distribution with minimum overlap
            if (overlap < minOverlap) {
                minOverlap = overlap;
                index = i;
                minArea = area < minArea ? area : minArea;
            } else if (overlap === minOverlap) // otherwise choose distribution with minimum area
            {
                if (area < minArea) {
                    minArea = area;
                    index = i;
                }
            }
        }
        return index;
    },
    // sorts node children by the best axis for split
    _chooseSplitAxis: function(node, m, M) {
        var compareMinX = node.leaf ? this.compareMinX : $2714652880d6ac2a$var$compareNodeMinX, compareMinY = node.leaf ? this.compareMinY : $2714652880d6ac2a$var$compareNodeMinY, xMargin = this._allDistMargin(node, m, M, compareMinX), yMargin = this._allDistMargin(node, m, M, compareMinY);
        // if total distributions margin value is minimal for x, sort by minX,
        // otherwise it's already sorted by minY
        if (xMargin < yMargin) node.children.sort(compareMinX);
    },
    // total margin of all possible split distributions where each node is at least m full
    _allDistMargin: function(node, m, M, compare) {
        node.children.sort(compare);
        var toBBox = this.toBBox, leftBBox = $2714652880d6ac2a$var$distBBox(node, 0, m, toBBox), rightBBox = $2714652880d6ac2a$var$distBBox(node, M - m, M, toBBox), margin = $2714652880d6ac2a$var$bboxMargin(leftBBox) + $2714652880d6ac2a$var$bboxMargin(rightBBox), i, child;
        for(i = m; i < M - m; i++){
            child = node.children[i];
            $2714652880d6ac2a$var$extend(leftBBox, node.leaf ? toBBox(child) : child);
            margin += $2714652880d6ac2a$var$bboxMargin(leftBBox);
        }
        for(i = M - m - 1; i >= m; i--){
            child = node.children[i];
            $2714652880d6ac2a$var$extend(rightBBox, node.leaf ? toBBox(child) : child);
            margin += $2714652880d6ac2a$var$bboxMargin(rightBBox);
        }
        return margin;
    },
    _adjustParentBBoxes: function(bbox, path, level) {
        // adjust bboxes along the given tree path
        for(var i = level; i >= 0; i--)$2714652880d6ac2a$var$extend(path[i], bbox);
    },
    _condense: function(path) {
        // go through the path, removing empty nodes and updating bboxes
        for(var i = path.length - 1, siblings; i >= 0; i--)if (path[i].children.length === 0) {
            if (i > 0) {
                siblings = path[i - 1].children;
                siblings.splice(siblings.indexOf(path[i]), 1);
            } else this.clear();
        } else $2714652880d6ac2a$var$calcBBox(path[i], this.toBBox);
    },
    _initFormat: function(format) {
        // data format (minX, minY, maxX, maxY accessors)
        // uses eval-type function compilation instead of just accepting a toBBox function
        // because the algorithms are very sensitive to sorting functions performance,
        // so they should be dead simple and without inner calls
        var compareArr = [
            "return a",
            " - b",
            ";"
        ];
        this.compareMinX = new Function("a", "b", compareArr.join(format[0]));
        this.compareMinY = new Function("a", "b", compareArr.join(format[1]));
        this.toBBox = new Function("a", "return {minX: a" + format[0] + ", minY: a" + format[1] + ", maxX: a" + format[2] + ", maxY: a" + format[3] + "};");
    }
};
function $2714652880d6ac2a$var$findItem(item, items, equalsFn) {
    if (!equalsFn) return items.indexOf(item);
    for(var i = 0; i < items.length; i++){
        if (equalsFn(item, items[i])) return i;
    }
    return -1;
}
// calculate node's bbox from bboxes of its children
function $2714652880d6ac2a$var$calcBBox(node, toBBox) {
    $2714652880d6ac2a$var$distBBox(node, 0, node.children.length, toBBox, node);
}
// min bounding rectangle of node children from k to p-1
function $2714652880d6ac2a$var$distBBox(node, k, p, toBBox, destNode) {
    if (!destNode) destNode = $2714652880d6ac2a$var$createNode(null);
    destNode.minX = Infinity;
    destNode.minY = Infinity;
    destNode.maxX = -Infinity;
    destNode.maxY = -Infinity;
    for(var i = k, child; i < p; i++){
        child = node.children[i];
        $2714652880d6ac2a$var$extend(destNode, node.leaf ? toBBox(child) : child);
    }
    return destNode;
}
function $2714652880d6ac2a$var$extend(a, b) {
    a.minX = Math.min(a.minX, b.minX);
    a.minY = Math.min(a.minY, b.minY);
    a.maxX = Math.max(a.maxX, b.maxX);
    a.maxY = Math.max(a.maxY, b.maxY);
    return a;
}
function $2714652880d6ac2a$var$compareNodeMinX(a, b) {
    return a.minX - b.minX;
}
function $2714652880d6ac2a$var$compareNodeMinY(a, b) {
    return a.minY - b.minY;
}
function $2714652880d6ac2a$var$bboxArea(a) {
    return (a.maxX - a.minX) * (a.maxY - a.minY);
}
function $2714652880d6ac2a$var$bboxMargin(a) {
    return a.maxX - a.minX + (a.maxY - a.minY);
}
function $2714652880d6ac2a$var$enlargedArea(a, b) {
    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) * (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
}
function $2714652880d6ac2a$var$intersectionArea(a, b) {
    var minX = Math.max(a.minX, b.minX), minY = Math.max(a.minY, b.minY), maxX = Math.min(a.maxX, b.maxX), maxY = Math.min(a.maxY, b.maxY);
    return Math.max(0, maxX - minX) * Math.max(0, maxY - minY);
}
function $2714652880d6ac2a$var$contains(a, b) {
    return a.minX <= b.minX && a.minY <= b.minY && b.maxX <= a.maxX && b.maxY <= a.maxY;
}
function $2714652880d6ac2a$var$intersects(a, b) {
    return b.minX <= a.maxX && b.minY <= a.maxY && b.maxX >= a.minX && b.maxY >= a.minY;
}
function $2714652880d6ac2a$var$createNode(children) {
    return {
        children: children,
        height: 1,
        leaf: true,
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity
    };
}
// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
// combines selection algorithm with binary divide & conquer approach
function $2714652880d6ac2a$var$multiSelect(arr, left, right, n, compare) {
    var stack = [
        left,
        right
    ], mid;
    while(stack.length){
        right = stack.pop();
        left = stack.pop();
        if (right - left <= n) continue;
        mid = left + Math.ceil((right - left) / n / 2) * n;
        $0317e0baaccf2538$exports(arr, mid, left, right, compare);
        stack.push(left, mid, mid, right);
    }
}





/**
 * @module ol/render/canvas/ReplayGroup
 */ 




/**
 * @module ol/render/ReplayGroup
 */ 
/**
 * Base class for replay groups.
 */ var $e212d309c766cc76$var$ReplayGroup = function ReplayGroup() {};
$e212d309c766cc76$var$ReplayGroup.prototype.getReplay = function getReplay(zIndex, replayType) {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * @abstract
 * @return {boolean} Is empty.
 */ $e212d309c766cc76$var$ReplayGroup.prototype.isEmpty = function isEmpty() {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * @abstract
 * @param {boolean} group Group with previous replay
 * @return {Array<*>} The resulting instruction group
 */ $e212d309c766cc76$var$ReplayGroup.prototype.addDeclutter = function addDeclutter(group) {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
var $e212d309c766cc76$export$2e2bcd8739ae039 = $e212d309c766cc76$var$ReplayGroup;


/**
 * @module ol/render/ReplayType
 */ /**
 * @enum {string}
 */ var $c7d61e203c9209b0$export$2e2bcd8739ae039 = {
    CIRCLE: "Circle",
    DEFAULT: "Default",
    IMAGE: "Image",
    LINE_STRING: "LineString",
    POLYGON: "Polygon",
    TEXT: "Text"
};


/**
 * @module ol/render/canvas/Replay
 */ 






/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $f01092ea270954d4$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    var length = 0;
    for(var i = offset + stride; i < end; i += stride){
        var x2 = flatCoordinates[i];
        var y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $f01092ea270954d4$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    var perimeter = $f01092ea270954d4$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    var dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    var dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}


/**
 * @module ol/geom/flat/textpath
 */ 
function $d5f14337ff045de9$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, measure, startM, maxAngle) {
    var result = [];
    // Keep text upright
    var reverse = flatCoordinates[offset] > flatCoordinates[end - stride];
    var numChars = text.length;
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    offset += stride;
    var x2 = flatCoordinates[offset];
    var y2 = flatCoordinates[offset + 1];
    var segmentM = 0;
    var segmentLength = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    var chunk = "";
    var chunkLength = 0;
    var data, index, previousAngle;
    for(var i = 0; i < numChars; ++i){
        index = reverse ? numChars - i - 1 : i;
        var char = text.charAt(index);
        chunk = reverse ? char + chunk : chunk + char;
        var charLength = measure(chunk) - chunkLength;
        chunkLength += charLength;
        var charM = startM + charLength / 2;
        while(offset < end - stride && segmentM + segmentLength < charM){
            x1 = x2;
            y1 = y2;
            offset += stride;
            x2 = flatCoordinates[offset];
            y2 = flatCoordinates[offset + 1];
            segmentM += segmentLength;
            segmentLength = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        }
        var segmentPos = charM - segmentM;
        var angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -Math.PI : Math.PI;
        if (previousAngle !== undefined) {
            var delta = angle - previousAngle;
            delta += delta > Math.PI ? -2 * Math.PI : delta < -Math.PI ? 2 * Math.PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        var interpolate = segmentPos / segmentLength;
        var x = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
        var y = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
        if (previousAngle == angle) {
            if (reverse) {
                data[0] = x;
                data[1] = y;
                data[2] = charLength / 2;
            }
            data[4] = chunk;
        } else {
            chunk = char;
            chunkLength = charLength;
            data = [
                x,
                y,
                charLength / 2,
                angle,
                chunk
            ];
            if (reverse) result.unshift(data);
            else result.push(data);
            previousAngle = angle;
        }
        startM += charLength;
    }
    return result;
}







/**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ var $3b9081ec7a886d58$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
var $3b9081ec7a886d58$export$f21891651e408226 = [
    $3b9081ec7a886d58$var$Instruction.FILL
];
var $3b9081ec7a886d58$export$7a98aa5364d62ba8 = [
    $3b9081ec7a886d58$var$Instruction.STROKE
];
var $3b9081ec7a886d58$export$9f746cc58a899a00 = [
    $3b9081ec7a886d58$var$Instruction.BEGIN_PATH
];
var $3b9081ec7a886d58$export$89b10f327e413e71 = [
    $3b9081ec7a886d58$var$Instruction.CLOSE_PATH
];
var $3b9081ec7a886d58$export$2e2bcd8739ae039 = $3b9081ec7a886d58$var$Instruction;


/**
 * @module ol/render/replay
 */ 
var $9cc56c68d2780fd0$export$11e75bce9f7ea886 = [
    (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).POLYGON,
    (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).CIRCLE,
    (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).LINE_STRING,
    (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).IMAGE,
    (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT,
    (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).DEFAULT
];
var $9cc56c68d2780fd0$export$91a016276e4aee96 = {};
$9cc56c68d2780fd0$export$91a016276e4aee96["left"] = 0;
$9cc56c68d2780fd0$export$91a016276e4aee96["end"] = 0;
$9cc56c68d2780fd0$export$91a016276e4aee96["center"] = 0.5;
$9cc56c68d2780fd0$export$91a016276e4aee96["right"] = 1;
$9cc56c68d2780fd0$export$91a016276e4aee96["start"] = 1;
$9cc56c68d2780fd0$export$91a016276e4aee96["top"] = 0;
$9cc56c68d2780fd0$export$91a016276e4aee96["middle"] = 0.5;
$9cc56c68d2780fd0$export$91a016276e4aee96["hanging"] = 0.2;
$9cc56c68d2780fd0$export$91a016276e4aee96["alphabetic"] = 0.8;
$9cc56c68d2780fd0$export$91a016276e4aee96["ideographic"] = 0.8;
$9cc56c68d2780fd0$export$91a016276e4aee96["bottom"] = 1;



/**
 * @type {import("../../extent.js").Extent}
 */ var $4a4b550eb212a23b$var$tmpExtent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
/**
 * @type {!import("../../transform.js").Transform}
 */ var $4a4b550eb212a23b$var$tmpTransform = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
var $4a4b550eb212a23b$var$CanvasReplay = /*@__PURE__*/ function(VectorContext) {
    function CanvasReplay(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree) {
        VectorContext.call(this);
        /**
     * @type {?}
     */ this.declutterTree = declutterTree;
        /**
     * @protected
     * @type {number}
     */ this.tolerance = tolerance;
        /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent = maxExtent;
        /**
     * @protected
     * @type {boolean}
     */ this.overlaps = overlaps;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @type {number}
     */ this.maxLineWidth = 0;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {boolean}
     */ this.alignFill_;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction1_ = null;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction2_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.bufferedMaxExtent_ = null;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = [];
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = [];
        /**
     * @private
     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
     */ this.coordinateCache_ = {};
        /**
     * @private
     * @type {!import("../../transform.js").Transform}
     */ this.renderedTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = [];
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = null;
        /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */ this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = 0;
    }
    if (VectorContext) CanvasReplay.__proto__ = VectorContext;
    CanvasReplay.prototype = Object.create(VectorContext && VectorContext.prototype);
    CanvasReplay.prototype.constructor = CanvasReplay;
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ CanvasReplay.prototype.replayTextBackground_ = function replayTextBackground_(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignFill_ = /** @type {boolean} */ fillInstruction[2];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    };
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} image Image.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {import("../canvas.js").DeclutterGroup} declutterGroup Declutter group.
   * @param {number} height Height.
   * @param {number} opacity Opacity.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {number} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {number} width Width.
   * @param {Array<number>} padding Padding.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ CanvasReplay.prototype.replayImage_ = function replayImage_(context, x, y, image, anchorX, anchorY, declutterGroup, height, opacity, originX, originY, rotation, scale, snapToPixel, width, padding, fillInstruction, strokeInstruction) {
        var fillStroke = fillInstruction || strokeInstruction;
        anchorX *= scale;
        anchorY *= scale;
        x -= anchorX;
        y -= anchorY;
        var w = width + originX > image.width ? image.width - originX : width;
        var h = height + originY > image.height ? image.height - originY : height;
        var boxW = padding[3] + w * scale + padding[1];
        var boxH = padding[0] + h * scale + padding[2];
        var boxX = x - padding[3];
        var boxY = y - padding[0];
        /** @type {import("../../coordinate.js").Coordinate} */ var p1;
        /** @type {import("../../coordinate.js").Coordinate} */ var p2;
        /** @type {import("../../coordinate.js").Coordinate} */ var p3;
        /** @type {import("../../coordinate.js").Coordinate} */ var p4;
        if (fillStroke || rotation !== 0) {
            p1 = [
                boxX,
                boxY
            ];
            p2 = [
                boxX + boxW,
                boxY
            ];
            p3 = [
                boxX + boxW,
                boxY + boxH
            ];
            p4 = [
                boxX,
                boxY + boxH
            ];
        }
        var transform = null;
        if (rotation !== 0) {
            var centerX = x + anchorX;
            var centerY = y + anchorY;
            transform = (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)($4a4b550eb212a23b$var$tmpTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, $7e819822b33b3d32$export$3e2152b047719fa1)($4a4b550eb212a23b$var$tmpExtent);
            (0, $7e819822b33b3d32$export$1f820e3920fa5715)($4a4b550eb212a23b$var$tmpExtent, (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)($4a4b550eb212a23b$var$tmpTransform, p1));
            (0, $7e819822b33b3d32$export$1f820e3920fa5715)($4a4b550eb212a23b$var$tmpExtent, (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)($4a4b550eb212a23b$var$tmpTransform, p2));
            (0, $7e819822b33b3d32$export$1f820e3920fa5715)($4a4b550eb212a23b$var$tmpExtent, (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)($4a4b550eb212a23b$var$tmpTransform, p3));
            (0, $7e819822b33b3d32$export$1f820e3920fa5715)($4a4b550eb212a23b$var$tmpExtent, (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)($4a4b550eb212a23b$var$tmpTransform, p4));
        } else (0, $7e819822b33b3d32$export$958e3e1a02eac4b6)(boxX, boxY, boxX + boxW, boxY + boxH, $4a4b550eb212a23b$var$tmpExtent);
        var canvas = context.canvas;
        var strokePadding = strokeInstruction ? strokeInstruction[2] * scale / 2 : 0;
        var intersects = $4a4b550eb212a23b$var$tmpExtent[0] - strokePadding <= canvas.width && $4a4b550eb212a23b$var$tmpExtent[2] + strokePadding >= 0 && $4a4b550eb212a23b$var$tmpExtent[1] - strokePadding <= canvas.height && $4a4b550eb212a23b$var$tmpExtent[3] + strokePadding >= 0;
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        if (declutterGroup) {
            if (!intersects && declutterGroup[4] == 1) return;
            (0, $7e819822b33b3d32$export$8b58be045bf06082)(declutterGroup, $4a4b550eb212a23b$var$tmpExtent);
            var declutterArgs = intersects ? [
                context,
                transform ? transform.slice(0) : null,
                opacity,
                image,
                originX,
                originY,
                w,
                h,
                x,
                y,
                scale
            ] : null;
            if (declutterArgs && fillStroke) declutterArgs.push(fillInstruction, strokeInstruction, p1, p2, p3, p4);
            declutterGroup.push(declutterArgs);
        } else if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, p1, p2, p3, p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, $c8f894129d9fa0b9$export$21a059be5bfd5fb)(context, transform, opacity, image, originX, originY, w, h, x, y, scale);
        }
    };
    /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */ CanvasReplay.prototype.applyPixelRatio = function applyPixelRatio(dashArray) {
        var pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    };
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */ CanvasReplay.prototype.appendFlatCoordinates = function appendFlatCoordinates(flatCoordinates, offset, end, stride, closed, skipFirst) {
        var myEnd = this.coordinates.length;
        var extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        var lastCoord = [
            flatCoordinates[offset],
            flatCoordinates[offset + 1]
        ];
        var nextCoord = [
            NaN,
            NaN
        ];
        var skipped = true;
        var i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, $7e819822b33b3d32$export$f97905ead28c61a8)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    this.coordinates[myEnd++] = lastCoord[0];
                    this.coordinates[myEnd++] = lastCoord[1];
                }
                this.coordinates[myEnd++] = nextCoord[0];
                this.coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else if (nextRel === (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).INTERSECTING) {
                this.coordinates[myEnd++] = nextCoord[0];
                this.coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastCoord[0] = nextCoord[0];
            lastCoord[1] = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            this.coordinates[myEnd++] = lastCoord[0];
            this.coordinates[myEnd++] = lastCoord[1];
        }
        return myEnd;
    };
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} replayEnds Replay ends.
   * @return {number} Offset.
   */ CanvasReplay.prototype.drawCustomCoordinates_ = function drawCustomCoordinates_(flatCoordinates, offset, ends, stride, replayEnds) {
        for(var i = 0, ii = ends.length; i < ii; ++i){
            var end = ends[i];
            var replayEnd = this.appendFlatCoordinates(flatCoordinates, offset, end, stride, false, false);
            replayEnds.push(replayEnd);
            offset = end;
        }
        return offset;
    };
    /**
   * @inheritDoc.
   */ CanvasReplay.prototype.drawCustom = function drawCustom(geometry, feature, renderer) {
        this.beginGeometry(geometry, feature);
        var type = geometry.getType();
        var stride = geometry.getStride();
        var replayBegin = this.coordinates.length;
        var flatCoordinates, replayEnd, replayEnds, replayEndss;
        var offset;
        if (type == (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POLYGON) {
            /** @type {import("../../geom/MultiPolygon.js").default} */ geometry;
            flatCoordinates = geometry.getOrientedFlatCoordinates();
            replayEndss = [];
            var endss = geometry.getEndss();
            offset = 0;
            for(var i = 0, ii = endss.length; i < ii; ++i){
                var myEnds = [];
                offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                replayEndss.push(myEnds);
            }
            this.instructions.push([
                (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                replayBegin,
                replayEndss,
                geometry,
                renderer,
                (0, $76a969a6125a5a4a$export$915c7058aeb4dfeb)
            ]);
        } else if (type == (0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON || type == (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_LINE_STRING) {
            replayEnds = [];
            flatCoordinates = type == (0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
            offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, replayEnds);
            this.instructions.push([
                (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                replayBegin,
                replayEnds,
                geometry,
                renderer,
                (0, $76a969a6125a5a4a$export$cbb9596fc0f40db2)
            ]);
        } else if (type == (0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING || type == (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POINT) {
            flatCoordinates = geometry.getFlatCoordinates();
            replayEnd = this.appendFlatCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
            this.instructions.push([
                (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                replayBegin,
                replayEnd,
                geometry,
                renderer,
                (0, $76a969a6125a5a4a$export$9c0934e4e9c3f61e)
            ]);
        } else if (type == (0, $8826602b1d512d67$export$2e2bcd8739ae039).POINT) {
            flatCoordinates = geometry.getFlatCoordinates();
            this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
            replayEnd = this.coordinates.length;
            this.instructions.push([
                (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                replayBegin,
                replayEnd,
                geometry,
                renderer
            ]);
        }
        this.endGeometry(geometry, feature);
    };
    /**
   * @protected
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
   */ CanvasReplay.prototype.beginGeometry = function beginGeometry(geometry, feature) {
        this.beginGeometryInstruction1_ = [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    };
    /**
   * FIXME empty description for jsdoc
   */ CanvasReplay.prototype.finish = function finish() {};
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   */ CanvasReplay.prototype.fill_ = function fill_(context) {
        if (this.alignFill_) {
            var origin = (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(this.renderedTransform_, [
                0,
                0
            ]);
            var repeatSize = 512 * this.pixelRatio;
            context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
            context.rotate(this.viewRotation_);
        }
        context.fill();
        if (this.alignFill_) context.setTransform.apply(context, (0, $c8f894129d9fa0b9$export$d601bed2da9f1374));
    };
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */ CanvasReplay.prototype.setStrokeStyle_ = function setStrokeStyle_(context, instruction) {
        context.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        if (0, $89969764a1196844$export$c986c2374f97af1a) {
            context.lineDashOffset = /** @type {number} */ instruction[7];
            context.setLineDash(/** @type {Array<number>} */ instruction[6]);
        }
    };
    /**
   * @param {import("../canvas.js").DeclutterGroup} declutterGroup Declutter group.
   * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
   */ CanvasReplay.prototype.renderDeclutter_ = function renderDeclutter_(declutterGroup, feature) {
        if (declutterGroup && declutterGroup.length > 5) {
            var groupCount = declutterGroup[4];
            if (groupCount == 1 || groupCount == declutterGroup.length - 5) {
                /** @type {import("../../structs/RBush.js").Entry} */ var box = {
                    minX: /** @type {number} */ declutterGroup[0],
                    minY: /** @type {number} */ declutterGroup[1],
                    maxX: /** @type {number} */ declutterGroup[2],
                    maxY: /** @type {number} */ declutterGroup[3],
                    value: feature
                };
                if (!this.declutterTree.collides(box)) {
                    this.declutterTree.insert(box);
                    for(var j = 5, jj = declutterGroup.length; j < jj; ++j){
                        var declutterData = /** @type {Array} */ declutterGroup[j];
                        if (declutterData) {
                            if (declutterData.length > 11) this.replayTextBackground_(declutterData[0], declutterData[13], declutterData[14], declutterData[15], declutterData[16], declutterData[11], declutterData[12]);
                            (0, $c8f894129d9fa0b9$export$21a059be5bfd5fb).apply(undefined, declutterData);
                        }
                    }
                }
                declutterGroup.length = 5;
                (0, $7e819822b33b3d32$export$3e2152b047719fa1)(declutterGroup);
            }
        }
    };
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features
   *     to skip.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {function((import("../../Feature.js").default|import("../Feature.js").default)): T|undefined} featureCallback Feature callback.
   * @param {import("../../extent.js").Extent=} opt_hitExtent Only check features that intersect this
   *     extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ CanvasReplay.prototype.replay_ = function replay_(context, transform, skippedFeaturesHash, instructions, snapToPixel, featureCallback, opt_hitExtent) {
        /** @type {Array<number>} */ var pixelCoordinates;
        if (this.pixelCoordinates_ && (0, $830d23b8323fc080$export$e9bab7fafb253603)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, $24a54079104c80a7$export$b92b2dedcfff79de)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, $2567d97ab31c5663$export$42b4187a82d80ed0)(this.renderedTransform_, transform);
        }
        var skipFeatures = !(0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(skippedFeaturesHash);
        var i = 0; // instruction index
        var ii = instructions.length; // end of instructions
        var d = 0; // data index
        var dd; // end of per-instruction data
        var anchorX, anchorY, prevX, prevY, roundX, roundY, declutterGroup, image;
        var pendingFill = 0;
        var pendingStroke = 0;
        var lastFillInstruction = null;
        var lastStrokeInstruction = null;
        var coordinateCache = this.coordinateCache_;
        var viewRotation = this.viewRotation_;
        var state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        var batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        var /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ feature;
        var x, y;
        while(i < ii){
            var instruction = instructions[i];
            var type = /** @type {CanvasInstruction} */ instruction[0];
            switch(type){
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ instruction[1];
                    if (skipFeatures && skippedFeaturesHash[(0, $34772e91e89a736f$export$5e82334337e0f204)(feature)] || !feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (opt_hitExtent !== undefined && !(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(opt_hitExtent, feature.getGeometry().getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    var x1 = pixelCoordinates[d];
                    var y1 = pixelCoordinates[d + 1];
                    var x2 = pixelCoordinates[d + 2];
                    var y2 = pixelCoordinates[d + 3];
                    var dx = x2 - x1;
                    var dy = y2 - y1;
                    var r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    var geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    var renderer = instruction[4];
                    var fn = instruction.length == 6 ? instruction[5] : undefined;
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    var coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    declutterGroup = featureCallback ? null : /** @type {import("../canvas.js").DeclutterGroup} */ instruction[6];
                    var height = /** @type {number} */ instruction[7];
                    var opacity = /** @type {number} */ instruction[8];
                    var originX = /** @type {number} */ instruction[9];
                    var originY = /** @type {number} */ instruction[10];
                    var rotateWithView = /** @type {boolean} */ instruction[11];
                    var rotation = /** @type {number} */ instruction[12];
                    var scale = /** @type {number} */ instruction[13];
                    var width = /** @type {number} */ instruction[14];
                    var padding = void 0, backgroundFill = void 0, backgroundStroke = void 0;
                    if (instruction.length > 16) {
                        padding = /** @type {Array<number>} */ instruction[15];
                        backgroundFill = /** @type {boolean} */ instruction[16];
                        backgroundStroke = /** @type {boolean} */ instruction[17];
                    } else {
                        padding = (0, $c8f894129d9fa0b9$export$40a9eeef55665a40);
                        backgroundFill = backgroundStroke = false;
                    }
                    if (rotateWithView) rotation += viewRotation;
                    for(; d < dd; d += 2)this.replayImage_(context, pixelCoordinates[d], pixelCoordinates[d + 1], image, anchorX, anchorY, declutterGroup, height, opacity, originX, originY, rotation, scale, snapToPixel, width, padding, backgroundFill ? /** @type {Array<*>} */ lastFillInstruction : null, backgroundStroke ? /** @type {Array<*>} */ lastStrokeInstruction : null);
                    this.renderDeclutter_(declutterGroup, feature);
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_CHARS:
                    var begin = /** @type {number} */ instruction[1];
                    var end = /** @type {number} */ instruction[2];
                    var baseline = /** @type {number} */ instruction[3];
                    declutterGroup = featureCallback ? null : /** @type {import("../canvas.js").DeclutterGroup} */ instruction[4];
                    var overflow = /** @type {number} */ instruction[5];
                    var fillKey = /** @type {string} */ instruction[6];
                    var maxAngle = /** @type {number} */ instruction[7];
                    var measure = /** @type {function(string):number} */ instruction[8];
                    var offsetY = /** @type {number} */ instruction[9];
                    var strokeKey = /** @type {string} */ instruction[10];
                    var strokeWidth = /** @type {number} */ instruction[11];
                    var text = /** @type {string} */ instruction[12];
                    var textKey = /** @type {string} */ instruction[13];
                    var textScale = /** @type {number} */ instruction[14];
                    var pathLength = (0, $f01092ea270954d4$export$153f8c6b4d8caebc)(pixelCoordinates, begin, end, 2);
                    var textLength = measure(text);
                    if (overflow || textLength <= pathLength) {
                        /** @type {import("./TextReplay.js").default} */ var textReplay = /** @type {?} */ this;
                        var textAlign = textReplay.textStates[textKey].textAlign;
                        var startM = (pathLength - textLength) * (0, $9cc56c68d2780fd0$export$91a016276e4aee96)[textAlign];
                        var parts = (0, $d5f14337ff045de9$export$153a9a17ab3e949f)(pixelCoordinates, begin, end, 2, text, measure, startM, maxAngle);
                        if (parts) {
                            var c = void 0, cc = void 0, chars = void 0, label = void 0, part = void 0;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = textReplay.getImage(chars, textKey, "", strokeKey);
                                anchorX = /** @type {number} */ part[2] + strokeWidth;
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth - offsetY;
                                this.replayImage_(context, /** @type {number} */ part[0], /** @type {number} */ part[1], label, anchorX, anchorY, declutterGroup, label.height, 1, 0, 0, /** @type {number} */ part[3], textScale, false, label.width, (0, $c8f894129d9fa0b9$export$40a9eeef55665a40), null, null);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = textReplay.getImage(chars, textKey, fillKey, "");
                                anchorX = /** @type {number} */ part[2];
                                anchorY = baseline * label.height - offsetY;
                                this.replayImage_(context, /** @type {number} */ part[0], /** @type {number} */ part[1], label, anchorX, anchorY, declutterGroup, label.height, 1, 0, 0, /** @type {number} */ part[3], textScale, false, label.width, (0, $c8f894129d9fa0b9$export$40a9eeef55665a40), null, null);
                            }
                        }
                    }
                    this.renderDeclutter_(declutterGroup, feature);
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ instruction[1];
                        var result = featureCallback(feature);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    roundX = x + 0.5 | 0;
                    roundY = y + 0.5 | 0;
                    if (roundX !== prevX || roundY !== prevY) {
                        context.moveTo(x, y);
                        prevX = roundX;
                        prevY = roundY;
                    }
                    for(d += 2; d < dd; d += 2){
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_FILL_STYLE:
                    lastFillInstruction = instruction;
                    this.alignFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }
                    context.fillStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE:
                    lastStrokeInstruction = instruction;
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i; // consume the instruction anyway, to avoid an infinite loop
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    };
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features
   *     to skip.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   */ CanvasReplay.prototype.replay = function replay(context, transform, viewRotation, skippedFeaturesHash, snapToPixel) {
        this.viewRotation_ = viewRotation;
        this.replay_(context, transform, skippedFeaturesHash, this.instructions, snapToPixel, undefined, undefined);
    };
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features
   *     to skip.
   * @param {function((import("../../Feature.js").default|import("../Feature.js").default)): T=} opt_featureCallback
   *     Feature callback.
   * @param {import("../../extent.js").Extent=} opt_hitExtent Only check features that intersect this
   *     extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ CanvasReplay.prototype.replayHitDetection = function replayHitDetection(context, transform, viewRotation, skippedFeaturesHash, opt_featureCallback, opt_hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.replay_(context, transform, skippedFeaturesHash, this.hitDetectionInstructions, true, opt_featureCallback, opt_hitExtent);
    };
    /**
   * Reverse the hit detection instructions.
   */ CanvasReplay.prototype.reverseHitDetectionInstructions = function reverseHitDetectionInstructions() {
        var hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        var i;
        var n = hitDetectionInstructions.length;
        var instruction;
        var type;
        var begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {CanvasInstruction} */ instruction[0];
            if (type == (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).END_GEOMETRY) begin = i;
            else if (type == (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, $830d23b8323fc080$export$292cfa960964f0e0)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    };
    /**
   * @inheritDoc
   */ CanvasReplay.prototype.setFillStrokeStyle = function setFillStrokeStyle(fillStyle, strokeStyle) {
        var state = this.state;
        if (fillStyle) {
            var fillStyleColor = fillStyle.getColor();
            state.fillStyle = (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2));
        } else state.fillStyle = undefined;
        if (strokeStyle) {
            var strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $c8f894129d9fa0b9$export$1eb2eaecacf2031e));
            var strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $c8f894129d9fa0b9$export$17bd0c38d6ae694e);
            var strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc);
            var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $c8f894129d9fa0b9$export$e06efc2409049f76);
            var strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $c8f894129d9fa0b9$export$365eb9648cf19bd0);
            var strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $c8f894129d9fa0b9$export$79661f132c62010e);
            var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $c8f894129d9fa0b9$export$80c1c01844597b7b);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
        }
    };
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @return {Array<*>} Fill instruction.
   */ CanvasReplay.prototype.createFill = function createFill(state, geometry) {
        var fillStyle = state.fillStyle;
        /** @type {Array<*>} */ var fillInstruction = [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== "string") // Fill is a pattern or gradient - align it!
        fillInstruction.push(true);
        return fillInstruction;
    };
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ CanvasReplay.prototype.applyStroke = function applyStroke(state) {
        this.instructions.push(this.createStroke(state));
    };
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */ CanvasReplay.prototype.createStroke = function createStroke(state) {
        return [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            this.applyPixelRatio(state.lineDash),
            state.lineDashOffset * this.pixelRatio
        ];
    };
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasReplay, import("../canvas.js").FillStrokeState, (import("../../geom/Geometry.js").default|import("../Feature.js").default)):Array<*>} createFill Create fill.
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry Geometry.
   */ CanvasReplay.prototype.updateFillStyle = function updateFillStyle(state, createFill, geometry) {
        var fillStyle = state.fillStyle;
        if (typeof fillStyle !== "string" || state.currentFillStyle != fillStyle) {
            if (fillStyle !== undefined) this.instructions.push(createFill.call(this, state, geometry));
            state.currentFillStyle = fillStyle;
        }
    };
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasReplay, import("../canvas.js").FillStrokeState)} applyStroke Apply stroke.
   */ CanvasReplay.prototype.updateStrokeStyle = function updateStrokeStyle(state, applyStroke) {
        var strokeStyle = state.strokeStyle;
        var lineCap = state.lineCap;
        var lineDash = state.lineDash;
        var lineDashOffset = state.lineDashOffset;
        var lineJoin = state.lineJoin;
        var lineWidth = state.lineWidth;
        var miterLimit = state.miterLimit;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $830d23b8323fc080$export$e9bab7fafb253603)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit) {
            if (strokeStyle !== undefined) applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
        }
    };
    /**
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
   */ CanvasReplay.prototype.endGeometry = function endGeometry(geometry, feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        var endGeometryInstruction = [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    };
    /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */ CanvasReplay.prototype.getBufferedMaxExtent = function getBufferedMaxExtent() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, $7e819822b33b3d32$export$9cd59f9826255e47)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                var width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, $7e819822b33b3d32$export$ab1029bcae9ddb4a)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    };
    return CanvasReplay;
}((0, $37298fa487b80ee5$export$2e2bcd8739ae039));
var $4a4b550eb212a23b$export$2e2bcd8739ae039 = $4a4b550eb212a23b$var$CanvasReplay;


/**
 * @module ol/render/canvas/ImageReplay
 */ 

var $de4b7300cd005a8c$var$CanvasImageReplay = /*@__PURE__*/ function(CanvasReplay) {
    function CanvasImageReplay(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree) {
        CanvasReplay.call(this, tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree);
        /**
     * @private
     * @type {import("../canvas.js").DeclutterGroup}
     */ this.declutterGroup_ = null;
        /**
     * @private
     * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
     */ this.image_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorY_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.height_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.opacity_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originY_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.scale_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = undefined;
    }
    if (CanvasReplay) CanvasImageReplay.__proto__ = CanvasReplay;
    CanvasImageReplay.prototype = Object.create(CanvasReplay && CanvasReplay.prototype);
    CanvasImageReplay.prototype.constructor = CanvasImageReplay;
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   * @return {number} My end.
   */ CanvasImageReplay.prototype.drawCoordinates_ = function drawCoordinates_(flatCoordinates, offset, end, stride) {
        return this.appendFlatCoordinates(flatCoordinates, offset, end, stride, false, false);
    };
    /**
   * @inheritDoc
   */ CanvasImageReplay.prototype.drawPoint = function drawPoint(pointGeometry, feature) {
        if (!this.image_) return;
        this.beginGeometry(pointGeometry, feature);
        var flatCoordinates = pointGeometry.getFlatCoordinates();
        var stride = pointGeometry.getStride();
        var myBegin = this.coordinates.length;
        var myEnd = this.drawCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
        this.instructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.declutterGroup_,
            this.height_,
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_ * this.pixelRatio,
            this.width_
        ]);
        this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.declutterGroup_,
            this.height_,
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_
        ]);
        this.endGeometry(pointGeometry, feature);
    };
    /**
   * @inheritDoc
   */ CanvasImageReplay.prototype.drawMultiPoint = function drawMultiPoint(multiPointGeometry, feature) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature);
        var flatCoordinates = multiPointGeometry.getFlatCoordinates();
        var stride = multiPointGeometry.getStride();
        var myBegin = this.coordinates.length;
        var myEnd = this.drawCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
        this.instructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.declutterGroup_,
            this.height_,
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_ * this.pixelRatio,
            this.width_
        ]);
        this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.declutterGroup_,
            this.height_,
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_
        ]);
        this.endGeometry(multiPointGeometry, feature);
    };
    /**
   * @inheritDoc
   */ CanvasImageReplay.prototype.finish = function finish() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
    };
    /**
   * @inheritDoc
   */ CanvasImageReplay.prototype.setImageStyle = function setImageStyle(imageStyle, declutterGroup) {
        var anchor = imageStyle.getAnchor();
        var size = imageStyle.getSize();
        var hitDetectionImage = imageStyle.getHitDetectionImage(1);
        var image = imageStyle.getImage(1);
        var origin = imageStyle.getOrigin();
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.declutterGroup_ = /** @type {import("../canvas.js").DeclutterGroup} */ declutterGroup;
        this.hitDetectionImage_ = hitDetectionImage;
        this.image_ = image;
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScale();
        this.width_ = size[0];
    };
    return CanvasImageReplay;
}((0, $4a4b550eb212a23b$export$2e2bcd8739ae039));
var $de4b7300cd005a8c$export$2e2bcd8739ae039 = $de4b7300cd005a8c$var$CanvasImageReplay;


/**
 * @module ol/render/canvas/LineStringReplay
 */ 

var $dd420074d5efdf60$var$CanvasLineStringReplay = /*@__PURE__*/ function(CanvasReplay) {
    function CanvasLineStringReplay(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree) {
        CanvasReplay.call(this, tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree);
    }
    if (CanvasReplay) CanvasLineStringReplay.__proto__ = CanvasReplay;
    CanvasLineStringReplay.prototype = Object.create(CanvasReplay && CanvasReplay.prototype);
    CanvasLineStringReplay.prototype.constructor = CanvasLineStringReplay;
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   * @return {number} end.
   */ CanvasLineStringReplay.prototype.drawFlatCoordinates_ = function drawFlatCoordinates_(flatCoordinates, offset, end, stride) {
        var myBegin = this.coordinates.length;
        var myEnd = this.appendFlatCoordinates(flatCoordinates, offset, end, stride, false, false);
        var moveToLineToInstruction = [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
            myBegin,
            myEnd
        ];
        this.instructions.push(moveToLineToInstruction);
        this.hitDetectionInstructions.push(moveToLineToInstruction);
        return end;
    };
    /**
   * @inheritDoc
   */ CanvasLineStringReplay.prototype.drawLineString = function drawLineString(lineStringGeometry, feature) {
        var state = this.state;
        var strokeStyle = state.strokeStyle;
        var lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature);
        this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ], (0, $3b9081ec7a886d58$export$9f746cc58a899a00));
        var flatCoordinates = lineStringGeometry.getFlatCoordinates();
        var stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
        this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
        this.endGeometry(lineStringGeometry, feature);
    };
    /**
   * @inheritDoc
   */ CanvasLineStringReplay.prototype.drawMultiLineString = function drawMultiLineString(multiLineStringGeometry, feature) {
        var state = this.state;
        var strokeStyle = state.strokeStyle;
        var lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature);
        this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ], (0, $3b9081ec7a886d58$export$9f746cc58a899a00));
        var ends = multiLineStringGeometry.getEnds();
        var flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        var stride = multiLineStringGeometry.getStride();
        var offset = 0;
        for(var i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, ends[i], stride);
        this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
        this.endGeometry(multiLineStringGeometry, feature);
    };
    /**
   * @inheritDoc
   */ CanvasLineStringReplay.prototype.finish = function finish() {
        var state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
        this.reverseHitDetectionInstructions();
        this.state = null;
    };
    /**
   * @inheritDoc.
   */ CanvasLineStringReplay.prototype.applyStroke = function applyStroke(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        CanvasReplay.prototype.applyStroke.call(this, state);
        this.instructions.push((0, $3b9081ec7a886d58$export$9f746cc58a899a00));
    };
    return CanvasLineStringReplay;
}((0, $4a4b550eb212a23b$export$2e2bcd8739ae039));
var $dd420074d5efdf60$export$2e2bcd8739ae039 = $dd420074d5efdf60$var$CanvasLineStringReplay;


/**
 * @module ol/render/canvas/PolygonReplay
 */ 




var $dc6cd1503b67ffe9$var$CanvasPolygonReplay = /*@__PURE__*/ function(CanvasReplay) {
    function CanvasPolygonReplay(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree) {
        CanvasReplay.call(this, tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree);
    }
    if (CanvasReplay) CanvasPolygonReplay.__proto__ = CanvasReplay;
    CanvasPolygonReplay.prototype = Object.create(CanvasReplay && CanvasReplay.prototype);
    CanvasPolygonReplay.prototype.constructor = CanvasPolygonReplay;
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ CanvasPolygonReplay.prototype.drawFlatCoordinatess_ = function drawFlatCoordinatess_(flatCoordinates, offset, ends, stride) {
        var state = this.state;
        var fill = state.fillStyle !== undefined;
        var stroke = state.strokeStyle != undefined;
        var numEnds = ends.length;
        this.instructions.push((0, $3b9081ec7a886d58$export$9f746cc58a899a00));
        this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$9f746cc58a899a00));
        for(var i = 0; i < numEnds; ++i){
            var end = ends[i];
            var myBegin = this.coordinates.length;
            var myEnd = this.appendFlatCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            var moveToLineToInstruction = [
                (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                myBegin,
                myEnd
            ];
            this.instructions.push(moveToLineToInstruction);
            this.hitDetectionInstructions.push(moveToLineToInstruction);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatCoordinates above).
                this.instructions.push((0, $3b9081ec7a886d58$export$89b10f327e413e71));
                this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$89b10f327e413e71));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, $3b9081ec7a886d58$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$f21891651e408226));
        }
        if (stroke) {
            this.instructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
        }
        return offset;
    };
    /**
   * @inheritDoc
   */ CanvasPolygonReplay.prototype.drawCircle = function drawCircle(circleGeometry, feature) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        var strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_(circleGeometry);
        this.beginGeometry(circleGeometry, feature);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $2c17bfc916c8f689$export$590567be997858b6)((0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2))
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ]);
        var flatCoordinates = circleGeometry.getFlatCoordinates();
        var stride = circleGeometry.getStride();
        var myBegin = this.coordinates.length;
        this.appendFlatCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        var circleInstruction = [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CIRCLE,
            myBegin
        ];
        this.instructions.push((0, $3b9081ec7a886d58$export$9f746cc58a899a00), circleInstruction);
        this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$9f746cc58a899a00), circleInstruction);
        this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$f21891651e408226));
        if (state.fillStyle !== undefined) this.instructions.push((0, $3b9081ec7a886d58$export$f21891651e408226));
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
        }
        this.endGeometry(circleGeometry, feature);
    };
    /**
   * @inheritDoc
   */ CanvasPolygonReplay.prototype.drawPolygon = function drawPolygon(polygonGeometry, feature) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        var strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_(polygonGeometry);
        this.beginGeometry(polygonGeometry, feature);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $2c17bfc916c8f689$export$590567be997858b6)((0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2))
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ]);
        var ends = polygonGeometry.getEnds();
        var flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        var stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, ends, stride);
        this.endGeometry(polygonGeometry, feature);
    };
    /**
   * @inheritDoc
   */ CanvasPolygonReplay.prototype.drawMultiPolygon = function drawMultiPolygon(multiPolygonGeometry, feature) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        var strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_(multiPolygonGeometry);
        this.beginGeometry(multiPolygonGeometry, feature);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $2c17bfc916c8f689$export$590567be997858b6)((0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2))
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ]);
        var endss = multiPolygonGeometry.getEndss();
        var flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        var stride = multiPolygonGeometry.getStride();
        var offset = 0;
        for(var i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
        this.endGeometry(multiPolygonGeometry, feature);
    };
    /**
   * @inheritDoc
   */ CanvasPolygonReplay.prototype.finish = function finish() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        var tolerance = this.tolerance;
        if (tolerance !== 0) {
            var coordinates = this.coordinates;
            for(var i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $ab8844daaf207c08$export$51a0620f7a28532b)(coordinates[i], tolerance);
        }
    };
    /**
   * @private
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry Geometry.
   */ CanvasPolygonReplay.prototype.setFillStrokeStyles_ = function setFillStrokeStyles_(geometry) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        if (fillStyle !== undefined) this.updateFillStyle(state, this.createFill, geometry);
        if (state.strokeStyle !== undefined) this.updateStrokeStyle(state, this.applyStroke);
    };
    return CanvasPolygonReplay;
}((0, $4a4b550eb212a23b$export$2e2bcd8739ae039));
var $dc6cd1503b67ffe9$export$2e2bcd8739ae039 = $dc6cd1503b67ffe9$var$CanvasPolygonReplay;


/**
 * @module ol/render/canvas/TextReplay
 */ 



/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $5ec5eeea02e3e4f4$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    var chunkStart = offset;
    var chunkEnd = offset;
    var chunkM = 0;
    var m = 0;
    var start = offset;
    var acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        var x2 = flatCoordinates[i];
        var y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}








/**
 * @module ol/style/TextPlacement
 */ /**
 * Text placement. One of `'point'`, `'line'`. Default is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 * @enum {string}
 */ var $f7c37f665517c7c3$export$2e2bcd8739ae039 = {
    POINT: "point",
    LINE: "line"
};


var $019c43c1a83ab259$var$CanvasTextReplay = /*@__PURE__*/ function(CanvasReplay) {
    function CanvasTextReplay(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree) {
        CanvasReplay.call(this, tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree);
        /**
     * @private
     * @type {import("../canvas.js").DeclutterGroup}
     */ this.declutterGroup_;
        /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */ this.labels_ = null;
        /**
     * @private
     * @type {string}
     */ this.text_ = "";
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textRotateWithView_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = {};
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = {};
        /**
     * @private
     * @type {import("../canvas.js").TextState}
     */ this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = {};
        /**
     * @private
     * @type {string}
     */ this.textKey_ = "";
        /**
     * @private
     * @type {string}
     */ this.fillKey_ = "";
        /**
     * @private
     * @type {string}
     */ this.strokeKey_ = "";
        /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */ this.widths_ = {};
        (0, $c8f894129d9fa0b9$export$18212182f4e22723).prune();
    }
    if (CanvasReplay) CanvasTextReplay.__proto__ = CanvasReplay;
    CanvasTextReplay.prototype = Object.create(CanvasReplay && CanvasReplay.prototype);
    CanvasTextReplay.prototype.constructor = CanvasTextReplay;
    /**
   * @inheritDoc
   */ CanvasTextReplay.prototype.drawText = function drawText(geometry, feature) {
        var fillState = this.textFillState_;
        var strokeState = this.textStrokeState_;
        var textState = this.textState_;
        if (this.text_ === "" || !textState || !fillState && !strokeState) return;
        var begin = this.coordinates.length;
        var geometryType = geometry.getType();
        var flatCoordinates = null;
        var end = 2;
        var stride = 2;
        var i, ii;
        if (textState.placement === (0, $f7c37f665517c7c3$export$2e2bcd8739ae039).LINE) {
            if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.getBufferedMaxExtent(), geometry.getExtent())) return;
            var ends;
            flatCoordinates = geometry.getFlatCoordinates();
            stride = geometry.getStride();
            if (geometryType == (0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING) ends = [
                flatCoordinates.length
            ];
            else if (geometryType == (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_LINE_STRING) ends = geometry.getEnds();
            else if (geometryType == (0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON) ends = geometry.getEnds().slice(0, 1);
            else if (geometryType == (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POLYGON) {
                var endss = geometry.getEndss();
                ends = [];
                for(i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            this.beginGeometry(geometry, feature);
            var textAlign = textState.textAlign;
            var flatOffset = 0;
            var flatEnd;
            for(var o = 0, oo = ends.length; o < oo; ++o){
                if (textAlign == undefined) {
                    var range = (0, $5ec5eeea02e3e4f4$export$ed6c897eea07a254)(textState.maxAngle, flatCoordinates, flatOffset, ends[o], stride);
                    flatOffset = range[0];
                    flatEnd = range[1];
                } else flatEnd = ends[o];
                for(i = flatOffset; i < flatEnd; i += stride)this.coordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
                end = this.coordinates.length;
                flatOffset = ends[o];
                this.drawChars_(begin, end, this.declutterGroup_);
                begin = end;
            }
            this.endGeometry(geometry, feature);
        } else {
            var label = this.getImage(this.text_, this.textKey_, this.fillKey_, this.strokeKey_);
            var width = label.width / this.pixelRatio;
            switch(geometryType){
                case (0, $8826602b1d512d67$export$2e2bcd8739ae039).POINT:
                case (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POINT:
                    flatCoordinates = geometry.getFlatCoordinates();
                    end = flatCoordinates.length;
                    break;
                case (0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING:
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case (0, $8826602b1d512d67$export$2e2bcd8739ae039).CIRCLE:
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_LINE_STRING:
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    end = flatCoordinates.length;
                    break;
                case (0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON:
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow && flatCoordinates[2] / this.resolution < width) return;
                    stride = 3;
                    break;
                case (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POLYGON:
                    var interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(i = 0, ii = interiorPoints.length; i < ii; i += 3)if (textState.overflow || interiorPoints[i + 2] / this.resolution >= width) flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    end = flatCoordinates.length;
                    if (end == 0) return;
                    break;
                default:
            }
            end = this.appendFlatCoordinates(flatCoordinates, 0, end, stride, false, false);
            if (textState.backgroundFill || textState.backgroundStroke) {
                this.setFillStrokeStyle(textState.backgroundFill, textState.backgroundStroke);
                if (textState.backgroundFill) {
                    this.updateFillStyle(this.state, this.createFill, geometry);
                    this.hitDetectionInstructions.push(this.createFill(this.state, geometry));
                }
                if (textState.backgroundStroke) {
                    this.updateStrokeStyle(this.state, this.applyStroke);
                    this.hitDetectionInstructions.push(this.createStroke(this.state));
                }
            }
            this.beginGeometry(geometry, feature);
            this.drawTextImage_(label, begin, end);
            this.endGeometry(geometry, feature);
        }
    };
    /**
   * @param {string} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {HTMLCanvasElement} Image.
   */ CanvasTextReplay.prototype.getImage = function getImage(text, textKey, fillKey, strokeKey) {
        var label;
        var key = strokeKey + textKey + text + fillKey + this.pixelRatio;
        if (!(0, $c8f894129d9fa0b9$export$18212182f4e22723).containsKey(key)) {
            var strokeState = strokeKey ? this.strokeStates[strokeKey] || this.textStrokeState_ : null;
            var fillState = fillKey ? this.fillStates[fillKey] || this.textFillState_ : null;
            var textState = this.textStates[textKey] || this.textState_;
            var pixelRatio = this.pixelRatio;
            var scale = textState.scale * pixelRatio;
            var align = (0, $9cc56c68d2780fd0$export$91a016276e4aee96)[textState.textAlign || (0, $c8f894129d9fa0b9$export$94d53b95641b5766)];
            var strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
            var lines = text.split("\n");
            var numLines = lines.length;
            var widths = [];
            var width = $019c43c1a83ab259$export$a539decdd6096c57(textState.font, lines, widths);
            var lineHeight = (0, $c8f894129d9fa0b9$export$4feaf6852ff92513)(textState.font);
            var height = lineHeight * numLines;
            var renderWidth = width + strokeWidth;
            var context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(Math.ceil(renderWidth * scale), Math.ceil((height + strokeWidth) * scale));
            label = context.canvas;
            (0, $c8f894129d9fa0b9$export$18212182f4e22723).set(key, label);
            if (scale != 1) context.scale(scale, scale);
            context.font = textState.font;
            if (strokeKey) {
                context.strokeStyle = strokeState.strokeStyle;
                context.lineWidth = strokeWidth;
                context.lineCap = /** @type {CanvasLineCap} */ strokeState.lineCap;
                context.lineJoin = /** @type {CanvasLineJoin} */ strokeState.lineJoin;
                context.miterLimit = strokeState.miterLimit;
                if ((0, $89969764a1196844$export$c986c2374f97af1a) && strokeState.lineDash.length) {
                    context.setLineDash(strokeState.lineDash);
                    context.lineDashOffset = strokeState.lineDashOffset;
                }
            }
            if (fillKey) context.fillStyle = fillState.fillStyle;
            context.textBaseline = "middle";
            context.textAlign = "center";
            var leftRight = 0.5 - align;
            var x = align * label.width / scale + leftRight * strokeWidth;
            var i;
            if (strokeKey) for(i = 0; i < numLines; ++i)context.strokeText(lines[i], x + leftRight * widths[i], 0.5 * (strokeWidth + lineHeight) + i * lineHeight);
            if (fillKey) for(i = 0; i < numLines; ++i)context.fillText(lines[i], x + leftRight * widths[i], 0.5 * (strokeWidth + lineHeight) + i * lineHeight);
        }
        return (0, $c8f894129d9fa0b9$export$18212182f4e22723).get(key);
    };
    /**
   * @private
   * @param {HTMLCanvasElement} label Label.
   * @param {number} begin Begin.
   * @param {number} end End.
   */ CanvasTextReplay.prototype.drawTextImage_ = function drawTextImage_(label, begin, end) {
        var textState = this.textState_;
        var strokeState = this.textStrokeState_;
        var pixelRatio = this.pixelRatio;
        var align = (0, $9cc56c68d2780fd0$export$91a016276e4aee96)[textState.textAlign || (0, $c8f894129d9fa0b9$export$94d53b95641b5766)];
        var baseline = (0, $9cc56c68d2780fd0$export$91a016276e4aee96)[textState.textBaseline];
        var strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        var anchorX = align * label.width / pixelRatio + 2 * (0.5 - align) * strokeWidth;
        var anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        this.instructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE,
            begin,
            end,
            label,
            (anchorX - this.textOffsetX_) * pixelRatio,
            (anchorY - this.textOffsetY_) * pixelRatio,
            this.declutterGroup_,
            label.height,
            1,
            0,
            0,
            this.textRotateWithView_,
            this.textRotation_,
            1,
            label.width,
            textState.padding == (0, $c8f894129d9fa0b9$export$40a9eeef55665a40) ? (0, $c8f894129d9fa0b9$export$40a9eeef55665a40) : textState.padding.map(function(p) {
                return p * pixelRatio;
            }),
            !!textState.backgroundFill,
            !!textState.backgroundStroke
        ]);
        this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE,
            begin,
            end,
            label,
            (anchorX - this.textOffsetX_) * pixelRatio,
            (anchorY - this.textOffsetY_) * pixelRatio,
            this.declutterGroup_,
            label.height,
            1,
            0,
            0,
            this.textRotateWithView_,
            this.textRotation_,
            1 / pixelRatio,
            label.width,
            textState.padding,
            !!textState.backgroundFill,
            !!textState.backgroundStroke
        ]);
    };
    /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   * @param {import("../canvas.js").DeclutterGroup} declutterGroup Declutter group.
   */ CanvasTextReplay.prototype.drawChars_ = function drawChars_(begin, end, declutterGroup) {
        var strokeState = this.textStrokeState_;
        var textState = this.textState_;
        var fillState = this.textFillState_;
        var strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = /** @type {import("../canvas.js").StrokeState} */ {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        var textKey = this.textKey_;
        if (!(this.textKey_ in this.textStates)) this.textStates[this.textKey_] = /** @type {import("../canvas.js").TextState} */ {
            font: textState.font,
            textAlign: textState.textAlign || (0, $c8f894129d9fa0b9$export$94d53b95641b5766),
            scale: textState.scale
        };
        var fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = /** @type {import("../canvas.js").FillState} */ {
                fillStyle: fillState.fillStyle
            };
        }
        var pixelRatio = this.pixelRatio;
        var baseline = (0, $9cc56c68d2780fd0$export$91a016276e4aee96)[textState.textBaseline];
        var offsetY = this.textOffsetY_ * pixelRatio;
        var text = this.text_;
        var font = textState.font;
        var textScale = textState.scale;
        var strokeWidth = strokeState ? strokeState.lineWidth * textScale / 2 : 0;
        var widths = this.widths_[font];
        if (!widths) this.widths_[font] = widths = {};
        this.instructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            declutterGroup,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            function(text) {
                var width = widths[text];
                if (!width) width = widths[text] = (0, $c8f894129d9fa0b9$export$4ea92329b673abd1)(font, text);
                return width * textScale * pixelRatio;
            },
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1
        ]);
        this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            declutterGroup,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            function(text) {
                var width = widths[text];
                if (!width) width = widths[text] = (0, $c8f894129d9fa0b9$export$4ea92329b673abd1)(font, text);
                return width * textScale;
            },
            offsetY,
            strokeKey,
            strokeWidth,
            text,
            textKey,
            1 / pixelRatio
        ]);
    };
    /**
   * @inheritDoc
   */ CanvasTextReplay.prototype.setTextStyle = function setTextStyle(textStyle, declutterGroup) {
        var textState, fillState, strokeState;
        if (!textStyle) this.text_ = "";
        else {
            this.declutterGroup_ = /** @type {import("../canvas.js").DeclutterGroup} */ declutterGroup;
            var textFillStyle = textStyle.getFill();
            if (!textFillStyle) fillState = this.textFillState_ = null;
            else {
                fillState = this.textFillState_;
                if (!fillState) fillState = this.textFillState_ = /** @type {import("../canvas.js").FillState} */ {};
                fillState.fillStyle = (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(textFillStyle.getColor() || (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2));
            }
            var textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) strokeState = this.textStrokeState_ = null;
            else {
                strokeState = this.textStrokeState_;
                if (!strokeState) strokeState = this.textStrokeState_ = /** @type {import("../canvas.js").StrokeState} */ {};
                var lineDash = textStrokeStyle.getLineDash();
                var lineDashOffset = textStrokeStyle.getLineDashOffset();
                var lineWidth = textStrokeStyle.getWidth();
                var miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $c8f894129d9fa0b9$export$17bd0c38d6ae694e);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $c8f894129d9fa0b9$export$e06efc2409049f76) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $c8f894129d9fa0b9$export$365eb9648cf19bd0);
                strokeState.lineWidth = lineWidth === undefined ? (0, $c8f894129d9fa0b9$export$79661f132c62010e) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, $c8f894129d9fa0b9$export$80c1c01844597b7b) : miterLimit;
                strokeState.strokeStyle = (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(textStrokeStyle.getColor() || (0, $c8f894129d9fa0b9$export$1eb2eaecacf2031e));
            }
            textState = this.textState_;
            var font = textStyle.getFont() || (0, $c8f894129d9fa0b9$export$3847dfea4f8d4dfa);
            (0, $c8f894129d9fa0b9$export$ea12437b7b2e443e)(font);
            var textScale = textStyle.getScale();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.textBaseline = textStyle.getTextBaseline() || (0, $c8f894129d9fa0b9$export$cf2279a1bff62eb);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, $c8f894129d9fa0b9$export$40a9eeef55665a40);
            textState.scale = textScale === undefined ? 1 : textScale;
            var textOffsetX = textStyle.getOffsetX();
            var textOffsetY = textStyle.getOffsetY();
            var textRotateWithView = textStyle.getRotateWithView();
            var textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || "";
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == "string" ? strokeState.strokeStyle : (0, $34772e91e89a736f$export$5e82334337e0f204)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + "|" + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + "[" + strokeState.lineDash.join() + "]" : "";
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || "?");
            this.fillKey_ = fillState ? typeof fillState.fillStyle == "string" ? fillState.fillStyle : "|" + (0, $34772e91e89a736f$export$5e82334337e0f204)(fillState.fillStyle) : "";
        }
    };
    return CanvasTextReplay;
}((0, $4a4b550eb212a23b$export$2e2bcd8739ae039));
function $019c43c1a83ab259$export$a539decdd6096c57(font, lines, widths) {
    var numLines = lines.length;
    var width = 0;
    for(var i = 0; i < numLines; ++i){
        var currentWidth = (0, $c8f894129d9fa0b9$export$4ea92329b673abd1)(font, lines[i]);
        width = Math.max(width, currentWidth);
        widths.push(currentWidth);
    }
    return width;
}
var $019c43c1a83ab259$export$2e2bcd8739ae039 = $019c43c1a83ab259$var$CanvasTextReplay;




/**
 * @type {Object<ReplayType, typeof CanvasReplay>}
 */ var $afd1450603f7bfcd$var$BATCH_CONSTRUCTORS = {
    "Circle": (0, $dc6cd1503b67ffe9$export$2e2bcd8739ae039),
    "Default": (0, $4a4b550eb212a23b$export$2e2bcd8739ae039),
    "Image": (0, $de4b7300cd005a8c$export$2e2bcd8739ae039),
    "LineString": (0, $dd420074d5efdf60$export$2e2bcd8739ae039),
    "Polygon": (0, $dc6cd1503b67ffe9$export$2e2bcd8739ae039),
    "Text": (0, $019c43c1a83ab259$export$2e2bcd8739ae039)
};
var $afd1450603f7bfcd$var$CanvasReplayGroup = /*@__PURE__*/ function(ReplayGroup) {
    function CanvasReplayGroup(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree, opt_renderBuffer) {
        ReplayGroup.call(this);
        /**
     * Declutter tree.
     * @private
     */ this.declutterTree_ = declutterTree;
        /**
     * @type {import("../canvas.js").DeclutterGroup}
     * @private
     */ this.declutterGroup_ = null;
        /**
     * @private
     * @type {number}
     */ this.tolerance_ = tolerance;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = overlaps;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderBuffer_ = opt_renderBuffer;
        /**
     * @private
     * @type {!Object<string, !Object<ReplayType, CanvasReplay>>}
     */ this.replaysByZIndex_ = {};
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.hitDetectionContext_ = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(1, 1);
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.hitDetectionTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
    }
    if (ReplayGroup) CanvasReplayGroup.__proto__ = ReplayGroup;
    CanvasReplayGroup.prototype = Object.create(ReplayGroup && ReplayGroup.prototype);
    CanvasReplayGroup.prototype.constructor = CanvasReplayGroup;
    /**
   * @inheritDoc
   */ CanvasReplayGroup.prototype.addDeclutter = function addDeclutter(group) {
        var declutter = null;
        if (this.declutterTree_) {
            if (group) {
                declutter = this.declutterGroup_;
                /** @type {number} */ declutter[4]++;
            } else {
                declutter = this.declutterGroup_ = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
                declutter.push(1);
            }
        }
        return declutter;
    };
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */ CanvasReplayGroup.prototype.clip = function clip(context, transform) {
        var flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    };
    /**
   * @param {Array<ReplayType>} replays Replays.
   * @return {boolean} Has replays of the provided types.
   */ CanvasReplayGroup.prototype.hasReplays = function hasReplays(replays) {
        for(var zIndex in this.replaysByZIndex_){
            var candidates = this.replaysByZIndex_[zIndex];
            for(var i = 0, ii = replays.length; i < ii; ++i){
                if (replays[i] in candidates) return true;
            }
        }
        return false;
    };
    /**
   * FIXME empty description for jsdoc
   */ CanvasReplayGroup.prototype.finish = function finish() {
        for(var zKey in this.replaysByZIndex_){
            var replays = this.replaysByZIndex_[zKey];
            for(var replayKey in replays)replays[replayKey].finish();
        }
    };
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
   * @param {function((import("../../Feature.js").default|import("../Feature.js").default)): T} callback Feature callback.
   * @param {Object<string, import("../canvas.js").DeclutterGroup>} declutterReplays Declutter replays.
   * @return {T|undefined} Callback result.
   * @template T
   */ CanvasReplayGroup.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, skippedFeaturesHash, callback, declutterReplays) {
        hitTolerance = Math.round(hitTolerance);
        var contextSize = hitTolerance * 2 + 1;
        var transform = (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        var context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else context.clearRect(0, 0, contextSize, contextSize);
        /**
     * @type {import("../../extent.js").Extent}
     */ var hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
            (0, $7e819822b33b3d32$export$1f820e3920fa5715)(hitExtent, coordinate);
            (0, $7e819822b33b3d32$export$ab1029bcae9ddb4a)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        var mask = $afd1450603f7bfcd$export$90d5d4c95ce0eca8(hitTolerance);
        var declutteredFeatures;
        if (this.declutterTree_) declutteredFeatures = this.declutterTree_.all().map(function(entry) {
            return entry.value;
        });
        var replayType;
        /**
     * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
     * @return {?} Callback result.
     */ function featureCallback(feature) {
            var imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(var i = 0; i < contextSize; i++)for(var j = 0; j < contextSize; j++){
                if (mask[i][j]) {
                    if (imageData[(j * contextSize + i) * 4 + 3] > 0) {
                        var result = void 0;
                        if (!(declutteredFeatures && (replayType == (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).IMAGE || replayType == (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT)) || declutteredFeatures.indexOf(feature) !== -1) result = callback(feature);
                        if (result) return result;
                        else {
                            context.clearRect(0, 0, contextSize, contextSize);
                            return undefined;
                        }
                    }
                }
            }
        }
        /** @type {Array<number>} */ var zs = Object.keys(this.replaysByZIndex_).map(Number);
        zs.sort((0, $830d23b8323fc080$export$4e734a3b32fb971b));
        var i, j, replays, replay, result;
        for(i = zs.length - 1; i >= 0; --i){
            var zIndexKey = zs[i].toString();
            replays = this.replaysByZIndex_[zIndexKey];
            for(j = (0, $9cc56c68d2780fd0$export$11e75bce9f7ea886).length - 1; j >= 0; --j){
                replayType = (0, $9cc56c68d2780fd0$export$11e75bce9f7ea886)[j];
                replay = replays[replayType];
                if (replay !== undefined) {
                    if (declutterReplays && (replayType == (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).IMAGE || replayType == (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT)) {
                        var declutter = declutterReplays[zIndexKey];
                        if (!declutter) declutterReplays[zIndexKey] = [
                            replay,
                            transform.slice(0)
                        ];
                        else declutter.push(replay, transform.slice(0));
                    } else {
                        result = replay.replayHitDetection(context, transform, rotation, skippedFeaturesHash, featureCallback, hitExtent);
                        if (result) return result;
                    }
                }
            }
        }
        return undefined;
    };
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>} Clip coordinates.
   */ CanvasReplayGroup.prototype.getClipCoords = function getClipCoords(transform) {
        var maxExtent = this.maxExtent_;
        var minX = maxExtent[0];
        var minY = maxExtent[1];
        var maxX = maxExtent[2];
        var maxY = maxExtent[3];
        var flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, $24a54079104c80a7$export$b92b2dedcfff79de)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    };
    /**
   * @inheritDoc
   */ CanvasReplayGroup.prototype.getReplay = function getReplay(zIndex, replayType) {
        var zIndexKey = zIndex !== undefined ? zIndex.toString() : "0";
        var replays = this.replaysByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.replaysByZIndex_[zIndexKey] = replays;
        }
        var replay = replays[replayType];
        if (replay === undefined) {
            var Constructor = $afd1450603f7bfcd$var$BATCH_CONSTRUCTORS[replayType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_, this.overlaps_, this.declutterTree_);
            replays[replayType] = replay;
        }
        return replay;
    };
    /**
   * @return {Object<string, Object<ReplayType, CanvasReplay>>} Replays.
   */ CanvasReplayGroup.prototype.getReplays = function getReplays() {
        return this.replaysByZIndex_;
    };
    /**
   * @inheritDoc
   */ CanvasReplayGroup.prototype.isEmpty = function isEmpty$1() {
        return (0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(this.replaysByZIndex_);
    };
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<ReplayType>=} opt_replayTypes Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ORDER}
   * @param {Object<string, import("../canvas.js").DeclutterGroup>=} opt_declutterReplays Declutter replays.
   */ CanvasReplayGroup.prototype.replay = function replay(context, transform, viewRotation, skippedFeaturesHash, snapToPixel, opt_replayTypes, opt_declutterReplays) {
        /** @type {Array<number>} */ var zs = Object.keys(this.replaysByZIndex_).map(Number);
        zs.sort((0, $830d23b8323fc080$export$4e734a3b32fb971b));
        // setup clipping so that the parts of over-simplified geometries are not
        // visible outside the current extent when panning
        context.save();
        this.clip(context, transform);
        var replayTypes = opt_replayTypes ? opt_replayTypes : (0, $9cc56c68d2780fd0$export$11e75bce9f7ea886);
        var i, ii, j, jj, replays, replay;
        for(i = 0, ii = zs.length; i < ii; ++i){
            var zIndexKey = zs[i].toString();
            replays = this.replaysByZIndex_[zIndexKey];
            for(j = 0, jj = replayTypes.length; j < jj; ++j){
                var replayType = replayTypes[j];
                replay = replays[replayType];
                if (replay !== undefined) {
                    if (opt_declutterReplays && (replayType == (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).IMAGE || replayType == (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT)) {
                        var declutter = opt_declutterReplays[zIndexKey];
                        if (!declutter) opt_declutterReplays[zIndexKey] = [
                            replay,
                            transform.slice(0)
                        ];
                        else declutter.push(replay, transform.slice(0));
                    } else replay.replay(context, transform, viewRotation, skippedFeaturesHash, snapToPixel);
                }
            }
        }
        context.restore();
    };
    return CanvasReplayGroup;
}((0, $e212d309c766cc76$export$2e2bcd8739ae039));
/**
 * This cache is used for storing calculated pixel circles for increasing performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<Array<(boolean|undefined)>>>}
 */ var $afd1450603f7bfcd$var$circleArrayCache = {
    0: [
        [
            true
        ]
    ]
};
/**
 * This method fills a row in the array from the given coordinate to the
 * middle with `true`.
 * @param {Array<Array<(boolean|undefined)>>} array The array that will be altered.
 * @param {number} x X coordinate.
 * @param {number} y Y coordinate.
 */ function $afd1450603f7bfcd$var$fillCircleArrayRowToMiddle(array, x, y) {
    var i;
    var radius = Math.floor(array.length / 2);
    if (x >= radius) for(i = radius; i < x; i++)array[i][y] = true;
    else if (x < radius) for(i = x + 1; i < radius; i++)array[i][y] = true;
}
function $afd1450603f7bfcd$export$90d5d4c95ce0eca8(radius) {
    if ($afd1450603f7bfcd$var$circleArrayCache[radius] !== undefined) return $afd1450603f7bfcd$var$circleArrayCache[radius];
    var arraySize = radius * 2 + 1;
    var arr = new Array(arraySize);
    for(var i = 0; i < arraySize; i++)arr[i] = new Array(arraySize);
    var x = radius;
    var y = 0;
    var error = 0;
    while(x >= y){
        $afd1450603f7bfcd$var$fillCircleArrayRowToMiddle(arr, radius + x, radius + y);
        $afd1450603f7bfcd$var$fillCircleArrayRowToMiddle(arr, radius + y, radius + x);
        $afd1450603f7bfcd$var$fillCircleArrayRowToMiddle(arr, radius - y, radius + x);
        $afd1450603f7bfcd$var$fillCircleArrayRowToMiddle(arr, radius - x, radius + y);
        $afd1450603f7bfcd$var$fillCircleArrayRowToMiddle(arr, radius - x, radius - y);
        $afd1450603f7bfcd$var$fillCircleArrayRowToMiddle(arr, radius - y, radius - x);
        $afd1450603f7bfcd$var$fillCircleArrayRowToMiddle(arr, radius + y, radius - x);
        $afd1450603f7bfcd$var$fillCircleArrayRowToMiddle(arr, radius + x, radius - y);
        y++;
        error += 1 + 2 * y;
        if (2 * (error - x) + 1 > 0) {
            x -= 1;
            error += 1 - 2 * x;
        }
    }
    $afd1450603f7bfcd$var$circleArrayCache[radius] = arr;
    return arr;
}
function $afd1450603f7bfcd$export$eae108acc6fdddb6(declutterReplays, context, rotation, snapToPixel) {
    var zs = Object.keys(declutterReplays).map(Number).sort((0, $830d23b8323fc080$export$4e734a3b32fb971b));
    var skippedFeatureUids = {};
    for(var z = 0, zz = zs.length; z < zz; ++z){
        var replayData = declutterReplays[zs[z].toString()];
        for(var i = 0, ii = replayData.length; i < ii;){
            var replay = replayData[i++];
            var transform = replayData[i++];
            replay.replay(context, transform, rotation, skippedFeatureUids, snapToPixel);
        }
    }
}
var $afd1450603f7bfcd$export$2e2bcd8739ae039 = $afd1450603f7bfcd$var$CanvasReplayGroup;



/**
 * @module ol/renderer/vector
 */ 



/**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ var $d9e0efcd90e741b9$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/GeometryType.js").default,
 *                function(import("../render/ReplayGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object)>}
 */ var $d9e0efcd90e741b9$var$GEOMETRY_RENDERERS = {
    "Point": $d9e0efcd90e741b9$var$renderPointGeometry,
    "LineString": $d9e0efcd90e741b9$var$renderLineStringGeometry,
    "Polygon": $d9e0efcd90e741b9$var$renderPolygonGeometry,
    "MultiPoint": $d9e0efcd90e741b9$var$renderMultiPointGeometry,
    "MultiLineString": $d9e0efcd90e741b9$var$renderMultiLineStringGeometry,
    "MultiPolygon": $d9e0efcd90e741b9$var$renderMultiPolygonGeometry,
    "GeometryCollection": $d9e0efcd90e741b9$var$renderGeometryCollectionGeometry,
    "Circle": $d9e0efcd90e741b9$var$renderCircleGeometry
};
function $d9e0efcd90e741b9$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $34772e91e89a736f$export$5e82334337e0f204)(feature1), 10) - parseInt((0, $34772e91e89a736f$export$5e82334337e0f204)(feature2), 10);
}
function $d9e0efcd90e741b9$export$75084a70d324c1e6(resolution, pixelRatio) {
    var tolerance = $d9e0efcd90e741b9$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $d9e0efcd90e741b9$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $d9e0efcd90e741b9$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 */ function $d9e0efcd90e741b9$var$renderCircleGeometry(replayGroup, geometry, style, feature) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        var circleReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).CIRCLE);
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle) {
        var textReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(false));
        textReplay.drawText(geometry, feature);
    }
}
function $d9e0efcd90e741b9$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, thisArg) {
    var loading = false;
    var imageStyle = style.getImage();
    if (imageStyle) {
        var imageState = imageStyle.getImageState();
        if (imageState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED || imageState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR) imageStyle.unlistenImageChange(listener, thisArg);
        else {
            if (imageState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE) imageStyle.load();
            imageState = imageStyle.getImageState();
            imageStyle.listenImageChange(listener, thisArg);
            loading = true;
        }
    }
    $d9e0efcd90e741b9$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance);
    return loading;
}
/**
 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 */ function $d9e0efcd90e741b9$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance) {
    var geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    var simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
    var renderer = style.getRenderer();
    if (renderer) $d9e0efcd90e741b9$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature);
    else {
        var geometryRenderer = $d9e0efcd90e741b9$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature);
    }
}
/**
 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 */ function $d9e0efcd90e741b9$var$renderGeometry(replayGroup, geometry, style, feature) {
    if (geometry.getType() == (0, $8826602b1d512d67$export$2e2bcd8739ae039).GEOMETRY_COLLECTION) {
        var geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(var i = 0, ii = geometries.length; i < ii; ++i)$d9e0efcd90e741b9$var$renderGeometry(replayGroup, geometries[i], style, feature);
        return;
    }
    var replay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).DEFAULT);
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer());
}
/**
 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 */ function $d9e0efcd90e741b9$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature) {
    var geometries = geometry.getGeometriesArray();
    var i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        var geometryRenderer = $d9e0efcd90e741b9$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature);
    }
}
/**
 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 */ function $d9e0efcd90e741b9$var$renderLineStringGeometry(replayGroup, geometry, style, feature) {
    var strokeStyle = style.getStroke();
    if (strokeStyle) {
        var lineStringReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).LINE_STRING);
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle) {
        var textReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(false));
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 */ function $d9e0efcd90e741b9$var$renderMultiLineStringGeometry(replayGroup, geometry, style, feature) {
    var strokeStyle = style.getStroke();
    if (strokeStyle) {
        var lineStringReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).LINE_STRING);
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle) {
        var textReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(false));
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 */ function $d9e0efcd90e741b9$var$renderMultiPolygonGeometry(replayGroup, geometry, style, feature) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        var polygonReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).POLYGON);
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle) {
        var textReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(false));
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 */ function $d9e0efcd90e741b9$var$renderPointGeometry(replayGroup, geometry, style, feature) {
    var imageStyle = style.getImage();
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED) return;
        var imageReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).IMAGE);
        imageReplay.setImageStyle(imageStyle, replayGroup.addDeclutter(false));
        imageReplay.drawPoint(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle) {
        var textReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(!!imageStyle));
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 */ function $d9e0efcd90e741b9$var$renderMultiPointGeometry(replayGroup, geometry, style, feature) {
    var imageStyle = style.getImage();
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED) return;
        var imageReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).IMAGE);
        imageReplay.setImageStyle(imageStyle, replayGroup.addDeclutter(false));
        imageReplay.drawMultiPoint(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle) {
        var textReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(!!imageStyle));
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 */ function $d9e0efcd90e741b9$var$renderPolygonGeometry(replayGroup, geometry, style, feature) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        var polygonReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).POLYGON);
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle) {
        var textReplay = replayGroup.getReplay(style.getZIndex(), (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(false));
        textReplay.drawText(geometry, feature);
    }
}


/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ var $b6f9cff97736b00f$var$CanvasVectorLayerRenderer = /*@__PURE__*/ function(CanvasLayerRenderer) {
    function CanvasVectorLayerRenderer(vectorLayer) {
        CanvasLayerRenderer.call(this, vectorLayer);
        /**
     * Declutter tree.
     * @private
     */ this.declutterTree_ = vectorLayer.getDeclutter() ? (0, (/*@__PURE__*/$parcel$interopDefault($2714652880d6ac2a$exports)))(9, undefined) : null;
        /**
     * @private
     * @type {boolean}
     */ this.dirty_ = false;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.renderedResolution_ = NaN;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.renderedExtent_ = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {function(import("../../Feature.js").default, import("../../Feature.js").default): number|null}
     */ this.renderedRenderOrder_ = null;
        /**
     * @private
     * @type {import("../../render/canvas/ReplayGroup.js").default}
     */ this.replayGroup_ = null;
        /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */ this.replayGroupChanged = true;
        /**
     * @type {CanvasRenderingContext2D}
     */ this.context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)();
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)((0, $c8f894129d9fa0b9$export$18212182f4e22723), (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLEAR, this.handleFontsChanged_, this);
    }
    if (CanvasLayerRenderer) CanvasVectorLayerRenderer.__proto__ = CanvasLayerRenderer;
    CanvasVectorLayerRenderer.prototype = Object.create(CanvasLayerRenderer && CanvasLayerRenderer.prototype);
    CanvasVectorLayerRenderer.prototype.constructor = CanvasVectorLayerRenderer;
    /**
   * @inheritDoc
   */ CanvasVectorLayerRenderer.prototype.disposeInternal = function disposeInternal() {
        (0, $37a5c0af9052e360$export$35276765542cd163)((0, $c8f894129d9fa0b9$export$18212182f4e22723), (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLEAR, this.handleFontsChanged_, this);
        CanvasLayerRenderer.prototype.disposeInternal.call(this);
    };
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("../../layer/Layer.js").State} layerState Layer state.
   */ CanvasVectorLayerRenderer.prototype.compose = function compose(context, frameState, layerState) {
        var extent = frameState.extent;
        var pixelRatio = frameState.pixelRatio;
        var skippedFeatureUids = layerState.managed ? frameState.skippedFeatureUids : {};
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        var rotation = viewState.rotation;
        var projectionExtent = projection.getExtent();
        var vectorSource = /** @type {import("../../source/Vector.js").default} */ this.getLayer().getSource();
        var transform = this.getTransform(frameState, 0);
        // clipped rendering if layer extent is set
        var clipExtent = layerState.extent;
        var clipped = clipExtent !== undefined;
        if (clipped) this.clip(context, frameState, /** @type {import("../../extent.js").Extent} */ clipExtent);
        var replayGroup = this.replayGroup_;
        if (replayGroup && !replayGroup.isEmpty()) {
            if (this.declutterTree_) this.declutterTree_.clear();
            var layer = /** @type {import("../../layer/Vector.js").default} */ this.getLayer();
            var drawOffsetX = 0;
            var drawOffsetY = 0;
            var replayContext;
            var transparentLayer = layerState.opacity !== 1;
            var hasRenderListeners = layer.hasListener((0, $847c6e8c21904781$export$2e2bcd8739ae039).RENDER);
            if (transparentLayer || hasRenderListeners) {
                var drawWidth = context.canvas.width;
                var drawHeight = context.canvas.height;
                if (rotation) {
                    var drawSize = Math.round(Math.sqrt(drawWidth * drawWidth + drawHeight * drawHeight));
                    drawOffsetX = (drawSize - drawWidth) / 2;
                    drawOffsetY = (drawSize - drawHeight) / 2;
                    drawWidth = drawHeight = drawSize;
                }
                // resize and clear
                this.context.canvas.width = drawWidth;
                this.context.canvas.height = drawHeight;
                replayContext = this.context;
            } else replayContext = context;
            var alpha = replayContext.globalAlpha;
            if (!transparentLayer) // for performance reasons, context.save / context.restore is not used
            // to save and restore the transformation matrix and the opacity.
            // see http://jsperf.com/context-save-restore-versus-variable
            replayContext.globalAlpha = layerState.opacity;
            if (replayContext != context) replayContext.translate(drawOffsetX, drawOffsetY);
            var viewHints = frameState.viewHints;
            var snapToPixel = !(viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING]);
            var width = frameState.size[0] * pixelRatio;
            var height = frameState.size[1] * pixelRatio;
            (0, $c8f894129d9fa0b9$export$8ac4d72be78047e6)(replayContext, -rotation, width / 2, height / 2);
            replayGroup.replay(replayContext, transform, rotation, skippedFeatureUids, snapToPixel);
            if (vectorSource.getWrapX() && projection.canWrapX() && !(0, $7e819822b33b3d32$export$be866b1e0809b17e)(projectionExtent, extent)) {
                var startX = extent[0];
                var worldWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(projectionExtent);
                var world = 0;
                var offsetX;
                while(startX < projectionExtent[0]){
                    --world;
                    offsetX = worldWidth * world;
                    transform = this.getTransform(frameState, offsetX);
                    replayGroup.replay(replayContext, transform, rotation, skippedFeatureUids, snapToPixel);
                    startX += worldWidth;
                }
                world = 0;
                startX = extent[2];
                while(startX > projectionExtent[2]){
                    ++world;
                    offsetX = worldWidth * world;
                    transform = this.getTransform(frameState, offsetX);
                    replayGroup.replay(replayContext, transform, rotation, skippedFeatureUids, snapToPixel);
                    startX -= worldWidth;
                }
            }
            (0, $c8f894129d9fa0b9$export$8ac4d72be78047e6)(replayContext, rotation, width / 2, height / 2);
            if (hasRenderListeners) this.dispatchRenderEvent(replayContext, frameState, transform);
            if (replayContext != context) {
                if (transparentLayer) {
                    var mainContextAlpha = context.globalAlpha;
                    context.globalAlpha = layerState.opacity;
                    context.drawImage(replayContext.canvas, -drawOffsetX, -drawOffsetY);
                    context.globalAlpha = mainContextAlpha;
                } else context.drawImage(replayContext.canvas, -drawOffsetX, -drawOffsetY);
                replayContext.translate(-drawOffsetX, -drawOffsetY);
            }
            if (!transparentLayer) replayContext.globalAlpha = alpha;
        }
        if (clipped) context.restore();
    };
    /**
   * @inheritDoc
   */ CanvasVectorLayerRenderer.prototype.composeFrame = function composeFrame(frameState, layerState, context) {
        var transform = this.getTransform(frameState, 0);
        this.preCompose(context, frameState, transform);
        this.compose(context, frameState, layerState);
        this.postCompose(context, frameState, layerState, transform);
    };
    /**
   * @inheritDoc
   */ CanvasVectorLayerRenderer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, thisArg) {
        if (!this.replayGroup_) return undefined;
        else {
            var resolution = frameState.viewState.resolution;
            var rotation = frameState.viewState.rotation;
            var layer = /** @type {import("../../layer/Vector.js").default} */ this.getLayer();
            /** @type {!Object<string, boolean>} */ var features = {};
            var result = this.replayGroup_.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, {}, /**
         * @param {import("../../Feature.js").FeatureLike} feature Feature.
         * @return {?} Callback result.
         */ function(feature) {
                var key = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
                if (!(key in features)) {
                    features[key] = true;
                    return callback.call(thisArg, feature, layer);
                }
            }, null);
            return result;
        }
    };
    /**
   * @param {import("../../events/Event.js").default} event Event.
   */ CanvasVectorLayerRenderer.prototype.handleFontsChanged_ = function handleFontsChanged_(event) {
        var layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    };
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ CanvasVectorLayerRenderer.prototype.handleStyleImageChange_ = function handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    };
    /**
   * @inheritDoc
   */ CanvasVectorLayerRenderer.prototype.prepareFrame = function prepareFrame(frameState, layerState) {
        var vectorLayer = /** @type {import("../../layer/Vector.js").default} */ this.getLayer();
        var vectorSource = /** @type {import("../../source/Vector.js").default} */ vectorLayer.getSource();
        var animating = frameState.viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING];
        var interacting = frameState.viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING];
        var updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        var updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (!this.dirty_ && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) return true;
        var frameStateExtent = frameState.extent;
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        var resolution = viewState.resolution;
        var pixelRatio = frameState.pixelRatio;
        var vectorLayerRevision = vectorLayer.getRevision();
        var vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        var vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $d9e0efcd90e741b9$export$531ddd8416d52dfc);
        var extent = (0, $7e819822b33b3d32$export$ab1029bcae9ddb4a)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        var projectionExtent = viewState.projection.getExtent();
        if (vectorSource.getWrapX() && viewState.projection.canWrapX() && !(0, $7e819822b33b3d32$export$be866b1e0809b17e)(projectionExtent, frameState.extent)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            var worldWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(projectionExtent);
            var gutter = Math.max((0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(extent) / 2, worldWidth);
            extent[0] = projectionExtent[0] - gutter;
            extent[2] = projectionExtent[2] + gutter;
        }
        if (!this.dirty_ && this.renderedResolution_ == resolution && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && (0, $7e819822b33b3d32$export$be866b1e0809b17e)(this.renderedExtent_, extent)) {
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        this.dirty_ = false;
        var replayGroup = new (0, $afd1450603f7bfcd$export$2e2bcd8739ae039)((0, $d9e0efcd90e741b9$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio, vectorSource.getOverlaps(), this.declutterTree_, vectorLayer.getRenderBuffer());
        vectorSource.loadFeatures(extent, resolution, projection);
        /**
     * @param {import("../../Feature.js").default} feature Feature.
     * @this {CanvasVectorLayerRenderer}
     */ var render = (function(feature) {
            var styles;
            var styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                var dirty = this.renderFeature(feature, resolution, pixelRatio, styles, replayGroup);
                this.dirty_ = this.dirty_ || dirty;
            }
        }).bind(this);
        if (vectorLayerRenderOrder) {
            /** @type {Array<import("../../Feature.js").default>} */ var features = [];
            vectorSource.forEachFeatureInExtent(extent, /**
         * @param {import("../../Feature.js").default} feature Feature.
         */ function(feature) {
                features.push(feature);
            });
            features.sort(vectorLayerRenderOrder);
            for(var i = 0, ii = features.length; i < ii; ++i)render(features[i]);
        } else vectorSource.forEachFeatureInExtent(extent, render);
        replayGroup.finish();
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedExtent_ = extent;
        this.replayGroup_ = replayGroup;
        this.replayGroupChanged = true;
        return true;
    };
    /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/ReplayGroup.js").default} replayGroup Replay group.
   * @return {boolean} `true` if an image is loading.
   */ CanvasVectorLayerRenderer.prototype.renderFeature = function renderFeature$1(feature, resolution, pixelRatio, styles, replayGroup) {
        if (!styles) return false;
        var loading = false;
        if (Array.isArray(styles)) for(var i = 0, ii = styles.length; i < ii; ++i)loading = (0, $d9e0efcd90e741b9$export$36f470a33a42f413)(replayGroup, feature, styles[i], (0, $d9e0efcd90e741b9$export$75084a70d324c1e6)(resolution, pixelRatio), this.handleStyleImageChange_, this) || loading;
        else loading = (0, $d9e0efcd90e741b9$export$36f470a33a42f413)(replayGroup, feature, styles, (0, $d9e0efcd90e741b9$export$75084a70d324c1e6)(resolution, pixelRatio), this.handleStyleImageChange_, this);
        return loading;
    };
    return CanvasVectorLayerRenderer;
}((0, $22aba15f167ce2ee$export$2e2bcd8739ae039));
/**
 * Determine if this renderer handles the provided layer.
 * @param {import("../../layer/Layer.js").default} layer The candidate layer.
 * @return {boolean} The renderer can render the layer.
 */ $b6f9cff97736b00f$var$CanvasVectorLayerRenderer["handles"] = function(layer) {
    return layer.getType() === (0, $e2d469ffcbcaca70$export$2e2bcd8739ae039).VECTOR;
};
/**
 * Create a layer renderer.
 * @param {import("../Map.js").default} mapRenderer The map renderer.
 * @param {import("../../layer/Layer.js").default} layer The layer to be rendererd.
 * @return {CanvasVectorLayerRenderer} The layer renderer.
 */ $b6f9cff97736b00f$var$CanvasVectorLayerRenderer["create"] = function(mapRenderer, layer) {
    return new $b6f9cff97736b00f$var$CanvasVectorLayerRenderer(/** @type {import("../../layer/Vector.js").default} */ layer);
};
var $b6f9cff97736b00f$export$2e2bcd8739ae039 = $b6f9cff97736b00f$var$CanvasVectorLayerRenderer;


/**
 * @module ol/renderer/canvas/VectorTileLayer
 */ 








/**
 * @module ol/layer/VectorTileRenderType
 */ /**
 * @enum {string}
 * Render mode for vector tiles:
 *  * `'image'`: Vector tiles are rendered as images. Great performance, but
 *    point symbols and texts are always rotated with the view and pixels are
 *    scaled during zoom animations.
 *  * `'hybrid'`: Polygon and line elements are rendered as images, so pixels
 *    are scaled during zoom animations. Point symbols and texts are accurately
 *    rendered as vectors and can stay upright on rotated views.
 *  * `'vector'`: Vector tiles are rendered as vectors. Most accurate rendering
 *    even during animations, but slower performance than the other options.
 * @api
 */ var $04f2ba33f80c7249$export$2e2bcd8739ae039 = {
    IMAGE: "image",
    HYBRID: "hybrid",
    VECTOR: "vector"
};











/**
 * @type {!Object<string, Array<import("../../render/ReplayType.js").default>>}
 */ var $da514137bfbfc687$var$IMAGE_REPLAYS = {
    "image": [
        (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).POLYGON,
        (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).CIRCLE,
        (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).LINE_STRING,
        (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).IMAGE,
        (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT
    ],
    "hybrid": [
        (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).POLYGON,
        (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).LINE_STRING
    ]
};
/**
 * @type {!Object<string, Array<import("../../render/ReplayType.js").default>>}
 */ var $da514137bfbfc687$var$VECTOR_REPLAYS = {
    "image": [
        (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).DEFAULT
    ],
    "hybrid": [
        (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).IMAGE,
        (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).TEXT,
        (0, $c7d61e203c9209b0$export$2e2bcd8739ae039).DEFAULT
    ],
    "vector": (0, $9cc56c68d2780fd0$export$11e75bce9f7ea886)
};
/**
 * @classdesc
 * Canvas renderer for vector tile layers.
 * @api
 */ var $da514137bfbfc687$var$CanvasVectorTileLayerRenderer = /*@__PURE__*/ function(CanvasTileLayerRenderer) {
    function CanvasVectorTileLayerRenderer(layer) {
        CanvasTileLayerRenderer.call(this, layer, true);
        /**
     * Declutter tree.
     * @private
     */ this.declutterTree_ = layer.getDeclutter() ? (0, (/*@__PURE__*/$parcel$interopDefault($2714652880d6ac2a$exports)))(9, undefined) : null;
        /**
     * @private
     * @type {boolean}
     */ this.dirty_ = false;
        /**
     * @private
     * @type {number}
     */ this.renderedLayerRevision_;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        var renderMode = layer.getRenderMode();
        // Use lower resolution for pure vector rendering. Closest resolution otherwise.
        this.zDirection = renderMode === (0, $04f2ba33f80c7249$export$2e2bcd8739ae039).VECTOR ? 1 : 0;
        if (renderMode !== (0, $04f2ba33f80c7249$export$2e2bcd8739ae039).VECTOR) this.context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)();
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)((0, $c8f894129d9fa0b9$export$18212182f4e22723), (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLEAR, this.handleFontsChanged_, this);
    }
    if (CanvasTileLayerRenderer) CanvasVectorTileLayerRenderer.__proto__ = CanvasTileLayerRenderer;
    CanvasVectorTileLayerRenderer.prototype = Object.create(CanvasTileLayerRenderer && CanvasTileLayerRenderer.prototype);
    CanvasVectorTileLayerRenderer.prototype.constructor = CanvasVectorTileLayerRenderer;
    /**
   * @inheritDoc
   */ CanvasVectorTileLayerRenderer.prototype.disposeInternal = function disposeInternal() {
        (0, $37a5c0af9052e360$export$35276765542cd163)((0, $c8f894129d9fa0b9$export$18212182f4e22723), (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLEAR, this.handleFontsChanged_, this);
        CanvasTileLayerRenderer.prototype.disposeInternal.call(this);
    };
    /**
   * @inheritDoc
   */ CanvasVectorTileLayerRenderer.prototype.getTile = function getTile(z, x, y, pixelRatio, projection) {
        var tile = CanvasTileLayerRenderer.prototype.getTile.call(this, z, x, y, pixelRatio, projection);
        if (tile.getState() === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) {
            this.createReplayGroup_(/** @type {import("../../VectorImageTile.js").default} */ tile, pixelRatio, projection);
            if (this.context) this.renderTileImage_(/** @type {import("../../VectorImageTile.js").default} */ tile, pixelRatio, projection);
        }
        return tile;
    };
    /**
   * @inheritDoc
   */ CanvasVectorTileLayerRenderer.prototype.getTileImage = function getTileImage(tile) {
        var tileLayer = /** @type {import("../../layer/Tile.js").default} */ this.getLayer();
        return /** @type {import("../../VectorImageTile.js").default} */ tile.getImage(tileLayer);
    };
    /**
   * @inheritDoc
   */ CanvasVectorTileLayerRenderer.prototype.prepareFrame = function prepareFrame(frameState, layerState) {
        var layer = /** @type {import("../../layer/Vector.js").default} */ this.getLayer();
        var layerRevision = layer.getRevision();
        if (this.renderedLayerRevision_ != layerRevision) this.renderedTiles.length = 0;
        this.renderedLayerRevision_ = layerRevision;
        return CanvasTileLayerRenderer.prototype.prepareFrame.call(this, frameState, layerState);
    };
    /**
   * @param {import("../../VectorImageTile.js").default} tile Tile.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../proj/Projection.js").default} projection Projection.
   * @private
   */ CanvasVectorTileLayerRenderer.prototype.createReplayGroup_ = function createReplayGroup_(tile, pixelRatio, projection) {
        var this$1 = this;
        var layer = /** @type {import("../../layer/Vector.js").default} */ this.getLayer();
        var revision = layer.getRevision();
        var renderOrder = /** @type {import("../../render.js").OrderFunction} */ layer.getRenderOrder() || null;
        var replayState = tile.getReplayState(layer);
        if (!replayState.dirty && replayState.renderedRevision == revision && replayState.renderedRenderOrder == renderOrder) return;
        var source = /** @type {import("../../source/VectorTile.js").default} */ layer.getSource();
        var sourceTileGrid = source.getTileGrid();
        var tileGrid = source.getTileGridForProjection(projection);
        var resolution = tileGrid.getResolution(tile.tileCoord[0]);
        var tileExtent = tile.extent;
        var loop = function(t, tt) {
            var sourceTile = tile.getTile(tile.tileKeys[t]);
            if (sourceTile.getState() != (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) return;
            var sourceTileCoord = sourceTile.tileCoord;
            var sourceTileExtent = sourceTileGrid.getTileCoordExtent(sourceTileCoord);
            var sharedExtent = (0, $7e819822b33b3d32$export$72209efa88586d42)(tileExtent, sourceTileExtent);
            var bufferedExtent = (0, $7e819822b33b3d32$export$e9bab7fafb253603)(sourceTileExtent, sharedExtent) ? null : (0, $7e819822b33b3d32$export$ab1029bcae9ddb4a)(sharedExtent, layer.getRenderBuffer() * resolution, this$1.tmpExtent);
            var tileProjection = sourceTile.getProjection();
            var reproject = false;
            if (!(0, $92f1443438429e81$export$fe091d73a555748b)(projection, tileProjection)) {
                reproject = true;
                sourceTile.setProjection(projection);
            }
            replayState.dirty = false;
            var replayGroup = new (0, $afd1450603f7bfcd$export$2e2bcd8739ae039)(0, sharedExtent, resolution, pixelRatio, source.getOverlaps(), this$1.declutterTree_, layer.getRenderBuffer());
            var squaredTolerance = (0, $d9e0efcd90e741b9$export$75084a70d324c1e6)(resolution, pixelRatio);
            /**
       * @param {import("../../Feature.js").FeatureLike} feature Feature.
       * @this {CanvasVectorTileLayerRenderer}
       */ var render = function(feature) {
                var styles;
                var styleFunction = feature.getStyleFunction() || layer.getStyleFunction();
                if (styleFunction) styles = styleFunction(feature, resolution);
                if (styles) {
                    var dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup);
                    this.dirty_ = this.dirty_ || dirty;
                    replayState.dirty = replayState.dirty || dirty;
                }
            };
            var features = sourceTile.getFeatures();
            if (renderOrder && renderOrder !== replayState.renderedRenderOrder) features.sort(renderOrder);
            for(var i = 0, ii = features.length; i < ii; ++i){
                var feature = features[i];
                if (reproject) {
                    if (tileProjection.getUnits() == (0, $fb72d58bc9104528$export$2e2bcd8739ae039).TILE_PIXELS) {
                        // projected tile extent
                        tileProjection.setWorldExtent(sourceTileExtent);
                        // tile extent in tile pixel space
                        tileProjection.setExtent(sourceTile.getExtent());
                    }
                    feature.getGeometry().transform(tileProjection, projection);
                }
                if (!bufferedExtent || (0, $7e819822b33b3d32$export$7b0a31e10bbff018)(bufferedExtent, feature.getGeometry().getExtent())) render.call(this$1, feature);
            }
            replayGroup.finish();
            sourceTile.setReplayGroup(layer, tile.tileCoord.toString(), replayGroup);
        };
        for(var t = 0, tt = tile.tileKeys.length; t < tt; ++t)loop(t, tt);
        replayState.renderedRevision = revision;
        replayState.renderedRenderOrder = renderOrder;
    };
    /**
   * @inheritDoc
   */ CanvasVectorTileLayerRenderer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, thisArg) {
        var resolution = frameState.viewState.resolution;
        var rotation = frameState.viewState.rotation;
        hitTolerance = hitTolerance == undefined ? 0 : hitTolerance;
        var layer = this.getLayer();
        /** @type {!Object<string, boolean>} */ var features = {};
        var renderedTiles = /** @type {Array<import("../../VectorImageTile.js").default>} */ this.renderedTiles;
        var bufferedExtent, found;
        var i, ii;
        for(i = 0, ii = renderedTiles.length; i < ii; ++i){
            var tile = renderedTiles[i];
            bufferedExtent = (0, $7e819822b33b3d32$export$ab1029bcae9ddb4a)(tile.extent, hitTolerance * resolution, bufferedExtent);
            if (!(0, $7e819822b33b3d32$export$ac68c24d37ca240f)(bufferedExtent, coordinate)) continue;
            for(var t = 0, tt = tile.tileKeys.length; t < tt; ++t){
                var sourceTile = tile.getTile(tile.tileKeys[t]);
                if (sourceTile.getState() != (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) continue;
                var replayGroup = /** @type {CanvasReplayGroup} */ sourceTile.getReplayGroup(layer, tile.tileCoord.toString());
                found = found || replayGroup.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, {}, /**
           * @param {import("../../Feature.js").FeatureLike} feature Feature.
           * @return {?} Callback result.
           */ function(feature) {
                    var key = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
                    if (!(key in features)) {
                        features[key] = true;
                        return callback.call(thisArg, feature, layer);
                    }
                }, null);
            }
        }
        return found;
    };
    /**
   * @param {import("../../VectorTile.js").default} tile Tile.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @return {import("../../transform.js").Transform} transform Transform.
   * @private
   */ CanvasVectorTileLayerRenderer.prototype.getReplayTransform_ = function getReplayTransform_(tile, frameState) {
        var layer = this.getLayer();
        var source = /** @type {import("../../source/VectorTile.js").default} */ layer.getSource();
        var tileGrid = source.getTileGrid();
        var tileCoord = tile.tileCoord;
        var tileResolution = tileGrid.getResolution(tileCoord[0]);
        var viewState = frameState.viewState;
        var pixelRatio = frameState.pixelRatio;
        var renderResolution = viewState.resolution / pixelRatio;
        var tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent);
        var center = viewState.center;
        var origin = (0, $7e819822b33b3d32$export$cb1538b07e6964ff)(tileExtent);
        var size = frameState.size;
        var offsetX = Math.round(pixelRatio * size[0] / 2);
        var offsetY = Math.round(pixelRatio * size[1] / 2);
        return (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.tmpTransform_, offsetX, offsetY, tileResolution / renderResolution, tileResolution / renderResolution, viewState.rotation, (origin[0] - center[0]) / tileResolution, (center[1] - origin[1]) / tileResolution);
    };
    /**
   * @param {import("../../events/Event.js").default} event Event.
   */ CanvasVectorTileLayerRenderer.prototype.handleFontsChanged_ = function handleFontsChanged_(event) {
        var layer = this.getLayer();
        if (layer.getVisible() && this.renderedLayerRevision_ !== undefined) layer.changed();
    };
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ CanvasVectorTileLayerRenderer.prototype.handleStyleImageChange_ = function handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    };
    /**
   * @inheritDoc
   */ CanvasVectorTileLayerRenderer.prototype.postCompose = function postCompose(context, frameState, layerState) {
        var layer = /** @type {import("../../layer/Vector.js").default} */ this.getLayer();
        var renderMode = layer.getRenderMode();
        if (renderMode != (0, $04f2ba33f80c7249$export$2e2bcd8739ae039).IMAGE) {
            var declutterReplays = layer.getDeclutter() ? {} : null;
            var source = /** @type {import("../../source/VectorTile.js").default} */ layer.getSource();
            var replayTypes = $da514137bfbfc687$var$VECTOR_REPLAYS[renderMode];
            var pixelRatio = frameState.pixelRatio;
            var rotation = frameState.viewState.rotation;
            var size = frameState.size;
            var offsetX, offsetY;
            if (rotation) {
                offsetX = Math.round(pixelRatio * size[0] / 2);
                offsetY = Math.round(pixelRatio * size[1] / 2);
                (0, $c8f894129d9fa0b9$export$8ac4d72be78047e6)(context, -rotation, offsetX, offsetY);
            }
            if (declutterReplays) this.declutterTree_.clear();
            var viewHints = frameState.viewHints;
            var snapToPixel = !(viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING]);
            var tiles = this.renderedTiles;
            var tileGrid = source.getTileGridForProjection(frameState.viewState.projection);
            var clips = [];
            var zs = [];
            for(var i = tiles.length - 1; i >= 0; --i){
                var tile = /** @type {import("../../VectorImageTile.js").default} */ tiles[i];
                if (tile.getState() == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ABORT) continue;
                var tileCoord = tile.tileCoord;
                var worldOffset = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent)[0] - tile.extent[0];
                var transform = undefined;
                for(var t = 0, tt = tile.tileKeys.length; t < tt; ++t){
                    var sourceTile = tile.getTile(tile.tileKeys[t]);
                    if (sourceTile.getState() != (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) continue;
                    var replayGroup = /** @type {CanvasReplayGroup} */ sourceTile.getReplayGroup(layer, tileCoord.toString());
                    if (!replayGroup || !replayGroup.hasReplays(replayTypes)) continue;
                    if (!transform) transform = this.getTransform(frameState, worldOffset);
                    var currentZ = sourceTile.tileCoord[0];
                    var currentClip = replayGroup.getClipCoords(transform);
                    context.save();
                    context.globalAlpha = layerState.opacity;
                    // Create a clip mask for regions in this low resolution tile that are
                    // already filled by a higher resolution tile
                    for(var j = 0, jj = clips.length; j < jj; ++j){
                        var clip = clips[j];
                        if (currentZ < zs[j]) {
                            context.beginPath();
                            // counter-clockwise (outer ring) for current tile
                            context.moveTo(currentClip[0], currentClip[1]);
                            context.lineTo(currentClip[2], currentClip[3]);
                            context.lineTo(currentClip[4], currentClip[5]);
                            context.lineTo(currentClip[6], currentClip[7]);
                            // clockwise (inner ring) for higher resolution tile
                            context.moveTo(clip[6], clip[7]);
                            context.lineTo(clip[4], clip[5]);
                            context.lineTo(clip[2], clip[3]);
                            context.lineTo(clip[0], clip[1]);
                            context.clip();
                        }
                    }
                    replayGroup.replay(context, transform, rotation, {}, snapToPixel, replayTypes, declutterReplays);
                    context.restore();
                    clips.push(currentClip);
                    zs.push(currentZ);
                }
            }
            if (declutterReplays) (0, $afd1450603f7bfcd$export$eae108acc6fdddb6)(declutterReplays, context, rotation, snapToPixel);
            if (rotation) (0, $c8f894129d9fa0b9$export$8ac4d72be78047e6)(context, rotation, /** @type {number} */ offsetX, /** @type {number} */ offsetY);
        }
        CanvasTileLayerRenderer.prototype.postCompose.call(this, context, frameState, layerState);
    };
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/ReplayGroup.js").default} replayGroup Replay group.
   * @return {boolean} `true` if an image is loading.
   */ CanvasVectorTileLayerRenderer.prototype.renderFeature = function renderFeature$1(feature, squaredTolerance, styles, replayGroup) {
        if (!styles) return false;
        var loading = false;
        if (Array.isArray(styles)) for(var i = 0, ii = styles.length; i < ii; ++i)loading = (0, $d9e0efcd90e741b9$export$36f470a33a42f413)(replayGroup, feature, styles[i], squaredTolerance, this.handleStyleImageChange_, this) || loading;
        else loading = (0, $d9e0efcd90e741b9$export$36f470a33a42f413)(replayGroup, feature, styles, squaredTolerance, this.handleStyleImageChange_, this);
        return loading;
    };
    /**
   * @param {import("../../VectorImageTile.js").default} tile Tile.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../proj/Projection.js").default} projection Projection.
   * @private
   */ CanvasVectorTileLayerRenderer.prototype.renderTileImage_ = function renderTileImage_(tile, pixelRatio, projection) {
        var layer = /** @type {import("../../layer/Vector.js").default} */ this.getLayer();
        var replayState = tile.getReplayState(layer);
        var revision = layer.getRevision();
        var replays = $da514137bfbfc687$var$IMAGE_REPLAYS[layer.getRenderMode()];
        if (replays && replayState.renderedTileRevision !== revision) {
            replayState.renderedTileRevision = revision;
            var tileCoord = tile.wrappedTileCoord;
            var z = tileCoord[0];
            var source = /** @type {import("../../source/VectorTile.js").default} */ layer.getSource();
            var tileGrid = source.getTileGridForProjection(projection);
            var resolution = tileGrid.getResolution(z);
            var context = tile.getContext(layer);
            var size = source.getTilePixelSize(z, pixelRatio, projection);
            context.canvas.width = size[0];
            context.canvas.height = size[1];
            var tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent);
            for(var i = 0, ii = tile.tileKeys.length; i < ii; ++i){
                var sourceTile = tile.getTile(tile.tileKeys[i]);
                if (sourceTile.getState() != (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) continue;
                var pixelScale = pixelRatio / resolution;
                var transform = (0, $2567d97ab31c5663$export$aad8462122ac592b)(this.tmpTransform_);
                (0, $2567d97ab31c5663$export$dcdf75081b88279d)(transform, pixelScale, -pixelScale);
                (0, $2567d97ab31c5663$export$d73ee8ef04f5226a)(transform, -tileExtent[0], -tileExtent[3]);
                var replayGroup = /** @type {CanvasReplayGroup} */ sourceTile.getReplayGroup(layer, tile.tileCoord.toString());
                replayGroup.replay(context, transform, 0, {}, true, replays);
            }
        }
    };
    return CanvasVectorTileLayerRenderer;
}((0, $317841df0443139a$export$2e2bcd8739ae039));
/**
 * Determine if this renderer handles the provided layer.
 * @param {import("../../layer/Layer.js").default} layer The candidate layer.
 * @return {boolean} The renderer can render the layer.
 */ $da514137bfbfc687$var$CanvasVectorTileLayerRenderer["handles"] = function(layer) {
    return layer.getType() === (0, $e2d469ffcbcaca70$export$2e2bcd8739ae039).VECTOR_TILE;
};
/**
 * Create a layer renderer.
 * @param {import("../Map.js").default} mapRenderer The map renderer.
 * @param {import("../../layer/Layer.js").default} layer The layer to be rendererd.
 * @return {CanvasVectorTileLayerRenderer} The layer renderer.
 */ $da514137bfbfc687$var$CanvasVectorTileLayerRenderer["create"] = function(mapRenderer, layer) {
    return new $da514137bfbfc687$var$CanvasVectorTileLayerRenderer(/** @type {import("../../layer/VectorTile.js").default} */ layer);
};
var $da514137bfbfc687$export$2e2bcd8739ae039 = $da514137bfbfc687$var$CanvasVectorTileLayerRenderer;


/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map';
 *     import View from 'ol/View';
 *     import TileLayer from 'ol/layer/Tile';
 *     import OSM from 'ol/source/OSM';
 *
 *     var map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM()
 *         })
 *       ],
 *       target: 'map'
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~Group}
 * is a subclass of {@link module:ol/layer/Base}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires module:ol/render/Event~RenderEvent#postcompose
 * @fires module:ol/render/Event~RenderEvent#precompose
 * @api
 */ var $88aa35e28fb911a2$var$Map = /*@__PURE__*/ function(PluggableMap) {
    function Map(options) {
        options = (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({}, options);
        if (!options.controls) options.controls = (0, $1c5b03a65fa2f53c$export$ebe90cb607ad99e)();
        if (!options.interactions) options.interactions = (0, $e30eb1cf0f64773b$export$ebe90cb607ad99e)();
        PluggableMap.call(this, options);
    }
    if (PluggableMap) Map.__proto__ = PluggableMap;
    Map.prototype = Object.create(PluggableMap && PluggableMap.prototype);
    Map.prototype.constructor = Map;
    Map.prototype.createRenderer = function createRenderer() {
        var renderer = new (0, $38a2f3b2ed67e329$export$2e2bcd8739ae039)(this);
        renderer.registerLayerRenderers([
            (0, $2a67941380f9882b$export$2e2bcd8739ae039),
            (0, $317841df0443139a$export$2e2bcd8739ae039),
            (0, $b6f9cff97736b00f$export$2e2bcd8739ae039),
            (0, $da514137bfbfc687$export$2e2bcd8739ae039)
        ]);
        return renderer;
    };
    return Map;
}((0, $2f0f58592e3964f7$export$2e2bcd8739ae039));
var $88aa35e28fb911a2$export$2e2bcd8739ae039 = $88aa35e28fb911a2$var$Map;


/**
 * @module ol/layer/Tile
 */ 

/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $620372cf01773fbe$export$2e2bcd8739ae039 = {
    PRELOAD: "preload",
    USE_INTERIM_TILES_ON_ERROR: "useInterimTilesOnError"
};



/**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {import("../source/Tile.js").default} [source] Source for this layer.
 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link module:ol/Map#addLayer}.
 * @property {boolean} [useInterimTilesOnError=true] Use interim tiles on error.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @api
 */ var $0e25041945985074$var$TileLayer = /*@__PURE__*/ function(Layer) {
    function TileLayer(opt_options) {
        var options = opt_options ? opt_options : {};
        var baseOptions = (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({}, options);
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        Layer.call(this, baseOptions);
        this.setPreload(options.preload !== undefined ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
        /**
    * The layer type.
    * @protected
    * @type {import("../LayerType.js").default}
    */ this.type = (0, $e2d469ffcbcaca70$export$2e2bcd8739ae039).TILE;
    }
    if (Layer) TileLayer.__proto__ = Layer;
    TileLayer.prototype = Object.create(Layer && Layer.prototype);
    TileLayer.prototype.constructor = TileLayer;
    /**
  * Return the level as number to which we will preload tiles up to.
  * @return {number} The level to preload tiles up to.
  * @observable
  * @api
  */ TileLayer.prototype.getPreload = function getPreload() {
        return /** @type {number} */ this.get((0, $620372cf01773fbe$export$2e2bcd8739ae039).PRELOAD);
    };
    /**
  * Set the level as number to which we will preload tiles up to.
  * @param {number} preload The level to preload tiles up to.
  * @observable
  * @api
  */ TileLayer.prototype.setPreload = function setPreload(preload) {
        this.set((0, $620372cf01773fbe$export$2e2bcd8739ae039).PRELOAD, preload);
    };
    /**
  * Whether we use interim tiles on error.
  * @return {boolean} Use interim tiles on error.
  * @observable
  * @api
  */ TileLayer.prototype.getUseInterimTilesOnError = function getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, $620372cf01773fbe$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
    };
    /**
  * Set whether we use interim tiles on error.
  * @param {boolean} useInterimTilesOnError Use interim tiles on error.
  * @observable
  * @api
  */ TileLayer.prototype.setUseInterimTilesOnError = function setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, $620372cf01773fbe$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    };
    return TileLayer;
}((0, $575253350abb8238$export$2e2bcd8739ae039));
/**
 * Return the associated {@link module:ol/source/Tile tilesource} of the layer.
 * @function
 * @return {import("../source/Tile.js").default} Source.
 * @api
 */ $0e25041945985074$var$TileLayer.prototype.getSource;
var $0e25041945985074$export$2e2bcd8739ae039 = $0e25041945985074$var$TileLayer;


/**
 * @module ol/source/OSM
 */ /**
 * @module ol/source/XYZ
 */ /**
 * @module ol/source/TileImage
 */ 

/**
 * @module ol/ImageTile
 */ /**
 * @module ol/Tile
 */ 



/**
 * A function that takes an {@link module:ol/Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   var xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     var data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string)} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~Tile} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes an {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ var $d91642aad273ae94$var$Tile = /*@__PURE__*/ function(EventTarget) {
    function Tile(tileCoord, state, opt_options) {
        EventTarget.call(this);
        var options = opt_options ? opt_options : {};
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.tileCoord = tileCoord;
        /**
     * @protected
     * @type {TileState}
     */ this.state = state;
        /**
     * An "interim" tile for this tile. The interim tile may be used while this
     * one is loading, for "smooth" transitions when changing params/dimensions
     * on the source.
     * @type {Tile}
     */ this.interimTile = null;
        /**
     * A key assigned to the tile. This is used by the tile source to determine
     * if this tile can effectively be used, or if a new tile should be created
     * and this one be used as an interim tile for this new tile.
     * @type {string}
     */ this.key = "";
        /**
     * The duration for the opacity transition.
     * @type {number}
     */ this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
     * Lookup of start times for rendering transitions.  If the start time is
     * equal to -1, the transition is complete.
     * @type {Object<string, number>}
     */ this.transitionStarts_ = {};
    }
    if (EventTarget) Tile.__proto__ = EventTarget;
    Tile.prototype = Object.create(EventTarget && EventTarget.prototype);
    Tile.prototype.constructor = Tile;
    /**
   * @protected
   */ Tile.prototype.changed = function changed() {
        this.dispatchEvent((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE);
    };
    /**
   * @return {string} Key.
   */ Tile.prototype.getKey = function getKey() {
        return this.key + "/" + this.tileCoord;
    };
    /**
   * Get the interim tile most suitable for rendering using the chain of interim
   * tiles. This corresponds to the  most recent tile that has been loaded, if no
   * such tile exists, the original tile is returned.
   * @return {!Tile} Best tile for rendering.
   */ Tile.prototype.getInterimTile = function getInterimTile() {
        if (!this.interimTile) //empty chain
        return this;
        var tile = this.interimTile;
        // find the first loaded tile and return it. Since the chain is sorted in
        // decreasing order of creation time, there is no need to search the remainder
        // of the list (all those tiles correspond to older requests and will be
        // cleaned up by refreshInterimChain)
        do {
            if (tile.getState() == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) return tile;
            tile = tile.interimTile;
        }while (tile);
        // we can not find a better tile
        return this;
    };
    /**
   * Goes through the chain of interim tiles and discards sections of the chain
   * that are no longer relevant.
   */ Tile.prototype.refreshInterimChain = function refreshInterimChain() {
        if (!this.interimTile) return;
        var tile = this.interimTile;
        var prev = /** @type {Tile} */ this;
        do {
            if (tile.getState() == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) {
                //we have a loaded tile, we can discard the rest of the list
                //we would could abort any LOADING tile request
                //older than this tile (i.e. any LOADING tile following this entry in the chain)
                tile.interimTile = null;
                break;
            } else if (tile.getState() == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADING) //keep this LOADING tile any loaded tiles later in the chain are
            //older than this tile, so we're still interested in the request
            prev = tile;
            else if (tile.getState() == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE) //the head of the list is the most current tile, we don't need
            //to start any other requests for this chain
            prev.interimTile = tile.interimTile;
            else prev = tile;
            tile = prev.interimTile;
        }while (tile);
    };
    /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */ Tile.prototype.getTileCoord = function getTileCoord() {
        return this.tileCoord;
    };
    /**
   * @return {TileState} State.
   */ Tile.prototype.getState = function getState() {
        return this.state;
    };
    /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {TileState} state State.
   * @api
   */ Tile.prototype.setState = function setState(state) {
        this.state = state;
        this.changed();
    };
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */ Tile.prototype.load = function load() {};
    /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */ Tile.prototype.getAlpha = function getAlpha(id, time) {
        if (!this.transition_) return 1;
        var start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        var delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, $0164a93fcf6e65ad$export$929e5a82286172a6)(delta / this.transition_);
    };
    /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */ Tile.prototype.inTransition = function inTransition(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    };
    /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */ Tile.prototype.endTransition = function endTransition(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    };
    return Tile;
}((0, $dd029d816e3b4259$export$2e2bcd8739ae039));
var $d91642aad273ae94$export$2e2bcd8739ae039 = $d91642aad273ae94$var$Tile;






var $50fe57b595b18ff9$var$ImageTile = /*@__PURE__*/ function(Tile) {
    function ImageTile(tileCoord, state, src, crossOrigin, tileLoadFunction, opt_options) {
        Tile.call(this, tileCoord, state, opt_options);
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * Image URI
     *
     * @private
     * @type {string}
     */ this.src_ = src;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */ this.image_ = new Image();
        if (crossOrigin !== null) this.image_.crossOrigin = crossOrigin;
        /**
     * @private
     * @type {Array<import("./events.js").EventsKey>}
     */ this.imageListenerKeys_ = null;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
    }
    if (Tile) ImageTile.__proto__ = Tile;
    ImageTile.prototype = Object.create(Tile && Tile.prototype);
    ImageTile.prototype.constructor = ImageTile;
    /**
   * @inheritDoc
   */ ImageTile.prototype.disposeInternal = function disposeInternal() {
        if (this.state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADING) {
            this.unlistenImage_();
            this.image_ = $50fe57b595b18ff9$var$getBlankImage();
        }
        if (this.interimTile) this.interimTile.dispose();
        this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ABORT;
        this.changed();
        Tile.prototype.disposeInternal.call(this);
    };
    /**
   * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */ ImageTile.prototype.getImage = function getImage() {
        return this.image_;
    };
    /**
   * @inheritDoc
   */ ImageTile.prototype.getKey = function getKey() {
        return this.src_;
    };
    /**
   * Tracks loading or read errors.
   *
   * @private
   */ ImageTile.prototype.handleImageError_ = function handleImageError_() {
        this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.image_ = $50fe57b595b18ff9$var$getBlankImage();
        this.changed();
    };
    /**
   * Tracks successful image load.
   *
   * @private
   */ ImageTile.prototype.handleImageLoad_ = function handleImageLoad_() {
        var image = /** @type {HTMLImageElement} */ this.image_;
        if (image.naturalWidth && image.naturalHeight) this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED;
        else this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY;
        this.unlistenImage_();
        this.changed();
    };
    /**
   * @inheritDoc
   * @api
   */ ImageTile.prototype.load = function load() {
        if (this.state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR) {
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        }
        if (this.state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.imageListenerKeys_ = [
                (0, $37a5c0af9052e360$export$8d2a95bc11b44725)(this.image_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).ERROR, this.handleImageError_, this),
                (0, $37a5c0af9052e360$export$8d2a95bc11b44725)(this.image_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).LOAD, this.handleImageLoad_, this)
            ];
            this.tileLoadFunction_(this, this.src_);
        }
    };
    /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ ImageTile.prototype.unlistenImage_ = function unlistenImage_() {
        this.imageListenerKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        this.imageListenerKeys_ = null;
    };
    return ImageTile;
}((0, $d91642aad273ae94$export$2e2bcd8739ae039));
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement} Blank image.
 */ function $50fe57b595b18ff9$var$getBlankImage() {
    var ctx = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(1, 1);
    ctx.fillStyle = "rgba(0,0,0,0)";
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $50fe57b595b18ff9$export$2e2bcd8739ae039 = $50fe57b595b18ff9$var$ImageTile;


/**
 * @module ol/TileCache
 */ 
/**
 * @module ol/tilecoord
 */ /**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z`, `x`, and `y`. `z` is the zoom level.
 * @typedef {Array<number>} TileCoord
 * @api
 */ /**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord=} opt_tileCoord Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */ function $321b949bcc451ffb$export$958e3e1a02eac4b6(z, x, y, opt_tileCoord) {
    if (opt_tileCoord !== undefined) {
        opt_tileCoord[0] = z;
        opt_tileCoord[1] = x;
        opt_tileCoord[2] = y;
        return opt_tileCoord;
    } else return [
        z,
        x,
        y
    ];
}
function $321b949bcc451ffb$export$92d0df0f1d25c63c(z, x, y) {
    return z + "/" + x + "/" + y;
}
function $321b949bcc451ffb$export$a47fb462a08de82f(tileCoord) {
    return $321b949bcc451ffb$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $321b949bcc451ffb$export$a807b7874eb66454(key) {
    return key.split("/").map(Number);
}
function $321b949bcc451ffb$export$d6af199866bfb566(tileCoord) {
    return (tileCoord[1] << tileCoord[0]) + tileCoord[2];
}
function $321b949bcc451ffb$export$fdbe9a381526a683(tileCoord) {
    var z = tileCoord[0];
    var digits = new Array(z);
    var mask = 1 << z - 1;
    var i, charCode;
    for(i = 0; i < z; ++i){
        // 48 is charCode for 0 - '0'.charCodeAt(0)
        charCode = 48;
        if (tileCoord[1] & mask) charCode += 1;
        if (tileCoord[2] & mask) charCode += 2;
        digits[i] = String.fromCharCode(charCode);
        mask >>= 1;
    }
    return digits.join("");
}
function $321b949bcc451ffb$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    var z = tileCoord[0];
    var x = tileCoord[1];
    var y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    var extent = tileGrid.getExtent();
    var tileRange;
    if (!extent) tileRange = tileGrid.getFullTileRange(z);
    else tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
    if (!tileRange) return true;
    else return tileRange.containsXY(x, y);
}


var $764d10c51058d078$var$TileCache = /*@__PURE__*/ function(LRUCache) {
    function TileCache(opt_highWaterMark) {
        LRUCache.call(this, opt_highWaterMark);
    }
    if (LRUCache) TileCache.__proto__ = LRUCache;
    TileCache.prototype = Object.create(LRUCache && LRUCache.prototype);
    TileCache.prototype.constructor = TileCache;
    /**
   * @param {!Object<string, import("./TileRange.js").default>} usedTiles Used tiles.
   */ TileCache.prototype.expireCache = function expireCache(usedTiles) {
        while(this.canExpireCache()){
            var tile = this.peekLast();
            var zKey = tile.tileCoord[0].toString();
            if (zKey in usedTiles && usedTiles[zKey].contains(tile.tileCoord)) break;
            else this.pop().dispose();
        }
    };
    /**
   * Prune all tiles from the cache that don't have the same z as the newest tile.
   */ TileCache.prototype.pruneExceptNewestZ = function pruneExceptNewestZ() {
        if (this.getCount() === 0) return;
        var key = this.peekFirstKey();
        var tileCoord = (0, $321b949bcc451ffb$export$a807b7874eb66454)(key);
        var z = tileCoord[0];
        this.forEach(function(tile) {
            if (tile.tileCoord[0] !== z) {
                this.remove((0, $321b949bcc451ffb$export$a47fb462a08de82f)(tile.tileCoord));
                tile.dispose();
            }
        }, this);
    };
    return TileCache;
}((0, $24eec3dde9adb61e$export$2e2bcd8739ae039));
var $764d10c51058d078$export$2e2bcd8739ae039 = $764d10c51058d078$var$TileCache;






/**
 * @module ol/reproj/Tile
 */ 






/**
 * @module ol/reproj
 */ 



function $5bc6f6a25c982e7a$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    var sourceCenter = (0, $92f1443438429e81$export$51186ad6e864892a)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    var sourceResolution = (0, $92f1443438429e81$export$2d8f7b4eec383d44)(targetProj, targetResolution, targetCenter);
    var targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    var sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    var sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $7e819822b33b3d32$export$ac68c24d37ca240f)(sourceExtent, sourceCenter)) {
        var compensationFactor = (0, $92f1443438429e81$export$2d8f7b4eec383d44)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
/**
 * Enlarge the clipping triangle point by 1 pixel to ensure the edges overlap
 * in order to mask gaps caused by antialiasing.
 *
 * @param {number} centroidX Centroid of the triangle (x coordinate in pixels).
 * @param {number} centroidY Centroid of the triangle (y coordinate in pixels).
 * @param {number} x X coordinate of the point (in pixels).
 * @param {number} y Y coordinate of the point (in pixels).
 * @return {import("./coordinate.js").Coordinate} New point 1 px farther from the centroid.
 */ function $5bc6f6a25c982e7a$var$enlargeClipPoint(centroidX, centroidY, x, y) {
    var dX = x - centroidX;
    var dY = y - centroidY;
    var distance = Math.sqrt(dX * dX + dY * dY);
    return [
        Math.round(x + dX / distance),
        Math.round(y + dY / distance)
    ];
}
function $5bc6f6a25c982e7a$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, opt_renderEdges) {
    var context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(Math.round(pixelRatio * width), Math.round(pixelRatio * height));
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    var sourceDataExtent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
    sources.forEach(function(src, i, arr) {
        (0, $7e819822b33b3d32$export$8b58be045bf06082)(sourceDataExtent, src.extent);
    });
    var canvasWidthInUnits = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(sourceDataExtent);
    var canvasHeightInUnits = (0, $7e819822b33b3d32$export$c08559766941f856)(sourceDataExtent);
    var stitchContext = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(Math.round(pixelRatio * canvasWidthInUnits / sourceResolution), Math.round(pixelRatio * canvasHeightInUnits / sourceResolution));
    var stitchScale = pixelRatio / sourceResolution;
    sources.forEach(function(src, i, arr) {
        var xPos = src.extent[0] - sourceDataExtent[0];
        var yPos = -(src.extent[3] - sourceDataExtent[3]);
        var srcWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(src.extent);
        var srcHeight = (0, $7e819822b33b3d32$export$c08559766941f856)(src.extent);
        stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, xPos * stitchScale, yPos * stitchScale, srcWidth * stitchScale, srcHeight * stitchScale);
    });
    var targetTopLeft = (0, $7e819822b33b3d32$export$cb1538b07e6964ff)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
     * Resulting matrix can be used to transform coordinate
     * from `sourceProjection` to destination pixels.
     *
     * To optimize number of context calls and increase numerical stability,
     * we also do the following operations:
     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
     * here before solving the linear system so [ui, vi] are pixel coordinates.
     *
     * Src points: xi, yi
     * Dst points: ui, vi
     * Affine coefficients: aij
     *
     * | x0 y0 1  0  0 0 |   |a00|   |u0|
     * | x1 y1 1  0  0 0 |   |a01|   |u1|
     * | x2 y2 1  0  0 0 | x |a02| = |u2|
     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
     */ var source = triangle.source;
        var target = triangle.target;
        var x0 = source[0][0], y0 = source[0][1];
        var x1 = source[1][0], y1 = source[1][1];
        var x2 = source[2][0], y2 = source[2][1];
        var u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
        var v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
        var u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
        var v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
        var u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
        var v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        var sourceNumericalShiftX = x0;
        var sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        var augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        var affineCoefs = (0, $d4e56cfc37d8b1f9$export$8240f01c446270e6)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        var centroidX = (u0 + u1 + u2) / 3;
        var centroidY = (v0 + v1 + v2) / 3;
        var p0 = $5bc6f6a25c982e7a$var$enlargeClipPoint(centroidX, centroidY, u0, v0);
        var p1 = $5bc6f6a25c982e7a$var$enlargeClipPoint(centroidX, centroidY, u1, v1);
        var p2 = $5bc6f6a25c982e7a$var$enlargeClipPoint(centroidX, centroidY, u2, v2);
        context.moveTo(p1[0], p1[1]);
        context.lineTo(p0[0], p0[1]);
        context.lineTo(p2[0], p2[1]);
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        context.scale(sourceResolution / pixelRatio, -sourceResolution / pixelRatio);
        context.drawImage(stitchContext.canvas, 0, 0);
        context.restore();
    });
    if (opt_renderEdges) {
        context.save();
        context.strokeStyle = "black";
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            var target = triangle.target;
            var u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            var v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            var u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            var v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            var u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            var v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}


/**
 * @module ol/reproj/Triangulation
 */ 


/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source
 * @property {Array<import("../coordinate.js").Coordinate>} target
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ var $72dfda612e83d57a$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ var $72dfda612e83d57a$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ var $72dfda612e83d57a$var$Triangulation = function Triangulation(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold) {
    /**
   * @type {import("../proj/Projection.js").default}
   * @private
   */ this.sourceProj_ = sourceProj;
    /**
   * @type {import("../proj/Projection.js").default}
   * @private
   */ this.targetProj_ = targetProj;
    /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ var transformInvCache = {};
    var transformInv = (0, $92f1443438429e81$export$fce0c6cfca85ed96)(this.targetProj_, this.sourceProj_);
    /**
   * @param {import("../coordinate.js").Coordinate} c A coordinate.
   * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
   * @private
   */ this.transformInv_ = function(c) {
        var key = c[0] + "/" + c[1];
        if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
        return transformInvCache[key];
    };
    /**
   * @type {import("../extent.js").Extent}
   * @private
   */ this.maxSourceExtent_ = maxSourceExtent;
    /**
   * @type {number}
   * @private
   */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
    /**
   * @type {Array<Triangle>}
   * @private
   */ this.triangles_ = [];
    /**
   * Indicates that the triangulation crosses edge of the source projection.
   * @type {boolean}
   * @private
   */ this.wrapsXInSource_ = false;
    /**
   * @type {boolean}
   * @private
   */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(maxSourceExtent) == (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent());
    /**
   * @type {?number}
   * @private
   */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent()) : null;
    /**
   * @type {?number}
   * @private
   */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(this.targetProj_.getExtent()) : null;
    var destinationTopLeft = (0, $7e819822b33b3d32$export$cb1538b07e6964ff)(targetExtent);
    var destinationTopRight = (0, $7e819822b33b3d32$export$b84fa077c8b05295)(targetExtent);
    var destinationBottomRight = (0, $7e819822b33b3d32$export$e77c1cf70445e168)(targetExtent);
    var destinationBottomLeft = (0, $7e819822b33b3d32$export$8d09f5e2e1bf560d)(targetExtent);
    var sourceTopLeft = this.transformInv_(destinationTopLeft);
    var sourceTopRight = this.transformInv_(destinationTopRight);
    var sourceBottomRight = this.transformInv_(destinationBottomRight);
    var sourceBottomLeft = this.transformInv_(destinationBottomLeft);
    this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, $72dfda612e83d57a$var$MAX_SUBDIVISION);
    if (this.wrapsXInSource_) {
        var leftBound = Infinity;
        this.triangles_.forEach(function(triangle, i, arr) {
            leftBound = Math.min(leftBound, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
        });
        // Shift triangles to be as close to `leftBound` as possible
        // (if the distance is more than `worldWidth / 2` it can be closer.
        this.triangles_.forEach((function(triangle) {
            if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound > this.sourceWorldWidth_ / 2) {
                var newTriangle = [
                    [
                        triangle.source[0][0],
                        triangle.source[0][1]
                    ],
                    [
                        triangle.source[1][0],
                        triangle.source[1][1]
                    ],
                    [
                        triangle.source[2][0],
                        triangle.source[2][1]
                    ]
                ];
                if (newTriangle[0][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                if (newTriangle[1][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                if (newTriangle[2][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                // Rarely (if the extent contains both the dateline and prime meridian)
                // the shift can in turn break some triangles.
                // Detect this here and don't shift in such cases.
                var minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                var maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
            }
        }).bind(this));
    }
    transformInvCache = {};
};
/**
 * Adds triangle to the triangulation.
 * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
 * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
 * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
 * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
 * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
 * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
 * @private
 */ $72dfda612e83d57a$var$Triangulation.prototype.addTriangle_ = function addTriangle_(a, b, c, aSrc, bSrc, cSrc) {
    this.triangles_.push({
        source: [
            aSrc,
            bSrc,
            cSrc
        ],
        target: [
            a,
            b,
            c
        ]
    });
};
/**
 * Adds quad (points in clock-wise order) to the triangulation
 * (and reprojects the vertices) if valid.
 * Performs quad subdivision if needed to increase precision.
 *
 * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
 * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
 * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
 * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
 * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
 * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
 * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
 * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
 * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
 * @private
 */ $72dfda612e83d57a$var$Triangulation.prototype.addQuad_ = function addQuad_(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
    var sourceQuadExtent = (0, $7e819822b33b3d32$export$8aceca7c77505534)([
        aSrc,
        bSrc,
        cSrc,
        dSrc
    ]);
    var sourceCoverageX = this.sourceWorldWidth_ ? (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
    var sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
    // when the quad is wrapped in the source projection
    // it covers most of the projection extent, but not fully
    var wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
    var needsSubdivision = false;
    if (maxSubdivision > 0) {
        if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
            var targetQuadExtent = (0, $7e819822b33b3d32$export$8aceca7c77505534)([
                a,
                b,
                c,
                d
            ]);
            var targetCoverageX = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(targetQuadExtent) / this.targetWorldWidth_;
            needsSubdivision = targetCoverageX > $72dfda612e83d57a$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $72dfda612e83d57a$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
    }
    if (!needsSubdivision && this.maxSourceExtent_) {
        if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
        return;
    }
    if (!needsSubdivision) {
        if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
            if (maxSubdivision > 0) needsSubdivision = true;
            else return;
        }
    }
    if (maxSubdivision > 0) {
        if (!needsSubdivision) {
            var center = [
                (a[0] + c[0]) / 2,
                (a[1] + c[1]) / 2
            ];
            var centerSrc = this.transformInv_(center);
            var dx;
            if (wrapsX) {
                var centerSrcEstimX = ((0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(aSrc[0], sourceWorldWidth) + (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(cSrc[0], sourceWorldWidth)) / 2;
                dx = centerSrcEstimX - (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(centerSrc[0], sourceWorldWidth);
            } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
            var dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
            var centerSrcErrorSquared = dx * dx + dy * dy;
            needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
        }
        if (needsSubdivision) {
            if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                // split horizontally (top & bottom)
                var bc = [
                    (b[0] + c[0]) / 2,
                    (b[1] + c[1]) / 2
                ];
                var bcSrc = this.transformInv_(bc);
                var da = [
                    (d[0] + a[0]) / 2,
                    (d[1] + a[1]) / 2
                ];
                var daSrc = this.transformInv_(da);
                this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
            } else {
                // split vertically (left & right)
                var ab = [
                    (a[0] + b[0]) / 2,
                    (a[1] + b[1]) / 2
                ];
                var abSrc = this.transformInv_(ab);
                var cd = [
                    (c[0] + d[0]) / 2,
                    (c[1] + d[1]) / 2
                ];
                var cdSrc = this.transformInv_(cd);
                this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
            }
            return;
        }
    }
    if (wrapsX) {
        if (!this.canWrapXInSource_) return;
        this.wrapsXInSource_ = true;
    }
    this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
    this.addTriangle_(a, b, c, aSrc, bSrc, cSrc);
};
/**
 * Calculates extent of the 'source' coordinates from all the triangles.
 *
 * @return {import("../extent.js").Extent} Calculated extent.
 */ $72dfda612e83d57a$var$Triangulation.prototype.calculateSourceExtent = function calculateSourceExtent() {
    var extent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
    this.triangles_.forEach(function(triangle, i, arr) {
        var src = triangle.source;
        (0, $7e819822b33b3d32$export$1f820e3920fa5715)(extent, src[0]);
        (0, $7e819822b33b3d32$export$1f820e3920fa5715)(extent, src[1]);
        (0, $7e819822b33b3d32$export$1f820e3920fa5715)(extent, src[2]);
    });
    return extent;
};
/**
 * @return {Array<Triangle>} Array of the calculated triangles.
 */ $72dfda612e83d57a$var$Triangulation.prototype.getTriangles = function getTriangles() {
    return this.triangles_;
};
var $72dfda612e83d57a$export$2e2bcd8739ae039 = $72dfda612e83d57a$var$Triangulation;


/**
 * @typedef {function(number, number, number, number) : import("../Tile.js").default} FunctionType
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ var $c8ca3105da7720d1$var$ReprojTile = /*@__PURE__*/ function(Tile) {
    function ReprojTile(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, opt_errorThreshold, opt_renderEdges) {
        Tile.call(this, tileCoord, (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE);
        /**
     * @private
     * @type {boolean}
     */ this.renderEdges_ = opt_renderEdges !== undefined ? opt_renderEdges : false;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.gutter_ = gutter;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.sourceTileGrid_ = sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.targetTileGrid_ = targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
     * @private
     * @type {!Array<import("../Tile.js").default>}
     */ this.sourceTiles_ = [];
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ this.sourceZ_ = 0;
        var targetExtent = targetTileGrid.getTileCoordExtent(this.wrappedTileCoord_);
        var maxTargetExtent = this.targetTileGrid_.getExtent();
        var maxSourceExtent = this.sourceTileGrid_.getExtent();
        var limitedTargetExtent = maxTargetExtent ? (0, $7e819822b33b3d32$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $7e819822b33b3d32$export$520c40045967cb15)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        var sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $7e819822b33b3d32$export$72209efa88586d42)(maxSourceExtent, sourceProjExtent);
        }
        var targetResolution = targetTileGrid.getResolution(this.wrappedTileCoord_[0]);
        var targetCenter = (0, $7e819822b33b3d32$export$c91255cadecfe081)(limitedTargetExtent);
        var sourceResolution = (0, $5bc6f6a25c982e7a$export$5fbb958059b7e71f)(sourceProj, targetProj, targetCenter, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        var errorThresholdInPixels = opt_errorThreshold !== undefined ? opt_errorThreshold : (0, $7b3aa4a24649670e$export$3ecb4bcfa5aae855);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = new (0, $72dfda612e83d57a$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels);
        if (this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        var sourceExtent = this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $7e819822b33b3d32$export$72209efa88586d42)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $7e819822b33b3d32$export$520c40045967cb15)(sourceExtent)) this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY;
        else {
            var sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(sourceExtent, this.sourceZ_);
            for(var srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(var srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                var tile = getTileFunction(this.sourceZ_, srcX, srcY, pixelRatio);
                if (tile) this.sourceTiles_.push(tile);
            }
            if (this.sourceTiles_.length === 0) this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY;
        }
    }
    if (Tile) ReprojTile.__proto__ = Tile;
    ReprojTile.prototype = Object.create(Tile && Tile.prototype);
    ReprojTile.prototype.constructor = ReprojTile;
    /**
   * @inheritDoc
   */ ReprojTile.prototype.disposeInternal = function disposeInternal() {
        if (this.state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADING) this.unlistenSources_();
        Tile.prototype.disposeInternal.call(this);
    };
    /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement} Canvas.
   */ ReprojTile.prototype.getImage = function getImage() {
        return this.canvas_;
    };
    /**
   * @private
   */ ReprojTile.prototype.reproject_ = function reproject_() {
        var sources = [];
        this.sourceTiles_.forEach((function(tile, i, arr) {
            if (tile && tile.getState() == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) sources.push({
                extent: this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord),
                image: tile.getImage()
            });
        }).bind(this));
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR;
        else {
            var z = this.wrappedTileCoord_[0];
            var size = this.targetTileGrid_.getTileSize(z);
            var width = typeof size === "number" ? size : size[0];
            var height = typeof size === "number" ? size : size[1];
            var targetResolution = this.targetTileGrid_.getResolution(z);
            var sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            var targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, $5bc6f6a25c982e7a$export$b3890eb0ae9dca99)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_);
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED;
        }
        this.changed();
    };
    /**
   * @inheritDoc
   */ ReprojTile.prototype.load = function load() {
        if (this.state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADING;
            this.changed();
            var leftToLoad = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach((function(tile, i, arr) {
                var state = tile.getState();
                if (state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE || state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADING) {
                    leftToLoad++;
                    var sourceListenKey = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(tile, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, function(e) {
                        var state = tile.getState();
                        if (state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED || state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR || state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY) {
                            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(sourceListenKey);
                            leftToLoad--;
                            if (leftToLoad === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    }, this);
                    this.sourcesListenerKeys_.push(sourceListenKey);
                }
            }).bind(this));
            this.sourceTiles_.forEach(function(tile, i, arr) {
                var state = tile.getState();
                if (state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE) tile.load();
            });
            if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
        }
    };
    /**
   * @private
   */ ReprojTile.prototype.unlistenSources_ = function unlistenSources_() {
        this.sourcesListenerKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        this.sourcesListenerKeys_ = null;
    };
    return ReprojTile;
}((0, $d91642aad273ae94$export$2e2bcd8739ae039));
var $c8ca3105da7720d1$export$2e2bcd8739ae039 = $c8ca3105da7720d1$var$ReprojTile;


/**
 * @module ol/source/UrlTile
 */ 

/**
 * @module ol/tileurlfunction
 */ 


function $847880a03aa9cac5$export$f0ecb46e90798741(template, tileGrid) {
    var zRegEx = /\{z\}/g;
    var xRegEx = /\{x\}/g;
    var yRegEx = /\{y\}/g;
    var dashYRegEx = /\{-y\}/g;
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        else return template.replace(zRegEx, tileCoord[0].toString()).replace(xRegEx, tileCoord[1].toString()).replace(yRegEx, function() {
            var y = -tileCoord[2] - 1;
            return y.toString();
        }).replace(dashYRegEx, function() {
            var z = tileCoord[0];
            var range = tileGrid.getFullTileRange(z);
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(range, 55); // The {-y} placeholder requires a tile grid with extent
            var y = range.getHeight() + tileCoord[2];
            return y.toString();
        });
    });
}
function $847880a03aa9cac5$export$436f44dbcc31fea3(templates, tileGrid) {
    var len = templates.length;
    var tileUrlFunctions = new Array(len);
    for(var i = 0; i < len; ++i)tileUrlFunctions[i] = $847880a03aa9cac5$export$f0ecb46e90798741(templates[i], tileGrid);
    return $847880a03aa9cac5$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $847880a03aa9cac5$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        else {
            var h = (0, $321b949bcc451ffb$export$d6af199866bfb566)(tileCoord);
            var index = (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(h, tileUrlFunctions.length);
            return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
        }
    });
}
function $847880a03aa9cac5$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}
function $847880a03aa9cac5$export$2a1fa079bfd73dde(url) {
    var urls = [];
    var match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        var startCharCode = match[1].charCodeAt(0);
        var stopCharCode = match[2].charCodeAt(0);
        var charCode;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        var stop = parseInt(match[2], 10);
        for(var i = parseInt(match[1], 10); i <= stop; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}


/**
 * @module ol/source/Tile
 */ 





/**
 * @module ol/source/Source
 */ 



/**
 * A function that returns a string or an array of strings representing source
 * attributions.
 *
 * @typedef {function(import("../PluggableMap.js").FrameState): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * * a simple string (e.g. `'© Acme Inc.'`)
 * * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * * a function that returns a string or array of strings (`{@link module:ol/source/Source~Attribution}`)
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions]
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} projection
 * @property {SourceState} [state='ready']
 * @property {boolean} [wrapX=false]
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ var $dba8564f516aed29$var$Source = /*@__PURE__*/ function(BaseObject) {
    function Source(options) {
        BaseObject.call(this);
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.projection_ = (0, $92f1443438429e81$export$3988ae62b71be9a3)(options.projection);
        /**
     * @private
     * @type {?Attribution}
     */ this.attributions_ = $dba8564f516aed29$var$adaptAttributions(options.attributions);
        /**
     * @private
     * @type {boolean}
     */ this.attributionsCollapsible_ = options.attributionsCollapsible !== undefined ? options.attributionsCollapsible : true;
        /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to `true`.
     * @type {boolean}
     */ this.loading = false;
        /**
     * @private
     * @type {SourceState}
     */ this.state_ = options.state !== undefined ? options.state : (0, $7c2f117cb5c1ce12$export$2e2bcd8739ae039).READY;
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
    }
    if (BaseObject) Source.__proto__ = BaseObject;
    Source.prototype = Object.create(BaseObject && BaseObject.prototype);
    Source.prototype.constructor = Source;
    /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   */ Source.prototype.getAttributions = function getAttributions() {
        return this.attributions_;
    };
    /**
   * @return {boolean} Aattributions are collapsible.
   */ Source.prototype.getAttributionsCollapsible = function getAttributionsCollapsible() {
        return this.attributionsCollapsible_;
    };
    /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   */ Source.prototype.getProjection = function getProjection() {
        return this.projection_;
    };
    /**
   * @abstract
   * @return {Array<number>|undefined} Resolutions.
   */ Source.prototype.getResolutions = function getResolutions() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Get the state of the source, see {@link module:ol/source/State~State} for possible states.
   * @return {SourceState} State.
   * @api
   */ Source.prototype.getState = function getState() {
        return this.state_;
    };
    /**
   * @return {boolean|undefined} Wrap X.
   */ Source.prototype.getWrapX = function getWrapX() {
        return this.wrapX_;
    };
    /**
   * Refreshes the source and finally dispatches a 'change' event.
   * @api
   */ Source.prototype.refresh = function refresh() {
        this.changed();
    };
    /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, `{@link module:ol/source/Source~Attribution}`,
   *     or `undefined`.
   * @api
   */ Source.prototype.setAttributions = function setAttributions(attributions) {
        this.attributions_ = $dba8564f516aed29$var$adaptAttributions(attributions);
        this.changed();
    };
    /**
   * Set the state of the source.
   * @param {SourceState} state State.
   * @protected
   */ Source.prototype.setState = function setState(state) {
        this.state_ = state;
        this.changed();
    };
    return Source;
}((0, $d575b598d09f57d3$export$2e2bcd8739ae039));
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {?Attribution} An attribution function (or null).
 */ function $dba8564f516aed29$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (Array.isArray(attributionLike)) return function(frameState) {
        return attributionLike;
    };
    if (typeof attributionLike === "function") return attributionLike;
    return function(frameState) {
        return [
            attributionLike
        ];
    };
}
var $dba8564f516aed29$export$2e2bcd8739ae039 = $dba8564f516aed29$var$Source;



/**
 * @module ol/tilegrid
 */ 





/**
 * @module ol/tilegrid/TileGrid
 */ 







/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ var $b5cc936d16623cb8$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and upwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and upwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Sizes.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ var $b5cc936d16623cb8$var$TileGrid = function TileGrid(options) {
    /**
   * @protected
   * @type {number}
   */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
    /**
   * @private
   * @type {!Array<number>}
   */ this.resolutions_ = options.resolutions;
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)((0, $830d23b8323fc080$export$efa610630f9e181)(this.resolutions_, function(a, b) {
        return b - a;
    }, true), 17); // `resolutions` must be sorted in descending order
    // check if we've got a consistent zoom factor and origin
    var zoomFactor;
    if (!options.origins) for(var i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
        if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
        else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
            zoomFactor = undefined;
            break;
        }
    }
    /**
   * @private
   * @type {number|undefined}
   */ this.zoomFactor_ = zoomFactor;
    /**
   * @protected
   * @type {number}
   */ this.maxZoom = this.resolutions_.length - 1;
    /**
   * @private
   * @type {import("../coordinate.js").Coordinate}
   */ this.origin_ = options.origin !== undefined ? options.origin : null;
    /**
   * @private
   * @type {Array<import("../coordinate.js").Coordinate>}
   */ this.origins_ = null;
    if (options.origins !== undefined) {
        this.origins_ = options.origins;
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(this.origins_.length == this.resolutions_.length, 20); // Number of `origins` and `resolutions` must be equal
    }
    var extent = options.extent;
    if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $7e819822b33b3d32$export$cb1538b07e6964ff)(extent);
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, 18); // Either `origin` or `origins` must be configured, never both
    /**
   * @private
   * @type {Array<number|import("../size.js").Size>}
   */ this.tileSizes_ = null;
    if (options.tileSizes !== undefined) {
        this.tileSizes_ = options.tileSizes;
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(this.tileSizes_.length == this.resolutions_.length, 19); // Number of `tileSizes` and `resolutions` must be equal
    }
    /**
   * @private
   * @type {number|import("../size.js").Size}
   */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $9a8010a8337e7cef$export$6b8cb5cd370bd90c) : null;
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, 22); // Either `tileSize` or `tileSizes` must be configured, never both
    /**
   * @private
   * @type {import("../extent.js").Extent}
   */ this.extent_ = extent !== undefined ? extent : null;
    /**
   * @private
   * @type {Array<import("../TileRange.js").default>}
   */ this.fullTileRanges_ = null;
    /**
   * @private
   * @type {import("../size.js").Size}
   */ this.tmpSize_ = [
        0,
        0
    ];
    if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map(function(size, z) {
        var tileRange = new (0, $014fe51f68272f2c$export$2e2bcd8739ae039)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
        return tileRange;
    }, this);
    else if (extent) this.calculateTileRanges_(extent);
};
/**
 * Call a function with each tile coordinate for a given extent and zoom level.
 *
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {number} zoom Integer zoom level.
 * @param {function(import("../tilecoord.js").TileCoord)} callback Function called with each tile coordinate.
 * @api
 */ $b5cc936d16623cb8$var$TileGrid.prototype.forEachTileCoord = function forEachTileCoord(extent, zoom, callback) {
    var tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
    for(var i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(var j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
        zoom,
        i,
        j
    ]);
};
/**
 * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @param {function(this: T, number, import("../TileRange.js").default): boolean} callback Callback.
 * @param {T=} opt_this The object to use as `this` in `callback`.
 * @param {import("../TileRange.js").default=} opt_tileRange Temporary import("../TileRange.js").default object.
 * @param {import("../extent.js").Extent=} opt_extent Temporary import("../extent.js").Extent object.
 * @return {boolean} Callback succeeded.
 * @template T
 */ $b5cc936d16623cb8$var$TileGrid.prototype.forEachTileCoordParentTileRange = function forEachTileCoordParentTileRange(tileCoord, callback, opt_this, opt_tileRange, opt_extent) {
    var tileRange, x, y;
    var tileCoordExtent = null;
    var z = tileCoord[0] - 1;
    if (this.zoomFactor_ === 2) {
        x = tileCoord[1];
        y = tileCoord[2];
    } else tileCoordExtent = this.getTileCoordExtent(tileCoord, opt_extent);
    while(z >= this.minZoom){
        if (this.zoomFactor_ === 2) {
            x = Math.floor(x / 2);
            y = Math.floor(y / 2);
            tileRange = (0, $014fe51f68272f2c$export$958e3e1a02eac4b6)(x, x, y, y, opt_tileRange);
        } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, opt_tileRange);
        if (callback.call(opt_this, z, tileRange)) return true;
        --z;
    }
    return false;
};
/**
 * Get the extent for this tile grid, if it was configured.
 * @return {import("../extent.js").Extent} Extent.
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getExtent = function getExtent() {
    return this.extent_;
};
/**
 * Get the maximum zoom level for the grid.
 * @return {number} Max zoom.
 * @api
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getMaxZoom = function getMaxZoom() {
    return this.maxZoom;
};
/**
 * Get the minimum zoom level for the grid.
 * @return {number} Min zoom.
 * @api
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getMinZoom = function getMinZoom() {
    return this.minZoom;
};
/**
 * Get the origin for the grid at the given zoom level.
 * @param {number} z Integer zoom level.
 * @return {import("../coordinate.js").Coordinate} Origin.
 * @api
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getOrigin = function getOrigin(z) {
    if (this.origin_) return this.origin_;
    else return this.origins_[z];
};
/**
 * Get the resolution for the given zoom level.
 * @param {number} z Integer zoom level.
 * @return {number} Resolution.
 * @api
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getResolution = function getResolution(z) {
    return this.resolutions_[z];
};
/**
 * Get the list of resolutions for the tile grid.
 * @return {Array<number>} Resolutions.
 * @api
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getResolutions = function getResolutions() {
    return this.resolutions_;
};
/**
 * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @param {import("../TileRange.js").default=} opt_tileRange Temporary import("../TileRange.js").default object.
 * @param {import("../extent.js").Extent=} opt_extent Temporary import("../extent.js").Extent object.
 * @return {import("../TileRange.js").default} Tile range.
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getTileCoordChildTileRange = function getTileCoordChildTileRange(tileCoord, opt_tileRange, opt_extent) {
    if (tileCoord[0] < this.maxZoom) {
        if (this.zoomFactor_ === 2) {
            var minX = tileCoord[1] * 2;
            var minY = tileCoord[2] * 2;
            return (0, $014fe51f68272f2c$export$958e3e1a02eac4b6)(minX, minX + 1, minY, minY + 1, opt_tileRange);
        }
        var tileCoordExtent = this.getTileCoordExtent(tileCoord, opt_extent);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, opt_tileRange);
    }
    return null;
};
/**
 * Get the extent for a tile range.
 * @param {number} z Integer zoom level.
 * @param {import("../TileRange.js").default} tileRange Tile range.
 * @param {import("../extent.js").Extent=} opt_extent Temporary import("../extent.js").Extent object.
 * @return {import("../extent.js").Extent} Extent.
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getTileRangeExtent = function getTileRangeExtent(z, tileRange, opt_extent) {
    var origin = this.getOrigin(z);
    var resolution = this.getResolution(z);
    var tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
    var minX = origin[0] + tileRange.minX * tileSize[0] * resolution;
    var maxX = origin[0] + (tileRange.maxX + 1) * tileSize[0] * resolution;
    var minY = origin[1] + tileRange.minY * tileSize[1] * resolution;
    var maxY = origin[1] + (tileRange.maxY + 1) * tileSize[1] * resolution;
    return (0, $7e819822b33b3d32$export$958e3e1a02eac4b6)(minX, minY, maxX, maxY, opt_extent);
};
/**
 * Get a tile range for the given extent and integer zoom level.
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {number} z Integer zoom level.
 * @param {import("../TileRange.js").default=} opt_tileRange Temporary tile range object.
 * @return {import("../TileRange.js").default} Tile range.
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getTileRangeForExtentAndZ = function getTileRangeForExtentAndZ(extent, z, opt_tileRange) {
    var tileCoord = $b5cc936d16623cb8$var$tmpTileCoord;
    this.getTileCoordForXYAndZ_(extent[0], extent[1], z, false, tileCoord);
    var minX = tileCoord[1];
    var minY = tileCoord[2];
    this.getTileCoordForXYAndZ_(extent[2], extent[3], z, true, tileCoord);
    return (0, $014fe51f68272f2c$export$958e3e1a02eac4b6)(minX, tileCoord[1], minY, tileCoord[2], opt_tileRange);
};
/**
 * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @return {import("../coordinate.js").Coordinate} Tile center.
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getTileCoordCenter = function getTileCoordCenter(tileCoord) {
    var origin = this.getOrigin(tileCoord[0]);
    var resolution = this.getResolution(tileCoord[0]);
    var tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
    return [
        origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
        origin[1] + (tileCoord[2] + 0.5) * tileSize[1] * resolution
    ];
};
/**
 * Get the extent of a tile coordinate.
 *
 * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @param {import("../extent.js").Extent=} opt_extent Temporary extent object.
 * @return {import("../extent.js").Extent} Extent.
 * @api
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getTileCoordExtent = function getTileCoordExtent(tileCoord, opt_extent) {
    var origin = this.getOrigin(tileCoord[0]);
    var resolution = this.getResolution(tileCoord[0]);
    var tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
    var minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
    var minY = origin[1] + tileCoord[2] * tileSize[1] * resolution;
    var maxX = minX + tileSize[0] * resolution;
    var maxY = minY + tileSize[1] * resolution;
    return (0, $7e819822b33b3d32$export$958e3e1a02eac4b6)(minX, minY, maxX, maxY, opt_extent);
};
/**
 * Get the tile coordinate for the given map coordinate and resolution.This
 * method considers that coordinates that intersect tile boundaries should be
 * assigned the higher tile coordinate.
 *
 * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} resolution Resolution.
 * @param {import("../tilecoord.js").TileCoord=} opt_tileCoord Destination import("../tilecoord.js").TileCoord object.
 * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
 * @api
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getTileCoordForCoordAndResolution = function getTileCoordForCoordAndResolution(coordinate, resolution, opt_tileCoord) {
    return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
};
/**
 * Note that this method should not be called for resolutions that correspond
 * to an integer zoom level.Instead call the `getTileCoordForXYAndZ_` method.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {number} resolution Resolution (for a non-integer zoom level).
 * @param {boolean} reverseIntersectionPolicy Instead of letting edge
 *   intersections go to the higher tile coordinate, let edge intersections
 *   go to the lower tile coordinate.
 * @param {import("../tilecoord.js").TileCoord=} opt_tileCoord Temporary import("../tilecoord.js").TileCoord object.
 * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
 * @private
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getTileCoordForXYAndResolution_ = function getTileCoordForXYAndResolution_(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
    var z = this.getZForResolution(resolution);
    var scale = resolution / this.getResolution(z);
    var origin = this.getOrigin(z);
    var tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
    var adjustX = reverseIntersectionPolicy ? 0.5 : 0;
    var adjustY = reverseIntersectionPolicy ? 0 : 0.5;
    var xFromOrigin = Math.floor((x - origin[0]) / resolution + adjustX);
    var yFromOrigin = Math.floor((y - origin[1]) / resolution + adjustY);
    var tileCoordX = scale * xFromOrigin / tileSize[0];
    var tileCoordY = scale * yFromOrigin / tileSize[1];
    if (reverseIntersectionPolicy) {
        tileCoordX = Math.ceil(tileCoordX) - 1;
        tileCoordY = Math.ceil(tileCoordY) - 1;
    } else {
        tileCoordX = Math.floor(tileCoordX);
        tileCoordY = Math.floor(tileCoordY);
    }
    return (0, $321b949bcc451ffb$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
};
/**
 * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
 * they should have separate implementations.This method is for integer zoom
 * levels.The other method should only be called for resolutions corresponding
 * to non-integer zoom levels.
 * @param {number} x Map x coordinate.
 * @param {number} y Map y coordinate.
 * @param {number} z Integer zoom level.
 * @param {boolean} reverseIntersectionPolicy Instead of letting edge
 *   intersections go to the higher tile coordinate, let edge intersections
 *   go to the lower tile coordinate.
 * @param {import("../tilecoord.js").TileCoord=} opt_tileCoord Temporary import("../tilecoord.js").TileCoord object.
 * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
 * @private
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getTileCoordForXYAndZ_ = function getTileCoordForXYAndZ_(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
    var origin = this.getOrigin(z);
    var resolution = this.getResolution(z);
    var tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
    var adjustX = reverseIntersectionPolicy ? 0.5 : 0;
    var adjustY = reverseIntersectionPolicy ? 0 : 0.5;
    var xFromOrigin = Math.floor((x - origin[0]) / resolution + adjustX);
    var yFromOrigin = Math.floor((y - origin[1]) / resolution + adjustY);
    var tileCoordX = xFromOrigin / tileSize[0];
    var tileCoordY = yFromOrigin / tileSize[1];
    if (reverseIntersectionPolicy) {
        tileCoordX = Math.ceil(tileCoordX) - 1;
        tileCoordY = Math.ceil(tileCoordY) - 1;
    } else {
        tileCoordX = Math.floor(tileCoordX);
        tileCoordY = Math.floor(tileCoordY);
    }
    return (0, $321b949bcc451ffb$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
};
/**
 * Get a tile coordinate given a map coordinate and zoom level.
 * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} z Zoom level.
 * @param {import("../tilecoord.js").TileCoord=} opt_tileCoord Destination import("../tilecoord.js").TileCoord object.
 * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
 * @api
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getTileCoordForCoordAndZ = function getTileCoordForCoordAndZ(coordinate, z, opt_tileCoord) {
    return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
};
/**
 * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @return {number} Tile resolution.
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getTileCoordResolution = function getTileCoordResolution(tileCoord) {
    return this.resolutions_[tileCoord[0]];
};
/**
 * Get the tile size for a zoom level. The type of the return value matches the
 * `tileSize` or `tileSizes` that the tile grid was configured with. To always
 * get an `import("../size.js").Size`, run the result through `import("../size.js").Size.toSize()`.
 * @param {number} z Z.
 * @return {number|import("../size.js").Size} Tile size.
 * @api
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getTileSize = function getTileSize(z) {
    if (this.tileSize_) return this.tileSize_;
    else return this.tileSizes_[z];
};
/**
 * @param {number} z Zoom level.
 * @return {import("../TileRange.js").default} Extent tile range for the specified zoom level.
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getFullTileRange = function getFullTileRange(z) {
    if (!this.fullTileRanges_) return null;
    else return this.fullTileRanges_[z];
};
/**
 * @param {number} resolution Resolution.
 * @param {number=} opt_direction If 0, the nearest resolution will be used.
 *   If 1, the nearest lower resolution will be used. If -1, the nearest
 *   higher resolution will be used. Default is 0.
 * @return {number} Z.
 * @api
 */ $b5cc936d16623cb8$var$TileGrid.prototype.getZForResolution = function getZForResolution(resolution, opt_direction) {
    var z = (0, $830d23b8323fc080$export$8a3786cc03fdb777)(this.resolutions_, resolution, opt_direction || 0);
    return (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(z, this.minZoom, this.maxZoom);
};
/**
 * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
 * @private
 */ $b5cc936d16623cb8$var$TileGrid.prototype.calculateTileRanges_ = function calculateTileRanges_(extent) {
    var length = this.resolutions_.length;
    var fullTileRanges = new Array(length);
    for(var z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
    this.fullTileRanges_ = fullTileRanges;
};
var $b5cc936d16623cb8$export$2e2bcd8739ae039 = $b5cc936d16623cb8$var$TileGrid;


function $a46307816b1ae884$export$1f4812384df8a9c5(projection) {
    var tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $a46307816b1ae884$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $a46307816b1ae884$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    var z = tileCoord[0];
    var center = tileGrid.getTileCoordCenter(tileCoord);
    var projectionExtent = $a46307816b1ae884$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $7e819822b33b3d32$export$ac68c24d37ca240f)(projectionExtent, center)) {
        var worldWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(projectionExtent);
        var worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    } else return tileCoord;
}
function $a46307816b1ae884$export$ce88871416242df8(extent, opt_maxZoom, opt_tileSize, opt_corner) {
    var corner = opt_corner !== undefined ? opt_corner : (0, $f386e227189cd37a$export$2e2bcd8739ae039).TOP_LEFT;
    var resolutions = $a46307816b1ae884$var$resolutionsFromExtent(extent, opt_maxZoom, opt_tileSize);
    return new (0, $b5cc936d16623cb8$export$2e2bcd8739ae039)({
        extent: extent,
        origin: (0, $7e819822b33b3d32$export$a1cfd206661d0801)(extent, corner),
        resolutions: resolutions,
        tileSize: opt_tileSize
    });
}
function $a46307816b1ae884$export$38500bbeccc864ff(opt_options) {
    /** @type {XYZOptions} */ var xyzOptions = opt_options || {};
    var extent = xyzOptions.extent || (0, $92f1443438429e81$export$3988ae62b71be9a3)("EPSG:3857").getExtent();
    /** @type {import("./tilegrid/TileGrid.js").Options} */ var gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $a46307816b1ae884$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize)
    };
    return new (0, $b5cc936d16623cb8$export$2e2bcd8739ae039)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number=} opt_maxZoom Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size=} opt_tileSize Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @return {!Array<number>} Resolutions array.
 */ function $a46307816b1ae884$var$resolutionsFromExtent(extent, opt_maxZoom, opt_tileSize) {
    var maxZoom = opt_maxZoom !== undefined ? opt_maxZoom : (0, $9a8010a8337e7cef$export$e98a216cdcc847dc);
    var height = (0, $7e819822b33b3d32$export$c08559766941f856)(extent);
    var width = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(extent);
    var tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(opt_tileSize !== undefined ? opt_tileSize : (0, $9a8010a8337e7cef$export$6b8cb5cd370bd90c));
    var maxResolution = Math.max(width / tileSize[0], height / tileSize[1]);
    var length = maxZoom + 1;
    var resolutions = new Array(length);
    for(var z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $a46307816b1ae884$export$a251b12f5601c16f(projection, opt_maxZoom, opt_tileSize, opt_corner) {
    var extent = $a46307816b1ae884$export$7b5b6ef8fd55fac4(projection);
    return $a46307816b1ae884$export$ce88871416242df8(extent, opt_maxZoom, opt_tileSize, opt_corner);
}
function $a46307816b1ae884$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $92f1443438429e81$export$3988ae62b71be9a3)(projection);
    var extent = projection.getExtent();
    if (!extent) {
        var half = 180 * (0, $fb72d58bc9104528$export$1482081eec883108)[(0, $fb72d58bc9104528$export$2e2bcd8739ae039).DEGREES] / projection.getMetersPerUnit();
        extent = (0, $7e819822b33b3d32$export$958e3e1a02eac4b6)(-half, -half, half, half);
    }
    return extent;
}


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions]
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize]
 * @property {boolean} [opaque]
 * @property {number} [tilePixelRatio]
 * @property {import("../proj.js").ProjectionLike} [projection]
 * @property {import("./State.js").default} [state]
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid]
 * @property {boolean} [wrapX=true]
 * @property {number} [transition]
 * @property {string} [key]
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 * @abstract
 * @api
 */ var $5386d6ea3128b160$var$TileSource = /*@__PURE__*/ function(Source) {
    function TileSource(options) {
        Source.call(this, {
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX
        });
        /**
     * @private
     * @type {boolean}
     */ this.opaque_ = options.opaque !== undefined ? options.opaque : false;
        /**
     * @private
     * @type {number}
     */ this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
     * @protected
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        /**
     * @protected
     * @type {import("../TileCache.js").default}
     */ this.tileCache = new (0, $764d10c51058d078$export$2e2bcd8739ae039)(options.cacheSize);
        /**
     * @protected
     * @type {import("../size.js").Size}
     */ this.tmpSize = [
            0,
            0
        ];
        /**
     * @private
     * @type {string}
     */ this.key_ = options.key || "";
        /**
     * @protected
     * @type {import("../Tile.js").Options}
     */ this.tileOptions = {
            transition: options.transition
        };
    }
    if (Source) TileSource.__proto__ = Source;
    TileSource.prototype = Object.create(Source && Source.prototype);
    TileSource.prototype.constructor = TileSource;
    /**
   * @return {boolean} Can expire cache.
   */ TileSource.prototype.canExpireCache = function canExpireCache() {
        return this.tileCache.canExpireCache();
    };
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, import("../TileRange.js").default>} usedTiles Used tiles.
   */ TileSource.prototype.expireCache = function expireCache(projection, usedTiles) {
        var tileCache = this.getTileCacheForProjection(projection);
        if (tileCache) tileCache.expireCache(usedTiles);
    };
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {number} z Zoom level.
   * @param {import("../TileRange.js").default} tileRange Tile range.
   * @param {function(import("../Tile.js").default):(boolean|void)} callback Called with each
   *     loaded tile.  If the callback returns `false`, the tile will not be
   *     considered loaded.
   * @return {boolean} The tile range is fully covered with loaded tiles.
   */ TileSource.prototype.forEachLoadedTile = function forEachLoadedTile(projection, z, tileRange, callback) {
        var tileCache = this.getTileCacheForProjection(projection);
        if (!tileCache) return false;
        var covered = true;
        var tile, tileCoordKey, loaded;
        for(var x = tileRange.minX; x <= tileRange.maxX; ++x)for(var y = tileRange.minY; y <= tileRange.maxY; ++y){
            tileCoordKey = (0, $321b949bcc451ffb$export$92d0df0f1d25c63c)(z, x, y);
            loaded = false;
            if (tileCache.containsKey(tileCoordKey)) {
                tile = /** @type {!import("../Tile.js").default} */ tileCache.get(tileCoordKey);
                loaded = tile.getState() === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED;
                if (loaded) loaded = callback(tile) !== false;
            }
            if (!loaded) covered = false;
        }
        return covered;
    };
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ TileSource.prototype.getGutterForProjection = function getGutterForProjection(projection) {
        return 0;
    };
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   * @protected
   */ TileSource.prototype.getKey = function getKey() {
        return this.key_;
    };
    /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */ TileSource.prototype.setKey = function setKey(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    };
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {boolean} Opaque.
   */ TileSource.prototype.getOpaque = function getOpaque(projection) {
        return this.opaque_;
    };
    /**
   * @inheritDoc
   */ TileSource.prototype.getResolutions = function getResolutions() {
        return this.tileGrid.getResolutions();
    };
    /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../Tile.js").default} Tile.
   */ TileSource.prototype.getTile = function getTile(z, x, y, pixelRatio, projection) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default} Tile grid.
   * @api
   */ TileSource.prototype.getTileGrid = function getTileGrid() {
        return this.tileGrid;
    };
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ TileSource.prototype.getTileGridForProjection = function getTileGridForProjection$1(projection) {
        if (!this.tileGrid) return (0, $a46307816b1ae884$export$1f4812384df8a9c5)(projection);
        else return this.tileGrid;
    };
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   * @protected
   */ TileSource.prototype.getTileCacheForProjection = function getTileCacheForProjection(projection) {
        var thisProj = this.getProjection();
        if (thisProj && !(0, $92f1443438429e81$export$fe091d73a555748b)(thisProj, projection)) return null;
        else return this.tileCache;
    };
    /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ TileSource.prototype.getTilePixelRatio = function getTilePixelRatio(pixelRatio) {
        return this.tilePixelRatio_;
    };
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */ TileSource.prototype.getTilePixelSize = function getTilePixelSize(z, pixelRatio, projection) {
        var tileGrid = this.getTileGridForProjection(projection);
        var tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        var tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        else return (0, $f65ee5b9d8e75975$export$dcdf75081b88279d)(tileSize, tilePixelRatio, this.tmpSize);
    };
    /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default=} opt_projection Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */ TileSource.prototype.getTileCoordForTileUrlFunction = function getTileCoordForTileUrlFunction(tileCoord, opt_projection) {
        var projection = opt_projection !== undefined ? opt_projection : this.getProjection();
        var tileGrid = this.getTileGridForProjection(projection);
        if (this.getWrapX() && projection.isGlobal()) tileCoord = (0, $a46307816b1ae884$export$39a9ce3624977b84)(tileGrid, tileCoord, projection);
        return (0, $321b949bcc451ffb$export$60bedf8e3e3c3dbe)(tileCoord, tileGrid) ? tileCoord : null;
    };
    /**
   * @inheritDoc
   */ TileSource.prototype.refresh = function refresh() {
        this.tileCache.clear();
        this.changed();
    };
    /**
   * Marks a tile coord as being used, without triggering a load.
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ TileSource.prototype.useTile = function useTile(z, x, y, projection) {};
    return TileSource;
}((0, $dba8564f516aed29$export$2e2bcd8739ae039));
var $5386d6ea3128b160$export$c571855c51e6c4b6 = /*@__PURE__*/ function(Event) {
    function TileSourceEvent(type, tile) {
        Event.call(this, type);
        /**
     * The tile related to the event.
     * @type {import("../Tile.js").default}
     * @api
     */ this.tile = tile;
    }
    if (Event) TileSourceEvent.__proto__ = Event;
    TileSourceEvent.prototype = Object.create(Event && Event.prototype);
    TileSourceEvent.prototype.constructor = TileSourceEvent;
    return TileSourceEvent;
}((0, $0327f54963b35733$export$2e2bcd8739ae039));
var $5386d6ea3128b160$export$2e2bcd8739ae039 = $5386d6ea3128b160$var$TileSource;


/**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $9a12283e10a2a947$export$2e2bcd8739ae039 = {
    /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */ TILELOADSTART: "tileloadstart",
    /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */ TILELOADEND: "tileloadend",
    /**
   * Triggered if tile loading results in an error.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */ TILELOADERROR: "tileloaderror"
};



/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions]
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize]
 * @property {boolean} [opaque]
 * @property {import("../proj.js").ProjectionLike} [projection]
 * @property {import("./State.js").default} [state]
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid]
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction
 * @property {number} [tilePixelRatio]
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction]
 * @property {string} [url]
 * @property {Array<string>} [urls]
 * @property {boolean} [wrapX=true]
 * @property {number} [transition]
 * @property {string} [key]
 */ /**
 * @classdesc
 * Base class for sources providing tiles divided into a tile grid over http.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ var $717890273ec27e1e$var$UrlTile = /*@__PURE__*/ function(TileSource) {
    function UrlTile(options) {
        TileSource.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible
        });
        /**
     * @private
     * @type {boolean}
     */ this.generateTileUrlFunction_ = !options.tileUrlFunction;
        /**
     * @protected
     * @type {import("../Tile.js").LoadFunction}
     */ this.tileLoadFunction = options.tileLoadFunction;
        /**
     * @protected
     * @type {import("../Tile.js").UrlFunction}
     */ this.tileUrlFunction = options.tileUrlFunction ? options.tileUrlFunction.bind(this) : (0, $847880a03aa9cac5$export$fab585f002f634a1);
        /**
     * @protected
     * @type {!Array<string>|null}
     */ this.urls = null;
        if (options.urls) this.setUrls(options.urls);
        else if (options.url) this.setUrl(options.url);
        if (options.tileUrlFunction) this.setTileUrlFunction(options.tileUrlFunction, this.key_);
        /**
     * @private
     * @type {!Object<string, boolean>}
     */ this.tileLoadingKeys_ = {};
    }
    if (TileSource) UrlTile.__proto__ = TileSource;
    UrlTile.prototype = Object.create(TileSource && TileSource.prototype);
    UrlTile.prototype.constructor = UrlTile;
    /**
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */ UrlTile.prototype.getTileLoadFunction = function getTileLoadFunction() {
        return this.tileLoadFunction;
    };
    /**
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */ UrlTile.prototype.getTileUrlFunction = function getTileUrlFunction() {
        return this.tileUrlFunction;
    };
    /**
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */ UrlTile.prototype.getUrls = function getUrls() {
        return this.urls;
    };
    /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ UrlTile.prototype.handleTileChange = function handleTileChange(event) {
        var tile = /** @type {import("../Tile.js").default} */ event.target;
        var uid = (0, $34772e91e89a736f$export$5e82334337e0f204)(tile);
        var tileState = tile.getState();
        var type;
        if (tileState == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, $9a12283e10a2a947$export$2e2bcd8739ae039).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR ? (0, $9a12283e10a2a947$export$2e2bcd8739ae039).TILELOADERROR : tileState == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED || tileState == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ABORT ? (0, $9a12283e10a2a947$export$2e2bcd8739ae039).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, $5386d6ea3128b160$export$c571855c51e6c4b6)(type, tile));
    };
    /**
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */ UrlTile.prototype.setTileLoadFunction = function setTileLoadFunction(tileLoadFunction) {
        this.tileCache.clear();
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    };
    /**
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string=} key Optional new tile key for the source.
   * @api
   */ UrlTile.prototype.setTileUrlFunction = function setTileUrlFunction(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        this.tileCache.pruneExceptNewestZ();
        if (typeof key !== "undefined") this.setKey(key);
        else this.changed();
    };
    /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */ UrlTile.prototype.setUrl = function setUrl(url) {
        var urls = this.urls = (0, $847880a03aa9cac5$export$2a1fa079bfd73dde)(url);
        this.setUrls(urls);
    };
    /**
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */ UrlTile.prototype.setUrls = function setUrls(urls) {
        this.urls = urls;
        var key = urls.join("\n");
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $847880a03aa9cac5$export$436f44dbcc31fea3)(urls, this.tileGrid), key);
        else this.setKey(key);
    };
    /**
   * @inheritDoc
   */ UrlTile.prototype.useTile = function useTile(z, x, y) {
        var tileCoordKey = (0, $321b949bcc451ffb$export$92d0df0f1d25c63c)(z, x, y);
        if (this.tileCache.containsKey(tileCoordKey)) this.tileCache.get(tileCoordKey);
    };
    return UrlTile;
}((0, $5386d6ea3128b160$export$2e2bcd8739ae039));
var $717890273ec27e1e$export$2e2bcd8739ae039 = $717890273ec27e1e$var$UrlTile;




/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize=2048] Cache size.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
 * access pixel data with the Canvas renderer.  See
 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [opaque=true] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} projection Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./State.js").default} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get tile URL given a tile coordinate and the projection.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 */ /**
 * @classdesc
 * Base class for sources providing images divided into a tile grid.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ var $1df042038de9d51b$var$TileImage = /*@__PURE__*/ function(UrlTile) {
    function TileImage(options) {
        UrlTile.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $1df042038de9d51b$var$defaultTileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible
        });
        /**
     * @protected
     * @type {?string}
     */ this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @protected
     * @type {typeof ImageTile}
     */ this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $50fe57b595b18ff9$export$2e2bcd8739ae039);
        /**
     * @protected
     * @type {!Object<string, TileCache>}
     */ this.tileCacheForProjection = {};
        /**
     * @protected
     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGridForProjection = {};
        /**
     * @private
     * @type {number|undefined}
     */ this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
     * @private
     * @type {boolean}
     */ this.renderReprojectionEdges_ = false;
    }
    if (UrlTile) TileImage.__proto__ = UrlTile;
    TileImage.prototype = Object.create(UrlTile && UrlTile.prototype);
    TileImage.prototype.constructor = TileImage;
    /**
   * @inheritDoc
   */ TileImage.prototype.canExpireCache = function canExpireCache() {
        if (!(0, $7b3aa4a24649670e$export$584433cc24140052)) return UrlTile.prototype.canExpireCache.call(this);
        if (this.tileCache.canExpireCache()) return true;
        else for(var key in this.tileCacheForProjection){
            if (this.tileCacheForProjection[key].canExpireCache()) return true;
        }
        return false;
    };
    /**
   * @inheritDoc
   */ TileImage.prototype.expireCache = function expireCache(projection, usedTiles) {
        if (!(0, $7b3aa4a24649670e$export$584433cc24140052)) {
            UrlTile.prototype.expireCache.call(this, projection, usedTiles);
            return;
        }
        var usedTileCache = this.getTileCacheForProjection(projection);
        this.tileCache.expireCache(this.tileCache == usedTileCache ? usedTiles : {});
        for(var id in this.tileCacheForProjection){
            var tileCache = this.tileCacheForProjection[id];
            tileCache.expireCache(tileCache == usedTileCache ? usedTiles : {});
        }
    };
    /**
   * @inheritDoc
   */ TileImage.prototype.getGutterForProjection = function getGutterForProjection(projection) {
        if ((0, $7b3aa4a24649670e$export$584433cc24140052) && this.getProjection() && projection && !(0, $92f1443438429e81$export$fe091d73a555748b)(this.getProjection(), projection)) return 0;
        else return this.getGutter();
    };
    /**
   * @return {number} Gutter.
   */ TileImage.prototype.getGutter = function getGutter() {
        return 0;
    };
    /**
   * @inheritDoc
   */ TileImage.prototype.getOpaque = function getOpaque(projection) {
        if ((0, $7b3aa4a24649670e$export$584433cc24140052) && this.getProjection() && projection && !(0, $92f1443438429e81$export$fe091d73a555748b)(this.getProjection(), projection)) return false;
        else return UrlTile.prototype.getOpaque.call(this, projection);
    };
    /**
   * @inheritDoc
   */ TileImage.prototype.getTileGridForProjection = function getTileGridForProjection$1(projection) {
        if (!(0, $7b3aa4a24649670e$export$584433cc24140052)) return UrlTile.prototype.getTileGridForProjection.call(this, projection);
        var thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, $92f1443438429e81$export$fe091d73a555748b)(thisProj, projection))) return this.tileGrid;
        else {
            var projKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(projection);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $a46307816b1ae884$export$1f4812384df8a9c5)(projection);
            return /** @type {!import("../tilegrid/TileGrid.js").default} */ this.tileGridForProjection[projKey];
        }
    };
    /**
   * @inheritDoc
   */ TileImage.prototype.getTileCacheForProjection = function getTileCacheForProjection(projection) {
        if (!(0, $7b3aa4a24649670e$export$584433cc24140052)) return UrlTile.prototype.getTileCacheForProjection.call(this, projection);
        var thisProj = this.getProjection();
        if (!thisProj || (0, $92f1443438429e81$export$fe091d73a555748b)(thisProj, projection)) return this.tileCache;
        else {
            var projKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(projection);
            if (!(projKey in this.tileCacheForProjection)) this.tileCacheForProjection[projKey] = new (0, $764d10c51058d078$export$2e2bcd8739ae039)(this.tileCache.highWaterMark);
            return this.tileCacheForProjection[projKey];
        }
    };
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!import("../Tile.js").default} Tile.
   * @private
   */ TileImage.prototype.createTile_ = function createTile_(z, x, y, pixelRatio, projection, key) {
        var tileCoord = [
            z,
            x,
            y
        ];
        var urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        var tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        var tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE : (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY, tileUrl !== undefined ? tileUrl : "", this.crossOrigin, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(tile, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleTileChange, this);
        return tile;
    };
    /**
   * @inheritDoc
   */ TileImage.prototype.getTile = function getTile(z, x, y, pixelRatio, projection) {
        var sourceProjection = /** @type {!import("../proj/Projection.js").default} */ this.getProjection();
        if (!(0, $7b3aa4a24649670e$export$584433cc24140052) || !sourceProjection || !projection || (0, $92f1443438429e81$export$fe091d73a555748b)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        else {
            var cache = this.getTileCacheForProjection(projection);
            var tileCoord = [
                z,
                x,
                y
            ];
            var tile;
            var tileCoordKey = (0, $321b949bcc451ffb$export$a47fb462a08de82f)(tileCoord);
            if (cache.containsKey(tileCoordKey)) tile = /** @type {!import("../Tile.js").default} */ cache.get(tileCoordKey);
            var key = this.getKey();
            if (tile && tile.key == key) return tile;
            else {
                var sourceTileGrid = this.getTileGridForProjection(sourceProjection);
                var targetTileGrid = this.getTileGridForProjection(projection);
                var wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
                var newTile = new (0, $c8ca3105da7720d1$export$2e2bcd8739ae039)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (function(z, x, y, pixelRatio) {
                    return this.getTileInternal(z, x, y, pixelRatio, sourceProjection);
                }).bind(this), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_);
                newTile.key = key;
                if (tile) {
                    newTile.interimTile = tile;
                    newTile.refreshInterimChain();
                    cache.replace(tileCoordKey, newTile);
                } else cache.set(tileCoordKey, newTile);
                return newTile;
            }
        }
    };
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../Tile.js").default} Tile.
   * @protected
   */ TileImage.prototype.getTileInternal = function getTileInternal(z, x, y, pixelRatio, projection) {
        var tile = null;
        var tileCoordKey = (0, $321b949bcc451ffb$export$92d0df0f1d25c63c)(z, x, y);
        var key = this.getKey();
        if (!this.tileCache.containsKey(tileCoordKey)) {
            tile = this.createTile_(z, x, y, pixelRatio, projection, key);
            this.tileCache.set(tileCoordKey, tile);
        } else {
            tile = this.tileCache.get(tileCoordKey);
            if (tile.key != key) {
                // The source's params changed. If the tile has an interim tile and if we
                // can use it then we use it. Otherwise we create a new tile.  In both
                // cases we attempt to assign an interim tile to the new tile.
                var interimTile = tile;
                tile = this.createTile_(z, x, y, pixelRatio, projection, key);
                //make the new tile the head of the list,
                if (interimTile.getState() == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE) //the old tile hasn't begun loading yet, and is now outdated, so we can simply discard it
                tile.interimTile = interimTile.interimTile;
                else tile.interimTile = interimTile;
                tile.refreshInterimChain();
                this.tileCache.replace(tileCoordKey, tile);
            }
        }
        return tile;
    };
    /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */ TileImage.prototype.setRenderReprojectionEdges = function setRenderReprojectionEdges(render) {
        if (!(0, $7b3aa4a24649670e$export$584433cc24140052) || this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        for(var id in this.tileCacheForProjection)this.tileCacheForProjection[id].clear();
        this.changed();
    };
    /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */ TileImage.prototype.setTileGridForProjection = function setTileGridForProjection(projection, tilegrid) {
        if (0, $7b3aa4a24649670e$export$584433cc24140052) {
            var proj = (0, $92f1443438429e81$export$3988ae62b71be9a3)(projection);
            if (proj) {
                var projKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(proj);
                if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
            }
        }
    };
    return TileImage;
}((0, $717890273ec27e1e$export$2e2bcd8739ae039));
/**
 * @param {ImageTile} imageTile Image tile.
 * @param {string} src Source.
 */ function $1df042038de9d51b$var$defaultTileLoadFunction(imageTile, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $1df042038de9d51b$export$2e2bcd8739ae039 = $1df042038de9d51b$var$TileImage;



/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize=2048] Cache size.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
 * access pixel data with the Canvas renderer.  See
 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [opaque=true] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=18] Optional max zoom level.
 * @property {number} [minZoom=0] Optional min zoom level.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get
 * tile URL given a tile coordinate and the projection.
 * Required if url or urls are not provided.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 */ /**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case,
 * {@link module:ol/source/TileImage} can be used with a `tileUrlFunction`
 * such as:
 *
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *        coordinate[1] + '/' + coordinate[2] + '.png';
 *    }
 *
 * @api
 */ var $53940888677ee56a$var$XYZ = /*@__PURE__*/ function(TileImage) {
    function XYZ(opt_options) {
        var options = opt_options || {};
        var projection = options.projection !== undefined ? options.projection : "EPSG:3857";
        var tileGrid = options.tileGrid !== undefined ? options.tileGrid : (0, $a46307816b1ae884$export$38500bbeccc864ff)({
            extent: (0, $a46307816b1ae884$export$7b5b6ef8fd55fac4)(projection),
            maxZoom: options.maxZoom,
            minZoom: options.minZoom,
            tileSize: options.tileSize
        });
        TileImage.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            opaque: options.opaque,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible
        });
    }
    if (TileImage) XYZ.__proto__ = TileImage;
    XYZ.prototype = Object.create(TileImage && TileImage.prototype);
    XYZ.prototype.constructor = XYZ;
    return XYZ;
}((0, $1df042038de9d51b$export$2e2bcd8739ae039));
var $53940888677ee56a$export$2e2bcd8739ae039 = $53940888677ee56a$var$XYZ;


var $d978548adde0e5c6$export$4de8a5e77eb994ad = '&#169; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors.';
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize=2048] Cache size.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
 * access pixel data with the Canvas renderer.  See
 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {number} [maxZoom=19] Max zoom.
 * @property {boolean} [opaque=true] Whether the layer is opaque.
 * @property {number} [reprojectionErrorThreshold=1.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {string} [url='https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 */ /**
 * @classdesc
 * Layer source for the OpenStreetMap tile server.
 * @api
 */ var $d978548adde0e5c6$var$OSM = /*@__PURE__*/ function(XYZ) {
    function OSM(opt_options) {
        var options = opt_options || {};
        var attributions;
        if (options.attributions !== undefined) attributions = options.attributions;
        else attributions = [
            $d978548adde0e5c6$export$4de8a5e77eb994ad
        ];
        var crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : "anonymous";
        var url = options.url !== undefined ? options.url : "https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        XYZ.call(this, {
            attributions: attributions,
            cacheSize: options.cacheSize,
            crossOrigin: crossOrigin,
            opaque: options.opaque !== undefined ? options.opaque : true,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            url: url,
            wrapX: options.wrapX,
            attributionsCollapsible: false
        });
    }
    if (XYZ) OSM.__proto__ = XYZ;
    OSM.prototype = Object.create(XYZ && XYZ.prototype);
    OSM.prototype.constructor = OSM;
    return OSM;
}((0, $53940888677ee56a$export$2e2bcd8739ae039));
var $d978548adde0e5c6$export$2e2bcd8739ae039 = $d978548adde0e5c6$var$OSM;





/**
 * @module ol/control/FullScreen
 */ 




/**
 * @return {string} Change type.
 */ var $e3ab01f0a01d866a$var$getChangeType = function() {
    var changeType;
    return function() {
        if (!changeType) {
            var body = document.body;
            if (body.webkitRequestFullscreen) changeType = "webkitfullscreenchange";
            else if (body.mozRequestFullScreen) changeType = "mozfullscreenchange";
            else if (body.msRequestFullscreen) changeType = "MSFullscreenChange";
            else if (body.requestFullscreen) changeType = "fullscreenchange";
        }
        return changeType;
    };
}();
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-full-screen'] CSS class name.
 * @property {string|Text} [label='\u2922'] Text label to use for the button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|Text} [labelActive='\u00d7'] Text label to use for the
 * button when full-screen is active.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Toggle full-screen'] Text label to use for the button tip.
 * @property {boolean} [keys=false] Full keyboard access.
 * @property {HTMLElement|string} [target] Specify a target if you want the
 * control to be rendered outside of the map's viewport.
 * @property {HTMLElement|string} [source] The element to be displayed
 * fullscreen. When not provided, the element containing the map viewport will
 * be displayed fullscreen.
 */ /**
 * @classdesc
 * Provides a button that when clicked fills up the full screen with the map.
 * The full screen source element is by default the element containing the map viewport unless
 * overridden by providing the `source` option. In which case, the dom
 * element introduced using this parameter will be displayed in full screen.
 *
 * When in full screen mode, a close button is shown to exit full screen mode.
 * The [Fullscreen API](http://www.w3.org/TR/fullscreen/) is used to
 * toggle the map in full screen mode.
 *
 * @api
 */ var $e3ab01f0a01d866a$var$FullScreen = /*@__PURE__*/ function(Control) {
    function FullScreen(opt_options) {
        var options = opt_options ? opt_options : {};
        Control.call(this, {
            element: document.createElement("div"),
            target: options.target
        });
        /**
     * @private
     * @type {string}
     */ this.cssClassName_ = options.className !== undefined ? options.className : "ol-full-screen";
        var label = options.label !== undefined ? options.label : "\u2922";
        /**
     * @private
     * @type {Text}
     */ this.labelNode_ = typeof label === "string" ? document.createTextNode(label) : label;
        var labelActive = options.labelActive !== undefined ? options.labelActive : "\xd7";
        /**
     * @private
     * @type {Text}
     */ this.labelActiveNode_ = typeof labelActive === "string" ? document.createTextNode(labelActive) : labelActive;
        /**
     * @private
     * @type {HTMLElement}
     */ this.button_ = document.createElement("button");
        var tipLabel = options.tipLabel ? options.tipLabel : "Toggle full-screen";
        this.setClassName_(this.button_, $e3ab01f0a01d866a$var$isFullScreen());
        this.button_.setAttribute("type", "button");
        this.button_.title = tipLabel;
        this.button_.appendChild(this.labelNode_);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.button_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLICK, this.handleClick_, this);
        var cssClasses = this.cssClassName_ + " " + (0, $bbcb4c1977b6e9f0$export$1afde3d6e16a7b29) + " " + (0, $bbcb4c1977b6e9f0$export$4d4f8be70b656192) + " " + (!$e3ab01f0a01d866a$var$isFullScreenSupported() ? (0, $bbcb4c1977b6e9f0$export$68eede0dd8c6c1da) : "");
        var element = this.element;
        element.className = cssClasses;
        element.appendChild(this.button_);
        /**
     * @private
     * @type {boolean}
     */ this.keys_ = options.keys !== undefined ? options.keys : false;
        /**
     * @private
     * @type {HTMLElement|string|undefined}
     */ this.source_ = options.source;
    }
    if (Control) FullScreen.__proto__ = Control;
    FullScreen.prototype = Object.create(Control && Control.prototype);
    FullScreen.prototype.constructor = FullScreen;
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ FullScreen.prototype.handleClick_ = function handleClick_(event) {
        event.preventDefault();
        this.handleFullScreen_();
    };
    /**
   * @private
   */ FullScreen.prototype.handleFullScreen_ = function handleFullScreen_() {
        if (!$e3ab01f0a01d866a$var$isFullScreenSupported()) return;
        var map = this.getMap();
        if (!map) return;
        if ($e3ab01f0a01d866a$var$isFullScreen()) $e3ab01f0a01d866a$var$exitFullScreen();
        else {
            var element;
            if (this.source_) element = typeof this.source_ === "string" ? document.getElementById(this.source_) : this.source_;
            else element = map.getTargetElement();
            if (this.keys_) $e3ab01f0a01d866a$var$requestFullScreenWithKeys(element);
            else $e3ab01f0a01d866a$var$requestFullScreen(element);
        }
    };
    /**
   * @private
   */ FullScreen.prototype.handleFullScreenChange_ = function handleFullScreenChange_() {
        var map = this.getMap();
        if ($e3ab01f0a01d866a$var$isFullScreen()) {
            this.setClassName_(this.button_, true);
            (0, $755a3001f896bcf1$export$5542201de9311ab2)(this.labelActiveNode_, this.labelNode_);
        } else {
            this.setClassName_(this.button_, false);
            (0, $755a3001f896bcf1$export$5542201de9311ab2)(this.labelNode_, this.labelActiveNode_);
        }
        if (map) map.updateSize();
    };
    /**
   * @param {HTMLElement} element Target element
   * @param {boolean} fullscreen True if fullscreen class name should be active
   * @private
   */ FullScreen.prototype.setClassName_ = function setClassName_(element, fullscreen) {
        var activeClassName = this.cssClassName_ + "-true";
        var inactiveClassName = this.cssClassName_ + "-false";
        var nextClassName = fullscreen ? activeClassName : inactiveClassName;
        element.classList.remove(activeClassName);
        element.classList.remove(inactiveClassName);
        element.classList.add(nextClassName);
    };
    /**
   * @inheritDoc
   * @api
   */ FullScreen.prototype.setMap = function setMap(map) {
        Control.prototype.setMap.call(this, map);
        if (map) this.listenerKeys.push((0, $37a5c0af9052e360$export$63174c828edd6ff8)(document, $e3ab01f0a01d866a$var$getChangeType(), this.handleFullScreenChange_, this));
    };
    return FullScreen;
}((0, $ef003b45d4724b43$export$2e2bcd8739ae039));
/**
 * @return {boolean} Fullscreen is supported by the current platform.
 */ function $e3ab01f0a01d866a$var$isFullScreenSupported() {
    var body = document.body;
    return !!(body.webkitRequestFullscreen || body.mozRequestFullScreen && document.mozFullScreenEnabled || body.msRequestFullscreen && document.msFullscreenEnabled || body.requestFullscreen && document.fullscreenEnabled);
}
/**
 * @return {boolean} Element is currently in fullscreen.
 */ function $e3ab01f0a01d866a$var$isFullScreen() {
    return !!(document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
}
/**
 * Request to fullscreen an element.
 * @param {HTMLElement} element Element to request fullscreen
 */ function $e3ab01f0a01d866a$var$requestFullScreen(element) {
    if (element.requestFullscreen) element.requestFullscreen();
    else if (element.msRequestFullscreen) element.msRequestFullscreen();
    else if (element.mozRequestFullScreen) element.mozRequestFullScreen();
    else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen();
}
/**
 * Request to fullscreen an element with keyboard input.
 * @param {HTMLElement} element Element to request fullscreen
 */ function $e3ab01f0a01d866a$var$requestFullScreenWithKeys(element) {
    if (element.mozRequestFullScreenWithKeys) element.mozRequestFullScreenWithKeys();
    else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen();
    else $e3ab01f0a01d866a$var$requestFullScreen(element);
}
/**
 * Exit fullscreen.
 */ function $e3ab01f0a01d866a$var$exitFullScreen() {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.msExitFullscreen) document.msExitFullscreen();
    else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
}
var $e3ab01f0a01d866a$export$2e2bcd8739ae039 = $e3ab01f0a01d866a$var$FullScreen;




var $cc12fb92b6cb9cf8$var$nm = $c45303ef5b6fbfc7$exports.default("olHelpers");
var $6262b9769c5759db$exports = {};
"use strict";
Object.defineProperty($6262b9769c5759db$exports, "__esModule", {
    value: true
});
$6262b9769c5759db$exports.addSearch = void 0;
/**
 * @module ol/layer/Vector
 */ 



/**
 * @module ol/style/Style
 */ /**
 * Feature styles.
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Fill, Stroke, Circle, Style} from 'ol/style';
 *
 *  var fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)'
 *  });
 *  var stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25
 *  });
 *  var styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5
 *      }),
 *      fill: fill,
 *      stroke: stroke
 *    })
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Fill, Stroke, Circle, Style} from 'ol/style';
 *  import GeometryType from 'ol/geom/GeometryType';
 *
 *  var white = [255, 255, 255, 1];
 *  var blue = [0, 153, 255, 1];
 *  var width = 3;
 *  styles[GeometryType.POLYGON] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5]
 *      })
 *    })
 *  ];
 *  styles[GeometryType.MULTI_POLYGON] =
 *      styles[GeometryType.POLYGON];
 *  styles[GeometryType.LINE_STRING] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2
 *      })
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width
 *      })
 *    })
 *  ];
 *  styles[GeometryType.MULTI_LINE_STRING] =
 *      styles[GeometryType.LINE_STRING];
 *  styles[GeometryType.POINT] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2
 *        })
 *      }),
 *      zIndex: Infinity
 *    })
 *  ];
 *  styles[GeometryType.MULTI_POINT] =
 *      styles[GeometryType.POINT];
 *  styles[GeometryType.GEOMETRY_COLLECTION] =
 *      styles[GeometryType.POLYGON].concat(
 *          styles[GeometryType.LINE_STRING],
 *          styles[GeometryType.POINT]
 *      );
 * ```
 */ 

/**
 * @module ol/style/Circle
 */ /**
 * @module ol/style/RegularShape
 */ 





/**
 * @module ol/style/Image
 */ 
/**
 * @typedef {Object} Options
 * @property {number} opacity
 * @property {boolean} rotateWithView
 * @property {number} rotation
 * @property {number} scale
 */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ var $982c1d3baf3da6dc$var$ImageStyle = function ImageStyle(options) {
    /**
   * @private
   * @type {number}
   */ this.opacity_ = options.opacity;
    /**
   * @private
   * @type {boolean}
   */ this.rotateWithView_ = options.rotateWithView;
    /**
   * @private
   * @type {number}
   */ this.rotation_ = options.rotation;
    /**
   * @private
   * @type {number}
   */ this.scale_ = options.scale;
};
/**
 * Clones the style.
 * @return {ImageStyle} The cloned style.
 * @api
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.clone = function clone() {
    return new $982c1d3baf3da6dc$var$ImageStyle({
        opacity: this.getOpacity(),
        scale: this.getScale(),
        rotation: this.getRotation(),
        rotateWithView: this.getRotateWithView()
    });
};
/**
 * Get the symbolizer opacity.
 * @return {number} Opacity.
 * @api
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getOpacity = function getOpacity() {
    return this.opacity_;
};
/**
 * Determine whether the symbolizer rotates with the map.
 * @return {boolean} Rotate with map.
 * @api
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getRotateWithView = function getRotateWithView() {
    return this.rotateWithView_;
};
/**
 * Get the symoblizer rotation.
 * @return {number} Rotation.
 * @api
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getRotation = function getRotation() {
    return this.rotation_;
};
/**
 * Get the symbolizer scale.
 * @return {number} Scale.
 * @api
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getScale = function getScale() {
    return this.scale_;
};
/**
 * This method is deprecated and always returns false.
 * @return {boolean} false.
 * @deprecated
 * @api
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getSnapToPixel = function getSnapToPixel() {
    return false;
};
/**
 * Get the anchor point in pixels. The anchor determines the center point for the
 * symbolizer.
 * @abstract
 * @return {Array<number>} Anchor.
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getAnchor = function getAnchor() {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * Get the image element for the symbolizer.
 * @abstract
 * @param {number} pixelRatio Pixel ratio.
 * @return {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} Image element.
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getImage = function getImage(pixelRatio) {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * @abstract
 * @param {number} pixelRatio Pixel ratio.
 * @return {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} Image element.
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getHitDetectionImage = function getHitDetectionImage(pixelRatio) {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * @abstract
 * @return {import("../ImageState.js").default} Image state.
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getImageState = function getImageState() {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * @abstract
 * @return {import("../size.js").Size} Image size.
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getImageSize = function getImageSize() {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * @abstract
 * @return {import("../size.js").Size} Size of the hit-detection image.
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getHitDetectionImageSize = function getHitDetectionImageSize() {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * Get the origin of the symbolizer.
 * @abstract
 * @return {Array<number>} Origin.
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getOrigin = function getOrigin() {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * Get the size of the symbolizer (in pixels).
 * @abstract
 * @return {import("../size.js").Size} Size.
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.getSize = function getSize() {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * Set the opacity.
 *
 * @param {number} opacity Opacity.
 * @api
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.setOpacity = function setOpacity(opacity) {
    this.opacity_ = opacity;
};
/**
 * Set whether to rotate the style with the view.
 *
 * @param {boolean} rotateWithView Rotate with map.
 * @api
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.setRotateWithView = function setRotateWithView(rotateWithView) {
    this.rotateWithView_ = rotateWithView;
};
/**
 * Set the rotation.
 *
 * @param {number} rotation Rotation.
 * @api
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.setRotation = function setRotation(rotation) {
    this.rotation_ = rotation;
};
/**
 * Set the scale.
 *
 * @param {number} scale Scale.
 * @api
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.setScale = function setScale(scale) {
    this.scale_ = scale;
};
/**
 * This method is deprecated and does nothing.
 * @param {boolean} snapToPixel Snap to pixel?
 * @deprecated
 * @api
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.setSnapToPixel = function setSnapToPixel(snapToPixel) {};
/**
 * @abstract
 * @param {function(this: T, import("../events/Event.js").default)} listener Listener function.
 * @param {T} thisArg Value to use as `this` when executing `listener`.
 * @return {import("../events.js").EventsKey|undefined} Listener key.
 * @template T
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.listenImageChange = function listenImageChange(listener, thisArg) {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * Load not yet loaded URI.
 * @abstract
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.load = function load() {
    (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * @abstract
 * @param {function(this: T, import("../events/Event.js").default)} listener Listener function.
 * @param {T} thisArg Value to use as `this` when executing `listener`.
 * @template T
 */ $982c1d3baf3da6dc$var$ImageStyle.prototype.unlistenImageChange = function unlistenImageChange(listener, thisArg) {
    (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
var $982c1d3baf3da6dc$export$2e2bcd8739ae039 = $982c1d3baf3da6dc$var$ImageStyle;


/**
 * Specify radius for regular polygons, or radius1 and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} [radius] Radius of a regular polygon.
 * @property {number} [radius1] Outer radius of a star.
 * @property {number} [radius2] Inner radius of a star.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's point facing up.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {import("./AtlasManager.js").default} [atlasManager] The atlas manager to use for this symbol. When
 * using WebGL it is recommended to use an atlas manager to avoid texture switching. If an atlas manager is given, the
 * symbol is added to an atlas. By default no atlas manager is used.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike} [strokeStyle]
 * @property {number} strokeWidth
 * @property {number} size
 * @property {string} lineCap
 * @property {Array<number>} lineDash
 * @property {number} lineDashOffset
 * @property {string} lineJoin
 * @property {number} miterLimit
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when `radius1` and
 * `radius2` are provided.
 * @api
 */ var $02d7f73313b743b3$var$RegularShape = /*@__PURE__*/ function(ImageStyle) {
    function RegularShape(options) {
        /**
     * @type {boolean}
     */ var rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        ImageStyle.call(this, {
            opacity: 1,
            rotateWithView: rotateWithView,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: 1
        });
        /**
     * @private
     * @type {Array<string|number>}
     */ this.checksums_ = null;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.hitDetectionCanvas_ = null;
        /**
     * @private
     * @type {import("./Fill.js").default}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.points_ = options.points;
        /**
     * @protected
     * @type {number}
     */ this.radius_ = /** @type {number} */ options.radius !== undefined ? options.radius : options.radius1;
        /**
     * @private
     * @type {number|undefined}
     */ this.radius2_ = options.radius2;
        /**
     * @private
     * @type {number}
     */ this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
     * @private
     * @type {import("./Stroke.js").default}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {Array<number>}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.imageSize_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.hitDetectionImageSize_ = null;
        /**
     * @protected
     * @type {import("./AtlasManager.js").default|undefined}
     */ this.atlasManager_ = options.atlasManager;
        this.render_(this.atlasManager_);
    }
    if (ImageStyle) RegularShape.__proto__ = ImageStyle;
    RegularShape.prototype = Object.create(ImageStyle && ImageStyle.prototype);
    RegularShape.prototype.constructor = RegularShape;
    /**
   * Clones the style. If an atlasmanager was provided to the original style it will be used in the cloned style, too.
   * @return {RegularShape} The cloned style.
   * @api
   */ RegularShape.prototype.clone = function clone() {
        var style = new RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            atlasManager: this.atlasManager_
        });
        style.setOpacity(this.getOpacity());
        style.setScale(this.getScale());
        return style;
    };
    /**
   * @inheritDoc
   * @api
   */ RegularShape.prototype.getAnchor = function getAnchor() {
        return this.anchor_;
    };
    /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */ RegularShape.prototype.getAngle = function getAngle() {
        return this.angle_;
    };
    /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default} Fill style.
   * @api
   */ RegularShape.prototype.getFill = function getFill() {
        return this.fill_;
    };
    /**
   * @inheritDoc
   */ RegularShape.prototype.getHitDetectionImage = function getHitDetectionImage(pixelRatio) {
        return this.hitDetectionCanvas_;
    };
    /**
   * @inheritDoc
   * @api
   */ RegularShape.prototype.getImage = function getImage(pixelRatio) {
        return this.canvas_;
    };
    /**
   * @inheritDoc
   */ RegularShape.prototype.getImageSize = function getImageSize() {
        return this.imageSize_;
    };
    /**
   * @inheritDoc
   */ RegularShape.prototype.getHitDetectionImageSize = function getHitDetectionImageSize() {
        return this.hitDetectionImageSize_;
    };
    /**
   * @inheritDoc
   */ RegularShape.prototype.getImageState = function getImageState() {
        return (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED;
    };
    /**
   * @inheritDoc
   * @api
   */ RegularShape.prototype.getOrigin = function getOrigin() {
        return this.origin_;
    };
    /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */ RegularShape.prototype.getPoints = function getPoints() {
        return this.points_;
    };
    /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */ RegularShape.prototype.getRadius = function getRadius() {
        return this.radius_;
    };
    /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */ RegularShape.prototype.getRadius2 = function getRadius2() {
        return this.radius2_;
    };
    /**
   * @inheritDoc
   * @api
   */ RegularShape.prototype.getSize = function getSize() {
        return this.size_;
    };
    /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default} Stroke style.
   * @api
   */ RegularShape.prototype.getStroke = function getStroke() {
        return this.stroke_;
    };
    /**
   * @inheritDoc
   */ RegularShape.prototype.listenImageChange = function listenImageChange(listener, thisArg) {
        return undefined;
    };
    /**
   * @inheritDoc
   */ RegularShape.prototype.load = function load() {};
    /**
   * @inheritDoc
   */ RegularShape.prototype.unlistenImageChange = function unlistenImageChange(listener, thisArg) {};
    /**
   * @protected
   * @param {import("./AtlasManager.js").default|undefined} atlasManager An atlas manager.
   */ RegularShape.prototype.render_ = function render_(atlasManager) {
        var imageSize;
        var lineCap = "";
        var lineJoin = "";
        var miterLimit = 0;
        var lineDash = null;
        var lineDashOffset = 0;
        var strokeStyle;
        var strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = this.stroke_.getColor();
            if (strokeStyle === null) strokeStyle = (0, $c8f894129d9fa0b9$export$1eb2eaecacf2031e);
            strokeStyle = (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(strokeStyle);
            strokeWidth = this.stroke_.getWidth();
            if (strokeWidth === undefined) strokeWidth = (0, $c8f894129d9fa0b9$export$79661f132c62010e);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset();
            if (!(0, $89969764a1196844$export$c986c2374f97af1a)) {
                lineDash = null;
                lineDashOffset = 0;
            }
            lineJoin = this.stroke_.getLineJoin();
            if (lineJoin === undefined) lineJoin = (0, $c8f894129d9fa0b9$export$365eb9648cf19bd0);
            lineCap = this.stroke_.getLineCap();
            if (lineCap === undefined) lineCap = (0, $c8f894129d9fa0b9$export$17bd0c38d6ae694e);
            miterLimit = this.stroke_.getMiterLimit();
            if (miterLimit === undefined) miterLimit = (0, $c8f894129d9fa0b9$export$80c1c01844597b7b);
        }
        var size = 2 * (this.radius_ + strokeWidth) + 1;
        /** @type {RenderOptions} */ var renderOptions = {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
        if (atlasManager === undefined) {
            // no atlas manager is used, create a new canvas
            var context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(size, size);
            this.canvas_ = context.canvas;
            // canvas.width and height are rounded to the closest integer
            size = this.canvas_.width;
            imageSize = size;
            this.draw_(renderOptions, context, 0, 0);
            this.createHitDetectionCanvas_(renderOptions);
        } else {
            // an atlas manager is used, add the symbol to an atlas
            size = Math.round(size);
            var hasCustomHitDetectionImage = !this.fill_;
            var renderHitDetectionCallback;
            if (hasCustomHitDetectionImage) // render the hit-detection image into a separate atlas image
            renderHitDetectionCallback = this.drawHitDetectionCanvas_.bind(this, renderOptions);
            var id = this.getChecksum();
            var info = atlasManager.add(id, size, size, this.draw_.bind(this, renderOptions), renderHitDetectionCallback);
            this.canvas_ = info.image;
            this.origin_ = [
                info.offsetX,
                info.offsetY
            ];
            imageSize = info.image.width;
            if (hasCustomHitDetectionImage) {
                this.hitDetectionCanvas_ = info.hitImage;
                this.hitDetectionImageSize_ = [
                    info.hitImage.width,
                    info.hitImage.height
                ];
            } else {
                this.hitDetectionCanvas_ = this.canvas_;
                this.hitDetectionImageSize_ = [
                    imageSize,
                    imageSize
                ];
            }
        }
        this.anchor_ = [
            size / 2,
            size / 2
        ];
        this.size_ = [
            size,
            size
        ];
        this.imageSize_ = [
            imageSize,
            imageSize
        ];
    };
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The rendering context.
   * @param {number} x The origin for the symbol (x).
   * @param {number} y The origin for the symbol (y).
   */ RegularShape.prototype.draw_ = function draw_(renderOptions, context, x, y) {
        var i, angle0, radiusC;
        // reset transform
        context.setTransform(1, 0, 0, 1, 0, 0);
        // then move to (x, y)
        context.translate(x, y);
        context.beginPath();
        var points = this.points_;
        if (points === Infinity) context.arc(renderOptions.size / 2, renderOptions.size / 2, this.radius_, 0, 2 * Math.PI, true);
        else {
            var radius2 = this.radius2_ !== undefined ? this.radius2_ : this.radius_;
            if (radius2 !== this.radius_) points = 2 * points;
            for(i = 0; i <= points; i++){
                angle0 = i * 2 * Math.PI / points - Math.PI / 2 + this.angle_;
                radiusC = i % 2 === 0 ? this.radius_ : radius2;
                context.lineTo(renderOptions.size / 2 + radiusC * Math.cos(angle0), renderOptions.size / 2 + radiusC * Math.sin(angle0));
            }
        }
        if (this.fill_) {
            var color = this.fill_.getColor();
            if (color === null) color = (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2);
            context.fillStyle = (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(color);
            context.fill();
        }
        if (this.stroke_) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = /** @type {CanvasLineCap} */ renderOptions.lineCap;
            context.lineJoin = /** @type {CanvasLineJoin} */ renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
        context.closePath();
    };
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   */ RegularShape.prototype.createHitDetectionCanvas_ = function createHitDetectionCanvas_(renderOptions) {
        this.hitDetectionImageSize_ = [
            renderOptions.size,
            renderOptions.size
        ];
        if (this.fill_) {
            this.hitDetectionCanvas_ = this.canvas_;
            return;
        }
        // if no fill style is set, create an extra hit-detection image with a
        // default fill style
        var context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(renderOptions.size, renderOptions.size);
        this.hitDetectionCanvas_ = context.canvas;
        this.drawHitDetectionCanvas_(renderOptions, context, 0, 0);
    };
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The context.
   * @param {number} x The origin for the symbol (x).
   * @param {number} y The origin for the symbol (y).
   */ RegularShape.prototype.drawHitDetectionCanvas_ = function drawHitDetectionCanvas_(renderOptions, context, x, y) {
        // reset transform
        context.setTransform(1, 0, 0, 1, 0, 0);
        // then move to (x, y)
        context.translate(x, y);
        context.beginPath();
        var points = this.points_;
        if (points === Infinity) context.arc(renderOptions.size / 2, renderOptions.size / 2, this.radius_, 0, 2 * Math.PI, true);
        else {
            var radius2 = this.radius2_ !== undefined ? this.radius2_ : this.radius_;
            if (radius2 !== this.radius_) points = 2 * points;
            var i, radiusC, angle0;
            for(i = 0; i <= points; i++){
                angle0 = i * 2 * Math.PI / points - Math.PI / 2 + this.angle_;
                radiusC = i % 2 === 0 ? this.radius_ : radius2;
                context.lineTo(renderOptions.size / 2 + radiusC * Math.cos(angle0), renderOptions.size / 2 + radiusC * Math.sin(angle0));
            }
        }
        context.fillStyle = (0, $2c17bfc916c8f689$export$590567be997858b6)((0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2));
        context.fill();
        if (this.stroke_) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.stroke();
        }
        context.closePath();
    };
    /**
   * @return {string} The checksum.
   */ RegularShape.prototype.getChecksum = function getChecksum() {
        var strokeChecksum = this.stroke_ ? this.stroke_.getChecksum() : "-";
        var fillChecksum = this.fill_ ? this.fill_.getChecksum() : "-";
        var recalculate = !this.checksums_ || strokeChecksum != this.checksums_[1] || fillChecksum != this.checksums_[2] || this.radius_ != this.checksums_[3] || this.radius2_ != this.checksums_[4] || this.angle_ != this.checksums_[5] || this.points_ != this.checksums_[6];
        if (recalculate) {
            var checksum = "r" + strokeChecksum + fillChecksum + (this.radius_ !== undefined ? this.radius_.toString() : "-") + (this.radius2_ !== undefined ? this.radius2_.toString() : "-") + (this.angle_ !== undefined ? this.angle_.toString() : "-") + (this.points_ !== undefined ? this.points_.toString() : "-");
            this.checksums_ = [
                checksum,
                strokeChecksum,
                fillChecksum,
                this.radius_,
                this.radius2_,
                this.angle_,
                this.points_
            ];
        }
        return /** @type {string} */ this.checksums_[0];
    };
    return RegularShape;
}((0, $982c1d3baf3da6dc$export$2e2bcd8739ae039));
var $02d7f73313b743b3$export$2e2bcd8739ae039 = $02d7f73313b743b3$var$RegularShape;


/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./AtlasManager.js").default} [atlasManager] The atlas manager to use for this circle.
 * When using WebGL it is recommended to use an atlas manager to avoid texture switching. If an atlas manager is given,
 * the circle is added to an atlas. By default no atlas manager is used.
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ var $e163d3c698de5692$var$CircleStyle = /*@__PURE__*/ function(RegularShape) {
    function CircleStyle(opt_options) {
        var options = opt_options || /** @type {Options} */ {};
        RegularShape.call(this, {
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            atlasManager: options.atlasManager
        });
    }
    if (RegularShape) CircleStyle.__proto__ = RegularShape;
    CircleStyle.prototype = Object.create(RegularShape && RegularShape.prototype);
    CircleStyle.prototype.constructor = CircleStyle;
    /**
  * Clones the style.  If an atlasmanager was provided to the original style it will be used in the cloned style, too.
  * @return {CircleStyle} The cloned style.
  * @override
  * @api
  */ CircleStyle.prototype.clone = function clone() {
        var style = new CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            atlasManager: this.atlasManager_
        });
        style.setOpacity(this.getOpacity());
        style.setScale(this.getScale());
        return style;
    };
    /**
  * Set the circle radius.
  *
  * @param {number} radius Circle radius.
  * @api
  */ CircleStyle.prototype.setRadius = function setRadius(radius) {
        this.radius_ = radius;
        this.render_(this.atlasManager_);
    };
    return CircleStyle;
}((0, $02d7f73313b743b3$export$2e2bcd8739ae039));
var $e163d3c698de5692$export$2e2bcd8739ae039 = $e163d3c698de5692$var$CircleStyle;


/**
 * @module ol/style/Fill
 */ 

/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ var $d6fd3e0b0360ea29$var$Fill = function Fill(opt_options) {
    var options = opt_options || {};
    /**
   * @private
   * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
   */ this.color_ = options.color !== undefined ? options.color : null;
    /**
   * @private
   * @type {string|undefined}
   */ this.checksum_ = undefined;
};
/**
 * Clones the style. The color is not cloned if it is an {@link module:ol/colorlike~ColorLike}.
 * @return {Fill} The cloned style.
 * @api
 */ $d6fd3e0b0360ea29$var$Fill.prototype.clone = function clone() {
    var color = this.getColor();
    return new $d6fd3e0b0360ea29$var$Fill({
        color: Array.isArray(color) ? color.slice() : color || undefined
    });
};
/**
 * Get the fill color.
 * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
 * @api
 */ $d6fd3e0b0360ea29$var$Fill.prototype.getColor = function getColor() {
    return this.color_;
};
/**
 * Set the color.
 *
 * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
 * @api
 */ $d6fd3e0b0360ea29$var$Fill.prototype.setColor = function setColor(color) {
    this.color_ = color;
    this.checksum_ = undefined;
};
/**
 * @return {string} The checksum.
 */ $d6fd3e0b0360ea29$var$Fill.prototype.getChecksum = function getChecksum() {
    if (this.checksum_ === undefined) {
        var color = this.color_;
        if (color) {
            if (Array.isArray(color) || typeof color == "string") this.checksum_ = "f" + (0, $2c17bfc916c8f689$export$590567be997858b6)(/** @type {import("../color.js").Color|string} */ color);
            else this.checksum_ = (0, $34772e91e89a736f$export$5e82334337e0f204)(this.color_);
        } else this.checksum_ = "f-";
    }
    return this.checksum_;
};
var $d6fd3e0b0360ea29$export$2e2bcd8739ae039 = $d6fd3e0b0360ea29$var$Fill;


/**
 * @module ol/style/Stroke
 */ 
/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {string} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {string} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `undefined` (no dash).
 * Please note that Internet Explorer 10 and lower do not support the `setLineDash` method on
 * the `CanvasRenderingContext2D` and therefore this option will have no visual effect in these browsers.
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ var $9ed46f4c9b041e5d$var$Stroke = function Stroke(opt_options) {
    var options = opt_options || {};
    /**
   * @private
   * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
   */ this.color_ = options.color !== undefined ? options.color : null;
    /**
   * @private
   * @type {string|undefined}
   */ this.lineCap_ = options.lineCap;
    /**
   * @private
   * @type {Array<number>}
   */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
    /**
   * @private
   * @type {number|undefined}
   */ this.lineDashOffset_ = options.lineDashOffset;
    /**
   * @private
   * @type {string|undefined}
   */ this.lineJoin_ = options.lineJoin;
    /**
   * @private
   * @type {number|undefined}
   */ this.miterLimit_ = options.miterLimit;
    /**
   * @private
   * @type {number|undefined}
   */ this.width_ = options.width;
    /**
   * @private
   * @type {string|undefined}
   */ this.checksum_ = undefined;
};
/**
 * Clones the style.
 * @return {Stroke} The cloned style.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.clone = function clone() {
    var color = this.getColor();
    return new $9ed46f4c9b041e5d$var$Stroke({
        color: Array.isArray(color) ? color.slice() : color || undefined,
        lineCap: this.getLineCap(),
        lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
        lineDashOffset: this.getLineDashOffset(),
        lineJoin: this.getLineJoin(),
        miterLimit: this.getMiterLimit(),
        width: this.getWidth()
    });
};
/**
 * Get the stroke color.
 * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.getColor = function getColor() {
    return this.color_;
};
/**
 * Get the line cap type for the stroke.
 * @return {string|undefined} Line cap.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.getLineCap = function getLineCap() {
    return this.lineCap_;
};
/**
 * Get the line dash style for the stroke.
 * @return {Array<number>} Line dash.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.getLineDash = function getLineDash() {
    return this.lineDash_;
};
/**
 * Get the line dash offset for the stroke.
 * @return {number|undefined} Line dash offset.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.getLineDashOffset = function getLineDashOffset() {
    return this.lineDashOffset_;
};
/**
 * Get the line join type for the stroke.
 * @return {string|undefined} Line join.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.getLineJoin = function getLineJoin() {
    return this.lineJoin_;
};
/**
 * Get the miter limit for the stroke.
 * @return {number|undefined} Miter limit.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.getMiterLimit = function getMiterLimit() {
    return this.miterLimit_;
};
/**
 * Get the stroke width.
 * @return {number|undefined} Width.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.getWidth = function getWidth() {
    return this.width_;
};
/**
 * Set the color.
 *
 * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.setColor = function setColor(color) {
    this.color_ = color;
    this.checksum_ = undefined;
};
/**
 * Set the line cap.
 *
 * @param {string|undefined} lineCap Line cap.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.setLineCap = function setLineCap(lineCap) {
    this.lineCap_ = lineCap;
    this.checksum_ = undefined;
};
/**
 * Set the line dash.
 *
 * Please note that Internet Explorer 10 and lower [do not support][mdn] the
 * `setLineDash` method on the `CanvasRenderingContext2D` and therefore this
 * property will have no visual effect in these browsers.
 *
 * [mdn]: https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility
 *
 * @param {Array<number>} lineDash Line dash.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.setLineDash = function setLineDash(lineDash) {
    this.lineDash_ = lineDash;
    this.checksum_ = undefined;
};
/**
 * Set the line dash offset.
 *
 * @param {number|undefined} lineDashOffset Line dash offset.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.setLineDashOffset = function setLineDashOffset(lineDashOffset) {
    this.lineDashOffset_ = lineDashOffset;
    this.checksum_ = undefined;
};
/**
 * Set the line join.
 *
 * @param {string|undefined} lineJoin Line join.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.setLineJoin = function setLineJoin(lineJoin) {
    this.lineJoin_ = lineJoin;
    this.checksum_ = undefined;
};
/**
 * Set the miter limit.
 *
 * @param {number|undefined} miterLimit Miter limit.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.setMiterLimit = function setMiterLimit(miterLimit) {
    this.miterLimit_ = miterLimit;
    this.checksum_ = undefined;
};
/**
 * Set the width.
 *
 * @param {number|undefined} width Width.
 * @api
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.setWidth = function setWidth(width) {
    this.width_ = width;
    this.checksum_ = undefined;
};
/**
 * @return {string} The checksum.
 */ $9ed46f4c9b041e5d$var$Stroke.prototype.getChecksum = function getChecksum() {
    if (this.checksum_ === undefined) {
        this.checksum_ = "s";
        if (this.color_) {
            if (typeof this.color_ === "string") this.checksum_ += this.color_;
            else this.checksum_ += (0, $34772e91e89a736f$export$5e82334337e0f204)(this.color_);
        } else this.checksum_ += "-";
        this.checksum_ += "," + (this.lineCap_ !== undefined ? this.lineCap_.toString() : "-") + "," + (this.lineDash_ ? this.lineDash_.toString() : "-") + "," + (this.lineDashOffset_ !== undefined ? this.lineDashOffset_ : "-") + "," + (this.lineJoin_ !== undefined ? this.lineJoin_ : "-") + "," + (this.miterLimit_ !== undefined ? this.miterLimit_.toString() : "-") + "," + (this.width_ !== undefined ? this.width_.toString() : "-");
    }
    return this.checksum_;
};
var $9ed46f4c9b041e5d$export$2e2bcd8739ae039 = $9ed46f4c9b041e5d$var$Stroke;


/**
 * A function that takes an {@link module:ol/Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style} or an array of them. This way e.g. a
 * vector layer can be styled.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes an {@link module:ol/Feature} as argument and returns an
 * {@link module:ol/geom/Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>),import("../render.js").State)}
 * RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 * @api
 */ var $0f1ce378ea6946fc$var$Style = function Style(opt_options) {
    var options = opt_options || {};
    /**
   * @private
   * @type {string|import("../geom/Geometry.js").default|GeometryFunction}
   */ this.geometry_ = null;
    /**
   * @private
   * @type {!GeometryFunction}
   */ this.geometryFunction_ = $0f1ce378ea6946fc$var$defaultGeometryFunction;
    if (options.geometry !== undefined) this.setGeometry(options.geometry);
    /**
   * @private
   * @type {import("./Fill.js").default}
   */ this.fill_ = options.fill !== undefined ? options.fill : null;
    /**
     * @private
     * @type {import("./Image.js").default}
     */ this.image_ = options.image !== undefined ? options.image : null;
    /**
   * @private
   * @type {RenderFunction|null}
   */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
    /**
   * @private
   * @type {import("./Stroke.js").default}
   */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
    /**
   * @private
   * @type {import("./Text.js").default}
   */ this.text_ = options.text !== undefined ? options.text : null;
    /**
   * @private
   * @type {number|undefined}
   */ this.zIndex_ = options.zIndex;
};
/**
 * Clones the style.
 * @return {Style} The cloned style.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.clone = function clone() {
    var geometry = this.getGeometry();
    if (geometry && typeof geometry === "object") geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
    return new $0f1ce378ea6946fc$var$Style({
        geometry: geometry,
        fill: this.getFill() ? this.getFill().clone() : undefined,
        image: this.getImage() ? this.getImage().clone() : undefined,
        stroke: this.getStroke() ? this.getStroke().clone() : undefined,
        text: this.getText() ? this.getText().clone() : undefined,
        zIndex: this.getZIndex()
    });
};
/**
 * Get the custom renderer function that was configured with
 * {@link #setRenderer} or the `renderer` constructor option.
 * @return {RenderFunction|null} Custom renderer function.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.getRenderer = function getRenderer() {
    return this.renderer_;
};
/**
 * Sets a custom renderer function for this style. When set, `fill`, `stroke`
 * and `image` options of the style will be ignored.
 * @param {RenderFunction|null} renderer Custom renderer function.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.setRenderer = function setRenderer(renderer) {
    this.renderer_ = renderer;
};
/**
 * Get the geometry to be rendered.
 * @return {string|import("../geom/Geometry.js").default|GeometryFunction}
 * Feature property or geometry or function that returns the geometry that will
 * be rendered with this style.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.getGeometry = function getGeometry() {
    return this.geometry_;
};
/**
 * Get the function used to generate a geometry for rendering.
 * @return {!GeometryFunction} Function that is called with a feature
 * and returns the geometry to render instead of the feature's geometry.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.getGeometryFunction = function getGeometryFunction() {
    return this.geometryFunction_;
};
/**
 * Get the fill style.
 * @return {import("./Fill.js").default} Fill style.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.getFill = function getFill() {
    return this.fill_;
};
/**
 * Set the fill style.
 * @param {import("./Fill.js").default} fill Fill style.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.setFill = function setFill(fill) {
    this.fill_ = fill;
};
/**
 * Get the image style.
 * @return {import("./Image.js").default} Image style.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.getImage = function getImage() {
    return this.image_;
};
/**
 * Set the image style.
 * @param {import("./Image.js").default} image Image style.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.setImage = function setImage(image) {
    this.image_ = image;
};
/**
 * Get the stroke style.
 * @return {import("./Stroke.js").default} Stroke style.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.getStroke = function getStroke() {
    return this.stroke_;
};
/**
 * Set the stroke style.
 * @param {import("./Stroke.js").default} stroke Stroke style.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.setStroke = function setStroke(stroke) {
    this.stroke_ = stroke;
};
/**
 * Get the text style.
 * @return {import("./Text.js").default} Text style.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.getText = function getText() {
    return this.text_;
};
/**
 * Set the text style.
 * @param {import("./Text.js").default} text Text style.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.setText = function setText(text) {
    this.text_ = text;
};
/**
 * Get the z-index for the style.
 * @return {number|undefined} ZIndex.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.getZIndex = function getZIndex() {
    return this.zIndex_;
};
/**
 * Set a geometry that is rendered instead of the feature's geometry.
 *
 * @param {string|import("../geom/Geometry.js").default|GeometryFunction} geometry
 *   Feature property or geometry or function returning a geometry to render
 *   for this style.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.setGeometry = function setGeometry(geometry) {
    if (typeof geometry === "function") this.geometryFunction_ = geometry;
    else if (typeof geometry === "string") this.geometryFunction_ = function(feature) {
        return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
    };
    else if (!geometry) this.geometryFunction_ = $0f1ce378ea6946fc$var$defaultGeometryFunction;
    else if (geometry !== undefined) this.geometryFunction_ = function() {
        return /** @type {import("../geom/Geometry.js").default} */ geometry;
    };
    this.geometry_ = geometry;
};
/**
 * Set the z-index.
 *
 * @param {number|undefined} zIndex ZIndex.
 * @api
 */ $0f1ce378ea6946fc$var$Style.prototype.setZIndex = function setZIndex(zIndex) {
    this.zIndex_ = zIndex;
};
function $0f1ce378ea6946fc$export$c314ea3f6b164147(obj) {
    var styleFunction;
    if (typeof obj === "function") styleFunction = obj;
    else {
        /**
     * @type {Array<Style>}
     */ var styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === "function", 41); // Expected an `Style` or an array of `Style`
            var style = /** @type {Style} */ obj;
            styles = [
                style
            ];
        }
        styleFunction = function() {
            return styles;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>}
 */ var $0f1ce378ea6946fc$var$defaultStyles = null;
function $0f1ce378ea6946fc$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$0f1ce378ea6946fc$var$defaultStyles) {
        var fill = new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)({
            color: "rgba(255,255,255,0.4)"
        });
        var stroke = new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
            color: "#3399CC",
            width: 1.25
        });
        $0f1ce378ea6946fc$var$defaultStyles = [
            new $0f1ce378ea6946fc$var$Style({
                image: new (0, $e163d3c698de5692$export$2e2bcd8739ae039)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $0f1ce378ea6946fc$var$defaultStyles;
}
function $0f1ce378ea6946fc$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/GeometryType.js").default, Array<Style>>} */ var styles = {};
    var white = [
        255,
        255,
        255,
        1
    ];
    var blue = [
        0,
        153,
        255,
        1
    ];
    var width = 3;
    styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON] = [
        new $0f1ce378ea6946fc$var$Style({
            fill: new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POLYGON] = styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON];
    styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING] = [
        new $0f1ce378ea6946fc$var$Style({
            stroke: new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                color: white,
                width: width + 2
            })
        }),
        new $0f1ce378ea6946fc$var$Style({
            stroke: new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                color: blue,
                width: width
            })
        })
    ];
    styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_LINE_STRING] = styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING];
    styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).CIRCLE] = styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON].concat(styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING]);
    styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).POINT] = [
        new $0f1ce378ea6946fc$var$Style({
            image: new (0, $e163d3c698de5692$export$2e2bcd8739ae039)({
                radius: width * 2,
                fill: new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)({
                    color: blue
                }),
                stroke: new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POINT] = styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).POINT];
    styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).GEOMETRY_COLLECTION] = styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON].concat(styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING], styles[(0, $8826602b1d512d67$export$2e2bcd8739ae039).POINT]);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $0f1ce378ea6946fc$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $0f1ce378ea6946fc$export$2e2bcd8739ae039 = $0f1ce378ea6946fc$var$Style;


/**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {import("./VectorRenderType.js").default|string} [renderMode='vector'] Render mode for vector layers:
 *  * `'image'`: Vector layers are rendered as images. Great performance, but point symbols and
 *    texts are always rotated with the view and pixels are scaled during zoom animations.
 *  * `'vector'`: Vector layers are rendered as vectors. Most accurate rendering even during
 *    animations, but slower performance.
 * @property {import("../source/Vector.js").default} [source] Source.
 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link module:ol/Map#addLayer}.
 * @property {boolean} [declutter=false] Declutter images and text. Decluttering is applied to all
 * image and text styles, and the priority is defined by the z-index of the style. Lower z-index
 * means higher priority.
 * @property {import("../style/Style.js").StyleLike} [style] Layer style. See
 * {@link module:ol/style} for default style which will be used if this is not defined.
 * @property {boolean} [updateWhileAnimating=false] When set to `true` and `renderMode`
 * is `vector`, feature batches will be recreated during animations. This means that no
 * vectors will be shown clipped, but the setting will have a performance impact for large
 * amounts of vector data. When set to `false`, batches will be recreated when no animation
 * is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true` and `renderMode`
 * is `vector`, feature batches will be recreated during interactions. See also
 * `updateWhileAnimating`.
 */ /**
 * @enum {string}
 * @private
 */ var $09432eee05d1671f$var$Property = {
    RENDER_ORDER: "renderOrder"
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @api
 */ var $09432eee05d1671f$var$VectorLayer = /*@__PURE__*/ function(Layer) {
    function VectorLayer(opt_options) {
        var options = opt_options ? opt_options : /** @type {Options} */ {};
        var baseOptions = (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        Layer.call(this, baseOptions);
        /**
    * @private
    * @type {boolean}
    */ this.declutter_ = options.declutter !== undefined ? options.declutter : false;
        /**
    * @type {number}
    * @private
    */ this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
    * User provided style.
    * @type {import("../style/Style.js").StyleLike}
    * @private
    */ this.style_ = null;
        /**
    * Style function for use within the library.
    * @type {import("../style/Style.js").StyleFunction|undefined}
    * @private
    */ this.styleFunction_ = undefined;
        this.setStyle(options.style);
        /**
    * @type {boolean}
    * @private
    */ this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
    * @type {boolean}
    * @private
    */ this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
        /**
    * @private
    * @type {import("./VectorTileRenderType.js").default|string}
    */ this.renderMode_ = options.renderMode || (0, $f47fc48773998764$export$2e2bcd8739ae039).VECTOR;
        /**
    * The layer type.
    * @protected
    * @type {import("../LayerType.js").default}
    */ this.type = (0, $e2d469ffcbcaca70$export$2e2bcd8739ae039).VECTOR;
    }
    if (Layer) VectorLayer.__proto__ = Layer;
    VectorLayer.prototype = Object.create(Layer && Layer.prototype);
    VectorLayer.prototype.constructor = VectorLayer;
    /**
  * @return {boolean} Declutter.
  */ VectorLayer.prototype.getDeclutter = function getDeclutter() {
        return this.declutter_;
    };
    /**
  * @param {boolean} declutter Declutter.
  */ VectorLayer.prototype.setDeclutter = function setDeclutter(declutter) {
        this.declutter_ = declutter;
    };
    /**
  * @return {number|undefined} Render buffer.
  */ VectorLayer.prototype.getRenderBuffer = function getRenderBuffer() {
        return this.renderBuffer_;
    };
    /**
  * @return {function(import("../Feature.js").default, import("../Feature.js").default): number|null|undefined} Render
  *     order.
  */ VectorLayer.prototype.getRenderOrder = function getRenderOrder() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($09432eee05d1671f$var$Property.RENDER_ORDER);
    };
    /**
  * Get the style for features.  This returns whatever was passed to the `style`
  * option at construction or to the `setStyle` method.
  * @return {import("../style/Style.js").StyleLike}
  *     Layer style.
  * @api
  */ VectorLayer.prototype.getStyle = function getStyle() {
        return this.style_;
    };
    /**
  * Get the style function.
  * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
  * @api
  */ VectorLayer.prototype.getStyleFunction = function getStyleFunction() {
        return this.styleFunction_;
    };
    /**
  * @return {boolean} Whether the rendered layer should be updated while
  *     animating.
  */ VectorLayer.prototype.getUpdateWhileAnimating = function getUpdateWhileAnimating() {
        return this.updateWhileAnimating_;
    };
    /**
  * @return {boolean} Whether the rendered layer should be updated while
  *     interacting.
  */ VectorLayer.prototype.getUpdateWhileInteracting = function getUpdateWhileInteracting() {
        return this.updateWhileInteracting_;
    };
    /**
  * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
  *     Render order.
  */ VectorLayer.prototype.setRenderOrder = function setRenderOrder(renderOrder) {
        this.set($09432eee05d1671f$var$Property.RENDER_ORDER, renderOrder);
    };
    /**
  * Set the style for features.  This can be a single style object, an array
  * of styles, or a function that takes a feature and resolution and returns
  * an array of styles. If it is `undefined` the default style is used. If
  * it is `null` the layer has no style (a `null` style), so only features
  * that have their own styles will be rendered in the layer. See
  * {@link module:ol/style} for information on the default style.
  * @param {import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction|null|undefined} style Layer style.
  * @api
  */ VectorLayer.prototype.setStyle = function setStyle(style) {
        this.style_ = style !== undefined ? style : (0, $0f1ce378ea6946fc$export$6865c5ac2f5ce8b6);
        this.styleFunction_ = style === null ? undefined : (0, $0f1ce378ea6946fc$export$c314ea3f6b164147)(this.style_);
        this.changed();
    };
    /**
  * @return {import("./VectorRenderType.js").default|string} The render mode.
  */ VectorLayer.prototype.getRenderMode = function getRenderMode() {
        return this.renderMode_;
    };
    return VectorLayer;
}((0, $575253350abb8238$export$2e2bcd8739ae039));
/**
 * Return the associated {@link module:ol/source/Vector vectorsource} of the layer.
 * @function
 * @return {import("../source/Vector.js").default} Source.
 * @api
 */ $09432eee05d1671f$var$VectorLayer.prototype.getSource;
var $09432eee05d1671f$export$2e2bcd8739ae039 = $09432eee05d1671f$var$VectorLayer;


/**
 * @module ol/source/Vector
 */ 









/**
 * @module ol/featureloader
 */ 
/**
 * @module ol/format/FormatType
 */ /**
 * @enum {string}
 */ var $60c0797155205327$export$2e2bcd8739ae039 = {
    ARRAY_BUFFER: "arraybuffer",
    JSON: "json",
    TEXT: "text",
    XML: "xml"
};


function $34037dfe4c349357$export$441d7b57adab24d0(url, format, success, failure) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @this {import("./source/Vector").default|import("./VectorTile.js").default}
     */ function(extent, resolution, projection) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", typeof url === "function" ? url(extent, resolution, projection) : url, true);
        if (format.getType() == (0, $60c0797155205327$export$2e2bcd8739ae039).ARRAY_BUFFER) xhr.responseType = "arraybuffer";
        /**
       * @param {Event} event Event.
       * @private
       */ xhr.onload = (function(event) {
            // status will be 0 for file:// urls
            if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
                var type = format.getType();
                /** @type {Document|Node|Object|string|undefined} */ var source;
                if (type == (0, $60c0797155205327$export$2e2bcd8739ae039).JSON || type == (0, $60c0797155205327$export$2e2bcd8739ae039).TEXT) source = xhr.responseText;
                else if (type == (0, $60c0797155205327$export$2e2bcd8739ae039).XML) {
                    source = xhr.responseXML;
                    if (!source) source = new DOMParser().parseFromString(xhr.responseText, "application/xml");
                } else if (type == (0, $60c0797155205327$export$2e2bcd8739ae039).ARRAY_BUFFER) source = /** @type {ArrayBuffer} */ xhr.response;
                if (source) success.call(this, format.readFeatures(source, {
                    featureProjection: projection
                }), format.readProjection(source), format.getLastExtent());
                else failure.call(this);
            } else failure.call(this);
        }).bind(this);
        /**
       * @private
       */ xhr.onerror = (function() {
            failure.call(this);
        }).bind(this);
        xhr.send();
    });
}
function $34037dfe4c349357$export$14cc81df70b6707e(url, format) {
    return $34037dfe4c349357$export$441d7b57adab24d0(url, format, /**
     * @param {Array<import("./Feature.js").default>} features The loaded features.
     * @param {import("./proj/Projection.js").default} dataProjection Data
     * projection.
     * @this {import("./source/Vector").default|import("./VectorTile.js").default}
     */ function(features, dataProjection) {
        var sourceOrTile = /** @type {?} */ this;
        if (typeof sourceOrTile.addFeatures === "function") /** @type {import("./source/Vector").default} */ sourceOrTile.addFeatures(features);
    }, /* FIXME handle error */ (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8));
}



/**
 * @module ol/loadingstrategy
 */ /**
 * Strategy function for loading all features with a single request.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @return {Array<import("./extent.js").Extent>} Extents.
 * @api
 */ function $d8ae32e631726bbf$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $d8ae32e631726bbf$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $d8ae32e631726bbf$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution) {
        var z = tileGrid.getZForResolution(resolution);
        var tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
        /** @type {Array<import("./extent.js").Extent>} */ var extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ var tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push(tileGrid.getTileCoordExtent(tileCoord));
        return extents;
    });
}





/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $06df2a0f10306cb8$export$2e2bcd8739ae039 = {
    /**
   * Triggered when a feature is added to the source.
   * @event ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */ ADDFEATURE: "addfeature",
    /**
   * Triggered when a feature is updated.
   * @event ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */ CHANGEFEATURE: "changefeature",
    /**
   * Triggered when the clear method is called on the source.
   * @event ol/source/Vector.VectorSourceEvent#clear
   * @api
   */ CLEAR: "clear",
    /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector#clear source.clear()} for exceptions.
   * @event ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */ REMOVEFEATURE: "removefeature"
};


/**
 * @module ol/structs/RBush
 */ 



/**
 * @typedef {Object} Entry
 * @property {number} minX
 * @property {number} minY
 * @property {number} maxX
 * @property {number} maxY
 * @property {Object} [value]
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template T
 */ var $02caaf5d0144620b$var$RBush = function RBush(opt_maxEntries) {
    /**
   * @private
   */ this.rbush_ = (0, (/*@__PURE__*/$parcel$interopDefault($2714652880d6ac2a$exports)))(opt_maxEntries, undefined);
    /**
   * A mapping between the objects added to this rbush wrapper
   * and the objects that are actually added to the internal rbush.
   * @private
   * @type {Object<string, Entry>}
   */ this.items_ = {};
};
/**
 * Insert a value into the RBush.
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {T} value Value.
 */ $02caaf5d0144620b$var$RBush.prototype.insert = function insert(extent, value) {
    /** @type {Entry} */ var item = {
        minX: extent[0],
        minY: extent[1],
        maxX: extent[2],
        maxY: extent[3],
        value: value
    };
    this.rbush_.insert(item);
    this.items_[(0, $34772e91e89a736f$export$5e82334337e0f204)(value)] = item;
};
/**
 * Bulk-insert values into the RBush.
 * @param {Array<import("../extent.js").Extent>} extents Extents.
 * @param {Array<T>} values Values.
 */ $02caaf5d0144620b$var$RBush.prototype.load = function load(extents, values) {
    var items = new Array(values.length);
    for(var i = 0, l = values.length; i < l; i++){
        var extent = extents[i];
        var value = values[i];
        /** @type {Entry} */ var item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        items[i] = item;
        this.items_[(0, $34772e91e89a736f$export$5e82334337e0f204)(value)] = item;
    }
    this.rbush_.load(items);
};
/**
 * Remove a value from the RBush.
 * @param {T} value Value.
 * @return {boolean} Removed.
 */ $02caaf5d0144620b$var$RBush.prototype.remove = function remove(value) {
    var uid = (0, $34772e91e89a736f$export$5e82334337e0f204)(value);
    // get the object in which the value was wrapped when adding to the
    // internal rbush. then use that object to do the removal.
    var item = this.items_[uid];
    delete this.items_[uid];
    return this.rbush_.remove(item) !== null;
};
/**
 * Update the extent of a value in the RBush.
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {T} value Value.
 */ $02caaf5d0144620b$var$RBush.prototype.update = function update(extent, value) {
    var item = this.items_[(0, $34772e91e89a736f$export$5e82334337e0f204)(value)];
    var bbox = [
        item.minX,
        item.minY,
        item.maxX,
        item.maxY
    ];
    if (!(0, $7e819822b33b3d32$export$e9bab7fafb253603)(bbox, extent)) {
        this.remove(value);
        this.insert(extent, value);
    }
};
/**
 * Return all values in the RBush.
 * @return {Array<T>} All.
 */ $02caaf5d0144620b$var$RBush.prototype.getAll = function getAll() {
    var items = this.rbush_.all();
    return items.map(function(item) {
        return item.value;
    });
};
/**
 * Return all values in the given extent.
 * @param {import("../extent.js").Extent} extent Extent.
 * @return {Array<T>} All in extent.
 */ $02caaf5d0144620b$var$RBush.prototype.getInExtent = function getInExtent(extent) {
    /** @type {Entry} */ var bbox = {
        minX: extent[0],
        minY: extent[1],
        maxX: extent[2],
        maxY: extent[3]
    };
    var items = this.rbush_.search(bbox);
    return items.map(function(item) {
        return item.value;
    });
};
/**
 * Calls a callback function with each value in the tree.
 * If the callback returns a truthy value, this value is returned without
 * checking the rest of the tree.
 * @param {function(this: S, T): *} callback Callback.
 * @param {S=} opt_this The object to use as `this` in `callback`.
 * @return {*} Callback return value.
 * @template S
 */ $02caaf5d0144620b$var$RBush.prototype.forEach = function forEach(callback, opt_this) {
    return this.forEach_(this.getAll(), callback, opt_this);
};
/**
 * Calls a callback function with each value in the provided extent.
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {function(this: S, T): *} callback Callback.
 * @param {S=} opt_this The object to use as `this` in `callback`.
 * @return {*} Callback return value.
 * @template S
 */ $02caaf5d0144620b$var$RBush.prototype.forEachInExtent = function forEachInExtent(extent, callback, opt_this) {
    return this.forEach_(this.getInExtent(extent), callback, opt_this);
};
/**
 * @param {Array<T>} values Values.
 * @param {function(this: S, T): *} callback Callback.
 * @param {S=} opt_this The object to use as `this` in `callback`.
 * @private
 * @return {*} Callback return value.
 * @template S
 */ $02caaf5d0144620b$var$RBush.prototype.forEach_ = function forEach_(values, callback, opt_this) {
    var result;
    for(var i = 0, l = values.length; i < l; i++){
        result = callback.call(opt_this, values[i]);
        if (result) return result;
    }
    return result;
};
/**
 * @return {boolean} Is empty.
 */ $02caaf5d0144620b$var$RBush.prototype.isEmpty = function isEmpty$1() {
    return (0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(this.items_);
};
/**
 * Remove all values from the RBush.
 */ $02caaf5d0144620b$var$RBush.prototype.clear = function clear() {
    this.rbush_.clear();
    this.items_ = {};
};
/**
 * @param {import("../extent.js").Extent=} opt_extent Extent.
 * @return {import("../extent.js").Extent} Extent.
 */ $02caaf5d0144620b$var$RBush.prototype.getExtent = function getExtent(opt_extent) {
    var data = this.rbush_.toJSON();
    return (0, $7e819822b33b3d32$export$958e3e1a02eac4b6)(data.minX, data.minY, data.maxX, data.maxY, opt_extent);
};
/**
 * @param {RBush} rbush R-Tree.
 */ $02caaf5d0144620b$var$RBush.prototype.concat = function concat(rbush) {
    this.rbush_.load(rbush.rbush_.all());
    for(var i in rbush.items_)this.items_[i] = rbush.items_[i];
};
var $02caaf5d0144620b$export$2e2bcd8739ae039 = $02caaf5d0144620b$var$RBush;


var $69f8886165740064$export$d402fd02dc2b661c = /*@__PURE__*/ function(Event) {
    function VectorSourceEvent(type, opt_feature) {
        Event.call(this, type);
        /**
     * The feature being added or removed.
     * @type {import("../Feature.js").default|undefined}
     * @api
     */ this.feature = opt_feature;
    }
    if (Event) VectorSourceEvent.__proto__ = Event;
    VectorSourceEvent.prototype = Object.create(Event && Event.prototype);
    VectorSourceEvent.prototype.constructor = VectorSourceEvent;
    return VectorSourceEvent;
}((0, $0327f54963b35733$export$2e2bcd8739ae039));
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<import("../Feature.js").default>|Collection<import("../Feature.js").default>} [features]
 * Features. If provided as {@link module:ol/Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader.
 *
 * Example:
 *
 * ```js
 * import {Vector} from 'ol/source';
 * import {GeoJSON} from 'ol/format';
 * import {bbox} from 'ol/loadingstrategy';
 *
 * var vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection) {
 *      var proj = projection.getCode();
 *      var url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      var xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      var onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          vectorSource.addFeatures(
 *              vectorSource.getFormat().readFeatures(xhr.responseText));
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy~all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader~xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy~all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires ol/source/Vector.VectorSourceEvent
 * @api
 */ var $69f8886165740064$var$VectorSource = /*@__PURE__*/ function(Source) {
    function VectorSource(opt_options) {
        var options = opt_options || {};
        Source.call(this, {
            attributions: options.attributions,
            projection: undefined,
            state: (0, $7c2f117cb5c1ce12$export$2e2bcd8739ae039).READY,
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        });
        /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader}
     */ this.loader_ = (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8);
        /**
     * @private
     * @type {import("../format/Feature.js").default|undefined}
     */ this.format_ = options.format;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps == undefined ? true : options.overlaps;
        /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */ this.url_ = options.url;
        if (options.loader !== undefined) this.loader_ = options.loader;
        else if (this.url_ !== undefined) {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(this.format_, 7); // `format` must be set when `url` is set
            // create a XHR feature loader for "url" and "format"
            this.loader_ = (0, $34037dfe4c349357$export$14cc81df70b6707e)(this.url_, /** @type {import("../format/Feature.js").default} */ this.format_);
        }
        /**
     * @private
     * @type {LoadingStrategy}
     */ this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $d8ae32e631726bbf$export$84bf76cd7afc7469);
        var useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
     * @private
     * @type {RBush<import("../Feature.js").default>}
     */ this.featuresRtree_ = useSpatialIndex ? new (0, $02caaf5d0144620b$export$2e2bcd8739ae039)() : null;
        /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */ this.loadedExtentsRtree_ = new (0, $02caaf5d0144620b$export$2e2bcd8739ae039)();
        /**
     * @private
     * @type {!Object<string, import("../Feature.js").default>}
     */ this.nullGeometryFeatures_ = {};
        /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, import("../Feature.js").default>}
     */ this.idIndex_ = {};
        /**
     * A lookup of features without id (keyed by getUid(feature)).
     * @private
     * @type {!Object<string, import("../Feature.js").default>}
     */ this.undefIdIndex_ = {};
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.featureChangeKeys_ = {};
        /**
     * @private
     * @type {Collection<import("../Feature.js").default>}
     */ this.featuresCollection_ = null;
        var collection, features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $7be3d63260860659$export$2e2bcd8739ae039)(features);
        if (features !== undefined) this.addFeaturesInternal(features);
        if (collection !== undefined) this.bindFeaturesCollection_(collection);
    }
    if (Source) VectorSource.__proto__ = Source;
    VectorSource.prototype = Object.create(Source && Source.prototype);
    VectorSource.prototype.constructor = VectorSource;
    /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * @param {import("../Feature.js").default} feature Feature to add.
   * @api
   */ VectorSource.prototype.addFeature = function addFeature(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    };
    /**
   * Add a feature without firing a `change` event.
   * @param {import("../Feature.js").default} feature Feature.
   * @protected
   */ VectorSource.prototype.addFeatureInternal = function addFeatureInternal(feature) {
        var featureKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
        if (!this.addToIndex_(featureKey, feature)) return;
        this.setupChangeEvents_(featureKey, feature);
        var geometry = feature.getGeometry();
        if (geometry) {
            var extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).ADDFEATURE, feature));
    };
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {import("../Feature.js").default} feature The feature.
   * @private
   */ VectorSource.prototype.setupChangeEvents_ = function setupChangeEvents_(featureKey, feature) {
        this.featureChangeKeys_[featureKey] = [
            (0, $37a5c0af9052e360$export$63174c828edd6ff8)(feature, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_, this),
            (0, $37a5c0af9052e360$export$63174c828edd6ff8)(feature, (0, $19100aa5be43a728$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    };
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {import("../Feature.js").default} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */ VectorSource.prototype.addToIndex_ = function addToIndex_(featureKey, feature) {
        var valid = true;
        var id = feature.getId();
        if (id !== undefined) {
            if (!(id.toString() in this.idIndex_)) this.idIndex_[id.toString()] = feature;
            else valid = false;
        } else {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!(featureKey in this.undefIdIndex_), 30); // The passed `feature` was already added to the source
            this.undefIdIndex_[featureKey] = feature;
        }
        return valid;
    };
    /**
   * Add a batch of features to the source.
   * @param {Array<import("../Feature.js").default>} features Features to add.
   * @api
   */ VectorSource.prototype.addFeatures = function addFeatures(features) {
        this.addFeaturesInternal(features);
        this.changed();
    };
    /**
   * Add features without firing a `change` event.
   * @param {Array<import("../Feature.js").default>} features Features.
   * @protected
   */ VectorSource.prototype.addFeaturesInternal = function addFeaturesInternal(features) {
        var extents = [];
        var newFeatures = [];
        var geometryFeatures = [];
        for(var i = 0, length = features.length; i < length; i++){
            var feature = features[i];
            var featureKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(var i$1 = 0, length$1 = newFeatures.length; i$1 < length$1; i$1++){
            var feature$1 = newFeatures[i$1];
            var featureKey$1 = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature$1);
            this.setupChangeEvents_(featureKey$1, feature$1);
            var geometry = feature$1.getGeometry();
            if (geometry) {
                var extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature$1);
            } else this.nullGeometryFeatures_[featureKey$1] = feature$1;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        for(var i$2 = 0, length$2 = newFeatures.length; i$2 < length$2; i$2++)this.dispatchEvent(new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).ADDFEATURE, newFeatures[i$2]));
    };
    /**
   * @param {!Collection<import("../Feature.js").default>} collection Collection.
   * @private
   */ VectorSource.prototype.bindFeaturesCollection_ = function bindFeaturesCollection_(collection) {
        var modifyingCollection = false;
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $06df2a0f10306cb8$export$2e2bcd8739ae039).ADDFEATURE, /**
       * @param {VectorSourceEvent} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $06df2a0f10306cb8$export$2e2bcd8739ae039).REMOVEFEATURE, /**
       * @param {VectorSourceEvent} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(collection, (0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, /**
       * @param {import("../Collection.js").CollectionEvent} evt The collection event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(/** @type {import("../Feature.js").default} */ evt.element);
                modifyingCollection = false;
            }
        }, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(collection, (0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("../Collection.js").CollectionEvent} evt The collection event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(/** @type {import("../Feature.js").default} */ evt.element);
                modifyingCollection = false;
            }
        }, this);
        this.featuresCollection_ = collection;
    };
    /**
   * Remove all features from the source.
   * @param {boolean=} opt_fast Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#removefeature} events.
   * @api
   */ VectorSource.prototype.clear = function clear(opt_fast) {
        if (opt_fast) {
            for(var featureId in this.featureChangeKeys_){
                var keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.undefIdIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            this.featuresRtree_.forEach(this.removeFeatureInternal, this);
            for(var id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.loadedExtentsRtree_.clear();
        this.nullGeometryFeatures_ = {};
        var clearEvent = new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    };
    /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(import("../Feature.js").default): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ VectorSource.prototype.forEachFeature = function forEachFeature(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        else if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    };
    /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(import("../Feature.js").default): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */ VectorSource.prototype.forEachFeatureAtCoordinateDirect = function forEachFeatureAtCoordinateDirect(coordinate, callback) {
        var extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            var geometry = feature.getGeometry();
            if (geometry.intersectsCoordinate(coordinate)) return callback(feature);
            else return undefined;
        });
    };
    /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(import("../Feature.js").default): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ VectorSource.prototype.forEachFeatureInExtent = function forEachFeatureInExtent(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        else if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    };
    /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(import("../Feature.js").default): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ VectorSource.prototype.forEachFeatureIntersectingExtent = function forEachFeatureIntersectingExtent(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
       * @param {import("../Feature.js").default} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */ function(feature) {
            var geometry = feature.getGeometry();
            if (geometry.intersectsExtent(extent)) {
                var result = callback(feature);
                if (result) return result;
            }
        });
    };
    /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with an {@link module:ol/Collection} as `features`.
   * @return {Collection<import("../Feature.js").default>} The collection of features.
   * @api
   */ VectorSource.prototype.getFeaturesCollection = function getFeaturesCollection() {
        return this.featuresCollection_;
    };
    /**
   * Get all features on the source in random order.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   */ VectorSource.prototype.getFeatures = function getFeatures() {
        var features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray();
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_)) (0, $830d23b8323fc080$export$8b58be045bf06082)(features, (0, $8c1e0b75b65663dc$export$a5c4301012ad6f07)(this.nullGeometryFeatures_));
        }
        return /** @type {Array<import("../Feature.js").default>} */ features;
    };
    /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   */ VectorSource.prototype.getFeaturesAtCoordinate = function getFeaturesAtCoordinate(coordinate) {
        var features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    };
    /**
   * Get all features in the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   */ VectorSource.prototype.getFeaturesInExtent = function getFeaturesInExtent(extent) {
        return this.featuresRtree_.getInExtent(extent);
    };
    /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(import("../Feature.js").default):boolean=} opt_filter Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {import("../Feature.js").default} Closest feature.
   * @api
   */ VectorSource.prototype.getClosestFeatureToCoordinate = function getClosestFeatureToCoordinate(coordinate, opt_filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        var x = coordinate[0];
        var y = coordinate[1];
        var closestFeature = null;
        var closestPoint = [
            NaN,
            NaN
        ];
        var minSquaredDistance = Infinity;
        var extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        var filter = opt_filter ? opt_filter : (0, $de1052d9f293b73a$export$22e23a2304399231);
        this.featuresRtree_.forEachInExtent(extent, /**
       * @param {import("../Feature.js").default} feature Feature.
       */ function(feature) {
            if (filter(feature)) {
                var geometry = feature.getGeometry();
                var previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    var minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    };
    /**
   * Get the extent of the features currently in the source.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent=} opt_extent Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ VectorSource.prototype.getExtent = function getExtent(opt_extent) {
        return this.featuresRtree_.getExtent(opt_extent);
    };
    /**
   * Get a feature by its identifier (the value returned by feature.getId()).
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {import("../Feature.js").default} The feature (or `null` if not found).
   * @api
   */ VectorSource.prototype.getFeatureById = function getFeatureById(id) {
        var feature = this.idIndex_[id.toString()];
        return feature !== undefined ? feature : null;
    };
    /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default|undefined} The feature format.
   * @api
   */ VectorSource.prototype.getFormat = function getFormat() {
        return this.format_;
    };
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ VectorSource.prototype.getOverlaps = function getOverlaps() {
        return this.overlaps_;
    };
    /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */ VectorSource.prototype.getUrl = function getUrl() {
        return this.url_;
    };
    /**
   * @param {Event} event Event.
   * @private
   */ VectorSource.prototype.handleFeatureChange_ = function handleFeatureChange_(event) {
        var feature = /** @type {import("../Feature.js").default} */ event.target;
        var featureKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
        var geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            var extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        var id = feature.getId();
        if (id !== undefined) {
            var sid = id.toString();
            if (featureKey in this.undefIdIndex_) {
                delete this.undefIdIndex_[featureKey];
                this.idIndex_[sid] = feature;
            } else if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else if (!(featureKey in this.undefIdIndex_)) {
            this.removeFromIdIndex_(feature);
            this.undefIdIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).CHANGEFEATURE, feature));
    };
    /**
   * Returns true if the feature is contained within the source.
   * @param {import("../Feature.js").default} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */ VectorSource.prototype.hasFeature = function hasFeature(feature) {
        var id = feature.getId();
        if (id !== undefined) return id in this.idIndex_;
        else return (0, $34772e91e89a736f$export$5e82334337e0f204)(feature) in this.undefIdIndex_;
    };
    /**
   * @return {boolean} Is empty.
   */ VectorSource.prototype.isEmpty = function isEmpty$1() {
        return this.featuresRtree_.isEmpty() && (0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_);
    };
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ VectorSource.prototype.loadFeatures = function loadFeatures(extent, resolution, projection) {
        var this$1 = this;
        var loadedExtentsRtree = this.loadedExtentsRtree_;
        var extentsToLoad = this.strategy_(extent, resolution);
        this.loading = false;
        var loop = function(i, ii) {
            var extentToLoad = extentsToLoad[i];
            var alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */ function(object) {
                return (0, $7e819822b33b3d32$export$be866b1e0809b17e)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                this$1.loader_.call(this$1, extentToLoad, resolution, projection);
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
                this$1.loading = this$1.loader_ !== (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8);
            }
        };
        for(var i = 0, ii = extentsToLoad.length; i < ii; ++i)loop(i, ii);
    };
    /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ VectorSource.prototype.removeLoadedExtent = function removeLoadedExtent(extent) {
        var loadedExtentsRtree = this.loadedExtentsRtree_;
        var obj;
        loadedExtentsRtree.forEachInExtent(extent, function(object) {
            if ((0, $7e819822b33b3d32$export$e9bab7fafb253603)(object.extent, extent)) {
                obj = object;
                return true;
            }
        });
        if (obj) loadedExtentsRtree.remove(obj);
    };
    /**
   * Remove a single feature from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {import("../Feature.js").default} feature Feature to remove.
   * @api
   */ VectorSource.prototype.removeFeature = function removeFeature(feature) {
        var featureKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        this.removeFeatureInternal(feature);
        this.changed();
    };
    /**
   * Remove feature without firing a `change` event.
   * @param {import("../Feature.js").default} feature Feature.
   * @protected
   */ VectorSource.prototype.removeFeatureInternal = function removeFeatureInternal(feature) {
        var featureKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
        this.featureChangeKeys_[featureKey].forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        delete this.featureChangeKeys_[featureKey];
        var id = feature.getId();
        if (id !== undefined) delete this.idIndex_[id.toString()];
        else delete this.undefIdIndex_[featureKey];
        this.dispatchEvent(new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).REMOVEFEATURE, feature));
    };
    /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {import("../Feature.js").default} feature The feature.
   * @return {boolean} Removed the feature from the index.
   * @private
   */ VectorSource.prototype.removeFromIdIndex_ = function removeFromIdIndex_(feature) {
        var removed = false;
        for(var id in this.idIndex_)if (this.idIndex_[id] === feature) {
            delete this.idIndex_[id];
            removed = true;
            break;
        }
        return removed;
    };
    /**
   * Set the new loader of the source. The next loadFeatures call will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
   * @api
   */ VectorSource.prototype.setLoader = function setLoader(loader) {
        this.loader_ = loader;
    };
    return VectorSource;
}((0, $dba8564f516aed29$export$2e2bcd8739ae039));
var $69f8886165740064$export$2e2bcd8739ae039 = $69f8886165740064$var$VectorSource;



/**
 * @module ol/Feature
 */ 



/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature';
 * import Polygon from 'ol/geom/Polygon';
 * import Point from 'ol/geom/Point';
 *
 * var feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon'
 * });
 *
 * // get the polygon geometry
 * var poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * var point = feature.getGeometry();
 * ```
 *
 * @api
 */ var $1171fbd986f3130c$var$Feature = /*@__PURE__*/ function(BaseObject) {
    function Feature(opt_geometryOrProperties) {
        BaseObject.call(this);
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = undefined;
        /**
     * @type {string}
     * @private
     */ this.geometryName_ = "geometry";
        /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */ this.style_ = null;
        /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */ this.styleFunction_ = undefined;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.geometryChangeKey_ = null;
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)(this.geometryName_), this.handleGeometryChanged_, this);
        if (opt_geometryOrProperties) {
            if (typeof /** @type {?} */ opt_geometryOrProperties.getSimplifiedGeometry === "function") {
                var geometry = /** @type {import("./geom/Geometry.js").default} */ opt_geometryOrProperties;
                this.setGeometry(geometry);
            } else {
                /** @type {Object<string, *>} */ var properties = opt_geometryOrProperties;
                this.setProperties(properties);
            }
        }
    }
    if (BaseObject) Feature.__proto__ = BaseObject;
    Feature.prototype = Object.create(BaseObject && BaseObject.prototype);
    Feature.prototype.constructor = Feature;
    /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature} The clone.
   * @api
   */ Feature.prototype.clone = function clone() {
        var clone = new Feature(this.getProperties());
        clone.setGeometryName(this.getGeometryName());
        var geometry = this.getGeometry();
        if (geometry) clone.setGeometry(geometry.clone());
        var style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    };
    /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {import("./geom/Geometry.js").default|undefined} The default geometry for the feature.
   * @api
   * @observable
   */ Feature.prototype.getGeometry = function getGeometry() {
        return /** @type {import("./geom/Geometry.js").default|undefined} */ this.get(this.geometryName_);
    };
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */ Feature.prototype.getId = function getId() {
        return this.id_;
    };
    /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */ Feature.prototype.getGeometryName = function getGeometryName() {
        return this.geometryName_;
    };
    /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike} The feature style.
   * @api
   */ Feature.prototype.getStyle = function getStyle() {
        return this.style_;
    };
    /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */ Feature.prototype.getStyleFunction = function getStyleFunction() {
        return this.styleFunction_;
    };
    /**
   * @private
   */ Feature.prototype.handleGeometryChange_ = function handleGeometryChange_() {
        this.changed();
    };
    /**
   * @private
   */ Feature.prototype.handleGeometryChanged_ = function handleGeometryChanged_() {
        if (this.geometryChangeKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        var geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(geometry, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    };
    /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {import("./geom/Geometry.js").default|undefined} geometry The new geometry.
   * @api
   * @observable
   */ Feature.prototype.setGeometry = function setGeometry(geometry) {
        this.set(this.geometryName_, geometry);
    };
    /**
   * Set the style for the feature.  This can be a single style object, an array
   * of styles, or a function that takes a resolution and returns an array of
   * styles. If it is `null` the feature has no style (a `null` style).
   * @param {import("./style/Style.js").StyleLike} style Style for this feature.
   * @api
   * @fires module:ol/events/Event~Event#event:change
   */ Feature.prototype.setStyle = function setStyle(style) {
        this.style_ = style;
        this.styleFunction_ = !style ? undefined : $1171fbd986f3130c$export$bb06ddfd5d66e02e(style);
        this.changed();
    };
    /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~Event#event:change
   */ Feature.prototype.setId = function setId(id) {
        this.id_ = id;
        this.changed();
    };
    /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */ Feature.prototype.setGeometryName = function setGeometryName(name) {
        (0, $37a5c0af9052e360$export$35276765542cd163)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)(this.geometryName_), this.handleGeometryChanged_, this);
        this.geometryName_ = name;
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)(this.geometryName_), this.handleGeometryChanged_, this);
        this.handleGeometryChanged_();
    };
    return Feature;
}((0, $d575b598d09f57d3$export$2e2bcd8739ae039));
function $1171fbd986f3130c$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === "function") return obj;
    else {
        /**
     * @type {Array<import("./style/Style.js").default>}
     */ var styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === "function", 41); // Expected an `import("./style/Style.js").Style` or an array of `import("./style/Style.js").Style`
            var style = /** @type {import("./style/Style.js").default} */ obj;
            styles = [
                style
            ];
        }
        return function() {
            return styles;
        };
    }
}
var $1171fbd986f3130c$export$2e2bcd8739ae039 = $1171fbd986f3130c$var$Feature;




var $6262b9769c5759db$var$searchIndicator = new $09432eee05d1671f$export$2e2bcd8739ae039({
    source: new $69f8886165740064$export$2e2bcd8739ae039(),
    zIndex: 25,
    style: new $0f1ce378ea6946fc$export$2e2bcd8739ae039({
        image: new $e163d3c698de5692$export$2e2bcd8739ae039({
            radius: 14,
            stroke: new $9ed46f4c9b041e5d$export$2e2bcd8739ae039({
                color: "#000000"
            }),
            fill: new $d6fd3e0b0360ea29$export$2e2bcd8739ae039({
                color: "rgba(204,36,104,0.6)"
            })
        })
    })
});
function $6262b9769c5759db$var$search(searchText, map, extent) {
    searchText = searchText.trim();
    if (!searchText) return;
    $dc57b31f1b066f38$exports.get("https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates", {
        f: "json",
        SingleLine: searchText,
        searchExtent: "-92.9,42.4,-86.8,47.1",
        outSR: 102100
    }, function(d) {
        if (d["candidates"] && d["candidates"]["length"] > 0) {
            var cand = d["candidates"][0];
            var loc = cand["location"];
            if (isNaN(loc.x) || isNaN(loc.y) || typeof loc.x === "string" || typeof loc.y === "string") ;
            else {
                var ext = cand["extent"];
                map.getView().setCenter([
                    loc.x,
                    loc.y
                ]);
                map.getView().fit([
                    ext.xmin,
                    ext.ymin,
                    ext.xmax,
                    ext.ymax
                ], {
                    size: map.getSize()
                });
                var p = new $f7e297e9f8b90024$export$2e2bcd8739ae039([
                    loc.x,
                    loc.y
                ]);
                var f = new $1171fbd986f3130c$export$2e2bcd8739ae039(p);
                $6262b9769c5759db$var$searchIndicator.getSource().addFeature(f);
                setTimeout(function() {
                    $6262b9769c5759db$var$searchIndicator.getSource().clear();
                }, 3000);
            }
        }
    }, "json");
}
function $6262b9769c5759db$var$addSearch(map, xMin, yMin, xMax, yMax) {
    if (xMin === void 0) xMin = -92.9;
    if (yMin === void 0) yMin = 42.4;
    if (xMax === void 0) xMax = -86.8;
    if (yMax === void 0) yMax = 47.1;
    map.addLayer($6262b9769c5759db$var$searchIndicator);
    var searchContainer = document.createElement("div");
    searchContainer.style.position = "absolute";
    searchContainer.style.left = "75px";
    searchContainer.style.top = "15px";
    // searchContainer.style.backgroundColor = 'white';
    searchContainer.style.zIndex = "25";
    searchContainer.id = "search-container";
    var searchText = document.createElement("input");
    searchText.type = "text";
    searchText.style.height = "25px";
    searchText.style.width = "200px";
    searchText.style.borderRadius = "5px 0 0 5px";
    searchText.style.border = "solid black 1px";
    searchText.style.padding = "0 0 0 5px";
    searchText.style.verticalAlign = "top";
    searchText.id = "search-container-text";
    var searchButton = document.createElement("input");
    searchButton.type = "button";
    searchButton.style.height = "29px";
    searchButton.style.width = "35px";
    searchButton.style.display = "inline-block";
    searchButton.style.padding = "3px";
    searchButton.style.borderRadius = "0 5px 5px 0";
    searchButton.style.background = "url('data:image/png;base64,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') no-repeat";
    searchButton.style.backgroundSize = "21px 21px";
    searchButton.style.backgroundPosition = "5px 3px";
    searchButton.style.border = "solid black 1px";
    searchButton.style.cursor = "pointer";
    searchButton.style.backgroundColor = "white";
    searchButton.title = "Search";
    searchButton.id = "search-container-button";
    searchButton.onclick = function() {
        $6262b9769c5759db$var$search(searchText.value, map, xMin + "," + yMin + "," + xMax + "," + yMax);
    };
    searchText.onkeyup = function(e) {
        if (e["keyCode"] === 13) $6262b9769c5759db$var$search(searchText.value, map, xMin + "," + yMin + "," + xMax + "," + yMax);
    };
    searchContainer.appendChild(searchText);
    searchContainer.appendChild(searchButton);
    map.getTargetElement().appendChild(searchContainer);
}
$6262b9769c5759db$exports.addSearch = $6262b9769c5759db$var$addSearch;


/**
 * Sets up a map with some default parameters and initializes
 * mapMove and mapPopup
 *
 * @param [options={}] config options
 * @param [options.divId=map] map div id
 * @param [options.center={}] center config object
 * @param [options.center.x=-10018378] center x, web mercator x or lon
 * @param [options.center.y=5574910] center y, web mercator y or lat
 * @param [options.zoom=7] zoom level
 * @param [options.minZoom=undefined] min zoom
 * @param [options.maxZoom=undefined] max zoom
 * @param [options.baseSwitcher=true] if add base map switcher
 * @param [options.fullScreen=false] if add base map switcher
 * @returns the ol map
 */ function $cc12fb92b6cb9cf8$var$quickMapBase(options) {
    if (options === void 0) options = {};
    options.divId = options.divId || "map";
    options.center = options.center || {
        x: -10018378,
        y: 5574910
    };
    options.zoom = typeof options.zoom == "number" ? options.zoom : 7;
    options.baseSwitcher = typeof options.baseSwitcher == "boolean" ? options.baseSwitcher : true;
    options.fullScreen = typeof options.fullScreen == "boolean" ? options.fullScreen : false;
    options.addSearch = options.addGeocode || options.addSearch;
    options.addOsm = typeof options.addOsm === "undefined" ? true : options.addOsm;
    var $mapDiv = $dc57b31f1b066f38$exports("#" + options.divId);
    $mapDiv.css("position", "relative");
    var osmLayer = new $0e25041945985074$export$2e2bcd8739ae039({
        source: new $d978548adde0e5c6$export$2e2bcd8739ae039()
    });
    // let satLayer = new ol.layer.Tile({visible: false, source: new ol.source.MapQuest({layer: 'sat'})});
    var osmCss = "url('data:image/png;base64,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')";
    var aerialCss = "url('data:image/png;base64,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')";
    options.baseSwitcher;
    if (options.zoom < 0 || options.zoom > 28) throw "zoom out of range";
    if (options.center.x >= -180 && options.center.x <= 180 && options.center.y >= -90 && options.center.y <= 90) {
        var p = new $f7e297e9f8b90024$export$2e2bcd8739ae039([
            options.center.x,
            options.center.y
        ]);
        // new Projection({code: "EPSG:4326"});
        // let coordinates = transform(p.getCoordinates(), "EPSG:4326", "EPSG:3857");
        // p.transform(new Projection({code: "EPSG:4326"}), new Projection({code: "EPSG:3857"}));
        // let coordinates = p.getCoordinates();
        var coordinates = $92f1443438429e81$export$51186ad6e864892a(p.getCoordinates(), new $8fe6435c5dc78f3e$export$2e2bcd8739ae039({
            code: "EPSG:4326"
        }), new $8fe6435c5dc78f3e$export$2e2bcd8739ae039({
            code: "EPSG:3857"
        }));
        options.center.x = coordinates[0];
        options.center.y = coordinates[1];
    }
    // const controls = control.defaults({
    //         attributionOptions: {collapsible: false}
    //     }
    // );
    var view = new $3192ea72f934a3fd$export$2e2bcd8739ae039({
        center: [
            options.center.x,
            options.center.y
        ],
        zoom: options.zoom,
        minZoom: options.minZoom,
        maxZoom: options.maxZoom
    });
    var map = new $88aa35e28fb911a2$export$2e2bcd8739ae039({
        layers: [],
        target: options.divId,
        // controls: controls,
        view: view
    });
    if (options.addOsm) map.addLayer(osmLayer);
    if (options.fullScreen) map.addControl(new $e3ab01f0a01d866a$export$2e2bcd8739ae039({}));
    if (options.addGeocode) $6262b9769c5759db$exports.addSearch(map);
    return map;
}
$cc12fb92b6cb9cf8$exports.quickMapBase = $cc12fb92b6cb9cf8$var$quickMapBase;
$cc12fb92b6cb9cf8$var$nm.quickMapBase = $cc12fb92b6cb9cf8$var$quickMapBase;
$cc12fb92b6cb9cf8$exports.default = $cc12fb92b6cb9cf8$var$quickMapBase;



var $4f69e05c18d35e9e$exports = {};
"use strict";
/**
 * Created by gavorhes on 11/3/2015.
 */ Object.defineProperty($4f69e05c18d35e9e$exports, "__esModule", {
    value: true
});
$4f69e05c18d35e9e$exports.mapMove = void 0;
var $17f5a264a47e119e$exports = {};
"use strict";
var $17f5a264a47e119e$var$__extends = $17f5a264a47e119e$exports && $17f5a264a47e119e$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($17f5a264a47e119e$exports, "__esModule", {
    value: true
});
$17f5a264a47e119e$exports.MapMoveCls = void 0;
var $d251620f6509e6d8$exports = {};
"use strict";
Object.defineProperty($d251620f6509e6d8$exports, "__esModule", {
    value: true
});
$d251620f6509e6d8$exports.MapInteractionBase = void 0;

var $d251620f6509e6d8$var$nm = $c45303ef5b6fbfc7$exports.default("olHelpers");
/**
 * base interaction
 */ var $d251620f6509e6d8$var$MapInteractionBase = /** @class */ function() {
    /**
     * map interaction base
     * @param subtype - the interaction subtype
     */ function MapInteractionBase(subtype) {
        this._map = null;
        this._initialized = false;
        this._subtype = subtype;
    }
    /**
     * base initializer, returns true for already initialized
     * @param theMap - the ol Map
     * @returns true for already initialized
     */ MapInteractionBase.prototype.init = function(theMap) {
        if (!this._initialized) {
            this._map = theMap;
            this._initialized = true;
        }
    };
    Object.defineProperty(MapInteractionBase.prototype, "map", {
        /**
         * get reference to the ol map object
         * @returns {ol.Map} the map object
         */ get: function() {
            return this._map;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MapInteractionBase.prototype, "initialized", {
        /**
         * get if is initialized
         * @returns {boolean} is initialized
         */ get: function() {
            return this._initialized;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Check the initialization status and throw exception if not valid yet
     * @protected
     */ MapInteractionBase.prototype._checkInit = function() {
        if (!this.initialized) {
            var msg = this._subtype + " object not initialized";
            alert(msg);
            console.log(msg);
            throw msg;
        }
    };
    /**
     * Check the initialization status and throw exception if not valid yet
     */ MapInteractionBase.prototype.checkInit = function() {
        this._checkInit();
    };
    return MapInteractionBase;
}();
$d251620f6509e6d8$exports.MapInteractionBase = $d251620f6509e6d8$var$MapInteractionBase;
$d251620f6509e6d8$var$nm.MapInteractionBase = $d251620f6509e6d8$var$MapInteractionBase;
$d251620f6509e6d8$exports.default = $d251620f6509e6d8$var$MapInteractionBase;


var $a0e04111c968a5b3$exports = {};
"use strict";
Object.defineProperty($a0e04111c968a5b3$exports, "__esModule", {
    value: true
});
$a0e04111c968a5b3$exports.definedAndNotNull = $a0e04111c968a5b3$exports.undefinedOrNull = void 0;

var $a0e04111c968a5b3$var$nm = $c45303ef5b6fbfc7$exports.default("util.checkDefined");
/**
 * check if the input is undefined or null
 * @param input - input pointer
 * @returns true undefined or null
 */ function $a0e04111c968a5b3$var$undefinedOrNull(input) {
    "use strict";
    return typeof input === "undefined" || input === null;
}
$a0e04111c968a5b3$exports.undefinedOrNull = $a0e04111c968a5b3$var$undefinedOrNull;
$a0e04111c968a5b3$var$nm.undefinedOrNull = $a0e04111c968a5b3$var$undefinedOrNull;
/**
 * check if the input is defined and not null
 * @param input - input pointer
 * @returns true defined and not null
 */ function $a0e04111c968a5b3$var$definedAndNotNull(input) {
    "use strict";
    return !$a0e04111c968a5b3$var$undefinedOrNull(input);
}
$a0e04111c968a5b3$exports.definedAndNotNull = $a0e04111c968a5b3$var$definedAndNotNull;
$a0e04111c968a5b3$var$nm.definedAndNotNull = $a0e04111c968a5b3$var$definedAndNotNull;



var $68981f1a81adf307$exports = {};
"use strict";
/**
 * Created by gavorhes on 11/3/2015.
 */ Object.defineProperty($68981f1a81adf307$exports, "__esModule", {
    value: true
});
$68981f1a81adf307$exports.makeGuid = void 0;

var $68981f1a81adf307$var$nm = $c45303ef5b6fbfc7$exports.default("util");
/**
 * guids are used to uniquely identify groups and features
 * @returns {string} a new guid
 */ function $68981f1a81adf307$var$makeGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
$68981f1a81adf307$exports.makeGuid = $68981f1a81adf307$var$makeGuid;
$68981f1a81adf307$var$nm.makeGuid = $68981f1a81adf307$var$makeGuid;
$68981f1a81adf307$exports.default = $68981f1a81adf307$var$makeGuid;



var $17f5a264a47e119e$var$nm = $c45303ef5b6fbfc7$exports.default("olHelpers");
/**
 * assists with map move interactions, trigger callback functions
 * @augments MapInteractionBase
 */ var $17f5a264a47e119e$var$MapMoveCls = /** @class */ function(_super) {
    $17f5a264a47e119e$var$__extends(MapMoveCls, _super);
    /**
     * constructor called implicitly
     */ function MapMoveCls() {
        var _this = _super.call(this, "map move") || this;
        _this._arrLyrRequest = [];
        _this._arrLyrTimeout = [];
        _this._arrLayer = [];
        _this._lookupLayer = {};
        _this._mapMoveCallbacks = [];
        _this._mapMoveCallbacksLookup = {};
        _this._mapMoveCallbackDelays = [];
        _this._mapMoveCallbackContext = [];
        _this._mapMoveCallbackTimeout = [];
        _this._mapExtent = undefined;
        _this._zoomLevel = undefined;
        return _this;
    }
    /**
     * initialize the map move object
     * @param theMap - the ol map
     */ MapMoveCls.prototype.init = function(theMap) {
        var _this = this;
        _super.prototype.init.call(this, theMap);
        this.map.getView().on([
            "change:center",
            "change:resolution"
        ], function(e) {
            _this._updateMapExtent();
            // trigger the layer updates
            for(var i = 0; i < _this._arrLayer.length; i++)_this.triggerLyrLoad(_this._arrLayer[i], i, e.type);
            // trigger the map callbacks
            for(var i = 0; i < _this._mapMoveCallbacks.length; i++)_this.triggerMoveCallback(i, e.type);
        });
    };
    MapMoveCls.prototype._updateMapExtent = function() {
        var theView = this.map.getView();
        this._zoomLevel = theView.getZoom();
        var extentArray = theView.calculateExtent(this.map.getSize());
        this._mapExtent = {
            minX: extentArray[0],
            minY: extentArray[1],
            maxX: extentArray[2],
            maxY: extentArray[3]
        };
    };
    Object.defineProperty(MapMoveCls.prototype, "mapExtent", {
        /**
         * return the map extent
         */ get: function() {
            if (!this._mapExtent) this._updateMapExtent();
            return this._mapExtent;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Trigger the layer load
     * @param lyr the layer being acted on
     * @param index index of the layer
     * @param eventType the event triggering the load, as 'change:center' or 'change:resolution'
     */ MapMoveCls.prototype.triggerLyrLoad = function(lyr, index, eventType) {
        if ($a0e04111c968a5b3$exports.undefinedOrNull(lyr) && $a0e04111c968a5b3$exports.undefinedOrNull(index)) throw "need to define lyr or index";
        else if ($a0e04111c968a5b3$exports.definedAndNotNull(lyr) && $a0e04111c968a5b3$exports.undefinedOrNull(index)) index = this._arrLayer.indexOf(lyr);
        else if ($a0e04111c968a5b3$exports.undefinedOrNull(lyr) && $a0e04111c968a5b3$exports.definedAndNotNull(index)) lyr = this._arrLayer[index];
        // clear the timeout
        if (this._arrLyrTimeout[index] != null) {
            clearTimeout(this._arrLyrTimeout[index]);
            this._arrLyrTimeout[index] = null;
        }
        // abort if necessary and clear the request
        if (this._arrLyrRequest[index] != null && this._arrLyrRequest[index] != 4) {
            this._arrLyrRequest[index].abort();
            this._arrLyrRequest[index] = null;
        }
        // dummy callback used if before load returns false
        var callbackFunc = function() {};
        if (lyr.mapMoveBefore(this._zoomLevel, eventType)) {
            lyr.mapMoveMakeGetParams(this._mapExtent, this._zoomLevel);
            var __this_1 = this;
            callbackFunc = function() {
                function innerFunction(theLayer, theIndex) {
                    var _innerThis = this;
                    this._arrLyrRequest[theIndex] = $dc57b31f1b066f38$exports.get(theLayer.url, theLayer.mapMoveParams, function(d) {
                        /**
                         * @type {LayerBaseVector}
                         */ theLayer.mapMoveCallback(d);
                        theLayer.loadCallback();
                    }, "json").fail(function(jqXHR) {
                        if (jqXHR.statusText != "abort") {
                            console.log("failed");
                            console.log(theLayer.url);
                            console.log(theLayer.mapMoveParams);
                        }
                    }).always(function() {
                        _innerThis._arrLyrTimeout[theIndex] = null;
                        _innerThis._arrLyrRequest[theIndex] = null;
                    });
                }
                innerFunction.call(__this_1, lyr, index);
            };
        } else lyr.clear();
        this._arrLyrTimeout[index] = setTimeout(callbackFunc, lyr.onDemandDelay);
    };
    /**
     * trigger the map move call back at the given index
     * @param ind - the index of the layer
     * @param eventType=undefined the event triggering the load as 'change:center' or 'change:resolution'
     * @param functionId=undefined the function id used to reference the added callback function
     */ MapMoveCls.prototype.triggerMoveCallback = function(ind, eventType, functionId) {
        if (typeof ind == "undefined" && typeof functionId == "undefined") throw "either the function index or the id must be defined";
        if (typeof ind !== "number") ind = this._mapMoveCallbacks.indexOf(this._mapMoveCallbacksLookup[functionId]);
        if (ind < 0) {
            console.log("function not found");
            return;
        }
        // clear the timeout
        if (this._mapMoveCallbackTimeout[ind] != null) {
            clearTimeout(this._mapMoveCallbackTimeout[ind]);
            this._mapMoveCallbackTimeout[ind] = null;
        }
        var ctx = this._mapMoveCallbackContext[ind];
        var theFunc = this._mapMoveCallbacks[ind];
        var __this = this;
        var f = function() {
            if (ctx !== null) theFunc.call(ctx, __this._mapExtent, __this._zoomLevel, eventType);
            else theFunc(__this._mapExtent, __this._zoomLevel, eventType);
        };
        this._mapMoveCallbackTimeout[ind] = setTimeout(f, this._mapMoveCallbackDelays[ind]);
    };
    /**
     * Add a layer to the interaction
     * @param  lyr - layer to add
     * @param triggerOnAdd - if the layer should be loaded on add
     */ MapMoveCls.prototype.addVectorLayer = function(lyr, triggerOnAdd) {
        if (triggerOnAdd === void 0) triggerOnAdd = true;
        if (this._arrLayer.indexOf(lyr) > -1) {
            console.log("already added " + lyr.name + " to map move");
            return;
        }
        this._checkInit();
        this._arrLyrRequest.push(null);
        this._arrLyrTimeout.push(null);
        this._arrLayer.push(lyr);
        this._lookupLayer[lyr.id] = lyr;
        triggerOnAdd = typeof triggerOnAdd == "boolean" ? triggerOnAdd : true;
        if (triggerOnAdd) {
            if (this._mapExtent === undefined) this._updateMapExtent();
            this.triggerLyrLoad(lyr, this._arrLayer.length - 1);
        }
    };
    /**
     * add a callback to the map move event
     * @param func - callback function
     * @param context - the context to use for this function
     * @param delay=50 the delay before call load
     * @param triggerOnAdd if the layer should be loaded on add to mapMove
     * @param functionId optional id to reference the function later for outside triggering
     */ MapMoveCls.prototype.addCallback = function(func, context, delay, triggerOnAdd, functionId) {
        if (this._mapMoveCallbacks.indexOf(func) > -1) {
            console.log("this function already added to map move");
            return;
        }
        this._checkInit();
        if (!functionId) functionId = $68981f1a81adf307$exports.default();
        this._mapMoveCallbacks.push(func);
        this._mapMoveCallbacksLookup[functionId] = func;
        this._mapMoveCallbackDelays.push(typeof delay == "number" ? delay : 50);
        this._mapMoveCallbackContext.push($a0e04111c968a5b3$exports.definedAndNotNull(context) ? context : null);
        this._mapMoveCallbackTimeout.push(null);
        triggerOnAdd = typeof triggerOnAdd == "boolean" ? triggerOnAdd : true;
        if (triggerOnAdd) {
            if (this._mapExtent === undefined) this._updateMapExtent();
            this.triggerMoveCallback(this._mapMoveCallbacks.length - 1);
        }
    };
    return MapMoveCls;
}($d251620f6509e6d8$exports.default);
$17f5a264a47e119e$exports.MapMoveCls = $17f5a264a47e119e$var$MapMoveCls;
$17f5a264a47e119e$var$nm.MapMoveCls = $17f5a264a47e119e$var$MapMoveCls;
$17f5a264a47e119e$exports.default = $17f5a264a47e119e$var$MapMoveCls;


/**
 * The single map move object catch is that it is common to multimap pages
 * @type {MapMoveCls}
 */ $4f69e05c18d35e9e$exports.mapMove = new $17f5a264a47e119e$exports.default();
$4f69e05c18d35e9e$exports.default = $4f69e05c18d35e9e$exports.mapMove;


var $82cfea7f148fe920$exports = {};
"use strict";
/**
 * Created by gavorhes on 11/3/2015.
 */ Object.defineProperty($82cfea7f148fe920$exports, "__esModule", {
    value: true
});
$82cfea7f148fe920$exports.mapPopup = void 0;
var $43e2701f532cd203$exports = {};
"use strict";
/**
 * Created by gavorhes on 11/3/2015.
 */ var $43e2701f532cd203$var$__extends = $43e2701f532cd203$exports && $43e2701f532cd203$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($43e2701f532cd203$exports, "__esModule", {
    value: true
});
$43e2701f532cd203$exports.MapPopupCls = $43e2701f532cd203$exports.FeatureLayerProperties = void 0;





/**
 * @module ol/Overlay
 */ 

/**
 * @module ol/OverlayPositioning
 */ /**
 * Overlay position: `'bottom-left'`, `'bottom-center'`,  `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, `'top-right'`
 * @enum {string}
 */ var $ff1e582d3732f9f8$export$2e2bcd8739ae039 = {
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_CENTER: "bottom-center",
    BOTTOM_RIGHT: "bottom-right",
    CENTER_LEFT: "center-left",
    CENTER_CENTER: "center-center",
    CENTER_RIGHT: "center-right",
    TOP_LEFT: "top-left",
    TOP_CENTER: "top-center",
    TOP_RIGHT: "top-right"
};






/**
 * @typedef {Object} Options
 * @property {number|string} [id] Set the overlay id. The overlay id can be used
 * with the {@link module:ol/Map~Map#getOverlayById} method.
 * @property {HTMLElement} [element] The overlay element.
 * @property {Array<number>} [offset=[0, 0]] Offsets in pixels used when positioning
 * the overlay. The first element in the
 * array is the horizontal offset. A positive value shifts the overlay right.
 * The second element in the array is the vertical offset. A positive value
 * shifts the overlay down.
 * @property {import("./coordinate.js").Coordinate} [position] The overlay position
 * in map projection.
 * @property {OverlayPositioning} [positioning='top-left'] Defines how
 * the overlay is actually positioned with respect to its `position` property.
 * Possible values are `'bottom-left'`, `'bottom-center'`, `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, and `'top-right'`.
 * @property {boolean} [stopEvent=true] Whether event propagation to the map
 * viewport should be stopped. If `true` the overlay is placed in the same
 * container as that of the controls (CSS class name
 * `ol-overlaycontainer-stopevent`); if `false` it is placed in the container
 * with CSS class name specified by the `className` property.
 * @property {boolean} [insertFirst=true] Whether the overlay is inserted first
 * in the overlay container, or appended. If the overlay is placed in the same
 * container as that of the controls (see the `stopEvent` option) you will
 * probably set `insertFirst` to `true` so the overlay is displayed below the
 * controls.
 * @property {boolean} [autoPan=false] If set to `true` the map is panned when
 * calling `setPosition`, so that the overlay is entirely visible in the current
 * viewport.
 * @property {PanOptions} [autoPanAnimation] The
 * animation options used to pan the overlay into view. This animation is only
 * used when `autoPan` is enabled. A `duration` and `easing` may be provided to
 * customize the animation.
 * @property {number} [autoPanMargin=20] The margin (in pixels) between the
 * overlay and the borders of the map when autopanning.
 * @property {string} [className='ol-overlay-container ol-selectable'] CSS class
 * name.
 */ /**
 * @typedef {Object} PanOptions
 * @property {number} [duration=1000] The duration of the animation in
 * milliseconds.
 * @property {function(number):number} [easing] The easing function to use. Can
 * be one from {@link module:ol/easing} or a custom function.
 * Default is {@link module:ol/easing~inAndOut}.
 */ /**
 * @enum {string}
 * @protected
 */ var $e43d9a501c20ce7e$var$Property = {
    ELEMENT: "element",
    MAP: "map",
    OFFSET: "offset",
    POSITION: "position",
    POSITIONING: "positioning"
};
/**
 * @classdesc
 * An element to be displayed over the map and attached to a single map
 * location.  Like {@link module:ol/control/Control~Control}, Overlays are
 * visible widgets. Unlike Controls, they are not in a fixed position on the
 * screen, but are tied to a geographical coordinate, so panning the map will
 * move an Overlay but not a Control.
 *
 * Example:
 *
 *     import Overlay from 'ol/Overlay';
 *
 *     var popup = new Overlay({
 *       element: document.getElementById('popup')
 *     });
 *     popup.setPosition(coordinate);
 *     map.addOverlay(popup);
 *
 * @api
 */ var $e43d9a501c20ce7e$var$Overlay = /*@__PURE__*/ function(BaseObject) {
    function Overlay(options) {
        BaseObject.call(this);
        /**
     * @protected
     * @type {Options}
     */ this.options = options;
        /**
     * @protected
     * @type {number|string|undefined}
     */ this.id = options.id;
        /**
     * @protected
     * @type {boolean}
     */ this.insertFirst = options.insertFirst !== undefined ? options.insertFirst : true;
        /**
     * @protected
     * @type {boolean}
     */ this.stopEvent = options.stopEvent !== undefined ? options.stopEvent : true;
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = document.createElement("div");
        this.element.className = options.className !== undefined ? options.className : "ol-overlay-container " + (0, $bbcb4c1977b6e9f0$export$99b49471b0394319);
        this.element.style.position = "absolute";
        /**
     * @protected
     * @type {boolean}
     */ this.autoPan = options.autoPan !== undefined ? options.autoPan : false;
        /**
     * @protected
     * @type {PanOptions}
     */ this.autoPanAnimation = options.autoPanAnimation || /** @type {PanOptions} */ {};
        /**
     * @protected
     * @type {number}
     */ this.autoPanMargin = options.autoPanMargin !== undefined ? options.autoPanMargin : 20;
        /**
     * @protected
     * @type {{bottom_: string,
     *         left_: string,
     *         right_: string,
     *         top_: string,
     *         visible: boolean}}
     */ this.rendered = {
            bottom_: "",
            left_: "",
            right_: "",
            top_: "",
            visible: true
        };
        /**
     * @protected
     * @type {?import("./events.js").EventsKey}
     */ this.mapPostrenderListenerKey = null;
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)($e43d9a501c20ce7e$var$Property.ELEMENT), this.handleElementChanged, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)($e43d9a501c20ce7e$var$Property.MAP), this.handleMapChanged, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)($e43d9a501c20ce7e$var$Property.OFFSET), this.handleOffsetChanged, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)($e43d9a501c20ce7e$var$Property.POSITION), this.handlePositionChanged, this);
        (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $d575b598d09f57d3$export$1ae67e5877b1d378)($e43d9a501c20ce7e$var$Property.POSITIONING), this.handlePositioningChanged, this);
        if (options.element !== undefined) this.setElement(options.element);
        this.setOffset(options.offset !== undefined ? options.offset : [
            0,
            0
        ]);
        this.setPositioning(options.positioning !== undefined ? /** @type {OverlayPositioning} */ options.positioning : (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).TOP_LEFT);
        if (options.position !== undefined) this.setPosition(options.position);
    }
    if (BaseObject) Overlay.__proto__ = BaseObject;
    Overlay.prototype = Object.create(BaseObject && BaseObject.prototype);
    Overlay.prototype.constructor = Overlay;
    /**
   * Get the DOM element of this overlay.
   * @return {HTMLElement|undefined} The Element containing the overlay.
   * @observable
   * @api
   */ Overlay.prototype.getElement = function getElement() {
        return /** @type {HTMLElement|undefined} */ this.get($e43d9a501c20ce7e$var$Property.ELEMENT);
    };
    /**
   * Get the overlay identifier which is set on constructor.
   * @return {number|string|undefined} Id.
   * @api
   */ Overlay.prototype.getId = function getId() {
        return this.id;
    };
    /**
   * Get the map associated with this overlay.
   * @return {import("./PluggableMap.js").default|undefined} The map that the
   * overlay is part of.
   * @observable
   * @api
   */ Overlay.prototype.getMap = function getMap() {
        return /** @type {import("./PluggableMap.js").default|undefined} */ this.get($e43d9a501c20ce7e$var$Property.MAP);
    };
    /**
   * Get the offset of this overlay.
   * @return {Array<number>} The offset.
   * @observable
   * @api
   */ Overlay.prototype.getOffset = function getOffset() {
        return /** @type {Array<number>} */ this.get($e43d9a501c20ce7e$var$Property.OFFSET);
    };
    /**
   * Get the current position of this overlay.
   * @return {import("./coordinate.js").Coordinate|undefined} The spatial point that the overlay is
   *     anchored at.
   * @observable
   * @api
   */ Overlay.prototype.getPosition = function getPosition() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get($e43d9a501c20ce7e$var$Property.POSITION);
    };
    /**
   * Get the current positioning of this overlay.
   * @return {OverlayPositioning} How the overlay is positioned
   *     relative to its point on the map.
   * @observable
   * @api
   */ Overlay.prototype.getPositioning = function getPositioning() {
        return /** @type {OverlayPositioning} */ this.get($e43d9a501c20ce7e$var$Property.POSITIONING);
    };
    /**
   * @protected
   */ Overlay.prototype.handleElementChanged = function handleElementChanged() {
        (0, $755a3001f896bcf1$export$1e1c9bf5a4ffe0d1)(this.element);
        var element = this.getElement();
        if (element) this.element.appendChild(element);
    };
    /**
   * @protected
   */ Overlay.prototype.handleMapChanged = function handleMapChanged() {
        if (this.mapPostrenderListenerKey) {
            (0, $755a3001f896bcf1$export$1d0aa160432dfea5)(this.element);
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.mapPostrenderListenerKey);
            this.mapPostrenderListenerKey = null;
        }
        var map = this.getMap();
        if (map) {
            this.mapPostrenderListenerKey = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(map, (0, $392290a16437301e$export$2e2bcd8739ae039).POSTRENDER, this.render, this);
            this.updatePixelPosition();
            var container = this.stopEvent ? map.getOverlayContainerStopEvent() : map.getOverlayContainer();
            if (this.insertFirst) container.insertBefore(this.element, container.childNodes[0] || null);
            else container.appendChild(this.element);
        }
    };
    /**
   * @protected
   */ Overlay.prototype.render = function render() {
        this.updatePixelPosition();
    };
    /**
   * @protected
   */ Overlay.prototype.handleOffsetChanged = function handleOffsetChanged() {
        this.updatePixelPosition();
    };
    /**
   * @protected
   */ Overlay.prototype.handlePositionChanged = function handlePositionChanged() {
        this.updatePixelPosition();
        if (this.get($e43d9a501c20ce7e$var$Property.POSITION) && this.autoPan) this.panIntoView();
    };
    /**
   * @protected
   */ Overlay.prototype.handlePositioningChanged = function handlePositioningChanged() {
        this.updatePixelPosition();
    };
    /**
   * Set the DOM element to be associated with this overlay.
   * @param {HTMLElement|undefined} element The Element containing the overlay.
   * @observable
   * @api
   */ Overlay.prototype.setElement = function setElement(element) {
        this.set($e43d9a501c20ce7e$var$Property.ELEMENT, element);
    };
    /**
   * Set the map to be associated with this overlay.
   * @param {import("./PluggableMap.js").default|undefined} map The map that the
   * overlay is part of.
   * @observable
   * @api
   */ Overlay.prototype.setMap = function setMap(map) {
        this.set($e43d9a501c20ce7e$var$Property.MAP, map);
    };
    /**
   * Set the offset for this overlay.
   * @param {Array<number>} offset Offset.
   * @observable
   * @api
   */ Overlay.prototype.setOffset = function setOffset(offset) {
        this.set($e43d9a501c20ce7e$var$Property.OFFSET, offset);
    };
    /**
   * Set the position for this overlay. If the position is `undefined` the
   * overlay is hidden.
   * @param {import("./coordinate.js").Coordinate|undefined} position The spatial point that the overlay
   *     is anchored at.
   * @observable
   * @api
   */ Overlay.prototype.setPosition = function setPosition(position) {
        this.set($e43d9a501c20ce7e$var$Property.POSITION, position);
    };
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary).
   * @protected
   */ Overlay.prototype.panIntoView = function panIntoView() {
        var map = this.getMap();
        if (!map || !map.getTargetElement()) return;
        var mapRect = this.getRect(map.getTargetElement(), map.getSize());
        var element = this.getElement();
        var overlayRect = this.getRect(element, [
            (0, $755a3001f896bcf1$export$e823f88e4111159a)(element),
            (0, $755a3001f896bcf1$export$fc5b8aac72846d1e)(element)
        ]);
        var margin = this.autoPanMargin;
        if (!(0, $7e819822b33b3d32$export$be866b1e0809b17e)(mapRect, overlayRect)) {
            // the overlay is not completely inside the viewport, so pan the map
            var offsetLeft = overlayRect[0] - mapRect[0];
            var offsetRight = mapRect[2] - overlayRect[2];
            var offsetTop = overlayRect[1] - mapRect[1];
            var offsetBottom = mapRect[3] - overlayRect[3];
            var delta = [
                0,
                0
            ];
            if (offsetLeft < 0) // move map to the left
            delta[0] = offsetLeft - margin;
            else if (offsetRight < 0) // move map to the right
            delta[0] = Math.abs(offsetRight) + margin;
            if (offsetTop < 0) // move map up
            delta[1] = offsetTop - margin;
            else if (offsetBottom < 0) // move map down
            delta[1] = Math.abs(offsetBottom) + margin;
            if (delta[0] !== 0 || delta[1] !== 0) {
                var center = /** @type {import("./coordinate.js").Coordinate} */ map.getView().getCenter();
                var centerPx = map.getPixelFromCoordinate(center);
                var newCenterPx = [
                    centerPx[0] + delta[0],
                    centerPx[1] + delta[1]
                ];
                map.getView().animate({
                    center: map.getCoordinateFromPixel(newCenterPx),
                    duration: this.autoPanAnimation.duration,
                    easing: this.autoPanAnimation.easing
                });
            }
        }
    };
    /**
   * Get the extent of an element relative to the document
   * @param {HTMLElement|undefined} element The element.
   * @param {import("./size.js").Size|undefined} size The size of the element.
   * @return {import("./extent.js").Extent} The extent.
   * @protected
   */ Overlay.prototype.getRect = function getRect(element, size) {
        var box = element.getBoundingClientRect();
        var offsetX = box.left + window.pageXOffset;
        var offsetY = box.top + window.pageYOffset;
        return [
            offsetX,
            offsetY,
            offsetX + size[0],
            offsetY + size[1]
        ];
    };
    /**
   * Set the positioning for this overlay.
   * @param {OverlayPositioning} positioning how the overlay is
   *     positioned relative to its point on the map.
   * @observable
   * @api
   */ Overlay.prototype.setPositioning = function setPositioning(positioning) {
        this.set($e43d9a501c20ce7e$var$Property.POSITIONING, positioning);
    };
    /**
   * Modify the visibility of the element.
   * @param {boolean} visible Element visibility.
   * @protected
   */ Overlay.prototype.setVisible = function setVisible(visible) {
        if (this.rendered.visible !== visible) {
            this.element.style.display = visible ? "" : "none";
            this.rendered.visible = visible;
        }
    };
    /**
   * Update pixel position.
   * @protected
   */ Overlay.prototype.updatePixelPosition = function updatePixelPosition() {
        var map = this.getMap();
        var position = this.getPosition();
        if (!map || !map.isRendered() || !position) {
            this.setVisible(false);
            return;
        }
        var pixel = map.getPixelFromCoordinate(position);
        var mapSize = map.getSize();
        this.updateRenderedPosition(pixel, mapSize);
    };
    /**
   * @param {import("./pixel.js").Pixel} pixel The pixel location.
   * @param {import("./size.js").Size|undefined} mapSize The map size.
   * @protected
   */ Overlay.prototype.updateRenderedPosition = function updateRenderedPosition(pixel, mapSize) {
        var style = this.element.style;
        var offset = this.getOffset();
        var positioning = this.getPositioning();
        this.setVisible(true);
        var offsetX = offset[0];
        var offsetY = offset[1];
        if (positioning == (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).BOTTOM_RIGHT || positioning == (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).CENTER_RIGHT || positioning == (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).TOP_RIGHT) {
            if (this.rendered.left_ !== "") this.rendered.left_ = style.left = "";
            var right = Math.round(mapSize[0] - pixel[0] - offsetX) + "px";
            if (this.rendered.right_ != right) this.rendered.right_ = style.right = right;
        } else {
            if (this.rendered.right_ !== "") this.rendered.right_ = style.right = "";
            if (positioning == (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).BOTTOM_CENTER || positioning == (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).CENTER_CENTER || positioning == (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).TOP_CENTER) offsetX -= this.element.offsetWidth / 2;
            var left = Math.round(pixel[0] + offsetX) + "px";
            if (this.rendered.left_ != left) this.rendered.left_ = style.left = left;
        }
        if (positioning == (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).BOTTOM_LEFT || positioning == (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).BOTTOM_CENTER || positioning == (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).BOTTOM_RIGHT) {
            if (this.rendered.top_ !== "") this.rendered.top_ = style.top = "";
            var bottom = Math.round(mapSize[1] - pixel[1] - offsetY) + "px";
            if (this.rendered.bottom_ != bottom) this.rendered.bottom_ = style.bottom = bottom;
        } else {
            if (this.rendered.bottom_ !== "") this.rendered.bottom_ = style.bottom = "";
            if (positioning == (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).CENTER_LEFT || positioning == (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).CENTER_CENTER || positioning == (0, $ff1e582d3732f9f8$export$2e2bcd8739ae039).CENTER_RIGHT) offsetY -= this.element.offsetHeight / 2;
            var top = Math.round(pixel[1] + offsetY) + "px";
            if (this.rendered.top_ != top) this.rendered.top_ = style.top = top;
        }
    };
    /**
   * returns the options this Overlay has been created with
   * @return {Options} overlay options
   */ Overlay.prototype.getOptions = function getOptions() {
        return this.options;
    };
    return Overlay;
}((0, $d575b598d09f57d3$export$2e2bcd8739ae039));
var $e43d9a501c20ce7e$export$2e2bcd8739ae039 = $e43d9a501c20ce7e$var$Overlay;




var $43e2701f532cd203$var$nm = $c45303ef5b6fbfc7$exports.default("olHelpers");
var $43e2701f532cd203$var$FeatureLayerProperties = /** @class */ function() {
    /**
     *
     * @param feature the feature
     * @param layer - the layer in the popup
     * @param layerIndex - index of the layer
     * @param selectionLayer - the ol selection layer
     * @param [esriLayerName=undefined] - esri layer name
     */ function FeatureLayerProperties(feature, layer, layerIndex, selectionLayer, esriLayerName) {
        this.feature = feature;
        this.layer = layer;
        this.layerIndex = layerIndex;
        this.selectionLayer = selectionLayer;
        this.popupContent = "";
        this.esriLayerName = typeof esriLayerName == "string" ? esriLayerName : undefined;
    }
    Object.defineProperty(FeatureLayerProperties.prototype, "layerName", {
        get: function() {
            if (typeof this.esriLayerName == "string") return this.esriLayerName;
            else return this.layer.name;
        },
        enumerable: false,
        configurable: true
    });
    return FeatureLayerProperties;
}();
$43e2701f532cd203$exports.FeatureLayerProperties = $43e2701f532cd203$var$FeatureLayerProperties;
/**
 * map popup class
 * @augments MapInteractionBase
 */ var $43e2701f532cd203$var$MapPopupCls = /** @class */ function(_super) {
    $43e2701f532cd203$var$__extends(MapPopupCls, _super);
    /**
     * Definition for openlayers style function
     * @callback olStyleFunction
     * &param feature the openlayers vector feature
     * $param
     */ /**
     * map popup constructor
     */ function MapPopupCls() {
        var _this = _super.call(this, "map popup") || this;
        _this._arrPopupLayerIds = [];
        _this._arrPopupLayers = [];
        // this._arrPopupOlLayers = [];
        _this._arrPopupContentFunction = [];
        _this._$popupContainer = undefined;
        _this._$popupContent = undefined;
        _this._$popupCloser = undefined;
        _this._popupOverlay = undefined;
        _this._selectionLayers = [];
        _this._selectionLayerLookup = {};
        _this._mapClickFunctions = [];
        //let a = function($jqueryContent){console.log($jqueryContent)};
        //this._popupChangedLookup = {'a': a};
        _this._popupChangedFunctions = [];
        _this._esriMapServiceLayers = [];
        _this._popupOpen = false;
        _this._popupCoordinate = null;
        _this._passThroughLayerFeatureArray = [];
        _this._currentPopupIndex = -1;
        _this._popupContentLength = 0;
        return _this;
    }
    /**
     * map popup initialization
     * @param  theMap - the ol map
     */ MapPopupCls.prototype.init = function(theMap) {
        var _this = this;
        _super.prototype.init.call(this, theMap);
        var $map;
        var target = this.map.getTarget();
        if (typeof target == "string") $map = $dc57b31f1b066f38$exports("#" + target);
        else $map = $dc57b31f1b066f38$exports(target);
        $map.append('<div class="ol-popup"><span class="ol-popup-closer">X</span><div class="popup-content"></div></div>');
        this._$popupContainer = $map.find(".ol-popup");
        this._$popupContent = $map.find(".popup-content");
        this._$popupCloser = $map.find(".ol-popup-closer");
        var _ease = function(n) {
            return $0164a93fcf6e65ad$export$9b47139b511b56e4(n);
        };
        this._popupOverlay = new $e43d9a501c20ce7e$export$2e2bcd8739ae039({
            element: this._$popupContainer[0],
            autoPan: true,
            autoPanAnimation: {
                duration: 250,
                source: theMap.getView().getCenter(),
                easing: _ease
            }
        });
        this._map.addOverlay(this._popupOverlay);
        this._$popupCloser.click(function(evt) {
            _this.closePopup();
        });
        // display popup on click
        this._map.on("singleclick", function(evt) {
            _this.closePopup();
            _this._popupCoordinate = evt["coordinate"];
            // esri map service layers
            if (_this._esriMapServiceLayers.length > 0) {
                var queryParams = {
                    geometry: evt["coordinate"].join(","),
                    geometryType: "esriGeometryPoint",
                    layers: "all",
                    sr: _this._map.getView().getProjection().getCode().split(":")[1],
                    mapExtent: _this._map.getView().calculateExtent(_this._map.getSize()).join(","),
                    imageDisplay: _this._map.getSize().join(",") + ",96",
                    returnGeometry: true,
                    tolerance: 15,
                    f: "pjson"
                };
                for(var _i = 0, _a = _this._esriMapServiceLayers; _i < _a.length; _i++){
                    var l = _a[_i];
                    l.getPopupInfo(queryParams);
                }
            }
            var layerFeatureObjectArray = _this._featuresAtPixel(evt["pixel"]);
            _this._passThroughLayerFeatureArray = [];
            _this._currentPopupIndex = -1;
            for(var i = 0; i < layerFeatureObjectArray.length; i++){
                var featObj = layerFeatureObjectArray[i];
                var props = featObj.feature.getProperties();
                var popupContentResponse = _this._arrPopupContentFunction[featObj.layerIndex](props, _this._$popupContent);
                //skip if return was false
                if (popupContentResponse === false) ;
                else if (typeof popupContentResponse == "string") {
                    featObj.popupContent = popupContentResponse;
                    _this._passThroughLayerFeatureArray.push(featObj);
                } else featObj.selectionLayer.getSource().addFeature(featObj.feature);
            }
            _this._popupContentLength = _this._passThroughLayerFeatureArray.length;
            _this._currentPopupIndex = -1;
            var popupHtml = '<div class="ol-popup-nav">';
            popupHtml += '<span class="previous-popup ol-popup-nav-arrow">&#9664;</span>';
            popupHtml += '<span class="next-popup ol-popup-nav-arrow">&#9654;</span>';
            popupHtml += '<span class="current-popup-item-number" style="font-weight: bold;"></span>';
            popupHtml += "<span>&nbsp;of&nbsp;</span>";
            popupHtml += '<span class="popup-content-length" style="font-weight: bold;">' + _this._popupContentLength + "</span>";
            popupHtml += "<span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>";
            popupHtml += '<span class="current-popup-layer-name"></span>';
            popupHtml += "</div>";
            popupHtml += '<div class="ol-popup-inner">';
            popupHtml += "</div>";
            _this._$popupContent.html(popupHtml);
            _this._$popupContent.find(".previous-popup").click(function() {
                if (_this._popupContentLength == 1) return;
                if (_this._currentPopupIndex == 0) _this._currentPopupIndex = _this._popupContentLength - 1;
                else _this._currentPopupIndex--;
                _this._triggerFeatSelect();
            });
            var nextPopup = _this._$popupContent.find(".next-popup");
            nextPopup.click(function() {
                if (_this._popupContentLength == 1 && _this._currentPopupIndex > -1) return;
                if (_this._currentPopupIndex == _this._popupContentLength - 1) _this._currentPopupIndex = 0;
                else _this._currentPopupIndex++;
                _this._triggerFeatSelect();
            });
            if (_this._popupContentLength > 0) {
                nextPopup.trigger("click");
                _this._popupOverlay.setPosition(_this._popupCoordinate);
                _this._$popupContent.scrollTop(0);
                _this._popupOpen = true;
            }
        });
        //change mouse cursor when over marker
        this._map.on("pointermove", function(evt) {
            if (evt["dragging"]) return;
            var pixel = _this.map.getEventPixel(evt["originalEvent"]);
            var hit = false;
            _this.map.forEachFeatureAtPixel(pixel, function(f, l) {
                if (hit) return;
                for(var _i = 0, _a = _this._arrPopupLayers; _i < _a.length; _i++){
                    var vLyr = _a[_i];
                    if (vLyr.olLayer == l) {
                        hit = true;
                        break;
                    }
                }
            });
            var mapElement = _this.map.getTargetElement();
            mapElement.style.cursor = hit ? "pointer" : "";
        });
    };
    /**
     * helper to select features
     * @private
     */ MapPopupCls.prototype._triggerFeatSelect = function() {
        var $currentPopupItemNumber = this._$popupContent.find(".current-popup-item-number");
        var $innerPopup = this._$popupContent.find(".ol-popup-inner");
        var $layerNameSpan = this._$popupContent.find(".current-popup-layer-name");
        this.clearSelection();
        var lyrFeatObj = this._passThroughLayerFeatureArray[this._currentPopupIndex];
        $currentPopupItemNumber.html((this._currentPopupIndex + 1).toFixed());
        $layerNameSpan.html(lyrFeatObj.layerName);
        $innerPopup.html(lyrFeatObj.popupContent);
        lyrFeatObj.selectionLayer.getSource().addFeature(lyrFeatObj.feature);
        for(var _i = 0, _a = this._popupChangedFunctions; _i < _a.length; _i++){
            var f = _a[_i];
            f(this._$popupContent);
        }
    };
    /**
     *
     * @param feature - the ol feature
     * @param {LayerEsriMapServer} lyr - the map server layer
     * @param {string} popupContent - popup content
     * @param {string} esriName - esri layer name
     */ MapPopupCls.prototype.addMapServicePopupContent = function(feature, lyr, popupContent, esriName) {
        var featLayerObject = new $43e2701f532cd203$var$FeatureLayerProperties(feature, lyr, this._popupContentLength, this._selectionLayerLookup[lyr.id], esriName);
        featLayerObject.popupContent = popupContent;
        this._passThroughLayerFeatureArray.push(featLayerObject);
        this._popupContentLength++;
        $dc57b31f1b066f38$exports(".popup-content-length").html(this._popupContentLength.toFixed());
        if (!this._popupOpen) {
            this._$popupContent.find(".next-popup").trigger("click");
            this._popupOverlay.setPosition(this._popupCoordinate);
            this._$popupContent.scrollTop(0);
            this._popupOpen = true;
        }
    };
    /**
     *
     * @param  pixel - the ol pixel
     * @returns  feature layer properties
     * @private
     */ MapPopupCls.prototype._featuresAtPixel = function(pixel) {
        var _this = this;
        var layerFeatureObjectArray = [];
        this.map.forEachFeatureAtPixel(pixel, function(feature, layer) {
            var hasLyr = false;
            var j;
            var lyr = null;
            for(j = 0; j < _this._arrPopupLayers.length; j++){
                lyr = _this._arrPopupLayers[j];
                if (lyr.olLayer === layer) {
                    hasLyr = true;
                    break;
                }
            }
            if (hasLyr) layerFeatureObjectArray.push(new $43e2701f532cd203$var$FeatureLayerProperties(feature, lyr, j, _this._selectionLayers[j]));
        });
        return layerFeatureObjectArray;
    };
    MapPopupCls.prototype.closePopup = function() {
        this._checkInit();
        this._popupOpen = false;
        this._popupOverlay.setPosition(undefined);
        this._$popupCloser[0].blur();
        this.clearSelection();
        this._$popupContent.html("");
        return false;
    };
    /**
     *
     * @param chgFunction - popup change function
     */ MapPopupCls.prototype.addPopupChangedFunction = function(chgFunction) {
        this._popupChangedFunctions.push(chgFunction);
    };
    /**
     *
     * @param {LayerBase|*} lyr - the layer being acted on
     * @param {object} [selectionStyle={}] the selection style configuration
     * @param {string} [selectionStyle.color=rgba(255,170,0,0.5)] the selection color
     * @param {number} [selectionStyle.width=10] the selection width for linear features
     * @param {object|function} [selectionStyle.olStyle=undefined] an openlayers style object or function
     * @returns  the new selection layer
     * @private
     */ MapPopupCls.prototype._addPopupLayer = function(lyr, selectionStyle) {
        this._checkInit();
        selectionStyle = selectionStyle || {};
        selectionStyle.color = selectionStyle.color || "rgba(255,170,0,0.5)";
        selectionStyle.width = selectionStyle.width || 10;
        var theStyle;
        if (selectionStyle.olStyle) theStyle = selectionStyle.olStyle;
        else theStyle = new $0f1ce378ea6946fc$export$2e2bcd8739ae039({
            stroke: new $9ed46f4c9b041e5d$export$2e2bcd8739ae039({
                color: selectionStyle.color,
                width: selectionStyle.width
            }),
            image: new $e163d3c698de5692$export$2e2bcd8739ae039({
                radius: 7,
                fill: new $d6fd3e0b0360ea29$export$2e2bcd8739ae039({
                    color: selectionStyle.color
                }),
                stroke: new $9ed46f4c9b041e5d$export$2e2bcd8739ae039({
                    color: selectionStyle.color,
                    width: 1
                })
            }),
            fill: new $d6fd3e0b0360ea29$export$2e2bcd8739ae039({
                color: selectionStyle.color
            })
        });
        var selectionLayer = new $09432eee05d1671f$export$2e2bcd8739ae039({
            source: new $69f8886165740064$export$2e2bcd8739ae039(),
            style: theStyle
        });
        selectionLayer.setZIndex(100);
        this._selectionLayers.push(selectionLayer);
        this._selectionLayerLookup[lyr.id] = selectionLayer;
        this.map.addLayer(selectionLayer);
        return selectionLayer;
    };
    /**
     * Add popup to the map
     * @param {LayerBase|*} lyr The layer that the popup with act on
     * @param {popupCallback} popupContentFunction - popup content function that makes popup info
     * @param {object} [selectionStyle={}] the selection style configuration
     * @param {string} [selectionStyle.color=rgba(255,170,0,0.5)] the selection color
     * @param {number} [selectionStyle.width=10] the selection width for linear features
     * @param {object|function} [selectionStyle.olStyle=undefined] an openlayers style object or function
     * @returns {object} a reference to the ol selection layer
     */ MapPopupCls.prototype.addVectorPopup = function(lyr, popupContentFunction, selectionStyle) {
        var selectionLayer = this._addPopupLayer(lyr, selectionStyle);
        this._arrPopupLayerIds.push(lyr.id);
        this._arrPopupLayers.push(lyr);
        // this._arrPopupOlLayers.push(lyr.olLayer);
        this._arrPopupContentFunction.push(popupContentFunction);
        return selectionLayer;
    };
    /**
     *
     * @param {LayerBase} lyr - layer
     */ MapPopupCls.prototype.removeVectorPopup = function(lyr) {
        var idx = this._arrPopupLayerIds.indexOf(lyr.id);
        if (idx > -1) {
            this._arrPopupLayerIds.splice(idx, 1);
            this._arrPopupLayers.splice(idx, 1);
            // this._arrPopupOlLayers.splice(idx, 1);
            this._arrPopupContentFunction.splice(idx, 1);
            this._selectionLayers.splice(idx, 1);
            delete this._selectionLayerLookup[lyr.id];
        }
    };
    /**
     *
     * @param {LayerEsriMapServer} lyr - map server layer
     * @param {object} [selectionStyle={}] the selection style configuration
     * @param {string} [selectionStyle.color=rgba(255,170,0,0.5)] the selection color
     * @param {number} [selectionStyle.width=10] the selection width for linear features
     * @param {object|function} [selectionStyle.olStyle=undefined] an openlayers style object or function
     * @returns {object} a reference to the ol selection layer
     */ MapPopupCls.prototype.addMapServicePopup = function(lyr, selectionStyle) {
        var selectionLayer = this._addPopupLayer(lyr, {
            olStyle: selectionStyle
        });
        this._esriMapServiceLayers.push(lyr);
        return selectionLayer;
    };
    MapPopupCls.prototype.clearSelection = function() {
        this._checkInit();
        for(var i = 0; i < this._selectionLayers.length; i++)this._selectionLayers[i].getSource().clear();
        for(var _i = 0, _a = this._mapClickFunctions; _i < _a.length; _i++){
            var f = _a[_i];
            f();
        }
    };
    /**
     * Add a function to be called when the map is clicked but before any popups are implemented
     * @param {function} func - the map click function
     */ MapPopupCls.prototype.addMapClickFunction = function(func) {
        this._mapClickFunctions.push(func);
    };
    return MapPopupCls;
}($d251620f6509e6d8$exports.default);
$43e2701f532cd203$exports.MapPopupCls = $43e2701f532cd203$var$MapPopupCls;
$43e2701f532cd203$var$nm.MapPopupCls = $43e2701f532cd203$var$MapPopupCls;
$43e2701f532cd203$exports.default = $43e2701f532cd203$var$MapPopupCls;


/**
 * The single popup object catch is that it is common to multimap pages
 * @type {MapPopupCls}
 */ $82cfea7f148fe920$exports.mapPopup = new $43e2701f532cd203$exports.default();
$82cfea7f148fe920$exports.default = $82cfea7f148fe920$exports.mapPopup;


var $b95b5545766c3f4f$var$nm = $c45303ef5b6fbfc7$exports.default("olHelpers");
/**
 * Sets up a map with some default parameters and initializes
 * mapMove and mapPopup
 *
 * @param {object} [options={}] config options
 * @param {string} [options.divId=map] map div id
 * @param {object} [options.center={}] center config object
 * @param {number} [options.center.x=-10018378] center x, web mercator x or lon
 * @param {number} [options.center.y=5574910] center y, web mercator y or lat
 * @param {number} [options.zoom=7] zoom level
 * @param {number} [options.minZoom=undefined] min zoom
 * @param {number} [options.maxZoom=undefined] max zoom
 * @param {boolean} [options.baseSwitcher=true] if add base map switcher
 * @param {boolean} [options.fullScreen=false] if add base map switcher
 * @returns {ol.Map} the ol map
 */ function $b95b5545766c3f4f$var$quickMap(options) {
    if (options === void 0) options = {};
    var m = $cc12fb92b6cb9cf8$exports.quickMapBase(options);
    $4f69e05c18d35e9e$exports.default.init(m);
    $82cfea7f148fe920$exports.default.init(m);
    return m;
}
$b95b5545766c3f4f$exports.quickMap = $b95b5545766c3f4f$var$quickMap;
$b95b5545766c3f4f$var$nm.quickMap = $b95b5545766c3f4f$var$quickMap;
$b95b5545766c3f4f$exports.default = $b95b5545766c3f4f$var$quickMap;


var $3da1ae41ec4e0382$exports = {};
"use strict";

$3da1ae41ec4e0382$exports = (parcelRequire("eW0mB"));


var $1c0f1e610963dfb8$exports = {};
"use strict";

$1c0f1e610963dfb8$exports = (parcelRequire("4SVKY"));


function $40f4c2feb843f2da$export$2e2bcd8739ae039(o, p) {
    $40f4c2feb843f2da$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $40f4c2feb843f2da$export$2e2bcd8739ae039(o, p);
}


function $c04286edcac4109a$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $40f4c2feb843f2da$export$2e2bcd8739ae039)(subClass, superClass);
}



var $b0c83d16b421d7f5$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0c83d16b421d7f5$var$ReactIs, $b0c83d16b421d7f5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$b0c83d16b421d7f5$exports = (parcelRequire("6DzO8"))();



var $c1fd227ec1675049$export$606287fac404e5cd = (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).shape({
    trySubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
    tryUnsubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
    notifyNestedSubs: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
    isSubscribed: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired
});
var $c1fd227ec1675049$export$666e7125cd4ae194 = (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).shape({
    subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
    dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
    getState: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired
});


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $a1da036e0434dc00$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


var $7fce8c6c059729e2$var$prefixUnsafeLifecycleMethods = typeof (0, (/*@__PURE__*/$parcel$interopDefault($3da1ae41ec4e0382$exports))).forwardRef !== "undefined";
var $7fce8c6c059729e2$var$didWarnAboutReceivingStore = false;
function $7fce8c6c059729e2$var$warnAboutReceivingStore() {
    if ($7fce8c6c059729e2$var$didWarnAboutReceivingStore) return;
    $7fce8c6c059729e2$var$didWarnAboutReceivingStore = true;
    (0, $a1da036e0434dc00$export$2e2bcd8739ae039)("<Provider> does not support changing `store` on the fly. It is most likely that you see this error because you updated to Redux 2.x and React Redux 2.x which no longer hot reload reducers automatically. See https://github.com/reduxjs/react-redux/releases/tag/v2.0.0 for the migration instructions.");
}
function $7fce8c6c059729e2$export$500fbc0cd14cdbaa(storeKey) {
    var _Provider$childContex;
    if (storeKey === void 0) storeKey = "store";
    var subscriptionKey = storeKey + "Subscription";
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $c04286edcac4109a$export$2e2bcd8739ae039)(Provider, _Component);
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
        };
        function Provider(props, context) {
            var _this;
            _this = _Component.call(this, props, context) || this;
            _this[storeKey] = props.store;
            return _this;
        }
        _proto.render = function render() {
            return (0, $3da1ae41ec4e0382$exports.Children).only(this.props.children);
        };
        return Provider;
    }((0, $3da1ae41ec4e0382$exports.Component));
    var eventName;
    Provider.propTypes = {
        store: (0, $c1fd227ec1675049$export$666e7125cd4ae194).isRequired,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).element.isRequired
    };
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = (0, $c1fd227ec1675049$export$666e7125cd4ae194).isRequired, _Provider$childContex[subscriptionKey] = (0, $c1fd227ec1675049$export$606287fac404e5cd), _Provider$childContex);
    return Provider;
}
var $7fce8c6c059729e2$export$2e2bcd8739ae039 = $7fce8c6c059729e2$export$500fbc0cd14cdbaa();



function $1054abeafa6bc7e1$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $e3e49ed681292e30$export$2e2bcd8739ae039() {
    $e3e49ed681292e30$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e3e49ed681292e30$export$2e2bcd8739ae039.apply(this, arguments);
}


function $cfde373be945f92b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $f550a03ccbc02dc9$exports = {};
"use strict";

var $1TAMD = parcelRequire("1TAMD");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $f550a03ccbc02dc9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f550a03ccbc02dc9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f550a03ccbc02dc9$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f550a03ccbc02dc9$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f550a03ccbc02dc9$var$TYPE_STATICS = {};
$f550a03ccbc02dc9$var$TYPE_STATICS[$1TAMD.ForwardRef] = $f550a03ccbc02dc9$var$FORWARD_REF_STATICS;
$f550a03ccbc02dc9$var$TYPE_STATICS[$1TAMD.Memo] = $f550a03ccbc02dc9$var$MEMO_STATICS;
function $f550a03ccbc02dc9$var$getStatics(component) {
    // React v16.11 and below
    if ($1TAMD.isMemo(component)) return $f550a03ccbc02dc9$var$MEMO_STATICS;
     // React v16.12 and above
    return $f550a03ccbc02dc9$var$TYPE_STATICS[component["$$typeof"]] || $f550a03ccbc02dc9$var$REACT_STATICS;
}
var $f550a03ccbc02dc9$var$defineProperty = Object.defineProperty;
var $f550a03ccbc02dc9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f550a03ccbc02dc9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f550a03ccbc02dc9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f550a03ccbc02dc9$var$getPrototypeOf = Object.getPrototypeOf;
var $f550a03ccbc02dc9$var$objectPrototype = Object.prototype;
function $f550a03ccbc02dc9$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($f550a03ccbc02dc9$var$objectPrototype) {
            var inheritedComponent = $f550a03ccbc02dc9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f550a03ccbc02dc9$var$objectPrototype) $f550a03ccbc02dc9$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $f550a03ccbc02dc9$var$getOwnPropertyNames(sourceComponent);
        if ($f550a03ccbc02dc9$var$getOwnPropertySymbols) keys = keys.concat($f550a03ccbc02dc9$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $f550a03ccbc02dc9$var$getStatics(targetComponent);
        var sourceStatics = $f550a03ccbc02dc9$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$f550a03ccbc02dc9$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $f550a03ccbc02dc9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $f550a03ccbc02dc9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$f550a03ccbc02dc9$exports = $f550a03ccbc02dc9$var$hoistNonReactStatics;


var $b7dd418d5ea4b2d4$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $b7dd418d5ea4b2d4$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$b7dd418d5ea4b2d4$exports = $b7dd418d5ea4b2d4$var$invariant;




var $1TAMD = parcelRequire("1TAMD");
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var $178e855991788f74$var$CLEARED = null;
var $178e855991788f74$var$nullListeners = {
    notify: function notify() {}
};
function $178e855991788f74$var$createListenerCollection() {
    // the current/next pattern is copied from redux's createStore code.
    // TODO: refactor+expose that code to be reusable here?
    var current = [];
    var next = [];
    return {
        clear: function clear() {
            next = $178e855991788f74$var$CLEARED;
            current = $178e855991788f74$var$CLEARED;
        },
        notify: function notify() {
            var listeners = current = next;
            for(var i = 0; i < listeners.length; i++)listeners[i]();
        },
        get: function get() {
            return next;
        },
        subscribe: function subscribe(listener) {
            var isSubscribed = true;
            if (next === current) next = current.slice();
            next.push(listener);
            return function unsubscribe() {
                if (!isSubscribed || current === $178e855991788f74$var$CLEARED) return;
                isSubscribed = false;
                if (next === current) next = current.slice();
                next.splice(next.indexOf(listener), 1);
            };
        }
    };
}
var $178e855991788f74$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscription(store, parentSub, onStateChange) {
        this.store = store;
        this.parentSub = parentSub;
        this.onStateChange = onStateChange;
        this.unsubscribe = null;
        this.listeners = $178e855991788f74$var$nullListeners;
    }
    var _proto = Subscription.prototype;
    _proto.addNestedSub = function addNestedSub(listener) {
        this.trySubscribe();
        return this.listeners.subscribe(listener);
    };
    _proto.notifyNestedSubs = function notifyNestedSubs() {
        this.listeners.notify();
    };
    _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.unsubscribe);
    };
    _proto.trySubscribe = function trySubscribe() {
        if (!this.unsubscribe) {
            this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
            this.listeners = $178e855991788f74$var$createListenerCollection();
        }
    };
    _proto.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
            this.listeners.clear();
            this.listeners = $178e855991788f74$var$nullListeners;
        }
    };
    return Subscription;
}();



var $7ba9029b4649a9cf$var$prefixUnsafeLifecycleMethods = typeof (0, (/*@__PURE__*/$parcel$interopDefault($3da1ae41ec4e0382$exports))).forwardRef !== "undefined";
var $7ba9029b4649a9cf$var$hotReloadingVersion = 0;
var $7ba9029b4649a9cf$var$dummyState = {};
function $7ba9029b4649a9cf$var$noop() {}
function $7ba9029b4649a9cf$var$makeSelectorStateful(sourceSelector, store) {
    // wrap the selector in an object that tracks its results between runs.
    var selector = {
        run: function runComponentSelector(props) {
            try {
                var nextProps = sourceSelector(store.getState(), props);
                if (nextProps !== selector.props || selector.error) {
                    selector.shouldComponentUpdate = true;
                    selector.props = nextProps;
                    selector.error = null;
                }
            } catch (error) {
                selector.shouldComponentUpdate = true;
                selector.error = error;
            }
        }
    };
    return selector;
}
function $7ba9029b4649a9cf$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    var _contextTypes, _childContextTypes;
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, connectOptions = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref2, [
        "getDisplayName",
        "methodName",
        "renderCountProp",
        "shouldHandleStateChanges",
        "storeKey",
        "withRef"
    ]);
    var subscriptionKey = storeKey + "Subscription";
    var version = $7ba9029b4649a9cf$var$hotReloadingVersion++;
    var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = (0, $c1fd227ec1675049$export$666e7125cd4ae194), _contextTypes[subscriptionKey] = (0, $c1fd227ec1675049$export$606287fac404e5cd), _contextTypes);
    var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = (0, $c1fd227ec1675049$export$606287fac404e5cd), _childContextTypes);
    return function wrapWithConnect(WrappedComponent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b7dd418d5ea4b2d4$exports)))((0, $1TAMD.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            withRef: withRef,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
        });
        var Connect = /*#__PURE__*/ function(_Component) {
            (0, $c04286edcac4109a$export$2e2bcd8739ae039)(Connect, _Component);
            function Connect(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.version = version;
                _this.state = {};
                _this.renderCount = 0;
                _this.store = props[storeKey] || context[storeKey];
                _this.propsMode = Boolean(props[storeKey]);
                _this.setWrappedInstance = _this.setWrappedInstance.bind((0, $1054abeafa6bc7e1$export$2e2bcd8739ae039)((0, $1054abeafa6bc7e1$export$2e2bcd8739ae039)(_this)));
                (0, (/*@__PURE__*/$parcel$interopDefault($b7dd418d5ea4b2d4$exports)))(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
                _this.initSelector();
                _this.initSubscription();
                return _this;
            }
            var _proto = Connect.prototype;
            _proto.getChildContext = function getChildContext() {
                var _ref3;
                // If this component received store from props, its subscription should be transparent
                // to any descendants receiving store+subscription from context; it passes along
                // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
                // Connect to control ordering of notifications to flow top-down.
                var subscription = this.propsMode ? null : this.subscription;
                return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
            };
            _proto.componentDidMount = function componentDidMount() {
                if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
                // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
                // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
                // To handle the case where a child component may have triggered a state change by
                // dispatching an action in its componentWillMount, we have to re-run the select and maybe
                // re-render.
                this.subscription.trySubscribe();
                this.selector.run(this.props);
                if (this.selector.shouldComponentUpdate) this.forceUpdate();
            }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0
            _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
                this.selector.run(nextProps);
            };
            _proto.shouldComponentUpdate = function shouldComponentUpdate() {
                return this.selector.shouldComponentUpdate;
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                if (this.subscription) this.subscription.tryUnsubscribe();
                this.subscription = null;
                this.notifyNestedSubs = $7ba9029b4649a9cf$var$noop;
                this.store = null;
                this.selector.run = $7ba9029b4649a9cf$var$noop;
                this.selector.shouldComponentUpdate = false;
            };
            _proto.getWrappedInstance = function getWrappedInstance() {
                (0, (/*@__PURE__*/$parcel$interopDefault($b7dd418d5ea4b2d4$exports)))(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
                return this.wrappedInstance;
            };
            _proto.setWrappedInstance = function setWrappedInstance(ref) {
                this.wrappedInstance = ref;
            };
            _proto.initSelector = function initSelector() {
                var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
                this.selector = $7ba9029b4649a9cf$var$makeSelectorStateful(sourceSelector, this.store);
                this.selector.run(this.props);
            };
            _proto.initSubscription = function initSubscription() {
                if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
                this.subscription = new (0, $178e855991788f74$export$2e2bcd8739ae039)(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `this.subscription` will then be null. An
                // extra null check every change can be avoided by copying the method onto `this` and then
                // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
                // listeners logic is changed to not call listeners that have been unsubscribed in the
                // middle of the notification loop.
                this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
            };
            _proto.onStateChange = function onStateChange() {
                this.selector.run(this.props);
                if (!this.selector.shouldComponentUpdate) this.notifyNestedSubs();
                else {
                    this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
                    this.setState($7ba9029b4649a9cf$var$dummyState);
                }
            };
            _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
                // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
                // needs to notify nested subs. Once called, it unimplements itself until further state
                // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
                // a boolean check every time avoids an extra method call most of the time, resulting
                // in some perf boost.
                this.componentDidUpdate = undefined;
                this.notifyNestedSubs();
            };
            _proto.isSubscribed = function isSubscribed() {
                return Boolean(this.subscription) && this.subscription.isSubscribed();
            };
            _proto.addExtraProps = function addExtraProps(props) {
                if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
                // this is especially important for 'ref' since that's a reference back to the component
                // instance. a singleton memoized selector would then be holding a reference to the
                // instance, preventing the instance from being garbage collected, and that would be bad
                var withExtras = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, props);
                if (withRef) withExtras.ref = this.setWrappedInstance;
                if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
                if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
                return withExtras;
            };
            _proto.render = function render() {
                var selector = this.selector;
                selector.shouldComponentUpdate = false;
                if (selector.error) throw selector.error;
                else return (0, $3da1ae41ec4e0382$exports.createElement)(WrappedComponent, this.addExtraProps(selector.props));
            };
            return Connect;
        }((0, $3da1ae41ec4e0382$exports.Component));
        if ($7ba9029b4649a9cf$var$prefixUnsafeLifecycleMethods) {
            // Use UNSAFE_ event name where supported
            Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
            delete Connect.prototype.componentWillReceiveProps;
        }
        /* eslint-enable react/no-deprecated */ Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = displayName;
        Connect.childContextTypes = childContextTypes;
        Connect.contextTypes = contextTypes;
        Connect.propTypes = contextTypes;
        var eventName;
        return (0, (/*@__PURE__*/$parcel$interopDefault($f550a03ccbc02dc9$exports)))(Connect, WrappedComponent);
    };
}





var $e1c5dc3cf9057bfd$var$hasOwn = Object.prototype.hasOwnProperty;
function $e1c5dc3cf9057bfd$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $e1c5dc3cf9057bfd$export$2e2bcd8739ae039(objA, objB) {
    if ($e1c5dc3cf9057bfd$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!$e1c5dc3cf9057bfd$var$hasOwn.call(objB, keysA[i]) || !$e1c5dc3cf9057bfd$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


/** Detect free variable `global` from Node.js. */ var $946b943250849329$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $946b943250849329$export$2e2bcd8739ae039 = $946b943250849329$var$freeGlobal;


/** Detect free variable `self`. */ var $7d88d81eb82f261a$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $7d88d81eb82f261a$var$root = (0, $946b943250849329$export$2e2bcd8739ae039) || $7d88d81eb82f261a$var$freeSelf || Function("return this")();
var $7d88d81eb82f261a$export$2e2bcd8739ae039 = $7d88d81eb82f261a$var$root;


/** Built-in value references. */ var $4b1937481569dabd$var$Symbol = (0, $7d88d81eb82f261a$export$2e2bcd8739ae039).Symbol;
var $4b1937481569dabd$export$2e2bcd8739ae039 = $4b1937481569dabd$var$Symbol;



/** Used for built-in method references. */ var $cfd9dcb1af6e945c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cfd9dcb1af6e945c$var$hasOwnProperty = $cfd9dcb1af6e945c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cfd9dcb1af6e945c$var$nativeObjectToString = $cfd9dcb1af6e945c$var$objectProto.toString;
/** Built-in value references. */ var $cfd9dcb1af6e945c$var$symToStringTag = (0, $4b1937481569dabd$export$2e2bcd8739ae039) ? (0, $4b1937481569dabd$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $cfd9dcb1af6e945c$var$getRawTag(value) {
    var isOwn = $cfd9dcb1af6e945c$var$hasOwnProperty.call(value, $cfd9dcb1af6e945c$var$symToStringTag), tag = value[$cfd9dcb1af6e945c$var$symToStringTag];
    try {
        value[$cfd9dcb1af6e945c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $cfd9dcb1af6e945c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$cfd9dcb1af6e945c$var$symToStringTag] = tag;
        else delete value[$cfd9dcb1af6e945c$var$symToStringTag];
    }
    return result;
}
var $cfd9dcb1af6e945c$export$2e2bcd8739ae039 = $cfd9dcb1af6e945c$var$getRawTag;


/** Used for built-in method references. */ var $e5815448047ae578$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e5815448047ae578$var$nativeObjectToString = $e5815448047ae578$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e5815448047ae578$var$objectToString(value) {
    return $e5815448047ae578$var$nativeObjectToString.call(value);
}
var $e5815448047ae578$export$2e2bcd8739ae039 = $e5815448047ae578$var$objectToString;


/** `Object#toString` result references. */ var $3500d27f561e364e$var$nullTag = "[object Null]", $3500d27f561e364e$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $3500d27f561e364e$var$symToStringTag = (0, $4b1937481569dabd$export$2e2bcd8739ae039) ? (0, $4b1937481569dabd$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $3500d27f561e364e$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $3500d27f561e364e$var$undefinedTag : $3500d27f561e364e$var$nullTag;
    return $3500d27f561e364e$var$symToStringTag && $3500d27f561e364e$var$symToStringTag in Object(value) ? (0, $cfd9dcb1af6e945c$export$2e2bcd8739ae039)(value) : (0, $e5815448047ae578$export$2e2bcd8739ae039)(value);
}
var $3500d27f561e364e$export$2e2bcd8739ae039 = $3500d27f561e364e$var$baseGetTag;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $02909716fc9d55ae$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $02909716fc9d55ae$export$2e2bcd8739ae039 = $02909716fc9d55ae$var$overArg;


/** Built-in value references. */ var $b5d084d7755a4777$var$getPrototype = (0, $02909716fc9d55ae$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $b5d084d7755a4777$export$2e2bcd8739ae039 = $b5d084d7755a4777$var$getPrototype;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $05c97b4d1d1744ea$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $05c97b4d1d1744ea$export$2e2bcd8739ae039 = $05c97b4d1d1744ea$var$isObjectLike;


/** `Object#toString` result references. */ var $e7aa51a59603a6c5$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $e7aa51a59603a6c5$var$funcProto = Function.prototype, $e7aa51a59603a6c5$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $e7aa51a59603a6c5$var$funcToString = $e7aa51a59603a6c5$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e7aa51a59603a6c5$var$hasOwnProperty = $e7aa51a59603a6c5$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $e7aa51a59603a6c5$var$objectCtorString = $e7aa51a59603a6c5$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $e7aa51a59603a6c5$var$isPlainObject(value) {
    if (!(0, $05c97b4d1d1744ea$export$2e2bcd8739ae039)(value) || (0, $3500d27f561e364e$export$2e2bcd8739ae039)(value) != $e7aa51a59603a6c5$var$objectTag) return false;
    var proto = (0, $b5d084d7755a4777$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $e7aa51a59603a6c5$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $e7aa51a59603a6c5$var$funcToString.call(Ctor) == $e7aa51a59603a6c5$var$objectCtorString;
}
var $e7aa51a59603a6c5$export$2e2bcd8739ae039 = $e7aa51a59603a6c5$var$isPlainObject;



var $5pegU = parcelRequire("5pegU");
var $005f68b908ac2328$export$1385d81a6c6bbcd4 = {
    INIT: "@@redux/INIT"
};
function $005f68b908ac2328$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error("Expected the enhancer to be a function.");
        return enhancer($005f68b908ac2328$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error("Expected the reducer to be a function.");
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error("Expected listener to be a function.");
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $e7aa51a59603a6c5$export$2e2bcd8739ae039)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === "undefined") throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error("Reducers may not dispatch actions.");
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error("Expected the nextReducer to be a function.");
        currentReducer = nextReducer;
        dispatch({
            type: $005f68b908ac2328$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object") throw new TypeError("Expected the observer to be an object.");
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $5pegU.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $005f68b908ac2328$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $5pegU.default] = observable, _ref2;
}




/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $9013014f7da26c43$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $a2aa30f1eef97a24$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || "an action";
    return "Given action " + actionName + ', reducer "' + key + '" returned undefined. ' + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}
function $a2aa30f1eef97a24$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $005f68b908ac2328$export$1385d81a6c6bbcd4).INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $e7aa51a59603a6c5$export$2e2bcd8739ae039)(inputState)) return "The " + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $a2aa30f1eef97a24$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $005f68b908ac2328$export$1385d81a6c6bbcd4).INIT
        });
        if (typeof initialState === "undefined") throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
        var type = "@@redux/PROBE_UNKNOWN_ACTION_" + Math.random().toString(36).substring(7).split("").join(".");
        if (typeof reducer(undefined, {
            type: type
        }) === "undefined") throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ("Don't try to handle " + (0, $005f68b908ac2328$export$1385d81a6c6bbcd4).INIT + ' or other actions in "redux/*" ') + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    });
}
function $a2aa30f1eef97a24$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $a2aa30f1eef97a24$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var errorMessage = $a2aa30f1eef97a24$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}


function $506cd67473defc62$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $506cd67473defc62$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $506cd67473defc62$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? "null" : typeof actionCreators) + ". " + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $506cd67473defc62$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}


/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $1ffc2a66eccde09a$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}


var $3002fbe1c12746ba$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $3002fbe1c12746ba$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $1ffc2a66eccde09a$export$2e2bcd8739ae039).apply(undefined, chain)(store.dispatch);
            return $3002fbe1c12746ba$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}




/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $cbc2046c3c81b879$var$isCrushed() {}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $37d1793933eb7014$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $a01ffd9f6ead941d$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $37d1793933eb7014$export$2e2bcd8739ae039)(value)) (0, $a1da036e0434dc00$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $e67b67eaaa8f8c25$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $e67b67eaaa8f8c25$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $e67b67eaaa8f8c25$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $e67b67eaaa8f8c25$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $e67b67eaaa8f8c25$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $e49b119ead212aa4$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $e67b67eaaa8f8c25$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $e49b119ead212aa4$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $e67b67eaaa8f8c25$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $e49b119ead212aa4$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $e67b67eaaa8f8c25$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $506cd67473defc62$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $e49b119ead212aa4$export$2e2bcd8739ae039 = [
    $e49b119ead212aa4$export$a9f27b4b187c1166,
    $e49b119ead212aa4$export$ba20d1a7aa0c4a90,
    $e49b119ead212aa4$export$94a6e55709d4d961
];



function $bd9e59e0dbeb300f$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $e67b67eaaa8f8c25$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : undefined;
}
function $bd9e59e0dbeb300f$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $e67b67eaaa8f8c25$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $bd9e59e0dbeb300f$export$2e2bcd8739ae039 = [
    $bd9e59e0dbeb300f$export$23fc470827b14aa,
    $bd9e59e0dbeb300f$export$514bc8c1a53c1d66
];




function $de6dfb8e4293efc0$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $de6dfb8e4293efc0$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $de6dfb8e4293efc0$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $de6dfb8e4293efc0$export$5b105939c84b5234(mergeProps) : undefined;
}
function $de6dfb8e4293efc0$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $de6dfb8e4293efc0$export$691c327fc30bc857;
    } : undefined;
}
var $de6dfb8e4293efc0$export$2e2bcd8739ae039 = [
    $de6dfb8e4293efc0$export$d61b680184bc3f00,
    $de6dfb8e4293efc0$export$a13ba70ef50dda6d
];




function $5df5c960457c6c6f$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!selector.hasOwnProperty("dependsOnOwnProps")) (0, $a1da036e0434dc00$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $5df5c960457c6c6f$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $5df5c960457c6c6f$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $5df5c960457c6c6f$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $5df5c960457c6c6f$var$verify(mergeProps, "mergeProps", displayName);
}


function $81c3998d4b7a1610$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $81c3998d4b7a1610$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $81c3998d4b7a1610$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref2, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $81c3998d4b7a1610$export$d20c0c2ca6eb2b6f : $81c3998d4b7a1610$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $8111c5508154ff5a$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $8111c5508154ff5a$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $8111c5508154ff5a$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $7ba9029b4649a9cf$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $bd9e59e0dbeb300f$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $e49b119ead212aa4$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $de6dfb8e4293efc0$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $81c3998d4b7a1610$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $8111c5508154ff5a$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $e1c5dc3cf9057bfd$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $e1c5dc3cf9057bfd$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $e1c5dc3cf9057bfd$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref3, [
            "pure",
            "areStatesEqual",
            "areOwnPropsEqual",
            "areStatePropsEqual",
            "areMergedPropsEqual"
        ]);
        var initMapStateToProps = $8111c5508154ff5a$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $8111c5508154ff5a$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $8111c5508154ff5a$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $8111c5508154ff5a$export$2e2bcd8739ae039 = $8111c5508154ff5a$export$9f9feb656dec1fc4();





var $f1a004315fae6573$exports = {};
"use strict";
var $f1a004315fae6573$var$__extends = $f1a004315fae6573$exports && $f1a004315fae6573$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($f1a004315fae6573$exports, "__esModule", {
    value: true
});
$f1a004315fae6573$exports.LayerEsriMapServer = $f1a004315fae6573$exports.localCacheUrl = $f1a004315fae6573$exports.makeServiceUrl = void 0;
var $a8d82ee56684bcee$exports = {};
"use strict";
Object.defineProperty($a8d82ee56684bcee$exports, "__esModule", {
    value: true
});
$a8d82ee56684bcee$exports.LayerBase = void 0;
var $4b8d86d30a99221f$exports = {};
"use strict";
/**
 * Created by gavorhes on 12/14/2015.
 */ Object.defineProperty($4b8d86d30a99221f$exports, "__esModule", {
    value: true
});
$4b8d86d30a99221f$exports.resolutionToZoom = $4b8d86d30a99221f$exports.zoomToResolution = void 0;

var $4b8d86d30a99221f$var$nm = $c45303ef5b6fbfc7$exports.default("olHelpers.zoomResolutionConvert");
var $4b8d86d30a99221f$var$_zoomResLookup = [
    156543.03392804097,
    78271.51696402048,
    39135.75848201024,
    19567.87924100512,
    9783.93962050256,
    4891.96981025128,
    2445.98490512564,
    1222.99245256282,
    611.49622628141,
    305.748113140705,
    152.8740565703525,
    76.43702828517625,
    38.21851414258813,
    19.109257071294063,
    9.554628535647032,
    4.777314267823516,
    2.388657133911758,
    1.194328566955879,
    0.5971642834779395,
    0.29858214173896974,
    0.14929107086948487,
    0.07464553543474244,
    0.03732276771737122,
    0.01866138385868561,
    0.009330691929342804,
    0.004665345964671402,
    0.002332672982335701,
    0.0011663364911678506,
    0.0005831682455839253 //28
];
/**
 * Get the resolution given the zoom level
 * @param {number} zoomLevel - the zoom level
 * @returns {number|*} the map resolution
 */ function $4b8d86d30a99221f$var$zoomToResolution(zoomLevel) {
    "use strict";
    if (typeof zoomLevel == "number") {
        if (zoomLevel % 1 === 0 && zoomLevel >= 0 && zoomLevel <= 28) return $4b8d86d30a99221f$var$_zoomResLookup[zoomLevel];
        else {
            console.log("invalid zoom level provided: " + zoomLevel);
            return undefined;
        }
    } else return undefined;
}
$4b8d86d30a99221f$exports.zoomToResolution = $4b8d86d30a99221f$var$zoomToResolution;
$4b8d86d30a99221f$var$nm.zoomToResolution = $4b8d86d30a99221f$var$zoomToResolution;
/**
 * Get resolution from the zoom level
 * @param {number} resolution - the resolution
 * @returns {number|*} the zoom level
 */ function $4b8d86d30a99221f$var$resolutionToZoom(resolution) {
    for(var i = 0; i < $4b8d86d30a99221f$var$_zoomResLookup.length; i++){
        if (resolution >= $4b8d86d30a99221f$var$_zoomResLookup[i]) return i;
    }
    return 0;
}
$4b8d86d30a99221f$exports.resolutionToZoom = $4b8d86d30a99221f$var$resolutionToZoom;
$4b8d86d30a99221f$var$nm.resolutionToZoom = $4b8d86d30a99221f$var$resolutionToZoom;





var $a8d82ee56684bcee$var$nm = $c45303ef5b6fbfc7$exports.default("layers");
/**
 * The base layer class
 * @abstract
 */ var $a8d82ee56684bcee$var$LayerBase = /** @class */ function() {
    /**
     * The base layer for all others
     * @param {string} url - url for source
     * @param {object} options - config
     * @param {string} [options.id=makeGuid()] - layer id
     * @param {string} [options.name=Unnamed Layer] - layer name
     * @param {number} [options.opacity=1] - opacity
     * @param {boolean} [options.visible=true] - default visible
     * @param {number} [options.minZoom=undefined] - min zoom level, 0 - 28
     * @param {number} [options.maxZoom=undefined] - max zoom level, 0 - 28
     * @param {object} [options.params={}] - the get parameters to include to retrieve the layer
     * @param {number} [options.zIndex=0] - the z index for the layer
     * @param {function} [options.loadCallback] - function to call on load, context this is the layer object
     * @param {boolean} [options.legendCollapse=false] - if the legend item should be initially collapsed
     * @param {boolean} [options.legendCheckbox=true] - if the legend item should have a checkbox for visibility
     * @param {boolean} [options.legendContent=undefined] - additional content to add to the legend
     */ function LayerBase(url, options) {
        if (options === void 0) options = {};
        options = options || {};
        if (typeof url !== "string") throw "Invalid URL";
        this._url = url;
        this._params = typeof options.params == "object" ? options.params : {};
        this._legendCollapse = typeof options.legendCollapse == "boolean" ? options.legendCollapse : false;
        this._legendCheckbox = typeof options.legendCheckbox == "boolean" ? options.legendCheckbox : true;
        this.id = options.id || $68981f1a81adf307$exports.default();
        this._name = options.name || "Unnamed Layer";
        this.animate = false;
        this._opacity = typeof options.opacity == "number" ? options.opacity : 1;
        if (this._opacity > 1) this._opacity = 1;
        else if (this._opacity < 0) this._opacity = 0;
        this._visible = typeof options.visible === "boolean" ? options.visible : true;
        this._source = undefined;
        /**
         *
         * @protected
         */ this._olLayer = undefined;
        this._loaded = false;
        this._maxResolution = $4b8d86d30a99221f$exports.zoomToResolution(options.minZoom);
        if (typeof this._maxResolution !== "undefined") this._maxResolution += 0.00001;
        this._minResolution = $4b8d86d30a99221f$exports.zoomToResolution(options.maxZoom);
        this._minZoom = typeof options.minZoom == "number" ? options.minZoom : undefined;
        this._maxZoom = typeof options.maxZoom == "number" ? options.maxZoom : undefined;
        this._zIndex = typeof options.zIndex == "number" ? options.zIndex : 0;
        this.loadCallback = typeof options.loadCallback == "function" ? options.loadCallback : function() {};
        this._legendContent = "";
        if (this._legendCheckbox) {
            this._legendContent += '<input type="checkbox" ' + (this.visible ? "checked" : "") + " " + ('class="legend-check" id="' + this.id + '-legend-layer-check"><span></span>');
            this._legendContent += '<label for="' + this.id + '-legend-layer-check" class="legend-layer-name">' + this.name + "</label>";
        } else this._legendContent += '<label class="legend-layer-name">' + this.name + "</label>";
        this._$legendDiv = null;
        this._applyCollapseCalled = false;
        this._addLegendContent(typeof options.legendContent === "string" ? options.legendContent : undefined);
    }
    /**
     * base load function, sets _loaded = true if it is not already
     * @protected
     * @returns {boolean} if already loaded
     */ LayerBase.prototype._load = function() {
        if (this.loaded == true) return true;
        else {
            this._loaded = true;
            return false;
        }
    };
    /**
     * Get the legend html, be sure to only add to the DOM once
     * @returns {string} html for layer wrapped in a div
     */ LayerBase.prototype.getLegendDiv = function() {
        return '<div class="legend-layer-div" id="' + this.id + '-legend-layer-div">' + this._legendContent + "</div>";
    };
    /**
     *
     * @param additionalContent - additional content to add to legend
     * @private
     */ LayerBase.prototype._addLegendContent = function(additionalContent) {
        if (additionalContent === void 0) additionalContent = "";
        var addCollapse = additionalContent.indexOf("<ul>") > -1;
        if (addCollapse) additionalContent = '<span class="legend-items-expander" title="Expand/Collapse">&#9660;</span>' + additionalContent;
        this._legendContent += additionalContent;
        this._$legendDiv = $dc57b31f1b066f38$exports("#" + this.id + "-legend-layer-div");
        if (this._$legendDiv.length > 0) {
            this._$legendDiv.append(additionalContent);
            this.applyCollapse();
        }
    };
    /**
     * add additional content to the legend
     * @param {string} [additionalContent=] - additonal content to add
     */ LayerBase.prototype.addLegendContent = function(additionalContent) {
        this._addLegendContent(additionalContent);
    };
    LayerBase.prototype.applyCollapse = function() {
        if (this._applyCollapseCalled) {
            console.log("collapse already applied");
            return undefined;
        }
        this._$legendDiv = $dc57b31f1b066f38$exports("#" + this.id + "-legend-layer-div");
        if (this._$legendDiv.length > 0) {
            var $expander = this._$legendDiv.find(".legend-items-expander");
            if ($expander.length > 0) {
                this._applyCollapseCalled = true;
                $expander.click(function() {
                    var $this = $dc57b31f1b066f38$exports(this);
                    $this.siblings("ul").slideToggle();
                    if ($this.hasClass("legend-layer-group-collapsed")) {
                        $this.removeClass("legend-layer-group-collapsed");
                        $this.html("&#9660;");
                    } else {
                        $this.addClass("legend-layer-group-collapsed");
                        $this.html("&#9654;");
                    }
                });
                if (this._legendCollapse) $expander.trigger("click");
            }
        }
    };
    /**
     * trick to refresh the layer
     */ LayerBase.prototype.refresh = function() {
        if (this.source) this.source.refresh();
    };
    Object.defineProperty(LayerBase.prototype, "id", {
        get: function() {
            return this._id;
        },
        set: function(newId) {
            this._id = newId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerBase.prototype, "animate", {
        get: function() {
            return this._animate;
        },
        set: function(animate) {
            this._animate = animate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerBase.prototype, "legendContent", {
        /**
         * get the legend content
         * @type {string}
         */ get: function() {
            return this._legendContent;
        },
        /**
         * set the legend content directly
         * @param {string} newVal - new content
         * @protected
         */ set: function(newVal) {
            this._legendContent = newVal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerBase.prototype, "params", {
        /**
         * get the map get params
         * @type {object}
         */ get: function() {
            return this._params;
        },
        /**
         * set the map get params
         * @param {object} newParams - new get params
         * @protected
         */ set: function(newParams) {
            this._params = newParams;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerBase.prototype, "minResolution", {
        /**
         * get the minimum resolution
         * @type {number|*}
         */ get: function() {
            return this._minResolution;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerBase.prototype, "maxResolution", {
        /**
         * get the maximum resolution
         * @type {number|*}
         */ get: function() {
            return this._maxResolution;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerBase.prototype, "minZoom", {
        /**
         * get min zoom
         * @type {number|*}
         */ get: function() {
            return this._minZoom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerBase.prototype, "maxZoom", {
        /**
         * get max zoom
         * @type {number|*}
         */ get: function() {
            return this._maxZoom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerBase.prototype, "url", {
        /**
         * get the url
         * @type {string}
         */ get: function() {
            return this._url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerBase.prototype, "visible", {
        /**
         * Get the layer visibility
         * @type {boolean}
         */ get: function() {
            return this._visible;
        },
        /**
         * set the visibility
         * @param visibility
         */ set: function(visibility) {
            this.setVisible(visibility);
        },
        enumerable: false,
        configurable: true
    });
    LayerBase.prototype.setVisible = function(visibility) {
        this._visible = visibility;
        if (this.olLayer) {
            this.olLayer.setVisible(this._visible);
            if (visibility && !this._loaded) this._load();
        }
    };
    Object.defineProperty(LayerBase.prototype, "opacity", {
        /**
         * Get the layer opacity
         * @type {number}
         */ get: function() {
            return this._opacity;
        },
        /**
         * Set the layer opacity
         * @param {number} opacity - layer opacity
         */ set: function(opacity) {
            this._opacity = opacity;
            if (this.olLayer) this.olLayer.setOpacity(this._opacity);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerBase.prototype, "name", {
        get: function() {
            return this._name;
        },
        set: function(newName) {
            this._name = newName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerBase.prototype, "loaded", {
        /**
         * Check if the layer is loaded
         * @type {boolean}
         */ get: function() {
            return this._loaded;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerBase.prototype, "source", {
        /**
         * get the layer source
         * @type {*}
         */ get: function() {
            return this.getSource();
        },
        enumerable: false,
        configurable: true
    });
    LayerBase.prototype.getSource = function() {
        return this._source;
    };
    Object.defineProperty(LayerBase.prototype, "zIndex", {
        /**
         * get the z index
         */ get: function() {
            return this._zIndex;
        },
        /**
         * set the z index
         */ set: function(newZ) {
            this._zIndex = newZ;
        },
        enumerable: false,
        configurable: true
    });
    LayerBase.prototype.setZIndex = function(newZ) {};
    Object.defineProperty(LayerBase.prototype, "olLayer", {
        /**
         * the the ol layer
         */ get: function() {
            return this.getOlLayer();
        },
        enumerable: false,
        configurable: true
    });
    LayerBase.prototype.getOlLayer = function() {
        return this._olLayer;
    };
    return LayerBase;
}();
$a8d82ee56684bcee$exports.LayerBase = $a8d82ee56684bcee$var$LayerBase;
$a8d82ee56684bcee$var$nm.LayerBase = $a8d82ee56684bcee$var$LayerBase;
$a8d82ee56684bcee$exports.default = $a8d82ee56684bcee$var$LayerBase;


var $e4882427249fdc65$exports = {};
"use strict";
var $e4882427249fdc65$var$__extends = $e4882427249fdc65$exports && $e4882427249fdc65$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($e4882427249fdc65$exports, "__esModule", {
    value: true
});
$e4882427249fdc65$exports.makeMapServiceLegend = $e4882427249fdc65$exports.makeFeatureServiceLegendAndSymbol = void 0;





/**
 * @module ol/style/Icon
 */ 





/**
 * @module ol/style/IconAnchorUnits
 */ /**
 * Icon anchor units. One of 'fraction', 'pixels'.
 * @enum {string}
 */ var $462dce7b26a23be3$export$2e2bcd8739ae039 = {
    FRACTION: "fraction",
    PIXELS: "pixels"
};


/**
 * @module ol/style/IconImage
 */ 





var $33bba60ac8fc0af6$var$IconImage = /*@__PURE__*/ function(EventTarget) {
    function IconImage(image, src, size, crossOrigin, imageState, color) {
        EventTarget.call(this);
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */ this.image_ = !image ? new Image() : image;
        if (crossOrigin !== null) /** @type {HTMLImageElement} */ this.image_.crossOrigin = crossOrigin;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = color ? /** @type {HTMLCanvasElement} */ document.createElement("canvas") : null;
        /**
     * @private
     * @type {import("../color.js").Color}
     */ this.color_ = color;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.imageListenerKeys_ = null;
        /**
     * @private
     * @type {import("../ImageState.js").default}
     */ this.imageState_ = imageState;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = size;
        /**
     * @private
     * @type {string|undefined}
     */ this.src_ = src;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.tainted_;
    }
    if (EventTarget) IconImage.__proto__ = EventTarget;
    IconImage.prototype = Object.create(EventTarget && EventTarget.prototype);
    IconImage.prototype.constructor = IconImage;
    /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */ IconImage.prototype.isTainted_ = function isTainted_() {
        if (this.tainted_ === undefined && this.imageState_ === (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED) {
            this.tainted_ = false;
            var context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(1, 1);
            try {
                context.drawImage(this.image_, 0, 0);
                context.getImageData(0, 0, 1, 1);
            } catch (e) {
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    };
    /**
   * @private
   */ IconImage.prototype.dispatchChangeEvent_ = function dispatchChangeEvent_() {
        this.dispatchEvent((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE);
    };
    /**
   * @private
   */ IconImage.prototype.handleImageError_ = function handleImageError_() {
        this.imageState_ = (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.dispatchChangeEvent_();
    };
    /**
   * @private
   */ IconImage.prototype.handleImageLoad_ = function handleImageLoad_() {
        this.imageState_ = (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED;
        if (this.size_) {
            this.image_.width = this.size_[0];
            this.image_.height = this.size_[1];
        }
        this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.unlistenImage_();
        this.replaceColor_();
        this.dispatchChangeEvent_();
    };
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement} Image or Canvas element.
   */ IconImage.prototype.getImage = function getImage(pixelRatio) {
        return this.canvas_ ? this.canvas_ : this.image_;
    };
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ IconImage.prototype.getImageState = function getImageState() {
        return this.imageState_;
    };
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement} Image element.
   */ IconImage.prototype.getHitDetectionImage = function getHitDetectionImage(pixelRatio) {
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                var width = this.size_[0];
                var height = this.size_[1];
                var context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    };
    /**
   * @return {import("../size.js").Size} Image size.
   */ IconImage.prototype.getSize = function getSize() {
        return this.size_;
    };
    /**
   * @return {string|undefined} Image src.
   */ IconImage.prototype.getSrc = function getSrc() {
        return this.src_;
    };
    /**
   * Load not yet loaded URI.
   */ IconImage.prototype.load = function load() {
        if (this.imageState_ == (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE) {
            this.imageState_ = (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADING;
            this.imageListenerKeys_ = [
                (0, $37a5c0af9052e360$export$8d2a95bc11b44725)(this.image_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).ERROR, this.handleImageError_, this),
                (0, $37a5c0af9052e360$export$8d2a95bc11b44725)(this.image_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).LOAD, this.handleImageLoad_, this)
            ];
            try {
                /** @type {HTMLImageElement} */ this.image_.src = this.src_;
            } catch (e) {
                this.handleImageError_();
            }
        }
    };
    /**
   * @private
   */ IconImage.prototype.replaceColor_ = function replaceColor_() {
        if (!this.color_ || this.isTainted_()) return;
        this.canvas_.width = this.image_.width;
        this.canvas_.height = this.image_.height;
        var ctx = this.canvas_.getContext("2d");
        ctx.drawImage(this.image_, 0, 0);
        var imgData = ctx.getImageData(0, 0, this.image_.width, this.image_.height);
        var data = imgData.data;
        var r = this.color_[0] / 255.0;
        var g = this.color_[1] / 255.0;
        var b = this.color_[2] / 255.0;
        for(var i = 0, ii = data.length; i < ii; i += 4){
            data[i] *= r;
            data[i + 1] *= g;
            data[i + 2] *= b;
        }
        ctx.putImageData(imgData, 0, 0);
    };
    /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ IconImage.prototype.unlistenImage_ = function unlistenImage_() {
        this.imageListenerKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        this.imageListenerKeys_ = null;
    };
    return IconImage;
}((0, $dd029d816e3b4259$export$2e2bcd8739ae039));
function $33bba60ac8fc0af6$export$3988ae62b71be9a3(image, src, size, crossOrigin, imageState, color) {
    var iconImage = (0, $20f070df2eea68ee$export$747ccdf771a87ab8).get(src, crossOrigin, color);
    if (!iconImage) {
        iconImage = new $33bba60ac8fc0af6$var$IconImage(image, src, size, crossOrigin, imageState, color);
        (0, $20f070df2eea68ee$export$747ccdf771a87ab8).set(src, crossOrigin, color, iconImage);
    }
    return iconImage;
}
var $33bba60ac8fc0af6$export$2e2bcd8739ae039 = $33bba60ac8fc0af6$var$IconImage;


/**
 * @module ol/style/IconOrigin
 */ /**
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 * @enum {string}
 */ var $c09c855d28be53b9$export$2e2bcd8739ae039 = {
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right"
};



/**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {import("./IconOrigin.js").default} [anchorOrigin] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`. Default is `top-left`.
 * @property {import("./IconAnchorUnits.js").default} [anchorXUnits] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels. Default is `'fraction'`.
 * @property {import("./IconAnchorUnits.js").default} [anchorYUnits] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels. Default is `'fraction'`.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you are using the WebGL renderer or if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {HTMLImageElement|HTMLCanvasElement} [img] Image object for the icon. If the `src` option is not provided then the
 * provided image must already be loaded. And in that case, it is required
 * to provide the size of the image, with the `imgSize` option.
 * @property {Array<number>} [offset=[0, 0]] Offset, which, together with the size and the offset origin, define the
 * sub-rectangle to use from the original icon image.
 * @property {import("./IconOrigin.js").default} [offsetOrigin] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`. Default is `top-left`.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {import("../size.js").Size} [size] Icon size in pixel. Can be used together with `offset` to define the
 * sub-rectangle to use from the origin (sprite) icon image.
 * @property {import("../size.js").Size} [imgSize] Image size in pixels. Only required if `img` is set and `src` is not, and
 * for SVG images in Internet Explorer 11. The provided `imgSize` needs to match the actual size of the image.
 * @property {string} [src] Image source URI.
 */ /**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ var $44e8bfd96871175f$var$Icon = /*@__PURE__*/ function(ImageStyle) {
    function Icon(opt_options) {
        var options = opt_options || {};
        /**
     * @type {number}
     */ var opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
     * @type {number}
     */ var rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
     * @type {number}
     */ var scale = options.scale !== undefined ? options.scale : 1;
        /**
     * @type {boolean}
     */ var rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        ImageStyle.call(this, {
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            rotateWithView: rotateWithView
        });
        /**
     * @private
     * @type {Array<number>}
     */ this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
     * @private
     * @type {Array<number>}
     */ this.normalizedAnchor_ = null;
        /**
     * @private
     * @type {import("./IconOrigin.js").default}
     */ this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : (0, $c09c855d28be53b9$export$2e2bcd8739ae039).TOP_LEFT;
        /**
     * @private
     * @type {import("./IconAnchorUnits.js").default}
     */ this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : (0, $462dce7b26a23be3$export$2e2bcd8739ae039).FRACTION;
        /**
     * @private
     * @type {import("./IconAnchorUnits.js").default}
     */ this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : (0, $462dce7b26a23be3$export$2e2bcd8739ae039).FRACTION;
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @type {HTMLImageElement|HTMLCanvasElement}
     */ var image = options.img !== undefined ? options.img : null;
        /**
     * @type {import("../size.js").Size}
     */ var imgSize = options.imgSize !== undefined ? options.imgSize : null;
        /**
     * @type {string|undefined}
     */ var src = options.src;
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!(src !== undefined && image), 4); // `image` and `src` cannot be provided at the same time
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!image || image && imgSize, 5); // `imgSize` must be set when `image` is provided
        if ((src === undefined || src.length === 0) && image) src = /** @type {HTMLImageElement} */ image.src || (0, $34772e91e89a736f$export$5e82334337e0f204)(image);
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(src !== undefined && src.length > 0, 6); // A defined and non-empty `src` or `image` must be provided
        /**
     * @type {import("../ImageState.js").default}
     */ var imageState = options.src !== undefined ? (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE : (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED;
        /**
     * @private
     * @type {import("../color.js").Color}
     */ this.color_ = options.color !== undefined ? (0, $2c17bfc916c8f689$export$75093a47a9fa838d)(options.color) : null;
        /**
     * @private
     * @type {import("./IconImage.js").default}
     */ this.iconImage_ = (0, $33bba60ac8fc0af6$export$3988ae62b71be9a3)(image, /** @type {string} */ src, imgSize, this.crossOrigin_, imageState, this.color_);
        /**
     * @private
     * @type {Array<number>}
     */ this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
     * @private
     * @type {import("./IconOrigin.js").default}
     */ this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : (0, $c09c855d28be53b9$export$2e2bcd8739ae039).TOP_LEFT;
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = options.size !== undefined ? options.size : null;
    }
    if (ImageStyle) Icon.__proto__ = ImageStyle;
    Icon.prototype = Object.create(ImageStyle && ImageStyle.prototype);
    Icon.prototype.constructor = Icon;
    /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   */ Icon.prototype.clone = function clone() {
        return new Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            crossOrigin: this.crossOrigin_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            src: this.getSrc(),
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            opacity: this.getOpacity(),
            scale: this.getScale(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView()
        });
    };
    /**
   * @inheritDoc
   * @api
   */ Icon.prototype.getAnchor = function getAnchor() {
        if (this.normalizedAnchor_) return this.normalizedAnchor_;
        var anchor = this.anchor_;
        var size = this.getSize();
        if (this.anchorXUnits_ == (0, $462dce7b26a23be3$export$2e2bcd8739ae039).FRACTION || this.anchorYUnits_ == (0, $462dce7b26a23be3$export$2e2bcd8739ae039).FRACTION) {
            if (!size) return null;
            anchor = this.anchor_.slice();
            if (this.anchorXUnits_ == (0, $462dce7b26a23be3$export$2e2bcd8739ae039).FRACTION) anchor[0] *= size[0];
            if (this.anchorYUnits_ == (0, $462dce7b26a23be3$export$2e2bcd8739ae039).FRACTION) anchor[1] *= size[1];
        }
        if (this.anchorOrigin_ != (0, $c09c855d28be53b9$export$2e2bcd8739ae039).TOP_LEFT) {
            if (!size) return null;
            if (anchor === this.anchor_) anchor = this.anchor_.slice();
            if (this.anchorOrigin_ == (0, $c09c855d28be53b9$export$2e2bcd8739ae039).TOP_RIGHT || this.anchorOrigin_ == (0, $c09c855d28be53b9$export$2e2bcd8739ae039).BOTTOM_RIGHT) anchor[0] = -anchor[0] + size[0];
            if (this.anchorOrigin_ == (0, $c09c855d28be53b9$export$2e2bcd8739ae039).BOTTOM_LEFT || this.anchorOrigin_ == (0, $c09c855d28be53b9$export$2e2bcd8739ae039).BOTTOM_RIGHT) anchor[1] = -anchor[1] + size[1];
        }
        this.normalizedAnchor_ = anchor;
        return this.normalizedAnchor_;
    };
    /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */ Icon.prototype.setAnchor = function setAnchor(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    };
    /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */ Icon.prototype.getColor = function getColor() {
        return this.color_;
    };
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement} Image or Canvas element.
   * @override
   * @api
   */ Icon.prototype.getImage = function getImage(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    };
    /**
   * @override
   */ Icon.prototype.getImageSize = function getImageSize() {
        return this.iconImage_.getSize();
    };
    /**
   * @override
   */ Icon.prototype.getHitDetectionImageSize = function getHitDetectionImageSize() {
        return this.getImageSize();
    };
    /**
   * @override
   */ Icon.prototype.getImageState = function getImageState() {
        return this.iconImage_.getImageState();
    };
    /**
   * @override
   */ Icon.prototype.getHitDetectionImage = function getHitDetectionImage(pixelRatio) {
        return this.iconImage_.getHitDetectionImage(pixelRatio);
    };
    /**
   * @inheritDoc
   * @api
   */ Icon.prototype.getOrigin = function getOrigin() {
        if (this.origin_) return this.origin_;
        var offset = this.offset_;
        if (this.offsetOrigin_ != (0, $c09c855d28be53b9$export$2e2bcd8739ae039).TOP_LEFT) {
            var size = this.getSize();
            var iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == (0, $c09c855d28be53b9$export$2e2bcd8739ae039).TOP_RIGHT || this.offsetOrigin_ == (0, $c09c855d28be53b9$export$2e2bcd8739ae039).BOTTOM_RIGHT) offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == (0, $c09c855d28be53b9$export$2e2bcd8739ae039).BOTTOM_LEFT || this.offsetOrigin_ == (0, $c09c855d28be53b9$export$2e2bcd8739ae039).BOTTOM_RIGHT) offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        this.origin_ = offset;
        return this.origin_;
    };
    /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */ Icon.prototype.getSrc = function getSrc() {
        return this.iconImage_.getSrc();
    };
    /**
   * @inheritDoc
   * @api
   */ Icon.prototype.getSize = function getSize() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    };
    /**
   * @override
   */ Icon.prototype.listenImageChange = function listenImageChange(listener, thisArg) {
        return (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.iconImage_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, listener, thisArg);
    };
    /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @override
   * @api
   */ Icon.prototype.load = function load() {
        this.iconImage_.load();
    };
    /**
   * @override
   */ Icon.prototype.unlistenImageChange = function unlistenImageChange(listener, thisArg) {
        (0, $37a5c0af9052e360$export$35276765542cd163)(this.iconImage_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, listener, thisArg);
    };
    return Icon;
}((0, $982c1d3baf3da6dc$export$2e2bcd8739ae039));
var $44e8bfd96871175f$export$2e2bcd8739ae039 = $44e8bfd96871175f$var$Icon;


var $e4882427249fdc65$var$nm = $c45303ef5b6fbfc7$exports.default("olHelpers.esriToOlStyle");
/**
 *
 * @param {Array<number>} colorArray - input color array
 * @param {number} opacity - the opacity 0 to 1
 * @returns {string} rgba string
 * @private
 */ function $e4882427249fdc65$var$_colorArrayToRgba(colorArray, opacity) {
    return "rgba(" + colorArray[0] + "," + colorArray[1] + "," + colorArray[2] + "," + opacity + ")";
}
/**
 * escape html charcters
 * @param {string} str - input string
 * @returns {string} escaped string
 */ function $e4882427249fdc65$var$htmlEscape(str) {
    return String(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
$e4882427249fdc65$var$nm.htmlEscape = $e4882427249fdc65$var$htmlEscape;
var $e4882427249fdc65$var$CommonSymbol = /** @class */ function() {
    /**
     *
     * @param symbolObj
     * @param {number} opacity
     */ function CommonSymbol(symbolObj, opacity) {
        this.symbolObj = symbolObj;
        this.opacity = opacity;
        this.olStyle = undefined;
        this.legendHtml = "";
    }
    return CommonSymbol;
}();
var $e4882427249fdc65$var$PointSymbol = /** @class */ function(_super) {
    $e4882427249fdc65$var$__extends(PointSymbol, _super);
    function PointSymbol(symbolObj, opacity) {
        var _this = _super.call(this, symbolObj, opacity) || this;
        switch(_this.symbolObj.type){
            case "esriSMS":
                var innerColor = $e4882427249fdc65$var$_colorArrayToRgba(_this.symbolObj.color, _this.opacity);
                var outerColor = $e4882427249fdc65$var$_colorArrayToRgba(_this.symbolObj.outline.color, _this.opacity);
                var outlineWidth = _this.symbolObj.outline.width;
                var radius = _this.symbolObj.size;
                _this.olStyle = new $0f1ce378ea6946fc$export$2e2bcd8739ae039({
                    image: new $e163d3c698de5692$export$2e2bcd8739ae039({
                        radius: radius,
                        fill: new $d6fd3e0b0360ea29$export$2e2bcd8739ae039({
                            color: innerColor
                        }),
                        stroke: new $9ed46f4c9b041e5d$export$2e2bcd8739ae039({
                            color: outerColor,
                            width: outlineWidth
                        })
                    })
                });
                _this.legendHtml = '<span class="legend-layer-icon" style="color: ' + innerColor + '">&#9679;</span>';
                break;
            case "esriPMS":
                _this.olStyle = new $0f1ce378ea6946fc$export$2e2bcd8739ae039({
                    image: new $44e8bfd96871175f$export$2e2bcd8739ae039({
                        src: "data:image/png;base64," + _this.symbolObj["imageData"]
                    })
                });
                _this.legendHtml = '<img class="legend-layer-icon" height="17" src="data:image/png;base64,' + _this.symbolObj["imageData"] + '">';
                break;
            default:
                console.log(_this.symbolObj);
                alert("Point symbol does not handle symbol type: " + _this.symbolObj["type"]);
        }
        return _this;
    }
    return PointSymbol;
}($e4882427249fdc65$var$CommonSymbol);
var $e4882427249fdc65$var$LineSymbol = /** @class */ function(_super) {
    $e4882427249fdc65$var$__extends(LineSymbol, _super);
    function LineSymbol(symbolObj, opacity) {
        var _this = _super.call(this, symbolObj, opacity) || this;
        switch(_this.symbolObj.type){
            case "esriSLS":
                var innerColor = $e4882427249fdc65$var$_colorArrayToRgba(_this.symbolObj.color, _this.opacity);
                var lineWidth = _this.symbolObj.width;
                _this.olStyle = new $0f1ce378ea6946fc$export$2e2bcd8739ae039({
                    stroke: new $9ed46f4c9b041e5d$export$2e2bcd8739ae039({
                        color: innerColor,
                        //lineDash: [4],
                        width: lineWidth
                    })
                });
                _this.legendHtml = '<span class="legend-layer-icon" ';
                _this.legendHtml += 'style="';
                _this.legendHtml += "background-color: " + innerColor + ";";
                _this.legendHtml += "width: 40px;";
                _this.legendHtml += "height: 4px;";
                _this.legendHtml += "position: relative;";
                _this.legendHtml += "display: inline-block;";
                _this.legendHtml += "top: -1px;";
                _this.legendHtml += '"></span>';
                break;
            default:
                console.log(_this.symbolObj);
                alert("Line symbol does not handle symbol type: " + _this.symbolObj["type"]);
        }
        return _this;
    }
    return LineSymbol;
}($e4882427249fdc65$var$CommonSymbol);
var $e4882427249fdc65$var$PolygonSymbol = /** @class */ function(_super) {
    $e4882427249fdc65$var$__extends(PolygonSymbol, _super);
    function PolygonSymbol(symbolObj, opacity) {
        var _this = _super.call(this, symbolObj, opacity) || this;
        switch(_this.symbolObj["type"]){
            case "esriSFS":
                var innerColor = $e4882427249fdc65$var$_colorArrayToRgba(_this.symbolObj.color, _this.opacity);
                var outerColor = $e4882427249fdc65$var$_colorArrayToRgba(_this.symbolObj.outline.color, _this.opacity);
                var outlineWidth = _this.symbolObj.outline.width;
                _this.olStyle = new $0f1ce378ea6946fc$export$2e2bcd8739ae039({
                    stroke: new $9ed46f4c9b041e5d$export$2e2bcd8739ae039({
                        color: outerColor,
                        //lineDash: [4],
                        width: outlineWidth
                    }),
                    fill: new $d6fd3e0b0360ea29$export$2e2bcd8739ae039({
                        color: innerColor
                    })
                });
                _this.legendHtml = '<span class="legend-layer-icon" ';
                _this.legendHtml += 'style="';
                _this.legendHtml += "background-color: " + innerColor + ";";
                _this.legendHtml += "border: solid " + outerColor + " 1px;";
                _this.legendHtml += "width: 40px;";
                _this.legendHtml += "height: 9px;";
                _this.legendHtml += "position: relative;";
                _this.legendHtml += "display: inline-block;";
                _this.legendHtml += "top: 2px;";
                _this.legendHtml += '"></span>';
                break;
            default:
                console.log(_this.symbolObj);
                alert("Polygon symbol does handle symbol type: " + _this.symbolObj["type"]);
        }
        return _this;
    }
    return PolygonSymbol;
}($e4882427249fdc65$var$CommonSymbol);
var $e4882427249fdc65$var$SymbolGenerator = /** @class */ function() {
    function SymbolGenerator(esriResponse) {
        this.opacity = (100 - (esriResponse["drawingInfo"]["transparency"] || 0)) / 100;
        this.renderer = esriResponse.drawingInfo.renderer;
        this.olStyle = undefined;
        this.legendHtml = "";
    }
    return SymbolGenerator;
}();
var $e4882427249fdc65$var$SingleSymbol = /** @class */ function(_super) {
    $e4882427249fdc65$var$__extends(SingleSymbol, _super);
    /**
     *
     * @param {object} esriResponse - layer info
     * @param SymbolClass - the symbol class to use
     */ function SingleSymbol(esriResponse, SymbolClass) {
        var _this = _super.call(this, esriResponse) || this;
        _this.symbol = _this.renderer.symbol;
        var symbolObj = new SymbolClass(_this.symbol, _this.opacity);
        _this.olStyle = symbolObj.olStyle;
        _this.legendHtml = symbolObj.legendHtml;
        return _this;
    }
    return SingleSymbol;
}($e4882427249fdc65$var$SymbolGenerator);
var $e4882427249fdc65$var$UniqueValueSymbol = /** @class */ function(_super) {
    $e4882427249fdc65$var$__extends(UniqueValueSymbol, _super);
    /**
     *
     * @param {object} esriResponse - layer info
     * @param SymbolClass - the Symbol class definition
     */ function UniqueValueSymbol(esriResponse, SymbolClass) {
        var _this = _super.call(this, esriResponse) || this;
        _this.uniqueValueInfos = _this.renderer.uniqueValueInfos;
        _this.propertyName = _this.renderer.field1;
        _this.defaultSymbol = _this.renderer.defaultSymbol;
        if (_this.defaultSymbol) {
            var symbolObj = new SymbolClass(_this.defaultSymbol, _this.opacity);
            _this.defaultStyle = symbolObj.olStyle;
            _this.defaultLabelHtml = '<span class="legend-layer-subitem">' + $e4882427249fdc65$var$htmlEscape(_this.renderer["defaultLabel"]) + "</span>" + symbolObj.legendHtml;
        } else {
            _this.defaultStyle = undefined;
            _this.defaultLabelHtml = "other";
        }
        _this.valueArray = [];
        _this.labelArray = [];
        _this.legendArray = [];
        _this.propertyStyleLookup = {};
        for(var _i = 0, _a = _this.uniqueValueInfos; _i < _a.length; _i++){
            var uniqueVal = _a[_i];
            _this.labelArray.push(uniqueVal["label"]);
            _this.valueArray.push(uniqueVal["value"]);
            var uniqueSym = new SymbolClass(uniqueVal.symbol, _this.opacity);
            _this.legendArray.push('<span class="legend-layer-subitem">' + $e4882427249fdc65$var$htmlEscape(uniqueVal["label"]) + "</span>" + uniqueSym.legendHtml);
            _this.propertyStyleLookup[uniqueVal["value"]] = uniqueSym.olStyle;
        }
        _this.olStyle = function(feature) {
            var checkProperties = feature.getProperties();
            var checkProperty = checkProperties[_this.propertyName];
            if (_this.propertyStyleLookup[checkProperty] !== undefined) return [
                _this.propertyStyleLookup[checkProperty]
            ];
            else return [
                _this.defaultStyle
            ];
        };
        if (_this.defaultLabelHtml !== null) _this.legendArray.push(_this.defaultLabelHtml);
        _this.legendHtml = "<ul>";
        for(var _b = 0, _c = _this.legendArray; _b < _c.length; _b++){
            var h = _c[_b];
            _this.legendHtml += "<li>" + h + "</li>";
        }
        _this.legendHtml += "</ul>";
        return _this;
    }
    return UniqueValueSymbol;
}($e4882427249fdc65$var$SymbolGenerator);
function $e4882427249fdc65$var$makeFeatureServiceLegendAndSymbol(esriResponse) {
    var renderer = esriResponse.drawingInfo.renderer;
    var symbolLegendOut = null;
    switch(renderer.type){
        case "simple":
            switch(esriResponse.geometryType){
                case "esriGeometryPoint":
                    symbolLegendOut = new $e4882427249fdc65$var$SingleSymbol(esriResponse, $e4882427249fdc65$var$PointSymbol);
                    break;
                case "esriGeometryPolyline":
                    symbolLegendOut = new $e4882427249fdc65$var$SingleSymbol(esriResponse, $e4882427249fdc65$var$LineSymbol);
                    break;
                case "esriGeometryPolygon":
                    symbolLegendOut = new $e4882427249fdc65$var$SingleSymbol(esriResponse, $e4882427249fdc65$var$PolygonSymbol);
                    break;
                default:
                    console.log(esriResponse);
                    alert(esriResponse.geometryType + " not handled");
            }
            break;
        case "uniqueValue":
            switch(esriResponse.geometryType){
                case "esriGeometryPoint":
                    symbolLegendOut = new $e4882427249fdc65$var$UniqueValueSymbol(esriResponse, $e4882427249fdc65$var$PointSymbol);
                    break;
                case "esriGeometryPolyline":
                    symbolLegendOut = new $e4882427249fdc65$var$UniqueValueSymbol(esriResponse, $e4882427249fdc65$var$LineSymbol);
                    break;
                case "esriGeometryPolygon":
                    symbolLegendOut = new $e4882427249fdc65$var$UniqueValueSymbol(esriResponse, $e4882427249fdc65$var$PolygonSymbol);
                    break;
                default:
                    console.log(esriResponse);
                    alert(esriResponse["geometryType"] + " not handled");
            }
            break;
        default:
            alert("not handled renderer type: " + renderer["type"]);
    }
    if (symbolLegendOut == null) return {
        style: undefined,
        legend: ""
    };
    else return {
        style: symbolLegendOut.olStyle,
        legend: symbolLegendOut.legendHtml
    };
}
$e4882427249fdc65$exports.makeFeatureServiceLegendAndSymbol = $e4882427249fdc65$var$makeFeatureServiceLegendAndSymbol;
$e4882427249fdc65$var$nm.makeFeatureServiceLegendAndSymbol = $e4882427249fdc65$var$makeFeatureServiceLegendAndSymbol;
/**
 *
 * @param {object} lyrObject - the layer as defined in the response
 * @param {boolean} [skipLayerNameAndExpander=false] use only icons
 * @returns {string} legend html
 */ function $e4882427249fdc65$var$mapServiceLegendItem(lyrObject, skipLayerNameAndExpander) {
    if (skipLayerNameAndExpander === void 0) skipLayerNameAndExpander = false;
    skipLayerNameAndExpander = typeof skipLayerNameAndExpander == "boolean" ? skipLayerNameAndExpander : false;
    var layerName = lyrObject["layerName"];
    var legendItems = lyrObject["legend"];
    var legendHtml = "";
    if (!skipLayerNameAndExpander) legendHtml += '<span class="legend-layer-subitem">' + layerName + "</span>";
    if (legendItems.length == 1) legendHtml = '<img class="legend-layer-icon" height="17" src="data:image/png;base64,' + legendItems[0]["imageData"] + '">';
    else {
        if (!skipLayerNameAndExpander) legendHtml += '<span class="legend-items-expander" title="Expand/Collapse">&#9660;</span>';
        legendHtml += "<ul>";
        for(var i = 0; i < legendItems.length; i++){
            legendHtml += "<li>";
            legendHtml += '<span class="legend-layer-subitem">' + $e4882427249fdc65$var$htmlEscape(legendItems[i]["label"]) + "</span>";
            legendHtml += '<img class="legend-layer-icon" height="17" src="data:image/png;base64,' + legendItems[i]["imageData"] + '">';
            legendHtml += "</li>";
        }
        legendHtml += "</ul>";
    }
    if (!skipLayerNameAndExpander) legendHtml = '<span class="legend-layer-subitem">' + layerName + "</span>" + legendHtml;
    return legendHtml;
}
/**
 * make map service legent
 * @param {object} esriResponse - layer info
 * @param  showLayers - limited number of layers to show in map service
 * @returns {string} legend content
 */ function $e4882427249fdc65$var$makeMapServiceLegend(esriResponse, showLayers) {
    if (showLayers === void 0) showLayers = [];
    var newLegendHtml = "";
    var layers = esriResponse["layers"];
    if (layers.length == 1) newLegendHtml += $e4882427249fdc65$var$mapServiceLegendItem(layers[0], true);
    else {
        newLegendHtml += "<ul>";
        for(var i = 0; i < layers.length; i++){
            if (showLayers.length > 0 && showLayers.indexOf(i) < 0) continue;
            newLegendHtml += "<li>" + $e4882427249fdc65$var$mapServiceLegendItem(layers[i]) + "</li>";
        }
        newLegendHtml += "</ul>";
    }
    return newLegendHtml;
}
$e4882427249fdc65$exports.makeMapServiceLegend = $e4882427249fdc65$var$makeMapServiceLegend;
$e4882427249fdc65$var$nm.makeMapServiceLegend = $e4882427249fdc65$var$makeMapServiceLegend;





/**
 * @module ol/format/EsriJSON
 */ 


/**
 * @module ol/format/Feature
 */ 


/**
 * @typedef {Object} ReadOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
 * If not provided, the projection will be derived from the data (where possible) or
 * the `dataProjection` of the format is assigned (where set). If the projection
 * can not be derived from the data and if no `dataProjection` is set for a format,
 * the features will not be reprojected.
 * @property {import("../extent.js").Extent} [extent] Tile extent of the tile being read. This is only used and
 * required for {@link module:ol/format/MVT}.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * created by the format reader. If not provided, features will be returned in the
 * `dataProjection`.
 */ /**
 * @typedef {Object} WriteOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
 * If not provided, the `dataProjection` of the format is assigned (where set).
 * If no `dataProjection` is set for a format, the features will be returned
 * in the `featureProjection`.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * that will be serialized by the format writer. If not provided, geometries are assumed
 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
 * as they are provided at construction.  If `true`, the right-hand rule will
 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
 * exterior and counter-clockwise for interior rings).  Note that not all
 * formats support this.  The GeoJSON format does use this property when writing
 * geometries.
 * @property {number} [decimals] Maximum number of decimal places for coordinates.
 * Coordinates are stored internally as floats, but floating-point arithmetic can create
 * coordinates with a large number of decimal places, not generally wanted on output.
 * Set a number here to round coordinates. Can also be used to ensure that
 * coordinates read in can be written back out with the same number of decimals.
 * Default is no rounding.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for feature formats.
 * {FeatureFormat} subclasses provide the ability to decode and encode
 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
 * file formats.  See the documentation for each format for more details.
 *
 * @abstract
 * @api
 */ var $abc939f9f19ad8b0$var$FeatureFormat = function FeatureFormat() {
    /**
   * @protected
   * @type {import("../proj/Projection.js").default}
   */ this.dataProjection = null;
    /**
   * @protected
   * @type {import("../proj/Projection.js").default}
   */ this.defaultFeatureProjection = null;
};
/**
 * Adds the data projection to the read options.
 * @param {Document|Node|Object|string} source Source.
 * @param {ReadOptions=} opt_options Options.
 * @return {ReadOptions|undefined} Options.
 * @protected
 */ $abc939f9f19ad8b0$var$FeatureFormat.prototype.getReadOptions = function getReadOptions(source, opt_options) {
    var options;
    if (opt_options) options = {
        dataProjection: opt_options.dataProjection ? opt_options.dataProjection : this.readProjection(source),
        featureProjection: opt_options.featureProjection
    };
    return this.adaptOptions(options);
};
/**
 * Sets the `dataProjection` on the options, if no `dataProjection`
 * is set.
 * @param {WriteOptions|ReadOptions|undefined} options
 *   Options.
 * @protected
 * @return {WriteOptions|ReadOptions|undefined}
 *   Updated options.
 */ $abc939f9f19ad8b0$var$FeatureFormat.prototype.adaptOptions = function adaptOptions(options) {
    return (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)({
        dataProjection: this.dataProjection,
        featureProjection: this.defaultFeatureProjection
    }, options);
};
/**
 * Get the extent from the source of the last {@link readFeatures} call.
 * @return {import("../extent.js").Extent} Tile extent.
 */ $abc939f9f19ad8b0$var$FeatureFormat.prototype.getLastExtent = function getLastExtent() {
    return null;
};
/**
 * @abstract
 * @return {import("./FormatType.js").default} Format.
 */ $abc939f9f19ad8b0$var$FeatureFormat.prototype.getType = function getType() {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * Read a single feature from a source.
 *
 * @abstract
 * @param {Document|Node|Object|string} source Source.
 * @param {ReadOptions=} opt_options Read options.
 * @return {import("../Feature.js").FeatureLike} Feature.
 */ $abc939f9f19ad8b0$var$FeatureFormat.prototype.readFeature = function readFeature(source, opt_options) {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * Read all features from a source.
 *
 * @abstract
 * @param {Document|Node|ArrayBuffer|Object|string} source Source.
 * @param {ReadOptions=} opt_options Read options.
 * @return {Array<import("../Feature.js").FeatureLike>} Features.
 */ $abc939f9f19ad8b0$var$FeatureFormat.prototype.readFeatures = function readFeatures(source, opt_options) {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * Read a single geometry from a source.
 *
 * @abstract
 * @param {Document|Node|Object|string} source Source.
 * @param {ReadOptions=} opt_options Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ $abc939f9f19ad8b0$var$FeatureFormat.prototype.readGeometry = function readGeometry(source, opt_options) {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * Read the projection from a source.
 *
 * @abstract
 * @param {Document|Node|Object|string} source Source.
 * @return {import("../proj/Projection.js").default} Projection.
 */ $abc939f9f19ad8b0$var$FeatureFormat.prototype.readProjection = function readProjection(source) {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * Encode a feature in this format.
 *
 * @abstract
 * @param {import("../Feature.js").default} feature Feature.
 * @param {WriteOptions=} opt_options Write options.
 * @return {string} Result.
 */ $abc939f9f19ad8b0$var$FeatureFormat.prototype.writeFeature = function writeFeature(feature, opt_options) {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * Encode an array of features in this format.
 *
 * @abstract
 * @param {Array<import("../Feature.js").default>} features Features.
 * @param {WriteOptions=} opt_options Write options.
 * @return {string} Result.
 */ $abc939f9f19ad8b0$var$FeatureFormat.prototype.writeFeatures = function writeFeatures(features, opt_options) {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
/**
 * Write a single geometry in this format.
 *
 * @abstract
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {WriteOptions=} opt_options Write options.
 * @return {string} Result.
 */ $abc939f9f19ad8b0$var$FeatureFormat.prototype.writeGeometry = function writeGeometry(geometry, opt_options) {
    return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
};
var $abc939f9f19ad8b0$export$2e2bcd8739ae039 = $abc939f9f19ad8b0$var$FeatureFormat;
function $abc939f9f19ad8b0$export$f47715993fe4603d(geometry, write, opt_options) {
    var featureProjection = opt_options ? (0, $92f1443438429e81$export$3988ae62b71be9a3)(opt_options.featureProjection) : null;
    var dataProjection = opt_options ? (0, $92f1443438429e81$export$3988ae62b71be9a3)(opt_options.dataProjection) : null;
    /**
   * @type {import("../geom/Geometry.js").default|import("../extent.js").Extent}
   */ var transformed;
    if (featureProjection && dataProjection && !(0, $92f1443438429e81$export$fe091d73a555748b)(featureProjection, dataProjection)) {
        if (Array.isArray(geometry)) // FIXME this is necessary because GML treats extents
        // as geometries
        transformed = (0, $92f1443438429e81$export$751c68e0e0efff79)(geometry, dataProjection, featureProjection);
        else transformed = (write ? /** @type {import("../geom/Geometry").default} */ geometry.clone() : geometry).transform(write ? featureProjection : dataProjection, write ? dataProjection : featureProjection);
    } else transformed = geometry;
    if (write && opt_options && /** @type {WriteOptions} */ opt_options.decimals !== undefined && !Array.isArray(transformed)) {
        var power = Math.pow(10, /** @type {WriteOptions} */ opt_options.decimals);
        // if decimals option on write, round each coordinate appropriately
        /**
     * @param {Array<number>} coordinates Coordinates.
     * @return {Array<number>} Transformed coordinates.
     */ var transform = function(coordinates) {
            for(var i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = Math.round(coordinates[i] * power) / power;
            return coordinates;
        };
        if (transformed === geometry) transformed = /** @type {import("../geom/Geometry").default} */ geometry.clone();
        transformed.applyTransform(transform);
    }
    return transformed;
}


/**
 * @module ol/format/JSONFeature
 */ 


/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for JSON feature formats.
 *
 * @abstract
 */ var $ee647177eb9b4503$var$JSONFeature = /*@__PURE__*/ function(FeatureFormat) {
    function JSONFeature() {
        FeatureFormat.call(this);
    }
    if (FeatureFormat) JSONFeature.__proto__ = FeatureFormat;
    JSONFeature.prototype = Object.create(FeatureFormat && FeatureFormat.prototype);
    JSONFeature.prototype.constructor = JSONFeature;
    /**
   * @inheritDoc
   */ JSONFeature.prototype.getType = function getType() {
        return (0, $60c0797155205327$export$2e2bcd8739ae039).JSON;
    };
    /**
   * Read a feature.  Only works for a single feature. Use `readFeatures` to
   * read a feature collection.
   *
   * @param {ArrayBuffer|Document|Node|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
   * @return {import("../Feature.js").default} Feature.
   * @api
   */ JSONFeature.prototype.readFeature = function readFeature(source, opt_options) {
        return this.readFeatureFromObject($ee647177eb9b4503$var$getObject(source), this.getReadOptions(source, opt_options));
    };
    /**
   * Read all features.  Works with both a single feature and a feature
   * collection.
   *
   * @param {ArrayBuffer|Document|Node|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   */ JSONFeature.prototype.readFeatures = function readFeatures(source, opt_options) {
        return this.readFeaturesFromObject($ee647177eb9b4503$var$getObject(source), this.getReadOptions(source, opt_options));
    };
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
   * @protected
   * @return {import("../Feature.js").default} Feature.
   */ JSONFeature.prototype.readFeatureFromObject = function readFeatureFromObject(object, opt_options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
   * @protected
   * @return {Array<import("../Feature.js").default>} Features.
   */ JSONFeature.prototype.readFeaturesFromObject = function readFeaturesFromObject(object, opt_options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Read a geometry.
   *
   * @param {ArrayBuffer|Document|Node|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   */ JSONFeature.prototype.readGeometry = function readGeometry(source, opt_options) {
        return this.readGeometryFromObject($ee647177eb9b4503$var$getObject(source), this.getReadOptions(source, opt_options));
    };
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ JSONFeature.prototype.readGeometryFromObject = function readGeometryFromObject(object, opt_options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Read the projection.
   *
   * @param {ArrayBuffer|Document|Node|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   */ JSONFeature.prototype.readProjection = function readProjection(source) {
        return this.readProjectionFromObject($ee647177eb9b4503$var$getObject(source));
    };
    /**
   * @abstract
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ JSONFeature.prototype.readProjectionFromObject = function readProjectionFromObject(object) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
   * @return {string} Encoded feature.
   * @api
   */ JSONFeature.prototype.writeFeature = function writeFeature(feature, opt_options) {
        return JSON.stringify(this.writeFeatureObject(feature, opt_options));
    };
    /**
   * @abstract
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
   * @return {Object} Object.
   */ JSONFeature.prototype.writeFeatureObject = function writeFeatureObject(feature, opt_options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
   * @return {string} Encoded features.
   * @api
   */ JSONFeature.prototype.writeFeatures = function writeFeatures(features, opt_options) {
        return JSON.stringify(this.writeFeaturesObject(features, opt_options));
    };
    /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
   * @return {Object} Object.
   */ JSONFeature.prototype.writeFeaturesObject = function writeFeaturesObject(features, opt_options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
   * @return {string} Encoded geometry.
   * @api
   */ JSONFeature.prototype.writeGeometry = function writeGeometry(geometry, opt_options) {
        return JSON.stringify(this.writeGeometryObject(geometry, opt_options));
    };
    /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
   * @return {Object} Object.
   */ JSONFeature.prototype.writeGeometryObject = function writeGeometryObject(geometry, opt_options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    };
    return JSONFeature;
}((0, $abc939f9f19ad8b0$export$2e2bcd8739ae039));
/**
 * @param {Document|Node|Object|string} source Source.
 * @return {Object} Object.
 */ function $ee647177eb9b4503$var$getObject(source) {
    if (typeof source === "string") {
        var object = JSON.parse(source);
        return object ? /** @type {Object} */ object : null;
    } else if (source !== null) return source;
    else return null;
}
var $ee647177eb9b4503$export$2e2bcd8739ae039 = $ee647177eb9b4503$var$JSONFeature;




/**
 * @module ol/geom/LineString
 */ 







/**
 * @module ol/geom/flat/interpolate
 */ 

function $9ed355ea392180de$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, opt_dest) {
    var pointX = NaN;
    var pointY = NaN;
    var n = (end - offset) / stride;
    if (n === 1) {
        pointX = flatCoordinates[offset];
        pointY = flatCoordinates[offset + 1];
    } else if (n == 2) {
        pointX = (1 - fraction) * flatCoordinates[offset] + fraction * flatCoordinates[offset + stride];
        pointY = (1 - fraction) * flatCoordinates[offset + 1] + fraction * flatCoordinates[offset + stride + 1];
    } else if (n !== 0) {
        var x1 = flatCoordinates[offset];
        var y1 = flatCoordinates[offset + 1];
        var length = 0;
        var cumulativeLengths = [
            0
        ];
        for(var i = offset + stride; i < end; i += stride){
            var x2 = flatCoordinates[i];
            var y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length);
            x1 = x2;
            y1 = y2;
        }
        var target = fraction * length;
        var index = (0, $830d23b8323fc080$export$2e0ae67339d5f1ac)(cumulativeLengths, target);
        if (index < 0) {
            var t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            var o = offset + (-index - 2) * stride;
            pointX = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(flatCoordinates[o], flatCoordinates[o + stride], t);
            pointY = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(flatCoordinates[o + 1], flatCoordinates[o + stride + 1], t);
        } else {
            pointX = flatCoordinates[offset + index * stride];
            pointY = flatCoordinates[offset + index * stride + 1];
        }
    }
    if (opt_dest) {
        opt_dest[0] = pointX;
        opt_dest[1] = pointY;
        return opt_dest;
    } else return [
        pointX,
        pointY
    ];
}
function $9ed355ea392180de$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    var coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        } else return null;
    } else if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        } else return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    var lo = offset / stride;
    var hi = end / stride;
    while(lo < hi){
        var mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    var m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    var m1 = flatCoordinates[(lo + 1) * stride - 1];
    var t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(var i = 0; i < stride - 1; ++i)coordinate.push((0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $9ed355ea392180de$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $9ed355ea392180de$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    var coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        } else return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        } else return null;
    }
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        else if (m <= flatCoordinates[end - 1]) return $9ed355ea392180de$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}






/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ var $a2c21eb98d0bd63f$var$LineString = /*@__PURE__*/ function(SimpleGeometry) {
    function LineString(coordinates, opt_layout) {
        SimpleGeometry.call(this);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.flatMidpoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.flatMidpointRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (opt_layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, opt_layout);
    }
    if (SimpleGeometry) LineString.__proto__ = SimpleGeometry;
    LineString.prototype = Object.create(SimpleGeometry && SimpleGeometry.prototype);
    LineString.prototype.constructor = LineString;
    /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */ LineString.prototype.appendCoordinate = function appendCoordinate(coordinate) {
        if (!this.flatCoordinates) this.flatCoordinates = coordinate.slice();
        else (0, $830d23b8323fc080$export$8b58be045bf06082)(this.flatCoordinates, coordinate);
        this.changed();
    };
    /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @override
   * @api
   */ LineString.prototype.clone = function clone() {
        return new LineString(this.flatCoordinates.slice(), this.layout);
    };
    /**
   * @inheritDoc
   */ LineString.prototype.closestPointXY = function closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf52e23c2de7bae9$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf52e23c2de7bae9$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    };
    /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */ LineString.prototype.forEachSegment = function forEachSegment$1(callback) {
        return (0, $d3093947f1b30e1e$export$4b80e395e36b5a56)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    };
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `opt_extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `opt_extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean=} opt_extrapolate Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate} Coordinate.
   * @api
   */ LineString.prototype.getCoordinateAtM = function getCoordinateAtM(m, opt_extrapolate) {
        if (this.layout != (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYM && this.layout != (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZM) return null;
        var extrapolate = opt_extrapolate !== undefined ? opt_extrapolate : false;
        return (0, $9ed355ea392180de$export$8f44c3c220ef6f09)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    };
    /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @override
   * @api
   */ LineString.prototype.getCoordinates = function getCoordinates() {
        return (0, $76a969a6125a5a4a$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate=} opt_dest Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */ LineString.prototype.getCoordinateAt = function getCoordinateAt(fraction, opt_dest) {
        return (0, $9ed355ea392180de$export$687ff82efd78795b)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, opt_dest);
    };
    /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */ LineString.prototype.getLength = function getLength() {
        return (0, $f01092ea270954d4$export$153f8c6b4d8caebc)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
   * @return {Array<number>} Flat midpoint.
   */ LineString.prototype.getFlatMidpoint = function getFlatMidpoint() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return this.flatMidpoint_;
    };
    /**
   * @inheritDoc
   */ LineString.prototype.getSimplifiedGeometryInternal = function getSimplifiedGeometryInternal(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new LineString(simplifiedFlatCoordinates, (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY);
    };
    /**
   * @inheritDoc
   * @api
   */ LineString.prototype.getType = function getType() {
        return (0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING;
    };
    /**
   * @inheritDoc
   * @api
   */ LineString.prototype.intersectsExtent = function intersectsExtent(extent) {
        return (0, $96949d2e503054c4$export$40d8d71841a3d779)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    };
    /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {GeometryLayout=} opt_layout Layout.
   * @override
   * @api
   */ LineString.prototype.setCoordinates = function setCoordinates(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $4ae92c9bec373de6$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return LineString;
}((0, $ce25558341ea2841$export$2e2bcd8739ae039));
var $a2c21eb98d0bd63f$export$2e2bcd8739ae039 = $a2c21eb98d0bd63f$var$LineString;



/**
 * @module ol/geom/MultiLineString
 */ 











/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ var $977a2295e90f3a11$var$MultiLineString = /*@__PURE__*/ function(SimpleGeometry) {
    function MultiLineString(coordinates, opt_layout, opt_ends) {
        SimpleGeometry.call(this);
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, opt_layout);
        else if (opt_layout !== undefined && opt_ends) {
            this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = opt_ends;
        } else {
            var layout = this.getLayout();
            var lineStrings = /** @type {Array<LineString>} */ coordinates;
            var flatCoordinates = [];
            var ends = [];
            for(var i = 0, ii = lineStrings.length; i < ii; ++i){
                var lineString = lineStrings[i];
                if (i === 0) layout = lineString.getLayout();
                (0, $830d23b8323fc080$export$8b58be045bf06082)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            this.setFlatCoordinates(layout, flatCoordinates);
            this.ends_ = ends;
        }
    }
    if (SimpleGeometry) MultiLineString.__proto__ = SimpleGeometry;
    MultiLineString.prototype = Object.create(SimpleGeometry && SimpleGeometry.prototype);
    MultiLineString.prototype.constructor = MultiLineString;
    /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */ MultiLineString.prototype.appendLineString = function appendLineString(lineString) {
        if (!this.flatCoordinates) this.flatCoordinates = lineString.getFlatCoordinates().slice();
        else (0, $830d23b8323fc080$export$8b58be045bf06082)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    };
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @override
   * @api
   */ MultiLineString.prototype.clone = function clone() {
        return new MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
    };
    /**
   * @inheritDoc
   */ MultiLineString.prototype.closestPointXY = function closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf52e23c2de7bae9$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf52e23c2de7bae9$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    };
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `opt_extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `opt_extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `opt_interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `opt_interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `opt_interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean=} opt_extrapolate Extrapolate. Default is `false`.
   * @param {boolean=} opt_interpolate Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate} Coordinate.
   * @api
   */ MultiLineString.prototype.getCoordinateAtM = function getCoordinateAtM(m, opt_extrapolate, opt_interpolate) {
        if (this.layout != (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYM && this.layout != (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZM || this.flatCoordinates.length === 0) return null;
        var extrapolate = opt_extrapolate !== undefined ? opt_extrapolate : false;
        var interpolate = opt_interpolate !== undefined ? opt_interpolate : false;
        return (0, $9ed355ea392180de$export$6a3300857e9ef453)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    };
    /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @override
   * @api
   */ MultiLineString.prototype.getCoordinates = function getCoordinates() {
        return (0, $76a969a6125a5a4a$export$cbb9596fc0f40db2)(this.flatCoordinates, 0, this.ends_, this.stride);
    };
    /**
   * @return {Array<number>} Ends.
   */ MultiLineString.prototype.getEnds = function getEnds() {
        return this.ends_;
    };
    /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */ MultiLineString.prototype.getLineString = function getLineString(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $a2c21eb98d0bd63f$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    };
    /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */ MultiLineString.prototype.getLineStrings = function getLineStrings() {
        var flatCoordinates = this.flatCoordinates;
        var ends = this.ends_;
        var layout = this.layout;
        /** @type {Array<LineString>} */ var lineStrings = [];
        var offset = 0;
        for(var i = 0, ii = ends.length; i < ii; ++i){
            var end = ends[i];
            var lineString = new (0, $a2c21eb98d0bd63f$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    };
    /**
   * @return {Array<number>} Flat midpoints.
   */ MultiLineString.prototype.getFlatMidpoints = function getFlatMidpoints() {
        var midpoints = [];
        var flatCoordinates = this.flatCoordinates;
        var offset = 0;
        var ends = this.ends_;
        var stride = this.stride;
        for(var i = 0, ii = ends.length; i < ii; ++i){
            var end = ends[i];
            var midpoint = (0, $9ed355ea392180de$export$687ff82efd78795b)(flatCoordinates, offset, end, stride, 0.5);
            (0, $830d23b8323fc080$export$8b58be045bf06082)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    };
    /**
   * @inheritDoc
   */ MultiLineString.prototype.getSimplifiedGeometryInternal = function getSimplifiedGeometryInternal(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        var simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$cedb9900c0b225c2)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new MultiLineString(simplifiedFlatCoordinates, (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY, simplifiedEnds);
    };
    /**
   * @inheritDoc
   * @api
   */ MultiLineString.prototype.getType = function getType() {
        return (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_LINE_STRING;
    };
    /**
   * @inheritDoc
   * @api
   */ MultiLineString.prototype.intersectsExtent = function intersectsExtent(extent) {
        return (0, $96949d2e503054c4$export$fdb1d8e850bf7937)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    };
    /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {GeometryLayout=} opt_layout Layout.
   * @override
   * @api
   */ MultiLineString.prototype.setCoordinates = function setCoordinates(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        var ends = (0, $4ae92c9bec373de6$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    };
    return MultiLineString;
}((0, $ce25558341ea2841$export$2e2bcd8739ae039));
var $977a2295e90f3a11$export$2e2bcd8739ae039 = $977a2295e90f3a11$var$MultiLineString;


/**
 * @module ol/geom/MultiPoint
 */ 







/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ var $760306f0926782cd$var$MultiPoint = /*@__PURE__*/ function(SimpleGeometry) {
    function MultiPoint(coordinates, opt_layout) {
        SimpleGeometry.call(this);
        if (opt_layout && !Array.isArray(coordinates[0])) this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, opt_layout);
    }
    if (SimpleGeometry) MultiPoint.__proto__ = SimpleGeometry;
    MultiPoint.prototype = Object.create(SimpleGeometry && SimpleGeometry.prototype);
    MultiPoint.prototype.constructor = MultiPoint;
    /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */ MultiPoint.prototype.appendPoint = function appendPoint(point) {
        if (!this.flatCoordinates) this.flatCoordinates = point.getFlatCoordinates().slice();
        else (0, $830d23b8323fc080$export$8b58be045bf06082)(this.flatCoordinates, point.getFlatCoordinates());
        this.changed();
    };
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @override
   * @api
   */ MultiPoint.prototype.clone = function clone() {
        var multiPoint = new MultiPoint(this.flatCoordinates.slice(), this.layout);
        return multiPoint;
    };
    /**
   * @inheritDoc
   */ MultiPoint.prototype.closestPointXY = function closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        var flatCoordinates = this.flatCoordinates;
        var stride = this.stride;
        for(var i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            var squaredDistance = (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for(var j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    };
    /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @override
   * @api
   */ MultiPoint.prototype.getCoordinates = function getCoordinates() {
        return (0, $76a969a6125a5a4a$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */ MultiPoint.prototype.getPoint = function getPoint(index) {
        var n = !this.flatCoordinates ? 0 : this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) return null;
        return new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    };
    /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */ MultiPoint.prototype.getPoints = function getPoints() {
        var flatCoordinates = this.flatCoordinates;
        var layout = this.layout;
        var stride = this.stride;
        /** @type {Array<Point>} */ var points = [];
        for(var i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            var point = new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)(flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    };
    /**
   * @inheritDoc
   * @api
   */ MultiPoint.prototype.getType = function getType() {
        return (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POINT;
    };
    /**
   * @inheritDoc
   * @api
   */ MultiPoint.prototype.intersectsExtent = function intersectsExtent(extent) {
        var flatCoordinates = this.flatCoordinates;
        var stride = this.stride;
        for(var i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            var x = flatCoordinates[i];
            var y = flatCoordinates[i + 1];
            if ((0, $7e819822b33b3d32$export$805bdfd6d6690e97)(extent, x, y)) return true;
        }
        return false;
    };
    /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
   * @override
   * @api
   */ MultiPoint.prototype.setCoordinates = function setCoordinates(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $4ae92c9bec373de6$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return MultiPoint;
}((0, $ce25558341ea2841$export$2e2bcd8739ae039));
var $760306f0926782cd$export$2e2bcd8739ae039 = $760306f0926782cd$var$MultiPoint;


/**
 * @module ol/geom/MultiPolygon
 */ 







/**
 * @module ol/geom/flat/center
 */ 
function $33e50334e1a46b7a$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    var flatCenters = [];
    var extent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        extent = (0, $7e819822b33b3d32$export$be0ab0bf96ca59ca)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}










/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ var $181e07a3c0063616$var$MultiPolygon = /*@__PURE__*/ function(SimpleGeometry) {
    function MultiPolygon(coordinates, opt_layout, opt_endss) {
        SimpleGeometry.call(this);
        /**
     * @type {Array<Array<number>>}
     * @private
     */ this.endss_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointsRevision_ = -1;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>}
     */ this.orientedFlatCoordinates_ = null;
        if (!opt_endss && !Array.isArray(coordinates[0])) {
            var layout = this.getLayout();
            var polygons = /** @type {Array<Polygon>} */ coordinates;
            var flatCoordinates = [];
            var endss = [];
            for(var i = 0, ii = polygons.length; i < ii; ++i){
                var polygon = polygons[i];
                if (i === 0) layout = polygon.getLayout();
                var offset = flatCoordinates.length;
                var ends = polygon.getEnds();
                for(var j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, $830d23b8323fc080$export$8b58be045bf06082)(flatCoordinates, polygon.getFlatCoordinates());
                endss.push(ends);
            }
            opt_layout = layout;
            coordinates = flatCoordinates;
            opt_endss = endss;
        }
        if (opt_layout !== undefined && opt_endss) {
            this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
            this.endss_ = opt_endss;
        } else this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, opt_layout);
    }
    if (SimpleGeometry) MultiPolygon.__proto__ = SimpleGeometry;
    MultiPolygon.prototype = Object.create(SimpleGeometry && SimpleGeometry.prototype);
    MultiPolygon.prototype.constructor = MultiPolygon;
    /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */ MultiPolygon.prototype.appendPolygon = function appendPolygon(polygon) {
        /** @type {Array<number>} */ var ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        } else {
            var offset = this.flatCoordinates.length;
            (0, $830d23b8323fc080$export$8b58be045bf06082)(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for(var i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
        }
        this.endss_.push(ends);
        this.changed();
    };
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @override
   * @api
   */ MultiPolygon.prototype.clone = function clone() {
        var len = this.endss_.length;
        var newEndss = new Array(len);
        for(var i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
        return new MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
    };
    /**
   * @inheritDoc
   */ MultiPolygon.prototype.closestPointXY = function closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf52e23c2de7bae9$export$37c18e6e7d50501a)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf52e23c2de7bae9$export$60e067685eb8f9c4)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    };
    /**
   * @inheritDoc
   */ MultiPolygon.prototype.containsXY = function containsXY(x, y) {
        return (0, $a614d7cd6ef0f487$export$c760d9d16cf92043)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    };
    /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ MultiPolygon.prototype.getArea = function getArea() {
        return (0, $b024f94ecb74bc8b$export$78e139679ca7205)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    };
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean=} opt_right Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @override
   * @api
   */ MultiPolygon.prototype.getCoordinates = function getCoordinates(opt_right) {
        var flatCoordinates;
        if (opt_right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $c8291834a008fd82$export$ea9ed55fc2a85010)(flatCoordinates, 0, this.endss_, this.stride, opt_right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $76a969a6125a5a4a$export$915c7058aeb4dfeb)(flatCoordinates, 0, this.endss_, this.stride);
    };
    /**
   * @return {Array<Array<number>>} Endss.
   */ MultiPolygon.prototype.getEndss = function getEndss() {
        return this.endss_;
    };
    /**
   * @return {Array<number>} Flat interior points.
   */ MultiPolygon.prototype.getFlatInteriorPoints = function getFlatInteriorPoints() {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            var flatCenters = (0, $33e50334e1a46b7a$export$78e139679ca7205)(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = (0, $197384c2130f50ad$export$11463803eda8a372)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return this.flatInteriorPoints_;
    };
    /**
   * Return the interior points as {@link module:ol/geom/MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */ MultiPolygon.prototype.getInteriorPoints = function getInteriorPoints() {
        return new (0, $760306f0926782cd$export$2e2bcd8739ae039)(this.getFlatInteriorPoints().slice(), (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYM);
    };
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ MultiPolygon.prototype.getOrientedFlatCoordinates = function getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            var flatCoordinates = this.flatCoordinates;
            if ((0, $c8291834a008fd82$export$f27cd06e85f4ba28)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $c8291834a008fd82$export$ea9ed55fc2a85010)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return this.orientedFlatCoordinates_;
    };
    /**
   * @inheritDoc
   */ MultiPolygon.prototype.getSimplifiedGeometryInternal = function getSimplifiedGeometryInternal(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        var simplifiedEndss = [];
        simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$b9acf67ef05cd17c)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new MultiPolygon(simplifiedFlatCoordinates, (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY, simplifiedEndss);
    };
    /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */ MultiPolygon.prototype.getPolygon = function getPolygon(index) {
        if (index < 0 || this.endss_.length <= index) return null;
        var offset;
        if (index === 0) offset = 0;
        else {
            var prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        var ends = this.endss_[index].slice();
        var end = ends[ends.length - 1];
        if (offset !== 0) for(var i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
        return new (0, $46a66e0f2fc72479$export$2e2bcd8739ae039)(this.flatCoordinates.slice(offset, end), this.layout, ends);
    };
    /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */ MultiPolygon.prototype.getPolygons = function getPolygons() {
        var layout = this.layout;
        var flatCoordinates = this.flatCoordinates;
        var endss = this.endss_;
        var polygons = [];
        var offset = 0;
        for(var i = 0, ii = endss.length; i < ii; ++i){
            var ends = endss[i].slice();
            var end = ends[ends.length - 1];
            if (offset !== 0) for(var j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
            var polygon = new (0, $46a66e0f2fc72479$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    };
    /**
   * @inheritDoc
   * @api
   */ MultiPolygon.prototype.getType = function getType() {
        return (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POLYGON;
    };
    /**
   * @inheritDoc
   * @api
   */ MultiPolygon.prototype.intersectsExtent = function intersectsExtent(extent) {
        return (0, $96949d2e503054c4$export$77b72fa3792f5bf0)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    };
    /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {GeometryLayout=} opt_layout Layout.
   * @override
   * @api
   */ MultiPolygon.prototype.setCoordinates = function setCoordinates(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 3);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        var endss = (0, $4ae92c9bec373de6$export$f9f2bb59da4accd3)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) this.flatCoordinates.length = 0;
        else {
            var lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    };
    return MultiPolygon;
}((0, $ce25558341ea2841$export$2e2bcd8739ae039));
var $181e07a3c0063616$export$2e2bcd8739ae039 = $181e07a3c0063616$var$MultiPolygon;








/**
 * @typedef {import("arcgis-rest-api").Feature} EsriJSONFeature
 * @typedef {import("arcgis-rest-api").FeatureSet} EsriJSONFeatureSet
 * @typedef {import("arcgis-rest-api").Geometry} EsriJSONGeometry
 * @typedef {import("arcgis-rest-api").Point} EsriJSONPoint
 * @typedef {import("arcgis-rest-api").Polyline} EsriJSONPolyline
 * @typedef {import("arcgis-rest-api").Polygon} EsriJSONPolygon
 * @typedef {import("arcgis-rest-api").Multipoint} EsriJSONMultipoint
 * @typedef {import("arcgis-rest-api").HasZM} EsriJSONHasZM
 * @typedef {import("arcgis-rest-api").Position} EsriJSONPosition
 * @typedef {import("arcgis-rest-api").SpatialReferenceWkid} EsriJSONSpatialReferenceWkid
 */ /**
 * @typedef {Object} EsriJSONMultiPolygon
 * @property {Array<Array<Array<Array<number>>>>} rings Rings for the MultiPolygon.
 * @property {boolean} [hasM] If the polygon coordinates have an M value.
 * @property {boolean} [hasZ] If the polygon coordinates have a Z value.
 * @property {EsriJSONSpatialReferenceWkid} [spatialReference] The coordinate reference system.
 */ /**
 * @const
 * @type {Object<import("../geom/GeometryType.js").default, function(EsriJSONGeometry): import("../geom/Geometry.js").default>}
 */ var $9d29023f494f4ae0$var$GEOMETRY_READERS = {};
$9d29023f494f4ae0$var$GEOMETRY_READERS[(0, $8826602b1d512d67$export$2e2bcd8739ae039).POINT] = $9d29023f494f4ae0$var$readPointGeometry;
$9d29023f494f4ae0$var$GEOMETRY_READERS[(0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING] = $9d29023f494f4ae0$var$readLineStringGeometry;
$9d29023f494f4ae0$var$GEOMETRY_READERS[(0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON] = $9d29023f494f4ae0$var$readPolygonGeometry;
$9d29023f494f4ae0$var$GEOMETRY_READERS[(0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POINT] = $9d29023f494f4ae0$var$readMultiPointGeometry;
$9d29023f494f4ae0$var$GEOMETRY_READERS[(0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_LINE_STRING] = $9d29023f494f4ae0$var$readMultiLineStringGeometry;
$9d29023f494f4ae0$var$GEOMETRY_READERS[(0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POLYGON] = $9d29023f494f4ae0$var$readMultiPolygonGeometry;
/**
 * @const
 * @type {Object<string, function(import("../geom/Geometry.js").default, import("./Feature.js").WriteOptions=): (EsriJSONGeometry)>}
 */ var $9d29023f494f4ae0$var$GEOMETRY_WRITERS = {};
$9d29023f494f4ae0$var$GEOMETRY_WRITERS[(0, $8826602b1d512d67$export$2e2bcd8739ae039).POINT] = $9d29023f494f4ae0$var$writePointGeometry;
$9d29023f494f4ae0$var$GEOMETRY_WRITERS[(0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING] = $9d29023f494f4ae0$var$writeLineStringGeometry;
$9d29023f494f4ae0$var$GEOMETRY_WRITERS[(0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON] = $9d29023f494f4ae0$var$writePolygonGeometry;
$9d29023f494f4ae0$var$GEOMETRY_WRITERS[(0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POINT] = $9d29023f494f4ae0$var$writeMultiPointGeometry;
$9d29023f494f4ae0$var$GEOMETRY_WRITERS[(0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_LINE_STRING] = $9d29023f494f4ae0$var$writeMultiLineStringGeometry;
$9d29023f494f4ae0$var$GEOMETRY_WRITERS[(0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POLYGON] = $9d29023f494f4ae0$var$writeMultiPolygonGeometry;
/**
 * @typedef {Object} Options
 * @property {string} [geometryName] Geometry name to use when creating features.
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the EsriJSON format.
 *
 * @api
 */ var $9d29023f494f4ae0$var$EsriJSON = /*@__PURE__*/ function(JSONFeature) {
    function EsriJSON(opt_options) {
        var options = opt_options ? opt_options : {};
        JSONFeature.call(this);
        /**
     * Name of the geometry attribute for features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
    }
    if (JSONFeature) EsriJSON.__proto__ = JSONFeature;
    EsriJSON.prototype = Object.create(JSONFeature && JSONFeature.prototype);
    EsriJSON.prototype.constructor = EsriJSON;
    /**
   * @inheritDoc
   */ EsriJSON.prototype.readFeatureFromObject = function readFeatureFromObject(object, opt_options) {
        var esriJSONFeature = /** @type {EsriJSONFeature} */ object;
        var geometry = $9d29023f494f4ae0$var$readGeometry(esriJSONFeature.geometry, opt_options);
        var feature = new (0, $1171fbd986f3130c$export$2e2bcd8739ae039)();
        if (this.geometryName_) feature.setGeometryName(this.geometryName_);
        feature.setGeometry(geometry);
        if (opt_options && opt_options.idField && esriJSONFeature.attributes[opt_options.idField]) feature.setId(/** @type {number} */ esriJSONFeature.attributes[opt_options.idField]);
        if (esriJSONFeature.attributes) feature.setProperties(esriJSONFeature.attributes);
        return feature;
    };
    /**
   * @inheritDoc
   */ EsriJSON.prototype.readFeaturesFromObject = function readFeaturesFromObject(object, opt_options) {
        var options = opt_options ? opt_options : {};
        if (object["features"]) {
            var esriJSONFeatureSet = /** @type {EsriJSONFeatureSet} */ object;
            /** @type {Array<import("../Feature.js").default>} */ var features = [];
            var esriJSONFeatures = esriJSONFeatureSet.features;
            options.idField = object.objectIdFieldName;
            for(var i = 0, ii = esriJSONFeatures.length; i < ii; ++i)features.push(this.readFeatureFromObject(esriJSONFeatures[i], options));
            return features;
        } else return [
            this.readFeatureFromObject(object, options)
        ];
    };
    /**
   * @inheritDoc
   */ EsriJSON.prototype.readGeometryFromObject = function readGeometryFromObject(object, opt_options) {
        return $9d29023f494f4ae0$var$readGeometry(/** @type {EsriJSONGeometry} */ object, opt_options);
    };
    /**
   * @inheritDoc
   */ EsriJSON.prototype.readProjectionFromObject = function readProjectionFromObject(object) {
        if (object["spatialReference"] && object["spatialReference"]["wkid"] !== undefined) {
            var spatialReference = /** @type {EsriJSONSpatialReferenceWkid} */ object["spatialReference"];
            var crs = spatialReference.wkid;
            return (0, $92f1443438429e81$export$3988ae62b71be9a3)("EPSG:" + crs);
        } else return null;
    };
    /**
   * Encode a geometry as a EsriJSON object.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
   * @return {EsriJSONGeometry} Object.
   * @override
   * @api
   */ EsriJSON.prototype.writeGeometryObject = function writeGeometryObject(geometry, opt_options) {
        return $9d29023f494f4ae0$var$writeGeometry(geometry, this.adaptOptions(opt_options));
    };
    /**
   * Encode a feature as a esriJSON Feature object.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
   * @return {Object} Object.
   * @override
   * @api
   */ EsriJSON.prototype.writeFeatureObject = function writeFeatureObject(feature, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        var object = {};
        var geometry = feature.getGeometry();
        if (geometry) {
            object["geometry"] = $9d29023f494f4ae0$var$writeGeometry(geometry, opt_options);
            if (opt_options && opt_options.featureProjection) object["geometry"]["spatialReference"] = /** @type {EsriJSONSpatialReferenceWkid} */ {
                wkid: Number((0, $92f1443438429e81$export$3988ae62b71be9a3)(opt_options.featureProjection).getCode().split(":").pop())
            };
        }
        var properties = feature.getProperties();
        delete properties[feature.getGeometryName()];
        if (!(0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(properties)) object["attributes"] = properties;
        else object["attributes"] = {};
        return object;
    };
    /**
   * Encode an array of features as a EsriJSON object.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
   * @return {Object} EsriJSON Object.
   * @override
   * @api
   */ EsriJSON.prototype.writeFeaturesObject = function writeFeaturesObject(features, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        var objects = [];
        for(var i = 0, ii = features.length; i < ii; ++i)objects.push(this.writeFeatureObject(features[i], opt_options));
        return /** @type {EsriJSONFeatureSet} */ {
            "features": objects
        };
    };
    return EsriJSON;
}((0, $ee647177eb9b4503$export$2e2bcd8739ae039));
/**
 * @param {EsriJSONGeometry} object Object.
 * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ function $9d29023f494f4ae0$var$readGeometry(object, opt_options) {
    if (!object) return null;
    /** @type {import("../geom/GeometryType.js").default} */ var type;
    if (typeof object["x"] === "number" && typeof object["y"] === "number") type = (0, $8826602b1d512d67$export$2e2bcd8739ae039).POINT;
    else if (object["points"]) type = (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POINT;
    else if (object["paths"]) {
        var esriJSONPolyline = /** @type {EsriJSONPolyline} */ object;
        if (esriJSONPolyline.paths.length === 1) type = (0, $8826602b1d512d67$export$2e2bcd8739ae039).LINE_STRING;
        else type = (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_LINE_STRING;
    } else if (object["rings"]) {
        var esriJSONPolygon = /** @type {EsriJSONPolygon} */ object;
        var layout = $9d29023f494f4ae0$var$getGeometryLayout(esriJSONPolygon);
        var rings = $9d29023f494f4ae0$var$convertRings(esriJSONPolygon.rings, layout);
        if (rings.length === 1) {
            type = (0, $8826602b1d512d67$export$2e2bcd8739ae039).POLYGON;
            object["rings"] = rings[0];
        } else {
            type = (0, $8826602b1d512d67$export$2e2bcd8739ae039).MULTI_POLYGON;
            object["rings"] = rings;
        }
    }
    var geometryReader = $9d29023f494f4ae0$var$GEOMETRY_READERS[type];
    return /** @type {import("../geom/Geometry.js").default} */ (0, $abc939f9f19ad8b0$export$f47715993fe4603d)(geometryReader(object), false, opt_options);
}
/**
 * Determines inner and outer rings.
 * Checks if any polygons in this array contain any other polygons in this
 * array. It is used for checking for holes.
 * Logic inspired by: https://github.com/Esri/terraformer-arcgis-parser
 * @param {Array<!Array<!Array<number>>>} rings Rings.
 * @param {import("../geom/GeometryLayout.js").default} layout Geometry layout.
 * @return {Array<!Array<!Array<!Array<number>>>>} Transformed rings.
 */ function $9d29023f494f4ae0$var$convertRings(rings, layout) {
    var flatRing = [];
    var outerRings = [];
    var holes = [];
    var i, ii;
    for(i = 0, ii = rings.length; i < ii; ++i){
        flatRing.length = 0;
        (0, $4ae92c9bec373de6$export$5c4daf67e03c190f)(flatRing, 0, rings[i], layout.length);
        // is this ring an outer ring? is it clockwise?
        var clockwise = (0, $c8291834a008fd82$export$318f2842ed17e094)(flatRing, 0, flatRing.length, layout.length);
        if (clockwise) outerRings.push([
            rings[i]
        ]);
        else holes.push(rings[i]);
    }
    while(holes.length){
        var hole = holes.shift();
        var matched = false;
        // loop over all outer rings and see if they contain our hole.
        for(i = outerRings.length - 1; i >= 0; i--){
            var outerRing = outerRings[i][0];
            var containsHole = (0, $7e819822b33b3d32$export$be866b1e0809b17e)(new (0, $d4b07f96c637c824$export$2e2bcd8739ae039)(outerRing).getExtent(), new (0, $d4b07f96c637c824$export$2e2bcd8739ae039)(hole).getExtent());
            if (containsHole) {
                // the hole is contained push it into our polygon
                outerRings[i].push(hole);
                matched = true;
                break;
            }
        }
        if (!matched) // no outer rings contain this hole turn it into and outer
        // ring (reverse it)
        outerRings.push([
            hole.reverse()
        ]);
    }
    return outerRings;
}
/**
 * @param {EsriJSONPoint} object Object.
 * @return {import("../geom/Geometry.js").default} Point.
 */ function $9d29023f494f4ae0$var$readPointGeometry(object) {
    var point;
    if (object.m !== undefined && object.z !== undefined) point = new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)([
        object.x,
        object.y,
        object.z,
        object.m
    ], (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZM);
    else if (object.z !== undefined) point = new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)([
        object.x,
        object.y,
        object.z
    ], (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZ);
    else if (object.m !== undefined) point = new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)([
        object.x,
        object.y,
        object.m
    ], (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYM);
    else point = new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)([
        object.x,
        object.y
    ]);
    return point;
}
/**
 * @param {EsriJSONPolyline} object Object.
 * @return {import("../geom/Geometry.js").default} LineString.
 */ function $9d29023f494f4ae0$var$readLineStringGeometry(object) {
    var layout = $9d29023f494f4ae0$var$getGeometryLayout(object);
    return new (0, $a2c21eb98d0bd63f$export$2e2bcd8739ae039)(object.paths[0], layout);
}
/**
 * @param {EsriJSONPolyline} object Object.
 * @return {import("../geom/Geometry.js").default} MultiLineString.
 */ function $9d29023f494f4ae0$var$readMultiLineStringGeometry(object) {
    var layout = $9d29023f494f4ae0$var$getGeometryLayout(object);
    return new (0, $977a2295e90f3a11$export$2e2bcd8739ae039)(object.paths, layout);
}
/**
 * @param {EsriJSONHasZM} object Object.
 * @return {import("../geom/GeometryLayout.js").default} The geometry layout to use.
 */ function $9d29023f494f4ae0$var$getGeometryLayout(object) {
    var layout = (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY;
    if (object.hasZ === true && object.hasM === true) layout = (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZM;
    else if (object.hasZ === true) layout = (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZ;
    else if (object.hasM === true) layout = (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYM;
    return layout;
}
/**
 * @param {EsriJSONMultipoint} object Object.
 * @return {import("../geom/Geometry.js").default} MultiPoint.
 */ function $9d29023f494f4ae0$var$readMultiPointGeometry(object) {
    var layout = $9d29023f494f4ae0$var$getGeometryLayout(object);
    return new (0, $760306f0926782cd$export$2e2bcd8739ae039)(object.points, layout);
}
/**
 * @param {EsriJSONMultiPolygon} object Object.
 * @return {import("../geom/Geometry.js").default} MultiPolygon.
 */ function $9d29023f494f4ae0$var$readMultiPolygonGeometry(object) {
    var layout = $9d29023f494f4ae0$var$getGeometryLayout(object);
    return new (0, $181e07a3c0063616$export$2e2bcd8739ae039)(object.rings, layout);
}
/**
 * @param {EsriJSONPolygon} object Object.
 * @return {import("../geom/Geometry.js").default} Polygon.
 */ function $9d29023f494f4ae0$var$readPolygonGeometry(object) {
    var layout = $9d29023f494f4ae0$var$getGeometryLayout(object);
    return new (0, $46a66e0f2fc72479$export$2e2bcd8739ae039)(object.rings, layout);
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
 * @return {EsriJSONGeometry} EsriJSON geometry.
 */ function $9d29023f494f4ae0$var$writePointGeometry(geometry, opt_options) {
    var coordinates = /** @type {import("../geom/Point.js").default} */ geometry.getCoordinates();
    var esriJSON;
    var layout = /** @type {import("../geom/Point.js").default} */ geometry.getLayout();
    if (layout === (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZ) esriJSON = /** @type {EsriJSONPoint} */ {
        x: coordinates[0],
        y: coordinates[1],
        z: coordinates[2]
    };
    else if (layout === (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYM) esriJSON = /** @type {EsriJSONPoint} */ {
        x: coordinates[0],
        y: coordinates[1],
        m: coordinates[2]
    };
    else if (layout === (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZM) esriJSON = /** @type {EsriJSONPoint} */ {
        x: coordinates[0],
        y: coordinates[1],
        z: coordinates[2],
        m: coordinates[3]
    };
    else if (layout === (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XY) esriJSON = /** @type {EsriJSONPoint} */ {
        x: coordinates[0],
        y: coordinates[1]
    };
    else (0, $b6052fc13e9a3991$export$a7a9523472993e97)(false, 34); // Invalid geometry layout
    return /** @type {EsriJSONGeometry} */ esriJSON;
}
/**
 * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @return {Object} Object with boolean hasZ and hasM keys.
 */ function $9d29023f494f4ae0$var$getHasZM(geometry) {
    var layout = geometry.getLayout();
    return {
        hasZ: layout === (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZ || layout === (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZM,
        hasM: layout === (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYM || layout === (0, $292479d5529f3ff8$export$2e2bcd8739ae039).XYZM
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
 * @return {EsriJSONPolyline} EsriJSON geometry.
 */ function $9d29023f494f4ae0$var$writeLineStringGeometry(geometry, opt_options) {
    var lineString = /** @type {import("../geom/LineString.js").default} */ geometry;
    var hasZM = $9d29023f494f4ae0$var$getHasZM(lineString);
    return /** @type {EsriJSONPolyline} */ {
        hasZ: hasZM.hasZ,
        hasM: hasZM.hasM,
        paths: [
            /** @type {Array<EsriJSONPosition>} */ lineString.getCoordinates()
        ]
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
 * @return {EsriJSONPolygon} EsriJSON geometry.
 */ function $9d29023f494f4ae0$var$writePolygonGeometry(geometry, opt_options) {
    var polygon = /** @type {import("../geom/Polygon.js").default} */ geometry;
    // Esri geometries use the left-hand rule
    var hasZM = $9d29023f494f4ae0$var$getHasZM(polygon);
    return /** @type {EsriJSONPolygon} */ {
        hasZ: hasZM.hasZ,
        hasM: hasZM.hasM,
        rings: /** @type {Array<Array<EsriJSONPosition>>} */ polygon.getCoordinates(false)
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
 * @return {EsriJSONPolyline} EsriJSON geometry.
 */ function $9d29023f494f4ae0$var$writeMultiLineStringGeometry(geometry, opt_options) {
    var multiLineString = /** @type {import("../geom/MultiLineString.js").default} */ geometry;
    var hasZM = $9d29023f494f4ae0$var$getHasZM(multiLineString);
    return /** @type {EsriJSONPolyline} */ {
        hasZ: hasZM.hasZ,
        hasM: hasZM.hasM,
        paths: /** @type {Array<Array<EsriJSONPosition>>} */ multiLineString.getCoordinates()
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
 * @return {EsriJSONMultipoint} EsriJSON geometry.
 */ function $9d29023f494f4ae0$var$writeMultiPointGeometry(geometry, opt_options) {
    var multiPoint = /** @type {import("../geom/MultiPoint.js").default} */ geometry;
    var hasZM = $9d29023f494f4ae0$var$getHasZM(multiPoint);
    return /** @type {EsriJSONMultipoint} */ {
        hasZ: hasZM.hasZ,
        hasM: hasZM.hasM,
        points: /** @type {Array<EsriJSONPosition>} */ multiPoint.getCoordinates()
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
 * @return {EsriJSONPolygon} EsriJSON geometry.
 */ function $9d29023f494f4ae0$var$writeMultiPolygonGeometry(geometry, opt_options) {
    var hasZM = $9d29023f494f4ae0$var$getHasZM(/** @type {import("../geom/MultiPolygon.js").default} */ geometry);
    var coordinates = /** @type {import("../geom/MultiPolygon.js").default} */ geometry.getCoordinates(false);
    var output = [];
    for(var i = 0; i < coordinates.length; i++)for(var x = coordinates[i].length - 1; x >= 0; x--)output.push(coordinates[i][x]);
    return /** @type {EsriJSONPolygon} */ {
        hasZ: hasZM.hasZ,
        hasM: hasZM.hasM,
        rings: output
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
 * @return {EsriJSONGeometry} EsriJSON geometry.
 */ function $9d29023f494f4ae0$var$writeGeometry(geometry, opt_options) {
    var geometryWriter = $9d29023f494f4ae0$var$GEOMETRY_WRITERS[geometry.getType()];
    return geometryWriter(/** @type {import("../geom/Geometry.js").default} */ (0, $abc939f9f19ad8b0$export$f47715993fe4603d)(geometry, true, opt_options), opt_options);
}
var $9d29023f494f4ae0$export$2e2bcd8739ae039 = $9d29023f494f4ae0$var$EsriJSON;


/**
 * @module ol/source/TileArcGISRest
 */ 





/**
 * @module ol/uri
 */ /**
 * Appends query parameters to a URI.
 *
 * @param {string} uri The original URI, which may already have query data.
 * @param {!Object} params An object where keys are URI-encoded parameter keys,
 *     and the values are arbitrary types or arrays.
 * @return {string} The new URI.
 */ function $e04dc6b4d00037d8$export$c202e3cb8db99a95(uri, params) {
    var keyParams = [];
    // Skip any null or undefined parameter values
    Object.keys(params).forEach(function(k) {
        if (params[k] !== null && params[k] !== undefined) keyParams.push(k + "=" + encodeURIComponent(params[k]));
    });
    var qs = keyParams.join("&");
    // remove any trailing ? or &
    uri = uri.replace(/[?&]$/, "");
    // append ? or & depending on whether uri has existing parameters
    uri = uri.indexOf("?") === -1 ? uri + "?" : uri + "&";
    return uri + qs;
}


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize=2048] Cache size.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.
 * Note that you must provide a `crossOrigin` value if you are using the WebGL renderer
 * or if you want to access pixel data with the Canvas renderer.  See
 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image
 * for more detail.
 * @property {Object<string,*>} [params] ArcGIS Rest parameters. This field is optional. Service defaults will be
 * used for any fields not specified. `FORMAT` is `PNG32` by default. `F` is `IMAGE` by
 * default. `TRANSPARENT` is `true` by default.  `BBOX`, `SIZE`, `BBOXSR`,
 * and `IMAGESR` will be set dynamically. Set `LAYERS` to
 * override the default service layer visibility. See
 * http://resources.arcgis.com/en/help/arcgis-rest-api/index.html#/Export_Map/02r3000000v7000000/
 * for further reference.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid. Base this on the resolutions,
 * tilesize and extent supported by the server.
 * If this is not defined, a default grid will be used: if there is a projection
 * extent, the grid will be based on that; if not, a grid based on a global
 * extent with origin at 0,0 will be used.
 * @property {import("../proj.js").ProjectionLike} projection Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL.
 * The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {string} [url] ArcGIS Rest service URL for a Map Service or Image Service. The
 * url should include /MapServer or /ImageServer.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition] Duration of the opacity transition for rendering.  To disable the opacity
 * transition, pass `transition: 0`.
 * @property {Array<string>} urls ArcGIS Rest service urls. Use this instead of `url` when the ArcGIS
 * Service supports multiple urls for export requests.
 */ /**
 * @classdesc
 * Layer source for tile data from ArcGIS Rest services. Map and Image
 * Services are supported.
 *
 * For cached ArcGIS services, better performance is available using the
 * {@link module:ol/source/XYZ~XYZ} data source.
 * @api
 */ var $f4107a82b9d7cea3$var$TileArcGISRest = /*@__PURE__*/ function(TileImage) {
    function TileArcGISRest(opt_options) {
        var options = opt_options || /** @type {Options} */ {};
        TileImage.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            projection: options.projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tileUrlFunction: $f4107a82b9d7cea3$var$tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition
        });
        /**
     * @private
     * @type {!Object}
     */ this.params_ = options.params || {};
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
        this.setKey(this.getKeyForParams_());
    }
    if (TileImage) TileArcGISRest.__proto__ = TileImage;
    TileArcGISRest.prototype = Object.create(TileImage && TileImage.prototype);
    TileArcGISRest.prototype.constructor = TileArcGISRest;
    /**
   * @private
   * @return {string} The key for the current params.
   */ TileArcGISRest.prototype.getKeyForParams_ = function getKeyForParams_() {
        var i = 0;
        var res = [];
        for(var key in this.params_)res[i++] = key + "-" + this.params_[key];
        return res.join("/");
    };
    /**
   * Get the user-provided params, i.e. those passed to the constructor through
   * the "params" option, and possibly updated using the updateParams method.
   * @return {Object} Params.
   * @api
   */ TileArcGISRest.prototype.getParams = function getParams() {
        return this.params_;
    };
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../size.js").Size} tileSize Tile size.
   * @param {import("../extent.js").Extent} tileExtent Tile extent.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {Object} params Params.
   * @return {string|undefined} Request URL.
   * @private
   */ TileArcGISRest.prototype.getRequestUrl_ = function getRequestUrl_(tileCoord, tileSize, tileExtent, pixelRatio, projection, params) {
        var urls = this.urls;
        if (!urls) return undefined;
        // ArcGIS Server only wants the numeric portion of the projection ID.
        var srid = projection.getCode().split(":").pop();
        params["SIZE"] = tileSize[0] + "," + tileSize[1];
        params["BBOX"] = tileExtent.join(",");
        params["BBOXSR"] = srid;
        params["IMAGESR"] = srid;
        params["DPI"] = Math.round(params["DPI"] ? params["DPI"] * pixelRatio : 90 * pixelRatio);
        var url;
        if (urls.length == 1) url = urls[0];
        else {
            var index = (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)((0, $321b949bcc451ffb$export$d6af199866bfb566)(tileCoord), urls.length);
            url = urls[index];
        }
        var modifiedUrl = url.replace(/MapServer\/?$/, "MapServer/export").replace(/ImageServer\/?$/, "ImageServer/exportImage");
        return (0, $e04dc6b4d00037d8$export$c202e3cb8db99a95)(modifiedUrl, params);
    };
    /**
   * @inheritDoc
   */ TileArcGISRest.prototype.getTilePixelRatio = function getTilePixelRatio(pixelRatio) {
        return /** @type {number} */ pixelRatio;
    };
    /**
   * Update the user-provided params.
   * @param {Object} params Params.
   * @api
   */ TileArcGISRest.prototype.updateParams = function updateParams(params) {
        (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)(this.params_, params);
        this.setKey(this.getKeyForParams_());
    };
    return TileArcGISRest;
}((0, $1df042038de9d51b$export$2e2bcd8739ae039));
/**
 * @param {import("../tilecoord.js").TileCoord} tileCoord The tile coordinate
 * @param {number} pixelRatio The pixel ratio
 * @param {import("../proj/Projection.js").default} projection The projection
 * @return {string|undefined} The tile URL
 * @this {TileArcGISRest}
 */ function $f4107a82b9d7cea3$var$tileUrlFunction(tileCoord, pixelRatio, projection) {
    var tileGrid = this.getTileGrid();
    if (!tileGrid) tileGrid = this.getTileGridForProjection(projection);
    if (tileGrid.getResolutions().length <= tileCoord[0]) return undefined;
    var tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
    var tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(tileGrid.getTileSize(tileCoord[0]), this.tmpSize);
    if (pixelRatio != 1) tileSize = (0, $f65ee5b9d8e75975$export$dcdf75081b88279d)(tileSize, pixelRatio, this.tmpSize);
    // Apply default params and override with user specified values.
    var baseParams = {
        "F": "image",
        "FORMAT": "PNG32",
        "TRANSPARENT": true
    };
    (0, $8c1e0b75b65663dc$export$e6e34fd1f2686227)(baseParams, this.params_);
    return this.getRequestUrl_(tileCoord, tileSize, tileExtent, pixelRatio, projection, baseParams);
}
var $f4107a82b9d7cea3$export$2e2bcd8739ae039 = $f4107a82b9d7cea3$var$TileArcGISRest;



var $f1a004315fae6573$var$nm = $c45303ef5b6fbfc7$exports.default("layers");
/**
 * Helper to return the url to the service on the production server
 * @param {string} folder
 * @param {string} service
 * @returns {string}
 */ function $f1a004315fae6573$var$makeServiceUrl(folder, service) {
    return "https://transportal.cee.wisc.edu/applications/arcgis2/rest/services/" + folder + "/" + service + "/MapServer";
}
$f1a004315fae6573$exports.makeServiceUrl = $f1a004315fae6573$var$makeServiceUrl;
function $f1a004315fae6573$var$localCacheUrl(folder, service) {
    var windowLocation = window.location;
    var loc = windowLocation.href;
    var url = "/mapserver/" + folder + "/" + service;
    if (loc.indexOf("transportal.cee.wisc.edu") > -1) {
        if (loc.toLowerCase().indexOf("webmapsstage") > -1) url = "https://transportal.cee.wisc.edu/gis/webmapsstage" + url;
        else url = "https://transportal.cee.wisc.edu/gis/webmaps" + url;
    } else if (parseInt(windowLocation.port) !== 8081) url = "https://transportal.cee.wisc.edu/gis/webmaps" + url;
    return url;
}
$f1a004315fae6573$exports.localCacheUrl = $f1a004315fae6573$var$localCacheUrl;
/**
 * esri mapserver layer
 * @augments LayerBase
 */ var $f1a004315fae6573$var$LayerEsriMapServer = /** @class */ function(_super) {
    $f1a004315fae6573$var$__extends(LayerEsriMapServer, _super);
    /**
     * The base layer for all others
     * @param {string} url - resource url
     * @param {object} [options] - config
     * @param {string} [options.id] - layer id
     * @param {string} [options.name=Unnamed Layer] - layer name
     * @param {number} [options.opacity=1] - opacity
     * @param {boolean} [options.visible=true] - default visible
     * @param {number} [options.minZoom=undefined] - min zoom level, 0 - 28
     * @param {number} [options.maxZoom=undefined] - max zoom level, 0 - 28
     * @param {object} [options.params={}] the get parameters to include to retrieve the layer
     * @param {number} [options.zIndex=0] the z index for the layer
     * @param {function} [options.loadCallback] function to call on load, context this is the layer object
     * @param {boolean} [options.legendCollapse=false] if the legend item should be initially collapsed
     * @param {boolean} [options.legendCheckbox=true] if the legend item should have a checkbox for visibility
     * @param {boolean} [options.legendContent] additional content to add to the legend
     * @param {boolean} [options.addPopup=false] if a popup should be added
     * @param {undefined|Array<number>} [options.showLayers=undefined] if a popup should be added
     */ function LayerEsriMapServer(url, options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, url, options) || this;
        var params = {};
        if (typeof options.showLayers !== "undefined") params["layers"] = "show:" + options.showLayers.join(",");
        _this._source = new $f4107a82b9d7cea3$export$2e2bcd8739ae039({
            url: _this.url == "" ? undefined : _this.url,
            params: params,
            urls: [
                _this.url == "" ? undefined : _this.url
            ]
        });
        _this._showLayers = options.showLayers || [];
        _this._olLayer = new $0e25041945985074$export$2e2bcd8739ae039({
            source: _this._source,
            visible: _this.visible,
            opacity: _this.opacity,
            minResolution: _this._minResolution,
            maxResolution: _this._maxResolution
        });
        _this._olLayer.setZIndex(_this._zIndex);
        options.addPopup = typeof options.addPopup == "boolean" ? options.addPopup : false;
        _this._esriFormat = new $9d29023f494f4ae0$export$2e2bcd8739ae039();
        _this._popupRequest = null;
        options.getLegend = typeof options.getLegend === "boolean" ? options.getLegend : true;
        if (options.getLegend) _this.addLegendContent();
        if (options.addPopup) $82cfea7f148fe920$exports.default.addMapServicePopup(_this);
        return _this;
    }
    /**
     * add additional content to the legend
     * @param {string} [additionalContent=''] additional content for legend
     */ LayerEsriMapServer.prototype.addLegendContent = function(additionalContent) {
        var _this = this;
        var urlCopy = this.url;
        if (urlCopy[urlCopy.length - 1] !== "/") urlCopy += "/";
        urlCopy += "legend?f=pjson&callback=?";
        $dc57b31f1b066f38$exports.get(urlCopy, {}, function(d) {
            var newHtml = $e4882427249fdc65$exports.makeMapServiceLegend(d, _this._showLayers);
            _super.prototype.addLegendContent.call(_this, newHtml);
        }, "json");
    };
    LayerEsriMapServer.prototype.getPopupInfo = function(queryParams) {
        if (!this.visible) return;
        var urlCopy = this.url;
        if (urlCopy[urlCopy.length - 1] != "/") urlCopy += "/";
        urlCopy += "identify?callback=?";
        var __this = this;
        if (this._popupRequest != null) this._popupRequest.abort();
        this._popupRequest = $dc57b31f1b066f38$exports.get(urlCopy, queryParams, function(d) {
            for(var _i = 0, _a = d["results"]; _i < _a.length; _i++){
                var r = _a[_i];
                var popupHtml = '<table class="esri-popup-table">';
                for(var a in r["attributes"])if (r["attributes"].hasOwnProperty(a)) {
                    var attrVal = r["attributes"][a];
                    if (attrVal == null || attrVal.toString().toLowerCase() == "null") continue;
                    var attr = a;
                    if (attr.length > 14) attr = attr.slice(0, 11) + "...";
                    popupHtml += "<tr><td>" + attr + "</td><td>" + attrVal + "</td></tr>";
                }
                popupHtml += "</table>";
                $82cfea7f148fe920$exports.default.addMapServicePopupContent(__this._esriFormat.readFeature(r), __this, popupHtml, r["layerName"]);
            }
        }, "json");
        this._popupRequest.always(function() {
            __this._popupRequest = null;
        });
    };
    Object.defineProperty(LayerEsriMapServer.prototype, "source", {
        get: function() {
            return _super.prototype.getSource.call(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerEsriMapServer.prototype, "olLayer", {
        get: function() {
            return _super.prototype.getOlLayer.call(this);
        },
        enumerable: false,
        configurable: true
    });
    return LayerEsriMapServer;
}($a8d82ee56684bcee$exports.LayerBase);
$f1a004315fae6573$exports.LayerEsriMapServer = $f1a004315fae6573$var$LayerEsriMapServer;
$f1a004315fae6573$var$nm.LayerEsriMapServer = $f1a004315fae6573$var$LayerEsriMapServer;
$f1a004315fae6573$exports.default = $f1a004315fae6573$var$LayerEsriMapServer;


// import $ = require("jquery");
let $c7b75ecb1ebab4ae$var$minZoomCached = 4;
let $c7b75ecb1ebab4ae$var$maxZoomCached = 8;
let $c7b75ecb1ebab4ae$var$mpaOpacity = 1;
let $c7b75ecb1ebab4ae$var$mpaLayers = [
    0,
    1
];
const $c7b75ecb1ebab4ae$export$9cc43b030498d23c = 7;
const $c7b75ecb1ebab4ae$export$7a5c0997e1e4951e = 2022;
const $c7b75ecb1ebab4ae$export$c23d59e707e59ba2 = 2023;
const $c7b75ecb1ebab4ae$export$2823211e9ec9e249 = [
    "LOTTR",
    "TTTR",
    "Delay"
];
const $c7b75ecb1ebab4ae$export$c44472fbbc495c5 = [
    "AM Peak",
    "Mid Day",
    "PM Peak",
    "Overnight",
    "Weekend",
    "Maximum"
];
const $c7b75ecb1ebab4ae$export$a6acc958a75da733 = new (0, $f1a004315fae6573$exports.LayerEsriMapServer)((0, $f1a004315fae6573$exports.localCacheUrl)("NPMRDS", "mpa_bounds"), {
    minZoom: $c7b75ecb1ebab4ae$var$minZoomCached,
    maxZoom: $c7b75ecb1ebab4ae$var$maxZoomCached,
    showLayers: $c7b75ecb1ebab4ae$var$mpaLayers,
    visible: true,
    name: "mpa_cache",
    getLegend: false,
    opacity: $c7b75ecb1ebab4ae$var$mpaOpacity
});
const $c7b75ecb1ebab4ae$export$8cc5b2f9a49aad7b = new (0, $f1a004315fae6573$exports.LayerEsriMapServer)((0, $f1a004315fae6573$exports.makeServiceUrl)("NPMRDS", "mpa_bounds"), {
    minZoom: $c7b75ecb1ebab4ae$var$maxZoomCached + 1,
    showLayers: $c7b75ecb1ebab4ae$var$mpaLayers,
    visible: true,
    name: name + "mpa_dyn",
    getLegend: false,
    opacity: 0.2
});
$c7b75ecb1ebab4ae$export$8cc5b2f9a49aad7b.opacity = 0.2;
const $c7b75ecb1ebab4ae$var$layerLookup = {};
const $c7b75ecb1ebab4ae$export$7aa73fef7821349c = [];
for(let i = 0; i < $c7b75ecb1ebab4ae$export$9cc43b030498d23c * 36; i++){
    let isInterstate = Math.floor(i / 18) % 2 == 0;
    let metric = $c7b75ecb1ebab4ae$export$2823211e9ec9e249[Math.floor(i / 6) % 3];
    let timePeriod = $c7b75ecb1ebab4ae$export$c44472fbbc495c5[i % 6];
    let year = (2017 + Math.floor(i / 36)).toFixed();
    let _name = `${year}-${isInterstate ? "int" : "non_int"}-${metric}-${timePeriod}-`;
    let cached = new (0, $f1a004315fae6573$exports.LayerEsriMapServer)((0, $f1a004315fae6573$exports.localCacheUrl)("NPMRDS", "compare_2017_2018"), {
        minZoom: $c7b75ecb1ebab4ae$var$minZoomCached,
        maxZoom: $c7b75ecb1ebab4ae$var$maxZoomCached,
        showLayers: [
            i
        ],
        visible: false,
        name: _name + "cache",
        getLegend: false,
        zIndex: isInterstate ? 7 : 5
    });
    let dynamic = new (0, $f1a004315fae6573$exports.LayerEsriMapServer)((0, $f1a004315fae6573$exports.makeServiceUrl)("NPMRDS", "compare_2017_2018"), {
        minZoom: $c7b75ecb1ebab4ae$var$maxZoomCached + 1,
        showLayers: [
            i
        ],
        visible: false,
        name: _name + "dyn",
        getLegend: false,
        zIndex: isInterstate ? 7 : 5
    });
    if (!$c7b75ecb1ebab4ae$var$layerLookup[year]) $c7b75ecb1ebab4ae$var$layerLookup[year] = {};
    if (!$c7b75ecb1ebab4ae$var$layerLookup[year][metric]) $c7b75ecb1ebab4ae$var$layerLookup[year][metric] = {};
    if (!$c7b75ecb1ebab4ae$var$layerLookup[year][metric][timePeriod]) $c7b75ecb1ebab4ae$var$layerLookup[year][metric][timePeriod] = {};
    if (isInterstate) $c7b75ecb1ebab4ae$var$layerLookup[year][metric][timePeriod]["int"] = [
        cached,
        dynamic
    ];
    else $c7b75ecb1ebab4ae$var$layerLookup[year][metric][timePeriod]["non_int"] = [
        cached,
        dynamic
    ];
    $c7b75ecb1ebab4ae$export$7aa73fef7821349c.push(cached);
    $c7b75ecb1ebab4ae$export$7aa73fef7821349c.push(dynamic);
}
function $c7b75ecb1ebab4ae$export$61f6a9c831786408(yr, metric, timeP, ints, nonInt) {
    let l = $c7b75ecb1ebab4ae$var$layerLookup[yr.toFixed()][metric][timeP];
    let outLayers = [];
    if (ints) for (let ly of l["int"])outLayers.push(ly);
    if (nonInt) for (let ly of l["non_int"])outLayers.push(ly);
    return outLayers;
}
function $c7b75ecb1ebab4ae$var$esriStyleConvert(obj) {
    let outHtml = "";
    outHtml += `<img src="data:${obj.contentType};base64,${obj["imageData"]}"/>&nbsp;`;
    outHtml += obj.label;
    return outHtml;
}
function $c7b75ecb1ebab4ae$var$makeLegendHtml(leg, lyr) {
    let legendInfo = "<ul>";
    let legendItems = leg["layers"][lyr]["legend"];
    for (let itm of legendItems)legendInfo += `<li>${$c7b75ecb1ebab4ae$var$esriStyleConvert(itm)}</li>`;
    legendInfo += "</ul>";
    return legendInfo;
}
let $c7b75ecb1ebab4ae$var$legendData = {};
let $c7b75ecb1ebab4ae$var$lottrLegend = "";
let $c7b75ecb1ebab4ae$var$ttrLegend = "";
const $c7b75ecb1ebab4ae$var$delayLegend = {
    "AM Peak": "",
    "Mid Day": "",
    "PM Peak": "",
    "Overnight": "",
    "Weekend": "",
    "Maximum": ""
};
$.get((0, $f1a004315fae6573$exports.makeServiceUrl)("NPMRDS", "compare_2017_2018_legend") + "/legend?f=pjson", {}, (d)=>{
    $c7b75ecb1ebab4ae$var$lottrLegend = $c7b75ecb1ebab4ae$var$makeLegendHtml(d, 0);
    $c7b75ecb1ebab4ae$var$ttrLegend = $c7b75ecb1ebab4ae$var$makeLegendHtml(d, 1);
    $c7b75ecb1ebab4ae$var$delayLegend["AM Peak"] = $c7b75ecb1ebab4ae$var$makeLegendHtml(d, 2);
    $c7b75ecb1ebab4ae$var$delayLegend["Mid Day"] = $c7b75ecb1ebab4ae$var$makeLegendHtml(d, 3);
    $c7b75ecb1ebab4ae$var$delayLegend["PM Peak"] = $c7b75ecb1ebab4ae$var$makeLegendHtml(d, 4);
    $c7b75ecb1ebab4ae$var$delayLegend["Overnight"] = $c7b75ecb1ebab4ae$var$makeLegendHtml(d, 5);
    $c7b75ecb1ebab4ae$var$delayLegend["Weekend"] = $c7b75ecb1ebab4ae$var$makeLegendHtml(d, 6);
    $c7b75ecb1ebab4ae$var$delayLegend["Maximum"] = $c7b75ecb1ebab4ae$var$makeLegendHtml(d, 7);
//
// // console.log(d);
// for (let i = 0; i < 16; i++) {
//
//     let metric = valsMetrics[Math.floor(i / 6) % 3];
//     let timePeriod = valsTimePeriod[i % 6];
//     let l = d['layers'][i]['legend'];
//
//     if (!legendData[metric]) {
//         legendData[metric] = {};
//     }
//
//
//
//     legendData[metric][timePeriod] = makeLegendHtml(d, i);
// }
}, "json");
function $c7b75ecb1ebab4ae$export$7800c6766de6d59f(metric, tim) {
    if (metric === "LOTTR") return $c7b75ecb1ebab4ae$var$lottrLegend;
    else if (metric === "TTTR") return $c7b75ecb1ebab4ae$var$ttrLegend;
    else return $c7b75ecb1ebab4ae$var$delayLegend[tim];
//
// console.log(metric, tim)
// if (!legendData[metric]){
//         return "";
// }
//
// if (!legendData[metric][tim]){
//         return "";
// }
//
// return legendData[metric][tim];
}


const $54e91371eee26243$export$67bc4958b53223b6 = "set period";
const $54e91371eee26243$export$8d07e2cf432fc8a9 = "set metric";
const $54e91371eee26243$export$3f59ade4d8f7e2ed = "set map";
const $54e91371eee26243$export$e6f55032c1689689 = "set show interstate";
const $54e91371eee26243$export$3a400aac470ddc77 = "set show other";
const $54e91371eee26243$export$a28c315522f7b563 = "SET_LEFT_YEAR";
const $54e91371eee26243$export$b196d66ea17512eb = "SET_RIGHT_YEAR";
function $54e91371eee26243$var$map(state = null, action) {
    if (action.type == $54e91371eee26243$export$3f59ade4d8f7e2ed) return action.map;
    else return state;
}
function $54e91371eee26243$var$metric(state = $c7b75ecb1ebab4ae$export$2823211e9ec9e249[0], action) {
    if (action.type == $54e91371eee26243$export$8d07e2cf432fc8a9) return action.metric;
    else return state;
}
function $54e91371eee26243$var$period(state = $c7b75ecb1ebab4ae$export$c44472fbbc495c5[0], action) {
    if (action.type == $54e91371eee26243$export$67bc4958b53223b6) return action.period;
    else return state;
}
function $54e91371eee26243$var$showInterstate(state = true, action) {
    if (action.type == $54e91371eee26243$export$e6f55032c1689689) return action.show;
    else return state;
}
function $54e91371eee26243$var$showOther(state = false, action) {
    if (action.type == $54e91371eee26243$export$3a400aac470ddc77) return action.show;
    else return state;
}
function $54e91371eee26243$var$leftYear(state = $c7b75ecb1ebab4ae$export$7a5c0997e1e4951e, action) {
    if (action.type == $54e91371eee26243$export$a28c315522f7b563) return action.year;
    else return state;
}
function $54e91371eee26243$var$rightYear(state = $c7b75ecb1ebab4ae$export$c23d59e707e59ba2, action) {
    if (action.type == $54e91371eee26243$export$b196d66ea17512eb) return action.year;
    else return state;
}
const $54e91371eee26243$export$6f57813fe9f31bf9 = (0, $005f68b908ac2328$export$2e2bcd8739ae039)((0, $a2aa30f1eef97a24$export$2e2bcd8739ae039)({
    metric: $54e91371eee26243$var$metric,
    period: $54e91371eee26243$var$period,
    showInterstate: $54e91371eee26243$var$showInterstate,
    showOther: $54e91371eee26243$var$showOther,
    map: $54e91371eee26243$var$map,
    leftYear: $54e91371eee26243$var$leftYear,
    rightYear: $54e91371eee26243$var$rightYear
}));
function $54e91371eee26243$export$50fdfeece43146fd() {
    return $54e91371eee26243$export$6f57813fe9f31bf9.getState();
}


var $27c95fd68ff17ad8$exports = {};
"use strict";
/**
 * Created by glenn on 6/12/2017.
 */ var $27c95fd68ff17ad8$var$__extends = $27c95fd68ff17ad8$exports && $27c95fd68ff17ad8$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $27c95fd68ff17ad8$var$__assign = $27c95fd68ff17ad8$exports && $27c95fd68ff17ad8$exports.__assign || function() {
    $27c95fd68ff17ad8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $27c95fd68ff17ad8$var$__assign.apply(this, arguments);
};
Object.defineProperty($27c95fd68ff17ad8$exports, "__esModule", {
    value: true
});
$27c95fd68ff17ad8$exports.RadioConnected = $27c95fd68ff17ad8$exports.Radio = void 0;
var $120de375adffa2b4$exports = {};
"use strict";

$120de375adffa2b4$exports = (parcelRequire("afi2q"));


/*!
 * jQuery UI Widget 1.13.2
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */ //>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: http://api.jqueryui.com/jQuery.widget/
//>>demos: http://jqueryui.com/widget/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    var widgetUuid = 0;
    var widgetHasOwnProperty = Array.prototype.hasOwnProperty;
    var widgetSlice = Array.prototype.slice;
    $.cleanData = function(orig) {
        return function(elems) {
            var events, elem, i;
            for(i = 0; (elem = elems[i]) != null; i++){
                // Only trigger remove when necessary to save time
                events = $._data(elem, "events");
                if (events && events.remove) $(elem).triggerHandler("remove");
            }
            orig(elems);
        };
    }($.cleanData);
    $.widget = function(name, base, prototype) {
        var existingConstructor, constructor, basePrototype;
        // ProxiedPrototype allows the provided prototype to remain unmodified
        // so that it can be used as a mixin for multiple widgets (#8876)
        var proxiedPrototype = {};
        var namespace = name.split(".")[0];
        name = name.split(".")[1];
        var fullName = namespace + "-" + name;
        if (!prototype) {
            prototype = base;
            base = $.Widget;
        }
        if (Array.isArray(prototype)) prototype = $.extend.apply(null, [
            {}
        ].concat(prototype));
        // Create selector for plugin
        $.expr.pseudos[fullName.toLowerCase()] = function(elem) {
            return !!$.data(elem, fullName);
        };
        $[namespace] = $[namespace] || {};
        existingConstructor = $[namespace][name];
        constructor = $[namespace][name] = function(options, element) {
            // Allow instantiation without "new" keyword
            if (!this || !this._createWidget) return new constructor(options, element);
            // Allow instantiation without initializing for simple inheritance
            // must use "new" keyword (the code above always passes args)
            if (arguments.length) this._createWidget(options, element);
        };
        // Extend with the existing constructor to carry over any static properties
        $.extend(constructor, existingConstructor, {
            version: prototype.version,
            // Copy the object used to create the prototype in case we need to
            // redefine the widget later
            _proto: $.extend({}, prototype),
            // Track widgets that inherit from this widget in case this widget is
            // redefined after a widget inherits from it
            _childConstructors: []
        });
        basePrototype = new base();
        // We need to make the options hash a property directly on the new instance
        // otherwise we'll modify the options hash on the prototype that we're
        // inheriting from
        basePrototype.options = $.widget.extend({}, basePrototype.options);
        $.each(prototype, function(prop, value) {
            if (typeof value !== "function") {
                proxiedPrototype[prop] = value;
                return;
            }
            proxiedPrototype[prop] = function() {
                function _super() {
                    return base.prototype[prop].apply(this, arguments);
                }
                function _superApply(args) {
                    return base.prototype[prop].apply(this, args);
                }
                return function() {
                    var __super = this._super;
                    var __superApply = this._superApply;
                    var returnValue;
                    this._super = _super;
                    this._superApply = _superApply;
                    returnValue = value.apply(this, arguments);
                    this._super = __super;
                    this._superApply = __superApply;
                    return returnValue;
                };
            }();
        });
        constructor.prototype = $.widget.extend(basePrototype, {
            // TODO: remove support for widgetEventPrefix
            // always use the name + a colon as the prefix, e.g., draggable:start
            // don't prefix for widgets that aren't DOM-based
            widgetEventPrefix: existingConstructor ? basePrototype.widgetEventPrefix || name : name
        }, proxiedPrototype, {
            constructor: constructor,
            namespace: namespace,
            widgetName: name,
            widgetFullName: fullName
        });
        // If this widget is being redefined then we need to find all widgets that
        // are inheriting from it and redefine all of them so that they inherit from
        // the new version of this widget. We're essentially trying to replace one
        // level in the prototype chain.
        if (existingConstructor) {
            $.each(existingConstructor._childConstructors, function(i, child) {
                var childPrototype = child.prototype;
                // Redefine the child widget using the same prototype that was
                // originally used, but inherit from the new version of the base
                $.widget(childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto);
            });
            // Remove the list of existing child constructors from the old constructor
            // so the old child constructors can be garbage collected
            delete existingConstructor._childConstructors;
        } else base._childConstructors.push(constructor);
        $.widget.bridge(name, constructor);
        return constructor;
    };
    $.widget.extend = function(target) {
        var input = widgetSlice.call(arguments, 1);
        var inputIndex = 0;
        var inputLength = input.length;
        var key;
        var value;
        for(; inputIndex < inputLength; inputIndex++)for(key in input[inputIndex]){
            value = input[inputIndex][key];
            if (widgetHasOwnProperty.call(input[inputIndex], key) && value !== undefined) {
                // Clone objects
                if ($.isPlainObject(value)) target[key] = $.isPlainObject(target[key]) ? $.widget.extend({}, target[key], value) : // Don't extend strings, arrays, etc. with objects
                $.widget.extend({}, value);
                else target[key] = value;
            }
        }
        return target;
    };
    $.widget.bridge = function(name, object) {
        var fullName = object.prototype.widgetFullName || name;
        $.fn[name] = function(options) {
            var isMethodCall = typeof options === "string";
            var args = widgetSlice.call(arguments, 1);
            var returnValue = this;
            if (isMethodCall) {
                // If this is an empty collection, we need to have the instance method
                // return undefined instead of the jQuery instance
                if (!this.length && options === "instance") returnValue = undefined;
                else this.each(function() {
                    var methodValue;
                    var instance = $.data(this, fullName);
                    if (options === "instance") {
                        returnValue = instance;
                        return false;
                    }
                    if (!instance) return $.error("cannot call methods on " + name + " prior to initialization; " + "attempted to call method '" + options + "'");
                    if (typeof instance[options] !== "function" || options.charAt(0) === "_") return $.error("no such method '" + options + "' for " + name + " widget instance");
                    methodValue = instance[options].apply(instance, args);
                    if (methodValue !== instance && methodValue !== undefined) {
                        returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
                        return false;
                    }
                });
            } else {
                // Allow multiple hashes to be passed on init
                if (args.length) options = $.widget.extend.apply(null, [
                    options
                ].concat(args));
                this.each(function() {
                    var instance = $.data(this, fullName);
                    if (instance) {
                        instance.option(options || {});
                        if (instance._init) instance._init();
                    } else $.data(this, fullName, new object(options, this));
                });
            }
            return returnValue;
        };
    };
    $.Widget = function() {};
    $.Widget._childConstructors = [];
    $.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: {
            classes: {},
            disabled: false,
            // Callbacks
            create: null
        },
        _createWidget: function(options, element) {
            element = $(element || this.defaultElement || this)[0];
            this.element = $(element);
            this.uuid = widgetUuid++;
            this.eventNamespace = "." + this.widgetName + this.uuid;
            this.bindings = $();
            this.hoverable = $();
            this.focusable = $();
            this.classesElementLookup = {};
            if (element !== this) {
                $.data(element, this.widgetFullName, this);
                this._on(true, this.element, {
                    remove: function(event) {
                        if (event.target === element) this.destroy();
                    }
                });
                this.document = $(element.style ? // Element within the document
                element.ownerDocument : // Element is window or document
                element.document || element);
                this.window = $(this.document[0].defaultView || this.document[0].parentWindow);
            }
            this.options = $.widget.extend({}, this.options, this._getCreateOptions(), options);
            this._create();
            if (this.options.disabled) this._setOptionDisabled(this.options.disabled);
            this._trigger("create", null, this._getCreateEventData());
            this._init();
        },
        _getCreateOptions: function() {
            return {};
        },
        _getCreateEventData: $.noop,
        _create: $.noop,
        _init: $.noop,
        destroy: function() {
            var that = this;
            this._destroy();
            $.each(this.classesElementLookup, function(key, value) {
                that._removeClass(value, key);
            });
            // We can probably remove the unbind calls in 2.0
            // all event bindings should go through this._on()
            this.element.off(this.eventNamespace).removeData(this.widgetFullName);
            this.widget().off(this.eventNamespace).removeAttr("aria-disabled");
            // Clean up events and states
            this.bindings.off(this.eventNamespace);
        },
        _destroy: $.noop,
        widget: function() {
            return this.element;
        },
        option: function(key, value) {
            var options = key;
            var parts;
            var curOption;
            var i;
            if (arguments.length === 0) // Don't return a reference to the internal hash
            return $.widget.extend({}, this.options);
            if (typeof key === "string") {
                // Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
                options = {};
                parts = key.split(".");
                key = parts.shift();
                if (parts.length) {
                    curOption = options[key] = $.widget.extend({}, this.options[key]);
                    for(i = 0; i < parts.length - 1; i++){
                        curOption[parts[i]] = curOption[parts[i]] || {};
                        curOption = curOption[parts[i]];
                    }
                    key = parts.pop();
                    if (arguments.length === 1) return curOption[key] === undefined ? null : curOption[key];
                    curOption[key] = value;
                } else {
                    if (arguments.length === 1) return this.options[key] === undefined ? null : this.options[key];
                    options[key] = value;
                }
            }
            this._setOptions(options);
            return this;
        },
        _setOptions: function(options) {
            var key;
            for(key in options)this._setOption(key, options[key]);
            return this;
        },
        _setOption: function(key, value) {
            if (key === "classes") this._setOptionClasses(value);
            this.options[key] = value;
            if (key === "disabled") this._setOptionDisabled(value);
            return this;
        },
        _setOptionClasses: function(value) {
            var classKey, elements, currentElements;
            for(classKey in value){
                currentElements = this.classesElementLookup[classKey];
                if (value[classKey] === this.options.classes[classKey] || !currentElements || !currentElements.length) continue;
                // We are doing this to create a new jQuery object because the _removeClass() call
                // on the next line is going to destroy the reference to the current elements being
                // tracked. We need to save a copy of this collection so that we can add the new classes
                // below.
                elements = $(currentElements.get());
                this._removeClass(currentElements, classKey);
                // We don't use _addClass() here, because that uses this.options.classes
                // for generating the string of classes. We want to use the value passed in from
                // _setOption(), this is the new value of the classes option which was passed to
                // _setOption(). We pass this value directly to _classes().
                elements.addClass(this._classes({
                    element: elements,
                    keys: classKey,
                    classes: value,
                    add: true
                }));
            }
        },
        _setOptionDisabled: function(value) {
            this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!value);
            // If the widget is becoming disabled, then nothing is interactive
            if (value) {
                this._removeClass(this.hoverable, null, "ui-state-hover");
                this._removeClass(this.focusable, null, "ui-state-focus");
            }
        },
        enable: function() {
            return this._setOptions({
                disabled: false
            });
        },
        disable: function() {
            return this._setOptions({
                disabled: true
            });
        },
        _classes: function(options) {
            var full = [];
            var that = this;
            options = $.extend({
                element: this.element,
                classes: this.options.classes || {}
            }, options);
            function bindRemoveEvent() {
                var nodesToBind = [];
                options.element.each(function(_, element) {
                    var isTracked = $.map(that.classesElementLookup, function(elements) {
                        return elements;
                    }).some(function(elements) {
                        return elements.is(element);
                    });
                    if (!isTracked) nodesToBind.push(element);
                });
                that._on($(nodesToBind), {
                    remove: "_untrackClassesElement"
                });
            }
            function processClassString(classes, checkOption) {
                var current, i;
                for(i = 0; i < classes.length; i++){
                    current = that.classesElementLookup[classes[i]] || $();
                    if (options.add) {
                        bindRemoveEvent();
                        current = $($.uniqueSort(current.get().concat(options.element.get())));
                    } else current = $(current.not(options.element).get());
                    that.classesElementLookup[classes[i]] = current;
                    full.push(classes[i]);
                    if (checkOption && options.classes[classes[i]]) full.push(options.classes[classes[i]]);
                }
            }
            if (options.keys) processClassString(options.keys.match(/\S+/g) || [], true);
            if (options.extra) processClassString(options.extra.match(/\S+/g) || []);
            return full.join(" ");
        },
        _untrackClassesElement: function(event) {
            var that = this;
            $.each(that.classesElementLookup, function(key, value) {
                if ($.inArray(event.target, value) !== -1) that.classesElementLookup[key] = $(value.not(event.target).get());
            });
            this._off($(event.target));
        },
        _removeClass: function(element, keys, extra) {
            return this._toggleClass(element, keys, extra, false);
        },
        _addClass: function(element, keys, extra) {
            return this._toggleClass(element, keys, extra, true);
        },
        _toggleClass: function(element, keys, extra, add) {
            add = typeof add === "boolean" ? add : extra;
            var shift = typeof element === "string" || element === null, options = {
                extra: shift ? keys : extra,
                keys: shift ? element : keys,
                element: shift ? this.element : element,
                add: add
            };
            options.element.toggleClass(this._classes(options), add);
            return this;
        },
        _on: function(suppressDisabledCheck, element, handlers) {
            var delegateElement;
            var instance = this;
            // No suppressDisabledCheck flag, shuffle arguments
            if (typeof suppressDisabledCheck !== "boolean") {
                handlers = element;
                element = suppressDisabledCheck;
                suppressDisabledCheck = false;
            }
            // No element argument, shuffle and use this.element
            if (!handlers) {
                handlers = element;
                element = this.element;
                delegateElement = this.widget();
            } else {
                element = delegateElement = $(element);
                this.bindings = this.bindings.add(element);
            }
            $.each(handlers, function(event, handler) {
                function handlerProxy() {
                    // Allow widgets to customize the disabled handling
                    // - disabled as an array instead of boolean
                    // - disabled class as method for disabling individual parts
                    if (!suppressDisabledCheck && (instance.options.disabled === true || $(this).hasClass("ui-state-disabled"))) return;
                    return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
                }
                // Copy the guid so direct unbinding works
                if (typeof handler !== "string") handlerProxy.guid = handler.guid = handler.guid || handlerProxy.guid || $.guid++;
                var match = event.match(/^([\w:-]*)\s*(.*)$/);
                var eventName = match[1] + instance.eventNamespace;
                var selector = match[2];
                if (selector) delegateElement.on(eventName, selector, handlerProxy);
                else element.on(eventName, handlerProxy);
            });
        },
        _off: function(element, eventName) {
            eventName = (eventName || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace;
            element.off(eventName);
            // Clear the stack to avoid memory leaks (#10056)
            this.bindings = $(this.bindings.not(element).get());
            this.focusable = $(this.focusable.not(element).get());
            this.hoverable = $(this.hoverable.not(element).get());
        },
        _delay: function(handler, delay) {
            function handlerProxy() {
                return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
            }
            var instance = this;
            return setTimeout(handlerProxy, delay || 0);
        },
        _hoverable: function(element) {
            this.hoverable = this.hoverable.add(element);
            this._on(element, {
                mouseenter: function(event) {
                    this._addClass($(event.currentTarget), null, "ui-state-hover");
                },
                mouseleave: function(event) {
                    this._removeClass($(event.currentTarget), null, "ui-state-hover");
                }
            });
        },
        _focusable: function(element) {
            this.focusable = this.focusable.add(element);
            this._on(element, {
                focusin: function(event) {
                    this._addClass($(event.currentTarget), null, "ui-state-focus");
                },
                focusout: function(event) {
                    this._removeClass($(event.currentTarget), null, "ui-state-focus");
                }
            });
        },
        _trigger: function(type, event, data) {
            var prop, orig;
            var callback = this.options[type];
            data = data || {};
            event = $.Event(event);
            event.type = (type === this.widgetEventPrefix ? type : this.widgetEventPrefix + type).toLowerCase();
            // The original event may come from any element
            // so we need to reset the target on the new event
            event.target = this.element[0];
            // Copy original event properties over to the new event
            orig = event.originalEvent;
            if (orig) {
                for(prop in orig)if (!(prop in event)) event[prop] = orig[prop];
            }
            this.element.trigger(event, data);
            return !(typeof callback === "function" && callback.apply(this.element[0], [
                event
            ].concat(data)) === false || event.isDefaultPrevented());
        }
    };
    $.each({
        show: "fadeIn",
        hide: "fadeOut"
    }, function(method, defaultEffect) {
        $.Widget.prototype["_" + method] = function(element, options, callback) {
            if (typeof options === "string") options = {
                effect: options
            };
            var hasOptions;
            var effectName = !options ? method : options === true || typeof options === "number" ? defaultEffect : options.effect || defaultEffect;
            options = options || {};
            if (typeof options === "number") options = {
                duration: options
            };
            else if (options === true) options = {};
            hasOptions = !$.isEmptyObject(options);
            options.complete = callback;
            if (options.delay) element.delay(options.delay);
            if (hasOptions && $.effects && $.effects.effect[effectName]) element[method](options);
            else if (effectName !== method && element[effectName]) element[effectName](options.duration, options.easing, callback);
            else element.queue(function(next) {
                $(this)[method]();
                if (callback) callback.call(element[0]);
                next();
            });
        };
    });
    return $.widget;
});



var $27c95fd68ff17ad8$var$RadioItem = /** @class */ function(_super) {
    $27c95fd68ff17ad8$var$__extends(RadioItem, _super);
    function RadioItem(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.guid = $68981f1a81adf307$exports.default();
        return _this;
    }
    RadioItem.prototype.render = function() {
        var _this = this;
        var style = {};
        if (this.props.inline) style = {
            display: "inline-block",
            padding: "0 5px"
        };
        var props = {
            id: this.guid,
            type: "radio",
            name: this.props.groupId,
            value: typeof this.props.index == "undefined" ? this.props.text : this.props.index.toFixed(),
            onChange: function(evt) {
                _this.props.change(evt.target.value);
                evt.target.checked = true;
            },
            checked: this.props.checked,
            defaultChecked: this.props.checked
        };
        if (this.props.connected) delete props.defaultChecked;
        else delete props.checked;
        return $120de375adffa2b4$exports.createElement("li", {
            style: style
        }, $120de375adffa2b4$exports.createElement("input", $27c95fd68ff17ad8$var$__assign({}, props)), $120de375adffa2b4$exports.createElement("label", {
            htmlFor: this.guid
        }, this.props.text));
    };
    return RadioItem;
}($120de375adffa2b4$exports.Component);
var $27c95fd68ff17ad8$var$RadioBase = /** @class */ function(_super) {
    $27c95fd68ff17ad8$var$__extends(RadioBase, _super);
    function RadioBase(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.inline = _this.props.inline || false;
        _this.groupId = _this.props.title.toLowerCase().replace(/ /g, "");
        return _this;
    }
    RadioBase.prototype.render = function() {
        var _this = this;
        var arr = [];
        for(var i = 0; i < this.props.items.length; i++){
            var itemProps = {
                groupId: this.groupId,
                text: this.props.items[i],
                inline: this.props.inline,
                change: function(s) {
                    return _this.props.callback(s);
                },
                key: this.props.items[i],
                connected: this.props.connected || false,
                checked: false,
                index: i
            };
            if (typeof this.props.selectedValueOrIndex == "number") itemProps.checked = i == this.props.selectedValueOrIndex;
            else {
                itemProps.checked = this.props.items[i] == this.props.selectedValueOrIndex;
                delete itemProps.index;
            }
            arr.push($120de375adffa2b4$exports.createElement($27c95fd68ff17ad8$var$RadioItem, $27c95fd68ff17ad8$var$__assign({}, itemProps)));
        }
        var classes = [
            "radio-list"
        ];
        if (this.props.classes) classes = classes.concat(this.props.classes);
        return $120de375adffa2b4$exports.createElement("div", {
            className: classes.join(" ")
        }, $120de375adffa2b4$exports.createElement("h4", null, this.props.title), $120de375adffa2b4$exports.createElement("ul", {
            style: {
                listStyle: "none"
            }
        }, arr));
    };
    return RadioBase;
}($120de375adffa2b4$exports.Component);
//
// interface _iRadioBaseOpt {
//     inline?: boolean;
//     classes?: string[];
// }
//
// interface _iRadioBase extends _iRadioBaseOpt{
//     title: string;
//     items: string[];
//     callback: (val: string) => any;
//     connected: boolean;
// }
//
// interface iRadioBase extends _iRadioBase{
//     selectedValueOrIndex: string|number;
// }
// interface iRadio {
//     title: string;
//     items: string[];
//     callback: (val: string) => any;
//     inline?: boolean;
//     classes?: string[];
// }
var $27c95fd68ff17ad8$var$Radio = /** @class */ function(_super) {
    $27c95fd68ff17ad8$var$__extends(Radio, _super);
    function Radio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Radio.prototype.render = function() {
        return $120de375adffa2b4$exports.createElement($27c95fd68ff17ad8$var$RadioBase, {
            title: this.props.title,
            items: this.props.items,
            callback: this.props.callback,
            inline: this.props.inline,
            selectedValueOrIndex: this.props.defaultValue,
            connected: false,
            classes: this.props.classes
        });
    };
    return Radio;
}($120de375adffa2b4$exports.Component);
$27c95fd68ff17ad8$exports.Radio = $27c95fd68ff17ad8$var$Radio;
var $27c95fd68ff17ad8$var$RadioConnected = /** @class */ function(_super) {
    $27c95fd68ff17ad8$var$__extends(RadioConnected, _super);
    function RadioConnected() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioConnected.prototype.render = function() {
        return $120de375adffa2b4$exports.createElement($27c95fd68ff17ad8$var$RadioBase, {
            title: this.props.title,
            items: this.props.items,
            callback: this.props.callback,
            inline: this.props.inline,
            selectedValueOrIndex: this.props.selectedIndex,
            connected: true,
            classes: this.props.classes
        });
    };
    RadioConnected.defaultProps = {
        inline: false,
        classes: []
    };
    return RadioConnected;
}($120de375adffa2b4$exports.Component);
$27c95fd68ff17ad8$exports.RadioConnected = $27c95fd68ff17ad8$var$RadioConnected;







let $dc9109b087454aaa$var$minZoomCached = 4;
let $dc9109b087454aaa$var$maxZoomCached = 8;
let $dc9109b087454aaa$export$cd233e9e428ae00e = [];
// let layerKeysInterstate: iLayerKeys2 = {};
// let layerKeysOther: iLayerKeys2 = {};
let $dc9109b087454aaa$var$layerDiv;
let $dc9109b087454aaa$var$theUl;
let $dc9109b087454aaa$var$lis;
function $dc9109b087454aaa$export$e8f1ea4a10bfd1c9(state) {
    if (!$dc9109b087454aaa$var$layerDiv) $dc9109b087454aaa$var$layerDiv = document.querySelector(".legend-layer-div");
    if (!$dc9109b087454aaa$var$layerDiv) return false;
    if (!$dc9109b087454aaa$var$theUl) $dc9109b087454aaa$var$theUl = $dc9109b087454aaa$var$layerDiv.querySelector("ul");
    if (!$dc9109b087454aaa$var$theUl || $dc9109b087454aaa$var$theUl.children.length == 0) return false;
    $dc9109b087454aaa$var$lis = $dc9109b087454aaa$var$theUl.children;
    for(let i = 0; i < $dc9109b087454aaa$var$lis.length; i++)switch(state.metric){
        case (0, $c7b75ecb1ebab4ae$export$2823211e9ec9e249)[0]:
            if (i == 0) $dc9109b087454aaa$var$lis[i].classList.remove("suppress-legend");
            else $dc9109b087454aaa$var$lis[i].classList.add("suppress-legend");
            break;
        case (0, $c7b75ecb1ebab4ae$export$2823211e9ec9e249)[1]:
            if (i == 1) $dc9109b087454aaa$var$lis[i].classList.remove("suppress-legend");
            else $dc9109b087454aaa$var$lis[i].classList.add("suppress-legend");
            break;
        case (0, $c7b75ecb1ebab4ae$export$2823211e9ec9e249)[2]:
            let theIndex = (0, $c7b75ecb1ebab4ae$export$c44472fbbc495c5).indexOf(state.period) + 2;
            if (i == theIndex) $dc9109b087454aaa$var$lis[i].classList.remove("suppress-legend");
            else $dc9109b087454aaa$var$lis[i].classList.add("suppress-legend");
            break;
        default:
            throw "val not found";
    }
    return true;
}
function $dc9109b087454aaa$export$4313aa101fde9289() {
    let state = (0, $54e91371eee26243$export$50fdfeece43146fd)();
    for (let l of $dc9109b087454aaa$export$cd233e9e428ae00e)l.visible = false;
    // if (state.showInterstate) {
    //     for (let lyr of layerKeysInterstate[state.metric][state.period]) {
    //         lyr.visible = true;
    //     }
    // }
    // if (state.showOther) {
    //     for (let lyr of layerKeysOther[state.metric][state.period]) {
    //         lyr.visible = true;
    //     }
    // }
    if (!$dc9109b087454aaa$export$e8f1ea4a10bfd1c9(state)) {
        let int = setInterval(()=>{
            if ($dc9109b087454aaa$export$e8f1ea4a10bfd1c9(state)) clearInterval(int);
        }, 100);
    }
} //
 // export function addLayers(map: Map, swiper: LayerSwipe) {
 //
 //     let mpaOpacity = 1;
 //     let mpaLayers = [0, 1];
 //
 //     let cachedMpa = new LayerEsriMapServer(
 //         localCacheUrl('NPMRDS', 'mpa_bounds'),
 //         {
 //             minZoom: minZoomCached,
 //             maxZoom: maxZoomCached,
 //             showLayers: mpaLayers,
 //             visible: true,
 //             name: 'mpa_cache',
 //             getLegend: false,
 //             opacity: mpaOpacity
 //         });
 //
 //     let dynamicMpa = new LayerEsriMapServer(
 //         makeServiceUrl('NPMRDS', 'mpa_bounds'),
 //         {
 //             minZoom: maxZoomCached + 1,
 //             showLayers: mpaLayers,
 //             visible: true,
 //             name: name + 'mpa_dyn',
 //             getLegend: false,
 //             opacity: mpaOpacity
 //         });
 //
 //     map.addLayer(cachedMpa.olLayer);
 //     map.addLayer(dynamicMpa.olLayer);
 //
 //     for (let i = 0; i < 144; i++) {
 //
 //         let isInterstate = Math.floor(i / 18) % 2 == 0;
 //         let metric = valsMetrics[Math.floor(i / 6) % 3];
 //         let timePeriod = valsTimePeriod[i % 6];
 //         let year = (2017 + Math.floor(i / 36)).toFixed();
 //
 //         let _name = `${year}-${isInterstate ? 'int' : 'non_int'}-${metric}-${timePeriod}-`;
 //
 //         let cached = new LayerEsriMapServer(
 //             localCacheUrl('NPMRDS', 'compare_2017_2018'),
 //             {
 //                 minZoom: minZoomCached,
 //                 maxZoom: maxZoomCached,
 //                 showLayers: [i],
 //                 visible: i == 0,
 //                 name: _name + 'cache',
 //                 getLegend: false,
 //                 zIndex: isInterstate ? 7 : 5
 //             });
 //
 //         let dynamic = new LayerEsriMapServer(
 //             makeServiceUrl('NPMRDS', 'compare_2017_2018'),
 //             {
 //                 minZoom: maxZoomCached + 1,
 //                 showLayers: [i],
 //                 visible: i == 0,
 //                 name: _name + 'dyn',
 //                 getLegend: false,
 //                 zIndex: isInterstate ? 7 : 5
 //             });
 //
 //         // if (i < 36) {
 //         //     swiper.addLeftLayer(cached);
 //         //     swiper.addLeftLayer(dynamic);
 //         // } else {
 //         //     swiper.addRightLayer(cached);
 //         //     swiper.addRightLayer(dynamic);
 //         // }
 //
 //         // if (i >= 18 && i <= 23) {
 //         //     //temporarily don't add
 //         // } else {
 //         //
 //         // }
 //
 //         map.addLayer(cached.olLayer);
 //         map.addLayer(dynamic.olLayer);
 //
 //         all_layers.push(cached);
 //         all_layers.push(dynamic);
 //
 //         if (isInterstate) {
 //             if (!layerKeysInterstate[metric]) {
 //                 layerKeysInterstate[metric] = {}
 //             }
 //
 //             if (!layerKeysInterstate[metric][timePeriod]) {
 //                 layerKeysInterstate[metric][timePeriod] = [];
 //             }
 //
 //             layerKeysInterstate[metric][timePeriod].push(cached);
 //             layerKeysInterstate[metric][timePeriod].push(dynamic);
 //         } else {
 //             if (!layerKeysOther[metric]) {
 //                 layerKeysOther[metric] = {}
 //             }
 //
 //             if (!layerKeysOther[metric][timePeriod]) {
 //                 layerKeysOther[metric][timePeriod] = [];
 //             }
 //
 //             layerKeysOther[metric][timePeriod].push(cached);
 //             layerKeysOther[metric][timePeriod].push(dynamic);
 //         }
 //     }
 //
 //     setVisibleLayers();
 // }


class $14ae3f026962fb23$var$ConnectedCheck extends $3da1ae41ec4e0382$exports.Component {
    render() {
        let theId = "id-" + this.props.label;
        return /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("div", null, /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("label", {
            htmlFor: theId
        }, this.props.label), /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("input", {
            type: "checkbox",
            id: theId,
            checked: this.props.checked,
            onChange: (d)=>{
                this.props.callback(d.target.checked);
                (0, $dc9109b087454aaa$export$4313aa101fde9289)();
            }
        }));
    }
}
const $14ae3f026962fb23$export$efdd3e096bc27746 = (0, $8111c5508154ff5a$export$2e2bcd8739ae039)((state)=>{
    return {
        title: "Metric",
        items: $c7b75ecb1ebab4ae$export$2823211e9ec9e249,
        inline: false,
        selectedIndex: $c7b75ecb1ebab4ae$export$2823211e9ec9e249.indexOf(state.metric)
    };
}, (dispatch)=>{
    return {
        callback: (d)=>{
            let a = {
                type: $54e91371eee26243$export$8d07e2cf432fc8a9,
                metric: $c7b75ecb1ebab4ae$export$2823211e9ec9e249[d]
            };
            dispatch(a);
            (0, $dc9109b087454aaa$export$4313aa101fde9289)();
        }
    };
})((0, $27c95fd68ff17ad8$exports.RadioConnected));
const $14ae3f026962fb23$export$722b24af687032b1 = (0, $8111c5508154ff5a$export$2e2bcd8739ae039)((state)=>{
    return {
        title: "Time Period",
        items: $c7b75ecb1ebab4ae$export$c44472fbbc495c5,
        inline: false,
        selectedIndex: $c7b75ecb1ebab4ae$export$c44472fbbc495c5.indexOf(state.period)
    };
}, (dispatch)=>{
    return {
        callback: (d)=>{
            let a = {
                type: $54e91371eee26243$export$67bc4958b53223b6,
                period: $c7b75ecb1ebab4ae$export$c44472fbbc495c5[d]
            };
            dispatch(a);
            (0, $dc9109b087454aaa$export$4313aa101fde9289)();
        }
    };
})((0, $27c95fd68ff17ad8$exports.RadioConnected));
const $14ae3f026962fb23$export$700b5497ff19f69d = (0, $8111c5508154ff5a$export$2e2bcd8739ae039)((state)=>{
    return {
        label: "Interstates",
        checked: state.showInterstate
    };
}, (dispatch)=>{
    return {
        callback: (d)=>{
            let a = {
                type: $54e91371eee26243$export$e6f55032c1689689,
                show: d
            };
            dispatch(a);
        }
    };
})($14ae3f026962fb23$var$ConnectedCheck);
const $14ae3f026962fb23$export$9f59e1d6658fa0da = (0, $8111c5508154ff5a$export$2e2bcd8739ae039)((state)=>{
    return {
        label: "Other Roads",
        checked: state.showOther
    };
}, (dispatch)=>{
    return {
        callback: (d)=>{
            let a = {
                type: $54e91371eee26243$export$3a400aac470ddc77,
                show: d
            };
            dispatch(a);
        }
    };
})($14ae3f026962fb23$var$ConnectedCheck);



var $8b868541d025dc7c$exports = {};
"use strict";
/**
 * Created by gavorhes on 12/16/2015.
 */ Object.defineProperty($8b868541d025dc7c$exports, "__esModule", {
    value: true
});
$8b868541d025dc7c$exports.LayerLegend = void 0;



var $8b868541d025dc7c$var$nm = $c45303ef5b6fbfc7$exports.default("collections");

var $8b868541d025dc7c$var$LayerGroup = /** @class */ function() {
    /**
     *
     * @param {object} [groupConfig={}] - group configuration object
     * @param {string} groupConfig.groupName - the group name
     * @param {boolean} [groupConfig.collapse=false] - if the group should be collapsed initially
     * @param {boolean} [groupConfig.addCheck=true] - if the group should have a checkbox controlling visibility of all layers
     * @param {LayerGroup} [parent=undefined] - the parent group
     */ function LayerGroup(groupConfig, parent) {
        this.groupLayers = [];
        this.groupLayersLookup = {};
        this.groupGroups = [];
        this.groupGroupsLookup = {};
        this.itemIdArray = [];
        if (typeof groupConfig == "undefined") {
            this.parent = null;
            this.groupId = "root";
            this.groupName = "root";
            this.allGroupLookup = {
                root: this
            };
            this.allGroupArray = [
                this
            ];
            this.allLayerArray = [];
            this.allLayerLookup = {};
            this.layerParentLookup = {};
            this.collapse = false;
            this.addCheck = false;
        } else {
            this.groupId = $68981f1a81adf307$exports.default();
            this.parent = parent;
            this.groupName = groupConfig.groupName;
            this.collapse = typeof groupConfig.collapse == "boolean" ? groupConfig.collapse : false;
            this.addCheck = typeof groupConfig.addCheck == "boolean" ? groupConfig.addCheck : true;
        }
    }
    /**
     *
     * @param {object} groupConfig - configuration object
     * @param {string} groupConfig.groupName - the group name
     * @param {boolean} groupConfig.collapse if the group should be collapsed initially
     * @param {boolean} groupConfig.addCheck if the group should have a checkbox controlling visibility of all layers
     * @param {Array<LayerGroup>} parents parent groups
     * @returns {LayerGroup} the layer group just added
     */ LayerGroup.prototype.addGroup = function(groupConfig, parents) {
        var parent;
        if (parents.length > 0) parent = parents[parents.length - 1];
        else parent = "root";
        /**
         * @type {LayerGroup}
         */ var parentGroup = this.allGroupLookup[parent];
        var newGroup = new LayerGroup(groupConfig, parentGroup);
        this.allGroupLookup[newGroup.groupId] = newGroup;
        this.allGroupArray.push(newGroup);
        parentGroup.groupGroups.push(newGroup);
        parentGroup.groupGroupsLookup[newGroup.groupId] = newGroup;
        if (parentGroup.itemIdArray.indexOf(newGroup.groupId) > 0) {
            console.log(newGroup.groupId);
            throw "layer and group ids must be unique";
        }
        parentGroup.itemIdArray.push(newGroup.groupId);
        return newGroup;
    };
    /**
     *
     * @param {LayerBase} newLayer the layer to be added
     * @param {Array} parents array
     */ LayerGroup.prototype.addLegendLayer = function(newLayer, parents) {
        var parent;
        if (parents.length > 0) parent = parents[parents.length - 1];
        else parent = "root";
        this.allLayerLookup[newLayer.id] = newLayer;
        this.allLayerArray.push(newLayer);
        /**
         * @type {LayerGroup}
         */ var parentGroup = this.allGroupLookup[parent];
        parentGroup.groupLayers.push(newLayer);
        parentGroup.groupLayersLookup[newLayer.id] = newLayer;
        if (parentGroup.itemIdArray.indexOf(newLayer.id) > 0) {
            console.log(newLayer.id);
            throw "layer and group ids must be unique";
        }
        parentGroup.itemIdArray.push(newLayer.id);
        this.layerParentLookup[newLayer.id] = parentGroup;
    };
    LayerGroup.prototype.getLegendHtml = function(legendId, options) {
        var legendHtml = '<ul id="' + legendId + '" class="legend-container">';
        legendHtml += "<li>" + options.legendTitle + '<input type="checkbox" checked id="suppress-by-extent-' + legendId + '" class="suppress-by-extent">' + ('<label title="Suppress layers not visible at this zoom level" for="suppress-by-extent-' + legendId + '">') + "<span></span>" + "</label></li>";
        legendHtml += this._buildLegend(this.itemIdArray, this, options.layerDivClasses) + "</ul>";
        return legendHtml;
    };
    /**
     * @param {Array} itemIds the items to process
     * @param {LayerGroup} theGroup new group
     * @param {Array} [layerDivClasses=[]] optional classes to apply to the layer divs
     * @static
     * @returns {string} html string
     */ LayerGroup.prototype._buildLegend = function(itemIds, theGroup, layerDivClasses) {
        if (itemIds.length == 0) return "";
        var theHml = "";
        var itemId = itemIds[0];
        if (theGroup.groupLayersLookup[itemId]) {
            /**
             * @type {LayerBase}
             */ var lyr = theGroup.groupLayersLookup[itemId];
            theHml += '<li id="' + lyr.id + '-layer-li" class="legend-layer-li ' + layerDivClasses.join(" ") + '">' + lyr.getLegendDiv() + "</li>";
        } else if (theGroup.groupGroupsLookup[itemId]) {
            /**
             * type {LayerGroup}
             */ var otherGroup = theGroup.groupGroupsLookup[itemId];
            theHml += "<li>";
            theHml += '<div id="' + otherGroup.groupId + '-legend-layer-div" ' + ('class="legend-layer-group  ' + layerDivClasses.join(" ") + '">');
            if (otherGroup.addCheck) theHml += '<input type="checkbox" checked id="' + otherGroup.groupId + '-group-chck">' + ('<label for="' + otherGroup.groupId + '-group-chck" title="Click arrow to expand or collapse">' + otherGroup.groupName + "</label>");
            else theHml += '<label title="Click arrow to expand or collapse">' + otherGroup.groupName + "</label>";
            theHml += '<span title="Expand/Collapse" class="layer-group-expander';
            theHml += (otherGroup.collapse ? " legend-layer-group-initial-collapse" : "") + '">';
            theHml += otherGroup.collapse ? "&#9654;" : "&#9660;";
            theHml += "</span>";
            //parents.push(groupId);
            theHml += "<ul>" + this._buildLegend(otherGroup.itemIdArray, otherGroup, layerDivClasses) + "</ul>";
            theHml += "</div>";
            theHml += "</li>";
        }
        return theHml + this._buildLegend(itemIds.slice(1), theGroup, layerDivClasses);
    };
    return LayerGroup;
}();
/**
 * a wrapper to make a legend
 */ var $8b868541d025dc7c$var$LayerLegend = /** @class */ function() {
    /**``
     *
     * @param {Array} legendItems array of layers or objects with {groupName:  {string}, collapse: {boolean}, addCheck: {boolean}, items: {Array}}
     * @param {string} divId the div where the legend should be added
     * @param {object} options for legend
     * @param {Array} [options.layerDivClasses=[]] optional array of classes to be applied to the layer legend divs for custom styling
     * @param {string} [options.legendTitle=Legend] the legend title
     * @param {boolean} [options.scaleDependent=true] if legend display is scale dependent
     */ function LayerLegend(legendItems, divId, options) {
        if (options === void 0) options = {};
        for(var _i = 0, legendItems_1 = legendItems; _i < legendItems_1.length; _i++){
            var i = legendItems_1[_i];
            if (typeof i == "undefined") throw "undefined item passed in array to legend constructor";
        }
        options.legendTitle = typeof options.legendTitle == "string" ? options.legendTitle : "Legend";
        options.scaleDependent = typeof options.scaleDependent == "boolean" ? options.scaleDependent : true;
        options.layerDivClasses = options.layerDivClasses || [];
        // if legend display is scale dependent, make sure the mapMove object is initialized first
        if (options.scaleDependent) $4f69e05c18d35e9e$exports.default.checkInit();
        this.$divElement = $dc57b31f1b066f38$exports("#" + divId);
        this._legendItems = legendItems;
        this.layerGroup = new $8b868541d025dc7c$var$LayerGroup();
        this._buildTree(legendItems);
        this.legendId = $68981f1a81adf307$exports.default();
        this.$divElement.append(this.layerGroup.getLegendHtml(this.legendId, options));
        for(var _a = 0, _b = this.layerGroup.allLayerArray; _a < _b.length; _a++){
            var l = _b[_a];
            l.applyCollapse();
        }
        var _this = this;
        //// if legend display is scale dependent, make sure the mapMove object is initialized first
        if (options.scaleDependent) {
            $4f69e05c18d35e9e$exports.default.checkInit();
            $4f69e05c18d35e9e$exports.default.addCallback(function(ext, zoom, evt) {
                if (typeof evt == "undefined" || evt == "change:resolution") for(var _i = 0, _a = this.layerGroup.allLayerArray; _i < _a.length; _i++){
                    var lyr = _a[_i];
                    var $lyrLi = $dc57b31f1b066f38$exports("#" + lyr.id + "-layer-li");
                    if (zoom > lyr.maxZoom || zoom < lyr.minZoom) $lyrLi.addClass("layer-not-visible");
                    else $lyrLi.removeClass("layer-not-visible");
                }
            }, this, 100, true, "legend1");
        }
        // <editor-fold desc="add event listeners">
        this.$divElement.find(".suppress-by-extent").change(function() {
            var legendLayerLis = $dc57b31f1b066f38$exports(".legend-layer-li");
            if (this.checked) legendLayerLis.removeClass("layer-force-show");
            else legendLayerLis.addClass("layer-force-show");
        });
        this.$divElement.find(".legend-check").change(function() {
            var lyrId = this.id.replace("-legend-layer-check", "");
            _this.layerGroup.allLayerLookup[lyrId].visible = this.checked;
        });
        this.$divElement.find(".legend-layer-group > input[type=checkbox]").change(function() {
            $dc57b31f1b066f38$exports(this).siblings("ul").find("input[type=checkbox]").prop("checked", this.checked).trigger("change");
        });
        this.$divElement.find(".layer-group-expander").click(function() {
            var $this = $dc57b31f1b066f38$exports(this);
            $this.removeClass("legend-layer-group-initial-collapse");
            $this.siblings("ul").slideToggle();
            if ($this.hasClass("legend-layer-group-collapsed")) {
                $this.removeClass("legend-layer-group-collapsed");
                $this.html("&#9660;");
            } else {
                $this.addClass("legend-layer-group-collapsed");
                $this.html("&#9654;");
            }
        });
        this.$divElement.find(".legend-layer-group-initial-collapse").trigger("click");
    // </editor-fold>
    }
    /**
     * @param {Array} [legendItems=this._layerConfig] the legend items
     * @param {Array} [parents=[]] the ordered list of groups in which this item is a member
     * @private
     */ LayerLegend.prototype._buildTree = function(legendItems, parents) {
        if (legendItems.length == 0) return;
        var oneItem = legendItems[0];
        //reset the parent if the item is in the base array
        if (this._legendItems.indexOf(oneItem) > -1 || typeof parents == "undefined") parents = [];
        if (typeof oneItem.groupName !== "undefined") {
            var groupItem = legendItems[0];
            var newGroup = this.layerGroup.addGroup(groupItem, parents);
            parents.push(newGroup.groupId);
            this._buildTree(oneItem.items, parents);
        } else {
            /**
             * @type {LayerBase}
             */ var layerItem = legendItems[0];
            this.layerGroup.addLegendLayer(layerItem, parents);
        }
        this._buildTree(legendItems.slice(1), parents);
    };
    return LayerLegend;
}();
$8b868541d025dc7c$exports.LayerLegend = $8b868541d025dc7c$var$LayerLegend;
$8b868541d025dc7c$var$nm.LayerLegend = $8b868541d025dc7c$var$LayerLegend;
$8b868541d025dc7c$exports.default = $8b868541d025dc7c$var$LayerLegend;




class $864efb6b6563540d$export$2e2bcd8739ae039 extends $3da1ae41ec4e0382$exports.Component {
    constructor(c, p){
        super(c, p);
        this.state = {
            left: "50%",
            dragging: false,
            percentRight: 50,
            offset: null
        };
        this.leftLayerRef = [];
        this.rightLayerRef = [];
        this.preCompLeft = (e)=>{
            this._precompLeft(e);
        };
        this.preCompRight = (e)=>{
            this._precompRight(e);
        };
        this.postComp = (e)=>{
            this._postComp(e);
        };
        this.layerCache = [];
    }
    get allLayers() {
        let retLayers = [];
        for (let l of this.leftLayerRef)retLayers.push(l);
        for (let l of this.rightLayerRef)if (retLayers.indexOf(l) === -1) retLayers.push(l);
        return retLayers;
    }
    removeAllLayers() {
        for (let l of this.leftLayerRef){
            l.olLayer.un("precompose", this.preCompLeft);
            l.olLayer.un("precompose", this.preCompRight);
            l.olLayer.un("postcompose", this.postComp);
            l.visible = false;
        // this.props.map.removeLayer(l.olLayer);
        }
        for (let l of this.rightLayerRef){
            l.olLayer.un("precompose", this.preCompLeft);
            l.olLayer.un("precompose", this.preCompRight);
            l.olLayer.un("postcompose", this.postComp);
            l.visible = false;
        // this.props.map.removeLayer(l.olLayer);
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        // console.log(newLayerMatch);
        //
        // for (let m of [this.props.leftLayers, this.props.rightLayers, prevProps.leftLayers, prevProps.rightLayers]){
        //     for (let l of m){
        //         if (this.layerCache.indexOf(l) < 0){
        //             this.layerCache.push(l);
        //         }
        //     }
        // }
        //
        //
        //
        let leftMatch = true;
        let rightMatch = true;
        //
        if (this.props.leftLayers.length !== this.leftLayerRef.length) leftMatch = false;
        for (let l of this.props.leftLayers)if (this.leftLayerRef.indexOf(l) < 0) {
            leftMatch = false;
            break;
        }
        if (this.props.rightLayers.length !== this.rightLayerRef.length) rightMatch = false;
        for (let l of this.props.rightLayers)if (this.rightLayerRef.indexOf(l) < 0) {
            rightMatch = false;
            break;
        }
        if (leftMatch && rightMatch) ;
        else {
            this.removeAllLayers();
            this.leftLayerRef = this.props.leftLayers;
            this.rightLayerRef = this.props.rightLayers;
            if (this.props.leftLayers === this.props.rightLayers) for (let l of this.props.leftLayers)l.visible = true;
            else {
                for (let l of this.props.leftLayers){
                    l.olLayer.on("precompose", this.preCompLeft);
                    l.olLayer.on("postcompose", this.postComp);
                    l.visible = true;
                }
                for (let l of this.props.rightLayers){
                    l.olLayer.on("precompose", this.preCompRight);
                    l.olLayer.on("postcompose", this.postComp);
                    l.visible = true;
                }
            }
        }
    }
    _precompLeft(event) {
        let ctx = event["context"];
        let width = ctx.canvas.width * (this.state.percentRight / 100);
        ctx.save();
        ctx.beginPath();
        ctx.rect(0, 0, width, ctx.canvas.height);
        ctx.clip();
    }
    _precompRight(event) {
        let ctx = event["context"];
        let width = ctx.canvas.width * (this.state.percentRight / 100);
        ctx.save();
        ctx.beginPath();
        ctx.rect(width, 0, ctx.canvas.width - width, ctx.canvas.height);
        ctx.clip();
    }
    _postComp(event) {
        let ctx = event["context"];
        ctx.restore();
    }
    componentDidMount() {
        window.onmouseup = (e)=>{
            this.setState({
                dragging: false
            });
        };
        setTimeout(()=>{
            this.props.map.getTargetElement().onmousemove = (evt)=>{
                if (evt.target["id"] == "swiper" || evt.target["tagName"].toLowerCase() == "canvas") ;
                else return;
                if (this.state.dragging) {
                    let mapLeft = this.props.map.getTargetElement().clientLeft;
                    let mapWidth = this.props.map.getTargetElement().clientWidth;
                    let pRight = 100 * (evt.clientX - mapLeft) / mapWidth;
                    if (pRight < 5 || pRight > 95) return;
                    this.setState({
                        percentRight: pRight
                    });
                    this.props.map.renderSync();
                }
            };
        }, 100);
    }
    render() {
        let divStyle = {
            left: `${this.state.percentRight.toFixed(2)}%`,
            position: "absolute",
            top: 0,
            width: "9px",
            height: "100%",
            borderLeft: "solid #000 1px",
            borderRight: "solid #000 1px",
            backgroundColor: "#d3d3d3",
            zIndex: 10,
            cursor: "ew-resize"
        };
        return /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("div", {
            id: "swiper",
            style: divStyle,
            onDrag: (e)=>{
                console.log(e);
            },
            onMouseDown: (e)=>{
                this.setState({
                    dragging: true
                });
                this.setState({
                    offset: e.clientX
                });
            }
        }, this.props.leftComponent, this.props.rightComponent);
    }
}






class $20d232864475b8b3$var$YearSelect extends $3da1ae41ec4e0382$exports.Component {
    render() {
        let style = {
            position: "relative",
            display: "block",
            padding: "4px",
            backgroundColor: "white",
            zIndex: 20,
            width: "53px",
            borderRadius: "4px",
            cursor: "default"
        };
        style["left"] = this.props.pos.left;
        style["top"] = this.props.pos.top;
        let optionArr = [];
        for(let i = 0; i < (0, $c7b75ecb1ebab4ae$export$9cc43b030498d23c); i++)optionArr.push(/*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("option", {
            key: (2017 + i).toString() + "y"
        }, 2017 + i));
        return /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("div", {
            style: style
        }, /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("select", {
            value: this.props.year,
            onChange: (e)=>{
                this.props.setYear(parseInt(e.target.value));
            }
        }, optionArr));
    }
}
const $20d232864475b8b3$export$8df77d993f32c195 = (0, $8111c5508154ff5a$export$2e2bcd8739ae039)((s)=>{
    return {
        pos: {
            left: "-73px",
            top: "11px"
        },
        year: s.leftYear
    };
}, (dispatch)=>{
    return {
        setYear: (n)=>{
            dispatch({
                type: (0, $54e91371eee26243$export$a28c315522f7b563),
                year: n
            });
        }
    };
})($20d232864475b8b3$var$YearSelect);
const $20d232864475b8b3$export$18ee423715c1ca62 = (0, $8111c5508154ff5a$export$2e2bcd8739ae039)((s)=>{
    return {
        pos: {
            left: "22px",
            top: "-15px"
        },
        year: s.rightYear
    };
}, (dispatch)=>{
    return {
        setYear: (n)=>{
            dispatch({
                type: (0, $54e91371eee26243$export$b196d66ea17512eb),
                year: n
            });
        }
    };
})($20d232864475b8b3$var$YearSelect);



console.log("update try 3: 10/23/2024");
let $0f78a9204d7472a7$var$intv = null;
$54e91371eee26243$export$6f57813fe9f31bf9.subscribe(()=>{
    let a = $54e91371eee26243$export$50fdfeece43146fd();
    console.log(a);
    let legCont = $c7b75ecb1ebab4ae$export$7800c6766de6d59f(a.metric, a.period);
    // console.log(legCont);
    $("#legend1").html(legCont);
    if (!legCont) $0f78a9204d7472a7$var$intv = setInterval(()=>{
        let legCont = $c7b75ecb1ebab4ae$export$7800c6766de6d59f(a.metric, a.period);
        $("#legend1").html(legCont);
        if (legCont) clearInterval($0f78a9204d7472a7$var$intv);
    }, 200);
});
class $0f78a9204d7472a7$var$_App extends $3da1ae41ec4e0382$exports.Component {
    constructor(p, c){
        super(p, c);
        this.state = {
            map: null
        };
    }
    componentDidMount() {
        this.map = (0, (/*@__PURE__*/$parcel$interopDefault($b95b5545766c3f4f$exports)))({
            center: {
                x: -9978960,
                y: 5588272
            },
            zoom: 5,
            minZoom: 7,
            fullScreen: true
        });
        this.setState({
            map: this.map
        });
        this.map.addLayer($c7b75ecb1ebab4ae$export$a6acc958a75da733.olLayer);
        this.map.addLayer($c7b75ecb1ebab4ae$export$8cc5b2f9a49aad7b.olLayer);
        this.props.setMap(this.map);
        for (let l of $c7b75ecb1ebab4ae$export$7aa73fef7821349c)this.map.addLayer(l.olLayer);
        let additionalContent = '<label class="slider-label label-left">2017</label><label class="slider-label label-right">2018</label>';
        glob["map"] = this.map;
        glob["store"] = $54e91371eee26243$export$6f57813fe9f31bf9;
        let legendLayer = new (0, $f1a004315fae6573$exports.LayerEsriMapServer)((0, $f1a004315fae6573$exports.makeServiceUrl)("NPMRDS", "compare_2017_2018_legend"), {});
        new (0, (/*@__PURE__*/$parcel$interopDefault($8b868541d025dc7c$exports)))([
            legendLayer
        ], "legend-container", {});
    }
    render() {
        return /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("div", null, /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("div", {
            id: "map"
        }, /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement((0, $864efb6b6563540d$export$2e2bcd8739ae039), {
            map: this.state.map,
            leftComponent: /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement((0, $20d232864475b8b3$export$8df77d993f32c195), null),
            rightComponent: /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement((0, $20d232864475b8b3$export$18ee423715c1ca62), null),
            leftLayers: this.props.leftLayers,
            rightLayers: this.props.rightLayers,
            allLayers: $c7b75ecb1ebab4ae$export$7aa73fef7821349c
        }), /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("div", {
            id: "legend"
        }, /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("h4", null, "Roads"), /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement((0, $14ae3f026962fb23$export$700b5497ff19f69d), null), /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement((0, $14ae3f026962fb23$export$9f59e1d6658fa0da), null), /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement((0, $14ae3f026962fb23$export$efdd3e096bc27746), null), /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement((0, $14ae3f026962fb23$export$722b24af687032b1), null), /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("h4", {
            className: "top-border"
        }, "Legend"), /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement("div", {
            id: "legend1"
        }))));
    }
}
const $0f78a9204d7472a7$var$App = (0, $8111c5508154ff5a$export$2e2bcd8739ae039)((s)=>{
    let leftYear = [];
    let rightYear = [];
    if (s.leftYear == s.rightYear) {
        leftYear = $c7b75ecb1ebab4ae$export$61f6a9c831786408(s.leftYear, s.metric, s.period, s.showInterstate, s.showOther);
        rightYear = leftYear;
    } else {
        leftYear = $c7b75ecb1ebab4ae$export$61f6a9c831786408(s.leftYear, s.metric, s.period, s.showInterstate, s.showOther);
        rightYear = $c7b75ecb1ebab4ae$export$61f6a9c831786408(s.rightYear, s.metric, s.period, s.showInterstate, s.showOther);
    }
    return {
        leftLayers: leftYear,
        rightLayers: rightYear
    };
}, (dispatch)=>{
    return {
        setMap: (map)=>{
            dispatch({
                type: $54e91371eee26243$export$3f59ade4d8f7e2ed,
                map: map
            });
        }
    };
})($0f78a9204d7472a7$var$_App);
$1c0f1e610963dfb8$exports.render(/*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement((0, $7fce8c6c059729e2$export$2e2bcd8739ae039), {
    store: $54e91371eee26243$export$6f57813fe9f31bf9
}, /*#__PURE__*/ $3da1ae41ec4e0382$exports.createElement($0f78a9204d7472a7$var$App, null)), document.getElementById("root"));

})();
//# sourceMappingURL=compare20172018.js.map
